/*!
  * Bootstrap v4.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2018 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery'), require('popper.js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
  (factory((global.bootstrap = {}),global.jQuery,global.Popper));
}(this, (function (exports,$,Popper) { 'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;
  Popper = Popper && Popper.hasOwnProperty('default') ? Popper['default'] : Popper;

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Util = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Private TransitionEnd Helpers
     * ------------------------------------------------------------------------
     */
    var TRANSITION_END = 'transitionend';
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

    function toType(obj) {
      return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }

    function getSpecialTransitionEndEvent() {
      return {
        bindType: TRANSITION_END,
        delegateType: TRANSITION_END,
        handle: function handle(event) {
          if ($$$1(event.target).is(this)) {
            return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
          }

          return undefined; // eslint-disable-line no-undefined
        }
      };
    }

    function transitionEndEmulator(duration) {
      var _this = this;

      var called = false;
      $$$1(this).one(Util.TRANSITION_END, function () {
        called = true;
      });
      setTimeout(function () {
        if (!called) {
          Util.triggerTransitionEnd(_this);
        }
      }, duration);
      return this;
    }

    function setTransitionEndSupport() {
      $$$1.fn.emulateTransitionEnd = transitionEndEmulator;
      $$$1.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
     * --------------------------------------------------------------------------
     * Public Util Api
     * --------------------------------------------------------------------------
     */


    var Util = {
      TRANSITION_END: 'bsTransitionEnd',
      getUID: function getUID(prefix) {
        do {
          // eslint-disable-next-line no-bitwise
          prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
        } while (document.getElementById(prefix));

        return prefix;
      },
      getSelectorFromElement: function getSelectorFromElement(element) {
        var selector = element.getAttribute('data-target');

        if (!selector || selector === '#') {
          selector = element.getAttribute('href') || '';
        }

        try {
          return document.querySelector(selector) ? selector : null;
        } catch (err) {
          return null;
        }
      },
      getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
        if (!element) {
          return 0;
        } // Get transition-duration of the element


        var transitionDuration = $$$1(element).css('transition-duration');
        var floatTransitionDuration = parseFloat(transitionDuration); // Return 0 if element or transition duration is not found

        if (!floatTransitionDuration) {
          return 0;
        } // If multiple durations are defined, take the first


        transitionDuration = transitionDuration.split(',')[0];
        return parseFloat(transitionDuration) * MILLISECONDS_MULTIPLIER;
      },
      reflow: function reflow(element) {
        return element.offsetHeight;
      },
      triggerTransitionEnd: function triggerTransitionEnd(element) {
        $$$1(element).trigger(TRANSITION_END);
      },
      // TODO: Remove in v5
      supportsTransitionEnd: function supportsTransitionEnd() {
        return Boolean(TRANSITION_END);
      },
      isElement: function isElement(obj) {
        return (obj[0] || obj).nodeType;
      },
      typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
        for (var property in configTypes) {
          if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
            var expectedTypes = configTypes[property];
            var value = config[property];
            var valueType = value && Util.isElement(value) ? 'element' : toType(value);

            if (!new RegExp(expectedTypes).test(valueType)) {
              throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
            }
          }
        }
      }
    };
    setTransitionEndSupport();
    return Util;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): alert.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Alert = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'alert';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.alert';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Selector = {
      DISMISS: '[data-dismiss="alert"]'
    };
    var Event = {
      CLOSE: "close" + EVENT_KEY,
      CLOSED: "closed" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      ALERT: 'alert',
      FADE: 'fade',
      SHOW: 'show'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Alert =
    /*#__PURE__*/
    function () {
      function Alert(element) {
        this._element = element;
      } // Getters


      var _proto = Alert.prototype;

      // Public
      _proto.close = function close(element) {
        var rootElement = this._element;

        if (element) {
          rootElement = this._getRootElement(element);
        }

        var customEvent = this._triggerCloseEvent(rootElement);

        if (customEvent.isDefaultPrevented()) {
          return;
        }

        this._removeElement(rootElement);
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Private


      _proto._getRootElement = function _getRootElement(element) {
        var selector = Util.getSelectorFromElement(element);
        var parent = false;

        if (selector) {
          parent = document.querySelector(selector);
        }

        if (!parent) {
          parent = $$$1(element).closest("." + ClassName.ALERT)[0];
        }

        return parent;
      };

      _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
        var closeEvent = $$$1.Event(Event.CLOSE);
        $$$1(element).trigger(closeEvent);
        return closeEvent;
      };

      _proto._removeElement = function _removeElement(element) {
        var _this = this;

        $$$1(element).removeClass(ClassName.SHOW);

        if (!$$$1(element).hasClass(ClassName.FADE)) {
          this._destroyElement(element);

          return;
        }

        var transitionDuration = Util.getTransitionDurationFromElement(element);
        $$$1(element).one(Util.TRANSITION_END, function (event) {
          return _this._destroyElement(element, event);
        }).emulateTransitionEnd(transitionDuration);
      };

      _proto._destroyElement = function _destroyElement(element) {
        $$$1(element).detach().trigger(Event.CLOSED).remove();
      }; // Static


      Alert._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $element = $$$1(this);
          var data = $element.data(DATA_KEY);

          if (!data) {
            data = new Alert(this);
            $element.data(DATA_KEY, data);
          }

          if (config === 'close') {
            data[config](this);
          }
        });
      };

      Alert._handleDismiss = function _handleDismiss(alertInstance) {
        return function (event) {
          if (event) {
            event.preventDefault();
          }

          alertInstance.close(this);
        };
      };

      _createClass(Alert, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Alert;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Alert._jQueryInterface;
    $$$1.fn[NAME].Constructor = Alert;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Alert._jQueryInterface;
    };

    return Alert;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): button.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Button = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'button';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.button';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ClassName = {
      ACTIVE: 'active',
      BUTTON: 'btn',
      FOCUS: 'focus'
    };
    var Selector = {
      DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
      DATA_TOGGLE: '[data-toggle="buttons"]',
      INPUT: 'input',
      ACTIVE: '.active',
      BUTTON: '.btn'
    };
    var Event = {
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
      FOCUS_BLUR_DATA_API: "focus" + EVENT_KEY + DATA_API_KEY + " " + ("blur" + EVENT_KEY + DATA_API_KEY)
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Button =
    /*#__PURE__*/
    function () {
      function Button(element) {
        this._element = element;
      } // Getters


      var _proto = Button.prototype;

      // Public
      _proto.toggle = function toggle() {
        var triggerChangeEvent = true;
        var addAriaPressed = true;
        var rootElement = $$$1(this._element).closest(Selector.DATA_TOGGLE)[0];

        if (rootElement) {
          var input = this._element.querySelector(Selector.INPUT);

          if (input) {
            if (input.type === 'radio') {
              if (input.checked && this._element.classList.contains(ClassName.ACTIVE)) {
                triggerChangeEvent = false;
              } else {
                var activeElement = rootElement.querySelector(Selector.ACTIVE);

                if (activeElement) {
                  $$$1(activeElement).removeClass(ClassName.ACTIVE);
                }
              }
            }

            if (triggerChangeEvent) {
              if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
                return;
              }

              input.checked = !this._element.classList.contains(ClassName.ACTIVE);
              $$$1(input).trigger('change');
            }

            input.focus();
            addAriaPressed = false;
          }
        }

        if (addAriaPressed) {
          this._element.setAttribute('aria-pressed', !this._element.classList.contains(ClassName.ACTIVE));
        }

        if (triggerChangeEvent) {
          $$$1(this._element).toggleClass(ClassName.ACTIVE);
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Static


      Button._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          if (!data) {
            data = new Button(this);
            $$$1(this).data(DATA_KEY, data);
          }

          if (config === 'toggle') {
            data[config]();
          }
        });
      };

      _createClass(Button, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Button;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
      event.preventDefault();
      var button = event.target;

      if (!$$$1(button).hasClass(ClassName.BUTTON)) {
        button = $$$1(button).closest(Selector.BUTTON);
      }

      Button._jQueryInterface.call($$$1(button), 'toggle');
    }).on(Event.FOCUS_BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
      var button = $$$1(event.target).closest(Selector.BUTTON)[0];
      $$$1(button).toggleClass(ClassName.FOCUS, /^focus(in)?$/.test(event.type));
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Button._jQueryInterface;
    $$$1.fn[NAME].Constructor = Button;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Button._jQueryInterface;
    };

    return Button;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Carousel = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'carousel';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.carousel';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

    var Default = {
      interval: 5000,
      keyboard: true,
      slide: false,
      pause: 'hover',
      wrap: true
    };
    var DefaultType = {
      interval: '(number|boolean)',
      keyboard: 'boolean',
      slide: '(boolean|string)',
      pause: '(string|boolean)',
      wrap: 'boolean'
    };
    var Direction = {
      NEXT: 'next',
      PREV: 'prev',
      LEFT: 'left',
      RIGHT: 'right'
    };
    var Event = {
      SLIDE: "slide" + EVENT_KEY,
      SLID: "slid" + EVENT_KEY,
      KEYDOWN: "keydown" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY,
      TOUCHEND: "touchend" + EVENT_KEY,
      LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      CAROUSEL: 'carousel',
      ACTIVE: 'active',
      SLIDE: 'slide',
      RIGHT: 'carousel-item-right',
      LEFT: 'carousel-item-left',
      NEXT: 'carousel-item-next',
      PREV: 'carousel-item-prev',
      ITEM: 'carousel-item'
    };
    var Selector = {
      ACTIVE: '.active',
      ACTIVE_ITEM: '.active.carousel-item',
      ITEM: '.carousel-item',
      NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
      INDICATORS: '.carousel-indicators',
      DATA_SLIDE: '[data-slide], [data-slide-to]',
      DATA_RIDE: '[data-ride="carousel"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Carousel =
    /*#__PURE__*/
    function () {
      function Carousel(element, config) {
        this._items = null;
        this._interval = null;
        this._activeElement = null;
        this._isPaused = false;
        this._isSliding = false;
        this.touchTimeout = null;
        this._config = this._getConfig(config);
        this._element = $$$1(element)[0];
        this._indicatorsElement = this._element.querySelector(Selector.INDICATORS);

        this._addEventListeners();
      } // Getters


      var _proto = Carousel.prototype;

      // Public
      _proto.next = function next() {
        if (!this._isSliding) {
          this._slide(Direction.NEXT);
        }
      };

      _proto.nextWhenVisible = function nextWhenVisible() {
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $$$1(this._element).is(':visible') && $$$1(this._element).css('visibility') !== 'hidden') {
          this.next();
        }
      };

      _proto.prev = function prev() {
        if (!this._isSliding) {
          this._slide(Direction.PREV);
        }
      };

      _proto.pause = function pause(event) {
        if (!event) {
          this._isPaused = true;
        }

        if (this._element.querySelector(Selector.NEXT_PREV)) {
          Util.triggerTransitionEnd(this._element);
          this.cycle(true);
        }

        clearInterval(this._interval);
        this._interval = null;
      };

      _proto.cycle = function cycle(event) {
        if (!event) {
          this._isPaused = false;
        }

        if (this._interval) {
          clearInterval(this._interval);
          this._interval = null;
        }

        if (this._config.interval && !this._isPaused) {
          this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
        }
      };

      _proto.to = function to(index) {
        var _this = this;

        this._activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

        var activeIndex = this._getItemIndex(this._activeElement);

        if (index > this._items.length - 1 || index < 0) {
          return;
        }

        if (this._isSliding) {
          $$$1(this._element).one(Event.SLID, function () {
            return _this.to(index);
          });
          return;
        }

        if (activeIndex === index) {
          this.pause();
          this.cycle();
          return;
        }

        var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

        this._slide(direction, this._items[index]);
      };

      _proto.dispose = function dispose() {
        $$$1(this._element).off(EVENT_KEY);
        $$$1.removeData(this._element, DATA_KEY);
        this._items = null;
        this._config = null;
        this._element = null;
        this._interval = null;
        this._isPaused = null;
        this._isSliding = null;
        this._activeElement = null;
        this._indicatorsElement = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._addEventListeners = function _addEventListeners() {
        var _this2 = this;

        if (this._config.keyboard) {
          $$$1(this._element).on(Event.KEYDOWN, function (event) {
            return _this2._keydown(event);
          });
        }

        if (this._config.pause === 'hover') {
          $$$1(this._element).on(Event.MOUSEENTER, function (event) {
            return _this2.pause(event);
          }).on(Event.MOUSELEAVE, function (event) {
            return _this2.cycle(event);
          });

          if ('ontouchstart' in document.documentElement) {
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            $$$1(this._element).on(Event.TOUCHEND, function () {
              _this2.pause();

              if (_this2.touchTimeout) {
                clearTimeout(_this2.touchTimeout);
              }

              _this2.touchTimeout = setTimeout(function (event) {
                return _this2.cycle(event);
              }, TOUCHEVENT_COMPAT_WAIT + _this2._config.interval);
            });
          }
        }
      };

      _proto._keydown = function _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) {
          return;
        }

        switch (event.which) {
          case ARROW_LEFT_KEYCODE:
            event.preventDefault();
            this.prev();
            break;

          case ARROW_RIGHT_KEYCODE:
            event.preventDefault();
            this.next();
            break;

          default:
        }
      };

      _proto._getItemIndex = function _getItemIndex(element) {
        this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(Selector.ITEM)) : [];
        return this._items.indexOf(element);
      };

      _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
        var isNextDirection = direction === Direction.NEXT;
        var isPrevDirection = direction === Direction.PREV;

        var activeIndex = this._getItemIndex(activeElement);

        var lastItemIndex = this._items.length - 1;
        var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

        if (isGoingToWrap && !this._config.wrap) {
          return activeElement;
        }

        var delta = direction === Direction.PREV ? -1 : 1;
        var itemIndex = (activeIndex + delta) % this._items.length;
        return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
      };

      _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
        var targetIndex = this._getItemIndex(relatedTarget);

        var fromIndex = this._getItemIndex(this._element.querySelector(Selector.ACTIVE_ITEM));

        var slideEvent = $$$1.Event(Event.SLIDE, {
          relatedTarget: relatedTarget,
          direction: eventDirectionName,
          from: fromIndex,
          to: targetIndex
        });
        $$$1(this._element).trigger(slideEvent);
        return slideEvent;
      };

      _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
        if (this._indicatorsElement) {
          var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(Selector.ACTIVE));
          $$$1(indicators).removeClass(ClassName.ACTIVE);

          var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

          if (nextIndicator) {
            $$$1(nextIndicator).addClass(ClassName.ACTIVE);
          }
        }
      };

      _proto._slide = function _slide(direction, element) {
        var _this3 = this;

        var activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

        var activeElementIndex = this._getItemIndex(activeElement);

        var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

        var nextElementIndex = this._getItemIndex(nextElement);

        var isCycling = Boolean(this._interval);
        var directionalClassName;
        var orderClassName;
        var eventDirectionName;

        if (direction === Direction.NEXT) {
          directionalClassName = ClassName.LEFT;
          orderClassName = ClassName.NEXT;
          eventDirectionName = Direction.LEFT;
        } else {
          directionalClassName = ClassName.RIGHT;
          orderClassName = ClassName.PREV;
          eventDirectionName = Direction.RIGHT;
        }

        if (nextElement && $$$1(nextElement).hasClass(ClassName.ACTIVE)) {
          this._isSliding = false;
          return;
        }

        var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

        if (slideEvent.isDefaultPrevented()) {
          return;
        }

        if (!activeElement || !nextElement) {
          // Some weirdness is happening, so we bail
          return;
        }

        this._isSliding = true;

        if (isCycling) {
          this.pause();
        }

        this._setActiveIndicatorElement(nextElement);

        var slidEvent = $$$1.Event(Event.SLID, {
          relatedTarget: nextElement,
          direction: eventDirectionName,
          from: activeElementIndex,
          to: nextElementIndex
        });

        if ($$$1(this._element).hasClass(ClassName.SLIDE)) {
          $$$1(nextElement).addClass(orderClassName);
          Util.reflow(nextElement);
          $$$1(activeElement).addClass(directionalClassName);
          $$$1(nextElement).addClass(directionalClassName);
          var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
          $$$1(activeElement).one(Util.TRANSITION_END, function () {
            $$$1(nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(ClassName.ACTIVE);
            $$$1(activeElement).removeClass(ClassName.ACTIVE + " " + orderClassName + " " + directionalClassName);
            _this3._isSliding = false;
            setTimeout(function () {
              return $$$1(_this3._element).trigger(slidEvent);
            }, 0);
          }).emulateTransitionEnd(transitionDuration);
        } else {
          $$$1(activeElement).removeClass(ClassName.ACTIVE);
          $$$1(nextElement).addClass(ClassName.ACTIVE);
          this._isSliding = false;
          $$$1(this._element).trigger(slidEvent);
        }

        if (isCycling) {
          this.cycle();
        }
      }; // Static


      Carousel._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = _objectSpread({}, Default, $$$1(this).data());

          if (typeof config === 'object') {
            _config = _objectSpread({}, _config, config);
          }

          var action = typeof config === 'string' ? config : _config.slide;

          if (!data) {
            data = new Carousel(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'number') {
            data.to(config);
          } else if (typeof action === 'string') {
            if (typeof data[action] === 'undefined') {
              throw new TypeError("No method named \"" + action + "\"");
            }

            data[action]();
          } else if (_config.interval) {
            data.pause();
            data.cycle();
          }
        });
      };

      Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
        var selector = Util.getSelectorFromElement(this);

        if (!selector) {
          return;
        }

        var target = $$$1(selector)[0];

        if (!target || !$$$1(target).hasClass(ClassName.CAROUSEL)) {
          return;
        }

        var config = _objectSpread({}, $$$1(target).data(), $$$1(this).data());

        var slideIndex = this.getAttribute('data-slide-to');

        if (slideIndex) {
          config.interval = false;
        }

        Carousel._jQueryInterface.call($$$1(target), config);

        if (slideIndex) {
          $$$1(target).data(DATA_KEY).to(slideIndex);
        }

        event.preventDefault();
      };

      _createClass(Carousel, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Carousel;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
    $$$1(window).on(Event.LOAD_DATA_API, function () {
      var carousels = [].slice.call(document.querySelectorAll(Selector.DATA_RIDE));

      for (var i = 0, len = carousels.length; i < len; i++) {
        var $carousel = $$$1(carousels[i]);

        Carousel._jQueryInterface.call($carousel, $carousel.data());
      }
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Carousel._jQueryInterface;
    $$$1.fn[NAME].Constructor = Carousel;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Carousel._jQueryInterface;
    };

    return Carousel;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Collapse = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'collapse';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.collapse';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Default = {
      toggle: true,
      parent: ''
    };
    var DefaultType = {
      toggle: 'boolean',
      parent: '(string|element)'
    };
    var Event = {
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      SHOW: 'show',
      COLLAPSE: 'collapse',
      COLLAPSING: 'collapsing',
      COLLAPSED: 'collapsed'
    };
    var Dimension = {
      WIDTH: 'width',
      HEIGHT: 'height'
    };
    var Selector = {
      ACTIVES: '.show, .collapsing',
      DATA_TOGGLE: '[data-toggle="collapse"]'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Collapse =
    /*#__PURE__*/
    function () {
      function Collapse(element, config) {
        this._isTransitioning = false;
        this._element = element;
        this._config = this._getConfig(config);
        this._triggerArray = $$$1.makeArray(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
        var toggleList = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));

        for (var i = 0, len = toggleList.length; i < len; i++) {
          var elem = toggleList[i];
          var selector = Util.getSelectorFromElement(elem);
          var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
            return foundElem === element;
          });

          if (selector !== null && filterElement.length > 0) {
            this._selector = selector;

            this._triggerArray.push(elem);
          }
        }

        this._parent = this._config.parent ? this._getParent() : null;

        if (!this._config.parent) {
          this._addAriaAndCollapsedClass(this._element, this._triggerArray);
        }

        if (this._config.toggle) {
          this.toggle();
        }
      } // Getters


      var _proto = Collapse.prototype;

      // Public
      _proto.toggle = function toggle() {
        if ($$$1(this._element).hasClass(ClassName.SHOW)) {
          this.hide();
        } else {
          this.show();
        }
      };

      _proto.show = function show() {
        var _this = this;

        if (this._isTransitioning || $$$1(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var actives;
        var activesData;

        if (this._parent) {
          actives = [].slice.call(this._parent.querySelectorAll(Selector.ACTIVES)).filter(function (elem) {
            return elem.getAttribute('data-parent') === _this._config.parent;
          });

          if (actives.length === 0) {
            actives = null;
          }
        }

        if (actives) {
          activesData = $$$1(actives).not(this._selector).data(DATA_KEY);

          if (activesData && activesData._isTransitioning) {
            return;
          }
        }

        var startEvent = $$$1.Event(Event.SHOW);
        $$$1(this._element).trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        if (actives) {
          Collapse._jQueryInterface.call($$$1(actives).not(this._selector), 'hide');

          if (!activesData) {
            $$$1(actives).data(DATA_KEY, null);
          }
        }

        var dimension = this._getDimension();

        $$$1(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
        this._element.style[dimension] = 0;

        if (this._triggerArray.length) {
          $$$1(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
        }

        this.setTransitioning(true);

        var complete = function complete() {
          $$$1(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
          _this._element.style[dimension] = '';

          _this.setTransitioning(false);

          $$$1(_this._element).trigger(Event.SHOWN);
        };

        var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        var scrollSize = "scroll" + capitalizedDimension;
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        this._element.style[dimension] = this._element[scrollSize] + "px";
      };

      _proto.hide = function hide() {
        var _this2 = this;

        if (this._isTransitioning || !$$$1(this._element).hasClass(ClassName.SHOW)) {
          return;
        }

        var startEvent = $$$1.Event(Event.HIDE);
        $$$1(this._element).trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        var dimension = this._getDimension();

        this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
        Util.reflow(this._element);
        $$$1(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
        var triggerArrayLength = this._triggerArray.length;

        if (triggerArrayLength > 0) {
          for (var i = 0; i < triggerArrayLength; i++) {
            var trigger = this._triggerArray[i];
            var selector = Util.getSelectorFromElement(trigger);

            if (selector !== null) {
              var $elem = $$$1([].slice.call(document.querySelectorAll(selector)));

              if (!$elem.hasClass(ClassName.SHOW)) {
                $$$1(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
              }
            }
          }
        }

        this.setTransitioning(true);

        var complete = function complete() {
          _this2.setTransitioning(false);

          $$$1(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
        };

        this._element.style[dimension] = '';
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $$$1(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      };

      _proto.setTransitioning = function setTransitioning(isTransitioning) {
        this._isTransitioning = isTransitioning;
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._config = null;
        this._parent = null;
        this._element = null;
        this._triggerArray = null;
        this._isTransitioning = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        config.toggle = Boolean(config.toggle); // Coerce string values

        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._getDimension = function _getDimension() {
        var hasWidth = $$$1(this._element).hasClass(Dimension.WIDTH);
        return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
      };

      _proto._getParent = function _getParent() {
        var _this3 = this;

        var parent = null;

        if (Util.isElement(this._config.parent)) {
          parent = this._config.parent; // It's a jQuery object

          if (typeof this._config.parent.jquery !== 'undefined') {
            parent = this._config.parent[0];
          }
        } else {
          parent = document.querySelector(this._config.parent);
        }

        var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
        var children = [].slice.call(parent.querySelectorAll(selector));
        $$$1(children).each(function (i, element) {
          _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
        });
        return parent;
      };

      _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
        if (element) {
          var isOpen = $$$1(element).hasClass(ClassName.SHOW);

          if (triggerArray.length) {
            $$$1(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
          }
        }
      }; // Static


      Collapse._getTargetFromElement = function _getTargetFromElement(element) {
        var selector = Util.getSelectorFromElement(element);
        return selector ? document.querySelector(selector) : null;
      };

      Collapse._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $$$1(this);
          var data = $this.data(DATA_KEY);

          var _config = _objectSpread({}, Default, $this.data(), typeof config === 'object' && config ? config : {});

          if (!data && _config.toggle && /show|hide/.test(config)) {
            _config.toggle = false;
          }

          if (!data) {
            data = new Collapse(this, _config);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Collapse, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Collapse;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
      if (event.currentTarget.tagName === 'A') {
        event.preventDefault();
      }

      var $trigger = $$$1(this);
      var selector = Util.getSelectorFromElement(this);
      var selectors = [].slice.call(document.querySelectorAll(selector));
      $$$1(selectors).each(function () {
        var $target = $$$1(this);
        var data = $target.data(DATA_KEY);
        var config = data ? 'toggle' : $trigger.data();

        Collapse._jQueryInterface.call($target, config);
      });
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Collapse._jQueryInterface;
    $$$1.fn[NAME].Constructor = Collapse;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Collapse._jQueryInterface;
    };

    return Collapse;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Dropdown = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'dropdown';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.dropdown';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
      KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
      KEYUP_DATA_API: "keyup" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DISABLED: 'disabled',
      SHOW: 'show',
      DROPUP: 'dropup',
      DROPRIGHT: 'dropright',
      DROPLEFT: 'dropleft',
      MENURIGHT: 'dropdown-menu-right',
      MENULEFT: 'dropdown-menu-left',
      POSITION_STATIC: 'position-static'
    };
    var Selector = {
      DATA_TOGGLE: '[data-toggle="dropdown"]',
      FORM_CHILD: '.dropdown form',
      MENU: '.dropdown-menu',
      NAVBAR_NAV: '.navbar-nav',
      VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
    };
    var AttachmentMap = {
      TOP: 'top-start',
      TOPEND: 'top-end',
      BOTTOM: 'bottom-start',
      BOTTOMEND: 'bottom-end',
      RIGHT: 'right-start',
      RIGHTEND: 'right-end',
      LEFT: 'left-start',
      LEFTEND: 'left-end'
    };
    var Default = {
      offset: 0,
      flip: true,
      boundary: 'scrollParent',
      reference: 'toggle',
      display: 'dynamic'
    };
    var DefaultType = {
      offset: '(number|string|function)',
      flip: 'boolean',
      boundary: '(string|element)',
      reference: '(string|element)',
      display: 'string'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Dropdown =
    /*#__PURE__*/
    function () {
      function Dropdown(element, config) {
        this._element = element;
        this._popper = null;
        this._config = this._getConfig(config);
        this._menu = this._getMenuElement();
        this._inNavbar = this._detectNavbar();

        this._addEventListeners();
      } // Getters


      var _proto = Dropdown.prototype;

      // Public
      _proto.toggle = function toggle() {
        if (this._element.disabled || $$$1(this._element).hasClass(ClassName.DISABLED)) {
          return;
        }

        var parent = Dropdown._getParentFromElement(this._element);

        var isActive = $$$1(this._menu).hasClass(ClassName.SHOW);

        Dropdown._clearMenus();

        if (isActive) {
          return;
        }

        var relatedTarget = {
          relatedTarget: this._element
        };
        var showEvent = $$$1.Event(Event.SHOW, relatedTarget);
        $$$1(parent).trigger(showEvent);

        if (showEvent.isDefaultPrevented()) {
          return;
        } // Disable totally Popper.js for Dropdown in Navbar


        if (!this._inNavbar) {
          /**
           * Check for Popper dependency
           * Popper - https://popper.js.org
           */
          if (typeof Popper === 'undefined') {
            throw new TypeError('Bootstrap dropdown require Popper.js (https://popper.js.org)');
          }

          var referenceElement = this._element;

          if (this._config.reference === 'parent') {
            referenceElement = parent;
          } else if (Util.isElement(this._config.reference)) {
            referenceElement = this._config.reference; // Check if it's jQuery element

            if (typeof this._config.reference.jquery !== 'undefined') {
              referenceElement = this._config.reference[0];
            }
          } // If boundary is not `scrollParent`, then set position to `static`
          // to allow the menu to "escape" the scroll parent's boundaries
          // https://github.com/twbs/bootstrap/issues/24251


          if (this._config.boundary !== 'scrollParent') {
            $$$1(parent).addClass(ClassName.POSITION_STATIC);
          }

          this._popper = new Popper(referenceElement, this._menu, this._getPopperConfig());
        } // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


        if ('ontouchstart' in document.documentElement && $$$1(parent).closest(Selector.NAVBAR_NAV).length === 0) {
          $$$1(document.body).children().on('mouseover', null, $$$1.noop);
        }

        this._element.focus();

        this._element.setAttribute('aria-expanded', true);

        $$$1(this._menu).toggleClass(ClassName.SHOW);
        $$$1(parent).toggleClass(ClassName.SHOW).trigger($$$1.Event(Event.SHOWN, relatedTarget));
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(this._element).off(EVENT_KEY);
        this._element = null;
        this._menu = null;

        if (this._popper !== null) {
          this._popper.destroy();

          this._popper = null;
        }
      };

      _proto.update = function update() {
        this._inNavbar = this._detectNavbar();

        if (this._popper !== null) {
          this._popper.scheduleUpdate();
        }
      }; // Private


      _proto._addEventListeners = function _addEventListeners() {
        var _this = this;

        $$$1(this._element).on(Event.CLICK, function (event) {
          event.preventDefault();
          event.stopPropagation();

          _this.toggle();
        });
      };

      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, this.constructor.Default, $$$1(this._element).data(), config);
        Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
        return config;
      };

      _proto._getMenuElement = function _getMenuElement() {
        if (!this._menu) {
          var parent = Dropdown._getParentFromElement(this._element);

          if (parent) {
            this._menu = parent.querySelector(Selector.MENU);
          }
        }

        return this._menu;
      };

      _proto._getPlacement = function _getPlacement() {
        var $parentDropdown = $$$1(this._element.parentNode);
        var placement = AttachmentMap.BOTTOM; // Handle dropup

        if ($parentDropdown.hasClass(ClassName.DROPUP)) {
          placement = AttachmentMap.TOP;

          if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
            placement = AttachmentMap.TOPEND;
          }
        } else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
          placement = AttachmentMap.RIGHT;
        } else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
          placement = AttachmentMap.LEFT;
        } else if ($$$1(this._menu).hasClass(ClassName.MENURIGHT)) {
          placement = AttachmentMap.BOTTOMEND;
        }

        return placement;
      };

      _proto._detectNavbar = function _detectNavbar() {
        return $$$1(this._element).closest('.navbar').length > 0;
      };

      _proto._getPopperConfig = function _getPopperConfig() {
        var _this2 = this;

        var offsetConf = {};

        if (typeof this._config.offset === 'function') {
          offsetConf.fn = function (data) {
            data.offsets = _objectSpread({}, data.offsets, _this2._config.offset(data.offsets) || {});
            return data;
          };
        } else {
          offsetConf.offset = this._config.offset;
        }

        var popperConfig = {
          placement: this._getPlacement(),
          modifiers: {
            offset: offsetConf,
            flip: {
              enabled: this._config.flip
            },
            preventOverflow: {
              boundariesElement: this._config.boundary
            }
          } // Disable Popper.js if we have a static display

        };

        if (this._config.display === 'static') {
          popperConfig.modifiers.applyStyle = {
            enabled: false
          };
        }

        return popperConfig;
      }; // Static


      Dropdown._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' ? config : null;

          if (!data) {
            data = new Dropdown(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      Dropdown._clearMenus = function _clearMenus(event) {
        if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
          return;
        }

        var toggles = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));

        for (var i = 0, len = toggles.length; i < len; i++) {
          var parent = Dropdown._getParentFromElement(toggles[i]);

          var context = $$$1(toggles[i]).data(DATA_KEY);
          var relatedTarget = {
            relatedTarget: toggles[i]
          };

          if (event && event.type === 'click') {
            relatedTarget.clickEvent = event;
          }

          if (!context) {
            continue;
          }

          var dropdownMenu = context._menu;

          if (!$$$1(parent).hasClass(ClassName.SHOW)) {
            continue;
          }

          if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $$$1.contains(parent, event.target)) {
            continue;
          }

          var hideEvent = $$$1.Event(Event.HIDE, relatedTarget);
          $$$1(parent).trigger(hideEvent);

          if (hideEvent.isDefaultPrevented()) {
            continue;
          } // If this is a touch-enabled device we remove the extra
          // empty mouseover listeners we added for iOS support


          if ('ontouchstart' in document.documentElement) {
            $$$1(document.body).children().off('mouseover', null, $$$1.noop);
          }

          toggles[i].setAttribute('aria-expanded', 'false');
          $$$1(dropdownMenu).removeClass(ClassName.SHOW);
          $$$1(parent).removeClass(ClassName.SHOW).trigger($$$1.Event(Event.HIDDEN, relatedTarget));
        }
      };

      Dropdown._getParentFromElement = function _getParentFromElement(element) {
        var parent;
        var selector = Util.getSelectorFromElement(element);

        if (selector) {
          parent = document.querySelector(selector);
        }

        return parent || element.parentNode;
      }; // eslint-disable-next-line complexity


      Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
        // If not input/textarea:
        //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
        // If input/textarea:
        //  - If space key => not a dropdown command
        //  - If key is other than escape
        //    - If key is not up or down => not a dropdown command
        //    - If trigger inside the menu => not a dropdown command
        if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $$$1(event.target).closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (this.disabled || $$$1(this).hasClass(ClassName.DISABLED)) {
          return;
        }

        var parent = Dropdown._getParentFromElement(this);

        var isActive = $$$1(parent).hasClass(ClassName.SHOW);

        if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
          if (event.which === ESCAPE_KEYCODE) {
            var toggle = parent.querySelector(Selector.DATA_TOGGLE);
            $$$1(toggle).trigger('focus');
          }

          $$$1(this).trigger('click');
          return;
        }

        var items = [].slice.call(parent.querySelectorAll(Selector.VISIBLE_ITEMS));

        if (items.length === 0) {
          return;
        }

        var index = items.indexOf(event.target);

        if (event.which === ARROW_UP_KEYCODE && index > 0) {
          // Up
          index--;
        }

        if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
          // Down
          index++;
        }

        if (index < 0) {
          index = 0;
        }

        items[index].focus();
      };

      _createClass(Dropdown, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Dropdown;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      event.preventDefault();
      event.stopPropagation();

      Dropdown._jQueryInterface.call($$$1(this), 'toggle');
    }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
      e.stopPropagation();
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Dropdown._jQueryInterface;
    $$$1.fn[NAME].Constructor = Dropdown;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Dropdown._jQueryInterface;
    };

    return Dropdown;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Modal = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'modal';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.modal';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

    var Default = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true
    };
    var DefaultType = {
      backdrop: '(boolean|string)',
      keyboard: 'boolean',
      focus: 'boolean',
      show: 'boolean'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      RESIZE: "resize" + EVENT_KEY,
      CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
      KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
      MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
      MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
      BACKDROP: 'modal-backdrop',
      OPEN: 'modal-open',
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      DIALOG: '.modal-dialog',
      DATA_TOGGLE: '[data-toggle="modal"]',
      DATA_DISMISS: '[data-dismiss="modal"]',
      FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
      STICKY_CONTENT: '.sticky-top'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Modal =
    /*#__PURE__*/
    function () {
      function Modal(element, config) {
        this._config = this._getConfig(config);
        this._element = element;
        this._dialog = element.querySelector(Selector.DIALOG);
        this._backdrop = null;
        this._isShown = false;
        this._isBodyOverflowing = false;
        this._ignoreBackdropClick = false;
        this._scrollbarWidth = 0;
      } // Getters


      var _proto = Modal.prototype;

      // Public
      _proto.toggle = function toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
      };

      _proto.show = function show(relatedTarget) {
        var _this = this;

        if (this._isTransitioning || this._isShown) {
          return;
        }

        if ($$$1(this._element).hasClass(ClassName.FADE)) {
          this._isTransitioning = true;
        }

        var showEvent = $$$1.Event(Event.SHOW, {
          relatedTarget: relatedTarget
        });
        $$$1(this._element).trigger(showEvent);

        if (this._isShown || showEvent.isDefaultPrevented()) {
          return;
        }

        this._isShown = true;

        this._checkScrollbar();

        this._setScrollbar();

        this._adjustDialog();

        $$$1(document.body).addClass(ClassName.OPEN);

        this._setEscapeEvent();

        this._setResizeEvent();

        $$$1(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
          return _this.hide(event);
        });
        $$$1(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
          $$$1(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
            if ($$$1(event.target).is(_this._element)) {
              _this._ignoreBackdropClick = true;
            }
          });
        });

        this._showBackdrop(function () {
          return _this._showElement(relatedTarget);
        });
      };

      _proto.hide = function hide(event) {
        var _this2 = this;

        if (event) {
          event.preventDefault();
        }

        if (this._isTransitioning || !this._isShown) {
          return;
        }

        var hideEvent = $$$1.Event(Event.HIDE);
        $$$1(this._element).trigger(hideEvent);

        if (!this._isShown || hideEvent.isDefaultPrevented()) {
          return;
        }

        this._isShown = false;
        var transition = $$$1(this._element).hasClass(ClassName.FADE);

        if (transition) {
          this._isTransitioning = true;
        }

        this._setEscapeEvent();

        this._setResizeEvent();

        $$$1(document).off(Event.FOCUSIN);
        $$$1(this._element).removeClass(ClassName.SHOW);
        $$$1(this._element).off(Event.CLICK_DISMISS);
        $$$1(this._dialog).off(Event.MOUSEDOWN_DISMISS);

        if (transition) {
          var transitionDuration = Util.getTransitionDurationFromElement(this._element);
          $$$1(this._element).one(Util.TRANSITION_END, function (event) {
            return _this2._hideModal(event);
          }).emulateTransitionEnd(transitionDuration);
        } else {
          this._hideModal();
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(window, document, this._element, this._backdrop).off(EVENT_KEY);
        this._config = null;
        this._element = null;
        this._dialog = null;
        this._backdrop = null;
        this._isShown = null;
        this._isBodyOverflowing = null;
        this._ignoreBackdropClick = null;
        this._scrollbarWidth = null;
      };

      _proto.handleUpdate = function handleUpdate() {
        this._adjustDialog();
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, config);
        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._showElement = function _showElement(relatedTarget) {
        var _this3 = this;

        var transition = $$$1(this._element).hasClass(ClassName.FADE);

        if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
          // Don't move modal's DOM position
          document.body.appendChild(this._element);
        }

        this._element.style.display = 'block';

        this._element.removeAttribute('aria-hidden');

        this._element.scrollTop = 0;

        if (transition) {
          Util.reflow(this._element);
        }

        $$$1(this._element).addClass(ClassName.SHOW);

        if (this._config.focus) {
          this._enforceFocus();
        }

        var shownEvent = $$$1.Event(Event.SHOWN, {
          relatedTarget: relatedTarget
        });

        var transitionComplete = function transitionComplete() {
          if (_this3._config.focus) {
            _this3._element.focus();
          }

          _this3._isTransitioning = false;
          $$$1(_this3._element).trigger(shownEvent);
        };

        if (transition) {
          var transitionDuration = Util.getTransitionDurationFromElement(this._element);
          $$$1(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
        } else {
          transitionComplete();
        }
      };

      _proto._enforceFocus = function _enforceFocus() {
        var _this4 = this;

        $$$1(document).off(Event.FOCUSIN) // Guard against infinite focus loop
        .on(Event.FOCUSIN, function (event) {
          if (document !== event.target && _this4._element !== event.target && $$$1(_this4._element).has(event.target).length === 0) {
            _this4._element.focus();
          }
        });
      };

      _proto._setEscapeEvent = function _setEscapeEvent() {
        var _this5 = this;

        if (this._isShown && this._config.keyboard) {
          $$$1(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
            if (event.which === ESCAPE_KEYCODE) {
              event.preventDefault();

              _this5.hide();
            }
          });
        } else if (!this._isShown) {
          $$$1(this._element).off(Event.KEYDOWN_DISMISS);
        }
      };

      _proto._setResizeEvent = function _setResizeEvent() {
        var _this6 = this;

        if (this._isShown) {
          $$$1(window).on(Event.RESIZE, function (event) {
            return _this6.handleUpdate(event);
          });
        } else {
          $$$1(window).off(Event.RESIZE);
        }
      };

      _proto._hideModal = function _hideModal() {
        var _this7 = this;

        this._element.style.display = 'none';

        this._element.setAttribute('aria-hidden', true);

        this._isTransitioning = false;

        this._showBackdrop(function () {
          $$$1(document.body).removeClass(ClassName.OPEN);

          _this7._resetAdjustments();

          _this7._resetScrollbar();

          $$$1(_this7._element).trigger(Event.HIDDEN);
        });
      };

      _proto._removeBackdrop = function _removeBackdrop() {
        if (this._backdrop) {
          $$$1(this._backdrop).remove();
          this._backdrop = null;
        }
      };

      _proto._showBackdrop = function _showBackdrop(callback) {
        var _this8 = this;

        var animate = $$$1(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

        if (this._isShown && this._config.backdrop) {
          this._backdrop = document.createElement('div');
          this._backdrop.className = ClassName.BACKDROP;

          if (animate) {
            this._backdrop.classList.add(animate);
          }

          $$$1(this._backdrop).appendTo(document.body);
          $$$1(this._element).on(Event.CLICK_DISMISS, function (event) {
            if (_this8._ignoreBackdropClick) {
              _this8._ignoreBackdropClick = false;
              return;
            }

            if (event.target !== event.currentTarget) {
              return;
            }

            if (_this8._config.backdrop === 'static') {
              _this8._element.focus();
            } else {
              _this8.hide();
            }
          });

          if (animate) {
            Util.reflow(this._backdrop);
          }

          $$$1(this._backdrop).addClass(ClassName.SHOW);

          if (!callback) {
            return;
          }

          if (!animate) {
            callback();
            return;
          }

          var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
          $$$1(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
        } else if (!this._isShown && this._backdrop) {
          $$$1(this._backdrop).removeClass(ClassName.SHOW);

          var callbackRemove = function callbackRemove() {
            _this8._removeBackdrop();

            if (callback) {
              callback();
            }
          };

          if ($$$1(this._element).hasClass(ClassName.FADE)) {
            var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

            $$$1(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
          } else {
            callbackRemove();
          }
        } else if (callback) {
          callback();
        }
      }; // ----------------------------------------------------------------------
      // the following methods are used to handle overflowing modals
      // todo (fat): these should probably be refactored out of modal.js
      // ----------------------------------------------------------------------


      _proto._adjustDialog = function _adjustDialog() {
        var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

        if (!this._isBodyOverflowing && isModalOverflowing) {
          this._element.style.paddingLeft = this._scrollbarWidth + "px";
        }

        if (this._isBodyOverflowing && !isModalOverflowing) {
          this._element.style.paddingRight = this._scrollbarWidth + "px";
        }
      };

      _proto._resetAdjustments = function _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
      };

      _proto._checkScrollbar = function _checkScrollbar() {
        var rect = document.body.getBoundingClientRect();
        this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        this._scrollbarWidth = this._getScrollbarWidth();
      };

      _proto._setScrollbar = function _setScrollbar() {
        var _this9 = this;

        if (this._isBodyOverflowing) {
          // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
          //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
          var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
          var stickyContent = [].slice.call(document.querySelectorAll(Selector.STICKY_CONTENT)); // Adjust fixed content padding

          $$$1(fixedContent).each(function (index, element) {
            var actualPadding = element.style.paddingRight;
            var calculatedPadding = $$$1(element).css('padding-right');
            $$$1(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
          }); // Adjust sticky content margin

          $$$1(stickyContent).each(function (index, element) {
            var actualMargin = element.style.marginRight;
            var calculatedMargin = $$$1(element).css('margin-right');
            $$$1(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
          }); // Adjust body padding

          var actualPadding = document.body.style.paddingRight;
          var calculatedPadding = $$$1(document.body).css('padding-right');
          $$$1(document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
        }
      };

      _proto._resetScrollbar = function _resetScrollbar() {
        // Restore fixed content padding
        var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
        $$$1(fixedContent).each(function (index, element) {
          var padding = $$$1(element).data('padding-right');
          $$$1(element).removeData('padding-right');
          element.style.paddingRight = padding ? padding : '';
        }); // Restore sticky content

        var elements = [].slice.call(document.querySelectorAll("" + Selector.STICKY_CONTENT));
        $$$1(elements).each(function (index, element) {
          var margin = $$$1(element).data('margin-right');

          if (typeof margin !== 'undefined') {
            $$$1(element).css('margin-right', margin).removeData('margin-right');
          }
        }); // Restore body padding

        var padding = $$$1(document.body).data('padding-right');
        $$$1(document.body).removeData('padding-right');
        document.body.style.paddingRight = padding ? padding : '';
      };

      _proto._getScrollbarWidth = function _getScrollbarWidth() {
        // thx d.walsh
        var scrollDiv = document.createElement('div');
        scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
      }; // Static


      Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = _objectSpread({}, Default, $$$1(this).data(), typeof config === 'object' && config ? config : {});

          if (!data) {
            data = new Modal(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config](relatedTarget);
          } else if (_config.show) {
            data.show(relatedTarget);
          }
        });
      };

      _createClass(Modal, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return Modal;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      var _this10 = this;

      var target;
      var selector = Util.getSelectorFromElement(this);

      if (selector) {
        target = document.querySelector(selector);
      }

      var config = $$$1(target).data(DATA_KEY) ? 'toggle' : _objectSpread({}, $$$1(target).data(), $$$1(this).data());

      if (this.tagName === 'A' || this.tagName === 'AREA') {
        event.preventDefault();
      }

      var $target = $$$1(target).one(Event.SHOW, function (showEvent) {
        if (showEvent.isDefaultPrevented()) {
          // Only register focus restorer if modal will actually get shown
          return;
        }

        $target.one(Event.HIDDEN, function () {
          if ($$$1(_this10).is(':visible')) {
            _this10.focus();
          }
        });
      });

      Modal._jQueryInterface.call($$$1(target), config, this);
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Modal._jQueryInterface;
    $$$1.fn[NAME].Constructor = Modal;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Modal._jQueryInterface;
    };

    return Modal;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): tooltip.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tooltip = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'tooltip';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.tooltip';
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var CLASS_PREFIX = 'bs-tooltip';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
    var DefaultType = {
      animation: 'boolean',
      template: 'string',
      title: '(string|element|function)',
      trigger: 'string',
      delay: '(number|object)',
      html: 'boolean',
      selector: '(string|boolean)',
      placement: '(string|function)',
      offset: '(number|string)',
      container: '(string|element|boolean)',
      fallbackPlacement: '(string|array)',
      boundary: '(string|element)'
    };
    var AttachmentMap = {
      AUTO: 'auto',
      TOP: 'top',
      RIGHT: 'right',
      BOTTOM: 'bottom',
      LEFT: 'left'
    };
    var Default = {
      animation: true,
      template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
      trigger: 'hover focus',
      title: '',
      delay: 0,
      html: false,
      selector: false,
      placement: 'top',
      offset: 0,
      container: false,
      fallbackPlacement: 'flip',
      boundary: 'scrollParent'
    };
    var HoverState = {
      SHOW: 'show',
      OUT: 'out'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      INSERTED: "inserted" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      FOCUSOUT: "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
    };
    var ClassName = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      TOOLTIP: '.tooltip',
      TOOLTIP_INNER: '.tooltip-inner',
      ARROW: '.arrow'
    };
    var Trigger = {
      HOVER: 'hover',
      FOCUS: 'focus',
      CLICK: 'click',
      MANUAL: 'manual'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tooltip =
    /*#__PURE__*/
    function () {
      function Tooltip(element, config) {
        /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */
        if (typeof Popper === 'undefined') {
          throw new TypeError('Bootstrap tooltips require Popper.js (https://popper.js.org)');
        } // private


        this._isEnabled = true;
        this._timeout = 0;
        this._hoverState = '';
        this._activeTrigger = {};
        this._popper = null; // Protected

        this.element = element;
        this.config = this._getConfig(config);
        this.tip = null;

        this._setListeners();
      } // Getters


      var _proto = Tooltip.prototype;

      // Public
      _proto.enable = function enable() {
        this._isEnabled = true;
      };

      _proto.disable = function disable() {
        this._isEnabled = false;
      };

      _proto.toggleEnabled = function toggleEnabled() {
        this._isEnabled = !this._isEnabled;
      };

      _proto.toggle = function toggle(event) {
        if (!this._isEnabled) {
          return;
        }

        if (event) {
          var dataKey = this.constructor.DATA_KEY;
          var context = $$$1(event.currentTarget).data(dataKey);

          if (!context) {
            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
            $$$1(event.currentTarget).data(dataKey, context);
          }

          context._activeTrigger.click = !context._activeTrigger.click;

          if (context._isWithActiveTrigger()) {
            context._enter(null, context);
          } else {
            context._leave(null, context);
          }
        } else {
          if ($$$1(this.getTipElement()).hasClass(ClassName.SHOW)) {
            this._leave(null, this);

            return;
          }

          this._enter(null, this);
        }
      };

      _proto.dispose = function dispose() {
        clearTimeout(this._timeout);
        $$$1.removeData(this.element, this.constructor.DATA_KEY);
        $$$1(this.element).off(this.constructor.EVENT_KEY);
        $$$1(this.element).closest('.modal').off('hide.bs.modal');

        if (this.tip) {
          $$$1(this.tip).remove();
        }

        this._isEnabled = null;
        this._timeout = null;
        this._hoverState = null;
        this._activeTrigger = null;

        if (this._popper !== null) {
          this._popper.destroy();
        }

        this._popper = null;
        this.element = null;
        this.config = null;
        this.tip = null;
      };

      _proto.show = function show() {
        var _this = this;

        if ($$$1(this.element).css('display') === 'none') {
          throw new Error('Please use show on visible elements');
        }

        var showEvent = $$$1.Event(this.constructor.Event.SHOW);

        if (this.isWithContent() && this._isEnabled) {
          $$$1(this.element).trigger(showEvent);
          var isInTheDom = $$$1.contains(this.element.ownerDocument.documentElement, this.element);

          if (showEvent.isDefaultPrevented() || !isInTheDom) {
            return;
          }

          var tip = this.getTipElement();
          var tipId = Util.getUID(this.constructor.NAME);
          tip.setAttribute('id', tipId);
          this.element.setAttribute('aria-describedby', tipId);
          this.setContent();

          if (this.config.animation) {
            $$$1(tip).addClass(ClassName.FADE);
          }

          var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

          var attachment = this._getAttachment(placement);

          this.addAttachmentClass(attachment);
          var container = this.config.container === false ? document.body : $$$1(document).find(this.config.container);
          $$$1(tip).data(this.constructor.DATA_KEY, this);

          if (!$$$1.contains(this.element.ownerDocument.documentElement, this.tip)) {
            $$$1(tip).appendTo(container);
          }

          $$$1(this.element).trigger(this.constructor.Event.INSERTED);
          this._popper = new Popper(this.element, tip, {
            placement: attachment,
            modifiers: {
              offset: {
                offset: this.config.offset
              },
              flip: {
                behavior: this.config.fallbackPlacement
              },
              arrow: {
                element: Selector.ARROW
              },
              preventOverflow: {
                boundariesElement: this.config.boundary
              }
            },
            onCreate: function onCreate(data) {
              if (data.originalPlacement !== data.placement) {
                _this._handlePopperPlacementChange(data);
              }
            },
            onUpdate: function onUpdate(data) {
              _this._handlePopperPlacementChange(data);
            }
          });
          $$$1(tip).addClass(ClassName.SHOW); // If this is a touch-enabled device we add extra
          // empty mouseover listeners to the body's immediate children;
          // only needed because of broken event delegation on iOS
          // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

          if ('ontouchstart' in document.documentElement) {
            $$$1(document.body).children().on('mouseover', null, $$$1.noop);
          }

          var complete = function complete() {
            if (_this.config.animation) {
              _this._fixTransition();
            }

            var prevHoverState = _this._hoverState;
            _this._hoverState = null;
            $$$1(_this.element).trigger(_this.constructor.Event.SHOWN);

            if (prevHoverState === HoverState.OUT) {
              _this._leave(null, _this);
            }
          };

          if ($$$1(this.tip).hasClass(ClassName.FADE)) {
            var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
            $$$1(this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
          } else {
            complete();
          }
        }
      };

      _proto.hide = function hide(callback) {
        var _this2 = this;

        var tip = this.getTipElement();
        var hideEvent = $$$1.Event(this.constructor.Event.HIDE);

        var complete = function complete() {
          if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
            tip.parentNode.removeChild(tip);
          }

          _this2._cleanTipClass();

          _this2.element.removeAttribute('aria-describedby');

          $$$1(_this2.element).trigger(_this2.constructor.Event.HIDDEN);

          if (_this2._popper !== null) {
            _this2._popper.destroy();
          }

          if (callback) {
            callback();
          }
        };

        $$$1(this.element).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          return;
        }

        $$$1(tip).removeClass(ClassName.SHOW); // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support

        if ('ontouchstart' in document.documentElement) {
          $$$1(document.body).children().off('mouseover', null, $$$1.noop);
        }

        this._activeTrigger[Trigger.CLICK] = false;
        this._activeTrigger[Trigger.FOCUS] = false;
        this._activeTrigger[Trigger.HOVER] = false;

        if ($$$1(this.tip).hasClass(ClassName.FADE)) {
          var transitionDuration = Util.getTransitionDurationFromElement(tip);
          $$$1(tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }

        this._hoverState = '';
      };

      _proto.update = function update() {
        if (this._popper !== null) {
          this._popper.scheduleUpdate();
        }
      }; // Protected


      _proto.isWithContent = function isWithContent() {
        return Boolean(this.getTitle());
      };

      _proto.addAttachmentClass = function addAttachmentClass(attachment) {
        $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
      };

      _proto.getTipElement = function getTipElement() {
        this.tip = this.tip || $$$1(this.config.template)[0];
        return this.tip;
      };

      _proto.setContent = function setContent() {
        var tip = this.getTipElement();
        this.setElementContent($$$1(tip.querySelectorAll(Selector.TOOLTIP_INNER)), this.getTitle());
        $$$1(tip).removeClass(ClassName.FADE + " " + ClassName.SHOW);
      };

      _proto.setElementContent = function setElementContent($element, content) {
        var html = this.config.html;

        if (typeof content === 'object' && (content.nodeType || content.jquery)) {
          // Content is a DOM node or a jQuery
          if (html) {
            if (!$$$1(content).parent().is($element)) {
              $element.empty().append(content);
            }
          } else {
            $element.text($$$1(content).text());
          }
        } else {
          $element[html ? 'html' : 'text'](content);
        }
      };

      _proto.getTitle = function getTitle() {
        var title = this.element.getAttribute('data-original-title');

        if (!title) {
          title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
        }

        return title;
      }; // Private


      _proto._getAttachment = function _getAttachment(placement) {
        return AttachmentMap[placement.toUpperCase()];
      };

      _proto._setListeners = function _setListeners() {
        var _this3 = this;

        var triggers = this.config.trigger.split(' ');
        triggers.forEach(function (trigger) {
          if (trigger === 'click') {
            $$$1(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
              return _this3.toggle(event);
            });
          } else if (trigger !== Trigger.MANUAL) {
            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
            $$$1(_this3.element).on(eventIn, _this3.config.selector, function (event) {
              return _this3._enter(event);
            }).on(eventOut, _this3.config.selector, function (event) {
              return _this3._leave(event);
            });
          }

          $$$1(_this3.element).closest('.modal').on('hide.bs.modal', function () {
            return _this3.hide();
          });
        });

        if (this.config.selector) {
          this.config = _objectSpread({}, this.config, {
            trigger: 'manual',
            selector: ''
          });
        } else {
          this._fixTitle();
        }
      };

      _proto._fixTitle = function _fixTitle() {
        var titleType = typeof this.element.getAttribute('data-original-title');

        if (this.element.getAttribute('title') || titleType !== 'string') {
          this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
          this.element.setAttribute('title', '');
        }
      };

      _proto._enter = function _enter(event, context) {
        var dataKey = this.constructor.DATA_KEY;
        context = context || $$$1(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $$$1(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
        }

        if ($$$1(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
          context._hoverState = HoverState.SHOW;
          return;
        }

        clearTimeout(context._timeout);
        context._hoverState = HoverState.SHOW;

        if (!context.config.delay || !context.config.delay.show) {
          context.show();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.SHOW) {
            context.show();
          }
        }, context.config.delay.show);
      };

      _proto._leave = function _leave(event, context) {
        var dataKey = this.constructor.DATA_KEY;
        context = context || $$$1(event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $$$1(event.currentTarget).data(dataKey, context);
        }

        if (event) {
          context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
        }

        if (context._isWithActiveTrigger()) {
          return;
        }

        clearTimeout(context._timeout);
        context._hoverState = HoverState.OUT;

        if (!context.config.delay || !context.config.delay.hide) {
          context.hide();
          return;
        }

        context._timeout = setTimeout(function () {
          if (context._hoverState === HoverState.OUT) {
            context.hide();
          }
        }, context.config.delay.hide);
      };

      _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
        for (var trigger in this._activeTrigger) {
          if (this._activeTrigger[trigger]) {
            return true;
          }
        }

        return false;
      };

      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, this.constructor.Default, $$$1(this.element).data(), typeof config === 'object' && config ? config : {});

        if (typeof config.delay === 'number') {
          config.delay = {
            show: config.delay,
            hide: config.delay
          };
        }

        if (typeof config.title === 'number') {
          config.title = config.title.toString();
        }

        if (typeof config.content === 'number') {
          config.content = config.content.toString();
        }

        Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
        return config;
      };

      _proto._getDelegateConfig = function _getDelegateConfig() {
        var config = {};

        if (this.config) {
          for (var key in this.config) {
            if (this.constructor.Default[key] !== this.config[key]) {
              config[key] = this.config[key];
            }
          }
        }

        return config;
      };

      _proto._cleanTipClass = function _cleanTipClass() {
        var $tip = $$$1(this.getTipElement());
        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

        if (tabClass !== null && tabClass.length) {
          $tip.removeClass(tabClass.join(''));
        }
      };

      _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
        var popperInstance = popperData.instance;
        this.tip = popperInstance.popper;

        this._cleanTipClass();

        this.addAttachmentClass(this._getAttachment(popperData.placement));
      };

      _proto._fixTransition = function _fixTransition() {
        var tip = this.getTipElement();
        var initConfigAnimation = this.config.animation;

        if (tip.getAttribute('x-placement') !== null) {
          return;
        }

        $$$1(tip).removeClass(ClassName.FADE);
        this.config.animation = false;
        this.hide();
        this.show();
        this.config.animation = initConfigAnimation;
      }; // Static


      Tooltip._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' && config;

          if (!data && /dispose|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Tooltip(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Tooltip, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "NAME",
        get: function get() {
          return NAME;
        }
      }, {
        key: "DATA_KEY",
        get: function get() {
          return DATA_KEY;
        }
      }, {
        key: "Event",
        get: function get() {
          return Event;
        }
      }, {
        key: "EVENT_KEY",
        get: function get() {
          return EVENT_KEY;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Tooltip;
    }();
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Tooltip._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tooltip;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tooltip._jQueryInterface;
    };

    return Tooltip;
  }($, Popper);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): popover.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Popover = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'popover';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.popover';
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var CLASS_PREFIX = 'bs-popover';
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');

    var Default = _objectSpread({}, Tooltip.Default, {
      placement: 'right',
      trigger: 'click',
      content: '',
      template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
    });

    var DefaultType = _objectSpread({}, Tooltip.DefaultType, {
      content: '(string|element|function)'
    });

    var ClassName = {
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      TITLE: '.popover-header',
      CONTENT: '.popover-body'
    };
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      INSERTED: "inserted" + EVENT_KEY,
      CLICK: "click" + EVENT_KEY,
      FOCUSIN: "focusin" + EVENT_KEY,
      FOCUSOUT: "focusout" + EVENT_KEY,
      MOUSEENTER: "mouseenter" + EVENT_KEY,
      MOUSELEAVE: "mouseleave" + EVENT_KEY
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Popover =
    /*#__PURE__*/
    function (_Tooltip) {
      _inheritsLoose(Popover, _Tooltip);

      function Popover() {
        return _Tooltip.apply(this, arguments) || this;
      }

      var _proto = Popover.prototype;

      // Overrides
      _proto.isWithContent = function isWithContent() {
        return this.getTitle() || this._getContent();
      };

      _proto.addAttachmentClass = function addAttachmentClass(attachment) {
        $$$1(this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
      };

      _proto.getTipElement = function getTipElement() {
        this.tip = this.tip || $$$1(this.config.template)[0];
        return this.tip;
      };

      _proto.setContent = function setContent() {
        var $tip = $$$1(this.getTipElement()); // We use append for html objects to maintain js events

        this.setElementContent($tip.find(Selector.TITLE), this.getTitle());

        var content = this._getContent();

        if (typeof content === 'function') {
          content = content.call(this.element);
        }

        this.setElementContent($tip.find(Selector.CONTENT), content);
        $tip.removeClass(ClassName.FADE + " " + ClassName.SHOW);
      }; // Private


      _proto._getContent = function _getContent() {
        return this.element.getAttribute('data-content') || this.config.content;
      };

      _proto._cleanTipClass = function _cleanTipClass() {
        var $tip = $$$1(this.getTipElement());
        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

        if (tabClass !== null && tabClass.length > 0) {
          $tip.removeClass(tabClass.join(''));
        }
      }; // Static


      Popover._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' ? config : null;

          if (!data && /destroy|hide/.test(config)) {
            return;
          }

          if (!data) {
            data = new Popover(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Popover, null, [{
        key: "VERSION",
        // Getters
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }, {
        key: "NAME",
        get: function get() {
          return NAME;
        }
      }, {
        key: "DATA_KEY",
        get: function get() {
          return DATA_KEY;
        }
      }, {
        key: "Event",
        get: function get() {
          return Event;
        }
      }, {
        key: "EVENT_KEY",
        get: function get() {
          return EVENT_KEY;
        }
      }, {
        key: "DefaultType",
        get: function get() {
          return DefaultType;
        }
      }]);

      return Popover;
    }(Tooltip);
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */


    $$$1.fn[NAME] = Popover._jQueryInterface;
    $$$1.fn[NAME].Constructor = Popover;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Popover._jQueryInterface;
    };

    return Popover;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): scrollspy.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var ScrollSpy = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'scrollspy';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.scrollspy';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Default = {
      offset: 10,
      method: 'auto',
      target: ''
    };
    var DefaultType = {
      offset: 'number',
      method: 'string',
      target: '(string|element)'
    };
    var Event = {
      ACTIVATE: "activate" + EVENT_KEY,
      SCROLL: "scroll" + EVENT_KEY,
      LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DROPDOWN_ITEM: 'dropdown-item',
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE: 'active'
    };
    var Selector = {
      DATA_SPY: '[data-spy="scroll"]',
      ACTIVE: '.active',
      NAV_LIST_GROUP: '.nav, .list-group',
      NAV_LINKS: '.nav-link',
      NAV_ITEMS: '.nav-item',
      LIST_ITEMS: '.list-group-item',
      DROPDOWN: '.dropdown',
      DROPDOWN_ITEMS: '.dropdown-item',
      DROPDOWN_TOGGLE: '.dropdown-toggle'
    };
    var OffsetMethod = {
      OFFSET: 'offset',
      POSITION: 'position'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var ScrollSpy =
    /*#__PURE__*/
    function () {
      function ScrollSpy(element, config) {
        var _this = this;

        this._element = element;
        this._scrollElement = element.tagName === 'BODY' ? window : element;
        this._config = this._getConfig(config);
        this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.LIST_ITEMS + ",") + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
        this._offsets = [];
        this._targets = [];
        this._activeTarget = null;
        this._scrollHeight = 0;
        $$$1(this._scrollElement).on(Event.SCROLL, function (event) {
          return _this._process(event);
        });
        this.refresh();

        this._process();
      } // Getters


      var _proto = ScrollSpy.prototype;

      // Public
      _proto.refresh = function refresh() {
        var _this2 = this;

        var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
        var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
        var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
        this._offsets = [];
        this._targets = [];
        this._scrollHeight = this._getScrollHeight();
        var targets = [].slice.call(document.querySelectorAll(this._selector));
        targets.map(function (element) {
          var target;
          var targetSelector = Util.getSelectorFromElement(element);

          if (targetSelector) {
            target = document.querySelector(targetSelector);
          }

          if (target) {
            var targetBCR = target.getBoundingClientRect();

            if (targetBCR.width || targetBCR.height) {
              // TODO (fat): remove sketch reliance on jQuery position/offset
              return [$$$1(target)[offsetMethod]().top + offsetBase, targetSelector];
            }
          }

          return null;
        }).filter(function (item) {
          return item;
        }).sort(function (a, b) {
          return a[0] - b[0];
        }).forEach(function (item) {
          _this2._offsets.push(item[0]);

          _this2._targets.push(item[1]);
        });
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        $$$1(this._scrollElement).off(EVENT_KEY);
        this._element = null;
        this._scrollElement = null;
        this._config = null;
        this._selector = null;
        this._offsets = null;
        this._targets = null;
        this._activeTarget = null;
        this._scrollHeight = null;
      }; // Private


      _proto._getConfig = function _getConfig(config) {
        config = _objectSpread({}, Default, typeof config === 'object' && config ? config : {});

        if (typeof config.target !== 'string') {
          var id = $$$1(config.target).attr('id');

          if (!id) {
            id = Util.getUID(NAME);
            $$$1(config.target).attr('id', id);
          }

          config.target = "#" + id;
        }

        Util.typeCheckConfig(NAME, config, DefaultType);
        return config;
      };

      _proto._getScrollTop = function _getScrollTop() {
        return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
      };

      _proto._getScrollHeight = function _getScrollHeight() {
        return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      };

      _proto._getOffsetHeight = function _getOffsetHeight() {
        return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
      };

      _proto._process = function _process() {
        var scrollTop = this._getScrollTop() + this._config.offset;

        var scrollHeight = this._getScrollHeight();

        var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

        if (this._scrollHeight !== scrollHeight) {
          this.refresh();
        }

        if (scrollTop >= maxScroll) {
          var target = this._targets[this._targets.length - 1];

          if (this._activeTarget !== target) {
            this._activate(target);
          }

          return;
        }

        if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
          this._activeTarget = null;

          this._clear();

          return;
        }

        var offsetLength = this._offsets.length;

        for (var i = offsetLength; i--;) {
          var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

          if (isActiveTarget) {
            this._activate(this._targets[i]);
          }
        }
      };

      _proto._activate = function _activate(target) {
        this._activeTarget = target;

        this._clear();

        var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


        queries = queries.map(function (selector) {
          return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
        });
        var $link = $$$1([].slice.call(document.querySelectorAll(queries.join(','))));

        if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
          $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
          $link.addClass(ClassName.ACTIVE);
        } else {
          // Set triggered link as active
          $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

          $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle special case when .nav-link is inside .nav-item

          $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
        }

        $$$1(this._scrollElement).trigger(Event.ACTIVATE, {
          relatedTarget: target
        });
      };

      _proto._clear = function _clear() {
        var nodes = [].slice.call(document.querySelectorAll(this._selector));
        $$$1(nodes).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
      }; // Static


      ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var data = $$$1(this).data(DATA_KEY);

          var _config = typeof config === 'object' && config;

          if (!data) {
            data = new ScrollSpy(this, _config);
            $$$1(this).data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(ScrollSpy, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }, {
        key: "Default",
        get: function get() {
          return Default;
        }
      }]);

      return ScrollSpy;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(window).on(Event.LOAD_DATA_API, function () {
      var scrollSpys = [].slice.call(document.querySelectorAll(Selector.DATA_SPY));
      var scrollSpysLength = scrollSpys.length;

      for (var i = scrollSpysLength; i--;) {
        var $spy = $$$1(scrollSpys[i]);

        ScrollSpy._jQueryInterface.call($spy, $spy.data());
      }
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = ScrollSpy._jQueryInterface;
    $$$1.fn[NAME].Constructor = ScrollSpy;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return ScrollSpy._jQueryInterface;
    };

    return ScrollSpy;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  var Tab = function ($$$1) {
    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */
    var NAME = 'tab';
    var VERSION = '4.1.3';
    var DATA_KEY = 'bs.tab';
    var EVENT_KEY = "." + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $$$1.fn[NAME];
    var Event = {
      HIDE: "hide" + EVENT_KEY,
      HIDDEN: "hidden" + EVENT_KEY,
      SHOW: "show" + EVENT_KEY,
      SHOWN: "shown" + EVENT_KEY,
      CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
    };
    var ClassName = {
      DROPDOWN_MENU: 'dropdown-menu',
      ACTIVE: 'active',
      DISABLED: 'disabled',
      FADE: 'fade',
      SHOW: 'show'
    };
    var Selector = {
      DROPDOWN: '.dropdown',
      NAV_LIST_GROUP: '.nav, .list-group',
      ACTIVE: '.active',
      ACTIVE_UL: '> li > .active',
      DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
      DROPDOWN_TOGGLE: '.dropdown-toggle',
      DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
      /**
       * ------------------------------------------------------------------------
       * Class Definition
       * ------------------------------------------------------------------------
       */

    };

    var Tab =
    /*#__PURE__*/
    function () {
      function Tab(element) {
        this._element = element;
      } // Getters


      var _proto = Tab.prototype;

      // Public
      _proto.show = function show() {
        var _this = this;

        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $$$1(this._element).hasClass(ClassName.ACTIVE) || $$$1(this._element).hasClass(ClassName.DISABLED)) {
          return;
        }

        var target;
        var previous;
        var listElement = $$$1(this._element).closest(Selector.NAV_LIST_GROUP)[0];
        var selector = Util.getSelectorFromElement(this._element);

        if (listElement) {
          var itemSelector = listElement.nodeName === 'UL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
          previous = $$$1.makeArray($$$1(listElement).find(itemSelector));
          previous = previous[previous.length - 1];
        }

        var hideEvent = $$$1.Event(Event.HIDE, {
          relatedTarget: this._element
        });
        var showEvent = $$$1.Event(Event.SHOW, {
          relatedTarget: previous
        });

        if (previous) {
          $$$1(previous).trigger(hideEvent);
        }

        $$$1(this._element).trigger(showEvent);

        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
          return;
        }

        if (selector) {
          target = document.querySelector(selector);
        }

        this._activate(this._element, listElement);

        var complete = function complete() {
          var hiddenEvent = $$$1.Event(Event.HIDDEN, {
            relatedTarget: _this._element
          });
          var shownEvent = $$$1.Event(Event.SHOWN, {
            relatedTarget: previous
          });
          $$$1(previous).trigger(hiddenEvent);
          $$$1(_this._element).trigger(shownEvent);
        };

        if (target) {
          this._activate(target, target.parentNode, complete);
        } else {
          complete();
        }
      };

      _proto.dispose = function dispose() {
        $$$1.removeData(this._element, DATA_KEY);
        this._element = null;
      }; // Private


      _proto._activate = function _activate(element, container, callback) {
        var _this2 = this;

        var activeElements;

        if (container.nodeName === 'UL') {
          activeElements = $$$1(container).find(Selector.ACTIVE_UL);
        } else {
          activeElements = $$$1(container).children(Selector.ACTIVE);
        }

        var active = activeElements[0];
        var isTransitioning = callback && active && $$$1(active).hasClass(ClassName.FADE);

        var complete = function complete() {
          return _this2._transitionComplete(element, active, callback);
        };

        if (active && isTransitioning) {
          var transitionDuration = Util.getTransitionDurationFromElement(active);
          $$$1(active).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      };

      _proto._transitionComplete = function _transitionComplete(element, active, callback) {
        if (active) {
          $$$1(active).removeClass(ClassName.SHOW + " " + ClassName.ACTIVE);
          var dropdownChild = $$$1(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

          if (dropdownChild) {
            $$$1(dropdownChild).removeClass(ClassName.ACTIVE);
          }

          if (active.getAttribute('role') === 'tab') {
            active.setAttribute('aria-selected', false);
          }
        }

        $$$1(element).addClass(ClassName.ACTIVE);

        if (element.getAttribute('role') === 'tab') {
          element.setAttribute('aria-selected', true);
        }

        Util.reflow(element);
        $$$1(element).addClass(ClassName.SHOW);

        if (element.parentNode && $$$1(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
          var dropdownElement = $$$1(element).closest(Selector.DROPDOWN)[0];

          if (dropdownElement) {
            var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(Selector.DROPDOWN_TOGGLE));
            $$$1(dropdownToggleList).addClass(ClassName.ACTIVE);
          }

          element.setAttribute('aria-expanded', true);
        }

        if (callback) {
          callback();
        }
      }; // Static


      Tab._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $$$1(this);
          var data = $this.data(DATA_KEY);

          if (!data) {
            data = new Tab(this);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (typeof data[config] === 'undefined') {
              throw new TypeError("No method named \"" + config + "\"");
            }

            data[config]();
          }
        });
      };

      _createClass(Tab, null, [{
        key: "VERSION",
        get: function get() {
          return VERSION;
        }
      }]);

      return Tab;
    }();
    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */


    $$$1(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
      event.preventDefault();

      Tab._jQueryInterface.call($$$1(this), 'show');
    });
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $$$1.fn[NAME] = Tab._jQueryInterface;
    $$$1.fn[NAME].Constructor = Tab;

    $$$1.fn[NAME].noConflict = function () {
      $$$1.fn[NAME] = JQUERY_NO_CONFLICT;
      return Tab._jQueryInterface;
    };

    return Tab;
  }($);

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.1.3): index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */

  (function ($$$1) {
    if (typeof $$$1 === 'undefined') {
      throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
    }

    var version = $$$1.fn.jquery.split(' ')[0].split('.');
    var minMajor = 1;
    var ltMajor = 2;
    var minMinor = 9;
    var minPatch = 1;
    var maxMajor = 4;

    if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
      throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
    }
  })($);

  exports.Util = Util;
  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Tooltip = Tooltip;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=bootstrap.js.map

!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):jQuery)}(function(a,b){function c(){return new Date(Date.UTC.apply(Date,arguments))}function d(){var a=new Date;return c(a.getFullYear(),a.getMonth(),a.getDate())}function e(a,b){return a.getUTCFullYear()===b.getUTCFullYear()&&a.getUTCMonth()===b.getUTCMonth()&&a.getUTCDate()===b.getUTCDate()}function f(a){return function(){return this[a].apply(this,arguments)}}function g(a){return a&&!isNaN(a.getTime())}function h(b,c){function d(a,b){return b.toLowerCase()}var e,f=a(b).data(),g={},h=new RegExp("^"+c.toLowerCase()+"([A-Z])");c=new RegExp("^"+c.toLowerCase());for(var i in f)c.test(i)&&(e=i.replace(h,d),g[e]=f[i]);return g}function i(b){var c={};if(q[b]||(b=b.split("-")[0],q[b])){var d=q[b];return a.each(p,function(a,b){b in d&&(c[b]=d[b])}),c}}var j=function(){var b={get:function(a){return this.slice(a)[0]},contains:function(a){for(var b=a&&a.valueOf(),c=0,d=this.length;d>c;c++)if(this[c].valueOf()===b)return c;return-1},remove:function(a){this.splice(a,1)},replace:function(b){b&&(a.isArray(b)||(b=[b]),this.clear(),this.push.apply(this,b))},clear:function(){this.length=0},copy:function(){var a=new j;return a.replace(this),a}};return function(){var c=[];return c.push.apply(c,arguments),a.extend(c,b),c}}(),k=function(b,c){a(b).data("datepicker",this),this._process_options(c),this.dates=new j,this.viewDate=this.o.defaultViewDate,this.focusDate=null,this.element=a(b),this.isInput=this.element.is("input"),this.inputField=this.isInput?this.element:this.element.find("input"),this.component=this.element.hasClass("date")?this.element.find(".add-on, .input-group-addon, .btn"):!1,this.hasInput=this.component&&this.inputField.length,this.component&&0===this.component.length&&(this.component=!1),this.isInline=!this.component&&this.element.is("div"),this.picker=a(r.template),this._check_template(this.o.templates.leftArrow)&&this.picker.find(".prev").html(this.o.templates.leftArrow),this._check_template(this.o.templates.rightArrow)&&this.picker.find(".next").html(this.o.templates.rightArrow),this._buildEvents(),this._attachEvents(),this.isInline?this.picker.addClass("datepicker-inline").appendTo(this.element):this.picker.addClass("datepicker-dropdown dropdown-menu"),this.o.rtl&&this.picker.addClass("datepicker-rtl"),this.viewMode=this.o.startView,this.o.calendarWeeks&&this.picker.find("thead .datepicker-title, tfoot .today, tfoot .clear").attr("colspan",function(a,b){return parseInt(b)+1}),this._allow_update=!1,this.setStartDate(this._o.startDate),this.setEndDate(this._o.endDate),this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled),this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted),this.setDatesDisabled(this.o.datesDisabled),this.fillDow(),this.fillMonths(),this._allow_update=!0,this.update(),this.showMode(),this.isInline&&this.show()};k.prototype={constructor:k,_resolveViewName:function(a,c){return 0===a||"days"===a||"month"===a?0:1===a||"months"===a||"year"===a?1:2===a||"years"===a||"decade"===a?2:3===a||"decades"===a||"century"===a?3:4===a||"centuries"===a||"millennium"===a?4:c===b?!1:c},_check_template:function(c){try{if(c===b||""===c)return!1;if((c.match(/[<>]/g)||[]).length<=0)return!0;var d=a(c);return d.length>0}catch(e){return!1}},_process_options:function(b){this._o=a.extend({},this._o,b);var e=this.o=a.extend({},this._o),f=e.language;q[f]||(f=f.split("-")[0],q[f]||(f=o.language)),e.language=f,e.startView=this._resolveViewName(e.startView,0),e.minViewMode=this._resolveViewName(e.minViewMode,0),e.maxViewMode=this._resolveViewName(e.maxViewMode,4),e.startView=Math.min(e.startView,e.maxViewMode),e.startView=Math.max(e.startView,e.minViewMode),e.multidate!==!0&&(e.multidate=Number(e.multidate)||!1,e.multidate!==!1&&(e.multidate=Math.max(0,e.multidate))),e.multidateSeparator=String(e.multidateSeparator),e.weekStart%=7,e.weekEnd=(e.weekStart+6)%7;var g=r.parseFormat(e.format);e.startDate!==-(1/0)&&(e.startDate?e.startDate instanceof Date?e.startDate=this._local_to_utc(this._zero_time(e.startDate)):e.startDate=r.parseDate(e.startDate,g,e.language,e.assumeNearbyYear):e.startDate=-(1/0)),e.endDate!==1/0&&(e.endDate?e.endDate instanceof Date?e.endDate=this._local_to_utc(this._zero_time(e.endDate)):e.endDate=r.parseDate(e.endDate,g,e.language,e.assumeNearbyYear):e.endDate=1/0),e.daysOfWeekDisabled=e.daysOfWeekDisabled||[],a.isArray(e.daysOfWeekDisabled)||(e.daysOfWeekDisabled=e.daysOfWeekDisabled.split(/[,\s]*/)),e.daysOfWeekDisabled=a.map(e.daysOfWeekDisabled,function(a){return parseInt(a,10)}),e.daysOfWeekHighlighted=e.daysOfWeekHighlighted||[],a.isArray(e.daysOfWeekHighlighted)||(e.daysOfWeekHighlighted=e.daysOfWeekHighlighted.split(/[,\s]*/)),e.daysOfWeekHighlighted=a.map(e.daysOfWeekHighlighted,function(a){return parseInt(a,10)}),e.datesDisabled=e.datesDisabled||[],a.isArray(e.datesDisabled)||(e.datesDisabled=[e.datesDisabled]),e.datesDisabled=a.map(e.datesDisabled,function(a){return r.parseDate(a,g,e.language,e.assumeNearbyYear)});var h=String(e.orientation).toLowerCase().split(/\s+/g),i=e.orientation.toLowerCase();if(h=a.grep(h,function(a){return/^auto|left|right|top|bottom$/.test(a)}),e.orientation={x:"auto",y:"auto"},i&&"auto"!==i)if(1===h.length)switch(h[0]){case"top":case"bottom":e.orientation.y=h[0];break;case"left":case"right":e.orientation.x=h[0]}else i=a.grep(h,function(a){return/^left|right$/.test(a)}),e.orientation.x=i[0]||"auto",i=a.grep(h,function(a){return/^top|bottom$/.test(a)}),e.orientation.y=i[0]||"auto";else;if(e.defaultViewDate){var j=e.defaultViewDate.year||(new Date).getFullYear(),k=e.defaultViewDate.month||0,l=e.defaultViewDate.day||1;e.defaultViewDate=c(j,k,l)}else e.defaultViewDate=d()},_events:[],_secondaryEvents:[],_applyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(d=b,e=a[f][1]):3===a[f].length&&(d=a[f][1],e=a[f][2]),c.on(e,d)},_unapplyEvents:function(a){for(var c,d,e,f=0;f<a.length;f++)c=a[f][0],2===a[f].length?(e=b,d=a[f][1]):3===a[f].length&&(e=a[f][1],d=a[f][2]),c.off(d,e)},_buildEvents:function(){var b={keyup:a.proxy(function(b){-1===a.inArray(b.keyCode,[27,37,39,38,40,32,13,9])&&this.update()},this),keydown:a.proxy(this.keydown,this),paste:a.proxy(this.paste,this)};this.o.showOnFocus===!0&&(b.focus=a.proxy(this.show,this)),this.isInput?this._events=[[this.element,b]]:this.component&&this.hasInput?this._events=[[this.inputField,b],[this.component,{click:a.proxy(this.show,this)}]]:this._events=[[this.element,{click:a.proxy(this.show,this),keydown:a.proxy(this.keydown,this)}]],this._events.push([this.element,"*",{blur:a.proxy(function(a){this._focused_from=a.target},this)}],[this.element,{blur:a.proxy(function(a){this._focused_from=a.target},this)}]),this.o.immediateUpdates&&this._events.push([this.element,{"changeYear changeMonth":a.proxy(function(a){this.update(a.date)},this)}]),this._secondaryEvents=[[this.picker,{click:a.proxy(this.click,this)}],[a(window),{resize:a.proxy(this.place,this)}],[a(document),{mousedown:a.proxy(function(a){this.element.is(a.target)||this.element.find(a.target).length||this.picker.is(a.target)||this.picker.find(a.target).length||this.isInline||this.hide()},this)}]]},_attachEvents:function(){this._detachEvents(),this._applyEvents(this._events)},_detachEvents:function(){this._unapplyEvents(this._events)},_attachSecondaryEvents:function(){this._detachSecondaryEvents(),this._applyEvents(this._secondaryEvents)},_detachSecondaryEvents:function(){this._unapplyEvents(this._secondaryEvents)},_trigger:function(b,c){var d=c||this.dates.get(-1),e=this._utc_to_local(d);this.element.trigger({type:b,date:e,dates:a.map(this.dates,this._utc_to_local),format:a.proxy(function(a,b){0===arguments.length?(a=this.dates.length-1,b=this.o.format):"string"==typeof a&&(b=a,a=this.dates.length-1),b=b||this.o.format;var c=this.dates.get(a);return r.formatDate(c,b,this.o.language)},this)})},show:function(){return this.inputField.prop("disabled")||this.inputField.prop("readonly")&&this.o.enableOnReadonly===!1?void 0:(this.isInline||this.picker.appendTo(this.o.container),this.place(),this.picker.show(),this._attachSecondaryEvents(),this._trigger("show"),(window.navigator.msMaxTouchPoints||"ontouchstart"in document)&&this.o.disableTouchKeyboard&&a(this.element).blur(),this)},hide:function(){return this.isInline||!this.picker.is(":visible")?this:(this.focusDate=null,this.picker.hide().detach(),this._detachSecondaryEvents(),this.viewMode=this.o.startView,this.showMode(),this.o.forceParse&&this.inputField.val()&&this.setValue(),this._trigger("hide"),this)},destroy:function(){return this.hide(),this._detachEvents(),this._detachSecondaryEvents(),this.picker.remove(),delete this.element.data().datepicker,this.isInput||delete this.element.data().date,this},paste:function(b){var c;if(b.originalEvent.clipboardData&&b.originalEvent.clipboardData.types&&-1!==a.inArray("text/plain",b.originalEvent.clipboardData.types))c=b.originalEvent.clipboardData.getData("text/plain");else{if(!window.clipboardData)return;c=window.clipboardData.getData("Text")}this.setDate(c),this.update(),b.preventDefault()},_utc_to_local:function(a){return a&&new Date(a.getTime()+6e4*a.getTimezoneOffset())},_local_to_utc:function(a){return a&&new Date(a.getTime()-6e4*a.getTimezoneOffset())},_zero_time:function(a){return a&&new Date(a.getFullYear(),a.getMonth(),a.getDate())},_zero_utc_time:function(a){return a&&new Date(Date.UTC(a.getUTCFullYear(),a.getUTCMonth(),a.getUTCDate()))},getDates:function(){return a.map(this.dates,this._utc_to_local)},getUTCDates:function(){return a.map(this.dates,function(a){return new Date(a)})},getDate:function(){return this._utc_to_local(this.getUTCDate())},getUTCDate:function(){var a=this.dates.get(-1);return"undefined"!=typeof a?new Date(a):null},clearDates:function(){this.inputField&&this.inputField.val(""),this.update(),this._trigger("changeDate"),this.o.autoclose&&this.hide()},setDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,b),this._trigger("changeDate"),this.setValue(),this},setUTCDates:function(){var b=a.isArray(arguments[0])?arguments[0]:arguments;return this.update.apply(this,a.map(b,this._utc_to_local)),this._trigger("changeDate"),this.setValue(),this},setDate:f("setDates"),setUTCDate:f("setUTCDates"),remove:f("destroy"),setValue:function(){var a=this.getFormattedDate();return this.inputField.val(a),this},getFormattedDate:function(c){c===b&&(c=this.o.format);var d=this.o.language;return a.map(this.dates,function(a){return r.formatDate(a,c,d)}).join(this.o.multidateSeparator)},getStartDate:function(){return this.o.startDate},setStartDate:function(a){return this._process_options({startDate:a}),this.update(),this.updateNavArrows(),this},getEndDate:function(){return this.o.endDate},setEndDate:function(a){return this._process_options({endDate:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekDisabled:function(a){return this._process_options({daysOfWeekDisabled:a}),this.update(),this.updateNavArrows(),this},setDaysOfWeekHighlighted:function(a){return this._process_options({daysOfWeekHighlighted:a}),this.update(),this},setDatesDisabled:function(a){this._process_options({datesDisabled:a}),this.update(),this.updateNavArrows()},place:function(){if(this.isInline)return this;var b=this.picker.outerWidth(),c=this.picker.outerHeight(),d=10,e=a(this.o.container),f=e.width(),g="body"===this.o.container?a(document).scrollTop():e.scrollTop(),h=e.offset(),i=[];this.element.parents().each(function(){var b=a(this).css("z-index");"auto"!==b&&0!==b&&i.push(parseInt(b))});var j=Math.max.apply(Math,i)+this.o.zIndexOffset,k=this.component?this.component.parent().offset():this.element.offset(),l=this.component?this.component.outerHeight(!0):this.element.outerHeight(!1),m=this.component?this.component.outerWidth(!0):this.element.outerWidth(!1),n=k.left-h.left,o=k.top-h.top;"body"!==this.o.container&&(o+=g),this.picker.removeClass("datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left"),"auto"!==this.o.orientation.x?(this.picker.addClass("datepicker-orient-"+this.o.orientation.x),"right"===this.o.orientation.x&&(n-=b-m)):k.left<0?(this.picker.addClass("datepicker-orient-left"),n-=k.left-d):n+b>f?(this.picker.addClass("datepicker-orient-right"),n+=m-b):this.picker.addClass("datepicker-orient-left");var p,q=this.o.orientation.y;if("auto"===q&&(p=-g+o-c,q=0>p?"bottom":"top"),this.picker.addClass("datepicker-orient-"+q),"top"===q?o-=c+parseInt(this.picker.css("padding-top")):o+=l,this.o.rtl){var r=f-(n+m);this.picker.css({top:o,right:r,zIndex:j})}else this.picker.css({top:o,left:n,zIndex:j});return this},_allow_update:!0,update:function(){if(!this._allow_update)return this;var b=this.dates.copy(),c=[],d=!1;return arguments.length?(a.each(arguments,a.proxy(function(a,b){b instanceof Date&&(b=this._local_to_utc(b)),c.push(b)},this)),d=!0):(c=this.isInput?this.element.val():this.element.data("date")||this.inputField.val(),c=c&&this.o.multidate?c.split(this.o.multidateSeparator):[c],delete this.element.data().date),c=a.map(c,a.proxy(function(a){return r.parseDate(a,this.o.format,this.o.language,this.o.assumeNearbyYear)},this)),c=a.grep(c,a.proxy(function(a){return!this.dateWithinRange(a)||!a},this),!0),this.dates.replace(c),this.dates.length?this.viewDate=new Date(this.dates.get(-1)):this.viewDate<this.o.startDate?this.viewDate=new Date(this.o.startDate):this.viewDate>this.o.endDate?this.viewDate=new Date(this.o.endDate):this.viewDate=this.o.defaultViewDate,d?this.setValue():c.length&&String(b)!==String(this.dates)&&this._trigger("changeDate"),!this.dates.length&&b.length&&this._trigger("clearDate"),this.fill(),this.element.change(),this},fillDow:function(){var b=this.o.weekStart,c="<tr>";for(this.o.calendarWeeks&&(this.picker.find(".datepicker-days .datepicker-switch").attr("colspan",function(a,b){return parseInt(b)+1}),c+='<th class="cw">&#160;</th>');b<this.o.weekStart+7;)c+='<th class="dow',a.inArray(b,this.o.daysOfWeekDisabled)>-1&&(c+=" disabled"),c+='">'+q[this.o.language].daysMin[b++%7]+"</th>";c+="</tr>",this.picker.find(".datepicker-days thead").append(c)},fillMonths:function(){for(var a=this._utc_to_local(this.viewDate),b="",c=0;12>c;){var d=a&&a.getMonth()===c?" focused":"";b+='<span class="month'+d+'">'+q[this.o.language].monthsShort[c++]+"</span>"}this.picker.find(".datepicker-months td").html(b)},setRange:function(b){b&&b.length?this.range=a.map(b,function(a){return a.valueOf()}):delete this.range,this.fill()},getClassNames:function(b){var c=[],d=this.viewDate.getUTCFullYear(),e=this.viewDate.getUTCMonth(),f=new Date;return b.getUTCFullYear()<d||b.getUTCFullYear()===d&&b.getUTCMonth()<e?c.push("old"):(b.getUTCFullYear()>d||b.getUTCFullYear()===d&&b.getUTCMonth()>e)&&c.push("new"),this.focusDate&&b.valueOf()===this.focusDate.valueOf()&&c.push("focused"),this.o.todayHighlight&&b.getUTCFullYear()===f.getFullYear()&&b.getUTCMonth()===f.getMonth()&&b.getUTCDate()===f.getDate()&&c.push("today"),-1!==this.dates.contains(b)&&c.push("active"),this.dateWithinRange(b)||c.push("disabled"),this.dateIsDisabled(b)&&c.push("disabled","disabled-date"),-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekHighlighted)&&c.push("highlighted"),this.range&&(b>this.range[0]&&b<this.range[this.range.length-1]&&c.push("range"),-1!==a.inArray(b.valueOf(),this.range)&&c.push("selected"),b.valueOf()===this.range[0]&&c.push("range-start"),b.valueOf()===this.range[this.range.length-1]&&c.push("range-end")),c},_fill_yearsView:function(c,d,e,f,g,h,i,j){var k,l,m,n,o,p,q,r,s,t,u;for(k="",l=this.picker.find(c),m=parseInt(g/e,10)*e,o=parseInt(h/f,10)*f,p=parseInt(i/f,10)*f,n=a.map(this.dates,function(a){return parseInt(a.getUTCFullYear()/f,10)*f}),l.find(".datepicker-switch").text(m+"-"+(m+9*f)),q=m-f,r=-1;11>r;r+=1)s=[d],t=null,-1===r?s.push("old"):10===r&&s.push("new"),-1!==a.inArray(q,n)&&s.push("active"),(o>q||q>p)&&s.push("disabled"),q===this.viewDate.getFullYear()&&s.push("focused"),j!==a.noop&&(u=j(new Date(q,0,1)),u===b?u={}:"boolean"==typeof u?u={enabled:u}:"string"==typeof u&&(u={classes:u}),u.enabled===!1&&s.push("disabled"),u.classes&&(s=s.concat(u.classes.split(/\s+/))),u.tooltip&&(t=u.tooltip)),k+='<span class="'+s.join(" ")+'"'+(t?' title="'+t+'"':"")+">"+q+"</span>",q+=f;l.find("td").html(k)},fill:function(){var d,e,f=new Date(this.viewDate),g=f.getUTCFullYear(),h=f.getUTCMonth(),i=this.o.startDate!==-(1/0)?this.o.startDate.getUTCFullYear():-(1/0),j=this.o.startDate!==-(1/0)?this.o.startDate.getUTCMonth():-(1/0),k=this.o.endDate!==1/0?this.o.endDate.getUTCFullYear():1/0,l=this.o.endDate!==1/0?this.o.endDate.getUTCMonth():1/0,m=q[this.o.language].today||q.en.today||"",n=q[this.o.language].clear||q.en.clear||"",o=q[this.o.language].titleFormat||q.en.titleFormat;if(!isNaN(g)&&!isNaN(h)){this.picker.find(".datepicker-days .datepicker-switch").text(r.formatDate(f,o,this.o.language)),this.picker.find("tfoot .today").text(m).toggle(this.o.todayBtn!==!1),this.picker.find("tfoot .clear").text(n).toggle(this.o.clearBtn!==!1),this.picker.find("thead .datepicker-title").text(this.o.title).toggle(""!==this.o.title),this.updateNavArrows(),this.fillMonths();var p=c(g,h-1,28),s=r.getDaysInMonth(p.getUTCFullYear(),p.getUTCMonth());p.setUTCDate(s),p.setUTCDate(s-(p.getUTCDay()-this.o.weekStart+7)%7);var t=new Date(p);p.getUTCFullYear()<100&&t.setUTCFullYear(p.getUTCFullYear()),t.setUTCDate(t.getUTCDate()+42),t=t.valueOf();for(var u,v=[];p.valueOf()<t;){if(p.getUTCDay()===this.o.weekStart&&(v.push("<tr>"),this.o.calendarWeeks)){var w=new Date(+p+(this.o.weekStart-p.getUTCDay()-7)%7*864e5),x=new Date(Number(w)+(11-w.getUTCDay())%7*864e5),y=new Date(Number(y=c(x.getUTCFullYear(),0,1))+(11-y.getUTCDay())%7*864e5),z=(x-y)/864e5/7+1;v.push('<td class="cw">'+z+"</td>")}u=this.getClassNames(p),u.push("day"),this.o.beforeShowDay!==a.noop&&(e=this.o.beforeShowDay(this._utc_to_local(p)),e===b?e={}:"boolean"==typeof e?e={enabled:e}:"string"==typeof e&&(e={classes:e}),e.enabled===!1&&u.push("disabled"),e.classes&&(u=u.concat(e.classes.split(/\s+/))),e.tooltip&&(d=e.tooltip)),u=a.isFunction(a.uniqueSort)?a.uniqueSort(u):a.unique(u),v.push('<td class="'+u.join(" ")+'"'+(d?' title="'+d+'"':"")+">"+p.getUTCDate()+"</td>"),d=null,p.getUTCDay()===this.o.weekEnd&&v.push("</tr>"),p.setUTCDate(p.getUTCDate()+1)}this.picker.find(".datepicker-days tbody").empty().append(v.join(""));var A=q[this.o.language].monthsTitle||q.en.monthsTitle||"Months",B=this.picker.find(".datepicker-months").find(".datepicker-switch").text(this.o.maxViewMode<2?A:g).end().find("span").removeClass("active");if(a.each(this.dates,function(a,b){b.getUTCFullYear()===g&&B.eq(b.getUTCMonth()).addClass("active")}),(i>g||g>k)&&B.addClass("disabled"),g===i&&B.slice(0,j).addClass("disabled"),g===k&&B.slice(l+1).addClass("disabled"),this.o.beforeShowMonth!==a.noop){var C=this;a.each(B,function(c,d){var e=new Date(g,c,1),f=C.o.beforeShowMonth(e);f===b?f={}:"boolean"==typeof f?f={enabled:f}:"string"==typeof f&&(f={classes:f}),f.enabled!==!1||a(d).hasClass("disabled")||a(d).addClass("disabled"),f.classes&&a(d).addClass(f.classes),f.tooltip&&a(d).prop("title",f.tooltip)})}this._fill_yearsView(".datepicker-years","year",10,1,g,i,k,this.o.beforeShowYear),this._fill_yearsView(".datepicker-decades","decade",100,10,g,i,k,this.o.beforeShowDecade),this._fill_yearsView(".datepicker-centuries","century",1e3,100,g,i,k,this.o.beforeShowCentury)}},updateNavArrows:function(){if(this._allow_update){var a=new Date(this.viewDate),b=a.getUTCFullYear(),c=a.getUTCMonth();switch(this.viewMode){case 0:this.o.startDate!==-(1/0)&&b<=this.o.startDate.getUTCFullYear()&&c<=this.o.startDate.getUTCMonth()?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),this.o.endDate!==1/0&&b>=this.o.endDate.getUTCFullYear()&&c>=this.o.endDate.getUTCMonth()?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"});break;case 1:case 2:case 3:case 4:this.o.startDate!==-(1/0)&&b<=this.o.startDate.getUTCFullYear()||this.o.maxViewMode<2?this.picker.find(".prev").css({visibility:"hidden"}):this.picker.find(".prev").css({visibility:"visible"}),this.o.endDate!==1/0&&b>=this.o.endDate.getUTCFullYear()||this.o.maxViewMode<2?this.picker.find(".next").css({visibility:"hidden"}):this.picker.find(".next").css({visibility:"visible"})}}},click:function(b){b.preventDefault(),b.stopPropagation();var e,f,g,h,i,j,k;e=a(b.target),e.hasClass("datepicker-switch")&&this.showMode(1);var l=e.closest(".prev, .next");l.length>0&&(f=r.modes[this.viewMode].navStep*(l.hasClass("prev")?-1:1),0===this.viewMode?(this.viewDate=this.moveMonth(this.viewDate,f),this._trigger("changeMonth",this.viewDate)):(this.viewDate=this.moveYear(this.viewDate,f),1===this.viewMode&&this._trigger("changeYear",this.viewDate)),this.fill()),e.hasClass("today")&&!e.hasClass("day")&&(this.showMode(-2),this._setDate(d(),"linked"===this.o.todayBtn?null:"view")),e.hasClass("clear")&&this.clearDates(),e.hasClass("disabled")||(e.hasClass("day")&&(g=parseInt(e.text(),10)||1,h=this.viewDate.getUTCFullYear(),i=this.viewDate.getUTCMonth(),e.hasClass("old")&&(0===i?(i=11,h-=1,j=!0,k=!0):(i-=1,j=!0)),e.hasClass("new")&&(11===i?(i=0,h+=1,j=!0,k=!0):(i+=1,j=!0)),this._setDate(c(h,i,g)),k&&this._trigger("changeYear",this.viewDate),j&&this._trigger("changeMonth",this.viewDate)),e.hasClass("month")&&(this.viewDate.setUTCDate(1),g=1,i=e.parent().find("span").index(e),h=this.viewDate.getUTCFullYear(),this.viewDate.setUTCMonth(i),this._trigger("changeMonth",this.viewDate),1===this.o.minViewMode?(this._setDate(c(h,i,g)),this.showMode()):this.showMode(-1),this.fill()),(e.hasClass("year")||e.hasClass("decade")||e.hasClass("century"))&&(this.viewDate.setUTCDate(1),g=1,i=0,h=parseInt(e.text(),10)||0,this.viewDate.setUTCFullYear(h),e.hasClass("year")&&(this._trigger("changeYear",this.viewDate),2===this.o.minViewMode&&this._setDate(c(h,i,g))),e.hasClass("decade")&&(this._trigger("changeDecade",this.viewDate),3===this.o.minViewMode&&this._setDate(c(h,i,g))),e.hasClass("century")&&(this._trigger("changeCentury",this.viewDate),4===this.o.minViewMode&&this._setDate(c(h,i,g))),this.showMode(-1),this.fill())),this.picker.is(":visible")&&this._focused_from&&a(this._focused_from).focus(),delete this._focused_from},_toggle_multidate:function(a){var b=this.dates.contains(a);if(a||this.dates.clear(),-1!==b?(this.o.multidate===!0||this.o.multidate>1||this.o.toggleActive)&&this.dates.remove(b):this.o.multidate===!1?(this.dates.clear(),this.dates.push(a)):this.dates.push(a),"number"==typeof this.o.multidate)for(;this.dates.length>this.o.multidate;)this.dates.remove(0)},_setDate:function(a,b){b&&"date"!==b||this._toggle_multidate(a&&new Date(a)),b&&"view"!==b||(this.viewDate=a&&new Date(a)),this.fill(),this.setValue(),b&&"view"===b||this._trigger("changeDate"),this.inputField&&this.inputField.change(),!this.o.autoclose||b&&"date"!==b||this.hide()},moveDay:function(a,b){var c=new Date(a);return c.setUTCDate(a.getUTCDate()+b),c},moveWeek:function(a,b){return this.moveDay(a,7*b)},moveMonth:function(a,b){if(!g(a))return this.o.defaultViewDate;if(!b)return a;var c,d,e=new Date(a.valueOf()),f=e.getUTCDate(),h=e.getUTCMonth(),i=Math.abs(b);if(b=b>0?1:-1,1===i)d=-1===b?function(){return e.getUTCMonth()===h}:function(){return e.getUTCMonth()!==c},c=h+b,e.setUTCMonth(c),(0>c||c>11)&&(c=(c+12)%12);else{for(var j=0;i>j;j++)e=this.moveMonth(e,b);c=e.getUTCMonth(),e.setUTCDate(f),d=function(){return c!==e.getUTCMonth()}}for(;d();)e.setUTCDate(--f),e.setUTCMonth(c);return e},moveYear:function(a,b){return this.moveMonth(a,12*b)},moveAvailableDate:function(a,b,c){do{if(a=this[c](a,b),!this.dateWithinRange(a))return!1;c="moveDay"}while(this.dateIsDisabled(a));return a},weekOfDateIsDisabled:function(b){return-1!==a.inArray(b.getUTCDay(),this.o.daysOfWeekDisabled)},dateIsDisabled:function(b){return this.weekOfDateIsDisabled(b)||a.grep(this.o.datesDisabled,function(a){return e(b,a)}).length>0},dateWithinRange:function(a){return a>=this.o.startDate&&a<=this.o.endDate},keydown:function(a){if(!this.picker.is(":visible"))return void((40===a.keyCode||27===a.keyCode)&&(this.show(),a.stopPropagation()));var b,c,d=!1,e=this.focusDate||this.viewDate;switch(a.keyCode){case 27:this.focusDate?(this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill()):this.hide(),a.preventDefault(),a.stopPropagation();break;case 37:case 38:case 39:case 40:if(!this.o.keyboardNavigation||7===this.o.daysOfWeekDisabled.length)break;b=37===a.keyCode||38===a.keyCode?-1:1,0===this.viewMode?a.ctrlKey?(c=this.moveAvailableDate(e,b,"moveYear"),c&&this._trigger("changeYear",this.viewDate)):a.shiftKey?(c=this.moveAvailableDate(e,b,"moveMonth"),c&&this._trigger("changeMonth",this.viewDate)):37===a.keyCode||39===a.keyCode?c=this.moveAvailableDate(e,b,"moveDay"):this.weekOfDateIsDisabled(e)||(c=this.moveAvailableDate(e,b,"moveWeek")):1===this.viewMode?((38===a.keyCode||40===a.keyCode)&&(b=4*b),c=this.moveAvailableDate(e,b,"moveMonth")):2===this.viewMode&&((38===a.keyCode||40===a.keyCode)&&(b=4*b),c=this.moveAvailableDate(e,b,"moveYear")),c&&(this.focusDate=this.viewDate=c,this.setValue(),this.fill(),a.preventDefault());break;case 13:if(!this.o.forceParse)break;e=this.focusDate||this.dates.get(-1)||this.viewDate,this.o.keyboardNavigation&&(this._toggle_multidate(e),d=!0),this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.setValue(),this.fill(),this.picker.is(":visible")&&(a.preventDefault(),a.stopPropagation(),this.o.autoclose&&this.hide());break;case 9:this.focusDate=null,this.viewDate=this.dates.get(-1)||this.viewDate,this.fill(),this.hide()}d&&(this.dates.length?this._trigger("changeDate"):this._trigger("clearDate"),this.inputField&&this.inputField.change())},showMode:function(a){a&&(this.viewMode=Math.max(this.o.minViewMode,Math.min(this.o.maxViewMode,this.viewMode+a))),this.picker.children("div").hide().filter(".datepicker-"+r.modes[this.viewMode].clsName).show(),this.updateNavArrows()}};var l=function(b,c){a(b).data("datepicker",this),this.element=a(b),this.inputs=a.map(c.inputs,function(a){return a.jquery?a[0]:a}),delete c.inputs,n.call(a(this.inputs),c).on("changeDate",a.proxy(this.dateUpdated,this)),this.pickers=a.map(this.inputs,function(b){return a(b).data("datepicker")}),this.updateDates()};l.prototype={updateDates:function(){this.dates=a.map(this.pickers,function(a){return a.getUTCDate()}),this.updateRanges()},updateRanges:function(){var b=a.map(this.dates,function(a){return a.valueOf()});a.each(this.pickers,function(a,c){c.setRange(b)})},dateUpdated:function(b){if(!this.updating){this.updating=!0;var c=a(b.target).data("datepicker");if("undefined"!=typeof c){var d=c.getUTCDate(),e=a.inArray(b.target,this.inputs),f=e-1,g=e+1,h=this.inputs.length;if(-1!==e){if(a.each(this.pickers,function(a,b){b.getUTCDate()||b.setUTCDate(d)}),d<this.dates[f])for(;f>=0&&d<this.dates[f];)this.pickers[f--].setUTCDate(d);else if(d>this.dates[g])for(;h>g&&d>this.dates[g];)this.pickers[g++].setUTCDate(d);this.updateDates(),delete this.updating}}}},remove:function(){a.map(this.pickers,function(a){a.remove()}),delete this.element.data().datepicker}};var m=a.fn.datepicker,n=function(c){var d=Array.apply(null,arguments);d.shift();var e;if(this.each(function(){var b=a(this),f=b.data("datepicker"),g="object"==typeof c&&c;if(!f){var j=h(this,"date"),m=a.extend({},o,j,g),n=i(m.language),p=a.extend({},o,n,j,g);b.hasClass("input-daterange")||p.inputs?(a.extend(p,{inputs:p.inputs||b.find("input").toArray()}),f=new l(this,p)):f=new k(this,p),b.data("datepicker",f)}"string"==typeof c&&"function"==typeof f[c]&&(e=f[c].apply(f,d))}),e===b||e instanceof k||e instanceof l)return this;if(this.length>1)throw new Error("Using only allowed for the collection of a single element ("+c+" function)");return e};a.fn.datepicker=n;var o=a.fn.datepicker.defaults={assumeNearbyYear:!1,autoclose:true,beforeShowDay:a.noop,beforeShowMonth:a.noop,beforeShowYear:a.noop,beforeShowDecade:a.noop,beforeShowCentury:a.noop,calendarWeeks:!1,clearBtn:!1,toggleActive:!1,daysOfWeekDisabled:[],daysOfWeekHighlighted:[],datesDisabled:[],endDate:1/0,forceParse:!0,format:"mm/dd/yyyy",keyboardNavigation:!0,language:"en",minViewMode:0,maxViewMode:4,multidate:!1,multidateSeparator:",",orientation:"bottom",rtl:!1,startDate:-(1/0),startView:0,todayBtn:!1,todayHighlight:!1,weekStart:0,disableTouchKeyboard:!1,enableOnReadonly:!0,showOnFocus:!0,zIndexOffset:10,container:"body",immediateUpdates:!1,title:"",templates:{leftArrow:"&laquo;",rightArrow:"&raquo;"}},p=a.fn.datepicker.locale_opts=["format","rtl","weekStart"];a.fn.datepicker.Constructor=k;var q=a.fn.datepicker.dates={en:{days:["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],daysShort:["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],daysMin:["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],months:["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],monthsShort:["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],today:"Meses",clear:"Limpar",titleFormat:"MM yyyy",format:"dd/mm/yyyy"}},r={modes:[{clsName:"days",navFnc:"Month",navStep:1},{clsName:"months",navFnc:"FullYear",navStep:1},{clsName:"years",navFnc:"FullYear",navStep:10},{clsName:"decades",navFnc:"FullDecade",navStep:100},{clsName:"centuries",navFnc:"FullCentury",navStep:1e3}],isLeapYear:function(a){return a%4===0&&a%100!==0||a%400===0},getDaysInMonth:function(a,b){return[31,r.isLeapYear(a)?29:28,31,30,31,30,31,31,30,31,30,31][b]},validParts:/dd?|DD?|mm?|MM?|yy(?:yy)?/g,nonpunctuation:/[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,parseFormat:function(a){if("function"==typeof a.toValue&&"function"==typeof a.toDisplay)return a;var b=a.replace(this.validParts,"\x00").split("\x00"),c=a.match(this.validParts);if(!b||!b.length||!c||0===c.length)throw new Error("Invalid date format.");return{separators:b,parts:c}},parseDate:function(e,f,g,h){function i(a,b){return b===!0&&(b=10),100>a&&(a+=2e3,a>(new Date).getFullYear()+b&&(a-=100)),a}function j(){var a=this.slice(0,s[n].length),b=s[n].slice(0,a.length);return a.toLowerCase()===b.toLowerCase()}if(!e)return b;if(e instanceof Date)return e;if("string"==typeof f&&(f=r.parseFormat(f)),f.toValue)return f.toValue(e,f,g);var l,m,n,o,p=/([\-+]\d+)([dmwy])/,s=e.match(/([\-+]\d+)([dmwy])/g),t={d:"moveDay",m:"moveMonth",w:"moveWeek",y:"moveYear"},u={yesterday:"-1d",today:"+0d",tomorrow:"+1d"};if(/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e)){for(e=new Date,n=0;n<s.length;n++)l=p.exec(s[n]),m=parseInt(l[1]),o=t[l[2]],e=k.prototype[o](e,m);return c(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate())}if("undefined"!=typeof u[e]&&(e=u[e],s=e.match(/([\-+]\d+)([dmwy])/g),/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(e))){for(e=new Date,n=0;n<s.length;n++)l=p.exec(s[n]),m=parseInt(l[1]),o=t[l[2]],e=k.prototype[o](e,m);return c(e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate())}s=e&&e.match(this.nonpunctuation)||[],e=new Date;var v,w,x={},y=["yyyy","yy","M","MM","m","mm","d","dd"],z={yyyy:function(a,b){return a.setUTCFullYear(h?i(b,h):b)},yy:function(a,b){return a.setUTCFullYear(h?i(b,h):b)},m:function(a,b){if(isNaN(a))return a;for(b-=1;0>b;)b+=12;for(b%=12,a.setUTCMonth(b);a.getUTCMonth()!==b;)a.setUTCDate(a.getUTCDate()-1);return a},d:function(a,b){return a.setUTCDate(b)}};z.M=z.MM=z.mm=z.m,z.dd=z.d,e=d();var A=f.parts.slice();if(s.length!==A.length&&(A=a(A).filter(function(b,c){return-1!==a.inArray(c,y)}).toArray()),s.length===A.length){var B;for(n=0,B=A.length;B>n;n++){if(v=parseInt(s[n],10),l=A[n],isNaN(v))switch(l){case"MM":w=a(q[g].months).filter(j),v=a.inArray(w[0],q[g].months)+1;break;case"M":w=a(q[g].monthsShort).filter(j),v=a.inArray(w[0],q[g].monthsShort)+1}x[l]=v}var C,D;for(n=0;n<y.length;n++)D=y[n],D in x&&!isNaN(x[D])&&(C=new Date(e),z[D](C,x[D]),isNaN(C)||(e=C))}return e},formatDate:function(b,c,d){if(!b)return"";if("string"==typeof c&&(c=r.parseFormat(c)),
c.toDisplay)return c.toDisplay(b,c,d);var e={d:b.getUTCDate(),D:q[d].daysShort[b.getUTCDay()],DD:q[d].days[b.getUTCDay()],m:b.getUTCMonth()+1,M:q[d].monthsShort[b.getUTCMonth()],MM:q[d].months[b.getUTCMonth()],yy:b.getUTCFullYear().toString().substring(2),yyyy:b.getUTCFullYear()};e.dd=(e.d<10?"0":"")+e.d,e.mm=(e.m<10?"0":"")+e.m,b=[];for(var f=a.extend([],c.separators),g=0,h=c.parts.length;h>=g;g++)f.length&&b.push(f.shift()),b.push(e[c.parts[g]]);return b.join("")},headTemplate:'<thead><tr><th colspan="7" class="datepicker-title"></th></tr><tr><th class="prev">&laquo;</th><th colspan="5" class="datepicker-switch"></th><th class="next">&raquo;</th></tr></thead>',contTemplate:'<tbody><tr><td colspan="7"></td></tr></tbody>',footTemplate:'<tfoot><tr><th colspan="7" class="today"></th></tr><tr><th colspan="7" class="clear"></th></tr></tfoot>'};r.template='<div class="datepicker"><div class="datepicker-days"><table class="table-condensed">'+r.headTemplate+"<tbody></tbody>"+r.footTemplate+'</table></div><div class="datepicker-months"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-years"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-decades"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+'</table></div><div class="datepicker-centuries"><table class="table-condensed">'+r.headTemplate+r.contTemplate+r.footTemplate+"</table></div></div>",a.fn.datepicker.DPGlobal=r,a.fn.datepicker.noConflict=function(){return a.fn.datepicker=m,this},a.fn.datepicker.version="1.6.4",a(document).on("focus.datepicker.data-api click.datepicker.data-api",'[data-provide="datepicker"]',function(b){var c=a(this);c.data("datepicker")||(b.preventDefault(),n.call(c,"show"))}),a(function(){n.call(a('[data-provide="datepicker-inline"]'))})});
!function (e, t, i, n) { "use strict"; var a = i("html"), s = i(e), o = i(t), r = i.fancybox = function () { r.open.apply(this, arguments) }, l = navigator.userAgent.match(/msie/i), c = null, d = t.createTouch !== n, h = function (e) { return e && e.hasOwnProperty && e instanceof i }, p = function (e) { return e && "string" === i.type(e) }, u = function (e) { return p(e) && e.indexOf("%") > 0 }, f = function (e) { return e && !(e.style.overflow && "hidden" === e.style.overflow) && (e.clientWidth && e.scrollWidth > e.clientWidth || e.clientHeight && e.scrollHeight > e.clientHeight) }, g = function (e, t) { var i = parseInt(e, 10) || 0; return t && u(e) && (i = r.getViewport()[t] / 100 * i), Math.ceil(i) }, m = function (e, t) { return g(e, t) + "px" }; i.extend(r, { version: "2.1.5", defaults: { padding: 15, margin: 20, width: 800, height: 600, minWidth: 100, minHeight: 100, maxWidth: 9999, maxHeight: 9999, pixelRatio: 1, autoSize: !0, autoHeight: !1, autoWidth: !1, autoResize: !0, autoCenter: !d, fitToView: !0, aspectRatio: !1, topRatio: .5, leftRatio: .5, scrolling: "auto", wrapCSS: "", arrows: !0, closeBtn: !0, closeClick: !1, nextClick: !1, mouseWheel: !0, autoPlay: !1, playSpeed: 3e3, preload: 3, modal: !1, loop: !0, ajax: { dataType: "html", headers: { "X-fancyBox": !0 } }, iframe: { scrolling: "auto", preload: !0 }, swf: { wmode: "transparent", allowfullscreen: "true", allowscriptaccess: "always" }, keys: { next: { 13: "left", 34: "up", 39: "left", 40: "up" }, prev: { 8: "right", 33: "down", 37: "right", 38: "down" }, close: [27], play: [32], toggle: [70] }, direction: { next: "left", prev: "right" }, scrollOutside: !0, index: 0, type: null, href: null, content: null, title: null, tpl: { wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>', image: '<img class="fancybox-image" src="{href}" alt="" />', iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (l ? ' allowtransparency="true"' : "") + "></iframe>", error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>', closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>', next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>', prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>' }, openEffect: "fade", openSpeed: 250, openEasing: "swing", openOpacity: !0, openMethod: "zoomIn", closeEffect: "fade", closeSpeed: 250, closeEasing: "swing", closeOpacity: !0, closeMethod: "zoomOut", nextEffect: "elastic", nextSpeed: 250, nextEasing: "swing", nextMethod: "changeIn", prevEffect: "elastic", prevSpeed: 250, prevEasing: "swing", prevMethod: "changeOut", helpers: { overlay: !0, title: !0 }, onCancel: i.noop, beforeLoad: i.noop, afterLoad: i.noop, beforeShow: i.noop, afterShow: i.noop, beforeChange: i.noop, beforeClose: i.noop, afterClose: i.noop }, group: {}, opts: {}, previous: null, coming: null, current: null, isActive: !1, isOpen: !1, isOpened: !1, wrap: null, skin: null, outer: null, inner: null, player: { timer: null, isActive: !1 }, ajaxLoad: null, imgPreload: null, transitions: {}, helpers: {}, open: function (e, t) { return e && (i.isPlainObject(t) || (t = {}), !1 !== r.close(!0)) ? (i.isArray(e) || (e = h(e) ? i(e).get() : [e]), i.each(e, function (a, s) { var o, l, c, d, u, f, g, m = {}; "object" === i.type(s) && (s.nodeType && (s = i(s)), h(s) ? (m = { href: s.data("fancybox-href") || s.attr("href"), title: s.data("fancybox-title") || s.attr("title"), isDom: !0, element: s }, i.metadata && i.extend(!0, m, s.metadata())) : m = s), o = t.href || m.href || (p(s) ? s : null), l = t.title !== n ? t.title : m.title || "", c = t.content || m.content, d = c ? "html" : t.type || m.type, !d && m.isDom && (d = s.data("fancybox-type"), d || (u = s.prop("class").match(/fancybox\.(\w+)/), d = u ? u[1] : null)), p(o) && (d || (r.isImage(o) ? d = "image" : r.isSWF(o) ? d = "swf" : "#" === o.charAt(0) ? d = "inline" : p(s) && (d = "html", c = s)), "ajax" === d && (f = o.split(/\s+/, 2), o = f.shift(), g = f.shift())), c || ("inline" === d ? o ? c = i(p(o) ? o.replace(/.*(?=#[^\s]+$)/, "") : o) : m.isDom && (c = s) : "html" === d ? c = o : d || o || !m.isDom || (d = "inline", c = s)), i.extend(m, { href: o, type: d, content: c, title: l, selector: g }), e[a] = m }), r.opts = i.extend(!0, {}, r.defaults, t), t.keys !== n && (r.opts.keys = t.keys ? i.extend({}, r.defaults.keys, t.keys) : !1), r.group = e, r._start(r.opts.index)) : void 0 }, cancel: function () { var e = r.coming; e && !1 !== r.trigger("onCancel") && (r.hideLoading(), r.ajaxLoad && r.ajaxLoad.abort(), r.ajaxLoad = null, r.imgPreload && (r.imgPreload.onload = r.imgPreload.onerror = null), e.wrap && e.wrap.stop(!0, !0).trigger("onReset").remove(), r.coming = null, r.current || r._afterZoomOut(e)) }, close: function (e) { r.cancel(), !1 !== r.trigger("beforeClose") && (r.unbindEvents(), r.isActive && (r.isOpen && e !== !0 ? (r.isOpen = r.isOpened = !1, r.isClosing = !0, i(".fancybox-item, .fancybox-nav").remove(), r.wrap.stop(!0, !0).removeClass("fancybox-opened"), r.transitions[r.current.closeMethod]()) : (i(".fancybox-wrap").stop(!0).trigger("onReset").remove(), r._afterZoomOut()))) }, play: function (e) { var t = function () { clearTimeout(r.player.timer) }, i = function () { t(), r.current && r.player.isActive && (r.player.timer = setTimeout(r.next, r.current.playSpeed)) }, n = function () { t(), o.unbind(".player"), r.player.isActive = !1, r.trigger("onPlayEnd") }, a = function () { r.current && (r.current.loop || r.current.index < r.group.length - 1) && (r.player.isActive = !0, o.bind({ "onCancel.player beforeClose.player": n, "onUpdate.player": i, "beforeLoad.player": t }), i(), r.trigger("onPlayStart")) }; e === !0 || !r.player.isActive && e !== !1 ? a() : n() }, next: function (e) { var t = r.current; t && (p(e) || (e = t.direction.next), r.jumpto(t.index + 1, e, "next")) }, prev: function (e) { var t = r.current; t && (p(e) || (e = t.direction.prev), r.jumpto(t.index - 1, e, "prev")) }, jumpto: function (e, t, i) { var a = r.current; a && (e = g(e), r.direction = t || a.direction[e >= a.index ? "next" : "prev"], r.router = i || "jumpto", a.loop && (0 > e && (e = a.group.length + e % a.group.length), e %= a.group.length), a.group[e] !== n && (r.cancel(), r._start(e))) }, reposition: function (e, t) { var n, a = r.current, s = a ? a.wrap : null; s && (n = r._getPosition(t), e && "scroll" === e.type ? (delete n.position, s.stop(!0, !0).animate(n, 200)) : (s.css(n), a.pos = i.extend({}, a.dim, n))) }, update: function (e) { var t = e && e.type, i = !t || "orientationchange" === t; i && (clearTimeout(c), c = null), r.isOpen && !c && (c = setTimeout(function () { var n = r.current; n && !r.isClosing && (r.wrap.removeClass("fancybox-tmp"), (i || "load" === t || "resize" === t && n.autoResize) && r._setDimension(), "scroll" === t && n.canShrink || r.reposition(e), r.trigger("onUpdate"), c = null) }, i && !d ? 0 : 300)) }, toggle: function (e) { r.isOpen && (r.current.fitToView = "boolean" === i.type(e) ? e : !r.current.fitToView, d && (r.wrap.removeAttr("style").addClass("fancybox-tmp"), r.trigger("onUpdate")), r.update()) }, hideLoading: function () { o.unbind(".loading"), i("#fancybox-loading").remove() }, showLoading: function () { var e, t; r.hideLoading(), e = i('<div id="fancybox-loading"><div></div></div>').click(r.cancel).appendTo("body"), o.bind("keydown.loading", function (e) { 27 === (e.which || e.keyCode) && (e.preventDefault(), r.cancel()) }), r.defaults.fixed || (t = r.getViewport(), e.css({ position: "absolute", top: .5 * t.h + t.y, left: .5 * t.w + t.x })) }, getViewport: function () { var t = r.current && r.current.locked || !1, i = { x: s.scrollLeft(), y: s.scrollTop() }; return t ? (i.w = t[0].clientWidth, i.h = t[0].clientHeight) : (i.w = d && e.innerWidth ? e.innerWidth : s.width(), i.h = d && e.innerHeight ? e.innerHeight : s.height()), i }, unbindEvents: function () { r.wrap && h(r.wrap) && r.wrap.unbind(".fb"), o.unbind(".fb"), s.unbind(".fb") }, bindEvents: function () { var e, t = r.current; t && (s.bind("orientationchange.fb" + (d ? "" : " resize.fb") + (t.autoCenter && !t.locked ? " scroll.fb" : ""), r.update), e = t.keys, e && o.bind("keydown.fb", function (a) { var s = a.which || a.keyCode, o = a.target || a.srcElement; return 27 === s && r.coming ? !1 : (a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || o && (o.type || i(o).is("[contenteditable]")) || i.each(e, function (e, o) { return t.group.length > 1 && o[s] !== n ? (r[e](o[s]), a.preventDefault(), !1) : i.inArray(s, o) > -1 ? (r[e](), a.preventDefault(), !1) : void 0 }), void 0) }), i.fn.mousewheel && t.mouseWheel && r.wrap.bind("mousewheel.fb", function (e, n, a, s) { for (var o = e.target || null, l = i(o), c = !1; l.length && !(c || l.is(".fancybox-skin") || l.is(".fancybox-wrap"));)c = f(l[0]), l = i(l).parent(); 0 === n || c || r.group.length > 1 && !t.canShrink && (s > 0 || a > 0 ? r.prev(s > 0 ? "down" : "left") : (0 > s || 0 > a) && r.next(0 > s ? "up" : "right"), e.preventDefault()) })) }, trigger: function (e, t) { var n, a = t || r.coming || r.current; if (a) { if (i.isFunction(a[e]) && (n = a[e].apply(a, Array.prototype.slice.call(arguments, 1))), n === !1) return !1; a.helpers && i.each(a.helpers, function (t, n) { n && r.helpers[t] && i.isFunction(r.helpers[t][e]) && r.helpers[t][e](i.extend(!0, {}, r.helpers[t].defaults, n), a) }), o.trigger(e) } }, isImage: function (e) { return p(e) && e.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i) }, isSWF: function (e) { return p(e) && e.match(/\.(swf)((\?|#).*)?$/i) }, _start: function (e) { var t, n, a, s, o, l = {}; if (e = g(e), t = r.group[e] || null, !t) return !1; if (l = i.extend(!0, {}, r.opts, t), s = l.margin, o = l.padding, "number" === i.type(s) && (l.margin = [s, s, s, s]), "number" === i.type(o) && (l.padding = [o, o, o, o]), l.modal && i.extend(!0, l, { closeBtn: !1, closeClick: !1, nextClick: !1, arrows: !1, mouseWheel: !1, keys: null, helpers: { overlay: { closeClick: !1 } } }), l.autoSize && (l.autoWidth = l.autoHeight = !0), "auto" === l.width && (l.autoWidth = !0), "auto" === l.height && (l.autoHeight = !0), l.group = r.group, l.index = e, r.coming = l, !1 === r.trigger("beforeLoad")) return r.coming = null, void 0; if (a = l.type, n = l.href, !a) return r.coming = null, r.current && r.router && "jumpto" !== r.router ? (r.current.index = e, r[r.router](r.direction)) : !1; if (r.isActive = !0, ("image" === a || "swf" === a) && (l.autoHeight = l.autoWidth = !1, l.scrolling = "visible"), "image" === a && (l.aspectRatio = !0), "iframe" === a && d && (l.scrolling = "scroll"), l.wrap = i(l.tpl.wrap).addClass("fancybox-" + (d ? "mobile" : "desktop") + " fancybox-type-" + a + " fancybox-tmp " + l.wrapCSS).appendTo(l.parent || "body"), i.extend(l, { skin: i(".fancybox-skin", l.wrap), outer: i(".fancybox-outer", l.wrap), inner: i(".fancybox-inner", l.wrap) }), i.each(["Top", "Right", "Bottom", "Left"], function (e, t) { l.skin.css("padding" + t, m(l.padding[e])) }), r.trigger("onReady"), "inline" === a || "html" === a) { if (!l.content || !l.content.length) return r._error("content") } else if (!n) return r._error("href"); "image" === a ? r._loadImage() : "ajax" === a ? r._loadAjax() : "iframe" === a ? r._loadIframe() : r._afterLoad() }, _error: function (e) { i.extend(r.coming, { type: "html", autoWidth: !0, autoHeight: !0, minWidth: 0, minHeight: 0, scrolling: "no", hasError: e, content: r.coming.tpl.error }), r._afterLoad() }, _loadImage: function () { var e = r.imgPreload = new Image; e.onload = function () { this.onload = this.onerror = null, r.coming.width = this.width / r.opts.pixelRatio, r.coming.height = this.height / r.opts.pixelRatio, r._afterLoad() }, e.onerror = function () { this.onload = this.onerror = null, r._error("image") }, e.src = r.coming.href, e.complete !== !0 && r.showLoading() }, _loadAjax: function () { var e = r.coming; r.showLoading(), r.ajaxLoad = i.ajax(i.extend({}, e.ajax, { url: e.href, error: function (e, t) { r.coming && "abort" !== t ? r._error("ajax", e) : r.hideLoading() }, success: function (t, i) { "success" === i && (e.content = t, r._afterLoad()) } })) }, _loadIframe: function () { var e = r.coming, t = i(e.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", d ? "auto" : e.iframe.scrolling).attr("src", e.href); i(e.wrap).bind("onReset", function () { try { i(this).find("iframe").hide().attr("src", "//about:blank").end().empty() } catch (e) { } }), e.iframe.preload && (r.showLoading(), t.one("load", function () { i(this).data("ready", 1), d || i(this).bind("load.fb", r.update), i(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show(), r._afterLoad() })), e.content = t.appendTo(e.inner), e.iframe.preload || r._afterLoad() }, _preloadImages: function () { var e, t, i = r.group, n = r.current, a = i.length, s = n.preload ? Math.min(n.preload, a - 1) : 0; for (t = 1; s >= t; t += 1)e = i[(n.index + t) % a], "image" === e.type && e.href && ((new Image).src = e.href) }, _afterLoad: function () { var e, t, n, a, s, o, l = r.coming, c = r.current, d = "fancybox-placeholder"; if (r.hideLoading(), l && r.isActive !== !1) { if (!1 === r.trigger("afterLoad", l, c)) return l.wrap.stop(!0).trigger("onReset").remove(), r.coming = null, void 0; switch (c && (r.trigger("beforeChange", c), c.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()), r.unbindEvents(), e = l, t = l.content, n = l.type, a = l.scrolling, i.extend(r, { wrap: e.wrap, skin: e.skin, outer: e.outer, inner: e.inner, current: e, previous: c }), s = e.href, n) { case "inline": case "ajax": case "html": e.selector ? t = i("<div>").html(t).find(e.selector) : h(t) && (t.data(d) || t.data(d, i('<div class="' + d + '"></div>').insertAfter(t).hide()), t = t.show().detach(), e.wrap.bind("onReset", function () { i(this).find(t).length && t.hide().replaceAll(t.data(d)).data(d, !1) })); break; case "image": t = e.tpl.image.replace("{href}", s); break; case "swf": t = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + s + '"></param>', o = "", i.each(e.swf, function (e, i) { t += '<param name="' + e + '" value="' + i + '"></param>', o += " " + e + '="' + i + '"' }), t += '<embed src="' + s + '" type="application/x-shockwave-flash" width="100%" height="100%"' + o + "></embed></object>" }h(t) && t.parent().is(e.inner) || e.inner.append(t), r.trigger("beforeShow"), e.inner.css("overflow", "yes" === a ? "scroll" : "no" === a ? "hidden" : a), r._setDimension(), r.reposition(), r.isOpen = !1, r.coming = null, r.bindEvents(), r.isOpened ? c.prevMethod && r.transitions[c.prevMethod]() : i(".fancybox-wrap").not(e.wrap).stop(!0).trigger("onReset").remove(), r.transitions[r.isOpened ? e.nextMethod : e.openMethod](), r._preloadImages() } }, _setDimension: function () { var e, t, n, a, s, o, l, c, d, h, p, f, v, w, b, y = r.getViewport(), x = 0, _ = !1, k = !1, j = r.wrap, C = r.skin, I = r.inner, T = r.current, S = T.width, W = T.height, H = T.minWidth, L = T.minHeight, D = T.maxWidth, A = T.maxHeight, P = T.scrolling, B = T.scrollOutside ? T.scrollbarWidth : 0, M = T.margin, R = g(M[1] + M[3]), O = g(M[0] + M[2]); if (j.add(C).add(I).width("auto").height("auto").removeClass("fancybox-tmp"), e = g(C.outerWidth(!0) - C.width()), t = g(C.outerHeight(!0) - C.height()), n = R + e, a = O + t, s = u(S) ? (y.w - n) * g(S) / 100 : S, o = u(W) ? (y.h - a) * g(W) / 100 : W, "iframe" === T.type) { if (w = T.content, T.autoHeight && 1 === w.data("ready")) try { w[0].contentWindow.document.location && (I.width(s).height(9999), b = w.contents().find("body"), B && b.css("overflow-x", "hidden"), o = b.outerHeight(!0)) } catch (E) { } } else (T.autoWidth || T.autoHeight) && (I.addClass("fancybox-tmp"), T.autoWidth || I.width(s), T.autoHeight || I.height(o), T.autoWidth && (s = I.width()), T.autoHeight && (o = I.height()), I.removeClass("fancybox-tmp")); if (S = g(s), W = g(o), d = s / o, H = g(u(H) ? g(H, "w") - n : H), D = g(u(D) ? g(D, "w") - n : D), L = g(u(L) ? g(L, "h") - a : L), A = g(u(A) ? g(A, "h") - a : A), l = D, c = A, T.fitToView && (D = Math.min(y.w - n, D), A = Math.min(y.h - a, A)), f = y.w - R, v = y.h - O, T.aspectRatio ? (S > D && (S = D, W = g(S / d)), W > A && (W = A, S = g(W * d)), H > S && (S = H, W = g(S / d)), L > W && (W = L, S = g(W * d))) : (S = Math.max(H, Math.min(S, D)), T.autoHeight && "iframe" !== T.type && (I.width(S), W = I.height()), W = Math.max(L, Math.min(W, A))), T.fitToView) if (I.width(S).height(W), j.width(S + e), h = j.width(), p = j.height(), T.aspectRatio) for (; (h > f || p > v) && S > H && W > L && !(x++ > 19);)W = Math.max(L, Math.min(A, W - 10)), S = g(W * d), H > S && (S = H, W = g(S / d)), S > D && (S = D, W = g(S / d)), I.width(S).height(W), j.width(S + e), h = j.width(), p = j.height(); else S = Math.max(H, Math.min(S, S - (h - f))), W = Math.max(L, Math.min(W, W - (p - v))); B && "auto" === P && o > W && f > S + e + B && (S += B), I.width(S).height(W), j.width(S + e), h = j.width(), p = j.height(), _ = (h > f || p > v) && S > H && W > L, k = T.aspectRatio ? l > S && c > W && s > S && o > W : (l > S || c > W) && (s > S || o > W), i.extend(T, { dim: { width: m(h), height: m(p) }, origWidth: s, origHeight: o, canShrink: _, canExpand: k, wPadding: e, hPadding: t, wrapSpace: p - C.outerHeight(!0), skinSpace: C.height() - W }), !w && T.autoHeight && W > L && A > W && !k && I.height("auto") }, _getPosition: function (e) { var t = r.current, i = r.getViewport(), n = t.margin, a = r.wrap.width() + n[1] + n[3], s = r.wrap.height() + n[0] + n[2], o = { position: "absolute", top: n[0], left: n[3] }; return t.autoCenter && t.fixed && !e && s <= i.h && a <= i.w ? o.position = "fixed" : t.locked || (o.top += i.y, o.left += i.x), o.top = m(Math.max(o.top, o.top + (i.h - s) * t.topRatio)), o.left = m(Math.max(o.left, o.left + (i.w - a) * t.leftRatio)), o }, _afterZoomIn: function () { var e = r.current; e && (r.isOpen = r.isOpened = !0, r.wrap.css("overflow", "visible").addClass("fancybox-opened"), r.update(), (e.closeClick || e.nextClick && r.group.length > 1) && r.inner.css("cursor", "pointer").bind("click.fb", function (t) { i(t.target).is("a") || i(t.target).parent().is("a") || (t.preventDefault(), r[e.closeClick ? "close" : "next"]()) }), e.closeBtn && i(e.tpl.closeBtn).appendTo(r.skin).bind("click.fb", function (e) { e.preventDefault(), r.close() }), e.arrows && r.group.length > 1 && ((e.loop || e.index > 0) && i(e.tpl.prev).appendTo(r.outer).bind("click.fb", r.prev), (e.loop || e.index < r.group.length - 1) && i(e.tpl.next).appendTo(r.outer).bind("click.fb", r.next)), r.trigger("afterShow"), e.loop || e.index !== e.group.length - 1 ? r.opts.autoPlay && !r.player.isActive && (r.opts.autoPlay = !1, r.play()) : r.play(!1)) }, _afterZoomOut: function (e) { e = e || r.current, i(".fancybox-wrap").trigger("onReset").remove(), i.extend(r, { group: {}, opts: {}, router: !1, current: null, isActive: !1, isOpened: !1, isOpen: !1, isClosing: !1, wrap: null, skin: null, outer: null, inner: null }), r.trigger("afterClose", e) } }), r.transitions = { getOrigPosition: function () { var e = r.current, t = e.element, i = e.orig, n = {}, a = 50, s = 50, o = e.hPadding, l = e.wPadding, c = r.getViewport(); return !i && e.isDom && t.is(":visible") && (i = t.find("img:first"), i.length || (i = t)), h(i) ? (n = i.offset(), i.is("img") && (a = i.outerWidth(), s = i.outerHeight())) : (n.top = c.y + (c.h - s) * e.topRatio, n.left = c.x + (c.w - a) * e.leftRatio), ("fixed" === r.wrap.css("position") || e.locked) && (n.top -= c.y, n.left -= c.x), n = { top: m(n.top - o * e.topRatio), left: m(n.left - l * e.leftRatio), width: m(a + l), height: m(s + o) } }, step: function (e, t) { var i, n, a, s = t.prop, o = r.current, l = o.wrapSpace, c = o.skinSpace; ("width" === s || "height" === s) && (i = t.end === t.start ? 1 : (e - t.start) / (t.end - t.start), r.isClosing && (i = 1 - i), n = "width" === s ? o.wPadding : o.hPadding, a = e - n, r.skin[s](g("width" === s ? a : a - l * i)), r.inner[s](g("width" === s ? a : a - l * i - c * i))) }, zoomIn: function () { var e = r.current, t = e.pos, n = e.openEffect, a = "elastic" === n, s = i.extend({ opacity: 1 }, t); delete s.position, a ? (t = this.getOrigPosition(), e.openOpacity && (t.opacity = .1)) : "fade" === n && (t.opacity = .1), r.wrap.css(t).animate(s, { duration: "none" === n ? 0 : e.openSpeed, easing: e.openEasing, step: a ? this.step : null, complete: r._afterZoomIn }) }, zoomOut: function () { var e = r.current, t = e.closeEffect, i = "elastic" === t, n = { opacity: .1 }; i && (n = this.getOrigPosition(), e.closeOpacity && (n.opacity = .1)), r.wrap.animate(n, { duration: "none" === t ? 0 : e.closeSpeed, easing: e.closeEasing, step: i ? this.step : null, complete: r._afterZoomOut }) }, changeIn: function () { var e, t = r.current, i = t.nextEffect, n = t.pos, a = { opacity: 1 }, s = r.direction, o = 200; n.opacity = .1, "elastic" === i && (e = "down" === s || "up" === s ? "top" : "left", "down" === s || "right" === s ? (n[e] = m(g(n[e]) - o), a[e] = "+=" + o + "px") : (n[e] = m(g(n[e]) + o), a[e] = "-=" + o + "px")), "none" === i ? r._afterZoomIn() : r.wrap.css(n).animate(a, { duration: t.nextSpeed, easing: t.nextEasing, complete: r._afterZoomIn }) }, changeOut: function () { var e = r.previous, t = e.prevEffect, n = { opacity: .1 }, a = r.direction, s = 200; "elastic" === t && (n["down" === a || "up" === a ? "top" : "left"] = ("up" === a || "left" === a ? "-" : "+") + "=" + s + "px"), e.wrap.animate(n, { duration: "none" === t ? 0 : e.prevSpeed, easing: e.prevEasing, complete: function () { i(this).trigger("onReset").remove() } }) } }, r.helpers.overlay = { defaults: { closeClick: !0, speedOut: 200, showEarly: !0, css: {}, locked: !d, fixed: !0 }, overlay: null, fixed: !1, el: i("html"), create: function (e) { e = i.extend({}, this.defaults, e), this.overlay && this.close(), this.overlay = i('<div class="fancybox-overlay"></div>').appendTo(r.coming ? r.coming.parent : e.parent), this.fixed = !1, e.fixed && r.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), this.fixed = !0) }, open: function (e) { var t = this; e = i.extend({}, this.defaults, e), this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(e), this.fixed || (s.bind("resize.overlay", i.proxy(this.update, this)), this.update()), e.closeClick && this.overlay.bind("click.overlay", function (e) { return i(e.target).hasClass("fancybox-overlay") ? (r.isActive ? r.close() : t.close(), !1) : void 0 }), this.overlay.css(e.css).show() }, close: function () { var e, t; s.unbind("resize.overlay"), this.el.hasClass("fancybox-lock") && (i(".fancybox-margin").removeClass("fancybox-margin"), e = s.scrollTop(), t = s.scrollLeft(), this.el.removeClass("fancybox-lock"), s.scrollTop(e).scrollLeft(t)), i(".fancybox-overlay").remove().hide(), i.extend(this, { overlay: null, fixed: !1 }) }, update: function () { var e, i = "100%"; this.overlay.width(i).height("100%"), l ? (e = Math.max(t.documentElement.offsetWidth, t.body.offsetWidth), o.width() > e && (i = o.width())) : o.width() > s.width() && (i = o.width()), this.overlay.width(i).height(o.height()) }, onReady: function (e, t) { var n = this.overlay; i(".fancybox-overlay").stop(!0, !0), n || this.create(e), e.locked && this.fixed && t.fixed && (n || (this.margin = o.height() > s.height() ? i("html").css("margin-right").replace("px", "") : !1), t.locked = this.overlay.append(t.wrap), t.fixed = !1), e.showEarly === !0 && this.beforeShow.apply(this, arguments) }, beforeShow: function (e, t) { var n, a; t.locked && (this.margin !== !1 && (i("*").filter(function () { return "fixed" === i(this).css("position") && !i(this).hasClass("fancybox-overlay") && !i(this).hasClass("fancybox-wrap") }).addClass("fancybox-margin"), this.el.addClass("fancybox-margin")), n = s.scrollTop(), a = s.scrollLeft(), this.el.addClass("fancybox-lock"), s.scrollTop(n).scrollLeft(a)), this.open(e) }, onUpdate: function () { this.fixed || this.update() }, afterClose: function (e) { this.overlay && !r.coming && this.overlay.fadeOut(e.speedOut, i.proxy(this.close, this)) } }, r.helpers.title = { defaults: { type: "float", position: "bottom" }, beforeShow: function (e) { var t, n, a = r.current, s = a.title, o = e.type; if (i.isFunction(s) && (s = s.call(a.element, a)), p(s) && "" !== i.trim(s)) { switch (t = i('<div class="fancybox-title fancybox-title-' + o + '-wrap">' + s + "</div>"), o) { case "inside": n = r.skin; break; case "outside": n = r.wrap; break; case "over": n = r.inner; break; default: n = r.skin, t.appendTo("body"), l && t.width(t.width()), t.wrapInner('<span class="child"></span>'), r.current.margin[2] += Math.abs(g(t.css("margin-bottom"))) }t["top" === e.position ? "prependTo" : "appendTo"](n) } } }, i.fn.fancybox = function (e) { var t, n = i(this), a = this.selector || "", s = function (s) { var o, l, c = i(this).blur(), d = t; s.ctrlKey || s.altKey || s.shiftKey || s.metaKey || c.is(".fancybox-wrap") || (o = e.groupAttr || "data-fancybox-group", l = c.attr(o), l || (o = "rel", l = c.get(0)[o]), l && "" !== l && "nofollow" !== l && (c = a.length ? i(a) : n, c = c.filter("[" + o + '="' + l + '"]'), d = c.index(this)), e.index = d, r.open(c, e) !== !1 && s.preventDefault()) }; return e = e || {}, t = e.index || 0, a && e.live !== !1 ? o.undelegate(a, "click.fb-start").delegate(a + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", s) : n.unbind("click.fb-start").bind("click.fb-start", s), this.filter("[data-fancybox-start=1]").trigger("click"), this }, o.ready(function () { var t, s; i.scrollbarWidth === n && (i.scrollbarWidth = function () { var e = i('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"), t = e.children(), n = t.innerWidth() - t.height(99).innerWidth(); return e.remove(), n }), i.support.fixedPosition === n && (i.support.fixedPosition = function () { var e = i('<div style="position:fixed;top:20px;"></div>').appendTo("body"), t = 20 === e[0].offsetTop || 15 === e[0].offsetTop; return e.remove(), t }()), i.extend(r.defaults, { scrollbarWidth: i.scrollbarWidth(), fixed: i.support.fixedPosition, parent: i("body") }), t = i(e).width(), a.addClass("fancybox-lock-test"), s = i(e).width(), a.removeClass("fancybox-lock-test"), i("<style type='text/css'>.fancybox-margin{margin-right:" + (s - t) + "px;}</style>").appendTo("head") }) }(window, document, jQuery);
// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "/api";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }

  var urlBaseHost = getHost(urlBase) || location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Endereco
 * @header lbServices.Endereco
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Endereco` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Endereco",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/enderecos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usuario.enderecos.findById() instead.
            "::findById::Usuario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.enderecos.destroyById() instead.
            "::destroyById::Usuario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.enderecos.updateById() instead.
            "::updateById::Usuario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.enderecos() instead.
            "::get::Usuario::enderecos": {
              isArray: true,
              url: urlBase + "/users/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Usuario.enderecos.create() instead.
            "::create::Usuario::enderecos": {
              url: urlBase + "/users/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Usuario.enderecos.createMany() instead.
            "::createMany::Usuario::enderecos": {
              isArray: true,
              url: urlBase + "/users/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Usuario.enderecos.destroyAll() instead.
            "::delete::Usuario::enderecos": {
              url: urlBase + "/users/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.enderecos.count() instead.
            "::count::Usuario::enderecos": {
              url: urlBase + "/users/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos.findById() instead.
            "::findById::Corretor::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos.destroyById() instead.
            "::destroyById::Corretor::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.enderecos.updateById() instead.
            "::updateById::Corretor::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.enderecos() instead.
            "::get::Corretor::enderecos": {
              isArray: true,
              url: urlBase + "/corretores/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos.create() instead.
            "::create::Corretor::enderecos": {
              url: urlBase + "/corretores/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Corretor.enderecos.createMany() instead.
            "::createMany::Corretor::enderecos": {
              isArray: true,
              url: urlBase + "/corretores/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Corretor.enderecos.destroyAll() instead.
            "::delete::Corretor::enderecos": {
              url: urlBase + "/corretores/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.enderecos.count() instead.
            "::count::Corretor::enderecos": {
              url: urlBase + "/corretores/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos.findById() instead.
            "::findById::Proprietario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos.destroyById() instead.
            "::destroyById::Proprietario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.enderecos.updateById() instead.
            "::updateById::Proprietario::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.enderecos() instead.
            "::get::Proprietario::enderecos": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos.create() instead.
            "::create::Proprietario::enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.enderecos.createMany() instead.
            "::createMany::Proprietario::enderecos": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.enderecos.destroyAll() instead.
            "::delete::Proprietario::enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.enderecos.count() instead.
            "::count::Proprietario::enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Empresa.enderecos.findById() instead.
            "::findById::Empresa::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empresa.enderecos.destroyById() instead.
            "::destroyById::Empresa::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.enderecos.updateById() instead.
            "::updateById::Empresa::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empresa.enderecos() instead.
            "::get::Empresa::enderecos": {
              isArray: true,
              url: urlBase + "/empresas/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Empresa.enderecos.create() instead.
            "::create::Empresa::enderecos": {
              url: urlBase + "/empresas/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Empresa.enderecos.createMany() instead.
            "::createMany::Empresa::enderecos": {
              isArray: true,
              url: urlBase + "/empresas/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Empresa.enderecos.destroyAll() instead.
            "::delete::Empresa::enderecos": {
              url: urlBase + "/empresas/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.enderecos.count() instead.
            "::count::Empresa::enderecos": {
              url: urlBase + "/empresas/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.findById() instead.
            "::findById::Imobiliaria::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.destroyById() instead.
            "::destroyById::Imobiliaria::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.enderecos.updateById() instead.
            "::updateById::Imobiliaria::enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.enderecos() instead.
            "::get::Imobiliaria::enderecos": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.create() instead.
            "::create::Imobiliaria::enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.enderecos.createMany() instead.
            "::createMany::Imobiliaria::enderecos": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.enderecos.destroyAll() instead.
            "::delete::Imobiliaria::enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.enderecos.count() instead.
            "::count::Imobiliaria::enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Endereco#modelName
        * @propertyOf lbServices.Endereco
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Endereco`.
        */
        R.modelName = "Endereco";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Storage
 * @header lbServices.Storage
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Storage` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Storage",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/upload/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Storage#getContainers
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Storage` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/upload",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#createContainer
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Storage` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#destroyContainer
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/upload/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#getContainer
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Storage` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/upload/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#getFiles
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Storage` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/upload/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#getFile
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Storage` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/upload/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#removeFile
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/upload/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#upload
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/upload/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Storage#download
             * @methodOf lbServices.Storage
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/upload/:container/download/:file",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Storage#modelName
        * @propertyOf lbServices.Storage
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Storage`.
        */
        R.modelName = "Storage";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Usuario
 * @header lbServices.Usuario
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Usuario` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Usuario",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Usuario.enderecos.findById() instead.
            "prototype$__findById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.enderecos.destroyById() instead.
            "prototype$__destroyById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.enderecos.updateById() instead.
            "prototype$__updateById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/enderecos/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__findById__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__destroyById__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__updateById__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.estado_civil() instead.
            "prototype$__get__estado_civil": {
              url: urlBase + "/users/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.perfil_usuario() instead.
            "prototype$__get__perfil_usuario": {
              url: urlBase + "/users/:id/perfil_usuario",
              method: "GET",
            },

            // INTERNAL. Use Usuario.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/users/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Usuario.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/users/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais.findById() instead.
            "prototype$__findById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais.destroyById() instead.
            "prototype$__destroyById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.redessociais.updateById() instead.
            "prototype$__updateById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.prop_imob.findById() instead.
            "prototype$__findById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.prop_imob.destroyById() instead.
            "prototype$__destroyById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.prop_imob.updateById() instead.
            "prototype$__updateById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.timecorretor.findById() instead.
            "prototype$__findById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.timecorretor.destroyById() instead.
            "prototype$__destroyById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.timecorretor.updateById() instead.
            "prototype$__updateById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__findById__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__findById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__destroyById__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__updateById__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update a related item by id for identities.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for identities
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__updateById__identities": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/identities/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__findById__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__findById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__destroyById__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__updateById__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update a related item by id for credentials.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for credentials
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__updateById__credentials": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/credentials/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.enderecos() instead.
            "prototype$__get__enderecos": {
              isArray: true,
              url: urlBase + "/users/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Usuario.enderecos.create() instead.
            "prototype$__create__enderecos": {
              url: urlBase + "/users/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Usuario.enderecos.destroyAll() instead.
            "prototype$__delete__enderecos": {
              url: urlBase + "/users/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.enderecos.count() instead.
            "prototype$__count__enderecos": {
              url: urlBase + "/users/:id/enderecos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__get__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries accessTokens of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__create__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__delete__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__count__accessTokens
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Counts accessTokens of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/users/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/users/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Usuario.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/users/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/users/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais() instead.
            "prototype$__get__redessociais": {
              isArray: true,
              url: urlBase + "/users/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais.create() instead.
            "prototype$__create__redessociais": {
              url: urlBase + "/users/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Usuario.redessociais.destroyAll() instead.
            "prototype$__delete__redessociais": {
              url: urlBase + "/users/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.redessociais.count() instead.
            "prototype$__count__redessociais": {
              url: urlBase + "/users/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Usuario.prop_imob() instead.
            "prototype$__get__prop_imob": {
              isArray: true,
              url: urlBase + "/users/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Usuario.prop_imob.create() instead.
            "prototype$__create__prop_imob": {
              url: urlBase + "/users/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Usuario.prop_imob.destroyAll() instead.
            "prototype$__delete__prop_imob": {
              url: urlBase + "/users/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.prop_imob.count() instead.
            "prototype$__count__prop_imob": {
              url: urlBase + "/users/:id/prop_imob/count",
              method: "GET",
            },

            // INTERNAL. Use Usuario.timecorretor() instead.
            "prototype$__get__timecorretor": {
              isArray: true,
              url: urlBase + "/users/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Usuario.timecorretor.create() instead.
            "prototype$__create__timecorretor": {
              url: urlBase + "/users/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Usuario.timecorretor.destroyAll() instead.
            "prototype$__delete__timecorretor": {
              url: urlBase + "/users/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.timecorretor.count() instead.
            "prototype$__count__timecorretor": {
              url: urlBase + "/users/:id/timecorretor/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__get__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries identities of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__get__identities": {
              isArray: true,
              url: urlBase + "/users/:id/identities",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__create__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Creates a new instance in identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__create__identities": {
              url: urlBase + "/users/:id/identities",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__delete__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Deletes all identities of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__identities": {
              url: urlBase + "/users/:id/identities",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__count__identities
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Counts identities of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__identities": {
              url: urlBase + "/users/:id/identities/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__get__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries credentials of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__get__credentials": {
              isArray: true,
              url: urlBase + "/users/:id/credentials",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__create__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Creates a new instance in credentials of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$__create__credentials": {
              url: urlBase + "/users/:id/credentials",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__delete__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Deletes all credentials of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__credentials": {
              url: urlBase + "/users/:id/credentials",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$__count__credentials
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Counts credentials of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__credentials": {
              url: urlBase + "/users/:id/credentials/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#create
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#createMany
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#upsert
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#replaceOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#upsertWithWhere
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#exists
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#findById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#replaceById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#find
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#findOne
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#updateAll
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#deleteById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#count
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$updateAttributes
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#createChangeStream
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#login
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#logout
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#confirm
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#resetPassword
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#userLogout
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Logs user out.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "userLogout": {
              url: urlBase + "/users/user-logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#changePwd
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Changes a logged in user password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `accessToken` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePwd": {
              url: urlBase + "/users/change-pwd",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#checkJwtToken
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "checkJwtToken": {
              url: urlBase + "/users/check-jwt-token",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#resetPasswordAction
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Action to reset user password
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPasswordAction": {
              url: urlBase + "/users/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#createUserWeb
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create User.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "createUserWeb": {
              url: urlBase + "/users/user-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#create
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#createMany
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#upsert
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/users",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#replaceOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#upsertWithWhere
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#exists
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#findById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#replaceById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#find
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#findOne
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#updateAll
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#deleteById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#count
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#prototype$updateAttributes
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/users/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#createChangeStream
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#pager
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/users/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#pagerDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/users/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#postDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/users/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#deleteDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/users/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#editDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/users/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#autocomplete
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/users/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#autocompleteDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/users/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#autocompleteDetailEdit
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/users/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#autocompleteGeneral
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/users/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#crudGET
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/users/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#crudGETDetail
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/users/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#quickAdd
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/users/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imbGestor() instead.
            "::get::Imobiliaria::imbGestor": {
              url: urlBase + "/imobiliarias/:id/imbGestor",
              method: "GET",
            },

            // INTERNAL. Use Imovel.corretor() instead.
            "::get::Imovel::corretor": {
              url: urlBase + "/imoveis/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use HistoricoClienteInteressado.corretor() instead.
            "::get::HistoricoClienteInteressado::corretor": {
              url: urlBase + "/historicosclienteinteressado/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.usuario() instead.
            "::get::ProprietarioImobiliaria::usuario": {
              url: urlBase + "/proprietarioimobiliarias/:id/usuario",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propGestor() instead.
            "::get::Proposta::propGestor": {
              url: urlBase + "/propostas/:id/propGestor",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logUsuario() instead.
            "::get::PropostaStatusLog::logUsuario": {
              url: urlBase + "/propostastatuslogs/:id/logUsuario",
              method: "GET",
            },

            // INTERNAL. Use PropostaAllLog.logUsuario() instead.
            "::get::PropostaAllLog::logUsuario": {
              url: urlBase + "/propostaalllogs/:id/logUsuario",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.usuario() instead.
            "::get::ClienteInteressadoAtividade::usuario": {
              url: urlBase + "/clienteinteressadoatividades/:id/usuario",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.corretor() instead.
            "::get::ClienteInteressadoAtividade::corretor": {
              url: urlBase + "/clienteinteressadoatividades/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TimeCorretor.corretor() instead.
            "::get::TimeCorretor::corretor": {
              url: urlBase + "/timesCorretores/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use Urlacess.usuario() instead.
            "::get::Urlacess::usuario": {
              url: urlBase + "/urlacesses/:id/usuario",
              method: "GET",
            },

            // INTERNAL. Use AvaliacaoCorretor.corretor() instead.
            "::get::AvaliacaoCorretor::corretor": {
              url: urlBase + "/avaliarcorretor/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoObservador.observador() instead.
            "::get::ClienteInteressadoObservador::observador": {
              url: urlBase + "/clientesinteressadoObservadores/:id/observador",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Usuario#getCurrent
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#updateOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchOrCreateWithWhere
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#update
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#destroyById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#removeById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchAttributes
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#updateOrCreate
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchOrCreateWithWhere
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#update
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#destroyById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#removeById
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Usuario#patchAttributes
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.Usuario#getCachedCurrent
         * @methodOf lbServices.Usuario
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Usuario#login} or
         * {@link lbServices.Usuario#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Usuario instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Usuario#isAuthenticated
         * @methodOf lbServices.Usuario
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Usuario#getCurrentId
         * @methodOf lbServices.Usuario
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Usuario#modelName
        * @propertyOf lbServices.Usuario
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Usuario`.
        */
        R.modelName = "Usuario";

    /**
     * @ngdoc object
     * @name lbServices.Usuario.enderecos
     * @header lbServices.Usuario.enderecos
     * @object
     * @description
     *
     * The object `Usuario.enderecos` groups methods
     * manipulating `Endereco` instances related to `Usuario`.
     *
     * Call {@link lbServices.Usuario#enderecos Usuario.enderecos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usuario#enderecos
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries enderecos of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::get::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#count
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Counts enderecos of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.enderecos.count = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::count::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#create
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.create = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::create::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#createMany
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.createMany = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::createMany::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#destroyAll
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Deletes all enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyAll = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::delete::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#destroyById
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Delete a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::destroyById::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#findById
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Find a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.findById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::findById::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.enderecos#updateById
             * @methodOf lbServices.Usuario.enderecos
             *
             * @description
             *
             * Update a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.updateById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::updateById::Usuario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario#estado_civil
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Fetches belongsTo relation estado_civil.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R.estado_civil = function() {
          var TargetResource = $injector.get("EstadoCivil");
          var action = TargetResource["::get::Usuario::estado_civil"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usuario.telefones
     * @header lbServices.Usuario.telefones
     * @object
     * @description
     *
     * The object `Usuario.telefones` groups methods
     * manipulating `Telefone` instances related to `Usuario`.
     *
     * Call {@link lbServices.Usuario#telefones Usuario.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usuario#telefones
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries telefones of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#count
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Counts telefones of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#create
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#createMany
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#destroyAll
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#destroyById
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#findById
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.telefones#updateById
             * @methodOf lbServices.Usuario.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::Usuario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario#perfil_usuario
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Fetches belongsTo relation perfil_usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R.perfil_usuario = function() {
          var TargetResource = $injector.get("PerfilUsuario");
          var action = TargetResource["::get::Usuario::perfil_usuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario#empresa
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::Usuario::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario#imobiliaria
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Usuario::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usuario.redessociais
     * @header lbServices.Usuario.redessociais
     * @object
     * @description
     *
     * The object `Usuario.redessociais` groups methods
     * manipulating `RedeSocial` instances related to `Usuario`.
     *
     * Call {@link lbServices.Usuario#redessociais Usuario.redessociais()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usuario#redessociais
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries redessociais of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::get::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#count
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Counts redessociais of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.redessociais.count = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::count::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#create
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.create = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::create::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#createMany
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.createMany = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::createMany::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#destroyAll
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Deletes all redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyAll = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::delete::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#destroyById
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Delete a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::destroyById::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#findById
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Find a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.findById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::findById::Usuario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.redessociais#updateById
             * @methodOf lbServices.Usuario.redessociais
             *
             * @description
             *
             * Update a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.updateById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::updateById::Usuario::redessociais"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usuario.prop_imob
     * @header lbServices.Usuario.prop_imob
     * @object
     * @description
     *
     * The object `Usuario.prop_imob` groups methods
     * manipulating `ProprietarioImobiliaria` instances related to `Usuario`.
     *
     * Call {@link lbServices.Usuario#prop_imob Usuario.prop_imob()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usuario#prop_imob
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries prop_imob of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::get::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#count
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Counts prop_imob of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.prop_imob.count = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::count::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#create
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.create = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::create::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#createMany
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.createMany = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::createMany::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#destroyAll
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Deletes all prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyAll = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::delete::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#destroyById
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Delete a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::destroyById::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#findById
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Find a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.findById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::findById::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.prop_imob#updateById
             * @methodOf lbServices.Usuario.prop_imob
             *
             * @description
             *
             * Update a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.updateById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::updateById::Usuario::prop_imob"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Usuario.timecorretor
     * @header lbServices.Usuario.timecorretor
     * @object
     * @description
     *
     * The object `Usuario.timecorretor` groups methods
     * manipulating `TimeCorretor` instances related to `Usuario`.
     *
     * Call {@link lbServices.Usuario#timecorretor Usuario.timecorretor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Usuario#timecorretor
             * @methodOf lbServices.Usuario
             *
             * @description
             *
             * Queries timecorretor of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::get::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#count
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Counts timecorretor of Usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.timecorretor.count = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::count::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#create
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.create = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::create::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#createMany
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.createMany = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::createMany::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#destroyAll
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Deletes all timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyAll = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::delete::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#destroyById
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Delete a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::destroyById::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#findById
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Find a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.findById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::findById::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Usuario.timecorretor#updateById
             * @methodOf lbServices.Usuario.timecorretor
             *
             * @description
             *
             * Update a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Usuario id
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.updateById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::updateById::Usuario::timecorretor"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Corretor
 * @header lbServices.Corretor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Corretor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Corretor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/corretores/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__findById__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__destroyById__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__updateById__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.enderecos.findById() instead.
            "prototype$__findById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos.destroyById() instead.
            "prototype$__destroyById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.enderecos.updateById() instead.
            "prototype$__updateById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.estado_civil() instead.
            "prototype$__get__estado_civil": {
              url: urlBase + "/corretores/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.perfil_usuario() instead.
            "prototype$__get__perfil_usuario": {
              url: urlBase + "/corretores/:id/perfil_usuario",
              method: "GET",
            },

            // INTERNAL. Use Corretor.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/corretores/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Corretor.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/corretores/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.findById() instead.
            "prototype$__findById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.destroyById() instead.
            "prototype$__destroyById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.redessociais.updateById() instead.
            "prototype$__updateById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.prop_imob.findById() instead.
            "prototype$__findById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob.destroyById() instead.
            "prototype$__destroyById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.prop_imob.updateById() instead.
            "prototype$__updateById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.timecorretor.findById() instead.
            "prototype$__findById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor.destroyById() instead.
            "prototype$__destroyById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.timecorretor.updateById() instead.
            "prototype$__updateById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__get__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries accessTokens of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/corretores/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__create__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/corretores/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__delete__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/corretores/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$__count__accessTokens
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Counts accessTokens of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/corretores/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos() instead.
            "prototype$__get__enderecos": {
              isArray: true,
              url: urlBase + "/corretores/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Corretor.enderecos.create() instead.
            "prototype$__create__enderecos": {
              url: urlBase + "/corretores/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Corretor.enderecos.destroyAll() instead.
            "prototype$__delete__enderecos": {
              url: urlBase + "/corretores/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.enderecos.count() instead.
            "prototype$__count__enderecos": {
              url: urlBase + "/corretores/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/corretores/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/corretores/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Corretor.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/corretores/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/corretores/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais() instead.
            "prototype$__get__redessociais": {
              isArray: true,
              url: urlBase + "/corretores/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.create() instead.
            "prototype$__create__redessociais": {
              url: urlBase + "/corretores/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Corretor.redessociais.destroyAll() instead.
            "prototype$__delete__redessociais": {
              url: urlBase + "/corretores/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.redessociais.count() instead.
            "prototype$__count__redessociais": {
              url: urlBase + "/corretores/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob() instead.
            "prototype$__get__prop_imob": {
              isArray: true,
              url: urlBase + "/corretores/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob.create() instead.
            "prototype$__create__prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Corretor.prop_imob.destroyAll() instead.
            "prototype$__delete__prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.prop_imob.count() instead.
            "prototype$__count__prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor() instead.
            "prototype$__get__timecorretor": {
              isArray: true,
              url: urlBase + "/corretores/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor.create() instead.
            "prototype$__create__timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Corretor.timecorretor.destroyAll() instead.
            "prototype$__delete__timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.timecorretor.count() instead.
            "prototype$__count__timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#create
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/corretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createMany
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/corretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#upsert
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/corretores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#replaceOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/corretores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#upsertWithWhere
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/corretores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#exists
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/corretores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#findById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/corretores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#replaceById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/corretores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#find
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/corretores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#findOne
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/corretores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#updateAll
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/corretores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#deleteById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/corretores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#count
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/corretores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$updateAttributes
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/corretores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createChangeStream
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/corretores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#login
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/corretores/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#logout
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/corretores/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#confirm
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/corretores/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#resetPassword
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/corretores/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createCorretorScriptCsv
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "createCorretorScriptCsv": {
              url: urlBase + "/corretores/create-corretor-script-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createScriptCsv
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `body` – `{object=}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "createScriptCsv": {
              url: urlBase + "/corretores/create-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#filaCSV
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "filaCSV": {
              url: urlBase + "/corretores/fila-csv",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#create
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/corretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createMany
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/corretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#upsert
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/corretores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#replaceOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/corretores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#upsertWithWhere
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/corretores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#exists
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/corretores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#findById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/corretores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#replaceById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/corretores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#find
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/corretores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#findOne
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/corretores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#updateAll
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/corretores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#deleteById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/corretores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#count
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/corretores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#prototype$updateAttributes
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/corretores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#createChangeStream
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/corretores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#pager
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/corretores/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#pagerDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/corretores/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#postDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/corretores/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#deleteDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/corretores/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#editDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/corretores/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#autocomplete
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/corretores/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#autocompleteDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/corretores/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#autocompleteDetailEdit
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/corretores/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#autocompleteGeneral
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/corretores/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#crudGET
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/corretores/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#crudGETDetail
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/corretores/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#quickAdd
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/corretores/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.corretores.findById() instead.
            "::findById::Imobiliaria::corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.corretores.destroyById() instead.
            "::destroyById::Imobiliaria::corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.corretores.updateById() instead.
            "::updateById::Imobiliaria::corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.corretores() instead.
            "::get::Imobiliaria::corretores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.corretores.create() instead.
            "::create::Imobiliaria::corretores": {
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.corretores.createMany() instead.
            "::createMany::Imobiliaria::corretores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.corretores.destroyAll() instead.
            "::delete::Imobiliaria::corretores": {
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.corretores.count() instead.
            "::count::Imobiliaria::corretores": {
              url: urlBase + "/imobiliarias/:id/corretores/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.corretor() instead.
            "::get::ClienteInteressado::corretor": {
              url: urlBase + "/clientesinteressados/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use Card.corretor() instead.
            "::get::Card::corretor": {
              url: urlBase + "/cards/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.corretor() instead.
            "::get::CardImovel::corretor": {
              url: urlBase + "/cardsimovel/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.corretor() instead.
            "::get::TempCardImovel::corretor": {
              url: urlBase + "/tempcardsimovel/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propCorretor() instead.
            "::get::Proposta::propCorretor": {
              url: urlBase + "/propostas/:id/propCorretor",
              method: "GET",
            },

            // INTERNAL. Use Time.gestor() instead.
            "::get::Time::gestor": {
              url: urlBase + "/times/:id/gestor",
              method: "GET",
            },

            // INTERNAL. Use TimeRegra.corretor() instead.
            "::get::TimeRegra::corretor": {
              url: urlBase + "/timeregras/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TimeHistorico.corretor() instead.
            "::get::TimeHistorico::corretor": {
              url: urlBase + "/timehistoricos/:id/corretor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Corretor#getCurrent
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/corretores" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#updateOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchOrCreateWithWhere
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#update
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#destroyById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#removeById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchAttributes
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#updateOrCreate
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchOrCreateWithWhere
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#update
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#destroyById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#removeById
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Corretor#patchAttributes
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.Corretor#getCachedCurrent
         * @methodOf lbServices.Corretor
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Corretor#login} or
         * {@link lbServices.Corretor#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Corretor instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Corretor#isAuthenticated
         * @methodOf lbServices.Corretor
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Corretor#getCurrentId
         * @methodOf lbServices.Corretor
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Corretor#modelName
        * @propertyOf lbServices.Corretor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Corretor`.
        */
        R.modelName = "Corretor";

    /**
     * @ngdoc object
     * @name lbServices.Corretor.enderecos
     * @header lbServices.Corretor.enderecos
     * @object
     * @description
     *
     * The object `Corretor.enderecos` groups methods
     * manipulating `Endereco` instances related to `Corretor`.
     *
     * Call {@link lbServices.Corretor#enderecos Corretor.enderecos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Corretor#enderecos
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries enderecos of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::get::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#count
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Counts enderecos of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.enderecos.count = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::count::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#create
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.create = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::create::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#createMany
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.createMany = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::createMany::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#destroyAll
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Deletes all enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyAll = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::delete::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#destroyById
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Delete a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::destroyById::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#findById
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Find a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.findById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::findById::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.enderecos#updateById
             * @methodOf lbServices.Corretor.enderecos
             *
             * @description
             *
             * Update a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.updateById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::updateById::Corretor::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor#estado_civil
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Fetches belongsTo relation estado_civil.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R.estado_civil = function() {
          var TargetResource = $injector.get("EstadoCivil");
          var action = TargetResource["::get::Corretor::estado_civil"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Corretor.telefones
     * @header lbServices.Corretor.telefones
     * @object
     * @description
     *
     * The object `Corretor.telefones` groups methods
     * manipulating `Telefone` instances related to `Corretor`.
     *
     * Call {@link lbServices.Corretor#telefones Corretor.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Corretor#telefones
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries telefones of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#count
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Counts telefones of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#create
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#createMany
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#destroyAll
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#destroyById
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#findById
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.telefones#updateById
             * @methodOf lbServices.Corretor.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::Corretor::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor#perfil_usuario
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Fetches belongsTo relation perfil_usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R.perfil_usuario = function() {
          var TargetResource = $injector.get("PerfilUsuario");
          var action = TargetResource["::get::Corretor::perfil_usuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor#empresa
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::Corretor::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor#imobiliaria
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Corretor::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Corretor.redessociais
     * @header lbServices.Corretor.redessociais
     * @object
     * @description
     *
     * The object `Corretor.redessociais` groups methods
     * manipulating `RedeSocial` instances related to `Corretor`.
     *
     * Call {@link lbServices.Corretor#redessociais Corretor.redessociais()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Corretor#redessociais
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries redessociais of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::get::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#count
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Counts redessociais of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.redessociais.count = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::count::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#create
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.create = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::create::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#createMany
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.createMany = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::createMany::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#destroyAll
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Deletes all redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyAll = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::delete::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#destroyById
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Delete a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::destroyById::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#findById
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Find a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.findById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::findById::Corretor::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.redessociais#updateById
             * @methodOf lbServices.Corretor.redessociais
             *
             * @description
             *
             * Update a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.updateById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::updateById::Corretor::redessociais"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Corretor.prop_imob
     * @header lbServices.Corretor.prop_imob
     * @object
     * @description
     *
     * The object `Corretor.prop_imob` groups methods
     * manipulating `ProprietarioImobiliaria` instances related to `Corretor`.
     *
     * Call {@link lbServices.Corretor#prop_imob Corretor.prop_imob()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Corretor#prop_imob
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries prop_imob of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::get::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#count
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Counts prop_imob of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.prop_imob.count = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::count::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#create
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.create = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::create::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#createMany
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.createMany = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::createMany::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#destroyAll
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Deletes all prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyAll = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::delete::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#destroyById
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Delete a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::destroyById::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#findById
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Find a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.findById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::findById::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.prop_imob#updateById
             * @methodOf lbServices.Corretor.prop_imob
             *
             * @description
             *
             * Update a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.updateById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::updateById::Corretor::prop_imob"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Corretor.timecorretor
     * @header lbServices.Corretor.timecorretor
     * @object
     * @description
     *
     * The object `Corretor.timecorretor` groups methods
     * manipulating `TimeCorretor` instances related to `Corretor`.
     *
     * Call {@link lbServices.Corretor#timecorretor Corretor.timecorretor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Corretor#timecorretor
             * @methodOf lbServices.Corretor
             *
             * @description
             *
             * Queries timecorretor of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::get::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#count
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Counts timecorretor of Corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.timecorretor.count = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::count::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#create
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.create = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::create::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#createMany
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.createMany = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::createMany::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#destroyAll
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Deletes all timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyAll = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::delete::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#destroyById
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Delete a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::destroyById::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#findById
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Find a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.findById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::findById::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Corretor.timecorretor#updateById
             * @methodOf lbServices.Corretor.timecorretor
             *
             * @description
             *
             * Update a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor id
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.updateById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::updateById::Corretor::timecorretor"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Proprietario
 * @header lbServices.Proprietario
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Proprietario` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Proprietario",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/proprietarios/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__findById__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__destroyById__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__updateById__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.enderecos.findById() instead.
            "prototype$__findById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos.destroyById() instead.
            "prototype$__destroyById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.enderecos.updateById() instead.
            "prototype$__updateById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.estado_civil() instead.
            "prototype$__get__estado_civil": {
              url: urlBase + "/proprietarios/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.perfil_usuario() instead.
            "prototype$__get__perfil_usuario": {
              url: urlBase + "/proprietarios/:id/perfil_usuario",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/proprietarios/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/proprietarios/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis.findById() instead.
            "prototype$__findById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis.destroyById() instead.
            "prototype$__destroyById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.imoveis.updateById() instead.
            "prototype$__updateById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.redessociais.findById() instead.
            "prototype$__findById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais.destroyById() instead.
            "prototype$__destroyById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.redessociais.updateById() instead.
            "prototype$__updateById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.prop_imob.findById() instead.
            "prototype$__findById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob.destroyById() instead.
            "prototype$__destroyById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.prop_imob.updateById() instead.
            "prototype$__updateById__prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.timecorretor.findById() instead.
            "prototype$__findById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor.destroyById() instead.
            "prototype$__destroyById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.timecorretor.updateById() instead.
            "prototype$__updateById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.findById() instead.
            "prototype$__findById__contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.destroyById() instead.
            "prototype$__destroyById__contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.updateById() instead.
            "prototype$__updateById__contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__get__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries accessTokens of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__create__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/proprietarios/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__delete__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/proprietarios/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$__count__accessTokens
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Counts accessTokens of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/proprietarios/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos() instead.
            "prototype$__get__enderecos": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.enderecos.create() instead.
            "prototype$__create__enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.enderecos.destroyAll() instead.
            "prototype$__delete__enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.enderecos.count() instead.
            "prototype$__count__enderecos": {
              url: urlBase + "/proprietarios/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/proprietarios/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/proprietarios/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/proprietarios/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis() instead.
            "prototype$__get__imoveis": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis.create() instead.
            "prototype$__create__imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.imoveis.destroyAll() instead.
            "prototype$__delete__imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.imoveis.count() instead.
            "prototype$__count__imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais() instead.
            "prototype$__get__redessociais": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais.create() instead.
            "prototype$__create__redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.redessociais.destroyAll() instead.
            "prototype$__delete__redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.redessociais.count() instead.
            "prototype$__count__redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob() instead.
            "prototype$__get__prop_imob": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob.create() instead.
            "prototype$__create__prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.prop_imob.destroyAll() instead.
            "prototype$__delete__prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.prop_imob.count() instead.
            "prototype$__count__prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor() instead.
            "prototype$__get__timecorretor": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor.create() instead.
            "prototype$__create__timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.timecorretor.destroyAll() instead.
            "prototype$__delete__timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.timecorretor.count() instead.
            "prototype$__count__timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.contas_bancarias() instead.
            "prototype$__get__contas_bancarias": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.create() instead.
            "prototype$__create__contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.destroyAll() instead.
            "prototype$__delete__contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.count() instead.
            "prototype$__count__contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#create
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createMany
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#upsert
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#replaceOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#upsertWithWhere
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#exists
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#findById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#replaceById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#find
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#findOne
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#updateAll
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#deleteById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#count
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$updateAttributes
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createChangeStream
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#login
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/proprietarios/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#logout
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/proprietarios/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#confirm
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Confirm a user registration with email verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/proprietarios/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#resetPassword
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/proprietarios/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#updateInfoProp
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update prop
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "updateInfoProp": {
              url: urlBase + "/proprietarios/update-prop-values",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#getPropInfo
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Autocomplete for imoveis wich clients are interested
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "getPropInfo": {
              url: urlBase + "/proprietarios/get-prop-info",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createPropScript
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "createPropScript": {
              url: urlBase + "/proprietarios/create-prop-script",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createPropScriptCsv
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `body` – `{object=}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "createPropScriptCsv": {
              url: urlBase + "/proprietarios/create-prop-script-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#filaCSV
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "filaCSV": {
              url: urlBase + "/proprietarios/fila-csv",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#create
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createMany
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#upsert
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#replaceOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#upsertWithWhere
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#exists
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#findById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#replaceById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#find
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#findOne
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#updateAll
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#deleteById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#count
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prototype$updateAttributes
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#createChangeStream
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#pager
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/proprietarios/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#pagerDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/proprietarios/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#postDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/proprietarios/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#deleteDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/proprietarios/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#editDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/proprietarios/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#autocomplete
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/proprietarios/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#autocompleteDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/proprietarios/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#autocompleteDetailEdit
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/proprietarios/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#autocompleteGeneral
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/proprietarios/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#crudGET
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/proprietarios/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#crudGETDetail
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/proprietarios/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#quickAdd
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/proprietarios/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.proprietario() instead.
            "::get::Imovel::proprietario": {
              url: urlBase + "/imoveis/:id/proprietario",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#getCurrent
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/proprietarios" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#updateOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchOrCreateWithWhere
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#update
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#destroyById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#removeById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchAttributes
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#updateOrCreate
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchOrCreateWithWhere
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#update
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#destroyById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#removeById
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#patchAttributes
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.Proprietario#getCachedCurrent
         * @methodOf lbServices.Proprietario
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.Proprietario#login} or
         * {@link lbServices.Proprietario#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A Proprietario instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Proprietario#isAuthenticated
         * @methodOf lbServices.Proprietario
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.Proprietario#getCurrentId
         * @methodOf lbServices.Proprietario
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.Proprietario#modelName
        * @propertyOf lbServices.Proprietario
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Proprietario`.
        */
        R.modelName = "Proprietario";

    /**
     * @ngdoc object
     * @name lbServices.Proprietario.enderecos
     * @header lbServices.Proprietario.enderecos
     * @object
     * @description
     *
     * The object `Proprietario.enderecos` groups methods
     * manipulating `Endereco` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#enderecos Proprietario.enderecos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#enderecos
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries enderecos of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::get::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#count
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Counts enderecos of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.enderecos.count = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::count::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#create
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.create = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::create::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#createMany
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.createMany = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::createMany::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#destroyAll
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Deletes all enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyAll = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::delete::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#destroyById
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Delete a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::destroyById::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#findById
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Find a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.findById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::findById::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.enderecos#updateById
             * @methodOf lbServices.Proprietario.enderecos
             *
             * @description
             *
             * Update a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.updateById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::updateById::Proprietario::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#estado_civil
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Fetches belongsTo relation estado_civil.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R.estado_civil = function() {
          var TargetResource = $injector.get("EstadoCivil");
          var action = TargetResource["::get::Proprietario::estado_civil"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.telefones
     * @header lbServices.Proprietario.telefones
     * @object
     * @description
     *
     * The object `Proprietario.telefones` groups methods
     * manipulating `Telefone` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#telefones Proprietario.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#telefones
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries telefones of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#count
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Counts telefones of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#create
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#createMany
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#destroyAll
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#destroyById
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#findById
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.telefones#updateById
             * @methodOf lbServices.Proprietario.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::Proprietario::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#perfil_usuario
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Fetches belongsTo relation perfil_usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R.perfil_usuario = function() {
          var TargetResource = $injector.get("PerfilUsuario");
          var action = TargetResource["::get::Proprietario::perfil_usuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#empresa
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::Proprietario::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario#imobiliaria
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Proprietario::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.imoveis
     * @header lbServices.Proprietario.imoveis
     * @object
     * @description
     *
     * The object `Proprietario.imoveis` groups methods
     * manipulating `Imovel` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#imoveis Proprietario.imoveis()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#imoveis
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries imoveis of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#count
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Counts imoveis of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.imoveis.count = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::count::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#create
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.create = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::create::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#createMany
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.createMany = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::createMany::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#destroyAll
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Deletes all imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyAll = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::delete::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#destroyById
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Delete a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::destroyById::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#findById
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Find a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.findById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::findById::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.imoveis#updateById
             * @methodOf lbServices.Proprietario.imoveis
             *
             * @description
             *
             * Update a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.updateById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::updateById::Proprietario::imoveis"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.redessociais
     * @header lbServices.Proprietario.redessociais
     * @object
     * @description
     *
     * The object `Proprietario.redessociais` groups methods
     * manipulating `RedeSocial` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#redessociais Proprietario.redessociais()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#redessociais
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries redessociais of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::get::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#count
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Counts redessociais of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.redessociais.count = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::count::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#create
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.create = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::create::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#createMany
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.createMany = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::createMany::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#destroyAll
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Deletes all redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyAll = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::delete::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#destroyById
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Delete a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::destroyById::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#findById
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Find a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.findById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::findById::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.redessociais#updateById
             * @methodOf lbServices.Proprietario.redessociais
             *
             * @description
             *
             * Update a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.updateById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::updateById::Proprietario::redessociais"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.prop_imob
     * @header lbServices.Proprietario.prop_imob
     * @object
     * @description
     *
     * The object `Proprietario.prop_imob` groups methods
     * manipulating `ProprietarioImobiliaria` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#prop_imob Proprietario.prop_imob()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#prop_imob
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries prop_imob of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::get::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#count
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Counts prop_imob of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.prop_imob.count = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::count::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#create
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.create = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::create::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#createMany
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Creates a new instance in prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.createMany = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::createMany::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#destroyAll
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Deletes all prop_imob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyAll = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::delete::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#destroyById
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Delete a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.prop_imob.destroyById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::destroyById::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#findById
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Find a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.findById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::findById::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.prop_imob#updateById
             * @methodOf lbServices.Proprietario.prop_imob
             *
             * @description
             *
             * Update a related item by id for prop_imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for prop_imob
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R.prop_imob.updateById = function() {
          var TargetResource = $injector.get("ProprietarioImobiliaria");
          var action = TargetResource["::updateById::Proprietario::prop_imob"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.timecorretor
     * @header lbServices.Proprietario.timecorretor
     * @object
     * @description
     *
     * The object `Proprietario.timecorretor` groups methods
     * manipulating `TimeCorretor` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#timecorretor Proprietario.timecorretor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#timecorretor
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries timecorretor of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::get::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#count
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Counts timecorretor of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.timecorretor.count = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::count::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#create
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.create = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::create::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#createMany
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.createMany = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::createMany::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#destroyAll
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Deletes all timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyAll = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::delete::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#destroyById
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Delete a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::destroyById::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#findById
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Find a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.findById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::findById::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.timecorretor#updateById
             * @methodOf lbServices.Proprietario.timecorretor
             *
             * @description
             *
             * Update a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.updateById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::updateById::Proprietario::timecorretor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proprietario.contas_bancarias
     * @header lbServices.Proprietario.contas_bancarias
     * @object
     * @description
     *
     * The object `Proprietario.contas_bancarias` groups methods
     * manipulating `ProprietarioContaBancaria` instances related to `Proprietario`.
     *
     * Call {@link lbServices.Proprietario#contas_bancarias Proprietario.contas_bancarias()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proprietario#contas_bancarias
             * @methodOf lbServices.Proprietario
             *
             * @description
             *
             * Queries contas_bancarias of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R.contas_bancarias = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::get::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#count
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Counts contas_bancarias of Proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.contas_bancarias.count = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::count::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#create
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Creates a new instance in contas_bancarias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R.contas_bancarias.create = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::create::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#createMany
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Creates a new instance in contas_bancarias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R.contas_bancarias.createMany = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::createMany::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#destroyAll
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Deletes all contas_bancarias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.contas_bancarias.destroyAll = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::delete::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#destroyById
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Delete a related item by id for contas_bancarias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for contas_bancarias
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.contas_bancarias.destroyById = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::destroyById::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#findById
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Find a related item by id for contas_bancarias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for contas_bancarias
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R.contas_bancarias.findById = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::findById::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proprietario.contas_bancarias#updateById
             * @methodOf lbServices.Proprietario.contas_bancarias
             *
             * @description
             *
             * Update a related item by id for contas_bancarias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proprietario id
             *
             *  - `fk` – `{*}` - Foreign key for contas_bancarias
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R.contas_bancarias.updateById = function() {
          var TargetResource = $injector.get("ProprietarioContaBancaria");
          var action = TargetResource["::updateById::Proprietario::contas_bancarias"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Dashboard
 * @header lbServices.Dashboard
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Dashboard` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Dashboard",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/dashboard/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#create
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/dashboard",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#createMany
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/dashboard",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#upsert
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/dashboard",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#replaceOrCreate
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/dashboard/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#upsertWithWhere
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/dashboard/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#exists
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/dashboard/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#findById
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/dashboard/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#replaceById
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/dashboard/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#find
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/dashboard",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#findOne
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/dashboard/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#updateAll
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/dashboard/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#deleteById
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/dashboard/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#count
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/dashboard/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#prototype$updateAttributes
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Dashboard id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/dashboard/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#createChangeStream
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/dashboard/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataDashboardAll
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataDashboardAll": {
              url: urlBase + "/dashboard/data-dashboard-all",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataLead
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataLead": {
              url: urlBase + "/dashboard/data-lead",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataImovel
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataImovel": {
              url: urlBase + "/dashboard/data-imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataCount
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataCount": {
              url: urlBase + "/dashboard/data-count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataFunil
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * add funil data
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataFunil": {
              url: urlBase + "/dashboard/data-funil",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataAtualizacao
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataAtualizacao": {
              url: urlBase + "/dashboard/data-atualizacao",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#mediaTempoGasto
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "mediaTempoGasto": {
              url: urlBase + "/dashboard/data-tempo-medio",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataVencimento
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataVencimento": {
              url: urlBase + "/dashboard/data-vencimento",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#dataGameficacao
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
            "dataGameficacao": {
              url: urlBase + "/dashboard/data-gameficacao",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Dashboard#patchOrCreate
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#updateOrCreate
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#patchOrCreateWithWhere
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#update
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#destroyById
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#removeById
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Dashboard#patchAttributes
             * @methodOf lbServices.Dashboard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Dashboard id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Dashboard` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Dashboard#modelName
        * @propertyOf lbServices.Dashboard
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Dashboard`.
        */
        R.modelName = "Dashboard";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Geocache
 * @header lbServices.Geocache
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Geocache` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Geocache",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/geocaches/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Geocache#create
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/geocaches",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#createMany
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/geocaches",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#upsert
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/geocaches",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#replaceOrCreate
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/geocaches/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#upsertWithWhere
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/geocaches/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#exists
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/geocaches/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#findById
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/geocaches/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#replaceById
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/geocaches/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#find
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/geocaches",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#findOne
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/geocaches/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#updateAll
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/geocaches/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#deleteById
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/geocaches/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#count
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/geocaches/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#prototype$updateAttributes
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Geocache id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/geocaches/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#createChangeStream
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/geocaches/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#getLocation
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Checks internal cache before returning the geo location.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `location` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains the geocode properties
             */
            "getLocation": {
              url: urlBase + "/geocaches/search/:location",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#getMostCached
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Finds the most cached searches.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `limit` – `{number}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains the most cached searches
             */
            "getMostCached": {
              isArray: true,
              url: urlBase + "/geocaches/most-cached/:limit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Geocache#getPlaces
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Finds the most cached searches.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `search` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
            "getPlaces": {
              isArray: true,
              url: urlBase + "/geocaches/autocomplete/:search",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Geocache#patchOrCreate
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#updateOrCreate
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#patchOrCreateWithWhere
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#update
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#destroyById
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#removeById
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Geocache#patchAttributes
             * @methodOf lbServices.Geocache
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Geocache id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Geocache` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Geocache#modelName
        * @propertyOf lbServices.Geocache
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Geocache`.
        */
        R.modelName = "Geocache";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.DashboardBi
 * @header lbServices.DashboardBi
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `DashboardBi` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "DashboardBi",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/dashboard-bi/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#create
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/dashboard-bi",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#createMany
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/dashboard-bi",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#upsert
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/dashboard-bi",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#replaceOrCreate
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/dashboard-bi/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#upsertWithWhere
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/dashboard-bi/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#exists
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/dashboard-bi/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#findById
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/dashboard-bi/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#replaceById
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/dashboard-bi/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#find
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/dashboard-bi",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#findOne
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/dashboard-bi/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#updateAll
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/dashboard-bi/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#deleteById
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/dashboard-bi/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#count
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/dashboard-bi/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#prototype$updateAttributes
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - DashboardBi id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/dashboard-bi/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#createChangeStream
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/dashboard-bi/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataCorretorLeads
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataCorretorLeads": {
              url: urlBase + "/dashboard-bi/data-corretor-leads",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataMidiasByDate
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataMidiasByDate": {
              url: urlBase + "/dashboard-bi/data-midias-by-date",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataMidiasGroupImob
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataMidiasGroupImob": {
              url: urlBase + "/dashboard-bi/data-midias-group-imb",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataGeralBi
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataGeralBi": {
              url: urlBase + "/dashboard-bi/data-geral-bi",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataFinanceiroDetalhadoBi
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataFinanceiroDetalhadoBi": {
              url: urlBase + "/dashboard-bi/data-financeiro-detalhado-bi",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataStatusByCorretor
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataStatusByCorretor": {
              url: urlBase + "/dashboard-bi/data-status-by-corretor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#dataStatusByCorretorAndImob
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
            "dataStatusByCorretorAndImob": {
              url: urlBase + "/dashboard-bi/data-status-by-corretor-and-imob",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#patchOrCreate
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#updateOrCreate
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#patchOrCreateWithWhere
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#update
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#destroyById
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#removeById
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.DashboardBi#patchAttributes
             * @methodOf lbServices.DashboardBi
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - DashboardBi id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `DashboardBi` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.DashboardBi#modelName
        * @propertyOf lbServices.DashboardBi
        * @description
        * The name of the model represented by this $resource,
        * i.e. `DashboardBi`.
        */
        R.modelName = "DashboardBi";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Config
 * @header lbServices.Config
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Config` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Config",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/configs/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Config#create
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#createMany
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#upsert
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/configs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#replaceOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#upsertWithWhere
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#exists
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#findById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#replaceById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#find
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#findOne
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#updateAll
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#deleteById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#count
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#prototype$updateAttributes
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Config id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/configs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#createChangeStream
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#getPublicConfig
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Returns public config
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains the public config
             */
            "getPublicConfig": {
              url: urlBase + "/configs/public",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#refreshConfigs
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Updates all configs accordingly to the configs in the database
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "refreshConfigs": {
              url: urlBase + "/configs/refresh",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#createMany
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Creates many config objects at the same time
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "createMany": {
              url: urlBase + "/configs/create-many",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#create
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#createMany
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#upsert
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/configs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#replaceOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#upsertWithWhere
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#exists
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#findById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#replaceById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#find
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#findOne
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#updateAll
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#deleteById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#count
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#prototype$updateAttributes
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Config id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/configs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#createChangeStream
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#pager
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/configs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#pagerDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/configs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#postDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/configs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#deleteDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/configs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#editDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/configs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#autocomplete
             * @methodOf lbServices.Config
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/configs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#autocompleteDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/configs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#autocompleteDetailEdit
             * @methodOf lbServices.Config
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/configs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#autocompleteGeneral
             * @methodOf lbServices.Config
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/configs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#crudGET
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/configs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#crudGETDetail
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/configs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Config#quickAdd
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/configs/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Config#patchOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Config#updateOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Config#patchOrCreateWithWhere
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Config#update
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Config#destroyById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Config#removeById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Config#patchAttributes
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Config id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Config#patchOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Config#updateOrCreate
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Config#patchOrCreateWithWhere
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Config#update
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Config#destroyById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Config#removeById
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Config#patchAttributes
             * @methodOf lbServices.Config
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Config id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Config` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Config#modelName
        * @propertyOf lbServices.Config
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Config`.
        */
        R.modelName = "Config";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UnidadeMedida
 * @header lbServices.UnidadeMedida
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UnidadeMedida` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UnidadeMedida",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/unidades-medida/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#create
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unidades-medida",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#createMany
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unidades-medida",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#upsert
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unidades-medida",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#replaceOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unidades-medida/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#upsertWithWhere
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unidades-medida/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#exists
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unidades-medida/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#findById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unidades-medida/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#replaceById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unidades-medida/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#find
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unidades-medida",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#findOne
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unidades-medida/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#updateAll
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unidades-medida/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#deleteById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unidades-medida/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#count
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unidades-medida/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#prototype$updateAttributes
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMedida id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unidades-medida/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#createChangeStream
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unidades-medida/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#create
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unidades-medida",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#createMany
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unidades-medida",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#upsert
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unidades-medida",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#replaceOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unidades-medida/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#upsertWithWhere
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unidades-medida/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#exists
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unidades-medida/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#findById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unidades-medida/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#replaceById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unidades-medida/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#find
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unidades-medida",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#findOne
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unidades-medida/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#updateAll
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unidades-medida/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#deleteById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unidades-medida/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#count
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unidades-medida/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#prototype$updateAttributes
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMedida id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unidades-medida/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#createChangeStream
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unidades-medida/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#pager
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/unidades-medida/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#pagerDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/unidades-medida/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#postDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/unidades-medida/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#deleteDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/unidades-medida/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#editDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/unidades-medida/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#autocomplete
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/unidades-medida/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#autocompleteDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/unidades-medida/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#autocompleteDetailEdit
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/unidades-medida/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#autocompleteGeneral
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/unidades-medida/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#crudGET
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/unidades-medida/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#crudGETDetail
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/unidades-medida/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#quickAdd
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/unidades-medida/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#updateOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchOrCreateWithWhere
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#update
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#destroyById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#removeById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchAttributes
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMedida id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#updateOrCreate
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchOrCreateWithWhere
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#update
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#destroyById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#removeById
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMedida#patchAttributes
             * @methodOf lbServices.UnidadeMedida
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMedida id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMedida` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UnidadeMedida#modelName
        * @propertyOf lbServices.UnidadeMedida
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UnidadeMedida`.
        */
        R.modelName = "UnidadeMedida";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EstadoCivil
 * @header lbServices.EstadoCivil
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EstadoCivil` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EstadoCivil",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/estadocivils/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#create
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/estadocivils",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#createMany
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/estadocivils",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#upsert
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/estadocivils",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#replaceOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/estadocivils/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#upsertWithWhere
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/estadocivils/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#exists
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/estadocivils/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#findById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/estadocivils/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#replaceById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/estadocivils/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#find
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/estadocivils",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#findOne
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/estadocivils/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#updateAll
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/estadocivils/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#deleteById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/estadocivils/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#count
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/estadocivils/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#prototype$updateAttributes
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EstadoCivil id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/estadocivils/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#createChangeStream
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/estadocivils/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#create
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/estadocivils",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#createMany
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/estadocivils",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#upsert
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/estadocivils",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#replaceOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/estadocivils/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#upsertWithWhere
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/estadocivils/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#exists
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/estadocivils/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#findById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/estadocivils/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#replaceById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/estadocivils/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#find
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/estadocivils",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#findOne
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/estadocivils/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#updateAll
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/estadocivils/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#deleteById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/estadocivils/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#count
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/estadocivils/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#prototype$updateAttributes
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EstadoCivil id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/estadocivils/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#createChangeStream
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/estadocivils/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#pager
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/estadocivils/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#pagerDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/estadocivils/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#postDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/estadocivils/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#deleteDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/estadocivils/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#editDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/estadocivils/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#autocomplete
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/estadocivils/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#autocompleteDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/estadocivils/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#autocompleteDetailEdit
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/estadocivils/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#autocompleteGeneral
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/estadocivils/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#crudGET
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/estadocivils/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#crudGETDetail
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/estadocivils/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#quickAdd
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/estadocivils/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.estado_civil() instead.
            "::get::Usuario::estado_civil": {
              url: urlBase + "/users/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use Corretor.estado_civil() instead.
            "::get::Corretor::estado_civil": {
              url: urlBase + "/corretores/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.estado_civil() instead.
            "::get::Proprietario::estado_civil": {
              url: urlBase + "/proprietarios/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.estado_civil() instead.
            "::get::ClienteInteressado::estado_civil": {
              url: urlBase + "/clientesinteressados/:id/estado_civil",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#updateOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchOrCreateWithWhere
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#update
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#destroyById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#removeById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchAttributes
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EstadoCivil id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#updateOrCreate
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchOrCreateWithWhere
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#update
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#destroyById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#removeById
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EstadoCivil#patchAttributes
             * @methodOf lbServices.EstadoCivil
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EstadoCivil id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EstadoCivil#modelName
        * @propertyOf lbServices.EstadoCivil
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EstadoCivil`.
        */
        R.modelName = "EstadoCivil";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Telefone
 * @header lbServices.Telefone
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Telefone` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Telefone",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/telefones/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Telefone.telefone_tipo() instead.
            "prototype$__get__telefone_tipo": {
              url: urlBase + "/telefones/:id/telefone_tipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#create
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#createMany
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#upsert
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefones",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#replaceOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#upsertWithWhere
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#exists
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#findById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#replaceById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#find
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#findOne
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#updateAll
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#deleteById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#count
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#prototype$updateAttributes
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Telefone id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefones/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#createChangeStream
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefones/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#saveEmail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Save email from clienteinteressado
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "saveEmail": {
              url: urlBase + "/telefones/save-email",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#create
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#createMany
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefones",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#upsert
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefones",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#replaceOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefones/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#upsertWithWhere
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefones/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#exists
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefones/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#findById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefones/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#replaceById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefones/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#find
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefones",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#findOne
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefones/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#updateAll
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefones/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#deleteById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefones/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#count
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#prototype$updateAttributes
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Telefone id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefones/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#createChangeStream
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefones/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#pager
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/telefones/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#pagerDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/telefones/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#postDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/telefones/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#deleteDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/telefones/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#editDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/telefones/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#autocomplete
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/telefones/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#autocompleteDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/telefones/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#autocompleteDetailEdit
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/telefones/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#autocompleteGeneral
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/telefones/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#crudGET
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/telefones/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#crudGETDetail
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/telefones/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Telefone#quickAdd
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/telefones/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.telefones.findById() instead.
            "::findById::Usuario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones.destroyById() instead.
            "::destroyById::Usuario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.telefones.updateById() instead.
            "::updateById::Usuario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.telefones() instead.
            "::get::Usuario::telefones": {
              isArray: true,
              url: urlBase + "/users/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Usuario.telefones.create() instead.
            "::create::Usuario::telefones": {
              url: urlBase + "/users/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Usuario.telefones.createMany() instead.
            "::createMany::Usuario::telefones": {
              isArray: true,
              url: urlBase + "/users/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Usuario.telefones.destroyAll() instead.
            "::delete::Usuario::telefones": {
              url: urlBase + "/users/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.telefones.count() instead.
            "::count::Usuario::telefones": {
              url: urlBase + "/users/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.findById() instead.
            "::findById::Corretor::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.destroyById() instead.
            "::destroyById::Corretor::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.telefones.updateById() instead.
            "::updateById::Corretor::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.telefones() instead.
            "::get::Corretor::telefones": {
              isArray: true,
              url: urlBase + "/corretores/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Corretor.telefones.create() instead.
            "::create::Corretor::telefones": {
              url: urlBase + "/corretores/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Corretor.telefones.createMany() instead.
            "::createMany::Corretor::telefones": {
              isArray: true,
              url: urlBase + "/corretores/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Corretor.telefones.destroyAll() instead.
            "::delete::Corretor::telefones": {
              url: urlBase + "/corretores/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.telefones.count() instead.
            "::count::Corretor::telefones": {
              url: urlBase + "/corretores/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.findById() instead.
            "::findById::Proprietario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.destroyById() instead.
            "::destroyById::Proprietario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.telefones.updateById() instead.
            "::updateById::Proprietario::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.telefones() instead.
            "::get::Proprietario::telefones": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.telefones.create() instead.
            "::create::Proprietario::telefones": {
              url: urlBase + "/proprietarios/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.telefones.createMany() instead.
            "::createMany::Proprietario::telefones": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.telefones.destroyAll() instead.
            "::delete::Proprietario::telefones": {
              url: urlBase + "/proprietarios/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.telefones.count() instead.
            "::count::Proprietario::telefones": {
              url: urlBase + "/proprietarios/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones.findById() instead.
            "::findById::Empresa::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones.destroyById() instead.
            "::destroyById::Empresa::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.telefones.updateById() instead.
            "::updateById::Empresa::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empresa.telefones() instead.
            "::get::Empresa::telefones": {
              isArray: true,
              url: urlBase + "/empresas/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones.create() instead.
            "::create::Empresa::telefones": {
              url: urlBase + "/empresas/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Empresa.telefones.createMany() instead.
            "::createMany::Empresa::telefones": {
              isArray: true,
              url: urlBase + "/empresas/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Empresa.telefones.destroyAll() instead.
            "::delete::Empresa::telefones": {
              url: urlBase + "/empresas/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.telefones.count() instead.
            "::count::Empresa::telefones": {
              url: urlBase + "/empresas/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.findById() instead.
            "::findById::Imobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.destroyById() instead.
            "::destroyById::Imobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.telefones.updateById() instead.
            "::updateById::Imobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.telefones() instead.
            "::get::Imobiliaria::telefones": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.create() instead.
            "::create::Imobiliaria::telefones": {
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.telefones.createMany() instead.
            "::createMany::Imobiliaria::telefones": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.telefones.destroyAll() instead.
            "::delete::Imobiliaria::telefones": {
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.telefones.count() instead.
            "::count::Imobiliaria::telefones": {
              url: urlBase + "/imobiliarias/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.findById() instead.
            "::findById::ClienteInteressado::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.destroyById() instead.
            "::destroyById::ClienteInteressado::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.telefones.updateById() instead.
            "::updateById::ClienteInteressado::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.telefones() instead.
            "::get::ClienteInteressado::telefones": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.create() instead.
            "::create::ClienteInteressado::telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.telefones.createMany() instead.
            "::createMany::ClienteInteressado::telefones": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.telefones.destroyAll() instead.
            "::delete::ClienteInteressado::telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.telefones.count() instead.
            "::count::ClienteInteressado::telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.findById() instead.
            "::findById::ProprietarioImobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.destroyById() instead.
            "::destroyById::ProprietarioImobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.updateById() instead.
            "::updateById::ProprietarioImobiliaria::telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones() instead.
            "::get::ProprietarioImobiliaria::telefones": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.create() instead.
            "::create::ProprietarioImobiliaria::telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.createMany() instead.
            "::createMany::ProprietarioImobiliaria::telefones": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.destroyAll() instead.
            "::delete::ProprietarioImobiliaria::telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.count() instead.
            "::count::ProprietarioImobiliaria::telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#updateOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchOrCreateWithWhere
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#update
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#destroyById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#removeById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchAttributes
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Telefone id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#updateOrCreate
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchOrCreateWithWhere
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#update
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#destroyById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#removeById
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Telefone#patchAttributes
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Telefone id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Telefone#modelName
        * @propertyOf lbServices.Telefone
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Telefone`.
        */
        R.modelName = "Telefone";


            /**
             * @ngdoc method
             * @name lbServices.Telefone#telefone_tipo
             * @methodOf lbServices.Telefone
             *
             * @description
             *
             * Fetches belongsTo relation telefone_tipo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Telefone id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R.telefone_tipo = function() {
          var TargetResource = $injector.get("TelefoneTipo");
          var action = TargetResource["::get::Telefone::telefone_tipo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TelefoneTipo
 * @header lbServices.TelefoneTipo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TelefoneTipo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TelefoneTipo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/telefonetipos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#create
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefonetipos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#createMany
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefonetipos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#upsert
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefonetipos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#replaceOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefonetipos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#upsertWithWhere
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefonetipos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#exists
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefonetipos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#findById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefonetipos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#replaceById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefonetipos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#find
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefonetipos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#findOne
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefonetipos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#updateAll
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefonetipos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#deleteById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefonetipos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#count
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefonetipos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#prototype$updateAttributes
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneTipo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefonetipos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#createChangeStream
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefonetipos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#create
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefonetipos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#createMany
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefonetipos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#upsert
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefonetipos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#replaceOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefonetipos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#upsertWithWhere
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefonetipos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#exists
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefonetipos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#findById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefonetipos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#replaceById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefonetipos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#find
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefonetipos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#findOne
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefonetipos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#updateAll
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefonetipos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#deleteById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefonetipos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#count
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefonetipos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#prototype$updateAttributes
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneTipo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefonetipos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#createChangeStream
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefonetipos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#pager
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/telefonetipos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#pagerDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/telefonetipos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#postDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/telefonetipos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#deleteDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/telefonetipos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#editDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/telefonetipos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#autocomplete
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/telefonetipos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#autocompleteDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/telefonetipos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#autocompleteDetailEdit
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/telefonetipos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#autocompleteGeneral
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/telefonetipos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#crudGET
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/telefonetipos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#crudGETDetail
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/telefonetipos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#quickAdd
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/telefonetipos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Telefone.telefone_tipo() instead.
            "::get::Telefone::telefone_tipo": {
              url: urlBase + "/telefones/:id/telefone_tipo",
              method: "GET",
            },

            // INTERNAL. Use TelefoneCliente.telefone_tipo() instead.
            "::get::TelefoneCliente::telefone_tipo": {
              url: urlBase + "/telefonescliente/:id/telefone_tipo",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#updateOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchOrCreateWithWhere
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#update
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#destroyById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#removeById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchAttributes
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneTipo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#updateOrCreate
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchOrCreateWithWhere
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#update
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#destroyById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#removeById
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneTipo#patchAttributes
             * @methodOf lbServices.TelefoneTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneTipo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TelefoneTipo#modelName
        * @propertyOf lbServices.TelefoneTipo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TelefoneTipo`.
        */
        R.modelName = "TelefoneTipo";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Pais
 * @header lbServices.Pais
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Pais` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Pais",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/paises/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Pais#create
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/paises",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#createMany
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/paises",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#upsert
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/paises",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#replaceOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/paises/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#upsertWithWhere
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/paises/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#exists
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/paises/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#findById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/paises/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#replaceById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/paises/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#find
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/paises",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#findOne
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/paises/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#updateAll
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/paises/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#deleteById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/paises/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#count
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/paises/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#prototype$updateAttributes
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Pais id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/paises/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#createChangeStream
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/paises/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#create
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/paises",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#createMany
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/paises",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#upsert
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/paises",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#replaceOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/paises/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#upsertWithWhere
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/paises/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#exists
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/paises/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#findById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/paises/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#replaceById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/paises/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#find
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/paises",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#findOne
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/paises/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#updateAll
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/paises/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#deleteById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/paises/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#count
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/paises/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#prototype$updateAttributes
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Pais id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/paises/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#createChangeStream
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/paises/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#pager
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/paises/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#pagerDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/paises/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#postDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/paises/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#deleteDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/paises/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#editDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/paises/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#autocomplete
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/paises/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#autocompleteDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/paises/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#autocompleteDetailEdit
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/paises/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#autocompleteGeneral
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/paises/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#crudGET
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/paises/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#crudGETDetail
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/paises/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Pais#quickAdd
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/paises/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Pais#patchOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#updateOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#patchOrCreateWithWhere
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#update
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#destroyById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#removeById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#patchAttributes
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Pais id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#patchOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#updateOrCreate
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#patchOrCreateWithWhere
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#update
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#destroyById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#removeById
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Pais#patchAttributes
             * @methodOf lbServices.Pais
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Pais id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Pais` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Pais#modelName
        * @propertyOf lbServices.Pais
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Pais`.
        */
        R.modelName = "Pais";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Estado
 * @header lbServices.Estado
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Estado` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Estado",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/estados/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Estado.cidade.findById() instead.
            "prototype$__findById__cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "GET",
            },

            // INTERNAL. Use Estado.cidade.destroyById() instead.
            "prototype$__destroyById__cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Estado.cidade.updateById() instead.
            "prototype$__updateById__cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Estado.cidade() instead.
            "prototype$__get__cidade": {
              isArray: true,
              url: urlBase + "/estados/:id/cidade",
              method: "GET",
            },

            // INTERNAL. Use Estado.cidade.create() instead.
            "prototype$__create__cidade": {
              url: urlBase + "/estados/:id/cidade",
              method: "POST",
            },

            // INTERNAL. Use Estado.cidade.destroyAll() instead.
            "prototype$__delete__cidade": {
              url: urlBase + "/estados/:id/cidade",
              method: "DELETE",
            },

            // INTERNAL. Use Estado.cidade.count() instead.
            "prototype$__count__cidade": {
              url: urlBase + "/estados/:id/cidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#create
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/estados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#createMany
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/estados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#upsert
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/estados",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#replaceOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/estados/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#upsertWithWhere
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/estados/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#exists
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/estados/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#findById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/estados/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#replaceById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/estados/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#find
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/estados",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#findOne
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/estados/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#updateAll
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/estados/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#deleteById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/estados/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#count
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/estados/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#prototype$updateAttributes
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/estados/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#createChangeStream
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/estados/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#create
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/estados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#createMany
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/estados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#upsert
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/estados",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#replaceOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/estados/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#upsertWithWhere
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/estados/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#exists
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/estados/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#findById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/estados/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#replaceById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/estados/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#find
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/estados",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#findOne
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/estados/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#updateAll
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/estados/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#deleteById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/estados/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#count
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/estados/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#prototype$updateAttributes
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/estados/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#createChangeStream
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/estados/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#pager
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/estados/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#pagerDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/estados/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#postDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/estados/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#deleteDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/estados/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#editDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/estados/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#autocomplete
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/estados/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#autocompleteDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/estados/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#autocompleteDetailEdit
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/estados/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#autocompleteGeneral
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/estados/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#crudGET
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/estados/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#crudGETDetail
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/estados/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Estado#quickAdd
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/estados/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Cidade.estado() instead.
            "::get::Cidade::estado": {
              url: urlBase + "/cidades/:id/estado",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Estado#patchOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#updateOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#patchOrCreateWithWhere
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#update
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#destroyById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#removeById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#patchAttributes
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#patchOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#updateOrCreate
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#patchOrCreateWithWhere
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#update
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#destroyById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#removeById
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Estado#patchAttributes
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Estado#modelName
        * @propertyOf lbServices.Estado
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Estado`.
        */
        R.modelName = "Estado";

    /**
     * @ngdoc object
     * @name lbServices.Estado.cidade
     * @header lbServices.Estado.cidade
     * @object
     * @description
     *
     * The object `Estado.cidade` groups methods
     * manipulating `Cidade` instances related to `Estado`.
     *
     * Call {@link lbServices.Estado#cidade Estado.cidade()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Estado#cidade
             * @methodOf lbServices.Estado
             *
             * @description
             *
             * Queries cidade of Estado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::get::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#count
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Counts cidade of Estado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cidade.count = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::count::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#create
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Creates a new instance in cidade of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade.create = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::create::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#createMany
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Creates a new instance in cidade of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade.createMany = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::createMany::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#destroyAll
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Deletes all cidade of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cidade.destroyAll = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::delete::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#destroyById
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Delete a related item by id for cidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `fk` – `{*}` - Foreign key for cidade
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cidade.destroyById = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::destroyById::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#findById
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Find a related item by id for cidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `fk` – `{*}` - Foreign key for cidade
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade.findById = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::findById::Estado::cidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Estado.cidade#updateById
             * @methodOf lbServices.Estado.cidade
             *
             * @description
             *
             * Update a related item by id for cidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Estado id
             *
             *  - `fk` – `{*}` - Foreign key for cidade
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade.updateById = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::updateById::Estado::cidade"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cidade
 * @header lbServices.Cidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cidades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cidade.estado() instead.
            "prototype$__get__estado": {
              url: urlBase + "/cidades/:id/estado",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#create
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#createMany
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#upsert
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#replaceOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#upsertWithWhere
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#exists
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#findById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#replaceById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#find
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#findOne
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#updateAll
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#deleteById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#count
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#prototype$updateAttributes
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#createChangeStream
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#create
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#createMany
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#upsert
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#replaceOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#upsertWithWhere
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#exists
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#findById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#replaceById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#find
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#findOne
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#updateAll
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#deleteById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#count
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#prototype$updateAttributes
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#createChangeStream
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#pager
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/cidades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#pagerDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/cidades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#postDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/cidades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#deleteDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/cidades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#editDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/cidades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#autocomplete
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/cidades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#autocompleteDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/cidades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#autocompleteDetailEdit
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/cidades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#autocompleteGeneral
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/cidades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#crudGET
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/cidades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#crudGETDetail
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/cidades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cidade#quickAdd
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/cidades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Estado.cidade.findById() instead.
            "::findById::Estado::cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "GET",
            },

            // INTERNAL. Use Estado.cidade.destroyById() instead.
            "::destroyById::Estado::cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Estado.cidade.updateById() instead.
            "::updateById::Estado::cidade": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/estados/:id/cidade/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Estado.cidade() instead.
            "::get::Estado::cidade": {
              isArray: true,
              url: urlBase + "/estados/:id/cidade",
              method: "GET",
            },

            // INTERNAL. Use Estado.cidade.create() instead.
            "::create::Estado::cidade": {
              url: urlBase + "/estados/:id/cidade",
              method: "POST",
            },

            // INTERNAL. Use Estado.cidade.createMany() instead.
            "::createMany::Estado::cidade": {
              isArray: true,
              url: urlBase + "/estados/:id/cidade",
              method: "POST",
            },

            // INTERNAL. Use Estado.cidade.destroyAll() instead.
            "::delete::Estado::cidade": {
              url: urlBase + "/estados/:id/cidade",
              method: "DELETE",
            },

            // INTERNAL. Use Estado.cidade.count() instead.
            "::count::Estado::cidade": {
              url: urlBase + "/estados/:id/cidade/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.cidade() instead.
            "::get::Imobiliaria::cidade": {
              url: urlBase + "/imobiliarias/:id/cidade",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#updateOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchOrCreateWithWhere
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#update
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#destroyById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#removeById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchAttributes
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#updateOrCreate
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchOrCreateWithWhere
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#update
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#destroyById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#removeById
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cidade#patchAttributes
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cidade#modelName
        * @propertyOf lbServices.Cidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cidade`.
        */
        R.modelName = "Cidade";


            /**
             * @ngdoc method
             * @name lbServices.Cidade#estado
             * @methodOf lbServices.Cidade
             *
             * @description
             *
             * Fetches belongsTo relation estado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cidade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Estado` object.)
             * </em>
             */
        R.estado = function() {
          var TargetResource = $injector.get("Estado");
          var action = TargetResource["::get::Cidade::estado"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PerfilUsuario
 * @header lbServices.PerfilUsuario
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PerfilUsuario` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PerfilUsuario",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/perfilusuarios/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PerfilUsuario.acls.findById() instead.
            "prototype$__findById__acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "GET",
            },

            // INTERNAL. Use PerfilUsuario.acls.destroyById() instead.
            "prototype$__destroyById__acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use PerfilUsuario.acls.updateById() instead.
            "prototype$__updateById__acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "PUT",
            },

            // INTERNAL. Use PerfilUsuario.acls() instead.
            "prototype$__get__acls": {
              isArray: true,
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "GET",
            },

            // INTERNAL. Use PerfilUsuario.acls.create() instead.
            "prototype$__create__acls": {
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "POST",
            },

            // INTERNAL. Use PerfilUsuario.acls.destroyAll() instead.
            "prototype$__delete__acls": {
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "DELETE",
            },

            // INTERNAL. Use PerfilUsuario.acls.count() instead.
            "prototype$__count__acls": {
              url: urlBase + "/perfilusuarios/:id/acls/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#create
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/perfilusuarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#createMany
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/perfilusuarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#upsert
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/perfilusuarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#replaceOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/perfilusuarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#upsertWithWhere
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/perfilusuarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#exists
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/perfilusuarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#findById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/perfilusuarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#replaceById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/perfilusuarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#find
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/perfilusuarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#findOne
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/perfilusuarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#updateAll
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/perfilusuarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#deleteById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/perfilusuarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#count
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/perfilusuarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#prototype$updateAttributes
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/perfilusuarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#createChangeStream
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/perfilusuarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#create
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/perfilusuarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#createMany
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/perfilusuarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#upsert
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/perfilusuarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#replaceOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/perfilusuarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#upsertWithWhere
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/perfilusuarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#exists
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/perfilusuarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#findById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/perfilusuarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#replaceById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/perfilusuarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#find
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/perfilusuarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#findOne
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/perfilusuarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#updateAll
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/perfilusuarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#deleteById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/perfilusuarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#count
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/perfilusuarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#prototype$updateAttributes
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/perfilusuarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#createChangeStream
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/perfilusuarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#pager
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/perfilusuarios/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#pagerDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/perfilusuarios/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#postDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/perfilusuarios/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#deleteDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/perfilusuarios/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#editDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/perfilusuarios/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#autocomplete
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/perfilusuarios/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#autocompleteDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/perfilusuarios/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#autocompleteDetailEdit
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/perfilusuarios/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#autocompleteGeneral
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/perfilusuarios/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#crudGET
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/perfilusuarios/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#crudGETDetail
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/perfilusuarios/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#quickAdd
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/perfilusuarios/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.perfil_usuario() instead.
            "::get::Usuario::perfil_usuario": {
              url: urlBase + "/users/:id/perfil_usuario",
              method: "GET",
            },

            // INTERNAL. Use Corretor.perfil_usuario() instead.
            "::get::Corretor::perfil_usuario": {
              url: urlBase + "/corretores/:id/perfil_usuario",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.perfil_usuario() instead.
            "::get::Proprietario::perfil_usuario": {
              url: urlBase + "/proprietarios/:id/perfil_usuario",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#updateOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchOrCreateWithWhere
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#update
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#destroyById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#removeById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchAttributes
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#updateOrCreate
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchOrCreateWithWhere
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#update
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#destroyById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#removeById
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#patchAttributes
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilUsuario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PerfilUsuario#modelName
        * @propertyOf lbServices.PerfilUsuario
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PerfilUsuario`.
        */
        R.modelName = "PerfilUsuario";

    /**
     * @ngdoc object
     * @name lbServices.PerfilUsuario.acls
     * @header lbServices.PerfilUsuario.acls
     * @object
     * @description
     *
     * The object `PerfilUsuario.acls` groups methods
     * manipulating `PerfilControleAcesso` instances related to `PerfilUsuario`.
     *
     * Call {@link lbServices.PerfilUsuario#acls PerfilUsuario.acls()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario#acls
             * @methodOf lbServices.PerfilUsuario
             *
             * @description
             *
             * Queries acls of PerfilUsuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.acls = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::get::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#count
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Counts acls of PerfilUsuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.acls.count = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::count::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#create
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Creates a new instance in acls of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.acls.create = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::create::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#createMany
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Creates a new instance in acls of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.acls.createMany = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::createMany::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#destroyAll
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Deletes all acls of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.acls.destroyAll = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::delete::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#destroyById
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Delete a related item by id for acls.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `fk` – `{*}` - Foreign key for acls
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.acls.destroyById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::destroyById::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#findById
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Find a related item by id for acls.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `fk` – `{*}` - Foreign key for acls
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.acls.findById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::findById::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PerfilUsuario.acls#updateById
             * @methodOf lbServices.PerfilUsuario.acls
             *
             * @description
             *
             * Update a related item by id for acls.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilUsuario id
             *
             *  - `fk` – `{*}` - Foreign key for acls
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.acls.updateById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::updateById::PerfilUsuario::acls"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Empresa
 * @header lbServices.Empresa
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Empresa` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Empresa",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/empresas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Empresa.enderecos.findById() instead.
            "prototype$__findById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empresa.enderecos.destroyById() instead.
            "prototype$__destroyById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.enderecos.updateById() instead.
            "prototype$__updateById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empresa.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empresas/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empresa.enderecos() instead.
            "prototype$__get__enderecos": {
              isArray: true,
              url: urlBase + "/empresas/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Empresa.enderecos.create() instead.
            "prototype$__create__enderecos": {
              url: urlBase + "/empresas/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Empresa.enderecos.destroyAll() instead.
            "prototype$__delete__enderecos": {
              url: urlBase + "/empresas/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.enderecos.count() instead.
            "prototype$__count__enderecos": {
              url: urlBase + "/empresas/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/empresas/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Empresa.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/empresas/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Empresa.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/empresas/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Empresa.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/empresas/:id/telefones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#create
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empresas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#createMany
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empresas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#upsert
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empresas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#replaceOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empresas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#upsertWithWhere
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empresas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#exists
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empresas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#findById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empresas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#replaceById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empresas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#find
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empresas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#findOne
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empresas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#updateAll
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empresas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#deleteById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empresas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#count
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empresas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#prototype$updateAttributes
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empresas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#createChangeStream
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empresas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#create
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empresas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#createMany
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empresas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#upsert
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empresas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#replaceOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empresas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#upsertWithWhere
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empresas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#exists
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empresas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#findById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empresas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#replaceById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empresas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#find
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empresas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#findOne
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empresas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#updateAll
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empresas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#deleteById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empresas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#count
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empresas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#prototype$updateAttributes
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empresas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#createChangeStream
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empresas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#pager
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/empresas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#pagerDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/empresas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#postDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/empresas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#deleteDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/empresas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#editDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/empresas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#autocomplete
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/empresas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#autocompleteDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/empresas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#autocompleteDetailEdit
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/empresas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#autocompleteGeneral
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/empresas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#crudGET
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/empresas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#crudGETDetail
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/empresas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empresa#quickAdd
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/empresas/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.empresa() instead.
            "::get::Usuario::empresa": {
              url: urlBase + "/users/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Corretor.empresa() instead.
            "::get::Corretor::empresa": {
              url: urlBase + "/corretores/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.empresa() instead.
            "::get::Proprietario::empresa": {
              url: urlBase + "/proprietarios/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.empresa() instead.
            "::get::ClienteInteressado::empresa": {
              url: urlBase + "/clientesinteressados/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Card.empresa() instead.
            "::get::Card::empresa": {
              url: urlBase + "/cards/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.empresa() instead.
            "::get::CardImovel::empresa": {
              url: urlBase + "/cardsimovel/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.empresa() instead.
            "::get::TempCardImovel::empresa": {
              url: urlBase + "/tempcardsimovel/:id/empresa",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#updateOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchOrCreateWithWhere
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#update
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#destroyById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#removeById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchAttributes
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#updateOrCreate
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchOrCreateWithWhere
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#update
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#destroyById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#removeById
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empresa#patchAttributes
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Empresa#modelName
        * @propertyOf lbServices.Empresa
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Empresa`.
        */
        R.modelName = "Empresa";

    /**
     * @ngdoc object
     * @name lbServices.Empresa.enderecos
     * @header lbServices.Empresa.enderecos
     * @object
     * @description
     *
     * The object `Empresa.enderecos` groups methods
     * manipulating `Endereco` instances related to `Empresa`.
     *
     * Call {@link lbServices.Empresa#enderecos Empresa.enderecos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Empresa#enderecos
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Queries enderecos of Empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::get::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#count
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Counts enderecos of Empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.enderecos.count = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::count::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#create
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.create = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::create::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#createMany
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.createMany = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::createMany::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#destroyAll
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Deletes all enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyAll = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::delete::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#destroyById
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Delete a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::destroyById::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#findById
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Find a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.findById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::findById::Empresa::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.enderecos#updateById
             * @methodOf lbServices.Empresa.enderecos
             *
             * @description
             *
             * Update a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.updateById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::updateById::Empresa::enderecos"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Empresa.telefones
     * @header lbServices.Empresa.telefones
     * @object
     * @description
     *
     * The object `Empresa.telefones` groups methods
     * manipulating `Telefone` instances related to `Empresa`.
     *
     * Call {@link lbServices.Empresa#telefones Empresa.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Empresa#telefones
             * @methodOf lbServices.Empresa
             *
             * @description
             *
             * Queries telefones of Empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#count
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Counts telefones of Empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#create
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#createMany
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#destroyAll
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#destroyById
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#findById
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::Empresa::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empresa.telefones#updateById
             * @methodOf lbServices.Empresa.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empresa id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::Empresa::telefones"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Menu
 * @header lbServices.Menu
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Menu` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Menu",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/menus/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Menu.menuId() instead.
            "prototype$__get__menuId": {
              url: urlBase + "/menus/:id/menuId",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.findById() instead.
            "prototype$__findById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.destroyById() instead.
            "prototype$__destroyById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.items.updateById() instead.
            "prototype$__updateById__items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Menu.perfis.findById() instead.
            "prototype$__findById__perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis.destroyById() instead.
            "prototype$__destroyById__perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.perfis.updateById() instead.
            "prototype$__updateById__perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Menu.items() instead.
            "prototype$__get__items": {
              isArray: true,
              url: urlBase + "/menus/:id/items",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.create() instead.
            "prototype$__create__items": {
              url: urlBase + "/menus/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Menu.items.destroyAll() instead.
            "prototype$__delete__items": {
              url: urlBase + "/menus/:id/items",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.items.count() instead.
            "prototype$__count__items": {
              url: urlBase + "/menus/:id/items/count",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis() instead.
            "prototype$__get__perfis": {
              isArray: true,
              url: urlBase + "/menus/:id/perfis",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis.create() instead.
            "prototype$__create__perfis": {
              url: urlBase + "/menus/:id/perfis",
              method: "POST",
            },

            // INTERNAL. Use Menu.perfis.destroyAll() instead.
            "prototype$__delete__perfis": {
              url: urlBase + "/menus/:id/perfis",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.perfis.count() instead.
            "prototype$__count__perfis": {
              url: urlBase + "/menus/:id/perfis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#create
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/menus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#createMany
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/menus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#upsert
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/menus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#replaceOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/menus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#upsertWithWhere
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/menus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#exists
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/menus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#findById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/menus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#replaceById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/menus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#find
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/menus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#findOne
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/menus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#updateAll
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/menus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#deleteById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/menus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#count
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/menus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#prototype$updateAttributes
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/menus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#createChangeStream
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/menus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#getMenus
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Retrieve Menus for a logged in user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object}` -
             *
             *  - `body` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `menus` – `{*=}` - Return array with menus
             */
            "getMenus": {
              url: urlBase + "/menus/get-menus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#create
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/menus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#createMany
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/menus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#upsert
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/menus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#replaceOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/menus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#upsertWithWhere
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/menus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#exists
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/menus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#findById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/menus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#replaceById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/menus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#find
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/menus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#findOne
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/menus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#updateAll
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/menus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#deleteById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/menus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#count
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/menus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#prototype$updateAttributes
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/menus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#createChangeStream
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/menus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#pager
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/menus/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#pagerDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/menus/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#postDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/menus/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#deleteDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/menus/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#editDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/menus/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#autocomplete
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/menus/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#autocompleteDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/menus/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#autocompleteDetailEdit
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/menus/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#autocompleteGeneral
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/menus/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#crudGET
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/menus/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#crudGETDetail
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/menus/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Menu#quickAdd
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/menus/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Menu.menuId() instead.
            "::get::Menu::menuId": {
              url: urlBase + "/menus/:id/menuId",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.findById() instead.
            "::findById::Menu::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.destroyById() instead.
            "::destroyById::Menu::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.items.updateById() instead.
            "::updateById::Menu::items": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/items/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Menu.items() instead.
            "::get::Menu::items": {
              isArray: true,
              url: urlBase + "/menus/:id/items",
              method: "GET",
            },

            // INTERNAL. Use Menu.items.create() instead.
            "::create::Menu::items": {
              url: urlBase + "/menus/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Menu.items.createMany() instead.
            "::createMany::Menu::items": {
              isArray: true,
              url: urlBase + "/menus/:id/items",
              method: "POST",
            },

            // INTERNAL. Use Menu.items.destroyAll() instead.
            "::delete::Menu::items": {
              url: urlBase + "/menus/:id/items",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.items.count() instead.
            "::count::Menu::items": {
              url: urlBase + "/menus/:id/items/count",
              method: "GET",
            },

            // INTERNAL. Use PerfilControleAcesso.acl() instead.
            "::get::PerfilControleAcesso::acl": {
              url: urlBase + "/perfil-controle-acessos/:id/acl",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Menu#patchOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#updateOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#patchOrCreateWithWhere
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#update
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#destroyById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#removeById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#patchAttributes
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#patchOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#updateOrCreate
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#patchOrCreateWithWhere
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#update
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#destroyById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#removeById
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Menu#patchAttributes
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Menu#modelName
        * @propertyOf lbServices.Menu
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Menu`.
        */
        R.modelName = "Menu";


            /**
             * @ngdoc method
             * @name lbServices.Menu#menuId
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Fetches belongsTo relation menuId.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.menuId = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::get::Menu::menuId"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Menu.items
     * @header lbServices.Menu.items
     * @object
     * @description
     *
     * The object `Menu.items` groups methods
     * manipulating `Menu` instances related to `Menu`.
     *
     * Call {@link lbServices.Menu#items Menu.items()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Menu#items
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Queries items of Menu.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.items = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::get::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#count
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Counts items of Menu.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.items.count = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::count::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#create
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.items.create = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::create::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#createMany
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Creates a new instance in items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.items.createMany = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::createMany::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#destroyAll
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Deletes all items of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.items.destroyAll = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::delete::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#destroyById
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Delete a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.items.destroyById = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::destroyById::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#findById
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Find a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.items.findById = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::findById::Menu::items"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.items#updateById
             * @methodOf lbServices.Menu.items
             *
             * @description
             *
             * Update a related item by id for items.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `fk` – `{*}` - Foreign key for items
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.items.updateById = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::updateById::Menu::items"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Menu.perfis
     * @header lbServices.Menu.perfis
     * @object
     * @description
     *
     * The object `Menu.perfis` groups methods
     * manipulating `PerfilControleAcesso` instances related to `Menu`.
     *
     * Call {@link lbServices.Menu#perfis Menu.perfis()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Menu#perfis
             * @methodOf lbServices.Menu
             *
             * @description
             *
             * Queries perfis of Menu.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.perfis = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::get::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#count
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Counts perfis of Menu.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.perfis.count = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::count::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#create
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Creates a new instance in perfis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.perfis.create = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::create::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#createMany
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Creates a new instance in perfis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.perfis.createMany = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::createMany::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#destroyAll
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Deletes all perfis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.perfis.destroyAll = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::delete::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#destroyById
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Delete a related item by id for perfis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for perfis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.perfis.destroyById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::destroyById::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#findById
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Find a related item by id for perfis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for perfis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.perfis.findById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::findById::Menu::perfis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Menu.perfis#updateById
             * @methodOf lbServices.Menu.perfis
             *
             * @description
             *
             * Update a related item by id for perfis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Menu id
             *
             *  - `fk` – `{*}` - Foreign key for perfis
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R.perfis.updateById = function() {
          var TargetResource = $injector.get("PerfilControleAcesso");
          var action = TargetResource["::updateById::Menu::perfis"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PerfilControleAcesso
 * @header lbServices.PerfilControleAcesso
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PerfilControleAcesso` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PerfilControleAcesso",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/perfil-controle-acessos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PerfilControleAcesso.acl() instead.
            "prototype$__get__acl": {
              url: urlBase + "/perfil-controle-acessos/:id/acl",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#create
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/perfil-controle-acessos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#createMany
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/perfil-controle-acessos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#upsert
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/perfil-controle-acessos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#replaceOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/perfil-controle-acessos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#upsertWithWhere
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/perfil-controle-acessos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#exists
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/perfil-controle-acessos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#findById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#replaceById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/perfil-controle-acessos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#find
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/perfil-controle-acessos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#findOne
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/perfil-controle-acessos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#updateAll
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/perfil-controle-acessos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#deleteById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#count
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/perfil-controle-acessos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#prototype$updateAttributes
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilControleAcesso id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#createChangeStream
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/perfil-controle-acessos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#create
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/perfil-controle-acessos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#createMany
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/perfil-controle-acessos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#upsert
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/perfil-controle-acessos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#replaceOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/perfil-controle-acessos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#upsertWithWhere
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/perfil-controle-acessos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#exists
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/perfil-controle-acessos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#findById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#replaceById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/perfil-controle-acessos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#find
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/perfil-controle-acessos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#findOne
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/perfil-controle-acessos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#updateAll
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/perfil-controle-acessos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#deleteById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#count
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/perfil-controle-acessos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#prototype$updateAttributes
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilControleAcesso id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/perfil-controle-acessos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#createChangeStream
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/perfil-controle-acessos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#pager
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/perfil-controle-acessos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#pagerDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#postDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#deleteDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#editDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#autocomplete
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/perfil-controle-acessos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#autocompleteDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#autocompleteDetailEdit
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/perfil-controle-acessos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#autocompleteGeneral
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/perfil-controle-acessos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#crudGET
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/perfil-controle-acessos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#crudGETDetail
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/perfil-controle-acessos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#quickAdd
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/perfil-controle-acessos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use PerfilUsuario.acls.findById() instead.
            "::findById::PerfilUsuario::acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "GET",
            },

            // INTERNAL. Use PerfilUsuario.acls.destroyById() instead.
            "::destroyById::PerfilUsuario::acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use PerfilUsuario.acls.updateById() instead.
            "::updateById::PerfilUsuario::acls": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/perfilusuarios/:id/acls/:fk",
              method: "PUT",
            },

            // INTERNAL. Use PerfilUsuario.acls() instead.
            "::get::PerfilUsuario::acls": {
              isArray: true,
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "GET",
            },

            // INTERNAL. Use PerfilUsuario.acls.create() instead.
            "::create::PerfilUsuario::acls": {
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "POST",
            },

            // INTERNAL. Use PerfilUsuario.acls.createMany() instead.
            "::createMany::PerfilUsuario::acls": {
              isArray: true,
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "POST",
            },

            // INTERNAL. Use PerfilUsuario.acls.destroyAll() instead.
            "::delete::PerfilUsuario::acls": {
              url: urlBase + "/perfilusuarios/:id/acls",
              method: "DELETE",
            },

            // INTERNAL. Use PerfilUsuario.acls.count() instead.
            "::count::PerfilUsuario::acls": {
              url: urlBase + "/perfilusuarios/:id/acls/count",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis.findById() instead.
            "::findById::Menu::perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis.destroyById() instead.
            "::destroyById::Menu::perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.perfis.updateById() instead.
            "::updateById::Menu::perfis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/menus/:id/perfis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Menu.perfis() instead.
            "::get::Menu::perfis": {
              isArray: true,
              url: urlBase + "/menus/:id/perfis",
              method: "GET",
            },

            // INTERNAL. Use Menu.perfis.create() instead.
            "::create::Menu::perfis": {
              url: urlBase + "/menus/:id/perfis",
              method: "POST",
            },

            // INTERNAL. Use Menu.perfis.createMany() instead.
            "::createMany::Menu::perfis": {
              isArray: true,
              url: urlBase + "/menus/:id/perfis",
              method: "POST",
            },

            // INTERNAL. Use Menu.perfis.destroyAll() instead.
            "::delete::Menu::perfis": {
              url: urlBase + "/menus/:id/perfis",
              method: "DELETE",
            },

            // INTERNAL. Use Menu.perfis.count() instead.
            "::count::Menu::perfis": {
              url: urlBase + "/menus/:id/perfis/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#updateOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchOrCreateWithWhere
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#update
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#destroyById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#removeById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchAttributes
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilControleAcesso id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#updateOrCreate
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchOrCreateWithWhere
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#update
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#destroyById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#removeById
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#patchAttributes
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilControleAcesso id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PerfilControleAcesso` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PerfilControleAcesso#modelName
        * @propertyOf lbServices.PerfilControleAcesso
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PerfilControleAcesso`.
        */
        R.modelName = "PerfilControleAcesso";


            /**
             * @ngdoc method
             * @name lbServices.PerfilControleAcesso#acl
             * @methodOf lbServices.PerfilControleAcesso
             *
             * @description
             *
             * Fetches belongsTo relation acl.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PerfilControleAcesso id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Menu` object.)
             * </em>
             */
        R.acl = function() {
          var TargetResource = $injector.get("Menu");
          var action = TargetResource["::get::PerfilControleAcesso::acl"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CategoriaImovel
 * @header lbServices.CategoriaImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CategoriaImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CategoriaImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/categoriaimoveis/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#create
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/categoriaimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#createMany
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/categoriaimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#upsert
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/categoriaimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#replaceOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/categoriaimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#upsertWithWhere
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/categoriaimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#exists
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/categoriaimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#findById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#replaceById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/categoriaimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#find
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/categoriaimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#findOne
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/categoriaimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#updateAll
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/categoriaimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#deleteById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#count
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/categoriaimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#prototype$updateAttributes
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CategoriaImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#createChangeStream
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/categoriaimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#create
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/categoriaimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#createMany
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/categoriaimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#upsert
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/categoriaimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#replaceOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/categoriaimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#upsertWithWhere
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/categoriaimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#exists
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/categoriaimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#findById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#replaceById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/categoriaimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#find
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/categoriaimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#findOne
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/categoriaimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#updateAll
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/categoriaimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#deleteById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#count
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/categoriaimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#prototype$updateAttributes
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CategoriaImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/categoriaimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#createChangeStream
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/categoriaimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#pager
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/categoriaimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#pagerDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/categoriaimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#postDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/categoriaimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#deleteDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/categoriaimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#editDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/categoriaimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#autocomplete
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/categoriaimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#autocompleteDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/categoriaimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#autocompleteDetailEdit
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/categoriaimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#autocompleteGeneral
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/categoriaimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#crudGET
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/categoriaimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#crudGETDetail
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/categoriaimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#quickAdd
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/categoriaimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.categoria_imovel() instead.
            "::get::Imovel::categoria_imovel": {
              url: urlBase + "/imoveis/:id/categoria_imovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#updateOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchOrCreateWithWhere
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#update
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#destroyById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#removeById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchAttributes
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CategoriaImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#updateOrCreate
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchOrCreateWithWhere
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#update
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#destroyById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#removeById
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CategoriaImovel#patchAttributes
             * @methodOf lbServices.CategoriaImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CategoriaImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CategoriaImovel#modelName
        * @propertyOf lbServices.CategoriaImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CategoriaImovel`.
        */
        R.modelName = "CategoriaImovel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Comodidade
 * @header lbServices.Comodidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Comodidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Comodidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/comodidades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Comodidade.grupo_comodidades() instead.
            "prototype$__get__grupo_comodidades": {
              url: urlBase + "/comodidades/:id/grupo_comodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#create
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/comodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#createMany
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/comodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#upsert
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/comodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#replaceOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/comodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#upsertWithWhere
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/comodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#exists
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/comodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#findById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/comodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#replaceById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/comodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#find
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/comodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#findOne
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/comodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#updateAll
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/comodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#deleteById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/comodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#count
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/comodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#prototype$updateAttributes
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Comodidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/comodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#createChangeStream
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/comodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#create
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/comodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#createMany
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/comodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#upsert
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/comodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#replaceOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/comodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#upsertWithWhere
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/comodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#exists
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/comodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#findById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/comodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#replaceById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/comodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#find
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/comodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#findOne
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/comodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#updateAll
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/comodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#deleteById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/comodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#count
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/comodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#prototype$updateAttributes
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Comodidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/comodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#createChangeStream
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/comodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#pager
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/comodidades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#pagerDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/comodidades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#postDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/comodidades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#deleteDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/comodidades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#editDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/comodidades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#autocomplete
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/comodidades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#autocompleteDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/comodidades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#autocompleteDetailEdit
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/comodidades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#autocompleteGeneral
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/comodidades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#crudGET
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/comodidades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#crudGETDetail
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/comodidades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#quickAdd
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/comodidades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use EmpreendimentoComodidade.comodidade() instead.
            "::get::EmpreendimentoComodidade::comodidade": {
              url: urlBase + "/empreendimentocomodidades/:id/comodidade",
              method: "GET",
            },

            // INTERNAL. Use ImovelComodidade.comodidade() instead.
            "::get::ImovelComodidade::comodidade": {
              url: urlBase + "/imovelcomodidades/:id/comodidade",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.findById() instead.
            "::findById::GrupoComodidade::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.destroyById() instead.
            "::destroyById::GrupoComodidade::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.updateById() instead.
            "::updateById::GrupoComodidade::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GrupoComodidade.comodidades() instead.
            "::get::GrupoComodidade::comodidades": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.create() instead.
            "::create::GrupoComodidade::comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.createMany() instead.
            "::createMany::GrupoComodidade::comodidades": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.destroyAll() instead.
            "::delete::GrupoComodidade::comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.count() instead.
            "::count::GrupoComodidade::comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#updateOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchOrCreateWithWhere
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#update
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#destroyById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#removeById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchAttributes
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Comodidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#updateOrCreate
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchOrCreateWithWhere
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#update
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#destroyById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#removeById
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Comodidade#patchAttributes
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Comodidade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Comodidade#modelName
        * @propertyOf lbServices.Comodidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Comodidade`.
        */
        R.modelName = "Comodidade";


            /**
             * @ngdoc method
             * @name lbServices.Comodidade#grupo_comodidades
             * @methodOf lbServices.Comodidade
             *
             * @description
             *
             * Fetches belongsTo relation grupo_comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Comodidade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R.grupo_comodidades = function() {
          var TargetResource = $injector.get("GrupoComodidade");
          var action = TargetResource["::get::Comodidade::grupo_comodidades"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Construtora
 * @header lbServices.Construtora
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Construtora` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Construtora",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/construtoras/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Construtora#create
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/construtoras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#createMany
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/construtoras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#upsert
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/construtoras",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#replaceOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/construtoras/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#upsertWithWhere
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/construtoras/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#exists
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/construtoras/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#findById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/construtoras/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#replaceById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/construtoras/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#find
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/construtoras",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#findOne
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/construtoras/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#updateAll
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/construtoras/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#deleteById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/construtoras/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#count
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/construtoras/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#prototype$updateAttributes
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Construtora id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/construtoras/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#createChangeStream
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/construtoras/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#create
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/construtoras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#createMany
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/construtoras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#upsert
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/construtoras",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#replaceOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/construtoras/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#upsertWithWhere
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/construtoras/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#exists
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/construtoras/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#findById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/construtoras/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#replaceById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/construtoras/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#find
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/construtoras",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#findOne
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/construtoras/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#updateAll
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/construtoras/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#deleteById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/construtoras/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#count
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/construtoras/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#prototype$updateAttributes
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Construtora id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/construtoras/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#createChangeStream
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/construtoras/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#pager
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/construtoras/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#pagerDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/construtoras/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#postDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/construtoras/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#deleteDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/construtoras/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#editDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/construtoras/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#autocomplete
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/construtoras/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#autocompleteDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/construtoras/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#autocompleteDetailEdit
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/construtoras/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#autocompleteGeneral
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/construtoras/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#crudGET
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/construtoras/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#crudGETDetail
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/construtoras/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Construtora#quickAdd
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/construtoras/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.construtora() instead.
            "::get::Empreendimento::construtora": {
              url: urlBase + "/empreendimentos/:id/construtora",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#updateOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchOrCreateWithWhere
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#update
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#destroyById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#removeById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchAttributes
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Construtora id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#updateOrCreate
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchOrCreateWithWhere
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#update
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#destroyById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#removeById
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Construtora#patchAttributes
             * @methodOf lbServices.Construtora
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Construtora id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Construtora#modelName
        * @propertyOf lbServices.Construtora
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Construtora`.
        */
        R.modelName = "Construtora";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Empreendimento
 * @header lbServices.Empreendimento
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Empreendimento` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Empreendimento",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/empreendimentos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Empreendimento.construtora() instead.
            "prototype$__get__construtora": {
              url: urlBase + "/empreendimentos/:id/construtora",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades.findById() instead.
            "prototype$__findById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades.destroyById() instead.
            "prototype$__destroyById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.comodidades.updateById() instead.
            "prototype$__updateById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empreendimento.fotos.findById() instead.
            "prototype$__findById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.fotos.destroyById() instead.
            "prototype$__destroyById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.fotos.updateById() instead.
            "prototype$__updateById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empreendimento.fase() instead.
            "prototype$__get__fase": {
              url: urlBase + "/empreendimentos/:id/fase",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.tipo_empreendimento() instead.
            "prototype$__get__tipo_empreendimento": {
              url: urlBase + "/empreendimentos/:id/tipo_empreendimento",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.status() instead.
            "prototype$__get__status": {
              url: urlBase + "/empreendimentos/:id/status",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades() instead.
            "prototype$__get__comodidades": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades.create() instead.
            "prototype$__create__comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.comodidades.destroyAll() instead.
            "prototype$__delete__comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.comodidades.count() instead.
            "prototype$__count__comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades/count",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.fotos() instead.
            "prototype$__get__fotos": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.fotos.create() instead.
            "prototype$__create__fotos": {
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.fotos.destroyAll() instead.
            "prototype$__delete__fotos": {
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.fotos.count() instead.
            "prototype$__count__fotos": {
              url: urlBase + "/empreendimentos/:id/fotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#create
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#createMany
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#upsert
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#replaceOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#upsertWithWhere
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#exists
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#findById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#replaceById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#find
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#findOne
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#updateAll
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#deleteById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#count
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#prototype$updateAttributes
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#createChangeStream
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#getEmp
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find imoveis by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "getEmp": {
              isArray: true,
              url: urlBase + "/empreendimentos/get-emp",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#getConfig
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find empreendimento config JSON.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "getConfig": {
              url: urlBase + "/empreendimentos/get-config",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#create
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#createMany
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#upsert
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#replaceOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#upsertWithWhere
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#exists
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#findById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#replaceById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#find
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#findOne
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#updateAll
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#deleteById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#count
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#prototype$updateAttributes
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#createChangeStream
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#pager
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/empreendimentos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#pagerDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/empreendimentos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#postDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/empreendimentos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#deleteDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/empreendimentos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#editDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/empreendimentos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#autocomplete
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/empreendimentos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#autocompleteDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/empreendimentos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#autocompleteDetailEdit
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/empreendimentos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#autocompleteGeneral
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/empreendimentos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#crudGET
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/empreendimentos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#crudGETDetail
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/empreendimentos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#quickAdd
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/empreendimentos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.empreendimento() instead.
            "::get::Imovel::empreendimento": {
              url: urlBase + "/imoveis/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use Card.empreendimento() instead.
            "::get::Card::empreendimento": {
              url: urlBase + "/cards/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.empreendimento() instead.
            "::get::CardImovel::empreendimento": {
              url: urlBase + "/cardsimovel/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.empreendimento() instead.
            "::get::TempCardImovel::empreendimento": {
              url: urlBase + "/tempcardsimovel/:id/empreendimento",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#updateOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchOrCreateWithWhere
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#update
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#destroyById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#removeById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchAttributes
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#updateOrCreate
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchOrCreateWithWhere
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#update
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#destroyById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#removeById
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#patchAttributes
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Empreendimento#modelName
        * @propertyOf lbServices.Empreendimento
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Empreendimento`.
        */
        R.modelName = "Empreendimento";


            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#construtora
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Fetches belongsTo relation construtora.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Construtora` object.)
             * </em>
             */
        R.construtora = function() {
          var TargetResource = $injector.get("Construtora");
          var action = TargetResource["::get::Empreendimento::construtora"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Empreendimento.comodidades
     * @header lbServices.Empreendimento.comodidades
     * @object
     * @description
     *
     * The object `Empreendimento.comodidades` groups methods
     * manipulating `EmpreendimentoComodidade` instances related to `Empreendimento`.
     *
     * Call {@link lbServices.Empreendimento#comodidades Empreendimento.comodidades()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#comodidades
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Queries comodidades of Empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R.comodidades = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::get::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#count
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Counts comodidades of Empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.comodidades.count = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::count::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#create
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R.comodidades.create = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::create::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#createMany
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R.comodidades.createMany = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::createMany::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#destroyAll
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Deletes all comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyAll = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::delete::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#destroyById
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Delete a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyById = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::destroyById::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#findById
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Find a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R.comodidades.findById = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::findById::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.comodidades#updateById
             * @methodOf lbServices.Empreendimento.comodidades
             *
             * @description
             *
             * Update a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R.comodidades.updateById = function() {
          var TargetResource = $injector.get("EmpreendimentoComodidade");
          var action = TargetResource["::updateById::Empreendimento::comodidades"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Empreendimento.fotos
     * @header lbServices.Empreendimento.fotos
     * @object
     * @description
     *
     * The object `Empreendimento.fotos` groups methods
     * manipulating `EmpreendimentoFoto` instances related to `Empreendimento`.
     *
     * Call {@link lbServices.Empreendimento#fotos Empreendimento.fotos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#fotos
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Queries fotos of Empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R.fotos = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::get::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#count
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Counts fotos of Empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.fotos.count = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::count::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#create
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Creates a new instance in fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R.fotos.create = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::create::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#createMany
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Creates a new instance in fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R.fotos.createMany = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::createMany::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#destroyAll
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Deletes all fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.fotos.destroyAll = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::delete::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#destroyById
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Delete a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.fotos.destroyById = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::destroyById::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#findById
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Find a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R.fotos.findById = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::findById::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento.fotos#updateById
             * @methodOf lbServices.Empreendimento.fotos
             *
             * @description
             *
             * Update a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R.fotos.updateById = function() {
          var TargetResource = $injector.get("EmpreendimentoFoto");
          var action = TargetResource["::updateById::Empreendimento::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#fase
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Fetches belongsTo relation fase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R.fase = function() {
          var TargetResource = $injector.get("Fase");
          var action = TargetResource["::get::Empreendimento::fase"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#tipo_empreendimento
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Fetches belongsTo relation tipo_empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R.tipo_empreendimento = function() {
          var TargetResource = $injector.get("TipoEmpreendimento");
          var action = TargetResource["::get::Empreendimento::tipo_empreendimento"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Empreendimento#status
             * @methodOf lbServices.Empreendimento
             *
             * @description
             *
             * Fetches belongsTo relation status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Empreendimento id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R.status = function() {
          var TargetResource = $injector.get("EmpreendimentoStatus");
          var action = TargetResource["::get::Empreendimento::status"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EmpreendimentoComodidade
 * @header lbServices.EmpreendimentoComodidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EmpreendimentoComodidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EmpreendimentoComodidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/empreendimentocomodidades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EmpreendimentoComodidade.comodidade() instead.
            "prototype$__get__comodidade": {
              url: urlBase + "/empreendimentocomodidades/:id/comodidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#create
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentocomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#createMany
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentocomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#upsert
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentocomodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentocomodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentocomodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#exists
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentocomodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#findById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#replaceById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentocomodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#find
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentocomodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#findOne
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentocomodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#updateAll
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentocomodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#deleteById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#count
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentocomodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#createChangeStream
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentocomodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#create
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentocomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#createMany
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentocomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#upsert
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentocomodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentocomodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentocomodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#exists
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentocomodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#findById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#replaceById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentocomodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#find
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentocomodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#findOne
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentocomodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#updateAll
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentocomodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#deleteById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#count
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentocomodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentocomodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#createChangeStream
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentocomodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#pager
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/empreendimentocomodidades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#pagerDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#postDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#deleteDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#editDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#autocomplete
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/empreendimentocomodidades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#autocompleteDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#autocompleteDetailEdit
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/empreendimentocomodidades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#autocompleteGeneral
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/empreendimentocomodidades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#crudGET
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/empreendimentocomodidades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#crudGETDetail
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/empreendimentocomodidades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#quickAdd
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/empreendimentocomodidades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.comodidades.findById() instead.
            "::findById::Empreendimento::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades.destroyById() instead.
            "::destroyById::Empreendimento::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.comodidades.updateById() instead.
            "::updateById::Empreendimento::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empreendimento.comodidades() instead.
            "::get::Empreendimento::comodidades": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.comodidades.create() instead.
            "::create::Empreendimento::comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.comodidades.createMany() instead.
            "::createMany::Empreendimento::comodidades": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.comodidades.destroyAll() instead.
            "::delete::Empreendimento::comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.comodidades.count() instead.
            "::count::Empreendimento::comodidades": {
              url: urlBase + "/empreendimentos/:id/comodidades/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#updateOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#update
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#destroyById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#removeById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchAttributes
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#updateOrCreate
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#update
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#destroyById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#removeById
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#patchAttributes
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EmpreendimentoComodidade#modelName
        * @propertyOf lbServices.EmpreendimentoComodidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EmpreendimentoComodidade`.
        */
        R.modelName = "EmpreendimentoComodidade";


            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoComodidade#comodidade
             * @methodOf lbServices.EmpreendimentoComodidade
             *
             * @description
             *
             * Fetches belongsTo relation comodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoComodidade id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidade = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::get::EmpreendimentoComodidade::comodidade"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EmpreendimentoFoto
 * @header lbServices.EmpreendimentoFoto
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EmpreendimentoFoto` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EmpreendimentoFoto",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/empreendimentofotos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use EmpreendimentoFoto.tipo_foto() instead.
            "prototype$__get__tipo_foto": {
              url: urlBase + "/empreendimentofotos/:id/tipo_foto",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#create
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#createMany
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#upsert
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentofotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentofotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentofotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#exists
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentofotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#findById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#replaceById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentofotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#find
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentofotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#findOne
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentofotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#updateAll
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentofotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#deleteById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#count
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentofotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#createChangeStream
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentofotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#create
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#createMany
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#upsert
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentofotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentofotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentofotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#exists
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentofotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#findById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#replaceById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentofotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#find
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentofotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#findOne
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentofotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#updateAll
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentofotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#deleteById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#count
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentofotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentofotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#createChangeStream
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentofotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#pager
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/empreendimentofotos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#pagerDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/empreendimentofotos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#postDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/empreendimentofotos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#deleteDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/empreendimentofotos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#editDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/empreendimentofotos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#autocomplete
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/empreendimentofotos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#autocompleteDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/empreendimentofotos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#autocompleteDetailEdit
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/empreendimentofotos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#autocompleteGeneral
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/empreendimentofotos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#crudGET
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/empreendimentofotos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#crudGETDetail
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/empreendimentofotos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#quickAdd
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/empreendimentofotos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.fotos.findById() instead.
            "::findById::Empreendimento::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.fotos.destroyById() instead.
            "::destroyById::Empreendimento::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.fotos.updateById() instead.
            "::updateById::Empreendimento::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/empreendimentos/:id/fotos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Empreendimento.fotos() instead.
            "::get::Empreendimento::fotos": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "GET",
            },

            // INTERNAL. Use Empreendimento.fotos.create() instead.
            "::create::Empreendimento::fotos": {
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.fotos.createMany() instead.
            "::createMany::Empreendimento::fotos": {
              isArray: true,
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.fotos.destroyAll() instead.
            "::delete::Empreendimento::fotos": {
              url: urlBase + "/empreendimentos/:id/fotos",
              method: "DELETE",
            },

            // INTERNAL. Use Empreendimento.fotos.count() instead.
            "::count::Empreendimento::fotos": {
              url: urlBase + "/empreendimentos/:id/fotos/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#updateOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#update
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#destroyById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#removeById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchAttributes
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#updateOrCreate
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#update
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#destroyById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#removeById
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#patchAttributes
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EmpreendimentoFoto#modelName
        * @propertyOf lbServices.EmpreendimentoFoto
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EmpreendimentoFoto`.
        */
        R.modelName = "EmpreendimentoFoto";


            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoFoto#tipo_foto
             * @methodOf lbServices.EmpreendimentoFoto
             *
             * @description
             *
             * Fetches belongsTo relation tipo_foto.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoFoto id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R.tipo_foto = function() {
          var TargetResource = $injector.get("TipoFoto");
          var action = TargetResource["::get::EmpreendimentoFoto::tipo_foto"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Fase
 * @header lbServices.Fase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Fase` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Fase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/fases/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Fase#create
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/fases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#createMany
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/fases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#upsert
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/fases",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#replaceOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/fases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#upsertWithWhere
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/fases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#exists
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/fases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#findById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/fases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#replaceById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/fases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#find
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/fases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#findOne
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/fases/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#updateAll
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/fases/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#deleteById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/fases/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#count
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/fases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#prototype$updateAttributes
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fase id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/fases/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#createChangeStream
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/fases/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#create
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/fases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#createMany
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/fases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#upsert
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/fases",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#replaceOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/fases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#upsertWithWhere
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/fases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#exists
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/fases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#findById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/fases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#replaceById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/fases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#find
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/fases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#findOne
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/fases/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#updateAll
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/fases/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#deleteById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/fases/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#count
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/fases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#prototype$updateAttributes
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fase id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/fases/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#createChangeStream
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/fases/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#pager
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/fases/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#pagerDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/fases/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#postDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/fases/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#deleteDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/fases/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#editDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/fases/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#autocomplete
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/fases/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#autocompleteDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/fases/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#autocompleteDetailEdit
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/fases/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#autocompleteGeneral
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/fases/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#crudGET
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/fases/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#crudGETDetail
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/fases/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Fase#quickAdd
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/fases/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.fase() instead.
            "::get::Empreendimento::fase": {
              url: urlBase + "/empreendimentos/:id/fase",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fase() instead.
            "::get::Imovel::fase": {
              url: urlBase + "/imoveis/:id/fase",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Fase#patchOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#updateOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#patchOrCreateWithWhere
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#update
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#destroyById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#removeById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#patchAttributes
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fase id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#patchOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#updateOrCreate
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#patchOrCreateWithWhere
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#update
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#destroyById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#removeById
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Fase#patchAttributes
             * @methodOf lbServices.Fase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Fase id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Fase#modelName
        * @propertyOf lbServices.Fase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Fase`.
        */
        R.modelName = "Fase";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Finalidade
 * @header lbServices.Finalidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Finalidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Finalidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/finalidades/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#create
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/finalidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#createMany
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/finalidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#upsert
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/finalidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#replaceOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/finalidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#upsertWithWhere
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/finalidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#exists
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/finalidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#findById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/finalidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#replaceById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/finalidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#find
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/finalidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#findOne
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/finalidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#updateAll
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/finalidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#deleteById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/finalidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#count
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/finalidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#prototype$updateAttributes
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Finalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/finalidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#createChangeStream
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/finalidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#create
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/finalidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#createMany
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/finalidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#upsert
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/finalidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#replaceOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/finalidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#upsertWithWhere
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/finalidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#exists
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/finalidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#findById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/finalidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#replaceById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/finalidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#find
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/finalidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#findOne
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/finalidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#updateAll
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/finalidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#deleteById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/finalidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#count
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/finalidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#prototype$updateAttributes
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Finalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/finalidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#createChangeStream
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/finalidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#pager
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/finalidades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#pagerDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/finalidades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#postDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/finalidades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#deleteDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/finalidades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#editDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/finalidades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#autocomplete
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/finalidades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#autocompleteDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/finalidades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#autocompleteDetailEdit
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/finalidades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#autocompleteGeneral
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/finalidades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#crudGET
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/finalidades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#crudGETDetail
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/finalidades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#quickAdd
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/finalidades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.finalidade() instead.
            "::get::Imovel::finalidade": {
              url: urlBase + "/imoveis/:id/finalidade",
              method: "GET",
            },

            // INTERNAL. Use SubTipoImovel.subtp_finalidade() instead.
            "::get::SubTipoImovel::subtp_finalidade": {
              url: urlBase + "/subtipoimoveis/:id/subtp_finalidade",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#updateOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchOrCreateWithWhere
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#update
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#destroyById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#removeById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchAttributes
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Finalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#updateOrCreate
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchOrCreateWithWhere
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#update
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#destroyById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#removeById
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Finalidade#patchAttributes
             * @methodOf lbServices.Finalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Finalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Finalidade#modelName
        * @propertyOf lbServices.Finalidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Finalidade`.
        */
        R.modelName = "Finalidade";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Imobiliaria
 * @header lbServices.Imobiliaria
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Imobiliaria` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Imobiliaria",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliarias/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Imobiliaria.cidade() instead.
            "prototype$__get__cidade": {
              url: urlBase + "/imobiliarias/:id/cidade",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.imobgrupo() instead.
            "prototype$__get__imobgrupo": {
              url: urlBase + "/imobiliarias/:id/imobgrupo",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.findById() instead.
            "prototype$__findById__imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.destroyById() instead.
            "prototype$__destroyById__imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.updateById() instead.
            "prototype$__updateById__imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.imbGestor() instead.
            "prototype$__get__imbGestor": {
              url: urlBase + "/imobiliarias/:id/imbGestor",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.findById() instead.
            "prototype$__findById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.destroyById() instead.
            "prototype$__destroyById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.enderecos.updateById() instead.
            "prototype$__updateById__enderecos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/enderecos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.corretores.findById() instead.
            "prototype$__findById__corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.corretores.destroyById() instead.
            "prototype$__destroyById__corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.corretores.updateById() instead.
            "prototype$__updateById__corretores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/corretores/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.imoveis.findById() instead.
            "prototype$__findById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis.destroyById() instead.
            "prototype$__destroyById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imoveis.updateById() instead.
            "prototype$__updateById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.tipoxml() instead.
            "prototype$__get__tipoxml": {
              url: urlBase + "/imobiliarias/:id/tipoxml",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.findById() instead.
            "prototype$__findById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.destroyById() instead.
            "prototype$__destroyById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.redessociais.updateById() instead.
            "prototype$__updateById__redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.destaques.findById() instead.
            "prototype$__findById__destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.destaques.destroyById() instead.
            "prototype$__destroyById__destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.destaques.updateById() instead.
            "prototype$__updateById__destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.config.findById() instead.
            "prototype$__findById__config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.config.destroyById() instead.
            "prototype$__destroyById__config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.config.updateById() instead.
            "prototype$__updateById__config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.findById() instead.
            "prototype$__findById__status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.destroyById() instead.
            "prototype$__destroyById__status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.updateById() instead.
            "prototype$__updateById__status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.findById() instead.
            "prototype$__findById__bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.destroyById() instead.
            "prototype$__destroyById__bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.updateById() instead.
            "prototype$__updateById__bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.portais.findById() instead.
            "prototype$__findById__portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.portais.destroyById() instead.
            "prototype$__destroyById__portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.portais.updateById() instead.
            "prototype$__updateById__portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/imobiliarias/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/imobiliarias/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas() instead.
            "prototype$__get__imobassociadas": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.create() instead.
            "prototype$__create__imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.destroyAll() instead.
            "prototype$__delete__imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.count() instead.
            "prototype$__count__imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos() instead.
            "prototype$__get__enderecos": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.enderecos.create() instead.
            "prototype$__create__enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.enderecos.destroyAll() instead.
            "prototype$__delete__enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.enderecos.count() instead.
            "prototype$__count__enderecos": {
              url: urlBase + "/imobiliarias/:id/enderecos/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.corretores() instead.
            "prototype$__get__corretores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.corretores.create() instead.
            "prototype$__create__corretores": {
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.corretores.destroyAll() instead.
            "prototype$__delete__corretores": {
              url: urlBase + "/imobiliarias/:id/corretores",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.corretores.count() instead.
            "prototype$__count__corretores": {
              url: urlBase + "/imobiliarias/:id/corretores/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis() instead.
            "prototype$__get__imoveis": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis.create() instead.
            "prototype$__create__imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imoveis.destroyAll() instead.
            "prototype$__delete__imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imoveis.count() instead.
            "prototype$__count__imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais() instead.
            "prototype$__get__redessociais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.create() instead.
            "prototype$__create__redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.redessociais.destroyAll() instead.
            "prototype$__delete__redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.redessociais.count() instead.
            "prototype$__count__redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.destaques() instead.
            "prototype$__get__destaques": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.destaques.create() instead.
            "prototype$__create__destaques": {
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.destaques.destroyAll() instead.
            "prototype$__delete__destaques": {
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.destaques.count() instead.
            "prototype$__count__destaques": {
              url: urlBase + "/imobiliarias/:id/destaques/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.config() instead.
            "prototype$__get__config": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/config",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.config.create() instead.
            "prototype$__create__config": {
              url: urlBase + "/imobiliarias/:id/config",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.config.destroyAll() instead.
            "prototype$__delete__config": {
              url: urlBase + "/imobiliarias/:id/config",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.config.count() instead.
            "prototype$__count__config": {
              url: urlBase + "/imobiliarias/:id/config/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.status_cliente() instead.
            "prototype$__get__status_cliente": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.create() instead.
            "prototype$__create__status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.destroyAll() instead.
            "prototype$__delete__status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.count() instead.
            "prototype$__count__status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores() instead.
            "prototype$__get__bifurcadores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.create() instead.
            "prototype$__create__bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.destroyAll() instead.
            "prototype$__delete__bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.count() instead.
            "prototype$__count__bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.portais() instead.
            "prototype$__get__portais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/portais",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.portais.create() instead.
            "prototype$__create__portais": {
              url: urlBase + "/imobiliarias/:id/portais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.portais.destroyAll() instead.
            "prototype$__delete__portais": {
              url: urlBase + "/imobiliarias/:id/portais",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.portais.count() instead.
            "prototype$__count__portais": {
              url: urlBase + "/imobiliarias/:id/portais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#create
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#createMany
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#upsert
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#replaceOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#upsertWithWhere
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#exists
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#findById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#replaceById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#find
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#findOne
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#updateAll
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#deleteById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#count
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#prototype$updateAttributes
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#createChangeStream
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#getImobiliaria
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "getImobiliaria": {
              isArray: true,
              url: urlBase + "/imobiliarias-replica/get-imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#getHeadersTest
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "getHeadersTest": {
              url: urlBase + "/imobiliarias/get-headers-test",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#getWhiteLabelConfigs
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "getWhiteLabelConfigs": {
              isArray: true,
              url: urlBase + "/imobiliarias-replica/get-white-label-configs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#verifyXml
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Verify if xml is valid.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "verifyXml": {
              url: urlBase + "/imobiliarias/verify-xml",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#uploadrichtext
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `res` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{object=}` -
             */
            "uploadrichtext": {
              url: urlBase + "/imobiliarias/uploadrichtext",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#verifyCsv
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `res` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "verifyCsv": {
              url: urlBase + "/imobiliarias/verify-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#makexml
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * make a xml following specific rules.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `res` – `{object}` -
             */
            "makexml": {
              url: urlBase + "/imobiliarias/makexml",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#create
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#createMany
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#upsert
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#replaceOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#upsertWithWhere
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#exists
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#findById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#replaceById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#find
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#findOne
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#updateAll
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#deleteById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#count
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#prototype$updateAttributes
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#createChangeStream
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#pager
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliarias/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#pagerDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliarias/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#postDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliarias/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#deleteDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliarias/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#editDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliarias/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#autocomplete
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliarias/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#autocompleteDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliarias/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#autocompleteDetailEdit
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliarias/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#autocompleteGeneral
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliarias/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#crudGET
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliarias/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#crudGETDetail
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliarias/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#quickAdd
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliarias/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.imobiliaria() instead.
            "::get::Usuario::imobiliaria": {
              url: urlBase + "/users/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Corretor.imobiliaria() instead.
            "::get::Corretor::imobiliaria": {
              url: urlBase + "/corretores/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imobiliaria() instead.
            "::get::Proprietario::imobiliaria": {
              url: urlBase + "/proprietarios/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobgrupo() instead.
            "::get::Imobiliaria::imobgrupo": {
              url: urlBase + "/imobiliarias/:id/imobgrupo",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.findById() instead.
            "::findById::Imobiliaria::imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.destroyById() instead.
            "::destroyById::Imobiliaria::imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.updateById() instead.
            "::updateById::Imobiliaria::imobassociadas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imobassociadas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas() instead.
            "::get::Imobiliaria::imobassociadas": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.create() instead.
            "::create::Imobiliaria::imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.createMany() instead.
            "::createMany::Imobiliaria::imobassociadas": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.destroyAll() instead.
            "::delete::Imobiliaria::imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imobassociadas.count() instead.
            "::count::Imobiliaria::imobassociadas": {
              url: urlBase + "/imobiliarias/:id/imobassociadas/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imobiliaria() instead.
            "::get::Imovel::imobiliaria": {
              url: urlBase + "/imoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TipoMidia.tpmd_imobiliaria() instead.
            "::get::TipoMidia::tpmd_imobiliaria": {
              url: urlBase + "/tiposmidia/:id/tpmd_imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.imobiliaria() instead.
            "::get::ClienteInteressado::imobiliaria": {
              url: urlBase + "/clientesinteressados/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.imobiliaria() instead.
            "::get::CardImovel::imobiliaria": {
              url: urlBase + "/cardsimovel/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Plantao.imobiliaria() instead.
            "::get::Plantao::imobiliaria": {
              url: urlBase + "/plantoes/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.imobiliaria() instead.
            "::get::TempCardImovel::imobiliaria": {
              url: urlBase + "/tempcardsimovel/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImovelTermos.terms_imobiliaria() instead.
            "::get::ImovelTermos::terms_imobiliaria": {
              url: urlBase + "/imovelTermos/:id/terms_imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.imobiliaria() instead.
            "::get::ProprietarioImobiliaria::imobiliaria": {
              url: urlBase + "/proprietarioimobiliarias/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propImobiliaria() instead.
            "::get::Proposta::propImobiliaria": {
              url: urlBase + "/propostas/:id/propImobiliaria",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexoImob.imob() instead.
            "::get::PropostaTipoAnexoImob::imob": {
              url: urlBase + "/propostatiposanexoimob/:id/imob",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.imobiliaria() instead.
            "::get::RadarImovel::imobiliaria": {
              url: urlBase + "/radarimoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioImobiliaria.imobiliaria() instead.
            "::get::TipoNegocioImobiliaria::imobiliaria": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use LogXmlPortal.imobiliaria() instead.
            "::get::LogXmlPortal::imobiliaria": {
              url: urlBase + "/logxmlportal/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Time.imobiliaria() instead.
            "::get::Time::imobiliaria": {
              url: urlBase + "/times/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.imobiliaria() instead.
            "::get::PortalImovel::imobiliaria": {
              url: urlBase + "/portalimoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaDestaques.imobiliaria() instead.
            "::get::ImobiliariaDestaques::imobiliaria": {
              url: urlBase + "/imobiliariasDestaques/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaConfig.imobiliaria() instead.
            "::get::ImobiliariaConfig::imobiliaria": {
              url: urlBase + "/imobiliariaconfigs/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaStatusCliente.imobiliaria() instead.
            "::get::ImobiliariaStatusCliente::imobiliaria": {
              url: urlBase + "/imobiliariastatusclientes/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.imobiliaria() instead.
            "::get::OrcamentoMarketing::imobiliaria": {
              url: urlBase + "/orcamentosmarketing/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.imobiliaria() instead.
            "::get::ImobiliariaBifurcador::imobiliaria": {
              url: urlBase + "/imobiliariabifurcador/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use BifurcadorLog.imobiliaria() instead.
            "::get::BifurcadorLog::imobiliaria": {
              url: urlBase + "/bifurcadorlogs/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.imobiliaria() instead.
            "::get::ImobiliariaPortal::imobiliaria": {
              url: urlBase + "/imobiliariaportais/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use PortalOrdemImobiliaria.imobiliaria() instead.
            "::get::PortalOrdemImobiliaria::imobiliaria": {
              url: urlBase + "/portalordemimobiliarias/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Cliente.imobiliaria() instead.
            "::get::Cliente::imobiliaria": {
              url: urlBase + "/clientes/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.imobiliaria() instead.
            "::get::ImportacaoCsvLogs::imobiliaria": {
              url: urlBase + "/importacaocsvlogs/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Campanha.imobiliaria() instead.
            "::get::Campanha::imobiliaria": {
              url: urlBase + "/campanhas/:id/imobiliaria",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#updateOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#update
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#destroyById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#removeById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchAttributes
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#updateOrCreate
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#update
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#destroyById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#removeById
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#patchAttributes
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Imobiliaria#modelName
        * @propertyOf lbServices.Imobiliaria
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Imobiliaria`.
        */
        R.modelName = "Imobiliaria";


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#cidade
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation cidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cidade` object.)
             * </em>
             */
        R.cidade = function() {
          var TargetResource = $injector.get("Cidade");
          var action = TargetResource["::get::Imobiliaria::cidade"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.telefones
     * @header lbServices.Imobiliaria.telefones
     * @object
     * @description
     *
     * The object `Imobiliaria.telefones` groups methods
     * manipulating `Telefone` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#telefones Imobiliaria.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#telefones
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries telefones of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#count
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Counts telefones of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#create
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#createMany
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#destroyAll
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#destroyById
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#findById
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.telefones#updateById
             * @methodOf lbServices.Imobiliaria.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::Imobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#imobgrupo
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation imobgrupo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobgrupo = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Imobiliaria::imobgrupo"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.imobassociadas
     * @header lbServices.Imobiliaria.imobassociadas
     * @object
     * @description
     *
     * The object `Imobiliaria.imobassociadas` groups methods
     * manipulating `Imobiliaria` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#imobassociadas Imobiliaria.imobassociadas()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#imobassociadas
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries imobassociadas of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobassociadas = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#count
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Counts imobassociadas of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.imobassociadas.count = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::count::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#create
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Creates a new instance in imobassociadas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobassociadas.create = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::create::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#createMany
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Creates a new instance in imobassociadas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobassociadas.createMany = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::createMany::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#destroyAll
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Deletes all imobassociadas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imobassociadas.destroyAll = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::delete::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#destroyById
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Delete a related item by id for imobassociadas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imobassociadas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imobassociadas.destroyById = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::destroyById::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#findById
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Find a related item by id for imobassociadas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imobassociadas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobassociadas.findById = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::findById::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imobassociadas#updateById
             * @methodOf lbServices.Imobiliaria.imobassociadas
             *
             * @description
             *
             * Update a related item by id for imobassociadas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for imobassociadas
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobassociadas.updateById = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::updateById::Imobiliaria::imobassociadas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#imbGestor
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation imbGestor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.imbGestor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::Imobiliaria::imbGestor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.enderecos
     * @header lbServices.Imobiliaria.enderecos
     * @object
     * @description
     *
     * The object `Imobiliaria.enderecos` groups methods
     * manipulating `Endereco` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#enderecos Imobiliaria.enderecos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#enderecos
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries enderecos of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::get::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#count
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Counts enderecos of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.enderecos.count = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::count::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#create
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.create = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::create::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#createMany
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Creates a new instance in enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.createMany = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::createMany::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#destroyAll
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Deletes all enderecos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyAll = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::delete::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#destroyById
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Delete a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.enderecos.destroyById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::destroyById::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#findById
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Find a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.findById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::findById::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.enderecos#updateById
             * @methodOf lbServices.Imobiliaria.enderecos
             *
             * @description
             *
             * Update a related item by id for enderecos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for enderecos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Endereco` object.)
             * </em>
             */
        R.enderecos.updateById = function() {
          var TargetResource = $injector.get("Endereco");
          var action = TargetResource["::updateById::Imobiliaria::enderecos"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.corretores
     * @header lbServices.Imobiliaria.corretores
     * @object
     * @description
     *
     * The object `Imobiliaria.corretores` groups methods
     * manipulating `Corretor` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#corretores Imobiliaria.corretores()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#corretores
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries corretores of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretores = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#count
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Counts corretores of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.corretores.count = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::count::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#create
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Creates a new instance in corretores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretores.create = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::create::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#createMany
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Creates a new instance in corretores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretores.createMany = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::createMany::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#destroyAll
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Deletes all corretores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.corretores.destroyAll = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::delete::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#destroyById
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Delete a related item by id for corretores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for corretores
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.corretores.destroyById = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::destroyById::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#findById
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Find a related item by id for corretores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for corretores
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretores.findById = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::findById::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.corretores#updateById
             * @methodOf lbServices.Imobiliaria.corretores
             *
             * @description
             *
             * Update a related item by id for corretores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for corretores
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretores.updateById = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::updateById::Imobiliaria::corretores"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.imoveis
     * @header lbServices.Imobiliaria.imoveis
     * @object
     * @description
     *
     * The object `Imobiliaria.imoveis` groups methods
     * manipulating `Imovel` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#imoveis Imobiliaria.imoveis()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#imoveis
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries imoveis of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#count
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Counts imoveis of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.imoveis.count = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::count::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#create
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.create = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::create::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#createMany
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.createMany = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::createMany::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#destroyAll
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Deletes all imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyAll = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::delete::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#destroyById
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Delete a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::destroyById::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#findById
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Find a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.findById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::findById::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.imoveis#updateById
             * @methodOf lbServices.Imobiliaria.imoveis
             *
             * @description
             *
             * Update a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.updateById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::updateById::Imobiliaria::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#tipoxml
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation tipoxml.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R.tipoxml = function() {
          var TargetResource = $injector.get("TipoMidia");
          var action = TargetResource["::get::Imobiliaria::tipoxml"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.redessociais
     * @header lbServices.Imobiliaria.redessociais
     * @object
     * @description
     *
     * The object `Imobiliaria.redessociais` groups methods
     * manipulating `RedeSocial` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#redessociais Imobiliaria.redessociais()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#redessociais
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries redessociais of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::get::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#count
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Counts redessociais of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.redessociais.count = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::count::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#create
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.create = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::create::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#createMany
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Creates a new instance in redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.createMany = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::createMany::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#destroyAll
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Deletes all redessociais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyAll = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::delete::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#destroyById
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Delete a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.redessociais.destroyById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::destroyById::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#findById
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Find a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.findById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::findById::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.redessociais#updateById
             * @methodOf lbServices.Imobiliaria.redessociais
             *
             * @description
             *
             * Update a related item by id for redessociais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for redessociais
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R.redessociais.updateById = function() {
          var TargetResource = $injector.get("RedeSocial");
          var action = TargetResource["::updateById::Imobiliaria::redessociais"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.destaques
     * @header lbServices.Imobiliaria.destaques
     * @object
     * @description
     *
     * The object `Imobiliaria.destaques` groups methods
     * manipulating `ImobiliariaDestaques` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#destaques Imobiliaria.destaques()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#destaques
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries destaques of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R.destaques = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::get::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#count
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Counts destaques of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.destaques.count = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::count::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#create
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Creates a new instance in destaques of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R.destaques.create = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::create::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#createMany
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Creates a new instance in destaques of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R.destaques.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::createMany::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#destroyAll
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Deletes all destaques of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.destaques.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::delete::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#destroyById
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Delete a related item by id for destaques.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for destaques
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.destaques.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::destroyById::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#findById
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Find a related item by id for destaques.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for destaques
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R.destaques.findById = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::findById::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.destaques#updateById
             * @methodOf lbServices.Imobiliaria.destaques
             *
             * @description
             *
             * Update a related item by id for destaques.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for destaques
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R.destaques.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaDestaques");
          var action = TargetResource["::updateById::Imobiliaria::destaques"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.config
     * @header lbServices.Imobiliaria.config
     * @object
     * @description
     *
     * The object `Imobiliaria.config` groups methods
     * manipulating `ImobiliariaConfig` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#config Imobiliaria.config()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#config
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries config of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R.config = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::get::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#count
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Counts config of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.config.count = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::count::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#create
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Creates a new instance in config of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R.config.create = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::create::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#createMany
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Creates a new instance in config of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R.config.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::createMany::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#destroyAll
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Deletes all config of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.config.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::delete::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#destroyById
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Delete a related item by id for config.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for config
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.config.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::destroyById::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#findById
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Find a related item by id for config.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for config
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R.config.findById = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::findById::Imobiliaria::config"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.config#updateById
             * @methodOf lbServices.Imobiliaria.config
             *
             * @description
             *
             * Update a related item by id for config.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for config
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R.config.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaConfig");
          var action = TargetResource["::updateById::Imobiliaria::config"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.status_cliente
     * @header lbServices.Imobiliaria.status_cliente
     * @object
     * @description
     *
     * The object `Imobiliaria.status_cliente` groups methods
     * manipulating `ImobiliariaStatusCliente` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#status_cliente Imobiliaria.status_cliente()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#status_cliente
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries status_cliente of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R.status_cliente = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::get::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#count
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Counts status_cliente of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.status_cliente.count = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::count::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#create
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Creates a new instance in status_cliente of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R.status_cliente.create = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::create::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#createMany
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Creates a new instance in status_cliente of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R.status_cliente.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::createMany::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#destroyAll
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Deletes all status_cliente of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.status_cliente.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::delete::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#destroyById
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Delete a related item by id for status_cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for status_cliente
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.status_cliente.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::destroyById::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#findById
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Find a related item by id for status_cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for status_cliente
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R.status_cliente.findById = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::findById::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.status_cliente#updateById
             * @methodOf lbServices.Imobiliaria.status_cliente
             *
             * @description
             *
             * Update a related item by id for status_cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for status_cliente
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R.status_cliente.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaStatusCliente");
          var action = TargetResource["::updateById::Imobiliaria::status_cliente"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.bifurcadores
     * @header lbServices.Imobiliaria.bifurcadores
     * @object
     * @description
     *
     * The object `Imobiliaria.bifurcadores` groups methods
     * manipulating `ImobiliariaBifurcador` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#bifurcadores Imobiliaria.bifurcadores()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#bifurcadores
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries bifurcadores of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R.bifurcadores = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::get::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#count
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Counts bifurcadores of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bifurcadores.count = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::count::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#create
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Creates a new instance in bifurcadores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R.bifurcadores.create = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::create::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#createMany
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Creates a new instance in bifurcadores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R.bifurcadores.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::createMany::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#destroyAll
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Deletes all bifurcadores of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bifurcadores.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::delete::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#destroyById
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Delete a related item by id for bifurcadores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bifurcadores
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bifurcadores.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::destroyById::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#findById
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Find a related item by id for bifurcadores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bifurcadores
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R.bifurcadores.findById = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::findById::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.bifurcadores#updateById
             * @methodOf lbServices.Imobiliaria.bifurcadores
             *
             * @description
             *
             * Update a related item by id for bifurcadores.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for bifurcadores
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R.bifurcadores.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaBifurcador");
          var action = TargetResource["::updateById::Imobiliaria::bifurcadores"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imobiliaria.portais
     * @header lbServices.Imobiliaria.portais
     * @object
     * @description
     *
     * The object `Imobiliaria.portais` groups methods
     * manipulating `ImobiliariaPortal` instances related to `Imobiliaria`.
     *
     * Call {@link lbServices.Imobiliaria#portais Imobiliaria.portais()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria#portais
             * @methodOf lbServices.Imobiliaria
             *
             * @description
             *
             * Queries portais of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portais = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::get::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#count
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Counts portais of Imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.portais.count = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::count::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#create
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Creates a new instance in portais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portais.create = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::create::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#createMany
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Creates a new instance in portais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portais.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::createMany::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#destroyAll
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Deletes all portais of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portais.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::delete::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#destroyById
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Delete a related item by id for portais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portais.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::destroyById::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#findById
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Find a related item by id for portais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portais
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portais.findById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::findById::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imobiliaria.portais#updateById
             * @methodOf lbServices.Imobiliaria.portais
             *
             * @description
             *
             * Update a related item by id for portais.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for portais
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portais.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::updateById::Imobiliaria::portais"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelComodidade
 * @header lbServices.ImovelComodidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelComodidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelComodidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelcomodidades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelComodidade.comodidade() instead.
            "prototype$__get__comodidade": {
              url: urlBase + "/imovelcomodidades/:id/comodidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#create
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelcomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#createMany
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelcomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#upsert
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelcomodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#replaceOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelcomodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#upsertWithWhere
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelcomodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#exists
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelcomodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#findById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#replaceById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelcomodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#find
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelcomodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#findOne
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelcomodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#updateAll
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelcomodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#deleteById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#count
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelcomodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#prototype$updateAttributes
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#createChangeStream
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelcomodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#create
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelcomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#createMany
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelcomodidades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#upsert
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelcomodidades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#replaceOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelcomodidades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#upsertWithWhere
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelcomodidades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#exists
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelcomodidades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#findById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#replaceById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelcomodidades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#find
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelcomodidades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#findOne
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelcomodidades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#updateAll
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelcomodidades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#deleteById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#count
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelcomodidades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#prototype$updateAttributes
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelcomodidades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#createChangeStream
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelcomodidades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#pager
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelcomodidades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#pagerDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelcomodidades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#postDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelcomodidades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#deleteDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelcomodidades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#editDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelcomodidades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#autocomplete
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelcomodidades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#autocompleteDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelcomodidades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#autocompleteDetailEdit
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelcomodidades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#autocompleteGeneral
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelcomodidades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#crudGET
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelcomodidades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#crudGETDetail
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelcomodidades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#quickAdd
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelcomodidades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.comodidades.findById() instead.
            "::findById::Imovel::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.comodidades.destroyById() instead.
            "::destroyById::Imovel::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.comodidades.updateById() instead.
            "::updateById::Imovel::comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.comodidades() instead.
            "::get::Imovel::comodidades": {
              isArray: true,
              url: urlBase + "/imoveis/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use Imovel.comodidades.create() instead.
            "::create::Imovel::comodidades": {
              url: urlBase + "/imoveis/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Imovel.comodidades.createMany() instead.
            "::createMany::Imovel::comodidades": {
              isArray: true,
              url: urlBase + "/imoveis/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Imovel.comodidades.destroyAll() instead.
            "::delete::Imovel::comodidades": {
              url: urlBase + "/imoveis/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.comodidades.count() instead.
            "::count::Imovel::comodidades": {
              url: urlBase + "/imoveis/:id/comodidades/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#updateOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#update
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#destroyById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#removeById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchAttributes
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#updateOrCreate
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#update
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#destroyById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#removeById
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#patchAttributes
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelComodidade#modelName
        * @propertyOf lbServices.ImovelComodidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelComodidade`.
        */
        R.modelName = "ImovelComodidade";


            /**
             * @ngdoc method
             * @name lbServices.ImovelComodidade#comodidade
             * @methodOf lbServices.ImovelComodidade
             *
             * @description
             *
             * Fetches belongsTo relation comodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelComodidade id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidade = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::get::ImovelComodidade::comodidade"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelFoto
 * @header lbServices.ImovelFoto
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelFoto` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelFoto",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelfotos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelFoto.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/imovelfotos/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelFoto.tipo_foto() instead.
            "prototype$__get__tipo_foto": {
              url: urlBase + "/imovelfotos/:id/tipo_foto",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#create
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelfotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#createMany
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelfotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#upsert
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelfotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#replaceOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelfotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#upsertWithWhere
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelfotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#exists
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelfotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#findById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelfotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#replaceById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelfotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#find
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelfotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#findOne
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelfotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#updateAll
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelfotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#deleteById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelfotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#count
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelfotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#prototype$updateAttributes
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelfotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#createChangeStream
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelfotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#do_water_mark
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Função que faz a watermark nas imagens passadas por parametro
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "do_water_mark": {
              url: urlBase + "/imovelfotos/do-water-mark",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#editFoto
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Edit Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "editFoto": {
              url: urlBase + "/imovelfotos/edit-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#create
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelfotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#createMany
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelfotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#upsert
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelfotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#replaceOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelfotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#upsertWithWhere
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelfotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#exists
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelfotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#findById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelfotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#replaceById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelfotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#find
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelfotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#findOne
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelfotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#updateAll
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelfotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#deleteById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelfotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#count
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelfotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#prototype$updateAttributes
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelfotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#createChangeStream
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelfotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#pager
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelfotos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#pagerDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelfotos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#postDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelfotos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#deleteDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelfotos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#editDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelfotos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#autocomplete
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelfotos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#autocompleteDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelfotos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#autocompleteDetailEdit
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelfotos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#autocompleteGeneral
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelfotos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#crudGET
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelfotos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#crudGETDetail
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelfotos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#quickAdd
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelfotos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.fotos.findById() instead.
            "::findById::Imovel::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fotos.destroyById() instead.
            "::destroyById::Imovel::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.fotos.updateById() instead.
            "::updateById::Imovel::fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.fotos() instead.
            "::get::Imovel::fotos": {
              isArray: true,
              url: urlBase + "/imoveis/:id/fotos",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fotos.create() instead.
            "::create::Imovel::fotos": {
              url: urlBase + "/imoveis/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Imovel.fotos.createMany() instead.
            "::createMany::Imovel::fotos": {
              isArray: true,
              url: urlBase + "/imoveis/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Imovel.fotos.destroyAll() instead.
            "::delete::Imovel::fotos": {
              url: urlBase + "/imoveis/:id/fotos",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.fotos.count() instead.
            "::count::Imovel::fotos": {
              url: urlBase + "/imoveis/:id/fotos/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#updateOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#update
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#destroyById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#removeById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchAttributes
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#updateOrCreate
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#update
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#destroyById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#removeById
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#patchAttributes
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelFoto#modelName
        * @propertyOf lbServices.ImovelFoto
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelFoto`.
        */
        R.modelName = "ImovelFoto";


            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#imovel
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImovelFoto::imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImovelFoto#tipo_foto
             * @methodOf lbServices.ImovelFoto
             *
             * @description
             *
             * Fetches belongsTo relation tipo_foto.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelFoto id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R.tipo_foto = function() {
          var TargetResource = $injector.get("TipoFoto");
          var action = TargetResource["::get::ImovelFoto::tipo_foto"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Imovel
 * @header lbServices.Imovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Imovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Imovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imoveis/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Imovel.finalidade() instead.
            "prototype$__get__finalidade": {
              url: urlBase + "/imoveis/:id/finalidade",
              method: "GET",
            },

            // INTERNAL. Use Imovel.categoria_imovel() instead.
            "prototype$__get__categoria_imovel": {
              url: urlBase + "/imoveis/:id/categoria_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fase() instead.
            "prototype$__get__fase": {
              url: urlBase + "/imoveis/:id/fase",
              method: "GET",
            },

            // INTERNAL. Use Imovel.proprietario() instead.
            "prototype$__get__proprietario": {
              url: urlBase + "/imoveis/:id/proprietario",
              method: "GET",
            },

            // INTERNAL. Use Imovel.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/imoveis/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Imovel.empreendimento() instead.
            "prototype$__get__empreendimento": {
              url: urlBase + "/imoveis/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use Imovel.comodidades.findById() instead.
            "prototype$__findById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.comodidades.destroyById() instead.
            "prototype$__destroyById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.comodidades.updateById() instead.
            "prototype$__updateById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.fotos.findById() instead.
            "prototype$__findById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fotos.destroyById() instead.
            "prototype$__destroyById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.fotos.updateById() instead.
            "prototype$__updateById__fotos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/fotos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.imvempreendimento() instead.
            "prototype$__get__imvempreendimento": {
              url: urlBase + "/imoveis/:id/imvempreendimento",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.findById() instead.
            "prototype$__findById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.destroyById() instead.
            "prototype$__destroyById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.imoveis.updateById() instead.
            "prototype$__updateById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.ocupacao() instead.
            "prototype$__get__ocupacao": {
              url: urlBase + "/imoveis/:id/ocupacao",
              method: "GET",
            },

            // INTERNAL. Use Imovel.padrao_imovel() instead.
            "prototype$__get__padrao_imovel": {
              url: urlBase + "/imoveis/:id/padrao_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.padrao_localizacao() instead.
            "prototype$__get__padrao_localizacao": {
              url: urlBase + "/imoveis/:id/padrao_localizacao",
              method: "GET",
            },

            // INTERNAL. Use Imovel.status_comercial() instead.
            "prototype$__get__status_comercial": {
              url: urlBase + "/imoveis/:id/status_comercial",
              method: "GET",
            },

            // INTERNAL. Use Imovel.subtipo_imovel() instead.
            "prototype$__get__subtipo_imovel": {
              url: urlBase + "/imoveis/:id/subtipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.tipo_imovel() instead.
            "prototype$__get__tipo_imovel": {
              url: urlBase + "/imoveis/:id/tipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.unidade_metrica() instead.
            "prototype$__get__unidade_metrica": {
              url: urlBase + "/imoveis/:id/unidade_metrica",
              method: "GET",
            },

            // INTERNAL. Use Imovel.midia() instead.
            "prototype$__get__midia": {
              url: urlBase + "/imoveis/:id/midia",
              method: "GET",
            },

            // INTERNAL. Use Imovel.tipo_negocio() instead.
            "prototype$__get__tipo_negocio": {
              url: urlBase + "/imoveis/:id/tipo_negocio",
              method: "GET",
            },

            // INTERNAL. Use Imovel.chave() instead.
            "prototype$__get__chave": {
              url: urlBase + "/imoveis/:id/chave",
              method: "GET",
            },

            // INTERNAL. Use Imovel.chave_estara() instead.
            "prototype$__get__chave_estara": {
              url: urlBase + "/imoveis/:id/chave_estara",
              method: "GET",
            },

            // INTERNAL. Use Imovel.modalidade() instead.
            "prototype$__get__modalidade": {
              url: urlBase + "/imoveis/:id/modalidade",
              method: "GET",
            },

            // INTERNAL. Use Imovel.tipo_locacao() instead.
            "prototype$__get__tipo_locacao": {
              url: urlBase + "/imoveis/:id/tipo_locacao",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views.findById() instead.
            "prototype$__findById__log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views.destroyById() instead.
            "prototype$__destroyById__log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.log_views.updateById() instead.
            "prototype$__updateById__log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.garantias.findById() instead.
            "prototype$__findById__garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.garantias.destroyById() instead.
            "prototype$__destroyById__garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.garantias.updateById() instead.
            "prototype$__updateById__garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.terms_imovel.findById() instead.
            "prototype$__findById__terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.terms_imovel.destroyById() instead.
            "prototype$__destroyById__terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.terms_imovel.updateById() instead.
            "prototype$__updateById__terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.portal_imovel.findById() instead.
            "prototype$__findById__portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.portal_imovel.destroyById() instead.
            "prototype$__destroyById__portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.portal_imovel.updateById() instead.
            "prototype$__updateById__portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.plantas.findById() instead.
            "prototype$__findById__plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.plantas.destroyById() instead.
            "prototype$__destroyById__plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.plantas.updateById() instead.
            "prototype$__updateById__plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.comodidades() instead.
            "prototype$__get__comodidades": {
              isArray: true,
              url: urlBase + "/imoveis/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use Imovel.comodidades.create() instead.
            "prototype$__create__comodidades": {
              url: urlBase + "/imoveis/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use Imovel.comodidades.destroyAll() instead.
            "prototype$__delete__comodidades": {
              url: urlBase + "/imoveis/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.comodidades.count() instead.
            "prototype$__count__comodidades": {
              url: urlBase + "/imoveis/:id/comodidades/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fotos() instead.
            "prototype$__get__fotos": {
              isArray: true,
              url: urlBase + "/imoveis/:id/fotos",
              method: "GET",
            },

            // INTERNAL. Use Imovel.fotos.create() instead.
            "prototype$__create__fotos": {
              url: urlBase + "/imoveis/:id/fotos",
              method: "POST",
            },

            // INTERNAL. Use Imovel.fotos.destroyAll() instead.
            "prototype$__delete__fotos": {
              url: urlBase + "/imoveis/:id/fotos",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.fotos.count() instead.
            "prototype$__count__fotos": {
              url: urlBase + "/imoveis/:id/fotos/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis() instead.
            "prototype$__get__imoveis": {
              isArray: true,
              url: urlBase + "/imoveis/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.create() instead.
            "prototype$__create__imoveis": {
              url: urlBase + "/imoveis/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imovel.imoveis.destroyAll() instead.
            "prototype$__delete__imoveis": {
              url: urlBase + "/imoveis/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.imoveis.count() instead.
            "prototype$__count__imoveis": {
              url: urlBase + "/imoveis/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views() instead.
            "prototype$__get__log_views": {
              isArray: true,
              url: urlBase + "/imoveis/:id/log_views",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views.create() instead.
            "prototype$__create__log_views": {
              url: urlBase + "/imoveis/:id/log_views",
              method: "POST",
            },

            // INTERNAL. Use Imovel.log_views.destroyAll() instead.
            "prototype$__delete__log_views": {
              url: urlBase + "/imoveis/:id/log_views",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.log_views.count() instead.
            "prototype$__count__log_views": {
              url: urlBase + "/imoveis/:id/log_views/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.garantias() instead.
            "prototype$__get__garantias": {
              isArray: true,
              url: urlBase + "/imoveis/:id/garantias",
              method: "GET",
            },

            // INTERNAL. Use Imovel.garantias.create() instead.
            "prototype$__create__garantias": {
              url: urlBase + "/imoveis/:id/garantias",
              method: "POST",
            },

            // INTERNAL. Use Imovel.garantias.destroyAll() instead.
            "prototype$__delete__garantias": {
              url: urlBase + "/imoveis/:id/garantias",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.garantias.count() instead.
            "prototype$__count__garantias": {
              url: urlBase + "/imoveis/:id/garantias/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.terms_imovel() instead.
            "prototype$__get__terms_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.terms_imovel.create() instead.
            "prototype$__create__terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.terms_imovel.destroyAll() instead.
            "prototype$__delete__terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.terms_imovel.count() instead.
            "prototype$__count__terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.portal_imovel() instead.
            "prototype$__get__portal_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.portal_imovel.create() instead.
            "prototype$__create__portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.portal_imovel.destroyAll() instead.
            "prototype$__delete__portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.portal_imovel.count() instead.
            "prototype$__count__portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel/count",
              method: "GET",
            },

            // INTERNAL. Use Imovel.plantas() instead.
            "prototype$__get__plantas": {
              isArray: true,
              url: urlBase + "/imoveis/:id/plantas",
              method: "GET",
            },

            // INTERNAL. Use Imovel.plantas.create() instead.
            "prototype$__create__plantas": {
              url: urlBase + "/imoveis/:id/plantas",
              method: "POST",
            },

            // INTERNAL. Use Imovel.plantas.destroyAll() instead.
            "prototype$__delete__plantas": {
              url: urlBase + "/imoveis/:id/plantas",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.plantas.count() instead.
            "prototype$__count__plantas": {
              url: urlBase + "/imoveis/:id/plantas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#create
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#createMany
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#upsert
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#replaceOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#upsertWithWhere
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#exists
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#replaceById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#find
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findOne
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#updateAll
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#deleteById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#count
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#prototype$updateAttributes
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#createChangeStream
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImovel": {
              isArray: true,
              url: urlBase + "/imoveis/get-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#relacionados
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find relacionados.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "relacionados": {
              isArray: true,
              url: urlBase + "/imoveis-replica/relacionados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#searchRelacionados
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find relacionados.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `cod` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "searchRelacionados": {
              isArray: true,
              url: urlBase + "/imoveis-replica/relacionados/:cod",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#tagsRelacionados
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find relacionados.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `cod` – `{string=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "tagsRelacionados": {
              isArray: true,
              url: urlBase + "/imoveis/tags/:cod",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#buscaRelacionados
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find relacionados.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `query` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "buscaRelacionados": {
              isArray: true,
              url: urlBase + "/imoveis-replica/relacionados/busca",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findByPolygon
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find findByPolygon.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findByPolygon": {
              isArray: true,
              url: urlBase + "/imoveis/find-by-polygon",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImoveis
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImoveis": {
              isArray: true,
              url: urlBase + "/imoveis/get-imoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImoveisCrm
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImoveisCrm": {
              isArray: true,
              url: urlBase + "/imoveis/get-imoveis-crm",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImoveisimob
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImoveisimob": {
              isArray: true,
              url: urlBase + "/imoveis/get-imoveis-imob",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImovelNew
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImovelNew": {
              isArray: true,
              url: urlBase + "/imoveis-replica/get-imovel-new",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImoveisNew
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImoveisNew": {
              isArray: true,
              url: urlBase + "/imoveis-replica/get-imoveis-new",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getDestaques
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getDestaques": {
              url: urlBase + "/imoveis-replica/get-destaques",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findByPolygonNew
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find findByPolygon to New site.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findByPolygonNew": {
              isArray: true,
              url: urlBase + "/imoveis-replica/find-by-polygon-new",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#createImovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "createImovel": {
              url: urlBase + "/imoveis/create-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#updateImovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "updateImovel": {
              url: urlBase + "/imoveis/update-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#editImovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Edit Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "editImovel": {
              url: urlBase + "/imoveis/edit-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#acceptTermsImovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Edit Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "acceptTermsImovel": {
              url: urlBase + "/imoveis/anunciar-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#getImovelUser
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find imoveis by User.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "getImovelUser": {
              url: urlBase + "/imoveis/get-imovel-user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#countCidades
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "countCidades": {
              isArray: true,
              url: urlBase + "/imoveis-replica/count-cidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#cityData
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return our info about cities
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "cityData": {
              isArray: true,
              url: urlBase + "/imoveis/city-data",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#removeDestaques
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "removeDestaques": {
              url: urlBase + "/imoveis/remover-destaques",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#addDestaques
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "addDestaques": {
              url: urlBase + "/imoveis/adicionar-destaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#sendEmailTerms
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "sendEmailTerms": {
              url: urlBase + "/imoveis/send-terms",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#sendTermsList
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "sendTermsList": {
              url: urlBase + "/imoveis/send-terms-list-imv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#topImoveis
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "topImoveis": {
              isArray: true,
              url: urlBase + "/imoveis-replica/topImoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#siteMapRoutesMap
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "siteMapRoutesMap": {
              url: urlBase + "/imoveis/sitemap-map-routes.xml",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#siteMapImov
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Return sitemap
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "siteMapImov": {
              url: urlBase + "/imoveis/sitemap-imovel.xml",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#create
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#createMany
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#upsert
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#replaceOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#upsertWithWhere
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#exists
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#replaceById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#find
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#findOne
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#updateAll
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#deleteById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#count
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#prototype$updateAttributes
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#createChangeStream
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#pager
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#pagerDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#postDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#deleteDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#editDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#autocomplete
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#autocompleteDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#autocompleteDetailEdit
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#autocompleteGeneral
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#crudGET
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#crudGETDetail
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Imovel#quickAdd
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.imoveis.findById() instead.
            "::findById::Proprietario::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis.destroyById() instead.
            "::destroyById::Proprietario::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.imoveis.updateById() instead.
            "::updateById::Proprietario::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.imoveis() instead.
            "::get::Proprietario::imoveis": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.imoveis.create() instead.
            "::create::Proprietario::imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.imoveis.createMany() instead.
            "::createMany::Proprietario::imoveis": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.imoveis.destroyAll() instead.
            "::delete::Proprietario::imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.imoveis.count() instead.
            "::count::Proprietario::imoveis": {
              url: urlBase + "/proprietarios/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis.findById() instead.
            "::findById::Imobiliaria::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis.destroyById() instead.
            "::destroyById::Imobiliaria::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imoveis.updateById() instead.
            "::updateById::Imobiliaria::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.imoveis() instead.
            "::get::Imobiliaria::imoveis": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.imoveis.create() instead.
            "::create::Imobiliaria::imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imoveis.createMany() instead.
            "::createMany::Imobiliaria::imoveis": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.imoveis.destroyAll() instead.
            "::delete::Imobiliaria::imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.imoveis.count() instead.
            "::count::Imobiliaria::imoveis": {
              url: urlBase + "/imobiliarias/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use ImovelFoto.imovel() instead.
            "::get::ImovelFoto::imovel": {
              url: urlBase + "/imovelfotos/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imvempreendimento() instead.
            "::get::Imovel::imvempreendimento": {
              url: urlBase + "/imoveis/:id/imvempreendimento",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.findById() instead.
            "::findById::Imovel::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.destroyById() instead.
            "::destroyById::Imovel::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.imoveis.updateById() instead.
            "::updateById::Imovel::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.imoveis() instead.
            "::get::Imovel::imoveis": {
              isArray: true,
              url: urlBase + "/imoveis/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Imovel.imoveis.create() instead.
            "::create::Imovel::imoveis": {
              url: urlBase + "/imoveis/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imovel.imoveis.createMany() instead.
            "::createMany::Imovel::imoveis": {
              isArray: true,
              url: urlBase + "/imoveis/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Imovel.imoveis.destroyAll() instead.
            "::delete::Imovel::imoveis": {
              url: urlBase + "/imoveis/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.imoveis.count() instead.
            "::count::Imovel::imoveis": {
              url: urlBase + "/imoveis/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.imovel() instead.
            "::get::CardImovel::imovel": {
              url: urlBase + "/cardsimovel/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.imovel() instead.
            "::get::TempCardImovel::imovel": {
              url: urlBase + "/tempcardsimovel/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelViewLog.log_imovel() instead.
            "::get::ImovelViewLog::log_imovel": {
              url: urlBase + "/imovelviewlogs/:id/log_imovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelGarantia.gar_imovel() instead.
            "::get::ImovelGarantia::gar_imovel": {
              url: urlBase + "/imovelgarantias/:id/gar_imovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelTermos.terms_imovel() instead.
            "::get::ImovelTermos::terms_imovel": {
              url: urlBase + "/imovelTermos/:id/terms_imovel",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propImovel() instead.
            "::get::Proposta::propImovel": {
              url: urlBase + "/propostas/:id/propImovel",
              method: "GET",
            },

            // INTERNAL. Use RadarImovelHistorico.imovel() instead.
            "::get::RadarImovelHistorico::imovel": {
              url: urlBase + "/radarimovelhistoricos/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.imoveis() instead.
            "::get::PortalImovel::imoveis": {
              url: urlBase + "/portalimoveis/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use TimeImovel.imovel() instead.
            "::get::TimeImovel::imovel": {
              url: urlBase + "/timeimoveis/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaDestaques.destaque() instead.
            "::get::ImobiliariaDestaques::destaque": {
              url: urlBase + "/imobiliariasDestaques/:id/destaque",
              method: "GET",
            },

            // INTERNAL. Use ImovelPlanta.imovel() instead.
            "::get::ImovelPlanta::imovel": {
              url: urlBase + "/imovelplantas/:id/imovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#updateOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchOrCreateWithWhere
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#update
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#destroyById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#removeById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchAttributes
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#updateOrCreate
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchOrCreateWithWhere
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#update
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#destroyById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#removeById
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Imovel#patchAttributes
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Imovel#modelName
        * @propertyOf lbServices.Imovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Imovel`.
        */
        R.modelName = "Imovel";


            /**
             * @ngdoc method
             * @name lbServices.Imovel#finalidade
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation finalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R.finalidade = function() {
          var TargetResource = $injector.get("Finalidade");
          var action = TargetResource["::get::Imovel::finalidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#categoria_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation categoria_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CategoriaImovel` object.)
             * </em>
             */
        R.categoria_imovel = function() {
          var TargetResource = $injector.get("CategoriaImovel");
          var action = TargetResource["::get::Imovel::categoria_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#fase
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation fase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Fase` object.)
             * </em>
             */
        R.fase = function() {
          var TargetResource = $injector.get("Fase");
          var action = TargetResource["::get::Imovel::fase"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#proprietario
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation proprietario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proprietario` object.)
             * </em>
             */
        R.proprietario = function() {
          var TargetResource = $injector.get("Proprietario");
          var action = TargetResource["::get::Imovel::proprietario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#corretor
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::Imovel::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#imobiliaria
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Imovel::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#empreendimento
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R.empreendimento = function() {
          var TargetResource = $injector.get("Empreendimento");
          var action = TargetResource["::get::Imovel::empreendimento"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.comodidades
     * @header lbServices.Imovel.comodidades
     * @object
     * @description
     *
     * The object `Imovel.comodidades` groups methods
     * manipulating `ImovelComodidade` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#comodidades Imovel.comodidades()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#comodidades
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries comodidades of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R.comodidades = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::get::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#count
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Counts comodidades of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.comodidades.count = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::count::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#create
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R.comodidades.create = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::create::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#createMany
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R.comodidades.createMany = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::createMany::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#destroyAll
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Deletes all comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyAll = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::delete::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#destroyById
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Delete a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyById = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::destroyById::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#findById
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Find a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R.comodidades.findById = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::findById::Imovel::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.comodidades#updateById
             * @methodOf lbServices.Imovel.comodidades
             *
             * @description
             *
             * Update a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelComodidade` object.)
             * </em>
             */
        R.comodidades.updateById = function() {
          var TargetResource = $injector.get("ImovelComodidade");
          var action = TargetResource["::updateById::Imovel::comodidades"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.fotos
     * @header lbServices.Imovel.fotos
     * @object
     * @description
     *
     * The object `Imovel.fotos` groups methods
     * manipulating `ImovelFoto` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#fotos Imovel.fotos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#fotos
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries fotos of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R.fotos = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::get::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#count
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Counts fotos of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.fotos.count = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::count::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#create
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Creates a new instance in fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R.fotos.create = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::create::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#createMany
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Creates a new instance in fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R.fotos.createMany = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::createMany::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#destroyAll
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Deletes all fotos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.fotos.destroyAll = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::delete::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#destroyById
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Delete a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.fotos.destroyById = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::destroyById::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#findById
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Find a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R.fotos.findById = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::findById::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.fotos#updateById
             * @methodOf lbServices.Imovel.fotos
             *
             * @description
             *
             * Update a related item by id for fotos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for fotos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelFoto` object.)
             * </em>
             */
        R.fotos.updateById = function() {
          var TargetResource = $injector.get("ImovelFoto");
          var action = TargetResource["::updateById::Imovel::fotos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#imvempreendimento
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation imvempreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imvempreendimento = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::Imovel::imvempreendimento"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.imoveis
     * @header lbServices.Imovel.imoveis
     * @object
     * @description
     *
     * The object `Imovel.imoveis` groups methods
     * manipulating `Imovel` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#imoveis Imovel.imoveis()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#imoveis
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries imoveis of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#count
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Counts imoveis of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.imoveis.count = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::count::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#create
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.create = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::create::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#createMany
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.createMany = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::createMany::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#destroyAll
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Deletes all imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyAll = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::delete::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#destroyById
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Delete a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::destroyById::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#findById
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Find a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.findById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::findById::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.imoveis#updateById
             * @methodOf lbServices.Imovel.imoveis
             *
             * @description
             *
             * Update a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis.updateById = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::updateById::Imovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#ocupacao
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation ocupacao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R.ocupacao = function() {
          var TargetResource = $injector.get("Ocupacao");
          var action = TargetResource["::get::Imovel::ocupacao"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#padrao_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation padrao_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R.padrao_imovel = function() {
          var TargetResource = $injector.get("PadraoImovel");
          var action = TargetResource["::get::Imovel::padrao_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#padrao_localizacao
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation padrao_localizacao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R.padrao_localizacao = function() {
          var TargetResource = $injector.get("PadraoLocalizacao");
          var action = TargetResource["::get::Imovel::padrao_localizacao"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#status_comercial
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation status_comercial.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R.status_comercial = function() {
          var TargetResource = $injector.get("StatusComercial");
          var action = TargetResource["::get::Imovel::status_comercial"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#subtipo_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation subtipo_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R.subtipo_imovel = function() {
          var TargetResource = $injector.get("SubTipoImovel");
          var action = TargetResource["::get::Imovel::subtipo_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#tipo_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation tipo_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R.tipo_imovel = function() {
          var TargetResource = $injector.get("TipoImovel");
          var action = TargetResource["::get::Imovel::tipo_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#unidade_metrica
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation unidade_metrica.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R.unidade_metrica = function() {
          var TargetResource = $injector.get("UnidadeMetrica");
          var action = TargetResource["::get::Imovel::unidade_metrica"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#midia
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation midia.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R.midia = function() {
          var TargetResource = $injector.get("TipoMidia");
          var action = TargetResource["::get::Imovel::midia"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#tipo_negocio
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation tipo_negocio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.tipo_negocio = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::Imovel::tipo_negocio"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#chave
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation chave.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R.chave = function() {
          var TargetResource = $injector.get("Chave");
          var action = TargetResource["::get::Imovel::chave"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#chave_estara
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation chave_estara.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R.chave_estara = function() {
          var TargetResource = $injector.get("Chave");
          var action = TargetResource["::get::Imovel::chave_estara"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#modalidade
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation modalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R.modalidade = function() {
          var TargetResource = $injector.get("Modalidade");
          var action = TargetResource["::get::Imovel::modalidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel#tipo_locacao
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Fetches belongsTo relation tipo_locacao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R.tipo_locacao = function() {
          var TargetResource = $injector.get("TipoLocacao");
          var action = TargetResource["::get::Imovel::tipo_locacao"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.log_views
     * @header lbServices.Imovel.log_views
     * @object
     * @description
     *
     * The object `Imovel.log_views` groups methods
     * manipulating `ImovelViewLog` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#log_views Imovel.log_views()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#log_views
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries log_views of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R.log_views = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::get::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#count
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Counts log_views of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.log_views.count = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::count::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#create
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Creates a new instance in log_views of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R.log_views.create = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::create::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#createMany
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Creates a new instance in log_views of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R.log_views.createMany = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::createMany::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#destroyAll
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Deletes all log_views of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.log_views.destroyAll = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::delete::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#destroyById
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Delete a related item by id for log_views.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for log_views
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.log_views.destroyById = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::destroyById::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#findById
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Find a related item by id for log_views.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for log_views
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R.log_views.findById = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::findById::Imovel::log_views"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.log_views#updateById
             * @methodOf lbServices.Imovel.log_views
             *
             * @description
             *
             * Update a related item by id for log_views.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for log_views
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R.log_views.updateById = function() {
          var TargetResource = $injector.get("ImovelViewLog");
          var action = TargetResource["::updateById::Imovel::log_views"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.garantias
     * @header lbServices.Imovel.garantias
     * @object
     * @description
     *
     * The object `Imovel.garantias` groups methods
     * manipulating `ImovelGarantia` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#garantias Imovel.garantias()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#garantias
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries garantias of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R.garantias = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::get::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#count
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Counts garantias of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.garantias.count = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::count::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#create
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Creates a new instance in garantias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R.garantias.create = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::create::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#createMany
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Creates a new instance in garantias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R.garantias.createMany = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::createMany::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#destroyAll
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Deletes all garantias of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.garantias.destroyAll = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::delete::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#destroyById
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Delete a related item by id for garantias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for garantias
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.garantias.destroyById = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::destroyById::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#findById
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Find a related item by id for garantias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for garantias
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R.garantias.findById = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::findById::Imovel::garantias"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.garantias#updateById
             * @methodOf lbServices.Imovel.garantias
             *
             * @description
             *
             * Update a related item by id for garantias.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for garantias
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R.garantias.updateById = function() {
          var TargetResource = $injector.get("ImovelGarantia");
          var action = TargetResource["::updateById::Imovel::garantias"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.terms_imovel
     * @header lbServices.Imovel.terms_imovel
     * @object
     * @description
     *
     * The object `Imovel.terms_imovel` groups methods
     * manipulating `ImovelTermos` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#terms_imovel Imovel.terms_imovel()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#terms_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries terms_imovel of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R.terms_imovel = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::get::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#count
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Counts terms_imovel of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.terms_imovel.count = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::count::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#create
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Creates a new instance in terms_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R.terms_imovel.create = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::create::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#createMany
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Creates a new instance in terms_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R.terms_imovel.createMany = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::createMany::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#destroyAll
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Deletes all terms_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.terms_imovel.destroyAll = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::delete::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#destroyById
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Delete a related item by id for terms_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for terms_imovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.terms_imovel.destroyById = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::destroyById::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#findById
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Find a related item by id for terms_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for terms_imovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R.terms_imovel.findById = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::findById::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.terms_imovel#updateById
             * @methodOf lbServices.Imovel.terms_imovel
             *
             * @description
             *
             * Update a related item by id for terms_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for terms_imovel
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R.terms_imovel.updateById = function() {
          var TargetResource = $injector.get("ImovelTermos");
          var action = TargetResource["::updateById::Imovel::terms_imovel"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.portal_imovel
     * @header lbServices.Imovel.portal_imovel
     * @object
     * @description
     *
     * The object `Imovel.portal_imovel` groups methods
     * manipulating `PortalImovel` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#portal_imovel Imovel.portal_imovel()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#portal_imovel
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries portal_imovel of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portal_imovel = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::get::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#count
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Counts portal_imovel of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.portal_imovel.count = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::count::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#create
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Creates a new instance in portal_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portal_imovel.create = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::create::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#createMany
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Creates a new instance in portal_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portal_imovel.createMany = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::createMany::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#destroyAll
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Deletes all portal_imovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portal_imovel.destroyAll = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::delete::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#destroyById
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Delete a related item by id for portal_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portal_imovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portal_imovel.destroyById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::destroyById::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#findById
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Find a related item by id for portal_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portal_imovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portal_imovel.findById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::findById::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.portal_imovel#updateById
             * @methodOf lbServices.Imovel.portal_imovel
             *
             * @description
             *
             * Update a related item by id for portal_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for portal_imovel
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portal_imovel.updateById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::updateById::Imovel::portal_imovel"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Imovel.plantas
     * @header lbServices.Imovel.plantas
     * @object
     * @description
     *
     * The object `Imovel.plantas` groups methods
     * manipulating `ImovelPlanta` instances related to `Imovel`.
     *
     * Call {@link lbServices.Imovel#plantas Imovel.plantas()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Imovel#plantas
             * @methodOf lbServices.Imovel
             *
             * @description
             *
             * Queries plantas of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R.plantas = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::get::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#count
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Counts plantas of Imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.plantas.count = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::count::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#create
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Creates a new instance in plantas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R.plantas.create = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::create::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#createMany
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Creates a new instance in plantas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R.plantas.createMany = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::createMany::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#destroyAll
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Deletes all plantas of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.plantas.destroyAll = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::delete::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#destroyById
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Delete a related item by id for plantas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for plantas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.plantas.destroyById = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::destroyById::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#findById
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Find a related item by id for plantas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for plantas
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R.plantas.findById = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::findById::Imovel::plantas"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Imovel.plantas#updateById
             * @methodOf lbServices.Imovel.plantas
             *
             * @description
             *
             * Update a related item by id for plantas.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Imovel id
             *
             *  - `fk` – `{*}` - Foreign key for plantas
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R.plantas.updateById = function() {
          var TargetResource = $injector.get("ImovelPlanta");
          var action = TargetResource["::updateById::Imovel::plantas"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Ocupacao
 * @header lbServices.Ocupacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Ocupacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Ocupacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/ocupacoes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#create
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ocupacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#createMany
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ocupacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#upsert
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/ocupacoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#replaceOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ocupacoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#upsertWithWhere
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ocupacoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#exists
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ocupacoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#findById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ocupacoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#replaceById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ocupacoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#find
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ocupacoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#findOne
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ocupacoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#updateAll
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ocupacoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#deleteById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ocupacoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#count
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ocupacoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#prototype$updateAttributes
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ocupacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/ocupacoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#createChangeStream
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ocupacoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#create
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/ocupacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#createMany
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/ocupacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#upsert
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/ocupacoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#replaceOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/ocupacoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#upsertWithWhere
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/ocupacoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#exists
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/ocupacoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#findById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/ocupacoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#replaceById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/ocupacoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#find
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/ocupacoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#findOne
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/ocupacoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#updateAll
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/ocupacoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#deleteById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/ocupacoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#count
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/ocupacoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#prototype$updateAttributes
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ocupacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/ocupacoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#createChangeStream
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/ocupacoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#pager
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/ocupacoes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#pagerDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/ocupacoes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#postDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/ocupacoes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#deleteDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/ocupacoes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#editDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/ocupacoes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#autocomplete
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/ocupacoes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#autocompleteDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/ocupacoes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#autocompleteDetailEdit
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/ocupacoes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#autocompleteGeneral
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/ocupacoes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#crudGET
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/ocupacoes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#crudGETDetail
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/ocupacoes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#quickAdd
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/ocupacoes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.ocupacao() instead.
            "::get::Imovel::ocupacao": {
              url: urlBase + "/imoveis/:id/ocupacao",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#updateOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchOrCreateWithWhere
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#update
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#destroyById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#removeById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchAttributes
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ocupacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#updateOrCreate
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchOrCreateWithWhere
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#update
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#destroyById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#removeById
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ocupacao#patchAttributes
             * @methodOf lbServices.Ocupacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ocupacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ocupacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Ocupacao#modelName
        * @propertyOf lbServices.Ocupacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Ocupacao`.
        */
        R.modelName = "Ocupacao";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PadraoImovel
 * @header lbServices.PadraoImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PadraoImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PadraoImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/padraoimoveis/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#create
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/padraoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#createMany
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/padraoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#upsert
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/padraoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#replaceOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/padraoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#upsertWithWhere
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/padraoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#exists
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/padraoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#findById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/padraoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#replaceById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/padraoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#find
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/padraoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#findOne
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/padraoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#updateAll
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/padraoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#deleteById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/padraoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#count
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/padraoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#prototype$updateAttributes
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/padraoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#createChangeStream
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/padraoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#create
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/padraoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#createMany
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/padraoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#upsert
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/padraoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#replaceOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/padraoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#upsertWithWhere
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/padraoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#exists
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/padraoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#findById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/padraoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#replaceById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/padraoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#find
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/padraoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#findOne
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/padraoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#updateAll
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/padraoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#deleteById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/padraoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#count
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/padraoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#prototype$updateAttributes
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/padraoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#createChangeStream
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/padraoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#pager
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/padraoimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#pagerDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/padraoimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#postDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/padraoimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#deleteDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/padraoimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#editDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/padraoimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#autocomplete
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/padraoimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#autocompleteDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/padraoimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#autocompleteDetailEdit
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/padraoimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#autocompleteGeneral
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/padraoimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#crudGET
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/padraoimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#crudGETDetail
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/padraoimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#quickAdd
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/padraoimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.padrao_imovel() instead.
            "::get::Imovel::padrao_imovel": {
              url: urlBase + "/imoveis/:id/padrao_imovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#updateOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#update
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#destroyById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#removeById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchAttributes
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#updateOrCreate
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#update
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#destroyById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#removeById
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoImovel#patchAttributes
             * @methodOf lbServices.PadraoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PadraoImovel#modelName
        * @propertyOf lbServices.PadraoImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PadraoImovel`.
        */
        R.modelName = "PadraoImovel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PadraoLocalizacao
 * @header lbServices.PadraoLocalizacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PadraoLocalizacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PadraoLocalizacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/padraolocalizacoes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#create
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/padraolocalizacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#createMany
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/padraolocalizacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#upsert
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/padraolocalizacoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#replaceOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/padraolocalizacoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#upsertWithWhere
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/padraolocalizacoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#exists
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/padraolocalizacoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#findById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#replaceById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/padraolocalizacoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#find
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/padraolocalizacoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#findOne
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/padraolocalizacoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#updateAll
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/padraolocalizacoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#deleteById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#count
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/padraolocalizacoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#prototype$updateAttributes
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoLocalizacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#createChangeStream
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/padraolocalizacoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#create
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/padraolocalizacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#createMany
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/padraolocalizacoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#upsert
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/padraolocalizacoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#replaceOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/padraolocalizacoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#upsertWithWhere
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/padraolocalizacoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#exists
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/padraolocalizacoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#findById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#replaceById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/padraolocalizacoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#find
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/padraolocalizacoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#findOne
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/padraolocalizacoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#updateAll
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/padraolocalizacoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#deleteById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#count
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/padraolocalizacoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#prototype$updateAttributes
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoLocalizacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/padraolocalizacoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#createChangeStream
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/padraolocalizacoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#pager
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/padraolocalizacoes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#pagerDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/padraolocalizacoes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#postDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/padraolocalizacoes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#deleteDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/padraolocalizacoes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#editDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/padraolocalizacoes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#autocomplete
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/padraolocalizacoes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#autocompleteDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/padraolocalizacoes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#autocompleteDetailEdit
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/padraolocalizacoes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#autocompleteGeneral
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/padraolocalizacoes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#crudGET
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/padraolocalizacoes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#crudGETDetail
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/padraolocalizacoes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#quickAdd
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/padraolocalizacoes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.padrao_localizacao() instead.
            "::get::Imovel::padrao_localizacao": {
              url: urlBase + "/imoveis/:id/padrao_localizacao",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#updateOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchOrCreateWithWhere
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#update
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#destroyById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#removeById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchAttributes
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoLocalizacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#updateOrCreate
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchOrCreateWithWhere
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#update
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#destroyById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#removeById
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PadraoLocalizacao#patchAttributes
             * @methodOf lbServices.PadraoLocalizacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PadraoLocalizacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PadraoLocalizacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PadraoLocalizacao#modelName
        * @propertyOf lbServices.PadraoLocalizacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PadraoLocalizacao`.
        */
        R.modelName = "PadraoLocalizacao";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.StatusComercial
 * @header lbServices.StatusComercial
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `StatusComercial` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "StatusComercial",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/statuscomerciais/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#create
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statuscomerciais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#createMany
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statuscomerciais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#upsert
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statuscomerciais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#replaceOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statuscomerciais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#upsertWithWhere
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statuscomerciais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#exists
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statuscomerciais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#findById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statuscomerciais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#replaceById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statuscomerciais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#find
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statuscomerciais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#findOne
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statuscomerciais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#updateAll
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statuscomerciais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#deleteById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statuscomerciais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#count
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statuscomerciais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#prototype$updateAttributes
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusComercial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statuscomerciais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#createChangeStream
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statuscomerciais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#create
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statuscomerciais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#createMany
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statuscomerciais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#upsert
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statuscomerciais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#replaceOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statuscomerciais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#upsertWithWhere
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statuscomerciais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#exists
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statuscomerciais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#findById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statuscomerciais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#replaceById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statuscomerciais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#find
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statuscomerciais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#findOne
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statuscomerciais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#updateAll
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statuscomerciais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#deleteById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statuscomerciais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#count
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statuscomerciais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#prototype$updateAttributes
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusComercial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statuscomerciais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#createChangeStream
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statuscomerciais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#pager
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/statuscomerciais/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#pagerDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/statuscomerciais/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#postDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/statuscomerciais/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#deleteDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/statuscomerciais/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#editDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/statuscomerciais/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#autocomplete
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/statuscomerciais/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#autocompleteDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/statuscomerciais/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#autocompleteDetailEdit
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/statuscomerciais/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#autocompleteGeneral
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/statuscomerciais/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#crudGET
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/statuscomerciais/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#crudGETDetail
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/statuscomerciais/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#quickAdd
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/statuscomerciais/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.status_comercial() instead.
            "::get::Imovel::status_comercial": {
              url: urlBase + "/imoveis/:id/status_comercial",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#updateOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchOrCreateWithWhere
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#update
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#destroyById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#removeById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchAttributes
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusComercial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#updateOrCreate
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchOrCreateWithWhere
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#update
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#destroyById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#removeById
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusComercial#patchAttributes
             * @methodOf lbServices.StatusComercial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusComercial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusComercial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.StatusComercial#modelName
        * @propertyOf lbServices.StatusComercial
        * @description
        * The name of the model represented by this $resource,
        * i.e. `StatusComercial`.
        */
        R.modelName = "StatusComercial";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SubTipoImovel
 * @header lbServices.SubTipoImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SubTipoImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SubTipoImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/subtipoimoveis/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use SubTipoImovel.subtp_finalidade() instead.
            "prototype$__get__subtp_finalidade": {
              url: urlBase + "/subtipoimoveis/:id/subtp_finalidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#create
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subtipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#createMany
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subtipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#upsert
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/subtipoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#replaceOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subtipoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#upsertWithWhere
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subtipoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#exists
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subtipoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#findById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#replaceById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subtipoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#find
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subtipoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#findOne
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subtipoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#updateAll
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subtipoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#deleteById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#count
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subtipoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#prototype$updateAttributes
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#createChangeStream
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subtipoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#create
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/subtipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#createMany
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/subtipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#upsert
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/subtipoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#replaceOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/subtipoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#upsertWithWhere
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/subtipoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#exists
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/subtipoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#findById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#replaceById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/subtipoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#find
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/subtipoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#findOne
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/subtipoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#updateAll
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/subtipoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#deleteById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#count
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/subtipoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#prototype$updateAttributes
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/subtipoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#createChangeStream
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/subtipoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#pager
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/subtipoimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#pagerDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/subtipoimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#postDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/subtipoimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#deleteDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/subtipoimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#editDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/subtipoimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#autocomplete
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/subtipoimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#autocompleteDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/subtipoimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#autocompleteDetailEdit
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/subtipoimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#autocompleteGeneral
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/subtipoimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#crudGET
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/subtipoimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#crudGETDetail
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/subtipoimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#quickAdd
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/subtipoimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.subtipo_imovel() instead.
            "::get::Imovel::subtipo_imovel": {
              url: urlBase + "/imoveis/:id/subtipo_imovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#updateOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#update
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#destroyById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#removeById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchAttributes
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#updateOrCreate
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#update
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#destroyById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#removeById
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#patchAttributes
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubTipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SubTipoImovel#modelName
        * @propertyOf lbServices.SubTipoImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SubTipoImovel`.
        */
        R.modelName = "SubTipoImovel";


            /**
             * @ngdoc method
             * @name lbServices.SubTipoImovel#subtp_finalidade
             * @methodOf lbServices.SubTipoImovel
             *
             * @description
             *
             * Fetches belongsTo relation subtp_finalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubTipoImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Finalidade` object.)
             * </em>
             */
        R.subtp_finalidade = function() {
          var TargetResource = $injector.get("Finalidade");
          var action = TargetResource["::get::SubTipoImovel::subtp_finalidade"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoFoto
 * @header lbServices.TipoFoto
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoFoto` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoFoto",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tipofotos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#create
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#createMany
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#upsert
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipofotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#replaceOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipofotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#upsertWithWhere
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipofotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#exists
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipofotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#findById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipofotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#replaceById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipofotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#find
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipofotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#findOne
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipofotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#updateAll
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipofotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#deleteById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipofotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#count
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipofotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#prototype$updateAttributes
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipofotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#createChangeStream
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipofotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#create
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#createMany
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipofotos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#upsert
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipofotos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#replaceOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipofotos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#upsertWithWhere
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipofotos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#exists
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipofotos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#findById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipofotos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#replaceById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipofotos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#find
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipofotos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#findOne
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipofotos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#updateAll
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipofotos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#deleteById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipofotos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#count
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipofotos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#prototype$updateAttributes
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipofotos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#createChangeStream
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipofotos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#pager
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tipofotos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#pagerDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tipofotos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#postDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tipofotos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#deleteDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tipofotos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#editDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tipofotos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#autocomplete
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tipofotos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#autocompleteDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tipofotos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#autocompleteDetailEdit
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tipofotos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#autocompleteGeneral
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tipofotos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#crudGET
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tipofotos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#crudGETDetail
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tipofotos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#quickAdd
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tipofotos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use EmpreendimentoFoto.tipo_foto() instead.
            "::get::EmpreendimentoFoto::tipo_foto": {
              url: urlBase + "/empreendimentofotos/:id/tipo_foto",
              method: "GET",
            },

            // INTERNAL. Use ImovelFoto.tipo_foto() instead.
            "::get::ImovelFoto::tipo_foto": {
              url: urlBase + "/imovelfotos/:id/tipo_foto",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#updateOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchOrCreateWithWhere
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#update
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#destroyById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#removeById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchAttributes
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#updateOrCreate
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchOrCreateWithWhere
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#update
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#destroyById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#removeById
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoFoto#patchAttributes
             * @methodOf lbServices.TipoFoto
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoFoto id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoFoto` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoFoto#modelName
        * @propertyOf lbServices.TipoFoto
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoFoto`.
        */
        R.modelName = "TipoFoto";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoImovel
 * @header lbServices.TipoImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tipoimoveis/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#create
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#createMany
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#upsert
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#replaceOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#upsertWithWhere
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#exists
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#findById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#replaceById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#find
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#findOne
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#updateAll
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#deleteById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#count
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#prototype$updateAttributes
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#createChangeStream
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#create
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#createMany
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipoimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#upsert
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipoimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#replaceOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipoimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#upsertWithWhere
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipoimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#exists
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipoimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#findById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipoimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#replaceById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipoimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#find
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipoimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#findOne
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipoimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#updateAll
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipoimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#deleteById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipoimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#count
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipoimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#prototype$updateAttributes
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipoimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#createChangeStream
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipoimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#pager
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tipoimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#pagerDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tipoimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#postDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tipoimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#deleteDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tipoimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#editDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tipoimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#autocomplete
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tipoimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#autocompleteDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tipoimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#autocompleteDetailEdit
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tipoimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#autocompleteGeneral
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tipoimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#crudGET
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tipoimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#crudGETDetail
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tipoimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#quickAdd
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tipoimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.tipo_imovel() instead.
            "::get::Imovel::tipo_imovel": {
              url: urlBase + "/imoveis/:id/tipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidadeOrdenacao.tipoimovel() instead.
            "::get::GrupoComodidadeOrdenacao::tipoimovel": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/tipoimovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelPrioridade.tipo_imovel() instead.
            "::get::ImovelPrioridade::tipo_imovel": {
              url: urlBase + "/imovelprioridades/:id/tipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.tipo_imovel() instead.
            "::get::RadarImovel::tipo_imovel": {
              url: urlBase + "/radarimoveis/:id/tipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use TimeTipoImovel.tipoimovel() instead.
            "::get::TimeTipoImovel::tipoimovel": {
              url: urlBase + "/timetiposimovel/:id/tipoimovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#updateOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#update
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#destroyById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#removeById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchAttributes
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#updateOrCreate
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#update
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#destroyById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#removeById
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoImovel#patchAttributes
             * @methodOf lbServices.TipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoImovel#modelName
        * @propertyOf lbServices.TipoImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoImovel`.
        */
        R.modelName = "TipoImovel";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoEmpreendimento
 * @header lbServices.TipoEmpreendimento
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoEmpreendimento` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoEmpreendimento",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tipoempreendimentos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#create
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipoempreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#createMany
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipoempreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#upsert
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipoempreendimentos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#replaceOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipoempreendimentos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#upsertWithWhere
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipoempreendimentos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#exists
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipoempreendimentos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#findById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#replaceById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipoempreendimentos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#find
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipoempreendimentos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#findOne
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipoempreendimentos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#updateAll
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipoempreendimentos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#deleteById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#count
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipoempreendimentos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#prototype$updateAttributes
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoEmpreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#createChangeStream
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipoempreendimentos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#create
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipoempreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#createMany
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipoempreendimentos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#upsert
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipoempreendimentos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#replaceOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipoempreendimentos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#upsertWithWhere
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipoempreendimentos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#exists
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipoempreendimentos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#findById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#replaceById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipoempreendimentos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#find
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipoempreendimentos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#findOne
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipoempreendimentos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#updateAll
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipoempreendimentos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#deleteById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#count
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipoempreendimentos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#prototype$updateAttributes
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoEmpreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipoempreendimentos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#createChangeStream
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipoempreendimentos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#pager
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tipoempreendimentos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#pagerDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tipoempreendimentos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#postDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tipoempreendimentos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#deleteDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tipoempreendimentos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#editDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tipoempreendimentos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#autocomplete
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tipoempreendimentos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#autocompleteDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tipoempreendimentos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#autocompleteDetailEdit
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tipoempreendimentos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#autocompleteGeneral
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tipoempreendimentos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#crudGET
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tipoempreendimentos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#crudGETDetail
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tipoempreendimentos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#quickAdd
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tipoempreendimentos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.tipo_empreendimento() instead.
            "::get::Empreendimento::tipo_empreendimento": {
              url: urlBase + "/empreendimentos/:id/tipo_empreendimento",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#updateOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchOrCreateWithWhere
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#update
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#destroyById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#removeById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchAttributes
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoEmpreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#updateOrCreate
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchOrCreateWithWhere
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#update
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#destroyById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#removeById
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoEmpreendimento#patchAttributes
             * @methodOf lbServices.TipoEmpreendimento
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoEmpreendimento id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoEmpreendimento` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoEmpreendimento#modelName
        * @propertyOf lbServices.TipoEmpreendimento
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoEmpreendimento`.
        */
        R.modelName = "TipoEmpreendimento";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.UnidadeMetrica
 * @header lbServices.UnidadeMetrica
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `UnidadeMetrica` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "UnidadeMetrica",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/unidademetricas/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#create
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unidademetricas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#createMany
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unidademetricas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#upsert
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unidademetricas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#replaceOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unidademetricas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#upsertWithWhere
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unidademetricas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#exists
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unidademetricas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#findById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unidademetricas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#replaceById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unidademetricas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#find
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unidademetricas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#findOne
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unidademetricas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#updateAll
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unidademetricas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#deleteById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unidademetricas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#count
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unidademetricas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#prototype$updateAttributes
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMetrica id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unidademetricas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#createChangeStream
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unidademetricas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#create
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unidademetricas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#createMany
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unidademetricas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#upsert
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unidademetricas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#replaceOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unidademetricas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#upsertWithWhere
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unidademetricas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#exists
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unidademetricas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#findById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unidademetricas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#replaceById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unidademetricas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#find
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unidademetricas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#findOne
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unidademetricas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#updateAll
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unidademetricas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#deleteById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unidademetricas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#count
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unidademetricas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#prototype$updateAttributes
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMetrica id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unidademetricas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#createChangeStream
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unidademetricas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#pager
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/unidademetricas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#pagerDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/unidademetricas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#postDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/unidademetricas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#deleteDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/unidademetricas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#editDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/unidademetricas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#autocomplete
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/unidademetricas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#autocompleteDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/unidademetricas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#autocompleteDetailEdit
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/unidademetricas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#autocompleteGeneral
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/unidademetricas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#crudGET
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/unidademetricas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#crudGETDetail
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/unidademetricas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#quickAdd
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/unidademetricas/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.unidade_metrica() instead.
            "::get::Imovel::unidade_metrica": {
              url: urlBase + "/imoveis/:id/unidade_metrica",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#updateOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchOrCreateWithWhere
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#update
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#destroyById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#removeById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchAttributes
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMetrica id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#updateOrCreate
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchOrCreateWithWhere
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#update
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#destroyById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#removeById
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.UnidadeMetrica#patchAttributes
             * @methodOf lbServices.UnidadeMetrica
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - UnidadeMetrica id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `UnidadeMetrica` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.UnidadeMetrica#modelName
        * @propertyOf lbServices.UnidadeMetrica
        * @description
        * The name of the model represented by this $resource,
        * i.e. `UnidadeMetrica`.
        */
        R.modelName = "UnidadeMetrica";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoMidia
 * @header lbServices.TipoMidia
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoMidia` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoMidia",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposmidia/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TipoMidia.tpmd_imobiliaria() instead.
            "prototype$__get__tpmd_imobiliaria": {
              url: urlBase + "/tiposmidia/:id/tpmd_imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#create
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposmidia",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#createMany
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposmidia",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#upsert
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposmidia",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#replaceOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposmidia/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#upsertWithWhere
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposmidia/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#exists
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposmidia/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#findById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposmidia/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#replaceById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposmidia/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#find
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposmidia",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#findOne
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposmidia/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#updateAll
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposmidia/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#deleteById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposmidia/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#count
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposmidia/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#prototype$updateAttributes
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoMidia id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposmidia/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#createChangeStream
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposmidia/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#create
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposmidia",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#createMany
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposmidia",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#upsert
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposmidia",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#replaceOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposmidia/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#upsertWithWhere
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposmidia/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#exists
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposmidia/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#findById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposmidia/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#replaceById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposmidia/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#find
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposmidia",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#findOne
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposmidia/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#updateAll
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposmidia/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#deleteById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposmidia/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#count
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposmidia/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#prototype$updateAttributes
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoMidia id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposmidia/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#createChangeStream
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposmidia/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#pager
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposmidia/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#pagerDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposmidia/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#postDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposmidia/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#deleteDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposmidia/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#editDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposmidia/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#autocomplete
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposmidia/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#autocompleteDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposmidia/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#autocompleteDetailEdit
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposmidia/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#autocompleteGeneral
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposmidia/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#crudGET
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposmidia/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#crudGETDetail
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposmidia/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#quickAdd
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposmidia/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.tipoxml() instead.
            "::get::Imobiliaria::tipoxml": {
              url: urlBase + "/imobiliarias/:id/tipoxml",
              method: "GET",
            },

            // INTERNAL. Use Imovel.midia() instead.
            "::get::Imovel::midia": {
              url: urlBase + "/imoveis/:id/midia",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.tipo_midia() instead.
            "::get::ClienteInteressado::tipo_midia": {
              url: urlBase + "/clientesinteressados/:id/tipo_midia",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.midia() instead.
            "::get::CardImovel::midia": {
              url: urlBase + "/cardsimovel/:id/midia",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.midia() instead.
            "::get::TempCardImovel::midia": {
              url: urlBase + "/tempcardsimovel/:id/midia",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#updateOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchOrCreateWithWhere
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#update
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#destroyById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#removeById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchAttributes
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoMidia id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#updateOrCreate
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchOrCreateWithWhere
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#update
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#destroyById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#removeById
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#patchAttributes
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoMidia id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoMidia#modelName
        * @propertyOf lbServices.TipoMidia
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoMidia`.
        */
        R.modelName = "TipoMidia";


            /**
             * @ngdoc method
             * @name lbServices.TipoMidia#tpmd_imobiliaria
             * @methodOf lbServices.TipoMidia
             *
             * @description
             *
             * Fetches belongsTo relation tpmd_imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoMidia id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.tpmd_imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::TipoMidia::tpmd_imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ClienteInteressado
 * @header lbServices.ClienteInteressado
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ClienteInteressado` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ClienteInteressado",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clientesinteressados/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ClienteInteressado.tipo_midia() instead.
            "prototype$__get__tipo_midia": {
              url: urlBase + "/clientesinteressados/:id/tipo_midia",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/clientesinteressados/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/clientesinteressados/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.estado_civil() instead.
            "prototype$__get__estado_civil": {
              url: urlBase + "/clientesinteressados/:id/estado_civil",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/clientesinteressados/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.findById() instead.
            "prototype$__findById__cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.destroyById() instead.
            "prototype$__destroyById__cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.updateById() instead.
            "prototype$__updateById__cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.cards.findById() instead.
            "prototype$__findById__cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards.destroyById() instead.
            "prototype$__destroyById__cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards.updateById() instead.
            "prototype$__updateById__cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.interesse() instead.
            "prototype$__get__interesse": {
              url: urlBase + "/clientesinteressados/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos.findById() instead.
            "prototype$__findById__historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos.destroyById() instead.
            "prototype$__destroyById__historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.historicos.updateById() instead.
            "prototype$__updateById__historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.status_inativo() instead.
            "prototype$__get__status_inativo": {
              url: urlBase + "/clientesinteressados/:id/status_inativo",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/clientesinteressados/:id/time",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cliente_interessado_status() instead.
            "prototype$__get__cliente_interessado_status": {
              url: urlBase + "/clientesinteressados/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades.findById() instead.
            "prototype$__findById__atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades.destroyById() instead.
            "prototype$__destroyById__atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.atividades.updateById() instead.
            "prototype$__updateById__atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.observador.findById() instead.
            "prototype$__findById__observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.observador.destroyById() instead.
            "prototype$__destroyById__observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.observador.updateById() instead.
            "prototype$__updateById__observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/clientesinteressados/:id/telefones/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp() instead.
            "prototype$__get__cards_incorp": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.create() instead.
            "prototype$__create__cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.destroyAll() instead.
            "prototype$__delete__cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.count() instead.
            "prototype$__count__cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards() instead.
            "prototype$__get__cards": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards.create() instead.
            "prototype$__create__cards": {
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards.destroyAll() instead.
            "prototype$__delete__cards": {
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards.count() instead.
            "prototype$__count__cards": {
              url: urlBase + "/clientesinteressados/:id/cards/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos() instead.
            "prototype$__get__historicos": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos.create() instead.
            "prototype$__create__historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.historicos.destroyAll() instead.
            "prototype$__delete__historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.historicos.count() instead.
            "prototype$__count__historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades() instead.
            "prototype$__get__atividades": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades.create() instead.
            "prototype$__create__atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.atividades.destroyAll() instead.
            "prototype$__delete__atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.atividades.count() instead.
            "prototype$__count__atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.observador() instead.
            "prototype$__get__observador": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.observador.create() instead.
            "prototype$__create__observador": {
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.observador.destroyAll() instead.
            "prototype$__delete__observador": {
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.observador.count() instead.
            "prototype$__count__observador": {
              url: urlBase + "/clientesinteressados/:id/observador/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#create
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientesinteressados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#createMany
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientesinteressados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#upsert
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientesinteressados",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#replaceOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientesinteressados/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#upsertWithWhere
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientesinteressados/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#exists
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientesinteressados/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#findById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientesinteressados/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#replaceById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientesinteressados/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#find
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientesinteressados",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#findOne
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientesinteressados/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#updateAll
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientesinteressados/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#deleteById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientesinteressados/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#count
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientesinteressados/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientesinteressados/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#createChangeStream
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientesinteressados/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#autocompleteByImovel
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Autocomplete for imoveis wich clients are interested
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "autocompleteByImovel": {
              url: urlBase + "/clientesinteressados/autocompleteByImovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#LeadExport
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Exports the leads by the filters passed as parameters.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "LeadExport": {
              url: urlBase + "/clientesinteressados/leadexport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#deleteCard
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Exclude cards.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "deleteCard": {
              url: urlBase + "/clientesinteressados/remove-card",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#trocarCorretor
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Trocar o corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "trocarCorretor": {
              url: urlBase + "/clientesinteressados/trocar-corretor",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#create
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientesinteressados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#createMany
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientesinteressados",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#upsert
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientesinteressados",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#replaceOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientesinteressados/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#upsertWithWhere
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientesinteressados/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#exists
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientesinteressados/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#findById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientesinteressados/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#replaceById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientesinteressados/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#find
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientesinteressados",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#findOne
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientesinteressados/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#updateAll
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientesinteressados/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#deleteById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientesinteressados/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#count
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientesinteressados/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientesinteressados/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#createChangeStream
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientesinteressados/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#pager
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clientesinteressados/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#pagerDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clientesinteressados/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#postDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clientesinteressados/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#deleteDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clientesinteressados/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#editDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clientesinteressados/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#autocomplete
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clientesinteressados/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#autocompleteDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clientesinteressados/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#autocompleteDetailEdit
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clientesinteressados/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#autocompleteGeneral
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clientesinteressados/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#crudGET
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clientesinteressados/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#crudGETDetail
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clientesinteressados/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#quickAdd
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clientesinteressados/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Card.cliente_interessado() instead.
            "::get::Card::cliente_interessado": {
              url: urlBase + "/cards/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.cliente_interessado() instead.
            "::get::CardImovel::cliente_interessado": {
              url: urlBase + "/cardsimovel/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado() instead.
            "::get::ClienteInteressadoAtividade::cliente_interessado": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use AvaliacaoCorretor.cliente() instead.
            "::get::AvaliacaoCorretor::cliente": {
              url: urlBase + "/avaliarcorretor/:id/cliente",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoObservador.lead() instead.
            "::get::ClienteInteressadoObservador::lead": {
              url: urlBase + "/clientesinteressadoObservadores/:id/lead",
              method: "GET",
            },

            // INTERNAL. Use BifurcadorLog.clienteinteressado() instead.
            "::get::BifurcadorLog::clienteinteressado": {
              url: urlBase + "/bifurcadorlogs/:id/clienteinteressado",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos.findById() instead.
            "::findById::Cliente::atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos.destroyById() instead.
            "::destroyById::Cliente::atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Cliente.atendimentos.updateById() instead.
            "::updateById::Cliente::atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Cliente.atendimentos() instead.
            "::get::Cliente::atendimentos": {
              isArray: true,
              url: urlBase + "/clientes/:id/atendimentos",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos.create() instead.
            "::create::Cliente::atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos",
              method: "POST",
            },

            // INTERNAL. Use Cliente.atendimentos.createMany() instead.
            "::createMany::Cliente::atendimentos": {
              isArray: true,
              url: urlBase + "/clientes/:id/atendimentos",
              method: "POST",
            },

            // INTERNAL. Use Cliente.atendimentos.destroyAll() instead.
            "::delete::Cliente::atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos",
              method: "DELETE",
            },

            // INTERNAL. Use Cliente.atendimentos.count() instead.
            "::count::Cliente::atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos/count",
              method: "GET",
            },

            // INTERNAL. Use CampanhaLead.cliente() instead.
            "::get::CampanhaLead::cliente": {
              url: urlBase + "/campanhasleads/:id/cliente",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#updateOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#update
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#destroyById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#removeById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchAttributes
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#updateOrCreate
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#update
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#destroyById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#removeById
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#patchAttributes
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ClienteInteressado#modelName
        * @propertyOf lbServices.ClienteInteressado
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ClienteInteressado`.
        */
        R.modelName = "ClienteInteressado";


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#tipo_midia
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation tipo_midia.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R.tipo_midia = function() {
          var TargetResource = $injector.get("TipoMidia");
          var action = TargetResource["::get::ClienteInteressado::tipo_midia"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#corretor
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::ClienteInteressado::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#empresa
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::ClienteInteressado::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#estado_civil
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation estado_civil.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EstadoCivil` object.)
             * </em>
             */
        R.estado_civil = function() {
          var TargetResource = $injector.get("EstadoCivil");
          var action = TargetResource["::get::ClienteInteressado::estado_civil"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#imobiliaria
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ClienteInteressado::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.telefones
     * @header lbServices.ClienteInteressado.telefones
     * @object
     * @description
     *
     * The object `ClienteInteressado.telefones` groups methods
     * manipulating `Telefone` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#telefones ClienteInteressado.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#telefones
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries telefones of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#count
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Counts telefones of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#create
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#createMany
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#destroyAll
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#destroyById
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#findById
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.telefones#updateById
             * @methodOf lbServices.ClienteInteressado.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::ClienteInteressado::telefones"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.cards_incorp
     * @header lbServices.ClienteInteressado.cards_incorp
     * @object
     * @description
     *
     * The object `ClienteInteressado.cards_incorp` groups methods
     * manipulating `Card` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#cards_incorp ClienteInteressado.cards_incorp()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#cards_incorp
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries cards_incorp of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.cards_incorp = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::get::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#count
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Counts cards_incorp of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cards_incorp.count = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::count::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#create
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Creates a new instance in cards_incorp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.cards_incorp.create = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::create::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#createMany
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Creates a new instance in cards_incorp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.cards_incorp.createMany = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::createMany::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#destroyAll
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Deletes all cards_incorp of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cards_incorp.destroyAll = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::delete::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#destroyById
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Delete a related item by id for cards_incorp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cards_incorp
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cards_incorp.destroyById = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::destroyById::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#findById
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Find a related item by id for cards_incorp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cards_incorp
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.cards_incorp.findById = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::findById::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards_incorp#updateById
             * @methodOf lbServices.ClienteInteressado.cards_incorp
             *
             * @description
             *
             * Update a related item by id for cards_incorp.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for cards_incorp
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.cards_incorp.updateById = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::updateById::ClienteInteressado::cards_incorp"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.cards
     * @header lbServices.ClienteInteressado.cards
     * @object
     * @description
     *
     * The object `ClienteInteressado.cards` groups methods
     * manipulating `CardImovel` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#cards ClienteInteressado.cards()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#cards
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries cards of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#count
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Counts cards of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cards.count = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::count::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#create
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Creates a new instance in cards of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards.create = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::create::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#createMany
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Creates a new instance in cards of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards.createMany = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::createMany::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#destroyAll
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Deletes all cards of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cards.destroyAll = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::delete::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#destroyById
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Delete a related item by id for cards.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cards
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cards.destroyById = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::destroyById::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#findById
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Find a related item by id for cards.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cards
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards.findById = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::findById::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.cards#updateById
             * @methodOf lbServices.ClienteInteressado.cards
             *
             * @description
             *
             * Update a related item by id for cards.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for cards
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards.updateById = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::updateById::ClienteInteressado::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#interesse
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::ClienteInteressado::interesse"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.historicos
     * @header lbServices.ClienteInteressado.historicos
     * @object
     * @description
     *
     * The object `ClienteInteressado.historicos` groups methods
     * manipulating `HistoricoClienteInteressado` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#historicos ClienteInteressado.historicos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#historicos
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries historicos of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historicos = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::get::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#count
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Counts historicos of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.historicos.count = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::count::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#create
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Creates a new instance in historicos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historicos.create = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::create::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#createMany
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Creates a new instance in historicos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historicos.createMany = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::createMany::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#destroyAll
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Deletes all historicos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historicos.destroyAll = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::delete::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#destroyById
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Delete a related item by id for historicos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for historicos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historicos.destroyById = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::destroyById::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#findById
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Find a related item by id for historicos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for historicos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historicos.findById = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::findById::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.historicos#updateById
             * @methodOf lbServices.ClienteInteressado.historicos
             *
             * @description
             *
             * Update a related item by id for historicos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for historicos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historicos.updateById = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::updateById::ClienteInteressado::historicos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#status_inativo
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation status_inativo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R.status_inativo = function() {
          var TargetResource = $injector.get("StatusInativo");
          var action = TargetResource["::get::ClienteInteressado::status_inativo"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#time
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::ClienteInteressado::time"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#cliente_interessado_status
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado_status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::get::ClienteInteressado::cliente_interessado_status"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.atividades
     * @header lbServices.ClienteInteressado.atividades
     * @object
     * @description
     *
     * The object `ClienteInteressado.atividades` groups methods
     * manipulating `ClienteInteressadoAtividade` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#atividades ClienteInteressado.atividades()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#atividades
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries atividades of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R.atividades = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::get::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#count
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Counts atividades of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.atividades.count = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::count::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#create
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Creates a new instance in atividades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R.atividades.create = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::create::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#createMany
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Creates a new instance in atividades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R.atividades.createMany = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::createMany::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#destroyAll
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Deletes all atividades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.atividades.destroyAll = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::delete::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#destroyById
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Delete a related item by id for atividades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for atividades
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.atividades.destroyById = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::destroyById::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#findById
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Find a related item by id for atividades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for atividades
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R.atividades.findById = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::findById::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.atividades#updateById
             * @methodOf lbServices.ClienteInteressado.atividades
             *
             * @description
             *
             * Update a related item by id for atividades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for atividades
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R.atividades.updateById = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividade");
          var action = TargetResource["::updateById::ClienteInteressado::atividades"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressado.observador
     * @header lbServices.ClienteInteressado.observador
     * @object
     * @description
     *
     * The object `ClienteInteressado.observador` groups methods
     * manipulating `ClienteInteressadoObservador` instances related to `ClienteInteressado`.
     *
     * Call {@link lbServices.ClienteInteressado#observador ClienteInteressado.observador()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado#observador
             * @methodOf lbServices.ClienteInteressado
             *
             * @description
             *
             * Queries observador of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R.observador = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::get::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#count
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Counts observador of ClienteInteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.observador.count = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::count::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#create
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Creates a new instance in observador of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R.observador.create = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::create::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#createMany
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Creates a new instance in observador of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R.observador.createMany = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::createMany::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#destroyAll
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Deletes all observador of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.observador.destroyAll = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::delete::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#destroyById
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Delete a related item by id for observador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for observador
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.observador.destroyById = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::destroyById::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#findById
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Find a related item by id for observador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for observador
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R.observador.findById = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::findById::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressado.observador#updateById
             * @methodOf lbServices.ClienteInteressado.observador
             *
             * @description
             *
             * Update a related item by id for observador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressado id
             *
             *  - `fk` – `{*}` - Foreign key for observador
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R.observador.updateById = function() {
          var TargetResource = $injector.get("ClienteInteressadoObservador");
          var action = TargetResource["::updateById::ClienteInteressado::observador"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Card
 * @header lbServices.Card
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Card` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Card",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cards/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Card.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/cards/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use Card.empreendimento() instead.
            "prototype$__get__empreendimento": {
              url: urlBase + "/cards/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use Card.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/cards/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use Card.cliente_interessado() instead.
            "prototype$__get__cliente_interessado": {
              url: urlBase + "/cards/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use Card.plantao() instead.
            "prototype$__get__plantao": {
              url: urlBase + "/cards/:id/plantao",
              method: "GET",
            },

            // INTERNAL. Use Card.status() instead.
            "prototype$__get__status": {
              url: urlBase + "/cards/:id/status",
              method: "GET",
            },

            // INTERNAL. Use Card.cardchatbot() instead.
            "prototype$__get__cardchatbot": {
              url: urlBase + "/cards/:id/cardchatbot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#create
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#createMany
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#upsert
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cards",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#replaceOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cards/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#upsertWithWhere
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cards/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#exists
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cards/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#findById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cards/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#replaceById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cards/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#find
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cards",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#findOne
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cards/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#updateAll
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cards/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#deleteById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cards/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#count
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cards/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#prototype$updateAttributes
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cards/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#createChangeStream
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cards/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#create
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#createMany
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#upsert
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cards",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#replaceOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cards/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#upsertWithWhere
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cards/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#exists
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cards/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#findById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cards/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#replaceById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cards/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#find
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cards",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#findOne
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cards/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#updateAll
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cards/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#deleteById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cards/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#count
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cards/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#prototype$updateAttributes
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cards/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#createChangeStream
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cards/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#pager
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/cards/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#pagerDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/cards/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#postDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/cards/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#deleteDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/cards/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#editDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/cards/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#autocomplete
             * @methodOf lbServices.Card
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/cards/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#autocompleteDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/cards/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#autocompleteDetailEdit
             * @methodOf lbServices.Card
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/cards/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#autocompleteGeneral
             * @methodOf lbServices.Card
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/cards/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#crudGET
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/cards/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#crudGETDetail
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/cards/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Card#quickAdd
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/cards/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.findById() instead.
            "::findById::ClienteInteressado::cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.destroyById() instead.
            "::destroyById::ClienteInteressado::cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.updateById() instead.
            "::updateById::ClienteInteressado::cards_incorp": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards_incorp/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp() instead.
            "::get::ClienteInteressado::cards_incorp": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.create() instead.
            "::create::ClienteInteressado::cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.createMany() instead.
            "::createMany::ClienteInteressado::cards_incorp": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.destroyAll() instead.
            "::delete::ClienteInteressado::cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards_incorp.count() instead.
            "::count::ClienteInteressado::cards_incorp": {
              url: urlBase + "/clientesinteressados/:id/cards_incorp/count",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.card() instead.
            "::get::Ligacao::card": {
              url: urlBase + "/call/:id/card",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Card#patchOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Card#updateOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Card#patchOrCreateWithWhere
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Card#update
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Card#destroyById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Card#removeById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Card#patchAttributes
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Card#patchOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Card#updateOrCreate
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Card#patchOrCreateWithWhere
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Card#update
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Card#destroyById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Card#removeById
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Card#patchAttributes
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Card#modelName
        * @propertyOf lbServices.Card
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Card`.
        */
        R.modelName = "Card";


            /**
             * @ngdoc method
             * @name lbServices.Card#empresa
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::Card::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#empreendimento
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R.empreendimento = function() {
          var TargetResource = $injector.get("Empreendimento");
          var action = TargetResource["::get::Card::empreendimento"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#corretor
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::Card::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#cliente_interessado
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.cliente_interessado = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::Card::cliente_interessado"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#plantao
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation plantao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R.plantao = function() {
          var TargetResource = $injector.get("Plantao");
          var action = TargetResource["::get::Card::plantao"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#status
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R.status = function() {
          var TargetResource = $injector.get("StatusCard");
          var action = TargetResource["::get::Card::status"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Card#cardchatbot
             * @methodOf lbServices.Card
             *
             * @description
             *
             * Fetches belongsTo relation cardchatbot.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Card id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R.cardchatbot = function() {
          var TargetResource = $injector.get("CardChatbot");
          var action = TargetResource["::get::Card::cardchatbot"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CardImovel
 * @header lbServices.CardImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CardImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CardImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cardsimovel/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CardImovel.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/cardsimovel/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/cardsimovel/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.empreendimento() instead.
            "prototype$__get__empreendimento": {
              url: urlBase + "/cardsimovel/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.midia() instead.
            "prototype$__get__midia": {
              url: urlBase + "/cardsimovel/:id/midia",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/cardsimovel/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/cardsimovel/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.cliente_interessado() instead.
            "prototype$__get__cliente_interessado": {
              url: urlBase + "/cardsimovel/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.cardchatbot() instead.
            "prototype$__get__cardchatbot": {
              url: urlBase + "/cardsimovel/:id/cardchatbot",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats.findById() instead.
            "prototype$__findById__ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats.destroyById() instead.
            "prototype$__destroyById__ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CardImovel.ackWhats.updateById() instead.
            "prototype$__updateById__ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CardImovel.campanha() instead.
            "prototype$__get__campanha": {
              url: urlBase + "/cardsimovel/:id/campanha",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats() instead.
            "prototype$__get__ackWhats": {
              isArray: true,
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats.create() instead.
            "prototype$__create__ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "POST",
            },

            // INTERNAL. Use CardImovel.ackWhats.destroyAll() instead.
            "prototype$__delete__ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "DELETE",
            },

            // INTERNAL. Use CardImovel.ackWhats.count() instead.
            "prototype$__count__ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#create
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#createMany
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#upsert
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardsimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#replaceOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardsimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#upsertWithWhere
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardsimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#exists
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardsimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#findById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardsimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#replaceById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardsimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#find
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardsimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#findOne
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardsimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#updateAll
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardsimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#deleteById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardsimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#count
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardsimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#prototype$updateAttributes
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardsimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#createChangeStream
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardsimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#saveCardSite
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Receive email and save
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "saveCardSite": {
              url: urlBase + "/cardsimovel/save-card-site",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#verificaUsuarioLead
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Verify if user in lead is already on system
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "verificaUsuarioLead": {
              url: urlBase + "/cardsimovel/verificaUsuarioLead",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#saveCardImovel
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Receive an imovel card and save
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "saveCardImovel": {
              url: urlBase + "/cardsimovel/save-card-imovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#createLeadScriptCsv
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "createLeadScriptCsv": {
              url: urlBase + "/cardsimovel/create-lead-script-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#sendEmail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Receive an imovel card and save
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `body` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "sendEmail": {
              url: urlBase + "/cardsimovel/send-email",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#cardImovelImbNull
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * update only imb on raw query
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `body` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "cardImovelImbNull": {
              url: urlBase + "/cardsimovel/update-card-imb-null",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#cardImovelSoftDelele
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * update only imb on raw query
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `body` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "cardImovelSoftDelele": {
              url: urlBase + "/cardsimovel/card-imovel-soft-delete",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#sendWhatsapp
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Receive an imovel card and save
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "sendWhatsapp": {
              url: urlBase + "/cardsimovel/send-whatsapp",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#changeTeamType
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Search on graph
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `query` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "changeTeamType": {
              url: urlBase + "/cardsimovel/foward-team",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#create
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#createMany
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#upsert
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardsimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#replaceOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardsimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#upsertWithWhere
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardsimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#exists
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardsimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#findById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardsimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#replaceById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardsimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#find
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardsimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#findOne
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardsimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#updateAll
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardsimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#deleteById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardsimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#count
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardsimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#prototype$updateAttributes
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardsimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#createChangeStream
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardsimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#pager
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/cardsimovel/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#pagerDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/cardsimovel/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#postDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/cardsimovel/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#deleteDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/cardsimovel/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#editDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/cardsimovel/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#autocomplete
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/cardsimovel/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#autocompleteDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/cardsimovel/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#autocompleteDetailEdit
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/cardsimovel/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#autocompleteGeneral
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/cardsimovel/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#crudGET
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/cardsimovel/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#crudGETDetail
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/cardsimovel/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#quickAdd
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/cardsimovel/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards.findById() instead.
            "::findById::ClienteInteressado::cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards.destroyById() instead.
            "::destroyById::ClienteInteressado::cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards.updateById() instead.
            "::updateById::ClienteInteressado::cards": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/cards/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.cards() instead.
            "::get::ClienteInteressado::cards": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.cards.create() instead.
            "::create::ClienteInteressado::cards": {
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards.createMany() instead.
            "::createMany::ClienteInteressado::cards": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cards.destroyAll() instead.
            "::delete::ClienteInteressado::cards": {
              url: urlBase + "/clientesinteressados/:id/cards",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.cards.count() instead.
            "::count::ClienteInteressado::cards": {
              url: urlBase + "/clientesinteressados/:id/cards/count",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.card() instead.
            "::get::RadarImovel::card": {
              url: urlBase + "/radarimoveis/:id/card",
              method: "GET",
            },

            // INTERNAL. Use CardImovelWhatsAck.lead() instead.
            "::get::CardImovelWhatsAck::lead": {
              url: urlBase + "/cardimovelwhatsacks/:id/lead",
              method: "GET",
            },

            // INTERNAL. Use TimeHistorico.cards() instead.
            "::get::TimeHistorico::cards": {
              url: urlBase + "/timehistoricos/:id/cards",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.card() instead.
            "::get::ClienteInteressadoAtividade::card": {
              url: urlBase + "/clienteinteressadoatividades/:id/card",
              method: "GET",
            },

            // INTERNAL. Use BifurcadorLog.card() instead.
            "::get::BifurcadorLog::card": {
              url: urlBase + "/bifurcadorlogs/:id/card",
              method: "GET",
            },

            // INTERNAL. Use CampanhaLead.card() instead.
            "::get::CampanhaLead::card": {
              url: urlBase + "/campanhasleads/:id/card",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#updateOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchOrCreateWithWhere
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#update
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#destroyById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#removeById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchAttributes
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#updateOrCreate
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchOrCreateWithWhere
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#update
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#destroyById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#removeById
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#patchAttributes
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CardImovel#modelName
        * @propertyOf lbServices.CardImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CardImovel`.
        */
        R.modelName = "CardImovel";


            /**
             * @ngdoc method
             * @name lbServices.CardImovel#empresa
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::CardImovel::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#imovel
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::CardImovel::imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#empreendimento
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R.empreendimento = function() {
          var TargetResource = $injector.get("Empreendimento");
          var action = TargetResource["::get::CardImovel::empreendimento"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#midia
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation midia.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R.midia = function() {
          var TargetResource = $injector.get("TipoMidia");
          var action = TargetResource["::get::CardImovel::midia"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#imobiliaria
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::CardImovel::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#corretor
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::CardImovel::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#cliente_interessado
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.cliente_interessado = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::CardImovel::cliente_interessado"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#cardchatbot
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation cardchatbot.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R.cardchatbot = function() {
          var TargetResource = $injector.get("CardChatbot");
          var action = TargetResource["::get::CardImovel::cardchatbot"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.CardImovel.ackWhats
     * @header lbServices.CardImovel.ackWhats
     * @object
     * @description
     *
     * The object `CardImovel.ackWhats` groups methods
     * manipulating `CardImovelWhatsAck` instances related to `CardImovel`.
     *
     * Call {@link lbServices.CardImovel#ackWhats CardImovel.ackWhats()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.CardImovel#ackWhats
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Queries ackWhats of CardImovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R.ackWhats = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::get::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#count
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Counts ackWhats of CardImovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.ackWhats.count = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::count::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#create
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Creates a new instance in ackWhats of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R.ackWhats.create = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::create::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#createMany
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Creates a new instance in ackWhats of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R.ackWhats.createMany = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::createMany::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#destroyAll
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Deletes all ackWhats of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ackWhats.destroyAll = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::delete::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#destroyById
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Delete a related item by id for ackWhats.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for ackWhats
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ackWhats.destroyById = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::destroyById::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#findById
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Find a related item by id for ackWhats.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for ackWhats
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R.ackWhats.findById = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::findById::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel.ackWhats#updateById
             * @methodOf lbServices.CardImovel.ackWhats
             *
             * @description
             *
             * Update a related item by id for ackWhats.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `fk` – `{*}` - Foreign key for ackWhats
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R.ackWhats.updateById = function() {
          var TargetResource = $injector.get("CardImovelWhatsAck");
          var action = TargetResource["::updateById::CardImovel::ackWhats"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CardImovel#campanha
             * @methodOf lbServices.CardImovel
             *
             * @description
             *
             * Fetches belongsTo relation campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovel id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R.campanha = function() {
          var TargetResource = $injector.get("Campanha");
          var action = TargetResource["::get::CardImovel::campanha"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Plantao
 * @header lbServices.Plantao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Plantao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Plantao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/plantoes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Plantao.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/plantoes/:id/imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#create
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/plantoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#createMany
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/plantoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#upsert
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/plantoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#replaceOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/plantoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#upsertWithWhere
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/plantoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#exists
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/plantoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#findById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/plantoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#replaceById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/plantoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#find
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/plantoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#findOne
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/plantoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#updateAll
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/plantoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#deleteById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/plantoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#count
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/plantoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#prototype$updateAttributes
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Plantao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/plantoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#createChangeStream
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/plantoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#create
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/plantoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#createMany
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/plantoes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#upsert
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/plantoes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#replaceOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/plantoes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#upsertWithWhere
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/plantoes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#exists
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/plantoes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#findById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/plantoes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#replaceById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/plantoes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#find
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/plantoes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#findOne
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/plantoes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#updateAll
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/plantoes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#deleteById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/plantoes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#count
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/plantoes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#prototype$updateAttributes
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Plantao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/plantoes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#createChangeStream
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/plantoes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#pager
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/plantoes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#pagerDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/plantoes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#postDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/plantoes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#deleteDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/plantoes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#editDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/plantoes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#autocomplete
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/plantoes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#autocompleteDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/plantoes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#autocompleteDetailEdit
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/plantoes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#autocompleteGeneral
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/plantoes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#crudGET
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/plantoes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#crudGETDetail
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/plantoes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Plantao#quickAdd
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/plantoes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Card.plantao() instead.
            "::get::Card::plantao": {
              url: urlBase + "/cards/:id/plantao",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.plantao() instead.
            "::get::TempCardImovel::plantao": {
              url: urlBase + "/tempcardsimovel/:id/plantao",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#updateOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchOrCreateWithWhere
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#update
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#destroyById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#removeById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchAttributes
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Plantao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#updateOrCreate
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchOrCreateWithWhere
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#update
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#destroyById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#removeById
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Plantao#patchAttributes
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Plantao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Plantao#modelName
        * @propertyOf lbServices.Plantao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Plantao`.
        */
        R.modelName = "Plantao";


            /**
             * @ngdoc method
             * @name lbServices.Plantao#imobiliaria
             * @methodOf lbServices.Plantao
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Plantao id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Plantao::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Faq
 * @header lbServices.Faq
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Faq` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Faq",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/faqs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Faq.tipo_pergunta() instead.
            "prototype$__get__tipo_pergunta": {
              url: urlBase + "/faqs/:id/tipo_pergunta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#create
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/faqs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#createMany
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/faqs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#upsert
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/faqs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#replaceOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/faqs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#upsertWithWhere
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/faqs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#exists
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/faqs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#findById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/faqs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#replaceById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/faqs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#find
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/faqs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#findOne
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/faqs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#updateAll
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/faqs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#deleteById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/faqs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#count
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/faqs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#prototype$updateAttributes
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Faq id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/faqs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#createChangeStream
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/faqs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#create
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/faqs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#createMany
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/faqs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#upsert
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/faqs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#replaceOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/faqs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#upsertWithWhere
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/faqs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#exists
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/faqs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#findById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/faqs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#replaceById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/faqs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#find
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/faqs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#findOne
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/faqs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#updateAll
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/faqs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#deleteById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/faqs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#count
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/faqs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#prototype$updateAttributes
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Faq id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/faqs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#createChangeStream
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/faqs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#pager
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/faqs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#pagerDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/faqs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#postDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/faqs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#deleteDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/faqs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#editDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/faqs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#autocomplete
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/faqs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#autocompleteDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/faqs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#autocompleteDetailEdit
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/faqs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#autocompleteGeneral
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/faqs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#crudGET
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/faqs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#crudGETDetail
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/faqs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Faq#quickAdd
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/faqs/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Faq#patchOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#updateOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#patchOrCreateWithWhere
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#update
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#destroyById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#removeById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#patchAttributes
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Faq id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#patchOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#updateOrCreate
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#patchOrCreateWithWhere
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#update
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#destroyById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#removeById
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Faq#patchAttributes
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Faq id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Faq` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Faq#modelName
        * @propertyOf lbServices.Faq
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Faq`.
        */
        R.modelName = "Faq";


            /**
             * @ngdoc method
             * @name lbServices.Faq#tipo_pergunta
             * @methodOf lbServices.Faq
             *
             * @description
             *
             * Fetches belongsTo relation tipo_pergunta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Faq id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R.tipo_pergunta = function() {
          var TargetResource = $injector.get("TipoPergunta");
          var action = TargetResource["::get::Faq::tipo_pergunta"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoPergunta
 * @header lbServices.TipoPergunta
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoPergunta` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoPergunta",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tipospergunta/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#create
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipospergunta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#createMany
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipospergunta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#upsert
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipospergunta",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#replaceOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipospergunta/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#upsertWithWhere
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipospergunta/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#exists
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipospergunta/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#findById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipospergunta/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#replaceById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipospergunta/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#find
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipospergunta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#findOne
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipospergunta/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#updateAll
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipospergunta/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#deleteById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipospergunta/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#count
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipospergunta/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#prototype$updateAttributes
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoPergunta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipospergunta/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#createChangeStream
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipospergunta/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#create
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tipospergunta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#createMany
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tipospergunta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#upsert
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tipospergunta",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#replaceOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tipospergunta/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#upsertWithWhere
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tipospergunta/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#exists
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tipospergunta/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#findById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tipospergunta/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#replaceById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tipospergunta/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#find
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tipospergunta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#findOne
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tipospergunta/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#updateAll
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tipospergunta/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#deleteById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tipospergunta/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#count
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tipospergunta/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#prototype$updateAttributes
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoPergunta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tipospergunta/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#createChangeStream
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tipospergunta/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#pager
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tipospergunta/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#pagerDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tipospergunta/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#postDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tipospergunta/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#deleteDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tipospergunta/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#editDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tipospergunta/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#autocomplete
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tipospergunta/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#autocompleteDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tipospergunta/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#autocompleteDetailEdit
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tipospergunta/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#autocompleteGeneral
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tipospergunta/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#crudGET
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tipospergunta/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#crudGETDetail
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tipospergunta/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#quickAdd
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tipospergunta/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Faq.tipo_pergunta() instead.
            "::get::Faq::tipo_pergunta": {
              url: urlBase + "/faqs/:id/tipo_pergunta",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#updateOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchOrCreateWithWhere
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#update
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#destroyById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#removeById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchAttributes
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoPergunta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#updateOrCreate
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchOrCreateWithWhere
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#update
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#destroyById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#removeById
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoPergunta#patchAttributes
             * @methodOf lbServices.TipoPergunta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoPergunta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoPergunta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoPergunta#modelName
        * @propertyOf lbServices.TipoPergunta
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoPergunta`.
        */
        R.modelName = "TipoPergunta";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TelefoneCliente
 * @header lbServices.TelefoneCliente
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TelefoneCliente` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TelefoneCliente",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/telefonescliente/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TelefoneCliente.telefone_tipo() instead.
            "prototype$__get__telefone_tipo": {
              url: urlBase + "/telefonescliente/:id/telefone_tipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#create
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefonescliente",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#createMany
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefonescliente",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#upsert
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefonescliente",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#replaceOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefonescliente/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#upsertWithWhere
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefonescliente/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#exists
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefonescliente/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#findById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefonescliente/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#replaceById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefonescliente/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#find
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefonescliente",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#findOne
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefonescliente/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#updateAll
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefonescliente/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#deleteById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefonescliente/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#count
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefonescliente/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#prototype$updateAttributes
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneCliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefonescliente/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#createChangeStream
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefonescliente/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#create
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/telefonescliente",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#createMany
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/telefonescliente",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#upsert
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/telefonescliente",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#replaceOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/telefonescliente/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#upsertWithWhere
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/telefonescliente/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#exists
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/telefonescliente/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#findById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/telefonescliente/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#replaceById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/telefonescliente/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#find
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/telefonescliente",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#findOne
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/telefonescliente/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#updateAll
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/telefonescliente/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#deleteById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/telefonescliente/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#count
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/telefonescliente/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#prototype$updateAttributes
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneCliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/telefonescliente/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#createChangeStream
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/telefonescliente/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#pager
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/telefonescliente/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#pagerDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/telefonescliente/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#postDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/telefonescliente/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#deleteDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/telefonescliente/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#editDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/telefonescliente/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#autocomplete
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/telefonescliente/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#autocompleteDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/telefonescliente/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#autocompleteDetailEdit
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/telefonescliente/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#autocompleteGeneral
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/telefonescliente/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#crudGET
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/telefonescliente/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#crudGETDetail
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/telefonescliente/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#quickAdd
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/telefonescliente/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#updateOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchOrCreateWithWhere
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#update
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#destroyById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#removeById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchAttributes
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneCliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#updateOrCreate
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchOrCreateWithWhere
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#update
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#destroyById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#removeById
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#patchAttributes
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneCliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneCliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TelefoneCliente#modelName
        * @propertyOf lbServices.TelefoneCliente
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TelefoneCliente`.
        */
        R.modelName = "TelefoneCliente";


            /**
             * @ngdoc method
             * @name lbServices.TelefoneCliente#telefone_tipo
             * @methodOf lbServices.TelefoneCliente
             *
             * @description
             *
             * Fetches belongsTo relation telefone_tipo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TelefoneCliente id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TelefoneTipo` object.)
             * </em>
             */
        R.telefone_tipo = function() {
          var TargetResource = $injector.get("TelefoneTipo");
          var action = TargetResource["::get::TelefoneCliente::telefone_tipo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Ligacao
 * @header lbServices.Ligacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Ligacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Ligacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/call/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Ligacao.card() instead.
            "prototype$__get__card": {
              url: urlBase + "/call/:id/card",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.findById() instead.
            "prototype$__findById__ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.destroyById() instead.
            "prototype$__destroyById__ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.updateById() instead.
            "prototype$__updateById__ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Ligacao.status() instead.
            "prototype$__get__status": {
              url: urlBase + "/call/:id/status",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog() instead.
            "prototype$__get__ligacaoLog": {
              isArray: true,
              url: urlBase + "/call/:id/ligacaoLog",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.create() instead.
            "prototype$__create__ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog",
              method: "POST",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.destroyAll() instead.
            "prototype$__delete__ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog",
              method: "DELETE",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.count() instead.
            "prototype$__count__ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#create
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/call",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#createMany
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/call",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#upsert
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/call",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#replaceOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/call/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#upsertWithWhere
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/call/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#exists
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/call/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#findById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/call/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#replaceById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/call/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#find
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/call",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#findOne
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/call/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#updateAll
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/call/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#deleteById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/call/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#count
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/call/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#prototype$updateAttributes
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/call/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#createChangeStream
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/call/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#callTwilio
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * call from Twilio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "callTwilio": {
              url: urlBase + "/call/call-twilio",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#statusTwilio
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * First Step from call.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string=}` -
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "statusTwilio": {
              url: urlBase + "/call/status-twilio/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#create
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/call",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#createMany
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/call",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#upsert
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/call",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#replaceOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/call/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#upsertWithWhere
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/call/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#exists
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/call/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#findById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/call/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#replaceById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/call/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#find
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/call",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#findOne
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/call/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#updateAll
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/call/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#deleteById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/call/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#count
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/call/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#prototype$updateAttributes
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/call/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#createChangeStream
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/call/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#pager
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/call/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#pagerDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/call/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#postDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/call/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#deleteDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/call/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#editDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/call/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#autocomplete
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/call/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#autocompleteDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/call/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#autocompleteDetailEdit
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/call/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#autocompleteGeneral
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/call/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#crudGET
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/call/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#crudGETDetail
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/call/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#quickAdd
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/call/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#updateOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchOrCreateWithWhere
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#update
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#destroyById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#removeById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchAttributes
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#updateOrCreate
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchOrCreateWithWhere
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#update
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#destroyById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#removeById
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#patchAttributes
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Ligacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Ligacao#modelName
        * @propertyOf lbServices.Ligacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Ligacao`.
        */
        R.modelName = "Ligacao";


            /**
             * @ngdoc method
             * @name lbServices.Ligacao#card
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Fetches belongsTo relation card.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Card` object.)
             * </em>
             */
        R.card = function() {
          var TargetResource = $injector.get("Card");
          var action = TargetResource["::get::Ligacao::card"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Ligacao.ligacaoLog
     * @header lbServices.Ligacao.ligacaoLog
     * @object
     * @description
     *
     * The object `Ligacao.ligacaoLog` groups methods
     * manipulating `LigacaoLog` instances related to `Ligacao`.
     *
     * Call {@link lbServices.Ligacao#ligacaoLog Ligacao.ligacaoLog()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Ligacao#ligacaoLog
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Queries ligacaoLog of Ligacao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R.ligacaoLog = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::get::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#count
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Counts ligacaoLog of Ligacao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.ligacaoLog.count = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::count::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#create
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Creates a new instance in ligacaoLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R.ligacaoLog.create = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::create::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#createMany
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Creates a new instance in ligacaoLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R.ligacaoLog.createMany = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::createMany::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#destroyAll
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Deletes all ligacaoLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ligacaoLog.destroyAll = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::delete::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#destroyById
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Delete a related item by id for ligacaoLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `fk` – `{*}` - Foreign key for ligacaoLog
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ligacaoLog.destroyById = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::destroyById::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#findById
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Find a related item by id for ligacaoLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `fk` – `{*}` - Foreign key for ligacaoLog
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R.ligacaoLog.findById = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::findById::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao.ligacaoLog#updateById
             * @methodOf lbServices.Ligacao.ligacaoLog
             *
             * @description
             *
             * Update a related item by id for ligacaoLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `fk` – `{*}` - Foreign key for ligacaoLog
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R.ligacaoLog.updateById = function() {
          var TargetResource = $injector.get("LigacaoLog");
          var action = TargetResource["::updateById::Ligacao::ligacaoLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Ligacao#status
             * @methodOf lbServices.Ligacao
             *
             * @description
             *
             * Fetches belongsTo relation status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Ligacao id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R.status = function() {
          var TargetResource = $injector.get("StatusCard");
          var action = TargetResource["::get::Ligacao::status"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.LigacaoLog
 * @header lbServices.LigacaoLog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `LigacaoLog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "LigacaoLog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/call-log/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#create
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/call-log",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#createMany
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/call-log",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#upsert
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/call-log",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#replaceOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/call-log/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#upsertWithWhere
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/call-log/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#exists
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/call-log/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#findById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/call-log/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#replaceById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/call-log/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#find
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/call-log",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#findOne
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/call-log/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#updateAll
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/call-log/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#deleteById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/call-log/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#count
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/call-log/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#prototype$updateAttributes
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LigacaoLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/call-log/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#createChangeStream
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/call-log/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#create
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/call-log",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#createMany
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/call-log",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#upsert
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/call-log",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#replaceOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/call-log/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#upsertWithWhere
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/call-log/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#exists
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/call-log/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#findById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/call-log/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#replaceById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/call-log/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#find
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/call-log",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#findOne
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/call-log/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#updateAll
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/call-log/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#deleteById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/call-log/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#count
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/call-log/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#prototype$updateAttributes
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LigacaoLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/call-log/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#createChangeStream
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/call-log/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#pager
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/call-log/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#pagerDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/call-log/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#postDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/call-log/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#deleteDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/call-log/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#editDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/call-log/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#autocomplete
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/call-log/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#autocompleteDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/call-log/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#autocompleteDetailEdit
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/call-log/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#autocompleteGeneral
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/call-log/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#crudGET
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/call-log/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#crudGETDetail
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/call-log/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#quickAdd
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/call-log/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.findById() instead.
            "::findById::Ligacao::ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.destroyById() instead.
            "::destroyById::Ligacao::ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.updateById() instead.
            "::updateById::Ligacao::ligacaoLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/call/:id/ligacaoLog/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Ligacao.ligacaoLog() instead.
            "::get::Ligacao::ligacaoLog": {
              isArray: true,
              url: urlBase + "/call/:id/ligacaoLog",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.create() instead.
            "::create::Ligacao::ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog",
              method: "POST",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.createMany() instead.
            "::createMany::Ligacao::ligacaoLog": {
              isArray: true,
              url: urlBase + "/call/:id/ligacaoLog",
              method: "POST",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.destroyAll() instead.
            "::delete::Ligacao::ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog",
              method: "DELETE",
            },

            // INTERNAL. Use Ligacao.ligacaoLog.count() instead.
            "::count::Ligacao::ligacaoLog": {
              url: urlBase + "/call/:id/ligacaoLog/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#updateOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchOrCreateWithWhere
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#update
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#destroyById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#removeById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchAttributes
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LigacaoLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#updateOrCreate
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchOrCreateWithWhere
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#update
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#destroyById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#removeById
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LigacaoLog#patchAttributes
             * @methodOf lbServices.LigacaoLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LigacaoLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LigacaoLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.LigacaoLog#modelName
        * @propertyOf lbServices.LigacaoLog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `LigacaoLog`.
        */
        R.modelName = "LigacaoLog";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.StatusCard
 * @header lbServices.StatusCard
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `StatusCard` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "StatusCard",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/statusCards/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#create
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statusCards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#createMany
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statusCards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#upsert
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statusCards",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#replaceOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statusCards/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#upsertWithWhere
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statusCards/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#exists
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statusCards/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#findById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statusCards/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#replaceById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statusCards/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#find
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statusCards",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#findOne
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statusCards/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#updateAll
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statusCards/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#deleteById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statusCards/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#count
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statusCards/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#prototype$updateAttributes
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusCard id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statusCards/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#createChangeStream
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statusCards/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#create
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statusCards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#createMany
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statusCards",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#upsert
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statusCards",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#replaceOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statusCards/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#upsertWithWhere
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statusCards/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#exists
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statusCards/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#findById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statusCards/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#replaceById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statusCards/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#find
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statusCards",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#findOne
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statusCards/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#updateAll
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statusCards/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#deleteById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statusCards/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#count
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statusCards/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#prototype$updateAttributes
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusCard id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statusCards/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#createChangeStream
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statusCards/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#pager
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/statusCards/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#pagerDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/statusCards/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#postDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/statusCards/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#deleteDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/statusCards/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#editDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/statusCards/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#autocomplete
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/statusCards/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#autocompleteDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/statusCards/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#autocompleteDetailEdit
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/statusCards/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#autocompleteGeneral
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/statusCards/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#crudGET
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/statusCards/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#crudGETDetail
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/statusCards/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#quickAdd
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/statusCards/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Card.status() instead.
            "::get::Card::status": {
              url: urlBase + "/cards/:id/status",
              method: "GET",
            },

            // INTERNAL. Use Ligacao.status() instead.
            "::get::Ligacao::status": {
              url: urlBase + "/call/:id/status",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#updateOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchOrCreateWithWhere
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#update
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#destroyById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#removeById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchAttributes
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusCard id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#updateOrCreate
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchOrCreateWithWhere
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#update
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#destroyById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#removeById
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusCard#patchAttributes
             * @methodOf lbServices.StatusCard
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusCard id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusCard` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.StatusCard#modelName
        * @propertyOf lbServices.StatusCard
        * @description
        * The name of the model represented by this $resource,
        * i.e. `StatusCard`.
        */
        R.modelName = "StatusCard";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoNegocio
 * @header lbServices.TipoNegocio
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoNegocio` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoNegocio",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposnegocio/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#create
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegocio",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#createMany
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegocio",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#upsert
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegocio",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#replaceOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegocio/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#upsertWithWhere
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegocio/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#exists
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegocio/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#findById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegocio/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#replaceById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegocio/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#find
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegocio",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#findOne
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegocio/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#updateAll
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegocio/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#deleteById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegocio/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#count
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegocio/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocio id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegocio/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#createChangeStream
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegocio/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#create
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegocio",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#createMany
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegocio",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#upsert
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegocio",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#replaceOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegocio/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#upsertWithWhere
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegocio/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#exists
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegocio/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#findById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegocio/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#replaceById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegocio/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#find
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegocio",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#findOne
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegocio/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#updateAll
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegocio/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#deleteById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegocio/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#count
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegocio/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocio id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegocio/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#createChangeStream
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegocio/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#pager
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposnegocio/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#pagerDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposnegocio/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#postDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposnegocio/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#deleteDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposnegocio/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#editDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposnegocio/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#autocomplete
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposnegocio/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#autocompleteDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposnegocio/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#autocompleteDetailEdit
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposnegocio/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#autocompleteGeneral
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposnegocio/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#crudGET
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposnegocio/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#crudGETDetail
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposnegocio/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#quickAdd
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposnegocio/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.tipo_negocio() instead.
            "::get::Imovel::tipo_negocio": {
              url: urlBase + "/imoveis/:id/tipo_negocio",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.interesse() instead.
            "::get::ClienteInteressado::interesse": {
              url: urlBase + "/clientesinteressados/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propTipoNegocio() instead.
            "::get::Proposta::propTipoNegocio": {
              url: urlBase + "/propostas/:id/propTipoNegocio",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatus.propTipoNegocio() instead.
            "::get::PropostaStatus::propTipoNegocio": {
              url: urlBase + "/propostasstatus/:id/propTipoNegocio",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.interesse() instead.
            "::get::RadarImovel::interesse": {
              url: urlBase + "/radarimoveis/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use Time.tipo_interesse() instead.
            "::get::Time::tipo_interesse": {
              url: urlBase + "/times/:id/tipo_interesse",
              method: "GET",
            },

            // INTERNAL. Use TimeRegra.tipo_interesse() instead.
            "::get::TimeRegra::tipo_interesse": {
              url: urlBase + "/timeregras/:id/tipo_interesse",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.interesse() instead.
            "::get::ClienteInteressadoStatus::interesse": {
              url: urlBase + "/clienteinteressadostatus/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.interesse() instead.
            "::get::ClienteInteressadoAtividade::interesse": {
              url: urlBase + "/clienteinteressadoatividades/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use TimeCorretor.tipoNegocio() instead.
            "::get::TimeCorretor::tipoNegocio": {
              url: urlBase + "/timesCorretores/:id/tipoNegocio",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#updateOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#update
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#destroyById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#removeById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchAttributes
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocio id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#updateOrCreate
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#update
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#destroyById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#removeById
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocio#patchAttributes
             * @methodOf lbServices.TipoNegocio
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocio id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoNegocio#modelName
        * @propertyOf lbServices.TipoNegocio
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoNegocio`.
        */
        R.modelName = "TipoNegocio";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TempCardImovel
 * @header lbServices.TempCardImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TempCardImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TempCardImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tempcardsimovel/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TempCardImovel.empresa() instead.
            "prototype$__get__empresa": {
              url: urlBase + "/tempcardsimovel/:id/empresa",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/tempcardsimovel/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.empreendimento() instead.
            "prototype$__get__empreendimento": {
              url: urlBase + "/tempcardsimovel/:id/empreendimento",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.midia() instead.
            "prototype$__get__midia": {
              url: urlBase + "/tempcardsimovel/:id/midia",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/tempcardsimovel/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/tempcardsimovel/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.plantao() instead.
            "prototype$__get__plantao": {
              url: urlBase + "/tempcardsimovel/:id/plantao",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.cardchatbot() instead.
            "prototype$__get__cardchatbot": {
              url: urlBase + "/tempcardsimovel/:id/cardchatbot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#create
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tempcardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#createMany
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tempcardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#upsert
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tempcardsimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#replaceOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tempcardsimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#upsertWithWhere
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tempcardsimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#exists
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tempcardsimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#findById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#replaceById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tempcardsimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#find
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tempcardsimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#findOne
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tempcardsimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#updateAll
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tempcardsimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#deleteById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#count
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tempcardsimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#prototype$updateAttributes
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#createChangeStream
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tempcardsimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#create
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tempcardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#createMany
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tempcardsimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#upsert
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tempcardsimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#replaceOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tempcardsimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#upsertWithWhere
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tempcardsimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#exists
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tempcardsimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#findById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#replaceById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tempcardsimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#find
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tempcardsimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#findOne
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tempcardsimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#updateAll
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tempcardsimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#deleteById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#count
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tempcardsimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#prototype$updateAttributes
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tempcardsimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#createChangeStream
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tempcardsimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#pager
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tempcardsimovel/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#pagerDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tempcardsimovel/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#postDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tempcardsimovel/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#deleteDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tempcardsimovel/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#editDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tempcardsimovel/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#autocomplete
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tempcardsimovel/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#autocompleteDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tempcardsimovel/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#autocompleteDetailEdit
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tempcardsimovel/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#autocompleteGeneral
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tempcardsimovel/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#crudGET
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tempcardsimovel/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#crudGETDetail
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tempcardsimovel/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#quickAdd
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tempcardsimovel/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#updateOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#update
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#destroyById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#removeById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchAttributes
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#updateOrCreate
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#update
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#destroyById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#removeById
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#patchAttributes
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TempCardImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TempCardImovel#modelName
        * @propertyOf lbServices.TempCardImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TempCardImovel`.
        */
        R.modelName = "TempCardImovel";


            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#empresa
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation empresa.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empresa` object.)
             * </em>
             */
        R.empresa = function() {
          var TargetResource = $injector.get("Empresa");
          var action = TargetResource["::get::TempCardImovel::empresa"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#imovel
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::TempCardImovel::imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#empreendimento
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation empreendimento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Empreendimento` object.)
             * </em>
             */
        R.empreendimento = function() {
          var TargetResource = $injector.get("Empreendimento");
          var action = TargetResource["::get::TempCardImovel::empreendimento"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#midia
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation midia.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoMidia` object.)
             * </em>
             */
        R.midia = function() {
          var TargetResource = $injector.get("TipoMidia");
          var action = TargetResource["::get::TempCardImovel::midia"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#imobiliaria
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::TempCardImovel::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#corretor
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::TempCardImovel::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#plantao
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation plantao.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Plantao` object.)
             * </em>
             */
        R.plantao = function() {
          var TargetResource = $injector.get("Plantao");
          var action = TargetResource["::get::TempCardImovel::plantao"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TempCardImovel#cardchatbot
             * @methodOf lbServices.TempCardImovel
             *
             * @description
             *
             * Fetches belongsTo relation cardchatbot.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TempCardImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R.cardchatbot = function() {
          var TargetResource = $injector.get("CardChatbot");
          var action = TargetResource["::get::TempCardImovel::cardchatbot"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Chave
 * @header lbServices.Chave
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Chave` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Chave",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/chaves/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Chave#create
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/chaves",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#createMany
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/chaves",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#upsert
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/chaves",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#replaceOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/chaves/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#upsertWithWhere
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/chaves/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#exists
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/chaves/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#findById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/chaves/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#replaceById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/chaves/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#find
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/chaves",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#findOne
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/chaves/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#updateAll
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/chaves/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#deleteById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/chaves/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#count
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/chaves/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#prototype$updateAttributes
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Chave id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/chaves/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#createChangeStream
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/chaves/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#create
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/chaves",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#createMany
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/chaves",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#upsert
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/chaves",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#replaceOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/chaves/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#upsertWithWhere
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/chaves/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#exists
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/chaves/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#findById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/chaves/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#replaceById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/chaves/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#find
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/chaves",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#findOne
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/chaves/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#updateAll
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/chaves/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#deleteById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/chaves/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#count
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/chaves/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#prototype$updateAttributes
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Chave id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/chaves/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#createChangeStream
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/chaves/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#pager
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/chaves/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#pagerDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/chaves/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#postDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/chaves/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#deleteDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/chaves/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#editDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/chaves/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#autocomplete
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/chaves/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#autocompleteDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/chaves/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#autocompleteDetailEdit
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/chaves/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#autocompleteGeneral
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/chaves/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#crudGET
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/chaves/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#crudGETDetail
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/chaves/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Chave#quickAdd
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/chaves/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.chave() instead.
            "::get::Imovel::chave": {
              url: urlBase + "/imoveis/:id/chave",
              method: "GET",
            },

            // INTERNAL. Use Imovel.chave_estara() instead.
            "::get::Imovel::chave_estara": {
              url: urlBase + "/imoveis/:id/chave_estara",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Chave#patchOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#updateOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#patchOrCreateWithWhere
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#update
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#destroyById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#removeById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#patchAttributes
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Chave id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#patchOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#updateOrCreate
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#patchOrCreateWithWhere
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#update
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#destroyById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#removeById
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Chave#patchAttributes
             * @methodOf lbServices.Chave
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Chave id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Chave` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Chave#modelName
        * @propertyOf lbServices.Chave
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Chave`.
        */
        R.modelName = "Chave";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.HistoricoClienteInteressado
 * @header lbServices.HistoricoClienteInteressado
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `HistoricoClienteInteressado` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "HistoricoClienteInteressado",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/historicosclienteinteressado/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use HistoricoClienteInteressado.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/historicosclienteinteressado/:id/corretor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#create
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/historicosclienteinteressado",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#createMany
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/historicosclienteinteressado",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#upsert
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/historicosclienteinteressado",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#replaceOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/historicosclienteinteressado/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#upsertWithWhere
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/historicosclienteinteressado/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#exists
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/historicosclienteinteressado/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#findById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#replaceById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/historicosclienteinteressado/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#find
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/historicosclienteinteressado",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#findOne
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/historicosclienteinteressado/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#updateAll
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/historicosclienteinteressado/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#deleteById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#count
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/historicosclienteinteressado/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#prototype$updateAttributes
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - HistoricoClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#createChangeStream
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/historicosclienteinteressado/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#create
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/historicosclienteinteressado",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#createMany
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/historicosclienteinteressado",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#upsert
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/historicosclienteinteressado",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#replaceOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/historicosclienteinteressado/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#upsertWithWhere
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/historicosclienteinteressado/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#exists
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/historicosclienteinteressado/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#findById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#replaceById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/historicosclienteinteressado/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#find
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/historicosclienteinteressado",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#findOne
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/historicosclienteinteressado/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#updateAll
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/historicosclienteinteressado/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#deleteById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#count
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/historicosclienteinteressado/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#prototype$updateAttributes
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - HistoricoClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/historicosclienteinteressado/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#createChangeStream
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/historicosclienteinteressado/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#pager
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/historicosclienteinteressado/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#pagerDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#postDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#deleteDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#editDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#autocomplete
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/historicosclienteinteressado/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#autocompleteDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#autocompleteDetailEdit
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/historicosclienteinteressado/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#autocompleteGeneral
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/historicosclienteinteressado/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#crudGET
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/historicosclienteinteressado/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#crudGETDetail
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/historicosclienteinteressado/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#quickAdd
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/historicosclienteinteressado/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.historicos.findById() instead.
            "::findById::ClienteInteressado::historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos.destroyById() instead.
            "::destroyById::ClienteInteressado::historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.historicos.updateById() instead.
            "::updateById::ClienteInteressado::historicos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/historicos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.historicos() instead.
            "::get::ClienteInteressado::historicos": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.historicos.create() instead.
            "::create::ClienteInteressado::historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.historicos.createMany() instead.
            "::createMany::ClienteInteressado::historicos": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.historicos.destroyAll() instead.
            "::delete::ClienteInteressado::historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.historicos.count() instead.
            "::count::ClienteInteressado::historicos": {
              url: urlBase + "/clientesinteressados/:id/historicos/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.historico_cliente_interessado() instead.
            "::get::ClienteInteressadoAtividade::historico_cliente_interessado": {
              url: urlBase + "/clienteinteressadoatividades/:id/historico_cliente_interessado",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#updateOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchOrCreateWithWhere
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#update
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#destroyById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#removeById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchAttributes
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - HistoricoClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#updateOrCreate
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchOrCreateWithWhere
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#update
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#destroyById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#removeById
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#patchAttributes
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - HistoricoClienteInteressado id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.HistoricoClienteInteressado#modelName
        * @propertyOf lbServices.HistoricoClienteInteressado
        * @description
        * The name of the model represented by this $resource,
        * i.e. `HistoricoClienteInteressado`.
        */
        R.modelName = "HistoricoClienteInteressado";


            /**
             * @ngdoc method
             * @name lbServices.HistoricoClienteInteressado#corretor
             * @methodOf lbServices.HistoricoClienteInteressado
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - HistoricoClienteInteressado id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::HistoricoClienteInteressado::corretor"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CardChatbot
 * @header lbServices.CardChatbot
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CardChatbot` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CardChatbot",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cardschatbot/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#create
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardschatbot",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#createMany
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardschatbot",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#upsert
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardschatbot",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#replaceOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardschatbot/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#upsertWithWhere
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardschatbot/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#exists
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardschatbot/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#findById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardschatbot/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#replaceById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardschatbot/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#find
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardschatbot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#findOne
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardschatbot/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#updateAll
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardschatbot/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#deleteById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardschatbot/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#count
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardschatbot/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#prototype$updateAttributes
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardChatbot id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardschatbot/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#createChangeStream
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardschatbot/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#create
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardschatbot",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#createMany
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardschatbot",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#upsert
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardschatbot",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#replaceOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardschatbot/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#upsertWithWhere
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardschatbot/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#exists
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardschatbot/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#findById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardschatbot/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#replaceById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardschatbot/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#find
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardschatbot",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#findOne
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardschatbot/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#updateAll
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardschatbot/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#deleteById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardschatbot/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#count
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardschatbot/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#prototype$updateAttributes
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardChatbot id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardschatbot/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#createChangeStream
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardschatbot/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#pager
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/cardschatbot/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#pagerDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/cardschatbot/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#postDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/cardschatbot/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#deleteDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/cardschatbot/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#editDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/cardschatbot/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#autocomplete
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/cardschatbot/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#autocompleteDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/cardschatbot/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#autocompleteDetailEdit
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/cardschatbot/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#autocompleteGeneral
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/cardschatbot/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#crudGET
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/cardschatbot/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#crudGETDetail
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/cardschatbot/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#quickAdd
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/cardschatbot/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Card.cardchatbot() instead.
            "::get::Card::cardchatbot": {
              url: urlBase + "/cards/:id/cardchatbot",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.cardchatbot() instead.
            "::get::CardImovel::cardchatbot": {
              url: urlBase + "/cardsimovel/:id/cardchatbot",
              method: "GET",
            },

            // INTERNAL. Use TempCardImovel.cardchatbot() instead.
            "::get::TempCardImovel::cardchatbot": {
              url: urlBase + "/tempcardsimovel/:id/cardchatbot",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#updateOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchOrCreateWithWhere
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#update
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#destroyById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#removeById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchAttributes
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardChatbot id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#updateOrCreate
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchOrCreateWithWhere
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#update
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#destroyById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#removeById
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardChatbot#patchAttributes
             * @methodOf lbServices.CardChatbot
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardChatbot id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardChatbot` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CardChatbot#modelName
        * @propertyOf lbServices.CardChatbot
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CardChatbot`.
        */
        R.modelName = "CardChatbot";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RedeSocial
 * @header lbServices.RedeSocial
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RedeSocial` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RedeSocial",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/redessociais/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RedeSocial.rd_nome() instead.
            "prototype$__get__rd_nome": {
              url: urlBase + "/redessociais/:id/rd_nome",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#create
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/redessociais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#createMany
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/redessociais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#upsert
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/redessociais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#replaceOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/redessociais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#upsertWithWhere
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/redessociais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#exists
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/redessociais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#findById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/redessociais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#replaceById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/redessociais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#find
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/redessociais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#findOne
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/redessociais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#updateAll
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/redessociais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#deleteById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/redessociais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#count
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/redessociais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#prototype$updateAttributes
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/redessociais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#createChangeStream
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/redessociais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#create
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/redessociais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#createMany
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/redessociais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#upsert
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/redessociais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#replaceOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/redessociais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#upsertWithWhere
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/redessociais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#exists
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/redessociais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#findById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/redessociais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#replaceById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/redessociais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#find
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/redessociais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#findOne
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/redessociais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#updateAll
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/redessociais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#deleteById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/redessociais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#count
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/redessociais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#prototype$updateAttributes
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/redessociais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#createChangeStream
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/redessociais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#pager
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/redessociais/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#pagerDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/redessociais/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#postDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/redessociais/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#deleteDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/redessociais/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#editDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/redessociais/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#autocomplete
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/redessociais/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#autocompleteDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/redessociais/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#autocompleteDetailEdit
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/redessociais/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#autocompleteGeneral
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/redessociais/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#crudGET
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/redessociais/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#crudGETDetail
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/redessociais/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#quickAdd
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/redessociais/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.redessociais.findById() instead.
            "::findById::Usuario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais.destroyById() instead.
            "::destroyById::Usuario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.redessociais.updateById() instead.
            "::updateById::Usuario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.redessociais() instead.
            "::get::Usuario::redessociais": {
              isArray: true,
              url: urlBase + "/users/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Usuario.redessociais.create() instead.
            "::create::Usuario::redessociais": {
              url: urlBase + "/users/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Usuario.redessociais.createMany() instead.
            "::createMany::Usuario::redessociais": {
              isArray: true,
              url: urlBase + "/users/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Usuario.redessociais.destroyAll() instead.
            "::delete::Usuario::redessociais": {
              url: urlBase + "/users/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.redessociais.count() instead.
            "::count::Usuario::redessociais": {
              url: urlBase + "/users/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.findById() instead.
            "::findById::Corretor::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.destroyById() instead.
            "::destroyById::Corretor::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.redessociais.updateById() instead.
            "::updateById::Corretor::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.redessociais() instead.
            "::get::Corretor::redessociais": {
              isArray: true,
              url: urlBase + "/corretores/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Corretor.redessociais.create() instead.
            "::create::Corretor::redessociais": {
              url: urlBase + "/corretores/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Corretor.redessociais.createMany() instead.
            "::createMany::Corretor::redessociais": {
              isArray: true,
              url: urlBase + "/corretores/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Corretor.redessociais.destroyAll() instead.
            "::delete::Corretor::redessociais": {
              url: urlBase + "/corretores/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.redessociais.count() instead.
            "::count::Corretor::redessociais": {
              url: urlBase + "/corretores/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais.findById() instead.
            "::findById::Proprietario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais.destroyById() instead.
            "::destroyById::Proprietario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.redessociais.updateById() instead.
            "::updateById::Proprietario::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.redessociais() instead.
            "::get::Proprietario::redessociais": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.redessociais.create() instead.
            "::create::Proprietario::redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.redessociais.createMany() instead.
            "::createMany::Proprietario::redessociais": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.redessociais.destroyAll() instead.
            "::delete::Proprietario::redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.redessociais.count() instead.
            "::count::Proprietario::redessociais": {
              url: urlBase + "/proprietarios/:id/redessociais/count",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.findById() instead.
            "::findById::Imobiliaria::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.destroyById() instead.
            "::destroyById::Imobiliaria::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.redessociais.updateById() instead.
            "::updateById::Imobiliaria::redessociais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/redessociais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.redessociais() instead.
            "::get::Imobiliaria::redessociais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.redessociais.create() instead.
            "::create::Imobiliaria::redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.redessociais.createMany() instead.
            "::createMany::Imobiliaria::redessociais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.redessociais.destroyAll() instead.
            "::delete::Imobiliaria::redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.redessociais.count() instead.
            "::count::Imobiliaria::redessociais": {
              url: urlBase + "/imobiliarias/:id/redessociais/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#updateOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchOrCreateWithWhere
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#update
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#destroyById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#removeById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchAttributes
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#updateOrCreate
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchOrCreateWithWhere
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#update
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#destroyById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#removeById
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#patchAttributes
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RedeSocial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RedeSocial#modelName
        * @propertyOf lbServices.RedeSocial
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RedeSocial`.
        */
        R.modelName = "RedeSocial";


            /**
             * @ngdoc method
             * @name lbServices.RedeSocial#rd_nome
             * @methodOf lbServices.RedeSocial
             *
             * @description
             *
             * Fetches belongsTo relation rd_nome.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RedeSocial id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R.rd_nome = function() {
          var TargetResource = $injector.get("TipoRedeSocial");
          var action = TargetResource["::get::RedeSocial::rd_nome"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.StatusInativo
 * @header lbServices.StatusInativo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `StatusInativo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "StatusInativo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/statusinativos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#create
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statusinativos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#createMany
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statusinativos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#upsert
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statusinativos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#replaceOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statusinativos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#upsertWithWhere
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statusinativos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#exists
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statusinativos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#findById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statusinativos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#replaceById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statusinativos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#find
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statusinativos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#findOne
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statusinativos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#updateAll
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statusinativos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#deleteById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statusinativos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#count
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statusinativos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#prototype$updateAttributes
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusInativo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statusinativos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#createChangeStream
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statusinativos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#create
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/statusinativos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#createMany
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/statusinativos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#upsert
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/statusinativos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#replaceOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/statusinativos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#upsertWithWhere
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/statusinativos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#exists
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/statusinativos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#findById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/statusinativos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#replaceById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/statusinativos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#find
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/statusinativos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#findOne
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/statusinativos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#updateAll
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/statusinativos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#deleteById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/statusinativos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#count
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/statusinativos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#prototype$updateAttributes
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusInativo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/statusinativos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#createChangeStream
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/statusinativos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#pager
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/statusinativos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#pagerDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/statusinativos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#postDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/statusinativos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#deleteDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/statusinativos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#editDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/statusinativos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#autocomplete
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/statusinativos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#autocompleteDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/statusinativos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#autocompleteDetailEdit
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/statusinativos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#autocompleteGeneral
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/statusinativos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#crudGET
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/statusinativos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#crudGETDetail
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/statusinativos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#quickAdd
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/statusinativos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.status_inativo() instead.
            "::get::ClienteInteressado::status_inativo": {
              url: urlBase + "/clientesinteressados/:id/status_inativo",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#updateOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchOrCreateWithWhere
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#update
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#destroyById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#removeById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchAttributes
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusInativo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#updateOrCreate
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchOrCreateWithWhere
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#update
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#destroyById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#removeById
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.StatusInativo#patchAttributes
             * @methodOf lbServices.StatusInativo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - StatusInativo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `StatusInativo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.StatusInativo#modelName
        * @propertyOf lbServices.StatusInativo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `StatusInativo`.
        */
        R.modelName = "StatusInativo";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoRedeSocial
 * @header lbServices.TipoRedeSocial
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoRedeSocial` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoRedeSocial",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposredesocial/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#create
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposredesocial",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#createMany
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposredesocial",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#upsert
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposredesocial",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#replaceOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposredesocial/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#upsertWithWhere
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposredesocial/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#exists
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposredesocial/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#findById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposredesocial/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#replaceById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposredesocial/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#find
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposredesocial",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#findOne
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposredesocial/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#updateAll
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposredesocial/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#deleteById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposredesocial/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#count
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposredesocial/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#prototype$updateAttributes
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoRedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposredesocial/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#createChangeStream
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposredesocial/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#create
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposredesocial",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#createMany
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposredesocial",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#upsert
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposredesocial",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#replaceOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposredesocial/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#upsertWithWhere
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposredesocial/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#exists
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposredesocial/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#findById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposredesocial/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#replaceById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposredesocial/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#find
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposredesocial",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#findOne
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposredesocial/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#updateAll
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposredesocial/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#deleteById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposredesocial/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#count
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposredesocial/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#prototype$updateAttributes
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoRedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposredesocial/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#createChangeStream
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposredesocial/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#pager
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposredesocial/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#pagerDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposredesocial/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#postDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposredesocial/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#deleteDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposredesocial/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#editDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposredesocial/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#autocomplete
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposredesocial/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#autocompleteDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposredesocial/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#autocompleteDetailEdit
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposredesocial/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#autocompleteGeneral
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposredesocial/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#crudGET
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposredesocial/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#crudGETDetail
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposredesocial/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#quickAdd
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposredesocial/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use RedeSocial.rd_nome() instead.
            "::get::RedeSocial::rd_nome": {
              url: urlBase + "/redessociais/:id/rd_nome",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#updateOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchOrCreateWithWhere
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#update
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#destroyById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#removeById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchAttributes
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoRedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#updateOrCreate
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchOrCreateWithWhere
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#update
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#destroyById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#removeById
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoRedeSocial#patchAttributes
             * @methodOf lbServices.TipoRedeSocial
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoRedeSocial id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoRedeSocial` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoRedeSocial#modelName
        * @propertyOf lbServices.TipoRedeSocial
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoRedeSocial`.
        */
        R.modelName = "TipoRedeSocial";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Modalidade
 * @header lbServices.Modalidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Modalidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Modalidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/modalidade/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#create
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/modalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#createMany
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/modalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#upsert
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/modalidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#replaceOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/modalidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#upsertWithWhere
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/modalidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#exists
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/modalidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#findById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/modalidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#replaceById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/modalidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#find
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/modalidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#findOne
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/modalidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#updateAll
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/modalidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#deleteById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/modalidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#count
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/modalidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#prototype$updateAttributes
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Modalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/modalidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#createChangeStream
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/modalidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#create
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/modalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#createMany
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/modalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#upsert
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/modalidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#replaceOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/modalidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#upsertWithWhere
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/modalidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#exists
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/modalidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#findById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/modalidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#replaceById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/modalidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#find
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/modalidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#findOne
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/modalidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#updateAll
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/modalidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#deleteById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/modalidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#count
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/modalidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#prototype$updateAttributes
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Modalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/modalidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#createChangeStream
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/modalidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#pager
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/modalidade/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#pagerDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/modalidade/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#postDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/modalidade/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#deleteDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/modalidade/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#editDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/modalidade/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#autocomplete
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/modalidade/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#autocompleteDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/modalidade/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#autocompleteDetailEdit
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/modalidade/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#autocompleteGeneral
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/modalidade/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#crudGET
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/modalidade/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#crudGETDetail
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/modalidade/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#quickAdd
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/modalidade/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.modalidade() instead.
            "::get::Imovel::modalidade": {
              url: urlBase + "/imoveis/:id/modalidade",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#updateOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchOrCreateWithWhere
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#update
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#destroyById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#removeById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchAttributes
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Modalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#updateOrCreate
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchOrCreateWithWhere
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#update
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#destroyById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#removeById
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Modalidade#patchAttributes
             * @methodOf lbServices.Modalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Modalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Modalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Modalidade#modelName
        * @propertyOf lbServices.Modalidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Modalidade`.
        */
        R.modelName = "Modalidade";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GrupoComodidade
 * @header lbServices.GrupoComodidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GrupoComodidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GrupoComodidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/gruposcomodidade/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GrupoComodidade.comodidades.findById() instead.
            "prototype$__findById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.destroyById() instead.
            "prototype$__destroyById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.updateById() instead.
            "prototype$__updateById__comodidades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/comodidades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.findById() instead.
            "prototype$__findById__grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.destroyById() instead.
            "prototype$__destroyById__grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.updateById() instead.
            "prototype$__updateById__grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GrupoComodidade.comodidades() instead.
            "prototype$__get__comodidades": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.create() instead.
            "prototype$__create__comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.destroyAll() instead.
            "prototype$__delete__comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.comodidades.count() instead.
            "prototype$__count__comodidades": {
              url: urlBase + "/gruposcomodidade/:id/comodidades/count",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem() instead.
            "prototype$__get__grupocomodidadeordem": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.create() instead.
            "prototype$__create__grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.destroyAll() instead.
            "prototype$__delete__grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.count() instead.
            "prototype$__count__grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#create
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gruposcomodidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#createMany
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gruposcomodidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#upsert
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gruposcomodidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#replaceOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gruposcomodidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#upsertWithWhere
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gruposcomodidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#exists
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gruposcomodidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#findById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#replaceById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gruposcomodidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#find
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gruposcomodidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#findOne
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gruposcomodidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#updateAll
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gruposcomodidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#deleteById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#count
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gruposcomodidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#prototype$updateAttributes
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#createChangeStream
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gruposcomodidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#create
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gruposcomodidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#createMany
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gruposcomodidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#upsert
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gruposcomodidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#replaceOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gruposcomodidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#upsertWithWhere
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gruposcomodidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#exists
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gruposcomodidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#findById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#replaceById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gruposcomodidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#find
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gruposcomodidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#findOne
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gruposcomodidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#updateAll
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gruposcomodidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#deleteById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#count
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gruposcomodidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#prototype$updateAttributes
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gruposcomodidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#createChangeStream
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gruposcomodidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#pager
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/gruposcomodidade/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#pagerDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/gruposcomodidade/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#postDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/gruposcomodidade/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#deleteDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/gruposcomodidade/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#editDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/gruposcomodidade/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#autocomplete
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/gruposcomodidade/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#autocompleteDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/gruposcomodidade/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#autocompleteDetailEdit
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/gruposcomodidade/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#autocompleteGeneral
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/gruposcomodidade/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#crudGET
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/gruposcomodidade/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#crudGETDetail
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/gruposcomodidade/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#quickAdd
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/gruposcomodidade/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Comodidade.grupo_comodidades() instead.
            "::get::Comodidade::grupo_comodidades": {
              url: urlBase + "/comodidades/:id/grupo_comodidades",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidadeOrdenacao.grupocomodidade() instead.
            "::get::GrupoComodidadeOrdenacao::grupocomodidade": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/grupocomodidade",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#updateOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#update
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#destroyById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#removeById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchAttributes
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#updateOrCreate
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchOrCreateWithWhere
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#update
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#destroyById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#removeById
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#patchAttributes
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GrupoComodidade#modelName
        * @propertyOf lbServices.GrupoComodidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GrupoComodidade`.
        */
        R.modelName = "GrupoComodidade";

    /**
     * @ngdoc object
     * @name lbServices.GrupoComodidade.comodidades
     * @header lbServices.GrupoComodidade.comodidades
     * @object
     * @description
     *
     * The object `GrupoComodidade.comodidades` groups methods
     * manipulating `Comodidade` instances related to `GrupoComodidade`.
     *
     * Call {@link lbServices.GrupoComodidade#comodidades GrupoComodidade.comodidades()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#comodidades
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Queries comodidades of GrupoComodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidades = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::get::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#count
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Counts comodidades of GrupoComodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.comodidades.count = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::count::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#create
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidades.create = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::create::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#createMany
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Creates a new instance in comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidades.createMany = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::createMany::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#destroyAll
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Deletes all comodidades of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyAll = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::delete::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#destroyById
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Delete a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.comodidades.destroyById = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::destroyById::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#findById
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Find a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidades.findById = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::findById::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.comodidades#updateById
             * @methodOf lbServices.GrupoComodidade.comodidades
             *
             * @description
             *
             * Update a related item by id for comodidades.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for comodidades
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Comodidade` object.)
             * </em>
             */
        R.comodidades.updateById = function() {
          var TargetResource = $injector.get("Comodidade");
          var action = TargetResource["::updateById::GrupoComodidade::comodidades"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.GrupoComodidade.grupocomodidadeordem
     * @header lbServices.GrupoComodidade.grupocomodidadeordem
     * @object
     * @description
     *
     * The object `GrupoComodidade.grupocomodidadeordem` groups methods
     * manipulating `GrupoComodidadeOrdenacao` instances related to `GrupoComodidade`.
     *
     * Call {@link lbServices.GrupoComodidade#grupocomodidadeordem GrupoComodidade.grupocomodidadeordem()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade#grupocomodidadeordem
             * @methodOf lbServices.GrupoComodidade
             *
             * @description
             *
             * Queries grupocomodidadeordem of GrupoComodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R.grupocomodidadeordem = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::get::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#count
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Counts grupocomodidadeordem of GrupoComodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.grupocomodidadeordem.count = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::count::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#create
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Creates a new instance in grupocomodidadeordem of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R.grupocomodidadeordem.create = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::create::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#createMany
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Creates a new instance in grupocomodidadeordem of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R.grupocomodidadeordem.createMany = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::createMany::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#destroyAll
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Deletes all grupocomodidadeordem of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.grupocomodidadeordem.destroyAll = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::delete::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#destroyById
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Delete a related item by id for grupocomodidadeordem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for grupocomodidadeordem
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.grupocomodidadeordem.destroyById = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::destroyById::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#findById
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Find a related item by id for grupocomodidadeordem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for grupocomodidadeordem
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R.grupocomodidadeordem.findById = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::findById::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidade.grupocomodidadeordem#updateById
             * @methodOf lbServices.GrupoComodidade.grupocomodidadeordem
             *
             * @description
             *
             * Update a related item by id for grupocomodidadeordem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidade id
             *
             *  - `fk` – `{*}` - Foreign key for grupocomodidadeordem
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R.grupocomodidadeordem.updateById = function() {
          var TargetResource = $injector.get("GrupoComodidadeOrdenacao");
          var action = TargetResource["::updateById::GrupoComodidade::grupocomodidadeordem"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GrupoComodidadeOrdenacao
 * @header lbServices.GrupoComodidadeOrdenacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GrupoComodidadeOrdenacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GrupoComodidadeOrdenacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/gruposcomodidadeordenacao/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GrupoComodidadeOrdenacao.grupocomodidade() instead.
            "prototype$__get__grupocomodidade": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/grupocomodidade",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidadeOrdenacao.tipoimovel() instead.
            "prototype$__get__tipoimovel": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/tipoimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#create
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#createMany
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#upsert
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#replaceOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gruposcomodidadeordenacao/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#upsertWithWhere
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gruposcomodidadeordenacao/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#exists
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#findById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#replaceById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#find
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#findOne
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gruposcomodidadeordenacao/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#updateAll
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gruposcomodidadeordenacao/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#deleteById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#count
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gruposcomodidadeordenacao/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#prototype$updateAttributes
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#createChangeStream
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gruposcomodidadeordenacao/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#create
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#createMany
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#upsert
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#replaceOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gruposcomodidadeordenacao/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#upsertWithWhere
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gruposcomodidadeordenacao/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#exists
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#findById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#replaceById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#find
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gruposcomodidadeordenacao",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#findOne
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gruposcomodidadeordenacao/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#updateAll
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gruposcomodidadeordenacao/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#deleteById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#count
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gruposcomodidadeordenacao/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#prototype$updateAttributes
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gruposcomodidadeordenacao/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#createChangeStream
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gruposcomodidadeordenacao/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#pager
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/gruposcomodidadeordenacao/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#pagerDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#postDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#deleteDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#editDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#autocomplete
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/gruposcomodidadeordenacao/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#autocompleteDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#autocompleteDetailEdit
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#autocompleteGeneral
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/gruposcomodidadeordenacao/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#crudGET
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/gruposcomodidadeordenacao/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#crudGETDetail
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/gruposcomodidadeordenacao/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#quickAdd
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/gruposcomodidadeordenacao/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.findById() instead.
            "::findById::GrupoComodidade::grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.destroyById() instead.
            "::destroyById::GrupoComodidade::grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.updateById() instead.
            "::updateById::GrupoComodidade::grupocomodidadeordem": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/:fk",
              method: "PUT",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem() instead.
            "::get::GrupoComodidade::grupocomodidadeordem": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "GET",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.create() instead.
            "::create::GrupoComodidade::grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.createMany() instead.
            "::createMany::GrupoComodidade::grupocomodidadeordem": {
              isArray: true,
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "POST",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.destroyAll() instead.
            "::delete::GrupoComodidade::grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem",
              method: "DELETE",
            },

            // INTERNAL. Use GrupoComodidade.grupocomodidadeordem.count() instead.
            "::count::GrupoComodidade::grupocomodidadeordem": {
              url: urlBase + "/gruposcomodidade/:id/grupocomodidadeordem/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#updateOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchOrCreateWithWhere
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#update
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#destroyById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#removeById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchAttributes
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#updateOrCreate
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchOrCreateWithWhere
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#update
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#destroyById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#removeById
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#patchAttributes
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidadeOrdenacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GrupoComodidadeOrdenacao#modelName
        * @propertyOf lbServices.GrupoComodidadeOrdenacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GrupoComodidadeOrdenacao`.
        */
        R.modelName = "GrupoComodidadeOrdenacao";


            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#grupocomodidade
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Fetches belongsTo relation grupocomodidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GrupoComodidade` object.)
             * </em>
             */
        R.grupocomodidade = function() {
          var TargetResource = $injector.get("GrupoComodidade");
          var action = TargetResource["::get::GrupoComodidadeOrdenacao::grupocomodidade"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.GrupoComodidadeOrdenacao#tipoimovel
             * @methodOf lbServices.GrupoComodidadeOrdenacao
             *
             * @description
             *
             * Fetches belongsTo relation tipoimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GrupoComodidadeOrdenacao id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R.tipoimovel = function() {
          var TargetResource = $injector.get("TipoImovel");
          var action = TargetResource["::get::GrupoComodidadeOrdenacao::tipoimovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SendEmail
 * @header lbServices.SendEmail
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SendEmail` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SendEmail",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/email-sends/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#create
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/email-sends",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#createMany
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/email-sends",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#upsert
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/email-sends",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#replaceOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/email-sends/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#upsertWithWhere
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/email-sends/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#exists
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/email-sends/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#findById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/email-sends/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#replaceById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/email-sends/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#find
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/email-sends",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#findOne
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/email-sends/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#updateAll
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/email-sends/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#deleteById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/email-sends/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#count
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/email-sends/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#prototype$updateAttributes
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - sendEmail id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/email-sends/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#createChangeStream
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/email-sends/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#emailContact
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Send Email contact form
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "emailContact": {
              url: urlBase + "/email-sends/send-email-to",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#create
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/email-sends",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#createMany
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/email-sends",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#upsert
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/email-sends",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#replaceOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/email-sends/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#upsertWithWhere
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/email-sends/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#exists
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/email-sends/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#findById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/email-sends/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#replaceById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/email-sends/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#find
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/email-sends",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#findOne
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/email-sends/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#updateAll
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/email-sends/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#deleteById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/email-sends/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#count
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/email-sends/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#prototype$updateAttributes
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - sendEmail id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/email-sends/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#createChangeStream
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/email-sends/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#pager
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/email-sends/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#pagerDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/email-sends/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#postDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/email-sends/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#deleteDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/email-sends/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#editDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/email-sends/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#autocomplete
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/email-sends/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#autocompleteDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/email-sends/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#autocompleteDetailEdit
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/email-sends/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#autocompleteGeneral
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/email-sends/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#crudGET
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/email-sends/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#crudGETDetail
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/email-sends/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#quickAdd
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/email-sends/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#updateOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchOrCreateWithWhere
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#update
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#destroyById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#removeById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchAttributes
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - sendEmail id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#updateOrCreate
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchOrCreateWithWhere
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#update
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#destroyById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#removeById
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SendEmail#patchAttributes
             * @methodOf lbServices.SendEmail
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - sendEmail id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SendEmail` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SendEmail#modelName
        * @propertyOf lbServices.SendEmail
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SendEmail`.
        */
        R.modelName = "SendEmail";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Portal
 * @header lbServices.Portal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Portal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Portal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/portais/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Portal.portal_base() instead.
            "prototype$__get__portal_base": {
              url: urlBase + "/portais/:id/portal_base",
              method: "GET",
            },

            // INTERNAL. Use Portal.historico.findById() instead.
            "prototype$__findById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.historico.destroyById() instead.
            "prototype$__destroyById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.historico.updateById() instead.
            "prototype$__updateById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.portimovel.findById() instead.
            "prototype$__findById__portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel.destroyById() instead.
            "prototype$__destroyById__portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portimovel.updateById() instead.
            "prototype$__updateById__portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.portalimobiliaria.findById() instead.
            "prototype$__findById__portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria.destroyById() instead.
            "prototype$__destroyById__portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portalimobiliaria.updateById() instead.
            "prototype$__updateById__portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.findById() instead.
            "prototype$__findById__ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.destroyById() instead.
            "prototype$__destroyById__ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.updateById() instead.
            "prototype$__updateById__ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.historico() instead.
            "prototype$__get__historico": {
              isArray: true,
              url: urlBase + "/portais/:id/historico",
              method: "GET",
            },

            // INTERNAL. Use Portal.historico.create() instead.
            "prototype$__create__historico": {
              url: urlBase + "/portais/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Portal.historico.destroyAll() instead.
            "prototype$__delete__historico": {
              url: urlBase + "/portais/:id/historico",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.historico.count() instead.
            "prototype$__count__historico": {
              url: urlBase + "/portais/:id/historico/count",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel() instead.
            "prototype$__get__portimovel": {
              isArray: true,
              url: urlBase + "/portais/:id/portimovel",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel.create() instead.
            "prototype$__create__portimovel": {
              url: urlBase + "/portais/:id/portimovel",
              method: "POST",
            },

            // INTERNAL. Use Portal.portimovel.destroyAll() instead.
            "prototype$__delete__portimovel": {
              url: urlBase + "/portais/:id/portimovel",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portimovel.count() instead.
            "prototype$__count__portimovel": {
              url: urlBase + "/portais/:id/portimovel/count",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria() instead.
            "prototype$__get__portalimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria.create() instead.
            "prototype$__create__portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.portalimobiliaria.destroyAll() instead.
            "prototype$__delete__portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portalimobiliaria.count() instead.
            "prototype$__count__portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria/count",
              method: "GET",
            },

            // INTERNAL. Use Portal.ordemimobiliaria() instead.
            "prototype$__get__ordemimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.create() instead.
            "prototype$__create__ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.destroyAll() instead.
            "prototype$__delete__ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.count() instead.
            "prototype$__count__ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#create
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#createMany
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#upsert
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#replaceOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#upsertWithWhere
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#exists
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#findById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#replaceById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#find
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#findOne
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#updateAll
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#deleteById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#count
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#prototype$updateAttributes
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#createChangeStream
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#create
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#createMany
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#upsert
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#replaceOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#upsertWithWhere
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#exists
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#findById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#replaceById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#find
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#findOne
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#updateAll
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#deleteById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#count
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#prototype$updateAttributes
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#createChangeStream
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#pager
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/portais/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#pagerDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/portais/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#postDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/portais/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#deleteDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/portais/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#editDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/portais/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#autocomplete
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/portais/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#autocompleteDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/portais/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#autocompleteDetailEdit
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/portais/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#autocompleteGeneral
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/portais/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#crudGET
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/portais/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#crudGETDetail
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/portais/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Portal#quickAdd
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/portais/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Portal.portal_base() instead.
            "::get::Portal::portal_base": {
              url: urlBase + "/portais/:id/portal_base",
              method: "GET",
            },

            // INTERNAL. Use LogXmlPortal.portal() instead.
            "::get::LogXmlPortal::portal": {
              url: urlBase + "/logxmlportal/:id/portal",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.portimovel() instead.
            "::get::PortalImovel::portimovel": {
              url: urlBase + "/portalimoveis/:id/portimovel",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portal() instead.
            "::get::ImobiliariaPortal::portal": {
              url: urlBase + "/imobiliariaportais/:id/portal",
              method: "GET",
            },

            // INTERNAL. Use PortalOrdemImobiliaria.portal() instead.
            "::get::PortalOrdemImobiliaria::portal": {
              url: urlBase + "/portalordemimobiliarias/:id/portal",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Portal#patchOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#updateOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#patchOrCreateWithWhere
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#update
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#destroyById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#removeById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#patchAttributes
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#patchOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#updateOrCreate
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#patchOrCreateWithWhere
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#update
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#destroyById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#removeById
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Portal#patchAttributes
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Portal#modelName
        * @propertyOf lbServices.Portal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Portal`.
        */
        R.modelName = "Portal";


            /**
             * @ngdoc method
             * @name lbServices.Portal#portal_base
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Fetches belongsTo relation portal_base.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R.portal_base = function() {
          var TargetResource = $injector.get("Portal");
          var action = TargetResource["::get::Portal::portal_base"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Portal.historico
     * @header lbServices.Portal.historico
     * @object
     * @description
     *
     * The object `Portal.historico` groups methods
     * manipulating `LogXmlPortal` instances related to `Portal`.
     *
     * Call {@link lbServices.Portal#historico Portal.historico()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Portal#historico
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Queries historico of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R.historico = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::get::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#count
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Counts historico of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.historico.count = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::count::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#create
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Creates a new instance in historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R.historico.create = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::create::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#createMany
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Creates a new instance in historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R.historico.createMany = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::createMany::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#destroyAll
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Deletes all historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historico.destroyAll = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::delete::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#destroyById
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Delete a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historico.destroyById = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::destroyById::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#findById
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Find a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R.historico.findById = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::findById::Portal::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.historico#updateById
             * @methodOf lbServices.Portal.historico
             *
             * @description
             *
             * Update a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R.historico.updateById = function() {
          var TargetResource = $injector.get("LogXmlPortal");
          var action = TargetResource["::updateById::Portal::historico"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Portal.portimovel
     * @header lbServices.Portal.portimovel
     * @object
     * @description
     *
     * The object `Portal.portimovel` groups methods
     * manipulating `PortalImovel` instances related to `Portal`.
     *
     * Call {@link lbServices.Portal#portimovel Portal.portimovel()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Portal#portimovel
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Queries portimovel of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portimovel = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::get::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#count
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Counts portimovel of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.portimovel.count = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::count::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#create
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Creates a new instance in portimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portimovel.create = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::create::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#createMany
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Creates a new instance in portimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portimovel.createMany = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::createMany::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#destroyAll
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Deletes all portimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portimovel.destroyAll = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::delete::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#destroyById
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Delete a related item by id for portimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portimovel
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portimovel.destroyById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::destroyById::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#findById
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Find a related item by id for portimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portimovel
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portimovel.findById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::findById::Portal::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portimovel#updateById
             * @methodOf lbServices.Portal.portimovel
             *
             * @description
             *
             * Update a related item by id for portimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portimovel
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portimovel.updateById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::updateById::Portal::portimovel"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Portal.portalimobiliaria
     * @header lbServices.Portal.portalimobiliaria
     * @object
     * @description
     *
     * The object `Portal.portalimobiliaria` groups methods
     * manipulating `ImobiliariaPortal` instances related to `Portal`.
     *
     * Call {@link lbServices.Portal#portalimobiliaria Portal.portalimobiliaria()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Portal#portalimobiliaria
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Queries portalimobiliaria of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::get::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#count
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Counts portalimobiliaria of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.portalimobiliaria.count = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::count::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#create
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Creates a new instance in portalimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria.create = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::create::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#createMany
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Creates a new instance in portalimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria.createMany = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::createMany::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#destroyAll
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Deletes all portalimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portalimobiliaria.destroyAll = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::delete::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#destroyById
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Delete a related item by id for portalimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portalimobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portalimobiliaria.destroyById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::destroyById::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#findById
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Find a related item by id for portalimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portalimobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria.findById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::findById::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.portalimobiliaria#updateById
             * @methodOf lbServices.Portal.portalimobiliaria
             *
             * @description
             *
             * Update a related item by id for portalimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for portalimobiliaria
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria.updateById = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::updateById::Portal::portalimobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Portal.ordemimobiliaria
     * @header lbServices.Portal.ordemimobiliaria
     * @object
     * @description
     *
     * The object `Portal.ordemimobiliaria` groups methods
     * manipulating `PortalOrdemImobiliaria` instances related to `Portal`.
     *
     * Call {@link lbServices.Portal#ordemimobiliaria Portal.ordemimobiliaria()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Portal#ordemimobiliaria
             * @methodOf lbServices.Portal
             *
             * @description
             *
             * Queries ordemimobiliaria of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R.ordemimobiliaria = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::get::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#count
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Counts ordemimobiliaria of Portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.ordemimobiliaria.count = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::count::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#create
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Creates a new instance in ordemimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R.ordemimobiliaria.create = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::create::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#createMany
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Creates a new instance in ordemimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R.ordemimobiliaria.createMany = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::createMany::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#destroyAll
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Deletes all ordemimobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ordemimobiliaria.destroyAll = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::delete::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#destroyById
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Delete a related item by id for ordemimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for ordemimobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.ordemimobiliaria.destroyById = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::destroyById::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#findById
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Find a related item by id for ordemimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for ordemimobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R.ordemimobiliaria.findById = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::findById::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Portal.ordemimobiliaria#updateById
             * @methodOf lbServices.Portal.ordemimobiliaria
             *
             * @description
             *
             * Update a related item by id for ordemimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Portal id
             *
             *  - `fk` – `{*}` - Foreign key for ordemimobiliaria
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R.ordemimobiliaria.updateById = function() {
          var TargetResource = $injector.get("PortalOrdemImobiliaria");
          var action = TargetResource["::updateById::Portal::ordemimobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoLocacao
 * @header lbServices.TipoLocacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoLocacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoLocacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposlocacao/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#create
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposlocacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#createMany
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposlocacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#upsert
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposlocacao",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#replaceOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposlocacao/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#upsertWithWhere
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposlocacao/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#exists
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposlocacao/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#findById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposlocacao/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#replaceById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposlocacao/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#find
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposlocacao",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#findOne
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposlocacao/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#updateAll
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposlocacao/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#deleteById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposlocacao/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#count
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposlocacao/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#prototype$updateAttributes
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoLocacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposlocacao/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#createChangeStream
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposlocacao/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#create
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposlocacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#createMany
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposlocacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#upsert
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposlocacao",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#replaceOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposlocacao/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#upsertWithWhere
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposlocacao/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#exists
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposlocacao/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#findById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposlocacao/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#replaceById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposlocacao/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#find
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposlocacao",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#findOne
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposlocacao/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#updateAll
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposlocacao/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#deleteById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposlocacao/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#count
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposlocacao/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#prototype$updateAttributes
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoLocacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposlocacao/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#createChangeStream
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposlocacao/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#pager
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposlocacao/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#pagerDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposlocacao/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#postDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposlocacao/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#deleteDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposlocacao/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#editDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposlocacao/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#autocomplete
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposlocacao/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#autocompleteDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposlocacao/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#autocompleteDetailEdit
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposlocacao/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#autocompleteGeneral
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposlocacao/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#crudGET
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposlocacao/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#crudGETDetail
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposlocacao/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#quickAdd
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposlocacao/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.tipo_locacao() instead.
            "::get::Imovel::tipo_locacao": {
              url: urlBase + "/imoveis/:id/tipo_locacao",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#updateOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchOrCreateWithWhere
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#update
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#destroyById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#removeById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchAttributes
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoLocacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#updateOrCreate
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchOrCreateWithWhere
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#update
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#destroyById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#removeById
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoLocacao#patchAttributes
             * @methodOf lbServices.TipoLocacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoLocacao id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoLocacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoLocacao#modelName
        * @propertyOf lbServices.TipoLocacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoLocacao`.
        */
        R.modelName = "TipoLocacao";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelViewLog
 * @header lbServices.ImovelViewLog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelViewLog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelViewLog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelviewlogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelViewLog.log_imovel() instead.
            "prototype$__get__log_imovel": {
              url: urlBase + "/imovelviewlogs/:id/log_imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#create
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelviewlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#createMany
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelviewlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#upsert
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelviewlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#replaceOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelviewlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#upsertWithWhere
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelviewlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#exists
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelviewlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#findById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#replaceById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelviewlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#find
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelviewlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#findOne
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelviewlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#updateAll
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelviewlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#deleteById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#count
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelviewlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#prototype$updateAttributes
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelViewLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#createChangeStream
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelviewlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#create
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelviewlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#createMany
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelviewlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#upsert
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelviewlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#replaceOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelviewlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#upsertWithWhere
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelviewlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#exists
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelviewlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#findById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#replaceById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelviewlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#find
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelviewlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#findOne
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelviewlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#updateAll
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelviewlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#deleteById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#count
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelviewlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#prototype$updateAttributes
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelViewLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelviewlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#createChangeStream
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelviewlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#pager
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelviewlogs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#pagerDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelviewlogs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#postDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelviewlogs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#deleteDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelviewlogs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#editDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelviewlogs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#autocomplete
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelviewlogs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#autocompleteDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelviewlogs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#autocompleteDetailEdit
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelviewlogs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#autocompleteGeneral
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelviewlogs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#crudGET
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelviewlogs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#crudGETDetail
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelviewlogs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#quickAdd
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelviewlogs/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.log_views.findById() instead.
            "::findById::Imovel::log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views.destroyById() instead.
            "::destroyById::Imovel::log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.log_views.updateById() instead.
            "::updateById::Imovel::log_views": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/log_views/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.log_views() instead.
            "::get::Imovel::log_views": {
              isArray: true,
              url: urlBase + "/imoveis/:id/log_views",
              method: "GET",
            },

            // INTERNAL. Use Imovel.log_views.create() instead.
            "::create::Imovel::log_views": {
              url: urlBase + "/imoveis/:id/log_views",
              method: "POST",
            },

            // INTERNAL. Use Imovel.log_views.createMany() instead.
            "::createMany::Imovel::log_views": {
              isArray: true,
              url: urlBase + "/imoveis/:id/log_views",
              method: "POST",
            },

            // INTERNAL. Use Imovel.log_views.destroyAll() instead.
            "::delete::Imovel::log_views": {
              url: urlBase + "/imoveis/:id/log_views",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.log_views.count() instead.
            "::count::Imovel::log_views": {
              url: urlBase + "/imoveis/:id/log_views/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#updateOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#update
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#destroyById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#removeById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchAttributes
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelViewLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#updateOrCreate
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#update
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#destroyById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#removeById
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#patchAttributes
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelViewLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelViewLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelViewLog#modelName
        * @propertyOf lbServices.ImovelViewLog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelViewLog`.
        */
        R.modelName = "ImovelViewLog";


            /**
             * @ngdoc method
             * @name lbServices.ImovelViewLog#log_imovel
             * @methodOf lbServices.ImovelViewLog
             *
             * @description
             *
             * Fetches belongsTo relation log_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelViewLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.log_imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImovelViewLog::log_imovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelGarantia
 * @header lbServices.ImovelGarantia
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelGarantia` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelGarantia",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelgarantias/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelGarantia.gar_imovel() instead.
            "prototype$__get__gar_imovel": {
              url: urlBase + "/imovelgarantias/:id/gar_imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#create
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelgarantias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#createMany
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelgarantias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#upsert
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelgarantias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#replaceOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelgarantias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#upsertWithWhere
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelgarantias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#exists
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelgarantias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#findById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelgarantias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#replaceById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelgarantias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#find
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelgarantias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#findOne
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelgarantias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#updateAll
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelgarantias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#deleteById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelgarantias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#count
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelgarantias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#prototype$updateAttributes
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelGarantia id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelgarantias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#createChangeStream
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelgarantias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#create
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelgarantias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#createMany
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelgarantias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#upsert
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelgarantias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#replaceOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelgarantias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#upsertWithWhere
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelgarantias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#exists
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelgarantias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#findById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelgarantias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#replaceById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelgarantias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#find
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelgarantias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#findOne
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelgarantias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#updateAll
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelgarantias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#deleteById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelgarantias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#count
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelgarantias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#prototype$updateAttributes
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelGarantia id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelgarantias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#createChangeStream
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelgarantias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#pager
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelgarantias/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#pagerDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelgarantias/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#postDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelgarantias/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#deleteDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelgarantias/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#editDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelgarantias/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#autocomplete
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelgarantias/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#autocompleteDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelgarantias/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#autocompleteDetailEdit
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelgarantias/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#autocompleteGeneral
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelgarantias/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#crudGET
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelgarantias/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#crudGETDetail
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelgarantias/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#quickAdd
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelgarantias/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.garantias.findById() instead.
            "::findById::Imovel::garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.garantias.destroyById() instead.
            "::destroyById::Imovel::garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.garantias.updateById() instead.
            "::updateById::Imovel::garantias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/garantias/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.garantias() instead.
            "::get::Imovel::garantias": {
              isArray: true,
              url: urlBase + "/imoveis/:id/garantias",
              method: "GET",
            },

            // INTERNAL. Use Imovel.garantias.create() instead.
            "::create::Imovel::garantias": {
              url: urlBase + "/imoveis/:id/garantias",
              method: "POST",
            },

            // INTERNAL. Use Imovel.garantias.createMany() instead.
            "::createMany::Imovel::garantias": {
              isArray: true,
              url: urlBase + "/imoveis/:id/garantias",
              method: "POST",
            },

            // INTERNAL. Use Imovel.garantias.destroyAll() instead.
            "::delete::Imovel::garantias": {
              url: urlBase + "/imoveis/:id/garantias",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.garantias.count() instead.
            "::count::Imovel::garantias": {
              url: urlBase + "/imoveis/:id/garantias/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#updateOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#update
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#destroyById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#removeById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchAttributes
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelGarantia id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#updateOrCreate
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#update
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#destroyById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#removeById
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#patchAttributes
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelGarantia id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelGarantia` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelGarantia#modelName
        * @propertyOf lbServices.ImovelGarantia
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelGarantia`.
        */
        R.modelName = "ImovelGarantia";


            /**
             * @ngdoc method
             * @name lbServices.ImovelGarantia#gar_imovel
             * @methodOf lbServices.ImovelGarantia
             *
             * @description
             *
             * Fetches belongsTo relation gar_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelGarantia id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.gar_imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImovelGarantia::gar_imovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelTermos
 * @header lbServices.ImovelTermos
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelTermos` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelTermos",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelTermos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelTermos.terms_imovel() instead.
            "prototype$__get__terms_imovel": {
              url: urlBase + "/imovelTermos/:id/terms_imovel",
              method: "GET",
            },

            // INTERNAL. Use ImovelTermos.terms_imobiliaria() instead.
            "prototype$__get__terms_imobiliaria": {
              url: urlBase + "/imovelTermos/:id/terms_imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#create
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelTermos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#createMany
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelTermos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#upsert
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelTermos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#replaceOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelTermos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#upsertWithWhere
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelTermos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#exists
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelTermos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#findById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelTermos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#replaceById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelTermos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#find
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelTermos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#findOne
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelTermos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#updateAll
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelTermos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#deleteById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelTermos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#count
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelTermos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#prototype$updateAttributes
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelTermos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#createChangeStream
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelTermos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#create
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelTermos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#createMany
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelTermos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#upsert
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelTermos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#replaceOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelTermos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#upsertWithWhere
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelTermos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#exists
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelTermos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#findById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelTermos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#replaceById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelTermos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#find
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelTermos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#findOne
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelTermos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#updateAll
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelTermos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#deleteById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelTermos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#count
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelTermos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#prototype$updateAttributes
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelTermos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#createChangeStream
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelTermos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#pager
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelTermos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#pagerDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelTermos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#postDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelTermos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#deleteDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelTermos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#editDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelTermos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#autocomplete
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelTermos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#autocompleteDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelTermos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#autocompleteDetailEdit
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelTermos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#autocompleteGeneral
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelTermos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#crudGET
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelTermos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#crudGETDetail
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelTermos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#quickAdd
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelTermos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.terms_imovel.findById() instead.
            "::findById::Imovel::terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.terms_imovel.destroyById() instead.
            "::destroyById::Imovel::terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.terms_imovel.updateById() instead.
            "::updateById::Imovel::terms_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/terms_imovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.terms_imovel() instead.
            "::get::Imovel::terms_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.terms_imovel.create() instead.
            "::create::Imovel::terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.terms_imovel.createMany() instead.
            "::createMany::Imovel::terms_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.terms_imovel.destroyAll() instead.
            "::delete::Imovel::terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.terms_imovel.count() instead.
            "::count::Imovel::terms_imovel": {
              url: urlBase + "/imoveis/:id/terms_imovel/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#updateOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#update
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#destroyById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#removeById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchAttributes
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#updateOrCreate
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#update
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#destroyById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#removeById
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#patchAttributes
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelTermos` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelTermos#modelName
        * @propertyOf lbServices.ImovelTermos
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelTermos`.
        */
        R.modelName = "ImovelTermos";


            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#terms_imovel
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Fetches belongsTo relation terms_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.terms_imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImovelTermos::terms_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImovelTermos#terms_imobiliaria
             * @methodOf lbServices.ImovelTermos
             *
             * @description
             *
             * Fetches belongsTo relation terms_imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelTermos id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.terms_imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImovelTermos::terms_imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProprietarioImobiliaria
 * @header lbServices.ProprietarioImobiliaria
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProprietarioImobiliaria` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProprietarioImobiliaria",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/proprietarioimobiliarias/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ProprietarioImobiliaria.usuario() instead.
            "prototype$__get__usuario": {
              url: urlBase + "/proprietarioimobiliarias/:id/usuario",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/proprietarioimobiliarias/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.findById() instead.
            "prototype$__findById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.destroyById() instead.
            "prototype$__destroyById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.updateById() instead.
            "prototype$__updateById__telefones": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones() instead.
            "prototype$__get__telefones": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "GET",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.create() instead.
            "prototype$__create__telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "POST",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.destroyAll() instead.
            "prototype$__delete__telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones",
              method: "DELETE",
            },

            // INTERNAL. Use ProprietarioImobiliaria.telefones.count() instead.
            "prototype$__count__telefones": {
              url: urlBase + "/proprietarioimobiliarias/:id/telefones/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#create
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietarioimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#createMany
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#upsert
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietarioimobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#replaceOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietarioimobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#upsertWithWhere
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietarioimobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#exists
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietarioimobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#findById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#replaceById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietarioimobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#find
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#findOne
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietarioimobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#updateAll
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietarioimobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#deleteById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#count
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietarioimobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#createChangeStream
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietarioimobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#create
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietarioimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#createMany
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#upsert
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietarioimobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#replaceOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietarioimobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#upsertWithWhere
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietarioimobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#exists
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietarioimobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#findById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#replaceById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietarioimobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#find
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietarioimobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#findOne
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietarioimobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#updateAll
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietarioimobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#deleteById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#count
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietarioimobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietarioimobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#createChangeStream
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietarioimobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#pager
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/proprietarioimobiliarias/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#pagerDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#postDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#deleteDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#editDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#autocomplete
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/proprietarioimobiliarias/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#autocompleteDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#autocompleteDetailEdit
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/proprietarioimobiliarias/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#autocompleteGeneral
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/proprietarioimobiliarias/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#crudGET
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/proprietarioimobiliarias/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#crudGETDetail
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/proprietarioimobiliarias/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#quickAdd
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/proprietarioimobiliarias/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.prop_imob.findById() instead.
            "::findById::Usuario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.prop_imob.destroyById() instead.
            "::destroyById::Usuario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.prop_imob.updateById() instead.
            "::updateById::Usuario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.prop_imob() instead.
            "::get::Usuario::prop_imob": {
              isArray: true,
              url: urlBase + "/users/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Usuario.prop_imob.create() instead.
            "::create::Usuario::prop_imob": {
              url: urlBase + "/users/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Usuario.prop_imob.createMany() instead.
            "::createMany::Usuario::prop_imob": {
              isArray: true,
              url: urlBase + "/users/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Usuario.prop_imob.destroyAll() instead.
            "::delete::Usuario::prop_imob": {
              url: urlBase + "/users/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.prop_imob.count() instead.
            "::count::Usuario::prop_imob": {
              url: urlBase + "/users/:id/prop_imob/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob.findById() instead.
            "::findById::Corretor::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob.destroyById() instead.
            "::destroyById::Corretor::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.prop_imob.updateById() instead.
            "::updateById::Corretor::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.prop_imob() instead.
            "::get::Corretor::prop_imob": {
              isArray: true,
              url: urlBase + "/corretores/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Corretor.prop_imob.create() instead.
            "::create::Corretor::prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Corretor.prop_imob.createMany() instead.
            "::createMany::Corretor::prop_imob": {
              isArray: true,
              url: urlBase + "/corretores/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Corretor.prop_imob.destroyAll() instead.
            "::delete::Corretor::prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.prop_imob.count() instead.
            "::count::Corretor::prop_imob": {
              url: urlBase + "/corretores/:id/prop_imob/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob.findById() instead.
            "::findById::Proprietario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob.destroyById() instead.
            "::destroyById::Proprietario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.prop_imob.updateById() instead.
            "::updateById::Proprietario::prop_imob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/prop_imob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.prop_imob() instead.
            "::get::Proprietario::prop_imob": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.prop_imob.create() instead.
            "::create::Proprietario::prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.prop_imob.createMany() instead.
            "::createMany::Proprietario::prop_imob": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.prop_imob.destroyAll() instead.
            "::delete::Proprietario::prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.prop_imob.count() instead.
            "::count::Proprietario::prop_imob": {
              url: urlBase + "/proprietarios/:id/prop_imob/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#updateOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#update
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#destroyById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#removeById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchAttributes
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#updateOrCreate
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#update
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#destroyById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#removeById
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#patchAttributes
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ProprietarioImobiliaria#modelName
        * @propertyOf lbServices.ProprietarioImobiliaria
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProprietarioImobiliaria`.
        */
        R.modelName = "ProprietarioImobiliaria";


            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#usuario
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.usuario = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::ProprietarioImobiliaria::usuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#imobiliaria
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ProprietarioImobiliaria::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ProprietarioImobiliaria.telefones
     * @header lbServices.ProprietarioImobiliaria.telefones
     * @object
     * @description
     *
     * The object `ProprietarioImobiliaria.telefones` groups methods
     * manipulating `Telefone` instances related to `ProprietarioImobiliaria`.
     *
     * Call {@link lbServices.ProprietarioImobiliaria#telefones ProprietarioImobiliaria.telefones()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria#telefones
             * @methodOf lbServices.ProprietarioImobiliaria
             *
             * @description
             *
             * Queries telefones of ProprietarioImobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::get::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#count
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Counts telefones of ProprietarioImobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.telefones.count = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::count::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#create
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.create = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::create::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#createMany
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Creates a new instance in telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.createMany = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::createMany::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#destroyAll
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Deletes all telefones of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyAll = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::delete::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#destroyById
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Delete a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.telefones.destroyById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::destroyById::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#findById
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Find a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.findById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::findById::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioImobiliaria.telefones#updateById
             * @methodOf lbServices.ProprietarioImobiliaria.telefones
             *
             * @description
             *
             * Update a related item by id for telefones.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioImobiliaria id
             *
             *  - `fk` – `{*}` - Foreign key for telefones
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Telefone` object.)
             * </em>
             */
        R.telefones.updateById = function() {
          var TargetResource = $injector.get("Telefone");
          var action = TargetResource["::updateById::ProprietarioImobiliaria::telefones"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelPrioridade
 * @header lbServices.ImovelPrioridade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelPrioridade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelPrioridade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelprioridades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelPrioridade.tipo_imovel() instead.
            "prototype$__get__tipo_imovel": {
              url: urlBase + "/imovelprioridades/:id/tipo_imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#create
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelprioridades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#createMany
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelprioridades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#upsert
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelprioridades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#replaceOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelprioridades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#upsertWithWhere
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelprioridades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#exists
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelprioridades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#findById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelprioridades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#replaceById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelprioridades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#find
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelprioridades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#findOne
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelprioridades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#updateAll
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelprioridades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#deleteById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelprioridades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#count
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelprioridades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#prototype$updateAttributes
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPrioridade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelprioridades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#createChangeStream
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelprioridades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#create
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelprioridades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#createMany
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelprioridades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#upsert
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelprioridades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#replaceOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelprioridades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#upsertWithWhere
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelprioridades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#exists
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelprioridades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#findById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelprioridades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#replaceById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelprioridades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#find
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelprioridades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#findOne
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelprioridades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#updateAll
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelprioridades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#deleteById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelprioridades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#count
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelprioridades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#prototype$updateAttributes
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPrioridade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelprioridades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#createChangeStream
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelprioridades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#pager
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelprioridades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#pagerDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelprioridades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#postDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelprioridades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#deleteDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelprioridades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#editDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelprioridades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#autocomplete
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelprioridades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#autocompleteDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelprioridades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#autocompleteDetailEdit
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelprioridades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#autocompleteGeneral
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelprioridades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#crudGET
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelprioridades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#crudGETDetail
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelprioridades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#quickAdd
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelprioridades/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#updateOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#update
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#destroyById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#removeById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchAttributes
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPrioridade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#updateOrCreate
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#update
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#destroyById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#removeById
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#patchAttributes
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPrioridade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPrioridade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelPrioridade#modelName
        * @propertyOf lbServices.ImovelPrioridade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelPrioridade`.
        */
        R.modelName = "ImovelPrioridade";


            /**
             * @ngdoc method
             * @name lbServices.ImovelPrioridade#tipo_imovel
             * @methodOf lbServices.ImovelPrioridade
             *
             * @description
             *
             * Fetches belongsTo relation tipo_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPrioridade id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R.tipo_imovel = function() {
          var TargetResource = $injector.get("TipoImovel");
          var action = TargetResource["::get::ImovelPrioridade::tipo_imovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Proposta
 * @header lbServices.Proposta
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Proposta` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Proposta",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Proposta.propImovel() instead.
            "prototype$__get__propImovel": {
              url: urlBase + "/propostas/:id/propImovel",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propTipoNegocio() instead.
            "prototype$__get__propTipoNegocio": {
              url: urlBase + "/propostas/:id/propTipoNegocio",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propImobiliaria() instead.
            "prototype$__get__propImobiliaria": {
              url: urlBase + "/propostas/:id/propImobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propGestor() instead.
            "prototype$__get__propGestor": {
              url: urlBase + "/propostas/:id/propGestor",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propCorretor() instead.
            "prototype$__get__propCorretor": {
              url: urlBase + "/propostas/:id/propCorretor",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatus() instead.
            "prototype$__get__propStatus": {
              url: urlBase + "/propostas/:id/propStatus",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog.findById() instead.
            "prototype$__findById__propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog.destroyById() instead.
            "prototype$__destroyById__propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propStatusLog.updateById() instead.
            "prototype$__updateById__propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propPartes.findById() instead.
            "prototype$__findById__propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propPartes.destroyById() instead.
            "prototype$__destroyById__propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propPartes.updateById() instead.
            "prototype$__updateById__propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propAnexos.findById() instead.
            "prototype$__findById__propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propAnexos.destroyById() instead.
            "prototype$__destroyById__propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propAnexos.updateById() instead.
            "prototype$__updateById__propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propTipoNegocioModalidade() instead.
            "prototype$__get__propTipoNegocioModalidade": {
              url: urlBase + "/propostas/:id/propTipoNegocioModalidade",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog() instead.
            "prototype$__get__propStatusLog": {
              isArray: true,
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog.create() instead.
            "prototype$__create__propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propStatusLog.destroyAll() instead.
            "prototype$__delete__propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propStatusLog.count() instead.
            "prototype$__count__propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog/count",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propPartes() instead.
            "prototype$__get__propPartes": {
              isArray: true,
              url: urlBase + "/propostas/:id/propPartes",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propPartes.create() instead.
            "prototype$__create__propPartes": {
              url: urlBase + "/propostas/:id/propPartes",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propPartes.destroyAll() instead.
            "prototype$__delete__propPartes": {
              url: urlBase + "/propostas/:id/propPartes",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propPartes.count() instead.
            "prototype$__count__propPartes": {
              url: urlBase + "/propostas/:id/propPartes/count",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propAnexos() instead.
            "prototype$__get__propAnexos": {
              isArray: true,
              url: urlBase + "/propostas/:id/propAnexos",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propAnexos.create() instead.
            "prototype$__create__propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propAnexos.destroyAll() instead.
            "prototype$__delete__propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propAnexos.count() instead.
            "prototype$__count__propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#create
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#createMany
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#upsert
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#replaceOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#upsertWithWhere
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#exists
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#findById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#replaceById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#find
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#findOne
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#updateAll
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#deleteById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#count
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#prototype$updateAttributes
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#createChangeStream
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#createSite
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create proposta
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "createSite": {
              url: urlBase + "/propostas/save",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#newProposta
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create proposta
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "newProposta": {
              url: urlBase + "/propostas/save-proposta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#reseendemail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find Proposta
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "reseendemail": {
              url: urlBase + "/propostas/reseendemail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#findProposta
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find Proposta
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "findProposta": {
              url: urlBase + "/propostas/get",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#statusByHash
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `hash` – `{*}` - Proposta External Id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "statusByHash": {
              url: urlBase + "/propostas/status/:hash",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#getCorretorPropostas
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Corretor Id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "getCorretorPropostas": {
              url: urlBase + "/propostas/corretor/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#saveSite
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Save proposta
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "saveSite": {
              url: urlBase + "/propostas/save1",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#create
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#createMany
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#upsert
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#replaceOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#upsertWithWhere
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#exists
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#findById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#replaceById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#find
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#findOne
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#updateAll
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#deleteById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#count
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#prototype$updateAttributes
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#createChangeStream
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#pager
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#pagerDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#postDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#deleteDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#editDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#autocomplete
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#autocompleteDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#autocompleteDetailEdit
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#autocompleteGeneral
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#crudGET
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#crudGETDetail
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Proposta#quickAdd
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostas/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use PropostaStatusLog.logProposta() instead.
            "::get::PropostaStatusLog::logProposta": {
              url: urlBase + "/propostastatuslogs/:id/logProposta",
              method: "GET",
            },

            // INTERNAL. Use PropostaAnexo.proposta() instead.
            "::get::PropostaAnexo::proposta": {
              url: urlBase + "/propostasanexo/:id/proposta",
              method: "GET",
            },

            // INTERNAL. Use PropostaAllLog.logProposta() instead.
            "::get::PropostaAllLog::logProposta": {
              url: urlBase + "/propostaalllogs/:id/logProposta",
              method: "GET",
            },

            // INTERNAL. Use LogErrorProposta.proposta() instead.
            "::get::LogErrorProposta::proposta": {
              url: urlBase + "/logerrorproposta/:id/proposta",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#updateOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchOrCreateWithWhere
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#update
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#destroyById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#removeById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchAttributes
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#updateOrCreate
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchOrCreateWithWhere
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#update
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#destroyById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#removeById
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Proposta#patchAttributes
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Proposta#modelName
        * @propertyOf lbServices.Proposta
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Proposta`.
        */
        R.modelName = "Proposta";


            /**
             * @ngdoc method
             * @name lbServices.Proposta#propImovel
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propImovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.propImovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::Proposta::propImovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propTipoNegocio
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propTipoNegocio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.propTipoNegocio = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::Proposta::propTipoNegocio"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propImobiliaria
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propImobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.propImobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Proposta::propImobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propGestor
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propGestor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.propGestor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::Proposta::propGestor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propCorretor
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propCorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.propCorretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::Proposta::propCorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propStatus
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propStatus.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R.propStatus = function() {
          var TargetResource = $injector.get("PropostaStatus");
          var action = TargetResource["::get::Proposta::propStatus"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proposta.propStatusLog
     * @header lbServices.Proposta.propStatusLog
     * @object
     * @description
     *
     * The object `Proposta.propStatusLog` groups methods
     * manipulating `PropostaStatusLog` instances related to `Proposta`.
     *
     * Call {@link lbServices.Proposta#propStatusLog Proposta.propStatusLog()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proposta#propStatusLog
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Queries propStatusLog of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R.propStatusLog = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::get::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#count
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Counts propStatusLog of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.propStatusLog.count = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::count::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#create
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Creates a new instance in propStatusLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R.propStatusLog.create = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::create::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#createMany
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Creates a new instance in propStatusLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R.propStatusLog.createMany = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::createMany::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#destroyAll
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Deletes all propStatusLog of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propStatusLog.destroyAll = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::delete::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#destroyById
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Delete a related item by id for propStatusLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propStatusLog
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propStatusLog.destroyById = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::destroyById::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#findById
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Find a related item by id for propStatusLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propStatusLog
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R.propStatusLog.findById = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::findById::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propStatusLog#updateById
             * @methodOf lbServices.Proposta.propStatusLog
             *
             * @description
             *
             * Update a related item by id for propStatusLog.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `fk` – `{*}` - Foreign key for propStatusLog
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R.propStatusLog.updateById = function() {
          var TargetResource = $injector.get("PropostaStatusLog");
          var action = TargetResource["::updateById::Proposta::propStatusLog"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proposta.propPartes
     * @header lbServices.Proposta.propPartes
     * @object
     * @description
     *
     * The object `Proposta.propPartes` groups methods
     * manipulating `PropostaParte` instances related to `Proposta`.
     *
     * Call {@link lbServices.Proposta#propPartes Proposta.propPartes()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proposta#propPartes
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Queries propPartes of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.propPartes = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::get::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#count
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Counts propPartes of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.propPartes.count = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::count::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#create
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Creates a new instance in propPartes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.propPartes.create = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::create::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#createMany
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Creates a new instance in propPartes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.propPartes.createMany = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::createMany::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#destroyAll
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Deletes all propPartes of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propPartes.destroyAll = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::delete::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#destroyById
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Delete a related item by id for propPartes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propPartes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propPartes.destroyById = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::destroyById::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#findById
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Find a related item by id for propPartes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propPartes
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.propPartes.findById = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::findById::Proposta::propPartes"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propPartes#updateById
             * @methodOf lbServices.Proposta.propPartes
             *
             * @description
             *
             * Update a related item by id for propPartes.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `fk` – `{*}` - Foreign key for propPartes
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.propPartes.updateById = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::updateById::Proposta::propPartes"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Proposta.propAnexos
     * @header lbServices.Proposta.propAnexos
     * @object
     * @description
     *
     * The object `Proposta.propAnexos` groups methods
     * manipulating `PropostaAnexo` instances related to `Proposta`.
     *
     * Call {@link lbServices.Proposta#propAnexos Proposta.propAnexos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Proposta#propAnexos
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Queries propAnexos of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R.propAnexos = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::get::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#count
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Counts propAnexos of Proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.propAnexos.count = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::count::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#create
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Creates a new instance in propAnexos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R.propAnexos.create = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::create::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#createMany
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Creates a new instance in propAnexos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R.propAnexos.createMany = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::createMany::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#destroyAll
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Deletes all propAnexos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propAnexos.destroyAll = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::delete::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#destroyById
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Delete a related item by id for propAnexos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propAnexos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.propAnexos.destroyById = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::destroyById::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#findById
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Find a related item by id for propAnexos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for propAnexos
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R.propAnexos.findById = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::findById::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta.propAnexos#updateById
             * @methodOf lbServices.Proposta.propAnexos
             *
             * @description
             *
             * Update a related item by id for propAnexos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `fk` – `{*}` - Foreign key for propAnexos
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R.propAnexos.updateById = function() {
          var TargetResource = $injector.get("PropostaAnexo");
          var action = TargetResource["::updateById::Proposta::propAnexos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Proposta#propTipoNegocioModalidade
             * @methodOf lbServices.Proposta
             *
             * @description
             *
             * Fetches belongsTo relation propTipoNegocioModalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Proposta id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R.propTipoNegocioModalidade = function() {
          var TargetResource = $injector.get("TipoNegocioModalidade");
          var action = TargetResource["::get::Proposta::propTipoNegocioModalidade"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaTipoParte
 * @header lbServices.PropostaTipoParte
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaTipoParte` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaTipoParte",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostatiposparte/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#create
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposparte",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#createMany
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposparte",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#upsert
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposparte",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#replaceOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposparte/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#upsertWithWhere
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposparte/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#exists
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposparte/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#findById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposparte/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#replaceById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposparte/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#find
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposparte",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#findOne
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposparte/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#updateAll
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposparte/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#deleteById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposparte/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#count
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposparte/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposparte/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#createChangeStream
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposparte/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#create
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposparte",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#createMany
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposparte",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#upsert
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposparte",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#replaceOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposparte/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#upsertWithWhere
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposparte/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#exists
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposparte/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#findById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposparte/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#replaceById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposparte/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#find
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposparte",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#findOne
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposparte/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#updateAll
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposparte/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#deleteById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposparte/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#count
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposparte/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposparte/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#createChangeStream
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposparte/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#pager
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostatiposparte/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#pagerDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostatiposparte/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#postDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostatiposparte/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#deleteDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostatiposparte/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#editDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostatiposparte/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#autocomplete
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostatiposparte/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#autocompleteDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostatiposparte/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#autocompleteDetailEdit
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostatiposparte/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#autocompleteGeneral
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostatiposparte/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#crudGET
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostatiposparte/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#crudGETDetail
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostatiposparte/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#quickAdd
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostatiposparte/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoParteTipo() instead.
            "::get::PropostaTipoAnexo::tipoParteTipo": {
              url: urlBase + "/propostatiposanexo/:id/tipoParteTipo",
              method: "GET",
            },

            // INTERNAL. Use PropostaParte.partTipo() instead.
            "::get::PropostaParte::partTipo": {
              url: urlBase + "/propostapartes/:id/partTipo",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowPerfil() instead.
            "::get::PropostaWorkflow::flowPerfil": {
              url: urlBase + "/propostasworkflow/:id/flowPerfil",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#updateOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#update
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#destroyById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#removeById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchAttributes
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#updateOrCreate
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#update
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#destroyById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#removeById
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoParte#patchAttributes
             * @methodOf lbServices.PropostaTipoParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaTipoParte#modelName
        * @propertyOf lbServices.PropostaTipoParte
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaTipoParte`.
        */
        R.modelName = "PropostaTipoParte";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaTipoAnexo
 * @header lbServices.PropostaTipoAnexo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaTipoAnexo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaTipoAnexo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostatiposanexo/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaTipoAnexo.tipoParteTipo() instead.
            "prototype$__get__tipoParteTipo": {
              url: urlBase + "/propostatiposanexo/:id/tipoParteTipo",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.findById() instead.
            "prototype$__findById__tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.destroyById() instead.
            "prototype$__destroyById__tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.updateById() instead.
            "prototype$__updateById__tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoNegocioAnexo() instead.
            "prototype$__get__tipoNegocioAnexo": {
              url: urlBase + "/propostatiposanexo/:id/tipoNegocioAnexo",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob() instead.
            "prototype$__get__tipoAnexoImob": {
              isArray: true,
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.create() instead.
            "prototype$__create__tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.destroyAll() instead.
            "prototype$__delete__tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "DELETE",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.count() instead.
            "prototype$__count__tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#create
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#createMany
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#upsert
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposanexo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#replaceOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposanexo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#upsertWithWhere
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposanexo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#exists
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposanexo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#findById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#replaceById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposanexo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#find
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposanexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#findOne
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposanexo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#updateAll
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposanexo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#deleteById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#count
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposanexo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#createChangeStream
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposanexo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#getTipoAnexos
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Get
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "getTipoAnexos": {
              isArray: true,
              url: urlBase + "/propostatiposanexo/get-tipo-anexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#create
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#createMany
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#upsert
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposanexo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#replaceOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposanexo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#upsertWithWhere
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposanexo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#exists
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposanexo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#findById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#replaceById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposanexo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#find
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposanexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#findOne
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposanexo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#updateAll
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposanexo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#deleteById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#count
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposanexo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposanexo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#createChangeStream
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposanexo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#pager
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostatiposanexo/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#pagerDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostatiposanexo/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#postDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostatiposanexo/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#deleteDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostatiposanexo/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#editDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostatiposanexo/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#autocomplete
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostatiposanexo/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#autocompleteDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostatiposanexo/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#autocompleteDetailEdit
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostatiposanexo/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#autocompleteGeneral
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostatiposanexo/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#crudGET
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostatiposanexo/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#crudGETDetail
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostatiposanexo/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#quickAdd
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostatiposanexo/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexoImob.tipoAnexo() instead.
            "::get::PropostaTipoAnexoImob::tipoAnexo": {
              url: urlBase + "/propostatiposanexoimob/:id/tipoAnexo",
              method: "GET",
            },

            // INTERNAL. Use PropostaAnexo.tipoAnexo() instead.
            "::get::PropostaAnexo::tipoAnexo": {
              url: urlBase + "/propostasanexo/:id/tipoAnexo",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#updateOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#update
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#destroyById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#removeById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchAttributes
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#updateOrCreate
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#update
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#destroyById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#removeById
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#patchAttributes
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaTipoAnexo#modelName
        * @propertyOf lbServices.PropostaTipoAnexo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaTipoAnexo`.
        */
        R.modelName = "PropostaTipoAnexo";


            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#tipoParteTipo
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Fetches belongsTo relation tipoParteTipo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R.tipoParteTipo = function() {
          var TargetResource = $injector.get("PropostaTipoParte");
          var action = TargetResource["::get::PropostaTipoAnexo::tipoParteTipo"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.PropostaTipoAnexo.tipoAnexoImob
     * @header lbServices.PropostaTipoAnexo.tipoAnexoImob
     * @object
     * @description
     *
     * The object `PropostaTipoAnexo.tipoAnexoImob` groups methods
     * manipulating `PropostaTipoAnexoImob` instances related to `PropostaTipoAnexo`.
     *
     * Call {@link lbServices.PropostaTipoAnexo#tipoAnexoImob PropostaTipoAnexo.tipoAnexoImob()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#tipoAnexoImob
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Queries tipoAnexoImob of PropostaTipoAnexo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R.tipoAnexoImob = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::get::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#count
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Counts tipoAnexoImob of PropostaTipoAnexo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tipoAnexoImob.count = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::count::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#create
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Creates a new instance in tipoAnexoImob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R.tipoAnexoImob.create = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::create::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#createMany
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Creates a new instance in tipoAnexoImob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R.tipoAnexoImob.createMany = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::createMany::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#destroyAll
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Deletes all tipoAnexoImob of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tipoAnexoImob.destroyAll = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::delete::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#destroyById
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Delete a related item by id for tipoAnexoImob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `fk` – `{*}` - Foreign key for tipoAnexoImob
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tipoAnexoImob.destroyById = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::destroyById::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#findById
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Find a related item by id for tipoAnexoImob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `fk` – `{*}` - Foreign key for tipoAnexoImob
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R.tipoAnexoImob.findById = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::findById::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo.tipoAnexoImob#updateById
             * @methodOf lbServices.PropostaTipoAnexo.tipoAnexoImob
             *
             * @description
             *
             * Update a related item by id for tipoAnexoImob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `fk` – `{*}` - Foreign key for tipoAnexoImob
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R.tipoAnexoImob.updateById = function() {
          var TargetResource = $injector.get("PropostaTipoAnexoImob");
          var action = TargetResource["::updateById::PropostaTipoAnexo::tipoAnexoImob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexo#tipoNegocioAnexo
             * @methodOf lbServices.PropostaTipoAnexo
             *
             * @description
             *
             * Fetches belongsTo relation tipoNegocioAnexo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexo id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R.tipoNegocioAnexo = function() {
          var TargetResource = $injector.get("TipoNegocioModalidade");
          var action = TargetResource["::get::PropostaTipoAnexo::tipoNegocioAnexo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaTipoAnexoImob
 * @header lbServices.PropostaTipoAnexoImob
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaTipoAnexoImob` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaTipoAnexoImob",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostatiposanexoimob/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaTipoAnexoImob.imob() instead.
            "prototype$__get__imob": {
              url: urlBase + "/propostatiposanexoimob/:id/imob",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexoImob.tipoAnexo() instead.
            "prototype$__get__tipoAnexo": {
              url: urlBase + "/propostatiposanexoimob/:id/tipoAnexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#create
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposanexoimob",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#createMany
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposanexoimob",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#upsert
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposanexoimob",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#replaceOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposanexoimob/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#upsertWithWhere
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposanexoimob/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#exists
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposanexoimob/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#findById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#replaceById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposanexoimob/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#find
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposanexoimob",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#findOne
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposanexoimob/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#updateAll
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposanexoimob/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#deleteById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#count
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposanexoimob/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#createChangeStream
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposanexoimob/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#create
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostatiposanexoimob",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#createMany
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostatiposanexoimob",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#upsert
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostatiposanexoimob",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#replaceOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostatiposanexoimob/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#upsertWithWhere
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostatiposanexoimob/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#exists
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostatiposanexoimob/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#findById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#replaceById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostatiposanexoimob/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#find
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostatiposanexoimob",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#findOne
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostatiposanexoimob/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#updateAll
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostatiposanexoimob/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#deleteById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#count
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostatiposanexoimob/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#prototype$updateAttributes
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostatiposanexoimob/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#createChangeStream
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostatiposanexoimob/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#pager
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostatiposanexoimob/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#pagerDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#postDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#deleteDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#editDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#autocomplete
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostatiposanexoimob/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#autocompleteDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#autocompleteDetailEdit
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostatiposanexoimob/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#autocompleteGeneral
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostatiposanexoimob/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#crudGET
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostatiposanexoimob/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#crudGETDetail
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostatiposanexoimob/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#quickAdd
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostatiposanexoimob/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.findById() instead.
            "::findById::PropostaTipoAnexo::tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.destroyById() instead.
            "::destroyById::PropostaTipoAnexo::tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.updateById() instead.
            "::updateById::PropostaTipoAnexo::tipoAnexoImob": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/:fk",
              method: "PUT",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob() instead.
            "::get::PropostaTipoAnexo::tipoAnexoImob": {
              isArray: true,
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.create() instead.
            "::create::PropostaTipoAnexo::tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.createMany() instead.
            "::createMany::PropostaTipoAnexo::tipoAnexoImob": {
              isArray: true,
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "POST",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.destroyAll() instead.
            "::delete::PropostaTipoAnexo::tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob",
              method: "DELETE",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoAnexoImob.count() instead.
            "::count::PropostaTipoAnexo::tipoAnexoImob": {
              url: urlBase + "/propostatiposanexo/:id/tipoAnexoImob/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#updateOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#update
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#destroyById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#removeById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchAttributes
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#updateOrCreate
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#update
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#destroyById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#removeById
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#patchAttributes
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexoImob` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaTipoAnexoImob#modelName
        * @propertyOf lbServices.PropostaTipoAnexoImob
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaTipoAnexoImob`.
        */
        R.modelName = "PropostaTipoAnexoImob";


            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#imob
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Fetches belongsTo relation imob.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imob = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::PropostaTipoAnexoImob::imob"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaTipoAnexoImob#tipoAnexo
             * @methodOf lbServices.PropostaTipoAnexoImob
             *
             * @description
             *
             * Fetches belongsTo relation tipoAnexo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaTipoAnexoImob id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R.tipoAnexo = function() {
          var TargetResource = $injector.get("PropostaTipoAnexo");
          var action = TargetResource["::get::PropostaTipoAnexoImob::tipoAnexo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaStatus
 * @header lbServices.PropostaStatus
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaStatus` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaStatus",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostasstatus/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaStatus.propTipoNegocio() instead.
            "prototype$__get__propTipoNegocio": {
              url: urlBase + "/propostasstatus/:id/propTipoNegocio",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#create
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasstatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#createMany
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasstatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#upsert
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasstatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#replaceOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasstatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#upsertWithWhere
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasstatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#exists
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasstatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#findById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasstatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#replaceById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasstatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#find
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasstatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#findOne
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasstatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#updateAll
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasstatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#deleteById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasstatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#count
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasstatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#prototype$updateAttributes
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasstatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#createChangeStream
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasstatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#create
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasstatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#createMany
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasstatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#upsert
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasstatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#replaceOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasstatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#upsertWithWhere
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasstatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#exists
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasstatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#findById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasstatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#replaceById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasstatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#find
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasstatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#findOne
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasstatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#updateAll
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasstatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#deleteById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasstatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#count
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasstatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#prototype$updateAttributes
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasstatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#createChangeStream
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasstatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#pager
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostasstatus/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#pagerDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostasstatus/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#postDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostasstatus/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#deleteDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostasstatus/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#editDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostasstatus/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#autocomplete
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostasstatus/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#autocompleteDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostasstatus/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#autocompleteDetailEdit
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostasstatus/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#autocompleteGeneral
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostasstatus/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#crudGET
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostasstatus/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#crudGETDetail
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostasstatus/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#quickAdd
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostasstatus/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propStatus() instead.
            "::get::Proposta::propStatus": {
              url: urlBase + "/propostas/:id/propStatus",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logStatus() instead.
            "::get::PropostaStatusLog::logStatus": {
              url: urlBase + "/propostastatuslogs/:id/logStatus",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusOrigem() instead.
            "::get::PropostaWorkflow::flowStatusOrigem": {
              url: urlBase + "/propostasworkflow/:id/flowStatusOrigem",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusDestino() instead.
            "::get::PropostaWorkflow::flowStatusDestino": {
              url: urlBase + "/propostasworkflow/:id/flowStatusDestino",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusNext() instead.
            "::get::PropostaWorkflow::flowStatusNext": {
              url: urlBase + "/propostasworkflow/:id/flowStatusNext",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#updateOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#update
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#destroyById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#removeById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchAttributes
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#updateOrCreate
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#update
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#destroyById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#removeById
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#patchAttributes
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaStatus#modelName
        * @propertyOf lbServices.PropostaStatus
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaStatus`.
        */
        R.modelName = "PropostaStatus";


            /**
             * @ngdoc method
             * @name lbServices.PropostaStatus#propTipoNegocio
             * @methodOf lbServices.PropostaStatus
             *
             * @description
             *
             * Fetches belongsTo relation propTipoNegocio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatus id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.propTipoNegocio = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::PropostaStatus::propTipoNegocio"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaStatusLog
 * @header lbServices.PropostaStatusLog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaStatusLog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaStatusLog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostastatuslogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaStatusLog.logStatus() instead.
            "prototype$__get__logStatus": {
              url: urlBase + "/propostastatuslogs/:id/logStatus",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logProposta() instead.
            "prototype$__get__logProposta": {
              url: urlBase + "/propostastatuslogs/:id/logProposta",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logUsuario() instead.
            "prototype$__get__logUsuario": {
              url: urlBase + "/propostastatuslogs/:id/logUsuario",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logParte() instead.
            "prototype$__get__logParte": {
              url: urlBase + "/propostastatuslogs/:id/logParte",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#create
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostastatuslogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#createMany
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostastatuslogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#upsert
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostastatuslogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#replaceOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostastatuslogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#upsertWithWhere
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostastatuslogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#exists
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostastatuslogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#findById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#replaceById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostastatuslogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#find
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostastatuslogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#findOne
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostastatuslogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#updateAll
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostastatuslogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#deleteById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#count
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostastatuslogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#prototype$updateAttributes
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#createChangeStream
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostastatuslogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#create
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostastatuslogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#createMany
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostastatuslogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#upsert
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostastatuslogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#replaceOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostastatuslogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#upsertWithWhere
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostastatuslogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#exists
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostastatuslogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#findById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#replaceById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostastatuslogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#find
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostastatuslogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#findOne
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostastatuslogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#updateAll
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostastatuslogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#deleteById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#count
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostastatuslogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#prototype$updateAttributes
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostastatuslogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#createChangeStream
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostastatuslogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#pager
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostastatuslogs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#pagerDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostastatuslogs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#postDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostastatuslogs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#deleteDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostastatuslogs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#editDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostastatuslogs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#autocomplete
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostastatuslogs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#autocompleteDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostastatuslogs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#autocompleteDetailEdit
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostastatuslogs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#autocompleteGeneral
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostastatuslogs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#crudGET
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostastatuslogs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#crudGETDetail
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostastatuslogs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#quickAdd
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostastatuslogs/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propStatusLog.findById() instead.
            "::findById::Proposta::propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog.destroyById() instead.
            "::destroyById::Proposta::propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propStatusLog.updateById() instead.
            "::updateById::Proposta::propStatusLog": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propStatusLog/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propStatusLog() instead.
            "::get::Proposta::propStatusLog": {
              isArray: true,
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propStatusLog.create() instead.
            "::create::Proposta::propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propStatusLog.createMany() instead.
            "::createMany::Proposta::propStatusLog": {
              isArray: true,
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propStatusLog.destroyAll() instead.
            "::delete::Proposta::propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propStatusLog.count() instead.
            "::count::Proposta::propStatusLog": {
              url: urlBase + "/propostas/:id/propStatusLog/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#updateOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#update
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#destroyById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#removeById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchAttributes
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#updateOrCreate
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#update
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#destroyById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#removeById
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#patchAttributes
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatusLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaStatusLog#modelName
        * @propertyOf lbServices.PropostaStatusLog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaStatusLog`.
        */
        R.modelName = "PropostaStatusLog";


            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#logStatus
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Fetches belongsTo relation logStatus.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R.logStatus = function() {
          var TargetResource = $injector.get("PropostaStatus");
          var action = TargetResource["::get::PropostaStatusLog::logStatus"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#logProposta
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Fetches belongsTo relation logProposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R.logProposta = function() {
          var TargetResource = $injector.get("Proposta");
          var action = TargetResource["::get::PropostaStatusLog::logProposta"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#logUsuario
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Fetches belongsTo relation logUsuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.logUsuario = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::PropostaStatusLog::logUsuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaStatusLog#logParte
             * @methodOf lbServices.PropostaStatusLog
             *
             * @description
             *
             * Fetches belongsTo relation logParte.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaStatusLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.logParte = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::get::PropostaStatusLog::logParte"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaParte
 * @header lbServices.PropostaParte
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaParte` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaParte",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostapartes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaParte.partTipo() instead.
            "prototype$__get__partTipo": {
              url: urlBase + "/propostapartes/:id/partTipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#create
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostapartes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#createMany
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostapartes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#upsert
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostapartes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#replaceOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostapartes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#upsertWithWhere
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostapartes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#exists
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostapartes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#findById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostapartes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#replaceById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostapartes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#find
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostapartes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#findOne
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostapartes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#updateAll
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostapartes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#deleteById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostapartes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#count
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostapartes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#prototype$updateAttributes
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostapartes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#createChangeStream
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostapartes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#create
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostapartes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#createMany
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostapartes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#upsert
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostapartes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#replaceOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostapartes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#upsertWithWhere
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostapartes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#exists
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostapartes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#findById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostapartes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#replaceById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostapartes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#find
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostapartes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#findOne
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostapartes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#updateAll
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostapartes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#deleteById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostapartes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#count
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostapartes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#prototype$updateAttributes
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostapartes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#createChangeStream
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostapartes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#pager
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostapartes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#pagerDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostapartes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#postDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostapartes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#deleteDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostapartes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#editDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostapartes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#autocomplete
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostapartes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#autocompleteDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostapartes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#autocompleteDetailEdit
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostapartes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#autocompleteGeneral
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostapartes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#crudGET
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostapartes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#crudGETDetail
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostapartes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#quickAdd
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostapartes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propPartes.findById() instead.
            "::findById::Proposta::propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propPartes.destroyById() instead.
            "::destroyById::Proposta::propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propPartes.updateById() instead.
            "::updateById::Proposta::propPartes": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propPartes/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propPartes() instead.
            "::get::Proposta::propPartes": {
              isArray: true,
              url: urlBase + "/propostas/:id/propPartes",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propPartes.create() instead.
            "::create::Proposta::propPartes": {
              url: urlBase + "/propostas/:id/propPartes",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propPartes.createMany() instead.
            "::createMany::Proposta::propPartes": {
              isArray: true,
              url: urlBase + "/propostas/:id/propPartes",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propPartes.destroyAll() instead.
            "::delete::Proposta::propPartes": {
              url: urlBase + "/propostas/:id/propPartes",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propPartes.count() instead.
            "::count::Proposta::propPartes": {
              url: urlBase + "/propostas/:id/propPartes/count",
              method: "GET",
            },

            // INTERNAL. Use PropostaStatusLog.logParte() instead.
            "::get::PropostaStatusLog::logParte": {
              url: urlBase + "/propostastatuslogs/:id/logParte",
              method: "GET",
            },

            // INTERNAL. Use PropostaAnexo.parteProposta() instead.
            "::get::PropostaAnexo::parteProposta": {
              url: urlBase + "/propostasanexo/:id/parteProposta",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#updateOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#update
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#destroyById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#removeById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchAttributes
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#updateOrCreate
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#update
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#destroyById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#removeById
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#patchAttributes
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaParte id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaParte#modelName
        * @propertyOf lbServices.PropostaParte
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaParte`.
        */
        R.modelName = "PropostaParte";


            /**
             * @ngdoc method
             * @name lbServices.PropostaParte#partTipo
             * @methodOf lbServices.PropostaParte
             *
             * @description
             *
             * Fetches belongsTo relation partTipo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaParte id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R.partTipo = function() {
          var TargetResource = $injector.get("PropostaTipoParte");
          var action = TargetResource["::get::PropostaParte::partTipo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaAnexo
 * @header lbServices.PropostaAnexo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaAnexo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaAnexo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostasanexo/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaAnexo.proposta() instead.
            "prototype$__get__proposta": {
              url: urlBase + "/propostasanexo/:id/proposta",
              method: "GET",
            },

            // INTERNAL. Use PropostaAnexo.tipoAnexo() instead.
            "prototype$__get__tipoAnexo": {
              url: urlBase + "/propostasanexo/:id/tipoAnexo",
              method: "GET",
            },

            // INTERNAL. Use PropostaAnexo.parteProposta() instead.
            "prototype$__get__parteProposta": {
              url: urlBase + "/propostasanexo/:id/parteProposta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#create
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#createMany
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#upsert
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasanexo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#replaceOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasanexo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#upsertWithWhere
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasanexo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#exists
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasanexo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#findById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasanexo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#replaceById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasanexo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#find
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasanexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#findOne
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasanexo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#updateAll
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasanexo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#deleteById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasanexo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#count
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasanexo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#prototype$updateAttributes
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasanexo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#createChangeStream
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasanexo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#create
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#createMany
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasanexo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#upsert
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasanexo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#replaceOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasanexo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#upsertWithWhere
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasanexo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#exists
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasanexo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#findById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasanexo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#replaceById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasanexo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#find
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasanexo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#findOne
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasanexo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#updateAll
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasanexo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#deleteById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasanexo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#count
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasanexo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#prototype$updateAttributes
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasanexo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#createChangeStream
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasanexo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#pager
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostasanexo/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#pagerDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostasanexo/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#postDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostasanexo/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#deleteDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostasanexo/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#editDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostasanexo/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#autocomplete
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostasanexo/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#autocompleteDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostasanexo/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#autocompleteDetailEdit
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostasanexo/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#autocompleteGeneral
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostasanexo/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#crudGET
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostasanexo/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#crudGETDetail
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostasanexo/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#quickAdd
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostasanexo/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propAnexos.findById() instead.
            "::findById::Proposta::propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propAnexos.destroyById() instead.
            "::destroyById::Proposta::propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propAnexos.updateById() instead.
            "::updateById::Proposta::propAnexos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/propostas/:id/propAnexos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proposta.propAnexos() instead.
            "::get::Proposta::propAnexos": {
              isArray: true,
              url: urlBase + "/propostas/:id/propAnexos",
              method: "GET",
            },

            // INTERNAL. Use Proposta.propAnexos.create() instead.
            "::create::Proposta::propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propAnexos.createMany() instead.
            "::createMany::Proposta::propAnexos": {
              isArray: true,
              url: urlBase + "/propostas/:id/propAnexos",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propAnexos.destroyAll() instead.
            "::delete::Proposta::propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos",
              method: "DELETE",
            },

            // INTERNAL. Use Proposta.propAnexos.count() instead.
            "::count::Proposta::propAnexos": {
              url: urlBase + "/propostas/:id/propAnexos/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#updateOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#update
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#destroyById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#removeById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchAttributes
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#updateOrCreate
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#update
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#destroyById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#removeById
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#patchAttributes
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAnexo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaAnexo#modelName
        * @propertyOf lbServices.PropostaAnexo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaAnexo`.
        */
        R.modelName = "PropostaAnexo";


            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#proposta
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Fetches belongsTo relation proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R.proposta = function() {
          var TargetResource = $injector.get("Proposta");
          var action = TargetResource["::get::PropostaAnexo::proposta"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#tipoAnexo
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Fetches belongsTo relation tipoAnexo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoAnexo` object.)
             * </em>
             */
        R.tipoAnexo = function() {
          var TargetResource = $injector.get("PropostaTipoAnexo");
          var action = TargetResource["::get::PropostaAnexo::tipoAnexo"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaAnexo#parteProposta
             * @methodOf lbServices.PropostaAnexo
             *
             * @description
             *
             * Fetches belongsTo relation parteProposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAnexo id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaParte` object.)
             * </em>
             */
        R.parteProposta = function() {
          var TargetResource = $injector.get("PropostaParte");
          var action = TargetResource["::get::PropostaAnexo::parteProposta"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoNegocioModalidade
 * @header lbServices.TipoNegocioModalidade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoNegocioModalidade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoNegocioModalidade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposnegociomodalidade/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.findById() instead.
            "prototype$__findById__tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.destroyById() instead.
            "prototype$__destroyById__tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.updateById() instead.
            "prototype$__updateById__tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria() instead.
            "prototype$__get__tipo_negocio_imobiliaria": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.create() instead.
            "prototype$__create__tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "POST",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.destroyAll() instead.
            "prototype$__delete__tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.count() instead.
            "prototype$__count__tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#create
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegociomodalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#createMany
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#upsert
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegociomodalidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#replaceOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegociomodalidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#upsertWithWhere
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegociomodalidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#exists
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegociomodalidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#findById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#replaceById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegociomodalidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#find
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#findOne
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegociomodalidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#updateAll
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegociomodalidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#deleteById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#count
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegociomodalidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#createChangeStream
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegociomodalidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#create
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegociomodalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#createMany
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#upsert
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegociomodalidade",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#replaceOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegociomodalidade/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#upsertWithWhere
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegociomodalidade/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#exists
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegociomodalidade/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#findById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#replaceById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegociomodalidade/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#find
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#findOne
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegociomodalidade/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#updateAll
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegociomodalidade/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#deleteById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#count
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegociomodalidade/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegociomodalidade/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#createChangeStream
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegociomodalidade/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#pager
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposnegociomodalidade/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#pagerDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#postDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#deleteDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#editDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#autocomplete
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposnegociomodalidade/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#autocompleteDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#autocompleteDetailEdit
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposnegociomodalidade/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#autocompleteGeneral
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposnegociomodalidade/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#crudGET
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposnegociomodalidade/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#crudGETDetail
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposnegociomodalidade/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#quickAdd
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposnegociomodalidade/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proposta.propTipoNegocioModalidade() instead.
            "::get::Proposta::propTipoNegocioModalidade": {
              url: urlBase + "/propostas/:id/propTipoNegocioModalidade",
              method: "GET",
            },

            // INTERNAL. Use PropostaTipoAnexo.tipoNegocioAnexo() instead.
            "::get::PropostaTipoAnexo::tipoNegocioAnexo": {
              url: urlBase + "/propostatiposanexo/:id/tipoNegocioAnexo",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioImobiliaria.tipo_negocio() instead.
            "::get::TipoNegocioImobiliaria::tipo_negocio": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/tipo_negocio",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#updateOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#update
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#destroyById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#removeById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchAttributes
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#updateOrCreate
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#update
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#destroyById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#removeById
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#patchAttributes
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoNegocioModalidade#modelName
        * @propertyOf lbServices.TipoNegocioModalidade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoNegocioModalidade`.
        */
        R.modelName = "TipoNegocioModalidade";

    /**
     * @ngdoc object
     * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
     * @header lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
     * @object
     * @description
     *
     * The object `TipoNegocioModalidade.tipo_negocio_imobiliaria` groups methods
     * manipulating `TipoNegocioImobiliaria` instances related to `TipoNegocioModalidade`.
     *
     * Call {@link lbServices.TipoNegocioModalidade#tipo_negocio_imobiliaria TipoNegocioModalidade.tipo_negocio_imobiliaria()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade#tipo_negocio_imobiliaria
             * @methodOf lbServices.TipoNegocioModalidade
             *
             * @description
             *
             * Queries tipo_negocio_imobiliaria of TipoNegocioModalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R.tipo_negocio_imobiliaria = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::get::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#count
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Counts tipo_negocio_imobiliaria of TipoNegocioModalidade.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tipo_negocio_imobiliaria.count = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::count::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#create
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Creates a new instance in tipo_negocio_imobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R.tipo_negocio_imobiliaria.create = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::create::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#createMany
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Creates a new instance in tipo_negocio_imobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R.tipo_negocio_imobiliaria.createMany = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::createMany::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#destroyAll
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Deletes all tipo_negocio_imobiliaria of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tipo_negocio_imobiliaria.destroyAll = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::delete::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#destroyById
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Delete a related item by id for tipo_negocio_imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `fk` – `{*}` - Foreign key for tipo_negocio_imobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tipo_negocio_imobiliaria.destroyById = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::destroyById::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#findById
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Find a related item by id for tipo_negocio_imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `fk` – `{*}` - Foreign key for tipo_negocio_imobiliaria
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R.tipo_negocio_imobiliaria.findById = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::findById::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria#updateById
             * @methodOf lbServices.TipoNegocioModalidade.tipo_negocio_imobiliaria
             *
             * @description
             *
             * Update a related item by id for tipo_negocio_imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioModalidade id
             *
             *  - `fk` – `{*}` - Foreign key for tipo_negocio_imobiliaria
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R.tipo_negocio_imobiliaria.updateById = function() {
          var TargetResource = $injector.get("TipoNegocioImobiliaria");
          var action = TargetResource["::updateById::TipoNegocioModalidade::tipo_negocio_imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaWorkflow
 * @header lbServices.PropostaWorkflow
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaWorkflow` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaWorkflow",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostasworkflow/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaWorkflow.flowPerfil() instead.
            "prototype$__get__flowPerfil": {
              url: urlBase + "/propostasworkflow/:id/flowPerfil",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusOrigem() instead.
            "prototype$__get__flowStatusOrigem": {
              url: urlBase + "/propostasworkflow/:id/flowStatusOrigem",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusDestino() instead.
            "prototype$__get__flowStatusDestino": {
              url: urlBase + "/propostasworkflow/:id/flowStatusDestino",
              method: "GET",
            },

            // INTERNAL. Use PropostaWorkflow.flowStatusNext() instead.
            "prototype$__get__flowStatusNext": {
              url: urlBase + "/propostasworkflow/:id/flowStatusNext",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#create
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasworkflow",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#createMany
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasworkflow",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#upsert
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasworkflow",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#replaceOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasworkflow/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#upsertWithWhere
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasworkflow/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#exists
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasworkflow/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#findById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasworkflow/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#replaceById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasworkflow/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#find
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasworkflow",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#findOne
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasworkflow/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#updateAll
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasworkflow/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#deleteById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasworkflow/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#count
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasworkflow/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#prototype$updateAttributes
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasworkflow/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#createChangeStream
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasworkflow/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#getWorkflow
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find workflow by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "getWorkflow": {
              isArray: true,
              url: urlBase + "/propostasworkflow/get-workflow",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#create
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostasworkflow",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#createMany
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostasworkflow",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#upsert
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostasworkflow",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#replaceOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostasworkflow/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#upsertWithWhere
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostasworkflow/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#exists
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostasworkflow/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#findById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostasworkflow/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#replaceById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostasworkflow/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#find
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostasworkflow",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#findOne
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostasworkflow/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#updateAll
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostasworkflow/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#deleteById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostasworkflow/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#count
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostasworkflow/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#prototype$updateAttributes
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostasworkflow/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#createChangeStream
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostasworkflow/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#pager
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostasworkflow/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#pagerDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostasworkflow/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#postDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostasworkflow/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#deleteDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostasworkflow/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#editDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostasworkflow/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#autocomplete
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostasworkflow/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#autocompleteDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostasworkflow/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#autocompleteDetailEdit
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostasworkflow/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#autocompleteGeneral
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostasworkflow/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#crudGET
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostasworkflow/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#crudGETDetail
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostasworkflow/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#quickAdd
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostasworkflow/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#updateOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#update
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#destroyById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#removeById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchAttributes
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#updateOrCreate
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#update
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#destroyById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#removeById
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#patchAttributes
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaWorkflow` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaWorkflow#modelName
        * @propertyOf lbServices.PropostaWorkflow
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaWorkflow`.
        */
        R.modelName = "PropostaWorkflow";


            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#flowPerfil
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Fetches belongsTo relation flowPerfil.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaTipoParte` object.)
             * </em>
             */
        R.flowPerfil = function() {
          var TargetResource = $injector.get("PropostaTipoParte");
          var action = TargetResource["::get::PropostaWorkflow::flowPerfil"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#flowStatusOrigem
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Fetches belongsTo relation flowStatusOrigem.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R.flowStatusOrigem = function() {
          var TargetResource = $injector.get("PropostaStatus");
          var action = TargetResource["::get::PropostaWorkflow::flowStatusOrigem"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#flowStatusDestino
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Fetches belongsTo relation flowStatusDestino.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R.flowStatusDestino = function() {
          var TargetResource = $injector.get("PropostaStatus");
          var action = TargetResource["::get::PropostaWorkflow::flowStatusDestino"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaWorkflow#flowStatusNext
             * @methodOf lbServices.PropostaWorkflow
             *
             * @description
             *
             * Fetches belongsTo relation flowStatusNext.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaWorkflow id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaStatus` object.)
             * </em>
             */
        R.flowStatusNext = function() {
          var TargetResource = $injector.get("PropostaStatus");
          var action = TargetResource["::get::PropostaWorkflow::flowStatusNext"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PalavraBloqueada
 * @header lbServices.PalavraBloqueada
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PalavraBloqueada` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PalavraBloqueada",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/palavrasbloqueadas/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#create
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/palavrasbloqueadas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#createMany
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/palavrasbloqueadas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#upsert
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/palavrasbloqueadas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#replaceOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/palavrasbloqueadas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#upsertWithWhere
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/palavrasbloqueadas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#exists
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/palavrasbloqueadas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#findById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#replaceById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/palavrasbloqueadas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#find
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/palavrasbloqueadas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#findOne
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/palavrasbloqueadas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#updateAll
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/palavrasbloqueadas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#deleteById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#count
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/palavrasbloqueadas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#prototype$updateAttributes
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PalavraBloqueada id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#createChangeStream
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/palavrasbloqueadas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#create
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/palavrasbloqueadas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#createMany
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/palavrasbloqueadas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#upsert
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/palavrasbloqueadas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#replaceOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/palavrasbloqueadas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#upsertWithWhere
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/palavrasbloqueadas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#exists
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/palavrasbloqueadas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#findById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#replaceById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/palavrasbloqueadas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#find
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/palavrasbloqueadas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#findOne
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/palavrasbloqueadas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#updateAll
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/palavrasbloqueadas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#deleteById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#count
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/palavrasbloqueadas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#prototype$updateAttributes
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PalavraBloqueada id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/palavrasbloqueadas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#createChangeStream
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/palavrasbloqueadas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#pager
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/palavrasbloqueadas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#pagerDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#postDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#deleteDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#editDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#autocomplete
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/palavrasbloqueadas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#autocompleteDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#autocompleteDetailEdit
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/palavrasbloqueadas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#autocompleteGeneral
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/palavrasbloqueadas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#crudGET
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/palavrasbloqueadas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#crudGETDetail
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/palavrasbloqueadas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#quickAdd
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/palavrasbloqueadas/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#updateOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchOrCreateWithWhere
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#update
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#destroyById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#removeById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchAttributes
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PalavraBloqueada id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#updateOrCreate
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchOrCreateWithWhere
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#update
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#destroyById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#removeById
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PalavraBloqueada#patchAttributes
             * @methodOf lbServices.PalavraBloqueada
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PalavraBloqueada id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PalavraBloqueada` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PalavraBloqueada#modelName
        * @propertyOf lbServices.PalavraBloqueada
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PalavraBloqueada`.
        */
        R.modelName = "PalavraBloqueada";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EmpreendimentoStatus
 * @header lbServices.EmpreendimentoStatus
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EmpreendimentoStatus` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EmpreendimentoStatus",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/empreendimentostatus/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#create
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#createMany
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#upsert
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentostatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentostatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentostatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#exists
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentostatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#findById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#replaceById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentostatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#find
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentostatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#findOne
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentostatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#updateAll
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentostatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#deleteById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#count
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentostatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#createChangeStream
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentostatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#create
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/empreendimentostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#createMany
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/empreendimentostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#upsert
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/empreendimentostatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#replaceOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/empreendimentostatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#upsertWithWhere
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/empreendimentostatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#exists
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/empreendimentostatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#findById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#replaceById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/empreendimentostatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#find
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/empreendimentostatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#findOne
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/empreendimentostatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#updateAll
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/empreendimentostatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#deleteById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#count
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/empreendimentostatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#prototype$updateAttributes
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/empreendimentostatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#createChangeStream
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/empreendimentostatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#pager
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/empreendimentostatus/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#pagerDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/empreendimentostatus/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#postDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/empreendimentostatus/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#deleteDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/empreendimentostatus/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#editDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/empreendimentostatus/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#autocomplete
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/empreendimentostatus/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#autocompleteDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/empreendimentostatus/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#autocompleteDetailEdit
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/empreendimentostatus/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#autocompleteGeneral
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/empreendimentostatus/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#crudGET
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/empreendimentostatus/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#crudGETDetail
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/empreendimentostatus/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#quickAdd
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/empreendimentostatus/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Empreendimento.status() instead.
            "::get::Empreendimento::status": {
              url: urlBase + "/empreendimentos/:id/status",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#updateOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#update
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#destroyById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#removeById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchAttributes
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#updateOrCreate
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchOrCreateWithWhere
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#update
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#destroyById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#removeById
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmpreendimentoStatus#patchAttributes
             * @methodOf lbServices.EmpreendimentoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmpreendimentoStatus id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmpreendimentoStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EmpreendimentoStatus#modelName
        * @propertyOf lbServices.EmpreendimentoStatus
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EmpreendimentoStatus`.
        */
        R.modelName = "EmpreendimentoStatus";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RadarImovel
 * @header lbServices.RadarImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RadarImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RadarImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/radarimoveis/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RadarImovel.card() instead.
            "prototype$__get__card": {
              url: urlBase + "/radarimoveis/:id/card",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/radarimoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.tipo_imovel() instead.
            "prototype$__get__tipo_imovel": {
              url: urlBase + "/radarimoveis/:id/tipo_imovel",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.interesse() instead.
            "prototype$__get__interesse": {
              url: urlBase + "/radarimoveis/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.findById() instead.
            "prototype$__findById__radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.destroyById() instead.
            "prototype$__destroyById__radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.updateById() instead.
            "prototype$__updateById__radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos() instead.
            "prototype$__get__radarimovelhistoricos": {
              isArray: true,
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.create() instead.
            "prototype$__create__radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "POST",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.destroyAll() instead.
            "prototype$__delete__radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "DELETE",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.count() instead.
            "prototype$__count__radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#create
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/radarimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#createMany
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/radarimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#upsert
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/radarimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#replaceOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/radarimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#upsertWithWhere
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/radarimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#exists
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/radarimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#findById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/radarimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#replaceById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/radarimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#find
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/radarimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#findOne
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/radarimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#updateAll
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/radarimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#deleteById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/radarimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#count
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/radarimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#prototype$updateAttributes
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/radarimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#createChangeStream
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/radarimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#create
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/radarimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#createMany
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/radarimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#upsert
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/radarimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#replaceOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/radarimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#upsertWithWhere
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/radarimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#exists
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/radarimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#findById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/radarimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#replaceById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/radarimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#find
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/radarimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#findOne
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/radarimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#updateAll
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/radarimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#deleteById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/radarimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#count
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/radarimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#prototype$updateAttributes
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/radarimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#createChangeStream
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/radarimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#pager
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/radarimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#pagerDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/radarimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#postDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/radarimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#deleteDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/radarimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#editDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/radarimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#autocomplete
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/radarimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#autocompleteDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/radarimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#autocompleteDetailEdit
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/radarimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#autocompleteGeneral
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/radarimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#crudGET
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/radarimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#crudGETDetail
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/radarimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#quickAdd
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/radarimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use RadarImovelHistorico.radar_imovel() instead.
            "::get::RadarImovelHistorico::radar_imovel": {
              url: urlBase + "/radarimovelhistoricos/:id/radar_imovel",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#updateOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchOrCreateWithWhere
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#update
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#destroyById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#removeById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchAttributes
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#updateOrCreate
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchOrCreateWithWhere
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#update
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#destroyById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#removeById
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#patchAttributes
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RadarImovel#modelName
        * @propertyOf lbServices.RadarImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RadarImovel`.
        */
        R.modelName = "RadarImovel";


            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#card
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Fetches belongsTo relation card.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.card = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::RadarImovel::card"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#imobiliaria
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::RadarImovel::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#tipo_imovel
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Fetches belongsTo relation tipo_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R.tipo_imovel = function() {
          var TargetResource = $injector.get("TipoImovel");
          var action = TargetResource["::get::RadarImovel::tipo_imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#interesse
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Fetches belongsTo relation interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::RadarImovel::interesse"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.RadarImovel.radarimovelhistoricos
     * @header lbServices.RadarImovel.radarimovelhistoricos
     * @object
     * @description
     *
     * The object `RadarImovel.radarimovelhistoricos` groups methods
     * manipulating `RadarImovelHistorico` instances related to `RadarImovel`.
     *
     * Call {@link lbServices.RadarImovel#radarimovelhistoricos RadarImovel.radarimovelhistoricos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.RadarImovel#radarimovelhistoricos
             * @methodOf lbServices.RadarImovel
             *
             * @description
             *
             * Queries radarimovelhistoricos of RadarImovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R.radarimovelhistoricos = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::get::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#count
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Counts radarimovelhistoricos of RadarImovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.radarimovelhistoricos.count = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::count::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#create
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Creates a new instance in radarimovelhistoricos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R.radarimovelhistoricos.create = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::create::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#createMany
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Creates a new instance in radarimovelhistoricos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R.radarimovelhistoricos.createMany = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::createMany::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#destroyAll
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Deletes all radarimovelhistoricos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.radarimovelhistoricos.destroyAll = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::delete::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#destroyById
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Delete a related item by id for radarimovelhistoricos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `fk` – `{*}` - Foreign key for radarimovelhistoricos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.radarimovelhistoricos.destroyById = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::destroyById::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#findById
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Find a related item by id for radarimovelhistoricos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `fk` – `{*}` - Foreign key for radarimovelhistoricos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R.radarimovelhistoricos.findById = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::findById::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovel.radarimovelhistoricos#updateById
             * @methodOf lbServices.RadarImovel.radarimovelhistoricos
             *
             * @description
             *
             * Update a related item by id for radarimovelhistoricos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovel id
             *
             *  - `fk` – `{*}` - Foreign key for radarimovelhistoricos
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R.radarimovelhistoricos.updateById = function() {
          var TargetResource = $injector.get("RadarImovelHistorico");
          var action = TargetResource["::updateById::RadarImovel::radarimovelhistoricos"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RadarImovelHistorico
 * @header lbServices.RadarImovelHistorico
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RadarImovelHistorico` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RadarImovelHistorico",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/radarimovelhistoricos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RadarImovelHistorico.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/radarimovelhistoricos/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use RadarImovelHistorico.radar_imovel() instead.
            "prototype$__get__radar_imovel": {
              url: urlBase + "/radarimovelhistoricos/:id/radar_imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#create
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/radarimovelhistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#createMany
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/radarimovelhistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#upsert
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/radarimovelhistoricos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#replaceOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/radarimovelhistoricos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#upsertWithWhere
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/radarimovelhistoricos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#exists
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/radarimovelhistoricos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#findById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#replaceById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/radarimovelhistoricos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#find
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/radarimovelhistoricos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#findOne
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/radarimovelhistoricos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#updateAll
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/radarimovelhistoricos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#deleteById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#count
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/radarimovelhistoricos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#prototype$updateAttributes
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#createChangeStream
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/radarimovelhistoricos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#create
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/radarimovelhistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#createMany
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/radarimovelhistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#upsert
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/radarimovelhistoricos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#replaceOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/radarimovelhistoricos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#upsertWithWhere
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/radarimovelhistoricos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#exists
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/radarimovelhistoricos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#findById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#replaceById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/radarimovelhistoricos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#find
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/radarimovelhistoricos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#findOne
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/radarimovelhistoricos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#updateAll
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/radarimovelhistoricos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#deleteById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#count
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/radarimovelhistoricos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#prototype$updateAttributes
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/radarimovelhistoricos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#createChangeStream
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/radarimovelhistoricos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#pager
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/radarimovelhistoricos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#pagerDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#postDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#deleteDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#editDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#autocomplete
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/radarimovelhistoricos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#autocompleteDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#autocompleteDetailEdit
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/radarimovelhistoricos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#autocompleteGeneral
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/radarimovelhistoricos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#crudGET
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/radarimovelhistoricos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#crudGETDetail
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/radarimovelhistoricos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#quickAdd
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/radarimovelhistoricos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.findById() instead.
            "::findById::RadarImovel::radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.destroyById() instead.
            "::destroyById::RadarImovel::radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.updateById() instead.
            "::updateById::RadarImovel::radarimovelhistoricos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos() instead.
            "::get::RadarImovel::radarimovelhistoricos": {
              isArray: true,
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "GET",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.create() instead.
            "::create::RadarImovel::radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "POST",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.createMany() instead.
            "::createMany::RadarImovel::radarimovelhistoricos": {
              isArray: true,
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "POST",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.destroyAll() instead.
            "::delete::RadarImovel::radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos",
              method: "DELETE",
            },

            // INTERNAL. Use RadarImovel.radarimovelhistoricos.count() instead.
            "::count::RadarImovel::radarimovelhistoricos": {
              url: urlBase + "/radarimoveis/:id/radarimovelhistoricos/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#updateOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchOrCreateWithWhere
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#update
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#destroyById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#removeById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchAttributes
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#updateOrCreate
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchOrCreateWithWhere
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#update
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#destroyById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#removeById
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#patchAttributes
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovelHistorico` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RadarImovelHistorico#modelName
        * @propertyOf lbServices.RadarImovelHistorico
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RadarImovelHistorico`.
        */
        R.modelName = "RadarImovelHistorico";


            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#imovel
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::RadarImovelHistorico::imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RadarImovelHistorico#radar_imovel
             * @methodOf lbServices.RadarImovelHistorico
             *
             * @description
             *
             * Fetches belongsTo relation radar_imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RadarImovelHistorico id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RadarImovel` object.)
             * </em>
             */
        R.radar_imovel = function() {
          var TargetResource = $injector.get("RadarImovel");
          var action = TargetResource["::get::RadarImovelHistorico::radar_imovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.EmailTransacional
 * @header lbServices.EmailTransacional
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `EmailTransacional` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "EmailTransacional",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/emails/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#create
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/emails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#createMany
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/emails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#upsert
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/emails",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#replaceOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/emails/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#upsertWithWhere
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/emails/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#exists
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/emails/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#findById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/emails/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#replaceById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/emails/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#find
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/emails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#findOne
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/emails/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#updateAll
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/emails/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#deleteById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/emails/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#count
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/emails/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#prototype$updateAttributes
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmailTransacional id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/emails/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#createChangeStream
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/emails/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#create
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/emails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#createMany
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/emails",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#upsert
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/emails",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#replaceOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/emails/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#upsertWithWhere
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/emails/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#exists
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/emails/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#findById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/emails/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#replaceById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/emails/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#find
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/emails",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#findOne
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/emails/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#updateAll
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/emails/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#deleteById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/emails/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#count
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/emails/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#prototype$updateAttributes
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmailTransacional id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/emails/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#createChangeStream
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/emails/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#pager
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/emails/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#pagerDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/emails/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#postDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/emails/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#deleteDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/emails/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#editDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/emails/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#autocomplete
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/emails/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#autocompleteDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/emails/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#autocompleteDetailEdit
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/emails/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#autocompleteGeneral
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/emails/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#crudGET
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/emails/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#crudGETDetail
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/emails/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#quickAdd
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/emails/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#updateOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchOrCreateWithWhere
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#update
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#destroyById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#removeById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchAttributes
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmailTransacional id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#updateOrCreate
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchOrCreateWithWhere
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#update
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#destroyById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#removeById
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.EmailTransacional#patchAttributes
             * @methodOf lbServices.EmailTransacional
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - EmailTransacional id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `EmailTransacional` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.EmailTransacional#modelName
        * @propertyOf lbServices.EmailTransacional
        * @description
        * The name of the model represented by this $resource,
        * i.e. `EmailTransacional`.
        */
        R.modelName = "EmailTransacional";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Unsubscribe
 * @header lbServices.Unsubscribe
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Unsubscribe` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Unsubscribe",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/unsubscribes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#create
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unsubscribes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#createMany
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unsubscribes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#upsert
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unsubscribes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#replaceOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unsubscribes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#upsertWithWhere
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unsubscribes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#exists
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unsubscribes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#findById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unsubscribes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#replaceById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unsubscribes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#find
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unsubscribes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#findOne
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unsubscribes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#updateAll
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unsubscribes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#deleteById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unsubscribes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#count
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unsubscribes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#prototype$updateAttributes
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Unsubscribe id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unsubscribes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#createChangeStream
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unsubscribes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#createByUser
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `greeting` – `{object=}` -
             */
            "createByUser": {
              url: urlBase + "/unsubscribes/set-unsubscribe",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#create
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/unsubscribes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#createMany
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/unsubscribes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#upsert
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/unsubscribes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#replaceOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/unsubscribes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#upsertWithWhere
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/unsubscribes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#exists
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/unsubscribes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#findById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/unsubscribes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#replaceById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/unsubscribes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#find
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/unsubscribes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#findOne
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/unsubscribes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#updateAll
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/unsubscribes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#deleteById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/unsubscribes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#count
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/unsubscribes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#prototype$updateAttributes
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Unsubscribe id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/unsubscribes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#createChangeStream
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/unsubscribes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#pager
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/unsubscribes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#pagerDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/unsubscribes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#postDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/unsubscribes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#deleteDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/unsubscribes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#editDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/unsubscribes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#autocomplete
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/unsubscribes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#autocompleteDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/unsubscribes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#autocompleteDetailEdit
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/unsubscribes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#autocompleteGeneral
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/unsubscribes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#crudGET
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/unsubscribes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#crudGETDetail
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/unsubscribes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#quickAdd
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/unsubscribes/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#updateOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchOrCreateWithWhere
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#update
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#destroyById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#removeById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchAttributes
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Unsubscribe id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#updateOrCreate
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchOrCreateWithWhere
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#update
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#destroyById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#removeById
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Unsubscribe#patchAttributes
             * @methodOf lbServices.Unsubscribe
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Unsubscribe id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Unsubscribe` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Unsubscribe#modelName
        * @propertyOf lbServices.Unsubscribe
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Unsubscribe`.
        */
        R.modelName = "Unsubscribe";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TipoNegocioImobiliaria
 * @header lbServices.TipoNegocioImobiliaria
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TipoNegocioImobiliaria` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TipoNegocioImobiliaria",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/tiposnegocioImobiliaria/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TipoNegocioImobiliaria.tipo_negocio() instead.
            "prototype$__get__tipo_negocio": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/tipo_negocio",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioImobiliaria.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#create
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#createMany
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#upsert
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#replaceOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegocioImobiliaria/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#upsertWithWhere
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegocioImobiliaria/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#exists
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#findById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#replaceById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#find
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#findOne
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegocioImobiliaria/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#updateAll
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegocioImobiliaria/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#deleteById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#count
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegocioImobiliaria/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#createChangeStream
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegocioImobiliaria/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#create
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#createMany
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#upsert
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#replaceOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/tiposnegocioImobiliaria/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#upsertWithWhere
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/tiposnegocioImobiliaria/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#exists
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#findById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#replaceById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#find
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/tiposnegocioImobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#findOne
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/tiposnegocioImobiliaria/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#updateAll
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/tiposnegocioImobiliaria/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#deleteById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#count
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/tiposnegocioImobiliaria/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/tiposnegocioImobiliaria/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#createChangeStream
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/tiposnegocioImobiliaria/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#pager
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/tiposnegocioImobiliaria/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#pagerDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#postDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#deleteDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#editDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#autocomplete
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/tiposnegocioImobiliaria/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#autocompleteDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#autocompleteDetailEdit
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#autocompleteGeneral
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/tiposnegocioImobiliaria/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#crudGET
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/tiposnegocioImobiliaria/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#crudGETDetail
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/tiposnegocioImobiliaria/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#quickAdd
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/tiposnegocioImobiliaria/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.findById() instead.
            "::findById::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.destroyById() instead.
            "::destroyById::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.updateById() instead.
            "::updateById::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria() instead.
            "::get::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.create() instead.
            "::create::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "POST",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.createMany() instead.
            "::createMany::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              isArray: true,
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "POST",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.destroyAll() instead.
            "::delete::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use TipoNegocioModalidade.tipo_negocio_imobiliaria.count() instead.
            "::count::TipoNegocioModalidade::tipo_negocio_imobiliaria": {
              url: urlBase + "/tiposnegociomodalidade/:id/tipo_negocio_imobiliaria/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#updateOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#update
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#destroyById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#removeById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchAttributes
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#updateOrCreate
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#update
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#destroyById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#removeById
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#patchAttributes
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TipoNegocioImobiliaria#modelName
        * @propertyOf lbServices.TipoNegocioImobiliaria
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TipoNegocioImobiliaria`.
        */
        R.modelName = "TipoNegocioImobiliaria";


            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#tipo_negocio
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation tipo_negocio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocioModalidade` object.)
             * </em>
             */
        R.tipo_negocio = function() {
          var TargetResource = $injector.get("TipoNegocioModalidade");
          var action = TargetResource["::get::TipoNegocioImobiliaria::tipo_negocio"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TipoNegocioImobiliaria#imobiliaria
             * @methodOf lbServices.TipoNegocioImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TipoNegocioImobiliaria id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::TipoNegocioImobiliaria::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.LogXmlPortal
 * @header lbServices.LogXmlPortal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `LogXmlPortal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "LogXmlPortal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/logxmlportal/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use LogXmlPortal.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/logxmlportal/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use LogXmlPortal.portal() instead.
            "prototype$__get__portal": {
              url: urlBase + "/logxmlportal/:id/portal",
              method: "GET",
            },

            // INTERNAL. Use LogXmlPortal.portalimobiliaria() instead.
            "prototype$__get__portalimobiliaria": {
              url: urlBase + "/logxmlportal/:id/portalimobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#create
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/logxmlportal",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#createMany
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/logxmlportal",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#upsert
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/logxmlportal",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#replaceOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/logxmlportal/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#upsertWithWhere
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/logxmlportal/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#exists
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/logxmlportal/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#findById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/logxmlportal/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#replaceById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/logxmlportal/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#find
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/logxmlportal",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#findOne
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/logxmlportal/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#updateAll
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/logxmlportal/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#deleteById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/logxmlportal/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#count
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/logxmlportal/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#prototype$updateAttributes
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/logxmlportal/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#createChangeStream
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/logxmlportal/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#create
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/logxmlportal",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#createMany
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/logxmlportal",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#upsert
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/logxmlportal",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#replaceOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/logxmlportal/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#upsertWithWhere
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/logxmlportal/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#exists
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/logxmlportal/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#findById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/logxmlportal/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#replaceById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/logxmlportal/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#find
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/logxmlportal",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#findOne
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/logxmlportal/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#updateAll
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/logxmlportal/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#deleteById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/logxmlportal/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#count
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/logxmlportal/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#prototype$updateAttributes
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/logxmlportal/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#createChangeStream
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/logxmlportal/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#pager
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/logxmlportal/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#pagerDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/logxmlportal/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#postDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/logxmlportal/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#deleteDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/logxmlportal/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#editDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/logxmlportal/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#autocomplete
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/logxmlportal/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#autocompleteDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/logxmlportal/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#autocompleteDetailEdit
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/logxmlportal/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#autocompleteGeneral
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/logxmlportal/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#crudGET
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/logxmlportal/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#crudGETDetail
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/logxmlportal/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#quickAdd
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/logxmlportal/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Portal.historico.findById() instead.
            "::findById::Portal::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.historico.destroyById() instead.
            "::destroyById::Portal::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.historico.updateById() instead.
            "::updateById::Portal::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/historico/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.historico() instead.
            "::get::Portal::historico": {
              isArray: true,
              url: urlBase + "/portais/:id/historico",
              method: "GET",
            },

            // INTERNAL. Use Portal.historico.create() instead.
            "::create::Portal::historico": {
              url: urlBase + "/portais/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Portal.historico.createMany() instead.
            "::createMany::Portal::historico": {
              isArray: true,
              url: urlBase + "/portais/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Portal.historico.destroyAll() instead.
            "::delete::Portal::historico": {
              url: urlBase + "/portais/:id/historico",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.historico.count() instead.
            "::count::Portal::historico": {
              url: urlBase + "/portais/:id/historico/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#updateOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchOrCreateWithWhere
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#update
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#destroyById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#removeById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchAttributes
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#updateOrCreate
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchOrCreateWithWhere
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#update
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#destroyById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#removeById
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#patchAttributes
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogXmlPortal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.LogXmlPortal#modelName
        * @propertyOf lbServices.LogXmlPortal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `LogXmlPortal`.
        */
        R.modelName = "LogXmlPortal";


            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#imobiliaria
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::LogXmlPortal::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#portal
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Fetches belongsTo relation portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R.portal = function() {
          var TargetResource = $injector.get("Portal");
          var action = TargetResource["::get::LogXmlPortal::portal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.LogXmlPortal#portalimobiliaria
             * @methodOf lbServices.LogXmlPortal
             *
             * @description
             *
             * Fetches belongsTo relation portalimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogXmlPortal id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::get::LogXmlPortal::portalimobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PropostaAllLog
 * @header lbServices.PropostaAllLog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PropostaAllLog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PropostaAllLog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/propostaalllogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PropostaAllLog.logProposta() instead.
            "prototype$__get__logProposta": {
              url: urlBase + "/propostaalllogs/:id/logProposta",
              method: "GET",
            },

            // INTERNAL. Use PropostaAllLog.logUsuario() instead.
            "prototype$__get__logUsuario": {
              url: urlBase + "/propostaalllogs/:id/logUsuario",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#create
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostaalllogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#createMany
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostaalllogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#upsert
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostaalllogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#replaceOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostaalllogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#upsertWithWhere
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostaalllogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#exists
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostaalllogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#findById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostaalllogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#replaceById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostaalllogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#find
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostaalllogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#findOne
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostaalllogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#updateAll
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostaalllogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#deleteById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostaalllogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#count
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostaalllogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#prototype$updateAttributes
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostaalllogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#createChangeStream
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostaalllogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#create
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/propostaalllogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#createMany
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/propostaalllogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#upsert
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/propostaalllogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#replaceOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/propostaalllogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#upsertWithWhere
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/propostaalllogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#exists
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/propostaalllogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#findById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/propostaalllogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#replaceById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/propostaalllogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#find
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/propostaalllogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#findOne
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/propostaalllogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#updateAll
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/propostaalllogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#deleteById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/propostaalllogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#count
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/propostaalllogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#prototype$updateAttributes
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/propostaalllogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#createChangeStream
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/propostaalllogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#pager
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/propostaalllogs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#pagerDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/propostaalllogs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#postDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/propostaalllogs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#deleteDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/propostaalllogs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#editDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/propostaalllogs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#autocomplete
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/propostaalllogs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#autocompleteDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/propostaalllogs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#autocompleteDetailEdit
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/propostaalllogs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#autocompleteGeneral
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/propostaalllogs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#crudGET
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/propostaalllogs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#crudGETDetail
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/propostaalllogs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#quickAdd
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/propostaalllogs/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#updateOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#update
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#destroyById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#removeById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchAttributes
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#updateOrCreate
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchOrCreateWithWhere
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#update
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#destroyById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#removeById
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#patchAttributes
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PropostaAllLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PropostaAllLog#modelName
        * @propertyOf lbServices.PropostaAllLog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PropostaAllLog`.
        */
        R.modelName = "PropostaAllLog";


            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#logProposta
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Fetches belongsTo relation logProposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R.logProposta = function() {
          var TargetResource = $injector.get("Proposta");
          var action = TargetResource["::get::PropostaAllLog::logProposta"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PropostaAllLog#logUsuario
             * @methodOf lbServices.PropostaAllLog
             *
             * @description
             *
             * Fetches belongsTo relation logUsuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PropostaAllLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.logUsuario = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::PropostaAllLog::logUsuario"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CardImovelWhatsAck
 * @header lbServices.CardImovelWhatsAck
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CardImovelWhatsAck` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CardImovelWhatsAck",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/cardimovelwhatsacks/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CardImovelWhatsAck.lead() instead.
            "prototype$__get__lead": {
              url: urlBase + "/cardimovelwhatsacks/:id/lead",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#create
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardimovelwhatsacks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#createMany
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardimovelwhatsacks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#upsert
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardimovelwhatsacks",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#replaceOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardimovelwhatsacks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#upsertWithWhere
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardimovelwhatsacks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#exists
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardimovelwhatsacks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#findById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#replaceById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardimovelwhatsacks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#find
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardimovelwhatsacks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#findOne
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardimovelwhatsacks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#updateAll
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardimovelwhatsacks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#deleteById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#count
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardimovelwhatsacks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#prototype$updateAttributes
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovelWhatsAck id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#createChangeStream
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardimovelwhatsacks/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#webhook
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * cria acks.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "webhook": {
              url: urlBase + "/cardimovelwhatsacks/ackWeb",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#create
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/cardimovelwhatsacks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#createMany
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/cardimovelwhatsacks",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#upsert
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/cardimovelwhatsacks",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#replaceOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/cardimovelwhatsacks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#upsertWithWhere
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/cardimovelwhatsacks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#exists
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/cardimovelwhatsacks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#findById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#replaceById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/cardimovelwhatsacks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#find
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/cardimovelwhatsacks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#findOne
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/cardimovelwhatsacks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#updateAll
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/cardimovelwhatsacks/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#deleteById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#count
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/cardimovelwhatsacks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#prototype$updateAttributes
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovelWhatsAck id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/cardimovelwhatsacks/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#createChangeStream
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/cardimovelwhatsacks/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#pager
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/cardimovelwhatsacks/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#pagerDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#postDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#deleteDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#editDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#autocomplete
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/cardimovelwhatsacks/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#autocompleteDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#autocompleteDetailEdit
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/cardimovelwhatsacks/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#autocompleteGeneral
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/cardimovelwhatsacks/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#crudGET
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/cardimovelwhatsacks/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#crudGETDetail
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/cardimovelwhatsacks/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#quickAdd
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/cardimovelwhatsacks/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use CardImovel.ackWhats.findById() instead.
            "::findById::CardImovel::ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats.destroyById() instead.
            "::destroyById::CardImovel::ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use CardImovel.ackWhats.updateById() instead.
            "::updateById::CardImovel::ackWhats": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/cardsimovel/:id/ackWhats/:fk",
              method: "PUT",
            },

            // INTERNAL. Use CardImovel.ackWhats() instead.
            "::get::CardImovel::ackWhats": {
              isArray: true,
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "GET",
            },

            // INTERNAL. Use CardImovel.ackWhats.create() instead.
            "::create::CardImovel::ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "POST",
            },

            // INTERNAL. Use CardImovel.ackWhats.createMany() instead.
            "::createMany::CardImovel::ackWhats": {
              isArray: true,
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "POST",
            },

            // INTERNAL. Use CardImovel.ackWhats.destroyAll() instead.
            "::delete::CardImovel::ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats",
              method: "DELETE",
            },

            // INTERNAL. Use CardImovel.ackWhats.count() instead.
            "::count::CardImovel::ackWhats": {
              url: urlBase + "/cardsimovel/:id/ackWhats/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#updateOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchOrCreateWithWhere
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#update
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#destroyById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#removeById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchAttributes
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovelWhatsAck id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#updateOrCreate
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchOrCreateWithWhere
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#update
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#destroyById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#removeById
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#patchAttributes
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovelWhatsAck id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovelWhatsAck` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CardImovelWhatsAck#modelName
        * @propertyOf lbServices.CardImovelWhatsAck
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CardImovelWhatsAck`.
        */
        R.modelName = "CardImovelWhatsAck";


            /**
             * @ngdoc method
             * @name lbServices.CardImovelWhatsAck#lead
             * @methodOf lbServices.CardImovelWhatsAck
             *
             * @description
             *
             * Fetches belongsTo relation lead.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CardImovelWhatsAck id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.lead = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::CardImovelWhatsAck::lead"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Time
 * @header lbServices.Time
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Time` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Time",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/times/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Time.tipo_interesse() instead.
            "prototype$__get__tipo_interesse": {
              url: urlBase + "/times/:id/tipo_interesse",
              method: "GET",
            },

            // INTERNAL. Use Time.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/times/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Time.gestor() instead.
            "prototype$__get__gestor": {
              url: urlBase + "/times/:id/gestor",
              method: "GET",
            },

            // INTERNAL. Use Time.regras.findById() instead.
            "prototype$__findById__regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.regras.destroyById() instead.
            "prototype$__destroyById__regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.regras.updateById() instead.
            "prototype$__updateById__regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.historico.findById() instead.
            "prototype$__findById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.historico.destroyById() instead.
            "prototype$__destroyById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.historico.updateById() instead.
            "prototype$__updateById__historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.timecorretor.findById() instead.
            "prototype$__findById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor.destroyById() instead.
            "prototype$__destroyById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.timecorretor.updateById() instead.
            "prototype$__updateById__timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.imoveis.findById() instead.
            "prototype$__findById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.imoveis.destroyById() instead.
            "prototype$__destroyById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.imoveis.updateById() instead.
            "prototype$__updateById__imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.tiposimovel.findById() instead.
            "prototype$__findById__tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.tiposimovel.destroyById() instead.
            "prototype$__destroyById__tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.tiposimovel.updateById() instead.
            "prototype$__updateById__tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.horario.findById() instead.
            "prototype$__findById__horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.horario.destroyById() instead.
            "prototype$__destroyById__horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.horario.updateById() instead.
            "prototype$__updateById__horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.regras() instead.
            "prototype$__get__regras": {
              isArray: true,
              url: urlBase + "/times/:id/regras",
              method: "GET",
            },

            // INTERNAL. Use Time.regras.create() instead.
            "prototype$__create__regras": {
              url: urlBase + "/times/:id/regras",
              method: "POST",
            },

            // INTERNAL. Use Time.regras.destroyAll() instead.
            "prototype$__delete__regras": {
              url: urlBase + "/times/:id/regras",
              method: "DELETE",
            },

            // INTERNAL. Use Time.regras.count() instead.
            "prototype$__count__regras": {
              url: urlBase + "/times/:id/regras/count",
              method: "GET",
            },

            // INTERNAL. Use Time.historico() instead.
            "prototype$__get__historico": {
              isArray: true,
              url: urlBase + "/times/:id/historico",
              method: "GET",
            },

            // INTERNAL. Use Time.historico.create() instead.
            "prototype$__create__historico": {
              url: urlBase + "/times/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Time.historico.destroyAll() instead.
            "prototype$__delete__historico": {
              url: urlBase + "/times/:id/historico",
              method: "DELETE",
            },

            // INTERNAL. Use Time.historico.count() instead.
            "prototype$__count__historico": {
              url: urlBase + "/times/:id/historico/count",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor() instead.
            "prototype$__get__timecorretor": {
              isArray: true,
              url: urlBase + "/times/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor.create() instead.
            "prototype$__create__timecorretor": {
              url: urlBase + "/times/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Time.timecorretor.destroyAll() instead.
            "prototype$__delete__timecorretor": {
              url: urlBase + "/times/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Time.timecorretor.count() instead.
            "prototype$__count__timecorretor": {
              url: urlBase + "/times/:id/timecorretor/count",
              method: "GET",
            },

            // INTERNAL. Use Time.imoveis() instead.
            "prototype$__get__imoveis": {
              isArray: true,
              url: urlBase + "/times/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Time.imoveis.create() instead.
            "prototype$__create__imoveis": {
              url: urlBase + "/times/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Time.imoveis.destroyAll() instead.
            "prototype$__delete__imoveis": {
              url: urlBase + "/times/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Time.imoveis.count() instead.
            "prototype$__count__imoveis": {
              url: urlBase + "/times/:id/imoveis/count",
              method: "GET",
            },

            // INTERNAL. Use Time.tiposimovel() instead.
            "prototype$__get__tiposimovel": {
              isArray: true,
              url: urlBase + "/times/:id/tiposimovel",
              method: "GET",
            },

            // INTERNAL. Use Time.tiposimovel.create() instead.
            "prototype$__create__tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel",
              method: "POST",
            },

            // INTERNAL. Use Time.tiposimovel.destroyAll() instead.
            "prototype$__delete__tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel",
              method: "DELETE",
            },

            // INTERNAL. Use Time.tiposimovel.count() instead.
            "prototype$__count__tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel/count",
              method: "GET",
            },

            // INTERNAL. Use Time.horario() instead.
            "prototype$__get__horario": {
              isArray: true,
              url: urlBase + "/times/:id/horario",
              method: "GET",
            },

            // INTERNAL. Use Time.horario.create() instead.
            "prototype$__create__horario": {
              url: urlBase + "/times/:id/horario",
              method: "POST",
            },

            // INTERNAL. Use Time.horario.destroyAll() instead.
            "prototype$__delete__horario": {
              url: urlBase + "/times/:id/horario",
              method: "DELETE",
            },

            // INTERNAL. Use Time.horario.count() instead.
            "prototype$__count__horario": {
              url: urlBase + "/times/:id/horario/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#create
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/times",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#createMany
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/times",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#upsert
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/times",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#replaceOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/times/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#upsertWithWhere
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/times/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#exists
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/times/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#findById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/times/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#replaceById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/times/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#find
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/times",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#findOne
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/times/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#updateAll
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/times/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#deleteById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/times/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#count
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/times/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#prototype$updateAttributes
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/times/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#createChangeStream
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/times/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#create
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/times",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#createMany
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/times",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#upsert
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/times",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#replaceOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/times/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#upsertWithWhere
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/times/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#exists
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/times/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#findById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/times/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#replaceById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/times/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#find
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/times",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#findOne
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/times/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#updateAll
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/times/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#deleteById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/times/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#count
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/times/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#prototype$updateAttributes
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/times/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#createChangeStream
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/times/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#pager
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/times/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#pagerDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/times/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#postDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/times/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#deleteDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/times/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#editDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/times/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#autocomplete
             * @methodOf lbServices.Time
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/times/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#autocompleteDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/times/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#autocompleteDetailEdit
             * @methodOf lbServices.Time
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/times/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#autocompleteGeneral
             * @methodOf lbServices.Time
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/times/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#crudGET
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/times/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#crudGETDetail
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/times/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Time#quickAdd
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/times/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.time() instead.
            "::get::ClienteInteressado::time": {
              url: urlBase + "/clientesinteressados/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeRegra.time() instead.
            "::get::TimeRegra::time": {
              url: urlBase + "/timeregras/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeHistorico.time() instead.
            "::get::TimeHistorico::time": {
              url: urlBase + "/timehistoricos/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeCorretor.time() instead.
            "::get::TimeCorretor::time": {
              url: urlBase + "/timesCorretores/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeImovel.time() instead.
            "::get::TimeImovel::time": {
              url: urlBase + "/timeimoveis/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeTipoImovel.time() instead.
            "::get::TimeTipoImovel::time": {
              url: urlBase + "/timetiposimovel/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeHorario.time() instead.
            "::get::TimeHorario::time": {
              url: urlBase + "/timehorarios/:id/time",
              method: "GET",
            },

            // INTERNAL. Use CampanhaTime.time() instead.
            "::get::CampanhaTime::time": {
              url: urlBase + "/campanhastimes/:id/time",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Time#patchOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Time#updateOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Time#patchOrCreateWithWhere
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Time#update
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Time#destroyById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Time#removeById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Time#patchAttributes
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Time#patchOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Time#updateOrCreate
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Time#patchOrCreateWithWhere
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Time#update
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Time#destroyById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Time#removeById
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Time#patchAttributes
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Time#modelName
        * @propertyOf lbServices.Time
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Time`.
        */
        R.modelName = "Time";


            /**
             * @ngdoc method
             * @name lbServices.Time#tipo_interesse
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Fetches belongsTo relation tipo_interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.tipo_interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::Time::tipo_interesse"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time#imobiliaria
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Time::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time#gestor
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Fetches belongsTo relation gestor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.gestor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::Time::gestor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.regras
     * @header lbServices.Time.regras
     * @object
     * @description
     *
     * The object `Time.regras` groups methods
     * manipulating `TimeRegra` instances related to `Time`.
     *
     * Call {@link lbServices.Time#regras Time.regras()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#regras
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries regras of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R.regras = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::get::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#count
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Counts regras of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.regras.count = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::count::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#create
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Creates a new instance in regras of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R.regras.create = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::create::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#createMany
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Creates a new instance in regras of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R.regras.createMany = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::createMany::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#destroyAll
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Deletes all regras of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.regras.destroyAll = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::delete::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#destroyById
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Delete a related item by id for regras.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for regras
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.regras.destroyById = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::destroyById::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#findById
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Find a related item by id for regras.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for regras
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R.regras.findById = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::findById::Time::regras"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.regras#updateById
             * @methodOf lbServices.Time.regras
             *
             * @description
             *
             * Update a related item by id for regras.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for regras
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R.regras.updateById = function() {
          var TargetResource = $injector.get("TimeRegra");
          var action = TargetResource["::updateById::Time::regras"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.historico
     * @header lbServices.Time.historico
     * @object
     * @description
     *
     * The object `Time.historico` groups methods
     * manipulating `TimeHistorico` instances related to `Time`.
     *
     * Call {@link lbServices.Time#historico Time.historico()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#historico
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries historico of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R.historico = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::get::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#count
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Counts historico of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.historico.count = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::count::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#create
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Creates a new instance in historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R.historico.create = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::create::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#createMany
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Creates a new instance in historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R.historico.createMany = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::createMany::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#destroyAll
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Deletes all historico of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historico.destroyAll = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::delete::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#destroyById
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Delete a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.historico.destroyById = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::destroyById::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#findById
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Find a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R.historico.findById = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::findById::Time::historico"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.historico#updateById
             * @methodOf lbServices.Time.historico
             *
             * @description
             *
             * Update a related item by id for historico.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for historico
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R.historico.updateById = function() {
          var TargetResource = $injector.get("TimeHistorico");
          var action = TargetResource["::updateById::Time::historico"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.timecorretor
     * @header lbServices.Time.timecorretor
     * @object
     * @description
     *
     * The object `Time.timecorretor` groups methods
     * manipulating `TimeCorretor` instances related to `Time`.
     *
     * Call {@link lbServices.Time#timecorretor Time.timecorretor()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#timecorretor
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries timecorretor of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::get::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#count
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Counts timecorretor of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.timecorretor.count = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::count::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#create
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.create = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::create::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#createMany
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Creates a new instance in timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.createMany = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::createMany::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#destroyAll
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Deletes all timecorretor of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyAll = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::delete::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#destroyById
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Delete a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.timecorretor.destroyById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::destroyById::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#findById
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Find a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.findById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::findById::Time::timecorretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.timecorretor#updateById
             * @methodOf lbServices.Time.timecorretor
             *
             * @description
             *
             * Update a related item by id for timecorretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for timecorretor
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R.timecorretor.updateById = function() {
          var TargetResource = $injector.get("TimeCorretor");
          var action = TargetResource["::updateById::Time::timecorretor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.imoveis
     * @header lbServices.Time.imoveis
     * @object
     * @description
     *
     * The object `Time.imoveis` groups methods
     * manipulating `TimeImovel` instances related to `Time`.
     *
     * Call {@link lbServices.Time#imoveis Time.imoveis()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#imoveis
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries imoveis of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R.imoveis = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::get::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#count
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Counts imoveis of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.imoveis.count = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::count::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#create
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R.imoveis.create = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::create::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#createMany
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Creates a new instance in imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R.imoveis.createMany = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::createMany::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#destroyAll
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Deletes all imoveis of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyAll = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::delete::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#destroyById
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Delete a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.imoveis.destroyById = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::destroyById::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#findById
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Find a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R.imoveis.findById = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::findById::Time::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.imoveis#updateById
             * @methodOf lbServices.Time.imoveis
             *
             * @description
             *
             * Update a related item by id for imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for imoveis
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R.imoveis.updateById = function() {
          var TargetResource = $injector.get("TimeImovel");
          var action = TargetResource["::updateById::Time::imoveis"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.tiposimovel
     * @header lbServices.Time.tiposimovel
     * @object
     * @description
     *
     * The object `Time.tiposimovel` groups methods
     * manipulating `TimeTipoImovel` instances related to `Time`.
     *
     * Call {@link lbServices.Time#tiposimovel Time.tiposimovel()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#tiposimovel
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries tiposimovel of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R.tiposimovel = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::get::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#count
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Counts tiposimovel of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.tiposimovel.count = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::count::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#create
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Creates a new instance in tiposimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R.tiposimovel.create = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::create::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#createMany
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Creates a new instance in tiposimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R.tiposimovel.createMany = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::createMany::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#destroyAll
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Deletes all tiposimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tiposimovel.destroyAll = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::delete::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#destroyById
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Delete a related item by id for tiposimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for tiposimovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.tiposimovel.destroyById = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::destroyById::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#findById
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Find a related item by id for tiposimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for tiposimovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R.tiposimovel.findById = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::findById::Time::tiposimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.tiposimovel#updateById
             * @methodOf lbServices.Time.tiposimovel
             *
             * @description
             *
             * Update a related item by id for tiposimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for tiposimovel
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R.tiposimovel.updateById = function() {
          var TargetResource = $injector.get("TimeTipoImovel");
          var action = TargetResource["::updateById::Time::tiposimovel"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Time.horario
     * @header lbServices.Time.horario
     * @object
     * @description
     *
     * The object `Time.horario` groups methods
     * manipulating `TimeHorario` instances related to `Time`.
     *
     * Call {@link lbServices.Time#horario Time.horario()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Time#horario
             * @methodOf lbServices.Time
             *
             * @description
             *
             * Queries horario of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R.horario = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::get::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#count
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Counts horario of Time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.horario.count = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::count::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#create
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Creates a new instance in horario of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R.horario.create = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::create::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#createMany
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Creates a new instance in horario of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R.horario.createMany = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::createMany::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#destroyAll
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Deletes all horario of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.horario.destroyAll = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::delete::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#destroyById
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Delete a related item by id for horario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for horario
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.horario.destroyById = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::destroyById::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#findById
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Find a related item by id for horario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for horario
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R.horario.findById = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::findById::Time::horario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Time.horario#updateById
             * @methodOf lbServices.Time.horario
             *
             * @description
             *
             * Update a related item by id for horario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Time id
             *
             *  - `fk` – `{*}` - Foreign key for horario
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R.horario.updateById = function() {
          var TargetResource = $injector.get("TimeHorario");
          var action = TargetResource["::updateById::Time::horario"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeRegra
 * @header lbServices.TimeRegra
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeRegra` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeRegra",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timeregras/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeRegra.tipo_interesse() instead.
            "prototype$__get__tipo_interesse": {
              url: urlBase + "/timeregras/:id/tipo_interesse",
              method: "GET",
            },

            // INTERNAL. Use TimeRegra.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/timeregras/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TimeRegra.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timeregras/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#create
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timeregras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#createMany
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timeregras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#upsert
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timeregras",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#replaceOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timeregras/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#upsertWithWhere
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timeregras/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#exists
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timeregras/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#findById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timeregras/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#replaceById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timeregras/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#find
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timeregras",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#findOne
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timeregras/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#updateAll
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timeregras/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#deleteById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timeregras/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#count
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timeregras/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#prototype$updateAttributes
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timeregras/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#createChangeStream
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timeregras/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#create
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timeregras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#createMany
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timeregras",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#upsert
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timeregras",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#replaceOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timeregras/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#upsertWithWhere
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timeregras/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#exists
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timeregras/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#findById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timeregras/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#replaceById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timeregras/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#find
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timeregras",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#findOne
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timeregras/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#updateAll
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timeregras/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#deleteById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timeregras/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#count
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timeregras/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#prototype$updateAttributes
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timeregras/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#createChangeStream
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timeregras/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#pager
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timeregras/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#pagerDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timeregras/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#postDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timeregras/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#deleteDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timeregras/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#editDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timeregras/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#autocomplete
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timeregras/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#autocompleteDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timeregras/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#autocompleteDetailEdit
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timeregras/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#autocompleteGeneral
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timeregras/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#crudGET
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timeregras/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#crudGETDetail
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timeregras/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#quickAdd
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timeregras/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Time.regras.findById() instead.
            "::findById::Time::regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.regras.destroyById() instead.
            "::destroyById::Time::regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.regras.updateById() instead.
            "::updateById::Time::regras": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/regras/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.regras() instead.
            "::get::Time::regras": {
              isArray: true,
              url: urlBase + "/times/:id/regras",
              method: "GET",
            },

            // INTERNAL. Use Time.regras.create() instead.
            "::create::Time::regras": {
              url: urlBase + "/times/:id/regras",
              method: "POST",
            },

            // INTERNAL. Use Time.regras.createMany() instead.
            "::createMany::Time::regras": {
              isArray: true,
              url: urlBase + "/times/:id/regras",
              method: "POST",
            },

            // INTERNAL. Use Time.regras.destroyAll() instead.
            "::delete::Time::regras": {
              url: urlBase + "/times/:id/regras",
              method: "DELETE",
            },

            // INTERNAL. Use Time.regras.count() instead.
            "::count::Time::regras": {
              url: urlBase + "/times/:id/regras/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#updateOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchOrCreateWithWhere
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#update
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#destroyById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#removeById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchAttributes
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#updateOrCreate
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchOrCreateWithWhere
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#update
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#destroyById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#removeById
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#patchAttributes
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeRegra` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeRegra#modelName
        * @propertyOf lbServices.TimeRegra
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeRegra`.
        */
        R.modelName = "TimeRegra";


            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#tipo_interesse
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Fetches belongsTo relation tipo_interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.tipo_interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::TimeRegra::tipo_interesse"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#corretor
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::TimeRegra::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeRegra#time
             * @methodOf lbServices.TimeRegra
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeRegra id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeRegra::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeHistorico
 * @header lbServices.TimeHistorico
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeHistorico` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeHistorico",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timehistoricos/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeHistorico.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/timehistoricos/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TimeHistorico.cards() instead.
            "prototype$__get__cards": {
              url: urlBase + "/timehistoricos/:id/cards",
              method: "GET",
            },

            // INTERNAL. Use TimeHistorico.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timehistoricos/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#create
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timehistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#createMany
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timehistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#upsert
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timehistoricos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#replaceOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timehistoricos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#upsertWithWhere
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timehistoricos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#exists
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timehistoricos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#findById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timehistoricos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#replaceById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timehistoricos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#find
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timehistoricos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#findOne
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timehistoricos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#updateAll
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timehistoricos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#deleteById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timehistoricos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#count
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timehistoricos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#prototype$updateAttributes
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timehistoricos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#createChangeStream
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timehistoricos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#create
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timehistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#createMany
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timehistoricos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#upsert
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timehistoricos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#replaceOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timehistoricos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#upsertWithWhere
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timehistoricos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#exists
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timehistoricos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#findById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timehistoricos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#replaceById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timehistoricos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#find
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timehistoricos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#findOne
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timehistoricos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#updateAll
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timehistoricos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#deleteById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timehistoricos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#count
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timehistoricos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#prototype$updateAttributes
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timehistoricos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#createChangeStream
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timehistoricos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#pager
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timehistoricos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#pagerDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timehistoricos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#postDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timehistoricos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#deleteDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timehistoricos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#editDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timehistoricos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#autocomplete
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timehistoricos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#autocompleteDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timehistoricos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#autocompleteDetailEdit
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timehistoricos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#autocompleteGeneral
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timehistoricos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#crudGET
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timehistoricos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#crudGETDetail
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timehistoricos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#quickAdd
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timehistoricos/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Time.historico.findById() instead.
            "::findById::Time::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.historico.destroyById() instead.
            "::destroyById::Time::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.historico.updateById() instead.
            "::updateById::Time::historico": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/historico/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.historico() instead.
            "::get::Time::historico": {
              isArray: true,
              url: urlBase + "/times/:id/historico",
              method: "GET",
            },

            // INTERNAL. Use Time.historico.create() instead.
            "::create::Time::historico": {
              url: urlBase + "/times/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Time.historico.createMany() instead.
            "::createMany::Time::historico": {
              isArray: true,
              url: urlBase + "/times/:id/historico",
              method: "POST",
            },

            // INTERNAL. Use Time.historico.destroyAll() instead.
            "::delete::Time::historico": {
              url: urlBase + "/times/:id/historico",
              method: "DELETE",
            },

            // INTERNAL. Use Time.historico.count() instead.
            "::count::Time::historico": {
              url: urlBase + "/times/:id/historico/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#updateOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchOrCreateWithWhere
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#update
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#destroyById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#removeById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchAttributes
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#updateOrCreate
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchOrCreateWithWhere
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#update
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#destroyById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#removeById
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#patchAttributes
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHistorico` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeHistorico#modelName
        * @propertyOf lbServices.TimeHistorico
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeHistorico`.
        */
        R.modelName = "TimeHistorico";


            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#corretor
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Corretor` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Corretor");
          var action = TargetResource["::get::TimeHistorico::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#cards
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Fetches belongsTo relation cards.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.cards = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::TimeHistorico::cards"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeHistorico#time
             * @methodOf lbServices.TimeHistorico
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHistorico id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeHistorico::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ClienteInteressadoStatus
 * @header lbServices.ClienteInteressadoStatus
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ClienteInteressadoStatus` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ClienteInteressadoStatus",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clienteinteressadostatus/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status() instead.
            "prototype$__get__cliente_interessado_status": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.findById() instead.
            "prototype$__findById__cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.destroyById() instead.
            "prototype$__destroyById__cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.updateById() instead.
            "prototype$__updateById__cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressadoStatus.interesse() instead.
            "prototype$__get__interesse": {
              url: urlBase + "/clienteinteressadostatus/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_() instead.
            "prototype$__get__cliente_interessado_status_": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.create() instead.
            "prototype$__create__cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.destroyAll() instead.
            "prototype$__delete__cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.count() instead.
            "prototype$__count__cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#create
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#createMany
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#upsert
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadostatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadostatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadostatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#exists
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadostatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#findById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#replaceById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadostatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#find
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#findOne
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadostatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#updateAll
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadostatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#deleteById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#count
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadostatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#createChangeStream
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadostatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#trocastatus
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "trocastatus": {
              url: urlBase + "/clienteinteressadostatus/trocastatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#addcard
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "addcard": {
              url: urlBase + "/clienteinteressadostatus/addcard",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#trocainteresse
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "trocainteresse": {
              url: urlBase + "/clienteinteressadostatus/trocainteresse",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#create
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#createMany
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#upsert
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadostatus",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadostatus/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadostatus/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#exists
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadostatus/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#findById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#replaceById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadostatus/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#find
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#findOne
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadostatus/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#updateAll
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadostatus/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#deleteById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#count
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadostatus/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadostatus/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#createChangeStream
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadostatus/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#pager
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clienteinteressadostatus/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#pagerDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#postDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#deleteDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#editDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#autocomplete
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clienteinteressadostatus/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#autocompleteDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#autocompleteDetailEdit
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clienteinteressadostatus/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#autocompleteGeneral
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clienteinteressadostatus/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#crudGET
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clienteinteressadostatus/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#crudGETDetail
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clienteinteressadostatus/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#quickAdd
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clienteinteressadostatus/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.cliente_interessado_status() instead.
            "::get::ClienteInteressado::cliente_interessado_status": {
              url: urlBase + "/clientesinteressados/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status() instead.
            "::get::ClienteInteressadoStatus::cliente_interessado_status": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.findById() instead.
            "::findById::ClienteInteressadoStatus::cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.destroyById() instead.
            "::destroyById::ClienteInteressadoStatus::cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.updateById() instead.
            "::updateById::ClienteInteressadoStatus::cliente_interessado_status_": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_() instead.
            "::get::ClienteInteressadoStatus::cliente_interessado_status_": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.create() instead.
            "::create::ClienteInteressadoStatus::cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.createMany() instead.
            "::createMany::ClienteInteressadoStatus::cliente_interessado_status_": {
              isArray: true,
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.destroyAll() instead.
            "::delete::ClienteInteressadoStatus::cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressadoStatus.cliente_interessado_status_.count() instead.
            "::count::ClienteInteressadoStatus::cliente_interessado_status_": {
              url: urlBase + "/clienteinteressadostatus/:id/cliente_interessado_status_/count",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado_status() instead.
            "::get::ClienteInteressadoAtividade::cliente_interessado_status": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaStatusCliente.status() instead.
            "::get::ImobiliariaStatusCliente::status": {
              url: urlBase + "/imobiliariastatusclientes/:id/status",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#update
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#destroyById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#removeById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchAttributes
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#update
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#destroyById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#removeById
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#patchAttributes
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ClienteInteressadoStatus#modelName
        * @propertyOf lbServices.ClienteInteressadoStatus
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ClienteInteressadoStatus`.
        */
        R.modelName = "ClienteInteressadoStatus";


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#cliente_interessado_status
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado_status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::get::ClienteInteressadoStatus::cliente_interessado_status"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_
     * @header lbServices.ClienteInteressadoStatus.cliente_interessado_status_
     * @object
     * @description
     *
     * The object `ClienteInteressadoStatus.cliente_interessado_status_` groups methods
     * manipulating `ClienteInteressadoStatus` instances related to `ClienteInteressadoStatus`.
     *
     * Call {@link lbServices.ClienteInteressadoStatus#cliente_interessado_status_ ClienteInteressadoStatus.cliente_interessado_status_()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#cliente_interessado_status_
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Queries cliente_interessado_status_ of ClienteInteressadoStatus.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status_ = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::get::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#count
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Counts cliente_interessado_status_ of ClienteInteressadoStatus.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.cliente_interessado_status_.count = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::count::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#create
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Creates a new instance in cliente_interessado_status_ of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status_.create = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::create::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#createMany
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Creates a new instance in cliente_interessado_status_ of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status_.createMany = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::createMany::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#destroyAll
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Deletes all cliente_interessado_status_ of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cliente_interessado_status_.destroyAll = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::delete::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#destroyById
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Delete a related item by id for cliente_interessado_status_.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cliente_interessado_status_
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.cliente_interessado_status_.destroyById = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::destroyById::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#findById
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Find a related item by id for cliente_interessado_status_.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for cliente_interessado_status_
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status_.findById = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::findById::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus.cliente_interessado_status_#updateById
             * @methodOf lbServices.ClienteInteressadoStatus.cliente_interessado_status_
             *
             * @description
             *
             * Update a related item by id for cliente_interessado_status_.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `fk` – `{*}` - Foreign key for cliente_interessado_status_
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status_.updateById = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::updateById::ClienteInteressadoStatus::cliente_interessado_status_"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoStatus#interesse
             * @methodOf lbServices.ClienteInteressadoStatus
             *
             * @description
             *
             * Fetches belongsTo relation interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoStatus id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::ClienteInteressadoStatus::interesse"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ClienteInteressadoAtividade
 * @header lbServices.ClienteInteressadoAtividade
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ClienteInteressadoAtividade` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ClienteInteressadoAtividade",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clienteinteressadoatividades/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado_status() instead.
            "prototype$__get__cliente_interessado_status": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado_status",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.historico_cliente_interessado() instead.
            "prototype$__get__historico_cliente_interessado": {
              url: urlBase + "/clienteinteressadoatividades/:id/historico_cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado() instead.
            "prototype$__get__cliente_interessado": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.usuario() instead.
            "prototype$__get__usuario": {
              url: urlBase + "/clienteinteressadoatividades/:id/usuario",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/clienteinteressadoatividades/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.card() instead.
            "prototype$__get__card": {
              url: urlBase + "/clienteinteressadoatividades/:id/card",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.interesse() instead.
            "prototype$__get__interesse": {
              url: urlBase + "/clienteinteressadoatividades/:id/interesse",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado_atividade_tipo() instead.
            "prototype$__get__cliente_interessado_atividade_tipo": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado_atividade_tipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#create
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadoatividades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#createMany
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#upsert
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadoatividades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadoatividades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadoatividades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#exists
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadoatividades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#findById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#replaceById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadoatividades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#find
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#findOne
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadoatividades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#updateAll
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadoatividades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#deleteById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#count
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadoatividades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#createChangeStream
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadoatividades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#comentario
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find imobs by domain.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "comentario": {
              url: urlBase + "/clienteinteressadoatividades/comentario",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#create
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadoatividades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#createMany
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividades",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#upsert
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadoatividades",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadoatividades/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadoatividades/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#exists
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadoatividades/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#findById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#replaceById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadoatividades/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#find
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividades",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#findOne
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadoatividades/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#updateAll
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadoatividades/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#deleteById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#count
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadoatividades/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadoatividades/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#createChangeStream
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadoatividades/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#pager
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clienteinteressadoatividades/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#pagerDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#postDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#deleteDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#editDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#autocomplete
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clienteinteressadoatividades/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#autocompleteDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#autocompleteDetailEdit
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clienteinteressadoatividades/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#autocompleteGeneral
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clienteinteressadoatividades/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#crudGET
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clienteinteressadoatividades/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#crudGETDetail
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clienteinteressadoatividades/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#quickAdd
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clienteinteressadoatividades/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.atividades.findById() instead.
            "::findById::ClienteInteressado::atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades.destroyById() instead.
            "::destroyById::ClienteInteressado::atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.atividades.updateById() instead.
            "::updateById::ClienteInteressado::atividades": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/atividades/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.atividades() instead.
            "::get::ClienteInteressado::atividades": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.atividades.create() instead.
            "::create::ClienteInteressado::atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.atividades.createMany() instead.
            "::createMany::ClienteInteressado::atividades": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.atividades.destroyAll() instead.
            "::delete::ClienteInteressado::atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.atividades.count() instead.
            "::count::ClienteInteressado::atividades": {
              url: urlBase + "/clientesinteressados/:id/atividades/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#update
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#destroyById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#removeById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchAttributes
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#update
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#destroyById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#removeById
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#patchAttributes
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividade` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ClienteInteressadoAtividade#modelName
        * @propertyOf lbServices.ClienteInteressadoAtividade
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ClienteInteressadoAtividade`.
        */
        R.modelName = "ClienteInteressadoAtividade";


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#cliente_interessado_status
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado_status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.cliente_interessado_status = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::get::ClienteInteressadoAtividade::cliente_interessado_status"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#historico_cliente_interessado
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation historico_cliente_interessado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `HistoricoClienteInteressado` object.)
             * </em>
             */
        R.historico_cliente_interessado = function() {
          var TargetResource = $injector.get("HistoricoClienteInteressado");
          var action = TargetResource["::get::ClienteInteressadoAtividade::historico_cliente_interessado"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#cliente_interessado
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.cliente_interessado = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::ClienteInteressadoAtividade::cliente_interessado"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#usuario
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.usuario = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::ClienteInteressadoAtividade::usuario"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#corretor
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::ClienteInteressadoAtividade::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#card
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation card.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.card = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::ClienteInteressadoAtividade::card"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#interesse
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation interesse.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.interesse = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::ClienteInteressadoAtividade::interesse"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividade#cliente_interessado_atividade_tipo
             * @methodOf lbServices.ClienteInteressadoAtividade
             *
             * @description
             *
             * Fetches belongsTo relation cliente_interessado_atividade_tipo.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividade id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R.cliente_interessado_atividade_tipo = function() {
          var TargetResource = $injector.get("ClienteInteressadoAtividadeTipo");
          var action = TargetResource["::get::ClienteInteressadoAtividade::cliente_interessado_atividade_tipo"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ClienteInteressadoAtividadeTipo
 * @header lbServices.ClienteInteressadoAtividadeTipo
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ClienteInteressadoAtividadeTipo` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ClienteInteressadoAtividadeTipo",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clienteinteressadoatividadetipo/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#create
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#createMany
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#upsert
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadoatividadetipo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadoatividadetipo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#exists
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#findById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#replaceById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#find
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#findOne
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadoatividadetipo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#updateAll
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadoatividadetipo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#deleteById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#count
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadoatividadetipo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividadeTipo id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#createChangeStream
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadoatividadetipo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#create
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#createMany
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#upsert
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clienteinteressadoatividadetipo/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clienteinteressadoatividadetipo/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#exists
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#findById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#replaceById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#find
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clienteinteressadoatividadetipo",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#findOne
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clienteinteressadoatividadetipo/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#updateAll
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clienteinteressadoatividadetipo/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#deleteById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#count
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clienteinteressadoatividadetipo/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividadeTipo id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clienteinteressadoatividadetipo/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#createChangeStream
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clienteinteressadoatividadetipo/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#pager
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clienteinteressadoatividadetipo/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#pagerDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#postDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#deleteDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#editDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#autocomplete
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clienteinteressadoatividadetipo/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#autocompleteDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#autocompleteDetailEdit
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#autocompleteGeneral
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clienteinteressadoatividadetipo/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#crudGET
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clienteinteressadoatividadetipo/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#crudGETDetail
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clienteinteressadoatividadetipo/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#quickAdd
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clienteinteressadoatividadetipo/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressadoAtividade.cliente_interessado_atividade_tipo() instead.
            "::get::ClienteInteressadoAtividade::cliente_interessado_atividade_tipo": {
              url: urlBase + "/clienteinteressadoatividades/:id/cliente_interessado_atividade_tipo",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#update
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#destroyById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#removeById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchAttributes
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividadeTipo id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#update
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#destroyById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#removeById
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoAtividadeTipo#patchAttributes
             * @methodOf lbServices.ClienteInteressadoAtividadeTipo
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoAtividadeTipo id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoAtividadeTipo` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ClienteInteressadoAtividadeTipo#modelName
        * @propertyOf lbServices.ClienteInteressadoAtividadeTipo
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ClienteInteressadoAtividadeTipo`.
        */
        R.modelName = "ClienteInteressadoAtividadeTipo";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeCorretor
 * @header lbServices.TimeCorretor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeCorretor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeCorretor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timesCorretores/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeCorretor.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timesCorretores/:id/time",
              method: "GET",
            },

            // INTERNAL. Use TimeCorretor.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/timesCorretores/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use TimeCorretor.tipoNegocio() instead.
            "prototype$__get__tipoNegocio": {
              url: urlBase + "/timesCorretores/:id/tipoNegocio",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#create
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timesCorretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#createMany
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timesCorretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#upsert
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timesCorretores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#replaceOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timesCorretores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#upsertWithWhere
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timesCorretores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#exists
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timesCorretores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#findById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timesCorretores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#replaceById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timesCorretores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#find
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timesCorretores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#findOne
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timesCorretores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#updateAll
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timesCorretores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#deleteById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timesCorretores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#count
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timesCorretores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#prototype$updateAttributes
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timesCorretores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#createChangeStream
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timesCorretores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#create
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timesCorretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#createMany
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timesCorretores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#upsert
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timesCorretores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#replaceOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timesCorretores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#upsertWithWhere
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timesCorretores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#exists
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timesCorretores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#findById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timesCorretores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#replaceById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timesCorretores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#find
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timesCorretores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#findOne
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timesCorretores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#updateAll
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timesCorretores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#deleteById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timesCorretores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#count
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timesCorretores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#prototype$updateAttributes
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timesCorretores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#createChangeStream
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timesCorretores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#pager
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timesCorretores/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#pagerDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timesCorretores/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#postDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timesCorretores/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#deleteDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timesCorretores/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#editDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timesCorretores/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#autocomplete
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timesCorretores/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#autocompleteDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timesCorretores/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#autocompleteDetailEdit
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timesCorretores/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#autocompleteGeneral
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timesCorretores/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#crudGET
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timesCorretores/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#crudGETDetail
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timesCorretores/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#quickAdd
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timesCorretores/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Usuario.timecorretor.findById() instead.
            "::findById::Usuario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Usuario.timecorretor.destroyById() instead.
            "::destroyById::Usuario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.timecorretor.updateById() instead.
            "::updateById::Usuario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Usuario.timecorretor() instead.
            "::get::Usuario::timecorretor": {
              isArray: true,
              url: urlBase + "/users/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Usuario.timecorretor.create() instead.
            "::create::Usuario::timecorretor": {
              url: urlBase + "/users/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Usuario.timecorretor.createMany() instead.
            "::createMany::Usuario::timecorretor": {
              isArray: true,
              url: urlBase + "/users/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Usuario.timecorretor.destroyAll() instead.
            "::delete::Usuario::timecorretor": {
              url: urlBase + "/users/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Usuario.timecorretor.count() instead.
            "::count::Usuario::timecorretor": {
              url: urlBase + "/users/:id/timecorretor/count",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor.findById() instead.
            "::findById::Corretor::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor.destroyById() instead.
            "::destroyById::Corretor::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.timecorretor.updateById() instead.
            "::updateById::Corretor::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/corretores/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Corretor.timecorretor() instead.
            "::get::Corretor::timecorretor": {
              isArray: true,
              url: urlBase + "/corretores/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Corretor.timecorretor.create() instead.
            "::create::Corretor::timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Corretor.timecorretor.createMany() instead.
            "::createMany::Corretor::timecorretor": {
              isArray: true,
              url: urlBase + "/corretores/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Corretor.timecorretor.destroyAll() instead.
            "::delete::Corretor::timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Corretor.timecorretor.count() instead.
            "::count::Corretor::timecorretor": {
              url: urlBase + "/corretores/:id/timecorretor/count",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor.findById() instead.
            "::findById::Proprietario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor.destroyById() instead.
            "::destroyById::Proprietario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.timecorretor.updateById() instead.
            "::updateById::Proprietario::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.timecorretor() instead.
            "::get::Proprietario::timecorretor": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.timecorretor.create() instead.
            "::create::Proprietario::timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.timecorretor.createMany() instead.
            "::createMany::Proprietario::timecorretor": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.timecorretor.destroyAll() instead.
            "::delete::Proprietario::timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.timecorretor.count() instead.
            "::count::Proprietario::timecorretor": {
              url: urlBase + "/proprietarios/:id/timecorretor/count",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor.findById() instead.
            "::findById::Time::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor.destroyById() instead.
            "::destroyById::Time::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.timecorretor.updateById() instead.
            "::updateById::Time::timecorretor": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/timecorretor/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.timecorretor() instead.
            "::get::Time::timecorretor": {
              isArray: true,
              url: urlBase + "/times/:id/timecorretor",
              method: "GET",
            },

            // INTERNAL. Use Time.timecorretor.create() instead.
            "::create::Time::timecorretor": {
              url: urlBase + "/times/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Time.timecorretor.createMany() instead.
            "::createMany::Time::timecorretor": {
              isArray: true,
              url: urlBase + "/times/:id/timecorretor",
              method: "POST",
            },

            // INTERNAL. Use Time.timecorretor.destroyAll() instead.
            "::delete::Time::timecorretor": {
              url: urlBase + "/times/:id/timecorretor",
              method: "DELETE",
            },

            // INTERNAL. Use Time.timecorretor.count() instead.
            "::count::Time::timecorretor": {
              url: urlBase + "/times/:id/timecorretor/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#updateOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchOrCreateWithWhere
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#update
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#destroyById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#removeById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchAttributes
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#updateOrCreate
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchOrCreateWithWhere
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#update
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#destroyById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#removeById
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#patchAttributes
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeCorretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeCorretor#modelName
        * @propertyOf lbServices.TimeCorretor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeCorretor`.
        */
        R.modelName = "TimeCorretor";


            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#time
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeCorretor::time"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#corretor
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::TimeCorretor::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeCorretor#tipoNegocio
             * @methodOf lbServices.TimeCorretor
             *
             * @description
             *
             * Fetches belongsTo relation tipoNegocio.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeCorretor id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoNegocio` object.)
             * </em>
             */
        R.tipoNegocio = function() {
          var TargetResource = $injector.get("TipoNegocio");
          var action = TargetResource["::get::TimeCorretor::tipoNegocio"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PortalImovel
 * @header lbServices.PortalImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PortalImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PortalImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/portalimoveis/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PortalImovel.imoveis() instead.
            "prototype$__get__imoveis": {
              url: urlBase + "/portalimoveis/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.portimovel() instead.
            "prototype$__get__portimovel": {
              url: urlBase + "/portalimoveis/:id/portimovel",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/portalimoveis/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.portalimobiliaria() instead.
            "prototype$__get__portalimobiliaria": {
              url: urlBase + "/portalimoveis/:id/portalimobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#create
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portalimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#createMany
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portalimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#upsert
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portalimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#replaceOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portalimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#upsertWithWhere
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portalimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#exists
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portalimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#findById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portalimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#replaceById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portalimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#find
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portalimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#findOne
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portalimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#updateAll
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portalimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#deleteById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portalimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#count
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portalimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#prototype$updateAttributes
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portalimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#createChangeStream
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portalimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#addDestaques
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Add imóveis highlight and super highlight
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "addDestaques": {
              url: urlBase + "/portalimoveis/adicionar-destaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#removeDestaques
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * remove highlight and super highlight
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "removeDestaques": {
              url: urlBase + "/portalimoveis/remove-destaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#removeImoveis
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * remove highlight and super highlight
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "removeImoveis": {
              url: urlBase + "/portalimoveis/remove-imoveis",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#alterDestaques
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * remove highlight and super highlight
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "alterDestaques": {
              url: urlBase + "/portalimoveis/alterar-destaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#csvDestaques
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "csvDestaques": {
              isArray: true,
              url: urlBase + "/portalimoveis/csv-destaques",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#create
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portalimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#createMany
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portalimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#upsert
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portalimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#replaceOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portalimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#upsertWithWhere
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portalimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#exists
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portalimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#findById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portalimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#replaceById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portalimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#find
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portalimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#findOne
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portalimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#updateAll
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portalimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#deleteById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portalimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#count
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portalimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#prototype$updateAttributes
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portalimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#createChangeStream
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portalimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#pager
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/portalimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#pagerDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/portalimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#postDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/portalimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#deleteDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/portalimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#editDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/portalimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#autocomplete
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/portalimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#autocompleteDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/portalimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#autocompleteDetailEdit
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/portalimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#autocompleteGeneral
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/portalimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#crudGET
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/portalimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#crudGETDetail
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/portalimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#quickAdd
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/portalimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.portal_imovel.findById() instead.
            "::findById::Imovel::portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.portal_imovel.destroyById() instead.
            "::destroyById::Imovel::portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.portal_imovel.updateById() instead.
            "::updateById::Imovel::portal_imovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/portal_imovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.portal_imovel() instead.
            "::get::Imovel::portal_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "GET",
            },

            // INTERNAL. Use Imovel.portal_imovel.create() instead.
            "::create::Imovel::portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.portal_imovel.createMany() instead.
            "::createMany::Imovel::portal_imovel": {
              isArray: true,
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "POST",
            },

            // INTERNAL. Use Imovel.portal_imovel.destroyAll() instead.
            "::delete::Imovel::portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.portal_imovel.count() instead.
            "::count::Imovel::portal_imovel": {
              url: urlBase + "/imoveis/:id/portal_imovel/count",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel.findById() instead.
            "::findById::Portal::portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel.destroyById() instead.
            "::destroyById::Portal::portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portimovel.updateById() instead.
            "::updateById::Portal::portimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.portimovel() instead.
            "::get::Portal::portimovel": {
              isArray: true,
              url: urlBase + "/portais/:id/portimovel",
              method: "GET",
            },

            // INTERNAL. Use Portal.portimovel.create() instead.
            "::create::Portal::portimovel": {
              url: urlBase + "/portais/:id/portimovel",
              method: "POST",
            },

            // INTERNAL. Use Portal.portimovel.createMany() instead.
            "::createMany::Portal::portimovel": {
              isArray: true,
              url: urlBase + "/portais/:id/portimovel",
              method: "POST",
            },

            // INTERNAL. Use Portal.portimovel.destroyAll() instead.
            "::delete::Portal::portimovel": {
              url: urlBase + "/portais/:id/portimovel",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portimovel.count() instead.
            "::count::Portal::portimovel": {
              url: urlBase + "/portais/:id/portimovel/count",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.findById() instead.
            "::findById::ImobiliariaPortal::portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.destroyById() instead.
            "::destroyById::ImobiliariaPortal::portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.updateById() instead.
            "::updateById::ImobiliariaPortal::portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel() instead.
            "::get::ImobiliariaPortal::portalimovel": {
              isArray: true,
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.create() instead.
            "::create::ImobiliariaPortal::portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.createMany() instead.
            "::createMany::ImobiliariaPortal::portalimovel": {
              isArray: true,
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.destroyAll() instead.
            "::delete::ImobiliariaPortal::portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.count() instead.
            "::count::ImobiliariaPortal::portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#updateOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchOrCreateWithWhere
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#update
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#destroyById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#removeById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchAttributes
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#updateOrCreate
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchOrCreateWithWhere
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#update
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#destroyById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#removeById
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#patchAttributes
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PortalImovel#modelName
        * @propertyOf lbServices.PortalImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PortalImovel`.
        */
        R.modelName = "PortalImovel";


            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#imoveis
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Fetches belongsTo relation imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imoveis = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::PortalImovel::imoveis"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#portimovel
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Fetches belongsTo relation portimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R.portimovel = function() {
          var TargetResource = $injector.get("Portal");
          var action = TargetResource["::get::PortalImovel::portimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#imobiliaria
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::PortalImovel::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PortalImovel#portalimobiliaria
             * @methodOf lbServices.PortalImovel
             *
             * @description
             *
             * Fetches belongsTo relation portalimobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R.portalimobiliaria = function() {
          var TargetResource = $injector.get("ImobiliariaPortal");
          var action = TargetResource["::get::PortalImovel::portalimobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeImovel
 * @header lbServices.TimeImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timeimoveis/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeImovel.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/timeimoveis/:id/imovel",
              method: "GET",
            },

            // INTERNAL. Use TimeImovel.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timeimoveis/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#create
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timeimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#createMany
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timeimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#upsert
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timeimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#replaceOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timeimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#upsertWithWhere
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timeimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#exists
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timeimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#findById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timeimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#replaceById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timeimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#find
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timeimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#findOne
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timeimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#updateAll
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timeimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#deleteById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timeimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#count
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timeimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#prototype$updateAttributes
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timeimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#createChangeStream
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timeimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#create
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timeimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#createMany
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timeimoveis",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#upsert
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timeimoveis",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#replaceOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timeimoveis/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#upsertWithWhere
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timeimoveis/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#exists
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timeimoveis/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#findById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timeimoveis/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#replaceById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timeimoveis/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#find
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timeimoveis",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#findOne
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timeimoveis/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#updateAll
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timeimoveis/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#deleteById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timeimoveis/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#count
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timeimoveis/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#prototype$updateAttributes
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timeimoveis/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#createChangeStream
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timeimoveis/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#pager
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timeimoveis/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#pagerDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timeimoveis/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#postDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timeimoveis/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#deleteDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timeimoveis/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#editDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timeimoveis/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#autocomplete
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timeimoveis/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#autocompleteDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timeimoveis/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#autocompleteDetailEdit
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timeimoveis/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#autocompleteGeneral
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timeimoveis/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#crudGET
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timeimoveis/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#crudGETDetail
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timeimoveis/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#quickAdd
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timeimoveis/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Time.imoveis.findById() instead.
            "::findById::Time::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.imoveis.destroyById() instead.
            "::destroyById::Time::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.imoveis.updateById() instead.
            "::updateById::Time::imoveis": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/imoveis/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.imoveis() instead.
            "::get::Time::imoveis": {
              isArray: true,
              url: urlBase + "/times/:id/imoveis",
              method: "GET",
            },

            // INTERNAL. Use Time.imoveis.create() instead.
            "::create::Time::imoveis": {
              url: urlBase + "/times/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Time.imoveis.createMany() instead.
            "::createMany::Time::imoveis": {
              isArray: true,
              url: urlBase + "/times/:id/imoveis",
              method: "POST",
            },

            // INTERNAL. Use Time.imoveis.destroyAll() instead.
            "::delete::Time::imoveis": {
              url: urlBase + "/times/:id/imoveis",
              method: "DELETE",
            },

            // INTERNAL. Use Time.imoveis.count() instead.
            "::count::Time::imoveis": {
              url: urlBase + "/times/:id/imoveis/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#updateOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#update
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#destroyById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#removeById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchAttributes
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#updateOrCreate
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#update
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#destroyById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#removeById
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#patchAttributes
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeImovel#modelName
        * @propertyOf lbServices.TimeImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeImovel`.
        */
        R.modelName = "TimeImovel";


            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#imovel
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::TimeImovel::imovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeImovel#time
             * @methodOf lbServices.TimeImovel
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeImovel::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeTipoImovel
 * @header lbServices.TimeTipoImovel
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeTipoImovel` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeTipoImovel",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timetiposimovel/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeTipoImovel.tipoimovel() instead.
            "prototype$__get__tipoimovel": {
              url: urlBase + "/timetiposimovel/:id/tipoimovel",
              method: "GET",
            },

            // INTERNAL. Use TimeTipoImovel.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timetiposimovel/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#create
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timetiposimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#createMany
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timetiposimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#upsert
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timetiposimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#replaceOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timetiposimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#upsertWithWhere
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timetiposimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#exists
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timetiposimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#findById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timetiposimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#replaceById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timetiposimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#find
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timetiposimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#findOne
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timetiposimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#updateAll
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timetiposimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#deleteById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timetiposimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#count
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timetiposimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#prototype$updateAttributes
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timetiposimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#createChangeStream
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timetiposimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#create
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timetiposimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#createMany
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timetiposimovel",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#upsert
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timetiposimovel",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#replaceOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timetiposimovel/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#upsertWithWhere
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timetiposimovel/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#exists
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timetiposimovel/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#findById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timetiposimovel/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#replaceById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timetiposimovel/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#find
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timetiposimovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#findOne
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timetiposimovel/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#updateAll
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timetiposimovel/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#deleteById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timetiposimovel/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#count
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timetiposimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#prototype$updateAttributes
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timetiposimovel/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#createChangeStream
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timetiposimovel/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#pager
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timetiposimovel/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#pagerDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timetiposimovel/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#postDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timetiposimovel/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#deleteDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timetiposimovel/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#editDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timetiposimovel/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#autocomplete
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timetiposimovel/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#autocompleteDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timetiposimovel/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#autocompleteDetailEdit
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timetiposimovel/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#autocompleteGeneral
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timetiposimovel/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#crudGET
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timetiposimovel/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#crudGETDetail
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timetiposimovel/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#quickAdd
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timetiposimovel/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Time.tiposimovel.findById() instead.
            "::findById::Time::tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.tiposimovel.destroyById() instead.
            "::destroyById::Time::tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.tiposimovel.updateById() instead.
            "::updateById::Time::tiposimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/tiposimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.tiposimovel() instead.
            "::get::Time::tiposimovel": {
              isArray: true,
              url: urlBase + "/times/:id/tiposimovel",
              method: "GET",
            },

            // INTERNAL. Use Time.tiposimovel.create() instead.
            "::create::Time::tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel",
              method: "POST",
            },

            // INTERNAL. Use Time.tiposimovel.createMany() instead.
            "::createMany::Time::tiposimovel": {
              isArray: true,
              url: urlBase + "/times/:id/tiposimovel",
              method: "POST",
            },

            // INTERNAL. Use Time.tiposimovel.destroyAll() instead.
            "::delete::Time::tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel",
              method: "DELETE",
            },

            // INTERNAL. Use Time.tiposimovel.count() instead.
            "::count::Time::tiposimovel": {
              url: urlBase + "/times/:id/tiposimovel/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#updateOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#update
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#destroyById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#removeById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchAttributes
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#updateOrCreate
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchOrCreateWithWhere
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#update
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#destroyById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#removeById
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#patchAttributes
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeTipoImovel` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeTipoImovel#modelName
        * @propertyOf lbServices.TimeTipoImovel
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeTipoImovel`.
        */
        R.modelName = "TimeTipoImovel";


            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#tipoimovel
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Fetches belongsTo relation tipoimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TipoImovel` object.)
             * </em>
             */
        R.tipoimovel = function() {
          var TargetResource = $injector.get("TipoImovel");
          var action = TargetResource["::get::TimeTipoImovel::tipoimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TimeTipoImovel#time
             * @methodOf lbServices.TimeTipoImovel
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeTipoImovel id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeTipoImovel::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ConfigGameficacao
 * @header lbServices.ConfigGameficacao
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ConfigGameficacao` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ConfigGameficacao",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/configgameficacaos/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#create
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configgameficacaos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#createMany
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configgameficacaos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#upsert
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/configgameficacaos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#replaceOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configgameficacaos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#upsertWithWhere
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configgameficacaos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#exists
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configgameficacaos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#findById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configgameficacaos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#replaceById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configgameficacaos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#find
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configgameficacaos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#findOne
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configgameficacaos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#updateAll
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configgameficacaos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#deleteById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configgameficacaos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#count
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configgameficacaos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#prototype$updateAttributes
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ConfigGameficacao id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/configgameficacaos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#createChangeStream
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configgameficacaos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#gameficar
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * gameficar Imóveis
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "gameficar": {
              url: urlBase + "/configgameficacaos/gameficar",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#create
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/configgameficacaos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#createMany
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/configgameficacaos",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#upsert
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/configgameficacaos",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#replaceOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/configgameficacaos/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#upsertWithWhere
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/configgameficacaos/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#exists
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/configgameficacaos/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#findById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/configgameficacaos/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#replaceById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/configgameficacaos/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#find
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/configgameficacaos",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#findOne
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/configgameficacaos/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#updateAll
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/configgameficacaos/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#deleteById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/configgameficacaos/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#count
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/configgameficacaos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#prototype$updateAttributes
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ConfigGameficacao id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/configgameficacaos/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#createChangeStream
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/configgameficacaos/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#pager
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/configgameficacaos/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#pagerDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/configgameficacaos/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#postDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/configgameficacaos/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#deleteDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/configgameficacaos/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#editDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/configgameficacaos/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#autocomplete
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/configgameficacaos/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#autocompleteDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/configgameficacaos/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#autocompleteDetailEdit
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/configgameficacaos/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#autocompleteGeneral
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/configgameficacaos/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#crudGET
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/configgameficacaos/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#crudGETDetail
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/configgameficacaos/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#quickAdd
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/configgameficacaos/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#updateOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchOrCreateWithWhere
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#update
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#destroyById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#removeById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchAttributes
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ConfigGameficacao id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#updateOrCreate
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchOrCreateWithWhere
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#update
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#destroyById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#removeById
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ConfigGameficacao#patchAttributes
             * @methodOf lbServices.ConfigGameficacao
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ConfigGameficacao id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ConfigGameficacao` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ConfigGameficacao#modelName
        * @propertyOf lbServices.ConfigGameficacao
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ConfigGameficacao`.
        */
        R.modelName = "ConfigGameficacao";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Urlacess
 * @header lbServices.Urlacess
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Urlacess` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Urlacess",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/urlacesses/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#prototype$__get__token
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Fetches belongsTo relation token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "prototype$__get__token": {
              url: urlBase + "/urlacesses/:id/token",
              method: "GET",
            },

            // INTERNAL. Use Urlacess.usuario() instead.
            "prototype$__get__usuario": {
              url: urlBase + "/urlacesses/:id/usuario",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#create
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/urlacesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#createMany
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/urlacesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#upsert
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/urlacesses",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#replaceOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/urlacesses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#upsertWithWhere
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/urlacesses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#exists
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/urlacesses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#findById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/urlacesses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#replaceById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/urlacesses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#find
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/urlacesses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#findOne
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/urlacesses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#updateAll
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/urlacesses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#deleteById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/urlacesses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#count
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/urlacesses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#prototype$updateAttributes
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/urlacesses/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#createChangeStream
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/urlacesses/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#userData
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Get data about user to login
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "userData": {
              isArray: true,
              url: urlBase + "/urlacesses/url-acess-email",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#deactivateUrl
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Get data about user to login
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "deactivateUrl": {
              isArray: true,
              url: urlBase + "/urlacesses/url-acess-deactivate",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#create
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/urlacesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#createMany
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/urlacesses",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#upsert
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/urlacesses",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#replaceOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/urlacesses/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#upsertWithWhere
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/urlacesses/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#exists
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/urlacesses/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#findById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/urlacesses/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#replaceById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/urlacesses/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#find
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/urlacesses",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#findOne
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/urlacesses/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#updateAll
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/urlacesses/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#deleteById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/urlacesses/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#count
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/urlacesses/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#prototype$updateAttributes
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/urlacesses/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#createChangeStream
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/urlacesses/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#pager
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/urlacesses/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#pagerDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/urlacesses/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#postDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/urlacesses/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#deleteDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/urlacesses/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#editDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/urlacesses/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#autocomplete
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/urlacesses/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#autocompleteDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/urlacesses/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#autocompleteDetailEdit
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/urlacesses/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#autocompleteGeneral
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/urlacesses/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#crudGET
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/urlacesses/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#crudGETDetail
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/urlacesses/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#quickAdd
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/urlacesses/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#updateOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchOrCreateWithWhere
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#update
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#destroyById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#removeById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchAttributes
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#updateOrCreate
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchOrCreateWithWhere
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#update
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#destroyById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#removeById
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Urlacess#patchAttributes
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Urlacess` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Urlacess#modelName
        * @propertyOf lbServices.Urlacess
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Urlacess`.
        */
        R.modelName = "Urlacess";


            /**
             * @ngdoc method
             * @name lbServices.Urlacess#usuario
             * @methodOf lbServices.Urlacess
             *
             * @description
             *
             * Fetches belongsTo relation usuario.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Urlacess id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.usuario = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::Urlacess::usuario"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TimeHorario
 * @header lbServices.TimeHorario
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TimeHorario` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TimeHorario",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/timehorarios/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TimeHorario.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/timehorarios/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#create
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timehorarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#createMany
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timehorarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#upsert
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timehorarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#replaceOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timehorarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#upsertWithWhere
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timehorarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#exists
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timehorarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#findById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timehorarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#replaceById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timehorarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#find
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timehorarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#findOne
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timehorarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#updateAll
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timehorarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#deleteById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timehorarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#count
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timehorarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#prototype$updateAttributes
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHorario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timehorarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#createChangeStream
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timehorarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#create
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/timehorarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#createMany
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/timehorarios",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#upsert
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/timehorarios",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#replaceOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/timehorarios/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#upsertWithWhere
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/timehorarios/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#exists
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/timehorarios/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#findById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/timehorarios/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#replaceById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/timehorarios/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#find
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/timehorarios",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#findOne
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/timehorarios/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#updateAll
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/timehorarios/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#deleteById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/timehorarios/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#count
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/timehorarios/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#prototype$updateAttributes
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHorario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/timehorarios/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#createChangeStream
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/timehorarios/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#pager
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/timehorarios/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#pagerDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/timehorarios/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#postDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/timehorarios/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#deleteDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/timehorarios/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#editDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/timehorarios/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#autocomplete
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/timehorarios/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#autocompleteDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/timehorarios/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#autocompleteDetailEdit
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/timehorarios/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#autocompleteGeneral
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/timehorarios/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#crudGET
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/timehorarios/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#crudGETDetail
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/timehorarios/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#quickAdd
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/timehorarios/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Time.horario.findById() instead.
            "::findById::Time::horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "GET",
            },

            // INTERNAL. Use Time.horario.destroyById() instead.
            "::destroyById::Time::horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Time.horario.updateById() instead.
            "::updateById::Time::horario": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/times/:id/horario/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Time.horario() instead.
            "::get::Time::horario": {
              isArray: true,
              url: urlBase + "/times/:id/horario",
              method: "GET",
            },

            // INTERNAL. Use Time.horario.create() instead.
            "::create::Time::horario": {
              url: urlBase + "/times/:id/horario",
              method: "POST",
            },

            // INTERNAL. Use Time.horario.createMany() instead.
            "::createMany::Time::horario": {
              isArray: true,
              url: urlBase + "/times/:id/horario",
              method: "POST",
            },

            // INTERNAL. Use Time.horario.destroyAll() instead.
            "::delete::Time::horario": {
              url: urlBase + "/times/:id/horario",
              method: "DELETE",
            },

            // INTERNAL. Use Time.horario.count() instead.
            "::count::Time::horario": {
              url: urlBase + "/times/:id/horario/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#updateOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchOrCreateWithWhere
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#update
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#destroyById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#removeById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchAttributes
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHorario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#updateOrCreate
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchOrCreateWithWhere
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#update
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#destroyById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#removeById
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#patchAttributes
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHorario id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TimeHorario` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TimeHorario#modelName
        * @propertyOf lbServices.TimeHorario
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TimeHorario`.
        */
        R.modelName = "TimeHorario";


            /**
             * @ngdoc method
             * @name lbServices.TimeHorario#time
             * @methodOf lbServices.TimeHorario
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TimeHorario id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::TimeHorario::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImobiliariaDestaques
 * @header lbServices.ImobiliariaDestaques
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImobiliariaDestaques` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImobiliariaDestaques",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliariasDestaques/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImobiliariaDestaques.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imobiliariasDestaques/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaDestaques.destaque() instead.
            "prototype$__get__destaque": {
              url: urlBase + "/imobiliariasDestaques/:id/destaque",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#create
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariasDestaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#createMany
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariasDestaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#upsert
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariasDestaques",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#replaceOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariasDestaques/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#upsertWithWhere
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariasDestaques/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#exists
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariasDestaques/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#findById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#replaceById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariasDestaques/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#find
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariasDestaques",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#findOne
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariasDestaques/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#updateAll
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariasDestaques/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#deleteById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#count
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariasDestaques/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#createChangeStream
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariasDestaques/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#create
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariasDestaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#createMany
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariasDestaques",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#upsert
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariasDestaques",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#replaceOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariasDestaques/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#upsertWithWhere
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariasDestaques/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#exists
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariasDestaques/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#findById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#replaceById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariasDestaques/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#find
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariasDestaques",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#findOne
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariasDestaques/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#updateAll
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariasDestaques/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#deleteById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#count
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariasDestaques/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariasDestaques/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#createChangeStream
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariasDestaques/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#pager
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliariasDestaques/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#pagerDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#postDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#deleteDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#editDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#autocomplete
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliariasDestaques/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#autocompleteDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#autocompleteDetailEdit
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliariasDestaques/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#autocompleteGeneral
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliariasDestaques/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#crudGET
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliariasDestaques/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#crudGETDetail
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliariasDestaques/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#quickAdd
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliariasDestaques/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.destaques.findById() instead.
            "::findById::Imobiliaria::destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.destaques.destroyById() instead.
            "::destroyById::Imobiliaria::destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.destaques.updateById() instead.
            "::updateById::Imobiliaria::destaques": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/destaques/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.destaques() instead.
            "::get::Imobiliaria::destaques": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.destaques.create() instead.
            "::create::Imobiliaria::destaques": {
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.destaques.createMany() instead.
            "::createMany::Imobiliaria::destaques": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.destaques.destroyAll() instead.
            "::delete::Imobiliaria::destaques": {
              url: urlBase + "/imobiliarias/:id/destaques",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.destaques.count() instead.
            "::count::Imobiliaria::destaques": {
              url: urlBase + "/imobiliarias/:id/destaques/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#updateOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#update
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#destroyById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#removeById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchAttributes
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#updateOrCreate
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#update
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#destroyById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#removeById
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#patchAttributes
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaDestaques` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImobiliariaDestaques#modelName
        * @propertyOf lbServices.ImobiliariaDestaques
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImobiliariaDestaques`.
        */
        R.modelName = "ImobiliariaDestaques";


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#imobiliaria
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImobiliariaDestaques::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaDestaques#destaque
             * @methodOf lbServices.ImobiliariaDestaques
             *
             * @description
             *
             * Fetches belongsTo relation destaque.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaDestaques id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.destaque = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImobiliariaDestaques::destaque"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImovelPlanta
 * @header lbServices.ImovelPlanta
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImovelPlanta` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImovelPlanta",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imovelplantas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImovelPlanta.imovel() instead.
            "prototype$__get__imovel": {
              url: urlBase + "/imovelplantas/:id/imovel",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#create
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelplantas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#createMany
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelplantas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#upsert
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelplantas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#replaceOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelplantas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#upsertWithWhere
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelplantas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#exists
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelplantas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#findById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelplantas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#replaceById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelplantas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#find
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelplantas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#findOne
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelplantas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#updateAll
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelplantas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#deleteById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelplantas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#count
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelplantas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#prototype$updateAttributes
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPlanta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelplantas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#createChangeStream
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelplantas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#create
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imovelplantas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#createMany
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imovelplantas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#upsert
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imovelplantas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#replaceOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imovelplantas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#upsertWithWhere
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imovelplantas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#exists
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imovelplantas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#findById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imovelplantas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#replaceById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imovelplantas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#find
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imovelplantas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#findOne
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imovelplantas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#updateAll
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imovelplantas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#deleteById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imovelplantas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#count
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imovelplantas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#prototype$updateAttributes
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPlanta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imovelplantas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#createChangeStream
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imovelplantas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#pager
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imovelplantas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#pagerDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imovelplantas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#postDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imovelplantas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#deleteDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imovelplantas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#editDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imovelplantas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#autocomplete
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imovelplantas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#autocompleteDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imovelplantas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#autocompleteDetailEdit
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imovelplantas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#autocompleteGeneral
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imovelplantas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#crudGET
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imovelplantas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#crudGETDetail
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imovelplantas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#quickAdd
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imovelplantas/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imovel.plantas.findById() instead.
            "::findById::Imovel::plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imovel.plantas.destroyById() instead.
            "::destroyById::Imovel::plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.plantas.updateById() instead.
            "::updateById::Imovel::plantas": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imoveis/:id/plantas/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imovel.plantas() instead.
            "::get::Imovel::plantas": {
              isArray: true,
              url: urlBase + "/imoveis/:id/plantas",
              method: "GET",
            },

            // INTERNAL. Use Imovel.plantas.create() instead.
            "::create::Imovel::plantas": {
              url: urlBase + "/imoveis/:id/plantas",
              method: "POST",
            },

            // INTERNAL. Use Imovel.plantas.createMany() instead.
            "::createMany::Imovel::plantas": {
              isArray: true,
              url: urlBase + "/imoveis/:id/plantas",
              method: "POST",
            },

            // INTERNAL. Use Imovel.plantas.destroyAll() instead.
            "::delete::Imovel::plantas": {
              url: urlBase + "/imoveis/:id/plantas",
              method: "DELETE",
            },

            // INTERNAL. Use Imovel.plantas.count() instead.
            "::count::Imovel::plantas": {
              url: urlBase + "/imoveis/:id/plantas/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#updateOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#update
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#destroyById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#removeById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchAttributes
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPlanta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#updateOrCreate
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchOrCreateWithWhere
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#update
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#destroyById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#removeById
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#patchAttributes
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPlanta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImovelPlanta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImovelPlanta#modelName
        * @propertyOf lbServices.ImovelPlanta
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImovelPlanta`.
        */
        R.modelName = "ImovelPlanta";


            /**
             * @ngdoc method
             * @name lbServices.ImovelPlanta#imovel
             * @methodOf lbServices.ImovelPlanta
             *
             * @description
             *
             * Fetches belongsTo relation imovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImovelPlanta id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imovel` object.)
             * </em>
             */
        R.imovel = function() {
          var TargetResource = $injector.get("Imovel");
          var action = TargetResource["::get::ImovelPlanta::imovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AvaliacaoCorretor
 * @header lbServices.AvaliacaoCorretor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AvaliacaoCorretor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AvaliacaoCorretor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/avaliarcorretor/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AvaliacaoCorretor.corretor() instead.
            "prototype$__get__corretor": {
              url: urlBase + "/avaliarcorretor/:id/corretor",
              method: "GET",
            },

            // INTERNAL. Use AvaliacaoCorretor.cliente() instead.
            "prototype$__get__cliente": {
              url: urlBase + "/avaliarcorretor/:id/cliente",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#create
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/avaliarcorretor",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#createMany
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/avaliarcorretor",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#upsert
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/avaliarcorretor",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#replaceOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/avaliarcorretor/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#upsertWithWhere
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/avaliarcorretor/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#exists
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/avaliarcorretor/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#findById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#replaceById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/avaliarcorretor/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#find
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/avaliarcorretor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#findOne
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/avaliarcorretor/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#updateAll
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/avaliarcorretor/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#deleteById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#count
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/avaliarcorretor/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#prototype$updateAttributes
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#createChangeStream
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/avaliarcorretor/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#verificar
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Autocomplete for imoveis wich clients are interested
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "verificar": {
              url: urlBase + "/avaliarcorretor/verificar",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#avaliacao
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Autocomplete for imoveis wich clients are interested
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "avaliacao": {
              url: urlBase + "/avaliarcorretor/avaliacao",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#create
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/avaliarcorretor",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#createMany
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/avaliarcorretor",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#upsert
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/avaliarcorretor",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#replaceOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/avaliarcorretor/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#upsertWithWhere
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/avaliarcorretor/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#exists
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/avaliarcorretor/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#findById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#replaceById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/avaliarcorretor/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#find
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/avaliarcorretor",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#findOne
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/avaliarcorretor/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#updateAll
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/avaliarcorretor/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#deleteById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#count
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/avaliarcorretor/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#prototype$updateAttributes
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/avaliarcorretor/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#createChangeStream
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/avaliarcorretor/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#pager
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/avaliarcorretor/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#pagerDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/avaliarcorretor/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#postDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/avaliarcorretor/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#deleteDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/avaliarcorretor/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#editDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/avaliarcorretor/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#autocomplete
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/avaliarcorretor/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#autocompleteDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/avaliarcorretor/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#autocompleteDetailEdit
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/avaliarcorretor/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#autocompleteGeneral
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/avaliarcorretor/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#crudGET
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/avaliarcorretor/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#crudGETDetail
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/avaliarcorretor/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#quickAdd
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/avaliarcorretor/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#updateOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchOrCreateWithWhere
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#update
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#destroyById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#removeById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchAttributes
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#updateOrCreate
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchOrCreateWithWhere
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#update
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#destroyById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#removeById
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#patchAttributes
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AvaliacaoCorretor` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AvaliacaoCorretor#modelName
        * @propertyOf lbServices.AvaliacaoCorretor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AvaliacaoCorretor`.
        */
        R.modelName = "AvaliacaoCorretor";


            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#corretor
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Fetches belongsTo relation corretor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.corretor = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::AvaliacaoCorretor::corretor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AvaliacaoCorretor#cliente
             * @methodOf lbServices.AvaliacaoCorretor
             *
             * @description
             *
             * Fetches belongsTo relation cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AvaliacaoCorretor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.cliente = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::AvaliacaoCorretor::cliente"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImobiliariaConfig
 * @header lbServices.ImobiliariaConfig
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImobiliariaConfig` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImobiliariaConfig",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliariaconfigs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImobiliariaConfig.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imobiliariaconfigs/:id/imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#create
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariaconfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#createMany
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariaconfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#upsert
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariaconfigs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#replaceOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariaconfigs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#upsertWithWhere
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariaconfigs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#exists
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariaconfigs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#findById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#replaceById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariaconfigs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#find
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariaconfigs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#findOne
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariaconfigs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#updateAll
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariaconfigs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#deleteById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#count
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariaconfigs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaConfig id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#createChangeStream
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariaconfigs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#create
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariaconfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#createMany
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariaconfigs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#upsert
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariaconfigs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#replaceOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariaconfigs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#upsertWithWhere
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariaconfigs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#exists
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariaconfigs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#findById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#replaceById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariaconfigs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#find
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariaconfigs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#findOne
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariaconfigs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#updateAll
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariaconfigs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#deleteById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#count
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariaconfigs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaConfig id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariaconfigs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#createChangeStream
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariaconfigs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#pager
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliariaconfigs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#pagerDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#postDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#deleteDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#editDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#autocomplete
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliariaconfigs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#autocompleteDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#autocompleteDetailEdit
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliariaconfigs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#autocompleteGeneral
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliariaconfigs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#crudGET
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliariaconfigs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#crudGETDetail
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliariaconfigs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#quickAdd
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliariaconfigs/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.config.findById() instead.
            "::findById::Imobiliaria::config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.config.destroyById() instead.
            "::destroyById::Imobiliaria::config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.config.updateById() instead.
            "::updateById::Imobiliaria::config": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/config/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.config() instead.
            "::get::Imobiliaria::config": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/config",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.config.create() instead.
            "::create::Imobiliaria::config": {
              url: urlBase + "/imobiliarias/:id/config",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.config.createMany() instead.
            "::createMany::Imobiliaria::config": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/config",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.config.destroyAll() instead.
            "::delete::Imobiliaria::config": {
              url: urlBase + "/imobiliarias/:id/config",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.config.count() instead.
            "::count::Imobiliaria::config": {
              url: urlBase + "/imobiliarias/:id/config/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#updateOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#update
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#destroyById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#removeById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchAttributes
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaConfig id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#updateOrCreate
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#update
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#destroyById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#removeById
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#patchAttributes
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaConfig id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaConfig` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImobiliariaConfig#modelName
        * @propertyOf lbServices.ImobiliariaConfig
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImobiliariaConfig`.
        */
        R.modelName = "ImobiliariaConfig";


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaConfig#imobiliaria
             * @methodOf lbServices.ImobiliariaConfig
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaConfig id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImobiliariaConfig::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImobiliariaStatusCliente
 * @header lbServices.ImobiliariaStatusCliente
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImobiliariaStatusCliente` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImobiliariaStatusCliente",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliariastatusclientes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImobiliariaStatusCliente.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imobiliariastatusclientes/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaStatusCliente.status() instead.
            "prototype$__get__status": {
              url: urlBase + "/imobiliariastatusclientes/:id/status",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#create
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariastatusclientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#createMany
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariastatusclientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#upsert
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariastatusclientes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#replaceOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariastatusclientes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#upsertWithWhere
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariastatusclientes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#exists
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariastatusclientes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#findById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#replaceById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariastatusclientes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#find
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariastatusclientes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#findOne
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariastatusclientes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#updateAll
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariastatusclientes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#deleteById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#count
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariastatusclientes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#createChangeStream
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariastatusclientes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#create
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariastatusclientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#createMany
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariastatusclientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#upsert
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariastatusclientes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#replaceOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariastatusclientes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#upsertWithWhere
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariastatusclientes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#exists
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariastatusclientes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#findById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#replaceById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariastatusclientes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#find
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariastatusclientes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#findOne
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariastatusclientes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#updateAll
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariastatusclientes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#deleteById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#count
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariastatusclientes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariastatusclientes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#createChangeStream
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariastatusclientes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#pager
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliariastatusclientes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#pagerDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#postDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#deleteDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#editDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#autocomplete
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliariastatusclientes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#autocompleteDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#autocompleteDetailEdit
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliariastatusclientes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#autocompleteGeneral
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliariastatusclientes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#crudGET
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliariastatusclientes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#crudGETDetail
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliariastatusclientes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#quickAdd
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliariastatusclientes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.findById() instead.
            "::findById::Imobiliaria::status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.destroyById() instead.
            "::destroyById::Imobiliaria::status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.updateById() instead.
            "::updateById::Imobiliaria::status_cliente": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/status_cliente/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.status_cliente() instead.
            "::get::Imobiliaria::status_cliente": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.create() instead.
            "::create::Imobiliaria::status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.createMany() instead.
            "::createMany::Imobiliaria::status_cliente": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.destroyAll() instead.
            "::delete::Imobiliaria::status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.status_cliente.count() instead.
            "::count::Imobiliaria::status_cliente": {
              url: urlBase + "/imobiliarias/:id/status_cliente/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#updateOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#update
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#destroyById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#removeById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchAttributes
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#updateOrCreate
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#update
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#destroyById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#removeById
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#patchAttributes
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaStatusCliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImobiliariaStatusCliente#modelName
        * @propertyOf lbServices.ImobiliariaStatusCliente
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImobiliariaStatusCliente`.
        */
        R.modelName = "ImobiliariaStatusCliente";


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#imobiliaria
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImobiliariaStatusCliente::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaStatusCliente#status
             * @methodOf lbServices.ImobiliariaStatusCliente
             *
             * @description
             *
             * Fetches belongsTo relation status.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaStatusCliente id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoStatus` object.)
             * </em>
             */
        R.status = function() {
          var TargetResource = $injector.get("ClienteInteressadoStatus");
          var action = TargetResource["::get::ImobiliariaStatusCliente::status"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ClienteInteressadoObservador
 * @header lbServices.ClienteInteressadoObservador
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ClienteInteressadoObservador` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ClienteInteressadoObservador",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clientesinteressadoObservadores/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ClienteInteressadoObservador.lead() instead.
            "prototype$__get__lead": {
              url: urlBase + "/clientesinteressadoObservadores/:id/lead",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressadoObservador.observador() instead.
            "prototype$__get__observador": {
              url: urlBase + "/clientesinteressadoObservadores/:id/observador",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#create
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientesinteressadoObservadores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#createMany
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientesinteressadoObservadores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#upsert
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientesinteressadoObservadores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientesinteressadoObservadores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientesinteressadoObservadores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#exists
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientesinteressadoObservadores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#findById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#replaceById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientesinteressadoObservadores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#find
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientesinteressadoObservadores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#findOne
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientesinteressadoObservadores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#updateAll
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientesinteressadoObservadores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#deleteById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#count
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientesinteressadoObservadores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#createChangeStream
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientesinteressadoObservadores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#findCrt
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find imoveis.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "findCrt": {
              isArray: true,
              url: urlBase + "/clientesinteressadoObservadores/find-crt",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#create
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientesinteressadoObservadores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#createMany
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientesinteressadoObservadores",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#upsert
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientesinteressadoObservadores",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#replaceOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientesinteressadoObservadores/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#upsertWithWhere
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientesinteressadoObservadores/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#exists
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientesinteressadoObservadores/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#findById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#replaceById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientesinteressadoObservadores/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#find
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientesinteressadoObservadores",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#findOne
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientesinteressadoObservadores/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#updateAll
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientesinteressadoObservadores/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#deleteById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#count
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientesinteressadoObservadores/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#prototype$updateAttributes
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientesinteressadoObservadores/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#createChangeStream
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientesinteressadoObservadores/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#pager
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clientesinteressadoObservadores/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#pagerDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#postDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#deleteDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#editDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#autocomplete
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clientesinteressadoObservadores/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#autocompleteDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#autocompleteDetailEdit
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clientesinteressadoObservadores/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#autocompleteGeneral
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clientesinteressadoObservadores/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#crudGET
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clientesinteressadoObservadores/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#crudGETDetail
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clientesinteressadoObservadores/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#quickAdd
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clientesinteressadoObservadores/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.observador.findById() instead.
            "::findById::ClienteInteressado::observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.observador.destroyById() instead.
            "::destroyById::ClienteInteressado::observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.observador.updateById() instead.
            "::updateById::ClienteInteressado::observador": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientesinteressados/:id/observador/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ClienteInteressado.observador() instead.
            "::get::ClienteInteressado::observador": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "GET",
            },

            // INTERNAL. Use ClienteInteressado.observador.create() instead.
            "::create::ClienteInteressado::observador": {
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.observador.createMany() instead.
            "::createMany::ClienteInteressado::observador": {
              isArray: true,
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "POST",
            },

            // INTERNAL. Use ClienteInteressado.observador.destroyAll() instead.
            "::delete::ClienteInteressado::observador": {
              url: urlBase + "/clientesinteressados/:id/observador",
              method: "DELETE",
            },

            // INTERNAL. Use ClienteInteressado.observador.count() instead.
            "::count::ClienteInteressado::observador": {
              url: urlBase + "/clientesinteressados/:id/observador/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#update
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#destroyById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#removeById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchAttributes
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#updateOrCreate
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchOrCreateWithWhere
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#update
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#destroyById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#removeById
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#patchAttributes
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressadoObservador` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ClienteInteressadoObservador#modelName
        * @propertyOf lbServices.ClienteInteressadoObservador
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ClienteInteressadoObservador`.
        */
        R.modelName = "ClienteInteressadoObservador";


            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#lead
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Fetches belongsTo relation lead.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.lead = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::ClienteInteressadoObservador::lead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ClienteInteressadoObservador#observador
             * @methodOf lbServices.ClienteInteressadoObservador
             *
             * @description
             *
             * Fetches belongsTo relation observador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ClienteInteressadoObservador id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Usuario` object.)
             * </em>
             */
        R.observador = function() {
          var TargetResource = $injector.get("Usuario");
          var action = TargetResource["::get::ClienteInteressadoObservador::observador"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.OrcamentoMarketing
 * @header lbServices.OrcamentoMarketing
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `OrcamentoMarketing` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "OrcamentoMarketing",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/orcamentosmarketing/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use OrcamentoMarketing.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/orcamentosmarketing/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.findById() instead.
            "prototype$__findById__gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.destroyById() instead.
            "prototype$__destroyById__gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.updateById() instead.
            "prototype$__updateById__gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos() instead.
            "prototype$__get__gastos": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.create() instead.
            "prototype$__create__gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "POST",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.destroyAll() instead.
            "prototype$__delete__gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "DELETE",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.count() instead.
            "prototype$__count__gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#create
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/orcamentosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#createMany
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#upsert
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/orcamentosmarketing",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#replaceOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/orcamentosmarketing/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#upsertWithWhere
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/orcamentosmarketing/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#exists
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/orcamentosmarketing/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#findById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#replaceById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/orcamentosmarketing/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#find
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#findOne
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/orcamentosmarketing/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#updateAll
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/orcamentosmarketing/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#deleteById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#count
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/orcamentosmarketing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#prototype$updateAttributes
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#createChangeStream
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/orcamentosmarketing/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#create
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/orcamentosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#createMany
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#upsert
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/orcamentosmarketing",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#replaceOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/orcamentosmarketing/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#upsertWithWhere
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/orcamentosmarketing/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#exists
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/orcamentosmarketing/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#findById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#replaceById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/orcamentosmarketing/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#find
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#findOne
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/orcamentosmarketing/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#updateAll
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/orcamentosmarketing/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#deleteById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#count
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/orcamentosmarketing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#prototype$updateAttributes
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/orcamentosmarketing/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#createChangeStream
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/orcamentosmarketing/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#pager
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/orcamentosmarketing/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#pagerDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/orcamentosmarketing/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#postDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/orcamentosmarketing/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#deleteDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/orcamentosmarketing/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#editDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/orcamentosmarketing/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#autocomplete
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/orcamentosmarketing/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#autocompleteDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/orcamentosmarketing/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#autocompleteDetailEdit
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/orcamentosmarketing/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#autocompleteGeneral
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/orcamentosmarketing/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#crudGET
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/orcamentosmarketing/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#crudGETDetail
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/orcamentosmarketing/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#quickAdd
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/orcamentosmarketing/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use GastoMarketing.orcamento() instead.
            "::get::GastoMarketing::orcamento": {
              url: urlBase + "/gastosmarketing/:id/orcamento",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#updateOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchOrCreateWithWhere
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#update
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#destroyById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#removeById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchAttributes
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#updateOrCreate
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchOrCreateWithWhere
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#update
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#destroyById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#removeById
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#patchAttributes
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.OrcamentoMarketing#modelName
        * @propertyOf lbServices.OrcamentoMarketing
        * @description
        * The name of the model represented by this $resource,
        * i.e. `OrcamentoMarketing`.
        */
        R.modelName = "OrcamentoMarketing";


            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#imobiliaria
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::OrcamentoMarketing::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.OrcamentoMarketing.gastos
     * @header lbServices.OrcamentoMarketing.gastos
     * @object
     * @description
     *
     * The object `OrcamentoMarketing.gastos` groups methods
     * manipulating `GastoMarketing` instances related to `OrcamentoMarketing`.
     *
     * Call {@link lbServices.OrcamentoMarketing#gastos OrcamentoMarketing.gastos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing#gastos
             * @methodOf lbServices.OrcamentoMarketing
             *
             * @description
             *
             * Queries gastos of OrcamentoMarketing.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R.gastos = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::get::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#count
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Counts gastos of OrcamentoMarketing.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.gastos.count = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::count::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#create
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Creates a new instance in gastos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R.gastos.create = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::create::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#createMany
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Creates a new instance in gastos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R.gastos.createMany = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::createMany::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#destroyAll
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Deletes all gastos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.gastos.destroyAll = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::delete::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#destroyById
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Delete a related item by id for gastos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `fk` – `{*}` - Foreign key for gastos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.gastos.destroyById = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::destroyById::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#findById
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Find a related item by id for gastos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `fk` – `{*}` - Foreign key for gastos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R.gastos.findById = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::findById::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.OrcamentoMarketing.gastos#updateById
             * @methodOf lbServices.OrcamentoMarketing.gastos
             *
             * @description
             *
             * Update a related item by id for gastos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - OrcamentoMarketing id
             *
             *  - `fk` – `{*}` - Foreign key for gastos
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R.gastos.updateById = function() {
          var TargetResource = $injector.get("GastoMarketing");
          var action = TargetResource["::updateById::OrcamentoMarketing::gastos"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.GastoMarketing
 * @header lbServices.GastoMarketing
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `GastoMarketing` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "GastoMarketing",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/gastosmarketing/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use GastoMarketing.orcamento() instead.
            "prototype$__get__orcamento": {
              url: urlBase + "/gastosmarketing/:id/orcamento",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#create
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gastosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#createMany
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gastosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#upsert
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gastosmarketing",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#replaceOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gastosmarketing/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#upsertWithWhere
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gastosmarketing/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#exists
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gastosmarketing/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#findById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gastosmarketing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#replaceById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gastosmarketing/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#find
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gastosmarketing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#findOne
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gastosmarketing/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#updateAll
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gastosmarketing/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#deleteById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gastosmarketing/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#count
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gastosmarketing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#prototype$updateAttributes
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GastoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gastosmarketing/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#createChangeStream
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gastosmarketing/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#verifyCsv
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `res` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "verifyCsv": {
              url: urlBase + "/gastosmarketing/verify-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#createGastoByCsv
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "createGastoByCsv": {
              url: urlBase + "/gastosmarketing/create-gasto-by-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#create
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/gastosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#createMany
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/gastosmarketing",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#upsert
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/gastosmarketing",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#replaceOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/gastosmarketing/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#upsertWithWhere
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/gastosmarketing/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#exists
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/gastosmarketing/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#findById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/gastosmarketing/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#replaceById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/gastosmarketing/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#find
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/gastosmarketing",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#findOne
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/gastosmarketing/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#updateAll
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/gastosmarketing/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#deleteById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/gastosmarketing/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#count
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/gastosmarketing/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#prototype$updateAttributes
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GastoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/gastosmarketing/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#createChangeStream
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/gastosmarketing/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#pager
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/gastosmarketing/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#pagerDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/gastosmarketing/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#postDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/gastosmarketing/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#deleteDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/gastosmarketing/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#editDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/gastosmarketing/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#autocomplete
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/gastosmarketing/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#autocompleteDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/gastosmarketing/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#autocompleteDetailEdit
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/gastosmarketing/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#autocompleteGeneral
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/gastosmarketing/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#crudGET
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/gastosmarketing/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#crudGETDetail
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/gastosmarketing/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#quickAdd
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/gastosmarketing/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.findById() instead.
            "::findById::OrcamentoMarketing::gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.destroyById() instead.
            "::destroyById::OrcamentoMarketing::gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.updateById() instead.
            "::updateById::OrcamentoMarketing::gastos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/orcamentosmarketing/:id/gastos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos() instead.
            "::get::OrcamentoMarketing::gastos": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "GET",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.create() instead.
            "::create::OrcamentoMarketing::gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "POST",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.createMany() instead.
            "::createMany::OrcamentoMarketing::gastos": {
              isArray: true,
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "POST",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.destroyAll() instead.
            "::delete::OrcamentoMarketing::gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos",
              method: "DELETE",
            },

            // INTERNAL. Use OrcamentoMarketing.gastos.count() instead.
            "::count::OrcamentoMarketing::gastos": {
              url: urlBase + "/orcamentosmarketing/:id/gastos/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#updateOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchOrCreateWithWhere
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#update
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#destroyById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#removeById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchAttributes
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GastoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#updateOrCreate
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchOrCreateWithWhere
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#update
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#destroyById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#removeById
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#patchAttributes
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GastoMarketing id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `GastoMarketing` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.GastoMarketing#modelName
        * @propertyOf lbServices.GastoMarketing
        * @description
        * The name of the model represented by this $resource,
        * i.e. `GastoMarketing`.
        */
        R.modelName = "GastoMarketing";


            /**
             * @ngdoc method
             * @name lbServices.GastoMarketing#orcamento
             * @methodOf lbServices.GastoMarketing
             *
             * @description
             *
             * Fetches belongsTo relation orcamento.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - GastoMarketing id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `OrcamentoMarketing` object.)
             * </em>
             */
        R.orcamento = function() {
          var TargetResource = $injector.get("OrcamentoMarketing");
          var action = TargetResource["::get::GastoMarketing::orcamento"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImobiliariaBifurcador
 * @header lbServices.ImobiliariaBifurcador
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImobiliariaBifurcador` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImobiliariaBifurcador",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliariabifurcador/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImobiliariaBifurcador.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imobiliariabifurcador/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.findById() instead.
            "prototype$__findById__logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.destroyById() instead.
            "prototype$__destroyById__logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.updateById() instead.
            "prototype$__updateById__logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs() instead.
            "prototype$__get__logs": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.create() instead.
            "prototype$__create__logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.destroyAll() instead.
            "prototype$__delete__logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.count() instead.
            "prototype$__count__logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#create
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariabifurcador",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#createMany
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#upsert
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariabifurcador",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#replaceOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariabifurcador/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#upsertWithWhere
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariabifurcador/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#exists
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariabifurcador/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#findById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#replaceById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariabifurcador/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#find
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#findOne
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariabifurcador/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#updateAll
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariabifurcador/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#deleteById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#count
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariabifurcador/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#createChangeStream
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariabifurcador/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#create
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariabifurcador",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#createMany
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#upsert
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariabifurcador",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#replaceOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariabifurcador/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#upsertWithWhere
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariabifurcador/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#exists
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariabifurcador/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#findById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#replaceById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariabifurcador/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#find
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#findOne
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariabifurcador/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#updateAll
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariabifurcador/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#deleteById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#count
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariabifurcador/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariabifurcador/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#createChangeStream
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariabifurcador/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#pager
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliariabifurcador/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#pagerDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#postDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#deleteDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#editDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#autocomplete
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliariabifurcador/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#autocompleteDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#autocompleteDetailEdit
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliariabifurcador/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#autocompleteGeneral
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliariabifurcador/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#crudGET
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliariabifurcador/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#crudGETDetail
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliariabifurcador/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#quickAdd
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliariabifurcador/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.findById() instead.
            "::findById::Imobiliaria::bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.destroyById() instead.
            "::destroyById::Imobiliaria::bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.updateById() instead.
            "::updateById::Imobiliaria::bifurcadores": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/bifurcadores/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores() instead.
            "::get::Imobiliaria::bifurcadores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.create() instead.
            "::create::Imobiliaria::bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.createMany() instead.
            "::createMany::Imobiliaria::bifurcadores": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.destroyAll() instead.
            "::delete::Imobiliaria::bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.bifurcadores.count() instead.
            "::count::Imobiliaria::bifurcadores": {
              url: urlBase + "/imobiliarias/:id/bifurcadores/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#updateOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#update
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#destroyById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#removeById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchAttributes
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#updateOrCreate
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#update
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#destroyById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#removeById
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#patchAttributes
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaBifurcador` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImobiliariaBifurcador#modelName
        * @propertyOf lbServices.ImobiliariaBifurcador
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImobiliariaBifurcador`.
        */
        R.modelName = "ImobiliariaBifurcador";


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#imobiliaria
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImobiliariaBifurcador::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ImobiliariaBifurcador.logs
     * @header lbServices.ImobiliariaBifurcador.logs
     * @object
     * @description
     *
     * The object `ImobiliariaBifurcador.logs` groups methods
     * manipulating `BifurcadorLog` instances related to `ImobiliariaBifurcador`.
     *
     * Call {@link lbServices.ImobiliariaBifurcador#logs ImobiliariaBifurcador.logs()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador#logs
             * @methodOf lbServices.ImobiliariaBifurcador
             *
             * @description
             *
             * Queries logs of ImobiliariaBifurcador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R.logs = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::get::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#count
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Counts logs of ImobiliariaBifurcador.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.logs.count = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::count::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#create
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Creates a new instance in logs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R.logs.create = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::create::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#createMany
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Creates a new instance in logs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R.logs.createMany = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::createMany::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#destroyAll
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Deletes all logs of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.logs.destroyAll = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::delete::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#destroyById
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Delete a related item by id for logs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `fk` – `{*}` - Foreign key for logs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.logs.destroyById = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::destroyById::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#findById
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Find a related item by id for logs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `fk` – `{*}` - Foreign key for logs
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R.logs.findById = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::findById::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaBifurcador.logs#updateById
             * @methodOf lbServices.ImobiliariaBifurcador.logs
             *
             * @description
             *
             * Update a related item by id for logs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaBifurcador id
             *
             *  - `fk` – `{*}` - Foreign key for logs
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R.logs.updateById = function() {
          var TargetResource = $injector.get("BifurcadorLog");
          var action = TargetResource["::updateById::ImobiliariaBifurcador::logs"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BifurcadorLog
 * @header lbServices.BifurcadorLog
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BifurcadorLog` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BifurcadorLog",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/bifurcadorlogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BifurcadorLog.card() instead.
            "prototype$__get__card": {
              url: urlBase + "/bifurcadorlogs/:id/card",
              method: "GET",
            },

            // INTERNAL. Use BifurcadorLog.clienteinteressado() instead.
            "prototype$__get__clienteinteressado": {
              url: urlBase + "/bifurcadorlogs/:id/clienteinteressado",
              method: "GET",
            },

            // INTERNAL. Use BifurcadorLog.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/bifurcadorlogs/:id/imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#create
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/bifurcadorlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#createMany
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/bifurcadorlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#upsert
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/bifurcadorlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#replaceOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/bifurcadorlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#upsertWithWhere
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/bifurcadorlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#exists
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/bifurcadorlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#findById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#replaceById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/bifurcadorlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#find
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/bifurcadorlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#findOne
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/bifurcadorlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#updateAll
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/bifurcadorlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#deleteById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#count
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/bifurcadorlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#prototype$updateAttributes
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#createChangeStream
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/bifurcadorlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#create
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/bifurcadorlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#createMany
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/bifurcadorlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#upsert
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/bifurcadorlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#replaceOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/bifurcadorlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#upsertWithWhere
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/bifurcadorlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#exists
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/bifurcadorlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#findById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#replaceById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/bifurcadorlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#find
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/bifurcadorlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#findOne
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/bifurcadorlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#updateAll
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/bifurcadorlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#deleteById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#count
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/bifurcadorlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#prototype$updateAttributes
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/bifurcadorlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#createChangeStream
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/bifurcadorlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#pager
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/bifurcadorlogs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#pagerDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/bifurcadorlogs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#postDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/bifurcadorlogs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#deleteDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/bifurcadorlogs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#editDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/bifurcadorlogs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#autocomplete
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/bifurcadorlogs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#autocompleteDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/bifurcadorlogs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#autocompleteDetailEdit
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/bifurcadorlogs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#autocompleteGeneral
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/bifurcadorlogs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#crudGET
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/bifurcadorlogs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#crudGETDetail
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/bifurcadorlogs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#quickAdd
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/bifurcadorlogs/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.findById() instead.
            "::findById::ImobiliariaBifurcador::logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.destroyById() instead.
            "::destroyById::ImobiliariaBifurcador::logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.updateById() instead.
            "::updateById::ImobiliariaBifurcador::logs": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariabifurcador/:id/logs/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs() instead.
            "::get::ImobiliariaBifurcador::logs": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.create() instead.
            "::create::ImobiliariaBifurcador::logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.createMany() instead.
            "::createMany::ImobiliariaBifurcador::logs": {
              isArray: true,
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.destroyAll() instead.
            "::delete::ImobiliariaBifurcador::logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaBifurcador.logs.count() instead.
            "::count::ImobiliariaBifurcador::logs": {
              url: urlBase + "/imobiliariabifurcador/:id/logs/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#updateOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchOrCreateWithWhere
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#update
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#destroyById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#removeById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchAttributes
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#updateOrCreate
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchOrCreateWithWhere
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#update
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#destroyById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#removeById
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#patchAttributes
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BifurcadorLog` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BifurcadorLog#modelName
        * @propertyOf lbServices.BifurcadorLog
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BifurcadorLog`.
        */
        R.modelName = "BifurcadorLog";


            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#card
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Fetches belongsTo relation card.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.card = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::BifurcadorLog::card"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#clienteinteressado
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Fetches belongsTo relation clienteinteressado.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.clienteinteressado = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::BifurcadorLog::clienteinteressado"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BifurcadorLog#imobiliaria
             * @methodOf lbServices.BifurcadorLog
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BifurcadorLog id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::BifurcadorLog::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImobiliariaPortal
 * @header lbServices.ImobiliariaPortal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImobiliariaPortal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImobiliariaPortal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/imobiliariaportais/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImobiliariaPortal.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/imobiliariaportais/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portal() instead.
            "prototype$__get__portal": {
              url: urlBase + "/imobiliariaportais/:id/portal",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.findById() instead.
            "prototype$__findById__portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.destroyById() instead.
            "prototype$__destroyById__portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.updateById() instead.
            "prototype$__updateById__portalimovel": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliariaportais/:id/portalimovel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel() instead.
            "prototype$__get__portalimovel": {
              isArray: true,
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "GET",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.create() instead.
            "prototype$__create__portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "POST",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.destroyAll() instead.
            "prototype$__delete__portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel",
              method: "DELETE",
            },

            // INTERNAL. Use ImobiliariaPortal.portalimovel.count() instead.
            "prototype$__count__portalimovel": {
              url: urlBase + "/imobiliariaportais/:id/portalimovel/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#create
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariaportais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#createMany
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariaportais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#upsert
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariaportais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#replaceOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariaportais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#upsertWithWhere
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariaportais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#exists
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariaportais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#findById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#replaceById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariaportais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#find
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariaportais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#findOne
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariaportais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#updateAll
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariaportais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#deleteById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#count
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariaportais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#createChangeStream
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariaportais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#portais
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Lista de portais para o Market Place.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "portais": {
              isArray: true,
              url: urlBase + "/imobiliariaportais/page-list",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#create
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/imobiliariaportais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#createMany
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/imobiliariaportais",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#upsert
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/imobiliariaportais",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#replaceOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/imobiliariaportais/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#upsertWithWhere
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/imobiliariaportais/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#exists
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/imobiliariaportais/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#findById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#replaceById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/imobiliariaportais/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#find
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/imobiliariaportais",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#findOne
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/imobiliariaportais/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#updateAll
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/imobiliariaportais/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#deleteById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#count
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/imobiliariaportais/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#prototype$updateAttributes
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/imobiliariaportais/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#createChangeStream
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/imobiliariaportais/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#pager
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/imobiliariaportais/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#pagerDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/imobiliariaportais/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#postDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/imobiliariaportais/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#deleteDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/imobiliariaportais/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#editDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/imobiliariaportais/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#autocomplete
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/imobiliariaportais/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#autocompleteDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/imobiliariaportais/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#autocompleteDetailEdit
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/imobiliariaportais/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#autocompleteGeneral
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/imobiliariaportais/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#crudGET
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/imobiliariaportais/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#crudGETDetail
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/imobiliariaportais/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#quickAdd
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/imobiliariaportais/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.portais.findById() instead.
            "::findById::Imobiliaria::portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.portais.destroyById() instead.
            "::destroyById::Imobiliaria::portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.portais.updateById() instead.
            "::updateById::Imobiliaria::portais": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/imobiliarias/:id/portais/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Imobiliaria.portais() instead.
            "::get::Imobiliaria::portais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/portais",
              method: "GET",
            },

            // INTERNAL. Use Imobiliaria.portais.create() instead.
            "::create::Imobiliaria::portais": {
              url: urlBase + "/imobiliarias/:id/portais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.portais.createMany() instead.
            "::createMany::Imobiliaria::portais": {
              isArray: true,
              url: urlBase + "/imobiliarias/:id/portais",
              method: "POST",
            },

            // INTERNAL. Use Imobiliaria.portais.destroyAll() instead.
            "::delete::Imobiliaria::portais": {
              url: urlBase + "/imobiliarias/:id/portais",
              method: "DELETE",
            },

            // INTERNAL. Use Imobiliaria.portais.count() instead.
            "::count::Imobiliaria::portais": {
              url: urlBase + "/imobiliarias/:id/portais/count",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria.findById() instead.
            "::findById::Portal::portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria.destroyById() instead.
            "::destroyById::Portal::portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portalimobiliaria.updateById() instead.
            "::updateById::Portal::portalimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/portalimobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.portalimobiliaria() instead.
            "::get::Portal::portalimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Portal.portalimobiliaria.create() instead.
            "::create::Portal::portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.portalimobiliaria.createMany() instead.
            "::createMany::Portal::portalimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.portalimobiliaria.destroyAll() instead.
            "::delete::Portal::portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.portalimobiliaria.count() instead.
            "::count::Portal::portalimobiliaria": {
              url: urlBase + "/portais/:id/portalimobiliaria/count",
              method: "GET",
            },

            // INTERNAL. Use LogXmlPortal.portalimobiliaria() instead.
            "::get::LogXmlPortal::portalimobiliaria": {
              url: urlBase + "/logxmlportal/:id/portalimobiliaria",
              method: "GET",
            },

            // INTERNAL. Use PortalImovel.portalimobiliaria() instead.
            "::get::PortalImovel::portalimobiliaria": {
              url: urlBase + "/portalimoveis/:id/portalimobiliaria",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#updateOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#update
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#destroyById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#removeById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchAttributes
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#updateOrCreate
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchOrCreateWithWhere
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#update
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#destroyById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#removeById
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#patchAttributes
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImobiliariaPortal` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImobiliariaPortal#modelName
        * @propertyOf lbServices.ImobiliariaPortal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImobiliariaPortal`.
        */
        R.modelName = "ImobiliariaPortal";


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#imobiliaria
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImobiliariaPortal::imobiliaria"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#portal
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Fetches belongsTo relation portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R.portal = function() {
          var TargetResource = $injector.get("Portal");
          var action = TargetResource["::get::ImobiliariaPortal::portal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ImobiliariaPortal.portalimovel
     * @header lbServices.ImobiliariaPortal.portalimovel
     * @object
     * @description
     *
     * The object `ImobiliariaPortal.portalimovel` groups methods
     * manipulating `PortalImovel` instances related to `ImobiliariaPortal`.
     *
     * Call {@link lbServices.ImobiliariaPortal#portalimovel ImobiliariaPortal.portalimovel()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal#portalimovel
             * @methodOf lbServices.ImobiliariaPortal
             *
             * @description
             *
             * Queries portalimovel of ImobiliariaPortal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portalimovel = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::get::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#count
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Counts portalimovel of ImobiliariaPortal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.portalimovel.count = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::count::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#create
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Creates a new instance in portalimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portalimovel.create = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::create::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#createMany
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Creates a new instance in portalimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portalimovel.createMany = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::createMany::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#destroyAll
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Deletes all portalimovel of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portalimovel.destroyAll = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::delete::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#destroyById
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Delete a related item by id for portalimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portalimovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.portalimovel.destroyById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::destroyById::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#findById
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Find a related item by id for portalimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for portalimovel
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portalimovel.findById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::findById::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImobiliariaPortal.portalimovel#updateById
             * @methodOf lbServices.ImobiliariaPortal.portalimovel
             *
             * @description
             *
             * Update a related item by id for portalimovel.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImobiliariaPortal id
             *
             *  - `fk` – `{*}` - Foreign key for portalimovel
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalImovel` object.)
             * </em>
             */
        R.portalimovel.updateById = function() {
          var TargetResource = $injector.get("PortalImovel");
          var action = TargetResource["::updateById::ImobiliariaPortal::portalimovel"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.PortalOrdemImobiliaria
 * @header lbServices.PortalOrdemImobiliaria
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `PortalOrdemImobiliaria` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "PortalOrdemImobiliaria",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/portalordemimobiliarias/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use PortalOrdemImobiliaria.portal() instead.
            "prototype$__get__portal": {
              url: urlBase + "/portalordemimobiliarias/:id/portal",
              method: "GET",
            },

            // INTERNAL. Use PortalOrdemImobiliaria.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/portalordemimobiliarias/:id/imobiliaria",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#create
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portalordemimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#createMany
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portalordemimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#upsert
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portalordemimobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#replaceOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portalordemimobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#upsertWithWhere
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portalordemimobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#exists
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portalordemimobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#findById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#replaceById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portalordemimobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#find
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portalordemimobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#findOne
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portalordemimobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#updateAll
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portalordemimobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#deleteById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#count
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portalordemimobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#createChangeStream
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portalordemimobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#create
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/portalordemimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#createMany
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/portalordemimobiliarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#upsert
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/portalordemimobiliarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#replaceOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/portalordemimobiliarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#upsertWithWhere
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/portalordemimobiliarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#exists
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/portalordemimobiliarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#findById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#replaceById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/portalordemimobiliarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#find
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/portalordemimobiliarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#findOne
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/portalordemimobiliarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#updateAll
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/portalordemimobiliarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#deleteById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#count
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/portalordemimobiliarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#prototype$updateAttributes
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/portalordemimobiliarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#createChangeStream
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/portalordemimobiliarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#pager
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/portalordemimobiliarias/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#pagerDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#postDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#deleteDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#editDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#autocomplete
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/portalordemimobiliarias/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#autocompleteDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#autocompleteDetailEdit
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/portalordemimobiliarias/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#autocompleteGeneral
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/portalordemimobiliarias/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#crudGET
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/portalordemimobiliarias/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#crudGETDetail
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/portalordemimobiliarias/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#quickAdd
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/portalordemimobiliarias/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.findById() instead.
            "::findById::Portal::ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "GET",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.destroyById() instead.
            "::destroyById::Portal::ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.updateById() instead.
            "::updateById::Portal::ordemimobiliaria": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/portais/:id/ordemimobiliaria/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Portal.ordemimobiliaria() instead.
            "::get::Portal::ordemimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.create() instead.
            "::create::Portal::ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.createMany() instead.
            "::createMany::Portal::ordemimobiliaria": {
              isArray: true,
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "POST",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.destroyAll() instead.
            "::delete::Portal::ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria",
              method: "DELETE",
            },

            // INTERNAL. Use Portal.ordemimobiliaria.count() instead.
            "::count::Portal::ordemimobiliaria": {
              url: urlBase + "/portais/:id/ordemimobiliaria/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#updateOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#update
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#destroyById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#removeById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchAttributes
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#updateOrCreate
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchOrCreateWithWhere
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#update
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#destroyById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#removeById
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#patchAttributes
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `PortalOrdemImobiliaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.PortalOrdemImobiliaria#modelName
        * @propertyOf lbServices.PortalOrdemImobiliaria
        * @description
        * The name of the model represented by this $resource,
        * i.e. `PortalOrdemImobiliaria`.
        */
        R.modelName = "PortalOrdemImobiliaria";


            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#portal
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation portal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Portal` object.)
             * </em>
             */
        R.portal = function() {
          var TargetResource = $injector.get("Portal");
          var action = TargetResource["::get::PortalOrdemImobiliaria::portal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.PortalOrdemImobiliaria#imobiliaria
             * @methodOf lbServices.PortalOrdemImobiliaria
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - PortalOrdemImobiliaria id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::PortalOrdemImobiliaria::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ProprietarioContaBancaria
 * @header lbServices.ProprietarioContaBancaria
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ProprietarioContaBancaria` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ProprietarioContaBancaria",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/proprietariocontabancarias/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#create
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietariocontabancarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#createMany
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietariocontabancarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#upsert
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietariocontabancarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#replaceOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietariocontabancarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#upsertWithWhere
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietariocontabancarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#exists
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietariocontabancarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#findById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#replaceById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietariocontabancarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#find
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietariocontabancarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#findOne
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietariocontabancarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#updateAll
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietariocontabancarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#deleteById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#count
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietariocontabancarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#prototype$updateAttributes
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioContaBancaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#createChangeStream
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietariocontabancarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#create
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/proprietariocontabancarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#createMany
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/proprietariocontabancarias",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#upsert
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/proprietariocontabancarias",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#replaceOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/proprietariocontabancarias/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#upsertWithWhere
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/proprietariocontabancarias/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#exists
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/proprietariocontabancarias/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#findById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#replaceById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/proprietariocontabancarias/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#find
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/proprietariocontabancarias",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#findOne
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/proprietariocontabancarias/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#updateAll
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/proprietariocontabancarias/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#deleteById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#count
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/proprietariocontabancarias/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#prototype$updateAttributes
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioContaBancaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/proprietariocontabancarias/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#createChangeStream
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/proprietariocontabancarias/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#pager
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/proprietariocontabancarias/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#pagerDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#postDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#deleteDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#editDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#autocomplete
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/proprietariocontabancarias/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#autocompleteDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#autocompleteDetailEdit
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/proprietariocontabancarias/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#autocompleteGeneral
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/proprietariocontabancarias/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#crudGET
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/proprietariocontabancarias/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#crudGETDetail
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/proprietariocontabancarias/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#quickAdd
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/proprietariocontabancarias/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.findById() instead.
            "::findById::Proprietario::contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.destroyById() instead.
            "::destroyById::Proprietario::contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.updateById() instead.
            "::updateById::Proprietario::contas_bancarias": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/proprietarios/:id/contas_bancarias/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Proprietario.contas_bancarias() instead.
            "::get::Proprietario::contas_bancarias": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "GET",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.create() instead.
            "::create::Proprietario::contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.createMany() instead.
            "::createMany::Proprietario::contas_bancarias": {
              isArray: true,
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "POST",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.destroyAll() instead.
            "::delete::Proprietario::contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias",
              method: "DELETE",
            },

            // INTERNAL. Use Proprietario.contas_bancarias.count() instead.
            "::count::Proprietario::contas_bancarias": {
              url: urlBase + "/proprietarios/:id/contas_bancarias/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#updateOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchOrCreateWithWhere
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#update
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#destroyById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#removeById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchAttributes
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioContaBancaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#updateOrCreate
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchOrCreateWithWhere
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#update
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#destroyById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#removeById
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ProprietarioContaBancaria#patchAttributes
             * @methodOf lbServices.ProprietarioContaBancaria
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ProprietarioContaBancaria id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ProprietarioContaBancaria` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ProprietarioContaBancaria#modelName
        * @propertyOf lbServices.ProprietarioContaBancaria
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ProprietarioContaBancaria`.
        */
        R.modelName = "ProprietarioContaBancaria";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Cliente
 * @header lbServices.Cliente
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Cliente` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Cliente",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/clientes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Cliente.atendimentos.findById() instead.
            "prototype$__findById__atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos.destroyById() instead.
            "prototype$__destroyById__atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Cliente.atendimentos.updateById() instead.
            "prototype$__updateById__atendimentos": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/clientes/:id/atendimentos/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Cliente.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/clientes/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos() instead.
            "prototype$__get__atendimentos": {
              isArray: true,
              url: urlBase + "/clientes/:id/atendimentos",
              method: "GET",
            },

            // INTERNAL. Use Cliente.atendimentos.create() instead.
            "prototype$__create__atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos",
              method: "POST",
            },

            // INTERNAL. Use Cliente.atendimentos.destroyAll() instead.
            "prototype$__delete__atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos",
              method: "DELETE",
            },

            // INTERNAL. Use Cliente.atendimentos.count() instead.
            "prototype$__count__atendimentos": {
              url: urlBase + "/clientes/:id/atendimentos/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#create
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#createMany
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#upsert
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#replaceOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#upsertWithWhere
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#exists
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#findById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#replaceById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#find
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#findOne
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#updateAll
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#deleteById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#count
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#prototype$updateAttributes
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#createChangeStream
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#create
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/clientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#createMany
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/clientes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#upsert
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/clientes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#replaceOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/clientes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#upsertWithWhere
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/clientes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#exists
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/clientes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#findById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/clientes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#replaceById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/clientes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#find
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/clientes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#findOne
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/clientes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#updateAll
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/clientes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#deleteById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/clientes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#count
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/clientes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#prototype$updateAttributes
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/clientes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#createChangeStream
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/clientes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#pager
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/clientes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#pagerDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/clientes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#postDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/clientes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#deleteDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/clientes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#editDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/clientes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#autocomplete
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/clientes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#autocompleteDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/clientes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#autocompleteDetailEdit
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/clientes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#autocompleteGeneral
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/clientes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#crudGET
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/clientes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#crudGETDetail
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/clientes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Cliente#quickAdd
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/clientes/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#updateOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchOrCreateWithWhere
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#update
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#destroyById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#removeById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchAttributes
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#updateOrCreate
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchOrCreateWithWhere
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#update
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#destroyById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#removeById
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Cliente#patchAttributes
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Cliente` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Cliente#modelName
        * @propertyOf lbServices.Cliente
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Cliente`.
        */
        R.modelName = "Cliente";

    /**
     * @ngdoc object
     * @name lbServices.Cliente.atendimentos
     * @header lbServices.Cliente.atendimentos
     * @object
     * @description
     *
     * The object `Cliente.atendimentos` groups methods
     * manipulating `ClienteInteressado` instances related to `Cliente`.
     *
     * Call {@link lbServices.Cliente#atendimentos Cliente.atendimentos()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Cliente#atendimentos
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Queries atendimentos of Cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.atendimentos = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#count
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Counts atendimentos of Cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.atendimentos.count = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::count::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#create
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Creates a new instance in atendimentos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.atendimentos.create = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::create::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#createMany
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Creates a new instance in atendimentos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.atendimentos.createMany = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::createMany::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#destroyAll
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Deletes all atendimentos of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.atendimentos.destroyAll = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::delete::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#destroyById
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Delete a related item by id for atendimentos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `fk` – `{*}` - Foreign key for atendimentos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.atendimentos.destroyById = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::destroyById::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#findById
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Find a related item by id for atendimentos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `fk` – `{*}` - Foreign key for atendimentos
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.atendimentos.findById = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::findById::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente.atendimentos#updateById
             * @methodOf lbServices.Cliente.atendimentos
             *
             * @description
             *
             * Update a related item by id for atendimentos.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `fk` – `{*}` - Foreign key for atendimentos
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.atendimentos.updateById = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::updateById::Cliente::atendimentos"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Cliente#imobiliaria
             * @methodOf lbServices.Cliente
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Cliente id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Cliente::imobiliaria"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImportacaoCsvErrors
 * @header lbServices.ImportacaoCsvErrors
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImportacaoCsvErrors` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImportacaoCsvErrors",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/importacaocsverrors/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#create
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/importacaocsverrors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#createMany
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/importacaocsverrors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#upsert
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/importacaocsverrors",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#replaceOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/importacaocsverrors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#upsertWithWhere
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/importacaocsverrors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#exists
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/importacaocsverrors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#findById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#replaceById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/importacaocsverrors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#find
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/importacaocsverrors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#findOne
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/importacaocsverrors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#updateAll
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/importacaocsverrors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#deleteById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#count
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/importacaocsverrors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#prototype$updateAttributes
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvErrors id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#createChangeStream
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/importacaocsverrors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#create
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/importacaocsverrors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#createMany
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/importacaocsverrors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#upsert
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/importacaocsverrors",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#replaceOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/importacaocsverrors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#upsertWithWhere
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/importacaocsverrors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#exists
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/importacaocsverrors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#findById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#replaceById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/importacaocsverrors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#find
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/importacaocsverrors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#findOne
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/importacaocsverrors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#updateAll
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/importacaocsverrors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#deleteById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#count
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/importacaocsverrors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#prototype$updateAttributes
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvErrors id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/importacaocsverrors/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#createChangeStream
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/importacaocsverrors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#pager
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/importacaocsverrors/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#pagerDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/importacaocsverrors/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#postDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/importacaocsverrors/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#deleteDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/importacaocsverrors/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#editDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/importacaocsverrors/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#autocomplete
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/importacaocsverrors/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#autocompleteDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/importacaocsverrors/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#autocompleteDetailEdit
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/importacaocsverrors/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#autocompleteGeneral
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/importacaocsverrors/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#crudGET
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/importacaocsverrors/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#crudGETDetail
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/importacaocsverrors/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#quickAdd
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/importacaocsverrors/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.findById() instead.
            "::findById::ImportacaoCsvLogs::errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.destroyById() instead.
            "::destroyById::ImportacaoCsvLogs::errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.updateById() instead.
            "::updateById::ImportacaoCsvLogs::errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors() instead.
            "::get::ImportacaoCsvLogs::errors": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.create() instead.
            "::create::ImportacaoCsvLogs::errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "POST",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.createMany() instead.
            "::createMany::ImportacaoCsvLogs::errors": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "POST",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.destroyAll() instead.
            "::delete::ImportacaoCsvLogs::errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "DELETE",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.count() instead.
            "::count::ImportacaoCsvLogs::errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#updateOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchOrCreateWithWhere
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#update
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#destroyById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#removeById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchAttributes
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvErrors id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#updateOrCreate
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchOrCreateWithWhere
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#update
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#destroyById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#removeById
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvErrors#patchAttributes
             * @methodOf lbServices.ImportacaoCsvErrors
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvErrors id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImportacaoCsvErrors#modelName
        * @propertyOf lbServices.ImportacaoCsvErrors
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImportacaoCsvErrors`.
        */
        R.modelName = "ImportacaoCsvErrors";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ImportacaoCsvLogs
 * @header lbServices.ImportacaoCsvLogs
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ImportacaoCsvLogs` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ImportacaoCsvLogs",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/importacaocsvlogs/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use ImportacaoCsvLogs.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/importacaocsvlogs/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.findById() instead.
            "prototype$__findById__errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.destroyById() instead.
            "prototype$__destroyById__errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.updateById() instead.
            "prototype$__updateById__errors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/importacaocsvlogs/:id/errors/:fk",
              method: "PUT",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors() instead.
            "prototype$__get__errors": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "GET",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.create() instead.
            "prototype$__create__errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "POST",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.destroyAll() instead.
            "prototype$__delete__errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors",
              method: "DELETE",
            },

            // INTERNAL. Use ImportacaoCsvLogs.errors.count() instead.
            "prototype$__count__errors": {
              url: urlBase + "/importacaocsvlogs/:id/errors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#create
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/importacaocsvlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#createMany
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#upsert
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/importacaocsvlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#replaceOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/importacaocsvlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#upsertWithWhere
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/importacaocsvlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#exists
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/importacaocsvlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#findById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#replaceById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/importacaocsvlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#find
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#findOne
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/importacaocsvlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#updateAll
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/importacaocsvlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#deleteById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#count
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/importacaocsvlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#prototype$updateAttributes
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#createChangeStream
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/importacaocsvlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#create
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/importacaocsvlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#createMany
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#upsert
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/importacaocsvlogs",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#replaceOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/importacaocsvlogs/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#upsertWithWhere
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/importacaocsvlogs/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#exists
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/importacaocsvlogs/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#findById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#replaceById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/importacaocsvlogs/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#find
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/importacaocsvlogs",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#findOne
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/importacaocsvlogs/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#updateAll
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/importacaocsvlogs/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#deleteById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#count
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/importacaocsvlogs/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#prototype$updateAttributes
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/importacaocsvlogs/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#createChangeStream
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/importacaocsvlogs/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#pager
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/importacaocsvlogs/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#pagerDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/importacaocsvlogs/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#postDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/importacaocsvlogs/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#deleteDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/importacaocsvlogs/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#editDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/importacaocsvlogs/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#autocomplete
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/importacaocsvlogs/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#autocompleteDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/importacaocsvlogs/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#autocompleteDetailEdit
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/importacaocsvlogs/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#autocompleteGeneral
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/importacaocsvlogs/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#crudGET
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/importacaocsvlogs/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#crudGETDetail
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/importacaocsvlogs/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#quickAdd
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/importacaocsvlogs/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#updateOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchOrCreateWithWhere
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#update
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#destroyById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#removeById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchAttributes
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#updateOrCreate
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchOrCreateWithWhere
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#update
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#destroyById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#removeById
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#patchAttributes
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvLogs` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ImportacaoCsvLogs#modelName
        * @propertyOf lbServices.ImportacaoCsvLogs
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ImportacaoCsvLogs`.
        */
        R.modelName = "ImportacaoCsvLogs";


            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#imobiliaria
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::ImportacaoCsvLogs::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.ImportacaoCsvLogs.errors
     * @header lbServices.ImportacaoCsvLogs.errors
     * @object
     * @description
     *
     * The object `ImportacaoCsvLogs.errors` groups methods
     * manipulating `ImportacaoCsvErrors` instances related to `ImportacaoCsvLogs`.
     *
     * Call {@link lbServices.ImportacaoCsvLogs#errors ImportacaoCsvLogs.errors()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs#errors
             * @methodOf lbServices.ImportacaoCsvLogs
             *
             * @description
             *
             * Queries errors of ImportacaoCsvLogs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `filter` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R.errors = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::get::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#count
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Counts errors of ImportacaoCsvLogs.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.errors.count = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::count::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#create
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Creates a new instance in errors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R.errors.create = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::create::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#createMany
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Creates a new instance in errors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R.errors.createMany = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::createMany::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#destroyAll
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Deletes all errors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `where` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.errors.destroyAll = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::delete::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#destroyById
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Delete a related item by id for errors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `fk` – `{*}` - Foreign key for errors
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.errors.destroyById = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::destroyById::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#findById
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Find a related item by id for errors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `fk` – `{*}` - Foreign key for errors
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R.errors.findById = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::findById::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.ImportacaoCsvLogs.errors#updateById
             * @methodOf lbServices.ImportacaoCsvLogs.errors
             *
             * @description
             *
             * Update a related item by id for errors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ImportacaoCsvLogs id
             *
             *  - `fk` – `{*}` - Foreign key for errors
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ImportacaoCsvErrors` object.)
             * </em>
             */
        R.errors.updateById = function() {
          var TargetResource = $injector.get("ImportacaoCsvErrors");
          var action = TargetResource["::updateById::ImportacaoCsvLogs::errors"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Campanha
 * @header lbServices.Campanha
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Campanha` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Campanha",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/campanhas/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Campanha.imobiliaria() instead.
            "prototype$__get__imobiliaria": {
              url: urlBase + "/campanhas/:id/imobiliaria",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhatime.findById() instead.
            "prototype$__findById__campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhatime.destroyById() instead.
            "prototype$__destroyById__campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhatime.updateById() instead.
            "prototype$__updateById__campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Campanha.campanhalead.findById() instead.
            "prototype$__findById__campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhalead.destroyById() instead.
            "prototype$__destroyById__campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhalead.updateById() instead.
            "prototype$__updateById__campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Campanha.campanhatime() instead.
            "prototype$__get__campanhatime": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhatime.create() instead.
            "prototype$__create__campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhatime.destroyAll() instead.
            "prototype$__delete__campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhatime.count() instead.
            "prototype$__count__campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime/count",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhalead() instead.
            "prototype$__get__campanhalead": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhalead.create() instead.
            "prototype$__create__campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhalead.destroyAll() instead.
            "prototype$__delete__campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhalead.count() instead.
            "prototype$__count__campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#create
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#createMany
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#upsert
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#replaceOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#upsertWithWhere
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#exists
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#findById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#replaceById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#find
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#findOne
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#updateAll
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#deleteById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#count
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#prototype$updateAttributes
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#createChangeStream
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#createCampanhaLeadScriptCsv
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Campanha Update Imovel
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `body` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "createCampanhaLeadScriptCsv": {
              url: urlBase + "/campanhas/create-campanha-lead-script-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#verifyCsv
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object}` -
             *
             *  - `res` – `{object}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "verifyCsv": {
              url: urlBase + "/campanhas/verify-csv",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#create
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#createMany
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhas",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#upsert
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhas",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#replaceOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhas/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#upsertWithWhere
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhas/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#exists
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhas/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#findById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhas/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#replaceById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhas/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#find
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhas",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#findOne
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhas/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#updateAll
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhas/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#deleteById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhas/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#count
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhas/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#prototype$updateAttributes
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhas/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#createChangeStream
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhas/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#pager
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/campanhas/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#pagerDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/campanhas/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#postDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/campanhas/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#deleteDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/campanhas/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#editDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/campanhas/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#autocomplete
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/campanhas/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#autocompleteDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/campanhas/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#autocompleteDetailEdit
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/campanhas/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#autocompleteGeneral
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/campanhas/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#crudGET
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/campanhas/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#crudGETDetail
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/campanhas/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Campanha#quickAdd
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/campanhas/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use CardImovel.campanha() instead.
            "::get::CardImovel::campanha": {
              url: urlBase + "/cardsimovel/:id/campanha",
              method: "GET",
            },

            // INTERNAL. Use CampanhaTime.campanha() instead.
            "::get::CampanhaTime::campanha": {
              url: urlBase + "/campanhastimes/:id/campanha",
              method: "GET",
            },

            // INTERNAL. Use CampanhaLead.campanha() instead.
            "::get::CampanhaLead::campanha": {
              url: urlBase + "/campanhasleads/:id/campanha",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#updateOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchOrCreateWithWhere
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#update
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#destroyById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#removeById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchAttributes
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#updateOrCreate
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchOrCreateWithWhere
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#update
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#destroyById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#removeById
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Campanha#patchAttributes
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Campanha#modelName
        * @propertyOf lbServices.Campanha
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Campanha`.
        */
        R.modelName = "Campanha";


            /**
             * @ngdoc method
             * @name lbServices.Campanha#imobiliaria
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Fetches belongsTo relation imobiliaria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Imobiliaria` object.)
             * </em>
             */
        R.imobiliaria = function() {
          var TargetResource = $injector.get("Imobiliaria");
          var action = TargetResource["::get::Campanha::imobiliaria"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Campanha.campanhatime
     * @header lbServices.Campanha.campanhatime
     * @object
     * @description
     *
     * The object `Campanha.campanhatime` groups methods
     * manipulating `CampanhaTime` instances related to `Campanha`.
     *
     * Call {@link lbServices.Campanha#campanhatime Campanha.campanhatime()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Campanha#campanhatime
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Queries campanhatime of Campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R.campanhatime = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::get::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#count
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Counts campanhatime of Campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.campanhatime.count = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::count::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#create
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Creates a new instance in campanhatime of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R.campanhatime.create = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::create::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#createMany
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Creates a new instance in campanhatime of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R.campanhatime.createMany = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::createMany::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#destroyAll
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Deletes all campanhatime of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.campanhatime.destroyAll = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::delete::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#destroyById
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Delete a related item by id for campanhatime.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for campanhatime
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.campanhatime.destroyById = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::destroyById::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#findById
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Find a related item by id for campanhatime.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for campanhatime
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R.campanhatime.findById = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::findById::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhatime#updateById
             * @methodOf lbServices.Campanha.campanhatime
             *
             * @description
             *
             * Update a related item by id for campanhatime.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `fk` – `{*}` - Foreign key for campanhatime
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R.campanhatime.updateById = function() {
          var TargetResource = $injector.get("CampanhaTime");
          var action = TargetResource["::updateById::Campanha::campanhatime"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Campanha.campanhalead
     * @header lbServices.Campanha.campanhalead
     * @object
     * @description
     *
     * The object `Campanha.campanhalead` groups methods
     * manipulating `CampanhaLead` instances related to `Campanha`.
     *
     * Call {@link lbServices.Campanha#campanhalead Campanha.campanhalead()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Campanha#campanhalead
             * @methodOf lbServices.Campanha
             *
             * @description
             *
             * Queries campanhalead of Campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R.campanhalead = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::get::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#count
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Counts campanhalead of Campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.campanhalead.count = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::count::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#create
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Creates a new instance in campanhalead of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R.campanhalead.create = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::create::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#createMany
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Creates a new instance in campanhalead of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R.campanhalead.createMany = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::createMany::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#destroyAll
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Deletes all campanhalead of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.campanhalead.destroyAll = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::delete::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#destroyById
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Delete a related item by id for campanhalead.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for campanhalead
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.campanhalead.destroyById = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::destroyById::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#findById
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Find a related item by id for campanhalead.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for campanhalead
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R.campanhalead.findById = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::findById::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Campanha.campanhalead#updateById
             * @methodOf lbServices.Campanha.campanhalead
             *
             * @description
             *
             * Update a related item by id for campanhalead.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Campanha id
             *
             *  - `fk` – `{*}` - Foreign key for campanhalead
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R.campanhalead.updateById = function() {
          var TargetResource = $injector.get("CampanhaLead");
          var action = TargetResource["::updateById::Campanha::campanhalead"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CampanhaTime
 * @header lbServices.CampanhaTime
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CampanhaTime` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CampanhaTime",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/campanhastimes/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CampanhaTime.campanha() instead.
            "prototype$__get__campanha": {
              url: urlBase + "/campanhastimes/:id/campanha",
              method: "GET",
            },

            // INTERNAL. Use CampanhaTime.time() instead.
            "prototype$__get__time": {
              url: urlBase + "/campanhastimes/:id/time",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#create
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhastimes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#createMany
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhastimes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#upsert
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhastimes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#replaceOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhastimes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#upsertWithWhere
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhastimes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#exists
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhastimes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#findById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhastimes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#replaceById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhastimes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#find
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhastimes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#findOne
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhastimes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#updateAll
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhastimes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#deleteById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhastimes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#count
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhastimes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#prototype$updateAttributes
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhastimes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#createChangeStream
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhastimes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#create
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhastimes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#createMany
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhastimes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#upsert
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhastimes",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#replaceOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhastimes/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#upsertWithWhere
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhastimes/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#exists
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhastimes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#findById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhastimes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#replaceById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhastimes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#find
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhastimes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#findOne
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhastimes/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#updateAll
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhastimes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#deleteById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhastimes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#count
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhastimes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#prototype$updateAttributes
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhastimes/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#createChangeStream
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhastimes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#pager
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/campanhastimes/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#pagerDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/campanhastimes/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#postDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/campanhastimes/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#deleteDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/campanhastimes/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#editDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/campanhastimes/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#autocomplete
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/campanhastimes/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#autocompleteDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/campanhastimes/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#autocompleteDetailEdit
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/campanhastimes/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#autocompleteGeneral
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/campanhastimes/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#crudGET
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/campanhastimes/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#crudGETDetail
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/campanhastimes/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#quickAdd
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/campanhastimes/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhatime.findById() instead.
            "::findById::Campanha::campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhatime.destroyById() instead.
            "::destroyById::Campanha::campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhatime.updateById() instead.
            "::updateById::Campanha::campanhatime": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhatime/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Campanha.campanhatime() instead.
            "::get::Campanha::campanhatime": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhatime.create() instead.
            "::create::Campanha::campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhatime.createMany() instead.
            "::createMany::Campanha::campanhatime": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhatime.destroyAll() instead.
            "::delete::Campanha::campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhatime.count() instead.
            "::count::Campanha::campanhatime": {
              url: urlBase + "/campanhas/:id/campanhatime/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#updateOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchOrCreateWithWhere
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#update
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#destroyById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#removeById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchAttributes
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#updateOrCreate
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchOrCreateWithWhere
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#update
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#destroyById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#removeById
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#patchAttributes
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaTime` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CampanhaTime#modelName
        * @propertyOf lbServices.CampanhaTime
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CampanhaTime`.
        */
        R.modelName = "CampanhaTime";


            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#campanha
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Fetches belongsTo relation campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R.campanha = function() {
          var TargetResource = $injector.get("Campanha");
          var action = TargetResource["::get::CampanhaTime::campanha"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CampanhaTime#time
             * @methodOf lbServices.CampanhaTime
             *
             * @description
             *
             * Fetches belongsTo relation time.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaTime id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Time` object.)
             * </em>
             */
        R.time = function() {
          var TargetResource = $injector.get("Time");
          var action = TargetResource["::get::CampanhaTime::time"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.CampanhaLead
 * @header lbServices.CampanhaLead
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `CampanhaLead` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "CampanhaLead",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/campanhasleads/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use CampanhaLead.campanha() instead.
            "prototype$__get__campanha": {
              url: urlBase + "/campanhasleads/:id/campanha",
              method: "GET",
            },

            // INTERNAL. Use CampanhaLead.cliente() instead.
            "prototype$__get__cliente": {
              url: urlBase + "/campanhasleads/:id/cliente",
              method: "GET",
            },

            // INTERNAL. Use CampanhaLead.card() instead.
            "prototype$__get__card": {
              url: urlBase + "/campanhasleads/:id/card",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#create
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhasleads",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#createMany
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhasleads",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#upsert
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhasleads",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#replaceOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhasleads/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#upsertWithWhere
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhasleads/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#exists
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhasleads/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#findById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhasleads/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#replaceById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhasleads/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#find
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhasleads",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#findOne
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhasleads/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#updateAll
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhasleads/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#deleteById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhasleads/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#count
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhasleads/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#prototype$updateAttributes
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhasleads/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#createChangeStream
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhasleads/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#create
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/campanhasleads",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#createMany
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/campanhasleads",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#upsert
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/campanhasleads",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#replaceOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/campanhasleads/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#upsertWithWhere
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/campanhasleads/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#exists
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/campanhasleads/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#findById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/campanhasleads/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#replaceById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/campanhasleads/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#find
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/campanhasleads",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#findOne
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/campanhasleads/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#updateAll
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/campanhasleads/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#deleteById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/campanhasleads/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#count
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/campanhasleads/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#prototype$updateAttributes
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/campanhasleads/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#createChangeStream
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/campanhasleads/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#pager
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/campanhasleads/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#pagerDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/campanhasleads/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#postDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/campanhasleads/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#deleteDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/campanhasleads/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#editDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/campanhasleads/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#autocomplete
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/campanhasleads/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#autocompleteDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/campanhasleads/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#autocompleteDetailEdit
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/campanhasleads/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#autocompleteGeneral
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/campanhasleads/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#crudGET
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/campanhasleads/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#crudGETDetail
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/campanhasleads/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#quickAdd
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/campanhasleads/quickAdd/:field",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhalead.findById() instead.
            "::findById::Campanha::campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhalead.destroyById() instead.
            "::destroyById::Campanha::campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhalead.updateById() instead.
            "::updateById::Campanha::campanhalead": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/campanhas/:id/campanhalead/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Campanha.campanhalead() instead.
            "::get::Campanha::campanhalead": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "GET",
            },

            // INTERNAL. Use Campanha.campanhalead.create() instead.
            "::create::Campanha::campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhalead.createMany() instead.
            "::createMany::Campanha::campanhalead": {
              isArray: true,
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "POST",
            },

            // INTERNAL. Use Campanha.campanhalead.destroyAll() instead.
            "::delete::Campanha::campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead",
              method: "DELETE",
            },

            // INTERNAL. Use Campanha.campanhalead.count() instead.
            "::count::Campanha::campanhalead": {
              url: urlBase + "/campanhas/:id/campanhalead/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#updateOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchOrCreateWithWhere
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#update
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#destroyById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#removeById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchAttributes
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#updateOrCreate
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchOrCreateWithWhere
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#update
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#destroyById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#removeById
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#patchAttributes
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CampanhaLead` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.CampanhaLead#modelName
        * @propertyOf lbServices.CampanhaLead
        * @description
        * The name of the model represented by this $resource,
        * i.e. `CampanhaLead`.
        */
        R.modelName = "CampanhaLead";


            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#campanha
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Fetches belongsTo relation campanha.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Campanha` object.)
             * </em>
             */
        R.campanha = function() {
          var TargetResource = $injector.get("Campanha");
          var action = TargetResource["::get::CampanhaLead::campanha"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#cliente
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Fetches belongsTo relation cliente.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ClienteInteressado` object.)
             * </em>
             */
        R.cliente = function() {
          var TargetResource = $injector.get("ClienteInteressado");
          var action = TargetResource["::get::CampanhaLead::cliente"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.CampanhaLead#card
             * @methodOf lbServices.CampanhaLead
             *
             * @description
             *
             * Fetches belongsTo relation card.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - CampanhaLead id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `CardImovel` object.)
             * </em>
             */
        R.card = function() {
          var TargetResource = $injector.get("CardImovel");
          var action = TargetResource["::get::CampanhaLead::card"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.LogErrorProposta
 * @header lbServices.LogErrorProposta
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `LogErrorProposta` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "LogErrorProposta",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/logerrorproposta/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use LogErrorProposta.proposta() instead.
            "prototype$__get__proposta": {
              url: urlBase + "/logerrorproposta/:id/proposta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#create
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/logerrorproposta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#createMany
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/logerrorproposta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#upsert
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/logerrorproposta",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#replaceOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/logerrorproposta/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#upsertWithWhere
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/logerrorproposta/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#exists
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/logerrorproposta/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#findById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/logerrorproposta/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#replaceById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/logerrorproposta/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#find
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/logerrorproposta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#findOne
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/logerrorproposta/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#updateAll
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/logerrorproposta/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#deleteById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/logerrorproposta/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#count
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/logerrorproposta/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#prototype$updateAttributes
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogErrorProposta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/logerrorproposta/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#createChangeStream
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/logerrorproposta/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#create
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/logerrorproposta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#createMany
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/logerrorproposta",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#upsert
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "upsert": {
              url: urlBase + "/logerrorproposta",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#replaceOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/logerrorproposta/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#upsertWithWhere
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/logerrorproposta/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#exists
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/logerrorproposta/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#findById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/logerrorproposta/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#replaceById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/logerrorproposta/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#find
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/logerrorproposta",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#findOne
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string ({"something":"value"})
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/logerrorproposta/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#updateAll
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/logerrorproposta/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#deleteById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/logerrorproposta/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#count
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/logerrorproposta/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#prototype$updateAttributes
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogErrorProposta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "prototype$updateAttributes": {
              url: urlBase + "/logerrorproposta/:id",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#createChangeStream
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/logerrorproposta/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#pager
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pager": {
              url: urlBase + "/logerrorproposta/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#pagerDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Retrieves rows with pager settings
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "pagerDetail": {
              url: urlBase + "/logerrorproposta/details/:id/:detail/pager",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#postDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "postDetail": {
              url: urlBase + "/logerrorproposta/details/:detail/:id",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#deleteDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "deleteDetail": {
              url: urlBase + "/logerrorproposta/details/:id/:detail/:iddetail",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#editDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "editDetail": {
              url: urlBase + "/logerrorproposta/details/:id/:detail/:iddetail",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#autocomplete
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocomplete": {
              url: urlBase + "/logerrorproposta/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#autocompleteDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetail": {
              url: urlBase + "/logerrorproposta/details/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#autocompleteDetailEdit
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * retrieves options for autocomplete field
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteDetailEdit": {
              url: urlBase + "/logerrorproposta/details/:id/:detail/autocomplete/:field/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#autocompleteGeneral
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * retrieves options for autocomplete model without relations
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `params` – `{object}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Return rows retrieved
             */
            "autocompleteGeneral": {
              url: urlBase + "/logerrorproposta/general/autocomplete/:model/:search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#crudGET
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "crudGET": {
              url: urlBase + "/logerrorproposta/crudGET/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#crudGETDetail
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "crudGETDetail": {
              url: urlBase + "/logerrorproposta/details/:id/:detail/:iddetail",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#quickAdd
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Quick Add.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
            "quickAdd": {
              url: urlBase + "/logerrorproposta/quickAdd/:field",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#updateOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchOrCreateWithWhere
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#update
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#destroyById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#removeById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchAttributes
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogErrorProposta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#updateOrCreate
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["updateOrCreate"] = R["upsert"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchOrCreateWithWhere
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#update
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#destroyById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#removeById
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#patchAttributes
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogErrorProposta id
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `LogErrorProposta` object.)
             * </em>
             */
        R["patchAttributes"] = R["prototype$updateAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.LogErrorProposta#modelName
        * @propertyOf lbServices.LogErrorProposta
        * @description
        * The name of the model represented by this $resource,
        * i.e. `LogErrorProposta`.
        */
        R.modelName = "LogErrorProposta";


            /**
             * @ngdoc method
             * @name lbServices.LogErrorProposta#proposta
             * @methodOf lbServices.LogErrorProposta
             *
             * @description
             *
             * Fetches belongsTo relation proposta.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - LogErrorProposta id
             *
             *  - `refresh` – `{boolean=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Proposta` object.)
             * </em>
             */
        R.proposta = function() {
          var TargetResource = $injector.get("Proposta");
          var action = TargetResource["::get::LogErrorProposta::proposta"];
          return action.apply(R, arguments);
        };


        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
    //$httpProvider.defaults.headers.common = { 'X-From' : 'ANGULAR' };
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && host !== urlBaseHost) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);

(function() {
    'use strict';

    angular
        .module('arboWeb', [
                'lbServices', 
                'angular-owl-carousel-2',
                // 'uiRouterStyles',
                'infinite-scroll',
                'ngResource', 
                'ngAnimate', 
                // 'ngCookies', 
                'ngTouch', 
                'ngSanitize', 
                'ngMessages', 
                'ngAria', 
                'ui.router', 
                'ui.bootstrap', 
                'toastr', 
                'ya.nouislider', 
                'satellizer', 
                'angularUtils.directives.dirPagination', 
                'angularFileUpload', 
                'ui.utils.masks', 
                'ngMask', 
                'angular.viacep', 
                // 'angular-creditcard-flag',
                'ngMeta',
                'swangular',
                '720kb.socialshare',
                'zxcvbn'
            ]);
})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .directive('resultSidebarEmpreendimento', resultSidebarEmpreendimento)
  // .filter('listingFilter', listingFilter);

  function resultSidebarEmpreendimento() {
    var directive = {
      restrict: 'A',
      templateUrl: 'app/listing/sidebar/result-sidebar-lancamento.html',
      controller: ResultSidebarEmpreendimentoController,
      controllerAs: 'vm',
      scope: {
        markers: '=',
        filters: '='
      },
      bindToController: true
    };
    return directive;
  }

  ResultSidebarEmpreendimentoController.inject = ['$scope', '$state', 'SERVER_URL', 'textFormatter', '$location', 'Empreendimento'];
  /* @ngInject */
  // function ResultSidebarController($scope, $state, SERVER_URL, Amenity, textFormatter, auth) {

  function ResultSidebarEmpreendimentoController($scope, $state, SERVER_URL, textFormatter, $location, Empreendimento, createThumb) {

    var vm = this;
    vm.filteredListings = [];
    vm.idsListings = [];
    vm.jump = 0;

    vm.getContainer = function () {
      if (angular.element(window).width() < 768) {
        return null;
      } else {
        return '.result-sidebar';
      }
    }

    $scope.$on('listingRefresh', function (event, listings) {
      vm.jump = 10;
      vm.filteredListings = [];
      vm.idsListings = listings.map(function (item) {
        return {
          'id': item.id
        }
      });

      angular.element('#jsonLd').remove();
      //vm.filteredListings = listings;
      //Bug que ficava "esticando" a navbar. Deve exitir jeito melhor de resolver isso.
      //Coloca o width do 'carrosel' do celular fixo, no tamanho do mapa. 
      if (angular.element(window).width() < 768 && vm.firstUsage == undefined) {
        vm.firstUsage = true;
      }

      if (vm.idsListings.length) {
        Empreendimento.find({
          filter: {
            limit: 10,
            skip: 0,
            where: {
              or: vm.idsListings.slice(0, 10)
            }
          }
        }).$promise.then(
          function (succ) {
            var succ = succ.map(function (el) {                
                var o = Object.assign({}, el);
                o = createThumb.get(o);            
                var _width = (angular.element('.section-title').width() - 20);
                o.width = _width + 'px';
                o.height = 0.75 * _width + 'px';                  
                return o;
              })
            vm.filteredListings = succ;
            // stop double reload
            localStorage.setItem('loading', 0)
          })
      }
      //var scriptArray = [];
      // var scriptTag = angular.element("<script>");
      // scriptTag.attr("type", "application/ld+json");
      // scriptTag.attr("id", "jsonLd");
      // var jsonLd = '';

      // if (!vm.filteredListings[0].anything) {
      //     for (var x in vm.filteredListings) {
      //         if (x == 0) {
      //             if (vm.filteredListings[x].photos) {
      //                 if (vm.filteredListings[x].photos.length > 0) {
      //                     jsonLd = '[{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                         '"s:name":"' + vm.filteredListings[x].title + '","s:image":"' + SERVER_URL + 'api/storage/' + vm.filteredListings[x].photos[0].container + '/download/' + vm.filteredListings[x].photos[0].name + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //                 } else {
      //                     jsonLd = '[{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                         '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //                 }
      //             } else {
      //                 jsonLd = '[{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                     '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //             }
      //             scriptArray.push(jsonLd);
      //         } else {
      //             if (x < vm.filteredListings.length - 1) {
      //                 if (vm.filteredListings[x].photos) {
      //                     if (vm.filteredListings[x].photos.length > 0) {
      //                         jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                             '"s:name":"' + vm.filteredListings[x].title + '","s:image":"' + SERVER_URL + 'api/storage/' + vm.filteredListings[x].photos[0].container + '/download/' + vm.filteredListings[x].photos[0].name + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //                     } else {
      //                         jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                             '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //                     }
      //                 } else {
      //                     jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                         '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}},';
      //                 }
      //                 scriptArray.push(jsonLd);
      //             } else {
      //                 if (vm.filteredListings[x].photos) {
      //                     if (vm.filteredListings[x].photos.length > 0) {
      //                         jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                             '"s:name":"' + vm.filteredListings[x].title + '","s:image":"' + SERVER_URL + 'api/storage/' + vm.filteredListings[x].photos[0].container + '/download/' + vm.filteredListings[x].photos[0].name + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}}]';
      //                     } else {
      //                         jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                             '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}}]';
      //                     }
      //                 } else {
      //                     jsonLd = '{"@context": {"s": "http://schema.org/"},"@type": "s:Product",' +
      //                         '"s:name":"' + vm.filteredListings[x].title + '","s:description":"' + vm.filteredListings[x].additional_info + '","s:offers": {"s:priceCurrency": "BRL","s:price":"' + (vm.filteredListings[x].pricing.full / 30).toFixed(2) + '"}}]';
      //                 }
      //                 scriptArray.push(jsonLd);
      //             }
      //         }
      //     }

      //     scriptTag.append(scriptArray);
      //     angular.element('head').append(scriptTag);
      //}
    });

    $scope.$parent.$watch('vm.showFilter', function (newValue, oldValue) {
      vm.showFilter = newValue;
    }, true);

    vm.showListing = showListing;
    vm.highlight = highlight;
    vm.formatPrice = formatPrice;
    // vm.createThumb = createThumb;
    vm.makeUrl = makeUrl;
    vm.loadMore = loadMore;
    vm.teste = true;

    function formatPrice(n) {
      if (n != null) {
        return n.toFixed(0).replace(/./g, function (c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
        });
      }
    }

    function makeUrl(listing) {
      var urlPath = $location.$$url.split('?')[0];
      
      if(listing.construtora){
        var description = removeSpecialChar(listing.construtora._cdata) + '-' + removeSpecialChar(listing.nome._cdata);
      }else{
        var description = removeSpecialChar(listing.nome._cdata);
      }      
      return (urlPath + '/empreendimento/' + description + '/' + listing.id);
      //return ('/empreendimento/' + 'asdsadasdsadsasa' + '/' + listing.id);
    }

    // function createThumb(obj) {
    //     if (obj.Fotos == undefined) {
    //         return 'noPhotoUrl';
    //       } else if (obj.Fotos.Foto[0]) {
    //         return obj.Fotos.Foto[0].URLArquivo._text.split('=')[0] + "=w320-h240";
    //       } else if (obj.Fotos.Foto) {
    //         return obj.Fotos.Foto.URLArquivo._text.split('=')[0] + "=w320-h240";
    //       }
    // }

    function removeSpecialChar(str) {
      str = str.toLowerCase().replace(/[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-').replace(/\s/g, '-').replace(/---/g, '-').replace(/--/g, '-');
      var conversions = {};
      conversions['ae'] = 'ä|æ|ǽ';
      conversions['oe'] = 'ö|œ';
      conversions['ue'] = 'ü';
      conversions['Ae'] = 'Ä';
      conversions['Ue'] = 'Ü';
      conversions['Oe'] = 'Ö';
      conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ|Ẫ';
      conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ẫ|ª';
      conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
      conversions['c'] = 'ç|ć|ĉ|ċ|č';
      conversions['D'] = 'Ð|Ď|Đ';
      conversions['d'] = 'ð|ď|đ';
      conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
      conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
      conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
      conversions['g'] = 'ĝ|ğ|ġ|ģ';
      conversions['H'] = 'Ĥ|Ħ';
      conversions['h'] = 'ĥ|ħ';
      conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
      conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
      conversions['J'] = 'Ĵ';
      conversions['j'] = 'ĵ';
      conversions['K'] = 'Ķ';
      conversions['k'] = 'ķ';
      conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
      conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
      conversions['N'] = 'Ñ|Ń|Ņ|Ň';
      conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
      conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
      conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
      conversions['R'] = 'Ŕ|Ŗ|Ř';
      conversions['r'] = 'ŕ|ŗ|ř';
      conversions['S'] = 'Ś|Ŝ|Ş|Š';
      conversions['s'] = 'ś|ŝ|ş|š|ſ';
      conversions['T'] = 'Ţ|Ť|Ŧ';
      conversions['t'] = 'ţ|ť|ŧ';
      conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
      conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
      conversions['Y'] = 'Ý|Ÿ|Ŷ';
      conversions['y'] = 'ý|ÿ|ŷ';
      conversions['W'] = 'Ŵ';
      conversions['w'] = 'ŵ';
      conversions['Z'] = 'Ź|Ż|Ž';
      conversions['z'] = 'ź|ż|ž';
      conversions['AE'] = 'Æ|Ǽ';
      conversions['ss'] = 'ß';
      conversions['IJ'] = 'Ĳ';
      conversions['ij'] = 'ĳ';
      conversions['OE'] = 'Œ';
      conversions['f'] = 'ƒ';

      str = str.toLowerCase();
      str = str.replace(/\s/g, '_');
      // I removed hifen from list below
      str = str.replace(/[!"#$%&'()*+,./:;<=>?@[\]^`{|}~]/g, '');

      for (var i in conversions) {
        var re = new RegExp(conversions[i], "g");
        str = str.replace(re, i);
      }
      return str;
    };

    function showListing(listing) {
      if (listing.anything) {
        if (listing.title.indexOf('Crie') > -1) {
          // if (auth.isAuthenticated()) {
          //     $state.go('main.panel.createPanel.createListing.create1');
          // } else {
          //     $state.go('main.login.enter', {
          //         toPost: true
          //     });
          // }
        } else {
          var url = 'http://storage.cabemcasa.com.br/tem-cara-de-guardiao';
          window.open(url, "_blank");
        }

      } else {
        var _listing = listing;
        var _address = listing.Titulo; //_listing.address.street + '-' + _listing.address.neighborhood + '-' + _listing.address.city + '-' + _listing.address.state;
        _address = textFormatter.urlFormatter(_address);

        var _route = ('imovel');
        var url = $state.href('main.' + _route + '-sub', {
          id: _listing.id,
          dummy: _address
        });

        window.open(url, '_blank');
      }
    }

    function loadMore() {
      if (vm.idsListings.length > 10 && vm.teste && vm.idsListings.slice(vm.jump, vm.jump + 10).length > 0) {
        vm.teste = false;

        vm.jump += 10;

        Empreendimento.find({
          filter: {
            limit: 10,
            skip: 0,
            where: {
              or: vm.idsListings.slice(vm.jump - 10, vm.jump)
            }
          }
        }).$promise.then(function (succ) {
          vm.teste = true;
          if (succ.length > 0) {
              var succ = succ.map(function (el) {                
                var o = Object.assign({}, el);

                o = createThumb.get(o);            
                var _width = (angular.element('.section-title').width() - 20); 
                if(_width > 0){
                  localStorage.setItem('width-result',_width);         
                }else{
                  _width = localStorage.getItem('width-result');
                }     
                o.width = _width + 'px';
                o.height = 0.75 * _width + 'px';    


                return o;
              })
            vm.filteredListings = vm.filteredListings.concat(succ);
            localStorage.setItem('loading', 0);
          }
        })

      }

    }

    function highlight(e, listing) {
      var myMarkers = $scope.$parent.$$childHead.vm.myMarkers;
      var markers = $scope.$parent.$$childHead.vm.markers;
      var icon = {
        url: '../../assets/images/mark.png',
        size: e.type == 'mouseenter' ? new google.maps.Size(18, 35) : new google.maps.Size(18, 35),
        scaledSize: e.type == 'mouseenter' ? new google.maps.Size(18, 35) : new google.maps.Size(18, 35)
      };

      var label = {
        color: 'black',
        fontWeight: 'bold',
        //text: listing.title.slice(0, 20)
      };

      if (e.type == 'mouseenter') {
        for (var idx in markers) {
          if (listing.id == markers[idx].listing.id) {
            // icon.labelOrigin = new google.maps.Point(50, 25);
            myMarkers[idx].setIcon(icon);
            // myMarkers[idx].setLabel(label);
          }
        }
      } else {
        for (var idx in markers) {
          if (listing.id == markers[idx].listing.id) {
            // icon.labelOrigin = new google.maps.Point(50, 25);
            myMarkers[idx].setIcon(icon);
            // myMarkers[idx].setLabel(null);
          }
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .directive('resultSidebar', resultSidebar)
  // .filter('listingFilter', listingFilter);

  function resultSidebar() {
    var directive = {
      restrict: 'A',
      templateUrl: 'app/listing/sidebar/result-sidebar.html',
      controller: ResultSidebarController,
      controllerAs: 'vm',
      scope: {
        markers: '=',
        filters: '='
      },
      bindToController: true
    };
    return directive;
  }

  // ResultSidebarController.inject = ['$scope', '$state', '$timeout', '$document', '$window', 'SERVER_URL', 'textFormatter', 'Imovel', 'Empreendimento', '$stateParams', 'createThumb'];
  // function ResultSidebarController($scope, $state, SERVER_URL, Amenity, textFormatter, auth) {

  /** @ngInject */
  function ResultSidebarController($scope, $rootScope, $http, $state, $location, $timeout, $document, $window, SERVER_URL, textFormatter, Imovel, Empreendimento, $stateParams, createThumb, toastr) {

    var vm = this;
    vm.params = $stateParams
    vm.filteredListings = [{shimmer: true, fotos: []},{shimmer: true, fotos: []},{shimmer: true, fotos: []},{shimmer: true, fotos: []},{shimmer: true, fotos: []},{shimmer: true, fotos: []}];
    vm.idsListings = [];
    vm.jump = 0;
    vm.showComodidades = showComodidades;
    vm.createThumb = createThumb;

    vm.setFavorite = setFavorite;
    vm.unsetFavorite = unsetFavorite;
    vm.favorites = $window.localStorage.getItem('favorites') ? JSON.parse($window.localStorage.getItem('favorites')) : [];
    var configWL = $rootScope.ConfigWhiteLabel;
    vm.config_wl = configWL;
    vm.loading = true;
    vm.maxPages = 2;

    vm.tags = [];
    vm.relacionados = [];

    vm.customProperties = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 22
        },
        700: {
          items: 2,
          stagePadding: 25
        },
        980:{
          items: 1,
          stagePadding: 12
        },
        1240: {
          items: 2,
        },
        1380: {
          items: 3,
        }
      }
    }

    if(!!location.search.replace('?','')){
      var oldParams = localStorage.getItem('params_campain')
      var _full =( oldParams ? oldParams + '&' : '')  + location.search.replace('?','')
      var array = _full.split('&').reduce(function(ac,el) {
        var _split = el.split('=')
        if(_split && _split.length == 2){
          ac[_split[0]] = _split[1];        }
        return ac
      },{})
      localStorage.setItem('params_campain', $.param(array));
    }

    vm.getContainer = function () {
      if (angular.element(window).width() < 768) {
        return null;
      } else {
        return '.result-sidebar';
      }
    }

    $scope.$on('listingRefresh', function (event, obj) {
      vm.loading = true;
      vm._center = obj.params.center;
      $(window).scrollTop(0)
      if (obj.listings.length > 0) {
        vm.urlPage = $location.path();
        vm.idsListings = obj.listings.map(function (item) {
          return item.id
        });
        vm.maxPages = vm.idsListings.length / 10;
        angular.element('#jsonLd').remove();
        vm.jump = $stateParams.pagina > 1 ? $stateParams.pagina * 10 : 0;
        $stateParams.pagina = $stateParams.pagina || 1;
        var slicedListings = vm.idsListings.slice(vm.jump, vm.jump + 20);

        var _where = {
          id: { inq: slicedListings}
        };

        if($rootScope.finalidade) _where.fnl_id = $rootScope.finalidade;
        if (vm.idsListings.length) {
          Imovel.getImoveisNew({
            where: _where,
            center: obj.params.center,
            order: $rootScope.order ? $rootScope.order : null,
            tipovar: (vm.params.tipovar || vm.params.tipo1) ? (vm.params.tipovar || vm.params.tipo1) : null
          }).$promise.then(
            function (succ) {
              vm.loading = false;
              var succ = succ.map(function (el) {
                var o = Object.assign({}, el);
                o.tipovar = vm.params.tipovar || vm.params.tipo1
                return createThumb.get(o)
              })
              vm.filteredListings = succ;

              for (var i = 0; i < vm.filteredListings.length; i++) {
                for (var j = 0; j < vm.favorites.length; j++) {
                  if (vm.filteredListings[i].imv_cod_gaia == vm.favorites[j]) {
                    vm.filteredListings[i].isFavorite = true;
                  }
                }
              }

              vm.jump = 10;
              // setTimeout(function () {
              //   $('.carousel').on('slide.bs.carousel', function (ev) {
              //     var lazy;
              //     lazy = $(ev.relatedTarget).find('img');
              //     if(lazy.data('img')){
              //       lazy.attr("src",  lazy.data('img'));
              //       lazy.removeAttr('data-img');
              //     }
              //   })

              //   angular.element('.carousel').bcSwipe({ threshold: 50 });
              // }, 500);

            })
        }
      } else {
        vm.loading = false;
        vm.filteredListings = [];
        vm.idsListings = [];
        var _url = SERVER_URL + 'api/imoveis/relacionados/busca';
        $http.get(_url, {
          params: {
            center: obj.params.center,
            tipoimovel: obj.params.tipoimovel,
            tipovar: obj.params.tipovar,
          }
        })
        .then(function (result) {
          var _result = result.data;
          vm.tags = _result.tags;
          vm.relacionados = _result.imoveis;
        })
        .catch(function (error) {
          console.error(error.message);
        })

      }
    });
    $scope.$parent.$watch('vm.showFilter', function (newValue, oldValue) {
      vm.showFilter = newValue;
    }, true);

    vm.makeUrl = makeUrl;
    vm.formatPrice = formatPrice;
    vm.loadMore = loadMore;
    vm.teste = true;

    // $scope.$on('mapRefresh', function (event, coordinates) {
    //   localStorage.setItem('coordinates', JSON.stringify(coordinates));
    //   findListings(coordinates);
    // });

    function makeUrl(listing) {
      var urlPath = $location.$$url.split('?')[0].split('#')[0];      var description = textFormatter.removeSpecialChar(listing.imv_titulo)
      return (urlPath + '/imovel/' + description + '/' + listing.imv_cod_gaia);
    }

    function loadMore() {

      $('#page-loader').css({ 'display': 'none' });
      vm.urlPage = $location.path();
      if (vm.idsListings.length > 10 && vm.teste && vm.idsListings.slice(vm.jump, vm.jump + 10).length > 0) {

        $stateParams.pagina = $stateParams.pagina ? +$stateParams.pagina + 1 : 1;

        vm.jump = 10 * $stateParams.pagina;

        if (vm.idsListings.slice(vm.jump, vm.jump + 10).length > 0) {
          vm.teste = false;
          $('#page-loader').css({ 'display': 'flex' });
          Imovel.getImoveisNew({
            where: {
              id: { inq: vm.idsListings.slice(vm.jump, vm.jump + 10) }
            },
            center:vm._center,
            // order: vm.params.tipovar
            tipovar: (vm.params.tipovar || vm.params.tipo1) ? (vm.params.tipovar || vm.params.tipo1) : null,
            order: $rootScope.order ? $rootScope.order : null
          }).$promise.then(
            function (succ) {
              vm.teste = true;
              if (succ.length > 0) {
                var succ = succ.map(function (el) {
                  var o = Object.assign({}, el);
                  o.tipovar = vm.params.tipovar || vm.params.tipo1
                  return createThumb.get(o);
                })

                vm.filteredListings = vm.filteredListings.concat(succ);
                localStorage.setItem('loading', 0);

                for (var i = 0; i < vm.filteredListings.length; i++) {
                  for (var j = 0; j < vm.favorites.length; j++) {
                    if (vm.filteredListings[i].imv_cod_gaia == vm.favorites[j]) {
                      vm.filteredListings[i].isFavorite = true;
                    }
                  }
                }

                // setTimeout(function () {
                //   $('.carousel').on('slide.bs.carousel', function (ev) {
                //     var lazy;
                //     lazy = $(ev.relatedTarget).find('img');
                //     if(lazy.data('img')){
                //       lazy.attr("src",  lazy.data('img'));
                //       lazy.removeAttr('data-img');
                //     }
                //     // lazy.css("background-image", "url( " + lazy.data('img') + ")");
                //     // lazy.removeAttr('data-img');
                //   })

                //   angular.element('.carousel').bcSwipe({ threshold: 50 });
                // }, 500);
              }

              $('#page-loader').css({ 'display': 'none' });

              $state.transitionTo($state.current.name, $stateParams, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: false
              });
            })
        }
      }

    }

    function formatPrice(n) {
      if (n != null) {
        n = parseFloat(n, 10);
        return n.toFixed(0).replace(/./g, function (c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
        });
      }
    }

    function showComodidades(subtipo, grupoComodidades) {
      // Sobrado / Casa / Chácara / Pousada
      if (grupoComodidades == 1 && (subtipo == 2 || subtipo == 3 || subtipo == 4 || subtipo == 12 || subtipo == 15 || subtipo == 19 || subtipo == 21)) {
        return true;
      }
      //Apartamento / Duplex / Triplex / Kitnet / Cobertura
      else if (grupoComodidades == 2 && (subtipo == 1 || subtipo == 8 || subtipo == 10 || subtipo == 13 || subtipo == 14 || subtipo == 16 || subtipo == 17 || subtipo == 18 || subtipo == 23 || subtipo == 29 || subtipo == 30 || subtipo == 31 || subtipo == 32 || subtipo == 33 || subtipo == 34)) {
        return true;
      }
      //Sala / Loja
      else if (grupoComodidades == 3 && (subtipo == 7 || subtipo == 11 || subtipo == 20 || subtipo == 22 || subtipo == 24 || subtipo == 25 || subtipo == 26 || subtipo == 27)) {
        return true;
      }
      //Barracão / Loteamento
      else if (grupoComodidades == 4 && (subtipo == 6)) {
        return true;
      }
      //Terreno
      else if (grupoComodidades == 5 && (subtipo == 5 || subtipo == 9 || subtipo == 28)) {
        return true;
      }
      // Default
      else if (grupoComodidades == 6) {
        return true;
      }
      return false;
    }

    function setFavorite(imovel) {
      if (vm.favorites == null || vm.favorites.length == 0) {
        vm.favorites = [imovel.imv_cod_gaia];
      }
      else {
        vm.favorites.push(imovel.imv_cod_gaia);
      }

      $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
      imovel.isFavorite = true;
      toastr.info('<strong>Imóvel salvo nos favoritos.</strong>', {
        iconClass: 'toast-arbo'
      });
    }

    function unsetFavorite(imovel) {
      var index = vm.favorites.indexOf(imovel.imv_cod_gaia);

      if (index !== -1) {
        vm.favorites.splice(index, 1);
        $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
        imovel.isFavorite = false;
      }
      toastr.info('<strong>Imóvel retirado dos favoritos.</strong>', {
        iconClass: 'toast-arbo'
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('arboWeb')
        .service('webDevTec', webDevTec);

    /** @ngInject */
    function webDevTec() {
        var data = [{
                'title': 'AngularJS',
                'url': 'https://angularjs.org/',
                'description': 'HTML enhanced for web apps!',
                'logo': 'angular.png'
            },
            {
                'title': 'BrowserSync',
                'url': 'http://browsersync.io/',
                'description': 'Time-saving synchronised browser testing.',
                'logo': 'browsersync.png'
            },
            {
                'title': 'GulpJS',
                'url': 'http://gulpjs.com/',
                'description': 'The streaming build system.',
                'logo': 'gulp.png'
            },
            {
                'title': 'Jasmine',
                'url': 'http://jasmine.github.io/',
                'description': 'Behavior-Driven JavaScript.',
                'logo': 'jasmine.png'
            },
            {
                'title': 'Karma',
                'url': 'http://karma-runner.github.io/',
                'description': 'Spectacular Test Runner for JavaScript.',
                'logo': 'karma.png'
            },
            {
                'title': 'Protractor',
                'url': 'https://github.com/angular/protractor',
                'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
                'logo': 'protractor.png'
            },
            {
                'title': 'Bootstrap',
                'url': 'http://getbootstrap.com/',
                'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
                'logo': 'bootstrap.png'
            },
            {
                'title': 'Angular UI Bootstrap',
                'url': 'http://angular-ui.github.io/bootstrap/',
                'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
                'logo': 'ui-bootstrap.png'
            },
            {
                'title': 'Sass (Node)',
                'url': 'https://github.com/sass/node-sass',
                'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
                'logo': 'node-sass.png'
            }
        ];

        this.getTec = getTec;

        function getTec() {
            return data;
        }
    }

})();
(function () {
	'use strict';

	angular.module('arboWeb').controller('viewRegisterController', viewRegisterController);

	/** @ngInject */
	function viewRegisterController($state, $q, toastr, $rootScope, $stateParams, textFormatter, auth, swangular, seoService, $location) {
		var vm = this;
		vm.config_wl = $rootScope.ConfigWhiteLabel;
		vm.checkRegister = checkRegister;
		function checkRegister() {
			if (auth.isAuthenticated()) {
				$stateParams.new = true;

				$state.go('main.painel.typeform-1', $stateParams, {reload: true});
			} else {
				$rootScope._url = true;
				swangular.open({
					animation: false,
					showCloseButton: true,
					showConfirmButton: false,
					html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-register-form.html\'"></div>',
					controllerAs: 'vm',
					controller: 'RegisterController',
				});
			}
		}

		seoService.generateTags({
			title: 'Cadastre seu Imovel - ' + (vm.config_wl.nome || 'Arbo imóveis'),
			description: 'Anuncie seu Imóvel na ' + vm.config_wl.nome,
			image: vm.config_wl.url_logo_bg_escura,
			slug: $location.absUrl(),
		});

		function checkDataFromURL ($stateParams) {

			if (!vm.config_wl.isArbo) return false;

			// * Se a URL não possuir corretor nem imobiliaria, redireciona para HOMEPAGE
			return (!$stateParams.i || !$stateParams.ii);
		}

		function init() {

			var checkData = checkDataFromURL($stateParams);

			if (checkData) $state.go('main.home');

			if ($stateParams.i && (!localStorage.getItem('corretor') || localStorage.getItem('corretor') != $stateParams.i)) {
				localStorage.setItem('corretor', $stateParams.i);
			}
			if ($stateParams.ii && (!localStorage.getItem('ii') || localStorage.getItem('ii') != $stateParams.ii)) {
				localStorage.setItem('ii', $stateParams.ii);
			}
		}
		init();
	}
})();

(function () {
  'use strict';

  angular.module('arboWeb')
    .controller('viewCreciController', viewCreciController);

  /** @ngInject */
  function viewCreciController($state, $q, toastr, $rootScope, textFormatter, createThumb, Imobiliaria) {
    var vm = this;
    vm.config_wl = $rootScope.ConfigWhiteLabel
    function init(){

      Imobiliaria.getImobiliaria({},
        function (res) {
          // console.log(res);
          vm.imobiliarias = res;
          
        })

    }
    init();
  }

})();
(function() {
    'use strict';

    angular
        .module('arboWeb')
        .directive('usernameFormatter', usernameFormatter);

    function usernameFormatter() {
        var directive = {
            require: 'ngModel',
            link: function(scope, element, attr, ngModelCtrl) {
                ngModelCtrl.$parsers.push(fromUser);

                function fromUser(text) {
                    if (text) {
                        if ((text.match(/_/g) || []).length > 1) {
                            var transformedInput = text.replace(/_\s*$/, "");
                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        } else {
                            var transformedInput = text.replace(/[^a-z_]/g, '');
                            transformedInput = transformedInput.replace(/[a-z_]{17}$/g, transformedInput.slice(0, -1));
                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        }
                    }
                }
            },
        };
        return directive;
    }
})();
(function () {
	'use strict';

	angular.module('arboWeb').directive('ratingStars', ratingStars);

	/*
	 * Directive
	 */
	ratingStars.$inject = [];

	function ratingStars() {
		var directive = {
			require: '?ngModel',
			restrict: 'E',
			templateUrl: 'app/components/stars-rate/starts.html',
			scope: {
				ratings: '<',
				averageRating: '<',
        ratingsPosition: '@',
        placeId: '=',
			},
			link: link,
			controller: angular.noop,
			controllerAs: 'vm',
			bindToController: true,
		};

		return directive;

		function link(scope, element, attrs, ngModel) {
			var vm = scope.vm;
			var myRating = null;
			var i = 0;

			// console.log(ngModel);
			vm.stars = [];
			for (i = 0; i < vm.ratings; i++) {
				vm.stars.push(i + 1);
			}
			// Bind data
			vm.mutable = false;

			// Bind functions
			vm.getClass = getClass;
			vm.mouseover = mouseover;
			vm.mouseout = mouseout;
			vm.click = click;

			// Initialise
			init();

			/*
			 * Private functions
			 */
			function init() {
				vm.mutable = !!ngModel;

				if (ngModel) {
					ngModel.$render = function () {
						vm._start = Math.floor(ngModel.$modelValue);
            vm._porcent = Math.floor((Number(ngModel.$modelValue) - vm._start) * 100);
            if(!vm.placeId) vm.placeId = 'place' + Math.floor(Math.random(1,100))
            // console.log(vm)
						myRating = ngModel.$viewValue;
					};
				}
			}

			/*
			 * Public functions
			 */
			function getClass(num) {
        var meio = ((num - myRating) > 0 &&  (num - myRating) < 1)
				return {
          'star': !meio,
          'hover': !meio,
          'fa': !meio,
          'fas': meio,
          'fa-star-half-alt': meio,
          on: vm.averageRating >= num || myRating >= num,
					'on-half': vm.averageRating > myRating && vm.averageRating < num && vm.averageRating >= num - 0.75,
					my: myRating >= num,
				};
			}

			function mouseover(rating) {
				if (ngModel) {
					myRating = rating;
				}
			}

			function mouseout() {
				if (ngModel) {
					myRating = ngModel.$viewValue;
				}
			}

			function click() {
				if (ngModel) {
					ngModel.$setViewValue(myRating);
				}
			}
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .directive('onErrorSrc', function($sce) {
      return {
        link: function(scope, element, attrs) {
          element.bind('error', function() {
            if ((/\.(jpg|jpeg|png)$/i).test(this.src) && this.src != attrs.onErrorSrc) {
              if(element.parent().data('src')){
                element.parent().data('src', attrs.onErrorSrc);
                element.parent().attr('data-src', attrs.onErrorSrc);
              };
              attrs.$set('src', attrs.onErrorSrc);
            }
          });
        }
      }
    })
    .service('createThumb', function ($rootScope, URL_CDN, URL_BUCKET) {
      var vm = this;
      const url_cdn = URL_CDN;
      const bucket = URL_BUCKET;
      vm.get = function (data) {
        var configWL = $rootScope.ConfigWhiteLabel;

        var imv = angular.copy(data)
        imv['imgThumb'] = [];
        imv['imgFull'] = [];
        imv.imobiliaria = imv.imobiliaria || {};
        imv.imobiliaria.imb_config_site = imv.imobiliaria.imb_config_site ? imv.imobiliaria.imb_config_site : {};
        imv.fotos = imv.fotos ? imv.fotos : [];

        imv.fotos.forEach(function (foto) {

          var src = '';
          var urlPhotoFull = (configWL.imb_config_site.watermark || imv.imobiliaria.imb_config_site.watermark) ? (foto.imvft_watermark || foto.imvft_url) : foto.imvft_url
          var urlArray = (urlPhotoFull || '').replace(/http(s?):\/\//, '').split('/');
          var fileName = urlArray.pop();
          // urlArray.push('320x240')
          // urlArray.push(encodeURIComponent(fileName))
          src = 'https://' + urlArray.concat(['320x240', encodeURIComponent(fileName)]).join('/');

          imv['imgThumb'].push({
            'imvft_url': vm.changeToCdn(src),
            'tipo_foto' : (foto.tipo_foto ? foto.tipo_foto : null)
          });

          src = 'https://' + urlArray.concat([encodeURIComponent(fileName)]).join('/');

          imv['imgFull'].push({
            'imvft_url': vm.changeToCdn(src),
            'tipo_foto' : (foto.tipo_foto ? foto.tipo_foto : null)
          });
        });

        return imv;
      };

      vm.get640 = function (data) {
      var configWL = $rootScope.ConfigWhiteLabel;

        var imv = angular.copy(data)
        imv['imgThumb640'] = [];
        imv.imobiliaria = imv.imobiliaria || {};
        imv.imobiliaria.imb_config_site = imv.imobiliaria.imb_config_site ? imv.imobiliaria.imb_config_site : {};
        imv.fotos.forEach(function (foto) {

          var src = '';
          var urlPhotoFull = (configWL.imb_config_site.watermark || imv.imobiliaria.imb_config_site.watermark) ? (foto.imvft_watermark || foto.imvft_url) : foto.imvft_url
          var urlArray = (urlPhotoFull || '').replace(/http(s?):\/\//, '').split('/');
          var fileName = urlArray.pop();
          urlArray.push('640x480')
          urlArray.push(encodeURIComponent(fileName))
          src = 'https://' + urlArray.join('/');
          imv['imgThumb640'].push({
            'imvft_url': vm.changeToCdn(src),
            'tipo_foto' : (foto.tipo_foto ? foto.tipo_foto : null)
          });
        });

        return imv;
      };

      vm.getWmk = function(img){
        if(!img.includes('_watermark.')){
          var extensionFile   = (img ? img.split('.') : []).pop();
          return extensionFile ? img.replace('.'+extensionFile, '_watermark.'+extensionFile) : img;
        }else{
          return img
        }
      }

      vm.singleThumbUrl = function(url){
        if(!url) return ''
        var urlArray = (url || '').replace(/http(s?):\/\//, '').split('/');
        var fileName = urlArray.pop();
        // urlArray.push('320x240')
        // urlArray.push(encodeURIComponent(fileName))
        return 'https://' + urlArray.concat(['320x240', encodeURIComponent(fileName)]).join('/');
      }

      vm.removeWmk = function(img){
        return img.replace('_watermark.', '.');
      }

      vm.changeToCdn = function (url) {
        if(!$rootScope.botreq){
          return url ? url.replace(bucket, url_cdn) : '';
        }else{
          return url
        }
      };

    });


})();

(function() {
    'use strict';

    angular
        .module('arboWeb')
        .directive('element', function($interval, $window) {
            return {
                restrict: 'E',
                link: function(scope, element) {
                    $window.addEventListener('resize', function() {
                        element.css('height', window.innerHeight);
                    }, false);
                },
            };
        });

})();
(function () {
	'use strict';

	angular.module('arboWeb')
		.controller('quemSomosController', quemSomosController);

	quemSomosController.inject = ['$scope', '$state'];

	/** @ngInject */
	function quemSomosController($state, toastr, textFormatter) {
		var vm = this;
		var params = {};
		var autocomplete = null;
		vm.menu = 0;
		vm.placeholder = '';
		vm.changeMenu = changeMenu;
		vm.search = search;
		vm.autoComplete = autoComplete;

		vm.idBg = Math.floor(Math.random()*6 + 1);

		function search() {
			if(vm.busca !== undefined && vm.busca != ''){
				// Associação
				// var hash = atob('malara');
				// params.hash = hash;
				var search = angular.element('#input-city').val().toLowerCase();
				search = search.toLowerCase().replace(/ - /g, '-');
				search = search.replace(/,/g, '');
				search = search.replace(/ /g, '-');

				switch (vm.menu) {
					case 1:

					case 2:
						params.cidade = search;

						if(vm.tipo !== undefined && vm.tipo !== null && vm.tipo != ''){
							params.tipoimovel = vm.tipo.toLowerCase();
							params.tipo = (vm.menu == 1) ? 'a-venda' :'para-alugar';
							$state.go('main.search-address-ad-build-type', params);
						}else{
							params.tipovar = (vm.menu == 1) ? 'a-venda' :'para-alugar';
							$state.go('main.search-address-ad-type', params);
						}
						break;
					case 3:
						if (vm.busca !== undefined) {
							$state.go('main.search-lancamentos-address', { cidade: search });
						} else {
							$state.go('main.search-lancamentos');
						}
						break;
					case 4:

						break;
					default:
						break;
				}
			}else{
				toastr.warning('Digite uma cidade');
			}
		}

		function autoComplete() {
			if (vm.menu != 4) {
				var input = document.querySelector('#input-city');
				var autoCompleteOpcoes = {
          sessionToken: '1234567890',
					componentRestrictions: {
            country: 'BR'
          }
        }
        debugger;
				autocomplete = new google.maps.places.Autocomplete(input, autoCompleteOpcoes);
			}
		}

		function changeMenu(data) {
			vm.menu = data;
			switch (data) {
				case 1:

				case 2:
					vm.placeholder = 'Digite condominio, região, bairro ou cidade';
					break;
				case 3:
					vm.tipo = null;
					vm.placeholder = 'Digite região, bairro ou cidade';
					break;
				case 4:
					vm.tipo = null;
					vm.busca = '';
					vm.placeholder = 'Ex: CA0123';
					break;
				default:
					vm.placeholder = 'Digite condominio, região, bairro ou cidade';
					break;
			}
		}
		changeMenu(1);

	}
})();

(function() {
    'use strict';

    angular
        .module('arboWeb')
        .directive('panelHeader', panelHeaderMain);

    /** @ngInject */
    function panelHeaderMain() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/panelHeader/panel-header.html',
            scope: {},
            controller: PanelHeaderController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        PanelHeaderController.inject = ['$state', '$timeout', '$rootScope', 'auth', 'toastr', 'toastrConfig', 'UserModel'];

        /** @ngInject */
        function PanelHeaderController($state, $timeout, $rootScope, auth, toastr, toastrConfig, UserModel) {
            var vm = this;

            vm.user = auth.getUser();

            $rootScope.$on('isGuardian', function(event, data) {
                //vm.user = auth.getUser();
                refreshMenu();
                angular.extend(toastrConfig, {
                    autoDismiss: false,
                    containerId: 'toast-container',
                    maxOpened: 1,
                    newestOnTop: true,
                    positionClass: 'toast-top-right',
                    preventDuplicates: false,
                    preventOpenDuplicates: true,
                    progressBar: false,
                    target: 'body'
                });
                toastr.success('Parabéns, ' + vm.user.first_name + '!!! Sua análise foi concluida e agora você é um Guardião! :D');
            })

            $rootScope.$on('hasSubmitted', function(event, data) {
                //vm.user = auth.getUser();
                refreshMenu();
            })

            refreshMenu();

            function refreshMenu() {
                UserModel.findById({
                    id: auth.getCurrentUserId()
                }, function(success) {
                    vm.user = success;
                    if (vm.user) {
                        if (vm.user.cpf) {
                            if (vm.user.is_guardian || vm.user.has_submitted_guardian) {
                                vm.tabs = [{
                                        title: 'MEUS ANÚNCIOS',
                                        sref: "main.panel.avatarPanel.listings"
                                    },
                                    {
                                        title: 'MINHAS RESERVAS',
                                        sref: "main.panel.avatarPanel.reservations"
                                    },
                                    // {
                                    //   title: 'CAIXA DE ENTRADA',
                                    //   sref: "main.panel.avatarPanel.mail"
                                    // },
                                    {
                                        title: 'CARTEIRA',
                                        sref: "main.panel.avatarPanel.wallet"
                                    },
                                    // {
                                    //   title: 'FAVORITOS',
                                    //   sref: "main.panel.avatarPanel.favorites"
                                    // },
                                    {
                                        title: 'PERFIL',
                                        sref: "main.panel.avatarPanel.profile"
                                    }
                                ]

                                vm.colsNumber = vm.tabs.length;
                            } else {
                                vm.tabs = [{
                                        title: 'MEUS ANÚNCIOS',
                                        sref: "main.panel.avatarPanel.listings"
                                    },
                                    {
                                        title: 'MINHAS RESERVAS',
                                        sref: "main.panel.avatarPanel.reservations"
                                    },
                                    // {
                                    //   title: 'CAIXA DE ENTRADA',
                                    //   sref: "main.panel.avatarPanel.mail"
                                    // },
                                    {
                                        title: 'CARTEIRA',
                                        sref: "main.panel.avatarPanel.wallet"
                                    },
                                    // {
                                    //   title: 'FAVORITOS',
                                    //   sref: "main.panel.avatarPanel.favorites"
                                    // },
                                    {
                                        title: 'PERFIL',
                                        sref: "main.panel.avatarPanel.profile"
                                    },
                                    {
                                        title: 'SEJA UM GUARDIÃO',
                                        sref: "main.panel.avatarPanel.registerGuardian.part1"
                                    }
                                ]
                            }
                        } else {
                            if (vm.user.is_guardian || vm.user.has_submitted_guardian) {
                                vm.tabs = [{
                                        title: 'MEUS ANÚNCIOS',
                                        sref: "main.panel.avatarPanel.listings"
                                    },
                                    {
                                        title: 'MINHAS RESERVAS',
                                        sref: "main.panel.avatarPanel.reservations"
                                    },
                                    // {
                                    //   title: 'CAIXA DE ENTRADA',
                                    //   sref: "main.panel.avatarPanel.mail"
                                    // },
                                    {
                                        title: 'CARTEIRA',
                                        sref: "main.panel.avatarPanel.wallet"
                                    },
                                    // {
                                    //   title: 'FAVORITOS',
                                    //   sref: "main.panel.avatarPanel.favorites"
                                    // },
                                    {
                                        title: 'PERFIL',
                                        sref: "main.panel.avatarPanel.profile"
                                    }
                                ]
                            } else {
                                vm.tabs = [{
                                        title: 'MEUS ANÚNCIOS',
                                        sref: "main.panel.avatarPanel.listings"
                                    },
                                    {
                                        title: 'MINHAS RESERVAS',
                                        sref: "main.panel.avatarPanel.reservations"
                                    },
                                    // {
                                    //   title: 'CAIXA DE ENTRADA',
                                    //   sref: "main.panel.avatarPanel.mail"
                                    // },
                                    // {
                                    //   title: 'CARTEIRA',
                                    //   sref: "main.panel.avatarPanel.wallet"
                                    // },
                                    // {
                                    //   title: 'FAVORITOS',
                                    //   sref: "main.panel.avatarPanel.favorites"
                                    // },
                                    {
                                        title: 'PERFIL',
                                        sref: "main.panel.avatarPanel.profile"
                                    },
                                    {
                                        title: 'SEJA UM GUARDIÃO',
                                        sref: "main.panel.avatarPanel.registerGuardian.part1"
                                    }
                                ]
                            }
                        }

                        vm.colsNumber = vm.tabs.length;
                        vm.colValue = 12 / vm.colsNumber;
                        vm.myColClass = "col-md-" + vm.colValue + " col-sm-" + vm.colValue + " col-xs-" + vm.colValue;
                    } else {
                        $state.go('main.login.enter');
                    }

                    if ($state.name == 'main.panel.createPanel.createListing.create1') {
                        $timeout(function() {
                            angular.element(document.querySelector('#tab5')).addClass('active');
                        });
                    }
                }, function(error) {
                    console.error(error);
                });
            }

        }
    }

})();
(function() {
  'use strict';

  angular
      .module('arboWeb')
      .controller('TermsUseController', TermsUseController);

  /** @ngInject */
  function TermsUseController($scope, $rootScope) {
      var vm = this;
      vm.redirectToTermsPage = false;
      vm.config_wl = $rootScope.ConfigWhiteLabel;
      vm.dateupdate = moment(vm.config_wl.configwl["TERMOS-DE-USO_update"]).format("DD/MM/YYYY - HH:MM:ss");

      if(vm.config_wl.isArbo || !vm.config_wl.configwl['TERMOS-DE-USO']){
        vm.redirectToTermsPage = true;
        window.location = 'https://transparencia.arboimoveis.com.br/termos/termos-de-servico/termo-de-uso.pdf'
      }
  }
})();

(function () {
	'use strict';

	angular.module('arboWeb').controller('PrivacyPolicyController', PrivacyPolicyController);

	/** @ngInject */
	function PrivacyPolicyController($scope, $rootScope, $http) {
		var vm = this;
		vm.config_wl = $rootScope.ConfigWhiteLabel;
		vm.dateupdate = moment(vm.config_wl.configwl['POLITICA-PRIVACIDADE_update']).format('DD/MM/YYYY - HH:MM:ss');

		if (vm.config_wl.isArbo) {
      // fetch in one trust
			$http.get('https://privacyportal-eu-cdn.onetrust.com/f5920dee-6368-4b3a-b747-a5b1d48f8487/privacy-notices/ef9855fb-a1a8-423d-a633-5353d3981de8-pt-br.json').then(function (res) {
        if(res.data.notices){
          var label = Object.keys(res.data.notices)[0]
          vm.config_wl.content = res.data.notices[label].content
          vm.dateupdate =  moment(new Date(res.data.notices[label].timestamp)).format('DD/MM/YYYY - HH:MM:ss');
        }
      });
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('arboWeb')
        .directive('onlyNumbers', onlyNumbers);

    function onlyNumbers() {
        var directive = {
            require: 'ngModel',
            link: function(scope, element, attr, ngModelCtrl) {
                ngModelCtrl.$parsers.push(fromUser);

                function fromUser(text) {
                    if (text) {
                        if ((text.match(/,/g) || []).length > 1) {
                            var transformedInput = text.replace(/,\s*$/, "");
                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        } else {
                            var transformedInput = text.replace(/[^0-9,]/g, '');
                            if (transformedInput !== text) {
                                ngModelCtrl.$setViewValue(transformedInput);
                                ngModelCtrl.$render();
                            }
                            return transformedInput;
                        }
                    }
                }
            },
        };
        return directive;
    }
})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('NPSCorretorController', NPSCorretorController)

  /** @ngInject */
  function NPSCorretorController($scope, $rootScope, $location, $state, $stateParams, SERVER_URL, $http, dataLead, seoService) {
    var vm = this;

    // console.log(dataLead);
    vm.loaderSearch = false;
    vm.formData = {
      send: $stateParams.send || false,
      corretor: $stateParams.corretor,
      stars: $stateParams.nota || $stateParams.na || null,
    }

    vm.sendNext = function (e, form) {
      e.preventDefault();
      if (!form.$valid) return;

      vm.loaderSearch = true;

      var obj = atob(atob($stateParams.lead))
      try {
        obj = JSON.parse(obj);
      } catch (error) {
        obj = {}
      }

      $http({
        method: 'POST',
        url: SERVER_URL + 'api/avaliarcorretor/avaliacao',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          obs:    vm.formData.obs,
          stars:  vm.formData.stars,
          email:  $stateParams.email,
          lead:   obj.id,
          crt:    obj.crt,
        }
      })
      .then(function (succ) {
        $stateParams.send = true;
        $state.transitionTo($state.current.name, $stateParams);
      })
      .catch(function (err) {
        vm.formData.errorsend = true;
      })
      .finally(function(){
        vm.loaderSearch = false;
      })
    }

    seoService.generateTags({
      title: 'Avaliação do seu corretor',
      slug: $location.absUrl(),
      noindex: true
    })
  }
})();

(function () {
    'use strict';

    angular
        .module('arboWeb')
        .directive('ngThumb', ['$window', function ($window) {
            var helper = {
                support: !!($window.FileReader && $window.CanvasRenderingContext2D),
                isFile: function (item) {
                    return angular.isObject(item) && item instanceof $window.File;
                },
                isImage: function (file) {
                    var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                    return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
                }
            };

            return {
                restrict: 'A',
                template: '<canvas/>',
                link: function (scope, element, attributes) {
                    if (!helper.support) return;

                    var params = scope.$eval(attributes.ngThumb);

                    if (!helper.isFile(params.file)) return;
                    // if (!helper.isImage(params.file)) return;

                    var canvas = element.find('canvas');
                    !($(canvas).hasClass('upload-foto')) ? $(canvas).addClass('upload-foto') : null;
                    var reader = new FileReader();

                    reader.onload = onLoadFile;
                    reader.readAsDataURL(params.file);

                    function onLoadFile(event) {
                        var img = new Image();
                        img.onload = onLoadImage;
                        img.src = event.target.result;
                    }

                    function onLoadImage() {
                        var width = params.width || this.width / this.height * params.height;
                        var height = params.height || this.height / this.width * params.width;
                        canvas.attr({ width: width, height: height });
                        canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);
                    }
                }
            };
        }]);
})();
(function () {
  'use strict';

  angular.module('arboWeb')
    .controller('newPassword', newPassword);

  /** @ngInject */
  function newPassword($state, $q, $location, toastr, $rootScope, textFormatter, createThumb, Imovel, Usuario, swangular) {
    var vm = this;

    vm.newPwd = '';
    vm.newPwdConf = '';
    vm.accessToken = '';
    vm.difPwd = false;

    vm.send = send;
    
    function activate() {
      if($location.search().access_token){
        vm.accessToken = $location.search().access_token;
      }else{
        $state.go('main.home');
      }
    }
    
    function send() {
      Usuario.resetPasswordAction({
        password: vm.newPwd,
        confirmation: vm.newPwd,
        accessToken: vm.accessToken
      },
      function success(data) {
        swangular.swal({
          animation: false,
          title: 'Senha alterada com sucesso',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 1500
        })

        setTimeout(function(){
          $state.go('main.home');
        }, 2000)
      },
      function error(data) {
        swangular.swal({
          type:'error',
          animation: false,
          title: 'Ocorreu um erro ao alterar a senha!',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 1500
        })
      });
    }
    activate();

  }
})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('RegisterController', RegisterController)
    .controller('LoginController', LoginController)
    .controller('ForgotController', ForgotController);

  /** @ngInject */
  function RegisterController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    Usuario,
    auth,
    $timeout,
    swangular
  ) {
    var vm = this;

    vm.config_wl = $rootScope.ConfigWhiteLabel;
    vm.form = {
      telefones: {},
    };
    vm.form.name = ($stateParams.nome || '').split(' ')[0];
    vm.form.lastname = ($stateParams.nome || '').split(' ')[1];
    vm.form.telefones['numero'] = $stateParams.telefone;
    vm.form.email = $stateParams.email;

    vm.showpassword = function () {
      if ($scope.inputType == 'password') $scope.inputType = 'text';
      else $scope.inputType = 'password';
    };

    $timeout(function () {
      // console.log('fez o doc ready');
      // debugger;
      $scope.inputType = 'password';

      $('input').click(function () {
        var scroll = $(window).scrollTop();
        var amount = scroll == 0 ? +1 : -1;
        $(window).scrollTop(amount);
      });

      $('.telefone').focusin(function () {
        $('.newtooltip').removeClass('d-none');
      });

      $('.telefone').focusout(function () {
        $('.newtooltip').addClass('d-none');
      });

      $('.senha').focusin(function () {
        $('.newtooltipsenha').removeClass('d-none');
      });

      $('.senha').focusout(function () {
        $('.newtooltipsenha').addClass('d-none');
      });
    }, 300);

    vm.sendNext = function (e, form) {
      e.preventDefault();
      e.stopPropagation();

      if (form && !form.$valid) {
        vm.novalid = true;
        debugger;
      } else {
        $rootScope.loadingModal.start('Salvando dados');
        Usuario.createUserWeb(vm.form).$promise.then(
          function (succ) {
            //throw 'Caso 2';
            auth
              .login({
                email: vm.form.email.toLowerCase(),
                password: vm.form.password,
              })
              .$promise.then(
                function (succ) {
                  //throw 'Caso 1';
                  var url = $rootScope._url
                    ? 'main.painel.typeform-1'
                    : $state.current.name;
                  vm.user = auth.getUser();
                  $rootScope._url = false;

                  swangular.close();
                  $rootScope.loadingModal.stop();

                  $state.go(url, {}, { reload: true });
                },
                function (err) {
                  $rootScope.loadingModal.stop();

                  swangular.open({
                    animation: true,
                    title: 'Legal!',
                    text: 'Seu cadastro está completo. Faça login para ter acesso ao seu perfil e painel gerencial.',
                    showCancelButton: false,
                    confirmButtonText: 'Ok, entendi.',
                  });

                  console.log(err);
                }
              );
          },
          function (err) {
            $rootScope.loadingModal.stop();

            if (err.status == 422) {
              swangular.open({
                animation: true,
                title: 'Erro ao efetuar o cadastro!',
                text: 'E-mail duplicado, por favor efetue o cadastro utilizando um e-mail diferente.',
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok, entendi.',
              });
            } else {
              swangular.open({
                animation: true,
                title: 'Algo deu errado.',
                text: 'Aconteceu um erro inesperado e seu cadastro não foi completado. Por favor, tente novamente.',
                type: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok, entendi.',
              });
            }

            console.log(err);
            vm.error = true;
          }
        );
      }
    };

    vm.openModalLogin = function (e) {
      e.preventDefault();
      swangular.close();

      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-login.html\'"></div>',
        controllerAs: 'vm',
        controller: 'LoginController',
      });
    };

    vm.gotologin = function (e) {
      e.preventDefault();
      $state.go('main.login-anuncio', $stateParams);
    };
  }

  /** @ngInject */
  function ForgotController(
    $scope,
    $rootScope,
    $state,
    Usuario,
    $location,
    auth,
    swangular
  ) {
    var vm = this;

    vm.form = {};

    vm.sendNext = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var url = location.host;
      Usuario.resetPassword({ email: vm.form.email, host: url }).$promise.then(
        function (succ) {
          vm.form.alert = {
            status: 'success',
            msg: 'O link foi enviado para o seu email !',
          };
        },
        function (err) {
          console.log(err);
          vm.form.alert = {
            status: 'danger',
            msg: 'Verifique se você cadastrou esse email em nosso sistema !',
          };
        }
      );
    };

    // vm.sendRegister = function(){
    //   // Aqui passa os registros para outro Model
    //   $uibModalInstance.dismiss('success');
    //   setTimeout(function(){
    //     openModalRegister();
    //   }, 500)
    // }

    // vm.sendForgot = function(){
    //   // Aqui passa os registros para outro Model
    //   $uibModalInstance.dismiss('success');
    //   setTimeout(function(){
    //     openModalRegister();
    //   }, 500)
    // }

    // $rootScope.closeModal = function(){
    //   $uibModalInstance.dismiss('cancel');
    // }
  }

  /** @ngInject */
  function LoginController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    auth,
    swangular
  ) {
    var vm = this;

    vm.form = {};
    vm.form.email = $stateParams.email;

    vm.sendNext = function (e, modallogin) {
      e.preventDefault();
      e.stopPropagation();

      auth.login(vm.form).$promise.then(
        function (succ) {
          var url = $rootScope._url
            ? 'main.painel.typeform-1'
            : $state.current.name;
          vm.user = auth.getUser();
          $rootScope._url = false;

          swangular.close();
          $state.go(url, {}, { reload: true });
        },
        function (err) {
          console.log(err);
          vm.error = true;
        }
      );
    };

    vm.gotoregister = function (e) {
      e.preventDefault();
      $state.go('main.registro-anuncio', $stateParams);
    };

    vm.sendRegister = function () {
      // Aqui passa os registros para outro Model
      swangular.close();

      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-register-form.html\'"></div>',
        controllerAs: 'vm',
        controller: 'RegisterController',
      });
    };

    vm.sendForgot = function () {
      // Aqui passa os registros para outro Model
      swangular.close();

      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-forgot.html\'"></div>',
        controllerAs: 'vm',
        controller: 'ForgotController',
      });
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb').directive("compareTo", function () {
      return {
        require: "ngModel",
        scope: {
          repeatPassword: "=compareTo"
        },

        link: function (scope, element, attributes, paramval) {
          paramval.$validators.compareTo = function (val) {
            return val == scope.repeatPassword;
          };
          scope.$watch("repeatPassword", function () {
            paramval.$validate();
          });
        }
      };
    });
})();
(function () {
	'use strict';

	angular
		.module('arboWeb')
		.directive('listingEmpty', listingEmpty);

	/** @ngInject */
	function listingEmpty() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/listingEmpty/listingEmpty.html',
			scope: {
				codigo: "="
			},
			controller: ListingController,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;

		/** @ngInject */
		function ListingController($rootScope, $http, $location, $scope, $state, $compile, $stateParams, $window, $sce, Imovel, toastr, createThumb, textFormatter, PROD, seoService, SERVER_URL) {
			var vm = this;
			vm.navegator = true;
			vm.title_page = "Ops! O imóvel " + vm.codigo + " já não está mais disponível :(";
			vm.relacionados = vm.tags = [];

			vm.customProperties = {
				loop: true,
				nav: false,
				margin: 10,
				dots: false,
				responsiveClass: true,
				responsive: {
					0: {
						items: 1,
						stagePadding: 22
					},
					700: {
						items: 2,
						stagePadding: 25
					},
					980:{
						items: 1,
						stagePadding: 12
					},
					1240: {
						items: 2,
					},
					1380: {
						items: 3,
					}
				}
			}

			function init() {
				var _urlRelacionado = SERVER_URL + 'api/imoveis/relacionados/' + vm.codigo;
				var _urlTags = SERVER_URL + 'api/imoveis/tags/' + vm.codigo;

				var currentX = '';
				var currentY = '';
				var movementConstant = .025;
	
				// $('#listing-empty > .images').mousemove(function (e) {
				$(document).mousemove(function (e) {
					if (currentX == '') currentX = e.pageX;
					var xdiff = e.pageX - currentX;
					currentX = e.pageX;
					if (currentY == '') currentY = e.pageY;
					var ydiff = e.pageY - currentY;
					currentY = e.pageY;
					$('.parallax > .item').each(function (i, el) {
						var movement = (i * 3 + 1) * (xdiff * movementConstant);
						var movementy = (i * 3 + 1) * (ydiff * movementConstant);
						var newX = $(el).position().left + movement;
						var newY = $(el).position().top + movementy;
						$(el).css('left', newX + 'px');
						$(el).css('top', newY + 'px');
					});
				});

				$http.get(_urlRelacionado)
					.then(function (result) {
						vm.relacionados = result.data;
						if(vm.relacionados.length < 4){
							vm.customProperties.loop = false;
							vm.navegator = false;
						}
					})
					.catch(function (error) {
						console.error(error.message);
					})

				$http.get(_urlTags)
					.then(function (result) {
						vm.tags = typeof result.data !== 'string' ? result.data : [];
					})
					.catch(function (error) {
						console.error(error.message);
					})

				var config = {
					title: vm.title_page,
					description: null,
					slug: $location.absUrl(),
					image: 'http://www.arboimoveis.com.br/assets/images/novosite/marlin-eita.png',

				}

				seoService.generateTags(config);

			}

			init();
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .directive('listingDetailEmpreendimento', configDirectve);

    function configDirectve(){
      var directive = {
        restrict: 'E',
        templateUrl: 'app/components/listingDetail/listingDetailLancamento.html',
        scope: {
          imovel: "="
        },
        controller: listingDetailEmpreendimentosController,
        controllerAs: 'vm',
        bindToController: true
      };

      return directive;

        /** @ngInject */
        function listingDetailEmpreendimentosController($rootScope, $http, $location, $scope, $locale, $state, $compile, $stateParams, $window, Imovel, SITE_URL, SERVER_URL, $sce, ngMeta, PROD, toastr, toastrConfig, Empreendimento, CardImovel, createThumb, textFormatter, seoService, API_MAPBOX)  {
          var vm = this;

          vm.showComodidades = showComodidades;
          vm.sharePage = sharePage;
          vm.getLocation = getLocation;
          vm.createThumb = createThumb;
          vm.makeUrl = makeUrl;
          vm.setTipoNegocio = setTipoNegocio;
          vm.toggleValoresMobile = toggleValoresMobile;
          vm.hasExtraExpenses = false;
          vm.mapCreated = false;

          var configWL = $rootScope.ConfigWhiteLabel;
          vm.config_wl = configWL;

          // Favoritos
          vm.favorites = JSON.parse($window.localStorage.getItem('favorites'));
          vm.setFavorite = setFavorite;
          vm.unsetFavorite = unsetFavorite;
          vm.changeFavorite = changeFavorite;
          vm.initVideo = initVideo;

          // toast config
          angular.extend(toastrConfig, {
            autoDismiss: false,
            containerId: 'toast-container',
            maxOpened: 1,
            newestOnTop: true,
            positionClass: 'toast-top-right',
            preventDuplicates: false,
            preventOpenDuplicates: true,
            progressBar: false,
            target: 'body'
          });

          vm.mobile = false;
          // if( navigator.userAgent.match(/Android/i)
          //     || navigator.userAgent.match(/webOS/i)
          //     || navigator.userAgent.match(/iPhone/i)
          //     || navigator.userAgent.match(/iPad/i)
          //     || navigator.userAgent.match(/iPod/i)
          //     || navigator.userAgent.match(/BlackBerry/i)
          //     || navigator.userAgent.match(/Windows Phone/i)){
          if (window.innerWidth < 992) {
            vm.mobile = true;
          }

          vm.resetInput = function () {
            $('#navbar-bottom').css({ 'bottom': '' })
          }

          vm.form = {
            card: null,
            formData: {
              cliente: '',
              telefone: '',
              email: '',
              codigo_anuncio: '',
              midia: $location.host(),
              check: false,
              corpo: $location.absUrl(),
              visita_hora: null,
              visita_data: null
            },
            submitContato: function (e) {
              e.preventDefault();
              e.stopPropagation();
              var copy = angular.copy(vm.form.formData);

              copy.visita_hora = null;
              copy.visita_data = null;

              var that = this;
              copy.corpo += copy.check;
              var req = {
                method: 'POST',
                url: SERVER_URL + 'api/cardsimovel/save-card-site',
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Token': '60a156bb175722a22f2d97e6dd6bb762'
                },
                data: copy
              }

              if (PROD) {
                ta('send', 'lead');

                fbq('track', 'Lead', {
                  content_name: vm.listing.imv_titulo,
                  content_category: (($stateParams.tipovar == 'a-venda') ? 'venda' : (($stateParams.tipovar == 'para-alugar') ? 'aluguel' : 'venda')),
                  currency: 'BRL',
                  value: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
                });

                var lis = (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_cod_gaia + '_SALE' : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_cod_gaia + '_RENT' : vm.listing.imv_cod_gaia + '_SALE'))
                // PAGE_VIEW conversionintent
                gtag('event', 'page_view', {
                  listing_id: lis,
                  listing_pagetype: 'conversionintent',
                  listing_totalvalue: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
                });

                // req['url'] = '/api/cardsimovel/save-card-site'; // Mudanda para produção
              }

              // return;
              $http(req)
                .then(function (res) {
                  that.card = res.data;
                  $('#form-valores').removeClass('d-flex').addClass('d-none');
                  $('#form-contato').removeClass('d-flex').addClass('d-none');
                  $('#form-agendamento').removeClass('d-none').addClass('d-flex');
                  // $('#valores > .valores').css({'height': '480px'});
                  $('.card-flip').toggleClass('is-flipped');

                  // Leads Analytics
                  gtag('event', 'lead', {
                    'event_category': 'imovelLead',
                    'event_label': $location.absUrl()
                  });

                  // Leads AdW
                  gtag('event', 'conversion', { 'send_to': 'AW-851855382/Hz5cCOzq7pEBEJaQmZYD' });
                });
            },
            submitAgendamento: function (e) {
              e.preventDefault();
              e.stopPropagation();
              var copy = angular.copy(this.formData);

              // var day = new Date(copy.visita_data);
              // var dayMonth = copy.visita_hora.split(':');
              // day.setHours(dayMonth[0], dayMonth[1], 0, 0);
              // copy.visita_hora = day;

              this.card.visita_hora = copy.visita_hora;
              this.card.visita_data = copy.visita_data;

              var req = {
                method: 'POST',
                url: SERVER_URL + 'api/cardsimovel/save-card-site',
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Token': '60a156bb175722a22f2d97e6dd6bb762'
                },
                data: vm.form.card
              }

              if (PROD) {
                fbq('track', 'Schedule');

                var lis = (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_cod_gaia + '_SALE' : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_cod_gaia + '_RENT' : vm.listing.imv_cod_gaia + '_SALE'))

                // PAGE_VIEW conversionintent
                gtag('event', 'page_view', {
                  listing_id: lis,
                  listing_pagetype: 'conversion',
                  listing_totalvalue: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
                });
              }

              $http(req)
                .then(function (succ) {
                  // console.log(succ);

                  $('#form-agendamento').removeClass('d-flex').addClass('d-none');
                  $('#form-agradecimento').removeClass('d-none').addClass('d-flex');
                  // $('#valores > .valores').css({'height': 'auto'});

                  gtag('event', 'schedule', {
                    'event_category': 'imovelSchedule',
                    'event_label': $location.absUrl()
                  });
                })
            }
          }

          vm.clickInput = function (a) {
            if (navigator.userAgent.match(/Android/i)
              || navigator.userAgent.match(/webOS/i)) {
              setTimeout(function () {
                $('#navbar-bottom').css({ 'bottom': a });
              }, 500)
            }
          }
          vm.trustSrc = trustSrc;
          vm.maptoogle = false;
          function setMap() {

              /****  MAPS ****/
              var imvLocation = angular.copy(vm.listing.imv_location);

              var image = {
                url: './assets/images/novosite/_marker.svg',
                size: new google.maps.Size(35, 45),
                scaledSize: new google.maps.Size(25, 35)
              };

              var style = [
                {
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "saturation": -100,
                      "color": "#dddddd"
                    }
                  ]
                },
                {
                  "featureType": "poi.school",
                  "elementType": "labels.icon",
                  "stylers": [
                    {
                      "color": "#dddddd"
                    }
                  ]
                },
                {
                  "elementType": "labels.text",
                  "stylers": [
                    {
                      "saturation": -100
                    }
                  ]
                }
              ];

              // var map = new google.maps.Map(document.getElementById('map-detail'), {
              //   center: imvLocation,
              //   zoom: 15,
              //   scrollwheel: false,
              //   navigationControl: false,
              //   mapTypeControl: false,
              //   scaleControl: false,
              //   styles: style
              // });
              //
              // map.setOptions({ draggable: false });
              //
              // var marker = new google.maps.Marker({
              //   position: {
              //     'lat': imvLocation.lat,
              //     'lng': imvLocation.lng
              //   },
              //   map: map,
              //   icon: image,
              //   draggable: false,
              //   flat: true
              // });

              var map = L.map('map-detail', {
                keyboard: false,
                dragging: true, //
                zoomControl: true, //
                boxZoom: false,
                doubleClickZoom: false,
                scrollWheelZoom: true, //
                tap: true, //
                touchZoom: true, //
              }).setView([imvLocation.lat, imvLocation.lng], 15);
              L.tileLayer(
                'https://api.mapbox.com/styles/v1/desenvolvimentoarbo/ck7noi1870ox01iqpixwhcxau/tiles/512/{z}/{x}/{y}?access_token='+API_MAPBOX, {
                  tileSize: 512,
                  zoomOffset: -1,
                  minZoom: 15,
                  attribution: '© <a href="https://www.mapbox.com/map-feedback/">Mapbox</a> and <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }
              ).addTo(map);

              var markerIcon = L.icon({
                iconUrl: image.url,
                iconSize:     [25, 35], // size of the icon
                // shadowSize:   [50, 64], // size of the shadow
                // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
                // shadowAnchor: [4, 62],  // the same for the shadow
                // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
              });

              L.marker([imvLocation.lat, imvLocation.lng], {icon: markerIcon}).addTo(map);
              $('#maps-detail').css({'z-index': '1'});

              if (!vm.mapCreated) {
                vm.mapCreated = true;
                $window.gtag('event', 'map_usage', {
                  'event_category': (vm.listing.tipo_imovel && vm.listing.tipo_imovel.timv_nome) ? vm.listing.tipo_imovel.timv_nome.toLowerCase() : 'imovel',
                  'event_label': 'listing_detail_lancamento',
                  'value': vm.listing.imv_cod_gaia,
                  'coordinates': vm.listing.imv_location.lat + ',' + vm.listing.imv_location.lng
                });
              }
              /***************************/
          }
          vm.formatPrice = textFormatter.formatPrice
          // input fields
          function trustSrc(src) {
            return $sce.trustAsResourceUrl(src);
          }

          function makeUrl(listing, tipo) {
            // var urlPath = $location.$$url.split('?')[0].split('#')[0];
            if (listing) {
              if (!tipo) {
                var description = textFormatter.removeSpecialChar(listing.imv_titulo)
                return ('/imovel/' + description + '/' + listing.imv_cod_gaia);
              }
              else {
                var city = textFormatter.removeSpecialChar(listing.imv_cidade) + '-' + listing.imv_estado.toLowerCase();

                // url para cidade
                if (tipo == 1) {
                  var url = SITE_URL + 'imoveis/' + city;
                  // var url = '/' + 'imoveis/' + city;
                  return url;
                }

                //url para tipo negocio
                else if (tipo == 2) {
                  var tipo_negocio = listing.imv_preco_locacao ? 'imoveis/para-locacao/' : 'imoveis/a-venda/';
                  var url = SITE_URL + tipo_negocio + city;
                  // var url = '/' + tipo_negocio + city;
                  return url;
                }

                //url para tipo de imovel
                else if (tipo == 3) {
                  var tipo_negocio = listing.imv_preco_locacao ? 'imoveis/para-locacao/' : 'imoveis/a-venda/';
                  var url = SITE_URL + tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + '/' + city;
                  // var url = '/' + tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + '/' + city;
                  return url;
                }
                //url do imóvel atual
                else if (tipo == 4) {
                  return $location.$$absUrl;
                }
              }

            }

          }

          vm.days = {
            monday: 'Segunda-feira',
            tuesday: 'Terça-feira',
            wednesday: 'Quarta-feira',
            thursday: 'Quinta-feira',
            friday: 'Sexta-feira',
            saturday: 'Sábado',
            sunday: 'Domingo'
          };

          activate();

          function activate() {
            // debugger

            $stateParams.tipovar = $stateParams.type2 ? $stateParams.type2 : ($stateParams.type4 ? $stateParams.type4 : null);

            // Imovel.getImovelNew({
            //   id: $stateParams.id.split('-')[0]
            // }, function (success) {
            //   // debugger;
            //   success = success[0];
              var success = vm.imovel;
              if($stateParams.tipovar == null){
                $stateParams.tipovar = (success.imv_preco_locacao > 0) ? 'para-alugar' : 'a-venda';
              }

              if (PROD) {
                fbq('track', 'ViewContent', {
                  content_ids: success.imv_cod_gaia + (($stateParams.tipovar == 'a-venda') ? '_venda' : (($stateParams.tipovar == 'para-alugar') ? '_locacao' : '_venda')),
                  content_name: success.imv_titulo,
                  content_type: 'product',
                  product_catalog_id: 535274536934839,
                  currency: 'BRL',
                  value: (($stateParams.tipovar == 'a-venda') ? success.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? success.imv_preco_locacao : success.imv_preco_venda))
                });
              }

              vm.listingMini = angular.copy(success);
              vm.listingMini['imgThumb'] = []
              vm.listing = createThumb.get(success);
              vm.listing = createThumb.get640(vm.listing);
              initVideo();

              // Ordena as fotos para o
              vm.tipoFotos = vm.listing['fotos'].reduce(function (rv, x) {
                    // REGRA - Retira o tipo 'Foto'
                    // O mesmo será utilizado apenas para a visualização da fotoHeader e fotoFooter
                      // if(x['tipo_foto']['tfoto_nome'] != 'Foto'){
                        (rv[x['tipo_foto']['tfoto_nome']] = rv[x['tipo_foto']['tfoto_nome']] || []).push(x);
                      // }
                      return rv;
                    }, {});

              setMap();

              angular.forEach(vm.listing.imgThumb, function (v, k) {
                if (k !== 0) { this.push(v); }
              }, vm.listingMini['imgThumb'])
              vm.listingMini.imgThumb.push(vm.listing.imgThumb[0])

              angular.element('.carousel').bcSwipe({ threshold: 50 });

              /* Imagens jsonLd  */
              var image = new Image();
              var photos = [];
              if (vm.listing.fotos && vm.listing.fotos.length > 0) {
                image.src = vm.listing.fotos[0].imvft_url;
                angular.forEach(vm.listing.fotos, function (v, k) {
                  photos.push({
                    "@type": "ImageObject",
                    "contentUrl": v.imvft_url,
                  })
                })

              } else {
                image.src = '../../assets/images/novosite/fallback.png';
              }

              /* Valor jsonLd */
              var preco;
              if (vm.listing.imv_preco_venda) {
                preco = vm.listing.imv_preco_venda
              } else {
                preco = vm.listing.imv_preco_locacao
              }

              /* Texto padrão */

              vm.listing.imv_obs = vm.listing.imv_obs ? vm.listing.imv_obs.split(" - MEEnviado")[0].split("___")[0] : '';

              vm.listing.imv_obs +=
              '\n\n\n '+vm.listing.tipo_imovel.timv_nome+' para '+(vm.listing.imv_preco_locacao ? 'Aluguel' : 'Venda')+' em região valorizada do bairro '+vm.listing.imv_bairro+', em '+vm.listing.imv_cidade+'.'
              +'Não encontrou o que procurava ou deseja mais informações sobre '+vm.listing.tipo_imovel.timv_nome+' em '+vm.listing.imv_cidade+'? Entre em contato com nossa equipe '+ (configWL.telefones && configWL.telefones[0] ? 'pelo telefone ' + configWL.telefones[0].numero : '') +'.'
              +'\n\n'
              +'A '+configWL.nome+' tem mais opções de apartamentos, casas residenciais e comerciais, sobrados, terrenos, lojas e barracões para venda ou locação, '
              +'além de empreendimentos em construção ou lançamentos na planta em '+vm.listing.imv_bairro+' e em outras regiões de '+vm.listing.imv_cidade+'. Aqui você encontra milhares de ofertas para encontrar o imóvel que mais combina com seu estilo de vida.'
              +'\n\n'
              +'Negocie seu imóvel de forma totalmente online na '+configWL.nome+' , com segurança e tranquilidade. '
              +'Na '+configWL.nome+' você consegue '+ (configWL.imb_config_site.tipo_imob == 1 ? 'comprar' : ( configWL.imb_config_site.tipo_imob == 2 ? 'alugar' : 'comprar ou alugar' )) +' um imóvel em '+vm.listing.imv_cidade+' mesmo não estando na cidade e com a praticidade de fazer tudo online, direto do seu computador ou smartphone.'
              +'Nós criamos soluções inovadoras para simplificar a relação de proprietários, inquilinos e compradores com o mercado imobiliário.'
              +'\n\n'
              +'\n\n'
              +'Anuncie seu imóvel! É fácil, rápido e gratuito! A '+configWL.nome+' é uma imobiliária digital com imóveis em diversas cidades do Brasil, incluindo '+vm.listing.imv_cidade+'.'
              +'\n\n'
              +'Na '+configWL.nome+' você consegue '+ (configWL.imb_config_site.tipo_imob == 1 ? 'vender' : ( configWL.imb_config_site.tipo_imob == 2 ? 'alugar' : 'vender ou alugar' )) +' seu imóvel muito mais rápido do que em imobiliárias tradicionais. '
              +'Já '+ (configWL.imb_config_site.tipo_imob == 1 ? 'vendemos' : ( configWL.imb_config_site.tipo_imob == 2 ? 'locamos' : 'vendemos e locamos' )) + ' diversos imóveis em '+vm.listing.imv_cidade+', especialmente em '+vm.listing.imv_bairro+'. '
              +'Isso porque temos uma equipe de marketing digital focada em produzir campanhas específicas para '+vm.listing.imv_cidade+', '
              +'o que aumenta muito o número de contatos interessados e tendo como consequência uma maior chance de '+ (configWL.imb_config_site.tipo_imob == 1 ? 'vender' : ( configWL.imb_config_site.tipo_imob == 2 ? 'alugar' : 'vender ou alugar' )) +' seu imóvel mais rápido. '
              +'Contamos também com um time de programadores, corretores treinados e uma central de atendimento preparada para atender proprietários e inquilinos.';

              /* criando ngMeta */

              var desc = $rootScope.ConfigWhiteLabel.descricao_site;
              var nome = $rootScope.ConfigWhiteLabel.nome;
              // ngMeta.setTitle(vm.listing.imv_titulo + ' - ' + nome);
              // ngMeta.setTag('og:title', vm.listing.imv_titulo + ' - ' + nome);
              // ngMeta.setTag('description', vm.listing.imv_obs);
              // ngMeta.setTag('og:description', vm.listing.imv_obs);
              ngMeta.setTag('type', 'BuyAction');
              // ngMeta.setTag('image', image.src);
              // ngMeta.setTag('og:image', image.src);
              // ngMeta.setTag('og:image:width', 640);
              // ngMeta.setTag('og:image:height ', 640);
              // ngMeta.setTag('og:url', $location.absUrl());

              seoService.generateTags(
                {
                  title: vm.listing.imv_titulo + ' - ' + nome,
                  description: vm.listing.imv_obs,
                  image:  image.src,
                  slug: $location.absUrl()
                }
              )

              seoService.ldJJsonImovel(vm.listing, $location.absUrl());

              if(PROD){
                // Google PageView
                // gtag('config', 'UA-91552221-1');

                var lis = (($stateParams.tipovar == 'a-venda') ? success.imv_cod_gaia + '_SALE' : (($stateParams.tipovar == 'para-alugar') ? success.imv_cod_gaia + '_RENT' : success.imv_cod_gaia + '_SALE'))
                // PAGE_VIEW OFFERDETAIL
                gtag('event', 'page_view', {
                  listing_id: lis,
                  listing_pagetype: 'offerdetail'
                });
              }

              /* criando jsonLd */
              var jsonLd = {
                "@context": "https://schema.org",
                "@type": "BuyAction",
                "price": preco,
                "priceSpecification": {
                  "@type": "PriceSpecification",
                  "priceCurrency": "BRL"
                },
                "seller": {
                  "@type": "RealEstateAgent",
                  "name": nome,
                  "image": image.src,
                  "url": "",
                  "address": configWL.endereco ? configWL.endereco : "",
                  "priceRange": preco,
                  "telephone": configWL.telefones ? configWL.telefones[0].numero : "",
                },
                "object": {
                  "@type": "SingleFamilyResidence",
                  "@id": vm.listing.id,
                  "name": nome + ' - ' + vm.listing.imv_titulo,
                  "url": 'https:'+$location.absUrl(),
                  "description": desc,
                  "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": vm.listing.imv_location.lat,
                    "longitude": vm.listing.imv_location.lng
                  },
                  "address": {
                    "streetAddress": vm.listing.imv_endereco,
                    "addressLocality": vm.listing.imv_cidade,
                    "addressRegion": vm.listing.imv_estado,
                    "addressCountry": {
                      "@type": "Country",
                      "name": "BR"
                    },
                    "postalCode": vm.listing.imv_cep,
                  },
                  "photo": photos
                }
              }

              // console.log($rootScope);

              var scriptTag = angular.element("<script>");
              scriptTag.attr("type", "application/ld+json");
              scriptTag.attr("id", "jsonld");
              scriptTag.append(JSON.stringify(jsonLd));
              angular.element('head').append(scriptTag);

              vm.form.formData.codigo_anuncio = vm.listing.imv_cod_gaia;

              /* Imoveis Relacionados */
              var _search = {
                timv_id: vm.listing.timv_id,
                imv_latitude: vm.listing.imv_latitude,
                imv_longitude: vm.listing.imv_longitude,
                id: vm.listing.id,

              }
              Imovel.relacionados(_search, function (succ) {
                vm.relacionados = []
                angular.forEach(succ, function (v, k) {
                  vm.relacionados.push(createThumb.get(v));
                })

                if (vm.favorites) {
                  for (var i = 0; i < vm.relacionados.length; i++) {
                    for (var j = 0; j < vm.favorites.length; j++) {
                      if (vm.relacionados[i].imv_cod_gaia == vm.favorites[j]) {
                        vm.relacionados[i].isFavorite = true;
                      }
                    }
                  }
                }

                setTimeout(function () {
                  // $('#carousel-similares').owlCarousel({
                  //   margin: 10,
                  //   dots: false,
                  //   loop: false,
                  //   nav: false,
                  //   responsiveClass: true,
                  //   responsive: {
                  //     0: {
                  //       items: 1.2,
                  //       loop: true
                  //     },
                  //     700: {
                  //       items: 2.3,
                  //     },
                  //     980: {
                  //       items: 3.2,
                  //     },
                  //     1280: {
                  //       items: 4.3,
                  //     },
                  //     1600: {
                  //       items: 5.3
                  //     }
                  //   }
                  // });

                  angular.element(".galeria-empreendimento .light-gallery").lightGallery({
                    selector: '.imagem',
                    download: false,
                  });

                }, 300)

              }, function (error) {
                // vm.refreshing = false;
                console.error('error', error);
              });

              if (vm.favorites) {
                for (var i = 0; i < vm.favorites.length; i++) {
                  if (vm.favorites[i] == vm.listing.imv_cod_gaia) {
                    vm.listing.isFavorite = true;
                  }
                }
              }

              hasExtraExpenses();

            // }, function (err) {
            //   console.error(err);
            // });

            // Fecha o card de valores ao clicar fora
            // angular.element('#main-content').click(function (e) {
            //   if (angular.element('#navbarCollapse').hasClass('show')) {
            //     e.preventDefault();
            //     e.stopPropagation();

            //     angular.element('#navbarCollapse').collapse("hide");
            //   }
            // });
          }

          var vendaApi = null;

          vm.readyVenda = function (api) {
            vendaApi = api;
          }

          vm.owlProperties = {
            loop: false,
            nav: false,
            margin: 10,
            dots: false,
            responsiveClass: true,
            stagePadding: 25,
            responsive: {
              0: {
                items: 1,
                stagePadding: 22
              },
              700: {
                items: 2,
                stagePadding: 25
              },
              980: {
                items: 3,
              },
              1280: {
                items: 4,
              },
              1600: {
                items: 5
              }
            }
          }

          vm.owlPropertiesGaleria = {
            loop: false,
            nav: false,
            margin: 10,
            dots: false,
            stagePadding: 55,
            responsiveClass: true,
            responsive: {
              0: {
                items: 1,
                stagePadding: 22
              },
              700: {
                items: 2,
                stagePadding: 25
              },
              980: {
                items: 3,
              }
            }
          }

          angular.element(document).ready(function () {
            $('#header').addClass('fixed-theme');
            var carousel1 = $('#carousel-detail');
            var carousel2 = $('#carousel-detail-mini');

            carousel1.on('slide.bs.carousel', function (event) {
              var to = $(event.relatedTarget).index();


              var items = carousel1.find(".carousel-item");
              var lazy = carousel1.find(".carousel-item.active");

              var items2 = carousel2.find(".carousel-item");
              var lazy2 = carousel2.find(".carousel-item.active");

              if (lazy.index() == 0 && to == (items.length - 1)) {
                lazy = items.last();
                lazy2 = items2.last();
              }
              else if (lazy.index() == -1 && to == 0) {
                lazy = items.first();
                lazy2 = items2.first();
              }
              else if (lazy.index() > to) {
                lazy = lazy.prev();
                lazy2 = lazy2.prev();
              }
              else {
                lazy = lazy.next();
                lazy2 = lazy2.next();
              }

              if(lazy.find('img').data('img')){
                lazy.find('img').attr("src",  lazy.find('img').data('img'));
                lazy.find('img').removeAttr('data-img');
              }

              if(lazy2.find('img').data('img')){
                lazy2.find('img').attr("src",  lazy2.find('img').data('img'));
                lazy2.find('img').removeAttr('data-img');
              }

              carousel2.carousel(to);
            });

            angular.element('.carousel').bcSwipe({ threshold: 50 });
          })

          $('.btn-more').click(function () {
            // angular.element('.info-desc').addClass('expand');
            // $(this).addClass('d-none')

            angular.element('.info-desc').toggleClass('expand');

            var btn = $(this);

            btn.toggleClass('change-text');
            var text = btn.hasClass('change-text') ? 'Esconder texto <i class="fal fa-chevron-up"></i>' : 'Leia mais <i class="fal fa-chevron-down"></i>';
            btn.html(text);
          });

          vm.nextOwl = function (ev) {
            vendaApi.trigger('next.owl.carousel');
          }

          vm.prevOwl = function (ev) {
            vendaApi.trigger('prev.owl.carousel');
          }


          if (window.innerWidth > 992) {
            var originalPosition = $('#valores').position().top;
            var timer;
            var _scrollFn = function () {
              clearTimeout(timer);
              timer = setTimeout(function () {
                $('#valores').css('position', 'absolute');
                // $('#valores').css('right', '65px');

                if (window.innerWidth > 1199) {
                  var dih = $('#valores-container').height();
                  var di_top = $('#valores-container').position().top;
                } else {
                  var dih = $('.informations').height();
                  var di_top = $('.informations').position().top;
                }

                var cx_height = $('#valores').height();
                var y_offset = window.pageYOffset;

                var newHeight = Math.max(originalPosition,
                  Math.min(dih + di_top - cx_height,
                    Math.max(originalPosition, y_offset + 10)));
                $('#valores').css({ top: newHeight });
              }, 0);
            };
            _scrollFn()

            $(window).scroll(_scrollFn);

            $scope.$on('$destroy', function () {
              $(window).unbind('scroll', _scrollFn);
            });


          }
          // ===============================================================

          // var API_URL = 'http://www.arboimoveis.com/api/';
          // var URL_API = 'http://192.168.0.60:3000/api/';
          var hostName = window.location.hostname;
          if (hostName == "localhost" || hostName == "127.0.0.1" || hostName.indexOf('192') != -1) {
            var API_URL = 'http://' + hostName + ':3000/api/';
          } else {
            var API_URL = 'https://' + hostName.replace("app.", "api.") + '/api/';
          }

          // ===============================================================

          // vm.saibamais = function() {
          //   var card = document.querySelector('.card-flip');
          //   card.classList.toggle('is-flipped');
          // };

          // ========= Datapicker ==========================================
          vm.datesPage = 0;
          vm.timesPage = 0;

          var startDate = new Date();
          vm.dates = getDates(startDate, 30);

          vm.form.formData.visita_data = vm.dates[1].date;
          vm.numElements = 3;
          setTempDates(vm.numElements);

          vm.times = getTimes();
          vm.form.formData.visita_hora = vm.times[1].time;
          setTempTimes(vm.numElements);

          function initVideo(){
            // debugger
            var src = '';
            if((/youtu/g).test(vm.listing.imv_videourl)){
              var videocod = vm.listing.imv_videourl.replace(/https:\/\//g, '').replace(/youtu.be\//g, '').replace(/www.youtube.com\//g, '').replace(/embed\//g, '').replace(/(watch\?v=)/g, '').replace(/(v\/)/g, '');
              var url_src = 'https://www.youtube.com/embed/'+videocod;
              src = '<object width="100%" height="100%" data="'+url_src+'"></object>';

              angular.element('video.imv-video').addClass('d-none');
              angular.element('div.div-video').removeClass('d-none');
              angular.element('div.div-video').append(src);
              return;
            }else if((/.webm/g).test(vm.listing.imv_videourl)){
              src = '<source src="'+ vm.listing.imv_videourl + '" type="video/webm"></source>';
            }else if((/.mp4/g).test(vm.listing.imv_videourl)){
              src = '<source src="'+ vm.listing.imv_videourl + '" type="video/mp4"></source>';
            }else{
              src = '<source src="'+ vm.listing.imv_videourl + '" ></source>';
            }
            angular.element('video.imv-video').append($compile(src)(vm))
          }

          function setTempDates(numElements) {
            vm.tempDates = [];
            for (var i = 0; i < numElements; i++) {
              vm.tempDates.push(vm.dates[vm.datesPage * numElements + i]);
            }
          }

          function setTempTimes(numElements) {
            vm.tempTimes = [];
            for (var i = 0; i < numElements; i++) {
              vm.tempTimes.push(vm.times[vm.timesPage * numElements + i]);
            }
          }

          function getDates(startDate, daysToAdd) {
            var dates = [];
            for (var i = 0; i < daysToAdd; i++) {
              var currentDate = new Date();
              currentDate.setDate(startDate.getDate() + i + 1);
              dates.push({ date: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()), dayOfWeek: dayAsString(currentDate.getDay()), day: ("0" + currentDate.getDate()).slice(-2), month: ("0" + (currentDate.getMonth() + 1)).slice(-2) });
            }
            return dates;
          }

          function getTimes() {
            var times = [
              { time: '09:00' }, { time: '09:15' }, { time: '09:30' },
              { time: '09:45' }, { time: '10:00' }, { time: '10:15' },
              { time: '10:30' }, { time: '10:45' }, { time: '11:00' },
              { time: '11:15' }, { time: '11:30' }, { time: '11:45' },
              { time: '12:00' }, { time: '12:15' }, { time: '12:30' },
              { time: '12:45' }, { time: '13:00' }, { time: '13:15' },
              { time: '13:30' }, { time: '13:45' }, { time: '14:00' },
              { time: '14:15' }, { time: '14:30' }, { time: '14:45' },
              { time: '15:00' }, { time: '15:15' }, { time: '15:30' },
              { time: '15:45' }, { time: '16:00' }, { time: '16:15' },
              { time: '16:30' }, { time: '16:45' }, { time: '17:00' },
              { time: '17:15' }, { time: '17:30' }, { time: '17:45' }
            ];
            return times;
          }

          $scope.$watch('vm.datesPage', function (newValue, oldValue) {
            if (newValue < 0) vm.datesPage = 0;
            else if (newValue > (vm.dates.length / vm.numElements) - 1) vm.datesPage = oldValue;

            if (newValue !== oldValue) {
              setTempDates(vm.numElements);
              vm.form.formDatavisita_data = vm.tempDates[1].date;
            }
          })

          $scope.$watch('vm.timesPage', function (newValue, oldValue) {
            if (newValue < 0) vm.timesPage = 0;
            else if (newValue > (vm.times.length / vm.numElements) - 1) vm.timesPage = oldValue;

            if (newValue !== oldValue) {
              setTempTimes(vm.numElements);
              vm.form.formData.visita_hora = vm.tempTimes[1].time;
            }
          })

          function dayAsString(dayIndex) {
            var weekdays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
            return weekdays[dayIndex];
          }

          function showComodidades(subtipo, grupoComodidades) {
            // Sobrado / Casa / Chácara / Pousada

            if (grupoComodidades == 1 && (subtipo == 2 || subtipo == 3 || subtipo == 4 || subtipo == 12 || subtipo == 15 || subtipo == 19 || subtipo == 21)) {
              return true;
            }
            //Apartamento / Duplex / Triplex / Kitnet / Cobertura
            else if (grupoComodidades == 2 && (subtipo == 1 || subtipo == 8 || subtipo == 10 || subtipo == 13 || subtipo == 14 || subtipo == 16 || subtipo == 17 || subtipo == 18 || subtipo == 23 || subtipo == 29 || subtipo == 30 || subtipo == 31 || subtipo == 32 || subtipo == 33 || subtipo == 34)) {
              return true;
            }
            //Sala / Loja
            else if (grupoComodidades == 3 && (subtipo == 7 || subtipo == 11 || subtipo == 20 || subtipo == 22 || subtipo == 24 || subtipo == 25 || subtipo == 26 || subtipo == 27)) {
              return true;
            }
            //Barracão / Loteamento
            else if (grupoComodidades == 4 && (subtipo == 6)) {
              return true;
            }
            //Terreno
            else if (grupoComodidades == 5 && (subtipo == 5 || subtipo == 9 || subtipo == 28)) {
              return true;
            }
            // Default
            else if (grupoComodidades == 6) {
              return true;
            }
            return false;
          }
          function sharePage() {
            window.open(
              'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
              'Arbo imóveis',
              'width=600,height=400'
            )
          }

          function getLocation() {
            var url = $location.url().replace('/', '');
            return SITE_URL + url;
          }

          function changeFavorite(imovel) {
            !vm.favorites || vm.favorites.indexOf(imovel.imv_cod_gaia) == -1 ? setFavorite(imovel) : unsetFavorite(imovel)
          }


          function setFavorite(imovel) {
            if (vm.favorites == null || vm.favorites.length == 0) {
              vm.favorites = [imovel.imv_cod_gaia];
            }
            else {
              vm.favorites.push(imovel.imv_cod_gaia);
            }

            $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
            imovel.isFavorite = true;
            toastr.info('<strong>Imóvel salvo nos favoritos.</strong>', {
              iconClass: 'toast-arbo'
            });
          }

          function unsetFavorite(imovel) {
            var index = vm.favorites.indexOf(imovel.imv_cod_gaia);

            if (index !== -1) {
              vm.favorites.splice(index, 1);
              $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
              imovel.isFavorite = false;
            }
            toastr.info('<strong>Imóvel retirado dos favoritos.</strong>', {
              iconClass: 'toast-arbo'
            });
          }

          function setTipoNegocio(event, tipo) {
            // Se clicar em outro tipo quando já estiver aberto
            if (vm.tipoNegocio != undefined && vm.tipoNegocio != tipo) {
              event.preventDefault();
              event.stopPropagation();
              openValoresMobile();
              console.log('a');
            }
            // Se clicar novamente no mesmo tipo
            if (vm.tipoNegocio == tipo) {
              vm.tipoNegocio = undefined;
              closeValoresMobile();
              console.log('b');

            }
            else {
              vm.tipoNegocio = tipo;
              openValoresMobile();
              console.log('c');

            }
          }

          function openValoresMobile() {
            angular.element('#navbar-bottom').addClass('open-valores-mobile');
            angular.element('body').addClass('position-fixed');
          }

          function closeValoresMobile() {
            angular.element('#navbar-bottom').removeClass('open-valores-mobile');
            angular.element('body').removeClass('position-fixed');
          }

          function toggleValoresMobile() {
            angular.element('#navbar-bottom').hasClass('open-valores-mobile') ? closeValoresMobile() : openValoresMobile();
          }

          function hasExtraExpenses() {
            vm.hasExtraExpenses = (vm.listing.imv_preco_cond || vm.listing.imv_preco_iptu || vm.listing.imv_preco_seguro);
          }

          vm.goToImob = goToImob;
          function goToImob(){
            var url = 'http://' + vm.listing.imobiliaria.imb_url_site.replace('http://', '').replace('https://', '') + '/imoveis';
            $window.open(url, '_blank');
          }
        }
    }
})();

(function () {
  "use strict";

  angular
    .module("arboWeb")
    .directive("scroll", function ($window) {
      return function (scope, element, attrs) {
        angular.element($window).bind("scroll", function () {
          if (this.pageYOffset >= 1000) {
            scope.btnsContatar = true;
          } else {
            scope.btnsContatar = false;
          }
          scope.$apply();
        });
      };
    })
    .directive("listingDetail", listingDetail);

  /** @ngInject */
  function listingDetail() {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/listingDetail/listingDetail.html",
      scope: {
        imovel: "=",
      },
      controller: ListingDetailController,
      controllerAs: "vm",
      bindToController: true,
    };

    return directive;

    // ListingDetailController.inject = ['$rootScope', '$location', '$scope', '$locale', '$state', '$stateParams', '$window', 'Imovel', 'SITE_URL', '$sce', 'ngMeta', 'PROD', 'toastr', 'toastrConfig', 'ngMask', 'Empreendimento', 'CardImovel', 'createThumb', 'textFormatter'];

    /** @ngInject */
    function ListingDetailController(
      $rootScope,
      $http,
      $location,
      $scope,
      $timeout,
      $state,
      $compile,
      $stateParams,
      $window,
      Imovel,
      SITE_URL,
      SERVER_URL,
      $sce,
      ngMeta,
      PROD,
      toastr,
      toastrConfig,
      Empreendimento,
      CardImovel,
      swangular,
      createThumb,
      textFormatter,
      seoService,
      Imobiliaria,
      $anchorScroll,
      API_MAPBOX,
      GOOGLE_API
    ) {
      var vm = this;

      vm.thumbvideoHQ = '';

      if (!!location.search.replace("?", "")) {
        var oldParams = localStorage.getItem("params_campain");
        var _full = (oldParams ? oldParams + "&" : "") + location.search.replace("?", "");
        var array = _full.split("&").reduce(function (ac, el) {
          var _split = el.split("=");
          if (_split && _split.length == 2) {
            ac[_split[0]] = _split[1];
          }
          return ac;
        }, {});
        localStorage.setItem("params_campain", $.param(array));
      }

      vm.GOOGLE_API = GOOGLE_API;
      vm.paramsCampain = localStorage.getItem("params_campain") || null;
      vm.contato = true;
      vm.visita = false;

      vm.today = moment().add(1,'days').format('YYYY-MM-DD');

      if (vm.imovel.imv_videourl) {
        var regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        var match = vm.imovel.imv_videourl.match(regex);
        // Recurso somente para o youtube.
        if(match){
          var id2 = regex.exec(vm.imovel.imv_videourl)[1];
          vm.thumbvideo = "https://img.youtube.com/vi/" + id2 + "/maxresdefault.jpg";

          vm.thumbvideoHQ = "https://i.ytimg.com/vi/" + id2 + "/hqdefault.jpg";
        }
      }

      vm.encodedURL = encodeURIComponent("Olá, me interessei por esse imóvel e gostaria de saber mais informações.\nImóvel: https://" + $location.host() + "/imovel/" + vm.imovel.imv_cod_gaia);
      vm.urlWhats = "https://wa.me/551140403939?text=" + vm.encodedURL;
      // vm.showComodidades = showComodidades;
      // vm.sharePage = sharePage;
      vm.getLocation = getLocation;
      vm.createThumb = createThumb;
      vm.makeUrl = makeUrl;
      // vm.setTipoNegocio = setTipoNegocio;
      vm.toggleValoresMobile = toggleValoresMobile;
      vm.isMobile = isMobile();
      vm.isTablet = isTablet();
      vm.staticmap = true;
      vm.mapCreated = false;
      // vm.hasExtraExpenses = false;
      vm.readMore = false;
      vm.readMoreFunc = readMoreDescription;
      vm.goToAllInfoFunc = goToAllInfo;
      AOS.init({
        duration: 2000, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        delay: 1000,
      });
      $(window).on("load", function () {
        AOS.refresh();
      });

      vm.showPropbtn = false;
      // Favoritos
      vm.favorites = JSON.parse($window.localStorage.getItem("favorites"));
      vm.setFavorite = setFavorite;
      function setFavorite(imovel) {
        var favorites = JSON.parse($window.localStorage.getItem("favorites")) || [];
        var index = favorites.indexOf(imovel.imv_cod_gaia);
        var msg = "";
        if (index !== -1) {
          favorites.splice(index, 1);
          $window.localStorage.setItem("favorites", JSON.stringify(favorites));
          msg = "<strong>Imóvel retirado dos favoritos.</strong>";
        } else {
          favorites.push(imovel.imv_cod_gaia);
          msg = "<strong>Imóvel salvo nos favoritos.</strong>";
        }

        $window.localStorage.setItem("favorites", JSON.stringify(favorites));
        imovel.isFavorite = !imovel.isFavorite;
        toastr.info(msg, {
          iconClass: "toast-arbo",
        });
      }
      // vm.unsetFavorite = unsetFavorite;
      // vm.changeFavorite = changeFavorite;
      vm.createThumb = createThumb;

      // toast config
      angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: "toast-container",
        maxOpened: 1,
        newestOnTop: true,
        positionClass: "toast-top-right",
        preventDuplicates: false,
        preventOpenDuplicates: true,
        progressBar: false,
        target: "body",
      });

      vm.mobile = false;
      if (window.innerWidth < 992) {
        vm.mobile = true;
      }

      vm.currentUrl = $location.path();

      vm.view = "fotos";
      vm.changeView = function (type) {
        vm.view = type;
        $('.btns-media').css('visibility', 'hidden');
        $timeout(function () {
          $('.btns-media').css('visibility', 'visible');
        }, 300);
        if (type == "video") {
          $timeout(function () {
            initVideo();
          });
        }
      };

      $timeout(function () {
        if (!!location.search && !!location.search.match("video")) {
          vm.changeView("video");
        }
      }, 500);

      vm.gotoProp = function (tpng_id) {
        if (tpng_id === 3) {
          vm.showPropbtn = true;
        } else if (tpng_id === 2) {
          $state.go("main.proposta.form", { ii: window.btoa(window.btoa(vm.listing.id)) });
        } else if (tpng_id === 1) {
          $state.go("main.propostacompra.form", { ii: window.btoa(window.btoa(vm.listing.id)) });
        }
      };

      vm.initMaps = function () {
        /****  MAPS ****/
        var imvLocation = angular.copy(vm.listing.imv_location);

        var image = {
          url: "./assets/images/novosite/_marker.svg",
          size: new google.maps.Size(35, 45),
          scaledSize: new google.maps.Size(25, 35),
        };

        var style = [
          {
            elementType: "labels.icon",
            stylers: [
              {
                saturation: -100,
                color: "#dddddd",
              },
            ],
          },
          {
            featureType: "poi.school",
            elementType: "labels.icon",
            stylers: [
              {
                color: "#dddddd",
              },
            ],
          },
          {
            elementType: "labels.text",
            stylers: [
              {
                saturation: -100,
              },
            ],
          },
        ];

        var map = L.map("maps-detail", {
          keyboard: false,
          dragging: true, //
          zoomControl: true, //
          boxZoom: false,
          doubleClickZoom: false,
          scrollWheelZoom: true, //
          tap: true, //
          touchZoom: true, //
        }).setView([imvLocation.lat, imvLocation.lng], 15);

        L.tileLayer("https://api.mapbox.com/styles/v1/desenvolvimentoarbo/ck7noi1870ox01iqpixwhcxau/tiles/512/{z}/{x}/{y}?access_token=" + API_MAPBOX, {
          tileSize: 512,
          zoomOffset: -1,
          minZoom: 15,
          attribution: '© <a href="https://www.mapbox.com/map-feedback/">Mapbox</a> and <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }).addTo(map);

        var markerIcon = L.icon({
          iconUrl: image.url,
          iconSize: [25, 35], // size of the icon
          // shadowSize:   [50, 64], // size of the shadow
          // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
          // shadowAnchor: [4, 62],  // the same for the shadow
          // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
        });

        L.marker([imvLocation.lat, imvLocation.lng], { icon: markerIcon }).addTo(map);
        $("#maps-detail").css({ "z-index": "1" });

        if (!vm.mapCreated) {
          vm.mapCreated = true;
          $window.gtag("event", "map_usage", {
            event_category: vm.listing.tipo_imovel && vm.listing.tipo_imovel.timv_nome ? vm.listing.tipo_imovel.timv_nome.toLowerCase() : "imovel",
            event_label: "listing_detail",
            value: vm.listing.imv_cod_gaia,
            coordinates: vm.listing.imv_location.lat + "," + vm.listing.imv_location.lng,
          });
        }

        // var map = new google.maps.Map(document.getElementById('maps-detail'), {
        //   center: imvLocation,
        //   zoom: 15,
        //   scrollwheel: false,
        //   navigationControl: false,
        //   mapTypeControl: false,
        //   scaleControl: false,
        //   styles: style
        // });
        // var marker = new google.maps.Marker({
        //   position: {
        //     'lat': imvLocation.lat,
        //     'lng': imvLocation.lng
        //   },
        //   map: map,
        //   icon: image,
        //   draggable: false,
        //   flat: true
        // });
      };

      $scope.$watch("vm.view", function (newValue, oldValue) {
        if (newValue === "maps") {
          $timeout(function () {
            angular
              .element("#maps-static")
              .on("dragstart", function (e) {
                e.preventDefault();
              })
              .triggerHandler(function () {
                vm.staticmap = !vm.staticmap;
              });
          });
        }
      });

      vm.tag = {
        hidden: false,
      };

      // if( navigator.userAgent.match(/Android/i)
      //     || navigator.userAgent.match(/webOS/i)
      //     || navigator.userAgent.match(/iPhone/i)
      //     || navigator.userAgent.match(/iPad/i)
      //     || navigator.userAgent.match(/iPod/i)
      //     || navigator.userAgent.match(/BlackBerry/i)
      //     || navigator.userAgent.match(/Windows Phone/i)){

      vm.resetInput = function () {
        $("#navbar-bottom").css({ bottom: "" });
      };

      // vm.form = {
      //   card: null,
      //   formData: {
      //     cliente: '',
      //     telefone: '',
      //     email: '',
      //     codigo_anuncio: '',
      //     midia: $location.host(),
      //     check: false,
      //     corpo: $location.absUrl(),
      //     visita_hora: null,
      //     visita_data: null
      //   },
      //   submitContato: function (e) {
      //     e.preventDefault();
      //     e.stopPropagation();
      //     var copy = angular.copy(vm.form.formData);

      //     copy.visita_hora = null;
      //     copy.visita_data = null;
      //     copy.card_params = paramsCampain;
      //     // debugger;
      //     var that = this;
      //     copy.corpo += copy.check ? ' \nQuero receber o contato somente por Whatsapp' : '';
      //     var req = {
      //       method: 'POST',
      //       url: SERVER_URL + 'api/cardsimovel/save-card-site',
      //       headers: {
      //         'Content-Type': 'application/json',
      //         'Access-Token': '60a156bb175722a22f2d97e6dd6bb762'
      //       },
      //       data: copy
      //     }

      //     if (PROD) {
      //       ta('send', 'lead');

      //       fbq('track', 'Lead', {
      //         content_name: vm.listing.imv_titulo,
      //         content_category: (($stateParams.tipovar == 'a-venda') ? 'venda' : (($stateParams.tipovar == 'para-alugar') ? 'aluguel' : 'venda')),
      //         currency: 'BRL',
      //         value: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
      //       });

      //       var lis = (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_cod_gaia + '_SALE' : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_cod_gaia + '_RENT' : vm.listing.imv_cod_gaia + '_SALE'))
      //       // PAGE_VIEW conversionintent
      //       gtag('event', 'page_view', {
      //         listing_id: lis,
      //         listing_pagetype: 'conversionintent',
      //         listing_totalvalue: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
      //       });

      //       // req['url'] = SERVER_URL + '/api/cardsimovel/save-card-site'; // Mudanda para produção
      //     }

      //     // return;
      //     $http(req)
      //       .then(function (res) {
      //         that.card = res.data;
      //         $('#form-valores').removeClass('d-flex').addClass('d-none');
      //         $('#form-contato').removeClass('d-flex').addClass('d-none');
      //         $('#form-agendamento').removeClass('d-none').addClass('d-flex');
      //         // $('#valores > .valores').css({'height': '480px'});
      //         $('.card-flip').toggleClass('is-flipped');

      //         // Leads Analytics
      //         gtag('event', 'lead', {
      //           'event_category': 'imovelLead',
      //           'event_label': $location.absUrl()
      //         });

      //         // Leads AdW
      //         gtag('event', 'conversion', { 'send_to': 'AW-851855382/Hz5cCOzq7pEBEJaQmZYD' });
      //       });
      //   },
      //   submitAgendamento: function (e) {
      //     e.preventDefault();
      //     e.stopPropagation();
      //     var copy = angular.copy(this.formData);

      //     // var day = new Date(copy.visita_data);
      //     // var dayMonth = copy.visita_hora.split(':');
      //     // day.setHours(dayMonth[0], dayMonth[1], 0, 0);
      //     // copy.visita_hora = day;

      //     this.card.visita_hora = copy.visita_hora;
      //     this.card.visita_data = copy.visita_data;

      //     var req = {
      //       method: 'POST',
      //       url: SERVER_URL + 'api/cardsimovel/save-card-site',
      //       headers: {
      //         'Content-Type': 'application/json',
      //         'Access-Token': '60a156bb175722a22f2d97e6dd6bb762'
      //       },
      //       data: vm.form.card
      //     }

      //     if (PROD) {
      //       fbq('track', 'Schedule');

      //       var lis = (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_cod_gaia + '_SALE' : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_cod_gaia + '_RENT' : vm.listing.imv_cod_gaia + '_SALE'))

      //       // PAGE_VIEW conversionintent
      //       gtag('event', 'page_view', {
      //         listing_id: lis,
      //         listing_pagetype: 'conversion',
      //         listing_totalvalue: (($stateParams.tipovar == 'a-venda') ? vm.listing.imv_preco_venda : (($stateParams.tipovar == 'para-alugar') ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda))
      //       });
      //     }

      //     $http(req)
      //       .then(function (succ) {
      //         // console.log(succ);

      //         $('#form-agendamento').removeClass('d-flex').addClass('d-none');
      //         $('#form-agradecimento').removeClass('d-none').addClass('d-flex');
      //         // $('#valores > .valores').css({'height': 'auto'});

      //         gtag('event', 'schedule', {
      //           'event_category': 'imovelSchedule',
      //           'event_label': $location.absUrl()
      //         });
      //       })
      //   }
      // }

      function initVideo() {
        // debugger
        var src = "";
        if (/youtu/g.test(vm.listing.imv_videourl)) {
          var videocod = vm.listing.imv_videourl
            .replace(/https:\/\//g, "")
            .replace(/youtu.be\//g, "")
            .replace(/www.youtube.com\//g, "")
            .replace(/embed\//g, "")
            .replace(/(watch\?v=)/g, "")
            .replace(/(v\/)/g, "");
          var url_src = "https://www.youtube.com/embed/" + videocod + '?modestbranding=1&autoplay=1&rel=0&';
          src = '<iframe width="100%" height="100%" allowfullscreen="true" src="' + url_src + '"></iframe>';

          angular.element("video.imv-video").addClass("d-none");
          angular.element("div.imv-video").removeClass("d-none");
          angular.element("div.imv-video").append(src);
          return;
        } else if (/.webm/g.test(vm.listing.imv_videourl)) {
          src = '<source src="' + vm.listing.imv_videourl + '" type="video/webm"></source>';
        } else if (/.mp4/g.test(vm.listing.imv_videourl)) {
          src = '<source src="' + vm.listing.imv_videourl + '" type="video/mp4"></source>';
        } else {
          src = '<source src="' + vm.listing.imv_videourl + '" ></source>';
        }
        angular.element("video.imv-video").append($compile(src)(vm));
      }

      // vm.clickInput = function (a) {
      //   if (navigator.userAgent.match(/Android/i)
      //     || navigator.userAgent.match(/webOS/i)) {
      //     setTimeout(function () {
      //       $('#navbar-bottom').css({ 'bottom': a });
      //     }, 500)
      //   }
      // }
      vm.trustSrc = trustSrc;
      vm.maptoogle = false;
      vm.toogleWrap = function (params) {
        if (params) {
          if (params > 1) {
            //video

            if (!angular.element(".button-toogle1").hasClass("d-none")) {
              angular.element(".button-toogle1").addClass("d-none");
            }
            if (!angular.element(".button-toogle0").hasClass("d-none")) {
              angular.element(".button-toogle0").addClass("d-none");
            }
            angular.element(".button-toogle2").removeClass("d-none");

            angular.element("video.imv-video").trigger("play");

            angular.element(".wrap-carousel").addClass("d-none");
            angular.element(".wrap-map").addClass("d-none");
            angular.element(".wrap-video").toggleClass("d-none");

            if (!angular.element(".button-toogle-carousel2").hasClass("d-none")) {
              angular.element(".button-toogle-carousel2").addClass("d-none");
            }
            if (!angular.element(".button-toogle-video").hasClass("d-none")) {
              angular.element(".button-toogle-video").addClass("d-none");
            }
            angular.element(".button-toogle-carousel1").removeClass("d-none");
            angular.element(".button-toogle-map").removeClass("d-none");
          } else {
            //mapa

            if (!angular.element(".button-toogle2").hasClass("d-none")) {
              angular.element(".button-toogle2").addClass("d-none");
            }
            if (!angular.element(".button-toogle0").hasClass("d-none")) {
              angular.element(".button-toogle0").addClass("d-none");
            }
            angular.element(".button-toogle1").removeClass("d-none");

            angular.element("video.imv-video").trigger("pause");

            angular.element(".wrap-carousel").addClass("d-none");
            angular.element(".wrap-map").toggleClass("d-none");
            angular.element(".wrap-video").addClass("d-none");

            if (!angular.element(".button-toogle-carousel1").hasClass("d-none")) {
              angular.element(".button-toogle-carousel1").addClass("d-none");
            }
            if (!angular.element(".button-toogle-map").hasClass("d-none")) {
              angular.element(".button-toogle-map").addClass("d-none");
            }
            angular.element(".button-toogle-carousel2").removeClass("d-none");
            angular.element(".button-toogle-video").removeClass("d-none");
          }
        } else {
          //fotos

          if (!angular.element(".button-toogle2").hasClass("d-none")) {
            angular.element(".button-toogle2").addClass("d-none");
          }
          if (!angular.element(".button-toogle1").hasClass("d-none")) {
            angular.element(".button-toogle1").addClass("d-none");
          }
          angular.element(".button-toogle0").removeClass("d-none");

          angular.element("video.imv-video").trigger("pause");

          angular.element(".wrap-carousel").toggleClass("d-none");
          angular.element(".wrap-map").addClass("d-none");
          angular.element(".wrap-video").addClass("d-none");

          if (!angular.element(".button-toogle-carousel1").hasClass("d-none")) {
            angular.element(".button-toogle-carousel1").addClass("d-none");
          }
          if (!angular.element(".button-toogle-carousel2").hasClass("d-none")) {
            angular.element(".button-toogle-carousel2").addClass("d-none");
          }
          angular.element(".button-toogle-map").removeClass("d-none");
          angular.element(".button-toogle-video").removeClass("d-none");
        }

        angular.element(".button-toogle").toggleClass("d-none");
        // angular.element('.wrap-toogle').toggleClass('d-none');

        if (params == 1 && !vm.maptoogle) {
          vm.maptoogle = true;
          /****  MAPS ****/
          var imvLocation = angular.copy(vm.listing.imv_location);
          var image = {
            url: "./assets/images/novosite/_marker.svg",
            size: new google.maps.Size(35, 45),
            scaledSize: new google.maps.Size(25, 35),
          };

          var style = [
            {
              elementType: "labels.icon",
              stylers: [
                {
                  saturation: -100,
                  color: "#dddddd",
                },
              ],
            },
            {
              featureType: "poi.school",
              elementType: "labels.icon",
              stylers: [
                {
                  color: "#dddddd",
                },
              ],
            },
            {
              elementType: "labels.text",
              stylers: [
                {
                  saturation: -100,
                },
              ],
            },
          ];

          var map = new google.maps.Map(document.getElementById("map-detail"), {
            center: imvLocation,
            zoom: 15,
            scrollwheel: false,
            navigationControl: false,
            mapTypeControl: false,
            scaleControl: false,
            styles: style,
          });
          var marker = new google.maps.Marker({
            position: {
              lat: imvLocation.lat,
              lng: imvLocation.lng,
            },
            map: map,
            icon: image,
            draggable: false,
            flat: true,
          });
          /***************************/
        }
      };
      vm.formatPrice = textFormatter.formatPrice;
      // input fields
      function trustSrc(src) {
        return $sce.trustAsResourceUrl(src);
      }

      function makeUrl(listing, tipo) {
        // var urlPath = $location.$$url.split('?')[0].split('#')[0];
        if (listing) {
          if (!tipo) {
            var description = textFormatter.removeSpecialChar(listing.imv_titulo);
            return "/imovel/" + description + "/" + listing.imv_cod_gaia;
          } else {
            var city = textFormatter.removeSpecialChar(listing.imv_cidade) + "-" + listing.imv_estado.toLowerCase();
            // var siteLocation = $location.protocol() + '://' + $location.host() + '/'
            var siteLocation = "/";
            // debugger
            // url para cidade
            if (tipo == 1) {
              var url = siteLocation + "imoveis/" + city;
              // var url = '/' + 'imoveis/' + city;
              return url;
            }

            //url para tipo negocio
            else if (tipo == 2) {
              var path = listing.imv_bairro ? (listing.imv_bairro + ' ' + city) : city;

              var formattedPath = textFormatter.removeSpecialChar(path);
              var tipo_negocio = listing.imv_preco_locacao ? "imoveis/para-locacao/" : "imoveis/a-venda/";
              var url = siteLocation + tipo_negocio + formattedPath;
              // var url = '/' + tipo_negocio + city;
              return url;
            }

            //url para tipo de imovel
            else if (tipo == 3) {
              var tipo_negocio = listing.imv_preco_locacao ? "imoveis/para-locacao/" : "imoveis/a-venda/";
              var path = listing.imv_bairro ? (listing.imv_bairro + ' ' + city) : city;

              var formattedPath = textFormatter.removeSpecialChar(path);
              var url = siteLocation + tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + "/" + formattedPath;
              // var url = '/' + tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + '/' + city;
              return url;
            }
            //url do imóvel atual
            else if (tipo == 4) {
              return $location.$$absUrl;
            }
            //url do bairro atual
            else if (tipo == 5) {
              var bairroPath = textFormatter.removeSpecialChar(listing.imv_bairro + ' ' + city);
              var url = "imoveis/" + bairroPath;
              return url;
            }
          }
        }
      }

      vm.days = {
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
        sunday: "Domingo",
      };

      activate();

      function activate() {
        // debugger

        $stateParams.tipovar = $stateParams.type2 ? $stateParams.type2 : $stateParams.type4 ? $stateParams.type4 : null;

        // Imovel.getImovelNew({
        //   id: $stateParams.id.split('-')[0]
        // }, function (success) {
        // debugger;
        // success = success[0];
        var success = vm.imovel;
        // Unidade, redirect para a view do empreendimento
        if(vm.imovel.imv_id && vm.imovel.timv_id == 47){
          $state.go('main.imovel',{id:vm.imovel.imv_id })
          return ;
        }

        vm.showComodidades = initComodidades(vm.imovel.timv_id);
        if ($stateParams.tipovar == null) {
          $stateParams.tipovar = success.imv_preco_locacao > 0 ? "para-alugar" : "a-venda";
        }

        if (PROD) {
          if (typeof $window.fbq == "function") {
            $window.fbq("track", "ViewContent", {
              content_ids: success.imv_cod_gaia + ($stateParams.tipovar == "a-venda" ? "_venda" : $stateParams.tipovar == "para-alugar" ? "_locacao" : "_venda"),
              content_name: success.imv_titulo,
              content_type: "product",
              product_catalog_id: 535274536934839,
              currency: "BRL",
              value: $stateParams.tipovar == "a-venda" ? success.imv_preco_venda : $stateParams.tipovar == "para-alugar" ? success.imv_preco_locacao : success.imv_preco_venda,
            });
          }
        }

        vm.listingMini = angular.copy(success);
        vm.listingMini["imgThumb"] = [];
        vm.listing = createThumb.get(success);
        vm.listing = createThumb.get640(vm.listing);
        vm.comodidadeEmp = false;

        for (var i = 0; i < vm.listingMini.comodidades.length; i++) {
          if (vm.listingMini.comodidades[i].gcmd_isemp) {
            vm.comodidadeEmp = true;
            break;
          }
        }

        // initVideo();
        // TAGS

        var statusImovel = {
          em_anuncio: 1,
          em_aprovacao: 2,
          anuncio_pausado: 3,
          reservado: 4,
          em_negociacao: 5,
          recusado: 9,
          locado: 6,
          vendido: 7,
          inativo: 8,
        };
        if (!vm.listing.imv_ativo ||
          [
            statusImovel.em_aprovacao,
            statusImovel.vendido,
            statusImovel.locado,
            statusImovel.inativo,
            statusImovel.recusado,
          ].includes(Number(vm.listing.stai_id))) {
          vm.tag.text = "Poxa, esse imóvel não está mais disponível :(";
          vm.tag.textca = "Poxa, esse imóvel não está mais disponível :(";
          vm.tag.description = "Mas temos outras opções que você vai amar. Deixe seu contato que a nossa equipe encaminha a opção ideal para você!";
          vm.tag.svg = "mudanca";
          vm.tag.hidden = true;
        } else if (moment().diff(moment(vm.listing.createdAt), "days") < 20) {
          if (vm.listing.view_week < 3) vm.tag.text = "Eba, imóvel novinho no site! Você é o primeiro a chegar por aqui.";
          else vm.tag.text = "Eba, imóvel novinho no site!";

          vm.tag.textca = vm.tag.text;
          vm.tag.description = "Esse imóvel tem grandes chances de ser seu! Aproveite para agendar uma visita e conhecê-lo de pertinho.";
          vm.tag.svg = "pin";
          vm.tag.hidden = true;
        } else if (vm.listing.view_week > 11) {
          vm.tag.text = vm.listing.view_week + " pessoas estão de olho neste imóvel";
          vm.tag.textca = "Uau, esse imóvel recebeu " + vm.listing.view_week + " visualizações na última semana.";
          vm.tag.description = "Mas ele ainda pode ser seu! Adiante-se e marque uma visita para conferir de pertinho todos os detalhes.";
          vm.tag.svg = "busca";
          vm.tag.hidden = true;
        }

        if ($window.innerWidth > 997) {
          angular.element(window).scroll(function (e) {
            if (angular.element(window).scrollTop() > 125) {
              angular.element(".tag-msg").addClass("tag-show");
            } else {
              angular.element(".tag-msg").removeClass("tag-show");
            }
          });
        }

        // Ordena as fotos para o
        vm.tipoFotos = vm.listing["imgThumb"].reduce(function (acc, x) {
          // REGRA - Retira o tipo 'Foto'
          // O mesmo será utilizado apenas para a visualização da fotoHeader e fotoFooter
          if (x["tipo_foto"] && x["tipo_foto"]["tfoto_nome"] != "Foto" && x["tipo_foto"]["tfoto_nome"] != "Planta") {
            (acc[x["tipo_foto"]["tfoto_nome"]] = acc[x["tipo_foto"]["tfoto_nome"]] || []).push(x);
          }
          return acc;
        }, {});

        // Ordena as fotos para o
        vm.fotosPlantas = vm.listing["imgThumb"].reduce(function (acc, x) {
          // REGRA - Retira o tipo 'Foto'
          // O mesmo será utilizado apenas para a visualização da fotoHeader e fotoFooter
          if (x["tipo_foto"] && x["tipo_foto"]["tfoto_nome"] == "Planta") {
            x.titulo = (
              (vm.listing.plantas || []).filter(function (planta) {
                if (!planta.imvpl_foto_planta) return false;
                var img = planta.imvpl_foto_planta.split("/").pop();
                return x.imvft_url.includes(img);
              })[0] || {}
            ).imvpl_titulo;
            (acc[x["tipo_foto"]["tfoto_nome"]] = acc[x["tipo_foto"]["tfoto_nome"]] || []).push(x);
          }
          return acc;
        }, {});
        // debugger;
        // vm.fotosDecorado = vm.listing['imgThumb'].reduce(function (acc, x) {
        //   // REGRA - Retira o tipo 'DECORADO'
        //   // O mesmo será utilizado apenas para a visualização da fotoHeader e fotoFooter
        //     if(x['tipo_foto'] && x['tipo_foto']['tfoto_nome'] == 'Decorado'){
        //       return x
        //     }

        //   }, {});

        $timeout(function () {
          var owl = $(".owl-carousel");

          owl.on("translate.owl.carousel", function (event) {
            var lazy;
            var last = $(event.target).find(".owl-item.active").last();
            lazy = last.next().find("img");
            if (lazy.data("img")) {
              lazy.attr("src", lazy.data("img"));
              lazy.removeAttr("data-img");
            }
          });
        });

        vm.galeriaLen = Object.keys(vm.tipoFotos);

        // Show Informações da imobiliaria
        var configWL = $rootScope.ConfigWhiteLabel;
        vm.config_wl = configWL;

        var crmSize = vm.config_wl.imb_config_site.image_size;

        var imgSize = crmSize >= 110 ? 105 : (parseInt(crmSize, 10) + 20);
        vm.topSize = imgSize ? (imgSize + 'px') : '72px';

        vm.showimobiliaria = !configWL.isArbo && vm.listing.imb_id != configWL.id ? false : true;

        angular.forEach(
          vm.listing.imgThumb,
          function (v, k) {
            if (k !== 0) {
              this.push(v);
            }
          },
          vm.listingMini["imgThumb"]
        );
        vm.listingMini.imgThumb.push(vm.listing.imgThumb[0]);

        angular.element(".carousel").bcSwipe({ threshold: 50 });

        /* Imagens jsonLd  */
        var image = new Image();
        var photos = [];
        if (vm.listing.fotos && vm.listing.fotos.length > 0) {
          image.src = vm.listing.imgThumb640[0].imvft_url;
          angular.forEach(vm.listing.fotos, function (v, k) {
            photos.push({
              "@type": "ImageObject",
              contentUrl: v.imvft_url,
            });
          });
        } else {
          image.src = "../../assets/images/novosite/fallback.png";
        }

        /* Valor jsonLd */
        var preco;
        if (vm.listing.imv_preco_venda) {
          preco = vm.listing.imv_preco_venda;
        } else {
          preco = vm.listing.imv_preco_locacao;
        }

        /* criando ngMeta */

        /* Descrição Padrão */
        // vm.listing.imv_obs = vm.listing.imv_obs ? vm.listing.imv_obs.split(" - MEEnviado")[0].split("___")[0] : ''; // READ: AQUI SPLIT
        vm.listing.imv_obs = vm.listing.imv_obs ? vm.listing.imv_obs.split(" - MEEnviado")[0] : "";
        // vm.listing.imv_obs += '\n\n\n '+vm.listing.tipo_imovel.timv_nome+' para '+(vm.listing.imv_preco_locacao ? 'Aluguel' : 'Venda')+' em região valorizada do bairro '+vm.listing.imv_bairro+' , em '+vm.listing.imv_cidade+'.\n'+
        // 'Não encontrou o que procurava ou deseja mais informações sobre '+vm.listing.tipo_imovel.timv_nome+' em '+vm.listing.imv_cidade+'? Entre'+
        // 'em contato com nossa equipe pelo telefone 4003-3793.\n'+
        // 'A '+configWL.nome+' tem mais opções de apartamentos, casas residenciais e comerciais, sobrados,'+
        // 'terrenos, lojas e barracões para venda ou locação, além de empreendimentos em construção'+
        // 'ou lançamentos na planta em '+vm.listing.imv_bairro+' e em outras regiões de '+vm.listing.imv_cidade+' . Aqui você encontra'+
        // 'milhares de ofertas para encontrar o imóvel que mais combina com seu estilo de vida.\n'+
        // 'Compre, venda ou alugue seu imóvel de forma totalmente online na '+configWL.nome+', com segurança e tranquilidade.\n'+
        // 'Na  '+configWL.nome+' você consegue comprar ou alugar um imóvel em '+vm.listing.imv_cidade+' mesmo não'+
        // 'estando na cidade e com a praticidade de fazer tudo online, direto do seu computador ou'+
        // 'smartphone. Nós criamos soluções inovadoras para simplificar a relação de proprietários,'+
        // 'inquilinos e compradores com o mercado imobiliário.\n'+
        // 'Tem um imóvel para venda ou locação em '+vm.listing.imv_cidade+' ? Anuncie na  '+configWL.nome+'! É fácil, rápido e'+
        // 'gratuito! A  '+configWL.nome+' é uma imobiliária digital com imóveis em diversas cidades do Brasil, incluindo '+vm.listing.imv_cidade+' .\n'+
        // 'Na  '+configWL.nome+' você consegue vender ou alugar seu imóvel muito mais rápido do que em imobiliárias tradicionais.\n'+
        // 'Já vendemos e locamos diversos imóveis em '+vm.listing.imv_cidade+' , especialmente em '+vm.listing.imv_bairro+' . Isso'+
        // 'porque temos uma equipe de marketing digital focada em produzir campanhas específicas para'+
        // ''+vm.listing.imv_cidade+' , o que aumenta muito o número de contatos interessados e tendo como'+
        // 'consequência uma maior chance de vender ou alugar seu imóvel mais rápido. Contamos'+
        // 'também com um time de programadores, corretores treinados e uma central de atendimento'+
        // 'preparada para atender proprietários e inquilinos.';

        // debugger;

        if (vm.listing.imb_id === 71) {
          // var prefix = vm.listing.imv_obs.split('Negociação')[0];
          vm.listing.imv_obs +=
            "\n\nNegociação: Estuda propostas conforme sua forma de pagamento.\n\nAGENDE AGORA uma visita pelo site, ou entre em contato com nosso canal exclusivo de atendimento total ao cliente: +554799930-9000.\n\nTrabalhamos exclusivamente nas regiões mais valorizadas de Balneário Camboriú e Praia Brava - Itajaí.\n\nA CR imóveis é especializada em vendas e trabalha apenas como imóveis documentados e tem processo de qualificação de carteira com intuito e de lhe apresentar as melhores opções para aquisição e investimento, seu presidencial ou comercial.\n\nTemos diversas opções de imóveis prontos, mobiliados, em construção e projetos em fase de lançamentos, atrativos para investimento. Somos credenciados oficialmente pelas melhores e principais construtoras do mercado local, gerando negócios prósperos com segurança e qualidade alinhado com objetivo de cada cliente.\n\nPrezando sempre por segurança e transparência temos um time para dar suporte e gerar satisfação para nossos clientes, contando também com assessoria jurídica entre as 500 mais desejadas do Brasil em 2018.\n\nOferecemos a possibilidade de negociar imóveis de forma totalmente online na CR Imóveis, com segurança, tranquilidade e agilidade. Na CR Imóveis você consegue comprar um imóvel em Balneário Camboriú e Praia Brava mesmo não estando na cidade e com a praticidade de fazer tudo online, direto do seu computador ou smartphone. Nós criamos e cada vez mais buscamos soluções inovadoras para simplificar para você.\n\nCaso tenha um imóvel a venda, converse com nosso time, entenda nossos benefícios e premissas para trabalhar e nos dedicarmos ao seu imóvel.A CR Imóveis se preocupa com seu patrimônio, busca a estratégia certa para atingir seu objetivo, aplicando ações de marketing, gerando conteúdo com nossa jornalista, fotos profissionais para imóvel com pontuação elevada e campanhas específicas, o que aumenta muito o número de contatos interessados e tendo como consequência uma maior chance de vender seu imóvel mais rápido. Contamos também com um time de programadores, corretores treinados e especializados e ainda uma central de atendimento preparada para atender proprietários, clientes e imobiliárias parceiras que auxiliam a fomentar negócios ideais para nossos clientes.\n\nCaso não tenha encontrado a informação ou imóvel que procurava, nos avise, nos iremos te ajudar até encontrar o negócio ideal para você!!\n\nCR Imóveis seu melhor negócio.\n\nAtendimento total ao cliente: +55 47 99930-9000 (WhatsApp).\n\nConheça o imóvel: Ligue (47) 3360-0107 ou (47) 3263-0110, agende uma visita e encante-se com o empreendimento.Informativo: Os preços, disponibilidades e condições de pagamento poderão ser alterados sem prévia comunicação.\n\nhttp://blog.crimoveisbc.com.br";
        } else {
          vm.listing.imv_obs +=
            "\n\n\n " +
            vm.listing.tipo_imovel.timv_nome +
            " para " +
            (vm.listing.imv_preco_locacao ? "Aluguel" : "Venda") +
            " em região valorizada do bairro " +
            vm.listing.imv_bairro +
            ", em " +
            vm.listing.imv_cidade +
            "." +
            "Não encontrou o que procurava ou deseja mais informações sobre " +
            vm.listing.tipo_imovel.timv_nome +
            " em " +
            vm.listing.imv_cidade +
            "? Entre em contato com nossa equipe " +
            (configWL.telefones && configWL.telefones[0] ? "pelo telefone " + configWL.telefones[0].numero : "") +
            "." +
            "\n\n" +
            "A " +
            configWL.nome +
            " tem as melhores opções de imóveis para " +
            (configWL.imb_config_site.tipo_imob == 1 ? "venda" : configWL.imb_config_site.tipo_imob == 2 ? "locação" : "venda ou locação") +
            ", " +
            "além de empreendimentos em construção ou lançamentos na planta em " +
            vm.listing.imv_bairro +
            " e em outras regiões de " +
            vm.listing.imv_cidade +
            ". Aqui você encontra milhares de ofertas para encontrar o imóvel que mais combina com seu estilo de vida." +
            "\n\n" +
            "Negocie seu imóvel de forma totalmente online na " +
            configWL.nome +
            " , com segurança e tranquilidade. " +
            "Na " +
            configWL.nome +
            " você consegue " +
            (configWL.imb_config_site.tipo_imob == 1 ? "comprar" : configWL.imb_config_site.tipo_imob == 2 ? "alugar" : "comprar ou alugar") +
            " um imóvel em " +
            vm.listing.imv_cidade +
            " mesmo não estando na cidade e com a praticidade de fazer tudo online, direto do seu computador ou smartphone." +
            "Nós criamos soluções inovadoras para simplificar a relação de proprietários, inquilinos e compradores com o mercado imobiliário." +
            "\n\n";
          vm.listing.imv_obs +=
            "Anuncie seu imóvel! É fácil, rápido e gratuito! A " +
            configWL.nome +
            " é uma imobiliária digital com imóveis em diversas cidades do Brasil, incluindo " +
            vm.listing.imv_cidade +
            "." +
            "\n\n" +
            "Na " +
            configWL.nome +
            " você consegue " +
            (configWL.imb_config_site.tipo_imob == 1 ? "vender" : configWL.imb_config_site.tipo_imob == 2 ? "alugar" : "vender ou alugar") +
            " seu imóvel muito mais rápido do que em imobiliárias tradicionais. " +
            "Já " +
            (configWL.imb_config_site.tipo_imob == 1 ? "vendemos" : configWL.imb_config_site.tipo_imob == 2 ? "locamos" : "vendemos e locamos") +
            " diversos imóveis em " +
            vm.listing.imv_cidade +
            ", especialmente em " +
            vm.listing.imv_bairro +
            ". " +
            "Isso porque temos uma equipe de marketing digital focada em produzir campanhas específicas para " +
            vm.listing.imv_cidade +
            ", " +
            "o que aumenta muito o número de contatos interessados e tendo como consequência uma maior chance de " +
            (configWL.imb_config_site.tipo_imob == 1 ? "vender" : configWL.imb_config_site.tipo_imob == 2 ? "alugar" : "vender ou alugar") +
            " seu imóvel mais rápido. " +
            "Contamos também com um time de programadores, corretores treinados e uma central de atendimento preparada para atender proprietários e inquilinos.";
        }

        var desc = $rootScope.ConfigWhiteLabel.descricao_site;
        var nome = $rootScope.ConfigWhiteLabel.nome;
        // ngMeta.setTitle(vm.listing.imv_titulo + ' - ' + nome);
        // ngMeta.setTag('og:title', vm.listing.imv_titulo + ' - ' + nome);
        // ngMeta.setTag('description', vm.listing.imv_obs);
        // ngMeta.setTag('og:description', vm.listing.imv_obs);
        ngMeta.setTag("type", "BuyAction");
        // ngMeta.setTag('image', image.src);
        // ngMeta.setTag('og:image', image.src);
        // ngMeta.setTag('og:image:width', 640);
        // ngMeta.setTag('og:image:height ', 640);
        // ngMeta.setTag('og:url', $location.absUrl());
        var slug = $location.absUrl().split("?")[0];
        seoService.generateTags({
          title: vm.listing.imv_titulo + " - " + nome,
          description: vm.listing.imv_obs,
          image: image.src,
          slug: slug,
          canonical: "https://" + $location.host() + "/imovel/" + vm.listing.imv_cod_gaia,
          amphtml: "https://" + $location.host() + "/imovel/" + vm.listing.imv_cod_gaia + "/amp",
        });

        seoService.ldJJsonImovel(vm.listing, slug);
        // console.log(vm.listing);

        if (vm.timv_id === 3 || vm.timv_id === 2 || vm.timv_id === 1 || vm.timv_id === 10 || vm.timv_id === 11 || vm.timv_id === 13 || vm.timv_id === 9 || vm.timv_id === 12 || vm.timv_id === 23 || vm.timv_id === 24 || vm.timv_id === 25) {
          if (vm.timv_id === 3 || vm.timv_id === 2 || vm.timv_id === 9 || vm.timv_id === 12) {
            vm.accommodation = "https://schema.org/House";
          } else {
            vm.accommodation = "https://schema.org/Apartment";
          }
        } else {
          vm.accommodation = "https://schema.org/Accommodation";
        }

        var url = $location.absUrl();
        // debugger;

        if (PROD) {
          // Google PageView
          // gtag('config', 'UA-91552221-1');

          var lis = $stateParams.tipovar == "a-venda" ? success.imv_cod_gaia + "_SALE" : $stateParams.tipovar == "para-alugar" ? success.imv_cod_gaia + "_RENT" : success.imv_cod_gaia + "_SALE";
          // PAGE_VIEW OFFERDETAIL
          gtag("event", "page_view", {
            listing_id: lis,
            listing_pagetype: "offerdetail",
          });
        }

        // /* criando jsonLd */
        // var jsonLd = {
        //   "@context": "https://schema.org",
        //   "@type": "BuyAction",
        //   "price": preco,
        //   "priceSpecification": {
        //     "@type": "PriceSpecification",
        //     "priceCurrency": "BRL"
        //   },
        //   "seller": {
        //     "@type": "RealEstateAgent",
        //     "name": nome,
        //     "image": image.src,
        //     "url": "",
        //     "address": $rootScope.ConfigWhiteLabel.endereco ? $rootScope.ConfigWhiteLabel.endereco : "",
        //     "priceRange": preco,
        //     "telephone": ($rootScope.ConfigWhiteLabel.telefones && $rootScope.ConfigWhiteLabel.telefones.length) ? $rootScope.ConfigWhiteLabel.telefones[0].numero : "",
        //   },
        //   "object": {
        //     "@type": "SingleFamilyResidence",
        //     "@id": vm.listing.id,
        //     "name": nome + ' - ' + vm.listing.imv_titulo,
        //     "url": $location.absUrl(),
        //     "description": vm.listing.imv_obs,
        //     "geo": {
        //       "@type": "GeoCoordinates",
        //       "latitude": vm.listing.imv_location.lat,
        //       "longitude": vm.listing.imv_location.lng
        //     },
        //     "address": {
        //       "streetAddress": vm.listing.imv_endereco,
        //       "addressLocality": vm.listing.imv_cidade,
        //       "addressRegion": vm.listing.imv_estado,
        //       "addressCountry": {
        //         "@type": "Country",
        //         "name": "BR"
        //       },
        //       "postalCode": vm.listing.imv_cep,
        //     },
        //     "photo": photos
        //   }
        // }

        // // console.log($rootScope);

        // var scriptTag = angular.element("<script>");
        // scriptTag.attr("type", "application/ld+json");
        // scriptTag.attr("id", "jsonld");
        // scriptTag.append(JSON.stringify(jsonLd));
        // angular.element('head').append(scriptTag);

        // vm.form.formData.codigo_anuncio = vm.listing.imv_cod_gaia;

        /* Imoveis Relacionados */
        var _search = {
          timv_id: vm.listing.timv_id,
          imv_latitude: vm.listing.imv_latitude,
          imv_longitude: vm.listing.imv_longitude,
          preco_type: $stateParams.tipovar ? $stateParams.tipovar : vm.listing.imv_preco_venda && vm.listing.imv_preco_venda > 0 ? "a-venda" : "para-alugar",
          imv_qtd_dorm: vm.paramsCampain && vm.paramsCampain.match("dormitorios") ? vm.listing.imv_qtd_dorm : null,
          id: vm.listing.id,
        };

        //Se não vier nada na url, dar prioridade para venda
        _search.preco = _search.preco_type == "a-venda" ? vm.listing.imv_preco_venda : vm.listing.imv_preco_locacao;

        Imovel.relacionados(
          _search,
          function (succ) {
            vm.relacionados = [];
            angular.forEach(succ, function (v, k) {
              v.tipovar = $stateParams.tipovar;
              vm.relacionados.push(createThumb.get(v));
            });

            if (vm.favorites) {
              for (var i = 0; i < vm.relacionados.length; i++) {
                for (var j = 0; j < vm.favorites.length; j++) {
                  if (vm.relacionados[i].imv_cod_gaia == vm.favorites[j]) {
                    vm.relacionados[i].isFavorite = true;
                  }
                }
              }
            }

            setTimeout(function () {
              // $('#carousel-similares').owlCarousel({
              //   margin: 10,
              //   dots: false,
              //   loop: false,
              //   nav: false,
              //   responsiveClass: true,
              //   responsive: {
              //     0: {
              //       items: 1.2,
              //       loop: true
              //     },
              //     700: {
              //       items: 2.3,
              //     },
              //     980: {
              //       items: 3.2,
              //     },
              //     1280: {
              //       items: 4.3,
              //     },
              //     1600: {
              //       items: 5.3
              //     }
              //   }
              // });

              angular.element('#carousel-imagem').lightGallery({
                selector: '.image-box',
                download: false,
              });


              angular.element('.carousel-imovel').lightGallery({
                selector: '.image-box',
                download: false,
              });
            }, 1300);
          },
          function (error) {
            // vm.refreshing = false;
            console.error("error", error);
          }
        );

        if (vm.favorites) {
          for (var i = 0; i < vm.favorites.length; i++) {
            if (vm.favorites[i] == vm.listing.imv_cod_gaia) {
              vm.listing.isFavorite = true;
            }
          }
        }

        hasExtraExpenses();

        // }, function (err) {
        //   console.error(err);
        // });

        // Fecha o card de valores ao clicar fora
        // angular.element('#main-content').click(function (e) {
        //   if (angular.element('#navbarCollapse').hasClass('show')) {
        //     e.preventDefault();
        //     e.stopPropagation();

        //     angular.element('#navbarCollapse').collapse("hide");
        //   }
        // });
      }

      var vendaApi = null;

      vm.readyVenda = function (api) {
        vendaApi = api;
      };

      vm.galerianextOwl = function (i) {
        $("#carousel-" + i + " .owl-carousel").trigger("next.owl.carousel");
      };

      vm.galeriaprevOwl = function (i) {
        $("#carousel-" + i + " .owl-carousel").trigger("prev.owl.carousel");
      };

      vm.owlPropertiesGaleria = {
        loop: false,
        nav: false,
        dots: false,
        lazyLoad: true,
        margin: 2,
        mouseDrag: false, // TESTE
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            stagePadding: 12,
          },
          768: {
            items: 2,
          },
          994: {
            items: 3,
          },
        },
      };

      vm.checkPlantas = function () {
        return JSON.stringify(vm.listing.imv_plantas) !== "[{}]";
      };

      vm.setURLPhoto = function (foto) {
        var url = "";
        url = (
          vm.listing.imgFull.filter(function (el) {
            if(!el.imvft_url) return false
            var img = foto.imvft_url.split("/").pop();
            return el.imvft_url.includes(img);
          })[0] || {}
        ).imvft_url;

        return vm.trustSrc(url);
      };

      vm.setURLPhotoPlantas = function (foto) {
        var url = foto.imvpl_foto_planta;
        return vm.trustSrc(url);
      };

      vm.checknavGaleria = function (fotos) {
        var pageWidth = angular.element("body").outerWidth();

        if (pageWidth > 994 && fotos.length > 3) return true;
        if (pageWidth > 768 && pageWidth <= 994 && fotos.length > 2) return true;
        if (pageWidth <= 768 && fotos.length > 1) return true;
        return false;
      };

      var imgsqtd = vm.listing.imgFull.length >= 3 ? 3 : vm.listing.imgFull.length == 1 ? 1 : 4;

      if (vm.listing.imgFull.length === 2) {
        vm.listing.imgFull.push([]);
        vm.listing.imgFull.unshift([]);
      }

      vm.properties = {
        loop: false,
        nav: false,
        dots: false,
        mouseDrag: false,
        margin: 2,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 2,
          },
          994: {
            items: imgsqtd,
          },
        },
      };

      var imagensApi = null;

      vm.readyImagens = function (api) {
        imagensApi = api;
      };

      vm.nextImageOwl = function (ev) {
        imagensApi.trigger("next.owl.carousel");
      };

      vm.prevImageOwl = function (ev) {
        imagensApi.trigger("prev.owl.carousel");
      };

      function initComodidades(tipo) {
        var comodidade = [];
        // TODO : Identificar padrão e minimizar o código abaixo

        // Tipos que nao possuem comodidades
        if ([35].includes(tipo)) return comodidade;
        // Sobrado | Casa | Terreno | Chácara | Pousada
        if ([2, 3, 4, 9, 12].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_area_total,
            label: "Área total",
            tipo: 1,
            icon: "fa-expand",
          });
        }
        var namesuite;
        if (vm.imovel.imv_qtd_suite != null && vm.imovel.imv_qtd_suite > 0) {
          namesuite = vm.imovel.imv_qtd_suite > 1 ? " suítes" : " suíte";
          namesuite = " ( " + vm.imovel.imv_qtd_suite + namesuite + " )";
        } else namesuite = "";
        // Apartamento | Sobrado | Casa | Cobertura | Chácara
        // Apartamento Duplex | Kitnet | Pousada | Apartamento Triplex
        if ([1, 2, 3, 7, 9, 10, 11, 12, 13].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_qtd_dorm + namesuite,
            label: "Dormitórios",
            icon: "fa-bed",
          });
        }

        // Apartamento | Sobrado | Casa | Barracão | Loja | Cobertura | Sala
        // Chácara | Apartamento Duplex | Kitnet | Pousada | Apartamento Triplex
        if ([1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_qtd_banheiros,
            label: "Banheiros",
            icon: "fa-shower",
          });

          comodidade.push({
            data: vm.imovel.imv_area_util,
            label: "Área util",
            tipo: 1,
            icon: "fa-ruler-triangle",
          });
        }

        // Apartamento | Loja | Cobertura | Sala | Apartamento Duplex | Kitnet | Apartamento Triplex
        if ([1, 6, 7, 8, 10, 11, 13].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_qtd_vagas,
            label: "Garagem",
            icon: "fa-car",
          });
        }

        // Barracão | Loja | Sala
        if ([5, 6, 8].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_qtd_cozinhas,
            label: "Cozinha",
            icon: "fa-utensils",
          });
        }

        // Terreno
        if ([4].includes(tipo)) {
          comodidade.push({
            data: vm.imovel.imv_topografia,
            icon: "fa-expand-alt",
          });
        }

        // DEFAULT
        if (!comodidade.length) {
          comodidade.push({
            data: vm.imovel.imv_area_total,
            label: "Área total",
            tipo: 1,
            icon: "fa-expand",
          });

          comodidade.push({
            data: vm.imovel.imv_area_util,
            label: "Área util",
            tipo: 1,
            icon: "fa-ruler-triangle",
          });

          comodidade.push({
            data: vm.imovel.imv_qtd_banheiros,
            label: "Banheiros",
            icon: "fa-shower",
          });

          comodidade.push({
            data: (vm.imovel.imv_qtd_dorm || '-') + namesuite,
            label: "Dormitórios",
            icon: "fa-bed",
          });
        }

        return comodidade;
      }
      var paramsCampain = localStorage.getItem("params_campain") || null;
      vm.openVisit = function (data, contato) {
        swangular.open({
          animation: false,
          showCloseButton: true,
          showConfirmButton: false,
          html: '<div class="slide-animate" ng-include="\'app/components/listingDetail/modalVisit.html\'"></div>',
          width: "auto",
          controllerAs: "vm",
          controller: "AgendamentoController",
          resolve: {
            listingImovel: function () {
              return {
                imovel: vm.listing,
                contatar: contato,
              };
            },
          },
        });
      };

      vm.openShare = function (e) {
        swangular.open({
          animation: false,
          showCloseButton: true,
          showConfirmButton: false,
          html: '<div class="slide-animate" ng-include="\'app/components/listingDetail/share.html\'"></div>',
          width: "auto",
          controller: [
            "$scope",
            "$location",
            "FACEBOOK_APP_ID",
            function ($scope, $location, FACEBOOK_APP_ID) {
              var imv_url = ($location.absUrl() || "").split("?")[0];
              var textWhats = "Encante-se por esse imóvel em " + vm.listing.imv_cidade + "\n\nImóvel: " + vm.listing.imv_cod_gaia + "\n" + imv_url + "?utm_source=compartilhamento-site&utm_media=WhatsApp";

              $scope.urlFacebook = "https://www.facebook.com/dialog/share?app_id=" + FACEBOOK_APP_ID + "&display=page&href=" + encodeURIComponent(imv_url + "?utm_source=compartilhamento-site&utm_media=Facebook");
              $scope.urlTwitter = "http://twitter.com/share?url=" + encodeURIComponent(imv_url + "?utm_source=compartilhamento-site&utm_media=Twitter");
              $scope.urlMessenger = "fb-messenger://share/?app_id=" + FACEBOOK_APP_ID + "&link=" + encodeURIComponent(imv_url);
              $scope.urlMail = "mailto:?body=" + encodeURIComponent("Dê uma olhada neste imóvel! " + imv_url + "?utm_source=compartilhamento-site&utm_media=Email");
              $scope.urlWhatsapp = "https://api.whatsapp.com/send?text=" + encodeURIComponent(textWhats);

              $scope.copyPaste = copyPaste;
              $scope.textCopy = null;

              function copyPaste() {
                var range, textArea, selection;

                // Create textarea element
                textArea = document.createElement("textarea");

                // Set the value of the text
                textArea.value = imv_url;

                // Make sure we cant change the text of the textarea
                textArea.setAttribute("readonly", "");

                // Hide the textarea off the screnn
                textArea.style.position = "absolute";
                textArea.style.left = "-9999px";

                // Add the textarea to the page
                document.body.appendChild(textArea);

                if (navigator.userAgent.match(/ipad|iphone/i)) {
                  range = document.createRange();
                  range.selectNodeContents(textArea);
                  selection = window.getSelection();
                  selection.removeAllRanges();
                  selection.addRange(range);
                  textArea.setSelectionRange(0, 999999);
                } else {
                  textArea.select();
                }

                var success = document.execCommand("Copy"); //Copy
                textArea.remove();
                $scope.textCopy = success ? "Link copiado" : null;

                $timeout(function () {
                  $scope.textCopy = null;
                }, 1800);
              }
            },
          ],
        });
      };

      vm.owlProperties = {
        loop: false,
        nav: false,
        margin: 10,
        dots: false,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            stagePadding: 22,
          },
          700: {
            items: 2,
            stagePadding: 25,
          },
          980: {
            items: 3,
          },
          1280: {
            items: 4,
          },
        },
      };

      // angular.element(document).ready(function () {
      //   $('#header').addClass('fixed-theme');
      //   var carousel1 = $('#carousel-detail');
      //   var carousel2 = $('#carousel-detail-mini');

      //   carousel1.on('slide.bs.carousel', function (event) {
      //     var to = $(event.relatedTarget).index();

      //     var items = carousel1.find(".carousel-item");
      //     var lazy = carousel1.find(".carousel-item.active");

      //     var items2 = carousel2.find(".carousel-item");
      //     var lazy2 = carousel2.find(".carousel-item.active");

      //     if (lazy.index() == 0 && to == (items.length - 1)) {
      //       lazy = items.last();
      //       lazy2 = items2.last();
      //     }
      //     else if (lazy.index() == -1 && to == 0) {
      //       lazy = items.first();
      //       lazy2 = items2.first();
      //     }
      //     else if (lazy.index() > to) {
      //       lazy = lazy.prev();
      //       lazy2 = lazy2.prev();
      //     }
      //     else {
      //       lazy = lazy.next();
      //       lazy2 = lazy2.next();
      //     }
      //     if(lazy.find('img').data('img')){
      //       lazy.find('img').attr("src",  lazy.find('img').data('img'));
      //       lazy.find('img').removeAttr('data-img');
      //     }

      //     if(lazy2.find('img').data('img')){
      //       lazy2.find('img').attr("src",  lazy2.find('img').data('img'));
      //       lazy2.find('img').removeAttr('data-img');
      //     }

      //     lazy.click(); // Para abrir o Carousel LightGallery
      //     carousel2.carousel(to);
      //   });

      //   angular.element('.carousel').bcSwipe({ threshold: 50 });
      // })

      // $('.btn-more').click(function () {
      //   // angular.element('.info-desc').addClass('expand');
      //   // $(this).addClass('d-none')

      //   angular.element('.info-desc').toggleClass('expand');

      //   var btn = $(this);

      //   btn.toggleClass('change-text');
      //   var text = btn.hasClass('change-text') ? 'Esconder texto <i class="fal fa-chevron-up"></i>' : 'Leia mais <i class="fal fa-chevron-down"></i>';
      //   btn.html(text);
      // });

      vm.nextOwl = function (ev) {
        vendaApi.trigger("next.owl.carousel");
      };

      vm.prevOwl = function (ev) {
        vendaApi.trigger("prev.owl.carousel");
      };

      // if (window.innerWidth > 992) {
      //   var originalPosition = $('#valores').position().top + 110;
      //   var timer;
      //   var _scrollFn = function () {
      //     clearTimeout(timer);
      //     timer = setTimeout(function () {
      //       $('#valores').css('position', 'absolute');
      //       // $('#valores').css('right', '65px');

      //       if (window.innerWidth > 1199) {
      //         var dih = $('#valores-container').height();
      //         var di_top = $('#valores-container').position().top;
      //       } else {
      //         var dih = $('.informations').height();
      //         var di_top = $('.informations').position().top;
      //       }

      //       var cx_height = $('#valores').height();
      //       var y_offset = window.pageYOffset;

      //       var newHeight = Math.max(originalPosition,
      //         Math.min(dih + di_top - cx_height,
      //           Math.max(originalPosition, y_offset + 10)));
      //       $('#valores').css({ top: newHeight });
      //     }, 0);
      //   };
      //   _scrollFn()

      //   $(window).scroll(_scrollFn);

      //   $scope.$on('$destroy', function () {
      //     $(window).unbind('scroll', _scrollFn);
      //   });

      // }
      // ===============================================================

      // var API_URL = 'http://www.arboimoveis.com/api/';
      // var URL_API = 'http://192.168.0.60:3000/api/';
      // var hostName = window.location.hostname;
      // if (hostName == "localhost" || hostName == "127.0.0.1" || hostName.indexOf('192') != -1) {
      //   var API_URL = 'http://' + hostName + ':3000/api/';
      // } else {
      //   var API_URL = 'https://' + hostName.replace("app.", "api.") + '/api/';
      // }

      // ===============================================================

      // vm.saibamais = function() {
      //   var card = document.querySelector('.card-flip');
      //   card.classList.toggle('is-flipped');
      // };

      // ========= Datapicker ==========================================
      // vm.datesPage = 0;
      // vm.timesPage = 0;

      // var startDate = new Date();
      // vm.dates = getDates(startDate, 30);

      // vm.form.formData.visita_data = vm.dates[1].date;
      // vm.numElements = 3;
      // setTempDates(vm.numElements);

      // vm.times = getTimes();
      // vm.form.formData.visita_hora = vm.times[1].time;
      // setTempTimes(vm.numElements);

      function isMobile() {
        var pageWidth = angular.element("body").outerWidth();
        return pageWidth < 767;
      }
      function isTablet() {
        var pageWidth = angular.element("body").outerWidth();
        return pageWidth < 992;
      }
      function readMoreDescription() {
        if (vm.readMore) {
          $anchorScroll.yOffset = 100;
          $anchorScroll("title-all-infos");
        }
        vm.readMore = !vm.readMore;
      }
      function goToAllInfo() {
        // vm.
      }
      // this.scrollTo = function(container, anchor) {
      //   var element = angular.element(anchor);
      //   angular.element(container).animate({scrollTop: element.offset().top}, "slow");
      // }
      // $scope.scrollTo = function(id) {

      //   // Pass the 'id' as the parameter here, the page will scroll
      //   // to the correct place and the URL will remain intact.
      //   if()
      //   $anchorScroll(id);
      // }
      // function setTempDates(numElements) {
      //   vm.tempDates = [];
      //   for (var i = 0; i < numElements; i++) {
      //     vm.tempDates.push(vm.dates[vm.datesPage * numElements + i]);
      //   }
      // }

      // function setTempTimes(numElements) {
      //   vm.tempTimes = [];
      //   for (var i = 0; i < numElements; i++) {
      //     vm.tempTimes.push(vm.times[vm.timesPage * numElements + i]);
      //   }
      // }

      // function getDates(startDate, daysToAdd) {
      //   var dates = [];
      //   for (var i = 0; i < daysToAdd; i++) {
      //     var currentDate = new Date();
      //     currentDate.setDate(startDate.getDate() + i + 1);
      //     dates.push({ date: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()), dayOfWeek: dayAsString(currentDate.getDay()), day: ("0" + currentDate.getDate()).slice(-2), month: ("0" + (currentDate.getMonth() + 1)).slice(-2) });
      //   }
      //   return dates;
      // }

      // function getTimes() {
      //   var times = [
      //     { time: '09:00' }, { time: '09:15' }, { time: '09:30' },
      //     { time: '09:45' }, { time: '10:00' }, { time: '10:15' },
      //     { time: '10:30' }, { time: '10:45' }, { time: '11:00' },
      //     { time: '11:15' }, { time: '11:30' }, { time: '11:45' },
      //     { time: '12:00' }, { time: '12:15' }, { time: '12:30' },
      //     { time: '12:45' }, { time: '13:00' }, { time: '13:15' },
      //     { time: '13:30' }, { time: '13:45' }, { time: '14:00' },
      //     { time: '14:15' }, { time: '14:30' }, { time: '14:45' },
      //     { time: '15:00' }, { time: '15:15' }, { time: '15:30' },
      //     { time: '15:45' }, { time: '16:00' }, { time: '16:15' },
      //     { time: '16:30' }, { time: '16:45' }, { time: '17:00' },
      //     { time: '17:15' }, { time: '17:30' }, { time: '17:45' }
      //   ];
      //   return times;
      // }

      // $scope.$watch('vm.datesPage', function (newValue, oldValue) {
      //   if (newValue < 0) vm.datesPage = 0;
      //   else if (newValue > (vm.dates.length / vm.numElements) - 1) vm.datesPage = oldValue;

      //   if (newValue !== oldValue) {
      //     setTempDates(vm.numElements);
      //     vm.form.formDatavisita_data = vm.tempDates[1].date;
      //   }
      // })

      // $scope.$watch('vm.timesPage', function (newValue, oldValue) {
      //   if (newValue < 0) vm.timesPage = 0;
      //   else if (newValue > (vm.times.length / vm.numElements) - 1) vm.timesPage = oldValue;

      //   if (newValue !== oldValue) {
      //     setTempTimes(vm.numElements);
      //     vm.form.formData.visita_hora = vm.tempTimes[1].time;
      //   }
      // })

      // function dayAsString(dayIndex) {
      //   var weekdays = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
      //   return weekdays[dayIndex];
      // }

      function sharePage() {
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + window.location.href, "Arbo imóveis", "width=600,height=400");
      }

      function getLocation() {
        // var url = $location.url().replace('/', '');
        return $location.absUrl();
      }

      // function changeFavorite(imovel) {
      //   !vm.favorites || vm.favorites.indexOf(imovel.imv_cod_gaia) == -1 ? setFavorite(imovel) : unsetFavorite(imovel)
      // }

      // function setFavorite(imovel) {
      //   if (vm.favorites == null || vm.favorites.length == 0) {
      //     vm.favorites = [imovel.imv_cod_gaia];
      //   }
      //   else {
      //     vm.favorites.push(imovel.imv_cod_gaia);
      //   }

      //   $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
      //   imovel.isFavorite = true;
      //   toastr.info('<strong>Imóvel salvo nos favoritos.</strong>', {
      //     iconClass: 'toast-arbo'
      //   });
      // }

      // function unsetFavorite(imovel) {
      //   var index = vm.favorites.indexOf(imovel.imv_cod_gaia);

      //   if (index !== -1) {
      //     vm.favorites.splice(index, 1);
      //     $window.localStorage.setItem('favorites', JSON.stringify(vm.favorites));
      //     imovel.isFavorite = false;
      //   }
      //   toastr.info('<strong>Imóvel retirado dos favoritos.</strong>', {
      //     iconClass: 'toast-arbo'
      //   });
      // }

      // function setTipoNegocio(event, tipo) {
      //   // Se clicar em outro tipo quando já estiver aberto
      //   if (vm.tipoNegocio != undefined && vm.tipoNegocio != tipo) {
      //     event.preventDefault();
      //     event.stopPropagation();
      //     openValoresMobile();
      //     console.log('a');
      //   }
      //   // Se clicar novamente no mesmo tipo
      //   if (vm.tipoNegocio == tipo) {
      //     vm.tipoNegocio = undefined;
      //     closeValoresMobile();
      //     console.log('b');

      //   }
      //   else {
      //     vm.tipoNegocio = tipo;
      //     openValoresMobile();
      //     console.log('c');

      //   }
      // }

      function openValoresMobile() {
        angular.element("#navbar-bottom").addClass("open-valores-mobile");
        angular.element("body").addClass("position-fixed");
      }

      function closeValoresMobile() {
        angular.element("#navbar-bottom").removeClass("open-valores-mobile");
        angular.element("body").removeClass("position-fixed");
      }

      function toggleValoresMobile() {
        angular.element("#navbar-bottom").hasClass("open-valores-mobile") ? closeValoresMobile() : openValoresMobile();
      }

      function hasExtraExpenses() {
        vm.hasExtraExpenses = vm.listing.imv_preco_cond || vm.listing.imv_preco_iptu || vm.listing.imv_preco_seguro;
      }

      vm.goToImob = goToImob;
      function goToImob() {
        var url = "http://" + vm.listing.imobiliaria.imb_url_site.replace("http://", "").replace("https://", "") + "/imoveis";
        $window.open(url, "_blank");
      }

      vm.generateImobLink = generateImobLink;
      function generateImobLink() {
        var imob = vm.listing.imobiliaria;
        var sigla = imob.cidade && imob.cidade.estado && imob.cidade.estado.sigla;
        if (imob && imob.cidade) {
          var texto = "" + textFormatter.urlFormatter(imob.imb_nome) + "-" + textFormatter.urlFormatter(imob.cidade.nome) + "-" + textFormatter.urlFormatter(sigla) + "-" + btoa(imob.id);
          return texto;
        }
        return "";
      }

      Imobiliaria.getImobiliaria(
        {
          where: {
            id: vm.listing.imobiliaria.id,
          },
        },
        function (suc) {
          vm.listing.imobiliaria = suc[0];
        }
      );

      // console.log('imobiliaria: ',vm.listing.imobiliaria);

      //new form contato/visita
      var paramsCampain = localStorage.getItem("params_campain") || null;
      vm.spinner = "<i class='icon fas fa-spinner fa-pulse'></i>";

      vm.stringTime = "";

      vm.submit = function submit(e) {
        e.preventDefault();
        var _copy = angular.copy(vm.form);
        _copy.card_params = paramsCampain;
        _copy.codigo_anuncio = vm.listing.imv_cod_gaia;
        _copy.midia = $location.host();
        _copy.corpo = $location.absUrl();
        _copy.visita_hora = _copy.visita_hora && moment(_copy.visita_hora).format('HH:mm');
        _copy.visita_data = _copy.visita_data && _copy.visita_data.toISOString();
        if(vm.config_wl && !vm.config_wl.isArbo) _copy.forceWhatsapp = true;
        if (vm._id) _copy.id = vm._id;
        vm.loading = true;

        $http({
          method: "POST",
          url: SERVER_URL + "api/cardsimovel/save-card-site",
          headers: {
            "Content-Type": "application/json",
            "Access-Token": "60a156bb175722a22f2d97e6dd6bb762",
          },
          data: _copy,
        })
          .then(function (res) {
            vm.contato = false;
            vm.succ = true;
            vm.msg_submit = "Tudo certo!";

            vm.message = "<p>Legal, recebemos seu contato!</p>\
                          <p>Em breve um corretor estará a sua disposição.</p>";

            if (vm.form.visita_data) {
              //reseta para previnir cagada, mas a cada nova tela ele zera.
              vm._id = null;
              vm.finished = true;
              vm.message =
                '<p>Sua visita foi pré-agendada!</p>\
                            <p class="red">' +
                vm.stringTime.replace("Agendar para dia ", "") +
                '</p>\
                            <p>Aguarde o contato do nosso corretor para confirmar os detalhes.</p>\
                            <img src="https://static-arbo.s3-sa-east-1.amazonaws.com/assets/Calendario.png"></img>\
                            <p>Enquanto isso você pode aproveitar para ver mais imóveis como este em nosso site!</p>';
            } else {
              //salva o id para mandar depois na req
              vm._id = res.data.id;
            }

            if (PROD && vm._id) {
              // Trovit Lead
              $window.ta("send", "lead");

              if (typeof $window.fbq == "function") {
                // FBQ Lead
                $window.fbq("track", "Lead", {
                  content_name: vm.listing.imv_titulo,
                  content_category: /\/a-venda\//g.test($location.path()) ? "venda" : /\/para-alugar\//g.test($location.path()) ? "aluguel" : "venda",
                  currency: "BRL",
                  value: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
                });

                // if(vm.listing.imv_preco_venda){
                // var cids = /\/a-venda\//g.test($location.path()) ? vm.listing.imv_cod_gaia + "_venda" : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_cod_gaia + "_locacao" : vm.listing.imv_cod_gaia + "_venda";
                // $window.fbq("track", "Purchase", {
                //   currency: "BRL",
                //   value: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
                //   content_ids: [cids],
                //   content_type: "product",
                // });
                // }
              }

              var lis = /\/a-venda\//g.test($location.path()) ? vm.listing.imv_cod_gaia + "_SALE" : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_cod_gaia + "_RENT" : vm.listing.imv_cod_gaia + "_SALE";

              if (typeof $window.gtag == "function") {
                // page_view conversionintent
                $window.gtag("event", "page_view", {
                  listing_id: lis,
                  listing_pagetype: "conversionintent",
                  listing_totalvalue: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
                });

                // Leads Analytics
                $window.gtag("event", "lead", {
                  event_category: vm.listing.tipo_imovel && vm.listing.tipo_imovel.timv_nome ? vm.listing.tipo_imovel.timv_nome.toLowerCase() : "imovel",
                  event_label: vm.listing.imv_cod_gaia.split("_")[1] || "ARBO",
                  value: vm.listing.imv_cod_gaia,
                });

                // Lead Analytics TESTE
                $window.gtag("event", "generate_lead");

                // Leads AdW
                $window.gtag("event", "conversion", { send_to: "AW-851855382/Hz5cCOzq7pEBEJaQmZYD" });
              }
            }
          })
          .catch(function (err) {
            console.error(err.mesage);
            vm.error_submit = true;
            vm.msg_submit = "Ocorreu um erro :(";
            $timeout(function () {
              vm.msg_submit = "Tente novamente, por favor!";
            }, 2000);
          })
          .finally(function () {
            $timeout(function () {
              vm.loading = false;
              vm.error_submit = false;
              vm.msg_submit = "";
            }, 2000);
          });
      };

      vm.getMoreDates = function getMoreDates(date) {
        vm.dates = vm.getDates(date);
        return;
      };

      vm.getMoreTimes = function getMoreTimes(time) {
        vm.times = vm.getTimes(time);
        return;
      };

      vm.getMonth = function getMonth(date) {
        var value = date == '' ? moment(new Date()).format('MMMM') : moment(date).format('MMMM')
        return value[0].toUpperCase() + value.slice(1);
      };

      function dayAsString(i) {
        return ["D", "S", "T", "Q", "Q", "S", "S"][i];
      }

      vm.getDayToAdd = function getDayToAdd() {
        if (window.innerWidth < 1500 && window.innerWidth >= 1200)
          return 8;
        if (window.innerWidth <= 1200 && window.innerWidth >= 1024)
          return 6;

        return 7;
      }

      vm.getTimeToAdd = function getTimeToAdd() {
        if (window.innerWidth < 1500 && window.innerWidth >= 1200)
          return 3;
        if (window.innerWidth <= 1200 && window.innerWidth >= 1024)
          return 2;

        return 4;
      }

      vm.getDates = function getDates(startDate, daysToAdd) {
        var days = vm.getDayToAdd();

        daysToAdd = daysToAdd || days;
        startDate = startDate || new Date();

        var dates = [];
        for (var i = 1, d = -3; i <= daysToAdd; i++, d++) {
          var currentDate = new Date();
          currentDate.setTime(startDate.getTime() + 24 * 60 * 60 * 1000 * d);
          dates.push({
            day: ("0" + currentDate.getDate()).slice(-2),
            date: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
            month: ("0" + (currentDate.getMonth() + 1)).slice(-2),
            dayOfWeek: dayAsString(currentDate.getDay()),
          });
        }
        return dates;
      };

      vm.momentFormater = function momentFormater(date, hour) {
        if (!date || !hour) return;
        var _hour = hour.split(":");
        var _date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), _hour[0], _hour[1], 0);
        if (moment().isBefore(_date, "days,hours")) {
          vm.stringTime = moment(_date).format("[Agendar para dia] DD [de] MMMM, dddd [às] LT");
          vm.dateVisita = true;
        } else {
          vm.stringTime = "Ops, essa data não está mais disponível. Por favor, selecione um dia após a data de hoje";
          vm.dateVisita = false;
        }
        return;
      };

      vm.getTimes = function getTimes(from, limit) {
        var limitTime = vm.getTimeToAdd();

        from = from || 0;
        limit = limit || limitTime;

        var times = [
          { index: 1, time: "08:00" },
          { index: 2, time: "08:30" },
          { index: 3, time: "09:00" },
          { index: 4, time: "09:30" },
          { index: 5, time: "10:00" },
          { index: 6, time: "10:30" },
          { index: 7, time: "11:00" },
          { index: 8, time: "11:30" },
          { index: 9, time: "12:00" },
          { index: 10, time: "12:30" },
          { index: 11, time: "13:00" },
          { index: 12, time: "13:30" },
          { index: 13, time: "14:00" },
          { index: 14, time: "14:30" },
          { index: 15, time: "15:00" },
          { index: 16, time: "15:30" },
          { index: 17, time: "16:00" },
          { index: 18, time: "16:30" },
          { index: 19, time: "17:00" },
          { index: 20, time: "17:30" },
          { index: 21, time: "18:00" },
          { index: 22, time: "18:30" },
        ];

        return times.slice(from, from + limit);
      };

      vm.goToAgendar = function goToAgendar(page) {
        //Agendar contato
        if (page === 1) {
          vm.contato = true;
          vm.form = {};
          vm.stringTime = "";
          vm.dateVisita = false;
        } else if (page === 2) {
          //Agendar visita
          vm.contato = false;
          vm.form = {};
          vm.dateVisita = false;
        }
      };
    }
  }
})();

(function () {
  ('use strict');

  angular.module('arboWeb').controller('homeController', homeController);

  // homeController.inject = ['$scope', '$state', 'Imovel', '$rootScope'];

  /** @ngInject */
  function homeController(
    $state,
    $scope,
    $q,
    $http,
    toastr,
    $rootScope,
    textFormatter,
    createThumb,
    Imovel,
    SERVER_URL,
    $timeout,
    $sce,
    seoService,
    $location
  ) {
    var vm = this;
    var params = {};
    var autocomplete = null;
    var input;
    vm.config_wl = $rootScope.ConfigWhiteLabel;
    vm.createThumb = createThumb;
    vm.loaderSearch = false;
    vm.menu = 1;
    vm.subsection = 1;
    vm.placeholder = '';
    vm.new_venda = [
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
    ];
    vm.new_locacao = [
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
    ];
    vm.listingsVenda = [
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
    ];
    vm.listingsLocacao = [
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
      { shimmer: true, fotos: [] },
    ];

    vm.imb_destaques = '';
    var url = SERVER_URL + 'api/imoveis/city-data';
    vm.trustHTML = $sce.trustAsHtml;
    var linksarr = vm.config_wl.configwl || {};
    vm.listopened = [];

    if (typeof linksarr['SECTION-HOME'] === 'string') {
      vm.config_wl.configwl['SECTION-HOME'] = [
        {
          valor: linksarr['SECTION-HOME'],
          update: linksarr['SECTION-HOME_update'],
        },
      ];
    }

    if (typeof linksarr['SECTION-FOOTER'] === 'string') {
      vm.config_wl.configwl['SECTION-FOOTER'] = [
        {
          valor: linksarr['SECTION-FOOTER'],
          update: linksarr['SECTION-FOOTER_update'],
        },
      ];
    }

    if (typeof linksarr['LINKIMOBILIARIA'] === 'string') {
      linksarr['LINKIMOBILIARIA'] = [
        {
          valor: linksarr['LINKIMOBILIARIA'],
          update: linksarr['LINKIMOBILIARIA_update'],
        },
      ];
    }

    (linksarr['LINKIMOBILIARIA'] || []).forEach(function (arr) {
      vm.listopened.push(arr.valor);
    });

    // debugger;
    seoService.generateTags({
      title: vm.config_wl.titulo_site,
      description: vm.config_wl.descricao_site,
      image: vm.config_wl.image_site,
      slug: $location.absUrl(),
      amphtml: 'https://' + $location.host() + '/amp',
    });

    AOS.init({
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
    });
    $(window).on('load', function () {
      AOS.refresh();
    });

    // $http.get(url)
    // .then(function(res){
    //   vm.venda = {curitiba:[], saopaulo:[], balneario:[], londrina:[], maringa:[]}
    //   vm.loc = {curitiba:[], saopaulo:[], balneario:[], londrina:[], maringa:[]}
    //   filtraBairros(res.data.venda, vm.venda);
    //   filtraBairros(res.data.loc, vm.loc);
    // })
    vm.numeroCidades = 315;
    function filtraBairros(obj, saida) {
      var key;
      for (key in obj) {
        switch (obj[key].imv_cidade) {
          case 'londrina':
            saida.londrina.push(obj[key]._arr);
            break;
          case 'curitiba':
            saida.curitiba.push(obj[key]._arr);
            break;
          case 'sao paulo':
            saida.saopaulo.push(obj[key]._arr);
            break;
          case 'balneario camboriu':
            saida.balneario.push(obj[key]._arr);
            break;
          case 'maringa':
            saida.maringa.push(obj[key]._arr);
            break;
          default:
            break;
        }
      }
    }
    // vm.changeMenu = changeMenu;
    vm.search = search;
    vm.autoComplete = autoComplete;
    vm.showTitle = true;
    vm.idBg = Math.floor(Math.random() * 6 + 1);

    vm.makeUrl = makeUrl;
    vm.formatPrice = textFormatter.formatPrice;

    vm.clearInput = function () {
      vm.busca = null;
      vm.buscaCodigo = null;
    };

    // var scroll = false;
    // var geocoder = new google.maps.Geocoder;
    vm.cities = [
      { city: 'São Paulo', state: 'SP' },
      { city: 'Curitiba', state: 'PR' },
      { city: 'Londrina', state: 'PR' },
      { city: 'Joinville', state: 'SC' },
      { city: 'Balneário Camboriú', state: 'SC', label: 'B. Camboriú' },
      { city: 'Itajaí', state: 'SC' },
    ];

    function makeUrl(listing) {
      // var urlPath = $location.$$url.split('?')[0].split('#')[0];
      if (listing && listing.imv_titulo) {
        var description = textFormatter.removeSpecialChar(listing.imv_titulo);
        return '/imovel/' + description + '/' + listing.imv_cod_gaia;
      }
      return '/';
    }

    angular.element('#myCarousel2').swipe({
      swipe: function (
        event,
        direction,
        distance,
        duration,
        fingerCount,
        fingerData
      ) {
        if (direction == 'left') $(this).carousel('next');
        if (direction == 'right') $(this).carousel('prev');
      },
      allowPageScroll: 'vertical',
    });

    function search(e) {
      if (e) e.preventDefault();

      vm.loaderSearch = true;

      var geocoder = new google.maps.Geocoder();

      setTimeout(function () {
        if (!navigator.geolocation) {
          console.info('Geolocation is not supported by your browser');
          goToList();
          return;
        }

        function success(position) {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          var latlng = { lat: latitude, lng: longitude };
          var storagelocal = JSON.parse(
            window.localStorage.getItem('location')
          );

          if (
            !storagelocal ||
            (storagelocal &&
              latlng.lat != storagelocal.lat &&
              storagelocal.lng != latlng.lng)
          ) {
            window.localStorage.setItem('location', JSON.stringify(latlng));

            geocoder.geocode({ location: latlng }, function (results, status) {
              if (status === 'OK') {
                var place = null;
                results[0].address_components.forEach(function (element) {
                  if (
                    !place &&
                    element.types[0] == 'administrative_area_level_2'
                  ) {
                    place = element.long_name;
                  } else if (
                    place &&
                    element.types[0] == 'administrative_area_level_1'
                  ) {
                    place = place + ' ' + element.short_name;
                  } else if (
                    !place &&
                    element.types[0] == 'administrative_area_level_1'
                  ) {
                    place = element.long_name;
                  } else if (!place && element.types[0] == 'country') {
                    place = element.long_name;
                  }
                });

                input.value = place;
                window.localStorage.setItem('location.address', input.value);
              }
              goToList();
            });
          } else {
            if (window.localStorage.getItem('location.address')) {
              input.value = window.localStorage.getItem('location.address');
              goToList();
            } else {
              geocoder.geocode(
                { location: latlng },
                function (results, status) {
                  if (status === 'OK') {
                    input.value = results[0].formatted_address;
                    window.localStorage.setItem(
                      'location.address',
                      input.value
                    );
                  }
                  goToList();
                }
              );
            }
          }
        }

        function error() {
          console.error('Unable to retrieve your location');
          goToList();
        }
        if (input.value == '') {
          navigator.geolocation.getCurrentPosition(success, error);
        } else {
          var cod_gaia = /[A-Z]{1,}(s|_|-)?[0-9]{1,}/gi;
          var id = /^\d+$/g;
          console.log();

          if (cod_gaia.test(input.value) || id.test(input.value)) {
            window.open('/imovel/' + input.value, '_self');
          } else {
            goToList();
          }
        }
      }, 0);
    }

    vm.searchCity = searchCity;

    function searchCity(e, data) {
      if (e) e.preventDefault();

      params.tipo1 =
        textFormatter.removeSpecialChar(data.city) +
        '-' +
        data.state.toLowerCase();
      $state.go('main.search-address', params, { reload: true });
    }

    function goToList() {
      if (vm.codCheck) {
        var search = vm.buscaCodigo;
        if (search && search != undefined && search != '') {
          //debugger
          Imovel.getImovelNew(
            {
              id: search.toUpperCase(),
            },
            function (success) {
              if (success.length != 0) {
                var description = textFormatter.removeSpecialChar(
                  success[0].imv_titulo
                );
                $state.go('main.imovel-sub', {
                  id: success[0].imv_cod_gaia.toUpperCase(),
                  dummy: description,
                });
              } else {
                toastr.warning(
                  'Não foi encontrado nenhum imóvel com este código!'
                );
              }
            }
          );
        } else {
          toastr.warning('Digite um código de imóvel!');
        }
      } else {
        var search = input.value
          ? input.value.toLowerCase()
          : vm.config_wl.cidade && vm.config_wl.estado
          ? vm.config_wl.cidade.toLowerCase() +
            ', ' +
            vm.config_wl.estado.toLowerCase()
          : null;
        if (search != undefined && search != '') {
          search = search.toLowerCase().replace(/ - /g, '-');
          search = search.replace(/,/g, '');
          search = search.replace(/ /g, '-');
          search = search.replace(/-brasil/g, '');
          search = textFormatter.removeSpecialChar(search);
          // params.tipo1 = search;
          params.tipo2 = search;
        }
        // params.tipo1 = params.tipo1 ? params.tipo1 : 'londrina-pr';
        params.tipo2 = params.tipo2 ? params.tipo2 : 'londrina-pr';
        // params.tipo1 = ( vm.config_wl.imb_config_site.tipo_imob == 1 ) ? 'a-venda' :(( vm.config_wl.imb_config_site.tipo_imob == 2 ) ? 'para-alugar' : 'a-venda');
        var indexroute = 'main.search-address-ad-type';
        params.tipo1 =
          typeof vm.finalidade === 'object'
            ? vm.finalidade.value
            : (
                vm.finalidades.filter(function (el) {
                  return vm.finalidade == el.label;
                })[0] || {}
              ).value;
        if (vm.tipo == 'Selecione') {
          vm.tipo = { label: 'Selecione', value: '' };
        }
        if (vm.tipo.value !== '') {
          params.tipovar = params.tipo1;
          params.cidade = params.tipo2;
          params.tipoimovel =
            typeof vm.tipo === 'object'
              ? vm.tipo.value
              : (
                  vm.tipoImovel.filter(function (el) {
                    return vm.tipo == el.label;
                  })[0] || {}
                ).value;
          indexroute = 'main.search-address-ad-build-type';
        }
        // //debugger;
        switch (vm.menu) {
          case 1:

          case 2:
            // if (vm.tipo !== undefined && vm.tipo !== null && vm.tipo != '') {
            //   params.tipoimovel = vm.tipo.toLowerCase();
            //   params.tipovar = (vm.menu == 1) ? 'a-venda' : 'para-alugar';
            //   $state.go('main.search-address-ad-build-type', params);
            // } else {
            // params.tipovar = (vm.menu == 1) ? 'a-venda' : 'para-alugar';
            $state.go(indexroute, params, { reload: true });
            // }
            break;
          case 3:
            if (vm.busca !== undefined) {
              $state.go('main.search-lancamentos-address', {
                cidade: search,
              });
            } else {
              $state.go('main.search-lancamentos');
            }
            break;
          case 4:
            //debugger
            Imovel.getImovelNew(
              {
                id: search.toUpperCase(),
              },
              function (success) {
                if (success.length != 0) {
                  var description = success[0].TituloImovel._cdata
                    .toLowerCase()
                    .replace(
                      /[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                      '-'
                    )
                    .replace(/\s/g, '-')
                    .replace(/---/g, '-')
                    .replace(/--/g, '-');
                  $state.go('main.imovel-sub', {
                    id: success[0].id,
                    dummy: description,
                  });
                } else {
                  toastr.warning(
                    'Não foi encontrado nenhum imóvel com este código!'
                  );
                }
              }
            );
            break;
          default:
            break;
        }
      }
      $timeout(function () {
        vm.loaderSearch = false;
      }, 100);
    }

    var service = new google.maps.places.AutocompleteService();
    var sessionToken = new google.maps.places.AutocompleteSessionToken();

    vm.makeUrlBairro = function (tipo, cidade, bairro) {
      var url = '';
      if (tipo === 'venda') {
        url += '/imoveis/a-venda/';
      } else {
        url += '/imoveis/para-alugar/';
      }
      url += textFormatter.urlFormatter(bairro) + '-';
      url += cidade;
      return url;
    };

    vm.finalidades = [];
    if (
      vm.config_wl.imb_config_site &&
      vm.config_wl.imb_config_site.tipo_imob
    ) {
      switch (vm.config_wl.imb_config_site.tipo_imob) {
        case 1:
          vm.finalidades.push({ label: 'Venda', value: 'a-venda' });
          break;
        case 2:
          vm.finalidades.push({ label: 'Locação', value: 'para-alugar' });
          break;
        default:
          vm.finalidades.push({ label: 'Venda', value: 'a-venda' });
          vm.finalidades.push({ label: 'Locação', value: 'para-alugar' });
          break;
      }
    } else {
      vm.finalidades.push({ label: 'Venda', value: 'a-venda' });
      vm.finalidades.push({ label: 'Locação', value: 'para-alugar' });
    }
    vm.finalidade = vm.finalidades[0];
    vm.tipoImovel = [
      { label: 'Selecione', value: '' },
      { label: 'Apartamento', value: 'apartamento' },
      { label: 'Casa', value: 'casa' },
      { label: 'Terreno', value: 'terreno' },
      { label: 'Barracões', value: 'barracao' },
      { label: 'Loja/Sala', value: 'loja+sala' },
      { label: 'Chácara', value: 'chacara' },
      { label: 'Kitnet', value: 'kitnet' },
      { label: 'Studio', value: 'studio' },
      { label: 'Casa Condomínio', value: 'casa-condominio' },
      { label: 'Terreno Condomínio', value: 'terreno-condominio' },
    ];
    vm.tipo = vm.tipoImovel[0];
    var clickHandler = function (e, obj) {
      var _current = angular
        .element(e.currentTarget)
        .closest('#' + e.handleObj.data.id)
        .find('input');

      if (_current.attr('aria-expanded') === 'false') {
        angular
          .element(e.currentTarget)
          .closest('#' + e.handleObj.data.id)
          .find('ul')
          .removeClass('ng-hide');
        var _oldVal = _current.val();
        var _val = _oldVal + ' ';
        _current.controller('ngModel').$setViewValue(_val);
        // scope.$digest;
        $timeout(function () {
          _current.controller('ngModel').$setViewValue(_oldVal);
        });
      } else {
        angular
          .element(e.currentTarget)
          .closest('#' + e.handleObj.data.id)
          .find('ul')
          .addClass('ng-hide');
        // //debugger
        // a.addClass('ng-hide');
        _current.attr('aria-expanded', 'false');
      }
    };
    $timeout(function () {
      angular.element('.fin').click({ id: 'finalidade' }, clickHandler);
      angular.element('.tip').click({ id: 'tipoimovel' }, clickHandler);
    });

    vm.getLocation = function (term) {
      var deferred = $q.defer();
      var queue = [];
      var url = SERVER_URL + 'api/imoveis-replica/get-imoveis-new';
      var urlAutocomplete =
        'https://api-site.arboimoveis.com.br/api/geocaches/autocomplete/' +
        textFormatter.removeSpecialChar(term);
      var req = {
        sessionToken: sessionToken,
        input:
          term +
          (!vm.config_wl.isArbo
            ? vm.config_wl.cidade + ' ' + vm.config_wl.estado
            : '') +
          ', Brasil',
        componentRestrictions: { country: 'BR' },
      };
      var pattern = '/(' + term + ')/i';
      var _where = {
        and: [
          { imv_ativo: true },
          { imv_publicar: true },
          {
            or: [
              { imv_preco_venda: { gte: 1 } },
              { imv_preco_locacao: { gte: 1 } },
              {
                'imv_emp_fields.emp_preco_min': {
                  gt: 0,
                },
              },
            ],
          },
          {
            or: [
              { id: parseInt(term) },
              { imv_cod_gaia: { regexp: pattern } },
              { imv_cod_origem: { regexp: pattern } },
              // { imv_titulo: { regexp: pattern } },
              // { imv_cidade: { regexp: pattern } },
              // { imv_bairro: { regexp: pattern } },
              // { imv_endereco: { regexp: pattern } },
            ],
          },
        ],
      };
      if (vm.config_wl.isArbo) {
        _where.push({ imobiliaria: { imb_impulsionar: true } });
      }
      // , function(results, status) {
      //   if (status === 'OK') {
      //     console.log(status, results);
      //   }
      // }
      queue.push(
        $http.get(url, {
          params: {
            limit: 3,
            where: _where,
            wlimobiliaria: !vm.config_wl.isArbo,
          },
        }),
        $http.get(urlAutocomplete)
      );

      $q.all(queue).then(function (res) {
        var predictions = res[1];
        res = res[0];
        // service.getPlacePredictions(req, function (r, s) {
        var resp = res.data.map(function (el) {
          el.description = el['imv_cod_gaia'];
          return el;
        });

        predictions = predictions.data.items
          .filter(function (el) {
            return el.types[0] != 'administrative_area_level_1';
          })
          .map(function (el) {
            el.description = el.desc;
            return el;
          });
        resp = predictions.concat(resp);

        deferred.resolve(resp);
      });
      // });

      return deferred.promise;
    };

    vm.clickSelect = function (item) {
      if (item.imv_cod_gaia) {
        $state.go('main.imovel', { id: item.imv_cod_gaia });
      }
      return;
    };

    function autoComplete() {
      // if (autocomplete == null) {
      //   var autoCompleteOpcoes = {
      //     componentRestrictions: {
      //       country: 'BR'
      //     }
      //   }
      //   autocomplete = new google.maps.places.Autocomplete(input, autoCompleteOpcoes);
      //   autocomplete.addListener('place_changed', function () {
      //     vm.search(null);
      //   })
      // }
      // var defaultBouns = new google.maps.LatLngBounds
      // var req = {
      //     'input': vm.busca,
      //     componentRestrictions : {country: 'BR'}
      //   }
      // console.log($('#results-google-home').val() );
      // if($('#input-city-home').val() != ''){
      //   vm.showTitle = false;
      //   service.getPlacePredictions(req, dSuggestions);
      // }else{
      //   vm.showTitle = true;
      //   var predictions = JSON.parse(localStorage.getItem('recent-search'))
      //   $('#results-google-home').empty();
      //   predictions.forEach(function(prediction) {
      //     // console.log(prediction);
      //     var li = $('<a></a>');
      //     li.addClass('recent-point')
      //     li.text(prediction.description);
      //     $('#results-google-home').append(li);
      //   });
      // }
      // // service.getQueryPredictions(req, dSuggestions);
    }

    var dSuggestions = function (predictions, status) {
      if (status != google.maps.places.PlacesServiceStatus.OK) {
        alert(status);
        return;
      }
      $('#results-google-home').empty();
      predictions.forEach(function (prediction) {
        // console.log(prediction);
        var li = $('<a></a>');
        li.addClass('map-point');
        li.text(prediction.description);
        $('#results-google-home').append(li);
      });
    };

    // function changeMenu(data) {
    //   vm.menu = data;
    //   switch (data) {
    //     case 1:

    //     case 2:
    //       vm.placeholder = 'Digite condominio, região, bairro ou cidade';
    //       break;
    //     case 3:
    //       vm.tipo = null;
    //       vm.placeholder = 'Digite região, bairro ou cidade';
    //       break;
    //     case 4:
    //       vm.tipo = null;
    //       vm.busca = '';
    //       vm.placeholder = 'Ex: CA0123';
    //       break;
    //     default:
    //       vm.placeholder = 'Digite condominio, região, bairro ou cidade';
    //       break;
    //   }
    // }
    // changeMenu(1);

    // vm.listingsVenda = [];
    // vm.listingsLocacao = [];
    var queue = [];

    // Imoveis do Carousel

    $q.all(queue).then(function (v) {
      var mainLoopId = setInterval(function () {
        if ($('.carousel').length) {
          $('.carousel').on('slide.bs.carousel', function (ev) {
            var lazy;
            lazy = $(ev.relatedTarget).find('img');
            if (lazy.data('img')) {
              lazy.attr('src', lazy.data('img'));
              lazy.removeAttr('data-img');
            }
          });
          angular.element('.carousel').bcSwipe({ threshold: 50 });
          clearInterval(mainLoopId);
        }
      }, 500);
    });

    var carouselApi = {};
    vm.readyCarousel = function (api) {
      carouselApi = api;
    };

    vm.nextOwlHome = function (ev) {
      carouselApi.trigger('next.owl.carousel');
    };

    vm.prevOwlHome = function (ev) {
      carouselApi.trigger('prev.owl.carousel');
    };

    vm.owlPropertiesSection = {
      loop: true,
      nav: false,
      margin: 10,
      items: 1,
      autoplay: true,
      autoplayTimeout: 50000,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      responsive: {
        0: {
          dots: true,
        },
        980: {
          dots: false,
        },
      },
    };

    vm.owlProperties = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onChange: function (event, a, c) {
        if (event.property && event.property.value == 9) {
          throw new Error('DragError');
        }
      },
      responsive: {
        0: {
          items: 1,
          stagePadding: 22,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
        1280: {
          items: 4,
        },
        1600: {
          items: 4,
        },
      },
    };
    vm.owlDestaques = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      responsive: {
        0: {
          items: 1,
          stagePadding: 22,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
      },
    };
    vm.owlCalls = {
      loop: true,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      autoplay: true,
      autoplayTimeout: 10000,
      responsive: {
        0: {
          items: 1,
          // stagePadding: 22
        },
      },
    };
    vm.owlTestimoniais = {
      loop: true,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      autoplay: true,
      rewind: true,
      autoplayTimeout: 15000,
      responsive: {
        0: {
          items: 1,
          // stagePadding: 22
        },
      },
    };
    vm.owlBlog = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      autoplay: true,
      rewind: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 22,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
      },
    };
    vm.owlSubsection = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      autoplay: true,
      autoplayTimeout: 10000,
      responsive: {
        0: {
          items: 1,
          stagePadding: 22,
          loop: true,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
      },
    };
    vm.owlKnow = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      onDragged: function (lala) {
        console.log(lala);
      },
      // autoplay : true,
      // rewind: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 20,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
      },
    };
    var vendaApi = null;
    var locacaoApi = null;
    var callApi = null;
    var testimonialApi = null;
    var blogApi = null;
    var subsectionApi = null;
    var knowApi = null;

    vm.imb_destaques = vm.config_wl.destaques;

    vm.readyVenda = function (api) {
      vendaApi = api;
    };

    vm.readyLocacao = function (api) {
      locacaoApi = api;
    };

    vm.readyCall = function (api) {
      callApi = api;
    };

    vm.readyTestimonial = function (api) {
      testimonialApi = api;
    };

    vm.readyBlog = function (api) {
      blogApi = api;
    };

    vm.readySubsection = function (api) {
      subsectionApi = api;
    };

    vm.readyKnow = function (api) {
      knowApi = api;
    };

    // console.log('configwl: ',vm.config_wl);
    vm.nextOwl = function (ev) {
      if (ev == 'carousel-venda') {
        vendaApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-locacao') {
        locacaoApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-calls') {
        callApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-testimonial') {
        testimonialApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-blog') {
        blogApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-subsection') {
        subsectionApi.trigger('next.owl.carousel', [500]);
      } else if (ev == 'carousel-know') {
        knowApi.trigger('next.owl.carousel', [500]);
      }
    };

    vm.prevOwl = function (ev) {
      if (ev == 'carousel-venda') {
        vendaApi.trigger('prev.owl.carousel', [500]);
      } else if (ev == 'carousel-locacao') {
        locacaoApi.trigger('prev.owl.carousel', [500]);
      }
    };

    vm.isMobile = function () {
      var pageWidth = angular.element(document).outerWidth();
      return pageWidth < 992;
    };

    vm.calls = [
      {
        title: 'Escolha onde quer morar.',
        description:
          'Procure seu imóvel de forma rápida e simples. Você escolhe a localização de onde quer morar ou investir e nós te mostramos as melhores opções. Encontre agora o imóvel ideal! <3',
        btn: 'BUSCAR IMÓVEL',
        linkbtn: '',
        icon: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="map-marker-smile" class="svg-inline--fa fa-map-marker-smile fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm64 117.16c14.82 0 26.84 12.02 26.84 26.84s-12.02 26.84-26.84 26.84-26.84-12.02-26.84-26.84 12.02-26.84 26.84-26.84zm-128 0c14.82 0 26.84 12.02 26.84 26.84s-12.02 26.84-26.84 26.84-26.84-12.02-26.84-26.84 12.02-26.84 26.84-26.84zm164.17 140.97C267.3 287.28 230.78 304 192 304c-38.75 0-75.27-16.72-100.16-45.86-5.75-6.72-4.95-16.81 1.77-22.55 6.69-5.73 16.81-4.97 22.55 1.77C134.98 259.38 162.62 272 192 272c29.41 0 57.03-12.63 75.83-34.66 5.78-6.73 15.86-7.53 22.56-1.78 6.72 5.74 7.52 15.85 1.78 22.57z"></path></svg>',
        iconcall: 'Sem burocracia.',
        photo:
          'https://static.arboimoveis.com.br/white-label-assets/arbo/506718-PHVHS3-651.jpg',
      },
      {
        title: 'Sem burocracia.',
        description:
          'Pode dizer adeus a papeladas e visitas à imobiliária. Aqui é tudo online, você envia seus documentos e negocia de onde estiver, de forma segura e fácil! Temos uma equipe de atendimento disponível para te ajudar.',
        btn: 'FALE CONOSCO',
        linkbtn: '/fale-conosco',
        icon: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="comment-alt-smile" class="svg-inline--fa fa-comment-alt-smile fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM320 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 303.3 294.8 320 256 320c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z"></path></svg>',
        iconcall: 'Nosso contrato é online',
        photo:
          'https://static.arboimoveis.com.br/white-label-assets/arbo/Ret%C3%A2ngulo+103.jpg',
      },
      {
        title: 'Nosso contrato é online.',
        description:
          'Envie propostas online e assine o contrato pelo seu celular. Sem burocracia e com toda a segurança que você precisa, contando com o apoio de profissionais, negocie e adquira um imóvel de onde estiver!',
        btn: 'BUSCAR IMÓVEL',
        linkbtn: '',
        icon: '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="home-heart" class="svg-inline--fa fa-home-heart fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M64 311.4V496c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V311.4c-6.7-5.5-44.7-38.3-224-196.4C107.9 273.9 70.4 306.1 64 311.4zm314.1-26.3c27.6 23 29.1 64.2 4.5 89.1l-84.7 85.6c-5.5 5.5-14.3 5.5-19.8 0l-84.7-85.6c-24.6-24.9-23.2-66.1 4.3-89.1 24-20 59.7-16.4 81.6 5.8l8.6 8.7 8.6-8.7c22-22.2 57.7-25.8 81.6-5.8zM64 311.4v-.3s-2.7 2.5 0 .3zm506.7-75.1L512 184.5V48c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v51.7L314.7 10.3c-15.3-13.7-38.2-13.7-53.5 0l-256 226c-6.6 5.9-7.1 16-1.2 22.6l21.4 23.8c5.9 6.6 16 7.1 22.6 1.2L277.4 81.7c6-5.3 15.1-5.3 21.2 0L527.9 284c6.6 5.9 16.7 5.4 22.6-1.2l21.4-23.8c5.9-6.7 5.4-16.8-1.2-22.7zM512 311.1v.3c2.9 2.3 0-.3 0-.3z"></path></svg>',
        iconcall: 'Venda seu imóvel mais rápido.',
        photo:
          'https://static.arboimoveis.com.br/white-label-assets/arbo/nicole-honeywill-ylveRpZ8L1s-unsplash.jpg',
      },
      {
        title: 'Venda seu imóvel mais rápido.',
        description:
          'Com a Arbo, você vende seu imóvel muito mais rápido! Cadastre online e gratuitamente seu imóvel no nosso sistema, anuncie nas melhores mídias e receba suporte de corretores, equipe jurídica e financeira.',
        btn: 'ANUNCIAR MEU IMÓVEL',
        linkbtn: '/cadastre-seu-imovel',
        icon: '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="handshake-alt" class="svg-inline--fa fa-handshake-alt fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M255.7 182.7l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H519.2l-47.6-47.6C461.1 69.9 446.9 64 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h121.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 4 7.8 1.2 11.3L411.9 377c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-2.2 2.7-5.4 4.4-8.9 4.8-3.5.4-7-.7-9.1-2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h89l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23H624c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H474.8c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.4-9.9-8.5-25.2 1.1-34z"></path></svg>',
        iconcall: 'Escolha onde quer morar.',
        photo:
          'https://static.arboimoveis.com.br/white-label-assets/arbo/adult-business-computer-2422286.jpg',
      },
    ];

    // isso aqui vai ser dinamico depois e vai vir do getwlconfig
    vm.testimoniais = [
      {
        text: 'A Arbo é uma empresa moderada e tecnológica, se preocupa muito com o tempo do seus clientes e busca resolver suas soluções de imediato. A equipe é jovem, de fácil diálogo e muito competente, profissionais que se dedicam e solucionam seus problemas muito rápido.',
        author: 'Paulo Takeshi',
        role: 'Sócio Green Açaí Londrina',
      },
      {
        text: 'A Arbo chegou rompendo alguns padrões antigos de gestão e atendimento, ultrapassando algumas barreiras e trazendo inovações por meio da tecnologia. Como gestor, entender esses desafios e conseguir repassar aos interessados é muito instigante, e me conecta com uma nova realidade do mercado imobiliário.',
        author: 'Thiago Gonçalves',
        role: 'Gerente de expansão Arbo',
      },
      {
        text: 'Somos gratos à equipe Arbo que nos deu todo suporte rapidamente. Estamos completamente satisfeitos com o atendimento, agilidade, qualidade dos serviços prestados, além das tecnologias que diferenciam a Arbo. O contrato online agilizou muito a nossa locação, foi ótimo!',
        author: 'Matheus, Andre e Vinicius',
        role: 'Engenheiros da Computação',
      },
      {
        text: 'Para nós, confiança, transparência e agilidade foram características que nos fizeram escolher a Arbo para aquisição da nossa casa. Agradecemos por sempre demonstrarem empatia pelo nosso sonho.',
        author: 'Diego e Carine',
      },
      {
        text: 'Fui atendida imediatamente com muita atenção e preocupação, excelente profissional Thaiana, que me ajudou e me encaminhou a encontrar o que precisava... PARABÉNS pelo profissionalismo, educação, dedicação, respeito e atenção para com seus clientes... Se todos os lugares tivessem profissionais assim, tudo seria mais fácil... Obrigada, Thaiana, super indico.',
        author: 'Ana Campestrini',
      },
      {
        text: 'O que há de melhor em tecnologia a serviço dos bons negócios imobiliários!',
        author: 'Eron Brito',
      },
      {
        text: 'Focada em atendimento e satisfação dos clientes, inovadora e ágil nos processos de intermediação de negócios imobiliários.',
        author: 'Marisa Rodrigues',
      },
    ];

    vm.posts = [
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
      {
        image:
          'https://via.placeholder.com/758x423?text=Visit+Blogging.com+Now%20C/O%20https://placeholder.com/',
        title:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem.',
        font: 'Fonte da matéria',
        description:
          'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.',
      },
    ];

    vm.togglePropostas = function () {
      var btnPropostas = $('.btns-proposta');
      var display = btnPropostas.css('display');

      display == 'none'
        ? btnPropostas.css({ display: 'block' })
        : btnPropostas.css({ display: 'none' });
    };

    function init() {
      // angular.element(window).bind('scroll', function () {
      //   if (!scroll) {
      //     scroll = true
      queue.push(
        Imovel.getDestaques({}, function (res) {
          var succ_venda = (res.venda || []).map(function (el) {
            var o = Object.assign({}, el);
            return createThumb.get(o);
          });

          var succ_locacao = (res.locacao || []).map(function (el) {
            var o = Object.assign({}, el);
            return createThumb.get(o);
          });

          var new_venda = (res.new_venda || []).map(function (el) {
            var o = Object.assign({}, el);
            return createThumb.get(o);
          });

          var new_locacao = (res.new_locacao || []).map(function (el) {
            var o = Object.assign({}, el);
            return createThumb.get(o);
          });

          vm.listingsVenda = succ_venda.map(function (el) {
            el.tipovar = 'a-venda';
            return el;
          });

          vm.listingsLocacao = succ_locacao.map(function (el) {
            el.tipovar = 'para-alugar';
            return el;
          });

          vm.new_venda = new_venda.map(function (el) {
            el.tipovar = 'a-venda';
            return el;
          });

          vm.new_locacao = new_locacao.map(function (el) {
            el.tipovar = 'para-alugar';
            return el;
          });
        })
      );
      //   }
      // })

      angular.element(document).ready(function () {
        var width = angular.element('body').width();
        $('#header').removeClass('fixed-theme');

        // document.getElementById('header').className =
        //   document.getElementById('header').className.replace(/(?:^|\s)fixed-theme(?!\S)/g, '');

        var items = width > 991 ? 4 : width > 576 ? 2 : 1;
        // console.log(width);

        input = document.querySelector('#input-city-home');
        var firstResult = '';
        var inputJquery = $('#input-city-home');
        // inputJquery.next().width($('div.home-search').closest( "div.form-group" ).width());

        // inputJquery.keydown(function (e) {
        //   if (e.which == 13) {
        //     // if($(".pac-container:last").is(":visible")){

        //     if ($(".pac-container:visible .pac-item-selected").length) {
        //       firstResult = $(".pac-container:visible .pac-item-selected > span:not(:first)").map(function () { return $(this).text() }).get().join(' ');
        //     } else {
        //       firstResult = $(".pac-container:visible .pac-item:first > span:not(:first)").map(function () { return $(this).text() }).get().join(' ');
        //     }
        //     setTimeout(function () {
        //       inputJquery.val(firstResult.toString())
        //     }, 40)
        //     // }
        //   }
        // })
      });

      // Imovel.countCidades({}).$promise.then(
      //   function (succ) {
      //     vm.cities = succ;
      //   },
      //   function (err) {
      //     console.log(err);
      //   }
      // );
    }
    init();
  }
})();

(function () {
  'use strict';

  angular.module('arboWeb').directive('headerMain', headerMain);

  /** @ngInject */
  function headerMain() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      scope: {},
      controller: HeaderController,
      controllerAs: 'vm',
      bindToController: true,
    };

    return directive;

    HeaderController.inject = ['$state', '$scope'];

    /** @ngInject */
    // function HeaderController(auth, $state, $scope, UserModel) {
    function HeaderController(
      $state,
      $scope,
      $uibModal,
      $rootScope,
      $location,
      textFormatter,
      TipoImovel,
      Finalidade,
      auth,
      swangular
    ) {
      var vm = this;
      var params = {};
      var input = null;
      vm.config_wl = $rootScope.ConfigWhiteLabel;
      vm.user = auth.getUser();
      vm.isAuthenticated = auth.isAuthenticated();

      var imbConfigSite = vm.config_wl.imb_config_site;

      if (imbConfigSite.toggle_url_primary) {
        var url_primary = imbConfigSite.url_primary || '';
        imbConfigSite.url_primary = url_primary;
      } else {
        imbConfigSite.url_primary = '';
      }

      vm.getPageWidth = function () {
        var pageWidth = $('body').outerWidth();
        return pageWidth;
      };

      vm.isMobile = function () {
        return vm.getPageWidth() < 1199.98;
      };

      /**
       * essa função também detectas de ele está realmente em um navegador mobile.
       * evita problemas de ativar efeitos especiais no desktop.
       */
      vm.isDesktop = function () {
        return navigator.userAgent.match(
          /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
        )
          ? false
          : true;
      };

      vm.changeLocation = function () {
        var link = ($location.port() ? 'http://' : 'https://') + location.host;
        if (imbConfigSite.url_primary) {
          link = '//' + imbConfigSite.url_primary.replace(/(^\w+:|^)\/\//, '');
        } else {
          if (/testing.arboimoveis.com/.test($location.host()))
            link = 'https://next-testing.arboimoveis.com.br/';
        }
        window.location = link;
      };

      vm.showLogo = function () {
        return $state.current.name.includes('main.search-address');
      };
      vm.autocomplete = function () {
        // var autoCompleteOpcoes = {
        //   componentRestrictions: {
        //     country: 'BR'
        //   }
        // }
        // var autocomplete = new google.maps.places.Autocomplete(input, autoCompleteOpcoes);
      };

      vm.finalidade = '';
      vm.tipos = [];
      vm.tipo = vm.tipos[0];
      vm.menu = 1;
      // vm.search = search;
      vm.precovenda = [];
      vm.precolocacao = [];
      vm.search = {
        title: {},
      };
      var stringHeight = vm.config_wl.imb_config_site.image_size;
      vm.logoHeight = stringHeight ? parseInt(stringHeight, 10) : 60;
      vm.logoWidth;
      vm.visibleSearchbar = false;
      vm.options = [];
      vm.navOptions = [];
      vm.more = [];

      const parser = new DOMParser();
      function isLinkOrNot(str) {
        return (
          parser.parseFromString(str, 'text/html').getElementsByTagName('a')
            .length > 0
        );
      }
      function returnLabelAndLink(str) {
        return {
          label: parser
            .parseFromString(str, 'text/html')
            .getElementsByTagName('a')[0].innerText,
          link: parser
            .parseFromString(str, 'text/html')
            .getElementsByTagName('a')[0].href,
        };
      }

      function getWlOptions() {
        if (vm.config_wl.isArbo) return;

        var blogOption = function (wlLink) {
          return { label: 'Blog', href: wlLink, target: '_blank' };
        };

        var arrOfLinks = [];
        var links;
        var arrOfLinksFiltered = [];
        var existsCustomLinks;
        var optionsBlogContactAndProposal = [];
        var optionsCustomLinksWithZeroOrder = [];
        var optionsCustomLinksGreaterThanZero = [];
        var optionsZeroOrder = [
          {
            label: 'Imóveis curtidos',
            href: '/favoritos',
            target: '_self',
          },
        ];

        const LINKHEADER = vm.config_wl.configwl['LINKHEADER'];
        const LINKHEADER_Order = vm.config_wl.configwl['LINKHEADER_ordem'] || 0;
        const config_site = vm.config_wl.imb_config_site;
        const proposta = config_site.proposta;
        const tipo_imob = config_site.tipo_imob;
        const contato = config_site.contato;
        const saleProposal = 1;
        const leaseProposal = 2;
        const whitelabelBlog =
          vm.config_wl.redessociais &&
          vm.config_wl.redessociais.filter(function (redesocial) {
            var tprd = redesocial.rd_nome && redesocial.rd_nome.tprd_nome;
            return tprd === 'Blog';
          })[0];
        const proposalOptions = [
          {
            label: 'Proposta de venda',
            href: '/proposta-compra',
            target: '_self',
          },
          {
            label: 'Proposta de locação',
            href: '/proposta-locacao',
            target: '_self',
          },
        ];

        const contatoOption = {
          label: 'Contato',
          href: '/fale-conosco',
          target: '_self',
        };

        if (LINKHEADER && Array.isArray(LINKHEADER) && LINKHEADER.length > 0) {
          links = LINKHEADER.map(function (item, index) {
            var isLink = isLinkOrNot(item.valor);
            if (isLink) {
              return (arrOfLinks[index] = {
                ordem: item.ordem ? item.ordem : 0,
                href: returnLabelAndLink(item.valor).link,
                label: returnLabelAndLink(item.valor).label,
                target: '_blank',
              });
            }
          });
          arrOfLinksFiltered = links.filter(function (linkItem) {
            return !!linkItem;
          });
        } else if (LINKHEADER && !Array.isArray(LINKHEADER)) {
          const isLink = isLinkOrNot(LINKHEADER);
          if (isLink) {
            arrOfLinks = [
              {
                ordem: LINKHEADER_Order,
                href: returnLabelAndLink(LINKHEADER).link,
                label: returnLabelAndLink(LINKHEADER).label,
                target: '_blank',
              },
            ];

            arrOfLinksFiltered = arrOfLinks;
          } else {
            arrOfLinksFiltered = [];
          }
        } else {
          arrOfLinksFiltered = [];
        }

        if (whitelabelBlog) {
          optionsBlogContactAndProposal.push(blogOption(whitelabelBlog.rd_url));
        }

        if (contato) {
          optionsBlogContactAndProposal.push(contatoOption);
        }

        if (proposta && tipo_imob == saleProposal) {
          optionsBlogContactAndProposal.push(proposalOptions[0]);
        } else if (proposta && tipo_imob == leaseProposal) {
          optionsBlogContactAndProposal.push(proposalOptions[1]);
        }

        existsCustomLinks = arrOfLinksFiltered.length > 0;

        if (existsCustomLinks) {
          optionsCustomLinksWithZeroOrder = arrOfLinksFiltered
            .filter(function (item) {
              return item.ordem == 0;
            })
            .sort(function (previousElement, nextElement) {
              return previousElement.name < nextElement.name ? -1 : 1;
            });

          optionsZeroOrder = optionsZeroOrder.concat(
            optionsCustomLinksWithZeroOrder
          );

          optionsCustomLinksGreaterThanZero = arrOfLinksFiltered
            .filter(function (item) {
              return item.ordem > 0;
            })
            .sort(function (previousElement, nextElement) {
              return previousElement.ordem < nextElement.ordem ? -1 : 1;
            });

          vm.options = vm.options.concat(
            optionsCustomLinksGreaterThanZero,
            optionsZeroOrder,
            optionsBlogContactAndProposal
          );
        } else {
          vm.options = vm.options.concat(
            optionsZeroOrder,
            optionsBlogContactAndProposal
          );
        }
      }

      getWlOptions();

      function setWlOptionsLimit() {
        if (vm.config_wl.isArbo) return;

        var imb_angariadora = vm.config_wl.imb_angariadora;
        var config_site = vm.config_wl.imb_config_site;

        var login = config_site.login;
        var busca_menu = config_site.busca_menu;
        var length = vm.options.length;

        var marginFluid = $('.margin-fluid');
        var navbarBrand = $('#navbar-brand');

        if (vm.isMobile()) {
          navbarBrand.css('padding', '0');
          if (marginFluid) marginFluid.css('padding-top', '72px');
        } else {
          var top = vm.logoHeight + 20;
          navbarBrand.css('padding', '10px 0');
          if (marginFluid) marginFluid.css('padding-top', top + 'px');
          var propostaSidebar = $('#proposta-form .main .asidebar .steps');
          var propostaforms = $('#proposta-form .main .main-forms .forms');
          if (propostaSidebar && propostaforms) {
            propostaSidebar.css('top', top + 'px');
            propostaforms.css('top', top + 'px');
          }
        }

        if (
          vm.isMobile() ||
          !vm.visibleSearchbar ||
          !busca_menu ||
          (!imb_angariadora && !login)
        ) {
          var limit = length > 4 ? 3 : 4;
          vm.navOptions = vm.options.slice(0, limit);
          vm.more = vm.options.slice(limit);
          createWlOptions();

          return;
        }

        var pageWidth = vm.getPageWidth();

        var isLargeLogo = vm.logoWidth > 200 && length !== 2;
        var isMediumLogo = vm.logoWidth > 130 && length !== 3;

        var isLargeWidth = pageWidth > 1599.98;
        var isMediumWidth = pageWidth > 1499.98;

        var pagelimit = isLargeWidth
          ? length !== 4
            ? 3
            : 4
          : isMediumWidth
          ? length !== 3
            ? 2
            : 3
          : 0;
        var limit = isLargeLogo ? 1 : isMediumLogo ? 2 : length > 4 ? 3 : 4;
        vm.navOptions = vm.options.slice(0, pagelimit ? pagelimit : limit);
        vm.more = vm.options.slice(pagelimit ? pagelimit : limit);
        createWlOptions();
      }

      function createWlOptions() {
        var navList = $('#nav-list');

        var options = vm.navOptions.map(function (option, index) {
          var icon = $(document.createElement('i'));

          icon.addClass('ml-2 fas fa-chevron-down');
          icon.css('font-size', '0.715rem');

          var isLastItem = index === vm.navOptions.length - 1;

          var item = $();

          if (vm.isMobile()) {
            item = $(document.createElement('div'));
          } else {
            item = $(document.createElement('li')).addClass(
              'nav-item h-100 mr-xl-4'
            );
          }

          var tag = $(document.createElement('a')).addClass('nav-link');

          if (vm.isMobile()) {
            tag.addClass('p-0');
          } else {
            tag.addClass('d-flex align-items-center h-100');
          }

          if (!vm.isMobile() && isLastItem && !vm.more.length)
            item.removeClass('mr-xl-4');

          if (option.options) {
            // IS DROPDOWN
            var drop = $(document.createElement('div'));

            item.addClass('dropdown');

            tag.attr({
              href: '#',
              id: 'dropdown-start',
              role: 'button',
              'data-toggle': 'dropdown',
              'aria-haspopup': 'true',
              'aria-expanded': 'false',
            });

            tag.append(option.label, icon);

            drop.attr({
              class: 'dropdown-menu new-drop-style',
              'aria-labelledby': 'dropdown-start',
            });

            if (vm.isMobile()) {
              tag.css('margin', '0 .3175rem');
              tag.addClass(
                'p-0 d-flex align-items-center justify-content-between py-3 nav-link'
              );

              drop.attr({
                style: 'box-shadow: none !important; position: initial',
              });
              drop.addClass('border-0 w-100');
            } else {
              drop.css({
                left: 'unset',
              });
              drop.addClass('add-links-prop');
            }

            var linkTags = option.options.map(function (linkOption) {
              var linkTag = $(document.createElement('a'));

              linkTag.attr({
                href: linkOption.href,
                target: linkOption.target,
                class: 'dropdown-item',
              });

              if (vm.isMobile()) linkTag.addClass('p-3');

              linkTag.append(linkOption.label);

              return linkTag;
            });

            drop.append(linkTags);
            item.append(tag, drop);
          } else {
            // IS NAV ITEM

            tag.attr({
              href: option.href,
              target: option.target,
            });

            tag.append(option.label);

            if (vm.isMobile()) {
              tag.attr({
                class: 'p-0 d-flex align-items-center py-3 nav-link',
                style: 'margin: 0 .3175rem',
              });
              return tag;
            }

            item.append(tag);
          }

          return item;
        });

        var more = $();

        if (vm.more.length) {
          var moreItem = $();

          if (vm.isMobile()) {
            moreItem = $(document.createElement('div'));
          } else {
            moreItem = $(document.createElement('li')).addClass(
              'nav-item h-100'
            );
          }
          var moreTag = $(document.createElement('a'));
          var moreDrop = $(document.createElement('div'));

          var icon = $(document.createElement('i'));

          icon.addClass('ml-2 fas fa-chevron-down');
          icon.css('font-size', '0.715rem');

          moreItem.addClass('nav-item h-100 dropdown');

          moreTag.attr({
            href: '#',
            id: 'dropdown-start',
            role: 'button',
            class: 'nav-link d-flex align-items-center h-100',
            'data-toggle': 'dropdown',
            'aria-haspopup': 'true',
            'aria-expanded': 'false',
          });

          moreTag.append('Mais', icon);
          moreDrop.attr({
            class: 'dropdown-menu add-links-prop new-drop-style',
            'aria-labelledby': 'dropdown-start',
          });

          if (vm.isMobile()) {
            moreTag.css('margin', '0 .3175rem');
            moreTag.addClass(
              'p-0 d-flex align-items-center justify-content-between py-3 nav-link'
            );

            moreDrop.attr({
              style: 'box-shadow: none !important; position: initial',
            });
            moreDrop.addClass('border-0 w-100');
          } else {
            moreDrop.css({
              left: 'unset',
            });
            moreDrop.addClass('add-links-prop');
          }

          var moreTags = vm.more.map(function (option) {
            var linkTag = $(document.createElement('a'));

            linkTag.attr({
              class: 'dropdown-item',
              href: option.href,
              target: option.target,
            });

            linkTag.append(option.label);

            return linkTag;
          });

          moreDrop.append(moreTags);
          moreItem.append(moreTag, moreDrop);

          more = moreItem;
        }

        if (vm.isMobile()) {
          $('#sidenav-list').empty().append(options, more);
          return;
        }

        var config_site = vm.config_wl.imb_config_site;
        var login = config_site.login;

        navList.empty().append(options, more);

        var dropdowns = $('#navDesktop li > div');

        if (vm.visibleSearchbar) {
          dropdowns.css('margin-top', vm.logoHeight / 2 - 8 + 'px');
        } else {
          dropdowns.css('margin-top', '2px');
          if (login && vm.isAuthenticated)
            dropdowns.last().css('margin-top', '12px');
        }
      }

      function transparentNav() {
        var isHome = /main.home/g.test($state.current.name);
        var config_site = vm.config_wl.imb_config_site;
        var login = config_site.login;

        var header = $('#header')[0];
        var arboLogo = $('#arbo-logo').children()[0];
        var dropdowns = $('#navDesktop li > div');

        var anuncieSeuImovel = $('.anuncie-seu-imovel');

        var filter = $('#formHeaderFilter')[0];
        var loginButton = $('#loginButton button div')[0];

        var logo = $('#logo')[0].classList;

        var aux =
          (vm.config_wl.imb_config_site.busca_menu != false ||
            /main.search-address-ad-type|main.search-address-ad-build-type/g.test(
              $state.current.name
            )) &&
          !/main.painel/g.test($state.current.name);

        if (filter && !aux) {
          filter.classList.add('d-none');
          logo.add('d-flex');
          logo.remove('d-none');
        }

        if (window.scrollY < 50 && isHome) {
          // Navbar Transparente
          vm.visibleSearchbar = false;

          if (!vm.config_wl.isArbo) {
            $('#navbar-logo').attr('src', vm.config_wl.url_logo_bg_escura);
          }

          navTransparente();
          if (filter) filter.classList.add('d-none');
          if (!vm.isMobile()) {
            anuncieSeuImovel.each(function () {
              $(this).addClass('inverted');
            });

            if (vm.config_wl.isArbo) {
              dropdowns.css('margin-top', '2px');
              if (vm.isAuthenticated)
                dropdowns.last().css('margin-top', '12px');
            }
          } else {
            anuncieSeuImovel.each(function () {
              $(this).removeClass('inverted');
            });
          }
          loginBranco();
        } else {
          // Navbar branca
          vm.visibleSearchbar = true;

          if (!vm.config_wl.isArbo) {
            $('#navbar-logo').attr('src', vm.config_wl.url_logo_verde);
          }

          navBranca();
          if (filter && aux) filter.classList.remove('d-none');
          if (!vm.isMobile()) {
            anuncieSeuImovel.each(function () {
              $(this).removeClass('inverted');
            });

            if (vm.config_wl.isArbo) {
              dropdowns.css('margin-top', '22px');
            }
          }
          loginPreto();
        }

        function navTransparente() {
          header.classList.add('bg-transparent', 'text-white');
          header.classList.remove('bg-white', 'text-black');

          if (!vm.isMobile()) {
            if (vm.config_wl.isArbo) $('#header').css('height', '100px');
            $('#user-drop').css('opacity', '0.8');
          }

          $('#header').css('box-shadow', '');

          if (vm.config_wl.isArbo && arboLogo)
            arboLogo.classList.add('arbo-white');
        }

        function navBranca() {
          header.classList.remove('bg-transparent', 'text-white');
          header.classList.add('bg-white', 'text-black');

          if (!vm.isMobile()) {
            if (vm.config_wl.isArbo) $('#header').css('height', '80px');
            $('#user-drop').css('opacity', '0.15');
          }

          $('#header').css('box-shadow', 'rgba(0, 0, 0, 0.05) 0px 2px 24px');

          if (vm.config_wl.isArbo && arboLogo)
            arboLogo.classList.remove('arbo-white');
        }

        function loginPreto() {
          if (loginButton) {
            loginButton.classList.remove('border-white', 'text-white');
            loginButton.classList.add('border-secondary-arbo', 'text-black');
          }
        }

        function loginBranco() {
          if (loginButton) {
            loginButton.classList.remove('border-secondary-arbo', 'text-black');
            loginButton.classList.add('border-white', 'text-white');
          }
        }
      }

      function transformNav() {
        if (
          (vm.visibleSearchbar && window.scrollY < 50) ||
          (!vm.visibleSearchbar && window.scrollY > 50)
        ) {
          transparentNav();
          setWlOptionsLimit();
        }
      }

      function setLogoSize() {
        if (vm.config_wl.isArbo) return;

        var isHome = /main.home/g.test($state.current.name);
        var logoHeight = $('#navbar-logo').height();
        var crmSize = vm.config_wl.imb_config_site.image_size;

        if (window.scrollY < 50 && isHome) {
          logoHeight = crmSize ? crmSize : 60;
        } else if (crmSize >= 110) {
          logoHeight = 85;
        }

        if (logoHeight === $('#navbar-logo').height()) return;

        vm.logoHeight = parseInt(logoHeight, 10);
        $('#navbar-logo').css('height', vm.logoHeight + 'px');
      }

      function switchLogo() {
        var isHome = /main.home/g.test($state.current.name);

        var logo = $('#logo')[0].classList;
        var filter = $('#formHeaderFilter')[0];

        var aux =
          (vm.config_wl.imb_config_site.busca_menu != false ||
            /main.search-address-ad-type|main.search-address-ad-build-type/g.test(
              $state.current.name
            )) &&
          !/main.painel/g.test($state.current.name);

        if (window.scrollY < 50 && isHome) {
          logo.add('d-flex');
          logo.remove('d-none');
          // if (filter) filter.classList.add('d-none');
        } else if (aux) {
          logo.add('d-none');
          logo.remove('d-flex');
          // if (filter) filter.classList.remove('d-none');
        }
      }

      $scope.$watch('vm.search.title', function () {
        $rootScope.$broadcast('titulo', vm.search.title);
      });

      $('form').on('submit', function (e) {
        e.preventDefault();
      });

      var currentState = $state.current.name;
      $rootScope.$on(
        '$stateChangeSuccess',
        function (event, toState, toParams, fromState, fromParams, options) {
          currentState = $state.current.name;
        }
      );
      angular.element(document).ready(function () {
        /*
         * Nav Bar
         */

        var config_site = vm.config_wl.imb_config_site;

        var image_size =
          config_site.image_size < 110
            ? parseInt(config_site.image_size, 10)
            : 85;

        const gambiarra = $(document.createElement('img'))
          .attr({ src: vm.config_wl.url_logo_verde, height: image_size })
          .css('visibility', 'hidden');

        $('#navbar-brand').append(gambiarra);

        vm.logoWidth = gambiarra.width();

        gambiarra.remove();

        var myNavBar = {
          flagAdd: true,
          elements: [],
          states: [],
          init: function (elements, states) {
            this.elements = elements;
            this.states = states;

            // Finalidade.find({}, function (res, info) {
            //   vm.finalidades = res;
            //   vm.finalidade = res[0];
            // });

            // TipoImovel.find({}, function (res, info) {
            //   vm.tipos = res;
            //   vm.tipo = res[0];
            // });
          },
          add: function () {
            if (this.flagAdd && this.states.indexOf(currentState) != -1) {
              for (var i = 0; i < this.elements.length; i++) {
                document.getElementById(this.elements[i]).className +=
                  ' fixed-theme';
              }
            }
          },
          remove: function () {
            for (var i = 0; i < this.elements.length; i++) {
              document.getElementById(this.elements[i]).className = document
                .getElementById(this.elements[i])
                .className.replace(/(?:^|\s)fixed-theme(?!\S)/g, '');
            }
          },
        };
        var el = ['header'];
        var st = [
          'main.home',
          'main.error401',
          'main.error403',
          'main.error404',
          'main.error500',
        ];
        myNavBar.init(el, st);

        function offSetManager() {
          var yOffset = 400;
          var currYOffSet = window.pageYOffset;
          if (myNavBar.states.indexOf(currentState) == -1) return;

          yOffset = angular.element('#input-city-home').offset()
            ? angular.element('#input-city-home').offset().top - 32
            : yOffset;

          if (yOffset < currYOffSet) {
            myNavBar.add();
            myNavBar.flagAdd = false;
            $('#img-logo').attr(
              'src',
              './assets/imgs/logo_sala_arq_scroll.png'
            );
          } else if (yOffset >= currYOffSet) {
            myNavBar.remove();
            myNavBar.flagAdd = true;
            $('#img-logo').attr('src', './assets/imgs/logo_sala_arq.png');
          }
        }

        if (!vm.isMobile()) setLogoSize();
        else switchLogo();
        transparentNav();
        setWlOptionsLimit();

        window.onscroll = function (e) {
          if (!vm.isMobile()) setLogoSize();
          else switchLogo();
          transformNav();
        };

        $('.dropdown-item, .nav-item').click(function (event) {
          if (vm.isMobile()) closeSidebar();
        });

        setWlOptionsLimit();
        //offSetManager();

        /* ------ Input Autocomplete ------------ */
        input = document.getElementById('header-search');

        var firstResult = '';
        var inputJquery = $('#header-search');
        inputJquery
          .next()
          .width($('div.home-search').closest('div.form-group').width());

        angular.element('.dropdown-user').click(function (event) {
          event.preventDefault();
        });
      });

      $scope.$watch(
        function () {
          return $state.current.name;
        },
        function () {
          if (!vm.isMobile()) setLogoSize();
          else switchLogo();
          transparentNav();
          setWlOptionsLimit();
          closeSidebar();
        }
      );

      $scope.$watch;

      $rootScope.$on('$includeContentLoaded', function () {
        if (!vm.isMobile()) setLogoSize();
        else switchLogo();
        transparentNav();
        setWlOptionsLimit();
      });

      // $rootScope.$on('$stateChangeStart',
      // function(event, toState, toParams, fromState, fromParams){
      //   if (!vm.isMobile()) setLogoSize();
      // })

      // Esconde a sidenav
      vm.toggleSidenav = function (e) {
        e.preventDefault();
        e.stopPropagation();
        angular.element('#sidenav').addClass('show');
      };

      function closeSidebar() {
        if (angular.element('#sidenav').hasClass('show')) {
          angular.element('#sidenav').removeClass('show');
        }
      }

      angular
        .element(
          '#main-content, #sidenav > a, #sidenav .submenu a, #sidenav .close-btn'
        )
        .click(function (e) {
          // e.target
          if (
            $(e.target)
              .parents()
              .toArray()
              .some(function (p) {
                return $('#sidenav .dropdown').toArray().indexOf(p) >= 0;
              })
          )
            return;

          closeSidebar();
        });

      function resizeDesktop() {
        var logo = $('#logo')[0].classList;

        logo.remove('d-none');
        logo.add('d-flex');

        closeSidebar();
        setLogoSize();
      }

      window.addEventListener('resize', function (e) {
        if (!vm.isMobile()) resizeDesktop();
        else switchLogo();
        transparentNav();
        setWlOptionsLimit();
      });

      /**********************
       *       SLIDER
       **********************/

      var _minl = 300,
        _maxl = 15000;

      var _minv = 50000,
        _maxv = 2000000;

      var _min_area = 30,
        _max_area = 50000;

      var optionsl = {
        isDate: false,
        min: _minl,
        max: _maxl,
        start: _minl + 20,
        end: _maxl - 20,
        overlap: false,
      };

      var optionsv = {
        isDate: false,
        min: _minv,
        max: _maxv,
        start: _minv + 20,
        end: _maxv - 20,
        overlap: false,
      };

      var element0 = document.getElementById('pre-filter-pricev-range');
      var element1 = document.getElementById('pre-filter-pricel-range');

      vm.goToSearch = function () {
        $scope.$broadcast('searchHeader', true);
      };

      // -------------------- Login --------------------
      vm.user = auth.getUser();
      vm.isAuthenticated = auth.isAuthenticated();
      vm.logout = function () {
        var token = auth.getCurrentUserToken();
        auth.logout(token);
      };

      vm.forms = {
        login: {
          email: '',
          pass: '',
        },

        openModalLogin: function (e) {
          e.preventDefault();
          var that = this;

          $rootScope._url = false;

          swangular.open({
            animation: false,
            showCloseButton: true,
            showConfirmButton: false,
            html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-login.html\'"></div>',
            controllerAs: 'vm',
            controller: 'LoginController',
          });
        },
        openModalGoCadastro: function (e) {
          e.preventDefault();

          var that = this;
          if (auth.isAuthenticated()) {
            $state.go('main.painel.typeform-1', {}, { reload: true });
          } else {
            $rootScope._url = true;
            swangular.open({
              animation: false,
              showCloseButton: true,
              showConfirmButton: false,
              html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-login.html\'"></div>',
              controllerAs: 'vm',
              controller: 'LoginController',
            });
          }
        },
      };
      /* ----------------------------- */

      vm.goToSearch = function () {
        $scope.$broadcast('searchHeader', true);
      };

      //corrige o bug B2C-158
      if (vm.isMobile() && !vm.isDesktop()) {
        if (vm.getPageWidth() < 1024) {
          $('body').swipe({
            swipe: function (direction) {
              if (direction == 'left')
                angular.element('#sidenav').addClass('show');
              if (direction == 'right')
                angular.element('#sidenav').removeClass('show');
            },
            allowPageScroll: 'vertical',
          });
        }
      }

      vm.itsListingDetail = function () {
        return (
          $state.current.url.includes(':id') ||
          $state.current.minHeader === true
        );
      };

      vm.activeSubmenu = activeSubmenu;

      function activeSubmenu(e) {
        var submenu = $(e.target).next();
        if (submenu.hasClass('active')) {
          submenu.removeClass('active');
          $(e.target).find('.fa-chevron-down').removeClass('open');
        } else {
          submenu.addClass('active');
          $(e.target).find('.fa-chevron-down').addClass('open');
        }
      }

      vm.scrollTop = function () {
        if ($state.current.name == 'main.home') {
          var currYOffSet = window.pageYOffset;
          var yOffset = 400;
          yOffset = angular.element('#input-city-home').offset()
            ? angular.element('#input-city-home').offset().top - 32
            : yOffset;

          if (currYOffSet >= 0 && currYOffSet < yOffset) {
            $('#page-header').addClass('position-absolute');
          } else {
            $('#page-header').removeClass('position-absolute');
          }
        } else {
          $('#page-header').removeClass('position-absolute');
        }
      };
    }
  }
})();

(function () {
	'use strict';

	angular.module('arboWeb').directive('footerMain', footerMain);

	/** @ngInject */
	function footerMain() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/footer/footer.html',
			scope: {},
			controller: FooterController,
			controllerAs: 'vm',
			bindToController: true,
		};

		return directive;

		/** @ngInject */

		FooterController.inject = ['$anchorScroll', '$rootScope'];

		function FooterController($anchorScroll, $rootScope, textFormatter) {
			var vm = this;
      vm.formatPhone = textFormatter.formatPhone;
      vm.formatPhoneLink = textFormatter.formatPhoneLink;
			vm.config_wl = $rootScope.ConfigWhiteLabel;

			vm.isMobile = function () {
				var pageWidth = angular.element(document).outerWidth();
				return pageWidth < 992;
			};

      vm.existsPrivacyPolice = !!vm.config_wl.configwl['POLITICA-PRIVACIDADE'];

			if (typeof vm.config_wl.configwl['LINKHEADER'] === 'string') {
				vm.config_wl.configwl['LINKHEADER'] = [
					{
						valor: vm.config_wl.configwl['LINKHEADER'],
						update: vm.config_wl.configwl['LINKHEADER_update'],
					},
				];
			}

			setTimeout(function () {
				(vm.config_wl.configwl['LINKHEADER'] || []).forEach(function (arr) {
					// Se mudar a classe das seções dos links do footer muda aqui tbm
					$('.conheca > .list').append('<li>' + arr.valor + '</li>');
				});
			});

			vm.currentYear = new Date().getFullYear();

			vm.partners = [
				{
					url: 'http://www.bunkerlocacoes.com.br/',
					image: '../../assets/images/bunker.png',
					alt: 'Logo Bunker - Alugar container',
				},
				{
					url: 'http://www.redfootbrasil.org/',
					image: '../../assets/images/redfoot.png',
					alt: 'Logo Redfoot',
				},
				{
					url: 'http://www.rentforall.com.br/',
					image: '../../assets/images/rent-for-all.png',
					alt: 'Logo Rent for All - Alugar espaço',
				},
			];

			vm.scrollTop = function () {
				$anchorScroll();
			};

			vm.buttons = [
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Quarto em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Comodo Rio de Janeiro',
					url: 'http://www.google.com',
				},
				{
					title: 'Quarto em Fortaleza',
					url: 'http://www.google.com',
				},
				{
					title: 'Comodo Londrina',
					url: 'http://www.google.com',
				},
				{
					title: 'Quarto em Curitiba',
					url: 'http://www.google.com',
				},
				{
					title: 'Espaco em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Comodo em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem Fortaleza',
					url: 'http://www.google.com',
				},
				{
					title: 'Comodo Fortaleza',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem Londrina',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Garagem em Sao Paulo',
					url: 'http://www.google.com',
				},
			];

			vm.cities = [
				{
					title: 'Belo Horizonte',
					url: 'http://www.google.com',
				},
				{
					title: 'Brasília',
					url: 'http://www.google.com',
				},
				{
					title: 'Campinas',
					url: 'http://www.google.com',
				},
				{
					title: 'Curitiba',
					url: 'http://www.google.com',
				},
				{
					title: 'Goiânia',
					url: 'http://www.google.com',
				},
				{
					title: 'Guarulhos',
					url: 'http://www.google.com',
				},
				{
					title: 'João Pessoa',
					url: 'http://www.google.com',
				},
				{
					title: 'Londrina',
					url: 'http://www.google.com',
				},
				{
					title: 'Natal',
					url: 'http://www.google.com',
				},
				{
					title: 'Niterói',
					url: 'http://www.google.com',
				},
				{
					title: 'Porto Alegre',
					url: 'http://www.google.com',
				},
				{
					title: 'Ribeirão Preto',
					url: 'http://www.google.com',
				},
				{
					title: 'Rio de Janeiro',
					url: 'http://www.google.com',
				},
				{
					title: 'Salvador',
					url: 'http://www.google.com',
				},
				{
					title: 'Santo André',
					url: 'http://www.google.com',
				},
				{
					title: 'Santos',
					url: 'http://www.google.com',
				},
				{
					title: 'São Bernardo do Campo',
					url: 'http://www.google.com',
				},
				{
					title: 'São Caetano',
					url: 'http://www.google.com',
				},
				{
					title: 'São José',
					url: 'http://www.google.com',
				},
				{
					title: 'São Paulo',
					url: 'http://www.google.com',
				},
				{
					title: 'Ver todas',
					url: 'http://www.google.com',
				},
			];

			//Conheca
			vm.knows = [
				{
					title: 'Sobre Nós',
					surl: 'main.about.us',
				},
				{
					title: 'Termos de Uso',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005516088-Termo-de-Uso-',
				},
				{
					title: 'Imprensa',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005399287-Imprensa',
				},
				{
					title: 'Formas de Pagamento',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005399547-Formas-de-Pagamento',
				},
			];

			//Preciso de Espaço
			vm.members = [
				{
					title: 'Como funciona',
					surl: 'main.becomeMember',
				},
				{
					title: 'O que não posso armazenar',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005477068-O-que-eu-n%C3%A3o-posso-armazenar-',
				},
				{
					title: 'O que posso guardar',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005307987-Que-tipos-de-coisas-eu-posso-guardar-',
				},
				{
					title: 'Como armazenar',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005307907-Como-eu-posso-armazenar-meus-pertences-na-Cabemcasa-',
				},
			];

			//Guardioes
			vm.guardians = [
				{
					title: 'O que é um Guardião',
					surl: 'main.becomeGuardian',
				},
				{
					title: 'Como ser um Guardião',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005568408-Como-ser-um-Guardi%C3%A3o-',
				},
				{
					title: 'Como anunciar espaço',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/articles/115005308847-Como-fazer-um-an%C3%BAncio-na-Cabemcasa-',
				},
				{
					title: 'Dúvidas Frequentes',
					url: 'https://cabemcasa.zendesk.com/hc/pt-br/categories/115000909848-Perguntas-Frequentes',
				},
			];

			//Sobre cabemcasa
			vm.aboutUs =
				'A Cabemcasa é a maior plataforma de armazenamento coletivo do Brasil. Somos uma rede colaborativa que reúne pessoas que têm cômodos vazios em suas casas para armazenar pertences de quem está procurando espaço para guardar seus objetos, ou aqueles que procuram garagens para estacionarem seus veículos. Mais do que uma plataforma inovadora, somos uma comunidade que busca otimizar espaços urbanos, proporcionando uma nova interação entre as pessoas e os ambientes onde vivem. Nossa proposta é trazer aos nossos membros uma alternativa mais econômica que self storages tradicionais, além de promover o consumo colaborativo e a sustentabilidade.';
		}
	}
})();

(function () {
  'use strict';

  angular.module('arboWeb').directive('filters', filtersMain);

  function filtersMain() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/filters/filters.html',
      scope: {
        tipoFiltros: '=',
        pagetitle: '=',
        tiposimovel: '=',
      },
      controller: FiltersController,
      controllerAs: 'vm',
      bindToController: true,
    };

    return directive;

    /** @ngInject */
    function FiltersController(
      $rootScope,
      $scope,
      $q,
      SERVER_URL,
      $http,
      $state,
      $stateParams,
      Imovel,
      Comodidade,
      TipoImovel,
      textFormatter,
      PROD,
      ngMeta,
      $location,
      $window,
      seoService
    ) {
      var vm = this;

      var input = null;
      var autocomplete = null;
      vm.config_wl = $rootScope.ConfigWhiteLabel;
      var geocoder = new google.maps.Geocoder();
      var params = {};

      // vm.tiposimovel = vm.tiposimovel ? vm.tiposimovel : ($rootScope._tiposimovel ? $rootScope._tiposimovel : ['a']);
      vm.autocomplete = function () {
        if (autocomplete == null) {
          var autoCompleteOpcoes = {
            componentRestrictions: {
              country: 'BR',
            },
          };

          autocomplete = new google.maps.places.Autocomplete(
            input,
            autoCompleteOpcoes
          );

          autocomplete.addListener('place_changed', function () {
            // input.focus();
            console.log('HERE');

            getGeoLocation(vm.search.setFilterForm(event, true));
          });
        }
      };

      vm.menu = 1;
      vm.search = {
        // Variaveis
        tipo: {},
        tipos: vm.tiposimovel,
        detail_cond: [],
        detail_ap: [],
        precoVenda: {},
        precolocacao: {},
        listing: [],
        initMap: false,
        initMapMobile: false,

        params: {
          tipo1: $stateParams.tipo1,
          tipo2: $stateParams.tipo2,
          tipo: $stateParams.tipo,
          tipovar: $stateParams.tipovar,
          cidade: $stateParams.cidade,
          // tipoimovel: $stateParams.tipoimovel ? $stateParams.tipoimovel.split('+') : [],
          tipoimovel:
            $stateParams.tipoimovel != undefined
              ? $stateParams.tipoimovel
                  .split('+')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          precovenda: $stateParams.precovenda
            ? $stateParams.precovenda.split('--')
            : [],
          precolocacao: $stateParams.precolocacao
            ? $stateParams.precolocacao.split('--')
            : [],
          area: $stateParams.area ? $stateParams.area.split('--') : [],

          noimovel:
            $stateParams.noimovel != undefined
              ? $stateParams.noimovel
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    // // acc[cur] = that._detail_ap.filter(function(com){return com.cmd_nome == cur});
                    // that
                    return acc;
                  }, {})
              : {},
          noempreendimento:
            $stateParams.noempreendimento != undefined
              ? $stateParams.noempreendimento
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          //dormitorios: $stateParams.dormitorios,
          dormitorios:
            $stateParams.dormitorios != undefined
              ? $stateParams.dormitorios
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          //imb_id: $stateParams.imb_id,
          imb_id:
            $stateParams.imb_id != undefined
              ? $stateParams.imb_id.split('--').reduce(function (acc, cur, i) {
                  acc[cur] = true;
                  return acc;
                }, {})
              : {},

          // vagas: $stateParams.vagas,
          vagas:
            $stateParams.vagas != undefined
              ? $stateParams.vagas.split('--').reduce(function (acc, cur, i) {
                  acc[cur] = true;
                  return acc;
                }, {})
              : {},
          mobilia: $stateParams.mobilia,
          fase: $stateParams.fase,
          center: {
            lat: 0,
            lng: 0,
          },
          north_east: {
            lat: 0,
            lng: 0,
          },
          south_west: {
            lat: 0,
            lng: 0,
          },
        },

        // Fun��es
        // toogle: function (params) {

        //     if (!$(angular.element('.button-toogle')[params]).hasClass('active')) {
        //         angular.element('.button-toogle').toggleClass('active');
        //         angular.element('.wrap-toogle').toggleClass('d-none');
        //     }
        //     if (params == 1) {
        //         $rootScope.$broadcast('listingMapRefresh', vm.search.listing);
        //         this.mapa = true;
        //         $('#page-content').css({ 'padding-right': '0' })
        //     } else {
        //         $rootScope.$broadcast('listingRefresh', vm.search.listing);
        //         this.mapa = false;
        //         $('#page-content').css({ 'padding-right': '' })
        //     }
        // },
        init: function () {
          // // GET Comodidades
          // Comodidade.find({
          // 	filter: {
          // 		fields: ['id', 'cmd_nome', 'cmd_nome_gaia']
          // 	}
          // }, function (res, info) {
          // 	angular.forEach(res, function (v, k) {
          // 		if (v.cmd_nome_gaia === null) {
          // 			vm.search.detail_cond.push(v);
          // 		} else {
          // 			vm.search.detail_ap.push(v);
          // 		}
          // 	})
          // })

          var that = this;
          var geocoder = new google.maps.Geocoder();
          var address = that.params.cidade || that.params.tipo1;

          $http
            .get(
              '//api-site.arboimoveis.com.br/api/geocaches/search/' + address
            )
            .then(function (results, error) {
              // geocoder.geocode({
              // 	'address': address
              // }, function (results, status) {
              // if (status === 'OK') {
              // console.log(results);
              $rootScope.geoCache = results;
              var res = results.data;
              results = results.data.geometry;

              // // Centro do Mapa
              // that.params.center.lat = results.location.lat();
              // that.params.center.lng = results.location.lng();
              that.params.center.lat = results.location.lat;
              that.params.center.lng = results.location.lng;

              // var bd = results.bounds;
              // var vp = results.viewport;
              // // South West
              // that.params.south_west.lat = vp ? vp.getSouthWest().lat() : bd.getSouthWest().lat();
              // that.params.south_west.lng = vp ? vp.getSouthWest().lng() : bd.getSouthWest().lng();
              that.params.south_west.lat =
                results.viewport.southwest.lat +
                (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
              that.params.south_west.lng =
                results.viewport.southwest.lng +
                (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

              // // North East
              // that.params.north_east.lat = vp ? vp.getNorthEast().lat() : bd.getNorthEast().lat();
              // that.params.north_east.lng = vp ? vp.getNorthEast().lng() : bd.getNorthEast().lng();
              that.params.north_east.lat =
                results.viewport.northeast.lat -
                (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
              that.params.north_east.lng =
                results.viewport.northeast.lng -
                (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

              that.params.allCidade = processGMapsRow(res);

              that.getCoord();
              // } else {
              // 	alert('Geocode was not successful for the following reason: ' + status);
              // }
            });

          $('body').removeClass('position-fixed');
          $('.results-wrapper').css({ top: '' });

          angular.element('.btn-order').click(function (e) {
            var dropdown = $('.relevance-dropdown');
            dropdown.toggleClass('show');
          });

          initTitle();
          initSliders();
        },
        getCoord: function (coord) {
          var that = this;
          var coordinates = angular.copy(this.params);

          // Filtro dos verdadeiros e falso
          for (var k in coordinates.dormitorios) {
            if (!coordinates.dormitorios[k]) {
              delete coordinates.dormitorios[k];
            }
          }

          for (var k in coordinates.imb_id) {
            if (!coordinates.imb_id[k]) {
              delete coordinates.imb_id[k];
            }
          }

          for (var k in coordinates.vagas) {
            if (!coordinates.vagas[k]) {
              delete coordinates.vagas[k];
            }
          }

          for (var k in coordinates.noimovel) {
            if (!coordinates.noimovel[k]) {
              delete coordinates.noimovel[k];
            }
          }

          for (var k in coordinates.noempreendimento) {
            if (!coordinates.noempreendimento[k]) {
              delete coordinates.noempreendimento[k];
            }
          }

          if (
            !coordinates.cidade ||
            coordinates.center.lat == 0 ||
            coordinates.center.lng == 0
          ) {
            var address = coordinates.cidade || that.params.tipo1;
            var geocoder = new google.maps.Geocoder();

            $http
              .get(
                '//api-site.arboimoveis.com.br/api/geocaches/search/' + address
              )
              .then(function (results, error) {
                // if (status === 'OK') {
                //console.log(status);
                var res = results.data;
                results = results.data.geometry;

                // // Centro do Mapa
                // that.params.center.lat = results.location.lat();
                // that.params.center.lng = results.location.lng();
                that.params.center.lat = results.location.lat;
                that.params.center.lng = results.location.lng;

                // var bd = results.bounds;
                // var vp = results.viewport;
                // // South West
                // that.params.south_west.lat = vp ? vp.getSouthWest().lat() : bd.getSouthWest().lat();
                // that.params.south_west.lng = vp ? vp.getSouthWest().lng() : bd.getSouthWest().lng();
                that.params.south_west.lat =
                  results.viewport.southwest.lat +
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
                that.params.south_west.lng =
                  results.viewport.southwest.lng +
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

                // // North East
                // that.params.north_east.lat = vp ? vp.getNorthEast().lat() : bd.getNorthEast().lat();
                // that.params.north_east.lng = vp ? vp.getNorthEast().lng() : bd.getNorthEast().lng();
                that.params.north_east.lat =
                  results.viewport.northeast.lat -
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
                that.params.north_east.lng =
                  results.viewport.northeast.lng -
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

                that.params.allCidade = coordinates.allcidade =
                  processGMapsRow(res);

                var _detail_ap = that.detail_ap.filter(function (v) {
                  for (var key in coordinates.noimovel) {
                    if (that.removeSpecialChar(v.cmd_nome) == key) {
                      return key;
                    }
                  }
                });

                coordinates.id_cmd = _detail_ap.map(function (cmd) {
                  return cmd.id;
                });

                findListings(coordinates);
                // } else {
                // 	alert('Geocode was not successful for the following reason: ' + status);
                // }
              });
          } else {
            var _detail_ap = that.detail_ap.filter(function (v) {
              for (var key in coordinates.noimovel) {
                if (that.removeSpecialChar(v.cmd_nome) == key) {
                  return key;
                }
              }
            });

            coordinates.id_cmd = _detail_ap.map(function (cmd) {
              return cmd.id;
            });

            if (coord !== undefined && coord !== null) {
              that.params.north_east = coordinates.north_east =
                coord.north_east;
              that.params.south_west = coordinates.south_west =
                coord.south_west;
              that.params.center = coordinates.center = coord.center;
            }

            findListings(coordinates);
          }
        },
        btnTipo: function (data) {
          this.params.tipovar = data;
          // this.params.tipovar = this.params.tipovar != data ? data : null;
          // this.setFilter();
        },
        btnTipoimovel: function (data) {
          this.params.tipoimovel[data] = !this.params.tipoimovel[data];
          // this.setFilter();
        },
        btnInteresse: function (data) {
          // $rootScope.finalidade = (vm.search.residencial && !vm.search.comercial) ? 1 : (vm.search.comercial && !vm.search.residencial) ? 2 : null;
          if (data == 1) {
            vm.search.residencial = !vm.search.residencial;
          } else if (data == 2) {
            vm.search.comercial = !vm.search.comercial;
          }
          // this.setFilter();
        },
        btnMobilia: function (data) {
          this.params.mobilia = this.params.mobilia != data ? data : null;
          // this.setFilter();
        },
        btnRadio: function (el) {
          // this.setFilter()
        },
        btnFase: function (data) {
          this.params.fase = this.params.fase != data ? data : null;
        },
        setFilter: setFilter,
        setFilterForm: setFilterForm,
        getGeoLocation: getGeoLocation,
        removeSpecialChar: textFormatter.removeSpecialChar,
      };

      angular.element(document).ready(function () {
        // $('#header').addClass('fixed-theme');
        angular.element('input[type="radio"]').each(function (index, element) {
          $(this).click(function () {
            if ($(this).checked) $(this).prop('checked', false);
          });
        });
        input = document.getElementById('header-search');

        if (
          vm.tipoFiltros == 2 ||
          (vm.isMobile() && /main.search/g.test($state.current.name))
        ) {
          vm.search.init();
        }
        vm.search.tipos = $rootScope._tiposimovel;
        // TipoImovel.find({}, function (res, info) {
        // 	vm.search.tipos = res;
        // });
      });

      $scope.$on('mapRefresh', function (event, coord) {
        if (vm.tipoFiltros == 2 || vm.isMobile()) {
          if (vm.search.initMap) {
            //isso aqui e muito errado mais foi para solucionar a tarefa #3938
            if (
              !(
                coord &&
                coord.north_east.lat == coord.south_west.lat &&
                coord.center.lat == coord.south_west.lat &&
                coord.north_east.lng == coord.south_west.lng &&
                coord.center.lng == coord.south_west.lng
              )
            ) {
              vm.search.getCoord(coord);
            } else if ($rootScope.newBairro.coord) {
              vm.search.getCoord($rootScope.newBairro.coord);
              // console.error('Aconteceu o bug do mapa', {coord: coord});
            }
          }
          vm.search.initMap = true;

          // No mobile está dando dois eventos de idle
          // 1 quando o Mapa é iniciado
          // 2 quando troca para a cidade por isso essa verificação
          if (vm.isMobile() && !vm.search.initMapMobile) {
            vm.search.initMap = false;
            vm.search.initMapMobile = true;
          }
        }
      });

      $scope.$on('filterRefresh', function (event, arg) {
        // vm.search.params.order = arg;
        if ($rootScope.tipovar) {
          vm.search.params.tipovar = $rootScope.tipovar;
        } else {
          console.error(
            'Aconteceu o bug do mapa $rootScope.tipovar',
            $rootScope.tipovar
          );
        }
        if (vm.tipoFiltros == 2 || vm.isMobile()) {
          vm.search.setFilter();
        } else {
          console.error(
            'Aconteceu o bug do mapa (vm.tipoFiltros == 2 || vm.isMobile()',
            vm.tipoFiltros
          );
        }
      });

      // $rootScope.$watch('mapa', function (newVal, oldVal) {
      // 	if ($rootScope.mapa && vm.tipoFiltros == 2) {
      // 		vm.search.getCoord()
      // 	}
      // });

      function initTitle() {
        if (vm.search.params.allCidade) {
          var _cidade = {};
          _cidade.cidade =
            vm.search.params.allCidade.cidade +
            ', ' +
            vm.search.params.allCidade.sigla;
          _cidade.bairro = vm.search.params.allCidade.bairro;
          _cidade.logradouro = vm.search.params.allCidade.logradouro;

          vm.pagetitle = {
            cidade_label: vm.search.params.allCidade.label,
            cidade_pesquisa: _cidade,
            count: vm.search.listing.length,
            tipovar: vm.search.params.tipovar,
            tipoimovel: vm.search.params.tipoimovel,
          };
        }
      }

      function processGMapsRow(item) {
        var zipcode = null;
        var number = null;
        var bairro = null;
        var logradouro = null;
        var cidade = null;
        var estado = null;
        var sigla = null;
        var pais = null;
        item.address_components.forEach(function (element) {
          if (element.types[0] == 'postal_code') {
            zipcode = element.long_name;
          } else if (element.types[0] == 'street_number') {
            number = element.long_name;

            if (number.indexOf(',') != -1) {
              number = number.split(',')[0];
            }
          } else if (
            element.types[0] == 'neighborhood' ||
            element.types[1] == 'sublocality'
          ) {
            bairro = element.long_name;
          } else if (element.types[0] == 'route') {
            logradouro = element.long_name;
          } else if (element.types[0] == 'administrative_area_level_2') {
            cidade = element.long_name;
          } else if (element.types[0] == 'administrative_area_level_1') {
            estado = element.long_name;
            sigla = element.short_name;
          } else if (element.types[0] == 'country') {
            pais = element.long_name;
          }
        }, this);

        //    if (zipcode != null) {
        return {
          label: item.formatted_address,
          value: item.formatted_address,
          latitude: item.geometry.location.lat,
          longitude: item.geometry.location.lng,
          zipcode: zipcode,
          number: number,
          bairro: bairro,
          logradouro: logradouro,
          cidade: cidade,
          estado: estado,
          sigla: sigla,
          pais: pais,
        };
        //    }
      }

      $scope.$on('searchHeader', function (event, search) {
        if (!search) {
          vm.search.setFilterForm(event, search);
        } else {
          getGeoLocation(vm.search.setFilterForm(event, search));
        }
      });

      function setFilterForm(e, srch) {
        if (e) e.preventDefault();
        // var that = this;
        var that = vm.search;

        setTimeout(function () {
          // var geocoder = new google.maps.Geocoder();

          var search = input.value
            ? input.value.toLowerCase()
            : vm.config_wl.cidade && vm.config_wl.estado && srch
            ? vm.config_wl.cidade.toLowerCase() +
              ', ' +
              vm.config_wl.estado.toLowerCase()
            : null;
          if (!!search && search != '') {
            search = search.toLowerCase().replace(/ - /g, '-');
            search = search.replace(/,/g, '');
            search = search.replace(/ /g, '-');
            search = search.replace(/-brasil/g, '');
            search = textFormatter.removeSpecialChar(search);
            that.params.cidade = search;
          }

          initParams();

          if (
            that.params.tipo1 != undefined &&
            that.params.tipo1 != null &&
            that.params.tipo2 == undefined &&
            that.params.tipo2 == null
          ) {
            if (
              that.params.tipo1 == 'a-venda' ||
              that.params.tipo1 == 'para-alugar' ||
              that.params.tipo1 == 'lancamento'
            ) {
              that.params.tipovar = that.params.tipo1;

              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo2 = that.params.cidade;
              // } else if (vm.search.tipos.filter(function (el) { return that.params.tipo1[textFormatter.removeSpecialChar(el.timv_nome)] }).length) {
            } else if (
              vm.search.tipos.length &&
              vm.search.tipos.filter(function (el) {
                return (
                  $stateParams.tipo1 == el.timv_label ||
                  $stateParams.tipo1.split('+').length > 1
                );
              }).length
            ) {
              // that.params.tipoimovel = that.params.tipo1;
              that.params.tipoimovel =
                that.params.tipo1 != undefined
                  ? that.params.tipo1.split('+').reduce(function (acc, cur, i) {
                      acc[cur] = true;
                      return acc;
                    }, {})
                  : {};

              // that.params.tipoimovel = params.tipo1 = Object.entries(that.params.tipo1).filter(function (v) {
              // 	return v[1];
              // }).map(function (v) {
              // 	if (v[1]) return v[0];
              // }).join('+');
              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo2 = that.params.cidade;
            } else {
              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo1 = that.params.cidade;
            }
          } else if (
            (that.params.tipo1 == undefined || that.params.tipo1 == null) &&
            (that.params.tipo2 == undefined || that.params.tipo2 == null)
          ) {
            that.params.cidade = that.params.cidade
              ? that.params.cidade
              : (vm.config_wl.cidade + '-' + vm.config_wl.estado).toLowerCase();
            that.params.tipovar =
              that.params.tipovar != undefined
                ? that.params.tipovar
                : 'a-venda';
          } else {
            if (
              that.params.tipo1 == 'a-venda' ||
              that.params.tipo1 == 'para-alugar' ||
              that.params.tipo1 == 'lancamento'
            ) {
              that.params.tipovar = that.params.tipo1;

              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo2 = that.params.cidade;
              // } else if (vm.search.tipos.filter(function (el) { return that.params.tipo1[textFormatter.removeSpecialChar(el.timv_nome)] }).length){

              // } else if (vm.search.tipos.filter(function (el) { var regx = new RegExp(textFormatter.removeSpecialChar(el.timv_nome)); return regx.test($stateParams.tipo1) }).length) {
              // TENTAR MUDAR DEPOIS
            } else if (
              vm.search.tipos.length &&
              vm.search.tipos.filter(function (el) {
                return (
                  $stateParams.tipo1 == el.timv_label ||
                  $stateParams.tipo1.split('+').length > 1
                );
              }).length
            ) {
              // that.params.tipoimovel = that.params.tipo1;
              that.params.tipoimovel =
                that.params.tipo1 != undefined
                  ? that.params.tipo1.split('+').reduce(function (acc, cur, i) {
                      acc[cur] = true;
                      return acc;
                    }, {})
                  : {};

              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo2 = that.params.cidade;
            } else {
              that.params.cidade = that.params.cidade
                ? that.params.cidade
                : (
                    vm.config_wl.cidade +
                    '-' +
                    vm.config_wl.estado
                  ).toLowerCase();
              that.params.tipo1 = that.params.cidade;
            }
          }

          // setFilter();

          if (that.params.cidade) {
            var address = that.params.cidade || that.params.tipo1;

            $http
              .get(
                '//api-site.arboimoveis.com.br/api/geocaches/search/' + address
              )
              .then(function (results, error) {
                // if (status === 'OK') {
                //console.log(status);
                var res = results.data;
                results = results.data.geometry;

                // // Centro do Mapa
                // that.params.center.lat = results.location.lat();
                // that.params.center.lng = results.location.lng();
                that.params.center.lat = results.location.lat;
                that.params.center.lng = results.location.lng;

                // var bd = results.bounds;
                // var vp = results.viewport;
                // // South West
                // that.params.south_west.lat = vp ? vp.getSouthWest().lat() : bd.getSouthWest().lat();
                // that.params.south_west.lng = vp ? vp.getSouthWest().lng() : bd.getSouthWest().lng();
                that.params.south_west.lat =
                  results.viewport.southwest.lat +
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
                that.params.south_west.lng =
                  results.viewport.southwest.lng +
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

                // // North East
                // that.params.north_east.lat = vp ? vp.getNorthEast().lat() : bd.getNorthEast().lat();
                // that.params.north_east.lng = vp ? vp.getNorthEast().lng() : bd.getNorthEast().lng();
                that.params.north_east.lat =
                  results.viewport.northeast.lat -
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
                that.params.north_east.lng =
                  results.viewport.northeast.lng -
                  (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);

                that.params.allCidade = processGMapsRow(res);
                // console.log(that.params.tipovar);

                // var notify = ($state.current.name == 'main.home');
                // $state.go($state.current.name, that.params, {
                //     location: true,
                //     notify: notify
                // });

                // that.getCoord();
                // initParams();
                // $rootScope.$broadcast('changeMapCity', that.params.cidade);
                if (/main.search/g.test($state.current.name)) {
                  setFilter(srch);
                } else {
                  setFilter();
                }
                $('#header-search').blur();
                // } else {
                // 	alert('Geocode was not successful for the following reason: ' + status);
                // }
              });
          }
        }, 40);
      }

      function getGeoLocation(cb) {
        if (!navigator.geolocation) {
          console.info('Geolocation is not supported by your browser');
          cb();
          return;
        }

        function successGL(position) {
          var latitude = position.coords.latitude;
          var longitude = position.coords.longitude;
          var latlng = { lat: latitude, lng: longitude };
          var storagelocal = JSON.parse(
            window.localStorage.getItem('location')
          );

          if (
            !storagelocal ||
            (storagelocal &&
              latlng.lat != storagelocal.lat &&
              storagelocal.lng != latlng.lng)
          ) {
            window.localStorage.setItem('location', JSON.stringify(latlng));

            geocoder.geocode({ location: latlng }, function (results, status) {
              if (status === 'OK') {
                var place = null;
                results[0].address_components.forEach(function (element) {
                  if (
                    !place &&
                    element.types[0] == 'administrative_area_level_2'
                  ) {
                    place = element.long_name;
                  } else if (
                    place &&
                    element.types[0] == 'administrative_area_level_1'
                  ) {
                    place = place + ' ' + element.short_name;
                  } else if (
                    !place &&
                    element.types[0] == 'administrative_area_level_1'
                  ) {
                    place = element.long_name;
                  } else if (!place && element.types[0] == 'country') {
                    place = element.long_name;
                  }
                });

                input.value = place;
                window.localStorage.setItem('location.address', input.value);
              }
              cb();
            });
          } else {
            if (window.localStorage.getItem('location.address')) {
              input.value = window.localStorage.getItem('location.address');
              cb();
            } else {
              geocoder.geocode(
                { location: latlng },
                function (results, status) {
                  if (status === 'OK') {
                    input.value = results[0].formatted_address;
                    window.localStorage.setItem(
                      'location.address',
                      input.value
                    );
                  }
                  cb();
                }
              );
            }
          }
        }

        function errorGL() {
          console.error('Unable to retrieve your location');
          cb();
        }
        if (input.value == '') {
          navigator.geolocation.getCurrentPosition(successGL, errorGL);
        } else {
          var cod_gaia = /[A-Z]{1,}(s|_|-)?[0-9]{1,}/gi;
          var id = /^\d+$/g;
          console.log();

          if (cod_gaia.test(input.value) || id.test(input.value)) {
            window.open('/imovel/' + input.value, '_self');
          } else {
            goToList();
          }
        }
      }

      function initParams() {
        vm.search.params = $.extend(vm.search.params, {
          tipo1: $stateParams.tipo1,
          tipo2: $stateParams.tipo2,
          tipo: $stateParams.tipo,
          tipovar: $stateParams.tipovar ? $stateParams.tipovar : null,
          cidade: $stateParams.cidade ? $stateParams.cidade : null,

          // tipoimovel: $stateParams.tipoimovel ? $stateParams.tipoimovel : null,
          tipoimovel:
            $stateParams.tipoimovel != undefined
              ? $stateParams.tipoimovel
                  .split('+')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          precovenda: $stateParams.precovenda
            ? $stateParams.precovenda.split('--')
            : [],
          precolocacao: $stateParams.precolocacao
            ? $stateParams.precolocacao.split('--')
            : [],
          area: $stateParams.area ? $stateParams.area.split('--') : [],

          noimovel:
            $stateParams.noimovel != undefined
              ? $stateParams.noimovel
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    // // acc[cur] = that._detail_ap.filter(function(com){return com.cmd_nome == cur});
                    // that
                    return acc;
                  }, {})
              : {},
          noempreendimento:
            $stateParams.noempreendimento != undefined
              ? $stateParams.noempreendimento
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          //dormitorios: $stateParams.dormitorios,
          dormitorios:
            $stateParams.dormitorios != undefined
              ? $stateParams.dormitorios
                  .split('--')
                  .reduce(function (acc, cur, i) {
                    acc[cur] = true;
                    return acc;
                  }, {})
              : {},

          //imb_id: $stateParams.imb_id,
          imb_id:
            $stateParams.imb_id != undefined
              ? $stateParams.imb_id.split('--').reduce(function (acc, cur, i) {
                  acc[cur] = true;
                  return acc;
                }, {})
              : {},

          // vagas: $stateParams.vagas,
          vagas:
            $stateParams.vagas != undefined
              ? $stateParams.vagas.split('--').reduce(function (acc, cur, i) {
                  acc[cur] = true;
                  return acc;
                }, {})
              : {},

          mobilia: $stateParams.mobilia,
          fase: $stateParams.fase ? $stateParams.fase : null,
        });
      }

      function setFilter(n) {
        // ----------------------------

        $stateParams.pagina = undefined;
        if (n != true && $stateParams.tipo1) {
          if (
            $stateParams.tipo1 == 'a-venda' ||
            $stateParams.tipo1 == 'para-alugar' ||
            $stateParams.tipo1 != 'lancamento'
          ) {
            vm.search.params.tipo1 = $stateParams.tipo1;
            vm.search.params.cidade = vm.search.params.cidade
              ? vm.search.params.cidade
              : (vm.config_wl.cidade + '-' + vm.config_wl.estado).toLowerCase();
            vm.search.params.tipo2 = vm.search.params.cidade;
          } else if (
            vm.search.tipos.filter(function (el) {
              return (
                $stateParams.tipo1 == el.timv_label ||
                ($stateParams.tipo1.split('+').length > 1 &&
                  $stateParams.tipoimovel != 'lancamento')
              );
            }).length
          ) {
            vm.search.params.tipo1 = $stateParams.tipo1;
            vm.search.params.cidade = vm.search.params.cidade
              ? vm.search.params.cidade
              : (vm.config_wl.cidade + '-' + vm.config_wl.estado).toLowerCase();
            vm.search.params.tipo2 = vm.search.params.cidade;
          } else if ($stateParams.tipo1) {
            vm.search.params.cidade = $stateParams.tipo1;
            vm.search.params.cidade = vm.search.params.cidade
              ? vm.search.params.cidade
              : (vm.config_wl.cidade + '-' + vm.config_wl.estado).toLowerCase();
            vm.search.params.tipo1 = vm.search.params.cidade;
          }
        }

        // -----------------------------
        var params = angular.copy(vm.search.params);
        var stateName;
        if (params.tipovar == 'novos') {
          // PARA EMPREENDIMENTOS
        }
        // else if(params.tipovar == "lancamento")
        // {
        // 	// vm.search.params.tipo1 = (!$stateParams.tipo1 && $stateParams.tipoimovel == 'lancamento') ? 'lancamento' : $stateParams.tipo1;
        // 	console.log()
        // }
        else {
          params.tipoimovel =
            params.tipovar == 'lancamento' ? null : params.tipoimovel;
          // PARA IMOVEIS
          if (
            (params.tipovar == '' || params.tipovar == null) &&
            (angular.equals({}, params.tipoimovel) || params.tipoimovel == null)
          ) {
            // if ((params.tipovar == null && params.tipoimovel != null) || (params.tipovar != null && params.tipoimovel == null)) {
            // if ((params.tipo1 != null || params.tipo1 != undefined) && (params.tipo2 == null || params.tipo2 == undefined) ) {
            stateName = 'main.search-address';
            if (params.tipovar != null && params.tipovar != undefined) {
              params.tipo1 = params.tipovar;
            } else if (
              params.tipoimovel != null &&
              params.tipoimovel != undefined &&
              !angular.equals({}, params.tipoimovel)
            ) {
              // params.tipo1 = params.tipoimovel;
              params.tipo1 = Object.entries(params.tipoimovel)
                .filter(function (v) {
                  return v[1];
                })
                .map(function (v) {
                  if (v[1]) return v[0];
                })
                .join('+');
            } else {
              params.tipo1 = params.cidade;
            }
          } else if (
            params.tipovar != '' &&
            params.tipovar != null &&
            !angular.equals({}, params.tipoimovel) &&
            params.tipoimovel != null
          ) {
            stateName = 'main.search-address-ad-build-type';
            params.tipo1 = null;
            params.tipo2 = null;
            params.tipoimovel = Object.entries(params.tipoimovel)
              .filter(function (v) {
                return v[1];
              })
              .map(function (v) {
                if (v[1]) return v[0];
              })
              .join('+');
          } else {
            stateName = 'main.search-address-ad-type';

            if (params.tipovar != null && params.tipovar != undefined) {
              params.tipo1 = params.tipovar;

              if (
                params.tipoimovel != null &&
                params.tipoimovel != undefined &&
                !angular.equals({}, params.tipoimovel)
              ) {
                params.tipo2 = Object.entries(params.tipoimovel)
                  .filter(function (v) {
                    return v[1];
                  })
                  .map(function (v) {
                    if (v[1]) return v[0];
                  })
                  .join('+');
              } else {
                params.tipo2 = params.cidade;
              }
            } else if (
              params.tipoimovel != null &&
              params.tipoimovel != undefined &&
              !angular.equals({}, params.tipoimovel)
            ) {
              // params.tipo1 = params.tipoimovel;
              params.tipo1 = Object.entries(params.tipoimovel)
                .filter(function (v) {
                  return v[1];
                })
                .map(function (v) {
                  if (v[1]) return v[0];
                })
                .join('+');

              if (params.tipovar != null || params.tipovar != undefined) {
                params.tipo2 = params.tipovar;
              } else {
                params.tipo2 = params.cidade;
              }
            }
          }

          // console.log('Essa rota', stateName);
        }
        $rootScope.finalidade =
          vm.search.residencial && !vm.search.comercial
            ? 1
            : vm.search.comercial && !vm.search.residencial
            ? 2
            : null;
        // console.log(params);
        // params.precovenda = (params.precovenda) ? params.precovenda.join('--') : [];
        // params.precolocacao = (params.precolocacao) ? params.precolocacao.join('--') : [];
        params.precovenda =
          params.precovenda && params.tipovar == 'a-venda'
            ? params.precovenda.join('--')
            : '';
        params.precolocacao =
          params.precolocacao && params.tipovar == 'para-alugar'
            ? params.precolocacao.join('--')
            : '';

        params.area = params.area ? params.area.join('--') : [];
        // console.log(params);
        params.noimovel = Object.entries(params.noimovel)
          .filter(function (v) {
            return v[1];
          })
          .map(function (v) {
            if (v[1]) return v[0];
          })
          .join('--');

        params.noempreendimento = Object.entries(params.noempreendimento)
          .filter(function (v) {
            return v[1];
          })
          .map(function (v) {
            if (v[1]) return v[0];
          })
          .join('--');

        params.dormitorios = Object.entries(params.dormitorios)
          .filter(function (v) {
            return v[1];
          })
          .map(function (v) {
            if (v[1]) return v[0];
          })
          .join('--');

        params.imb_id = Object.entries(params.imb_id)
          .filter(function (v) {
            return v[1];
          })
          .map(function (v) {
            if (v[1]) return v[0];
          })
          .join('--');

        params.vagas = Object.entries(params.vagas)
          .filter(function (v) {
            return v[1];
          })
          .map(function (v) {
            if (v[1]) return v[0];
          })
          .join('--');

        if (n !== true) vm.search.getCoord();

        if (
          angular.element('.filters-modal') &&
          !angular.element('.filters-modal').hasClass('hide')
        )
          vm.toggleFiltersModal();

        var notify = /main.search/g.test($state.current.name);

        if (vm.isMobile() && n === true) {
          $state.transitionTo(stateName, params, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false,
          });
        } else {
          $state.go(stateName, params, {
            location: true,
            notify: n || !notify,
          });
        }
        // $rootScope.finalidade = (vm.search.residencial && !vm.search.comercial) ? 1 : (vm.search.comercial && !vm.search.residencial) ? 2 : null;
        // $scope.$broadcast('filterRefresh', vm.selectedOrder);
        // vm.updateFilter()
        // $rootScope.$broadcast('callCleanMap'); // fazer broad aqui | Removido da master
      }

      function findListings(coordinates) {
        vm.config_wl = $rootScope.ConfigWhiteLabel;
        var _ti = vm.tiposimovel ? vm.tiposimovel : $rootScope._tiposimovel;
        if (_ti) {
          var title = '';
          var desc = 'Encontre as melhores opções de ';
          var _first = false;
          // "Encontre as melhores opções de imóveis  à venda e para alugar em Rio de Janeiro. Na Arbo você encontra a melhor oferta para garantir o seu imóvel."
          if (
            Object.keys(coordinates.tipoimovel).length &&
            !coordinates.tipovar
          ) {
            for (var x in coordinates.tipoimovel) {
              var tipo = _ti.filter(function (el) {
                return x == el.timv_label && coordinates.tipoimovel[x];
              });
              if (tipo[0]) {
                title += !_first
                  ? tipo[0].timv_nome + 's'
                  : ', ' + tipo[0].timv_nome + 's';
                desc += !_first
                  ? tipo[0].timv_nome + 's'
                  : ', ' + tipo[0].timv_nome + 's';
                _first = true;
              }
            }
            desc += ' em ' + coordinates.allCidade.label;
            title += ' em ';
          } else if (
            !Object.keys(coordinates.tipoimovel).length &&
            coordinates.tipovar
          ) {
            desc +=
              'Imóveis ' +
              (coordinates.tipovar == 'a-venda'
                ? 'à venda em '
                : coordinates.tipovar == 'para-alugar'
                ? 'para alugar em '
                : 'lancamento em') +
              coordinates.allCidade.label;
            title =
              'Imóveis ' +
              (coordinates.tipovar == 'a-venda'
                ? 'à venda em '
                : coordinates.tipovar == 'para-alugar'
                ? 'para alugar em '
                : 'lancamento em');
          } else if (
            coordinates.tipovar &&
            Object.keys(coordinates.tipoimovel).length
          ) {
            for (var x in coordinates.tipoimovel) {
              var tipo = _ti.filter(function (el) {
                return x == el.timv_label && coordinates.tipoimovel[x];
              });
              if (tipo && tipo[0]) {
                title += !_first
                  ? tipo[0].timv_nome + 's'
                  : ', ' + tipo[0].timv_nome + 's';
                desc += !_first
                  ? tipo[0].timv_nome + 's'
                  : ', ' + tipo[0].timv_nome + 's';
                _first = true;
              }
            }
            desc +=
              (coordinates.tipovar == 'a-venda'
                ? ' à venda em '
                : ' para alugar em ') + coordinates.allCidade.label;
            title +=
              coordinates.tipovar == 'a-venda'
                ? ' à venda em '
                : ' para alugar em ';
          } else {
            desc +=
              'Imóveis para alugar e à venda em ' + coordinates.allCidade.label;
            title = 'Imóveis em ';
          }
          // console.log(desc)
          desc +=
            '. Na ' +
            vm.config_wl.nome +
            ' você encontra a melhor oportunidade de garantir o seu imóvel.';
          title += coordinates.allCidade.label + ' - ' + vm.config_wl.nome;
          var config = {
            title: title,
            description: desc,
            slug: $location.absUrl(),
            next:
              $location.path() + ('?pagina=' + (+$stateParams.pagina + 1 || 2)),
            prev:
              +$stateParams.pagina - 1 > 1
                ? $location.path() + '?pagina=' + (+$stateParams.pagina - 1)
                : 0,
          };
          seoService.generateTags(config);

          // ngMeta.setTitle(title);
          // ngMeta.setTag('og:title', title);
          // ngMeta.setTag('description', desc);
          // ngMeta.setTag('og:description', desc);
          // ngMeta.setTag('og:url', $location.absUrl());

          // Google PageView
          // gtag('config', 'UA-91552221-1');
        }

        coordinates.fase = $rootScope.fase ? $rootScope.fase : coordinates.fase;
        if (coordinates.fase != null) {
          coordinates.finalidade = $rootScope.finalidade
            ? $rootScope.finalidade
            : coordinates.finalidade;
        }
        coordinates.order = $rootScope.order
          ? $rootScope.order
          : coordinates.order;
        coordinates.tipo1 = coordinates.tipovar;
        coordinates.tipoimovel = coordinates.tipoimovel.lancamento
          ? null
          : coordinates.tipoimovel;
        coordinates.tipoimovel =
          coordinates.tipo1 == 'lancamento'
            ? { lancamento: true }
            : coordinates.tipoimovel;
        Imovel.findByPolygonNew(
          coordinates,
          function (success) {
            vm.search.listing = success;
            if (PROD) {
              if (typeof $window.fbq == 'function') {
                $window.fbq('track', 'Search', {
                  content_type: 'home_listing',
                  content_ids: success.map(function (v) {
                    return (
                      v.imv_cod_gaia +
                      (vm.search.params.tipovar == 'a-venda'
                        ? '_venda'
                        : vm.search.params.tipovar == 'para-alugar'
                        ? '_locacao'
                        : '_venda')
                    );
                  }), // Top search results
                  city: vm.search.params.allCidade.cidade, //Required for Search event
                  region: vm.search.params.allCidade.estado, // region is the state for the US. Required for Search event
                  country: vm.search.params.allCidade.pais, //Required for Search event
                });
              }

              var lis = '';
              lis = vm.search.params.tipovar ? vm.search.params.tipovar : '';
              lis += lis != '' ? '|' : '';
              lis += vm.search.params.allCidade.cidade
                ? vm.search.params.allCidade.cidade.replace(/ /g, '-')
                : '';
              // PAGE_VIEW searchresults
              gtag('event', 'page_view', {
                listing_id: lis,
                listing_pagetype: 'searchresults',
              });
            }

            initTitle();
            if ($scope.$parent.vm.filtros) {
              $scope.$parent.vm.filtros = false;
              $('body').removeClass('position-fixed');
              $('.results-wrapper').css({ top: '' });
            }

            if ($rootScope.mapa) {
              // console.log('refresh mapa');
              $rootScope.$broadcast('listingMapRefresh', {
                listings: vm.search.listing,
                cidade: vm.search.params.cidade,
              });
              // vm.search.initMap = true;
            }

            // console.log('refresh lista');
            $rootScope.$broadcast('listingRefresh', {
              listings: vm.search.listing,
              params: vm.search.params,
            });
          },
          function (error) {
            console.error('error', error);
          }
        );
        // }
      }

      function initSliders() {
        var _minl = 300,
          _maxl = 15000;
        var _minv = 50000,
          _maxv = 5000000;
        var _min_area = 30,
          _max_area = 1000;

        var optionsv = {
          isDate: false,
          min: _minv,
          max: _maxv,
          start: _minv + 1000,
          end: _maxv - 500000,
          overlap: true,
        };

        var optionsl = {
          isDate: false,
          min: _minl,
          max: _maxl,
          start: _minv + 200,
          end: _maxv - 1000,
          overlap: true,
        };

        var area_options = {
          isDate: false,
          min: _min_area,
          max: _max_area,
          start: _min_area + 20,
          end: _max_area - 50,
          overlap: true,
        };
        optionsv.start = vm.search.params.precovenda
          ? vm.search.params.precovenda[0]
          : _minv + 1000;
        optionsv.end = vm.search.params.precovenda
          ? vm.search.params.precovenda[1]
          : _maxv - 500000;
        optionsl.start = vm.search.params.precolocacao
          ? vm.search.params.precolocacao[0]
          : _minl + 200;
        optionsl.end = vm.search.params.precolocacao
          ? vm.search.params.precolocacao[1]
          : _maxl - 1000;

        area_options.start = vm.search.params.area
          ? vm.search.params.area[0]
          : _min + 20;
        area_options.end = vm.search.params.area
          ? vm.search.params.area[1]
          : _max - 50;

        var elementv1 = document.getElementById('pricev-range1');
        var rangev1 = document.getElementById('rangePricev1');
        var elementl1 = document.getElementById('pricel-range1');
        var rangel1 = document.getElementById('rangePricel1');

        var elementv2 = document.getElementById('pricev-range2');
        var rangev2 = document.getElementById('rangePricev2');
        var elementl2 = document.getElementById('pricel-range2');
        var rangel2 = document.getElementById('rangePricel2');
        var area2 = document.getElementById('area-range2');
        var areaRange2 = document.getElementById('rangeArea2');

        var elementvMobile = document.getElementById('pricev-range-mobile');
        var rangevMobile = document.getElementById('rangePricev-mobile');
        var elementlMobile = document.getElementById('pricel-range-mobile');
        var rangelMobile = document.getElementById('rangePricel-mobile');
        var areaMobile = document.getElementById('area-range-mobile');
        var areaRangeMobile = document.getElementById('rangeArea-mobile');

        var timeOut;
        /***************  1. FILTROS DO HEADER  **********************/

        if (elementv1 != null && elementl1 != null) {
          var pricevSlider1 = new Slider(elementv1, optionsv);
          var pricelSlider1 = new Slider(elementl1, optionsl);

          pricevSlider1.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 1000) * 1000) +
              ' - ' +
              textFormatter.formatPrice(Math.round(data.right / 1000) * 1000);
            rangev1.innerHTML = div;

            vm.search.params.precovenda[0] =
              Math.round(data.left / 1000) * 1000;
            vm.search.params.precovenda[1] =
              Math.round(data.right / 1000) * 1000;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });

          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricevSlider1.getInfo().left)
            ) +
            ' - ' +
            textFormatter.formatPrice(
              Math.round(pricevSlider1.getInfo().right)
            );
          rangev1.innerHTML = div;

          /**********************/
          pricelSlider1.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 100) * 100) +
              ' - ' +
              textFormatter.formatPrice(Math.round(data.right / 100) * 100);
            rangel1.innerHTML = div;

            vm.search.params.precolocacao[0] =
              Math.round(data.left / 100) * 100;
            vm.search.params.precolocacao[1] =
              Math.round(data.right / 100) * 100;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });

          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricelSlider1.getInfo().left)
            ) +
            ' - ' +
            textFormatter.formatPrice(
              Math.round(pricelSlider1.getInfo().right)
            );
          rangel1.innerHTML = div;
        }

        /***************  2. FILTROS LATERAIS  **********************/
        if (
          vm.tipoFiltros == 2 &&
          elementv2 != null &&
          elementl2 != null &&
          area2 != null
        ) {
          var pricevSlider2 = new Slider(elementv2, optionsv);
          var pricelSlider2 = new Slider(elementl2, optionsl);
          var areaSlider2 = new Slider(area2, area_options);

          pricevSlider2.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 1000) * 1000);
            rangev2.querySelector('#min').innerHTML = div;

            var div =
              (data.right == _maxv ? '> ' : '') +
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.right / 1000) * 1000);
            rangev2.querySelector('#max').innerHTML = div;

            // rangev2.innerHTML = div;

            vm.search.params.precovenda[0] =
              Math.round(data.left / 1000) * 1000;
            vm.search.params.precovenda[1] =
              Math.round(data.right / 1000) * 1000;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });
          var div =
            'R$ ' +
            textFormatter.formatPrice(Math.round(pricevSlider2.getInfo().left));
          rangev2.querySelector('#min').innerHTML = div;
          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricevSlider2.getInfo().right)
            );
          rangev2.querySelector('#max').innerHTML = div;
          // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricevSlider2.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricevSlider2.getInfo().right));
          // rangev2.innerHTML = div;

          /**********************/
          pricelSlider2.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 100) * 100);
            rangel2.querySelector('#min').innerHTML = div;

            var div =
              (data.right == _maxl ? '> ' : '') +
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.right / 100) * 100);
            rangel2.querySelector('#max').innerHTML = div;

            // rangel2.innerHTML = div;

            vm.search.params.precolocacao[0] =
              Math.round(data.left / 100) * 100;
            vm.search.params.precolocacao[1] =
              Math.round(data.right / 100) * 100;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });
          var div =
            'R$ ' +
            textFormatter.formatPrice(Math.round(pricelSlider2.getInfo().left));
          rangel2.querySelector('#min').innerHTML = div;
          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricelSlider2.getInfo().right)
            );
          rangel2.querySelector('#max').innerHTML = div;
          // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricelSlider2.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricelSlider2.getInfo().right));
          // rangel2.innerHTML = div;

          /**********************/
          areaSlider2.subscribe('moving', function (data) {
            var div =
              textFormatter.formatPrice(Math.round(data.left)) +
              ' <span>m<sup>2</sup></span>';
            areaRange2.querySelector('#min').innerHTML = div;

            var div =
              (data.right == _max_area ? '> ' : '') +
              textFormatter.formatPrice(Math.round(data.right)) +
              ' <span>m<sup>2</sup></span>';
            areaRange2.querySelector('#max').innerHTML = div;

            // var div = textFormatter.formatPrice(Math.round(data.left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(data.right)) + ' <span>m<sup>2</sup></span>';
            // areaRange2.innerHTML = div;

            vm.search.params.area[0] = Math.round(data.left);
            vm.search.params.area[1] = Math.round(data.right);

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });
          var div =
            textFormatter.formatPrice(Math.round(areaSlider2.getInfo().left)) +
            ' <span>m<sup>2</sup></span>';
          areaRange2.querySelector('#min').innerHTML = div;
          var div =
            textFormatter.formatPrice(Math.round(areaSlider2.getInfo().right)) +
            ' <span>m<sup>2</sup></span>';
          areaRange2.querySelector('#max').innerHTML = div;
          // var div = textFormatter.formatPrice(Math.round(areaSlider2.getInfo().left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(areaSlider2.getInfo().right)) + ' <span>m<sup>2</sup></span>';
          // areaRange2.innerHTML = div;
        }

        /***************  3. FILTROS MOBILE  **********************/
        if (
          vm.isMobile() &&
          elementvMobile != null &&
          elementlMobile != null &&
          areaMobile != null
        ) {
          var pricevSliderMobile = new Slider(elementvMobile, optionsv);
          var pricelSliderMobile = new Slider(elementlMobile, optionsl);
          var areaSliderMobile = new Slider(areaMobile, area_options);

          pricevSliderMobile.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 1000) * 1000) +
              ' - ' +
              textFormatter.formatPrice(Math.round(data.right / 1000) * 1000);
            rangevMobile.innerHTML = div;

            vm.search.params.precovenda[0] =
              Math.round(data.left / 1000) * 1000;
            vm.search.params.precovenda[1] =
              Math.round(data.right / 1000) * 1000;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });

          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricevSliderMobile.getInfo().left)
            ) +
            ' - ' +
            textFormatter.formatPrice(
              Math.round(pricevSliderMobile.getInfo().right)
            );
          rangevMobile.innerHTML = div;

          /**********************/
          pricelSliderMobile.subscribe('moving', function (data) {
            var div =
              'R$ ' +
              textFormatter.formatPrice(Math.round(data.left / 100) * 100) +
              ' - ' +
              textFormatter.formatPrice(Math.round(data.right / 100) * 100);
            rangelMobile.innerHTML = div;

            vm.search.params.precolocacao[0] =
              Math.round(data.left / 100) * 100;
            vm.search.params.precolocacao[1] =
              Math.round(data.right / 100) * 100;

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });

          var div =
            'R$ ' +
            textFormatter.formatPrice(
              Math.round(pricelSliderMobile.getInfo().left)
            ) +
            ' - ' +
            textFormatter.formatPrice(
              Math.round(pricelSliderMobile.getInfo().right)
            );
          rangelMobile.innerHTML = div;

          /**********************/

          areaSliderMobile.subscribe('moving', function (data) {
            var div =
              textFormatter.formatPrice(Math.round(data.left)) +
              ' <span>m<sup>2</sup></span> - ' +
              textFormatter.formatPrice(Math.round(data.right)) +
              ' <span>m<sup>2</sup></span>';
            areaRangeMobile.innerHTML = div;

            vm.search.params.area[0] = Math.round(data.left);
            vm.search.params.area[1] = Math.round(data.right);

            clearTimeout(timeOut);
            timeOut = setTimeout(function () {
              vm.search.btnRadio();
            }, 200);
          });

          var div =
            textFormatter.formatPrice(
              Math.round(areaSliderMobile.getInfo().left)
            ) +
            ' <span>m<sup>2</sup></span> - ' +
            textFormatter.formatPrice(
              Math.round(areaSliderMobile.getInfo().right)
            ) +
            ' <span>m<sup>2</sup></span>';
          areaRangeMobile.innerHTML = div;
        }
      }

      vm.toggleFiltersModal = function () {
        if (vm.isMobile()) {
          angular.element('.filters-modal').toggleClass('hide');
          angular.element('.fixed-filter').toggleClass('hide');
          angular.element('.btn-fixed').toggleClass('hide');

          $('body').toggleClass('position-fixed');
          $('.results-wrapper').css({ top: '' });
        }
      };

      vm.removeHideLogo = function (ev) {
        ev.stopPropagation();

        angular.element('.menu-logo').removeClass('hide');
        angular.element('#formHeader').removeClass('expand-search-input');
        angular.element('#formHeaderFilter').removeClass('col-12');
        angular.element('#formHeader').addClass('ml-1');

        if (vm.isMobile) {
          angular.element('#header-search').attr('placeholder', 'Pesquisar');
        }
      };

      vm.hideLogo = function (ev) {
        ev.stopPropagation();

        angular.element('.menu-logo').addClass('hide');
        angular.element('#formHeader').addClass('expand-search-input');
        angular.element('#formHeaderFilter').addClass('col-12');
        angular.element('#formHeader').removeClass('ml-1');

        if (vm.isMobile) {
          angular
            .element('#header-search')
            .attr('placeholder', 'Cidade, bairro, rua ou código');
          setTimeout(function (params) {
            var inputJquery = $('#header-search');
            inputJquery.next().width($('#formHeader').width());
          }, 100);
        }
      };

      vm.isMobile = function () {
        var pageWidth = angular.element('body').outerWidth();
        return pageWidth < 992;
      };

      function goToList() {
        if (vm.codCheck) {
          var search = vm.buscaCodigo;
          if (search && search != undefined && search != '') {
            Imovel.getImovelNew(
              {
                id: search.toUpperCase(),
              },
              function (success) {
                if (success.length != 0) {
                  var description = textFormatter.removeSpecialChar(
                    success[0].imv_titulo
                  );
                  $state.go('main.imovel-sub', {
                    id: success[0].imv_cod_gaia.toUpperCase(),
                    dummy: description,
                  });
                } else {
                  toastr.warning(
                    'Não foi encontrado nenhum imóvel com este código!'
                  );
                }
              }
            );
          } else {
            toastr.warning('Digite um código de imóvel!');
          }
        } else {
          var search = input.value
            ? input.value.toLowerCase()
            : vm.config_wl.cidade && vm.config_wl.estado
            ? vm.config_wl.cidade.toLowerCase() +
              ', ' +
              vm.config_wl.estado.toLowerCase()
            : null;
          if (search != undefined && search != '') {
            search = search.toLowerCase().replace(/ - /g, '-');
            search = search.replace(/,/g, '');
            search = search.replace(/ /g, '-');
            search = search.replace(/-brasil/g, '');
            search = textFormatter.removeSpecialChar(search);
            // params.tipo1 = search;
            params.tipo2 = search;
          }
          // params.tipo1 = params.tipo1 ? params.tipo1 : 'londrina-pr';
          params.tipo2 = params.tipo2 ? params.tipo2 : 'londrina-pr';
          params.tipo1 = 'a-venda';
          switch (vm.menu) {
            case 1:

            case 2:
              // if (vm.tipo !== undefined && vm.tipo !== null && vm.tipo != '') {
              //   params.tipoimovel = vm.tipo.toLowerCase();
              //   params.tipovar = (vm.menu == 1) ? 'a-venda' : 'para-alugar';
              //   $state.go('main.search-address-ad-build-type', params);
              // } else {
              // params.tipovar = (vm.menu == 1) ? 'a-venda' : 'para-alugar';
              $state.go('main.search-address-ad-type', params, {
                reload: true,
              });
              // }
              break;
            case 3:
              if (vm.busca !== undefined) {
                $state.go('main.search-lancamentos-address', {
                  cidade: search,
                });
              } else {
                $state.go('main.search-lancamentos');
              }
              break;
            case 4:
              Imovel.getImovelNew(
                {
                  id: search.toUpperCase(),
                },
                function (success) {
                  if (success.length != 0) {
                    var description = success[0].TituloImovel._cdata
                      .toLowerCase()
                      .replace(
                        /[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
                        '-'
                      )
                      .replace(/\s/g, '-')
                      .replace(/---/g, '-')
                      .replace(/--/g, '-');
                    $state.go('main.imovel-sub', {
                      id: success[0].id,
                      dummy: description,
                    });
                  } else {
                    toastr.warning(
                      'Não foi encontrado nenhum imóvel com este código!'
                    );
                  }
                }
              );
              break;
            default:
              break;
          }
        }
      }
      vm.updateFilter = updateFilter;
      function updateFilter(tipovar) {
        if (vm.selectedOrder) $rootScope.order = vm.selectedOrder;
        if (tipovar) $rootScope.tipovar = tipovar;

        $rootScope.finalidade =
          vm.search.residencial && !vm.search.comercial
            ? 1
            : vm.search.comercial && !vm.search.residencial
            ? 2
            : null;
        $scope.$broadcast('filterRefresh', vm.selectedOrder);
        // $rootScope.$broadcast('callCleanMap'); // fazer broad aqui | Removida da Maste
      }

      // Autocomplete New
      var sessionToken = new google.maps.places.AutocompleteSessionToken();
      var service = new google.maps.places.AutocompleteService({
        componentRestrictions: { country: 'BR' },
      });

      vm.getLocation = function (term) {
        var deferred = $q.defer();
        var queue = [];
        var url = SERVER_URL + 'api/imoveis-replica/get-imoveis-new';
        var urlAutocomplete =
          'https://api-site.arboimoveis.com.br/api/geocaches/autocomplete/' +
          textFormatter.removeSpecialChar(term);
        var req = {
          sessionToken: sessionToken,
          input:
            term +
            (!vm.config_wl.isArbo
              ? vm.config_wl.cidade + ' ' + vm.config_wl.estado
              : '') +
            ', Brasil',
          componentRestrictions: { country: 'BR' },
        };
        var pattern = '/(' + term + ')/i';
        var _where = {
          and: [
            { imv_ativo: true },
            { imv_publicar: true },
            {
              or: [
                { imv_preco_venda: { gte: 1 } },
                { imv_preco_locacao: { gte: 1 } },
                {
                  'imv_emp_fields.emp_preco_min': {
                    gt: 0,
                  },
                },
              ],
            },
            {
              or: [
                { id: parseInt(term) },
                { imv_cod_gaia: { regexp: pattern } },
                { imv_cod_origem: { regexp: pattern } },
                // { imv_titulo: { regexp: pattern } },
                // { imv_cidade: { regexp: pattern } },
                // { imv_bairro: { regexp: pattern } },
                // { imv_endereco: { regexp: pattern } },
              ],
            },
          ],
        };
        if (vm.config_wl.isArbo) {
          _where.push({ imobiliaria: { imb_impulsionar: true } });
        }
        // , function(results, status) {
        //   if (status === 'OK') {
        //     console.log(status, results);
        //   }
        // }
        queue.push(
          $http.get(url, {
            params: {
              limit: 3,
              where: _where,
              wlimobiliaria: !vm.config_wl.isArbo,
            },
          }),
          $http.get(urlAutocomplete)
        );

        $q.all(queue).then(function (res) {
          var predictions = res[1];
          res = res[0];
          // service.getPlacePredictions(req, function (r, s) {
          var resp = res.data.map(function (el) {
            el.description = el['imv_cod_gaia'];
            return el;
          });

          predictions = predictions.data.items
            .filter(function (el) {
              return el.types[0] != 'administrative_area_level_1';
            })
            .map(function (el) {
              el.description = el.desc;
              return el;
            });
          resp = predictions.concat(resp);

          deferred.resolve(resp);
        });
        // });

        return deferred.promise;
      };

      vm.clickSelect = function (item) {
        if (item.imv_cod_gaia) {
          $state.go('main.imovel', { id: item.imv_cod_gaia });
        } else if (item.description) {
          setTimeout(function () {
            goToList();
          }, 500);
        } else {
          $state.go('main.home');
        }
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('FavoritosController', FavoritosController);

  /* @ngInject */
  function FavoritosController($scope, $state, $location, $stateParams, $window, SERVER_URL, textFormatter, auth, Imovel, toastr, createThumb, seoService) {
    var vm = this;

    vm.getFavorites = getFavorites;
    vm.setFavorite = setFavorite;
    vm.unsetFavorite = unsetFavorite;
    vm.makeUrl = makeUrl;
    vm.showComodidades = showComodidades;
    vm.formatPrice = formatPrice;
    vm.createThumb = createThumb;

    function initialize() {
      vm.getFavorites();
    }

    seoService.generateTags({
      title: 'Favoritos',
      description: 'Na lista de favoritos você pode salvar e fazer propostas naquele cantinho que mais amou!',
      slug: $location.absUrl()
    })

    function getFavorites() {
      vm.cod_favorites = JSON.parse($window.localStorage.getItem('favorites'));
      if (vm.cod_favorites && vm.cod_favorites.length != 0) {
        Imovel.getImoveisNew({
            where: {
              imv_cod_gaia: { inq: vm.cod_favorites }
            }
        }).$promise.then(function (res) {
          vm.favorites = res.map(function (el) {
            var o = Object.assign({}, el);
            return createThumb.get(o)
          })
  
          if (vm.favorites.length == 0) vm.favoritesMessage = 'Você ainda não possui nenhum imóvel favorito :(';
          for (var i = 0; i < vm.favorites.length; i++) {
            for (var j = 0; j < vm.cod_favorites.length; j++) {
              if (vm.favorites[i].imv_cod_gaia == vm.cod_favorites[j]) {
                vm.favorites[i].isFavorite = true;
              }
            }
          }
          setTimeout(function () {
            $('.carousel').on('slide.bs.carousel', function (ev) {
              var lazy;
              lazy = $(ev.relatedTarget).find('img');
              if(lazy.data('img')){
                lazy.attr("src",  lazy.data('img'));
                lazy.removeAttr('data-img');
              }
            })

            angular.element('.carousel').bcSwipe({ threshold: 50 });
          }, 500);

        }, function (err) {
          vm.favorites = [];
          vm.favoritesMessage = 'Ocorreu um erro ao carregar os favoritos, tente novamente.';
          console.log(err);
        })
      }
      else {
        vm.favorites = [];
        vm.favoritesMessage = 'Você ainda não possui nenhum imóvel favorito :(';
      }
    }

    function setFavorite(imovel) {
      if (vm.cod_favorites == null || vm.cod_favorites.length == 0) {
        vm.cod_favorites = [imovel.imv_cod_gaia];
      }
      else {
        vm.cod_favorites.push(imovel.imv_cod_gaia);
      }

      $window.localStorage.setItem('favorites', JSON.stringify(vm.cod_favorites));
      imovel.isFavorite = true;
      vm.getFavorites();
      toastr.info('<strong>Imóvel salvo nos favoritos.</strong>', {
        iconClass: 'toast-arbo'
      });
    }

    function unsetFavorite(imovel) {
      var index = vm.cod_favorites.indexOf(imovel.imv_cod_gaia);

      if (index !== -1) {
        vm.cod_favorites.splice(index, 1);
        $window.localStorage.setItem('favorites', JSON.stringify(vm.cod_favorites));
        imovel.isFavorite = false;
      }

      vm.getFavorites();
      toastr.info('<strong>Imóvel retirado dos favoritos.</strong>', {
        iconClass: 'toast-arbo'
      });
    }

    function makeUrl(listing) {
      // var urlPath = $location.$$url.split('?')[0].split('#')[0];
      var description = textFormatter.removeSpecialChar(listing.imv_titulo)
      return ('/imovel/' + description + '/' + listing.imv_cod_gaia);
    }

    function showComodidades(subtipo, grupoComodidades) {
      // Sobrado / Casa / Chácara / Pousada    
      if (grupoComodidades == 1 && (subtipo == 2 || subtipo == 3 || subtipo == 4 || subtipo == 12 || subtipo == 15 || subtipo == 19 || subtipo == 21)) {
        return true;
      }
      //Apartamento / Duplex / Triplex / Kitnet / Cobertura
      else if (grupoComodidades == 2 && (subtipo == 1 || subtipo == 8 || subtipo == 10 || subtipo == 13 || subtipo == 14 || subtipo == 16 || subtipo == 17 || subtipo == 18 || subtipo == 23 || subtipo == 29 || subtipo == 30 || subtipo == 31 || subtipo == 32 || subtipo == 33 || subtipo == 34)) {
        return true;
      }
      //Sala / Loja
      else if (grupoComodidades == 3 && (subtipo == 7 || subtipo == 11 || subtipo == 20 || subtipo == 22 || subtipo == 24 || subtipo == 25 || subtipo == 26 || subtipo == 27)) {
        return true;
      }
      //Barracão / Loteamento
      else if (grupoComodidades == 4 && (subtipo == 6)) {
        return true;
      }
      //Terreno
      else if (grupoComodidades == 5 && (subtipo == 5 || subtipo == 9 || subtipo == 28)) {
        return true;
      }
      // Default
      else if (grupoComodidades == 6) {
        return true;
      }
      return false;
    }

    function formatPrice(n) {
      if (n != null) {
        n = parseFloat(n, 10);
        return n.toFixed(0).replace(/./g, function (c, i, a) {
          return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
        });
      }
    }


    initialize();
  }

})();
(function () {
	'use strict';

	angular.module('arboWeb').directive('checkImage', checkImage);

	/*
	 * Directive
	 */
	checkImage.$inject = ['$http'];

	function checkImage($http) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				attrs.$observe('ngSrc', function (ngSrc) {
					$http
						.get(ngSrc)
						.success(function () {
							// console.log('checkImage')
							// alert('image exist');
						})
						.error(function () {
							// alert('image not exist');
							// console.log('image not exist')

							element.attr('src', '../../assets/images/novosite/sem-foto-locais.jpg'); // set default image
						});
				});
			},
		};
	}
})();

(function () {
	'use strict';

	angular.module('arboWeb').directive('carouselPlaces', carouselPlaces).controller('ListingPlacesControllerCarousel', ListingPlacesControllerCarousel);

	/** @ngInject */
	function ListingPlacesControllerCarousel($rootScope, $http, $location, $scope, $state, $compile, $stateParams, $window, $sce, Imovel, toastr, createThumb, textFormatter, PROD, SITE_URL, SERVER_URL) {
		var vm = this;
		vm.owlPropertiesPlaces = {
			loop: false,
			nav: false,
			margin: 10,
			dots: false,
			autoWidth: true,
			onInitialized: function (event) {
				refreshWidth(event);
			},

			// responsiveClass: true,
			// responsive: {
			// 	0: {
			// 		items: 1,
			//   },
			//   350: {
			//     items: 1,
			//     stagePadding: 25,
			//   },
			// 	700: {
			// 		items: 3,
			// 		stagePadding: 25,
			// 	},
			// 	980: {
			// 		items: 2,
			// 	},
			// 	1280: {
			// 		items: 3,
			//   },
			//   1480: {
			//     items: 3,
			// 		stagePadding: 25,
			// 	},
			// 	1700: {
			// 		items: 4,
			// 		stagePadding: 5,
			//   },
			//   2300: {
			// 		items: 5,
			// 		stagePadding: 5,
			//   },
			//   2700: {
			// 		items: 6,
			// 		stagePadding: 5,
			// 	},
			// },
		};

		function refreshWidth(event) {
			setTimeout(function () {
				$(event.currentTarget).parent().owlCarousel({
					loop: false,
					navigation: false,
					nav: false,
					margin: 10,
					dots: false,
					autoWidth: true,
				});
			}, 1000);
		}

		function init() {
			var carouselApi = {};
			// vm.owlProperties = _default;

			vm.readyCarousel = function (api) {
				carouselApi = api;
			};

			vm.nextOwl = function (ev) {
				carouselApi.trigger('next.owl.carousel');
			};

			vm.prevOwl = function (ev) {
				carouselApi.trigger('prev.owl.carousel');
			};
		}

		init();
	}

	/** @ngInject */
	function carouselPlaces() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/carouselPlaces/carouselPlaces.html',
			scope: {
				places: '=',
				properties: '=',
				navegator: '=',
				position: '=',
				titleCarousel: '@',
				icon: '@',
			},
			controller: ListingPlacesControllerCarousel,
			controllerAs: 'vm',
			bindToController: true,
		};

		return directive;
	}
})();

(function () {
	'use strict';

	angular
		.module('arboWeb')
		.directive('carouselImovel', carouselImovel)
		.directive('carouselImovelDestaques', carouselImovelDestaques)
		.controller('ListingControllerCarousel', ListingControllerCarousel);


	/** @ngInject */
	function ListingControllerCarousel($rootScope, $http, $location, $scope, $state, $compile, $stateParams, $window, $sce, Imovel, toastr, createThumb, textFormatter, PROD, SITE_URL, SERVER_URL) {
		var vm = this;
		var _default = {
			loop: false,
			nav: false,
			margin: 10,
			dots: false,
			responsiveClass: true,
			responsive: {
				0: {
					items: 1,
					// stagePadding: 22
				},
				700: {
					items: 2,
					stagePadding: 25
				},
				980: {
					items: 3,
				},
				1280: {
					items: 4,
				},
				1600: {
					items: 5
				}
			}
		}

		function init() {
			
			var carouselApi = {};
			vm.owlProperties = vm.properties || _default;

			vm.readyCarousel = function (api) {
				carouselApi = api;
			}

			vm.nextOwl = function (ev) {
				carouselApi.trigger('next.owl.carousel');
			}

			vm.prevOwl = function (ev) {
				carouselApi.trigger('prev.owl.carousel');
			}
		}


		init();
	}

	/** @ngInject */
	function carouselImovel() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/carouselImovel/carouselImovel.html',
			scope: {
				imoveis: "=",
				properties: "=",
				navegator: "=",
				titleCarousel: "@",
			},
			controller: ListingControllerCarousel,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}

	/** @ngInject */
	function carouselImovelDestaques() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/carouselImovel/carouselImovelDestaque.html',
			scope: {
				imoveis: "=",
				properties: "=",
				navegator: "=",
				titleCarousel: "@",
			},
			controller: ListingControllerCarousel,
			controllerAs: 'vm',
			bindToController: true
		};

		return directive;
	}

})();

(function () {
	'use strict';

	angular.module('arboWeb').directive('cardPlace', cardPlace).controller('ListingPlaceController', ListingPlaceController);

	/** @ngInject */
	function ListingPlaceController(textFormatter, $stateParams) {
		var vm = this;
    vm.tipovar = $stateParams.tipovar ? $stateParams.tipovar + '/' : '';
		function init() {
			// console.log(vm.place)
			vm.url = '/imoveis/' + vm.tipovar + textFormatter.removeSpecialChar((vm.place.name || '') + '-' + $stateParams.tipo1);
		}
		vm.getDistanceFromLatLonInKm = getDistanceFromLatLonInKm;
		function getDistanceFromLatLonInKm(position1, position2) {
			if (position1 && position2) {
				var deg2rad = function (deg) {
						return deg * (Math.PI / 180);
					},
					R = 6371,
					dLat = deg2rad(position2.lat - position1.lat),
					dLng = deg2rad(position2.lng - position1.lng),
					a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(position1.lat)) * Math.cos(deg2rad(position1.lat)) * Math.sin(dLng / 2) * Math.sin(dLng / 2),
					c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return (R * c * 1000).toFixed();
			} else {
				return '0';
			}
		}

		init();
	}

	/** @ngInject */
	function cardPlace() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/cardPlace/cardPlace.html',
			scope: {
				place: '=',
				position: '=',
			},
			controller: ListingPlaceController,
			controllerAs: 'vm',
			bindToController: true,
		};

		return directive;
	}
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .directive('cardImovel', cardImovel)
    .directive('cardImovelDestaques', cardImovelDestaque)
    .controller('ListingController', ListingController);

  /** @ngInject */
  function ListingController(
    $rootScope,
    $http,
    $location,
    $scope,
    $state,
    $compile,
    $stateParams,
    $window,
    $sce,
    Imovel,
    toastr,
    createThumb,
    textFormatter,
    PROD,
    SITE_URL,
    SERVER_URL
  ) {
    var vm = this;
    vm.makeUrl = makeUrl;
    vm.createThumb = createThumb;
    vm.formatPrice = textFormatter.formatPrice;
    vm.showComodidades = initComodidades(vm.imovel.timv_id);
    vm.rnd = Math.floor(Math.random() * 100 + 1);
    // vm.rnd = moment().time;
    vm.setFavorite = setFavorite;
    vm.formatPrice = formatPrice;
    vm.titleCase = titleCase;

    function makeUrl(listing, video) {
      // var viewVideo = video ? "?video=true" : "";
      if (vm.urlImovel) return vm.urlImovel;
      // var urlPath = $location.$$url.split('?')[0].split('#')[0];
      var description = textFormatter.removeSpecialChar(listing.imv_titulo);
      return '/imovel/' + description + '/' + listing.imv_cod_gaia;
    }

    function init() {
      vm.imovel = createThumb.get(vm.imovel);
      vm.imovel = createThumb.get640(vm.imovel);
      var configWL = $rootScope.ConfigWhiteLabel;
      vm.config_wl = configWL;

      $('.carousel').on('slide.bs.carousel', function (ev) {
        var lazy;
        $(ev.relatedTarget).addClass('next-active'); // Para a próxima imagem ficar visivel.

        lazy = $(ev.relatedTarget).find('img');
        if (lazy.data('img')) {
          lazy.attr('src', lazy.data('img'));
          lazy.removeAttr('data-img');
        }
      });

      $('.carousel').on('slid.bs.carousel', function (ev) {
        $(ev.relatedTarget).removeClass('next-active'); // Remove a visibilidade.
      });

      setTimeout(function () {
        $('.carousel').bcSwipe({ threshold: 50 });
      }, 500);

      vm.ocultarPreco = vm.imovel
        ? vm.imovel.imv_ocultar_preco
        : null;
      vm.valorVenda = vm.imovel
        ? vm.imovel.imv_avg_venda || vm.imovel.imv_preco_venda
        : null;
      vm.valorAluguel = vm.imovel
        ? vm.imovel.imv_avg_locacao || vm.imovel.imv_preco_locacao
        : null;
      vm.valorCondominio = vm.imovel
        ? vm.imovel.imv_avg_cond || vm.imovel.imv_preco_cond
        : null;

      var strTipo =
        vm.valorVenda > 0 && vm.valorAluguel > 0
          ? 'à venda ou para alugar '
          : vm.valorVenda > 0
          ? 'à venda '
          : 'para alugar ';

      var tipo = vm.imovel.tipo_imovel || {};
      var tipoImovel = tipo.timv_nome;
      vm.title = tipoImovel + ' ' + strTipo + 'em ' + vm.imovel.imv_bairro;

      // Rua, número e bairro
      vm.endereco =
        vm.imovel.imv_endereco && vm.imovel.imv_endereco.replace(/,$/gi, '');
      vm.imovel.imv_end_numero !== null &&
        (vm.endereco += ', ' + vm.imovel.imv_end_numero);
      vm.imovel.imv_bairro && (vm.endereco += ' - ' + vm.imovel.imv_bairro);

      var regex = /(edif(í|i)cio)|(conjunto)|(residencial)|(condom(í|i)nio)/gi;
      // isso aqui vai dar B.O no futuro
      vm.titleCondominio = regex.test(vm.imovel.imv_nome_cond)
        ? vm.imovel.imv_nome_cond
        : 'Condomínio ' + vm.imovel.imv_nome_cond || '';
    }

    function initComodidades(tipo) {
      var comodidade = [];
      // TODO : Identificar padrão e minimizar o código abaixo

      // Sobrado | Casa | Terreno | Chácara | Pousada
      if ([2, 3, 4, 9, 12].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_area_total,
          tipo: 1,
          label: 'Área Total',
          icon: 'fa-expand',
        });
      }

      // Apartamento | Sobrado | Casa | Cobertura | Chácara
      // Apartamento Duplex | Kitnet | Pousada | Apartamento Triplex
      if ([1, 2, 3, 7, 9, 10, 11, 12, 13].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_qtd_dorm,
          label: 'Quartos',
          icon: 'fa-bed',
        });
      }

      // Apartamento | Sobrado | Casa | Barracão | Loja | Cobertura | Sala
      // Chácara | Apartamento Duplex | Kitnet | Pousada | Apartamento Triplex
      if ([1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_qtd_banheiros,
          label: 'Banheiros',
          icon: 'fa-shower',
        });

        comodidade.push({
          data: vm.imovel.imv_area_util,
          tipo: 1,
          label: 'Área Util',
          icon: 'fa-ruler-triangle',
        });
      }

      // Apartamento | Loja | Cobertura | Sala | Apartamento Duplex | Kitnet | Apartamento Triplex
      if ([1, 6, 7, 8, 10, 11, 13].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_qtd_vagas,
          label: 'Vagas',
          icon: 'fa-car',
        });
      }

      // Barracão | Loja | Sala
      if ([5, 6, 8].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_qtd_cozinhas,
          label: 'Cozinhas',
          icon: 'fa-utensils',
        });
      }

      // Terreno
      if ([4].includes(tipo)) {
        comodidade.push({
          data: vm.imovel.imv_topografia,
          label: 'Topografia',
          icon: 'fa-expand-alt',
        });
      }

      // DEFAULT
      if (!comodidade.length) {
        comodidade.push({
          data: vm.imovel.imv_area_total,
          tipo: 1,
          label: 'Área Total',
          icon: 'fa-expand',
        });

        comodidade.push({
          data: vm.imovel.imv_area_util,
          tipo: 1,
          label: 'Área Util',
          icon: 'fa-ruler-triangle',
        });

        comodidade.push({
          data: vm.imovel.imv_qtd_banheiros,
          label: 'Banheiros',
          icon: 'fa-shower',
        });

        comodidade.push({
          data: vm.imovel.imv_qtd_dorm,
          label: 'Quartos',
          icon: 'fa-bed',
        });
      }

      return comodidade;
    }

    function setFavorite(imovel) {
      var favorites =
        JSON.parse($window.localStorage.getItem('favorites')) || [];
      var index = favorites.indexOf(imovel.imv_cod_gaia);
      var msg = '';
      if (index !== -1) {
        favorites.splice(index, 1);
        $window.localStorage.setItem('favorites', JSON.stringify(favorites));
        msg = '<strong>Imóvel retirado dos favoritos.</strong>';
      } else {
        favorites.push(imovel.imv_cod_gaia);
        msg = '<strong>Imóvel salvo nos favoritos.</strong>';
      }

      $window.localStorage.setItem('favorites', JSON.stringify(favorites));
      imovel.isFavorite = !imovel.isFavorite;
      toastr.info(msg, {
        iconClass: 'toast-arbo',
      });
    }

    function titleCase(str) {
      if (!str) return;
      return str
        .toLowerCase()
        .split(' ')
        .map(function (str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        })
        .join(' ');
    }

    function formatPrice(str) {
      return str.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 0,
      });
    }

    init();
  }

  /** @ngInject */
  function cardImovel() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cardImovel/cardImovel.html',
      scope: {
        imovel: '=',
        urlImovel: '=',
      },
      controller: ListingController,
      controllerAs: 'vm',
      bindToController: true,
    };

    return directive;
  }
  /** @ngInject */
  function cardImovelDestaque() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cardImovel/cardImovelDestaque.html',
      scope: {
        imovel: '=',
        urlImovel: '=',
      },
      controller: ListingController,
      controllerAs: 'vm',
      bindToController: true,
    };

    return directive;
  }
})();

(function () {
	'use strict';

	angular
		.module('arboWeb')
        .directive('bgImage', function () {
            return function (scope, element, attrs) {
                restrict: 'A',
                attrs.$observe('bgImage', function(value) {
                    element.css({
                        'background-image': 'url(' + value + ')',
                            'background-size': 'cover',
                            'background-repeat': 'no-repeat',
                            'background-position': 'center center'
                    });
                });
            };
        });
})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('typeFormController', typeFormController);

  /* @ngInject */
  function typeFormController(
    $scope,
    $rootScope,
    $state,
    $location,
    $window,
    $http,
    auth,
    SERVER_URL,
    IMAGE_FILTER,
    SIZE_FILTER,
    textFormatter,
    $stateParams,
    viaCEP,
    Finalidade,
    ImovelSelect,
    TipoImovel,
    TipoNegocio,
    Chave,
    Usuario,
    Ocupacao,
    Imovel,
    ImovelFoto,
    Modalidade,
    Imobiliaria,
    GrupoComodidadeOrdenacao,
    ImovelComodidade,
    FileUploader,
    swangular,
    $timeout,
    ImageCompress
  ) {
    var vm = this;
    var map;
    var marker = null;
    var user = auth.getUser();

    var minimumIntermediacao = 6;
    var defaultIntermediacao = 6;
    var defaultPeriodo = 90;
    var defaultExclusividade = true;
    var defaultLocacaoAdministrativa = false;
    var defaultIntermediacaoPrimeiroAluguel = 100;
    var defaultIntermediacaoSegundoAluguel = 50;

    function getImbConfigTerms() {
      var imv = ImovelSelect || null;

      if (!imv) return null;

      if (imv.config_termos && imv.config_termos.length) {
        vm.imbTermsConfig = imv.config_termos[0];

        return;
      }

      var configuracaoTermosFilter = JSON.stringify({
        where: { imb_id: vm.imobiliaria.id || imv.imb_id },
        limit: 1,
      });

      // Procura se a imobiliária tem um termo padrão configurado
      $http
        .get(
          SERVER_URL +
            'api/configuracaotermos?filter=' +
            encodeURI(configuracaoTermosFilter)
        )
        .then(function (res) {
          var data = (res && res.data) || undefined;
          if (data.length) {
            createImobTermosImovel(imv, data[0]);
          } else {
            createDefaultTermosImovel(imv);
          }
        });
    }

    /**
     * Cria os termos de publicação do imóvel de acordo com o padrão configurado pela imobiliária
     * e salva na variável global vm.imbTermsConfig
     *
     * @param {Object} imv - Imóvel
     *
     * @param {Object} imobiliariaTermos - Configuração de Termos da imobiliária
     */
    function createImobTermosImovel(imv, imobiliariaTermos) {
      var data_inicial = new Date();
      var data_final = new Date();
      var periodo = Number(imobiliariaTermos.periodo) || defaultPeriodo;
      data_final.setDate(data_inicial.getDate() + periodo);

      var intermediacao_padrao_primeiro_aluguel = !!imv.imv_preco_locacao
        ? imobiliariaTermos.intermediacao_padrao_primeiro_aluguel != null
          ? imobiliariaTermos.intermediacao_padrao_primeiro_aluguel
          : defaultIntermediacaoPrimeiroAluguel
        : null;

      var intermediacao_padrao_segundo_aluguel = !!imv.imv_preco_locacao
        ? imobiliariaTermos.intermediacao_padrao_segundo_aluguel != null
          ? imobiliariaTermos.intermediacao_padrao_segundo_aluguel
          : defaultIntermediacaoSegundoAluguel
        : null;

      var termos = {
        exclusividade: imobiliariaTermos.exclusividade,
        locacao_administrativa: imobiliariaTermos.locacao_administrativa,
        data_inicial: data_inicial,
        data_final: data_final,
        intermediacao_padrao:
          imobiliariaTermos.intermediacao_padrao || defaultIntermediacao,
        intermediacao_padrao_primeiro_aluguel:
          intermediacao_padrao_primeiro_aluguel,
        intermediacao_padrao_segundo_aluguel:
          intermediacao_padrao_segundo_aluguel,
        imv_id: imv.id,
        imb_id: imobiliariaTermos.imb_id,
        usu_id: user.id,
        periodo: periodo,
      };

      if (termos.intermediacao_padrao < minimumIntermediacao)
        termos.intermediacao_padrao = minimumIntermediacao;

      $http
        .post(SERVER_URL + 'api/configuracaotermosimovel', termos)
        .then(function (res) {
          vm.imbTermsConfig = res.data || termosConfig;
        });
    }

    /**
     * Cria os termos de publicação do imóvel de acordo com o padrão configurado pela imobiliária
     * e salva na variável global vm.imbTermsConfig
     *
     * @param {Object} imv - Imóvel
     */
    function createDefaultTermosImovel(imv) {
      // Valores padrão da criação do termo pelo CRM
      var data_inicial = new Date();
      var data_final = new Date();
      data_final.setDate(data_inicial.getDate() + defaultPeriodo);
      var termosConfig = {
        exclusividade: defaultExclusividade,
        locacao_administrativa: defaultLocacaoAdministrativa,
        data_inicial: data_inicial,
        data_final: data_final,
        intermediacao_padrao: defaultIntermediacao,
        intermediacao_padrao_primeiro_aluguel: !!imv.imv_preco_locacao
          ? defaultIntermediacaoPrimeiroAluguel
          : null,
        intermediacao_padrao_segundo_aluguel: !!imv.imv_preco_locacao
          ? defaultIntermediacaoSegundoAluguel
          : null,
        imv_id: imv.id,
        imb_id: imv.imb_id,
        usu_id: user.id,
        periodo: defaultPeriodo,
      };

      $http
        .post(SERVER_URL + 'api/configuracaotermosimovel', termosConfig)
        .then(function (res) {
          vm.imbTermsConfig = !!res.data ? res.data : termosConfig;
        });
    }

    function getImbData() {
      Imobiliaria.getImobiliaria({
        where: { id: vm.imobiliaria.id || 9 },
      }).$promise.then(function (res) {
        vm.imb = res[0];
      });
    }

    $scope.overImgs = [];
    $scope.overImgs.isError = false;

    if (
      $stateParams.i &&
      (!localStorage.getItem('corretor') ||
        localStorage.getItem('corretor') != $stateParams.i)
    ) {
      localStorage.setItem('corretor', $stateParams.i);
    }

    function cpfValidation(raw) {
      if (!raw) return false;

      var blacklist = [
        '00000000000',
        '11111111111',
        '22222222222',
        '33333333333',
        '44444444444',
        '55555555555',
        '66666666666',
        '77777777777',
        '88888888888',
        '99999999999',
      ];

      var cleaned = raw.replace(/\./g, '').replace(/\-/g, '');

      if (blacklist.includes(cleaned)) {
        return false;
      }

      var sum = 0;
      var check = 0;

      for (var i = 1; i <= 9; i++) {
        sum += parseInt(cleaned.substring(i - 1, i)) * (11 - i);
      }

      if (
        ((check = (10 * sum) % 11),
        (10 != check && 11 != check) || (check = 0),
        check != parseInt(cleaned.substring(9, 10)))
      ) {
        return false;
      }

      sum = 0;
      for (var i = 1; i <= 10; i++) {
        sum += parseInt(cleaned.substring(i - 1, i)) * (12 - i);
      }

      return (
        (check = (10 * sum) % 11),
        (10 != check && 11 != check) || (check = 0),
        check == parseInt(cleaned.substring(10, 11))
      );
    }

    $timeout(function () {
      var inputs = document.querySelectorAll('input, select, textarea');

      inputs.forEach(function (input) {
        input.addEventListener(
          'invalid',
          function (event) {
            input.classList.add('error');
          },
          false
        );
      });

      // MALDITO TIMEOUT
      getImbConfigTerms();

      // DE NOVO AAAA
      getImbData();
    }, 500);

    vm.imobiliaria = $rootScope.ConfigWhiteLabel;
    var imb_nome = vm.imobiliaria.nome ? vm.imobiliaria.nome : 'Arbo';
    // -------------------------------------------------
    // Seu Imovel
    var finalidade = [
      { id: 1, fnl_nome: 'Residencial' },
      { id: 2, fnl_nome: 'Comercial' },
    ];

    // TipoImovel
    var tiposResidencial = [
      { id: 1, timv_nome: 'Apartamento' },
      { id: 2, timv_nome: 'Casa' },
      { id: 3, timv_nome: 'Terreno' },
    ];

    // SubtipoImovel
    var tiposImovelResidencial = [
      {
        id: 1,
        t_id: 1,
        stimv_id: 8,
        timv_id: 1,
        timv_nome: 'Apartamento',
        condominio: true,
      },
      {
        id: 2,
        t_id: 1,
        stimv_id: 38,
        timv_id: 15,
        timv_nome: 'Studio',
        condominio: true,
      },
      {
        id: 3,
        t_id: 1,
        stimv_id: 13,
        timv_id: 10,
        timv_nome: 'Apartamento Duplex',
        condominio: true,
      },
      {
        id: 4,
        t_id: 1,
        stimv_id: 16,
        timv_id: 13,
        timv_nome: 'Apartamento Triplex',
        condominio: true,
      },
      {
        id: 5,
        t_id: 1,
        stimv_id: 10,
        timv_id: 7,
        timv_nome: 'Cobertura com apenas o andar tipo',
        condominio: true,
      },
      {
        id: 6,
        t_id: 1,
        stimv_id: 10,
        timv_id: 7,
        timv_nome: 'Cobertura com mais de um andar',
        condominio: true,
      },
      {
        id: 7,
        t_id: 1,
        stimv_id: 17,
        timv_id: 1,
        timv_nome: 'Apartamento térreo com Garden',
        condominio: true,
      },

      {
        id: 8,
        t_id: 2,
        stimv_id: 4,
        timv_id: 3,
        timv_nome: 'Casa Térrea',
        condominio: false,
      },
      {
        id: 9,
        t_id: 2,
        stimv_id: 2,
        timv_id: 2,
        timv_nome: 'Casa Sobrado',
        condominio: false,
      },
      {
        id: 10,
        t_id: 2,
        stimv_id: 32,
        timv_id: 24,
        timv_nome: 'Loft',
        condominio: false,
      },
      {
        id: 11,
        t_id: 2,
        stimv_id: 3,
        timv_id: 3,
        timv_nome: 'Casa Térrea em condomínio',
        condominio: true,
      },
      {
        id: 12,
        t_id: 2,
        stimv_id: 3,
        timv_id: 2,
        timv_nome: 'Casa Sobrado em condomínio',
        condominio: true,
      },

      {
        id: 13,
        t_id: 3,
        stimv_id: 5,
        timv_id: 4,
        timv_nome: 'Terreno em Rua',
        condominio: false,
      },
      {
        id: 14,
        t_id: 3,
        stimv_id: 5,
        timv_id: 4,
        timv_nome: 'Terreno em Condomínio',
        condominio: true,
      },
      {
        id: 15,
        t_id: 3,
        stimv_id: 5,
        timv_id: 4,
        timv_nome: 'Terreno em Condomínio de Chácaras',
        condominio: true,
      },
    ];

    var tiposImovelComercial = [
      {
        id: 1,
        timv_id: 8,
        stimv_id: 2,
        timv_nome: 'Sala em prédio comercial',
        condominio: true,
      },
      {
        id: 2,
        timv_id: 4,
        stimv_id: 40,
        timv_nome: 'Laje em prédio comercial',
        condominio: true,
      },
      {
        id: 3,
        timv_id: 6,
        stimv_id: 7,
        timv_nome: 'Loja em prédio comercial',
        condominio: true,
      },
      { id: 4, timv_id: 3, stimv_id: 21, timv_nome: 'Casa', condominio: false },
      { id: 5, timv_id: 6, stimv_id: 7, timv_nome: 'Loja', condominio: false },
      {
        id: 6,
        timv_id: 5,
        stimv_id: 6,
        timv_nome: 'Barracão',
        condominio: false,
      },
      {
        id: 7,
        timv_id: 4,
        stimv_id: 44,
        timv_nome: 'Industria',
        condominio: false,
      },
      {
        id: 8,
        timv_id: 4,
        stimv_id: 5,
        timv_nome: 'Terreno',
        condominio: false,
      },
    ];
    // Tipo do negocio
    var tipoNegocio = [
      { id: 1, tpng_nome: 'venda' },
      { id: 2, tpng_nome: 'locação' },
      { id: 3, tpng_nome: 'venda / locação' },
    ];
    // -------------------------------------------------

    // Formulario de Tipo do imovel
    vm.form_tipo = {
      // Variaveis
      imv: {
        i: localStorage.getItem('corretor') || $stateParams.i,
        imv: ImovelSelect ? ImovelSelect.id : null,
      },
      imv_finalidade: [{ id: null, fnl_nome: '-- Selecione --' }],
      imv_tipo: [{ id: null, timv_nome: '-- Selecione --' }],
      imv_subtipo: [{ id: null, timv_nome: '-- Selecione --' }],
      imv_tiponegocio: [{ id: null, tpng_nome: '-- Selecione --' }],

      // funções
      init: function () {
        var that = this;

        // Finalidade
        that.imv.imv_finalidade = $stateParams.imv_finalidade
          ? parseInt($stateParams.imv_finalidade)
          : null;
        that.imv_finalidade = that.imv_finalidade.concat(finalidade);

        // TipoImovel
        if (that.imv.imv_finalidade == 1) {
          var imv_t = tiposImovelResidencial.filter(function (el) {
            return el.id == $stateParams.imv_subtipo;
          })[0];
          var imv_tipo = tiposResidencial.filter(function (el) {
            return el.id == imv_t.t_id;
          })[0];

          that.imv_tipo = that.imv_tipo.concat(tiposResidencial);
          that.imv_subtipo = that.imv_subtipo.concat(
            tiposImovelResidencial.filter(function (el) {
              return el.t_id == imv_tipo.id;
            })
          );

          that.imv.imv_tipo = $stateParams.imv_tipo
            ? parseInt(imv_tipo.id)
            : null;
          that.imv.imv_subtipo = $stateParams.imv_tipo
            ? parseInt(imv_t.id)
            : null;
        } else if (that.imv.imv_finalidade == 2) {
          var imv_t = tiposImovelComercial.filter(function (el) {
            return el.id == $stateParams.imv_subtipo;
          })[0];

          that.imv_tipo = that.imv_tipo.concat(tiposImovelComercial);

          that.imv.imv_tipo = $stateParams.imv_tipo ? parseInt(imv_t.id) : null;
        } else {
          that.imv.imv_tipo = null;
          that.imv.imv_subtipo = null;
        }

        // TipoNegocio
        that.imv_tiponegocio = that.imv_tiponegocio.concat(tipoNegocio);
        that.imv.imv_tiponegocio = $stateParams.imv_tiponegocio
          ? parseInt($stateParams.imv_tiponegocio)
          : null;
      },
      changeFinalidade: function (e) {
        var that = this;
        that.imv_tipo = [{ id: null, timv_nome: '-- Selecione --' }];
        that.imv.imv_tipo = null;

        if (e) {
          if (e == 1) {
            that.imv_tipo = that.imv_tipo.concat(tiposResidencial);
          } else if (e == 2) {
            that.imv_tipo = that.imv_tipo.concat(tiposImovelComercial);
          }
        }
      },
      changeTipo: function (e) {
        // console.log(e);
        var that = this;
        that.imv.imv_subtipo = null;
        that.imv_subtipo = [
          { id: null, t_id: e, timv_nome: '-- Selecione --' },
        ];
        that.imv_subtipo = that.imv_subtipo.concat(
          tiposImovelResidencial.filter(function (el) {
            return el.t_id == e;
          })
        );
      },
      dirtyForm: function (e) {
        e.preventDefault();
        e['select-subtipo-imv']
          ? (e['select-subtipo-imv'].$dirty = true)
          : null;

        e['select-transacao-imv'].$dirty = true;
        e['select-tipo-imv'].$dirty = true;
        e['select-finalidade-imv'].$dirty = true;
      },
      requiredForm: function () {
        var that = this;
        return !(
          that.imv.imv_tipo &&
          that.imv.imv_tiponegocio &&
          that.imv.imv_finalidade
        );
      },
      requiredFormSub: function () {
        var that = this;
        return !(
          that.imv.imv_tipo &&
          that.imv.imv_tiponegocio &&
          that.imv.imv_finalidade &&
          that.imv.imv_subtipo
        );
      },
      validacao: function (e, form) {
        e.preventDefault();
        e.stopPropagation();

        // INICIO DO CONFLITO
        if (form && !form.$valid) {
          $scope.novalid = true;
          //debugger;
        } else {
          var that = this;

          var imv_t;
          var imv_f = that.imv.imv_finalidade;
          var imv_tn = that.imv.imv_tiponegocio;

          if (imv_f == 1) {
            imv_t = that.imv_subtipo.filter(function (el) {
              return el.id == that.imv.imv_subtipo;
            })[0];
          } else if (imv_f == 2) {
            imv_t = that.imv_tipo.filter(function (el) {
              return el.id == that.imv.imv_tipo;
            })[0];
          }

          var params = {
            new: !vm.form_tipo.imv.imv && true,
            imv_finalidade: imv_f,
            imv_tipo: imv_t['timv_id'],
            stimv_id: imv_t['stimv_id'],
            imv_subtipo: imv_t['id'],
            condominio: imv_t['condominio'] ? '1' : '0',
            imv_tiponegocio: imv_tn,
            i: that.imv.i,
            imv: that.imv.id ? window.btoa(that.imv.id) : null,
          };

          var query = '?';
          for (var key in params) {
            if (params.hasOwnProperty(key) && params[key] != null) {
              query += key + '=' + params[key] + '&';
            }
          }
          // Hit on History to save state
          window.history.pushState(
            null,
            null,
            'formulario/tipo-imovel' + query
          );

          $state.go('main.painel.typeform-2', params, {});
        }
      },
    };

    // Formulario de Detalhes da Transação
    vm.form_tran = {
      // Variaveis
      params: angular.copy($stateParams),
      imb_id: $stateParams.imb_id ? $stateParams.imb_id : -1,
      imv: {
        imv_finalidade: parseInt($stateParams.imv_finalidade),
        imv_tipo: parseInt($stateParams.imv_tipo),
        imv_tiponegocio: parseInt($stateParams.imv_tiponegocio),
        stimv_id: parseInt($stateParams.stimv_id),
        // crt_id: window.atob(window.atob(localStorage.getItem("corretor"))) || window.atob(window.atob($stateParams.i)),
        imv_cond_fechado: $stateParams.condominio == 1 ? true : false,
        prop_id: user.id,
      },
      imv_id: ImovelSelect ? ImovelSelect.id : null,
      address: {},
      address_viacep: {},
      modalidade: [{ id: null, tipo: 'Qual modalidade se encaixa?' }],
      localchave: [{ id: null, local_chave: 'Onde estará a chave do imóvel?' }],
      ocupacao: [{ id: null, ocp_nome: 'Qual estado do imóvel ?' }],
      movermap: false,
      // funções
      init: function () {
        var that = this;
        // if(that.params.imv_finalidade === undefined  && that.params.imv_tipo === undefined && that.params.imv_tiponegocio === undefined)
        //   $state.go('main.painel.typeform-1')
        // SET CORRETOR
        that.params['i'] = localStorage.getItem('corretor') || $stateParams.i;
        that.params['ii'] = localStorage.getItem('ii') || $stateParams.ii;

        that.imv = Object.assign({}, that.imv, ImovelSelect);
        that.imv.imv_id = that.imv.id;
        that.imv.garantias = Array.isArray(that.imv.garantias)
          ? that.imv.garantias[0]
          : {};

        vm.form_tran.imv.ocp_id = vm.form_tran.imv.ocp_id
          ? vm.form_tran.imv.ocp_id
          : null;
        vm.form_tran.imv.chvest_id = vm.form_tran.imv.chvest_id
          ? vm.form_tran.imv.chvest_id
          : null;

        if (localStorage.getItem('corretor') || $stateParams.i) {
          var value = localStorage.getItem('corretor') || $stateParams.i;
          that.imv['crt_id'] = atob(atob(value));
        }
        if (localStorage.getItem('ii') || $stateParams.ii) {
          var value = localStorage.getItem('ii') || $stateParams.ii;
          that.imv['imb_id'] = atob(atob(value));
        }

        if (ImovelSelect && ImovelSelect.id) {
          that.address.imv_cep = ImovelSelect.imv_cep;
          that.address.imv_end_numero = ImovelSelect.imv_end_numero;
          that.address.imv_bairro = ImovelSelect.imv_bairro;
          that.address.imv_endereco = ImovelSelect.imv_endereco;
          that.address.imv_cidade = ImovelSelect.imv_cidade;
          that.address.imv_estado = ImovelSelect.imv_estado;
          that.address.imv_pais = 'Brasil'; // Tem que mudar depois isso
          setTimeout(function () {
            that.viacepGet();
          });
        }

        map = new google.maps.Map(document.getElementById('googlemaps'), {
          center: { lat: -9.6589803, lng: -49.1563789 },
          zoom: 5,
        });

        map.setOptions({ draggable: false });

        google.maps.event.addListener(map, 'center_changed', function () {
          window.setTimeout(function () {
            var center = map.getCenter();
            marker.setPosition(center);
          }, 0);
        });

        google.maps.event.addListener(map, 'idle', function () {
          if (map.center.lat() != 0) {
            that.imv.imv_longitude = map.getCenter().lng();
            that.imv.imv_latitude = map.getCenter().lat();
          }
        });

        Chave.find(
          {
            fields: ['id', 'local_chave'],
          },
          function (res) {
            that.localchave = that.localchave.concat(res);
          }
        );

        Ocupacao.find(
          {
            fields: ['id', 'ocp_nome'],
          },
          function (res) {
            that.ocupacao = that.ocupacao.concat(res);
          }
        );

        Modalidade.find({}, function (res) {
          that.modalidade = that.modalidade.concat(res);
        });
      },
      validacao: function (e, form) {
        e.preventDefault();
        // debugger;
        if (form && !form.$valid) {
          $scope.novalid = true;
          angular.element('#select-ocupacao').focus();
          // debugger;
        } else {
          var that = this;
          var create = Object.assign({}, that.imv, that.address);
          create.imv_accept_terms = that.imv_accept_terms;
          create.email = user.email;
          // adicionei a imobiliária do imóvel, que não estava enviando quando era whiteLabel
          create.imb_id = that.imb_id ? that.imb_id : -1;

          if (!create.id) {
            Imovel.createImovel(create).$promise.then(
              function (succ) {
                // return;
                that.params.idarray = 0;
                that.params.imv = succ.id ? window.btoa(succ.id) : null;

                $state.go('main.painel.typeform-3', that.params, {
                  location: true,
                  notify: true,
                });
              },
              function (err) {
                console.log(err);
              }
            );
          } else {
            if (that.stateparams && that.stateparams.new) {
              that.imv.imv_cadastrado = true;
            }
            Imovel.updateImovel(create).$promise.then(
              function (succ) {
                // return;
                that.params.idarray = 0;
                that.params.imv = succ.id ? window.btoa(succ.id) : null;

                $state.go('main.painel.typeform-3', that.params, {
                  location: true,
                  notify: true,
                });
              },
              function (err) {
                console.log(err);
              }
            );
          }
        }
      },
      movePin: function () {
        var that = this;
        that.movermap = !that.movermap;
        map.setOptions({ draggable: that.movermap });
      },
      viacepGet: function () {
        var that = this;
        // console.log(that.address.cep);

        if (
          that.address.imv_cep !== undefined &&
          that.address.imv_cep.replace(/\D+/g).length == 8
        ) {
          viaCEP.get(that.address.imv_cep).then(
            function (res) {
              that.address_viacep = res;

              that.address.imv_bairro = res.bairro;
              that.address.imv_endereco = res.logradouro;
              that.address.imv_cidade = res.localidade;
              that.address.imv_estado = res.uf;
              that.address.imv_pais = 'Brasil'; // Tem que mudar depois isso

              angular.element('#label-cep').addClass('active');

              // angular.element('#zipcode-address').focus();
              res.logradouro
                ? angular.element('#num-address').focus()
                : angular.element('#stre-address').focus();

              setTimeout(function () {
                upperLabel();
                setMap(
                  res.logradouro
                    ? res.logradouro +
                        (that.address.imv_end_numero
                          ? that.address.imv_end_numero
                          : '') +
                        ', ' +
                        res.localidade +
                        ' - ' +
                        res.uf
                    : 'centro ' + res.localidade + ' - ' + res.uf
                );
              }, 100);
            },
            function (err) {
              that.address = {};
              that.address_viacep = {};
              angular.element('#label-cep').removeClass('active');
              upperLabel();

              // console.log(err);
            }
          );
        } else {
          angular.element('#label-cep').removeClass('active');
        }
      },
      openModal: function (e) {
        var textSW = '',
          titleSW = '';
        switch (e) {
          case 1:
            titleSW = 'FIADOR';
            textSW =
              'É a pessoa que, solidariamente com o locatário, irá responder pelas dívidas oriundas do contrato de locação, como aluguel, condomínio, IPTU, danos ao imóvel, dentre outras. Para ser fiador é necessária uma idoneidade financeira, ou seja, sem nenhum tipo de restrição. A renda e patrimônio devem indicar, no momento da contratação, que aquela pessoa tem condição de arcar com as obrigações decorrentes do contrato em eventual caso de inadimplência do locatário. Ao menos um fiador deve possuir imóvel na cidade em que é feita a locação e que esteja devidamente registrado, livre e desembaraçado de quaisquer ônus.';
            break;
          case 2:
            titleSW = 'SEGURO FIANÇA';
            textSW =
              'Este serviço é oferecido pelas seguradoras. O inquilino paga um valor mensal para garantir que os alugueres e demais encargos locatícios (dependendo da apólice contratada) serão cobertos em caso de não pagamento. Geralmente, o seguro fiança é cobrado mensalmente, junto com os demais encargos locatícios e corresponde a 10% do valor do aluguel (podendo variar dependendo da seguradora e coberturas contratadas). Esse valor não será devolvido ao locatário no final do contrato.';
            break;
          case 3:
            titleSW = 'TÍTULO DE CAPITALIZAÇÃO';
            textSW =
              'O inquilino deve procurar uma empresa que emite títulos de capitalização para aluguel e fazer a aquisição. O custo do título é variável, em função do valor da caução exigido pelo locador. Este valor deverá ser pago à vista, diretamente para a seguradora, e ficará caucionado em favor do locador/imobiliária. Para contratar essa garantia locatícia não é preciso comprovar renda e a contratação é rápida e bastante simples, com renovação automática, geralmente a cada 12 meses. Ao final do contrato de locação, o valor caucionado será devolvido ao locatário integralmente, corrigido.';
            break;
          case 4:
            titleSW = 'CAUÇÃO';
            textSW =
              'Neste caso, o inquilino vai precisar fazer um pagamento adiantado na hora de locar o imóvel. O valor, que será usado como garantia da locação, pode chegar ao equivalente a três meses de aluguel, valor máximo estipulado em lei, que será depositado em caderneta de poupança. A caução poderá ser feita também em bens móveis ou imóveis. No caso de bens móveis esta deverá ser registrada em cartório de títulos e documentos; para bens imóveis, deverá ser averbada à margem da respectiva matrícula.';
            break;
          case 5:
            titleSW = 'GARANTIA TOTAL';
            // textSW =  'Garantimos o seu aluguel durante todo o contrato.O Contrato de Locação sem garantia para o locatário. Apesar de muitos pensarem que esta opção é desfavorável para o locador, ela, na realidade, possui certos benefícios, que devem ser ponderados por quem pretende locar seu imóvel, como por exemplo, a facilidade para proceder o despejo. Em caso de inadimplência na locação desprovida de garantia, a Lei do Inquilinato (Lei 8.245/91) permite o despejo liminar do locatário,  com a desocupação do imóvel no prazo de 15 dias.';
            textSW =
              'A Locação é sem garantia para o locatário, porém o proprietário tem garantia total do aluguel durante todo o contrato. Essa modalidade, apesar de muitos pensarem ser desfavorável para o proprietário, na realidade, possui certos benefícios, que devem ser ponderados por quem pretende locar seu imóvel com rapidez e segurança, como por exemplo, a facilidade e maior rapidez para proceder o despejo em caso de inadimplência. Aqui na ARBO você tem assessoria jurídica durante toda a locação. Nossos locatários passam por uma análise de cadastro rigorosa, conferindo maior segurança na hora de locar seu imóvel.';
            break;
          default:
            titleSW = textSW = 'Garantias';
            break;
        }

        swangular.swal({
          type: 'info',
          animation: false,
          title: titleSW,
          html: textSW,
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
        });
      },
    };

    // Formulario de Detalhes do Imóvel
    vm.form_imov = {
      // Variaveis
      imv: {
        imv_id: $stateParams.imv,
      },
      imv_id: ImovelSelect ? ImovelSelect.id : null,
      imv_comodidades: {},
      stateparams: $stateParams,
      idArray: parseInt($stateParams.idarray),
      imv_tipo: $stateParams.imv_tipo,
      form: [],
      // funções
      init: function () {
        var that = this;

        // SET CORRETOR
        that.stateparams['i'] =
          localStorage.getItem('corretor') || $stateParams.i;

        // Tem que pegar o imóvel para validar a rota
        that.imv = Object.assign({}, that.imv, ImovelSelect);
        that.imv.imv_id = that.imv.id;

        GrupoComodidadeOrdenacao.find({
          filter: {
            fields: [
              'id',
              'gcmdo_label',
              'gcmdo_obg',
              'gcmdo_ordem',
              'gcmd_id',
            ],
            include: {
              relation: 'grupocomodidade',
              scope: {
                fields: [
                  'id',
                  'gcmd_nome',
                  'gcmd_label',
                  'gcmd_ask',
                  'gcmd_tipo',
                ],
                include: {
                  relation: 'grupocategoria',
                  scope: {
                    include: {
                      relation: 'comodidades',
                      scope: {
                        fields: ['id', 'cmd_nome', 'cmd_icone'],
                      },
                    },
                  },
                },
              },
            },
            where: {
              timv_id: that.imv_tipo,
            },
            order: 'gcmdo_ordem ASC',
          },
        }).$promise.then(
          function (succ) {
            that.form = succ;
          },
          function (err) {
            console.log(err);
          }
        );

        if (that.imv_id) {
          ImovelComodidade.find({
            filter: {
              where: {
                icmd_id: that.imv_id,
              },
            },
          }).$promise.then(
            function (succ) {
              succ.forEach(function (el, i, a) {
                that.imv_comodidades[el.cmd_id] = true;
              });
              // that.imv_comodidade = succ;
            },
            function (err) {
              console.log(err);
              that.imv_comodidade = {};
            }
          );

          setTimeout(function () {
            upperLabel();
          }, 1000);
        }
      },
      rangeDetalhe: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      validacao: function () {},
      jumpSteps: function () {
        var that = this;

        if (that.stateparams && that.stateparams.new) {
          that.imv.imv_cadastrado = true;
        }

        Imovel.updateImovel(that.imv).$promise.then(
          function (succ) {
            $state.go('main.painel.typeform-upload', that.stateparams, {
              location: true,
              notify: true,
            });
          },
          function (err) {
            console.log(err);
          }
        );
      },
      prevStepImovel: function () {
        var that = this;
        $state.go('main.painel.typeform-2', that.stateparams);
      },
      prevStep: function () {
        var that = this;

        --that.idArray;
        that.stateparams.idarray = that.idArray;
        $state.go('main.painel.typeform-3', that.stateparams, {
          location: true,
          notify: false,
        });
      },
      nextStep: function (e, form) {
        e.preventDefault();
        if (form && !form.$valid) {
          $scope.novalid = true;
          //debugger;
        } else {
          var that = this;
          $rootScope.loadingModal.start('Salvando dados');

          that.imv.imv_comodidades = that.imv_comodidades;
          if (that.stateparams && that.stateparams.new) {
            that.imv.imv_cadastrado = true;
          }

          Imovel.updateImovel(that.imv).$promise.then(
            function (succ) {
              ++that.idArray;
              that.stateparams.idarray = that.idArray;
              $rootScope.loadingModal.stop();
              if (vm.form_imov.form.length != that.idArray) {
                $state.go('main.painel.typeform-3', that.stateparams, {
                  location: true,
                  notify: false,
                });
              } else {
                $state.go('main.painel.typeform-upload', that.stateparams, {
                  location: true,
                  notify: true,
                });
              }
            },
            function (err) {
              $rootScope.loadingModal.stop();
            }
          );
        }
      },
    };

    vm.form_img = {
      params: angular.copy($stateParams),
      selected: {},
      allFotos: [],
      init: function () {
        if ($stateParams.new) {
          $scope.new = true;
        }
        $scope.alerts = [
          {
            type: 'success',
            msg: 'Imóvel cadastrado! Agora o passo mais importante para o anúncio perfeito. Envie pelo menos três fotos do imóvel e nós cuidamos do resto para você.',
          },
        ];

        $scope.closeAlert = function (index) {
          $scope.alerts.splice(index, 1);
        };
        var that = this;
        var header = $('#header');
        !header.is('fixed-theme') ? header.addClass('fixed-theme') : null;

        // SET CORRETOR
        // stateparams

        that.allFotos = ImovelSelect.fotos;

        var urlUpload =
          SERVER_URL +
          'api/uploadfotos/' +
          ImovelSelect.imv_cod_gaia +
          '/upload';
        var nameUpload = ImovelSelect.imv_cod_gaia;
        var formData = {
          fromSite: true,
          key: 'value',
        };

        // $scope.uploaderImgImovel = $scope.uploaderImg =  new FileUploader({
        $scope.uploaderImgImovel = new FileUploader({
          scope: $scope, // to automatically update the html. Default: $rootScope
          url: urlUpload,
          queueLimit: 25,
          formData: [formData],
        });

        $scope.uploaderImgImovel.filters.push(IMAGE_FILTER);
        $scope.uploaderImgImovel.filters.push(SIZE_FILTER);

        // Renomeando a imagem
        $scope.uploaderImgImovel.onAfterAddingFile = function (item) {
          // Changing img name
          var fileExtension = '.' + item.file.name.split('.').pop();
          item.file.name =
            nameUpload + '_' + new Date().getTime() + fileExtension;

          var blob = new Blob([item._file], { type: item._file.type });

          ImageCompress.compressImage(blob).then(function (compressedBlob) {
            item._file = new File([compressedBlob], item.file.name, {
              type: item.file.type,
            });
          });
        };

        $scope.uploaderImgImovel.onBeforeUploadItem = function (item) {
          if (item) {
            item.headers = { 'X-Access-Token': auth.getCurrentUserToken() };
          }

          item.url =
            item.url + '?order=' + item.index + '&fromCondominio=false';
        };

        // Erro ao tentar adicionar Arquivos fora dos filtros
        $scope.uploaderImgImovel.onWhenAddingFileFailed = function (
          item,
          filter,
          options
        ) {
          // console.info('onWhenAddingFileFailed', item, filter, options);

          if ($scope.overImgs.isError === false) {
            $scope.overImgs.isError = true;
          }

          if (!$scope.overImgs.includes(item.name)) {
            $scope.overImgs.push(item.name);
          }

          $scope.closeAlert = function (index) {
            $scope.alerts.splice(index, 1);
          };

          var textSW;
          // console.log(item,filter,options);
          if (filter.name == 'sizeFilter') {
            textSW = 'Por favor, escolha imagens de até 5MB';
          } else if (filter.name == 'imageFilter') {
            textSW = 'Por favor, escolha somente imagens';
          } else if (filter.name == 'queueLimit') {
            textSW = 'Limite de 25 imagens por upload';
          } else {
            textSW = 'Esse tipo de arquivo não é suportado';
          }
          swangular.swal({
            type: 'error',
            animation: false,
            title: '',
            html: '<h3>' + textSW + '<br>' + item.name + '</h3>',
            confirmButtonClass: 'btn button btn-default px-5',
            buttonsStyling: false,
            timer: 5500,
          });
        };

        // Erro na Hora de fazer upload da Image
        $scope.uploaderImgImovel.onErrorItem = function (
          fileItem,
          response,
          status,
          headers
        ) {
          console.info('onErrorItem', fileItem, response, status, headers);
        };

        // Fim do Upload
        $scope.uploaderImgImovel.onCompleteAll = function () {
          $rootScope.loadingModal.stop();
          setTimeout(function () {
            if (localStorage.getItem('corretor') || $stateParams.i) {
              var that = $scope.vm.form_terms;

              if ($stateParams && $stateParams.new) {
                that.imv.imv_cadastrado = true;
              }
              Imovel.updateImovel({
                imv_id: that.imv.id,
                imv_cadastrado: that.imv.imv_cadastrado,
              });
            }
            $state.go('main.painel.typeform-termos', vm.form_img.params, {
              location: true,
              notify: true,
            });
          }, 600);
        };
      },
      uploadAll: function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($scope.uploaderImgImovel.queue.length > 0) {
          $rootScope.loadingModal.start('Carregando fotos');
          $scope.uploaderImgImovel.uploadAll();
        } else {
          if (localStorage.getItem('corretor') || $stateParams.i) {
            var that = $scope.vm.form_terms;

            if ($stateParams && $stateParams.new) {
              that.imv.imv_cadastrado = true;
            }

            Imovel.updateImovel({
              imv_id: that.imv.id,
              imv_cadastrado: that.imv.imv_cadastrado,
            });
          }
          $state.go('main.painel.typeform-termos', vm.form_img.params, {
            location: true,
            notify: true,
          });
        }
      },
      prevStep: function () {
        var that = this;
        that.params.idarray = 0;
        $state.go('main.painel.typeform-3', that.params, {
          location: true,
          notify: true,
        });
      },
      idle: function (e) {
        e.imvft_ativo = false;
        ImovelFoto.editFoto(e).$promise.then(
          function (succ) {
            // console.log(succ);
          },
          function (err) {
            console.log(err);
          }
        );
      },
    };

    vm.form_obg = {
      init: function () {},
    };

    vm.form_terms = {
      imv: ImovelSelect,
      terms: {
        terms_imv: ImovelSelect ? ImovelSelect.id : null,
      },
      init: function () {},
      requiredForm: function () {
        var that = this;
        return !(that.terms.anuncio && that.terms.termos);
      },
      cancelar: function () {
        if ($stateParams.new) {
          $state.go('main.home');
        } else {
          $state.go('main.painel.dashboard');
        }
      },
      checkUserData: function (e) {
        var that = this;

        var promise = new Promise(function (resolve, reject) {
          that.imv.imv_id = that.imv.id;
          that.terms.imv = that.imv;

          var user = JSON.parse($window.localStorage.getItem('user'));

          Usuario.findById({
            id: user.id,
            filter: {
              include: ['telefones'],
            },
          }).$promise.then(
            function (succ) {
              var usuario = succ;
              var userPhone = usuario.telefones[usuario.telefones.length - 1];
              var cpfNotExists = !usuario.cpf || usuario.cpf.length != 14;
              var phoneNotExists =
                !usuario.telefones.length ||
                !userPhone ||
                userPhone.numero.length < 11;
              var phoneRegex =
                /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/;

              if (cpfNotExists || phoneNotExists) {
                swangular
                  .swal({
                    html:
                      '<h1 class="modal-title">Falta pouco</h1><p class="modal-text modal-text-' +
                      (cpfNotExists && phoneNotExists ? 'lg' : 'sm') +
                      '">Para validar o aceite de publicação, precisamos que confirme seu' +
                      (phoneNotExists ? ' telefone' : '') +
                      (cpfNotExists && phoneNotExists ? ' e' : '') +
                      (cpfNotExists ? ' CPF' : '') +
                      '.</p>',
                    showCancelButton: false,
                    confirmButtonClass: 'modal-confirm-btn',
                    buttonsStyling: false,
                  })
                  .then(function (result) {
                    var cpfHtml =
                      '<div class="modal-input"><label for="cpf-user" class="modal-label">CPF:</label>\
                      <input type="tel" name="cpf-user" id="cpf-user" placeholder="CPF"></div>';

                    var phoneHtml =
                      '<div class="modal-input"><label for="telefone-user" class="modal-label">Telefone:</label>\
                      <input type="tel" name="telefone-user" id="telefone-user" placeholder="Telefone"></div>';

                    if (result.value) {
                      swangular
                        .swal({
                          html:
                            (phoneNotExists ? phoneHtml : '') +
                            (phoneNotExists && cpfNotExists ? '<br/>' : '') +
                            (cpfNotExists ? cpfHtml : ''),
                          onOpen: function () {
                            if (cpfNotExists) {
                              angular
                                .element('#cpf-user')
                                .mask('000.000.000-00', { reverse: true });
                            }

                            if (phoneNotExists) {
                              var behavior = function (val) {
                                  return val.replace(/\D/g, '').length === 11
                                    ? '(00) 00000-0000'
                                    : '(00) 0000-00009';
                                },
                                options = {
                                  onKeyPress: function (
                                    val,
                                    e,
                                    field,
                                    options
                                  ) {
                                    field.mask(
                                      behavior.apply({}, arguments),
                                      options
                                    );
                                  },
                                };

                              angular
                                .element('#telefone-user')
                                .mask(behavior, options);
                            }
                          },
                          preConfirm: function () {
                            var validationMsgEl = document.getElementById(
                              'swal2-validation-message'
                            );
                            var cpfField = cpfNotExists
                              ? document.getElementById('cpf-user').value
                              : null;
                            var phoneField = phoneNotExists
                              ? document.getElementById('telefone-user').value
                              : null;

                            var invalidCpf = cpfNotExists
                              ? !cpfField || !cpfValidation(cpfField)
                              : null;
                            var invalidPhone = phoneNotExists
                              ? !phoneField ||
                                phoneField.length < 11 ||
                                !phoneRegex.test(phoneField)
                              : null;

                            var msg =
                              'Insira ' +
                              (invalidCpf ? 'um CPF' : '') +
                              (invalidCpf && invalidPhone ? ' e ' : '') +
                              (invalidPhone ? 'um telefone' : '') +
                              ' válido' +
                              (invalidCpf && invalidPhone ? 's.' : '');

                            if (invalidCpf || invalidPhone) {
                              validationMsgEl.style.display = 'block';
                              validationMsgEl.className = 'validation-msg';
                              validationMsgEl.textContent = msg;
                            } else {
                              if (cpfField) usuario.cpf = cpfField;

                              if (phoneField) {
                                usuario.telefones.push({
                                  numero: phoneField,
                                  contato: usuario.nome,
                                  pes_id: usuario.id,
                                });
                              }

                              return usuario;
                            }
                          },
                          confirmButtonClass: 'modal-confirm-btn',
                          cancelButtonClass: 'modal-cancel-btn',
                          cancelButtonText: 'Cancelar',
                          buttonsStyling: false,
                          showCancelButton: true,
                        })
                        .then(function (res) {
                          Usuario.upsertWithWhere(
                            { where: { id: res.value.id } },
                            res.value
                          ).$promise.then(function () {
                            resolve(true);
                          });
                        })
                        .catch(function (err) {
                          reject('Não foi possível atualizar os dados!' + err);
                        });
                    }
                  });
              } else {
                resolve(true);
              }
            },
            function (err) {
              console.log(err);
            }
          );
        });

        return promise;
      },
      acceptTerm: function (e) {
        var that = this;

        that.imv.imv_id = that.imv.id;
        that.terms.imv = that.imv;

        if ($stateParams && $stateParams.new) {
          that.imv.imv_cadastrado = true;
        }

        that.terms.config_id = vm.imbTermsConfig.id;
        Imovel.acceptTermsImovel(that.terms).$promise.then(
          function (succ) {
            // Espera o outro update de imóvel
            Imovel.updateImovel({
              imv_id: $state.params.imv,
              imv_termos_valido: true,
              imv_cadastrado: that.imv.imv_cadastrado,
              imv_exclusivo: !!vm.imbTermsConfig.exclusividade,
              gameficacao: false,
            });
            $rootScope.loadingModal.stop();
            setTimeout(function () {
              swangular
                .swal({
                  html: '<div class="modal-confirm-icon"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 0C13.4297 0 0 13.4297 0 30C0 46.5703 13.4297 60 30 60C46.5703 60 60 46.5703 60 30C60 13.4297 46.5703 0 30 0ZM43.5703 24.8203L28.5703 39.8203C27.9258 40.4648 27.0938 40.7812 26.25 40.7812C25.4062 40.7812 24.5695 40.4626 23.9285 39.8217L16.4285 32.3217C15.15 31.0397 15.15 28.9596 16.4285 27.6776C17.7105 26.3955 19.7906 26.3955 21.0727 27.6776L26.25 32.8594L38.9297 20.1797C40.2117 18.8977 42.2918 18.8977 43.5738 20.1797C44.8477 21.457 44.8477 23.543 43.5703 24.8203Z" fill="#00BF70"/></svg></div>\
                  <h1 class="modal-title">Aceite concluído</h1><p class="modal-text modal-text-sm">Acompanhe seus imóveis anunciados acessando seu perfil no menu do site.</p>',
                  confirmButtonClass: 'modal-confirm-btn',
                  buttonsStyling: false,
                })
                .then(function (res) {
                  $state.go('main.painel.dashboard', {
                    tab:
                      $stateParams.imv_tiponegocio == 1 ? 'vender' : 'alugar',
                    selected: 'aguardando',
                  });
                });
            }, 100);
          },
          function (err) {
            console.log('Algo inesperado', err);
            $rootScope.loadingModal.stop();
          }
        );
      },
      callAcceptTerm: function (e) {
        var that = this;
        that
          .checkUserData(e)
          .then(function (succ) {
            $rootScope.loadingModal.start('Atualizando os dados');
            that.acceptTerm(e);
          })
          .catch(function (err) {
            console.log(err);
          });
      },
      openModal: function (num) {
        var textSW = '';

        switch (num) {
          // Exclusividade
          case 0:
            if (vm.form_terms.imv.imv_exclusivo) {
              textSW =
                'Caso tenha anunciado em outros lugares antes de cadastrar seu imóvel e optar pela opção de anúncio Exclusivo, o proprietário deve remover os outros anúncios.';
            } else {
              textSW =
                'A ' +
                imb_nome +
                ' entende que Você é livre para anunciar seu imóvel em todos os meios que entender pertinente. Por isso, não trabalha com cláusula de exclusividade. Porém, o Proprietário não poderá negociar com um cliente que vier dos Nossos canais de captação de leads, sem a intermediação da ' +
                imb_nome +
                '. Caso o proprietário tiver firmado contrato de anuncio com cláusula de exclusividade com terceiro, deverá se abster de anunciar na Plataforma ' +
                imb_nome +
                '.';
            }
            break;
          // Venda
          case 1:
            textSW =
              'Essa obrigação poderá ter início nos seguintes momentos: no ato do recebimento do sinal, assinatura do compromisso de compra e venda ou, ainda, na escritura do imóvel.';
            break;
          // Locação
          case 2:
            textSW =
              'O contrato de administração é vinculado ao contrato de locação, e se rescinde automaticamente no caso da rescisão da locação.';
            break;
          // Responsabilidades
          case 3:
            textSW =
              'É de responsabilidade do proprietário a apresentação de todas as documentações solicitadas para o fechamento do negócio.';
            break;
          default:
            textSW = 'Termos de Uso';
            break;
        }

        swangular.swal({
          html:
            '<div class="w-100 text-left" style="padding-left: 20px;"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 2.06452C23.653 2.06452 29.9355 8.2629 29.9355 16C29.9355 23.6962 23.7026 29.9355 16 29.9355C8.30684 29.9355 2.06452 23.7057 2.06452 16C2.06452 8.30948 8.2969 2.06452 16 2.06452ZM16 0C7.16406 0 0 7.16664 0 16C0 24.8385 7.16406 32 16 32C24.8359 32 32 24.8385 32 16C32 7.16664 24.8359 0 16 0ZM13.6774 22.1935H14.4516V14.4516H13.6774C13.2499 14.4516 12.9032 14.105 12.9032 13.6774V13.1613C12.9032 12.7337 13.2499 12.3871 13.6774 12.3871H16.7742C17.2017 12.3871 17.5484 12.7337 17.5484 13.1613V22.1935H18.3226C18.7501 22.1935 19.0968 22.5402 19.0968 22.9677V23.4839C19.0968 23.9114 18.7501 24.2581 18.3226 24.2581H13.6774C13.2499 24.2581 12.9032 23.9114 12.9032 23.4839V22.9677C12.9032 22.5402 13.2499 22.1935 13.6774 22.1935ZM16 6.70968C14.8598 6.70968 13.9355 7.634 13.9355 8.77419C13.9355 9.91439 14.8598 10.8387 16 10.8387C17.1402 10.8387 18.0645 9.91439 18.0645 8.77419C18.0645 7.634 17.1402 6.70968 16 6.70968Z" fill="white"/></svg></div><br/><p class="modal-announce-terms">' +
            textSW +
            '</p>',
          showConfirmButton: false,
          background: '#0A1420',
          cancelButtonClass: 'modal-announce-terms-button',
          showCancelButton: true,
          buttonsStyling: false,
          cancelButtonText: 'OK, entendi.',
        });
      },
    };

    function upperLabel() {
      angular.element('input.upper').each(function (index, element) {
        var $this = $(this);
        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      });

      angular.element('textarea.upper').each(function (index, element) {
        var $this = $(this);
        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      });
    }

    function setMap(data) {
      var geocoder = new google.maps.Geocoder();
      var address = data;
      var resultsMap = map;
      geocoder.geocode({ address: address }, function (results, status) {
        if (status === 'OK') {
          results = results[0];
          resultsMap.setCenter(results.geometry.location);

          switch (results.address_components[0].types[0]) {
            case 'street_number':
              resultsMap.setZoom(18);
              break;
            case 'route':
              resultsMap.setZoom(15);
              break;
            default:
              resultsMap.setZoom(13);
              break;
          }
          marker ? marker.setMap(null) : null;
          marker = new google.maps.Marker({
            map: resultsMap,
            icon: {
              url: './assets/images/novosite/_marker.svg',
              size: new google.maps.Size(35, 45),
              scaledSize: new google.maps.Size(25, 35),
            },
            position: results.geometry.location,
          });
        } else {
          alert(
            'Geocode was not successful for the following reason: ' + status
          );
        }
      });
    }

    angular.element(document).ready(function () {
      setTimeout(function () {
        upperLabel();
      });
    });

    document.addEventListener(
      'focus',
      function (e) {
        upperLabel();
        e.preventDefault();
      },
      true
    );

    document.addEventListener(
      'blur',
      function (e) {
        upperLabel();
        e.preventDefault();
      },
      true
    );
  }
})();

(function () {
	'use strict';

	angular
		.module('arboWeb')
		.controller('DashboardController', DashboardController);
	/* @ngInject */
	function DashboardController($state, $stateParams, $scope, $rootScope, $window, SERVER_URL, textFormatter, auth, Imovel, Usuario, EstadoCivil, viaCEP, Estado, Cidade, swangular, loginUser, seoService, $location) {
    var vm = this;
    if(!loginUser){
      $state.go('main.home')
      return;
	}

		vm.isMobile = isMobile;

		vm.user = auth.getUser();
		vm.imoveis = [];
		vm.alugar = {};
		vm.vender = {};
		vm.favoritos = [];
		vm.favoritos_ativos = 0;
		vm.renovacoes = [];
		vm.selectedTab = ['Meus imóveis', 'Para alugar'];
		vm.contentDropdown = false;
		vm.selectedImovel = [];
		vm.dashPage = 1;
		vm.loader = false;
		vm.tab = $location.search().tab;
	    vm.makeUrl = makeUrl;
		vm.setDashPage = setDashPage;
		vm.editImovel = editImovel;
		vm.renewTerms = renewTerms;
		vm.activeSubmenu = activeSubmenu;

		$scope.updateSelectedStatus = function (selectedStatus) {
			vm.selectedImovel = selectedStatus;
			vm.contentDropdown = false;
			var dotElement = document.getElementById('selected-status-dot');
			dotElement.style.backgroundColor = selectedStatus.statusProp.hex_text_color;
		}
		$scope.botao_ctr = true;

		seoService.generateTags({
			title: 'Dashboard',
			description: 'Administrar meus imoveis, ver meus imóveis favoritos, aceitar e renovar termos',
			slug: $location.absUrl()
		})


		function getImovelUser(e) {
			Imovel.getImovelUser({
				type: e,
				user: vm.user.id
			}).$promise.then(function (res) {
				var data = res.data;
				vm.imoveis = data;
				vm.selectedImovel = data[0];
				document.getElementById('selected-status-dot').style.backgroundColor = vm.selectedImovel.statusProp.hex_text_color;
			}, function (err) {
				console.log(err);
			})
		}

		function getFavoritos() {
			var cod_favorites = JSON.parse($window.localStorage.getItem('favorites'));
			if (cod_favorites && cod_favorites.length != 0) {
				Imovel.getImoveisNew({
					where: {
						imv_cod_gaia: { inq: cod_favorites }
					}
				}).$promise.then(function (res) {
					vm.favoritos = res;
					vm.favoritos.forEach(function(favorito) {
						if(favorito.imv_ativo == true)
						{
							vm.favoritos_ativos++;
						}
					});
				}, function (err) {
					console.log(err);
				})
			}
		}

		function getRenovacoes(){
			var user = JSON.parse($window.localStorage.getItem('user'));
			Imovel.getImoveisNew({
					where:{
					'prop_id':  user.id,
					'imv_termos_valido': false
					}
			},function(imoveis){
				vm.renovacoes = imoveis;
			});
		}

		function makeUrl(listing) {
			// var urlPath = $location.$$url.split('?')[0].split('#')[0];
			var description = textFormatter.removeSpecialChar(listing.imv_titulo)
			return ('/imovel/' + description + '/' + listing.imv_cod_gaia);
		}

		function init() {

			angular.element(document).ready(function () {
				// getImovelUser(2);
				getFavoritos();
				getRenovacoes();
				var header = $('#header');
				!(header.hasClass('fixed-theme')) ? header.addClass('fixed-theme') : null;
			})

			vm.selectedTab[0] = $stateParams.option ? $stateParams.option : null;
			vm.selectedTab[1] = $stateParams.suboption ? $stateParams.suboption : null;
      vm.dashPage = $stateParams.page ? $stateParams.page : null;

      if($location.search().selected) {
				var selected = $location.search().selected;

        $('.body-options li').removeClass('active');

				if (vm.tab === 'renovacao') selected = selected + '-renovacao';

				angular.element('#' + selected + '-tab').addClass('active');

        $('.tab-content div').removeClass('active show');
        angular.element('.tab-content div#' + selected).addClass('active show');
      }
		}

		init();

    // if (vm.isMobile()) {
    // 	angular.element('#dashboard')
    // 		.swipe({
    // 			swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
    // 				if (direction == 'left')
    // 					angular.element('.profile-wrapper').addClass('open-menu');
    // 				if (direction == 'right')
    // 					angular.element('.profile-wrapper').removeClass('open-menu');
    // 			},
    // 			allowPageScroll: "vertical"
    // 		});
    // }

		// angular.element('.body-options a').click(function (evt) {
		// 	var parent = $(evt.currentTarget).parent().get(0);
		// 	$('.body-options li').removeClass('active');
    //   $(parent).addClass('active');

    //   $location.search('selected', angular.element(evt.currentTarget).attr('aria-controls'));

    //   $('.tab-content div').removeClass('active show');
    //   angular.element('.tab-content div#' + $location.search().selected).addClass('active show');

		// 	// vm.selectedTab[1] = $(evt.currentTarget).text();
    // })

		function setDashPage(option, suboption, page) {
			if (suboption) vm.selectedTab = [option, suboption];
			else vm.selectedTab = [option];
      vm.dashPage = page;
			if (suboption && option == 'Meus imóveis') {
				if (suboption == 'Para alugar') {
					getImovelUser(2);
				} else if (suboption == 'Para vender') {
					getImovelUser(1);
				}
			}
		}

		if (loginUser && loginUser.selectedtab) {
			if (loginUser.selectedtab.match(/alugar/g)) {
				setDashPage('Meus imóveis', 'Para alugar', 1);
			}
			if (loginUser.selectedtab.match(/vender/g)) {
				setDashPage('Meus imóveis', 'Para vender', 1);
			}
			if (loginUser.selectedtab.match(/favoritos/g)) {
				setDashPage('Favoritos', '', 3);
			}
			if (loginUser.selectedtab.match(/renovacao/g)) {
				setDashPage('Renovação', '', 5);
			}
			if (loginUser.selectedtab.match(/meu-perfil/g)) {
				vm.setDashPage('Meu Perfil', '', 0);
			}
		}

		function editImovel(e) {
			var params = {
				imv: window.btoa(e.id),
				imv_finalidade: e['fnl_id'],
				imv_tipo: e['timv_id'],
				imv_tiponegocio: e['tpng_id'],
				condominio: e['imv_cond_fechado'],
			}
			$state.go('main.painel.typeform-2', params)
		}

		function renewTerms(imovel){
			$state.go('main.painel.typeform-termos', {imv: btoa(imovel.id)}, {reload: true});
		}

		function activeSubmenu(e) {
      var submenu = $(e.target).next();
			if (submenu.hasClass('active')) {
				submenu.removeClass('active');
			} else {
				submenu.addClass('active');
			}
		}

		/* ACCOUNT CONTROLLER FUNCTIONS */

		vm.dayNumbers;
		vm.yearNumbers;
		vm.mounthNumbers = [{ id: 1, name: 'Janeiro', days: 31 }, { id: 2, name: 'Fevereiro', days: 28 }, { id: 3, name: 'Março', days: 31 }, { id: 4, name: 'Abril', days: 30 }, { id: 5, name: 'Maio', days: 31 }, { id: 6, name: 'Junho', days: 30 }, { id: 7, name: 'Julho', days: 31 }, { id: 8, name: 'Agosto', days: 31 }, { id: 9, name: 'Setembro', days: 30 }, { id: 10, name: 'Outubro', days: 31 }, { id: 11, name: 'Novembro', days: 30 }, { id: 12, name: 'Dezembro', days: 31 }]
		vm.statusCivil = [{ id: null, nome: 'Estado civil' }];

		vm.dayGenerate = function (num) {
			vm.dayNumbers = [];
			for (var x = 1; x <= num; x++) {
				vm.dayNumbers.push(x);
			}
		}

		vm.yearGenerate = function (ini, fim) {
			vm.yearNumbers = []
			for (var x = fim; x >= ini; x--) {
				vm.yearNumbers.push(x);
			}
		}

		vm.closeModal_ = function () {
			$('#lp-pom-box-677').hide();
			vm.botao_ctr = false;
			localStorage.setItem('botao_ctr',false);
		}

		vm.closeModal2_ = function () {
			$('#lp-pom-box-666').hide();
			vm.botao_ctr = false;
			localStorage.setItem('botao_ctr',false);
		}

		vm.dayGenerate(31);
		vm.yearGenerate(1945, (new Date().getYear() + 1900));
		EstadoCivil.find({})
			.$promise.then(function (succ) {
				vm.statusCivil = vm.statusCivil.concat(succ);
			}, function (err) {
				console.log(err);
			})

		vm.formAddress = {
			address: {},
			viacepGet: function () {
				var that = this;
				// console.log(that.address.cep);

				if (that.address.cep !== undefined && that.address.cep.replace(/\D+/g).length == 8) {
					viaCEP.get(that.address.cep)
						.then(function (res) {

							that.address.bairro = res.bairro;
							that.address.logradouro = res.logradouro;
							that.address.cidade = res.localidade;
							that.address.estado = res.uf;
							that.address.pais = 'Brasil'; // Tem que mudar depois isso

							// angular.element('#zipcode-address').focus();
							// res.logradouro ? angular.element('#num-address').focus() : angular.element('#stre-address').focus();

							setTimeout(function () {
								// upperLabel();
							}, 100);

						}, function (err) {
							console.log(err);

							that.address = {};
							that.address_viacep = {};
							// upperLabel();
						});
				}
			}
		}

		Usuario.findById({
			id: vm.user.id,
			filter: {
				include: ['estado_civil', 'enderecos', 'telefones']
			}
		})
			.$promise.then(function (succ) {
				vm.form = $.extend(vm.form, succ)

				vm.lastTel = vm.form.telefones.filter(function(telefone) {
					return telefone.contato === vm.user.nome
				})
				var newtel = {
					contato: vm.user.nome,
					numero: '',
					ttel_id: 2,
					pes_id: vm.user.id
				}

				if(vm.lastTel.length > 0 ){
					vm.lastTel = vm.lastTel[0]
					if(!vm.lastTel.ttel_id){
						vm.lastTel.ttel_id = 2
					}
				}else{
					vm.form.telefones.push(newtel);
					vm.lastTel = vm.form.telefones[vm.form.telefones.length - 1]
				}
				// debugger;
				vm.formAddress.address = vm.form.enderecos ? vm.form.enderecos[0]: null;
				vm.form.day = succ.data_aniversario?  +moment(succ.data_aniversario).format('DD') : 1;
				vm.form.month = succ.data_aniversario? vm.mounthNumbers[+moment(succ.data_aniversario).format('MM') - 1] : vm.mounthNumbers[0];
				vm.form.year = succ.data_aniversario? +moment(succ.data_aniversario).format('YYYY') : +moment().format('YYYY');



				setTimeout(function () {
					// upperLabel();
				}, 100)
			}, function (err) {
				console.log(err);

			})

		function upperLabel() {
			angular.element('input.upper').each(function (index, element) {
				var $this = $(this);
				if (element.value.length > 0) {
					$this.siblings('label.upper').addClass('active');
				} else {
					$this.siblings('label.upper').removeClass('active');
				}
			})
		}
		vm.validacao = validacao;

		function validacao(event) {
			event.preventDefault();

			vm.form.data_aniversario = new Date(vm.form.year, vm.form.month.id - 1, vm.form.day);

			var idx = vm.form.telefones.findIndex(function (obj) {
				return obj.contato == vm.user.nome
			})
			if(vm.form.telefones[idx].numero === ""){
				vm.form.telefones.pop(idx);
			}

			vm.loader = true;
			vm.form.enderecos = [vm.formAddress.address];
			Usuario.upsertWithWhere({ where: { id: vm.user.id } }, vm.form)
				.$promise.then(function (succ) {
					vm.loader = false;
					swangular.swal({
						type: 'success',
						title: 'Dados atualizados',
						html: 'Os dados foram atualizados com sucesso',
						confirmButtonClass: 'btn button btn-default px-5',
						buttonsStyling: false,

						onClose: function () {
							$state.go('main.painel.dashboard');
						}
					})

				}, function (err) {
					console.log(err);
				})

		}

		function isMobile() {
			var pageWidth = angular.element('body').outerWidth();
			return (pageWidth < 992);
		}

	}
})();

(function () {
    ('use strict');
  
    angular
    .module('arboWeb')
    .service('validatorsArbo', ValidatorsArbo);
  
    function ValidatorsArbo() {
      var vm = this;

      /**
       * Valida o CPF
       * @param {String} cpf 
       * @returns {Boolean} true se o CPF for válido, false caso não seja.
       */
      vm.valid_cpf = function valid_cpf(cpf) {
        var Soma;
        var Resto;
        var i;
        Soma = 0;
        if (cpf == '00000000000') return false;
        for (i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
        if (Resto == 10 || Resto == 11) Resto = 0;
        if (Resto != parseInt(cpf.substring(9, 10))) return false;
        Soma = 0;
        for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
        if (Resto == 10 || Resto == 11) Resto = 0;
        if (Resto != parseInt(cpf.substring(10, 11))) return false;
        return true;
    };
     
    }
  })();
  
(function () {
  ('use strict');

  angular.module('arboWeb').service('ImageCompress', ImageCompress);

  ImageCompress.inject = ['$scope', '$compile'];

  /**
   * @param {Record<string, () => Promise<unknown>>} $http - The $http service from AngularJS.
   * @param {string} SERVER_URL - The server URL.
   */
  function ImageCompress($http, SERVER_URL) {
    /**
     * Compresses an image.
     * @param {Blob} file - The file to be compressed.
     * @param {Object} $scope - The scope in which the function is called.
     * @return {Promise<unknown>} - The promise that will be resolved when the image is compressed.
     */
    this.compressImage = function (file) {
      return new Promise(function (resolve, _) {
        handleCompress(file).then(function (compressedImage) {
          resolve(compressedImage);
        });
      });
    };

    /**
     * Handle compression of an image file using imageCompression library.
     * @param {Blob} imageFile - The image file to be compressed.
     * @returns {Promise<Blob>} A Promise that resolves to the compressed image Blob.
     */
    function handleCompress(imageFile) {
      return new Promise(function (resolve, reject) {
        var options = {
          useWebWorker: true,
        };

        imageCompression(imageFile, options)
          .then(function (compressedFile) {
            resolve(compressedFile);
          })
          .catch(function (error) {
            console.log(error.message);
            reject(error);
          });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('UnsubscribeController', UnsubscribeController)

  /* @ngInject */
  function UnsubscribeController($scope, $state, $location, PROD, SERVER_URL, textFormatter, $stateParams, $timeout, $window, Cidade, Estado, Imobiliaria, $rootScope, SendEmail, swangular) {
    var vm = this;
  }

})();
(function() {
    'use strict';

    angular
        .module('arboWeb')
        .service('textFormatter', textFormatter);

    // textFormatter.inject = ['dependency1'];

    function textFormatter() {
        var vm = this;

        vm.conversions = {};
        vm.conversions['ae'] = 'ä|æ|ǽ';
        vm.conversions['oe'] = 'ö|œ';
        vm.conversions['ue'] = 'ü';
        vm.conversions['Ae'] = 'Ä';
        vm.conversions['Ue'] = 'Ü';
        vm.conversions['Oe'] = 'Ö';
        vm.conversions['A'] = 'À|Á|Â|Ã|Ä|Å|Ǻ|Ā|Ă|Ą|Ǎ|Ẫ';
        vm.conversions['a'] = 'à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ẫ|ª';
        vm.conversions['C'] = 'Ç|Ć|Ĉ|Ċ|Č';
        vm.conversions['c'] = 'ç|ć|ĉ|ċ|č';
        vm.conversions['D'] = 'Ð|Ď|Đ';
        vm.conversions['d'] = 'ð|ď|đ';
        vm.conversions['E'] = 'È|É|Ê|Ë|Ē|Ĕ|Ė|Ę|Ě';
        vm.conversions['e'] = 'è|é|ê|ë|ē|ĕ|ė|ę|ě';
        vm.conversions['G'] = 'Ĝ|Ğ|Ġ|Ģ';
        vm.conversions['g'] = 'ĝ|ğ|ġ|ģ';
        vm.conversions['H'] = 'Ĥ|Ħ';
        vm.conversions['h'] = 'ĥ|ħ';
        vm.conversions['I'] = 'Ì|Í|Î|Ï|Ĩ|Ī|Ĭ|Ǐ|Į|İ';
        vm.conversions['i'] = 'ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı';
        vm.conversions['J'] = 'Ĵ';
        vm.conversions['j'] = 'ĵ';
        vm.conversions['K'] = 'Ķ';
        vm.conversions['k'] = 'ķ';
        vm.conversions['L'] = 'Ĺ|Ļ|Ľ|Ŀ|Ł';
        vm.conversions['l'] = 'ĺ|ļ|ľ|ŀ|ł';
        vm.conversions['N'] = 'Ñ|Ń|Ņ|Ň';
        vm.conversions['n'] = 'ñ|ń|ņ|ň|ŉ';
        vm.conversions['O'] = 'Ò|Ó|Ô|Õ|Ō|Ŏ|Ǒ|Ő|Ơ|Ø|Ǿ';
        vm.conversions['o'] = 'ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º';
        vm.conversions['R'] = 'Ŕ|Ŗ|Ř';
        vm.conversions['r'] = 'ŕ|ŗ|ř';
        vm.conversions['S'] = 'Ś|Ŝ|Ş|Š';
        vm.conversions['s'] = 'ś|ŝ|ş|š|ſ';
        vm.conversions['T'] = 'Ţ|Ť|Ŧ';
        vm.conversions['t'] = 'ţ|ť|ŧ';
        vm.conversions['U'] = 'Ù|Ú|Û|Ũ|Ū|Ŭ|Ů|Ű|Ų|Ư|Ǔ|Ǖ|Ǘ|Ǚ|Ǜ';
        vm.conversions['u'] = 'ù|ú|û|ũ|ū|ŭ|ů|ű|ų|ư|ǔ|ǖ|ǘ|ǚ|ǜ';
        vm.conversions['Y'] = 'Ý|Ÿ|Ŷ';
        vm.conversions['y'] = 'ý|ÿ|ŷ';
        vm.conversions['W'] = 'Ŵ';
        vm.conversions['w'] = 'ŵ';
        vm.conversions['Z'] = 'Ź|Ż|Ž';
        vm.conversions['z'] = 'ź|ż|ž';
        vm.conversions['AE'] = 'Æ|Ǽ';
        vm.conversions['ss'] = 'ß';
        vm.conversions['IJ'] = 'Ĳ';
        vm.conversions['ij'] = 'ĳ';
        vm.conversions['OE'] = 'Œ';
        vm.conversions['f'] = 'ƒ';
        vm.conversions['2'] = '²';

        vm.removeSpecialChar = removeSpecialChar;
        vm.urlFormatter = urlFormatter;
        vm.formatPrice = formatPrice;
        vm.phoneMask = phoneMask;
        vm.cpfMask = cpfMask;
        vm.formatPhone = formatPhone;
        vm.formatPhoneLink = formatPhoneLink;

        function phoneMask(str){
            if (str != null) {
                str = (str + '').split('');
                str.splice(0, 0, "(");
                str.splice(3, 0, ") ");
                if(str.length>11 && str.length<14) str.splice(-4, 0, "-");
            }
            return str.join('');
        };

        function cpfMask(str){
            if(str != null && str.length==11){
                str = (str + '').split('');
                str.splice(3,0,".");
                str.splice(7,0,".");
                str.splice(11,0,"-");
                return str.join('');
            }
            return str;
        }

        function formatPrice(n, z) {
            if (n != null) {
                z = (z !== null && z !== undefined) ? z : 2;
                return n.toFixed(z).replace(/./g, function (c, i, a) {
                return i > 0 && (a.length - i) % 3 === 0 ? c === "."?",": ("." + c) : c;
                });
            }
        }

        function urlFormatter(str) {
            if (!str) return;
            
            str = str.toLowerCase().replace(/[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-').replace(/\s/g, '-').replace(/---/g, '-').replace(/--/g, '-');

            str = str.toLowerCase();
            str = str.replace(/[0-9]/g, '');
            str = str.replace(/[!"#$%&'()*+,./:;<=>?@[\]^`{|}~]/g, '');
            str = str.replace(/\s/g, '-');
            str = str.replace(/--+/g, '-');

            for (var i in vm.conversions) {
                var re = new RegExp(vm.conversions[i], "g");
                str = str.replace(re, i);
            }
            return str;
        }

        function removeSpecialChar(str) {
            if(str){
                str = str.toLowerCase().replace(/[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-').replace(/\s/g, '-').replace(/---/g, '-').replace(/--/g, '-');

                str = str.toLowerCase();
                str = str.replace(/\s/g, '_');
                str = str.replace(/[!"#$%&'()*+,./:;<=>?@[\]^`{|}~]/g, '');

                for (var i in vm.conversions) {
                    var re = new RegExp(vm.conversions[i], "g");
                    str = str.replace(re, i);
                }
            }

            return str;
        };

        function formatPhone(typePhoneById, number) {
          switch (typePhoneById) {
            case 3:
              return number.replace(/^\(?(\d{2})\)?[-. ]?(\d{4}|\d{5})[-. ]?(\d{4})$/, "($1) $2-$3");
            case 17:
              return number.replace(/^(\d{4})(\d{3})(\d{4}).*/, '$1 $2 $3');
            case 18:
              return number.replace(/^(\d{4})(\d{4}).*/, '$1-$2');
            case 14:
              return number.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
            default:
              return number.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1) $2-$3');
          }
        }

        function formatPhoneLink(typePhoneById, number, link) {
          if(typePhoneById == 3){
            return link = 'https://api.whatsapp.com/send?phone=55' + number;
          }else{
            return link = 'tel:+55'+number;
          }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('arboWeb')
        .controller('TestController', TestController);

    /** @ngInject */
    function TestController(Amenity) {
        var vm = this;
        vm.amenity;
        activate();

        function activate() {
            Amenity.findById({ id: '58ca9fbb6a5a851b675607dd' }, function(response) {
                vm.amenity = response;
                vm.amenity.name = 'Mudou';
                vm.amenity.$save(function(success) {})
            });
        }

    }

})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('propostaCompraController', propostaCompraController)
    .filter('cnpjMask', cnpjMask);

  function cnpjMask() {
    return function (input) {
      input = input || '';

      return input.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5'
      );
    };
  }

  /* @ngInject */
  function propostaCompraController(
    $rootScope,
    $scope,
    $state,
    $sce,
    $q,
    $timeout,
    $location,
    $http,
    $window,
    SERVER_URL,
    URL_CDN,
    URL_BUCKET,
    toastr,
    textFormatter,
    $stateParams,
    auth,
    Usuario,
    viaCEP,
    Imovel,
    EstadoCivil,
    FileUploader,
    swangular,
    Proposta,
    PROD,
    LogErrorProposta
  ) {
    var vm = this;
    var imobiliaria = $rootScope.ConfigWhiteLabel;
    vm.tpng = {};
    vm.showImovel = true;
    var clienteCPF = null;
    var propCreated = {
      init: true,
      value: false,
    };

    var sendGa = function (name, data) {
      var trackers = $window.ga.getAll();
      for (var index = 0; index < trackers.length; index++) {
        var trackerName = trackers[index].get('name');
        $window.ga(trackerName + '.' + name, data);
      }
    };

    const urlCDN = URL_CDN;
    const urlBucket = URL_BUCKET;

    vm.imageThumb = function (url) {
      var size = '320x240';
      if (!url) return '';
      if (url.match(size)) return url;

      // change CDN
      url = url.replace(urlBucket, urlCDN);

      if (size != 'max') {
        var urlArray = (url || '').replace(/http(s?):\/\//, '').split('/');
        var fileName = urlArray.pop();

        return (
          'https://' +
          urlArray.concat([size, encodeURIComponent(fileName)]).join('/')
        );
      }
      return url;
    };

    vm.formatPrice = function (str) {
      return str.toLocaleString('pt-br', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 0,
      });
    };

    vm.toggleImovel = function (params) {
      vm.showImovel = !vm.showImovel;
    };

    if ($state.current.name == 'main.propostacompra.form') {
      vm.tpng.label = 'venda';
      vm.tpng.id = 1;
      vm.tpng.steps = 'steps-compra';
      vm.tpng.localstorage = 'proposta-compra';
      vm.tpng.client_label = 'compra';
    } else {
      vm.tpng.label = 'locacao';
      vm.tpng.id = 2;
      vm.tpng.steps = 'steps-locacao';
      vm.tpng.localstorage = 'proposta-locacao';
      vm.tpng.client_label = 'locação';
    }

    $(document).ready(function () {
      $('.fa-info-circle').click(function () {
        $('.newtooltip').toggleClass('d-none');
      });
    });

    var etapa = localStorage.getItem(vm.tpng.steps) || 1;
    vm.proposta = localStorage.getItem(vm.tpng.localstorage)
      ? JSON.parse(localStorage.getItem(vm.tpng.localstorage))
      : {};
    vm.config_wl = $rootScope.ConfigWhiteLabel;
    vm.isArboRent = false;
    if ('imb_config_crm' in vm.config_wl) {
      vm.isArboRent = vm.config_wl.imb_config_crm.imb_tag_rent ? true : false;
    }

    vm.selectedImovel = null;

    vm.subterror = false;
    vm.textFormatter = textFormatter;

    vm.corretorRead = !!$stateParams.i;
    vm.imovelRead = !!$stateParams.ii;

    vm.card_imovel = $stateParams.card_imovel || $location.search().card_imovel;

    if (!vm.card_imovel) showModalInvalid();

    var imb_id = imobiliaria.isArbo ? 9 : imobiliaria.id;

    vm.isLoading = true;
    vm.spinner = "<i class='icon fas fa-spinner fa-pulse'></i>";

    vm.imoveis = {};
    vm.data = {
      parte: [],
      descricao: {},
    };

    // Buscar dados do card
    vm.getCardData = function (card_imovel) {
      if (!card_imovel) {
        propCreated.init = false;
        return showModalInvalid();
      }

      var url = SERVER_URL + 'api/cardsimovel/get-card-data';

      $http
        .get(url, {
          params: {
            card_imovel: card_imovel,
            imobiliaria_wl: imb_id,
          },
        })
        .then(function (res) {
          res = res.data;

          if (!res.valid || (res.data && res.data.length == 0)) {
            propCreated.init = false;
            return showModalInvalid();
          }

          vm.data.parte = vm.data.parte || [];
          vm.isLoading = false;
          vm.showImovel = true;
          vm.data.cod_imovel = res.data.imovel || '';
          vm.data.name = res.data.cliente_interessado.cli_nome || '';
          vm.data.email = res.data.cliente_interessado.cli_email || '';
          vm.data.dataNasc = res.data.cliente_interessado.cli_nascimento || '';
          vm.data.phone =
            res.data.cliente_interessado.telefones &&
            res.data.cliente_interessado.telefones[0]
              ? res.data.cliente_interessado.telefones[0].numero
              : '';
          // Setando nome do corretor
          vm.data.corretor = {
            id: res.data.corretorID,
            label: res.data.corretorNome,
          };
          // Setando CPF || CNPJ
          if (
            res.data.cliente_interessado &&
            res.data.cliente_interessado.cli_cpf
          ) {
            if (vm.proposta.perfil) {
              vm.data.parte[0] = Object.assign({}, vm.data.parte[0], {
                docCNPJ: res.data.cliente_interessado.cli_cpf,
              });
            } else {
              vm.data.parte[0] = Object.assign({}, vm.data.parte[0], {
                docCPF: res.data.cliente_interessado.cli_cpf,
              });
            }
          }
        })
        .catch(function () {
          return swangular.swal({
            type: 'error',
            animation: false,
            title: 'Erro',
            html: 'Ocorreu um erro inesperado. Entre em contato com nossa equipe!',
            timer: 3000,
          });
        });
    };

    function showModalInvalid() {
      if (!propCreated.init && !propCreated.value) {
        return swangular.open({
          animation: false,
          showCloseButton: false,
          showConfirmButton: false,
          html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-invalid-link.html\'"></div>',
          customClass: 'custom-modal-proposta',
          width: '535px',
          controllerAs: 'vm',
          controller: 'propostaCompraController',
          resolve: {},
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    }

    $scope.redirect = function () {
      $state.go('main.home', {}, { reload: true });
      swangular.close();
    };

    // filtro para remover a modalidade "Sem Seguraça", fiz isso pq tem o item no banco
    // mas não pode ser mostrado no lugar nenhum, ai eu pergunto então por que não remover o item do banco?
    // a resposta da equipe foi pq não sabem se isso aparece em algum outro lugar????? What?
    // TODO: gambiarra, o certo é gerenciar isso via CRM. e não diretamente no código.
    // TODO: precisamos criar uma área no CRM que mostre todas as OPçÕes ocultas!
    // nunca devemos gerenciar esse tipo de coisa no código.
    $scope.semSeguroFiltro = function (_modalidade) {
      return _modalidade.tnmod_id !== 1 ? _modalidade : null;
    };

    // converte o que HTML que vem do banco de string para HTML·
    $scope.convertToHtml = function ($sce) {
      return $sce;
    };

    $scope.$watch('vm.data.tnmod_id', function (newValue) {
      //se valor == 1 então é sem-seguro e não pedemos ativar essa opção.
      if (newValue == 1) {
        vm.data.tnmod_id = 11; //seta como sendo a categoria padrão
      }
    });

    /**
     * Busca as modalidades que a imobiliária tem disponível para locação.
     * @param {*} imb_id id da Imobiliária
     */
    function getModalidesByImbID(imb_id) {
      var url = SERVER_URL + 'api/imobiliariamodalidadenegocio/modalidades';

      $http
        .get(url, {
          params: { imb_id: imb_id },
        })
        .then(
          function (data) {
            // quando ele encontra que o imobiliária não tem nenhum item cadastrado ele vai trazer
            // os itens padrões.
            if (!data.data.modalidades.length) {
              getModalidesTipoNegocio(2)
            } else {
              vm.modalidades = data.data.modalidades;
              vm.data.tnmod_id = vm.modalidades[0].tnmod_id;
            }
          },
          function (err) {
            console.log(err);
          }
        );
    }
    /**
     * Busca as modalidades por tipo de negocio.
     * @param {*} tpng_id id do tipo de negocio
     */
    function getModalidesTipoNegocio(tpng_id) {
      var url = SERVER_URL + 'api/imobiliariamodalidadenegocio/modalidadespadrao';

      $http
        .get(url, {
          params: { tpng_id: tpng_id },
        })
        .then(
          function (data) {
            vm.modalidades = data.data.modalidades;
            vm.data.tnmod_id = vm.modalidades[0].tnmod_id;
          },
          function (err) {
            console.log(err);
          }
        );
    }

    /**
     * Define o conteúdo dos itens apresentados no modelo da proposta
     * Verifica se o Imóvel selecionado pertence a um WhiteLabel.
     * Caso o imóvel seja de um Whitelabel, é preciso trazer as configurações
     * de modelo respectiva ao white label.
     */
    function defineModelosNegocio(imbId) {
      getModalidesByImbID(imbId);
    }

    vm.tpng.id == 2 ? defineModelosNegocio(imb_id) : getModalidesTipoNegocio(1);

    if (vm.proposta && vm.proposta.pessoal) {
      vm.data.parte[0] = vm.proposta.pessoal.parte0;
      vm.data.parte[1] = vm.proposta.pessoal.parte1;
      vm.address = vm.proposta.pessoal.endereco;
      vm.data.phone = vm.proposta.pessoal.telefone;
      vm.data.email = vm.proposta.pessoal.email;
      vm.data.dataNasc = vm.proposta.pessoal.dataNasc;
      vm.data.name = vm.proposta.pessoal.name;
    }

    if (vm.proposta && vm.proposta.negocio) {
      vm.data.corretor = vm.proposta.negocio.corretor;

      // verifica o tipo de neǵocio e se for 1 == Sem Seguro, Zera.
      vm.data.tnmod_id =
        vm.proposta.negocio.tnmod_id === 1 ? 0 : vm.proposta.negocio.tnmod_id;
      vm.data.cod_imovel = vm.proposta.negocio.cod_imovel;
      vm.data.priceLocacao = vm.proposta.negocio.preco;
      vm.data.addConditions = vm.proposta.negocio.condicoes;
      vm.data.renda_mensal = vm.proposta.negocio.renda_mensal
        ? vm.proposta.negocio.renda_mensal
        : null;
      vm.data.propt_data_pretencao = vm.proposta.negocio.pretencao;
      vm.data.propt_dia_pag = vm.proposta.negocio.pagamento;

      switch (vm.data.tnmod_id) {
        case 7:
          vm.data.descricao.permuta_carro = vm.proposta.negocio.permuta_carro;
          vm.data.descricao.permuta_imovel = vm.proposta.negocio.permuta_imovel;
          vm.data.descricao.permuta_outro = vm.proposta.negocio.permuta_outro;
          break;

        case 8:
          if (vm.proposta.negocio.caixa) {
            vm.data.descricao.caixa = vm.proposta.negocio.caixa;
          }

          if (vm.proposta.negocio.bb) {
            vm.data.descricao.bb = vm.proposta.negocio.bb;
          }

          if (vm.proposta.negocio.santander) {
            vm.data.descricao.santander = vm.proposta.negocio.santander;
          }

          if (vm.proposta.negocio.itau) {
            vm.data.descricao.itau = vm.proposta.negocio.itau;
          }

          if (vm.proposta.negocio.bradesco) {
            vm.data.descricao.bradesco = vm.proposta.negocio.bradesco;
          }

          if (vm.proposta.negocio.banco_outros) {
            vm.data.descricao.banco_outros = vm.proposta.negocio.banco_outros;
          }

          vm.data.descricao.banco_agencia = vm.proposta.negocio.banco_agencia;
          vm.data.descricao.financiamento_valor =
            vm.proposta.negocio.financiamento_valor;
          break;
        case 9:
          vm.data.descricao.consorcio_valor =
            vm.proposta.negocio.consorcio_valor;
          vm.data.descricao.consorciadora = vm.proposta.negocio.consorciadora;
          break;
        case 10:
          vm.data.descricao.outros_descreva =
            vm.proposta.negocio.outros_descreva;
          break;
        default:
          break;
      }
    }

    // var radioNegociacao = document.getElementsByClassName("btn-group-vertical");
    // radioNegociacao[0].children[vm.data.tnmod_id - 7].children[0].checked=true;
    // console.log(radioNegociacao[0].children[vm.data.tnmod_id - 7].children[0]);

    function isMobile() {
      var pageWidth = angular.element('body').outerWidth();
      return pageWidth < 992;
    }
    vm.isMobile = isMobile;

    if (vm.data.tnmod_id === undefined) {
      if (vm.tpng.id === 1) vm.data.tnmod_id = 6;
      else vm.data.tnmod_id = 1;
    }

    vm.pessoais = function (e, data) {
      e.preventDefault();

      // Criando validação de data maior que o dia atual
      data['form-dataNasc'].$validators.dateCheck = function (
        modelValue,
        viewValue
      ) {
        var moreThanToday =
          moment().diff(moment(viewValue, 'DD/MM/YYYY'), 'days') <= 0;

        return moreThanToday ? false : true;
      };
      // validação criada, hora de verificar se ele passa
      data['form-dataNasc'].$validate();
      if (angular.equals({}, data.$error)) {
        vm.proposta.pessoal = {
          name: vm.data.name,
          email: vm.data.email,
          dataNasc: vm.data.dataNasc,
          telefone: vm.data.phone,
          parte0: vm.data.parte[0],
          parte1: vm.data.parte[1],
          endereco: vm.address,
        };

        vm.proposta.pessoal.parte0.phone = vm.proposta.pessoal.telefone;
        vm.proposta.pessoal.parte0.accept_whats =
          vm.proposta.negocio.accept_whats;
        vm.proposta.pessoal.parte0.endereco = vm.address;
        vm.proposta.pessoal.parte0.name = vm.data.name;
        vm.proposta.pessoal.parte0.email = vm.data.email;
        vm.proposta.pessoal.parte0.dataNasc = vm.data.dataNasc;

        //PARTE DA ETAPA 3
        localStorage.setItem(vm.tpng.localstorage, JSON.stringify(vm.proposta));

        if (PROD) {
          sendGa('send', {
            hitType: 'event',
            eventCategory: 'propostaWorkflow',
            eventAction: 'sucesso na etapa ' + etapa,
            eventLabel:
              vm.tpng.label +
              '|' +
              (vm.proposta.perfil ? 'juridico' : 'física'),
          });
        }

        nextStep();

        return;
      } else {
        vm.subterror = true;
        angular.element('input.ng-invalid').first().focus();

        if (PROD) {
          sendGa('send', {
            hitType: 'event',
            eventCategory: 'propostaWorkflow',
            eventAction: 'falha na etapa ' + etapa,
            eventLabel:
              vm.tpng.label +
              '|' +
              (vm.proposta.perfil ? 'juridico' : 'física'),
          });
        }
      }
    };

    vm.resetCustomValidation = function (id, errors) {
      // reset custom validations
      errors.forEach(function (el) {
        $('#' + id)
          .controller('ngModel')
          .$setValidity(el, true);
      });
    };

    vm.removeAutoCompleteChrome = function ($event) {
      // Eu sei, gambiarra
      window.scroll(0, window.scrollY + 1);
    };

    vm.negocio = function (e, data) {
      //reset
      if (data['form-payment'])
        data['form-payment'].$setValidity('autcmplt', true);

      e.preventDefault();

      if (!vm.data.corretor || !vm.data.corretor.id) {
        data['form-corretor'].$setValidity('autcmplt', false);
        var ele = document.getElementById('form-corretor');
        vm.subterror = true;

        ele.focus();
      } else if (!vm.data.cod_imovel || !vm.data.cod_imovel.id) {
        data['form-codimvoel'].$setValidity('autcmplt', false);
        var ele = document.getElementById('form-codimvoel');
        vm.subterror = true;

        ele.focus();
      } else if (vm.data.propt_dia_pag && !vm.data.propt_dia_pag.value) {
        if (data['form-payment'])
          data['form-payment'].$setValidity('autcmplt', false);

        var ele = document.getElementById('form-payment');
        vm.subterror = true;

        ele.focus();
      } else if (
        vm.data.propt_data_pretencao &&
        !moment(vm.data.propt_data_pretencao, 'DD/MM/YYYY').isAfter(moment(), 'day')
      ) {
        data['form-entrace'].$setValidity('olddate', false);
        var ele = document.getElementById('form-entrace');
        vm.subterror = true;

        ele.focus();
      } else if (angular.equals({}, data.$error)) {
        vm.proposta.negocio = {
          corretor: vm.data.corretor,
          tnmod_id: vm.data.tnmod_id,
          cod_imovel: vm.data.cod_imovel,
          preco: vm.data.priceLocacao,
          condicoes: vm.data.addConditions,
          accept_whats: vm.data.accept_whats,
          renda_mensal: vm.data.renda_mensal,
          pretencao: vm.data.propt_data_pretencao,
          pagamento:
            vm.data.propt_dia_pag && vm.data.propt_dia_pag.value
              ? vm.data.propt_dia_pag.value
              : vm.data.propt_dia_pag,
        };

        switch (vm.data.tnmod_id) {
          case 7:
            vm.proposta.negocio.permuta_carro = vm.data.descricao.permuta_carro;
            vm.proposta.negocio.permuta_imovel =
              vm.data.descricao.permuta_imovel;
            vm.proposta.negocio.permuta_outro = vm.data.descricao.permuta_outro;
            break;

          case 8:
            if (vm.data.descricao.caixa) {
              vm.proposta.negocio.caixa = vm.data.descricao.caixa;
            }

            if (vm.data.descricao.bb) {
              vm.proposta.negocio.bb = vm.data.descricao.bb;
            }

            if (vm.data.descricao.santander) {
              vm.proposta.negocio.santander = vm.data.descricao.santander;
            }

            if (vm.data.descricao.itau) {
              vm.proposta.negocio.itau = vm.data.descricao.itau;
            }

            if (vm.data.descricao.bradesco) {
              vm.proposta.negocio.bradesco = vm.proposta.negocio.bradesco;
            }

            if (vm.data.descricao.banco_outros) {
              vm.proposta.negocio.banco_outros = vm.data.descricao.banco_outros;
            }

            vm.proposta.negocio.banco_agencia = vm.data.descricao.banco_agencia;
            vm.proposta.negocio.financiamento_valor =
              vm.data.descricao.financiamento_valor;
            break;
          case 9:
            vm.proposta.negocio.consorcio_valor =
              vm.data.descricao.consorcio_valor;
            vm.proposta.negocio.consorciadora = vm.data.descricao.consorciadora;
            break;
          case 10:
            vm.proposta.negocio.outros_descreva =
              vm.data.descricao.outros_descreva;
            break;
          default:
            break;
        }

        vm.proposta.pessoal = {
          parte0: vm.data.parte[0],
        };

        localStorage.setItem(vm.tpng.localstorage, JSON.stringify(vm.proposta));

        //PARTE DA ETAPA 2
        if (PROD) {
          sendGa('send', {
            hitType: 'event',
            eventCategory: 'propostaWorkflow',
            eventAction: 'sucesso na etapa ' + etapa,
            eventLabel:
              vm.tpng.label +
              '|' +
              (vm.proposta.perfil ? 'juridico' : 'física'),
          });
        }

        nextStep();

        return;
      } else {
        if (PROD) {
          sendGa('send', {
            hitType: 'event',
            eventCategory: 'propostaWorkflow',
            eventAction: 'falha na etapa ' + etapa,
            eventLabel:
              vm.tpng.label +
              '|' +
              (vm.proposta.perfil ? 'juridico' : 'física'),
          });
        }

        vm.subterror = true;
        angular.element('input.ng-invalid').first().focus();
      }
    };

    vm.enviar = function (e) {
      e.preventDefault();
      vm.proposta = JSON.parse(localStorage.getItem(vm.tpng.localstorage));
      var descricao;
      var deferred = $q.defer();

      if (!vm.proposta) {
        return swangular.swal({
          type: 'error',
          title: 'Não foi possível gerar sua proposta.',
          html: 'Por favor contate o suporte!',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
        });
      }

      switch (vm.proposta.negocio.tnmod_id) {
        case 6:
          descricao = {
            modalidade: 'à vista',
          };

          break;
        case 7:
          descricao = {
            permuta:
              (!!vm.proposta.negocio.permuta_carro
                ? '\ncarro - ' + vm.proposta.negocio.permuta_carro
                : '') +
              (!!vm.proposta.negocio.permuta_imovel
                ? '\nImovel - ' + vm.proposta.negocio.permuta_imovel
                : '') +
              (!!vm.proposta.negocio.permuta_outro
                ? '\nOutro - ' + vm.proposta.negocio.permuta_outro
                : ''),
          };

          break;
        case 8:
          descricao = {
            valor: vm.proposta.negocio.financiamento_valor,
            banco: !!vm.proposta.negocio.caixa
              ? 'caixa - '
              : !!vm.proposta.negocio.bb
              ? 'banco do brasil - '
              : !!vm.proposta.negocio.santander
              ? 'santander - '
              : !!vm.proposta.negocio.itau
              ? 'itau - '
              : !!vm.proposta.negocio.bradesco
              ? 'bradesco - '
              : vm.proposta.negocio.banco_outros,
            agencia: vm.proposta.negocio.banco_agencia,
          };

          break;
        case 9:
          descricao = {
            valor: vm.proposta.negocio.consorcio_valor,
            consorciadora: vm.proposta.negocio.consorciadora,
          };

          break;
        case 10:
          descricao = { descricao: vm.proposta.negocio.outros_descreva };

          break;
      }

      $http({
        method: 'POST',
        url: SERVER_URL + 'api/propostas/save-proposta',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          card: vm.card_imovel,
          imobiliaria: vm.proposta.negocio.cod_imovel.imb_id,
          corretor: vm.proposta.negocio.corretor.id,
          modalidade: vm.proposta.negocio.tnmod_id,
          descricao: descricao,
          imovel: vm.proposta.negocio.cod_imovel.id,
          parte0: vm.proposta.pessoal.parte0,
          parte1: vm.proposta.pessoal.parte1,
          tipo: vm.tpng.label,
          perfil: vm.proposta.perfil,
          preco: vm.proposta.negocio.preco,
          condicoes: vm.proposta.negocio.condicoes,
          propt_dia_pag:
            vm.data.propt_dia_pag && vm.data.propt_dia_pag.value
              ? vm.data.propt_dia_pag.value
              : vm.data.propt_dia_pag,
          propt_data_pretencao: vm.data.propt_data_pretencao,
          propt_accept_terms: vm.form.propt_accept_terms,
          ppart_renda_mensal: vm.proposta.negocio.renda_mensal
            ? vm.proposta.negocio.renda_mensal
            : null,
          pst_id: vm.proposta.negocio.tnmod_id == 1 ? 1 : 33,
        },
      })
        .then(function (response) {
          var hash = [];
          var succ = response.data;
          var hashProposta = succ.propt_hash;

          localStorage.setItem('propv-form', btoa(succ.id));

          if (localStorage.getItem('propv-hash'))
            hash = JSON.parse(localStorage.getItem('propv-hash'));

          hash.unshift(hashProposta);
          localStorage.setItem('propv-hash', JSON.stringify(hash));

          vm.urlshare =
            'http://' +
            $rootScope.ConfigWhiteLabel.url_site
              .replace('http://', '')
              .replace('https://', '') +
            (vm.tpng.id == 1 ? '/proposta-compra/' : '/proposta-locacao/') +
            hashProposta +
            (vm.tpng.id == 1 ? '/compra-conjunta' : '/locacao-conjunta');
          $('.revise-sua-proposta').addClass('hide');
          //remove o botão de voltar após enviar a proposta
          //PARTE DA ETAPA 4
          if (PROD) {
            sendGa('send', {
              hitType: 'event',
              eventCategory: 'propostaWorkflow',
              eventAction: 'sucesso na etapa ' + etapa,
              eventLabel:
                vm.tpng.label +
                '|' +
                (vm.proposta.perfil ? 'juridico' : 'física'),
            });
          }

          var promise = crudGet();

          promise.then(
            function (greeting) {
              propCreated = {
                init: false,
                value: true,
              };
              deferred.resolve(
                Object.assign(greeting, {
                  success: true,
                  resend: false,
                })
              );
              nextStep();
            },
            function (reason) {
              deferred.resolve(
                Object.assign(reason, {
                  success: false,
                  resend: true,
                })
              );
            }
          );
        })
        .catch(function (err) {
          if (PROD) {
            sendGa('send', {
              hitType: 'event',
              eventCategory: 'propostaWorkflow',
              eventAction: 'falha na etapa ' + etapa,
              eventLabel:
                vm.tpng.label +
                '|' +
                (vm.proposta.perfil ? 'juridico' : 'física'),
            });
          }

          swangular.swal({
            type: 'error',
            title: err.data.error.message,
            html: 'Por favor contate o suporte!',
            confirmButtonClass: 'btn button btn-default px-5',
            buttonsStyling: false,
          });

          LogErrorProposta.create({
            lerrp_dados: vm.data,
            lerrp_erro: err.data.error,
          });

          console.log('Error: ', err);
        })
        .finally(function () {
          localStorage.removeItem(vm.tpng.localstorage);
          localStorage.removeItem(vm.tpng.steps);

          document.body.scrollTop = document.documentElement.scrollTop = 0;

          return;
        });
    };

    vm.calendario = function (data) {
      return moment(data).format('DD/MM/YYYY');
    };

    vm.formproposta = {};

    vm.checkStep = function (e) {
      return etapa == e;
    };

    vm.transitionForms = function (step) {
      // o ng-show coloca essa classe, mas por conta de muita modificação no $scope, estava demorando para dar o $digest (e não consegui forçar em nenhum lugar)
      // Essa função antecipa o ng-show caso demore, para colocar o ng-hide antes que ele.

      $('#form-step-' + step).addClass('ng-hide');
    };

    function nextStep(e) {
      vm.transitionForms(e || etapa);

      if (document.getElementById('nvPropostaLat'))
        document.getElementById('nvPropostaLat').style.display = 'block';
      etapa = e || +etapa + 1;

      if (etapa > 5) {
        etapa = 1;
        $('.revise-sua-proposta').removeClass('hide');
      }

      localStorage.setItem(vm.tpng.steps, etapa);

      vm.subterror = false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      return;
    }

    vm.nextStep = nextStep;

    vm.prevStep = function (e) {
      vm.transitionForms(e || etapa);

      etapa = e || etapa - 1;

      if (etapa < 2) {
        etapa = 1;
        vm.setperfil('fisica');
      }

      localStorage.getItem(vm.tpng.steps, etapa);
      vm.subterror = false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      return;
    };

    vm.setperfil = function (e) {
      if (vm.proposta.perfil === undefined || etapa == 1) {
        switch (e) {
          case 'juridico':
            vm.proposta.perfil = true;

            if (PROD) {
              sendGa('send', {
                hitType: 'event',
                eventCategory: 'propostaWorkflow',
                eventAction: 'sucesso na etapa ' + etapa,
                eventLabel:
                  vm.tpng.label +
                  '|' +
                  (vm.proposta.perfil ? 'juridico' : 'física'),
              });
            }

            break;
          default:
            vm.proposta.perfil = false;

            if (PROD) {
              sendGa('send', {
                hitType: 'event',
                eventCategory: 'propostaWorkflow',
                eventAction: 'sucesso na etapa ' + etapa,
                eventLabel:
                  vm.tpng.label +
                  '|' +
                  (vm.proposta.perfil ? 'juridico' : 'física'),
              });
            }

            break;
        }
        localStorage.setItem(vm.tpng.localstorage, JSON.stringify(vm.proposta));

        nextStep();
      }
    };

    vm.calendario = function (data) {
      return moment(data).format('DD/MM/YYYY');
    };

    vm.novaProposta = novaProposta;

    function novaProposta(e) {
      localStorage.removeItem(vm.tpng.localstorage);
      localStorage.removeItem(vm.tpng.steps);
      $state.go($state.current.name, {}, { reload: true });
    }

    vm.gonegocio = function () {
      if (PROD) {
        sendGa('send', {
          hitType: 'event',
          eventCategory: 'propostaWorkflow',
          eventAction: 'retorno p/ etapa 2',
          eventLabel:
            vm.tpng.label + '|' + (vm.proposta.perfil ? 'juridico' : 'física'),
        });
      }

      nextStep(2);

      return;
    };

    vm.gopessoal = function () {
      if (PROD) {
        sendGa('send', {
          hitType: 'event',
          eventCategory: 'propostaWorkflow',
          eventAction: 'retorno p/ etapa 3',
          eventLabel:
            vm.tpng.label + '|' + (vm.proposta.perfil ? 'juridico' : 'física'),
        });
      }

      nextStep(3);

      return;
    };

    // ----------- NEW ^ ------------------

    vm.copyPaste = copyPaste;
    vm.propostaData = null;
    vm.setProfile = function (e) {
      if (e == 1 || e == 2) {
        vm.typeProfile = e;
      } else {
        vm.typeProfile = 1;
      }

      nextStep();

      localStorage.setItem('profile-propv-arbo', vm.typeProfile);
    };

    var autocomplete = null;

    vm.autocomplete = function () {
      if (!vm.data.end_imovel) {
        vm.imoveis = null;
        vm.data.imovelSelect = null;

        return;
      }

      var input = document.getElementById('form-endimovel');

      if (autocomplete == null) {
        var autoCompleteOpcoes = {
          sessionToken: '1234567890',
          componentRestrictions: {
            country: 'BR',
          },
        };

        autocomplete = new google.maps.places.Autocomplete(
          input,
          autoCompleteOpcoes
        );

        autocomplete.addListener('place_changed', function () {
          vm.data['end_imovel'] = autocomplete.getPlace().formatted_address;
          var location = autocomplete.getPlace().geometry.location;
          var center = {
            lat: location.lat(),
            lng: location.lng(),
          };

          var north_east = {
            lat: location.lat() + 0.008,
            lng: location.lng() + 0.008,
          };

          var south_west = {
            lat: location.lat() - 0.008,
            lng: location.lng() - 0.008,
          };

          Imovel.findByPolygonNew({
            center: center,
            north_east: north_east,
            south_west: south_west,
            tipovar: 'para-alugar',
          }).$promise.then(function (response) {
            var ids = response.map(function (el) {
              return el.id;
            });

            if (ids.length) {
              Imovel.getImoveisNew({
                where: {
                  id: { inq: ids },
                },
                limit: 20,
              }).$promise.then(function (response) {
                vm.imoveis = response;

                if (response && response.length) {
                  vm.data.imovelSelect = response[0].id;
                } else {
                  vm.data.imovelSelect = null;
                }
              });
            }
          });
        });
      }
    };

    vm.estadoCivil = [
      { id: 1, label: 'Solteiro(a)' },
      { id: 2, label: 'Casado(a)' },
      { id: 3, label: 'Divorciado(a)' },
      { id: 4, label: 'Viúvo(a)' },
      { id: 5, label: 'Separado(a)' },
    ];

    vm.valid_cpf = function (cpf) {
      var Soma;
      var Resto;
      Soma = 0;

      if (cpf == '00000000000') return false;

      for (var i = 1; i <= 9; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);

      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(9, 10))) return false;

      Soma = 0;

      for (var i = 1; i <= 10; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);

      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(10, 11))) return false;

      return true;
    };

    vm.form = {
      submit_formname: function (e) {
        e.preventDefault();

        if (etapa == 2) {
          if (!vm.data.imovelSelect) {
            swangular.swal({
              type: 'error',
              animation: false,
              title: 'Selecione um imóvel!',
              confirmButtonClass: 'btn button btn-default px-5',
              buttonsStyling: false,
              timer: 2500,
            });

            return false;
          }

          localStorage.setItem('save-profilev-form', JSON.stringify(vm.data));

          var parte = {};
          parte['name'] = vm.data['name'];
          parte['email'] = vm.data['email'];
          parte['phone'] = vm.data['phone'];
          parte['accept_whats'] = vm.data['accept_whats'];
          parte['endereco'] = vm.data['end_imovel'];
          parte['type'] = vm.data['type'];

          var crt_id = vm.data.corretor ? vm.data.corretor['id'] : null;
          var tnmod_id = vm.data.tnmod_id ? vm.data.tnmod_id['id'] : null;
          var desc = vm.data.descricao;
          var descricao;

          switch (vm.data.negocio) {
            case 1:
              descricao = {
                modalidade: 'Sem garantia',
              };

              break;
            case 5:
              descricao = {
                modalidade: 'Titulo de capitalização',
              };

              break;
            case 6:
              descricao = {
                modalidade: 'à vista',
              };

              break;
            case 7:
              descricao = {
                valor_proposta: desc.valor_proposta_7,
                permuta:
                  (!!desc.permuta_carro
                    ? '\ncarro - ' + desc.permuta_carro
                    : '') +
                  (!!desc.permuta_imovel
                    ? '\nImovel - ' + desc.permuta_imovel
                    : '') +
                  (!!desc.permuta_outro
                    ? '\nOutro - ' + desc.permuta_outro
                    : ''),
              };

              break;
            case 8:
              descricao = {
                valor: desc.financiamento_valor,
                banco: !!desc.caixa
                  ? 'caixa - ' + desc.caixa
                  : !!desc.bb
                  ? 'banco do brasil - ' + desc.bb
                  : !!desc.santander
                  ? 'santander - ' + desc.santander
                  : !!desc.itau
                  ? 'itau - ' + desc.itau
                  : !!desc.bradesco
                  ? 'bradesco - ' + desc.bradesco
                  : desc.banco_outros,
                agencia: desc.banco_agencia,
              };

              break;
            case 9:
              descricao = {
                valor: desc.consorcio_valor,
                consorciadora: desc.consorciadora,
              };

              break;
            case 10:
              descricao = { descricao: desc.outros_descreva };

              break;
          }

          Proposta.createSite({
            corretor: crt_id,
            modalidade: tnmod_id,
            descricao: descricao,
            imovel: vm.data.imovelSelect,
            parte: parte,
            tipo: vm.tpng.label,
          }).$promise.then(
            function (succ) {
              var hash = [];

              localStorage.setItem('propv-form', btoa(succ.id));

              if (localStorage.getItem('propv-hash'))
                hash = JSON.parse(localStorage.getItem('propv-hash'));

              var hashProposta = succ.__data.propt_hash;
              hash.unshift(hashProposta);
              localStorage.setItem('propv-hash', JSON.stringify(hash));

              var promise = crudGet();
              promise.then(
                function (greeting) {
                  console.log('Load: Proposta');
                  nextStep();
                },
                function (reason) {
                  console.log('Error: Proposta');
                }
              );
            },
            function (err) {
              console.log('Error: ', err);
            }
          );
        } else if (etapa == 3) {
          vm.propostaData['propt_valor'] = parseFloat(vm.data.priceLocacao);
          vm.data.addConditions
            ? (vm.propostaData['propt_adicionais'] =
                vm.data.addConditions +
                '\n' +
                vm.propostaData['propt_adicionais'])
            : null;
          vm.propostaData['propt_data_pretencao'] = vm.data.dateStart;
          vm.propostaData['propt_dia_pag'] = parseInt(vm.data.datePayment);
          vm.propostaData['pst_id'] =
            vm.proposta.negocio.tnmod_id == 1 ? 1 : 33;

          vm.propostaData.$saveSite().then(
            function (succ) {
              var promise = crudGet();

              promise.then(
                function (greeting) {
                  console.log('Load: Proposta');
                  nextStep();
                },
                function (reason) {
                  console.log('Error: Proposta');
                }
              );
            },
            function (err) {
              console.log('Error: ', err);
            }
          );
        } else if (etapa == 4) {
          var parteInit = JSON.parse(
            localStorage.getItem('save-profilev-form')
          );

          if (!vm.propostaData.propPartes) vm.propostaData.propPartes = [];

          for (var i = 0; i < vm.data.parte.length; ++i) {
            if (
              !vm.data.parte[i]['docCPF'] ||
              !vm.valid_cpf(vm.data.parte[i]['docCPF'])
            ) {
              swangular.swal({
                type: 'error',
                animation: false,
                title: 'CPF inválido',
                confirmButtonClass: 'btn button btn-default px-5',
                buttonsStyling: false,
                timer: 2500,
              });

              return false;
            }
            var parte = {};

            for (
              var index = 0;
              index < vm.propostaData.propPartes.length;
              index++
            ) {
              if (
                vm.propostaData.propPartes[index]['ptpart_id'] ==
                vm.data.parte[i]['type']
              ) {
                parte = vm.propostaData.propPartes[index];
                parte['index'] = index;
              }
            }
            if (vm.typeProfile == 1) {
              parte['ptpart_id'] = vm.data.parte[i]['type'];
              parte['ppart_renda_mensal'] = vm.data.parte[i]['renda_mensal'];
              parte['ppart_document'] = vm.data.parte[i]['docCPF'];
              parte['ppart_rg'] = vm.data.parte[i]['docRG'].replace(/\D/g, '');
              parte['ppart_data_nasc'] = vm.data.parte[i]['birthday'];
              parte['ppart_nacionalidade'] = (
                vm.data.parte[i]['nationality'] || ''
              ).toLowerCase();
              parte['ppart_profissao'] = (
                vm.data.parte[i]['professional'] || ''
              ).toLowerCase();

              if (vm.data.parte[i]['type'] == 2) {
                parte['ppart_estado_civil'] =
                  vm.data.parte[i]['estadocivil']['label'];
                parte['ppart_imposto_renda'] = vm.data.parte[i]['imprenda'];

                parte['ppart_renda_mensal'] = vm.data.parte[i]['renda'];

                // Address
                parte['ppart_end_logradouro'] = vm.address['end_logradouro'];
                parte['ppart_end_numero'] = vm.address['end_numero'];
                parte['ppart_end_complemento'] = vm.address['end_complemento'];
                parte['ppart_end_bairro'] = vm.address['end_bairro'];
                parte['ppart_end_cep'] = vm.address['end_cep'];
                parte['ppart_end_cidade'] = vm.address['end_cidade'];
                parte['ppart_end_estado'] = vm.address['end_estado'];
                parte['ppart_end_pais'] = vm.address['end_pais'];
              }
            } else if (vm.typeProfile == 2) {
              parte['ptpart_id'] = vm.data.parte[i]['type'];
              parte['ppart_renda_mensal'] = vm.data.parte[i]['renda_mensal'];
              parte['ppart_nome'] =
                vm.data.parte[i]['name'] || parteInit['name'];
              parte['ppart_document'] =
                vm.data.parte[i]['docCNPJ'] || vm.data.parte[i]['docCPF'];
              parte['ppart_ie'] = (
                vm.data.parte[i]['docIE'] || vm.data.parte[i]['docRG']
              ).replace(/\D/g, '');

              if (vm.data.parte[i]['action']) {
                parte['ppart_profissao'] =
                  vm.data.parte[i]['action'].toLowerCase();
              }

              if (vm.data.parte[i]['birthday']) {
                parte['ppart_data_nasc'] = vm.data.parte[i]['birthday'];
              }

              if (vm.data.parte[i]['email']) {
                parte['ppart_email'] = vm.data.parte[i]['email'];
              }

              if (vm.data.parte[i]['type'] == 4) {
                parte['ppart_end_logradouro'] = vm.address['end_logradouro'];
                parte['ppart_end_numero'] = vm.address['end_numero'];
                parte['ppart_end_complemento'] = vm.address['end_complemento'];
                parte['ppart_end_bairro'] = vm.address['end_bairro'];
                parte['ppart_end_cep'] = vm.address['end_cep'];
                parte['ppart_end_cidade'] = vm.address['end_cidade'];
                parte['ppart_end_estado'] = vm.address['end_estado'];
                parte['ppart_end_pais'] = vm.address['end_pais'];
              }
            }
            if (parte.index !== undefined) {
              vm.propostaData.propPartes[parte.index] = parte;
            } else {
              vm.propostaData.propPartes.push(parte);
            }
          }

          vm.propostaData['propStatusOld'] = 33;
          vm.propostaData.$saveSite().then(
            function (succ) {
              var promise = crudGet();

              promise.then(
                function (greeting) {
                  console.log('Load: Proposta');
                  nextStep();
                },
                function (reason) {
                  console.log('Error: Proposta');
                }
              );
            },
            function (err) {
              console.log('Error: ', err);
            }
          );
        } else if (etapa == 5) {
          for (var i = 0; i < vm.data.parte.length; ++i) {
            vm.propostaData.propPartes[i]['ppart_cnt_nome'] =
              vm.data.parte[i]['contatoNome'];
            vm.propostaData.propPartes[i]['ppart_cnt_telefone'] =
              vm.data.parte[i]['contatoTel'];
          }

          var hash =
            typeof vm.propostaData.hash === 'string'
              ? [vm.propostaData.hash]
              : vm.propostaData.hash;

          vm.urlshare =
            'http://' +
            $rootScope.ConfigWhiteLabel.url_site
              .replace('http://', '')
              .replace('https://', '') +
            '/proposta-compra/' +
            hash[0] +
            '/compra-conjunta';
          vm.propostaData['propStatusOld'] = 1;

          vm.propostaData.$saveSite().then(
            function (succ) {
              nextStep();
              finishProposta();
            },
            function (err) {
              console.log('Error: ', err);
            }
          );
        }

        return;
      },
      getCorretor: function (val) {
        val = val.replace(/[^a-zA-Z ]/g, '');

        if (!val || val.length == 0) val = '[blank]';
        else val = val.trim();

        var _url =
          SERVER_URL + 'api/propostas/autocomplete/propCorretor/' + val;
        var dataparams;

        if (imobiliaria.isArbo) {
          if (
            vm.data.cod_imovel &&
            vm.data.cod_imovel.imb_id &&
            vm.data.cod_imovel.imb_id != 9
          ) {
            dataparams = {
              params: { limit: 5, imb_id: vm.data.cod_imovel.imb_id },
            };
          } else {
            dataparams = { params: { limit: 5 } };
          }
        } else {
          dataparams = { params: { limit: 5, imb_id: imobiliaria.id } };
        }

        var params = dataparams;

        return $http
          .get(_url, {
            params: params,
          })
          .then(function (response) {
            return response.data;
          });
      },
      selectAutocomplete: function ($item, $model, $label, $event, input) {
        // toda vez que o imóvel muda, e o tipo da proposta é locação (tpng.id == 2),
        // nós zeramos a configuração de modalidade da proposta

        if (vm.tpng.id == 2) {
          if ($item.imb_id) {
            vm.data.tnmod_id = 0;
            vm.selectedImovel = $item.imb_id;
            defineModelosNegocio($item.imb_id);
          } else if (vm.selectedImovel) {
            defineModelosNegocio(vm.selectedImovel);
          } else {
            defineModelosNegocio(imobiliaria.id);
          }
        }

        input.$setValidity('autcmplt', true);
      },
      selectNegocio: function ($item, $model, $label, $event, input) {
        vm.data.negocio = $item.id;
      },
      getImoveis: function (term) {
        var deferred = $q.defer();
        var queue = [];
        var url = SERVER_URL + 'api/imoveis-replica/get-imoveis-new';
        term = term.replace(/\/|\\/g, '');
        var pattern = '/(' + term + ')/i';
        var _where = {
          and: [
            { imv_ativo: true },
            { imv_publicar: true },
            { tpng_id: { inq: [vm.tpng.id, 3] } },
            {
              or: [
                { id: parseInt(term) },
                { imv_cod_gaia: { regexp: pattern } },
              ],
            },
          ],
        };

        var showlimit = isMobile ? 2 : 5;

        queue.push(
          $http.get(url, {
            params: {
              limit: showlimit,
              where: _where,
              wlimobiliaria: !vm.config_wl.isArbo,
            },
          })
        );

        $q.all(queue).then(function (res) {
          res = res[0];
          deferred.resolve(res.data);
        });

        return deferred.promise;
      },
      searchImoveis: function (imv) {
        if (!imv) {
          vm.imoveis = null;
          vm.data.imovelSelect = null;

          return;
        }

        var _url = SERVER_URL + 'api/imoveis-replica/get-imoveis-new';
        var filter = {};

        filter['imv_cod_gaia'] = { regexp: '/' + imv + '/i' };

        if (!imobiliaria.isArbo) filter['imb_id'] = imobiliaria.id;

        filter['and'] = [];
        filter['and'].push({ imv_preco_venda: { neq: null } });
        filter['and'].push({ imv_preco_venda: { neq: 0 } });
        filter['and'].push({ tpng_id: { inq: [1, 3] } });

        Imovel.getImoveisNew({
          where: filter,
          limit: 20,
        }).$promise.then(function (response) {
          vm.imoveis = response;

          if (response && response.length) {
            vm.data.imovelSelect = response[0].id;
          } else {
            vm.data.imovelSelect = null;
          }
        });
      },
      selectImovel: function (e) {
        if (vm.data.imovelSelect == e) {
          vm.data.imovelSelect = null;
        } else {
          vm.data.imovelSelect = e;
        }
      },
      viacepGet: function () {
        if (
          vm.address.end_cep !== undefined &&
          vm.address.end_cep.replace(/\D+/g).length == 8
        ) {
          viaCEP.get(vm.address.end_cep).then(
            function (res) {
              vm.address_viacep = res;
              vm.address.end_bairro = res.bairro;
              vm.address.end_logradouro = res.logradouro;
              vm.address.end_cidade = res.localidade;
              vm.address.end_estado = res.uf;
              vm.address.end_pais = 'Brasil'; // Tem que mudar depois isso

              res.logradouro
                ? angular.element('#num-address').focus()
                : angular.element('#stre-address').focus();

              setTimeout(function () {
                upperLabel();
              }, 100);
            },
            function (err) {
              vm.address = {};
              vm.address_viacep = {};

              upperLabel();
            }
          );
        }
      },
    };

    function copyPaste() {
      var range, textArea, selection;

      textArea = document.getElementById('valueToCopy'); //Visible element to copy the value to

      if (navigator.userAgent.match(/ipad|iphone/i)) {
        range = document.createRange();
        range.selectNodeContents(textArea);
        selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, 999999);
      } else textArea.select();

      var success = document.execCommand('Copy'); //Copy
      var msg = success
        ? 'Copiado com sucesso.'
        : 'Ocorreu um erro, tente novamente'; //Set success or error msg

      swangular.swal({
        type: 'success',
        animation: false,
        title: msg,
        confirmButtonClass: 'btn button btn-default px-5',
        buttonsStyling: false,
        timer: 1500,
      });
    }

    function upperLabel() {
      angular.element('input.upper').each(function (index, element) {
        var $this = $(this);

        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      });
    }
  }
})();

// (function () {
//   'use strict';

//   angular
//     .module('arboWeb')
//     .controller('propostaContrapropostaController', propostaContrapropostaController)
//     .controller('propostaComfirmaController', propostaComfirmaController)
//     .controller('propostaAnexosController', propostaAnexosController)
//     .controller('propostaConjuntaController', propostaConjuntaController)

//   /* @ngInject */
//   function propostaContrapropostaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, Imovel, FileUploader) {
//     var vm = this,
//       propostaData = currentProposta;
//     vm.sucesso = false;
//     vm.resend = (propostaData['propt_contrap_valor'] || propostaData['propt_contrap_just']) ? true : false;
    
//     if (propostaData) {
//       vm.prop_valor = propostaData.propt_valor;
//     }

//     var e = atob(atob($stateParams.e)).split('&');
//     if(e.length && e.length == 2){
//       propostaData['pst_id'] = e[0];
//       propostaData['altBy'] = e[1];
//     }else{
//       $state.go('main.proposta.form')
//     }

//     vm.submit = function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       propostaData['propt_contrap_valor'] = vm.data.valor;
//       propostaData['propt_contrap_just'] = vm.data.justificativa;
//       delete propostaData['propPartes']
//       propostaData.$saveSite()
//         .then(function (succ) {
//           vm.sucesso = true;
//         }, function (err) {
//           console.log(err);
//         })
//     }
//   }

//   /* @ngInject */
//   function propostaComfirmaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, Imovel, FileUploader) {
//     var vm = this;
//     vm.sucesso = currentProposta;
//   }

//   /* @ngInject */
//   function propostaAnexosController($rootScope, $scope, $state, $q, $location, $http, $window, swangular, PropostaTipoAnexo, SERVER_URL, DOC_FILTER, SIZE_FILTER, textFormatter, $stateParams, auth, currentProposta, Imovel, FileUploader) {
//     var vm = this,
//       propostaData = currentProposta;
    
//     vm.success = false;

//     var e = atob(atob($stateParams.e)).split('&');
//     if(e.length && e.length == 2){
//       propostaData['pst_id'] = e[0];
//       propostaData['altBy'] = e[1];
//     }else{
//       $state.go('main.proposta.form')
//     }

//     function init(){
//       var header = $('#header');
//       !(header.is('fixed-theme')) ? header.addClass('fixed-theme'): null;
//       PropostaTipoAnexo.getTipoAnexos({
//         imob: propostaData.imb_id,
//         modalidade : propostaData.tnmod_id
//       })
//       .$promise.then(function(succ){
//         $scope.uploaderFile = []
//         succ.forEach(function(el) {
//           $scope.uploaderFile.push(createUploader(el.id));
//         });
//         vm.inputFiles = succ;
//       }, function(err){
//         console.log(err);
//       })
//       console.log(currentProposta);
//     }

//     function createUploader(idItem){
//       var urlUpload = SERVER_URL + 'api/upload/proposta-doc'+ propostaData.id + '--' + propostaData.hash +'/upload?e='+propostaData['altBy']
//       var uploader = null
//       // $scope.uploaderFile = $scope.uploaderImg =  new FileUploader({
//       uploader = new FileUploader({
//         scope: $scope, // to automatically update the html. Default: $rootScope
//         url: urlUpload,
//         queueLimit: 1,
//         autoUpload: true,
//         formData: [{
//           key: 'value'
//         }]
//       });

//       uploader.filters.push(DOC_FILTER);
//       uploader.filters.push(SIZE_FILTER);

//       // Renomeando a imagem
//       uploader.onAfterAddingFile = function (item) {
//         // Changing img name
//         // var fileExtension = '.' + item.file.name.split('.').pop();
//         item.file.name = idItem + '__' + new Date().getTime() + item.file.name;
//         console.info('Name afterAdding: ', item);
//       }
//       uploader.onBeforeUploadItem = function(item) {
//         debugger;
//         console.info('onBeforeUploadItem', item);
//       };

//       // Erro ao tentar adicionar Arquivos fora dos filtros
//       uploader.onWhenAddingFileFailed = function(item, filter, options) {
//           // console.info('onWhenAddingFileFailed', item, filter, options);
//           var textSW;
//           console.log(filter);
          
//           if(filter.name == 'sizeFilter'){
//             textSW = 'Por favor, escolha imagens de até 5MB';
//           }else if(filter.name == 'docFilter'){
//             textSW = 'Por favor, escolha somente arquivos pdf ou imagem';
//           }else if(filter.name == 'queueLimit'){
//             textSW = 'Só é permitido o upload de um arquivo';
//           }else{
//             textSW = 'Aconteceu algum erro ao fazer upload';            
//           }
//           swangular.swal({
//             type: 'error',
//             animation: false,
//             title: '',
//             html: '<h3>'+textSW+'</h3>',
//             confirmButtonClass: 'btn button btn-default px-5',
//             buttonsStyling: false,
//             timer: 2500
//           })
//       };

//       // Erro na Hora de fazer upload da Image
//       uploader.onErrorItem = function(fileItem, response, status, headers) {
//         console.info('onErrorItem', fileItem, response, status, headers);
//       };

//       // Fim do Upload
//       uploader.onCompleteAll = function () {

//       }

//       return uploader;
//     }
    
//     init();

//   }

//   /* @ngInject */
//   function propostaConjuntaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, swangular, Imovel, FileUploader) {
//     var vm = this,
//       propostaData = currentProposta;
//     vm.sucesso = false;
//     vm.resend = (propostaData['propt_contrap_valor'] || propostaData['propt_contrap_just']) ? true : false;
//     vm.urlSite = $rootScope.ConfigWhiteLabel.url_site.replace('http://', '').replace('https://', '');
//     vm.imovel = propostaData.imv_id;
//     if (propostaData) {
//       vm.prop_valor = propostaData.propt_valor;
//     }

//     vm.submit = function (e) {
//       e.preventDefault();
//       e.stopPropagation();
      
//       // propostaData['propPartes'] = [];
//       propostaData['propPartes'].push({
//         ptpart_id: 2, // Tipo locatario
//         ppart_nome: vm.parte['name'],
//         ppart_email: vm.parte['email'],
//         ppart_tel: vm.parte['phone'],
//         ppart_rg: vm.parte['docRG'],
//         ppart_document: vm.parte['docCPF'],
//         ppart_nacionalidade: vm.parte['nationality'],
//         ppart_profissao: vm.parte['professional'],

//       });

//       propostaData.$saveSite()
//         .then(function (succ) {
//           vm.sucesso = true;
//           swangular.swal({
//             type: 'info',
//             animation: false,
//             title: '',
//             html: '<h3>Seu cadastro foi adicionado a proposta</h3>',
//             confirmButtonClass: 'btn button btn-default px-5',
//             buttonsStyling: false,
//             timer: 1500
//           }).then(function(succ){
//             $state.go('main.home');
//           })
//         }, function (err) {
//           console.log(err);
//         })
//     }
//   }
  
// })();

(function () {
  ('use strict');

  angular.module('arboWeb').service('seoService', SeoService);

  function SeoService(ngMeta, $rootScope, $location, FACEBOOK_APP_ID) {
    var vm = this;

    vm.generateTags = generateTags;
    vm.ldJJsonImovel = ldJJsonImovel;
    vm.ldJsonHome = ldJsonHome;
    vm.ldJsonBreadCrumb = ldJsonBreadCrumb;
    vm.ldJsonPlace = ldJsonPlace;
    vm.ldJsonPlaceImv = ldJsonPlaceImv;
    vm.ldJsonBairroBar = ldJsonBairroBar;
    vm.ldJsonBairroRestaurante = ldJsonBairroRestaurante;
    vm.ldJsonFaleConosco = ldJsonFaleConosco;

    /**
     * Converte uma URL e adiciona o HTTPS nela
     * alert(setHttp("www.google.com"));
       alert(setHttp("http://www.google.com/")); 
    * @param {String} link link sem ou com http
    * @returns 
    */
    function setHttp(link){
      if (link.search(/^http[s]?\:\/\//) == -1) {
        link = 'https://' + link
      }
      return link
    }


    function generateTags(config) {
      var config_ = {
        title: 'Arbo Imóveis',
        description:
          'A Arbo é um dos maiores grupos imobiliários do Brasil. Confira milhares de casas, apartamentos e imóveis comerciais para vender e alugar em diversas cidades do país.',
        image:
          'https://www.arboimoveis.com.br/assets/images/novosite/arbo_verde.png',
        slug: '',
        canonical: null,
      };
      var arbokey =
        'imobiliária digital gestão de leads corretor de imóveis CRM imobiliário alugar comprar vender imóvel administração da locação site imobiliário incorporadoras apartamento alugar apartamento alto padrão casa em condomínio aluguel sem fiador Londrina São Paulo SP Balneário Camboriú BC Curitiba cwb Maringá';
      var wlkey =
        'imobiliária em ' +
        $rootScope.ConfigWhiteLabel.cidade +
        ' ' +
        $rootScope.ConfigWhiteLabel.nome +
        ' digital comprar apartamento alugar apartamento casa em condomínio aluguel sem fiador portal imobiliário apartamento alto padrão vender imóvel';
      var keywords = $rootScope.ConfigWhiteLabel.isArbo ? arbokey : wlkey;
      config = Object.assign({}, config_, config || {});
      config.canonical = config.canonical || config.slug;
      
      // garate o protocolo 
      config.canonical = setHttp(config.canonical);

      ngMeta.setTitle(config.title);
      ngMeta.setTag('twitter:card', 'summary');
      ngMeta.setTag('twitter:site', 'arboimoveis');
      ngMeta.setTag('twitter:title', config.title);
      ngMeta.setTag('twitter:description', config.description);
      ngMeta.setTag('twitter:image', config.image);

      ngMeta.setTag('application-name', $rootScope.ConfigWhiteLabel.nome);
      ngMeta.setTag('type', 'website');
      ngMeta.setTag('image', config.image);
      ngMeta.setTag('description', config.description);
      ngMeta.setTag('keywords', keywords);

      ngMeta.setTag('og:type', 'website');
      ngMeta.setTag('og:site_name', 'arboimoveis');
      ngMeta.setTag('og:title', config.title);
      ngMeta.setTag('og:description', config.description);
      ngMeta.setTag('og:image:url', config.image);
      ngMeta.setTag('og:image:width', 640);
      ngMeta.setTag('og:image:height ', 640);
      ngMeta.setTag('og:url', config.canonical);
      ngMeta.setTag('canonical', config.canonical);

      if (config.noindex) {
        angular
          .element('head')
          .append(angular.element('<meta name="robots" content="noindex" />'));
      } else {
        angular.element('meta[content="noindex"]').remove();
      }

      if (config.next) {
        angular
          .element('head')
          .append(
            angular.element('<link rel="next" href="' + config.next + '"/>')
          );
      } else {
        angular.element('link[rel="next"]').remove();
      }

      if (config.prev) {
        angular
          .element('head')
          .append(
            angular.element('<link rel="prev" href="' + config.prev + '"/>')
          );
      } else {
        angular.element('link[rel="prev"]').remove();
      }

      if (config.amphtml) {
        angular
          .element('head')
          .append(
            angular.element(
              '<link rel="amphtml" href="' + config.amphtml + '"/>'
            )
          );
      } else {
        angular.element('link[rel="amphtml"]').remove();
      }

      ngMeta.setTag('fb:app_id', FACEBOOK_APP_ID);
      // Google PageView
      // gtag('config', 'UA-91552221-1', {
      //   page_title: config.title,
      //   page_location: $location.absUrl(),
      //   page_path: $location.path(),
      // });
      if (typeof window.ga == 'function') {
        ga('send', 'pageview', {
          page_title: config.title,
          page_location: $location.absUrl(),
          page_path: $location.path(),
        });
      }
    }

    function ldJJsonImovel(imovel, url) {
      angular.element('#jsonLd').remove();

      var nome = $rootScope.ConfigWhiteLabel.nome;
      imovel.vetorImages = imovel.fotos.map(function (foto) {
        return foto.imvft_url;
      });

      ParseAcommodation(imovel, url);

      // ParseProduct(imovel, url);

      ParsePlace(imovel);
    }
    function ldJsonHome() {
      angular.element('#jsonLd').remove();
      var jsonLd = {
        '@id': 'Arbo Imóveis',
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Arbo Imóveis',
        description:
          'Encontre seu novo lar através das imobiliárias que anunciam no site Arbo. Utilize filtros e encontre os melhores imóveis, preços e regiões. Soluções Imobiliárias.',
        address: {
          '@type': 'PostalAddress',
          addressCountry: {
            '@type': 'Country',
            name: 'BR',
          },
          addressLocality: 'Londrina',
          addressRegion: 'PR',
          postalCode: '86050-435',
          streetAddress: 'R. Bento Munhoz da Rocha Neto, 685 - Jardim do Lago, Londrina - PR',
        },
        brand: {
          '@type': 'Brand',
          logo: '',
        },
        telephone: '+55 4003-3793',
        URL: 'https://www.arboimoveis.com.br/',
      };

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonLd');
      scriptTag.append(JSON.stringify(jsonLd));
      angular.element('head').append(scriptTag);
    }

    function ldJsonBreadCrumb(vm) {
      angular.element('#jsonld').remove();
      if (!vm) return '';

      var jsonBreadCrumb = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Arbo Imóveis',
            item: {
              '@id': 'https://www.arboimoveis.com.br',
            },
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Imóveis',
            item: {
              '@id': 'https://www.arboimoveis.com.br/imoveis/',
            },
          },
          {
            '@type': 'ListItem',
            position: 3,
            name:
              vm.proximidades.brr_cidade + ', ' + vm.proximidades.brr_estado,
            item: {
              '@id':
                'https://www.arboimoveis.com.br/imoveis/a-venda/' +
                vm.proximidades.brr_cidade +
                '-' +
                vm.proximidades.brr_estado,
            },
          },
          {
            '@type': 'ListItem',
            position: 4,
            name: vm.proximidades.brr_nome,
            item: {
              '@id':
                'https://www.arboimoveis.com.br/imoveis/a-venda/' +
                vm.proximidades.brr_nome +
                '-' +
                vm.proximidades.brr_cidade +
                '-' +
                vm.proximidades.brr_estado,
            },
          },
        ],
      };

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonLdBreadCrumb');
      scriptTag.append(JSON.stringify(jsonBreadCrumb));
      angular.element('head').append(scriptTag);
      return jsonBreadCrumb;
    }
    function ldJsonPlace(vm) {
      angular.element('#jsonld').remove();
      if (!vm) return '';
      var prox = vm.proximidades;
      var jsonPlace = {
        '@context': 'https://schema.org',
        '@type': 'Place',
        name: prox.brr_nome,
        geo: {
          '@type': 'GeoCoordinates',
          latitude: prox.brr_location.lat,
          longitude: prox.brr_location.lng,
          address: {
            '@type': 'PostalAddress',
            addressLocality: prox.brr_cidade,
            addressRegion: prox.brr_estado,
            addressCountry: 'BR',
          },
        },
      };

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonLdPlace');
      scriptTag.append(JSON.stringify(jsonPlace));
      angular.element('head').append(scriptTag);
      return jsonPlace;
    }
    function ldJsonBairroRestaurante(vm) {
      if (!vm) return '';

      var configs = vm.proximidades.brr_configs;

      var restaurantes = configs.restaurant ? configs.restaurant : [];
      var bares = configs.bar ? configs.bar : [];
      var jsons = restaurantes
        .concat(bares)
        .filter(function (el) {
          return el.user_ratings_total;
        })
        .map(function (r) {
          var jsonBairroRestaurante = {
            '@context': 'http://schema.org/',
            '@type': 'Restaurant',
            name: r.name,
            acceptsReservations: 'Yes',
            menu: '',
            servesCuisine: '',
            priceRange: '$$',
            address: {
              '@type': 'PostalAddress',
              streetAddress: r.endereco,
              addressLocality: vm.proximidades.brr_cidade,
              addressRegion: vm.proximidades.brr_estado,
              postalCode: '',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: r.rating,
              ratingCount: r.user_ratings_total,
            },
            image:
              r.photos && r.photos.length && r.photos[0].url
                ? r.photos[0].url
                : 'https://www.arboimoveis.com.br/assets/images/novosite/sem-foto-locais.jpg',
            telephone: '',
          };
          return jsonBairroRestaurante;
        });

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonLdRestaurante');
      scriptTag.append(JSON.stringify(jsons));
      angular.element('head').append(scriptTag);
    }

    function ldJsonBairroBar(vm) {
      if (!vm) return;
      // var bares = vm.proximidades.brr_configs.bar;
      // var jsons = bares
      // 	.filter(function (el) {
      // 		return el.user_ratings_total;
      // 	})
      // 	.map(function (b) {
      // 		var jsonBairroBar = {
      // 			'@context': 'https://schema.org/',
      // 			'@type': 'Bar',
      // 			'name': b.name,
      // 			'datePublished': '2018-03-10',
      // 			'aggregateRating': {
      // 				'@type': 'AggregateRating',
      // 				'ratingValue': b.rating,
      // 				'ratingCount': b.user_ratings_total,
      // 				'itemReviewed': {
      //           "@context": "https://schema.org/",
      //           "@type": "Thing",
      //           "name": "Schema.org Ontology",
      //           "subjectOf": {
      //             "@type": "Book",
      //             "name": "The Complete History of Schema.org"
      //           }
      //         },
      // 			},
      // 			'address': {
      // 				'@type': 'PostalAddress',
      // 				'streetAddress': b.endereco,
      // 				'addressLocality': vm.proximidades.brr_cidade,
      // 				'addressRegion': vm.proximidades.brr_estado,
      // 				'postalCode': '',
      // 			},
      // 		};
      // 		return jsonBairroBar;
      // 	});

      // var scriptTag = angular.element('<script>');
      // scriptTag.attr('type', 'application/ld+json');
      // scriptTag.attr('id', 'jsonLdBar');
      // scriptTag.append(JSON.stringify(jsons));
      // angular.element('head').append(scriptTag);
    }
    function ldJsonFaleConosco(subOrganization) {
      angular.element('#jsonLd').remove();
      // angular.element('#orgArbo').remove();
      angular.element('#faleJsonLd').remove();
      var jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Arbo Imóveis',
        description:
          'A Arbo é um dos maiores grupos imobiliários do Brasil. Confira milhares de casas, apartamentos e imóveis comerciais para vender e alugar em diversas cidades do país.',

        address: {
          '@type': 'PostalAddress',
          addressCountry: {
            '@type': 'Country',
            name: 'BR',
          },
          addressLocality: 'Londrina',
          addressRegion: 'PR',
          postalCode: '86050-460',
          streetAddress:
            'Palhano Business Center - Torre 2, Av. Ayrton Senna da Silva, 200 - 1109 - Gleba Fazenda Palhano, Londrina - PR',
        },

        brand: {
          '@type': 'Brand',
          logo: '',
        },

        telephone: '+55 4003-3793',
        URL: 'https://www.arboimoveis.com.br/',
      };
      if (subOrganization) {
        jsonLd['subOrganization'] = {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: subOrganization.nome,
          description: subOrganization.nome,

          address: {
            '@type': 'PostalAddress',
            addressCountry: {
              '@type': 'Country',
              name: 'BR',
            },
            addressLocality: subOrganization.estado,
            streetAddress: subOrganization.endereco,
          },
          URL: subOrganization.site,
        };
      }

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'faleJsonLd');
      scriptTag.append(JSON.stringify(jsonLd));
      angular.element('head').append(scriptTag);
    }

    // ### func privadas ###

    // PARSE
    function ParsePlace(imovel) {
      var jsonPlace;
      var configPlace = {
        name: imovel.imv_titulo,
        lat: imovel.imv_latitude,
        long: imovel.imv_longitude,
        address: imovel.imv_endereco,
        city: imovel.imv_cidade,
        state: imovel.imv_estado,
        country: imovel.imv_pais,
      };

      jsonPlace = ldJsonPlaceImv(configPlace);

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonld');
      scriptTag.append(JSON.stringify(jsonPlace));
      angular.element('head').append(scriptTag);
    }
    function ParseProduct(imovel, url) {
      var jsonProduct;
      var configProduct = {
        name: imovel.imv_titulo,
        image: imovel.fotos[0],
      };
      if (!!imovel.imv_preco_venda && !!imovel.imv_preco_locacao) {
        url = url.replace('para-alugar/', '');
        url = url.replace('a-venda/', '');
        var vet = url.split('/');
        vet.splice(4, 0, 'a-venda');
        var compra = vet.join('/');
        vet.splice(4, 1, 'para-alugar');
        var loca = vet.join('/');
        var offer = {
          '@type': 'AggregateOffer',
          highPrice: imovel.imv_preco_venda,
          lowPrice: imovel.imv_preco_locacao,
          offers: [
            {
              '@type': 'Offer',
              url: compra,
            },
            {
              '@type': 'Offer',
              url: loca,
            },
          ],
        };
      } else {
        var price = imovel.imv_preco_venda
          ? imovel.imv_preco_venda
          : imovel.imv_preco_locacao;
        var offer = {
          '@type': 'Offer',
          '@context': 'http://schema.org',
          price: price,
          priceCurrency: 'BRL',
          availability: 'http://schema.org/InStock',
          url: url,
        };
      }

      jsonProduct = ldJsonProduct(configProduct, offer);

      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonld');
      scriptTag.append(JSON.stringify(jsonProduct));
      angular.element('head').append(scriptTag);
    }
    function ParseAcommodation(imovel, url) {
      var jsonAccomodation;
      var nome = $rootScope.ConfigWhiteLabel.nome;
      var configAcomodation = {
        name: imovel.imv_titulo + ' - ' + nome,
        vetorImages: imovel.vetorImages,
        description: imovel.imv_obs,
        floorSize: imovel.imv_area_util,
        address: imovel.imv_endereco,
        url: url,
      };
      if (
        imovel.timv_id === 3 ||
        imovel.timv_id === 2 ||
        imovel.timv_id === 1 ||
        imovel.timv_id === 10 ||
        imovel.timv_id === 11 ||
        imovel.timv_id === 13 ||
        imovel.timv_id === 9 ||
        imovel.timv_id === 12 ||
        imovel.timv_id === 23 ||
        imovel.timv_id === 24 ||
        imovel.timv_id === 25
      ) {
        configAcomodation.numberOfRooms = imovel.imv_qtd_dorm;
        if (
          imovel.timv_id === 3 ||
          imovel.timv_id === 2 ||
          imovel.timv_id === 9 ||
          imovel.timv_id === 12
        ) {
          configAcomodation.house = true;
        } else {
          configAcomodation.house = false;
        }
        jsonAccomodation = ldJsonAccomodationPlus(configAcomodation);
      } else {
        jsonAccomodation = ldJsonAccomodation(configAcomodation);
      }
      var scriptTag = angular.element('<script>');
      scriptTag.attr('type', 'application/ld+json');
      scriptTag.attr('id', 'jsonld');
      scriptTag.append(JSON.stringify(jsonAccomodation));
      angular.element('head').append(scriptTag);
    }
    // JSON
    function ldJsonAccomodation(accomodation) {
      var json = {
        '@context': 'http://schema.org/',
        '@type': 'Accommodation',
        image: accomodation.vetorImages,
        name: accomodation.name,
        description: accomodation.description,
        numberOfRooms: accomodation.rooms,
        floorSize: accomodation.size,
        address: accomodation.address,
        url: accomodation.url,
      };
      return json;
    }
    function ldJsonAccomodationPlus(accomodation) {
      var json = {
        '@context': 'http://schema.org/',
        '@type': accomodation.house ? 'House' : 'Apartment',
        image: accomodation.vetorImages,
        name: accomodation.name,
        description: accomodation.description,
        numberOfRooms: accomodation.rooms,
        floorSize: accomodation.size,
        address: accomodation.address,
        url: accomodation.url,
      };
      return json;
    }
    function ldJsonProduct(product, offer) {
      var json = {
        '@type': 'Product',
        '@context': 'http://schema.org',
        offers: offer,
        name: product.name,
        image: product.image,
      };
      return json;
    }
    function ldJsonPlaceImv(place) {
      var json = {
        '@context': 'http://schema.org',
        '@type': 'Place',
        name: place.name,
        geo: {
          '@type': 'GeoCoordinates',
          latitude: place.lat,
          longitude: place.long,
        },
        address: {
          '@type': 'PostalAddress',
          streetAddress: place.address,
          addressLocality: place.city,
          addressRegion: place.state,
          addressCountry: place.country,
        },
      };
      return json;
    }
  }
})();

(function () {
	'use strict';

	angular.module('arboWeb').controller('propostaController', propostaController);

	/* @ngInject */
	function propostaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, toastr, textFormatter, $stateParams, auth, Usuario, viaCEP, Imovel, EstadoCivil, FileUploader, swangular, Proposta, LogErrorProposta) {
		var vm = this;
		var imobiliaria = $rootScope.ConfigWhiteLabel;
		var etapa = localStorage.getItem('step-proposta-locacao') || 1;
		vm.proposta = localStorage.getItem('proposta-locacao') || {};

		if (vm.data.tnmod_id === undefined) {
			vm.data.tnmod_id = 6;
		}

		vm.corretorRead = !!$stateParams.i;
		vm.imovelRead = !!$stateParams.ii;

		vm.imoveis = {};
		vm.data = {
			parte: [],
			descricao: {},
		};

		if (vm.proposta && vm.proposta.pessoal) {
			vm.data.parte[0] = vm.proposta.pessoal.parte0;
			vm.data.parte[1] = vm.proposta.pessoal.parte1;
			vm.address = vm.proposta.pessoal.endereco;
			vm.data.phone = vm.proposta.pessoal.telefone;
			vm.data.email = vm.proposta.pessoal.email;
			vm.data.name = vm.proposta.pessoal.name;
		}

		if (vm.proposta && vm.proposta.negocio) {
			vm.data.corretor = vm.proposta.negocio.corretor;
			(vm.data.tnmod_id = vm.proposta.negocio.tnmod_id), (vm.data.cod_imovel = vm.proposta.negocio.cod_imovel);
			vm.data.priceLocacao = vm.proposta.negocio.preco;
			vm.data.addConditions = vm.proposta.negocio.condicoes;
			switch (vm.data.tnmod_id) {
				case 7:
					vm.data.descricao.permuta_carro = vm.proposta.negocio.permuta_carro;
					vm.data.descricao.permuta_imovel = vm.proposta.negocio.permuta_imovel;
					vm.data.descricao.permuta_outro = vm.proposta.negocio.permuta_outro;
					break;

				case 8:
					if (vm.proposta.negocio.caixa) {
						vm.data.descricao.caixa = vm.proposta.negocio.caixa;
					}
					if (vm.proposta.negocio.bb) {
						vm.data.descricao.bb = vm.proposta.negocio.bb;
					}
					if (vm.proposta.negocio.santander) {
						vm.data.descricao.santander = vm.proposta.negocio.santander;
					}
					if (vm.proposta.negocio.itau) {
						vm.data.descricao.itau = vm.proposta.negocio.itau;
					}
					if (vm.proposta.negocio.bradesco) {
						vm.data.descricao.bradesco = vm.proposta.negocio.bradesco;
					}
					if (vm.proposta.negocio.banco_outros) {
						vm.data.descricao.banco_outros = vm.proposta.negocio.banco_outros;
					}
					vm.data.descricao.banco_agencia = vm.proposta.negocio.banco_agencia;
					vm.data.descricao.financiamento_valor = vm.proposta.negocio.financiamento_valor;
					break;

				case 9:
					vm.data.descricao.consorcio_valor = vm.proposta.negocio.consorcio_valor;
					vm.data.descricao.consorciadora = vm.proposta.negocio.consorciadora;
					break;

				case 10:
					vm.data.descricao.outros_descreva = vm.proposta.negocio.outros_descreva;
					break;
				default:
					break;
			}
		}

		vm.pessoais = function (e, data) {
			e.preventDefault();

			if (vm.proposta.perfil == false && vm.data.parte[0] && (!vm.data.parte[0].estadocivil || !vm.data.parte[0].estadocivil.id)) {
				data['form-civil'].$setValidity('autcmplt', false);
				var ele = document.getElementById('form-civil');
				vm.subterror = true;
				ele.focus();
			} else if (angular.equals({}, data.$error)) {
				vm.proposta.pessoal = {
					name: vm.data.name,
					email: vm.data.email,
					telefone: vm.data.phone,
					parte0: vm.data.parte[0],
					parte1: vm.data.parte[1],
					endereco: vm.address,
				};
				vm.proposta.pessoal.parte0.phone = vm.proposta.pessoal.telefone;
				vm.proposta.pessoal.parte0.accept_whats = vm.proposta.negocio.accept_whats;
				vm.proposta.pessoal.parte0.endereco = vm.address;
				vm.proposta.pessoal.parte0.name = vm.data.name;
				vm.proposta.pessoal.parte0.email = vm.data.email;

				localStorage.setItem('proposta-locacao ', JSON.stringify(vm.proposta));
				nextStep();
				return;
			} else {
				vm.subterror = true;
				angular.element('input.ng-invalid').first().focus();
			}
		};

		vm.negocio = function (e, data) {
			e.preventDefault();
			if (!vm.data.corretor || !vm.data.corretor.id) {
				data['form-corretor'].$setValidity('autcmplt', false);
				var ele = document.getElementById('form-corretor');
				vm.subterror = true;
				ele.focus();
			} else if (!vm.data.cod_imovel || !vm.data.cod_imovel.id) {
				data['form-codimvoel'].$setValidity('autcmplt', false);
				var ele = document.getElementById('form-codimvoel');
				vm.subterror = true;
				ele.focus();
			} else if (angular.equals({}, data.$error)) {
				vm.proposta.negocio = {
					corretor: vm.data.corretor,
					tnmod_id: vm.data.tnmod_id,
					cod_imovel: vm.data.cod_imovel,
					preco: vm.data.priceLocacao,
					condicoes: vm.data.addConditions,
					accept_whats: vm.data.accept_whats,
				};
				switch (vm.data.tnmod_id) {
					case 7:
						vm.proposta.negocio.permuta_carro = vm.data.descricao.permuta_carro;
						vm.proposta.negocio.permuta_imovel = vm.data.descricao.permuta_imovel;
						vm.proposta.negocio.permuta_outro = vm.data.descricao.permuta_outro;
						break;

					case 8:
						if (vm.data.descricao.caixa) {
							vm.proposta.negocio.caixa = vm.data.descricao.caixa;
						}
						if (vm.data.descricao.bb) {
							vm.proposta.negocio.bb = vm.data.descricao.bb;
						}
						if (vm.data.descricao.santander) {
							vm.proposta.negocio.santander = vm.data.descricao.santander;
						}
						if (vm.data.descricao.itau) {
							vm.proposta.negocio.itau = vm.data.descricao.itau;
						}
						if (vm.data.descricao.bradesco) {
							vm.proposta.negocio.bradesco = vm.proposta.negocio.bradesco;
						}
						if (vm.data.descricao.banco_outros) {
							vm.proposta.negocio.banco_outros = vm.data.descricao.banco_outros;
						}
						vm.proposta.negocio.banco_agencia = vm.data.descricao.banco_agencia;
						vm.proposta.negocio.financiamento_valor = vm.data.descricao.financiamento_valor;
						break;

					case 9:
						vm.proposta.negocio.consorcio_valor = vm.data.descricao.consorcio_valor;
						vm.proposta.negocio.consorciadora = vm.data.descricao.consorciadora;
						break;

					case 10:
						vm.proposta.negocio.outros_descreva = vm.data.descricao.outros_descreva;
						break;
					default:
						break;
				}
				vm.proposta.pessoal = {
					parte0: vm.data.parte[0],
				};
				localStorage.setItem('proposta-locacao ', JSON.stringify(vm.proposta));
				nextStep();
				return;
			} else {
				vm.subterror = true;
				angular.element('input.ng-invalid').first().focus();
			}
		};

		vm.enviar = function (e, data) {
			vm.proposta = JSON.parse(localStorage.getItem('proposta-locacao '));
			var descricao;
			switch (vm.proposta.negocio.tnmod_id) {
				case 6:
					// descricao = { valor_proposta: desc.valor_proposta_6 }
					descricao = {
						modalidade: 'à vista',
					};
					break;
				case 7:
					descricao = {
						permuta:
							(!!vm.proposta.negocio.permuta_carro ? '\ncarro - ' + vm.proposta.negocio.permuta_carro : '') +
							(!!vm.proposta.negocio.permuta_imovel ? '\nImovel - ' + vm.proposta.negocio.permuta_imovel : '') +
							(!!vm.proposta.negocio.permuta_outro ? '\nOutro - ' + vm.proposta.negocio.permuta_outro : ''),
					};
					break;
				case 8:
					descricao = {
						valor: vm.proposta.negocio.financiamento_valor,
						banco: !!vm.proposta.negocio.caixa ? 'caixa - ' : !!vm.proposta.negocio.bb ? 'banco do brasil - ' : !!vm.proposta.negocio.santander ? 'santander - ' : !!vm.proposta.negocio.itau ? 'itau - ' : !!vm.proposta.negocio.bradesco ? 'bradesco - ' : vm.proposta.negocio.banco_outros,
						agencia: vm.proposta.negocio.banco_agencia,
					};

					break;
				case 9:
					descricao = {
						valor: vm.proposta.negocio.consorcio_valor,
						consorciadora: vm.proposta.negocio.consorciadora,
					};
					break;
				case 10:
					descricao = {descricao: vm.proposta.negocio.outros_descreva};
					break;
			}
			Proposta.newProposta({
				imobiliaria: vm.proposta.negocio.cod_imovel.imb_id,
				corretor: vm.proposta.negocio.corretor.id,
				modalidade: vm.proposta.negocio.tnmod_id,
				descricao: descricao,
				imovel: vm.proposta.negocio.cod_imovel.id,
				parte0: vm.proposta.pessoal.parte0,
				parte1: vm.proposta.pessoal.parte1,
				tipo: 'venda',
				perfil: vm.proposta.perfil,
				preco: vm.proposta.negocio.preco,
				condicoes: vm.proposta.negocio.condicoes,
			}).$promise.then(
				function (succ) {
					localStorage.setItem('propv-form', btoa(succ.id));
					var hash = [];
					if (localStorage.getItem('propv-hash')) {
						hash = JSON.parse(localStorage.getItem('propv-hash'));
					}
					var hashProposta = succ.__data.propt_hash;
					hash.unshift(hashProposta);
					localStorage.setItem('propv-hash', JSON.stringify(hash));
					vm.urlshare = 'http://' + $rootScope.ConfigWhiteLabel.url_site.replace('http://', '').replace('https://', '') + '/proposta-locacao/' + hashProposta + '/locacao-conjunta';
					var promise = crudGet();
					promise.then(
						function (greeting) {
							console.log('Load: Proposta');
							nextStep();
						},
						function (reason) {
							console.log('Error: Proposta');
						}
					);
				},
				function (err) {
					swangular.swal({
						type: 'error',
						title: err.data.error.message,
						html: 'Por favor contate o suporte!',
						confirmButtonClass: 'btn button btn-default px-5',
						buttonsStyling: false,
					});
					LogErrorProposta.create({
						lerrp_dados: vm.data,
						lerrp_erro: err.data.error,
					});
					console.log('Error: ', err);
				}
			);

			localStorage.removeItem('proposta-locacao ');
			localStorage.removeItem('step-proposta-locacao');
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			// e.preventDefault();
			// nextStep();
			return;
		};

		vm.formproposta = {};
    vm.setperfil = {};

    vm.checkStep = function (e) {
			if (etapa == e) {
				return true;
			}
			return false;
		};

		function nextStep(e) {
			etapa = e || +etapa + 1;
			if (etapa > 5) etapa = 1;
			localStorage.setItem('step-proposta-locacao', etapa);
			vm.subterror = false;
			document.body.scrollTop = document.documentElement.scrollTop = 0;
			return;
		}

		vm.setperfil = function (e) {
			switch (e) {
				case 'juridico':
					vm.proposta.perfil = true;
					break;
				default:
					vm.proposta.perfil = false;
					break;
			}
			localStorage.setItem('proposta-locacao ', JSON.stringify(vm.proposta));
			nextStep();
		};

		vm.finishProposta = finishProposta;
		function finishProposta(e) {
			// localStorage.removeItem('save-profile-form');
			// localStorage.removeItem('step-prop-arbo');
			// localStorage.removeItem('prop-form');
			// localStorage.removeItem('prop-hash');
			// if(e){
			//   setTimeout(function(){
			//     $state.go($state.current.name, {}, {'reload': true});
			//   }, 200)
			// }
		}

		// ----------- NEW ^ ------------------

		// vm.typeProfile = localStorage.getItem('profile-prop-arbo') || 1;
		// vm.copyPaste = copyPaste;

		vm.imoveis = {};
		vm.data = {
			parte: [],
		};
		vm.propostaData = null;

		if (localStorage.getItem('prop-form') && etapa > 2) {
			var promise = crudGet();
			promise.then(
				function (greeting) {
					console.log('Load: Proposta');
				},
				function (reason) {}
			);
		}

		vm.setProfile = function (e) {
			if (e == 1 || e == 2) {
				vm.typeProfile = e;
			} else {
				vm.typeProfile = 1;
			}

			localStorage.setItem('profile-prop-arbo', vm.typeProfile);

			nextStep();
		};

		var autocomplete = null;
		vm.autocomplete = function () {
			if (!vm.data.end_imovel) {
				vm.imoveis = null;
				vm.data.imovelSelect = null;
				return;
			}
			var input = document.getElementById('form-endimovel');

			if (autocomplete == null) {
				var autoCompleteOpcoes = {
					componentRestrictions: {
						country: 'BR',
					},
				};

				autocomplete = new google.maps.places.Autocomplete(input, autoCompleteOpcoes);

				autocomplete.addListener('place_changed', function () {
					console.log(autocomplete);
					vm.data['end_imovel'] = autocomplete.getPlace().formatted_address;
					var location = autocomplete.getPlace().geometry.location;
					var center = {
						lat: location.lat(),
						lng: location.lng(),
					};

					var north_east = {
						lat: location.lat() + 0.008,
						lng: location.lng() + 0.008,
					};

					var south_west = {
						lat: location.lat() - 0.008,
						lng: location.lng() - 0.008,
					};

					Imovel.findByPolygonNew({
						center: center,
						north_east: north_east,
						south_west: south_west,
						tipovar: 'para-alugar',
					}).$promise.then(function (response) {
						var ids = response.map(function (el) {
							return el.id;
						});
						if (ids.length) {
							Imovel.getImoveisNew({
								where: {
									id: {inq: ids},
								},
								limit: 20,
							}).$promise.then(function (response) {
								vm.imoveis = response;
								if (response && response.length) {
									vm.data.imovelSelect = response[0].id;
								} else {
									vm.data.imovelSelect = null;
								}
							});
						}
					});

					// getGeoLocation(vm.search.setFilterForm(event));
				});
			}
		};

		vm.estadoCivil = [
			{'id': 1, 'label': 'Solteiro(a)'},
			{'id': 2, 'label': 'Casado(a)'},
			{'id': 3, 'label': 'Divorciado(a)'},
			{'id': 4, 'label': 'Viúvo(a)'},
			{'id': 5, 'label': 'Separado(a)'},
		];
		vm.valid_cpf = function (cpf) {
			var Soma;
			var Resto;
			var i;
			Soma = 0;
			if (cpf == '00000000000') return false;
			for (i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
			Resto = (Soma * 10) % 11;
			if (Resto == 10 || Resto == 11) Resto = 0;
			if (Resto != parseInt(cpf.substring(9, 10))) return false;
			Soma = 0;
			for (i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
			Resto = (Soma * 10) % 11;
			if (Resto == 10 || Resto == 11) Resto = 0;
			if (Resto != parseInt(cpf.substring(10, 11))) return false;
			return true;
		};
		vm.form = {
			submit_formname: function (e) {
				e.preventDefault();

				if (etapa == 2) {
					if (!vm.data.imovelSelect) {
						swangular.swal({
							type: 'error',
							animation: false,
							title: 'Selecione um imóvel!',
							confirmButtonClass: 'btn button btn-default px-5',
							buttonsStyling: false,
							timer: 2500,
						});
						return false;
					}
					localStorage.setItem('save-profile-form', JSON.stringify(vm.data));
					// nextStep();
					// }else if(etapa == 3){
					// var parte = JSON.parse(localStorage.getItem('save-profile-form'));
					var parte = {};
					parte['name'] = vm.data['name'];
					parte['email'] = vm.data['email'];
					parte['phone'] = vm.data['phone'];
					parte['accept_whats'] = vm.data['accept_whats'];
					parte['endereco'] = vm.data['end_imovel'];
					parte['type'] = vm.data['type'];

					var crt_id = vm.data.corretor ? vm.data.corretor['id'] : null;
					var tnmod_id = vm.data.tnmod_id ? vm.data.tnmod_id['id'] : null;
					
					Proposta.createSite({
						corretor: crt_id,
						modalidade: tnmod_id,
						imovel: vm.data.imovelSelect,
						parte: parte,
						tipo: 'locacao',
					}).$promise.then(
						function (succ) {
							localStorage.setItem('prop-form', btoa(succ.id));
							var hash = [];
							if (localStorage.getItem('prop-hash')) {
								hash = JSON.parse(localStorage.getItem('prop-hash'));
							}
							var hashProposta = succ.__data.propt_hash;
							hash.unshift(hashProposta);
							localStorage.setItem('prop-hash', JSON.stringify(hash));

							var promise = crudGet();
							promise.then(
								function (greeting) {
									console.log('Load: Proposta');
									nextStep();
								},
								function (reason) {
									console.log('Error: Proposta');
								}
							);
						},
						function (err) {
							console.log('Error: ', err);
						}
					);
				} else if (etapa == 3) {
					vm.propostaData['propt_valor'] = parseFloat(vm.data.priceLocacao);
					vm.propostaData['propt_adicionais'] = vm.data.addConditions;
					vm.propostaData['propt_data_pretencao'] = vm.data.dateStart;
					vm.propostaData['propt_dia_pag'] = parseInt(vm.data.datePayment);

					vm.propostaData['pst_id'] = 1;
					vm.propostaData.$saveSite().then(
						function (succ) {
							var promise = crudGet();
							promise.then(
								function (greeting) {
									console.log('Load: Proposta');
									nextStep();
								},
								function (reason) {
									console.log('Error: Proposta');
								}
							);
						},
						function (err) {
							console.log('Error: ', err);
						}
					);
				} else if (etapa == 4) {
					var parteInit = JSON.parse(localStorage.getItem('save-profile-form'));

					if (!vm.propostaData.propPartes) {
						vm.propostaData.propPartes = [];
					}

					for (var i = 0; i < vm.data.parte.length; ++i) {
						if (!vm.data.parte[i]['docCPF'] || !vm.valid_cpf(vm.data.parte[i]['docCPF'])) {
							swangular.swal({
								type: 'error',
								animation: false,
								title: 'CPF inválido',
								confirmButtonClass: 'btn button btn-default px-5',
								buttonsStyling: false,
								timer: 2500,
							});
							return false;
						}
						var parte = {};
						for (var index = 0; index < vm.propostaData.propPartes.length; index++) {
							if (vm.propostaData.propPartes[index]['ptpart_id'] == vm.data.parte[i]['type']) {
								parte = vm.propostaData.propPartes[index];
								parte['index'] = index;
							}
						}
						// if(!vm.propostaData.propPartes[i] || vm.propostaData.propPartes[i] == undefined){
						//   vm.propostaData.propPartes[i] = {}
						// }
						if (vm.typeProfile == 1) {
							parte['ptpart_id'] = vm.data.parte[i]['type'];

							// parte['ppart_nome']        = vm.data.parte[i]['name'] || parteInit['name'];

							parte['ppart_document'] = vm.data.parte[i]['docCPF'];
							parte['ppart_rg'] = vm.data.parte[i]['docRG'].replace(/\D/g, '');
							parte['ppart_data_nasc'] = vm.data.parte[i]['birthday'];
							parte['ppart_nacionalidade'] = (vm.data.parte[i]['nationality'] || '').toLowerCase();
							parte['ppart_profissao'] = (vm.data.parte[i]['professional'] || '').toLowerCase();

							if (vm.data.parte[i]['type'] == 2) {
								parte['ppart_estado_civil'] = vm.data.parte[i]['estadocivil']['label'];
								parte['ppart_imposto_renda'] = vm.data.parte[i]['imprenda'];

								parte['ppart_renda_mensal'] = vm.data.parte[i]['renda'];

								// Address
								parte['ppart_end_logradouro'] = vm.address['end_logradouro'];
								parte['ppart_end_numero'] = vm.address['end_numero'];
								parte['ppart_end_complemento'] = vm.address['end_complemento'];
								parte['ppart_end_bairro'] = vm.address['end_bairro'];
								parte['ppart_end_cep'] = vm.address['end_cep'];
								parte['ppart_end_cidade'] = vm.address['end_cidade'];
								parte['ppart_end_estado'] = vm.address['end_estado'];
								parte['ppart_end_pais'] = vm.address['end_pais'];
							}
						} else if (vm.typeProfile == 2) {
							parte['ptpart_id'] = vm.data.parte[i]['type'];

							parte['ppart_nome'] = vm.data.parte[i]['name'] || parteInit['name'];

							parte['ppart_document'] = vm.data.parte[i]['docCNPJ'] || vm.data.parte[i]['docCPF'];
							parte['ppart_ie'] = (vm.data.parte[i]['docIE'] || vm.data.parte[i]['docRG']).replace(/\D/g, '');

							if (vm.data.parte[i]['action']) {
								parte['ppart_profissao'] = vm.data.parte[i]['action'].toLowerCase();
							}

							if (vm.data.parte[i]['birthday']) {
								parte['ppart_data_nasc'] = vm.data.parte[i]['birthday'];
							}

							if (vm.data.parte[i]['email']) {
								parte['ppart_email'] = vm.data.parte[i]['email'];
							}

							if (vm.data.parte[i]['type'] == 5) {
								parte['ppart_end_logradouro'] = vm.address['end_logradouro'];
								parte['ppart_end_numero'] = vm.address['end_numero'];
								parte['ppart_end_complemento'] = vm.address['end_complemento'];
								parte['ppart_end_bairro'] = vm.address['end_bairro'];
								parte['ppart_end_cep'] = vm.address['end_cep'];
								parte['ppart_end_cidade'] = vm.address['end_cidade'];
								parte['ppart_end_estado'] = vm.address['end_estado'];
								parte['ppart_end_pais'] = vm.address['end_pais'];
							}
						}
						if (parte.index) {
							vm.propostaData.propPartes[parte.index] = parte;
						} else {
							vm.propostaData.propPartes.push(parte);
						}
					}
					vm.propostaData['propStatusOld'] = 1;
					vm.propostaData.$saveSite().then(
						function (succ) {
							var promise = crudGet();
							promise.then(
								function (greeting) {
									console.log('Load: Proposta');
									nextStep();
								},
								function (reason) {
									console.log('Error: Proposta');
								}
							);
						},
						function (err) {
							console.log('Error: ', err);
						}
					);
				} else if (etapa == 5) {
					for (var i = 0; i < vm.data.parte.length; ++i) {
						vm.propostaData.propPartes[i]['ppart_cnt_nome'] = vm.data.parte[i]['contatoNome'];
						vm.propostaData.propPartes[i]['ppart_cnt_telefone'] = vm.data.parte[i]['contatoTel'];
					}
					var hash = typeof vm.propostaData.hash === 'string' ? [vm.propostaData.hash] : vm.propostaData.hash;
					vm.urlshare = 'http://' + $rootScope.ConfigWhiteLabel.url_site.replace('http://', '').replace('https://', '') + '/proposta-locacao/' + hash[0] + '/locacao-conjunta';

					vm.propostaData['propStatusOld'] = 1;
					vm.propostaData.$saveSite().then(
						function (succ) {
							nextStep();
							finishProposta();
						},
						function (err) {
							console.log('Error: ', err);
						}
					);
				}

				return;
			},
			getCorretor: function (val) {
				val = val.replace(/[^a-zA-Z ]/g, '');
				if (!val || val.length == 0) {
					val = '[blank]';
				} else {
					val = val.trim();
				}

				var _url = SERVER_URL + 'api/propostas/autocomplete/propCorretor/' + val;
				var params = imobiliaria.isArbo ? {params: {limit: 5}} : {params: {limit: 5, imb_id: imobiliaria.id}};
				return $http
					.get(_url, {
						params: params,
						// params: {limit: 5, imb_id: imob}
					})
					.then(function (response) {
						return response.data;
					});
			},
			getNegocio: function (val) {
				val = val.replace(/[^a-zA-Z ]/g, '');
				if (!val || val.length == 0) {
					val = '';
				} else {
					val = val.trim();
				}
				var _url = SERVER_URL + 'api/tiposnegocioImobiliaria';
				var imob = imobiliaria.isArbo ? 0 : imobiliaria.id;
				var _where = imob ? {imob_id: imob} : {};

				return $http
					.get(_url, {
						params: {
							filter: {
								limit: 5,
								where: _where,
								include: {
									relation: 'tipo_negocio',
									scope: {
										fields: ['tnmod_nome'],
										where: {
											tnmod_nome: {
												'regexp': '/' + val + '/i',
											},
										},
									},
								},
							},
						},
					})
					.then(function (response) {
						var data = [];
						data = response.data.reduce(function (acc, cur, i) {
							var check = false;
							cur.label = cur.tipo_negocio.tnmod_nome;
							console.log(acc, cur);

							acc.forEach(function (el) {
								if (el.label == cur.label) {
									check = true;
								}
							});
							if (!check) {
								acc.push(cur);
							}
							return acc;
						}, []);
						return data;
					});
			},
			selectCorretor: function ($item, $model, $label, $event) {
				console.log($item, $model, $label, $event);
			},
			searchImoveis: function () {
				// e.preventDefault();
				if (!vm.data.cod_imovel) {
					vm.imoveis = null;
					vm.data.imovelSelect = null;
					return;
				}

				var _url = SERVER_URL + 'api/imoveis-replica/get-imoveis-new';
				var filter = {};
				vm.data.cod_imovel = vm.data.cod_imovel.replace(/\/|\\/g, '');
				filter['imv_cod_gaia'] = {'regexp': '/' + vm.data.cod_imovel + '/i'};

				if (!imobiliaria.isArbo) {
					filter['imb_id'] = imobiliaria.id;
				}

				filter['and'] = [];
				filter['and'].push({imv_preco_locacao: {'neq': null}});
				filter['and'].push({imv_preco_locacao: {'neq': 0}});
				filter['and'].push({tpng_id: {'inq': [2, 3]}});

				Imovel.getImoveisNew({
					where: filter,
					limit: 20,
				}).$promise.then(function (response) {
					vm.imoveis = response;
					if (response.length) {
						vm.data.imovelSelect = response[0].id;
					} else {
						vm.data.imovelSelect = null;
					}
				});
			},
			selectImovel: function (e) {
				if (vm.data.imovelSelect == e) {
					vm.data.imovelSelect = null;
				} else {
					vm.data.imovelSelect = e;
				}
			},
			viacepGet: function () {
				// console.log(that.address.cep);

				if (vm.address.end_cep !== undefined && vm.address.end_cep.replace(/\D+/g).length == 8) {
					viaCEP.get(vm.address.end_cep).then(
						function (res) {
							vm.address_viacep = res;

							vm.address.end_bairro = res.bairro;
							vm.address.end_logradouro = res.logradouro;
							vm.address.end_cidade = res.localidade;
							vm.address.end_estado = res.uf;
							vm.address.end_pais = 'Brasil'; // Tem que mudar depois isso

							res.logradouro ? angular.element('#num-address').focus() : angular.element('#stre-address').focus();

							setTimeout(function () {
								upperLabel();
							}, 100);
						},
						function (err) {
							vm.address = {};
							vm.address_viacep = {};

							upperLabel();

							// console.log(err);
						}
					);
				}
			},
		};

		function crudGet() {
			var id = localStorage.getItem('prop-form') ? atob(localStorage.getItem('prop-form')) : null;
			var hash = JSON.parse(localStorage.getItem('prop-hash'));
			var deferred = $q.defer();

			Proposta.findProposta({'id': id, 'hash': hash}).$promise.then(
				function (succ) {
					if (succ && succ['id']) {
						vm.propostaData = succ;
						vm.propostaData['hash'] = hash;
						// vm.propostaData['propStatusOld'] = 1;
						for (var index = 0; index < vm.propostaData.propPartes.length; index++) {
							var element = vm.propostaData.propPartes[index];
							if (element.ptpart_id == 2 || element.ptpart_id == 5) {
								vm.emailParte = element['ppart_email'];
								console.log(vm.emailParte);
							}
						}
					} else {
						finishProposta();
						$state.go($state.current.name, {}, {'reload': true});
					}
					return deferred.resolve();
				},
				function (err) {
					vm.propostaData = {};
					console.log('Error: ', err);
					return deferred.reject();
				}
			);

			return deferred.promise;
		}

		function copyPaste() {
			var range, textArea, selection;

			textArea = document.getElementById('valueToCopy'); //Visible element to copy the value to

			if (navigator.userAgent.match(/ipad|iphone/i)) {
				range = document.createRange();
				range.selectNodeContents(textArea);
				selection = window.getSelection();
				selection.removeAllRanges();
				selection.addRange(range);
				textArea.setSelectionRange(0, 999999);
			} else {
				textArea.select();
			}

			var success = document.execCommand('Copy'); //Copy
			var msg = success ? 'Copiado com sucesso.' : 'Ocorreu um erro, tente novamente'; //Set success or error msg
			swangular.swal({
				type: 'success',
				animation: false,
				title: msg,
				confirmButtonClass: 'btn button btn-default px-5',
				buttonsStyling: false,
				timer: 1500,
			});
		}

		function upperLabel() {
			angular.element('input.upper').each(function (index, element) {
				var $this = $(this);
				if (element.value.length > 0) {
					$this.siblings('label.upper').addClass('active');
				} else {
					$this.siblings('label.upper').removeClass('active');
				}
			});
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('propostaContrapropostaController', propostaContrapropostaController)
    .controller('propostaComfirmaController', propostaComfirmaController)
    .controller('propostaComfirmaContraController', propostaComfirmaContraController)
    .controller('propostaDefaultController', propostaDefaultController)
    .controller('propostaAnexosController', propostaAnexosController)
    .controller('propostaConjuntaController', propostaConjuntaController)
    .controller('propostaStatusController', propostaStatusController)
    .controller('cotacoesModalController', cotacoesModalController)

  /* @ngInject */
  function propostaContrapropostaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, Imovel, FileUploader) {
    var vm = this,
      propostaData = currentProposta;
    vm.sucesso = false;
    //propStatusOld = 4 - Pré análise enviada
    //propStatusOld = 7 - Pré aprovado
    //propStatusOld = 8 - Enviada ao proprietário?
    //propStatusOld = 10 - Contraproposta do Proprietário
    //propStatusOld = 34 - Gestor aceitou a proposta
    vm.resend = propostaData['propt_contrap_valor'] || ![4, 7, 8, 10, 34].includes(propostaData.pst_id) || false;

    if (propostaData) {
      vm.prop_valor = propostaData.propt_valor;
      vm.cprop_valor = propostaData.propt_contrap_valor || null;
    }

    var e = $window.atob($window.atob($stateParams.e)).split('&');
    if (e.length && e.length >= 2) {
      propostaData['propStatusOld'] = angular.copy(propostaData['pst_id']);
      propostaData['pst_id'] = e[0];
      propostaData['altBy'] = e[1];
    } else {
      $state.go('main.proposta.form')
    }
    vm.submit = function (e) {
      e.preventDefault();
      e.stopPropagation();

      propostaData['propt_contrap_valor'] = vm.data.valor;
      propostaData['propt_contrap_just'] = vm.data.justificativa;
      // sobreescrevendo o id antigo (36 é de venda, 10 de locação)
      propostaData['pst_id'] = currentProposta.tpng_id == 1 ? 36 : 10;
      delete propostaData['propPartes']
      delete currentProposta.propPartes;
      delete currentProposta.crt_id;
      delete currentProposta.gest_id;

      propostaData.$saveSite(vm.data)
        .then(function (succ) {
          vm.sucesso = true;
        }, function (err) {
          console.log(err);
        })
    }
  }

  /* @ngInject */
  function propostaComfirmaController(
    $rootScope,
    $scope,
    $state,
    $q,
    $location,
    $http,
    $window,
    SERVER_URL,
    textFormatter,
    $stateParams,
    auth,
    currentProposta,
    Proprietario,
    PropostaTipoAnexo,
    $timeout,
    FileUploader,
    swangular,
    viaCEP,
    DOC_FILTER,
    SIZE_FILTER,
    LogErrorProposta,
    toastr
  ) {
    localStorage.removeItem('$LoopBack$accessTokenId');
    var vm = this;
    var propostaData = currentProposta;
    var prop_id = auth.getUser().id;
    var propt_id = currentProposta.propPartes
      ? currentProposta.propPartes[1].propt_id
      : null;

    vm.maritalStatuses = [
      'Solteiro(a)',
      'Casado(a)',
      'Separado(a)',
      'Divorciado(a)',
      'Viúvo(a)',
    ];
    vm.isPessoaFisica = true;
    vm.isProp = $stateParams.urlaccess
    vm.isCasado = false;
    vm.data = {
      person: {
        address: {},
      },
      conjuge: {},
      banco: {},
      truthfulness: false,
    };

    vm.getGentilicos = function () {
      var _url = SERVER_URL + 'api/paises/pager?page=1&per_page=1000';

      return $http
        .get(_url)
        .then(function (response) {
          vm.gentilicos = response.data.data.map(function (pais) {
            return pais.gentilico;
          });
        });
    }

    vm.getNationality = function (reg) {
      reg = reg.replace(/[^a-zA-Z ]/g, '');

      if (!reg || reg.length == 0) {
        reg = '[blank]';
      } else {
        reg = reg.trim();
      }

      var _url = SERVER_URL + 'api/paises/autocomplete/gentilico/' + reg + '?limit=20';

      return $http
        .get(_url)
        .then(function (response) {
          return response.data;
        });
    }

    vm.checkEstrangeiro = function (e, type) {
      if (type == 'conjuge') {
        if (e.target && e.target.checked) {
          Object.assign(vm.data.conjuge, {nationality: null, rg: null})
          jQuery('#conjuge-nationality').val('');
        } else {
          Object.assign(vm.data.conjuge, {nationality: 'brasileiro', crnm: null});
          jQuery('#conjuge-nationality').val('brasileiro');
        }
      } else if (type == 'socio') {
        if (e.target && e.target.checked) {
          Object.assign(vm.data.person.socio, {nationality: null, rg: null})
          jQuery('#socio-nationality').val('');
        } else {
          Object.assign(vm.data.person.socio, {nationality: 'brasileiro', crnm: null})
          jQuery('#socio-nationality').val('brasileiro');
        }
      } else {
        if (e.target && e.target.checked) {
          Object.assign(vm.data.person, {nationality: null, rg: null})
          jQuery('#person-nationality').val('')
        } else {
          Object.assign(vm.data.person, {nationality: 'brasileiro', crnm: null})
          jQuery('#person-nationality').val('brasileiro');
        }
      }
    }

    vm.sucesso = propostaData.success || false;
    vm.resend = propostaData.resend || false;
    vm.fileError = false;

    // Tipos de anexo (tem que estar igual ao do banco)
    vm.fileTypes = [
      { name: 'rg', id: 1 },
      { name: 'conjRg', id: 1 },
      { name: 'cpf', id: 3 },
      { name: 'conjCpf', id: 3 },
      { name: 'contSocial', id: 5 },
      { name: 'compEnd', id: 6 },
      { name: 'irpj', id: 7 },
      { name: 'crnm', id: 19 },
      { name: 'conjCrnm', id: 19 },
    ];

    vm.diasAluguel = [];

    for (var i = 1; i < 31; i++) {
      vm.diasAluguel.push(i);
    };

    var getFormData = $http.get(SERVER_URL + 'api/propostas/get-whitelabel-form-data');

    $q.all([getFormData]).then(function (res) {
      vm.banks = res[0].data.banks;
      vm.pagamento = res[0].data.pagamento;
      vm.pix = res[0].data.pix;

      init()
    });

    vm.conta = [
      { id: "0", label: 'Conta corrente' },
      { id: "1", label: 'Conta poupança' },
    ];

    vm.bancoSelect = "";
    vm.pagamentoSelect = "";
    vm.pixSelect = "";
    vm.contaSelect = "";
    vm.agenciamask = "";
    vm.contamask = "";
    vm.outrobanco = false;

    $scope.uploaders = []; // uploaders dos <input type="file">
    $scope.files = []; // lista dos arquivos adicionados
    $scope.docsValid = false; // variavel de controle da validacao dos arquivos
    $scope.uploadError = false; // variavel de controle da condicional de erro no upload de arquivos

    vm.makeContaMask = function () {
      var input = $('input#conta');
      $(input).mask('000ZZZZZZZZZZZZZZZZZZZ-YY', {
        translation: {
          Z: { pattern: /[0-9]/, optional: true },
          Y: { pattern: /[0-9xX]/, optional: true },
        },
      });
    };
    vm.makeAgenciaMask = function () {
      var input = $('input#agencia');
      $(input).mask('000ZZZZZZZ-YY', {
        translation: {
          Z: { pattern: /[0-9]/, optional: true },
          Y: { pattern: /[0-9xX]/, optional: true },
        },
      });
    };

    $scope.$watch('vm.pixSelect', function (newValue, oldValue) {
      if (oldValue) {
        vm.data.banco.chavepix = null
      }

      if(!newValue) return

      vm.chavepix = {}

      $timeout(function () {
          vm.chavepix[newValue.label] = true
      }, 300)

      $timeout(function () {
        if (newValue.label == "Celular") {
          $('input[name="chavepixCel"]').mask('+ZZ (99) X9999-9999', {
            translation: {
              Z: {pattern: /5/, fallback: '5', optional: false},
							X: {pattern: /[0-9]/, optional: true},
            },
          });
        } else if(newValue.label == "Chave Aleatória") {
          $('input[name="chavepixChaveAl"]').mask('ZZZZZZZZ-ZZZZ-ZZZZ-ZZZZ-ZZZZZZZZZZZZ', {
            translation: {
              Z: { pattern: /[a-zA-z0-9]/, optional: false },
            },
          });
        }
      }, 300)

    });

    $scope.$watch('vm.pagamentoSelect', function (newValue, oldValue) {
      if (oldValue && newValue != oldValue) {
        clearBankDataFields();
      }
    });

		var defaultFieldsFormPag = ['chavepix', 'banco', 'agencia', 'conta', 'operacao', 'titular', 'titularCpf'];

    function clearBankDataFields() {
      defaultFieldsFormPag.map(function (item) {
        vm.data.banco[item] = null;
      });

      vm.bancoSelect = null;
      vm.pixSelect = null;
      vm.contaSelect = null;
    }

    // Remove um item da fila de arquivos e da lista local
    $scope.removeItem = function (item) {
      // remove o arquivo da lista local
      $scope.files = $scope.files.filter(function (el) {
        return el.uploader.alias != item.uploader.alias;
      });

      item.remove(); // remove o item da fila

      checkDocs();
    };

    // Valida se a qtd de docs adicionados
    function checkDocs() {
      if (vm.isPessoaFisica) {
        if (vm.isCasado && $scope.files.length < 4) {
          $scope.docsValid = false;
        } else if ($scope.files.length < 2) {
          $scope.docsValid = false;
        } else {
          $scope.docsValid = true;
        }
      } else {
        if (vm.isCasado && $scope.files.length < 7) {
          $scope.docsValid = false;
        } else if ($scope.files.length < 5) {
          $scope.docsValid = false;
        } else {
          $scope.docsValid = true;
        }
      }
    }

    // Cria um uploader
    function createUploader(fileType) {
      var urlUpload =
        SERVER_URL +
        'api/upload/proposta-doc' +
        propostaData.id +
        '--' +
        propostaData.hash +
        '/upload?e=' +
        propostaData['altBy'];

      // Cria a insância de uploader (deve ser um pra cada <input type="file">)
      var uploader = new FileUploader({
        alias: fileType.name, // nome do uploader
        scope: $scope, // to automatically update the html. Default: $rootScope
        url: urlUpload, // url
        autoUpload: true,
        queueLimit: 1, // qtd de docs que podem ser adicionados para a fila
        formData: [
          {
            key: 'value',
          },
        ],
      });

      // Filtos de tamanho e formato dos aquivos
      uploader.filters.push(DOC_FILTER);
      uploader.filters.push(SIZE_FILTER);

      // Renomeando a imagem
      uploader.onAfterAddingFile = function (item) {

        item.file.originalName = item.file.name;
        item.file.name =
          fileType.id + '___' + new Date().getTime() + item.file.name;

        $scope.files.push(item);

        checkDocs();
      };

      // Erro ao tentar adicionar Arquivos fora dos filtros
      uploader.onWhenAddingFileFailed = function (item, filter, options) {

        var textSW;

        if (filter.name == 'sizeFilter') {
          textSW = 'Por favor, escolha imagens de até 5MB';
        } else if (filter.name == 'docFilter') {
          textSW = 'Por favor, escolha somente arquivos PDF ou imagem';
        } else if (filter.name == 'queueLimit') {
          textSW = 'Só é permitido o upload de dois arquivos';
        } else {
          textSW = 'Aconteceu algum erro ao fazer upload';
        }

        swangular.swal({
          type: 'error',
          animation: false,
          title: '',
          html: '<h3>' + textSW + '</h3>',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 2500,
        });
      };


      // uploader.onBeforeUploadItem = function (item) {
      //   vm.data.uploads = vm.data.uploads || { socio: {}, conjuge: {}, proprietario: {} }
      //   vm.data.uploads[vm.data.actualPartUpload || 'proprietario'][item.alias] = { url: 'proposta-doc' +propostaData.id + '--' + propostaData.hash + '/' + item.file.name, ptax_id: fileType.id };
      // };

      uploader.onSuccessItem = function (item, response) {
        vm.data.uploads = vm.data.uploads || { socio: {}, conjuge: {}, proprietario: {} }

        if (response.result.files) {
          for (var key in response.result.files) {
            var file = response.result.files[key][0];
            if (file && file.providerResponse) {
              vm.data.uploads[vm.data.actualPartUpload || 'proprietario'][item.alias] = { url: file.providerResponse.location, ptax_id: fileType.id };
            }
          }

        }
      };

      // Erro na Hora de fazer upload da Imagem
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        swangular.swal({
          type: 'error',
          animation: false,
          title: '',
          html:
            '<h3>Erro ao fazer o upload do item: ' +
            fileItem.file.originalName +
            '</h3>',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 2500,
        });

        vm.uploadError = true;
      };

      return uploader;
    }

    // "Popula" a lista de uploaders de acordo com os de tipos de anexo
    vm.fileTypes.forEach(function (e) {
      $scope.uploaders[e.name] = createUploader(e);
    });

    // Função que é executada quando o controller é instanciado
    function init() {
      var person = vm.data.person;
      var banco = vm.data.banco;
      vm.getGentilicos();

      var prop = currentProposta.propPartes.find(function (el) {
        return el.ptpart_id == 1;
      });

      if (vm.isProp) {
        if (prop) {
          vm.isPessoaFisica = prop.ppart_tipo_pessoa == 1 ? true : false

          if(prop.formpag_id) {
            vm.pagamentoSelect = vm.pagamento.filter(function (params) {
              return params.id == prop.formpag_id
            })[0]
          }

          if(prop.ban_id) {
            vm.bancoSelect = vm.banks.filter(function (params) {
              return params.id == prop.ban_id
            })[0]
          }

          if(prop.tipchvpix_id) {
            vm.pixSelect = vm.pix.filter(function (params) {
              return params.id == prop.tipchvpix_id
            })[0]
          }

          if(prop.ppart_cb_tipo) {
            vm.contaSelect = vm.conta.filter(function (params) {
              return params.id == prop.ppart_cb_tipo
            })[0]
          }

          if(prop.ppart_cb_operacao) {
            banco.operacao = prop.ppart_cb_operacao || null;
          }

          if(prop.ppart_chave_pix) {
            banco.chavepix = prop.ppart_chave_pix || null;
          }

          if(!vm.isPessoaFisica) {
            vm.data.person.socio = {}
            vm.data.person.socio.nationality = 'brasileiro'
          }

          person.name = prop.ppart_nome;
          person.cpf = prop.ppart_document;
          person.cnpj = prop.ppart_document;
          person.email = prop.ppart_email;
          person.phone = prop.ppart_tel;
          person.profissao = prop.ppart_profissao;
          person.birthday = prop.ppart_data_nasc;
          person.maritalStatus = prop.ppart_estado_civil;
          vm.changeMaritalStatus();
          person.nationality = prop.ppart_nacionalidade || 'brasileiro';

          if(person.nationality !== 'brasileiro') {
            person.crnm = prop.ppart_crnm;
            vm.isEstrangeiro = true;
            person.rg = null;
          } else {
            person.rg = prop.ppart_rg;
            person.crnm = null;
          }

          person.address.cep = prop.ppart_end_cep;
          person.address.numero = prop.ppart_end_numero;
          person.address.rua = prop.ppart_end_logradouro;
          person.address.bairro = prop.ppart_end_bairro;
          person.address.cidade = prop.ppart_end_cidade;
          person.address.estado = prop.ppart_end_estado;
          person.address.complemento = prop.ppart_end_complemento;

          banco.agencia = prop.ppart_cb_agencia || null;
          banco.conta = prop.ppart_cb_conta || null;
          banco.titular = prop.ppart_cb_nome_titular || null;
          banco.titularCpf = prop.ppart_cb_nome_cpf_titular || null;
        } else {
          Proprietario.getPropInfo({
            prop_id: prop_id,
          }).$promise
            .then(function (res) {
              if (res.enderecos) {
                prop.ppart_rg ?
                person.rg = Number.parseInt(res.ppart_rg) :
                person.crnm = Number.parseInt(res.ppart_crnm);

                person.name = res.nome;
                person.email = res.email;
                person.phone = prop.ppart_tel; // peganddo do proprietario, porque nesse fetch n vem
                person.rg = Number.parseInt(res.rg);
                person.cpf = res.cpf;
                person.profissao = res.profissao;
                person.birthday = res.data_aniversario;
                person.address.cep = res.enderecos[0]
                  ? res.enderecos[0].cep
                  : null;
                person.address.numero = res.enderecos[0]
                  ? Number.parseInt(res.enderecos[0].numero)
                  : null;
                person.address.rua = res.enderecos[0]
                  ? res.enderecos[0].logradouro
                  : null;
                person.address.bairro = res.enderecos[0]
                  ? res.enderecos[0].bairro
                  : null;
                person.address.cidade = res.enderecos[0]
                  ? res.enderecos[0].cidade || prop.ppart_end_cidade
                  : null;
                person.address.estado = res.enderecos[0]
                  ? res.enderecos[0].estado || prop.ppart_end_estado
                  : null;
                person.address.complemento = res.enderecos[0]
                  ? res.enderecos[0].complemento
                  : null;
              }
              if(res.contas_bancarias && res.contas_bancarias.length) {
                vm.bancoSelect = res.contas_bancarias[0]
                  ? vm.banks[res.contas_bancarias[0].ban_id]
                  : null;
                banco.agencia = res.contas_bancarias[0]
                  ? res.contas_bancarias[0].procb_agencia
                  : null;
                banco.conta = res.contas_bancarias[0]
                  ? res.contas_bancarias[0].procb_conta
                  : null;
                vm.contaSelect = res.contas_bancarias[0]
                  ? vm.conta[res.contas_bancarias[0].procb_tipo]
                  : null;
                banco.titular = res.contas_bancarias[0]
                  ? res.contas_bancarias[0].procb_nome_titular
                  : null;
                banco.titularCpf = res.contas_bancarias[0]
                  ? res.contas_bancarias[0].procb_nome_cpf_titular
                  : null;
              }
            })
            .catch(function (err) {
              console.error(
                'Falha ao pegar os dados do proprietario do banco',
                err
              );
            });
        }
      } else {
        var dados =
          currentProposta.propPartes.find(function (el) {
            return el.ptpart_id == 2; // Comprador/Locatário
          }) ||
          currentProposta.propPartes.find(function (el) {
            return el.ptpart_id == 4; // Razão Social
          });

        var isPessoaFisica = dados.ptpart_id == 2;

        if (!propostaData['altBy']) propostaData['altBy'] = dados.id;
        person.name = dados.ppart_nome;
        person.profissao = dados.ppart_profissao;

        if (isPessoaFisica) {
          person.cpf = dados.ppart_document;
          person.email = dados.ppart_email;
          person.phone = dados.ppart_tel;
          person.profissao = dados.ppart_profissao;
          person.birthday = dados.ppart_data_nasc;
          person.nationality = dados.ppart_nacionalidade || 'brasileiro';

          if(person.nationality !== 'brasileiro') {
            person.crnm = dados.ppart_crnm;
            vm.isEstrangeiro = true;
            person.rg = null;
          } else {
            person.rg = dados.ppart_rg;
            person.crnm = dados.ppart_crnm;
          }

          person.address.cep = dados.ppart_end_cep;
          person.address.numero = dados.ppart_end_numero;
          person.address.rua = dados.ppart_end_logradouro;
          person.address.bairro = dados.ppart_end_bairro;
          person.address.cidade = dados.ppart_end_cidade;
          person.address.estado = dados.ppart_end_estado;
          person.address.complemento = dados.ppart_end_complemento;
        } else {
          vm.isPessoaFisica = false;
          var socio = currentProposta.propPartes.find(function (el) {
            return el.ptpart_id == 5  && el.proposta_parte_empresa != prop.id; // Sócio Administrador
          });

          if (!vm.data.person.socio) {
            vm.data.person.socio = {nationality: 'brasileiro'};
          }

          person.cnpj = dados.ppart_document;
          person.ie = dados.ppart_ie;

          if (socio) {
            vm.data.person.socio.name = socio.ppart_nome;
            vm.data.person.socio.cpf = socio.ppart_document;
            vm.data.person.socio.phone = socio.ppart_tel;
            vm.data.person.socio.email = socio.ppart_email;
            vm.data.person.socio.birthday = socio.ppart_data_nasc;
            vm.data.person.socio.profissao = socio.ppart_profissao;
            vm.data.person.socio.nationality = socio.ppart_nacionalidade || 'brasileiro';

            if(vm.data.person.socio.nationality !== 'brasileiro') {
              vm.data.person.socio.crnm = socio.ppart_crnm;
              vm.isEstrangeiroSocio = true;
              vm.data.person.socio.rg = null;
            } else {
              vm.data.person.socio.rg = socio.ppart_rg
              vm.data.person.socio.crnm = null;
            }
          }
        }
      }
    }

    // Procura o endereço via CEP
    vm.getCEP = function (prefix) {
      if (prefix == 'person') var ctx = this.data.person;
      else var ctx = this.data.conjuge;

      var cep = ctx.address.cep;

      if (cep && cep.replace(/\D+/g).length == 8) {
        viaCEP
          .get(cep)
          .then(function (res) {
            ctx.address.bairro = res.bairro;
            ctx.address.rua = res.logradouro;
            ctx.address.cidade = res.localidade;
            ctx.address.estado = res.uf;
            ctx.address.pais = 'Brasil'; // Tem que mudar depois isso (?)

            // Se tiver rua, foca no elemento de numero senao, foca na rua
            if (res.logradouro)
              angular.element('#' + prefix + '-numero').focus();
            else angular.element('#' + prefix + '-rua').focus();
          })
          .catch(console.error);
      }
    };

    // Valida a data de nascimento
    vm.validateBornDate = function (field, formInstance) {
      const date = document.getElementById(field).value;
      const dateDiff = moment().diff(moment(date, 'DD/MM/YYYY'), 'days');

      if (dateDiff <= 0) formInstance[field].$setValidity('date', false);
    };

    // Seta valores para o campo numero das partes (PF e PJ)
    vm.setWithoutNumber = function (event, parte) {
      const endereco = parte === 'person' ? vm.data.person.address : vm.data.conjuge.address;

      if (event.target.checked) {
        endereco.numero = 'S/N';
      } else {
        endereco.numero = '';
      }
    };

    // Altera o tipo do contrato
    vm.changeContractType = function (event) {
      vm.isPessoaFisica = event.target.value == '1' || false;

      vm.data = null;
      vm.isCasado = false;
      $scope.files = [];
      $scope.formValid = false;

      Object.keys($scope.uploaders).forEach(function (k) {
        $scope.uploaders[k].clearQueue();
      });
    };

    // Altera o estado civil
    vm.changeMaritalStatus = function () {
      vm.isCasado =
        (vm.data.person.maritalStatus || (vm.data.person.socio && vm.data.person.socio.maritalStatus)) ==
          'Casado(a)' || false;

      if (vm.data.conjuge) vm.data.conjuge.address = {};
      if (!vm.isCasado) {
        if (vm.data.conjuge) delete vm.data.conjuge;
        if (vm.data.uploads && vm.data.uploads.conjuge) {
          delete vm.data.uploads.conjuge;
        }
      } else {
        vm.data.conjuge = {};
        vm.data.conjuge.nationality = 'brasileiro';
      }

      checkDocs();
    };

    // Usa o mesmo endereço do conjuge na pessoa
    vm.useSameAddress = function (event) {
      if (event.target.checked && vm.data.person) {
        vm.data.conjuge.address = vm.data.person.address
      } else {
        vm.data.conjuge.address = {};
      }
    };

    vm.initConjugeAddressField = function () {
      vm.autocomplete_endereco = true;
      if(vm.data.person){
        vm.data.conjuge.address = vm.data.person.address
      }
    };

    vm.checkNationality = function (data, gentilicos) {
      var nationality = data.nationality;
      if (typeof nationality == 'string') {
        return gentilicos.includes(nationality);
      }

      return gentilicos.includes(nationality.label);
    }

    function validateNationality() {
    var isValidNationality = true;

    if (vm.data.person && vm.isPessoaFisica) {
        isValidNationality = vm.checkNationality(vm.data.person, vm.gentilicos);
    }

    if (vm.data.person.socio && isValidNationality) {
        isValidNationality = vm.checkNationality(vm.data.person.socio, vm.gentilicos);
    }

    if (vm.data.conjuge && isValidNationality) {
        isValidNationality = vm.checkNationality(vm.data.conjuge, vm.gentilicos);
    }

    return isValidNationality;
}

    // Envia os dados do form
    vm.submit = function (e, form) {
      vm.firstSubmit = true;
      var isValidNationality = validateNationality();

      e.preventDefault();
      e.stopPropagation();

      if (!isValidNationality) {
        toastr.warning('Nacionalidade inválida!', {
          iconClass: 'toast-error',
        });

        return
      }

      if (form.$valid) {
        $rootScope.loadingModal.start('Atualizando os dados');

        // Atualiza os dados do proprietário
        if (vm.isProp) {
          if(vm.data.person.nationality) {
            Object.assign(vm.data.person, {
              nationality: vm.data.person.nationality.label || vm.data.person.nationality
            })
          }

          if(vm.data.conjuge && vm.data.conjuge.nationality) {
            Object.assign(vm.data.conjuge, {
              nationality: vm.data.conjuge.nationality.label || vm.data.conjuge.nationality
            })
          }

          Object.assign(vm.data.banco, {
            banco: vm.bancoSelect && vm.bancoSelect.id || null,
            bancoCode: vm.bancoSelect && vm.bancoSelect.code || null,
            tipoConta: vm.contaSelect && vm.contaSelect.id || null,
            tipoChavePix: vm.pixSelect && vm.pixSelect.id || null,
            formaPag: vm.pagamentoSelect && vm.pagamentoSelect.id || null,
          })

          Proprietario.updateInfoProp(
            {
              data: vm.data, // Dados fornecidos via formulário
              prop_id: prop_id, // ID da proposta
              propt_id: propt_id, // ID do proprietário
            },
            function (res) {
              if (res && res.success) {
                currentProposta.propt_dia_pag = vm.data.rentDay;
                currentProposta.propt_valor_final = propostaData.propt_contrap_valor || currentProposta.propt_valor

                delete currentProposta.propPartes;
                delete currentProposta.crt_id;
                delete currentProposta.gest_id;

                currentProposta
                  .$saveSite()
                  .then(function () {
                    vm.finish = true;
                    vm.success = true;

                    $rootScope.loadingModal.stop();

                    localStorage.setItem('aceiteEmAndamento', false);
                  })
                  .catch(function (e) {
                    vm.sucesso = false;

                    $rootScope.loadingModal.stop();

                    LogErrorProposta.create({
                      lerrp_dados: vm.data,
                      lerrp_erro: e,
                      prop_id: currentProposta.id,
                    });
                  });
              }
            },
            function (err) {
              vm.sucesso = false;
              $rootScope.loadingModal.stop();

              LogErrorProposta.create({
                lerrp_dados: vm.data,
                lerrp_erro: err,
                prop_id: currentProposta.id,
              });
            }
          );
        } else {
          var e = $window.atob($window.atob($stateParams.e)).split('&');

          if (e.length && e.length >= 2) {
            currentProposta['propStatusOld'] = angular.copy(
              currentProposta['pst_id']
            );

            if(e[0] == 'null') e[0] = null

            currentProposta['pst_id'] = e[0] || currentProposta['pst_id'];
            currentProposta['altBy'] = currentProposta['altBy'] || e[1];
          }

          var propostaParts = {
            PERSON_ID:2,
            CONJUGE_ID:3,
            JURIDICO_ID:4,
            SOCIO_ID:5,
          }

          var socio = vm.data.socio || vm.data.person.socio ;
          if (socio && Object.keys(socio).length) {
            currentProposta.propPartes.push({
              propt_id: currentProposta.id,
              ppart_data_nasc: socio.birthday,
              ppart_document: socio.cpf,
              ppart_email: socio.email,
              ppart_estado_civil: socio.maritalStatus,
              ppart_nacionalidade: socio.nationality.label || socio.nationality,
              ppart_nome: socio.name,
              ppart_profissao: socio.profissao,
              ppart_rg: socio.rg || null,
              ppart_crnm: socio.crnm || null,
              ppart_tel: socio.phone,
              ptpart_id: propostaParts.SOCIO_ID, // esse cara é importante
              ppart_end_bairro: vm.data.person.address.bairro,
              ppart_end_cep: vm.data.person.address.cep,
              ppart_end_cidade: vm.data.person.address.cidade,
              ppart_end_complemento: vm.data.person.address.complemento,
              ppart_end_estado: vm.data.person.address.estado,
              ppart_end_numero: vm.data.person.address.numero,
              ppart_end_logradouro: vm.data.person.address.rua,
              ppart_end_pais: 'Brasil',
            });

            var conjuge = vm.data.conjuge;
            if (conjuge && Object.keys(conjuge).length) {
              currentProposta.propPartes.push({
                propt_id: currentProposta.id,
                proposta_parte_id: null,
                ptpart_id: propostaParts.CONJUGE_ID, // esse cara é importante
                ppart_data_nasc: conjuge.birthday,
                ppart_document: conjuge.cpf,
                ppart_email: conjuge.email,
                ppart_nacionalidade: conjuge.nationality.label || conjuge.nationality,
                ppart_nome: conjuge.nome,
                ppart_tel: conjuge.phone,
                ppart_profissao: conjuge.profissao,
                ppart_rg: conjuge.rg || null,
                ppart_crnm: conjuge.crnm || null,
                ppart_end_bairro: conjuge.address.bairro,
                ppart_end_cep: conjuge.address.cep,
                ppart_end_cidade: conjuge.address.cidade,
                ppart_end_complemento: conjuge.address.complemento,
                ppart_end_estado: conjuge.address.estado,
                ppart_end_numero: conjuge.address.numero,
                ppart_end_logradouro: conjuge.address.rua,
                ppart_end_pais: 'Brasil',
                ppart_estado_civil: 'Casado(a)',
                cpf_conjuge: socio.cpf,
              });
            }
          }

          if(vm.data && vm.data.rentDay) currentProposta.propt_dia_pag = vm.data.rentDay;

          var person = vm.data.person;
          vm.personPart = currentProposta.propPartes.find(function(part) {
            return [propostaParts.PERSON_ID].includes(part.ptpart_id)
          })

          if (person && Object.keys(person).length && vm.personPart) {
            Object.assign(vm.personPart,{
              propt_id: currentProposta.id,
              ppart_data_nasc: person.birthday,
              ppart_document: person.cpf,
              ppart_email: person.email,
              ppart_nacionalidade: person.nationality.label || person.nationality,
              ppart_nome: person.name,
              ppart_tel: person.phone,
              ppart_profissao: person.profissao,
              ppart_rg: person.rg || null,
              ppart_crnm: person.crnm || null,
              ppart_end_bairro: person.address.bairro,
              ppart_end_cep: person.address.cep,
              ppart_end_cidade: person.address.cidade,
              ppart_end_complemento: person.address.complemento,
              ppart_end_estado: person.address.estado,
              ppart_end_numero: person.address.numero,
              ppart_end_logradouro: person.address.rua,
              ppart_end_pais: 'Brasil',
              ppart_estado_civil: person.maritalStatus
            });

            var conjuge = vm.data.conjuge;
            if (conjuge && Object.keys(conjuge).length) {
              currentProposta.propPartes.push({
                propt_id: currentProposta.id,
                proposta_parte_id: vm.personPart.id,
                ptpart_id: propostaParts.CONJUGE_ID, // esse cara é importante
                ppart_data_nasc: conjuge.birthday,
                ppart_document: conjuge.cpf,
                ppart_email: conjuge.email,
                ppart_nacionalidade: conjuge.nationality.label || conjuge.nationality,
                ppart_nome: conjuge.nome,
                ppart_tel: conjuge.phone,
                ppart_profissao: conjuge.profissao,
                ppart_rg: conjuge.rg || null,
                ppart_crnm: conjuge.crnm || null,
                ppart_end_bairro: conjuge.address.bairro,
                ppart_end_cep: conjuge.address.cep,
                ppart_end_cidade: conjuge.address.cidade,
                ppart_end_complemento: conjuge.address.complemento,
                ppart_end_estado: conjuge.address.estado,
                ppart_end_numero: conjuge.address.numero,
                ppart_end_logradouro: conjuge.address.rua,
                ppart_end_pais: 'Brasil',
                ppart_estado_civil: 'Casado(a)'
              });
            }
          }


          var juridico = vm.data.person;
          vm.juridicoPart = currentProposta.propPartes.find(function(part) {
            return [propostaParts.JURIDICO_ID].includes(part.ptpart_id)
          })

          if (juridico && Object.keys(juridico).length && vm.juridicoPart) {

            Object.assign(vm.juridicoPart,{
              ppart_ie:juridico.ie,
              ppart_document:juridico.cnpj,
              ppart_profissao:juridico.activity,
              ppart_nome:juridico.name,
              ppart_end_bairro: juridico.address.bairro,
              ppart_end_cep: juridico.address.cep,
              ppart_end_cidade: juridico.address.cidade,
              ppart_end_complemento: juridico.address.complemento,
              ppart_end_estado: juridico.address.estado,
              ppart_end_numero: juridico.address.numero,
              ppart_end_logradouro: juridico.address.rua,
              ppart_end_pais: 'Brasil',
            });
          }


          if(vm.data.uploads){
            currentProposta.uploads = {
              'conjuge':vm.data.uploads.conjuge,
              'socio':vm.data.uploads.socio
            }
            // Como ele está utilizando o mesmo for, os dados do proprietário, locatário e pessoa jurídica são os "mesmos"
            var ptpart_label = (vm.juridicoPart) ? 'juridico' : 'locatario';
            currentProposta.uploads[ptpart_label] = vm.data.uploads.proprietario
          }


          currentProposta
            .$saveSite()
            .then(function () {
              vm.finish = true;
              vm.success = true;
              $rootScope.loadingModal.stop();
            })
            .catch(function (e) {
              vm.sucesso = false;

              $rootScope.loadingModal.stop();

              LogErrorProposta.create({
                lerrp_dados: vm.data,
                lerrp_erro: e,
                prop_id: currentProposta.id,
              });
            });
        }
      } else {
        angular.element('input.ng-invalid').first().focus();
        angular.element('select.ng-invalid').first().focus();
      }
    }
  }

  /* @ngInject */
  function propostaComfirmaContraController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, Proprietario, $timeout, FileUploader, viaCEP, LogErrorProposta) {
    var vm = this
    var propostaData = currentProposta
    var _e = atob(atob($stateParams.e)).split('&');

    vm.sucesso = propostaData.success || false;
    vm.resend = propostaData.resend || false;
  }

  function propostaDefaultController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, Proprietario, $timeout, FileUploader, viaCEP, LogErrorProposta) {
    var vm = this
    var propostaData = currentProposta
    var _e = atob(atob($stateParams.e)).split('&');

    vm.sucesso = propostaData.success || false;
    vm.resend = propostaData.resend || false;

  }


  /* @ngInject */
  function propostaAnexosController($rootScope, $scope, $state, $q, $location, $http, $window, swangular, PropostaTipoAnexo, SERVER_URL, DOC_FILTER, SIZE_FILTER, textFormatter, $stateParams, auth, currentProposta, Imovel, FileUploader) {
    var vm = this,
      propostaData = currentProposta;
    vm.success = false;
    vm.sendAnexos = sendAnexos;

    var e = $window.atob($window.atob($stateParams.e)).split('&');
    if (e.length && e.length >= 2) {
      propostaData['propStatusOld'] = angular.copy(propostaData['pst_id']);
      propostaData['pst_id'] = e[0];
      propostaData['altBy'] = e[1];
    } else $state.go('main.proposta.form');

    function init() {
      var header = $('#header');
      var tipo = propostaData['propPartes'].filter(function (el) { return el.id == propostaData['altBy'] });

      !(header.is('fixed-theme')) ? header.addClass('fixed-theme') : null;

      if (!tipo.length) $state.go('main.proposta.form');

      PropostaTipoAnexo.getTipoAnexos({
        imob: propostaData.imb_id,
        modalidade: propostaData.tnmod_id,
        tipo: tipo[0].ptpart_id
      })
        .$promise.then(function (succ) {
          $scope.uploaderFile = []

          succ.forEach(function (el) { $scope.uploaderFile.push(createUploader(el.id)); });

          vm.inputFiles = succ;
        }, function (err) { console.log(err); })

      console.log(currentProposta);
    }

    function createUploader(idItem) {
      var urlUpload = SERVER_URL + 'api/upload/proposta-doc' + propostaData.id + '--' + propostaData.hash + '/upload?e=' + propostaData['altBy']
      var uploader = null

      uploader = new FileUploader({
        scope: $scope, // to automatically update the html. Default: $rootScope
        url: urlUpload,
        queueLimit: 1,
        autoUpload: true,
        formData: [{
          key: 'value'
        }]
      });

      uploader.filters.push(DOC_FILTER);
      uploader.filters.push(SIZE_FILTER);

      // Renomeando a imagem
      uploader.onAfterAddingFile = function (item) {
        item.file.name = idItem + '___' + new Date().getTime() + item.file.name;
        console.info('Name afterAdding: ', item);
      }
      uploader.onBeforeUploadItem = function (item) {
        console.info('onBeforeUploadItem', item);
      };

      // Erro ao tentar adicionar Arquivos fora dos filtros
      uploader.onWhenAddingFileFailed = function (item, filter, options) {
        // console.info('onWhenAddingFileFailed', item, filter, options);
        var textSW;
        console.log(filter);

        if (filter.name == 'sizeFilter') {
          textSW = 'Por favor, escolha imagens de até 5MB';
        } else if (filter.name == 'docFilter') {
          textSW = 'Por favor, escolha somente arquivos pdf ou imagem';
        } else if (filter.name == 'queueLimit') {
          textSW = 'Só é permitido o upload de um arquivo';
        } else {
          textSW = 'Aconteceu algum erro ao fazer upload';
        }
        swangular.swal({
          type: 'error',
          animation: false,
          title: '',
          html: '<h3>' + textSW + '</h3>',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 2500
        })
      };

      // Erro na Hora de fazer upload da Image
      uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
      };

      return uploader;
    }

    init();

    function sendAnexos() {
      delete propostaData.crt_id;
      delete propostaData.gest_id;

      propostaData.$saveSite()
        .then(function () {
          swangular.swal({
            type: 'info',
            animation: false,
            title: '',
            html: '<h3>Documentação enviada</h3>',
            confirmButtonClass: 'btn button btn-default px-5',
            buttonsStyling: false,
            timer: 2500
          }).then(function () {
            $state.go('main.home');
          })
        })
    }
  }

  /* @ngInject */
  function propostaConjuntaController($rootScope, $scope, $state, $q, $location, $http, $window, SERVER_URL, textFormatter, $stateParams, auth, currentProposta, swangular, Imovel, FileUploader, validatorsArbo, toastr) {
    var vm = this,
      propostaData = currentProposta;
    vm.sucesso = false;
    vm.resend = (propostaData['propt_contrap_valor'] || propostaData['propt_contrap_just']) ? true : false;
    vm.urlSite = window.location.origin;
    vm.imovel = propostaData.imv_id;
    vm.cod_imovel = propostaData.propImovel.imv_cod_gaia;
    vm.parte = {};
    vm.parte['nationality'] = 'brasileiro';

    if (propostaData) {
      vm.prop_valor = propostaData.propt_valor;
      vm.cprop_valor = propostaData.propt_contrap_valor || null;
    }

    vm.getGentilicosPropConjunta = function () {
      var _url = SERVER_URL + 'api/paises/pager?page=1&per_page=1000';

      return $http
        .get(_url)
        .then(function (response) {
          vm.gentilicos = response.data.data.map(function (pais) {
            return pais.gentilico;
          });
        });
    }

    vm.checkEstrangeiroPropConjunta = function(e) {
      if (e.target && e.target.checked) {
        jQuery('#form-nationality').val('');
        vm.parte.docRG = '';
      } else {
        jQuery('#form-nationality').val('brasileiro');
        vm.parte.docCRNM = '';
      }
    }

    vm.checkNationality = function (data, gentilicos) {
      if (typeof data.nationality == 'string') {
        return gentilicos.includes(data.nationality);
      }

      return gentilicos.includes(data.nationality.label);
    }

    vm.getNationalityPropConjunta = function (reg) {
      reg = reg.replace(/[^a-zA-Z ]/g, '');

      if (!reg || reg.length == 0) {
        reg = '[blank]';
      } else {
        reg = reg.trim();
      }

      var _url = SERVER_URL + 'api/paises/autocomplete/gentilico/' + reg + '?limit=20';

      return $http
        .get(_url)
        .then(function (response) {
          return response.data;
        });
    }

    vm.valid_cpf = validatorsArbo.valid_cpf;

    vm.submit = function (e) {
      e.preventDefault();
      e.stopPropagation();

      vm.getGentilicosPropConjunta();

      var isValidNationality = vm.checkNationality(vm.parte, vm.gentilicos);

      if (!isValidNationality) {
        toastr.warning('Nacionalidade inválida!', {
          iconClass: 'toast-error',
        });

        return;
      }

      if (
        !vm.parte['docCPF'] ||
        !vm.valid_cpf(vm.parte['docCPF'])
      ) {
        swangular.swal({
          type: 'error',
          animation: false,
          title: 'CPF inválido',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,
          timer: 2500,
        });
        return false;
      }

      propostaData['propPartes'].push({
        ptpart_id: 2, // Tipo locatario
        ppart_nome: vm.parte['name'],
        ppart_email: vm.parte['email'],
        ppart_tel: vm.parte['phone'],
        ppart_rg: vm.parte['docRG'] || null,
        ppart_crnm: vm.parte['docCRNM'] || null,
        ppart_document: vm.parte['docCPF'],
        ppart_nacionalidade: vm.parte['nationality'].label || vm.parte['nationality'],
        ppart_profissao: vm.parte['professional'],
        ppart_data_nasc: moment(vm.parte['birthday'], 'DD/MM/YYYY').utcOffset(-3, true).format(),
        ppart_renda_mensal: Math.round(vm.parte['rendaMensal']),
      });

      propostaData.$saveSite()
        .then(function (succ) {
          vm.sucesso = true;
          swangular.swal({
            type: 'info',
            animation: false,
            title: '',
            html: '<h3>Seu cadastro foi adicionado a proposta</h3>',
            confirmButtonClass: 'btn button btn-default px-5',
            buttonsStyling: false,
            timer: 1500
          }).then(function (succ) {
            $state.go('main.home');
          })
        }, function (err) {
          console.log(err);
        })
    }

    vm.getGentilicosPropConjunta();

    jQuery('#form-nationality').val('brasileiro');
  }

  /* @ngInject */
  function propostaStatusController(
    $rootScope,
    $scope,
    $state,
    $q,
    $location,
    $http,
    $window,
    textFormatter,
    $stateParams,
    propostaStatus,
    ConfigWhiteLabel,
    swangular
  ) {
    var vm = this;

    vm.toDate = function (date) {
      return date && moment(date).format('DD/MM/YYYY') || '00/00/0000'
    }

    vm.circleClass = function (status) {
      var doneClass = vm.propostaStatus.status.order > status.order || vm.propostaStatus.status.name == "Finalizada" ? 'done' : ''

      return status.type + ' ' + doneClass
    }

    vm.stepTextClass = function (status) {
      if (vm.propostaStatus.status.name == status.name)
        return 'active'
      if (vm.propostaStatus.status.order > status.order)
        return 'done'
    }

    function openModal () {
      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        width: 'clamp(600px, 630px, 100%)',
        htmlTemplate: 'app/proposta/proposta.cotacoes-modal.html',
        controllerAs: 'vm',
        controller: 'cotacoesModalController',
        resolve: {
          cotacoes: function () {
            return propostaStatus.cotacao_seguros
          }
        }
      });
    }

    vm.openModal = openModal
    vm.formatPrice = textFormatter.formatPrice;
    vm.propostaStatus = propostaStatus;
    vm.statusList = propostaStatus.statusList
    vm.statusSize = vm.statusList.length

    vm.checkIfValid = function () {
      if (!vm.propostaStatus.cotacao_seguros || !vm.propostaStatus.cotacao_seguros.resultados) return false;

      return true;
    }

    vm.checkIfApproved = function () {
      if (vm.propostaStatus.cotacao_seguros && vm.propostaStatus.cotacao_seguros.resultados) {
        var approvedResults = vm.propostaStatus.cotacao_seguros.resultados.filter(function (res) {
          if (res.status === 'aprovado') return true;
        })

        if (!(approvedResults.length > 0)) return false;

        return true;
      }

      return true;
    }
  }

  /** @ngInject */
  function cotacoesModalController(
    $scope,
    $rootScope,
    $state,
    $stateParams,
    auth,
    swangular,
    cotacoes
  ) {
    var vm = this;
    vm.cotacoes = cotacoes;

    vm.resultados = vm.cotacoes.resultados.filter(function (res) {
      if (res.status === 'aprovado' || res.status === 'reprovado') return true;
    })

    vm.currentCotacao = {
      index: 0,
      cotacao: vm.resultados[0]
    };

    vm.changeCurrentCotacao = function (position) {
      if ((position > vm.resultados.length - 1) || (position < 0)) return;

      vm.currentCotacao.index = position;
      vm.currentCotacao.cotacao = vm.resultados[position];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('corretorPropostasController', corretorPropostasController)

  /* @ngInject */
  function corretorPropostasController(
    $rootScope,
    $scope,
    $state,
    $q,
    $location,
    $http,
    $window,
    textFormatter,
    $stateParams,
    corretorPropostas
  ) {
    var vm = this;

    vm.formatPrice = textFormatter.formatPrice;
    vm.propostas = corretorPropostas.propostas;

    vm.toDate = function (date) {
      return date && moment(date).format('DD/MM/YYYY') || '00/00/0000'
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('NossoTimeController', NossoTimeController)
    .controller('NossoTimeModalController', NossoTimeModalController);

  /* @ngInject */
  function NossoTimeController(
    $scope,
    $document,
    $state,
    $sce,
    $timeout,
    $http,
    PROD,
    $rootScope,
    SERVER_URL,
    SendEmail,
    swangular,
    $location,
    Corretor
  ) {
    var vm = this;
    var imob = $rootScope.ConfigWhiteLabel;
    vm.imob = imob;
    vm.trustAsHtml = function (string) {
      return $sce.trustAsHtml(string);
    };

    if (!vm.imob.imb_config_site.nossotime) {
      $state.go('main.home', {}, { reload: true });
    }

    $timeout(function () {
      init();
    });

    function init() {
      $('#header').addClass('fixed-theme');
      Corretor.find({
        filter: {
          where: {
            imb_id: vm.imob.id,
            status: true,
          },
          include: [
            {
              relation: 'telefones',
              scope: {
                include: ['telefone_tipo'],
              },
            },
            {
              relation: 'redessociais',
              scope: {
                include: ['rd_nome'],
              },
            },
          ],
        },
      }).$promise.then(function (res) {
        vm.corretores = res;
      });
    }

    vm.chamaNoZapBB = function (tel) {
      var url = 'https://api.whatsapp.com/send?phone=55';
      var num = tel.replace(/\D/g, '');

      vm.openTab(url + num);
    };

    vm.openTab = function (url) {
      window.open(url, '_blank');
    };

    vm.openDetails = function (corretor) {
      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        html: '<div class="slide-animate" ng-include="\'app/nossotime/detailmodal.html\'"></div>',
        width: 'auto',
        controllerAs: 'vm',
        controller: 'NossoTimeModalController',
        resolve: {
          dados: function () {
            return corretor;
          },
        },
      });
    };
  }

  function NossoTimeModalController(
    $scope,
    $document,
    $state,
    $sce,
    $timeout,
    $http,
    PROD,
    $rootScope,
    SERVER_URL,
    SendEmail,
    swangular,
    $location,
    dados
  ) {
    var vm = this;
    vm.corretor = dados;

    vm.chamaNoZapBB = function (tel) {
      var url = 'https://api.whatsapp.com/send?phone=55';
      var num = tel.replace(/\D/g, '');

      vm.openTab(url + num);
    };

    vm.openTab = function (url) {
      window.open(url, '_blank');
    };
  }
})();

(function () {
  'use strict';

  angular.module('arboWeb').controller('MainController', MainController);

  MainController.inject = [
    '$timeout',
    '$document',
    'webDevTec',
    'toastr',
    '$rootScope',
    '$state',
    '$scope',
    'ConfigWhiteLabel',
    'ngMeta',
  ];
  /** @ngInject */
  function MainController(
    $timeout,
    $document,
    webDevTec,
    toastr,
    $rootScope,
    $state,
    $scope,
    ConfigWhiteLabel,
    ngMeta,
    $window,
    seoService,
    $location
  ) {
    //$document.scrollTop(0, 20000);

    $rootScope.ConfigWhiteLabel = ConfigWhiteLabel;
    switch ($state.current.name) {
      case 'main.termsuse':
        seoService.generateTags({
          title:
            'Termos de Uso - Arbo imóveis' +
            ($rootScope.ConfigWhiteLabel.isArbo ? '- Arbo imóveis' : ''),
          description:
            'Leia atentamente estes termos de serviço, pois eles contêm informações importantes sobre seus direitos, recursos e obrigações. Ao acessar e/ou utilizar os serviços da ARBO, você concorda em cumprir com estes Termos de Serviço e em estar sujeito a eles.',
          slug: $location.absUrl(),
        });
        break;
      case 'main.privacypolicy':
        seoService.generateTags({
          title:
            'Políticas de Privacidade' +
            ($rootScope.ConfigWhiteLabel.isArbo ? '- Arbo imóveis' : ''),
          description:
            'Todas as informações pessoais relativas aos Usuários que acessam e utilizam a Plataforma ARBO são tratadas em concordância com a Lei 12.965/2014 (Marco Civil da Internet) e a Lei 13.709/18 (Lei de Proteção de Dados).',
          slug: $location.absUrl(),
        });
        break;
      default:
        break;
    }

    // Google PageView
    // gtag('config', 'UA-91552221-1');

    localStorage.removeItem('size-window');
    $scope.showHeader = function () {
      return (
        $state.current.url !== '/status/:hash' &&
        $state.current.name.indexOf('main.proposta.corretor') != 0
      );
    };
    $scope.showFooter = function () {
      return (
        $state.current.name.indexOf('main.search') != 0 &&
        $state.current.url !== '/status/:hash' &&
        $state.current.name.indexOf('main.proposta.corretor') != 0
      );
    };
    $scope.showFooterBairro = function () {
      return $state.current.name.indexOf('main.search-neighborhood') != 0;
    };
    $rootScope.$on(
      '$stateChangeSuccess',
      function (event, toState, toParams, fromState, fromParams) {
        if (toState.name != 'main.search-neighborhood') {
          $('#list-social').removeClass('col-md-3');
          $('.list-social').css({ 'margin-bottom': '0' });
          $('#action-list').appendTo('#action-list-col');
        }
      }
    );

    function upperLabel() {
      angular.element('input.upper').each(function (index, element) {
        var $this = $(this);
        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      });

      angular.element('textarea.upper').each(function (index, element) {
        var $this = $(this);
        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      });
    }

    document.addEventListener(
      'focus',
      function (e) {
        upperLabel();
        e.preventDefault();
      },
      true
    );
    document.addEventListener(
      'blur',
      function (e) {
        upperLabel();
        e.preventDefault();
      },
      true
    );

    $timeout(function () {
      upperLabel();
    });
  }
})();

(function () {

  'use strict';

  angular
    .module('arboWeb')
    .directive('searchMap', searchMap);

  searchMap.inject = ['Imovel', '$rootScope', '$timeout', '$state', '$http', '$stateParams', '$document', 'textFormatter', 'ngMeta', 'PROD', '$window', '$location', 'toastr', 'API_MAPBOX'];

  function searchMap(Imovel, $rootScope, $timeout, $state, $http, $stateParams, $document, textFormatter, ngMeta, PROD, $window, $location, toastr, API_MAPBOX) {
    var directive = {
      bindToController: true,
      controller: SearchMapController,
      controllerAs: 'vm',
      link: {
        post: link
      },
      restrict: 'A',
      scope: {}
    };
    return directive;

    function SearchMapController() {
      var vm = this;
      vm.initMap = true;
      vm.markers = [];
      vm.myMarkers = [];
    }

    function link(scope, element, attrs, ctrl) {
      if(!$rootScope.botreq){

        var vm = ctrl;
        var optimizedDatabaseLoading = 1;
        var markerTarget = "modal";
        var sidebarResultTarget = "modal";
        var showMarkerLabels = false;
        var mapDefaultZoom = 13;
        var mapNumberZoom = 18;
        var mapNeighborhoodZoom = 15;
        var mapStreetZoom = 16;
        var _latitude = 0;
        var _longitude = 0;
        var wait = false;
        var autocomplete = null;
        var _zoom = false;
        var _searchAddress = '';

        vm.geoLocate = geoLocate;
        vm.initializeMap = initializeMap;
        vm.search = search;
        vm.autoComplete = autoComplete;
        vm.initializeMapEvents = initializeMapEvents;
        vm.infoWindow = null;
        vm.noResize = false;
        vm.Coordenadas = {
          // "Araraquara": {
          //   "latitude": -21.7794,
          //   "longitude": -48.2277
          // },
          // "Sao Carlos": {
          //   "latitude": -22.0185,
          //   "longitude": -47.9310
          // },
          // "PresidentePrudente": {
          //   "latitude": -22.1206,
          //   "longitude": -51.4210
          // },
          // "Piracicaba": {
          //   "latitude": -22.728191,
          //   "longitude": -47.645601
          // },
          // "Londrina": {
          //   "latitude": -23.3045,
          //   "longitude": -51.1696
          // },
          // "BragancaPaulista": {
          //   "latitude": -22.9411,
          //   "longitude": -46.5626
          // }
        };

        // angular.element(window).resize(function () {
        //   if (angular.element(window).width() <= 800) {
        //     if (angular.element('#main-content').height() >= angular.element(window).height()) {
        //       _height = (angular.element(window).height() - 65);
        //     } else {
        //       _height = (angular.element('#main-content').height() - 265);
        //     }
        //   }
        //   _resize();
        // });

        // function _resize() {
        //   var size;
        //   if (localStorage.getItem('size-window')) {
        //     size = localStorage.getItem('size-window');
        //   } else {
        //     size = (angular.element(window).height() - 121)
        //     localStorage.setItem('size-window', size);
        //   }
        //   angular.element(".hero-section.full-screen").height(size);

        // }

        // if (angular.element(window).width() <= 800) {
        //   var _height = 0;
        //   if (angular.element('#main-content').height() >= angular.element(window).height()) {
        //     _height = (angular.element(window).height() - 65);
        //   } else {
        //     _height = (angular.element('#main-content').height() - 265);
        //   }
        // }

        scope.$on('listingMapRefresh', function (event, args) {

          // var mapTipoImovel = {
          //   'apartamento': 'Apartamentos',
          //   'apartamento-duplex': 'Apartamentos Duplex',
          //   'barracao': 'Barracões',
          //   'casa': 'Casas',
          //   'chacara': 'Chácaras',
          //   'cobertura': 'Coberturas',
          //   'loja': 'Lojas',
          //   'sala': 'Salas',
          //   'sobrado': 'Sobrados',
          //   'terreno': 'Terrenos'
          // }

          // $rootScope.contImoveis = args.listings.length;
          // $rootScope.tipovar = $stateParams.tipovar;

          // for (var x in mapTipoImovel) {
          //   if($stateParams.tipoimovel == x) {
          //     $rootScope.tipoimovel = mapTipoImovel[x];
          //   }
          // }

          if (vm.initMap) {
            activate();
            // debugger
            if(args.cidade){
            geoLocate(args.cidade);
           }else if ($rootScope.newBairro){
            geoLocate($rootScope.newBairro.brr_nome + ' - ' + $rootScope.newBairro.brr_cidade);
           }
          }
          vm.initMap = false;

          vm.markers = [];
          //
          if (args.listings != null && args.listings.length > 0) {
            for (var x in args.listings) {
              var res = args.listings[x];
              //
              if (res.imv_location !== undefined && res.imv_location !== null) {
                var marker = {
                  id: res.id,
                  code: res.imv_cod_gaia,
                  latitude: res.imv_location.lat,
                  longitude: res.imv_location.lng,
                };

                vm.markers.push(marker);
              }

            }

            if (!vm.wait) {
              vm.loadData();
            }
          } else {
            vm.loadData();
          }

        });

        function activate() {

          if($rootScope.newBairro){
            _latitude = $rootScope.newBairro.brr_location.lat || 0;
            _longitude = $rootScope.newBairro.brr_location.lng || 0;
          }
          // _resize();

          // if ($stateParams.cidade != null) {
          //   vm.geoLocate();
          // } else {
          //   _latitude = -23.3045;
          //   _longitude = -51.1696;

          //   var _address = "Londrina, PR";


          //   scope.$parent.vm.searchValue = _address;
          // }

          if (!vm.wait) {
            vm.initializeMap(optimizedDatabaseLoading, _latitude, _longitude, markerTarget, sidebarResultTarget, showMarkerLabels, mapDefaultZoom);
          }

        }
        function processGMapsRow(item) {
          var zipcode = null;
          var number = null;
          var bairro = null;
          var logradouro = null;
          var cidade = null;
          var estado = null;
          var pais = null;
          item.address_components.forEach(function (element) {
            if (element.types[0] == "postal_code") {
              zipcode = element.long_name;
            } else if (element.types[0] == "street_number") {
              number = element.long_name;

              if (number.indexOf(',') != -1) {
                number = number.split(',')[0];
              }
            } else if (element.types[0] == 'neighborhood' || element.types[1] == 'sublocality') {
              bairro = element.long_name;
            } else if (element.types[0] == 'route') {
              logradouro = element.long_name;
            } else if (element.types[0] == 'administrative_area_level_2') {
              cidade = element.long_name;
            } else if (element.types[0] == 'administrative_area_level_1') {
              estado = element.long_name;
            } else if (element.types[0] == 'country') {
              pais = element.long_name
            }
          }, this);

          //    if (zipcode != null) {
          return {
            label: item.formatted_address,
            value: item.formatted_address,
            latitude: item.geometry.location.lat,
            longitude: item.geometry.location.lng,
            zipcode: zipcode,
            number: number,
            bairro: bairro,
            logradouro: logradouro,
            cidade: cidade,
            estado: estado,
            pais: pais
          };
          //    }
        }
        // function processGMapsRow(item) {
        //   var zipcode = null;
        //   var number = null;
        //   var bairro = null;
        //   var logradouro = null;
        //   var cidade = null;
        //   var estado = null;
        //   item.address_components.forEach(function (element) {
        //     if (element.types[0] == "postal_code") {
        //       zipcode = element.long_name;
        //     } else if (element.types[0] == "street_number") {
        //       number = element.long_name;

        //       if (number.indexOf(',') != -1) {
        //         number = number.split(',')[0];
        //       }
        //     } else if (element.types[0] == 'neighborhood' || element.types[1] == 'sublocality') {
        //       bairro = element.long_name;
        //     } else if (element.types[0] == 'route') {
        //       logradouro = element.long_name;
        //     } else if (element.types[0] == 'administrative_area_level_2') {
        //       cidade = element.long_name;
        //     } else if (element.types[0] == 'administrative_area_level_1') {
        //       estado = element.long_name;
        //     }
        //   }, this);

        //   // $(item.address_components).each(function () {
        //   //     if (this.types[0] == "postal_code") {
        //   //         zipcode = this.long_name;
        //   //     }
        //   //     else if (this.types[0] == "street_number") {
        //   //         number = this.long_name;

        //   //         if (number.indexOf(',') != -1) {
        //   //             number = number.split(',')[0];
        //   //         }
        //   //     }
        //   //     else if (this.types[0] == 'neighborhood') {
        //   //         bairro = this.long_name;
        //   //     }
        //   //     else if (this.types[0] == 'route') {
        //   //         logradouro = this.long_name;
        //   //     }
        //   //     else if (this.types[0] == 'administrative_area_level_2') {
        //   //         cidade = this.long_name;
        //   //     }
        //   //     else if (this.types[0] == 'administrative_area_level_1') {
        //   //         estado = this.long_name;
        //   //     }
        //   // });

        //   //    if (zipcode != null) {
        //   return {
        //     label: item.formatted_address,
        //     value: item.formatted_address,
        //     latitude: item.geometry.location.lat(),
        //     longitude: item.geometry.location.lng(),
        //     zipcode: zipcode,
        //     number: number,
        //     bairro: bairro,
        //     logradouro: logradouro,
        //     cidade: cidade,
        //     estado: estado
        //   };
        //   //    }
        // }

        function geoLocate(location) {
          vm.wait = false;
          var searchAddress = _searchAddress = location || ($stateParams.cidade && $stateParams.cidade.trim().length > 0 ? $stateParams.cidade : undefined);

          // vm.initializeMap(optimizedDatabaseLoading, _latitude, _longitude, markerTarget, sidebarResultTarget, showMarkerLabels, mapDefaultZoom);
          if (searchAddress == null) {
            // vm.loadData();
          } else {
            // searchAddress = searchAddress.replace(/-/g, ' ');
            // var geocoder = new google.maps.Geocoder();
            // var geoOptions = {
            //   address: searchAddress
            // };

            function setupMap(results) {
              var verify_type = processGMapsRow(results.data);

              // vm.map.setCenter(results.data.geometry.location);
              vm.map.fitBounds([
                [results.data.geometry.viewport.northeast.lat, results.data.geometry.viewport.northeast.lng],
                [results.data.geometry.viewport.southwest.lat, results.data.geometry.viewport.southwest.lng]
              ]);

              $window.gtag('event', 'map_usage', {
                'event_category': 'arbo_site_map_load',
                'event_label': 'search_map',
                'value': _searchAddress,
                'coordinates': vm.map.getCenter().lat + ',' + vm.map.getCenter().lng
              });

              if (verify_type.number) {
                vm.map.setZoom(mapNumberZoom);
              } else if (verify_type.bairro) {
                vm.map.setZoom(mapNeighborhoodZoom);
              } else if (verify_type.logradouro) {
                vm.map.setZoom(mapStreetZoom);
              } else {
                // vm.map.setZoom(14);
                // var bounds = new google.maps.LatLngBounds();
                // bounds.extend(results.data.geometry.viewport.northeast);
                // bounds.extend(results.data.geometry.viewport.southwest);
              }

            }
            if($rootScope.geoCache){
              setupMap($rootScope.geoCache)
            }else{
              $http.get('//api-site.arboimoveis.com.br/api/geocaches/search/'+searchAddress)
              .then(function (results, error) {
                setupMap(results)

                // geocoder.geocode(geoOptions, function (results, status) {
                //   if (status === 'OK') {
                //   resultsMap.setCenter(results[0].geometry.location);
                //   var marker = new google.maps.Marker({
                //     map: resultsMap,
                //     position: results[0].geometry.location
                //   });
                //console.log(results[0].address_components[0]);

                // if (verify_type.number) {
                //   vm.map.setZoom(18);
                // } else if (verify_type.logradouro) {
                //   vm.map.setZoom(16);
                // } else if (verify_type.bairro) {
                //   vm.map.setZoom(15);
                // } else if (verify_type.cidade) {
                //   vm.map.setZoom(13);
                // }else{
                //   vm.map.setZoom(11);
                // }
                //vm.map.setZoom(17);
                //   vm.wait = true;
                //   vm.loadData();
                // } else {
                //   toastr.warning('Não foi encontrado nenhuma localização para esta busca.');
                //   $state.go('main.search-address');
                // }
              });
            }



          }
        }
        function initializeMap(optimizedDatabaseLoading, _latitude, _longitude, markerTarget, sidebarResultTarget, showMarkerLabels, mapDefaultZoom) {
          //
          // console.log(google.maps.ZoomControlStyle.SMALL);

          var style = [
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "saturation": -100,
                  "color": "#dddddd"
                }
              ]
            },
            {
              "featureType": "poi.school",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "color": "#dddddd"
                }
              ]
            },
            {
              "elementType": "labels.text",
              "stylers": [
                {
                  "saturation": -100
                }
              ]
            }
          ];

          // vm.map = new google.maps.Map(document.querySelector('#map-homepage'), {
          //   zoom: mapDefaultZoom,
          //   minZoom: 9,
          //   center: new google.maps.LatLng(_latitude, _longitude),
          //   mapTypeId: "roadmap",
          //   streetViewControl: false,
          //   scrollwheel: true,
          //   mapTypeControl: false,
          //   styles: style,
          //   zoomControl: true,
          //   zoomControlOptions: {
          //       position: google.maps.ControlPosition.LEFT_BOTTOM
          //   },
          //   fullscreenControl: false
          // });
          vm.map = L.map('map-homepage', { zoomControl: false }).setView([_latitude, _longitude], mapDefaultZoom);
          var imageIconn = '../../assets/images/novosite/_marker.svg';
          var _markerIcons_Style = L.icon({
            iconUrl: imageIconn,
            iconSize:     [25, 35], // size of the icon
            // shadowSize:   [50, 64], // size of the shadow
            // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
            // shadowAnchor: [4, 62],  // the same for the shadow
            // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
          });

          if($rootScope.newBairro.brr_nome){
            L.marker([_latitude, _longitude],{icon: _markerIcons_Style}).addTo(vm.map);
          }

          L.control.zoom({ position: 'bottomleft' }).addTo(vm.map);
          L.tileLayer(
            'https://api.mapbox.com/styles/v1/desenvolvimentoarbo/ck7noi1870ox01iqpixwhcxau/tiles/512/{z}/{x}/{y}?access_token='+API_MAPBOX, {
              tileSize: 512,
              zoomOffset: -1,
              minZoom: '11', // Max ZoomOut
              attribution: '© <a href="https://www.mapbox.com/map-feedback/">Mapbox</a> and <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }
          ).addTo(vm.map);

          vm.autoComplete(vm.map, vm.marker);
          vm.initializeMapEvents();
        }
        scope.$on('changeMapCity', function (event, location) {
          // console.log(coordenates)
          // console.log(optimizedDatabaseLoading, coordenates.latitude, coordenates.longitude, markerTarget, sidebarResultTarget, showMarkerLabels, mapDefaultZoom);
          // vm.initializeMap(optimizedDatabaseLoading, coordenates.latitude, coordenates.longitude, markerTarget, sidebarResultTarget, showMarkerLabels, mapDefaultZoom);

          geoLocate(location);
        });
        function autoComplete(map, marker) {
          if (angular.element("#address-autocomplete").length) {
            if (!map) {
              vm.map = map = new google.maps.Map(document.querySelector("#address-autocomplete"));
            }
            var input = document.querySelector('#address-autocomplete');
            autocomplete = new google.maps.places.Autocomplete(input, { sessionToken: '1234567890' });
            autocomplete.bindTo('bounds', map);

            function success(position) {
              // map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
              map.setView([position.coords.latitude, position.coords.longitude], mapDefaultZoom)
            }
          }
        }
        function search(auto) {
          // Quando seleciona da lista do google!!!
          // if (angular.element(window).width() <= 767) {

          //     $document.scrollTo(50, 0, 500);
          // }

          // var place = auto.getPlace();

          // if (!place.geometry) {
          //     return;
          // }

          // if (place.geometry.viewport) {
          //     vm.map.fitBounds(place.geometry.viewport);
          // } else {
          //     vm.map.setCenter(place.geometry.location);
          //     vm.map.setZoom(17);
          // }
          // var address = '';
          // if (place.address_components) {

          //     var address_components = angular.copy(place.address_components);
          //     if (address_components[address_components.length - 1].types[0] == "country") {
          //         delete address_components[address_components.length - 1];
          //     }

          //     var rev_address_components = address_components.reverse();

          //     var _address = rev_address_components[2].long_name + ', ' + rev_address_components[1].short_name;

          // }
        }
        angular.element('#address-autocomplete').on("keydown", function (event) {
          if (event.keyCode == 13) {
            vm.entered = true;
            vm.geoLocate(angular.element('#address-autocomplete')[0].value);
          } else {
            vm.entered = false;
          }
        });
        angular.element('#searchBtn').on("click", function (event) {
          vm.geoLocate(angular.element('#address-autocomplete')[0].value);
        });

        function initializeMapEvents() {
          var i;
          var a;
          var newMarkers = [];
          // var resultsArray = [];
          // var visibleMarkersId = [];
          var markerCluster = L.markerClusterGroup({
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: true,
            iconCreateFunction: function(cluster) {
              return L.divIcon({ iconSize: [36, 36], className: 'leaflet-div-icon-custom', html: '<div class="cluster"><div>' + cluster.getChildCount() + '</div></div>' });
            }
          });
          var mapAutoZoom;
          // var searchClicked;
          var startChange = false;
          var zoomInit = false;

          // google.maps.event.addListener(vm.map, 'bounds_changed', function () {
          //   if (!vm.noResize) {
          //     startChange = true;
          //   } else {
          //     vm.noResize = false;
          //   }
          // });
          //google.maps.event.addListener(autocomplete, 'place_changed', function() {
          //    if (!vm.entered) {
          //        vm.search(autocomplete);
          //    }
          //});
          // google.maps.event.addListener(vm.map, 'zoom_changed', function() {
          //   if(zoomInit){
          //     _zoom = true;
          //   }else{
          //     zoomInit = true;
          //   }
          //
          // });
          // google.maps.event.addListener(vm.map, 'drag', function() {
          //   _zoom = true;
          // });
          // google.maps.event.addListener(vm.map, 'idle', function () {
          //   if (searchClicked != 1 && startChange && vm.map.center.lat() != 0) {
          //     if(_zoom){
          //       _zoom = false;
          //       delete $stateParams.pagina;
          //
          //       $state.transitionTo($state.current.name, $stateParams, {
          //         location: true,
          //         inherit: true,
          //         relative: $state.$current,
          //         notify: false
          //       });
          //     }
          //
          //     var coordinates = {
          //       north_east: {
          //         lat: vm.map.getBounds().getNorthEast().lat(),
          //         lng: vm.map.getBounds().getNorthEast().lng()
          //       },
          //       south_west: {
          //         lat: vm.map.getBounds().getSouthWest().lat(),
          //         lng: vm.map.getBounds().getSouthWest().lng()
          //       },
          //       center: {
          //         lat: vm.map.getCenter().lat(),
          //         lng: vm.map.getCenter().lng()
          //       }
          //     };
          //
          //     var coord = angular.copy(coordinates);
          //
          //     startChange = false;
          //
          //     $rootScope.$broadcast('mapRefresh', coord);
          //   }
          // });

          // There isn't a bounds changed event. So we'll use a moveend for this purpose.
          vm.map.on('dragend', function() {
            _zoom = true;

            $window.gtag('event', 'map_usage', {
              'event_category': 'arbo_site_map_dragend',
              'event_label': 'search_map',
              'value': _searchAddress,
              'coordinates': vm.map.getCenter().lat + ',' + vm.map.getCenter().lng
            });
          });
          vm.map.on('zoomlevelschange zoomend', function() {
            if (zoomInit) _zoom = true;
            else zoomInit = true;

            $window.gtag('event', 'map_usage', {
              'event_category': 'arbo_site_map_zoom',
              'event_label': 'search_map',
              'value': _searchAddress,
              'coordinates': vm.map.getCenter().lat + ',' + vm.map.getCenter().lng
            });
          });
          vm.map.on('moveend', function() {
            if(_zoom){
              _zoom = false;
              delete $stateParams.pagina;

              $state.transitionTo($state.current.name, $stateParams, {
                location: true,
                inherit: true,
                relative: $state.$current,
                notify: false
              });
            }

            var coordinates = {
              north_east: {
                lat: vm.map.getBounds().getNorthEast().lat,
                lng: vm.map.getBounds().getNorthEast().lng
              },
              south_west: {
                lat: vm.map.getBounds().getSouthWest().lat,
                lng: vm.map.getBounds().getSouthWest().lng
              },
              center: {
                lat: vm.map.getCenter().lat,
                lng: vm.map.getCenter().lng
              }
            };

            var coord = angular.copy(coordinates);
            startChange = false;

            $window.gtag('event', 'map_usage', {
              'event_category': 'arbo_site_map_moveend',
              'event_label': 'search_map',
              'value': _searchAddress,
              'coordinates': vm.map.getCenter().lat + ',' + vm.map.getCenter().lng
            });

            $rootScope.$broadcast('mapRefresh', coord);
          });

          vm.makeUrl = makeUrl;

          function makeUrl(listing) {
            var urlPath = $location.$$url.split('?')[0].split('#')[0];
            var description = textFormatter.removeSpecialChar(listing.imv_titulo)
            return (urlPath + '/imovel/' + description + '/' + listing.imv_cod_gaia);
          }

          vm.loadData = function () {
            vm.myMarkers = [];
            if (markerCluster != undefined) {
              markerCluster.clearLayers();
            }

            // for (var i = 0; i < newMarkers.length; i++) {
            //   newMarkers[i].setMap(null);
            // }
            vm.allMarkers = vm.markers;
            placeMarkers(vm.markers);
          };

          function placeMarkers(markers) {
            newMarkers = [];

            for (i = 0; i < markers.length; i++) {

              var marker;
              var markerContent = document.createElement('div');
              var thumbnailImage;

              if (markers[i]["latitude"] && markers[i]["longitude"] && markers[i]["address"]) {
                renderRichMarker(markers[i].id, markers[i], "latitudeLongitude");
              } else if (markers[i]["address"] && !markers[i]["latitude"] && !markers[i]["longitude"]) {
                renderRichMarker(markers[i].id, markers[i], "address");
              } else if (markers[i]["latitude"] && markers[i]["longitude"] && !markers[i]["address"]) {
                renderRichMarker(markers[i].id, markers[i], "latitudeLongitude");
              } else { }
            }

            function renderRichMarker(i, marker, method) {
              if (method == "latitudeLongitude") {
                // var image = {
                //   url: '../../assets/images/novosite/_marker.svg',
                //   size: new google.maps.Size(27, 46),
                //   scaledSize: new google.maps.Size(22, 29)
                // };
                // var image = {
                //   url: '../../assets/images/novosite/old_marker.svg',
                //   size: new google.maps.Size(35, 45),
                //   scaledSize: new google.maps.Size(25, 35)
                // };
                var imageIcon = '../../assets/images/novosite/_marker.svg';
                if (!$rootScope.ConfigWhiteLabel.isArbo) {
                  // var image = {
                  //   url: '../../assets/images/novosite/_marker.svg',
                  //   size: new google.maps.Size(35, 45),
                  //   scaledSize: new google.maps.Size(25, 35)
                  // }
                  // } else {
                  var svgMarker = '<svg aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="'+($rootScope.ConfigWhiteLabel.primary_color.trim() || '#00BF6F')+'" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>'
                  imageIcon = encodeURI('data:image/svg+xml,' + svgMarker).replace('#','%23');
                  // var image = {
                  //   path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z',
                  //   fillColor: $rootScope.ConfigWhiteLabel.primary_color,
                  //   fillOpacity: 1,
                  //   anchor: new google.maps.Point(0, 0),
                  //   strokeWeight: 1.8,
                  //   strokeColor: '#FFF',
                  //   scale: 0.07
                  // }
                }

                // var _marker = new google.maps.Marker({
                //   position: new google.maps.LatLng(marker["latitude"], marker["longitude"]),
                //   optimized: false,
                //   map: vm.map,
                //   icon: image,
                //   draggable: false,
                //   content: markerContent,
                //   flat: true,
                //   title: marker["title"],
                //   url: marker["url"]
                // });

                var _markerIcon = L.icon({
                  iconUrl: imageIcon,
                  iconSize:     [25, 35], // size of the icon
                  // shadowSize:   [50, 64], // size of the shadow
                  // iconAnchor:   [22, 94], // point of the icon which will correspond to marker's location
                  // shadowAnchor: [4, 62],  // the same for the shadow
                  // popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
                });

                var _marker = L.marker([marker["latitude"], marker["longitude"]], {icon: _markerIcon});
                _marker.on('click', function(e) {

                  vm.wait = true;
                  $timeout(function(){
                    vm.wait = false; // SOMENTE PARA NAO RECARREGAR AS INFOS DO MAPA QUANDO CLICAR
                  }, 1600)
                  Imovel.getImoveisNew({ where: { id: i }})
                    .$promise
                    .then(function (data) {
                      var imovel = data[0];
                      var urlImovel = makeUrl(imovel);

                      if (imovel.fotos && imovel.fotos[0]) {
                        var cod_gaia = imovel.imv_cod_gaia;
                        var urlThumb = imovel.fotos[0].imvft_url;
                        urlThumb = urlThumb.replace(cod_gaia, cod_gaia + '/320x240');
                      }

                      if ($state.params.tipovar != undefined) {
                        $state.params.tipovar == 'a-venda' && imovel.imv_preco_venda ? imovel.imv_preco_venda : ($state.params.tipovar == 'para-alugar' && imovel.imv_preco_locacao ? imovel.imv_preco_locacao : (imovel.imv_preco_venda ? imovel.imv_preco_venda : imovel.imv_preco_locacao))
                      }

                      if (($state.params.tipovar == 'para-alugar') || ($state.params.tipovar == null && imovel.imv_preco_locacao && !imovel.imv_preco_venda)) {
                        imovel.preco_exibir = imovel.imv_preco_locacao
                      } else if (($state.params.tipovar == 'a-venda') || ($state.params.tipovar == null && imovel.imv_preco_venda)) {
                        imovel.preco_exibir = imovel.imv_preco_venda
                      }


                      var contentString = '' +
                        '<div id="info-card-map" class="info-card-map">' +
                        '<div class="result-item result-card-map d-flex flex-column mb-5">' +
                        '<a href="' + urlImovel + '" class="result">' +
                        '<div class="info-card-image">' +
                        '<img src="' + urlThumb + '" alt="'+ (imovel.subtipo_imovel && imovel.subtipo_imovel.stimv_nome || imovel.tipo_imovel && imovel.tipo_imovel.timv_nome) + imovel.imv_endereco+'">' +
                        '</div>' +
                        '</a>' +
                        '<a href="' + urlImovel + '" class="result">' +
                        '<div class="result-description">' +
                        '<div class="row">' +
                        '<div class="row col-12">' +
                        '<p itemprop="nome" class="title col-12"> ' + (imovel.subtipo_imovel && imovel.subtipo_imovel.stimv_nome || imovel.tipo_imovel && imovel.tipo_imovel.timv_nome) + '</p>' +
                        '<em class="cod col-12">cód. ' + imovel.imv_cod_gaia + '</em>' +
                        '</div>' +
                        ((!imovel.imobiliaria.imb_hidden_address) ? ('<p class="address col-8">' + imovel.imv_endereco + '</p>') : '') +
                        '<p class="imobiliaria col-8"> ' + (imovel.imobiliaria ? (imovel.imobiliaria.imb_nome + '  ' + imovel.imobiliaria.imb_creci) : '') + '</p>' +
                        '<div class="row col-12">' +
                        '<div class="comodidades col-7 row">' +
                        '<div class="col">' +
                        '<i class="fal fa-ruler-triangle"></i>' +
                        '<p>' + (imovel.imv_area_util ? (imovel.imv_area_util + '<span>m<sup>2</sup></span>') : '-') + '</p>' +
                        '</div>' +
                        '<div class="col">' +
                        '<i class="fal fa-bed"></i>' +
                        '<p>' + (imovel.imv_qtd_dorm ? imovel.imv_qtd_dorm : '-') + '</p>' +
                        '</div>' +
                        '<div class="col">' +
                        '<i class="fal fa-shower"></i>' +
                        '<p>' + (imovel.imv_qtd_banheiros ? imovel.imv_qtd_banheiros : '-') + '</p>' +
                        '</div>' +
                        '<div class="col">' +
                        '<i class="fal fa-car"></i>' +
                        '<p>' + (imovel.imv_qtd_vagas ? imovel.imv_qtd_vagas : '-') + '</p>' +
                        '</div>' +
                        '</div>' +
                        '<div class="offer-info col-5">' +
                        '<p class="offer-cond">' + (imovel.imv_preco_cond ? 'Condomínio <br />R$' : '') +
                        (imovel.imv_preco_cond ? imovel.imv_preco_cond : '') + '</p>' +
                        '<div class="offer-contaner">' +
                        '<em class="offer"><span>R$</span> ' +
                        textFormatter.formatPrice(imovel.preco_exibir) +
                        '</em>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</div>' +
                        '</a>' +
                        '</div>' +
                        '</div>';

                      _marker.bindPopup(contentString)
                        .openPopup();

                      // Since the popup element is only available in the DOM after it's open, that's the available time to transform its css

                      $('.leaflet-popup-content').css({'margin': '0', 'width': 'auto'});
                      $('.leaflet-popup-content-wrapper').css({'padding': '0'});
                    })
                    .catch(function (err) {console.error(err)});
                });
                // _marker.addTo(vm.map)
                //   .bindPopup(markerContent);

                // _marker.set("id", i);

                vm.myMarkers.push(_marker);

                // google.maps.event.addListener(marker, 'click', (function (marker, i) {

                //   return function () {
                //     // var _listing = markers[i].listing;
                //     // var _address = _listing.address.street + '-' + _listing.address.neighborhood + '-' + _listing.address.city + '-' + _listing.address.state;
                //     // _address = textFormatter.urlFormatter(_address);

                //     // var _route = (_listing.type == 'space' ? 'storage' : 'garagem');

                //     // var url = $state.href('main.' + _route + '-sub', {
                //     //   id: _listing.id,
                //     //   dummy: _address
                //     // });
                //     //window.open(url, '_blank');
                //   }
                // })(marker, i));

                // _marker.addListener('click', function (e) {
                //   vm.noResize = true;
                //
                //   // Fecha o card quando clicado novamente no pin
                //   if (vm.infoWindow !== null) {
                //     vm.infoWindow.close();
                //     vm.infoWindow = null;
                //   }
                //   else {
                //     Imovel.getImoveisNew({
                //       where: {
                //         id: i
                //       }
                //     }).$promise.then(
                //       function (succ) {
                //         var imovel = succ[0];
                //         var urlImovel = makeUrl(imovel);
                //
                //         if (imovel.fotos && imovel.fotos[0]) {
                //           var cod_gaia = imovel.imv_cod_gaia;
                //           var urlThumb = imovel.fotos[0].imvft_url;
                //           urlThumb = urlThumb.replace(cod_gaia, cod_gaia + '/320x240');
                //         }
                //         if ($state.params.tipovar != undefined) {
                //           $state.params.tipovar == 'a-venda' && imovel.imv_preco_venda ? imovel.imv_preco_venda : ($state.params.tipovar == 'para-alugar' && imovel.imv_preco_locacao ? imovel.imv_preco_locacao : (imovel.imv_preco_venda ? imovel.imv_preco_venda : imovel.imv_preco_locacao))
                //         }
                //         if (($state.params.tipovar == 'para-alugar') || ($state.params.tipovar == null && imovel.imv_preco_locacao && !imovel.imv_preco_venda)) {
                //           imovel.preco_exibir = imovel.imv_preco_locacao
                //         } else if (($state.params.tipovar == 'a-venda') || ($state.params.tipovar == null && imovel.imv_preco_venda)) {
                //           imovel.preco_exibir = imovel.imv_preco_venda
                //         }
                //
                //         var contentString = '' +
                //           '<div id="info-card-map" class="info-card-map">' +
                //           '<div class="result-item result-card-map d-flex flex-column mb-5">' +
                //           '<a href="' + urlImovel + '" class="result">' +
                //           '<div class="info-card-image">' +
                //           '<img src="' + urlThumb + '" alt="'+ (imovel.subtipo_imovel && imovel.subtipo_imovel.stimv_nome || imovel.tipo_imovel && imovel.tipo_imovel.timv_nome) + imovel.imv_endereco+'">' +
                //           '</div>' +
                //           '</a>' +
                //           '<a href="' + urlImovel + '" class="result">' +
                //           '<div class="result-description">' +
                //           '<div class="row">' +
                //           '<div class="row col-12">' +
                //           '<p itemprop="nome" class="title col-12"> ' + (imovel.subtipo_imovel && imovel.subtipo_imovel.stimv_nome || imovel.tipo_imovel && imovel.tipo_imovel.timv_nome) + '</p>' +
                //           '<em class="cod col-12">cód. ' + imovel.imv_cod_gaia + '</em>' +
                //           '</div>' +
                //           ((!imovel.imobiliaria.imb_hidden_address) ? ('<p class="address col-8">' + imovel.imv_endereco + '</p>') : '') +
                //           '<p class="imobiliaria col-8"> ' + (imovel.imobiliaria ? (imovel.imobiliaria.imb_nome + '  ' + imovel.imobiliaria.imb_creci) : '') + '</p>' +
                //           '<div class="row col-12">' +
                //           '<div class="comodidades col-7 row">' +
                //           '<div class="col">' +
                //           '<i class="fal fa-ruler-triangle"></i>' +
                //           '<p>' + (imovel.imv_area_util ? (imovel.imv_area_util + '<span>m<sup>2</sup></span>') : '-') + '</p>' +
                //           '</div>' +
                //           '<div class="col">' +
                //           '<i class="fal fa-bed"></i>' +
                //           '<p>' + (imovel.imv_qtd_dorm ? imovel.imv_qtd_dorm : '-') + '</p>' +
                //           '</div>' +
                //           '<div class="col">' +
                //           '<i class="fal fa-shower"></i>' +
                //           '<p>' + (imovel.imv_qtd_banheiros ? imovel.imv_qtd_banheiros : '-') + '</p>' +
                //           '</div>' +
                //           '<div class="col">' +
                //           '<i class="fal fa-car"></i>' +
                //           '<p>' + (imovel.imv_qtd_vagas ? imovel.imv_qtd_vagas : '-') + '</p>' +
                //           '</div>' +
                //           '</div>' +
                //           '<div class="offer-info col-5">' +
                //           '<p class="offer-cond">' + (imovel.imv_preco_cond ? 'Condomínio <br />R$' : '') +
                //           (imovel.imv_preco_cond ? imovel.imv_preco_cond : '') + '</p>' +
                //           '<div class="offer-contaner">' +
                //           '<em class="offer"><span>R$</span> ' +
                //           textFormatter.formatPrice(imovel.preco_exibir) +
                //           '</em>' +
                //           '</div>' +
                //           '</div>' +
                //           '</div>' +
                //           '</div>' +
                //           '</div>' +
                //           '</a>' +
                //           '</div>' +
                //           '</div>';
                //
                //         if (vm.infoWindow != null) {
                //           vm.infoWindow.close();
                //           vm.infoWindow = null;
                //         }
                //
                //         vm.infoWindow = new google.maps.InfoWindow({
                //           content: contentString,
                //           maxWidth: 290
                //         });
                //
                //         vm.infoWindow.addListener('domready', function () {
                //
                //           var iwOuter = $('.gm-style-iw');
                //           var iwBackground = iwOuter.prev();
                //           // Remover o div da sombra do fundo
                //           iwBackground.css({ 'display': 'none' });
                //           // iwBackground.children(':nth-child(2)').css({'display' : 'none'});
                //           // Remover o div de fundo branco
                //           // iwBackground.children(':nth-child(4)').css({'display' : 'none'});
                //
                //           // var iwCloseBtn = iwOuter.next(); // Old google Maps
                //           var iwCloseBtn = $('.gm-style-iw > button');
                //           iwCloseBtn.css({ 'display': 'none' });
                //
                //         });
                //
                //         setTimeout(function () {
                //           vm.infoWindow.open(vm.map, _marker);
                //         }, 200)
                //
                //       });
                //   }
                // }, function (err) {
                //   console.log(err);
                // })
                //
                // // vm.map.addListener('click', function () {
                // //   if (vm.infoWindow) vm.infoWindow.close();
                // //   vm.infoWindow = null;
                // // });

                newMarkers.push(_marker);
                markerCluster.addLayer(_marker);
              } else if (method == "address") {
                a = i;
                var geocoder = new google.maps.Geocoder();
                var geoOptions = {
                  address: marker["address"]
                };
                $http.get('//api-site.arboimoveis.com.br/api/geocaches/search/'+marker["address"])
                .then(geocodeCallback(markerContent))
                // geocoder.geocode(geoOptions, geocodeCallback(markerContent));

              }

              if (mapAutoZoom == 1) {
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < newMarkers.length; i++) {
                  bounds.extend(newMarkers[i].getPosition());
                }
                vm.map.fitBounds(bounds);
              }

            }

            function geocodeCallback(markerContent) {
              return function (results, status) {
                // if (status == google.maps.GeocoderStatus.OK) {
                var image = {
                  url: '../../assets/images/mark.png',
                  size: new google.maps.Size(27, 46)
                };
                marker = new google.maps.Marker({
                  position: results.data.geometry.location,
                  optimized: false,
                  map: vm.map,
                  icon: image,
                  draggable: false,
                  content: markerContent,
                  flat: true,
                  title: markers[i]["title"]
                });

                marker.set("id", i);

                vm.myMarkers.push(marker);

                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                  return function () {
                    var url = $state.href('main.listing', {
                      id: markers[i].listing.id
                    });
                    window.open(url, '_blank');
                  }
                })(marker, i));

                marker.addListener('mouseover', function () {
                  var id = markers[i].listing.id;
                  angular.element(".results-wrapper .result-item[data-id=" + id + "] a").addClass("hover-state");
                });

                marker.addListener('mouseout', function () {
                  var id = markers[i].listing.id;
                  angular.element(".results-wrapper .result-item[data-id=" + id + "] a").removeClass("hover-state");
                });

                newMarkers.push(marker);
                markerCluster.addLayer(marker);
                renderResults();
                if (mapAutoZoom == 1) {
                  var bounds = new google.maps.LatLngBounds();
                  for (var i = 0; i < newMarkers.length; i++) {
                    bounds.extend(newMarkers[i].getPosition());
                  }
                  vm.map.fitBounds(bounds);
                }
                // } else { }
              }
            }

            var clusterStyles = [{
              height: 36,
              width: 36
            }];

            // markerCluster = new MarkerClusterer(vm.map, newMarkers, {
            //   styles: clusterStyles,
            //   maxZoom: 16,
            //   ignoreHidden: true
            // });

            vm.map.addLayer(markerCluster);
          }
        }
      }

      function formatPrice(n) {
        if (n != null) {
          return n.toFixed(0).replace(/./g, function (c, i, a) {
            return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
          });
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('SearchControllerEmpreendimentos', SearchControllerEmpreendimentos);

  SearchControllerEmpreendimentos.inject = ['$scope', '$locale', '$state', '$timeout', '$stateParams', '$location', 'Imovel', 'Empreendimento', 'SERVER_URL', '_'];

  /** @ngInject */
  function SearchControllerEmpreendimentos($scope, $locale, $state, $timeout, $stateParams, $location, Imovel, Empreendimento, SERVER_URL, _) {
    var vm = this;
    vm.mobileShowResult = true;
    vm.initSearching = true;
    vm.showMap = true;
    vm.aux = 0;

    vm.listings = [];
    vm.options = {
      start: [10, 500],
      connect: true,
      step: 10,
      range: {
        min: 10,
        max: 500
      }
    }

    vm.filteredListings = [];
    vm.hasNoListing = false;
    vm.showFilter = false;
    vm.listingFilter = {};

    // vm.listingFilter.amenities = [];
    vm.filtersSelected = {};

    // start filters venda/locacao
    if ($stateParams.tipo == "Locação") {
      vm.vendaVisible = false;
      vm.locacaoVisible = true;
    } else {
      vm.vendaVisible = true;
      vm.locacaoVisible = false;
    }


    vm.Coordenadas = {
      "Araraquara": {
        "latitude": -21.7794,
        "longitude": -48.2277
      },
      "Sao Carlos": {
        "latitude": -22.0185,
        "longitude": -47.9310
      },
      "PresidentePrudente": {
        "latitude": -22.1206,
        "longitude": -51.4210
      },
      "Piracicaba": {
        "latitude": -22.728191,
        "longitude": -47.645601
      },
      "Londrina": {
        "latitude": -23.3045,
        "longitude": -51.1696
      },
      "BragancaPaulista": {
        "latitude": -22.9411,
        "longitude": -46.5626
      }
    };

    vm.Tipos = [{
        value: "",
        name: "Tipos"
      },
      {
        value: "Venda",
        name: "Venda"
      },
      {
        value: "Locação",
        name: "Locação"
      }
    ];

    vm.Cidades = [{
        value: "",
        name: "Cidades"
      },
      {
        value: "araraquara-sp",
        name: "Araraquara"
      },
      {
        value: "braganca-paulista-sp",
        name: "Bragança Paulista"
      },
      {
        value: "londrina-pr",
        name: "Londrina"
      },
      {
        value: "piracicaba-sp",
        name: "Piracicaba"
      },
      {
        value: "presidente-prudente-sp",
        name: "Presidente Prudente"
      },
      {
        value: "sao-carlos-sp",
        name: "São Carlos"
      },
      {
        value: "maringa-pr",
        name: "Maringá"
      }
    ];

    vm.TipoImoveis = [{
        value: "",
        name: "Tipo de Imóvel"
      },
      {
        value: "Residencial",
        name: "Residencial"
      },
      {
        value: "Comercial",
        name: "Comercial"
      },
      {
        value: "Prédios residenciais",
        name: "Prédios residenciais"
      },
      {
        value: "Casas residenciais",
        name: "Casas residenciais"
      },
      {
        value: "Terrenos ou lotes residenciais",
        name: "Terrenos ou lotes residenciais"
      }
    ];


    vm.PrecosVenda = [{
        value: "",
        name: "R$ de venda"
      },
      {
        value: "80000",
        name: "Até 80.000"
      },
      {
        value: "100000",
        name: "De 80.000 até 100.000 "
      },
      {
        value: "200000",
        name: "De 100.000 até 200.000 "
      },
      {
        value: "500000",
        name: "De 200.000 até 500.000 "
      },
      {
        value: "800000",
        name: "De 500.000 até 800.000 "
      },
      {
        value: "1000000",
        name: "De 800.000 até 1.000.000 "
      },
      {
        value: "5000000",
        name: "De 1.000.000 até 5.000.000 "
      },
      {
        value: "100000000",
        name: "Acima de 5.000.000 "
      },
    ];

    vm.PrecosLocacao = [{
        value: "",
        name: "R$ de Locação"
      },
      {
        value: "500",
        name: "Até 500"
      },
      {
        value: "700",
        name: "De 500 até 700"
      },
      {
        value: "1000",
        name: "De 700 até 1000"
      },
      {
        value: "1500",
        name: "De 1.000 até 1.500"
      },
      {
        value: "2000",
        name: "De 1.500 até 2.000"
      },
      {
        value: "3000",
        name: "De 2.000 até 3.000"
      },
      {
        value: "5000",
        name: "De 3.000 até 5.000"
      },
      {
        value: "10000",
        name: "Acima de 5.000"
      },
    ];
    vm.Areas = [{
        value: "",
        name: "Área útil"
      },
      {
        value: "100",
        name: "Até 100 m²"
      },
      {
        value: "200",
        name: "Até 200 m²"
      },
      {
        value: "300",
        name: "Até 300 m²"
      },
      {
        value: "400",
        name: "Até 400 m²"
      },
      {
        value: "100000",
        name: "Mais de 400 m²"
      },
    ];
    vm.Dormitorios = [{
        value: "",
        name: "Dormitórios"
      },
      {
        value: "1",
        name: "1 ou mais"
      },
      {
        value: "2",
        name: "2 ou mais"
      },
      {
        value: "3",
        name: "3 ou mais"
      },
      {
        value: "4",
        name: "4 ou mais"
      },
      {
        value: "5",
        name: "Mais de 4"
      },
    ];
    vm.Vagas = [{
        value: "",
        name: "Vagas"
      },
      {
        value: "1",
        name: "1 ou mais"
      },
      {
        value: "2",
        name: "2 ou mais"
      },
      {
        value: "3",
        name: "3 ou mais"
      },
      {
        value: "4",
        name: "Mais de 3"
      },
    ];

    vm.Statuss = [{
        value: "",
        name: "Status do Empreendimento"
      },
      {
        value: "lancamentos",
        name: "Lançamentos"
      },
      {
        value: "pre-lancamentos",
        name: "Pré-lançamentos"
      },
      {
        value: "futuro-lancamento",
        name: "Futuro lançamento"
      },
      {
        value: "ultimas-unidades",
        name: "Últimas unidades"
      },
      {
        value: "pronto-para-morar",
        name: "Pronto para Morar"
      },
    ];

    vm.Mobilias = [{
        value: "",
        name: "Mobília"
      },
      {
        value: true,
        name: "Sim"
      },
      {
        value: false,
        name: "Não"
      }
    ];

    vm.environments = [{
        type: 'open',
        name: 'Ambiente ao Ar Livre',
        enabled: false
      },
      {
        type: 'closed',
        name: 'Ambiente Coberto',
        enabled: false
      }
    ];
    vm.txtResultsHeader = '';


    vm.Tipo = {
      value: $stateParams.tipo == null ? "" : $stateParams.tipo
    };


    vm.Status = {
      value: $stateParams.status == null ? "" : $stateParams.status
    };

    vm.Cidade = {
      value: ($stateParams.cidade == null || vm.Cidades.map(function (val) {
        return val.value
      }).indexOf($stateParams.cidade) == -1) ? "" : $stateParams.cidade
    };

    vm.TipoImovel = {
      value: $stateParams.tipoimovel == null ? "" : $stateParams.tipoimovel
    };
    vm.PrecoVenda = {
      value: $stateParams.precovenda == null ? "" : $stateParams.precovenda
    };
    vm.PrecoLocacao = {
      value: $stateParams.precolocacao == null ? "" : $stateParams.precolocacao
    };
    vm.Area = {
      value: $stateParams.area == null ? "" : $stateParams.area
    };

    vm.Dormitorio = {
      value: $stateParams.domirtorios == null ? "" : $stateParams.domirtorios
    };

    vm.Vaga = {
      value: $stateParams.vaga == null ? "" : $stateParams.vaga
    };
    vm.Mobilia = {
      value: $stateParams.mobilia == null ? "" : $stateParams.mobilia
    };



    //$scope.$broadcast('changeMapCity', vm.Coordenadas[vm.Cidade.value]);


    vm.setFilter = setFilter;
    vm.hiddenMapMobile = hiddenMapMobile;
    vm.alerta = alerta;
    vm.limpar = limpar;
    vm.findListings = findListings;
    vm.showHideFilter = showHideFilter;
    vm.refreshSearch = refreshSearch;
    // vm.createListing = createListing;
    vm.closedNode = closedNode;
    // vm.createThumb = createThumb;

    function refreshSearch() {
      filterListings();
    }

    // function createThumb(photo) {
    //   return photo.split('=')[0] + "=w320-h240";
    // }

    $scope.$on('mapRefresh', function (event, coordinates) {
      //console.log('coordenadas --->>');
      localStorage.setItem('coordinates', JSON.stringify(coordinates));
      vm.findListings(coordinates);
    });

    $scope.$watch('vm.Cidade.value', function (newValue, oldValue) {
      if (newValue != oldValue && newValue != "") {
        // vm.map.setCenter(vm.Coordenadas[vm.Cidade.value]);
        $scope.$broadcast('changeMapCity', vm.Cidade.name);
      }
    });

    // $scope.$watch('vm.options.start', function (newValue, oldValue) {
    //     // vm.listingFilter.pricing = {
    //     //     min: Math.round(newValue[0]),
    //     //     max: Math.round(newValue[1])
    //     // }
    //     vm.refreshSearch();
    // }, true);

    activate();

    function activate() {      
    }

    function findListings(coordinates) {
      vm.refreshing = true;
      //debugger;
      // console.log(coordinates)
      var previousCity = '';
      var nextCity = '';
      if (localStorage.getItem('loading') == 0) {
        // stop double reload
        localStorage.setItem('loading', 1);
        Empreendimento.findByPolygonNew(coordinates, function (success) {
          vm.listings = [];
          if (success.length == 0) {
            createMarkers(null);
            localStorage.setItem('loading', 0);
          } else {
            angular.forEach(success, function (res) {
              vm.listings.push(res);
            });
            createMarkers(null);
          }
        }, function (error) {
          vm.refreshing = false;
          console.error('error', error);
        });
      }
    }

    // new filter - mobile
    function showHideFilter() {
      if ($('.filtros').hasClass('hidden-xs')) {
        localStorage.setItem('menu-mobile', JSON.stringify(false))
        $('.filtros').removeClass('hidden-xs');
        $('.div-filtro').css("position", "relative");
      } else {
        localStorage.setItem('menu-mobile', JSON.stringify(true))
        $('.filtros').addClass('hidden-xs');
        $('.div-filtro').css("position", "absolute");
        setFilter("item", "reload");
      }
    }

    function alerta() {
      alert("Alerta");
    }

    function hiddenMapMobile() {
      if (vm.mobileShowResult) {
        vm.mobileShowResult = false
        vm.txtToggleMap = 'Lista'
        angular.element(".mobile-filter-row").removeClass("mobile-filter-padding");
        angular.element(".map-wrapper").css("z-index", "5");
      } else {
        vm.txtToggleMap = 'Mapa '
        vm.mobileShowResult = true;
        angular.element(".mobile-filter-row").addClass("mobile-filter-padding");
        angular.element(".map-wrapper").css("z-index", "-10");
      }
    }

    function limpar() {
      vm.Tipo = {
        value: ""
      };
      // vm.Cidade = {
      //   value: ""
      // };
      vm.TipoImovel = {
        value: ""
      };
      vm.PrecoVenda = {
        value: ""
      };
      vm.PrecoLocacao = {
        value: ""
      };
      vm.Area = {
        value: ""
      };
      vm.Dormitorio = {
        value: ""
      };
      vm.Vaga = {
        value: ""
      };
      vm.Mobilia = {
        value: ""
      };
      vm.Status = {
        value: ""
      };
      setFilter("item", 'clean');
    }

    function setFilter(item, filterType) {
      //debugger;
      $stateParams.status = vm.Status.value;
      $stateParams.cidade = vm.Cidade.value;  
      // debugger;
      if (filterType != 'city' && JSON.parse(localStorage.getItem('menu-mobile'))) {
        vm.listingFilter.listing_type = item;
        if($stateParams.cidade != "" && $stateParams.status != ""){
          $state.go('main.search-lancamentos-address-status', {
            cidade: vm.Cidade.value,
            status: vm.Status.value
          });
        }else if($stateParams.cidade == "" && $stateParams.status == ""){
          $state.go('main.search-lancamentos', {
            cidade: null,
          });
        }else{
          $state.go('main.search-lancamentos-address', {
            cidade: vm.Cidade.value,
            status: null
          });
        }
        
      filterListings();

      }

    }

    function filterListings() {
      var items = vm.listings;
      var listingFilter = vm.listingFilter;
      var isSearchFilterEmpty = false;

      // console.log("listingFilter");
      isSearchFilterEmpty = vm.Cidade.value != "" ||
        vm.Tipo.value != "" ||
        vm.TipoImovel.value != "" ||
        vm.PrecoVenda.value != "" ||
        vm.PrecoLocacao.value != "" ||
        vm.Area.value != "" ||
        vm.Dormitorio.value != "" ||
        vm.Vaga.value != "" ||
        vm.Mobilia.value != "" ||
        vm.Status.value != "";

      var _filters = {
        tipo: true,
        cidade: true,
        tipoimovel: true,
        precovenda: true,
        precolocacao: true,
        area: true,
        domirtorios: true,
        vagas: true,
        mobilia: true,
        status: true,
        myLocation: true
      }

      var _precovendaFilter = [];

      _precovendaFilter[""] = {
        min: 0,
        max: 100000000000000
      };
      _precovendaFilter["80000"] = {
        min: 0,
        max: 80.000
      };
      _precovendaFilter["100000"] = {
        min: 80000,
        max: 100000
      };
      _precovendaFilter["200000"] = {
        min: 100000,
        max: 200000
      };
      _precovendaFilter["500000"] = {
        min: 200000,
        max: 500000
      };
      _precovendaFilter["800000"] = {
        min: 500000,
        max: 800000
      };
      _precovendaFilter["1000000"] = {
        min: 800000,
        max: 1000000
      };
      _precovendaFilter["5000000"] = {
        min: 1000000,
        max: 5000000
      };
      _precovendaFilter["100000000"] = {
        min: 5000000,
        max: 100000000000000
      };

      var _precolocacaoFilter = [];
      _precolocacaoFilter[""] = {
        min: 0,
        max: 100000000000000
      };
      _precolocacaoFilter["500"] = {
        min: 0,
        max: 500
      };
      _precolocacaoFilter["700"] = {
        min: 500,
        max: 700
      };
      _precolocacaoFilter["1000"] = {
        min: 700,
        max: 1000
      };
      _precolocacaoFilter["1500"] = {
        min: 1000,
        max: 1500
      };
      _precolocacaoFilter["2000"] = {
        min: 1500,
        max: 2000
      };
      _precolocacaoFilter["3000"] = {
        min: 2000,
        max: 3000
      };
      _precolocacaoFilter["5000"] = {
        min: 3000,
        max: 5000
      };
      _precolocacaoFilter["10000"] = {
        min: 5000,
        max: 10000000000
      };
      //debugger;
      var coordinates = JSON.parse(localStorage.getItem('coordinates'));
      coordinates.status = $stateParams.status;
      $scope.$emit('mapRefresh', coordinates);
    }

    // if (isSearchFilterEmpty) {
    //   var result = [];
    //   //console.log(items);

    //   angular.forEach(items, function (item) {
    //     var filter = angular.extend({}, _filters);
    //     item.filters = filter;

    //     // item.filters.cidade = vm.Cidade.value == "" || (item.address.city == vm.Cidade.value);
    //     //item.filters.tipo = (vm.Tipo.value == "" && vm.PrecoVenda.value == "" && vm.PrecoLocacao.value == "") || (vm.PrecoVenda.value != "" && item.tipo == "Venda" || item.tipo == vm.Tipo.value) || (vm.PrecoLocacao.value != "" && item.tipo == "Locação" || item.tipo == vm.Tipo.value);
    //     //item.filters.tipo = vm.Tipo.value == "" || (item.tipo == vm.Tipo.value);
    //     // console.log(vm.Tipo.value)
    //     // console.log(item.tipo)
    //     // console.log(item.filters)
    //     //   console.log(item.status)
    //     //   console.log(vm.Status.value)
    //     //   console.log(vm.Status.value == item.status)
    //     var re = new RegExp(vm.TipoImovel.value, 'gi');
    //     item.filters.status = vm.Status.value == "" || (item.status == vm.Status.value);
    //     item.filters.tipoimovel = vm.TipoImovel.value == "" || (item.tipo.match(re) != null);
    //     //item.filters.precovenda = (item.precoVenda >= _precovendaFilter[vm.PrecoVenda.value].min && item.precoVenda < _precovendaFilter[vm.PrecoVenda.value].max);
    //     item.filters.precovenda = (item.valorMin >= _precovendaFilter[vm.PrecoVenda.value].min && item.valorMin <= _precovendaFilter[vm.PrecoVenda.value].max);
    //     //item.filters.precolocacao = (item.precoLocacao >= _precolocacaoFilter[vm.PrecoLocacao.value].min && item.precoLocacao < _precolocacaoFilter[vm.PrecoLocacao.value].max);
    //     item.filters.domirtorios = vm.Dormitorio.value == "" || (item.dormMin >= vm.Dormitorio.value);
    //     item.filters.vagas = vm.Vaga.value == "" || (item.vagasMin >= vm.Vaga.value);
    //     item.filters.mobilia = vm.Mobilia.value == "" || (item.mobilia >= vm.Mobilia.value);
    //     item.filters.area = vm.Area.value == "" || (item.areaUtilMin <= vm.Area.value) || (item.areaUtilMax <= vm.Area.value);
    //     //   console.log(item.filters)
    //     var show = _.toArray(item.filters).every(function (prop) {
    //       return prop == true;
    //     });
    //     if (show) {

    //       result.push(item);
    //     }
    //   });

    // } else {
    //   result = items;
    // }

    //var result = items;
    //$scope.$broadcast('changeMapCity', vm.Coordenadas[vm.Cidade.value]);

    // console.log(result);

    function createMarkers(items) {

      var result = (items == null) ? vm.listings : items;
      vm.initSearching =false;
      if (result.length == 0) {
        vm.filteredListings = [];
        vm.hasNoListing = true;
        //$scope.$broadcast('listingRefresh', vm.filteredListings);
      } else {
        vm.hasNoListing = false;
        vm.filteredListings = result;
      }

      $(".franquia").hide();
      $(".facebook").attr("href", "https://www.facebook.com/arboimoveis/");
      $(".Instagram").attr("href", "https://www.instagram.com/arbolondrina/");

      if (vm.filteredListings.length > 0) {
        var _city = vm.filteredListings[0].address.city;


        if (_city != "") {

          if (_city == "Araraquara") {
            $(".facebook").attr("href", "https://www.facebook.com/arboararaquara/");
            $(".instagram").attr("href", "https://www.instagram.com/arboararaquara/");
          } else if (_city == "BragancaPaulista") {
            $(".facebook").attr("href", "https://www.facebook.com/arbobraganca");
            $(".instagram").attr("href", "https://www.instagram.com/arbobraganca/");
          } else if (_city == "Sao Carlos") {
            $(".facebook").attr("href", "https://www.facebook.com/arbosaocarlos");
            $(".instagram").attr("href", "https://www.instagram.com/arbosaocarlos/");
          } else if (_city == "Piracicaba") {
            $(".facebook").attr("href", "https://www.facebook.com/arbopiracicaba");
            $(".instagram").attr("href", "https://www.instagram.com/arbopiracicaba/");
          } else if (_city == "PresidentePrudente") {
            $(".facebook").attr("href", "https://www.facebook.com/arboprudente");
            $(".instagram").attr("href", "https://www.instagram.com/arboprudente");
          } else if (_city == "Londrina") {
            $(".facebook").attr("href", "https://www.facebook.com/arboimoveis");
            $(".instagram").attr("href", "https://www.instagram.com/arbolondrina");
          }
        }
      }

      $scope.$broadcast('listingRefresh', vm.filteredListings);
    }

    function closedNode() {
      window.localStorage['closed_note'] = true;
    }
  }


})();

(function () {
  'use strict';

  angular.module('arboWeb').controller('SearchController', SearchController);

  SearchController.inject = [
    '$scope',
    '$locale',
    '$state',
    '$timeout',
    '$stateParams',
    '$location',
    'Imovel',
    'SITE_URL',
    '_',
  ];

  /** @ngInject */
  function SearchController(
    $rootScope,
    $scope,
    $locale,
    $state,
    $timeout,
    $stateParams,
    $location,
    Imovel,
    Comodidade,
    TipoImovel,
    SITE_URL,
    _,
    textFormatter,
    tiposImovel
  ) {
    var vm = this;
    var scroll = 0;
    vm.filtros = false;
    vm.mapa = true;
    $rootScope.mapa = true;
    $rootScope.filtros = false;
    vm.tipos_imovel = tiposImovel;
    $rootScope._tiposimovel = tiposImovel;
    vm.makeUrl = makeUrl;
    vm.config_wl = $rootScope.ConfigWhiteLabel;

    var imgSize =
      vm.config_wl.imb_config_site.image_size >= 110
        ? 105
        : parseInt(vm.config_wl.imb_config_site.image_size, 10) + 20;
    vm.filtersSize = imgSize ? imgSize + 'px' : 'unset';

    vm.keyLength = function (obj) {
      var count = 0;
      if (obj && Object.keys(obj).length) {
        for (var x in obj) {
          var tipo = tiposImovel.filter(function (el) {
            return x == el.timv_label && obj[x];
          });
          if (tipo[0]) {
            count++;
          }
        }
        return count;
      }
    };
    vm.search = {
      // Variaveis
      // tipos: [],
      title: {},
      detail_cond: [],
      detail_ap: [],
      precoVenda: {},
      precolocacao: {},
      listing: {},
      mapa: true,
      initMap: false,

      // params: {
      //   tipo: $stateParams.tipo,
      //   tipovar: $stateParams.tipovar,
      //   cidade: $stateParams.cidade,
      //   tipoimovel: $stateParams.tipoimovel,

      //   precovenda: $stateParams.precovenda ? $stateParams.precovenda.split('--') : [],
      //   precolocacao: $stateParams.precolocacao ? $stateParams.precolocacao.split('--') : [],
      //   area: $stateParams.area ? $stateParams.area.split('--') : [],

      //   noimovel: $stateParams.noimovel ? $stateParams.noimovel.split('--').reduce(function (acc, cur, i) {
      //     acc[cur] = true;
      //     // // acc[cur] = that._detail_ap.filter(function(com){return com.cmd_nome == cur});
      //     // that
      //     return acc;
      //   }, {}) : {},
      //   noempreendimento: $stateParams.noempreendimento ? $stateParams.noempreendimento.split('--').reduce(function (acc, cur, i) {
      //     acc[cur] = true;
      //     return acc;
      //   }, {}) : {},

      //   //dormitorios: $stateParams.dormitorios,
      //   dormitorios: $stateParams.dormitorios ? $stateParams.dormitorios.split('--').reduce(function (acc, cur, i) {
      //     acc[cur] = true;
      //     return acc;
      //   }, {}) : {},

      //   // vagas: $stateParams.vagas,
      //   vagas: $stateParams.vagas ? $stateParams.vagas.split('--').reduce(function (acc, cur, i) {
      //     acc[cur] = true;
      //     return acc;
      //   }, {}) : {},

      //   mobilia: $stateParams.mobilia,

      //   center: {
      //     lat: 0,
      //     lng: 0
      //   },
      //   north_east: {
      //     lat: 0,
      //     lng: 0
      //   },
      //   south_west: {
      //     lat: 0,
      //     lng: 0
      //   }
      // },

      // Funções
      toggle: function (mobile) {
        // Toggle mapa or toggle filtros
        // console.log(mobile);
        // vm.search.initMap = false;
        // $rootScope.filtros = angular.copy(vm.filtros);

        if (!mobile) {
          $rootScope.mapa = angular.copy(vm.mapa);

          $('#busca').css({ width: '100%', 'margin-left': '0' });

          if (vm.filtros) {
            scroll = $(window).scrollTop();

            $('body').addClass('position-fixed');
            $('.results-wrapper').css({ top: -scroll });
          } else {
            $('body').removeClass('position-fixed');
            $('.results-wrapper').css({ top: '' });
            $(window).scrollTop(scroll);
          }

          if (vm.mapa) {
            this.mapa = true;
            // $scope.$broadcast('listingMapRefresh', vm.search.listing);
            // $scope.$broadcast('listingRefresh', vm.search.listing);

            $('#page-content').css({
              'padding-right': '0',
              'padding-left': '0',
            });
            $('.results-wrapper').css({
              width: 'calc(60%)',
              'min-width': 'calc(60%)',
            });
            $('.map-wrapper').css({
              'min-width': 'calc(40%)',
              'margin-left': '0',
            });
            $('#map-homepage').css({
              height: '100%',
              width: 'auto',
              position: 'relative',
            });

            // $('.result-item').addClass('map-active');
            // console.log('mapa');
          } else {
            $('#page-content').css({ 'padding-right': '' });
            // $('.result-item').removeClass('map-active');
            // $scope.$broadcast('listingRefresh', vm.search.listing);

            $('.results-wrapper').css({
              width: '100%',
              'min-width': '100%',
              'margin-left': '0',
            });

            // console.log('nada');
          }
          // console.log($('.fixed-filter'))

          // SAFARI BUG - POSITION FIXED AND PARENT FIXED

          var isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );

          if (isSafari) {
            angular.element('.fixed-filter').css('position', 'unset');
            setTimeout(function () {
              angular.element('.fixed-filter').css('position', 'fixed');
            }, 1000);
          } else {
            angular.element('.fixed-filter').css('position', 'fixed');
          }
        } else if (mobile == 'mapaMobile') {
          vm.mapa = true;
          this.mapa = true;
          $rootScope.mapa = angular.copy(vm.mapa);

          $rootScope.$broadcast('filterRefresh', null);
          $('.results-wrapper').css({ display: 'none' });
        } else if (mobile == 'listaMobile') {
          vm.mapa = false;
          this.mapa = false;
          $rootScope.mapa = angular.copy(vm.mapa);

          $('.results-wrapper').css({ display: '' });
        }
      },

      // toogle: function (params) {
      //   if (!$(angular.element('.button-toogle')[params]).hasClass('active')) {
      //     angular.element('.button-toogle').toggleClass('active');
      //     angular.element('.wrap-toogle').toggleClass('d-none');
      //   }

      //   if (params == 1) {
      //     $scope.$broadcast('listingMapRefresh', vm.search.listing);
      //     this.mapa = true;
      //     $('#page-content').css({ 'padding-right': '0' })
      //   } else {
      //     $scope.$broadcast('listingRefresh', vm.search.listing);
      //     this.mapa = false;
      //     $('#page-content').css({ 'padding-right': '' })
      //   }
      // },
      init: function () {
        // TipoImovel.find({}, function(res, info) {
        //   angular.forEach(res, function (v, k) {
        //     vm.search.tipos.push(v);
        //   });
        // });

        // console.log('Iniciou')
        // GET Comodidades
        // Comodidade.find({
        //   filter: {
        //     fields: ['id', 'cmd_nome', 'cmd_nome_gaia']
        //   }
        // }, function (res, info) {
        //   angular.forEach(res, function (v, k) {
        //     if (v.cmd_nome_gaia === null) {
        //       vm.search.detail_cond.push(v);
        //     } else {
        //       vm.search.detail_ap.push(v);
        //     }
        //   })
        // })

        // var that = this;
        // var geocoder = new google.maps.Geocoder();
        // var address = that.params.cidade;
        // geocoder.geocode({
        //   'address': address
        // }, function (results, status) {
        //   if (status === 'OK') {
        //     //console.log(status);

        //     results = results[0].geometry;

        //     // Centro do Mapa
        //     that.params.center.lat = results.location.lat();
        //     that.params.center.lng = results.location.lng();

        //     var bd = results.bounds;
        //     var vp = results.viewport;
        //     // debugger
        //     // South West
        //     that.params.south_west.lat = vp ? vp.getSouthWest().lat() : bd.getSouthWest().lat();
        //     that.params.south_west.lng = vp ? vp.getSouthWest().lng() : bd.getSouthWest().lng();

        //     // North East
        //     that.params.north_east.lat = vp ? vp.getNorthEast().lat() : bd.getNorthEast().lat();
        //     that.params.north_east.lng = vp ? vp.getNorthEast().lng() : bd.getNorthEast().lng();

        //     that.getCoord();
        //   } else {
        //     alert('Geocode was not successful for the following reason: ' + status);
        //   }
        // });
        if (vm.isMobile()) {
          $rootScope.$broadcast('searchHeader', false);
        }
      },
      getCoord: function () {
        // var coordinates = angular.copy(this.params);
        // var that = this;
        // var _detail_ap = this.detail_ap.filter(function (v) {
        //   for (var key in coordinates.noimovel) {
        //     if (that.removeSpecialChar(v.cmd_nome) == key) {
        //       return key;
        //     }
        //   }
        // })
        // coordinates.id_cmd = _detail_ap.map(function (cmd) {
        //   return cmd.id
        // })
        // findListings(coordinates);
      },
      // btnTipoimovel: function (data) {
      //   this.params.tipoimovel = this.params.tipoimovel != data ? data : null;
      //   this.setFilter();
      // },
      // btnMobilia: function (data) {
      //   this.params.mobilia = this.params.mobilia != data ? data : null;
      //   this.setFilter();
      // },
      // btnRadio: function (el) {
      //   this.setFilter()
      // },
      // setFilter: setFilter,
      removeSpecialChar: textFormatter.removeSpecialChar,
    };

    vm.toggleFiltersModal = function () {
      if (vm.isMobile()) {
        angular.element('.filters-modal').toggleClass('hide');
        angular.element('.fixed-filter').toggleClass('hide');
        angular.element('.btn-fixed').toggleClass('hide');

        $('body').toggleClass('position-fixed');
        $('.results-wrapper').css({ top: '' });
      }
    };

    angular.element(document).ready(function () {
      $('#header').addClass('fixed-theme');

      if (vm.isMobile()) {
        // console.log('Mobile');
        vm.mapa = false;
        vm.search.mapa = false;
        vm.search.toggle('listaMobile');
      } else {
        vm.search.toggle(0);
      }
      // angular.element('input[type="radio"]').each(function (index, element) {
      //   $(this).click(function () {
      //     if ($(this).checked)
      //       $(this).prop('checked', false);
      //   })
      // })

      angular.element(document).click(function (e) {
        angular.element('.btn-toggle').next().removeClass('show');
        // angular.element('.relevance-dropdown').removeClass('show');
      });

      angular.element('.toggle-dropdown').click(function (e) {
        e.stopPropagation();
      });

      angular.element('.btn-toggle').click(function (e) {
        e.stopPropagation();

        var btn = $(e.target);
        var wasOpen = btn.next().hasClass('show');

        // Fecha todos os dropdowns
        // angular.element('.btn-toggle').removeClass('active');
        angular.element('.btn-toggle').next().removeClass('show');

        // Abre somente o clicado
        // btn.addClass('active');
        if (!wasOpen) {
          btn.next().addClass('show');
          btn.next().css('left', btn.position().left);
        }
      });
      // gambi
      angular.element('.btn-toggle .fal').click(function (e) {
        e.stopPropagation();
        console.log(e);

        var btn = $(e.target).parent();
        var wasOpen = btn.next().hasClass('show');

        // Fecha todos os dropdowns
        // angular.element('.btn-toggle').removeClass('active');
        angular.element('.btn-toggle').next().removeClass('show');

        // Abre somente o clicado
        // btn.addClass('active');
        if (!wasOpen) {
          btn.next().addClass('show');
          btn.next().css('left', btn.position().left);
        }
      });

      angular.element('.toggle-dropdown .btn').click(function (e) {
        angular.element('.btn-toggle').removeClass('active');
        angular.element(e.target).parent().parent().prev().addClass('active');
        angular.element('.btn-toggle').next().removeClass('show');
      });
    });
    vm.tituloCidade = function () {
      return (
        capitalize(
          vm.search.title.cidade
            .substr(0, vm.search.title.cidade.length - 3)
            .split(/-/)
            .join(' ')
        ) +
        ' - ' +
        vm.search.title.cidade.substr(-2, 2).toUpperCase()
      );
    };

    vm.cidadeURL = function (key) {
      var obj = vm.search.title.cidade_pesquisa;

      if (key === 'logradouro' || (key == null && obj.logradouro))
        return textFormatter.urlFormatter(
          obj.logradouro + ' ' + obj.bairro + ' ' + obj.cidade
        );
      if (key === 'bairro' || (key == null && obj.bairro))
        return textFormatter.urlFormatter(obj.bairro + ' ' + obj.cidade);
      if (key === 'cidade' || (key == null && obj.cidade))
        return textFormatter.urlFormatter(obj.cidade);
    };

    vm.sizeObject = function (obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (obj.hasOwnProperty(key) && obj[key]) size++;
      }
      return size;
    };

    vm.tipoimovelURl = function () {
      return Object.entries(vm.search.title.tipoimovel || {})
        .filter(function (v) {
          return v[1];
        })
        .map(function (v) {
          if (v[1]) return v[0];
        })
        .join('+');
    };

    vm.tituloImovel = function () {
      var name = '';
      var count_actives = 0;
      if (
        vm.search.title.tipoimovel &&
        Object.keys(vm.search.title.tipoimovel).length
      ) {
        for (var x in vm.search.title.tipoimovel) {
          var tipo = tiposImovel.filter(function (el) {
            return x == el.timv_label && vm.search.title.tipoimovel[x];
          });
          if (tipo[0]) {
            count_actives++;
            name =
              tipo[0].timv_nome == 'Barracão'
                ? 'barracões'
                : tipo[0].timv_nome + 's';
            name = name.toLowerCase();
          }
        }
      }
      if (count_actives != 1) {
        name = 'imóveis ';
      }
      return name + ' ';
    };

    function capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    // function setFilter() {
    //   var params = angular.copy(vm.search.params);
    //   var stateName;
    //   if (params.tipovar == 'novos') {
    //     // PARA EMPREENDIMENTOS

    //   } else {
    //     // PARA IMOVEIS
    //     if ((params.tipovar == '' || params.tipovar == null) && (params.tipoimovel == '' || params.tipoimovel == null)) {
    //       stateName = 'main.search-address';
    //     } else if ((params.tipovar != '' && params.tipovar != null) && (params.tipoimovel != '' && params.tipoimovel != null)) {
    //       stateName = 'main.search-address-ad-build-type';
    //     } else {
    //       stateName = 'main.search-address-ad-type';
    //     }
    //     //// console.log(stateName);
    //     //// console.log(params);
    //   }
    //   params.precovenda = params.precovenda ? params.precovenda.join('--') : [];
    //   params.precolocacao = params.precolocacao ? params.precolocacao.join('--') : [];
    //   params.area = params.area ? params.area.join('--') : [];
    //   // debugger;
    //   params.noimovel = Object.entries(params.noimovel).filter(function (v) {
    //     return v[1];
    //   }).map(function (v) {
    //     if (v[1]) return v[0];
    //   }).join('--');

    //   params.noempreendimento = Object.entries(params.noempreendimento).map(function (v) {
    //     if (v[1]) return v[0];
    //   }).join('--');

    //   vm.search.getCoord();
    //   $state.go(stateName, params, {
    //     location: true,
    //     notify: false
    //   });
    // }

    // $scope.$on('mapRefresh', function (event, coord) {
    //   vm.search.params = Object.assign(vm.search.params, coord);
    //   if(vm.search.initMap){
    //     vm.search.getCoord();
    //   }else{
    //     vm.search.initMap = true;
    //   }
    // })

    function findListings(coordinates) {
      // if(!coordinates.initMap){
      //   console.log('AQUI----->');
      //   console.log(coordinates);
      // Imovel.findByPolygonNew(coordinates,
      //   function (success) {
      //     vm.search.listing = success;
      //     vm.filtros = false;
      //     if (vm.mapa) {
      //       $scope.$broadcast('listingMapRefresh', vm.search.listing);
      //     }
      //     $scope.$broadcast('listingRefresh', vm.search.listing);
      //   },
      //   function (error) {
      //     console.error('error', error);
      //   });
      // }
    }

    /********************** SLIDER **********************/

    // if (vm.search.params.tipovar == 'para-alugar') {
    //   var _min = 300,
    //     _max = 15000
    // } else {
    //   var _min = 50000,
    //     _max = 2000000
    // }
    // var _min_area = 30,
    //   _max_area = 50000

    // var options = {
    //   isDate: false,
    //   min: _min,
    //   max: _max,
    //   start: _min + 20,
    //   end: _max - 20,
    //   overlap: true
    // };

    // var area_options = {
    //   isDate: false,
    //   min: _min_area,
    //   max: _max_area,
    //   start: _min_area + 20,
    //   end: _max_area - 20,
    //   overlap: true
    // }

    // var element0 = document.getElementById('pricev-range');
    // var element1 = document.getElementById('pricel-range');
    // var element2 = document.getElementById('area-range');
    // var element3 = document.getElementById('pricev-range-mobile');
    // var element4 = document.getElementById('pricel-range-mobile');
    // var element5 = document.getElementById('area-range-mobile');

    // options.start = vm.search.params.precovenda ? vm.search.params.precovenda[0] : _min + 20;
    // options.end = vm.search.params.precovenda ? vm.search.params.precovenda[1] : _max - 20;
    // var pricevSlider = new Slider(element0, options);
    // var pricevSliderMobile = new Slider(element3, options);

    // options.start = vm.search.params.precolocacao ? vm.search.params.precolocacao[0] : _min + 20;
    // options.end = vm.search.params.precolocacao ? vm.search.params.precolocacao[1] : _max - 20;
    // var pricelSlider = new Slider(element1, options);
    // var pricelSliderMobile = new Slider(element4, options);

    // area_options.start = vm.search.params.area ? vm.search.params.area[0] : _min + 20;
    // area_options.end = vm.search.params.area ? vm.search.params.area[1] : _max - 20;
    // var areaSlider = new Slider(element2, area_options);
    // var areaSliderMobile = new Slider(element5, area_options);

    // var timeOut;
    // /**********************/
    // pricevSlider.subscribe('moving', function (data) {
    //   var div = 'R$ ' + textFormatter.formatPrice(Math.round(data.left)) + ' - ' + textFormatter.formatPrice(Math.round(data.right));
    //   document.getElementById('rangePricev').innerHTML = div;

    //   vm.search.params.precovenda[0] = Math.round(data.left);
    //   vm.search.params.precovenda[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricevSlider.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricevSlider.getInfo().right));
    // document.getElementById('rangePricev').innerHTML = div;

    // /**********************/
    // pricelSlider.subscribe('moving', function (data) {
    //   var div = 'R$ ' + textFormatter.formatPrice(Math.round(data.left)) + ' - ' + textFormatter.formatPrice(Math.round(data.right));
    //   document.getElementById('rangePricel').innerHTML = div;

    //   vm.search.params.precolocacao[0] = Math.round(data.left);
    //   vm.search.params.precolocacao[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricelSlider.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricelSlider.getInfo().right));
    // document.getElementById('rangePricel').innerHTML = div;

    // /**********************/

    // areaSlider.subscribe('moving', function (data) {
    //   var div = textFormatter.formatPrice(Math.round(data.left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(data.right)) + ' <span>m<sup>2</sup></span>';
    //   document.getElementById('rangeArea').innerHTML = div;

    //   vm.search.params.area[0] = Math.round(data.left);
    //   vm.search.params.area[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = textFormatter.formatPrice(Math.round(areaSlider.getInfo().left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(areaSlider.getInfo().right)) + ' <span>m<sup>2</sup></span>';
    // document.getElementById('rangeArea').innerHTML = div;
    // /***************************************************/

    // /* Filtros Mobile */
    // /**********************/
    // pricevSliderMobile.subscribe('moving', function (data) {
    //   var div = 'R$ ' + textFormatter.formatPrice(Math.round(data.left)) + ' - ' + textFormatter.formatPrice(Math.round(data.right));
    //   document.getElementById('rangePricev-mobile').innerHTML = div;

    //   vm.search.params.precovenda[0] = Math.round(data.left);
    //   vm.search.params.precovenda[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricevSlider.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricevSliderMobile.getInfo().right));
    // document.getElementById('rangePricev-mobile').innerHTML = div;

    // /**********************/
    // pricelSliderMobile.subscribe('moving', function (data) {
    //   var div = 'R$ ' + textFormatter.formatPrice(Math.round(data.left)) + ' - ' + textFormatter.formatPrice(Math.round(data.right));
    //   document.getElementById('rangePricel-mobile').innerHTML = div;

    //   vm.search.params.precolocacao[0] = Math.round(data.left);
    //   vm.search.params.precolocacao[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = 'R$ ' + textFormatter.formatPrice(Math.round(pricelSliderMobile.getInfo().left)) + ' - ' + textFormatter.formatPrice(Math.round(pricelSliderMobile.getInfo().right));
    // document.getElementById('rangePricel-mobile').innerHTML = div;

    // /**********************/

    // areaSlider.subscribe('moving', function (data) {
    //   var div = textFormatter.formatPrice(Math.round(data.left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(data.right)) + ' <span>m<sup>2</sup></span>';
    //   document.getElementById('rangeArea-mobile').innerHTML = div;

    //   vm.search.params.area[0] = Math.round(data.left);
    //   vm.search.params.area[1] = Math.round(data.right);

    //   clearTimeout(timeOut);
    //   timeOut = setTimeout(function () {
    //     vm.search.btnRadio()
    //   }, 200)
    // });

    // var div = textFormatter.formatPrice(Math.round(areaSliderMobile.getInfo().left)) + ' <span>m<sup>2</sup></span> - ' + textFormatter.formatPrice(Math.round(areaSliderMobile.getInfo().right)) + ' <span>m<sup>2</sup></span>';
    // document.getElementById('rangeArea-mobile').innerHTML = div;
    // /***************************************************/

    vm.isMobile = function () {
      var pageWidth = angular.element(document).outerWidth();
      return pageWidth < 992;
    };

    $scope.$on('titulo', function (e, titulo) {
      vm.search.title = titulo;
    });

    function makeUrl(tipo) {
      // var urlPath = $location.$$url.split('?')[0].split('#')[0];

      var city = textFormatter.removeSpecialChar(vm.search.title.cidade);

      // url para cidade
      if (tipo == 1 || !vm.search.title.tipovar) {
        var url = SITE_URL + 'imoveis/' + city;
      }

      //url para tipo negocio
      else if (tipo == 2) {
        var tipo_negocio = 'imoveis/' + vm.search.title.tipovar;
        var url = SITE_URL + tipo_negocio + '/' + city;
      }

      //url para tipo de imovel
      else if (tipo == 3) {
        var tipo_negocio = 'imoveis/' + vm.search.title.tipovar;
        var tipos = '';
        for (var tipo in vm.search.title.tipoimovel) {
          if (vm.search.title.tipoimovel.tipo) tipos += tipo + '+';
        }
        tipos = tipos.slice(0, -1);
        var url =
          SITE_URL + tipo_negocio + (tipos ? '/' + tipos : '') + '/' + city;
      }
      return url;
    }

    $rootScope.order = vm.selectedOrder = 'mais_proximos';
    vm.getSelectedOrder = getSelectedOrder;
    function getSelectedOrder() {
      var order = 'Menor Preço';

      if (vm.selectedOrder == 'menor_preco') {
        order = 'Menor Preço';
      } else if (vm.selectedOrder == 'maior_preco') {
        order = 'Maior Preço';
      }
      // Para teste, ordenando pelo tipo de imóvel
      else if (vm.selectedOrder == 'mais_relevantes') {
        order = 'Mais Relevantes';
      } else if (vm.selectedOrder == 'mais_proximos') {
        order = 'Mais Próximos';
      }
      return order;
    }

    vm.updateFilter = updateFilter;
    function updateFilter(tipovar) {
      if (vm.selectedOrder) $rootScope.order = vm.selectedOrder;
      if (tipovar) $rootScope.tipovar = tipovar;
      $rootScope.finalidade =
        vm.search.residencial && !vm.search.comercial
          ? 1
          : vm.search.comercial && !vm.search.residencial
          ? 2
          : null;
      $rootScope.$broadcast('filterRefresh', vm.selectedOrder);
    }

    vm.search.init();
  }
})();

// var resizeId;
// var lastModal;
// var customizerEnabled = 0;
// var defaultColor;
// $(document).ready(function($) {
//     "use strict";

//     if( $("body").hasClass("navigation-fixed") ){
//         fixedNavigation(true);
//     }
//     else {
//         fixedNavigation(false);
//     }

//     if( $(".tse-scrollable").length ){
//         $(".tse-scrollable").TrackpadScrollEmulator();
//     }

//     if( viewport.is('xs') ){
//         // $(".map-wrapper").height( $(window).height() - $("#page-header").height() );
//         $(".has-background").css( "min-height", $(window).height() - $("#page-header").height() + "px" );
//     }
//     else {
//         if( $("body").hasClass("navigation-fixed") ){
//             $(".hero-section.full-screen").height( $(window).height() - $("#page-header nav").height() - 65 );
//         }
//         else {
//             $(".hero-section.full-screen").height( $(window).height() - $("#page-header").height() - 65 );
//         }
//     }

//     $('.main-nav a[href^="#"], a[href^="#"].scroll').on('click',function (e) {
//         e.preventDefault();
//         var target = this.hash,
//             $target = $(target);
//         $('html, body').stop().animate({
//             'scrollTop': $target.offset().top
//         }, 2000, 'swing', function () {
//             window.location.hash = target;
//         });
//     });

//     $(document).on("click", function(e){
//         if( e.target.className == "controls-more" ){
//             $(".controls-more.show").removeClass("show");
//             $(e.target).addClass("show");

//         }
//         else {
//             $(".controls-more.show").each(function() {
//                 $(this).removeClass("show");
//             });
//         }
//     });

//     $(".nav-btn").on("click", function(){
//         $(this).toggleClass("active");
//         $(".primary-nav").toggleClass("show");
//     });

//     $(".duplicate").live("click", function(e){
//         e.preventDefault();
//         var duplicateElement = $(this).attr("href");
//         var parentElement = $(duplicateElement)[0].parentElement;
//         $(parentElement).append( $(duplicateElement)[0].outerHTML );
//     });

//     equalHeight(".container");
//     bgTransfer();
//     responsiveNavigation();

// });

// $(window).resize(function(){
//     clearTimeout(resizeId);
//     resizeId = setTimeout(doneResizing, 250);
//     responsiveNavigation();
// });

// function bgTransfer(){
//     if( viewport.is('xs') ){

//     }
//     $(".bg-transfer").each(function() {
//         $(this).css("background-image", "url("+ $(this).find("img").attr("src") +")" );
//     });
// }

// function trackpadScroll(method){
//     if( method == "initialize" ){
//     }
//     else if ( method == "recalculate" ){
//         setTimeout(function(){
//             if( $(".tse-scrollable").length ){
//             }
//         }, 1000);
//     }
// }

// function doneResizing(){
//     var $equalHeight = $('.container');
//     for( var i=0; i<$equalHeight.length; i++ ){
//         equalHeight( $equalHeight );
//     }
//     responsiveNavigation()
// }

// function responsiveNavigation(){
//     if( viewport.is('xs') ){
//         $("body").addClass("nav-btn-only");
//     }else{
//         $("body").removeClass('nav-btn-only');
//     }
//     if( $("body").hasClass("nav-btn-only") ){
//         $(".primary-nav .has-child").children("a").attr("data-toggle", "collapse");
//         $(".primary-nav .has-child").find(".nav-wrapper").addClass("collapse");
//         $(".mega-menu .heading").each(function(e) {
//             $(this).wrap("<a href='" + "#mega-menu-collapse-"+e + "'></a>");
//             $(this).parent().attr("data-toggle", "collapse");
//             $(this).parent().addClass("has-child");
//             $(this).parent().attr("aria-controls", "mega-menu-collapse-"+e);
//         });
//         $(".mega-menu ul").each(function(e) {
//             $(this).attr("id", "mega-menu-collapse-"+e);
//             $(this).addClass("collapse");
//         });
//     }
// }

// function equalHeight(container){
//     if( !viewport.is('xs') ){
//         var currentTallest = 0,
//             currentRowStart = 0,
//             rowDivs = new Array(),
//             $el,
//             topPosition = 0;

//         $(container).find('.equal-height').each(function() {
//             $el = $(this);
//             $($el).height('auto');
//             topPostion = $el.position().top;
//             if (currentRowStart != topPostion) {
//                 for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
//                     rowDivs[currentDiv].height(currentTallest);
//                 }
//                 rowDivs.length = 0; // empty the array
//                 currentRowStart = topPostion;
//                 currentTallest = $el.height();
//                 rowDivs.push($el);
//             } else {
//                 rowDivs.push($el);
//                 currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
//             }
//             for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
//                 rowDivs[currentDiv].height(currentTallest);
//             }
//         });
//     }
// }

// var viewport = (function() {
//     var viewPorts = ['xs', 'sm', 'md', 'lg'];

//     var viewPortSize = function() {
//         return window.getComputedStyle(document.body, ':before').content.replace(/"/g, '');
//     };

//     var is = function(size) {
//         if ( viewPorts.indexOf(size) == -1 ) throw "no valid viewport name given";
//         return viewPortSize() == size;
//     };

//     var isEqualOrGreaterThan = function(size) {
//         if ( viewPorts.indexOf(size) == -1 ) throw "no valid viewport name given";
//         return viewPorts.indexOf(viewPortSize()) >= viewPorts.indexOf(size);
//     };

//     return {
//         is: is,
//         isEqualOrGreaterThan: isEqualOrGreaterThan
//     }

// })();

// function fixedNavigation(state){
//     if( state == true ){
//         $("body").addClass("navigation-fixed");
//         var headerHeight = $("#page-header").height();
//         $("#page-header").css("position", "fixed");
//         $("#page-content").css({
//             "-webkit-transform" : "translateY(" + headerHeight + "px)",
//             "-moz-transform"    : "translateY(" + headerHeight + "px)",
//             "-ms-transform"     : "translateY(" + headerHeight + "px)",
//             "-o-transform"      : "translateY(" + headerHeight + "px)",
//             "transform"         : "translateY(" + headerHeight + "px)"
//         });
//     }
//     else if( state == false ) {
//         $("body").removeClass("navigation-fixed");
//         $("#page-header").css("position", "relative");
//         $("#page-content").css({
//             "-webkit-transform" : "translateY(0px)",
//             "-moz-transform"    : "translateY(0px)",
//             "-ms-transform"     : "translateY(0px)",
//             "-o-transform"      : "translateY(0px)",
//             "transform"         : "translateY(0px)"
//         });
//     }
// }

// $("[data-show-after-scroll]").each(function() {
//     var _this = $(this);
//     var scroll = _this.attr("data-show-after-scroll");
//     var offsetTop = $(this).offset().top;
//     $(window).scroll(function() {
//         var currentScroll = $(window).scrollTop();
//         if (currentScroll >= scroll) {
//             _this.addClass("show");
//         }
//         else {
//             _this.removeClass("show");
//         }
//     });
// });
(function() {
    'use strict';

    angular
        .module('arboWeb')
        .controller('ListingController', ListingController);

    /** @ngInject */
    function ListingController(listingImovel) {
        var vm = this;

        activate();

        function activate() {
            vm.isEmp = !!listingImovel.isEmp;
            vm.imovel = listingImovel.imovel;
            vm.codigo = listingImovel.codigo;
        }
    }
})();

/**
 * @name InfoBoxOptions
 * @class This class represents the optional parameter passed to the {@link InfoBox} constructor.
 * @property {string|Node} content The content of the InfoBox (plain text or an HTML DOM node).
 * @property {boolean} disableAutoPan Disable auto-pan on <tt>open</tt> (default is <tt>false</tt>).
 * @property {number} maxWidth The maximum width (in pixels) of the InfoBox. Set to 0 if no maximum.
 * @property {Size} pixelOffset The offset (in pixels) from the top left corner of the InfoBox
 *  (or the bottom left corner if the <code>alignBottom</code> property is <code>true</code>)
 *  to the map pixel corresponding to <tt>position</tt>.
 * @property {LatLng} position The geographic location at which to display the InfoBox.
 * @property {number} zIndex The CSS z-index style value for the InfoBox.
 *  Note: This value overrides a zIndex setting specified in the <tt>boxStyle</tt> property.
 * @property {string} boxClass The name of the CSS class defining the styles for the InfoBox container.
 *  The default name is <code>infoBox</code>.
 * @property {Object} [boxStyle] An object literal whose properties define specific CSS
 *  style values to be applied to the InfoBox. Style values defined here override those that may
 *  be defined in the <code>boxClass</code> style sheet. If this property is changed after the
 *  InfoBox has been created, all previously set styles (except those defined in the style sheet)
 *  are removed from the InfoBox before the new style values are applied.
 * @property {string} closeBoxMargin The CSS margin style value for the close box.
 *  The default is "2px" (a 2-pixel margin on all sides).
 * @property {string} closeBoxURL The URL of the image representing the close box.
 *  Note: The default is the URL for Google's standard close box.
 *  Set this property to "" if no close box is required.
 * @property {Size} infoBoxClearance Minimum offset (in pixels) from the InfoBox to the
 *  map edge after an auto-pan.
 * @property {boolean} isHidden Hide the InfoBox on <tt>open</tt> (default is <tt>false</tt>).
 * @property {boolean} alignBottom Align the bottom left corner of the InfoBox to the <code>position</code>
 *  location (default is <tt>false</tt> which means that the top left corner of the InfoBox is aligned).
 * @property {string} pane The pane where the InfoBox is to appear (default is "floatPane").
 *  Set the pane to "mapPane" if the InfoBox is being used as a map label.
 *  Valid pane names are the property names for the <tt>google.maps.MapPanes</tt> object.
 * @property {boolean} enableEventPropagation Propagate mousedown, click, dblclick,
 *  and contextmenu events in the InfoBox (default is <tt>false</tt> to mimic the behavior
 *  of a <tt>google.maps.InfoWindow</tt>). Set this property to <tt>true</tt> if the InfoBox
 *  is being used as a map label. iPhone note: This property setting has no effect; events are
 *  always propagated.
 */

/**
 * Creates an InfoBox with the options specified in {@link InfoBoxOptions}.
 *  Call <tt>InfoBox.open</tt> to add the box to the map.
 * @constructor
 * @param {InfoBoxOptions} [opt_opts]
 */
function InfoBox(opt_opts) {

  opt_opts = opt_opts || {};

  google.maps.OverlayView.apply(this, arguments);

  // Standard options (in common with google.maps.InfoWindow):
  //
  this.content_ = opt_opts.content || "";
  this.disableAutoPan_ = opt_opts.disableAutoPan || false;
  this.maxWidth_ = opt_opts.maxWidth || 0;
  this.pixelOffset_ = opt_opts.pixelOffset || new google.maps.Size(0, 0);
  this.position_ = opt_opts.position || new google.maps.LatLng(0, 0);
  this.zIndex_ = opt_opts.zIndex || null;

  // Additional options (unique to InfoBox):
  //
  this.boxClass_ = opt_opts.boxClass || "infoBox";
  this.boxStyle_ = opt_opts.boxStyle || {};
  this.closeBoxMargin_ = opt_opts.closeBoxMargin || "2px";
  this.closeBoxURL_ = opt_opts.closeBoxURL || "http://www.google.com/intl/en_us/mapfiles/close.gif";
  if (opt_opts.closeBoxURL === "") {
    this.closeBoxURL_ = "";
  }
  this.infoBoxClearance_ = opt_opts.infoBoxClearance || new google.maps.Size(1, 1);
  this.isHidden_ = opt_opts.isHidden || false;
  this.alignBottom_ = opt_opts.alignBottom || false;
  this.pane_ = opt_opts.pane || "floatPane";
  this.enableEventPropagation_ = opt_opts.enableEventPropagation || false;

  this.div_ = null;
  this.closeListener_ = null;
  this.eventListener1_ = null;
  this.eventListener2_ = null;
  this.eventListener3_ = null;
  this.moveListener_ = null;
  this.contextListener_ = null;
  this.fixedWidthSet_ = null;
}

/* InfoBox extends OverlayView in the Google Maps API v3.
 */
InfoBox.prototype = new google.maps.OverlayView();

/**
 * Creates the DIV representing the InfoBox.
 * @private
 */
InfoBox.prototype.createInfoBoxDiv_ = function () {

  var bw;
  var me = this;

  // This handler prevents an event in the InfoBox from being passed on to the map.
  //
  var cancelHandler = function (e) {
    e.cancelBubble = true;

    if (e.stopPropagation) {

      e.stopPropagation();
    }
  };

  // This handler ignores the current event in the InfoBox and conditionally prevents
  // the event from being passed on to the map. It is used for the contextmenu event.
  //
  var ignoreHandler = function (e) {

    e.returnValue = false;

    if (e.preventDefault) {

      e.preventDefault();
    }

    if (!me.enableEventPropagation_) {

      cancelHandler(e);
    }
  };

  if (!this.div_) {

    this.div_ = document.createElement("div");

    this.setBoxStyle_();

    if (typeof this.content_.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + this.content_;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(this.content_);
    }

    // Add the InfoBox DIV to the DOM
    this.getPanes()[this.pane_].appendChild(this.div_);

    this.addClickHandler_();

    if (this.div_.style.width) {

      this.fixedWidthSet_ = true;

    } else {

      if (this.maxWidth_ !== 0 && this.div_.offsetWidth > this.maxWidth_) {

        this.div_.style.width = this.maxWidth_;
        this.div_.style.overflow = "auto";
        this.fixedWidthSet_ = true;

      } else { // The following code is needed to overcome problems with MSIE

        bw = this.getBoxWidths_();

        this.div_.style.width = (this.div_.offsetWidth - bw.left - bw.right) + "px";
        this.fixedWidthSet_ = false;
      }
    }

    this.panBox_(this.disableAutoPan_);

    if (!this.enableEventPropagation_) {

      // Cancel event propagation.
      //
      this.eventListener1_ = google.maps.event.addDomListener(this.div_, "mousedown", cancelHandler);
      this.eventListener2_ = google.maps.event.addDomListener(this.div_, "click", cancelHandler);
      this.eventListener3_ = google.maps.event.addDomListener(this.div_, "dblclick", cancelHandler);
      this.eventListener4_ = google.maps.event.addDomListener(this.div_, "mouseover", function (e) {
        this.style.cursor = "default";
      });
    }

    this.contextListener_ = google.maps.event.addDomListener(this.div_, "contextmenu", ignoreHandler);

    /**
     * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
     * @name InfoBox#domready
     * @event
     */
    google.maps.event.trigger(this, "domready");
  }
};

/**
 * Returns the HTML <IMG> tag for the close box.
 * @private
 */
InfoBox.prototype.getCloseBoxImg_ = function () {

  var img = "";

  if (this.closeBoxURL_ !== "") {

    img  = "<img";
    img += " src='" + this.closeBoxURL_ + "'";
    img += " align=right"; // Do this because Opera chokes on style='float: right;'
    img += " style='";
    img += " position: relative;"; // Required by MSIE
    img += " cursor: pointer;";
    img += " margin: " + this.closeBoxMargin_ + ";";
    img += "'>";
  }

  return img;
};

/**
 * Adds the click handler to the InfoBox close box.
 * @private
 */
InfoBox.prototype.addClickHandler_ = function () {

  var closeBox;

  if (this.closeBoxURL_ !== "") {

    closeBox = this.div_.firstChild;
    this.closeListener_ = google.maps.event.addDomListener(closeBox, 'click', this.getCloseClickHandler_());

  } else {

    this.closeListener_ = null;
  }
};

/**
 * Returns the function to call when the user clicks the close box of an InfoBox.
 * @private
 */
InfoBox.prototype.getCloseClickHandler_ = function () {

  var me = this;

  return function (e) {

    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    e.cancelBubble = true;

    if (e.stopPropagation) {

      e.stopPropagation();
    }

    me.close();

    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(me, "closeclick");
  };
};

/**
 * Pans the map so that the InfoBox appears entirely within the map's visible area.
 * @private
 */
InfoBox.prototype.panBox_ = function (disablePan) {

  var map;
  var bounds;
  var xOffset = 0, yOffset = 0;

  if (!disablePan) {

    map = this.getMap();

    if (map instanceof google.maps.Map) { // Only pan if attached to map, not panorama

      if (!map.getBounds().contains(this.position_)) {
      // Marker not in visible area of map, so set center
      // of map to the marker position first.
        map.setCenter(this.position_);
      }

      bounds = map.getBounds();

      var mapDiv = map.getDiv();
      var mapWidth = mapDiv.offsetWidth;
      var mapHeight = mapDiv.offsetHeight;
      var iwOffsetX = this.pixelOffset_.width;
      var iwOffsetY = this.pixelOffset_.height;
      var iwWidth = this.div_.offsetWidth;
      var iwHeight = this.div_.offsetHeight;
      var padX = this.infoBoxClearance_.width;
      var padY = this.infoBoxClearance_.height;
      var pixPosition = this.getProjection().fromLatLngToContainerPixel(this.position_);

      if (pixPosition.x < (-iwOffsetX + padX)) {
        xOffset = pixPosition.x + iwOffsetX - padX;
      } else if ((pixPosition.x + iwWidth + iwOffsetX + padX) > mapWidth) {
        xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
      }
      if (this.alignBottom_) {
        if (pixPosition.y < (-iwOffsetY + padY + iwHeight)) {
          yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
        } else if ((pixPosition.y + iwOffsetY + padY) > mapHeight) {
          yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
        }
      } else {
        if (pixPosition.y < (-iwOffsetY + padY)) {
          yOffset = pixPosition.y + iwOffsetY - padY;
        } else if ((pixPosition.y + iwHeight + iwOffsetY + padY) > mapHeight) {
          yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
        }
      }

      if (!(xOffset === 0 && yOffset === 0)) {

        // Move the map to the shifted center.
        //
        var c = map.getCenter();
        map.panBy(xOffset, yOffset);
      }
    }
  }
};

/**
 * Sets the style of the InfoBox by setting the style sheet and applying
 * other specific styles requested.
 * @private
 */
InfoBox.prototype.setBoxStyle_ = function () {

  var i, boxStyle;

  if (this.div_) {

    // Apply style values from the style sheet defined in the boxClass parameter:
    this.div_.className = this.boxClass_;

    // Clear existing inline style values:
    this.div_.style.cssText = "";

    // Apply style values defined in the boxStyle parameter:
    boxStyle = this.boxStyle_;
    for (i in boxStyle) {

      if (boxStyle.hasOwnProperty(i)) {

        this.div_.style[i] = boxStyle[i];
      }
    }

    // Fix up opacity style for benefit of MSIE:
    //
    if (typeof this.div_.style.opacity !== "undefined" && this.div_.style.opacity !== "") {

      this.div_.style.filter = "alpha(opacity=" + (this.div_.style.opacity * 100) + ")";
    }

    // Apply required styles:
    //
    this.div_.style.position = "absolute";
    this.div_.style.visibility = 'hidden';
    if (this.zIndex_ !== null) {

      this.div_.style.zIndex = this.zIndex_;
    }
  }
};

/**
 * Get the widths of the borders of the InfoBox.
 * @private
 * @return {Object} widths object (top, bottom left, right)
 */
InfoBox.prototype.getBoxWidths_ = function () {

  var computedStyle;
  var bw = {top: 0, bottom: 0, left: 0, right: 0};
  var box = this.div_;

  if (document.defaultView && document.defaultView.getComputedStyle) {

    computedStyle = box.ownerDocument.defaultView.getComputedStyle(box, "");

    if (computedStyle) {

      // The computed styles are always in pixel units (good!)
      bw.top = parseInt(computedStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(computedStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(computedStyle.borderRightWidth, 10) || 0;
    }

  } else if (document.documentElement.currentStyle) { // MSIE

    if (box.currentStyle) {

      // The current styles may not be in pixel units, but assume they are (bad!)
      bw.top = parseInt(box.currentStyle.borderTopWidth, 10) || 0;
      bw.bottom = parseInt(box.currentStyle.borderBottomWidth, 10) || 0;
      bw.left = parseInt(box.currentStyle.borderLeftWidth, 10) || 0;
      bw.right = parseInt(box.currentStyle.borderRightWidth, 10) || 0;
    }
  }

  return bw;
};

/**
 * Invoked when <tt>close</tt> is called. Do not call it directly.
 */
InfoBox.prototype.onRemove = function () {

  if (this.div_) {

    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};

/**
 * Draws the InfoBox based on the current map projection and zoom level.
 */
InfoBox.prototype.draw = function () {

  this.createInfoBoxDiv_();

  var pixPosition = this.getProjection().fromLatLngToDivPixel(this.position_);

  this.div_.style.left = (pixPosition.x + this.pixelOffset_.width) + "px";
  
  if (this.alignBottom_) {
    this.div_.style.bottom = -(pixPosition.y + this.pixelOffset_.height) + "px";
  } else {
    this.div_.style.top = (pixPosition.y + this.pixelOffset_.height) + "px";
  }

  if (this.isHidden_) {

    this.div_.style.visibility = 'hidden';

  } else {

    this.div_.style.visibility = "visible";
  }
};

/**
 * Sets the options for the InfoBox. Note that changes to the <tt>maxWidth</tt>,
 *  <tt>closeBoxMargin</tt>, <tt>closeBoxURL</tt>, and <tt>enableEventPropagation</tt>
 *  properties have no affect until the current InfoBox is <tt>close</tt>d and a new one
 *  is <tt>open</tt>ed.
 * @param {InfoBoxOptions} opt_opts
 */
InfoBox.prototype.setOptions = function (opt_opts) {
  if (typeof opt_opts.boxClass !== "undefined") { // Must be first

    this.boxClass_ = opt_opts.boxClass;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.boxStyle !== "undefined") { // Must be second

    this.boxStyle_ = opt_opts.boxStyle;
    this.setBoxStyle_();
  }
  if (typeof opt_opts.content !== "undefined") {

    this.setContent(opt_opts.content);
  }
  if (typeof opt_opts.disableAutoPan !== "undefined") {

    this.disableAutoPan_ = opt_opts.disableAutoPan;
  }
  if (typeof opt_opts.maxWidth !== "undefined") {

    this.maxWidth_ = opt_opts.maxWidth;
  }
  if (typeof opt_opts.pixelOffset !== "undefined") {

    this.pixelOffset_ = opt_opts.pixelOffset;
  }
  if (typeof opt_opts.alignBottom !== "undefined") {

    this.alignBottom_ = opt_opts.alignBottom;
  }
  if (typeof opt_opts.position !== "undefined") {

    this.setPosition(opt_opts.position);
  }
  if (typeof opt_opts.zIndex !== "undefined") {

    this.setZIndex(opt_opts.zIndex);
  }
  if (typeof opt_opts.closeBoxMargin !== "undefined") {

    this.closeBoxMargin_ = opt_opts.closeBoxMargin;
  }
  if (typeof opt_opts.closeBoxURL !== "undefined") {

    this.closeBoxURL_ = opt_opts.closeBoxURL;
  }
  if (typeof opt_opts.infoBoxClearance !== "undefined") {

    this.infoBoxClearance_ = opt_opts.infoBoxClearance;
  }
  if (typeof opt_opts.isHidden !== "undefined") {

    this.isHidden_ = opt_opts.isHidden;
  }
  if (typeof opt_opts.enableEventPropagation !== "undefined") {

    this.enableEventPropagation_ = opt_opts.enableEventPropagation;
  }

  if (this.div_) {

    this.draw();
  }
};

/**
 * Sets the content of the InfoBox.
 *  The content can be plain text or an HTML DOM node.
 * @param {string|Node} content
 */
InfoBox.prototype.setContent = function (content) {
  this.content_ = content;

  if (this.div_) {

    if (this.closeListener_) {

      google.maps.event.removeListener(this.closeListener_);
      this.closeListener_ = null;
    }

    // Odd code required to make things work with MSIE.
    //
    if (!this.fixedWidthSet_) {

      this.div_.style.width = "";
    }

    if (typeof content.nodeType === "undefined") {
      this.div_.innerHTML = this.getCloseBoxImg_() + content;
    } else {
      this.div_.innerHTML = this.getCloseBoxImg_();
      this.div_.appendChild(content);
    }

    // Perverse code required to make things work with MSIE.
    // (Ensures the close box does, in fact, float to the right.)
    //
    if (!this.fixedWidthSet_) {
      this.div_.style.width = this.div_.offsetWidth + "px";
      if (typeof content.nodeType === "undefined") {
        this.div_.innerHTML = this.getCloseBoxImg_() + content;
      } else {
        this.div_.innerHTML = this.getCloseBoxImg_();
        this.div_.appendChild(content);
      }
    }

    this.addClickHandler_();
  }

  /**
   * This event is fired when the content of the InfoBox changes.
   * @name InfoBox#content_changed
   * @event
   */
  google.maps.event.trigger(this, "content_changed");
};

/**
 * Sets the geographic location of the InfoBox.
 * @param {LatLng} latlng
 */
InfoBox.prototype.setPosition = function (latlng) {

  this.position_ = latlng;

  if (this.div_) {

    this.draw();
  }

  /**
   * This event is fired when the position of the InfoBox changes.
   * @name InfoBox#position_changed
   * @event
   */
  google.maps.event.trigger(this, "position_changed");
};

/**
 * Sets the zIndex style for the InfoBox.
 * @param {number} index
 */
InfoBox.prototype.setZIndex = function (index) {

  this.zIndex_ = index;

  if (this.div_) {

    this.div_.style.zIndex = index;
  }

  /**
   * This event is fired when the zIndex of the InfoBox changes.
   * @name InfoBox#zindex_changed
   * @event
   */
  google.maps.event.trigger(this, "zindex_changed");
};

/**
 * Returns the content of the InfoBox.
 * @returns {string}
 */
InfoBox.prototype.getContent = function () {

  return this.content_;
};

/**
 * Returns the geographic location of the InfoBox.
 * @returns {LatLng}
 */
InfoBox.prototype.getPosition = function () {

  return this.position_;
};

/**
 * Returns the zIndex for the InfoBox.
 * @returns {number}
 */
InfoBox.prototype.getZIndex = function () {

  return this.zIndex_;
};

/**
 * Shows the InfoBox.
 */
InfoBox.prototype.show = function () {

  this.isHidden_ = false;
  if (this.div_) {
    this.div_.style.visibility = "visible";
  }
};

/**
 * Hides the InfoBox.
 */
InfoBox.prototype.hide = function () {

  this.isHidden_ = true;
  if (this.div_) {
    this.div_.style.visibility = "hidden";
  }
};

/**
 * Adds the InfoBox to the specified map or Street View panorama. If <tt>anchor</tt>
 *  (usually a <tt>google.maps.Marker</tt>) is specified, the position
 *  of the InfoBox is set to the position of the <tt>anchor</tt>. If the
 *  anchor is dragged to a new location, the InfoBox moves as well.
 * @param {Map|StreetViewPanorama} map
 * @param {MVCObject} [anchor]
 */
InfoBox.prototype.open = function (map, anchor) {

  var me = this;

  if (anchor) {

    this.position_ = anchor.getPosition();
    this.moveListener_ = google.maps.event.addListener(anchor, "position_changed", function () {
      me.setPosition(this.getPosition());
    });
  }

  this.setMap(map);

  if (this.div_) {

    this.panBox_();
  }
};

/**
 * Removes the InfoBox from the map.
 */
InfoBox.prototype.close = function () {

  if (this.closeListener_) {

    google.maps.event.removeListener(this.closeListener_);
    this.closeListener_ = null;
  }

  if (this.eventListener1_) {

    google.maps.event.removeListener(this.eventListener1_);
    google.maps.event.removeListener(this.eventListener2_);
    google.maps.event.removeListener(this.eventListener3_);
    google.maps.event.removeListener(this.eventListener4_);
    this.eventListener1_ = null;
    this.eventListener2_ = null;
    this.eventListener3_ = null;
    this.eventListener4_ = null;
  }

  if (this.moveListener_) {

    google.maps.event.removeListener(this.moveListener_);
    this.moveListener_ = null;
  }

  if (this.contextListener_) {

    google.maps.event.removeListener(this.contextListener_);
    this.contextListener_ = null;
  }

  this.setMap(null);
};
(function () {
    'use strict';

    angular.module('arboWeb').controller('CodeController', CodeController);

    CodeController.inject = ['$scope', '$window', '$http', '$locale', '$state', '$timeout', '$stateParams', '$location', 'Imovel', 'SERVER_URL', '_'];

    function CodeController($scope, $window, $http, $locale, $state, $timeout, $stateParams, $location, Imovel, SERVER_URL, _) {
        $http({
            method: 'GET',
            url: SERVER_URL + 'cod/' + $stateParams.codigo
        }).then(function success(response) {
            //redirect
            $window.location.href = 'imovel/' + response.data.id;

        }, function error() {
            //if error
            $window.location.href = '404';
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('AcceptTermsController', AcceptTermsController);

  /* @ngInject */
  function AcceptTermsController(
    $state,
    SERVER_URL,
    $stateParams,
    $rootScope,
    $http,
    swangular
  ) {
    var vm = this;
    // debugger;
    function validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    // WL não entrar por enquanto
    if(!$rootScope.ConfigWhiteLabel.isArbo || !validateEmail($stateParams.email)){
      $state.go('main.home')
    }

    vm.submit =function (a,b) {
      // accept-terms-email
      debugger
      var _url = SERVER_URL+'api/cardsimovel/accept-terms-email'
      $http.post(_url,{email:$stateParams.email}).then(function(response){
        swangular.swal({
          type: 'success',
          title: 'Dados atualizados',
          html: 'Os dados foram atualizados com sucesso',
          confirmButtonClass: 'btn button btn-default px-5',
          buttonsStyling: false,

          onClose: function () {
            $state.go('main.home');
          }
        })
      }).catch(function() {
        swangular.swal({
          type: 'error',
          animation: false,
          title: 'Erro',
          html: 'Ocorreu um erro inesperado. Entre em contato ',
          timer: 3000
        })
      });
    }

    // alert('a')
  }
})();

(function () {
  'use strict';

  angular.module('arboWeb')
    .controller('Error404Controller', Error404Controller);

  Error404Controller.inject = ['$scope', '$state','$timeout'];

  /** @ngInject */
  function Error404Controller($scope,$state,$timeout) {
    var vm = this;

    // $timeout(function () {
    //   //DOM has finished rendering
    //   init()
    // });

    // function init() {

    //   // set transparent navbar
    //   var pageHeader = angular.element('#page-header');
    //   pageHeader.addClass('transparent-nav')
    // //   pageHeader.css('background-color', 'transparent')
    //   pageHeader.css('border-bottom', '0px solid')

    //   // hide form
    //   var formHeader = angular.element('#formHeader');
    //   formHeader.css('display', 'none')
      
    //   // change logo
    //   var logo = angular.element('#navbar-arbo-logo')       
    //   logo.attr('src','./assets/images/novosite/arbo_branco.png')
    
    // }

    // init()
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('ImobiliariasController', ImobiliariasController)
    .controller('ImobiliariaPageController', ImobiliariaPageController);

  /* @ngInject */
  function ImobiliariasController(
    $state,
    $scope,
    $rootScope,
    $timeout,
    auth,
    Imobiliaria,
    Imovel,
    Estado,
    Cidade,
    textFormatter,
    $location,
    seoService
  ) {
    var vm = this;
    // console.log('scope: ', $scope);
    // console.log('vm: ', vm);
    // console.log('ConfigWhiteLabel: ', $rootScope.ConfigWhiteLabel);

    if ($rootScope.ConfigWhiteLabel.isArbo === false) {
      $state.go('main.home', {}, { reload: true });
    }

    seoService.generateTags({
      title: 'Imobiliárias credenciadas - Arbo imóveis',
      description: 'Imobiliárias parceiras',
      slug: $location.absUrl(),
    });

    vm.imobs = [];
    vm.currentImobs = [];
    vm.localData = {
      states: [
        {
          id: null,
          nome: 'Todos os estados',
        },
      ],
      cities: [
        {
          id: null,
          nome: 'Todas as cidades',
        },
      ],
    };

    vm.updateCities = updateCities;
    vm.updateImobs = updateImobs;
    vm.generateImobLink = generateImobLink;

    function init() {
      Estado.find({
        filter: {
          include: ['cidade'],
          fields: ['id', 'nome'],
        },
      }).$promise.then(
        function (res) {
          vm.localData.states = vm.localData.states.concat(res);
        },
        function (err) {
          console.log(err);
        }
      );
      Imobiliaria.getImobiliaria({
        where: {
          and: [
            { imb_nome: { nilike: '%teste%' } },
            { imb_nome: { nilike: '%Arbo Imóveis%' } },
            { imb_ativa: true },
            { imb_allow_site_arbo: true },
          ],
        },
      }).$promise.then(
        function (res) {
          vm.imobs = res;
          vm.currentImobs = vm.imobs;
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function updateCities() {
      vm.localData.cities = [
        {
          id: null,
          nome: 'Todas as cidades',
        },
      ];

      vm.localData.cities = vm.localData.cities.concat(
        vm.localData.state.cidade
      );
      vm.localData.city = vm.localData.cities[0];

      if (vm.localData.cities[1] == undefined) {
        vm.localData.cities = [
          {
            id: null,
            nome: 'Todas as cidades',
          },
        ];
        vm.localData.city = vm.localData.cities[0];
      }

      vm.updateImobs();
    }

    function updateImobs() {
      /*
        Três situações:
        - Todos os imóveis
        - Todos os imóvies de um estado
        - Todos os imóvies de uma cidade
      */

      if (!vm.localData.state.id) {
        vm.currentImobs = vm.imobs;
      } else if (!vm.localData.city.id) {
        vm.currentImobs = vm.imobs.filter(function (imob) {
          return imob.cidade && imob.cidade.estado_id === vm.localData.state.id;
        });
      } else {
        vm.currentImobs = vm.imobs.filter(function (imob) {
          return imob.cidade && imob.cidade.id === vm.localData.city.id;
        });
      }
    }

    function generateImobLink(imob) {
      if (imob && imob.cidade) {
        var texto =
          '/imobiliarias/' +
          textFormatter.urlFormatter(imob.imb_nome) +
          '-' +
          textFormatter.urlFormatter(imob.cidade.nome) +
          '-' +
          textFormatter.urlFormatter(imob.cidade.estado.sigla) +
          '-' +
          btoa(imob.id);
        return texto;
      }
      return '';
    }

    $timeout(function () {
      init();
    });
  }

  function ImobiliariaPageController(
    $state,
    $scope,
    $location,
    $rootScope,
    $http,
    $timeout,
    auth,
    Imobiliaria,
    Imovel,
    Estado,
    Cidade,
    $stateParams,
    SERVER_URL,
    textFormatter,
    ngMeta,
    ImobSelect,
    createThumb,
    seoService
  ) {
    var vm = this;
    // console.log('ImobSelect: ', ImobSelect);
    vm.vendaDestaques = [];
    vm.locacaoDestaques = [];

    if (ImobSelect == undefined) {
      $state.go('main.imobiliarias', {}, { reload: true });
      seoService.generateTags({
        title: 'Imobiliárias credenciadas',
        description: 'Imobiliárias parceiras',
        slug: $location.absUrl(),
      });
    } else if (
      !$rootScope.ConfigWhiteLabel.isArbo &&
      $rootScope.ConfigWhiteLabel.id != ImobSelect.id
    ) {
      $state.go('main.home', {}, { reload: true });
    }

    // ngMeta.setTitle(ImobSelect.imb_nome + ' - Imobiliária em ' + ImobSelect.cidade.nome + ' | Arbo Imóveis');
    // ngMeta.setTag('og:title',ImobSelect.imb_nome + ' - Imobiliária em ' + ImobSelect.cidade.nome + ' | Arbo Imóveis');
    var desc = fazdesc();
    var title =
      ImobSelect.imb_nome +
      ' - Imobiliária em ' +
      ImobSelect.cidade.nome +
      ' | Arbo Imóveis';
    // console.log(desc);
    // ngMeta.setTag('description', desc);
    // ngMeta.setTag('og:description', desc);

    seoService.generateTags({
      title: title,
      description: desc,
      slug: $location.absUrl(),
    });

    vm.urlallvenda =
      '/imoveis/a-venda/' +
      textFormatter.urlFormatter(ImobSelect.cidade.nome) +
      '-' +
      textFormatter.urlFormatter(ImobSelect.cidade.estado.sigla) +
      '?imb_id=' +
      ImobSelect.id;

    vm.urlalllocacao =
      '/imoveis/para-alugar/' +
      textFormatter.urlFormatter(ImobSelect.cidade.nome) +
      '-' +
      textFormatter.urlFormatter(ImobSelect.cidade.estado.sigla) +
      '?imb_id=' +
      ImobSelect.id;

    if (
      ImobSelect.imb_config_site &&
      ImobSelect.imb_config_site.tipo_imob &&
      ImobSelect.imb_config_site.tipo_imob != 3
    ) {
      if (ImobSelect.imb_config_site.tipo_imob === 2) {
        vm.tiponegocio = 'locação';
      } else {
        vm.tiponegocio = 'venda';
      }
    } else {
      vm.tiponegocio = 'venda e locação';
    }

    var idimob = ImobSelect.id;
    vm.imob = ImobSelect;
    vm.findTop8 = findTop8;
    vm.highlight = highlight;
    vm.makeUrl = makeUrl;
    vm.formatPrice = textFormatter.formatPrice;
    vm.generateImobLink = generateImobLink;

    var vendaApi = null;
    vm.readyVenda = function (api) {
      vendaApi = api;
    };

    var locacaoApi = null;
    vm.readyLocacao = function (api) {
      locacaoApi = api;
    };

    function init() {
      vm.findTop8(true);
      vm.findTop8(false);
    }

    function findTop8(venda) {
      Imovel.topImoveis({
        imb_id: idimob,
        interval: '2 month',
        limit: 8,
        venda: venda,
      }).$promise.then(
        function (res) {
          res.forEach(function (item) {
            item = createThumb.get(angular.copy(item));
          });
          // debugger;
          if (venda) {
            vm.vendaDestaques = res;
          } else {
            vm.locacaoDestaques = res;
          }

          var mainLoopId = setInterval(function () {
            if ($('.carousel').length) {
              $('.carousel').on('slide.bs.carousel', function (ev) {
                var lazy;
                lazy = $(ev.relatedTarget);
                lazy.css('background-image', 'url( ' + lazy.data('img') + ')');
                lazy.removeAttr('data-img');
              });
              angular.element('.carousel').bcSwipe({ threshold: 50 });
              clearInterval(mainLoopId);
            }
          }, 500);
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function highlight(e, listing) {
      var myMarkers = $scope.$parent.$$childHead.vm.myMarkers;
      var markers = $scope.$parent.$$childHead.vm.markers;
      var icon = {
        url: '../../assets/images/mark.png',
        size:
          e.type == 'mouseenter'
            ? new google.maps.Size(18, 35)
            : new google.maps.Size(18, 35),
        scaledSize:
          e.type == 'mouseenter'
            ? new google.maps.Size(18, 35)
            : new google.maps.Size(18, 35),
      };

      var label = {
        color: 'black',
        fontWeight: 'bold',
        //text: listing.title.slice(0, 20)
      };

      if (e.type == 'mouseenter') {
        for (var idx in markers) {
          if (listing.id == markers[idx].listing.id) {
            // icon.labelOrigin = new google.maps.Point(50, 25);
            myMarkers[idx].setIcon(icon);
            // myMarkers[idx].setLabel(label);
          }
        }
      } else {
        for (var idx in markers) {
          if (listing.id == markers[idx].listing.id) {
            // icon.labelOrigin = new google.maps.Point(50, 25);
            myMarkers[idx].setIcon(icon);
            // myMarkers[idx].setLabel(null);
          }
        }
      }
    }

    function fazdesc() {
      var desc =
        ImobSelect.imb_nome +
        ' - Imobiliária em ' +
        ImobSelect.cidade.nome +
        ' CRECI: ' +
        ImobSelect.imb_creci +
        ' - Endereço: ' +
        ImobSelect.imb_endereco +
        ' - ' +
        ImobSelect.imb_end_numero +
        ' ' +
        (ImobSelect.imb_end_complemento ? ImobSelect.imb_end_complemento : '');

      if (ImobSelect.telefones) {
        desc += ' Contato: ';
        ImobSelect.telefones.forEach(function (tel) {
          desc += tel.numero + ' - ' + tel.contato + ', ';
        });
      }

      if (ImobSelect.enderecos) {
        desc += ' Endereços Adicionais: ';
        ImobSelect.enderecos.forEach(function (endereco) {
          desc +=
            endereco.logradouro +
            ' - ' +
            endereco.numero +
            ' ' +
            (endereco.complemento ? endereco.complemento : '') +
            ' ' +
            (endereco.bairro ? endereco.bairro : '') +
            ' ' +
            endereco.cidade +
            ' ' +
            endereco.cep +
            ', ';
        });
      }

      // if(ImobSelect.redessociais){
      // 	desc += ' | Web -';
      // 	ImobSelect.redessociais.forEach(function(rede){
      // 		desc += rede.rd_nome.tprd_nome +': ' + rede.rd_url + ', ';
      // 	});
      // }
      if (ImobSelect.imb_subdomain_url) {
        desc += 'Site: ' + ImobSelect.imb_subdomain_url + ' ';
      }
      return desc;
    }

    function makeUrl(listing, tipo) {
      // var urlPath = $location.$$url.split('?')[0].split('#')[0];
      if (listing) {
        if (!tipo) {
          var description = textFormatter.removeSpecialChar(listing.imv_titulo);
          return '/imovel/' + description + '/' + listing.imv_cod_gaia;
        } else {
          var city =
            textFormatter.removeSpecialChar(listing.imv_cidade) +
            '-' +
            listing.imv_estado.toLowerCase();
          // var siteLocation = $location.protocol() + '://' + $location.host() + '/'
          var siteLocation = '/';
          // debugger
          // url para cidade
          if (tipo == 1) {
            var url = siteLocation + 'imoveis/' + city;
            // var url = '/' + 'imoveis/' + city;
            return url;
          }

          //url para tipo negocio
          else if (tipo == 2) {
            var tipo_negocio = listing.imv_preco_locacao
              ? 'imoveis/para-locacao/'
              : 'imoveis/a-venda/';
            var url = siteLocation + tipo_negocio + city;
            // var url = '/' + tipo_negocio + city;
            return url;
          }

          //url para tipo de imovel
          else if (tipo == 3) {
            var tipo_negocio = listing.imv_preco_locacao
              ? 'imoveis/para-locacao/'
              : 'imoveis/a-venda/';
            var url =
              siteLocation +
              tipo_negocio +
              textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) +
              '/' +
              city;
            // var url = '/' + tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + '/' + city;
            return url;
          }
          //url do imóvel atual
          else if (tipo == 4) {
            return $location.$$absUrl;
          }
        }
      }
    }

    vm.owlProperties = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      rewind: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          margin: -5,
          stagePadding: 22,
        },
        700: {
          items: 2,
          margin: -5,
          stagePadding: 25,
        },
        980: {
          items: 3,
        },
        1280: {
          items: 4,
        },
        1600: {
          items: 5,
        },
      },
    };

    angular.element(document).ready(function () {
      $('#header').addClass('fixed-theme');
      var carousel1 = $('#carousel-detail');
      var carousel2 = $('#carousel-detail-mini');

      carousel1.on('slide.bs.carousel', function (event) {
        var to = $(event.relatedTarget).index();

        var items = carousel1.find('.carousel-item');
        var lazy = carousel1.find('.carousel-item.active');

        var items2 = carousel2.find('.carousel-item');
        var lazy2 = carousel2.find('.carousel-item.active');

        if (lazy.index() == 0 && to == items.length - 1) {
          lazy = items.last();
          lazy2 = items2.last();
        } else if (lazy.index() == -1 && to == 0) {
          lazy = items.first();
          lazy2 = items2.first();
        } else if (lazy.index() > to) {
          lazy = lazy.prev();
          lazy2 = lazy2.prev();
        } else {
          lazy = lazy.next();
          lazy2 = lazy2.next();
        }

        lazy.css('background-image', 'url( ' + lazy.data('img') + ')');
        lazy.removeAttr('data-img');

        lazy2.css('background-image', 'url( ' + lazy2.data('img') + ')');
        lazy2.removeAttr('data-img');

        carousel2.carousel(to);
      });

      angular.element('.carousel').bcSwipe({ threshold: 50 });
    });

    function generateImobLink(imob) {
      var texto =
        '/imobiliarias/' +
        textFormatter.urlFormatter(imob.imb_nome) +
        '-' +
        textFormatter.urlFormatter(imob.cidade.nome) +
        '-' +
        textFormatter.urlFormatter(imob.cidade.estado.sigla) +
        '-' +
        btoa(imob.id);
      return texto;
    }

    vm.nextOwl = function (ev) {
      if (ev == 'carousel-venda') {
        vendaApi.trigger('next.owl.carousel');
      } else if (ev == 'carousel-locacao') {
        locacaoApi.trigger('next.owl.carousel');
      }
    };

    vm.prevOwl = function (ev) {
      if (ev == 'carousel-venda') {
        vendaApi.trigger('prev.owl.carousel');
      } else if (ev == 'carousel-locacao') {
        locacaoApi.trigger('prev.owl.carousel');
      }
    };

    $timeout(function () {
      init();
    });
  }
})();

(function () {
  'use strict';

  angular.module('arboWeb').controller('ContactController', ContactController);

  /* @ngInject */
  function ContactController(
    $scope,
    $state,
    $location,
    PROD,
    SERVER_URL,
    textFormatter,
    $stateParams,
    $timeout,
    $window,
    Cidade,
    Estado,
    Imobiliaria,
    $rootScope,
    SendEmail,
    swangular,
    Endereco,
    seoService,
    GOOGLE_API
  ) {
    var vm = this;
    var marker;

    vm.GOOGLE_API = GOOGLE_API;
    vm.imb_selected = null;
    vm.imb_selected_end = null;
    vm.changeMap = changeMap;
    vm.routeImbContact = routeImbContact;
    vm.changeMapEndAdicionais = changeMapEndAdicionais;
    vm.config_wl = $rootScope.ConfigWhiteLabel;
    vm.formatPhone = textFormatter.formatPhone;
    var daysOfTheWeek = {
      0: 'Segunda',
      1: 'Terça',
      2: 'Quarta',
      3: 'Quinta',
      4: 'Sexta',
      5: 'Sábado',
      6: 'Domingo',
    };

    $timeout(function () {
      //DOM has finished rendering
      // init()
      // var x = angular.element('.middle-content').clone()
      // angular.element('#clonemodal').html(x)
      // debugger;
    });


    AOS.init({
      duration: 2000, // values from 0 to 3000, with step 50ms
      // easing: 'ease-in-cubic', // default easing for AOS animations
    });
    $(window).on('load', function () {
      AOS.refresh();
    });

    // seoService.generateTags({
    //   title: 'Entre em contato conosco - ' + vm.config_wl.nome,
    //   description: 'Fale conosco. A Arbo imóveis oferece CRM para imobiliárias e incorporadoras. A Arbo também é um portal para quem quer vender, comprar ou alugar um imóvel.',
    //   slug: $location.absUrl()
    // })

    vm.form_map = {
      // Variaveis
      city: null,
      state: null,
      citys: [
        {
          id: null,
          nome: 'Selecione uma cidade',
        },
      ],
      states: [
        {
          id: null,
          nome: 'Selecione um estado',
        },
      ],
      // imv_tiponegocio: [{'id': null, 'tpng_nome': 'Selecione um tipo'}],
      // // funções
      // init: function () {
      //   var that = this;
      //   Estado.find({
      //     filter: {
      //       include: ['cidade'],
      //       fields: ['id', 'nome']
      //     }
      //   },
      //     function (res) {
      //       that.states = that.states.concat(res);
      //     })
      // },
      validacao: function () {},
    };

    vm.form_contato = {
      // Variaveis
      name: '',
      email: '',
      phone: '',
      message: '',
      lgpd: '',
    };

    var redessociais = [];
    var emails = [];
    var imb = vm.config_wl;
    formatOpeningHours(imb);

    (imb.redessociais || []).forEach(function (rds) {
      redessociais.push({
        url: rds.rd_url,
        nome: rds.rd_nome.tprd_nome,
      });
    });
    (imb.emails || []).forEach(function (e) {
      emails.push({
        nome: e.nome,
        endereco: e.endereco,
      });
    });

    imb.cidade = imb.cidade_endereco
      ? imb.cidade_endereco
      : { nome: imb.cidade };
    imb.estado =
      imb.cidade_endereco && imb.cidade_endereco.estado
        ? imb.cidade_endereco.estado
        : { nome: imb.estado, sigla: imb.estado };

    vm.info_imb = Object.assign(imb, {
      cidade: imb.cidade.nome,
      estado: imb.estado.nome,
      endereco: imb.endereco,
      latitude: imb.latitude,
      longitude: imb.longitude,
      telefones: imb.telefones,
      horarios: vm.horarios,
      site: 'https://' + imb.url_site,
      sociais: redessociais,
      listaEmails: imb.emails,
      descricao: imb.cidade.nome + ' > ' + imb._estado + ' > ' + imb.nome,
    });

    function formatOpeningHours(imb) {
      var horarios = {
        normal: [],
        weekend: [],
      };

      var imbHorarios = JSON.parse(JSON.stringify(imb.horarios || [])); // (*visible* confused ooga booga)
      imbHorarios.sort(function (a, b) {
        return parseInt(a.imbhr_dia_semana) > parseInt(b.imbhr_dia_semana)
          ? 1
          : -1;
      });

      imbHorarios.forEach(function (hr) {
        Object.keys(hr).forEach(function (key) {
          if (key == 'imbhr_dia_semana') hr[key] = daysOfTheWeek[hr[key]];

          if (/_inicio|_fim/.test(key) && hr[key])
            hr[key] = moment(hr[key]).format('HH:mm') + 'h';
        });

        if (hr.imbhr_inicio_manha && hr.imbhr_fim_manha) {
          hr.manha =
            'das ' + hr.imbhr_inicio_manha + ' às ' + hr.imbhr_fim_manha;
        } else if (
          (hr.imbhr_inicio_manha && hr.imbhr_fim_tarde) &&
          !(hr.imbhr_fim_manha && hr.imbhr_inicio_tarde)
        ) {
          hr.manha =
            'das ' + hr.imbhr_inicio_manha + ' às ' + hr.imbhr_fim_tarde;
        }

        if (hr.imbhr_inicio_tarde && hr.imbhr_fim_tarde) {
          hr.tarde =
            'das ' + hr.imbhr_inicio_tarde + ' às ' + hr.imbhr_fim_tarde;
        }

        delete hr.imbhr_inicio_manha;
        delete hr.imbhr_fim_manha;
        delete hr.imbhr_inicio_tarde;
        delete hr.imbhr_fim_tarde;

        horarios[
          hr.imbhr_dia_semana == 'Sábado' || hr.imbhr_dia_semana == 'Domingo'
            ? 'weekend'
            : 'normal'
        ].push({
          day: hr.imbhr_dia_semana,
          hour: [hr.manha, hr.tarde]
            .filter(function (el) {
              return !!el;
            })
            .join(' / '),
        });
      });

      vm.horarios = [];
      Object.keys(horarios).forEach(function (key) {
        var arr = horarios[key];
        var hours = arr.reduce(function (acc, crr) {
          if (!acc[crr.hour]) acc[crr.hour] = [];
          acc[crr.hour].push(crr.day);

          return acc;
        }, {});

        Object.keys(hours).forEach(function (key) {
          vm.horarios.push({
            day: hours[key].join('/'),
            hour: key,
          });
        });
      });
    }

    function formatImb(imb) {
      var redessociais = [];
      var emails = [];
      formatOpeningHours(imb);

      (imb.redessociais || []).forEach(function (rds) {
        redessociais.push({
          url: rds.rd_url,
          nome: rds.rd_nome ? rds.rd_nome.tprd_nome : null,
        });
      });

      (imb.emails || []).forEach(function (e) {
        emails.push({
          nome: e.nome,
          endereco: e.endereco,
        });
      });

      // imb.cidade = imb.cidade || {};
      // imb.cidade.estado = imb.cidade.estado || {};

      return {
        imb_config_site: imb.imb_config_site,
        enderecos: imb.enderecos,
        id: imb.id,
        nome: imb.imb_nome,
        creci: imb.imb_creci,
        cidade: imb.cidade.nome,
        estado: imb.estado.nome,
        endereco: imb.imb_endereco
          ? imb.imb_endereco +
            ', ' +
            (imb.imb_end_numero ? imb.imb_end_numero + '. ' : '') +
            (imb.imb_end_complemento ? imb.imb_end_complemento : '') +
            (imb.cidade
              ? ' - ' + imb.cidade.nome + ' - ' + imb.estado.sigla
              : '')
          : '',
        latitude: imb.imb_latitude,
        longitude: imb.imb_longitude,
        telefones: imb.telefones,
        horarios: vm.horarios,
        site: 'https://' + imb.imb_url_site,
        sociais: redessociais,
        listaEmails: emails,
        descricao:
          imb.estado.nome + ' > ' + imb.cidade.nome + ' > ' + imb.imb_nome,
      };
    }

    vm.imb_selected = vm.info_imb;

    var hasTelephone =
      vm.info_imb.telefones &&
      vm.info_imb.telefones.some(function (telephone) {
        return telephone.numero;
      });

    vm.showPhones =
      hasTelephone && vm.config_wl.imb_config_site.show_contact_phones;
    vm.imbs = [vm.imbs];

    $scope.$watch('vm.form_map.state', function (newValue, oldValue) {
      if (newValue && newValue.id) {
        // reset box
        vm.form_map.citys = [
          {
            id: null,
            nome: 'Selecione uma cidade',
          },
        ];

        vm.form_map.city = vm.form_map.citys[0];
        vm.form_map.citys = vm.form_map.citys.concat(vm.form_map.state.cidade);
        // Cidade.find({
        //   filter: {
        //     fields: ['id', 'nome'],
        //     where: {
        //       estado_id: newValue.id
        //     }
        //   }
        // },
        //   function (res) {
        //     vm.form_map.citys = vm.form_map.citys.concat(res);
        //   })
      }
    });

    vm.isLoading = true;
    var idImb = $stateParams.idImb;
    function initImobiliaria() {
      if (vm.config_wl.isArbo) {
        $rootScope.loadingModal.start('Carregando Imobiliária');
        Imobiliaria.getImobiliaria(
          {
            where: {
              imb_ativa: true,
              imb_allow_site_arbo: true,
              imb_nome: { nilike: '%teste%' },
            },
          },
          function (res) {
            vm.imbs = [];
            try {
              res.forEach(function (imb) {
                vm.imbs.push(formatImb(imb));
              });
              if (idImb) {
                idImb = idImb.split('-');
                vm.imbs.forEach(function (list) {
                  if (!!idImb && list.id == idImb[0]) {
                    changeMap(list);
                  }
                });
                vm.imb_selected = vm.imbs.find(function (imb) {
                  return imb.id == idImb[0];
                });
              }
              $timeout(function () {
                seoService.ldJsonFaleConosco(
                  vm.imb_selected.nome != 'Arbo Imóveis'
                    ? vm.imb_selected
                    : null
                );
                seoService.generateTags({
                  title:
                    vm.imb_selected.nome == 'Arbo Imóveis'
                      ? 'Entre em contato com nossa equipe - Arbo Imóveis.'
                      : 'Fale conosco - ' + vm.imb_selected.nome,
                  description:
                    vm.imb_selected.nome == 'Arbo Imóveis'
                      ? 'Fale conosco. Arbo Imóveis oferece CRM para imobiliárias e incorporadoras. Também somos um portal para quem quer vender, comprar ou alugar imóveis.'
                      : 'Anuncie com ' +
                        vm.imb_selected.nome +
                        ', a imobiliária com os melhores imóveis à venda e para alugar na região de ' +
                        vm.imb_selected.cidade +
                        '.',
                  slug: $location.absUrl(),
                });
              });
            } catch (error) {
              console.error(error);
            } finally {
              vm.isLoading = false;
              $rootScope.loadingModal.stop();
            }
          }
        );
      } else {
        vm.isLoading = false;
      }
    }

    initImobiliaria();
    function init() {
      $('#header').addClass('fixed-theme');
      vm.form_map.init();

      vm.showMapModal = false;
      // initMap()
      //updateInfoImb()

      if (PROD) {
        // PAGE_VIEW searchresults
        gtag('event', 'page_view', {
          listing_id: 'contato',
          listing_pagetype: 'other',
        });
      }
    }

    function initMap() {
      var myLatLng = {
        lat: vm.imb_selected.latitude,
        lng: vm.imb_selected.longitude,
      };

      var style = [
        {
          elementType: 'labels.icon',
          stylers: [
            {
              saturation: -100,
              color: '#dddddd',
            },
          ],
        },
        {
          featureType: 'poi.school',
          elementType: 'labels.icon',
          stylers: [
            {
              color: '#dddddd',
            },
          ],
        },
        {
          elementType: 'labels.text',
          stylers: [
            {
              saturation: -100,
            },
          ],
        },
      ];

      // map desk
      vm.map = new google.maps.Map(document.getElementById('googlemaps'), {
        center: myLatLng,
        zoom: 17,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        styles: style,
      });

      if ($rootScope.ConfigWhiteLabel.isArbo) {
        var image = {
          url: '../../assets/images/novosite/marker.png',
          size: new google.maps.Size(35, 45),
          scaledSize: new google.maps.Size(25, 35),
        };
      } else {
        var image = {
          path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z',
          fillColor: $rootScope.ConfigWhiteLabel.primary_color,
          fillOpacity: 1,
          anchor: new google.maps.Point(0, 0),
          strokeWeight: 1.8,
          strokeColor: '#FFF',
          scale: 0.07,
        };
      }

      marker = new google.maps.Marker({
        position: myLatLng,
        map: vm.map,
        icon: image,
      });

      if (angular.element(window).width() <= 768) {
        // map mobile
        vm.mapmob = new google.maps.Map(
          document.getElementById('googlemapsmob'),
          {
            center: myLatLng,
            zoomControl: true,
            zoomControlOptions: {
              position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
            zoom: 17,
          }
        );
        marker = new google.maps.Marker({
          position: myLatLng,
          map: vm.mapmob,
          icon: image,
        });
      }
    }

    //// function updateInfoImb() {
    //   var modalImbInfo = angular.element('.imb-infos').clone()
    //   angular.element('#modal-imb-infos').html('')
    //   angular.element('#modal-imb-infos').html(modalImbInfo)
    // }

    function changeMapEndAdicionais(end) {
      // debugger;
      vm.imb_selected_end = end;

      //updateInfoImb()
      if (end.latitude && end.longitude) {
        var map;

        if (angular.element(window).width() > 768) {
          //desk (dont open modal)
          map = vm.map;
        } else {
          //mobile
          map = vm.mapmob;
          angular.element('#modalContact').modal();
        }

        if (end.latitude != null) {
          map.panTo({
            lat: end.latitude,
            lng: end.longitude,
          });
        }

        if ($rootScope.ConfigWhiteLabel.isArbo) {
          var image = {
            url: '../../assets/images/novosite/marker.png',
            size: new google.maps.Size(35, 45),
            scaledSize: new google.maps.Size(25, 35),
          };
        } else {
          var image = {
            path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z',
            fillColor: $rootScope.ConfigWhiteLabel.primary_color,
            fillOpacity: 1,
            anchor: new google.maps.Point(0, 0),
            strokeWeight: 1.8,
            strokeColor: '#FFF',
            scale: 0.07,
          };
        }

        marker.setMap(null);
        // vm.map.center({lat:end.latitude,lng:end.longitude})
        marker = new google.maps.Marker({
          position: {
            lat: end.latitude,
            lng: end.longitude,
          },
          map: map,
          icon: image,
        });
      }
    }

    function changeMap(imb) {
      vm.imb_selected = imb;
      vm.imb_selected_end = null;
      //updateInfoImb()
      var map;

      if (angular.element(window).width() > 768) {
        //desk (dont open modal)
        map = vm.map;
      } else {
        //mobile
        map = vm.mapmob;
        angular.element('#modalContact').modal();
      }

      // if(imb.latitude != null){
      //   map.panTo({
      //     lat: imb.latitude,
      //     lng: imb.longitude
      //   })
      // }

      if ($rootScope.ConfigWhiteLabel.isArbo) {
        var image = {
          url: '../../assets/images/novosite/marker.png',
          size: new google.maps.Size(35, 45),
          scaledSize: new google.maps.Size(25, 35),
        };
      } else {
        var image = {
          path: 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z',
          fillColor: $rootScope.ConfigWhiteLabel.primary_color,
          fillOpacity: 1,
          anchor: new google.maps.Point(0, 0),
          strokeWeight: 1.8,
          strokeColor: '#FFF',
          scale: 0.07,
        };
      }

      // marker.setMap(null);
      // vm.map.center({lat:imb.latitude,lng:imb.longitude})
      // marker = new google.maps.Marker({
      //   position: {
      //     lat: imb.latitude,
      //     lng: imb.longitude
      //   },
      //   map: map,
      //   icon: image,
      // });
    }

    function routeImbContact(imb) {
      if (!imb) return '';
      var name = textFormatter.removeSpecialChar(imb.nome);
      return imb.id + '-' + name + '/fale-conosco';
    }

    vm.formatSite = function (site) {
      // site = site.replace('http://', '');
      if (site != null)
        return site.replace(/(http(s)?):\/\//g, '').split(':')[0];
      else return 'Site is null';
    };

    vm.sendContact = function (e) {
      e.preventDefault();

      SendEmail.emailContact(vm.form_contato).$promise.then(
        function (succ) {
          swangular.swal({
            type: 'success',
            title: 'Recebemos seu email !',
            text: 'Já estamos providenciando um atendente para entrar em contato',
          });
          vm.form_contato = {};
        },
        function (err) {
          e.preventDefault();
          e.stopPropagation();

          swangular.swal({
            type: 'success',
            title: '<i class="fal fa-frown"></i><br/>NÃÃÃÃÃÃOOOOOOO !',
            html:
              'Aconteceu um problema com nosso site.<br/> Perdemos o seu contato.<br/>' +
              'Por favor entre em contato <a href="tel:40033793">40033793</a>',
          });
        }
      );
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('ConhecaController', ConhecaController)

  /* @ngInject */
  function ConhecaController($scope, $document, $state, $sce, $timeout, $http, PROD, $rootScope, SERVER_URL, SendEmail, swangular, $location, seoService) {
    var vm = this;
    var imob = $rootScope.ConfigWhiteLabel;
    vm.cadastroPage = 1;
    vm.imb_rich_text = imob.quemSomos;
    vm.imob = imob;

    if(!imob.imb_config_site.tecnologia && $state.current.name == 'main.conheca-tecnologia'){
      $state.go('main.home')
    }
    if($state.current.name == 'main.conheca-quem-somos' && (vm.imb_rich_text || '').length === 0){
      $state.go('main.home')
    }
    vm.trustAsHtml = function(string) {
      return $sce.trustAsHtml(string);
    };
    switch ($state.current.name) {
      case 'main.conheca-tecnologia':
          seoService.generateTags({
            title: 'Arbo. All in One',
            description: 'Na Arbo integramos todos os processos imobiliários redesenhando cada etapa. Oferecemos serviços para imobiliárias, corretores, compradores, vendedores, locatários e incorporadoras. Temos como missão aprimorar todos os fluxos do mercado imobiliário.',
            slug: $location.absUrl()
          })
        break;
      case 'main.conheca-imob':
          seoService.generateTags({
            title: 'Arbo para Imobiliárias',
            description: 'Na Arbo você elimina os processos imobiliários desconexos e passa a focar no que realmente importa: resultados comerciais e a excelência na jornada do seu cliente.',
            slug: $location.absUrl()
          })
        break;
      case 'main.conheca-incorp':
          seoService.generateTags({
            title: 'Arbo para Incorporadoras',
            description: 'Na Arbo você elimina os processos desconexos e passa a focar no que realmente importa: resultados comerciais e a excelência na jornada do seu cliente.',
            slug: $location.absUrl()
          })
        break;
      case 'main.conheca-quem-somos':
          seoService.generateTags({
            title: 'Quem Somos | '+ vm.imob.nome,
            description: vm.trustAsHtml,
            slug: $location.absUrl(),
            image: (vm.imob.url_logo_branca || 'http://www.arboimoveis.com.br/assets/images/novosite/arbo_verde.png')
          })
        break;
      default:
        break;
    }

    vm.listing = [0, 1, 2]
    vm.properties = {
      loop:true,
      dots: true,
      nav: true,
      items:3,
      autoWidth:true,
      margin:100,
      center: true,
      navText : [
        '<i class="fa fa-angle-left" aria-hidden="true"></i>',
        '<i class="fa fa-angle-right" aria-hidden="true"></i>'
      ]
    };
    function init_map(){
      var myLatLng = {
        lat: -23.304453,
        lng: -51.169582
      }
      var style = [
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "saturation": -100,
              "color": "#dddddd"
            }
          ]
        },
        {
          "featureType": "poi.school",
          "elementType": "labels.icon",
          "stylers": [
            {
              "color": "#dddddd"
            }
          ]
        },
        {
          "elementType": "labels.text",
          "stylers": [
            {
              "saturation": -100
            }
          ]
        }
      ]
      // map desk
      vm.map = new google.maps.Map(document.getElementById('googlemaps'), {
        center: myLatLng,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        zoom: 17,
        styles: style
      });
    }
    // if(imob.isArbo)
    // {
    //   var _url = SERVER_URL+'api/imobiliarias/crudGET/' + 9;
    //   $http.get(_url).then(function(response){
    //     vm.imb_rich_text = response.data.imb_rich_text;
    //   });
    // }
    // else
    // {
    //   var _url = SERVER_URL+'api/imobiliarias/crudGET/' + imob.id;
    //   $http.get(_url).then(function(response){
    //     vm.imb_rich_text = response.data.imb_rich_text;
    //   });
    // }
    vm.form_contato = {
      name: '',
      email: '',
      phone: '',
      message: '',
      uf: '',
      city: '',
      by_whats: false
    }

    // var nextBtn = angular.element('.cadastro-rapido #next-page');
    // var prevBtn = angular.element('.cadastro-rapido #prev-page');

    // nextBtn.click(function (evt) {
    //   console.log(vm.cadastroPage);
    //   if (vm.cadastroPage < 3) {
    //     nextBtn.css({ 'color': '' });
    //     prevBtn.css({ 'color': '' });
    //     vm.cadastroPage++;
    //   }
    //   else {
    //     vm.cadastroPage = 1;
    //     nextBtn.css({ 'color': '#aaa' });
    //   }
    //   $scope.$apply();
    // });
    // prevBtn.click(function (evt) {
    //   console.log(vm.cadastroPage);
    //   if (vm.cadastroPage > 1) {
    //     nextBtn.css({ 'color': '' });
    //     prevBtn.css({ 'color': '' });
    //     vm.cadastroPage--;
    //   }
    //   else {
    //     vm.cadastroPage = 3;
    //     prevBtn.css({ 'color': '#aaa' });
    //   }
    //   $scope.$apply();
    // });

    $timeout(function () {
      init()
      if(vm.imob.isArbo)
      {
        // init_map()
      }
    });

    function init() {
      $('#header').addClass('fixed-theme');

      // $('#cadastro-rapido-carousel').bcSwipe({
      //   threshold: 0
      // });

      // $('#cadastro-rapido-carousel').on('slide.bs.carousel', function (evt) {
      //   vm.cadastroPage = evt.to + 1;
      //   $scope.$apply();
      // })

      var elem = document.getElementById('conheca');
      if(elem){
        elem.querySelectorAll('a[href^="#"]').forEach(function(anchor){
          anchor.addEventListener('click', function (e) {
            e.preventDefault();

            var div = $($(this).attr('href'));
            var scrollToPosition = div.offset().top - 65;

            window.scrollTo(0, scrollToPosition);
          })
        })
      }

      if(PROD){
        var state = 'quem-somos';
        // PAGE_VIEW searchresults
        gtag('event', 'page_view', {
          listing_id: state,
          listing_pagetype: 'other'
        });
      }
    }

    vm.sendConheca = function (e) {
      e.preventDefault()

      vm.form_contato.message = 'Estado: ' + vm.form_contato.uf + '\nCidade: ' + vm.form_contato.city + '\nSomente por WhatsApp: ' + vm.form_contato.by_whats;
      vm.form_contato.message = 'URL de envio:' + $location.absUrl()  + '\n\n'+ vm.form_contato.message;

      SendEmail.emailContact(vm.form_contato)
        .$promise.then(function (succ) {
          swangular.swal({
            type: 'success',
            title: 'Recebemos seu email !',
            text: 'Já estamos providenciando um atendente para entrar em contato'
          })
          vm.form_contato = {}
        }, function (err) {
          e.preventDefault();
          e.stopPropagation();
        })
    }
  }
})();

// (function () {
//     'use strict';

//     angular
//         .module('arboWeb')
//         .service('carousel', carousel);

//     function carousel() {
//         var vm = this;

//         vm.nextOwl = nextOwl;
//         vm.prevOwl = prevOwl;

//         function nextOwl(ev) {
//             $('#' + ev).trigger('next.owl.carousel');
//         }

//         function prevOwl(ev) {
//             $('#' + ev).trigger('prev.owl.carousel');
//         }

//         function removeSpecialChar(str) {
//             str = str.toLowerCase().replace(/[`~!@—#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-').replace(/\s/g, '-').replace(/---/g, '-').replace(/--/g, '-');

//             str = str.toLowerCase();
//             str = str.replace(/\s/g, '_');
//             str = str.replace(/[!"#$%&'()*+,./:;<=>?@[\]^`{|}~]/g, '');

//             for (var i in vm.conversions) {
//                 var re = new RegExp(vm.conversions[i], "g");
//                 str = str.replace(re, i);
//             }
//             return str;
//         };
//     }
// })();
(function () {
  'use strict';

  angular.module('arboWeb').controller('BairroController', BairroController);

  /** @ngInject */
  function BairroController(
    $anchorScroll,
    PROD,
    $rootScope,
    $state,
    $stateParams,
    $http,
    $window,
    Imovel,
    swangular,
    SERVER_URL,
    textFormatter,
    seoService,
    $location,
    API_MAPBOX,
    GOOGLE_API,
    $interval,
    Bairros,
    SITE_URL
  ) {
    var vm = this;

    var response = Bairros;
    vm.tipovar = $stateParams.tipovar ? $stateParams.tipovar + '/' : '';
    vm.config_wl = $rootScope.ConfigWhiteLabel;
    vm.readMore = false;
    vm.readMoreImv = false;
    vm.openModalMoreInfo = openModalMoreInfo;
    vm.readMoreFunc = readMoreDescription;
    vm.readMoreImoveisFunc = readMoreImoveisFunc;
    vm.urlFormatter = textFormatter.urlFormatter;
    vm.urlPath = $stateParams.tipo1;
    // vm.ldJsonBairroRestaurante = seoService.ldJsonBairroRestaurante();
    // vm.ldJsonBairroBar = seoService.ldJsonBairroBar();
    $rootScope.mapa = true;
    $rootScope.newBairro = null;
    vm.mapa = true;
    vm.url = SERVER_URL + 'api/bairros-replica/get-bairro-slug';
    vm.moreRegion = 'ficam nessa região.';
    // debugger
    vm.owlProperties = {
      loop: false,
      nav: false,
      margin: 10,
      dots: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 22,
        },
        700: {
          items: 2,
          stagePadding: 25,
        },
        980: {
          items: 2,
          stagePadding: 25,
        },
        981: {
          items: 1,
          stagePadding: 5,
        },
        1080: {
          items: 2,
          stagePadding: 5,
        },
        1439: {
          items: 3,
          stagePadding: 5,
        },
        1900: {
          items: 3,
          stagePadding: 5,
        },
      },
    };

    vm.search = {
      mapa: false,

      toggle: function (mobile) {
        if (!mobile) {
          $rootScope.mapa = angular.copy(vm.mapa);

          if (vm.mapa) {
            this.mapa = true;
            $('#neighborhood').css({ 'padding-right': '0' });
            $('.neighborhood-content').css({
              width: 'calc(50% - 21px)',
              'min-width': 'calc(50% - 21px)',
            });
            $('.map-wrapper').css({
              width: 'calc(50% + 21px)',
              'min-width': 'calc(50% + 21px)',
              'margin-left': '0',
            });
            $('#map-homepage').css({
              height: '100%',
              width: 'auto',
              position: 'relative',
            });
          } else {
            $('#neighborhood').css({ 'padding-right': '' });
            $('.neighborhood-content').css({
              width: '100%',
              'min-width': '100%',
              'margin-left': '0',
            });
          }
        } else if (mobile == 'mapaMobile') {
          vm.mapa = true;
          this.mapa = true;
          $rootScope.mapa = angular.copy(vm.mapa);

          $('.neighborhood-content').css({ display: 'none' });
          $('#page-footer').attr('style', 'display:none !important;');
          $('.map-wrapper').attr('style', 'display:block !important;');
          $('#titulos-mobile').attr('style', 'display:block !important;');
          try {
            getGeoLocation();
            // $rootScope.$broadcast('filterRefresh', null);
          } catch (error) {
            debugger;
          }
        } else if (mobile == 'listaMobile') {
          vm.mapa = false;
          this.mapa = false;
          $rootScope.mapa = angular.copy(vm.mapa);
          $('.neighborhood-content').show();
          $('.map-wrapper').hide();
        }
      },
    };
    function ordenacao(a, b) {
      if (b.user_ratings_total == a.user_ratings_total) return 0;
      if (b.user_ratings_total > a.user_ratings_total) return 1;
      else if (b.user_ratings_total < a.user_ratings_total) return -1;
      else return -1;
    }
    function init() {
      seoService.ldJsonBreadCrumb();
      seoService.ldJsonPlace();
      $rootScope.newBairro = angular.copy(response.data.bairro);
      if (!response.data.bairro) $state.go('main.error404');
      vm.proximidades = response.data.bairro;
      vm.proximidades.imoveis = response.data.imoveis || [];
      vm.proximidades.proxs = response.data.proxs || [];
      vm.proximidades.superPadariaFarm = [];
      vm.proximidades.barCafeRestaurant = [];
      vm.proximidades.oQueFazer = [];
      vm.proximidades.tags = response.data.tags || [];
      vm.formatPlace = function (text) {
        return (
          SITE_URL +
          'imoveis/' +
          vm.tipovar +
          textFormatter.urlFormatter(text + ' ' + vm.urlPath)
        );
      };
      vm.urlSearch = vm.urlFormatter(
        vm.proximidades.brr_cidade + ' ' + vm.proximidades.brr_estado
      );
      var groupPlace = [
        {
          name: 'Transporte público',
          singleName: 'Os pontos',
          group_id: 1,
          icon: 'bus',
          places: [],
          group: ['bus_station', 'subway_station', 'train_station'],
        },
        {
          name: 'Escolas, colégios e universidades',
          singleName: 'As instituições',
          group_id: 2,
          icon: 'graduation-cap',
          places: [],
          group: ['university', 'school'],
        },
        {
          name: 'Museus, teatros e arenas de show',
          singleName: 'As áreas de lazer',
          group_id: 3,
          icon: 'theater-masks',
          places: [],
          group: ['museum', 'movie_theater', 'stadium'],
        },
        {
          name: 'Shoppings',
          singleName: 'Os shoppings',
          group_id: 4,
          icon: 'shopping-bag',
          places: [],
          group: ['shopping_mall'],
        },
      ];

      vm.myPlaces = groupPlace.map(function (el) {
        el.group.forEach(function (_el) {
          if (vm.proximidades.brr_configs[_el]) {
            vm.proximidades.brr_configs[_el].map(function (location) {
              location.score =
                location.rating + location.user_ratings_total / 10;
              return location;
            });
            el.places = el.places.concat(vm.proximidades.brr_configs[_el]);
          }
        });
        return el;
      });

      vm.myPlaces = vm.myPlaces.map(function (el) {
        el.places.sort(function (_el) {
          return _el.score - _el.score;
        });
        el.places = el.places.slice(0, 3);
        el.desc = el.places
          .map(function (value) {
            return value.name;
          })
          .join(', ');
        el.desc = el.singleName + ' ' + el.desc + ' ficam nessa região.';
        return el;
      });

      /**
           * Supermercados, padarias e farmácias
              - drugstore
              - pharmacy
              - supermarket
              - bakery
           */
      vm.proximidades.superPadariaFarm = []
        .concat(
          vm.proximidades.brr_configs.drugstore || [],
          vm.proximidades.brr_configs.pharmacy || [],
          vm.proximidades.brr_configs.bakery || [],
          vm.proximidades.brr_configs.supermarket || []
        )
        .sort(function (a, b) {
          return ordenacao(a, b);
        });
      // Bares e restaurantes
      // bar
      // cafe
      // restaurant
      vm.proximidades.barCafeRestaurant = []
        .concat(
          vm.proximidades.brr_configs.bar || [],
          vm.proximidades.brr_configs.cafe || [],
          vm.proximidades.brr_configs.restaurant || []
        )
        .sort(function (a, b) {
          return ordenacao(a, b);
        });
      //O que fazer no bairro?
      /**
           * amusement_park
            art_gallery
            movie_theater
            park
            shopping_mall
            museum
          */
      vm.proximidades.oQueFazer = []
        .concat(
          vm.proximidades.brr_configs.museum || [],
          vm.proximidades.brr_configs.art_gallery || [],
          vm.proximidades.brr_configs.movie_theater || [],
          vm.proximidades.brr_configs.park || [],
          vm.proximidades.brr_configs.shopping_mall || []
        )
        .sort(function (a, b) {
          return ordenacao(a, b);
        });
      if (vm.proximidades.proxs.length == 1) {
        vm.moreRegion = 'fica nessa região.';
      }

      var arr = [];

      var description =
        'Conheça o bairro ' +
        vm.proximidades.brr_nome +
        ' em ' +
        vm.proximidades.brr_cidade +
        '.';
      if (
        vm.proximidades.superPadariaFarm &&
        vm.proximidades.superPadariaFarm.length > 1
      )
        arr.push(vm.proximidades.superPadariaFarm[0].name);
      if (vm.proximidades.oQueFazer && vm.proximidades.oQueFazer.length > 1)
        arr.push(
          vm.proximidades.oQueFazer[0].name,
          vm.proximidades.oQueFazer[1].name
        );
      description += ' Próximo a ' + arr.join(', ') + '.';

      seoService.generateTags({
        title:
          'Imóveis em ' +
          vm.proximidades.brr_nome +
          ', ' +
          vm.proximidades.brr_cidade +
          ' - ' +
          vm.proximidades.brr_estado,
        description: description,
        slug: vm.proximidades.brr_slug,
        canonical:
          'https://' + $location.host() + '/bairros/' + vm.proximidades.brr_slug,
      });

      seoService.ldJsonPlace(vm);
      seoService.ldJsonBreadCrumb(vm);
      seoService.ldJsonBairroRestaurante(vm);
      seoService.ldJsonBairroBar(vm);

      setTimeout(function () {
        constructMoreInfos();
        var _descriptions = $('#descriptions');
        try {
          if (_descriptions.height() <= 256) {
            $('#btn-read-more').hide();
          }
          if (!vm.isMobile()) {
            getGeoLocation();
          }
        } catch (e) {
          //todo
        }
      }, 50);
    }

    function readMoreDescription() {
      if (vm.readMore) {
        $anchorScroll.yOffset = 100;
        $anchorScroll('descriptions');
      }
      vm.readMore = !vm.readMore;
    }
    function readMoreImoveisFunc() {
      if (vm.readMoreImv) {
        $anchorScroll.yOffset = 100;
        $anchorScroll('imoveis-proximos');
      }
      vm.readMoreImv = !vm.readMoreImv;
    }

    function openModalMoreInfo() {
      swangular.open({
        animation: false,
        showCloseButton: true,
        showConfirmButton: false,
        html: '<div class="slide-animate" ng-include="\'app/components/modal/dialog-infos.html\'"></div>',
        controllerAs: 'vm',
        controller: 'BairroController',
      });
    }

    // vm.goToImv = goToImv;
    // function goToImv() {
    // 	debugger;
    // 	var url = 'http://www.arboimoveis.com.br/imoveis/' + vm.urlPath;
    // 	$window.open(url, '_blank');
    // }

    function constructMoreInfos() {
      if (vm.proximidades.brr_configs.bus_station) {
        if (vm.proximidades.brr_configs.bus_station.length == 1) {
          $('#bus-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.bus_station[0].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.bus_station.length == 2) {
          $('#bus-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.bus_station[0].name +
              '  e  ' +
              vm.proximidades.brr_configs.bus_station[1].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.bus_station.length >= 3) {
          $('#bus-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.bus_station[0].name +
              ', ' +
              vm.proximidades.brr_configs.bus_station[1].name +
              '  e  ' +
              vm.proximidades.brr_configs.bus_station[2].name +
              '.</p>'
          );
        }
      }

      if (vm.proximidades.brr_configs.subway_station) {
        if (vm.proximidades.brr_configs.subway_station.length == 1) {
          $('#subway-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.subway_station[0].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.subway_station.length == 2) {
          $('#subway-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.subway_station[0].name +
              '  e  ' +
              vm.proximidades.brr_configs.subway_station[1].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.subway_station.length >= 3) {
          $('#subway-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.subway_station[0].name +
              ', ' +
              vm.proximidades.brr_configs.subway_station[1].name +
              '  e  ' +
              vm.proximidades.brr_configs.subway_station[2].name +
              '.</p>'
          );
        }
      }

      if (vm.proximidades.brr_configs.train_station) {
        if (vm.proximidades.brr_configs.train_station.length == 1) {
          $('#train-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.train_station[0].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.train_station.length == 2) {
          $('#train-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.train_station[0].name +
              '  e  ' +
              vm.proximidades.brr_configs.train_station[1].name +
              '.</p>'
          );
        } else if (vm.proximidades.brr_configs.train_station.length >= 3) {
          $('#train-station').append(
            '<p class="info">Nessa região, você pode ter acesso a transportes públicos  em ' +
              vm.proximidades.brr_configs.train_station[0].name +
              ', ' +
              vm.proximidades.brr_configs.train_station[1].name +
              '  e  ' +
              vm.proximidades.brr_configs.train_station[2].name +
              '.</p>'
          );
        }
      }

      if (vm.proximidades.brr_configs.school) {
        if (vm.proximidades.brr_configs.school.length == 1) {
          $('#school').append(
            '<p class="info">A instituição ' +
              vm.proximidades.brr_configs.school[0].name +
              ' fica nessa região.</p>'
          );
        } else if (vm.proximidades.brr_configs.school.length == 2) {
          $('#school').append(
            '<p class="info">As instituições ' +
              vm.proximidades.brr_configs.school[0].name +
              '  e  ' +
              vm.proximidades.brr_configs.school[1].name +
              ' ficam nessa região.</p>'
          );
        } else if (vm.proximidades.brr_configs.school.length >= 3) {
          $('#school').append(
            '<p class="info">As instituições ' +
              vm.proximidades.brr_configs.school[0].name +
              ', ' +
              vm.proximidades.brr_configs.school[1].name +
              '  e  ' +
              vm.proximidades.brr_configs.school[2].name +
              ' ficam nessa região.</p>'
          );
        }
      }
    }
    angular.element(document).ready(function () {
      setTimeout(function () {
        $('#header').addClass('fixed-theme');
        $('#action-list').appendTo('#list-social');
        $('#list-social').addClass('col-md-3');
        $('.list-social').css({ 'margin-bottom': '12px' });
        $('#yourproposal').css({ width: '180px' });
        $('#addproperty').css({ width: '180px' });
        $('#addpropertysite').css({ width: '180px' });
        $('#evaluateproperty').css({ width: '180px' });
      }, 50);
      vm.isMobile = function () {
        var pageWidth = angular.element('body').outerWidth();
        return pageWidth < 992;
      };
    });
    function getGeoLocation() {
      $http
        .get('//api-site.arboimoveis.com.br/api/geocaches/search/' + vm.urlPath)
        .then(function (results, error) {
          var coordinates = {
            center: { lat: 0, lng: 0 },
            south_west: { lat: 0, lng: 0 },
            north_east: { lat: 0, lng: 0 },
            order: 'mais_relevantes',
          };

          var res = results.data;
          results = results.data.geometry;
          // // Centro do Mapa
          coordinates.center.lat = results.location.lat;
          coordinates.center.lng = results.location.lng;
          coordinates.south_west.lat =
            results.viewport.southwest.lat +
            (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
          coordinates.south_west.lng =
            results.viewport.southwest.lng +
            (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
          // // North East
          coordinates.north_east.lat =
            results.viewport.northeast.lat -
            (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
          coordinates.north_east.lng =
            results.viewport.northeast.lng -
            (vm.isMobile() ? 0.029201541956219046 : 0.029118311092801264);
          coordinates.allcidade = processGMapsRow(res);

          Imovel.findByPolygonNew(coordinates, function (success) {
            vm.listing = success;
            var coord = angular.copy(coordinates);
            $rootScope.newBairro.coord = coord;
            // $rootScope.$broadcast('mapRefresh', coord);
            setTimeout(function () {
              $rootScope.$broadcast('listingMapRefresh', {
                listings: vm.listing,
                cidade:
                  vm.proximidades.brr_nome + ' - ' + vm.proximidades.brr_cidade,
              });
            }, 50);
          });
        });
    }

    function processGMapsRow(item) {
      var zipcode = null;
      var number = null;
      var bairro = null;
      var logradouro = null;
      var cidade = null;
      var estado = null;
      var sigla = null;
      var pais = null;
      item.address_components.forEach(function (element) {
        if (element.types[0] == 'postal_code') {
          zipcode = element.long_name;
        } else if (element.types[0] == 'street_number') {
          number = element.long_name;
          if (number.indexOf(',') != -1) {
            number = number.split(',')[0];
          }
        } else if (
          element.types[0] == 'neighborhood' ||
          element.types[1] == 'sublocality'
        ) {
          bairro = element.long_name;
        } else if (element.types[0] == 'route') {
          logradouro = element.long_name;
        } else if (element.types[0] == 'administrative_area_level_2') {
          cidade = element.long_name;
        } else if (element.types[0] == 'administrative_area_level_1') {
          estado = element.long_name;
          sigla = element.short_name;
        } else if (element.types[0] == 'country') {
          pais = element.long_name;
        }
      }, this);
      return {
        label: item.formatted_address,
        value: item.formatted_address,
        latitude: item.geometry.location.lat,
        longitude: item.geometry.location.lng,
        zipcode: zipcode,
        number: number,
        bairro: bairro,
        logradouro: logradouro,
        cidade: cidade,
        estado: estado,
        sigla: sigla,
        pais: pais,
      };
    }
    init();
  }
})();

(function () {
  'use strict';
  angular
    .module('arboWeb')
    .service('auth', authService);

  authService.inject = ['$window', '$timeout', 'LoopBackAuth', 'Usuario', '$state', '$auth', 'SERVER_URL', '$http', 'toastr', 'toastrConfig', 'FRONTEND_URL'];

  function authService($window, $timeout, LoopBackAuth, Usuario, $state, $auth, SERVER_URL, $http, toastr, toastrConfig, FRONTEND_URL, swangular, Urlacess) {
    var self = this;

    self.updateLocalStorage = function (item, i) {
      var user = self.getUser();
      user[item] = i;
      self.setUserInfo(user);
    }

    self.setUserLb = function (accessToken) {
      LoopBackAuth.setUser(accessToken.id, accessToken.userId, accessToken.user);
      LoopBackAuth.rememberMe = true;
      LoopBackAuth.save();
    // ;
    }

    self.setUserInfo = function (user) {
      window.localStorage['user'] = angular.toJson(user);
    // ;
    }

    self.getUser = function () {
      if (window.localStorage['user']) {
        return JSON.parse(window.localStorage['user']);
      }
      return false;
    }

    self.isAuthenticated = function () {
      return LoopBackAuth.currentUserId != null;
    }

    //Autenticacao Provider
    // self.authenticate = function (provider, params) {

    //   return $auth.authenticate(provider)
    //     .then(function (response) {
    //       self.removeSatellizer();
    //       var obj = {
    //         accessToken: response.access_token
    //       }
    //       $http.post(SERVER_URL + 'api/users/facebook/token', obj)
    //         .then(
    //           function (response) {
    //             var accessToken = {
    //               id: response.data.id,
    //               userId: response.data.user.id,
    //               user: response.data.user
    //             }
    //             self.setUserLb(accessToken);
    //             self.setUserInfo(response.data.user);

    //             if (params.r.length > 0) {
    //               $window.location.href = FRONTEND_URL + params.r;
    //             } else {
    //               if (params.toPost) {
    //                 $state.go('main.panel.createPanel.createListing.create1');
    //               } else if (params.toBecome) {
    //                 if (accessToken.user.has_submitted_guardian) {
    //                   $state.go('main.panel.createPanel.createListing.create1');
    //                 } else {
    //                   $state.go('main.panel.avatarPanel.registerGuardian.part1');
    //                 }
    //               } else {
    //                 $state.go('main.search');
    //               }
    //             }
    //           },
    //           function (response) {
    //             self.removeSatellizer();
    //             if (response.data.error.name === 'CANT_CREATE_USER') {
    //               angular.extend(toastrConfig, {
    //                 autoDismiss: false,
    //                 containerId: 'toast-container',
    //                 maxOpened: 1,
    //                 newestOnTop: true,
    //                 positionClass: 'toast-top-right',
    //                 preventDuplicates: false,
    //                 preventOpenDuplicates: true,
    //                 progressBar: false,
    //                 target: 'body',
    //                 timeOut: 5000
    //               });
    //               toastr.warning('Você precisa permitir o uso de seu email do Facebook.');
    //             }
    //           });
    //     })
    //     .catch(function (response) {
    //     })
    //     .finally(function () {
    //     });
    // }

    self.logout = function (token) {

      Usuario.userLogout({
        'accessToken': token
      }).$promise.then(function (success) {
        LoopBackAuth.clearUser();
        LoopBackAuth.clearStorage();
        $window.localStorage.removeItem('user');
        $window.localStorage.removeItem('closed_note');
        $window.localStorage.removeItem('waitingUsers');
        $window.localStorage.removeItem('myLocation');
        if ($state.current.authenticate) {
          $state.go('main.home', {}, {reload: true});
        }else{
          $state.go($state.current.name, {}, {reload: true});
        }
      }, function (err) {
        LoopBackAuth.clearUser();
        LoopBackAuth.clearStorage();
        $window.localStorage.removeItem('user');
        $window.localStorage.removeItem('closed_note');
        $window.localStorage.removeItem('waitingUsers');
        $window.localStorage.removeItem('myLocation');
        if ($state.current.authenticate) {
          $state.go('main.home', {}, {reload: true});
        }else{
          $state.go($state.current.name, {}, {reload: true});
        }
      });
    }

    self.login = function (credentials){
      return Usuario.login(credentials, function success(data) {
        //console.log(data);
      //;
        var accessToken = {
          id: data.id,
          userId: data.user.id,
          user: data.user
        }
        self.setUserLb(accessToken);
        self.setUserInfo(data.user);
        return data;
      }, function error(data) {
        return data
      });
    }

    self.logWithUrl = function(hash){
      function succ(data){
        // throw 'deu ruim'
        // debugger
        if(!data[0]){
          throw 'Hash expirado'
        } else {
          var accessToken = {
            id: data[0].token_id,
            userId: data[0].user_id,
            user: data[0].usuario
          }
          self.setUserLb(accessToken);
          self.setUserInfo(data[0].usuario);

          // Urlacess.deactivateUrl({acessId:data[0].id},function(data){
          //   // console.log(data.message);
          // });
          // window.location.reload()
          return data[0];
        }
        // if(!data.message && data[0] && data[0].token){
          // self.logout();

        // }
      }

      function err (data) {
        throw data
        // self.logout()
        // $state.go('main.home', {}, {reload: true});
        // return data;
      }

      return Urlacess.userData(hash, succ, err);
    }

    self.getCurrentUserId = function () {
      return LoopBackAuth.currentUserId;
    }

    self.getCurrentUserToken = function () {
      return LoopBackAuth.accessTokenId;
    }

    self.removeSatellizer = function () {
      if ($window.localStorage.getItem('satellizer_token')) {
        $window.localStorage.removeItem('satellizer_token');
      }
    }
  }

})();

(function () {
	'use strict';

	angular.module('arboWeb').controller('AgendamentoController', AgendamentoController);

	/* @ngInject */
	function AgendamentoController($scope, $state, $rootScope, $location, $timeout, $http, $window, auth, textFormatter, createThumb, seoService, listingImovel, SERVER_URL, PROD) {
		var vm = this;
		var configWL = $rootScope.ConfigWhiteLabel;
		vm.config_wl = configWL;
		vm.listing = listingImovel ? listingImovel.imovel : ($state.go('main.home'), {});
		vm.currentUrl = $location.absUrl();
		$scope.pageContato = listingImovel.contatar || null;
		vm.form = {};
		vm.spinner = "<i class='icon fas fa-spinner fa-pulse'></i>";
		vm.dateVisita = true;
		vm.nextPage = false;
		vm.pageOne = true;
		vm.isMobile = isMobile();

		vm.today = moment().add(1,'days').format('YYYY-MM-DD');

		vm.titleContato = /agendamento/g.test($state.current.name) ? 'Agendamento' : 'Contato';

		if (!!location.search.replace('?', '')) {
			var oldParams = localStorage.getItem('params_campain');
			var _full = (oldParams ? oldParams + '&' : '') + location.search.replace('?', '');
			var array = _full.split('&').reduce(function (ac, el) {
				var _split = el.split('=');
				if (_split && _split.length == 2) {
					ac[_split[0]] = _split[1];
				}
				return ac;
			}, {});
			localStorage.setItem('params_campain', $.param(array));
		}

		var paramsCampain = localStorage.getItem('params_campain') || null;
		vm.tag = {
			hidden: false,
		};
		if (!vm.listing.imv_ativo) {
			// vm.tag.text = 'Poxa, esse imóvel não está mais disponível :(';
			// vm.tag.textca = 'Poxa, esse imóvel não está mais disponível :(';
			// vm.tag.description = 'Mas temos outras opções que você vai amar. Deixe seu contato que a nossa equipe encaminha a opção ideal para você!';
			// vm.tag.svg = 'mudanca';
			// vm.tag.hidden = true;
		} else if (moment().diff(moment(vm.listing.createdAt), 'days') < 20) {
			if (vm.listing.view_week < 3) vm.tag.text = 'Eba, imóvel novinho no site! Você é o primeiro a chegar por aqui.';
			else vm.tag.text = 'Eba, imóvel novinho no site!';

			vm.tag.textca = vm.tag.text;
			vm.tag.description = 'Esse imóvel tem grandes chances de ser seu! Aproveite para agendar uma visita e conhecê-lo de pertinho.';
			vm.tag.svg = 'pin';
			vm.tag.hidden = true;
		} else if (vm.listing.view_week > 11) {
			vm.tag.text = vm.listing.view_week + ' pessoas estão de olho neste imóvel';
			vm.tag.textca = 'Uau, esse imóvel recebeu ' + vm.listing.view_week + ' visualizações na última semana.';
			vm.tag.description = 'Mas ele ainda pode ser seu! Adiante-se e marque uma visita para conferir de pertinho todos os detalhes.';
			vm.tag.svg = 'busca';
			vm.tag.hidden = true;
		}

		$scope.nextModal = function (number) {
			if (number == 1) {
				vm.pageOne = !vm.pageOne;
			}
		};

		$scope.checkField = function () {
			if (vm.form.cliente != null && vm.form.telefone != null && vm.form.email) {
				vm.nextPage = true;
			} else vm.nextPage = false;
		};

		vm.getMoreDates = function getMoreDates(date) {
			vm.dates = vm.getDates(date);
			return;
		};

		vm.getMoreTimes = function getMoreTimes(time) {
			vm.times = vm.getTimes(time);
			return;
		};

		function dayAsString(i) {
			return ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'][i];
		}

		vm.getDates = function getDates(startDate, daysToAdd) {
			daysToAdd = daysToAdd || 7;
			startDate = startDate || new Date();

			var dates = [];
			for (var i = 1, d = -3; i <= daysToAdd; i++, d++) {
				var currentDate = new Date();
				currentDate.setTime(startDate.getTime() + 24 * 60 * 60 * 1000 * d);
				dates.push({
					day: ('0' + currentDate.getDate()).slice(-2),
					date: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()),
					month: ('0' + (currentDate.getMonth() + 1)).slice(-2),
					dayOfWeek: dayAsString(currentDate.getDay()),
				});
			}
			return dates;
		};

		vm.momentFormater = function momentFormater(date, hour) {
			if (!date || !hour) return;
			var _hour = hour.split(':');
			var _date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), _hour[0], _hour[1], 0);
			if (moment().isBefore(_date, 'days,hours')) {
				vm.stringTime = moment(_date).format('[Agendar para dia] DD [de] MMMM, dddd [às] LT');
				vm.dateVisita = true;
			} else {
				vm.stringTime = 'Ops, essa data não está mais disponível. Por favor, selecione um dia após a data de hoje';
				vm.dateVisita = false;
			}
			return;
		};

		vm.getTimes = function getTimes(from, limit) {
			from = from || 0;
			limit = limit || 4;

			var times = [
				{index: 1, time: '08:00'},
				{index: 2, time: '08:30'},
				{index: 3, time: '09:00'},
				{index: 4, time: '09:30'},
				{index: 5, time: '10:00'},
				{index: 6, time: '10:30'},
				{index: 7, time: '11:00'},
				{index: 8, time: '11:30'},
				{index: 9, time: '12:00'},
				{index: 10, time: '12:30'},
				{index: 11, time: '13:00'},
				{index: 12, time: '13:30'},
				{index: 13, time: '14:00'},
				{index: 14, time: '14:30'},
				{index: 15, time: '15:00'},
				{index: 16, time: '15:30'},
				{index: 17, time: '16:00'},
				{index: 18, time: '16:30'},
				{index: 19, time: '17:00'},
				{index: 20, time: '17:30'},
				{index: 21, time: '18:00'},
				{index: 22, time: '18:30'},
			];

			return times.slice(from, from + limit);
		};

		vm.makeUrl = function makeUrl(listing, tipo) {
			// var urlPath = $location.$$url.split('?')[0].split('#')[0];
			if (listing) {
				if (!tipo) {
					var description = textFormatter.removeSpecialChar(listing.imv_titulo);
					return '/imovel/' + description + '/' + listing.imv_cod_gaia;
				} else {
					var city = textFormatter.removeSpecialChar(listing.imv_cidade) + '-' + listing.imv_estado.toLowerCase();
					var url = '';
					if (tipo === 1) {
						// url para cidade
						url = 'imoveis/' + city;
					} else if (tipo === 2) {
						//url para tipo negocio
						var tipo_negocio = listing.imv_preco_locacao ? 'imoveis/para-locacao/' : 'imoveis/a-venda/';
						url = tipo_negocio + city;
						return url;
					} else if (tipo === 3) {
						//url para tipo de imovel
						var tipo_negocio = listing.imv_preco_locacao ? 'imoveis/para-locacao/' : 'imoveis/a-venda/';
						url = tipo_negocio + textFormatter.removeSpecialChar(listing.tipo_imovel.timv_nome) + '/' + city;
					} else if (tipo === 5) {
						//url do bairro atual
						var bairro = textFormatter.removeSpecialChar(listing.imv_bairro) + '-';
						url = 'imoveis/' + bairro + city;
					} else if (tipo === 4) {
						//url do bairro atual
						var _url = $location.path().split('/');
						_url.pop();
						url = _url
							.filter(function (el) {
								return !!el;
							})
							.join('/');
					} else {
						return $location.path();
					}
					return '/' + url;
				}
			}
			return '/';
		};

		vm.stringTime = "";

		vm.submit = function submit(e) {
			e.preventDefault();
			var _copy = angular.copy(vm.form);
			_copy.card_params = paramsCampain;
			_copy.codigo_anuncio = vm.listing.imv_cod_gaia;
			_copy.midia = $location.host();
			_copy.corpo = $location.absUrl();
			_copy.visita_hora = _copy.visita_hora && moment(_copy.visita_hora).format('HH:mm');
			_copy.visita_data = _copy.visita_data && _copy.visita_data.toISOString();
      if (vm.config_wl && !vm.config_wl.isArbo) _copy.forceWhatsapp = true;

			vm.loading = true;

			$http({
				method: 'POST',
				url: SERVER_URL + 'api/cardsimovel/save-card-site',
				headers: {
					'Content-Type': 'application/json',
					'Access-Token': '60a156bb175722a22f2d97e6dd6bb762',
				},
				data: _copy,
			})
				.then(function (res) {
					vm.pageOne = vm.pageOne ? false : true;
					vm.contato = false;
					vm.succ = true;
					vm.msg_submit = 'Tudo certo!';

					vm.message = '<p>Legal, recebemos seu contato!</p>\
                            <p>Em breve um corretor estará a sua disposição.</p>';

					if (vm.form.visita_data) {
						vm.dateVisita = false;
						vm.finished = true;
						vm.message =
							'<p>Sua visita foi pré-agendada!</p>\
                                    <p class="red">' +
							vm.stringTime.replace('Agendar para dia ', '') +
							'</p>\
                                <p>Aguarde o contato do corretor para confirmar o horário que você sugeriu para a visita.</p>\
                                <img src="https://static-arbo.s3-sa-east-1.amazonaws.com/assets/Calendario.png"></img>\
                                <p>Enquanto isso você pode aproveitar para ver mais imóveis como este em nosso site!</p>';
					}

					if (PROD) {
						// Trovit Lead
						$window.ta('send', 'lead');

						if (typeof $window.fbq == 'function') {
							// FBQ Lead
							$window.fbq('track', 'Lead', {
								content_name: vm.listing.imv_titulo,
								content_category: /\/a-venda\//g.test($location.path()) ? 'venda' : /\/para-alugar\//g.test($location.path()) ? 'aluguel' : 'venda',
								currency: 'BRL',
								value: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
							});

							// if(vm.listing.imv_preco_venda){
							// var cids = /\/a-venda\//g.test($location.path()) ? vm.listing.imv_cod_gaia + '_venda' : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_cod_gaia + '_locacao' : vm.listing.imv_cod_gaia + '_venda';
							// $window.fbq('track', 'Purchase', {
							// 	currency: 'BRL',
							// 	value: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
							// 	content_ids: [cids],
							// 	content_type: 'product',
							// });
							// }
						}

						var lis = /\/a-venda\//g.test($location.path()) ? vm.listing.imv_cod_gaia + '_SALE' : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_cod_gaia + '_RENT' : vm.listing.imv_cod_gaia + '_SALE';

						if (typeof $window.gtag == 'function') {
							// page_view conversionintent
							$window.gtag('event', 'page_view', {
								listing_id: lis,
								listing_pagetype: 'conversionintent',
								listing_totalvalue: /\/a-venda\//g.test($location.path()) ? vm.listing.imv_preco_venda : /\/para-alugar\//g.test($location.path()) ? vm.listing.imv_preco_locacao : vm.listing.imv_preco_venda,
							});

							// Leads Analytics
							$window.gtag('event', 'lead', {
								'event_category': vm.listing.tipo_imovel && vm.listing.tipo_imovel.timv_nome ? vm.listing.tipo_imovel.timv_nome.toLowerCase() : 'imovel',
								'event_label': vm.listing.imv_cod_gaia.split('_')[1] || 'ARBO',
								'value': vm.listing.imv_cod_gaia,
							});

							// Lead Analytics TESTE
							$window.gtag('event', 'generate_lead');

							// Leads AdW
							$window.gtag('event', 'conversion', {'send_to': 'AW-851855382/Hz5cCOzq7pEBEJaQmZYD'});
						}
					}
				})
				.catch(function (err) {
					console.error(err.mesage);
					vm.error_submit = true;
					vm.msg_submit = 'Ocorreu um erro :(';
					$timeout(function () {
						vm.msg_submit = 'Tente novamente, por favor!';
					}, 2000);
				})
				.finally(function () {
					$timeout(function () {
						vm.loading = false;
						vm.error_submit = false;
						vm.msg_submit = '';
					}, 5000);
				});
		};

		seoService.generateTags({
			title: vm.titleContato + ' | ' + vm.listing.imv_titulo + ' - ' + vm.config_wl.nome,
			description:
				vm.titleContato == 'Agendamento'
					? 'Legal que você se interessou por esse imóvel! Preencha os campos abaixo para receber o contato da nossa equipe e agendar uma visita ao imóvel :)'
					: 'Legal que você se interessou por esse imóvel! Preencha os campos abaixo para receber o contato da nossa equipe e saber mais sobre o imóvel :)',
			image: (vm.listing.fotos[0] || {}).imvft_url,
			slug: $location.absUrl(),
		});

		function isMobile() {
			var pageWidth = angular.element('body').outerWidth();
			return pageWidth < 992;
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('arboWeb')
    .controller('AccountController', AccountController);

  /* @ngInject */
  function AccountController($scope, $state, $location, SERVER_URL, textFormatter, $stateParams, auth, Usuario, viaCEP, Imovel, EstadoCivil, FileUploader) {
    var vm = this;
    // 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
    vm.dayNumbers;
    vm.yearNumbers;
    vm.mounthNumbers = [{name:'Janeiro', days: 31}, {name:'Fevereiro', days: 28}, {name:'Março', days: 31}, {name:'Abril', days: 30}, {name:'Maio', days: 31}, {name:'Junho', days: 30}, {name:'Julho', days: 31}, {name:'Agosto', days: 31}, {name:'Setembro', days: 30}, {name:'Outubro', days: 31}, {name:'Novembro', days: 30}, {name:'Dezembro', days: 31}]
    vm.statusCivil = [{id: null, nome: 'Estado cívil'}];

    var user = auth.getUser();

    vm.dayGenerate = function(num){
      vm.dayNumbers = [];
      for(var x=1; x <= num; x++){
        vm.dayNumbers.push(x);
      }
    }

    vm.yearGenerate = function(ini, fim){
      vm.yearNumbers = []
      for(var x=fim; x >= ini; x--){
        vm.yearNumbers.push(x)
      }
    }
    
    vm.dayGenerate(31);
    vm.yearGenerate(1945, (new Date().getYear() + 1900));
    EstadoCivil.find({})
      .$promise.then(function(succ){
        vm.statusCivil = vm.statusCivil.concat(succ);
      }, function(err){
        console.log(err);
      })
      
    vm.formAddress ={
      address: {},
      viacepGet: function () {
        var that = this;
        // console.log(that.address.cep);

        if (that.address.imv_cep !== undefined && that.address.imv_cep.replace(/\D+/g).length == 8) {
          viaCEP.get(that.address.imv_cep)
            .then(function (res) {

              that.address.imv_bairro= res.bairro;
              that.address.imv_endereco= res.logradouro;
              that.address.imv_cidade= res.localidade;
              that.address.imv_estado= res.uf;
              that.address.imv_pais= 'Brasil'; // Tem que mudar depois isso

              // angular.element('#zipcode-address').focus();
              res.logradouro ? angular.element('#num-address').focus() : angular.element('#stre-address').focus();

              setTimeout(function () {
                // upperLabel();
              }, 100);

            }, function (err) {
              that.address = {};
              that.address_viacep = {};
  
              // upperLabel();

              // console.log(err);
            });
        }
      }
    }

    Imovel.getImovelUser({user: user.id})
      .$promise.then(function(succ){
        // console.log(succ);
        
      }, function(err){
        console.log(err);

      })
    Usuario.findById({ id: user.id, filter:{include: ['estado_civil', 'enderecos']}})
      .$promise.then(function(succ){
        // console.log(succ);
        vm.form = $.extend(vm.form, succ)
        setTimeout(function(){
          // upperLabel();
        }, 100)
      }, function(err){
        console.log(err);
        
      })
    angular.element(document).ready(function(){
      $('#header').addClass('fixed-theme');
      // init();
      // upperLabel();
    })

    function upperLabel() {
      angular.element('input.upper').each(function (index, element) {
        var $this = $(this);
        if (element.value.length > 0) {
          $this.siblings('label.upper').addClass('active');
        } else {
          $this.siblings('label.upper').removeClass('active');
        }
      })
    }

  }


})();
(function() {
    'use strict';

    angular
        .module('arboWeb')
        .service('appInitFactory', function($q, $rootScope) {

        })
        .factory('_', ['$window', function($window) {
            return $window._; // assumes underscore has already been loaded on the page
        }]);

})();
/* eslint-disable angular/no-run-logic */
(function () {
    'use strict';

    angular
        .module('arboWeb')
        .run(runBlock);

    /** @ngInject */
    // function runBlock($rootScope, $state, $timeout, $location, auth, $window, UserModel, FRONTEND_URL, PROD, ngMeta) {
    function runBlock($rootScope, $state, $timeout, $locale, $location, auth, $window, toastrConfig, FRONTEND_URL, PROD, ngMeta, swangular, seoService,SERVER_URL,$http) {
        ngMeta.init();
        var user = {};

        function runReload(toState) {
          if (
            [
              'ListingController',
              'homeController',
              'SearchController',
            ].includes(toState)
          ) {
            $timeout(function () {
              var urlParams = new URLSearchParams(window.location.search);
              var reloaded = urlParams.get('reloaded');

              if (!reloaded) {
                var href = new URL(window.location.href);
                href.searchParams.set('reloaded', 'true');
                window.location = href.toString();
                $timeout(function () {
                  location.reload();
                }, 100);
              }
            }, 0);
          }
        }
        // $locale.NUMBER_FORMATS.CURRENCY_SYM = 'R$ '; O site já possui Label de CURRENCY_SYM

        $locale.NUMBER_FORMATS.CURRENCY_SYM = '';
        $locale.NUMBER_FORMATS.DECIMAL_SEP = ',';
        $locale.NUMBER_FORMATS.GROUP_SEP = '.';

        $rootScope.FRONTEND_URL = FRONTEND_URL;

        // Marlon e Mane não vejam
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 236.88 72.76"><defs><style>.cls-1{fill:#00BF6F;}</style></defs><title>Ativo 1</title><g id="Camada_2" data-name="Camada 2"><g id="Camada_1-2" data-name="Camada 1"><path class="cls-1" d="M204.35,22.43a24.16,24.16,0,0,0-14.49-4.33A25.16,25.16,0,0,0,175,22.43a22.27,22.27,0,0,0-8.51,12,34.63,34.63,0,0,0-1.55,10.93,36.45,36.45,0,0,0,1.45,10.52,22.62,22.62,0,0,0,8.46,12.37,24.53,24.53,0,0,0,14.95,4.54,23.86,23.86,0,0,0,14.7-4.59A23.57,23.57,0,0,0,213,55.54a40.19,40.19,0,0,0,1.34-10.42,35,35,0,0,0-1.54-10.83A22.46,22.46,0,0,0,204.35,22.43Zm-5.52,30.12a11.46,11.46,0,0,1-3.4,5.67,8.37,8.37,0,0,1-5.67,2.06,8.85,8.85,0,0,1-5.93-2.06,11.33,11.33,0,0,1-3.46-5.67,27.5,27.5,0,0,1-.82-7.22,28,28,0,0,1,.82-7.33,10.89,10.89,0,0,1,3.41-5.46,8.73,8.73,0,0,1,5.77-2,8.9,8.9,0,0,1,5.88,2,10.81,10.81,0,0,1,3.4,5.46,28,28,0,0,1,.83,7.33A26.08,26.08,0,0,1,198.83,52.55Z"/><path class="cls-1" d="M234,57.14a9.61,9.61,0,0,0-6.7-2.63,9.36,9.36,0,0,0-6.5,2.63,8.18,8.18,0,0,0-2.89,6.24,8.6,8.6,0,0,0,2.68,6.34,9.22,9.22,0,0,0,6.71,2.63,9.53,9.53,0,0,0,6.8-2.63,8.42,8.42,0,0,0,2.79-6.34A8.15,8.15,0,0,0,234,57.14Z"/><path class="cls-1" d="M102.17,19.44A11,11,0,0,0,96.7,18.2a12.87,12.87,0,0,0-11.13,6c-.21.2-.38.27-.52.2s-.21-.24-.21-.51V20.75A1.85,1.85,0,0,0,83,18.9H72.16a1.85,1.85,0,0,0-1.86,1.85V69.89A2.1,2.1,0,0,0,72.4,72H82.75a2.09,2.09,0,0,0,2.09-2.09V42.54a8.41,8.41,0,0,1,2.58-6.44,10.15,10.15,0,0,1,6.29-2.74,23.33,23.33,0,0,1,2.38-.2,12.7,12.7,0,0,1,3,.41,2.61,2.61,0,0,0,1.49,0c.31-.14.5-.52.57-1.13l2-10.83A1.77,1.77,0,0,0,102.17,19.44Z"/><path class="cls-1" d="M149.25,21.92A19.72,19.72,0,0,0,137,18q-7.64,0-11.76,5.05c-.14.21-.29.28-.46.21s-.26-.24-.26-.52V1.36A1.36,1.36,0,0,0,123.19,0H111.37A1.36,1.36,0,0,0,110,1.36v69a1.59,1.59,0,0,0,1.6,1.6H123a1.6,1.6,0,0,0,1.6-1.6v-3c0-.28.09-.43.26-.47s.32.06.46.26A13.94,13.94,0,0,0,137,72.76a19.78,19.78,0,0,0,12.43-4.18,21.22,21.22,0,0,0,7.47-11,37.45,37.45,0,0,0,1.76-12.38,36.34,36.34,0,0,0-2-12.78A21.63,21.63,0,0,0,149.25,21.92Zm-8,33.72a8.07,8.07,0,0,1-7.53,4.43c-3,0-5.36-1.47-7-4.43q-2.07-3.81-2.07-10.21,0-6.81,2.17-10.62a7.87,7.87,0,0,1,6.91-4A8,8,0,0,1,141,34.7q2.48,4.14,2.47,10.83A21.2,21.2,0,0,1,141.26,55.64Z"/><path class="cls-1" d="M62.56,68.94h0L42.26,6.11,41.19,2.83A4.07,4.07,0,0,0,37.31,0h-12a4.07,4.07,0,0,0-3.88,2.83L20.42,6.11.11,68.94a2.84,2.84,0,0,0-.06.31c0,.08,0,.17,0,.25a1.56,1.56,0,0,0,0,.31,1.93,1.93,0,0,0,0,.24c0,.1.06.2.09.3a1.66,1.66,0,0,0,.06.21,2.34,2.34,0,0,0,.15.27L.44,71a1.55,1.55,0,0,0,.21.23s.09.11.15.16a2.4,2.4,0,0,0,.26.18l.18.13.35.13.16.06a2.12,2.12,0,0,0,.57.07H12.78a2.53,2.53,0,0,0,2.41-1.78l2.9-9.3a.58.58,0,0,1,.62-.52H44a.58.58,0,0,1,.62.52l2.89,9.3A2.53,2.53,0,0,0,49.89,72H60.35a2.12,2.12,0,0,0,.57-.07l.13,0a2.46,2.46,0,0,0,.38-.14c.06,0,.1-.08.16-.11a1.42,1.42,0,0,0,.28-.2c.05,0,.09-.1.14-.14a1.71,1.71,0,0,0,.22-.25,1.86,1.86,0,0,0,.11-.19,2.34,2.34,0,0,0,.15-.27,1.87,1.87,0,0,0,.07-.22,1.57,1.57,0,0,0,.08-.29,2.46,2.46,0,0,0,0-.26,2.81,2.81,0,0,0,0-.29,1.28,1.28,0,0,0-.05-.27C62.6,69.13,62.59,69,62.56,68.94Zm-22.1-19.8H22.21q-.62,0-.51-.72L22.42,46,31,17c.06-.24.17-.35.3-.39l.07,0,.06,0c.14,0,.24.15.3.39l8.56,29L41,48.42C41,48.9,40.87,49.14,40.46,49.14Z"/></g></g></svg>';
        var cssbiz = 'background: url(\'data:image/svg+xml;utf8,' + svg + '\') left top no-repeat; font-size: 60px;';
        console.log('\n%c     ', cssbiz);

        $rootScope.loadingModal = {
            start:function(message){
                swangular.swal({
                    html: message,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onOpen:function(){
                        swangular.showLoading();
                    }
                });
            },
            stop:function(){
                swangular.close();
            }
        }

        $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {          
            runReload(toState.controller);
            $(window).scrollTop(0);
            setMetas($rootScope.ConfigWhiteLabel)
            angular.extend(toastrConfig, {
                autoDismiss: false,
                containerId: 'toast-container',
                maxOpened: 1,
                newestOnTop: true,
                positionClass: 'toast-top-right',
                preventDuplicates: false,
                preventOpenDuplicates: true,
                progressBar: false,
                target: 'body'
            });

            if (PROD) {
                // gtag('config', 'UA-91552221-1');
                gtag('event', 'pageview', {
                    'event_category': 'PageView',
                    'event_label': $location.path()
                  });
            }
            $(document).on('focus click tap', 'input', function () {
                $(this).attr("autocomplete", 'off');
            });

            $('body').removeClass("position-fixed");
            $('.filters-toggle.menu-logo ').removeClass('d-none');
            $('#formHeader').removeClass('col-12');

            if (!(/main.search/g).test(toState.name) && isMobile()) {
                $('.filters-toggle.menu-logo ').addClass('d-none');
                $('#formHeader').addClass('col-12');
            }

            if (!(/main.home/g).test(toState.name)) {
                var header = $('#header');
                !(header.hasClass('fixed-theme')) ? header.addClass('fixed-theme'): null;
            }

        });

        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
            $(window).scrollTop(0);


            angular.extend(toastrConfig, {
                autoDismiss: false,
                containerId: 'toast-container',
                maxOpened: 1,
                newestOnTop: true,
                positionClass: 'toast-top-right',
                preventDuplicates: false,
                preventOpenDuplicates: true,
                progressBar: false,
                target: 'body'
            });

            $(document).on('focus click tap', 'input', function () {
                $(this).attr("autocomplete", 'off');
            });

            if(auth.isAuthenticated()){
              $http.get(SERVER_URL + 'api/users/check-jwt-token-app'
              ).catch(function(err) {
                if(err && err.status == 401){
                  auth.logout()
                  $state.transitionTo("main.home", {
                    r: decodeURI($location.$$url)
                  });
                  event.preventDefault();
                }
              })
            }

            // debugger;
            // auth.logWithUrl({emailCod: 'mp1pmlyo75cfrn9tic9bue3ura21ptz'})
            // .$promise.then(function(succ){
            //   deferred.resolve({selectedtab: tabs})
            // }, function(err){
            //   deferred.reject(null)
            // });


            // if (PROD) {
            //     // gtag('config', 'UA-91552221-1');
            //     gtag('event', 'pageview', {
            //         'event_category': 'PageView',
            //         'event_label': $location.path()
            //       });
            // }
            // if (auth.isAuthenticated()) {
            //   user = auth.getUser();

            //   if (!user.is_guardian) {
            //     // if ((toState.name.indexOf('createPanel') != -1) || (toState.name.indexOf('avatarPanel.listing') != -1)) {
            //     //   $state.transitionTo("main.home");
            //     //   event.preventDefault();
            //     // }
            //     UserModel.isGuardian({
            //       id: user.id
            //     }, function (response) {
            //       if (user.is_guardian !== response.is_guardian) {
            //         auth.updateLocalStorage('is_guardian', response.is_guardian);
            //         $rootScope.$emit('isGuardian', response.is_guardian);
            //       }
            //     });
            //   } else {
            //     // if (toState.name.indexOf('registerGuardian') != -1) {
            //     //   $state.transitionTo("main.home");
            //     //   event.preventDefault();
            //     // }
            //   }
            // }

            // if (toState.data.private && !auth.isAuthenticated()) {
            //   $state.transitionTo("main.login");
            //   event.preventDefault();
            // }

            // if (auth.isAuthenticated() && toState.data.anon) {
            //   $state.transitionTo("main.panel.avatarPanel.listings");
            //   event.preventDefault();
            // }

            if (toState.authenticate && !auth.isAuthenticated()) {
                // swangular.swal({
                //     title: 'Área Restrita',
                //     text: "Faça Login",
                //     type: 'warning',
                //     showCancelButton: false,
                //     confirmButtonColor: '#3085d6',
                //     cancelButtonColor: '#d33',
                //     confirmButtonText: 'Ok'
                //   }).then(function(result) {
                //     if (result.value) {
                //         $state.transitionTo("main.home", {
                //             r: decodeURI($location.$$url)
                //         });
                //         event.preventDefault();
                //     }
                //   });
              $state.transitionTo("main.home", {
                r: decodeURI($location.$$url)
              });
              event.preventDefault();
            }

            // if (fromState.name == 'main.home') {
            //   $rootScope.$emit('stopInterval');
            // }

            seoService.ldJsonHome();

        });

        // $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        //   if (PROD) {
        //     hj('stateChange', $location.url());
        //   }
        //   document.body.scrollTop = document.documentElement.scrollTop = 0;

        //   if (toState.url.indexOf('busca') > -1) {
        //     $timeout(function () {
        //       angular.element('#siteFooter').hide();
        //     });
        //   } else {
        //     $timeout(function () {
        //       angular.element('#siteFooter').show();
        //     });
        //   }

        //   if (toState.name.indexOf('main.panel.createPanel.createListing') == -1) {
        //     $timeout(function () {
        //       angular.element('#panel-header').show();
        //     });
        //   } else {
        //     $timeout(function () {
        //       angular.element('#panel-header').hide();
        //     });
        //   }
        // });

        $rootScope.$on('$locationChangeSuccess', function () {
            $rootScope.actualLocation = $location.path();
            ngMeta.setTag('canonical', 'https:'+$location.absUrl());

            // $(window).scrollTop(0);
            // if (PROD) {
            //     // gtag('config', 'UA-91552221-1');
            //     gtag('event', 'pageview', {
            //         'event_category': 'PageView',
            //         'event_label': $location.path(),
            //         'value': document.title
            //       });
            // }
        });

        // $rootScope.$watch(function () {
        //   return $location.path()
        // }, function (newLocation, oldLocation) {
        //   if ($rootScope.actualLocation === newLocation) {
        //     if ($location.path() == '/painel/criar/anuncio/part-2' || $location.path() == '/painel/criar/anuncio/part-3') {
        //       $location.path('/painel/criar/anuncio/part-1');
        //     }
        //     if ($location.path() == '/painel/registraguardiao/part-2' || $location.path() == '/painel/registraguardiao/part-3') {
        //       $location.path('/painel/registraguardiao/part-1');
        //     }
        //     if ($location.path() == '/painel/carteira' && !user.cpf) {
        //       $location.path('/');
        //     }
        //   }
        // });

        // if ($location.path() == '/painel/carteira' && !user.cpf) {
        //   $location.path('/');
        // }

        // if ($location.path() == '/painel/criar/anuncio/part-2' || $location.path() == '/painel/criar/anuncio/part-3') {
        //   $location.path('/painel/criar/anuncio/part-1');
        // }
        // if ($location.path() == '/painel/registraguardiao/part-2' || $location.path() == '/painel/registraguardiao/part-3') {
        //   $location.path('/painel/registraguardiao/part-1');
        // }
        function isMobile() {
            var pageWidth = angular.element('body').outerWidth();
            return (pageWidth < 992);
        }

        function setMetas(configs) {

            //set metas
            if(configs){
                var configSeo = {
                    title: configs.titulo_site,
                    desc: configs.descricao_site,
                    slug: $location.absUrl()
                }
                seoService.generateTags(configSeo);

                // ngMeta.setTitle(configs.titulo_site);
                // ngMeta.setTag('description', configs.descricao_site);
                // ngMeta.setTag('og:description', configs.descricao_site);
                // ngMeta.setTag('og:title', configs.titulo_site);

                // Google PageView
                // gtag('config', 'UA-91552221-1');
            }

        }

        $timeout(function () {
            $('.filters-toggle.menu-logo ').removeClass('d-none');
            $('#formHeader').removeClass('col-12');

            if (!(/main.search/g).test($state.current.name) && isMobile()) {
                $('.filters-toggle.menu-logo ').addClass('d-none');
                $('#formHeader').addClass('col-12');
            }
        }, 800)
    }

})();

/* eslint-disable angular/controller-as-route */
(function () {
  'use strict';

  angular.module('arboWeb').config(routerConfig);

  /**
   * Retorna apenas números de telefones válidos para ir para o site.
   * @param {Array} phones recebe os telefones cadatrados na configuração da imobiliária
   * @returns retorna telefones válidos para apresentação.
   */
  function checkForAllowedPhones(phones) {
    var allowedPhones = phones;
    var deniedPhones = ['11999293012', '40033793'];
    allowedPhones = allowedPhones.filter(function (phone) {
      return !deniedPhones.includes(phone.numero);
    });
    return allowedPhones;
  }

  /** @ngInject */
  function listingImovel(
    $rootScope,
    $q,
    $window,
    $state,
    $location,
    $stateParams,
    Imovel
  ) {
    var deferred = $q.defer();
    var params = $location.search();
    if (
      !(
        $location.path().includes('/contato') ||
        $location.path().includes('/agendamento')
      ) &&
      params['arbo_redirect'] == 'contato'
    ) {
      var url = $location.url();
      url = url.replace($location.path(), $location.path() + '/contato');
      $window.location.href = url;
      return;
    }
    Imovel.getImovelNew(
      {
        id: $stateParams.id.split('-')[0],
      },
      function (success) {
        var succ = {};
        success = JSON.parse(JSON.stringify(success[0] || null));
        succ.imovel = success;
        succ.isEmp = success ? success.imv_is_emp : false;
        succ.codigo = $stateParams.id.split('-')[0];
        setTimeout(function () {
          $(window).scrollTop(0);
        }, 2000); // scrollTop

        deferred.resolve(succ);
      }
    );

    return deferred.promise;
  }

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, ngMetaProvider) {
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('main', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main',
        abstract: true,
        data: {
          private: false,
        },
        authenticate: true,
        resolve: {
          ConfigWhiteLabel: function (
            $rootScope,
            $q,
            $http,
            $window,
            $location,
            Imobiliaria,
            createThumb
          ) {
            var deferred = $q.defer();

            if (
              /^testing.arboimoveis|^site.staging.arboimoveis|^www.arboimoveis|192.168.|localhost/.test(
                $location.host()
              )
            ) {
              //arbo
              var configs = {},
                link = null;

              configs.url_logo_branca =
                './assets/images/novosite/arbo_branco.png';
              configs.url_logo_verde =
                './assets/images/novosite/arbo_imoveis_desktop.svg';
              configs.url_logo_bg_escura =
                './assets/images/novosite/arbo_bg_escuro.png';
              configs.url_logo_footer =
                './assets/images/novosite/arbo_imoveis_desktop.svg';
              configs.url_logo_footer_endeavor =
                './assets/images/novosite/scale_up_endeavor_desktop.png';
              configs.url_logo_footer_endeavor_mobile =
                './assets/images/novosite/scale_up_endeavor_mobile.png';
              configs.url_logo_footer_mobile =
                './assets/images/novosite/arbo_imoveis_mobile.png';
              configs.url_capa =
                'https://static.arboimoveis.com.br/assets/arbonext/familia-sorrindo-na-cama-home.jpg';
              configs.instagram = ['https://www.instagram.com/arboimoveis/'];
              configs.facebook = ['https://www.facebook.com/arboimoveis/'];
              configs.linkedin = [
                'https://br.linkedin.com/company/arboimoveis',
              ];
              configs.youtube = [];
              configs.blog = ['https://blog.arboimoveis.com.br/'];
              configs.nome = 'Arbo Imóveis';
              configs.cidade = 'Londrina';
              configs.estado = 'PR';
              configs._estado = 'Paraná';
              configs.primary_color = getComputedStyle(
                document.body
              ).getPropertyValue('--primary-color');
              configs.secondary_color = getComputedStyle(
                document.body
              ).getPropertyValue('--secondary-color');
              configs.telefones = [
                { numero: '(11) 4040-3939' },
              ];
              configs.url_site = 'http://www.arboimoveis.com.br';
              configs.redessociais = [
                {
                  rd_url: 'https://www.facebook.com.br/arboimoveis',
                  rd_nome: { tprd_nome: 'Facebook' },
                },
                {
                  rd_url: 'https://www.instagram.com.br/arboimoveis',
                  rd_nome: { tprd_nome: 'Instagram' },
                },
                {
                  rd_url: 'https://br.linkedin.com/company/arboimoveis',
                  rd_nome: { tprd_nome: 'Linkedin' },
                },
                {
                  rd_url: 'https://blog.arboimoveis.com.br/',
                  rd_nome: { tprd_nome: 'Blog' },
                },
              ];
              configs.configwl = {};
              configs.endereco =
                'R. Bento Munhoz da Rocha Neto, 685 - Jardim do Lago, Londrina - PR, 86050-435';
              configs.creci = 'J6017';
              configs.latitude = -23.3297798;
              configs.longitude = -51.173675820;
              configs.emails = [];
              configs.horarios = [];
              configs.titulo_site =
                'Arbo - Plataforma Imobiliária';
              configs.descricao_site =
                'Encontre seu novo lar através das imobiliárias que anunciam no site Arbo. Utilize filtros e encontre os melhores imóveis, preços e regiões. Soluções Imobiliárias.';
              configs.imb_angariadora = true;
              configs.isArbo = true;
              configs.quemSomos = null;
              configs.enderecos = {};
              configs.imb_config_site = {
                titulo: 'Encontre o&nbsp;seu lugar',
                sub_titulo:
                  'Compre ou alugue com agilidade, segurança e sem burocracia',
                tecnologia: true,
                nossotime: false,
                watermark: false,
                tipo_imob: 3,
              };

              // favicon
              link = document.createElement('link');
              link.type = 'image/x-icon';
              link.rel = 'shortcut icon';
              link.href = '/assets/images/favicon/favicon-16x16.png';
              document.getElementsByTagName('head')[0].appendChild(link);

              deferred.resolve(configs);
            } else {
              Imobiliaria.getWhiteLabelConfigs({}, function (imb, err) {
                var configs = {},
                  link = null;

                configs.instagram = [];
                configs.blog = [];
                configs.facebook = [];
                configs.linkedin = [];
                configs.youtube = [];
                configs.twitter = [];
                configs.pinterest = [];

                if (imb && imb[0] && imb[0].arbo) {
                  //arbo
                  configs.url_logo_branca =
                    './assets/images/novosite/arbo_branco.png';
                  configs.url_logo_verde =
                    './assets/images/novosite/arbo-imoveis-desktop.png';
                  configs.url_logo_escura =
                    './assets/images/novosite/arbo_bg_escuro.png';
                  configs.url_logo_footer =
                    './assets/images/novosite/arbo-imoveis-desktop.png';
                  configs.url_logo_footer_endeavor =
                    './assets/images/novosite/scale_up_endeavor_desktop.png';
                  configs.url_logo_footer_endeavor_mobile =
                    './assets/images/novosite/scale_up_endeavor_mobile.png';
                  configs.url_logo_footer_mobile =
                    './assets/images/novosite/arbo_imoveis_mobile.png';
                  configs.url_capa =
                    'https://static.arboimoveis.com.br/assets/arbonext/familia-sorrindo-na-cama-home.jpg';
                  configs.instagram = [
                    'https://www.instagram.com/arboimoveis/',
                  ];
                  configs.facebook = ['https://www.facebook.com/arboimoveis/'];
                  configs.linkedin = [
                    'https://br.linkedin.com/company/arboimoveis',
                  ];
                  configs.youtube = [];
                  configs.blog = ['https://blog.arboimoveis.com.br/'];
                  configs.nome = 'Arbo Imóveis';
                  configs.cidade = 'Londrina';
                  configs.estado = 'PR';
                  configs._estado = 'Paraná';
                  configs.primary_color = getComputedStyle(
                    document.body
                  ).getPropertyValue('--primary-color');
                  configs.secondary_color = getComputedStyle(
                    document.body
                  ).getPropertyValue('--secondary-color');
                  configs.url_site = 'http://www.arboimoveis.com.br';
                  configs.redessociais = [
                    {
                      rd_url: 'https://www.facebook.com.br/arboimoveis',
                      rd_nome: { tprd_nome: 'Facebook' },
                    },
                    {
                      rd_url: 'https://www.instagram.com.br/arboimoveis',
                      rd_nome: { tprd_nome: 'Instagram' },
                    },
                    {
                      rd_url: 'https://br.linkedin.com/company/arboimoveis',
                      rd_nome: { tprd_nome: 'Linkedin' },
                    },
                    {
                      rd_url: 'https://blog.arboimoveis.com.br/',
                      rd_nome: { tprd_nome: 'Blog' },
                    },
                  ];
                  configs.endereco =
                    'R. Bento Munhoz da Rocha Neto, 685 - Jardim do Lago, Londrina - PR, 86050-435';
                  configs.creci = 'J6017';
                  configs.latitude = -23.3297798;
                  configs.longitude = -51.173675820;
                  configs.emails = [];
                  configs.horarios = [];
                  configs.titulo_site =
                    'Arbo - Plataforma Imobiliária';
                  configs.descricao_site =
                    'Encontre seu novo lar através das imobiliárias que anunciam no site Arbo. Utilize filtros e encontre os melhores imóveis, preços e regiões. Soluções Imobiliárias.';
                  configs.imb_angariadora = true;
                  configs.isArbo = true;
                  configs.quemSomos = null;
                  configs.enderecos = {};
                  configs.imb_config_site = {
                    titulo: 'Encontre o&nbsp;seu lugar',
                    sub_titulo:
                      'Compre ou alugue com agilidade, segurança e sem burocracia',
                    tecnologia: true,
                    nossotime: false,
                    watermark: false,
                    tipo_imob: 3,
                  };

                  // favicon
                  link = document.createElement('link');
                  link.type = 'image/x-icon';
                  link.rel = 'shortcut icon';
                  link.href = '/assets/images/favicon/favicon-16x16.png';
                  document.getElementsByTagName('head')[0].appendChild(link);

                  return deferred.resolve(configs);
                } else if (imb && imb[0]) {
                  document.documentElement.style.setProperty(
                    '--primary-color',
                    imb[0].imb_config_site.custom_accent_color || imb[0].imb_primary_color
                  );
                  document.documentElement.style.setProperty(
                    '--secondary-color',
                    imb[0].imb_second_color
                  );
                  configs.isArbo = false;
                  configs.id = imb[0].id;

                  for (var rd in imb[0].redessociais) {
                    switch (imb[0].redessociais[rd].rd_nome.tprd_nome) {
                      case 'Instagram':
                        configs.instagram.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'Blog':
                        configs.blog.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'Facebook':
                        configs.facebook.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'Linkedin':
                        configs.linkedin.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'YouTube':
                        configs.youtube.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'Twitter':
                        configs.twitter.push(imb[0].redessociais[rd].rd_url);
                        break;
                      case 'Pinterest':
                        configs.pinterest.push(imb[0].redessociais[rd].rd_url);
                        break;
                      default:
                        break;
                    }
                  }

                  configs.configwl = imb[0].config;
                  configs.url_logo_branca = imb[0].imb_url_logo; //Não sei de onde é essa logo, aparentemente é da pagina "quem somos"
                  configs.url_logo_bg_escura = imb[0].imb_url_logo; //logo da capa
                  configs.url_logo_verde = imb[0].imb_url_logo_do_menu //logo do menu
                    ? imb[0].imb_url_logo_do_menu
                    : imb[0].imb_url_logo;
                  configs.url_logo_footer = imb[0].imb_url_logo_rodape //logo do rodapé
                    ? imb[0].imb_url_logo_rodape
                    : imb[0].imb_url_logo;
                  configs.url_logo_footer_mobile = imb[0].imb_url_logo_rodape //logo do rodapé mobile
                    ? imb[0].imb_url_logo_rodape
                    : imb[0].imb_url_logo;
                  configs.url_capa = imb[0].imb_url_foto_capa;
                  configs.nome = imb[0].imb_nome;
                  configs.cidade = imb[0].cidade && imb[0].cidade.nome;
                  configs.estado = imb[0].cidade && imb[0].cidade.estado && imb[0].cidade.estado.sigla;
                  configs._estado = imb[0].cidade && imb[0].cidade.estado && imb[0].cidade.estado.nome;
                  configs.primary_color = imb[0].imb_primary_color;
                  configs.secondary_color = imb[0].imb_second_color;
                  configs.horarios = imb[0].horarios;
                  configs.url_site = imb[0].imb_url_site;
                  configs.redessociais = imb[0].redessociais;
                  configs.endereco_titulo = imb[0].imb_endereco_titulo;
                  configs.emails = imb[0].emails;
                  configs.endereco = imb[0].imb_endereco
                    ? imb[0].imb_endereco +
                      ',' +
                      (imb[0].imb_end_numero
                        ? imb[0].imb_end_numero + '. '
                        : '') +
                      (imb[0].imb_end_complemento
                        ? imb[0].imb_end_complemento
                        : '')
                    : '';
                  configs.creci = imb[0].imb_creci;
                  configs.latitude = imb[0].imb_latitude;
                  configs.longitude = imb[0].imb_longitude;
                  configs.titulo_site = imb[0].imb_titulo_site;
                  configs.descricao_site = imb[0].imb_descricao_site;
                  configs.image_site = imb[0].imb_url_foto_metadata
                    ? imb[0].imb_url_foto_metadata
                    : imb[0].imb_url_logo;
                  configs.imb_angariadora = imb[0].imb_angariadora;
                  configs.imb_hidden_address = imb[0].imb_hidden_address;
                  configs.imb_hidden_cond_num = imb[0].imb_hidden_cond_num;
                  configs.imb_hidden_number = imb[0].imb_hidden_number;
                  configs.quemSomos = imb[0].imb_rich_text;
                  configs.enderecos = imb[0].enderecos;
                  configs.telefones = imb[0].telefones && imb[0].telefones.length > 0 ? checkForAllowedPhones(imb[0].telefones): [];
                  configs.corretores = imb[0].corretores;
                  configs.imb_config_site = {
                    titulo: 'Encontre o&nbsp;seu lugar',
                    sub_titulo:
                      'Compre ou alugue com agilidade, segurança e sem burocracia',
                    tecnologia: false,
                    nossotime: false,
                    watermark: false,
                    tipo_imob: 3,
                  };
                  configs.imb_config_site = Object.assign(
                    configs.imb_config_site,
                    imb[0].imb_config_site || {}
                  );
                  configs.imb_config_crm = Object.assign(
                    imb[0].imb_config_crm || {}
                  );
                  if (imb[0].destaques) {
                    configs.destaques = imb[0].destaques
                      .sort(function (a, b) {
                        if (a.ides_ordem < b.ides_ordem) return -1;
                        if (a.ides_ordem > b.ides_ordem) return 1;
                        return 0;
                      })
                      .map(function (row) {
                        if (row.ides_url)
                          row.destaque.custom_url = row.ides_url;
                        return row.destaque;
                      });
                  } else {
                    configs.destaques = undefined;
                  }

                  // favicon
                  link = document.createElement('link');
                  link.type = 'image/x-icon';
                  link.rel = 'shortcut icon';
                  link.href =
                    imb[0].imb_favicon ||
                    '/assets/images/favicon/favicon-16x16.png';
                  document.getElementsByTagName('head')[0].appendChild(link);

                  return deferred.resolve(configs);
                } else {
                  $window.location.href = 'http://www.arboimoveis.com.br';
                }
              });
            }

            return deferred.promise;
          },
        },
      })
      .state('main.home', {
        url: '',
        templateUrl: 'app/components/home/home.html',
        controller: 'homeController',
        controllerAs: 'vm',
        authenticate: false,
      })
      // .state('main.quemsomos', {
      //   url: 'quem-somos',
      //   templateUrl: 'app/components/quemsomos/quemsomos.html',
      //   controller: '',
      //   controllerAs: 'vm',
      //   data: {
      //     css: 'app/components/quemsomos/quemsomos-style.css',
      //     private: false,
      //     meta: {
      //       'title': 'Imóveis para alugar e comprar sem burocracia - Arbo Imóveis.',
      //       'description': 'Comprar ou alugar imóveis online nunca foi tão fácil como na Arbo. Agende sua visita, simule o financiamento e feche negócio em poucos dias.'
      //     }
      //   },
      //   authenticate: false
      // })
      .state('main.search-lancamentos', {
        url: 'imoveis/novos',
        templateUrl: 'app/listing/searchLancamentos.html',
        controller: 'SearchControllerEmpreendimentos',
        controllerAs: 'vm',
        authenticate: false,
        params: {},
      })
      // .state('main.imobs-creci', {
      //   url: 'imobiliarias-credenciadas',
      //   templateUrl: 'app/components/view-creci/view-creci.html',
      //   controller: 'viewCreciController',
      //   controllerAs: 'vm',
      //   authenticate: false,
      // })
      .state('main.new-password', {
        url: 'nova-senha',
        templateUrl: 'app/components/newPass/newPass.html',
        controller: 'newPassword',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.privacypolicy', {
        url: 'politica-privacidade',
        templateUrl: 'app/components/ourServices/privacy-policy.html',
        controller: 'PrivacyPolicyController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.termsuse', {
        url: 'termos-uso',
        templateUrl: 'app/components/ourServices/terms-of-use.html',
        controller: 'TermsUseController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.favorites', {
        url: 'favoritos',
        templateUrl: 'app/components/favoritos/favoritos.html',
        controller: 'FavoritosController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.registerimovel', {
        url: 'cadastre-seu-imovel?i&ii',
        templateUrl: 'app/components/view-register/view-register.html',
        controller: 'viewRegisterController',
        controllerAs: 'vm',
        authenticate: false,
      })
      /*****************************
        Rotas do Painel do usuário
      *****************************/

      .state('main.painel', {
        url: '',
        templateUrl: 'app/account/painel.html',
        abstract: true,
        authenticate: true,
        params: {},
      })
      .state('main.painel.account', {
        url: 'minha-conta',
        templateUrl: 'app/account/account.html',
        controller: 'AccountController',
        controllerAs: 'vm',
        authenticate: true,
        params: {},
      })
      // voltar aqui
      .state('main.painel.dashboard', {
        url: 'dashboard?email&tab&selected',
        templateUrl: 'app/account/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm',
        // authenticate: true,
        // params: {
        //   option: null,
        //   suboption: null,
        //   page: null
        // },
        resolve: {
          loginUser: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            auth,
            $state
          ) {
            var deferred = $q.defer();
            var hash = $stateParams.email;
            var tabs = $stateParams.tab;
            if (!auth.isAuthenticated()) {
              if (!hash) {
                deferred.reject(null);
                return;
              }
              auth.logWithUrl({ emailCod: hash }).$promise.then(
                function (succ) {
                  deferred.resolve({ selectedtab: tabs });
                },
                function (err) {
                  deferred.reject(null);
                }
              );
            } else {
              if (tabs) {
                deferred.resolve({ selectedtab: tabs });
              } else {
                deferred.resolve(true);
              }
            }
            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform', {
        url: 'formulario',
        controller: function ($state) {
          $state.go('main.painel.typeform-1');
        },
      })

      // Formulamrio de Imovel
      .state('main.painel.typeform-1', {
        url: 'formulario/tipo-imovel?new&i&imv&imv_finalidade&imv_tipo&stimv_id&imv_subtipo&imv_tiponegocio&condominio',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: true,
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel
          ) {
            var deferred = $q.defer();
            if ($stateParams.imv) {
              Imovel.findById({ id: atob($stateParams.imv) }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform-2', {
        url: 'formulario/detalhes-da-transacao?new&i&imv&imv_finalidade&imv_tipo&stimv_id&imv_subtipo&imv_tiponegocio&condominio',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: true,
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel,
            ConfigWhiteLabel
          ) {
            var deferred = $q.defer();
            $stateParams.imb_id = ConfigWhiteLabel && ConfigWhiteLabel.id ? ConfigWhiteLabel.id : -1;
            if ($stateParams.imv) {
              Imovel.findById({
                id: atob($stateParams.imv),
                filter: { include: ['garantias'] },
              }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }


            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform-upload', {
        url: 'formulario/imagens-do-imovel?new&i&imv&imv_finalidade&imv_tipo&stimv_id&imv_subtipo&imv_tiponegocio&condominio',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: true,
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel
          ) {
            var deferred = $q.defer();
            if ($stateParams.imv) {
              Imovel.findById({
                id: atob($stateParams.imv),
                filter: { include: ['fotos'] },
              }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform-3', {
        url: 'formulario/detalhes-do-imovel/:idarray?new&i&imv&imv_finalidade&imv_tipo&stimv_id&imv_subtipo&imv_tiponegocio&condominio',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: true,
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel
          ) {
            var deferred = $q.defer();
            if ($stateParams.imv) {
              Imovel.findById({ id: atob($stateParams.imv) }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform-termos', {
        url: 'formulario/termos-de-uso?i&new&imv&imv_finalidade&imv_tipo&stimv_id&imv_subtipo&imv_tiponegocio&condominio',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: true,
        params: {
          imv: null,
        },
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel
          ) {
            var deferred = $q.defer();

            if ($stateParams.imv) {
              Imovel.findById({ id: atob($stateParams.imv), filter: { include: ['config_termos'] } }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.painel.typeform-obrigado', {
        url: 'formulario/obrigado',
        templateUrl: 'app/account/formulario/typeform.html',
        controller: 'typeFormController',
        controllerAs: 'vm',
        authenticate: false,
        params: {
          imv: null,
        },
        resolve: {
          ImovelSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imovel
          ) {
            var deferred = $q.defer();
            if ($stateParams.imv) {
              Imovel.findById({ id: atob($stateParams.imv) }).$promise.then(
                function (succ) {
                  return deferred.resolve(succ);
                },
                function (err) {
                  return deferred.reject(null);
                }
              );
            } else {
              return deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })

      /*****************************
        Fim Rotas do Painel do usuário
      *****************************/

      .state('main.proposta', {
        url: 'proposta-locacao',
        templateUrl: 'app/proposta/proposta.html',
        controllerAs: 'vm',
        abstract: true,
        authenticate: false,
        resolve: {
          mess: function ($location, ConfigWhiteLabel) {
            var imob = ConfigWhiteLabel;
            if (
              imob.imb_config_site['tipo_imob'] == 1 &&
              $location.path() == '/proposta-locacao'
            ) {
              $location.path('main.home');
            }
          },
        },
      })
      .state('main.proposta.form', {
        url: '?i&ii&corretor',
        templateUrl: 'app/proposta-compra/proposta.form.html',
        controller: 'propostaCompraController',
        controllerAs: 'vm',
        authenticate: false,

        resolve: {
          propInfo: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            auth,
            Imovel
          ) {
            localStorage.removeItem('$LoopBack$accessTokenId');
            function titleCase(str) {
              var splitStr = str.toLowerCase().split(' ');
              for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] =
                  splitStr[i].charAt(0).toUpperCase() +
                  splitStr[i].substring(1);
              }
              return splitStr.join(' ');
            }

            var deferred = $q.defer();
            if ($stateParams.i || $stateParams.ii) {
              var idUser = $stateParams.i
                ? atob(atob($stateParams.i))
                : undefined;
              var idImb = $stateParams.ii
                ? atob(atob($stateParams.ii))
                : undefined;
              var corretorUrl = $stateParams.corretor
                ? $stateParams.corretor
                : '';
              corretorUrl = corretorUrl.replace(/-/g, ' ');
              var corretor = titleCase(corretorUrl);

              var proposta = localStorage.getItem('proposta-locacao')
                ? JSON.parse(localStorage.getItem('proposta-locacao'))
                : {};
              proposta.negocio = proposta.negocio ? proposta.negocio : {};

              if (idUser) {
                proposta.negocio.corretor = { id: +idUser, label: corretor };
                localStorage.setItem(
                  'proposta-locacao',
                  JSON.stringify(proposta)
                );
              }

              if (idImb) {
                Imovel.getImoveisNew(
                  { where: { id: idImb } },
                  function (imb, err) {
                    proposta.negocio.cod_imovel = imb[0];
                    localStorage.setItem(
                      'proposta-locacao',
                      JSON.stringify(proposta)
                    );
                    localStorage.setItem('steps-locacao', 1);

                    deferred.resolve(null);
                  }
                );
              } else {
                deferred.resolve(null);
              }
            } else {
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.contraproposta', {
        url: '/:id/contraproposta?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.contraproposta.html',
        controller: 'propostaContrapropostaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(succ);
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.formdocs', {
        // stateParams = {id}
        url: '/:id/anexos?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.confirmacao.html',
        controller: 'propostaComfirmaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(
                      Object.assign(succ, {
                        success: true,
                        resend: false,
                      })
                    );
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.confirm', {
        url: '/:id/confirmacao?e&urlaccess', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.confirmacao.html',
        controller: 'propostaComfirmaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter,
            auth
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length == 2) {
                        //propStatusOld = 8 - Enviada ao proprietário?z
                        //propStatusOld = 7 - Pré aprovado
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if ([7, 8].includes(succ['propStatusOld'])) {
                          succ['pst_id'] = e[0];
                          succ['altBy'] = e[1];
                          var hash = $stateParams.urlaccess;
                          // deferred.resolve(Object.assign(succ,{success: true, resend: false}));
                          // deferred.resolve(succ);

                          // auth.logout()

                          if (hash) {
                            auth
                              .logWithUrl({ emailCod: $stateParams.urlaccess })
                              .$promise.then(
                                function (_succ) {
                                  // localStorage.setItem('aceiteEmAndamento',$stateParams.urlaccess)
                                  // deferred.resolve(succ)
                                  deferred.resolve(
                                    Object.assign(succ, {
                                      success: true,
                                      resend: false,
                                    })
                                  );
                                },
                                function (err) {
                                  console.error(err);
                                  deferred.resolve(
                                    Object.assign(succ, {
                                      success: true,
                                      resend: false,
                                    })
                                  );
                                  // deferred.resolve(false);
                                }
                              );
                          } else {
                            deferred.resolve(null);
                          }
                          // if (!auth.isAuthenticated() || (localStorage.getItem('aceiteEmAndamento') && typeof localStorage.getItem('aceiteEmAndamento') == 'string' && localStorage.getItem('aceiteEmAndamento') != $stateParams.urlaccess)) {

                          // }
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.status', {
        url: '/status/:hash',
        templateUrl: 'app/proposta/proposta.status.html',
        controller: 'propostaStatusController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          propostaStatus: function ($state, $stateParams, $q, Proposta) {
            var deferred = $q.defer();
            var hash = $stateParams.hash;

            if (!hash) {
              $state.go('main.home');
              deferred.resolve(null);
            } else {
              Proposta
                .statusByHash({hash: hash})
                .$promise
                .then(
                  function (succ) {
                    deferred.resolve(succ);
                  },
                  function (err) {
                    $state.go('main.home');
                    deferred.resolve(null);
                  }
                )
            }

            return deferred.promise;
          },
        },
      })

      .state('main.proposta.corretor', {
        url: '/corretor/:id',
        templateUrl: 'app/proposta/corretor.propostas.html',
        controller: 'corretorPropostasController',
        controllerAs: 'vm',
        authenticate: false,
        minHeader: true,
        resolve: {
          corretorPropostas: function ($state, $stateParams, $q, Proposta) {
            var deferred = $q.defer();
            var id = $stateParams.id;

            if (!id) {
              $state.go('main.home');
              deferred.resolve(null);
            } else {
              Proposta
                .getCorretorPropostas({id: id})
                .$promise
                .then(
                  function (succ) {
                    deferred.resolve(succ);
                  },
                  function (err) {
                    $state.go('main.home');
                    deferred.resolve(null);
                  }
                )
            }

            return deferred.promise;
          },
        },
      })

      .state('main.proposta.confirmcontra', {
        url: '/:id/confirmacao-contra?e&urlaccess', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.confirmacao-contra.html',
        controller: 'propostaComfirmaContraController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length == 2) {
                        //propStatusOld = 10 - Contraproposta do Proprietário
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if (succ['propStatusOld'] == 10) {
                          succ['pst_id'] = 8;
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(succ, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(null);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.recusar', {
        url: '/:id/recusar-proposta?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.recusar.html',
        controller: 'propostaComfirmaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length == 2) {
                        //propStatusOld = 10 - Contraproposta do Proprietários
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if (succ['propStatusOld'] == 10) {
                          succ['pst_id'] = 32; // 32 sempre finaliza a proposta
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(succ, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(null);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.proposta.locacaoconjunta', {
        url: '/:id/locacao-conjunta',
        templateUrl: 'app/proposta/proposta.locacaoconjunta.html',
        controller: 'propostaConjuntaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(succ);
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })

      .state('main.propostacompra', {
        url: 'proposta-compra',
        templateUrl: 'app/proposta-compra/proposta.html',
        controllerAs: 'vm',
        abstract: true,
        authenticate: false,
        resolve: {
          mess: function ($location, ConfigWhiteLabel) {
            var imob = ConfigWhiteLabel;
            if (
              imob.imb_config_site['tipo_imob'] == 2 &&
              $location.path() == '/proposta-compra'
            ) {
              $location.path('main.home');
            }
          },
        },
      })
      .state('main.propostacompra.form', {
        url: '?i&ii&card_imovel',
        templateUrl: 'app/proposta-compra/proposta.form.html',
        controller: 'propostaCompraController',
        controllerAs: 'vm',
        authenticate: false,

        resolve: {
          propInfo: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            auth,
            Imovel
          ) {
            function titleCase(str) {
              var splitStr = str.toLowerCase().split(' ');
              for (var i = 0; i < splitStr.length; i++) {
                splitStr[i] =
                  splitStr[i].charAt(0).toUpperCase() +
                  splitStr[i].substring(1);
              }
              return splitStr.join(' ');
            }

            var deferred = $q.defer();

            if ($stateParams.i || $stateParams.ii) {
              var idUser = $stateParams.i
                ? atob(atob($stateParams.i))
                : undefined;
              var idImb = $stateParams.ii
                ? atob(atob($stateParams.ii))
                : undefined;
              var corretorUrl = $stateParams.corretor
                ? $stateParams.corretor
                : '';
              corretorUrl = corretorUrl.replace(/-/g, ' ');
              var corretor = titleCase(corretorUrl);

              var proposta = localStorage.getItem('proposta-compra')
                ? JSON.parse(localStorage.getItem('proposta-compra'))
                : {};
              proposta.negocio = proposta.negocio ? proposta.negocio : {};

              if (idUser) {
                proposta.negocio.corretor = { id: +idUser, label: corretor };
                localStorage.setItem(
                  'proposta-compra',
                  JSON.stringify(proposta)
                );
              }

              if (idImb) {
                Imovel.getImoveisNew(
                  { where: { id: idImb } },
                  function (imb, err) {
                    proposta.negocio.cod_imovel = imb[0];
                    localStorage.setItem(
                      'proposta-compra',
                      JSON.stringify(proposta)
                    );
                    localStorage.setItem('steps-compra', 1);

                    deferred.resolve(null);
                  }
                );
              } else {
                deferred.resolve(null);
              }
            } else {
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.confirmcontra', {
        url: '/:id/confirmacao-contra?e&urlaccess', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta/proposta.confirmacao-contra.html',
        controller: 'propostaDefaultController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length == 2) {
                        //propStatusOld = 36 - Proprietário enviou uma contraproposta
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if (succ['propStatusOld'] == 36) {
                          succ['pst_id'] = 39;
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(succ, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(null);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.contraproposta', {
        url: '/:id/contraproposta?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta-compra/proposta.contraproposta.html',
        controller: 'propostaContrapropostaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(succ);
                  } else {
                    $state.go('main.propostacompra.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.propostacompra.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.propostacompra.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.formdocs', {
        url: '/:id/anexos?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta-compra/proposta.anexos.html',
        controller: 'propostaAnexosController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(succ);
                  } else {
                    $state.go('main.propostacompra.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.propostacompra.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.propostacompra.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.confirm', {
        url: '/:id/confirmacao?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta-compra/proposta.confirmacao.html',
        controller: 'propostaComfirmaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();

            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  if (succ.id) {
                    var e = atob(atob($stateParams.e)).split('&');

                    succ['hash'] = $stateParams.id;
                    succ['propStatusOld'] = angular.copy(succ['pst_id']);
                    var prop = angular.copy(succ);

                    try {
                      if (e.length && e.length >= 2) {
                        //propStatusOld = 34 - Gestor aceitou a proposta
                        if (succ['propStatusOld'] == 34) {
                          succ['pst_id'] = e[0];
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(prop, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(false);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(prop, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.propostacompra.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.propostacompra.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.propostacompra.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.recusar', {
        url: '/:id/recusar?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta-compra/proposta.recusa.html',
        controller: 'propostaComfirmaContraController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length >= 2) {
                        //propStatusOld = 34 - Gestor aceitou a proposta
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if (succ['propStatusOld'] == 34) {
                          succ['pst_id'] = 37;
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(succ, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(null);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.propostacompra.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.propostacompra.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.propostacompra.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.recusarcontra', {
        url: '/:id/recusar-proposta?e', // e = atob([:idproximostatus]&[:idparte])
        templateUrl: 'app/proposta-compra/proposta.recusa-contra.html',
        controller: 'propostaDefaultController', // Deixei essa controller pq ela não faz nada demais
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    var e = [];

                    try {
                      e = atob(atob($stateParams.e)).split('&');

                      if (e.length && e.length >= 2) {
                        //propStatusOld = 36 - Proprietário enviou uma contraproposta
                        succ['propStatusOld'] = angular.copy(succ['pst_id']);
                        if (succ['propStatusOld'] == 36) {
                          succ['pst_id'] = 42;
                          succ['altBy'] = e[1];

                          succ.$saveSite().then(
                            function (s) {
                              deferred.resolve(
                                Object.assign(succ, {
                                  success: true,
                                  resend: false,
                                })
                              );
                            },
                            function (e) {
                              deferred.resolve(null);
                            }
                          );
                        } else {
                          deferred.resolve(
                            Object.assign(succ, {
                              success: false,
                              resend: true,
                            })
                          );
                        }
                      } else {
                        deferred.resolve(null);
                      }
                    } catch (error) {
                      deferred.resolve(null);
                    }
                  } else {
                    $state.go('main.propostacompra.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.propostacompra.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.propostacompra.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })
      .state('main.propostacompra.conjunta', {
        url: '/:id/compra-conjunta',
        templateUrl: 'app/proposta-compra/proposta.conjunta.html',
        controller: 'propostaConjuntaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          currentProposta: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter
          ) {
            var deferred = $q.defer();
            if ($stateParams.id) {
              Proposta.findProposta({ hash: $stateParams.id }).$promise.then(
                function (succ) {
                  // debugger
                  if (succ.id) {
                    succ['hash'] = $stateParams.id;
                    deferred.resolve(succ);
                  } else {
                    $state.go('main.proposta.form');
                    deferred.resolve(null);
                  }
                },
                function (err) {
                  $state.go('main.proposta.form');
                  deferred.resolve(null);
                }
              );
            } else {
              $state.go('main.proposta.form');
              deferred.resolve(null);
            }

            return deferred.promise;
          },
        },
      })

      /*****************************/
      .state('main.contact', {
        url: 'fale-conosco',
        templateUrl: 'app/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.acceptterms', {
        url: 'aceitar-termos?email',
        templateUrl: 'app/lgpd/accept-terms.html',
        controller: 'AcceptTermsController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.contactImb', {
        url: ':idImb/fale-conosco',
        templateUrl: 'app/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.search-lancamentos-address', {
        url: 'imoveis/novos/:cidade',
        templateUrl: 'app/listing/searchLancamentos.html',
        controller: 'SearchControllerEmpreendimentos',
        controllerAs: 'vm',
        authenticate: false,
        params: {
          status: null,
        },
      })
      .state('main.search-lancamentos-address-status', {
        url: 'imoveis/novos/:status/:cidade',
        templateUrl: 'app/listing/searchLancamentos.html',
        controller: 'SearchControllerEmpreendimentos',
        controllerAs: 'vm',
        authenticate: false,
        params: {
          status: null,
        },
      })

      // Pesquisa de imoveis
      .state('main.search-all', {
        url: 'imoveis',
        // templateUrl: 'app/listing/search.html',
        // controller: 'SearchController',
        // controllerAs: 'vm',
        controller: function ($rootScope, $state) {
          var vm = this;
          vm.config_wl = $rootScope.ConfigWhiteLabel;
          var address =
            vm.config_wl.cidade && vm.config_wl.estado
              ? vm.config_wl.cidade.toLowerCase().replace(/ /g, '-') +
                '-' +
                vm.config_wl.estado.toLowerCase().replace(/ /g, '-')
              : 'londrina-pr';

          $state.go(
            'main.search-address',
            { tipo1: address },
            { reload: true }
          );
        },
        authenticate: false,
        // resolve: {
        //   tiposImovel: function ($stateParams, $q, TipoImovel, textFormatter, ConfigWhiteLabel) {

        //     var deferred = $q.defer();

        //     TipoImovel.find({}, function (res, info) {
        //       return deferred.resolve(res)
        //     });
        //     return deferred.promise;
        //   }
        // }
      })
      .state('main.search-address', {
        url: 'imoveis/:tipo1?precovenda&precolocacao&area&dormitorios&imb_id&vagas&mobilia&noimovel&noempreendimento&myLocation&pagina',
        templateUrl: 'app/listing/search.html',
        controller: 'SearchController',
        controllerAs: 'vm',
        authenticate: false,

        // params:{
        //   cidade: null,
        //   tipovar: null,
        //   tipoimovel: null
        // },
        resolve: {
          configRoute: function (
            $stateParams,
            $q,
            TipoImovel,
            textFormatter,
            ConfigWhiteLabel
          ) {
            var deferred = $q.defer();
            $stateParams.cidade =
              ConfigWhiteLabel.cidade.toLowerCase() +
              '-' +
              ConfigWhiteLabel.estado.toLowerCase();

            TipoImovel.find({}, function (res, info) {
              if (
                $stateParams.tipo1 == 'a-venda' ||
                $stateParams.tipo1 == 'para-alugar'
              ) {
                $stateParams.tipovar = $stateParams.tipo1;
                // }else if( res.filter(function(el){ return textFormatter.removeSpecialChar(el.timv_nome) == $stateParams.tipo1}).length ){
                // } else if (res.filter(function (el) { var regx = new RegExp(textFormatter.removeSpecialChar(el.timv_nome)); return regx.test($stateParams.tipo1) }).length) {
              } else if (
                res.filter(function (el) {
                  return $stateParams.tipo1 == el.timv_label;
                }).length ||
                $stateParams.tipo1.split('+').length > 1
              ) {
                $stateParams.tipoimovel = $stateParams.tipo1;
              } else {
                // TODO: REMOVER AO FAZER TASK #2001
                $stateParams.tipo1 =
                  $stateParams.tipo1 == 'centro-jaragua-do-sul-sc'
                    ? 'jaragua-do-sul-centro-jaragua-do-sul-sc'
                    : $stateParams.tipo1;
                $stateParams.cidade = $stateParams.tipo1;
              }

              return deferred.resolve(res);
            });

            return deferred.promise;
          },
          tiposImovel: function (configRoute) {
            return configRoute;
          },
        },
      })
      .state('main.search-address-ad-type', {
        url: 'imoveis/:tipo1/:tipo2?precovenda&precolocacao&area&dormitorios&imb_id&vagas&mobilia&noimovel&noempreendimento&myLocation&pagina',
        templateUrl: 'app/listing/search.html',
        controller: 'SearchController',
        controllerAs: 'vm',
        authenticate: false,

        // params:{
        //   cidade: null,
        //   tipovar: null,
        //   tipoimovel: null
        // },
        resolve: {
          configRoute: function (
            $stateParams,
            $q,
            TipoImovel,
            textFormatter,
            ConfigWhiteLabel
          ) {
            // console.log($stateParams);
            var deferred = $q.defer();

            $stateParams.cidade =
              ConfigWhiteLabel.cidade.toLowerCase() +
              '-' +
              ConfigWhiteLabel.estado.toLowerCase();

            TipoImovel.find({}, function (res, info) {
              // Tipo 1
              if (
                $stateParams.tipo1 == 'a-venda' ||
                $stateParams.tipo1 == 'para-alugar' ||
                $stateParams.tipo1 == 'lancamento'
              ) {
                // $stateParams.tipoimovel = ($stateParams.tipoimovel == 'lancamento')?null:$stateParams.tipoimovel;
                $stateParams.tipovar = $stateParams.tipo1;
                $stateParams.tipoimovel =
                  $stateParams.tipo1 == 'lancamento'
                    ? 'lancamento'
                    : $stateParams.tipoimovel;
                // }else if( res.filter(function(el){ return textFormatter.removeSpecialChar(el.timv_nome) == $stateParams.tipo1}).length ){
              } else if (
                res.filter(function (el) {
                  var regx = new RegExp(
                    textFormatter.removeSpecialChar(el.timv_nome)
                  );
                  return regx.test($stateParams.tipo1);
                }).length
              ) {
                $stateParams.tipoimovel =
                  $stateParams.tipoimovel == 'lancamento'
                    ? null
                    : $stateParams.tipo1;
              } else {
                $stateParams.cidade = $stateParams.tipo1;
              }

              // Tipo 2
              if (
                $stateParams.tipo2 == 'a-venda' ||
                $stateParams.tipo2 == 'para-alugar' ||
                $stateParams.tipo2 == 'lancamento'
              ) {
                $stateParams.tipovar = $stateParams.tipo2;
              } else if (
                res.filter(function (el) {
                  return (
                    textFormatter.removeSpecialChar(el.timv_nome) ==
                    $stateParams.tipo2
                  );
                }).length
              ) {
                $stateParams.tipoimovel = $stateParams.tipo2;
              } else {
                // TODO: REMOVER AO FAZER TASK #2001
                $stateParams.tipo2 =
                  $stateParams.tipo2 == 'centro-jaragua-do-sul-sc'
                    ? 'jaragua-do-sul-centro-jaragua-do-sul-sc'
                    : $stateParams.tipo2;
                $stateParams.cidade = $stateParams.tipo2;
              }

              return deferred.resolve(res);
            });

            return deferred.promise;
          },
          tiposImovel: function (configRoute) {
            return configRoute;
          },
        },
      })
      .state('main.search-address-ad-build-type', {
        url: 'imoveis/:tipovar/:tipoimovel/:cidade?precovenda&precolocacao&area&dormitorios&imb_id&vagas&mobilia&noimovel&noempreendimento&myLocation&pagina',
        templateUrl: 'app/listing/search.html',
        controller: 'SearchController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          tiposImovel: function (
            $stateParams,
            $q,
            TipoImovel,
            textFormatter,
            ConfigWhiteLabel
          ) {
            // TODO: REMOVER AO FAZER TASK #2001
            $stateParams.cidade =
              $stateParams.cidade == 'centro-jaragua-do-sul-sc'
                ? 'jaragua-do-sul-centro-jaragua-do-sul-sc'
                : $stateParams.cidade;

            var deferred = $q.defer();
            TipoImovel.find({}, function (res, info) {
              return deferred.resolve(res);
            });
            return deferred.promise;
          },
        },
      })
      .state('main.search-neighborhood', {
        url: 'bairros/:tipo1?tipovar',
        templateUrl: 'app/bairro/bairro.html',
        controller: 'BairroController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          Bairros: function (
            $stateParams,
            $q,
            TipoImovel,
            textFormatter,
            ConfigWhiteLabel,
            SERVER_URL,
            $http
          ) {
            var deferred = $q.defer();

            var getBairro = $http({
              url: SERVER_URL + 'api/bairros-replica/get-bairro-by-slug',
              method: 'GET',
              params: { slug: $stateParams.tipo1 },
            });

            var getNearbyBairro = $http({
              url: SERVER_URL + 'api/bairros-replica/get-nearby-bairros',
              method: 'GET',
              params: { slug: $stateParams.tipo1 },
            });

            var getImoveis = $http({
              url: SERVER_URL + 'api/bairros-replica/get-imoveis',
              method: 'GET',
              params: { slug: $stateParams.tipo1 },
            });

            $q.all([getBairro, getNearbyBairro, getImoveis])
              .then(function (responses) {
                var result = {
                  bairro: responses[0].data,
                  proxs: responses[1].data,
                  imoveis: responses[2].data.imoveis,
                  tags: responses[2].data.tags,
                };

                return deferred.resolve({ data: result });
              })
              .catch(function (error) {
                return deferred.reject(error);
              });

            return deferred.promise;
          },
        },
      })
      .state('main.error401', {
        url: '401',
        templateUrl: 'app/errors/error401.html',
        authenticate: false,
      })
      .state('main.error403', {
        url: '403',
        templateUrl: 'app/errors/error403.html',
        authenticate: false,
      })
      .state('main.error404', {
        url: '404',
        controller: 'Error404Controller',
        controllerAs: 'vm',
        templateUrl: 'app/errors/error404.html',
        authenticate: false,
      })
      .state('main.error500', {
        url: '500',
        templateUrl: 'app/errors/error500.html',
        authenticate: false,
      })
      .state('main.code', {
        url: 'cod/:codigo',
        controller: 'CodeController',
        controllerAs: 'vm',
        authenticate: false,
        params: {
          cidade: null,
        },
      })
      .state('main.form', {
        url: 'anunciar-imovel',
        templateUrl: 'app/account/formulario/form.html',
        authenticate: false,
      })
      .state('main.registro-anuncio', {
        url: 'cadastro/anuncie-seu-imovel?nome&email&telefone&whatsapp&redirect&redirect_to',
        templateUrl: 'app/components/registro/registro.anuncio.html',
        controllerAs: 'vm',
        controller: 'RegisterController',
        authenticate: false,
        minHeader: true,
        resolve: {
          redirectURL: function (
            $state,
            $stateParams,
            $q,
            $rootScope,
            auth,
            textFormatter,
            ConfigWhiteLabel
          ) {
            if (auth.isAuthenticated()) $state.go('main.painel.typeform-1');
            $rootScope._url = true;
            return true;
          },
        },
      })
      .state('main.login-anuncio', {
        url: 'login/anuncie-seu-imovel?nome&email&telefone&whatsapp&redirect&redirect_to',
        templateUrl: 'app/components/registro/login.anuncio.html',
        controllerAs: 'vm',
        controller: 'LoginController',
        authenticate: false,
        minHeader: true,
        resolve: {
          redirectURL: function (
            $state,
            $stateParams,
            $q,
            $rootScope,
            auth,
            textFormatter,
            ConfigWhiteLabel
          ) {
            if (auth.isAuthenticated()) $state.go('main.painel.typeform-1');
            $rootScope._url = true;
            return true;
          },
        },
      })
      .state('main.form-locacao', {
        url: 'proposta-locacao-form',
        templateUrl: 'app/account/formulario/proposta-locacao.html',
        authenticate: false,
      })
      .state('main.conheca-incorp', {
        url: 'conheca/incorporadoras',
        templateUrl: 'app/conheca/conhecaIncorp.html',
        controller: 'ConhecaController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          mess: function ($location, ConfigWhiteLabel) {
            var imob = ConfigWhiteLabel;
            if (!imob.isArbo && $location.path() == '/conheca/incorporadoras') {
              $location.path('main.home');
            }
          },
        },
      })
      .state('main.conheca-quem-somos', {
        url: 'conheca/quem-somos',
        templateUrl: 'app/conheca/quemSomos.html',
        controller: 'ConhecaController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.conheca-tecnologia', {
        url: 'conheca/tecnologia',
        templateUrl: 'app/conheca/tecnologia.html',
        controller: 'ConhecaController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.nosso-time', {
        url: 'nossotime',
        templateUrl: 'app/nossotime/nossotime.html',
        controller: 'NossoTimeController',
        controllerAs: 'vm',
        // abstract: true,
        authenticate: false,
        resolve: {},
      })
      .state('main.amp-home', {
        url: 'amphome?negocio&tipo&cidade',
        // templateUrl: 'app/conheca/tecnologia.html',
        // controller: 'ConhecaController',
        // controllerAs: 'vm',
        authenticate: false,
        resolve: {
          mess: function (
            $location,
            $stateParams,
            ConfigWhiteLabel,
            textFormatter,
            $window
          ) {
            if ($stateParams && (!$stateParams.negocio || !$stateParams.tipo)) {
              $window.location.href = '/';
              return;
            }
            $stateParams.negocio =
              $stateParams.negocio == 'Venda' ? 'a-venda' : 'para-alugar';
            $stateParams.tipo = $stateParams.tipo.toLowerCase();
            $stateParams.cidade =
              $stateParams.cidade == 'null' || !$stateParams.cidade
                ? ConfigWhiteLabel.cidade + ' ' + ConfigWhiteLabel.estado
                : $stateParams.cidade;
            $stateParams.cidade = $stateParams.cidade
              .toLowerCase()
              .replace(/ - /g, '-');
            $stateParams.cidade = $stateParams.cidade.replace(/,/g, '');
            $stateParams.cidade = $stateParams.cidade.replace(/ /g, '-');
            $stateParams.cidade = $stateParams.cidade.replace(/-brasil/g, '');
            $stateParams.cidade = textFormatter.removeSpecialChar(
              $stateParams.cidade
            );
            var url = $location.url().split('?')[0];
            url = url.replace(
              $location.path(),
              'imoveis/' +
                $stateParams.negocio +
                '/' +
                $stateParams.tipo +
                '/' +
                $stateParams.cidade
            );
            // TODO: source analytics;
            url = url.replace($location.search(), '');
            $window.location.href = url;
            return;
          },
        },
      })
      .state('main.imobiliarias', {
        url: 'imobiliarias',
        templateUrl: 'app/imobiliarias/imobiliarias.html',
        controller: 'ImobiliariasController',
        controllerAs: 'vm',
        authenticate: false,
      })
      .state('main.imobiliariaPage', {
        url: 'imobiliarias/:imobRoute',
        templateUrl: 'app/imobiliarias/imobiliariaspage.html',
        controller: 'ImobiliariaPageController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          ImobSelect: function (
            $rootScope,
            $q,
            $stateParams,
            $http,
            $window,
            $location,
            Imobiliaria
          ) {
            var deferred = $q.defer();

            var rota = $stateParams.imobRoute;

            var id64 = rota.split('-')[rota.split('-').length - 1];
            var idImob = atob(id64);
            var where = { id: idImob };
            Imobiliaria.getImobiliaria({
              where: where,
            }).$promise.then(
              function (res) {
                var imob = res[0];
                if (!imob.imb_ativa) {
                  deferred.resolve(null);
                } else deferred.resolve(imob);
              },
              function (err) {
                console.log(err);
                deferred.resolve(null);
              }
            );
            return deferred.promise;
          },
        },
      })
      .state('main.unsubscribe', {
        url: 'unsubscribe?token',
        templateUrl: 'app/unsubscribe/unsubscribe.html',
        controller: 'UnsubscribeController',
        controllerAs: 'vm',
        authenticate: false,
        resolve: {
          unsubscribeAction: function (
            $state,
            $stateParams,
            $q,
            Proposta,
            textFormatter,
            SERVER_URL,
            $http
          ) {
            var deferred = $q.defer();
            var url = SERVER_URL + 'api/unsubscribes/set-unsubscribe';
            var email = $stateParams.token;
            $http.get(url, {
              params: { email: email },
            });
            console.log('aqui');
            deferred.resolve(true);
            return deferred.promise;
          },
        },
      })
      .state('main.corretor-lead-nps', {
        url: 'avalie-sua-visita?lead&corretor&email&send&nota&na',
        templateUrl: 'app/components/nps/lead-corretor.nps.html',
        controllerAs: 'vm',
        controller: 'NPSCorretorController',
        authenticate: false,
        minHeader: true,
        resolve: {
          dataLead: function (
            $state,
            $stateParams,
            $q,
            $http,
            ClienteInteressado,
            textFormatter,
            SERVER_URL,
            ConfigWhiteLabel
          ) {
            var deferred = $q.defer();

            var obj = atob(atob($stateParams.lead));
            try {
              obj = JSON.parse(obj);
            } catch (error) {
              obj = {};
            }

            if (obj.email != $stateParams.email)
              deferred.resolve({ success: false, data: succ });
            else {
              $http({
                method: 'GET',
                url: SERVER_URL + 'api/avaliarcorretor/verificar',
                headers: {
                  'Content-Type': 'application/json',
                },
                params: {
                  lead: obj.id,
                  crt: obj.crt,
                },
              })
                .then(function (succ) {
                  if (succ)
                    deferred.resolve({ success: true, data: succ.data });
                  else deferred.resolve({ success: false, data: succ.data });
                })
                .catch(function (err) {
                  deferred.resolve({ success: false, data: err });
                });
            }

            return deferred.promise;
          },
        },
      });

    var listingRouteURLs = [
      'listing',
      ':imoveis/:type1/imovel',
      ':imoveis/:type2/:type3/imovel',
      ':imoveis/:type4/:type5/:type6/imovel',
      'imovel',
    ];

    var listingRoute = {
      templateUrl: 'app/listing/listing.html',
      controller: 'ListingController',
      controllerAs: 'vm',
      params: {
        id: null,
      },
      authenticate: false,
      resolve: {},
    };

    for (var x in listingRouteURLs) {
      var _name = listingRouteURLs[x].split('/');

      var _newRoute = angular.copy(listingRoute);
      var _newRouteAgendamento = angular.copy(listingRoute);
      var _newRouteContato = angular.copy(listingRoute);

      _newRoute.url = listingRouteURLs[x] + '/:id';
      _newRouteAgendamento.url = listingRouteURLs[x] + '/:id/agendamento';
      _newRouteContato.url = listingRouteURLs[x] + '/:id/contato';

      _newRoute.resolve['listingImovel'] = listingImovel;
      _newRouteAgendamento.resolve['listingImovel'] = listingImovel;
      _newRouteContato.resolve['listingImovel'] = listingImovel;

      _newRouteAgendamento.templateUrl =
        'app/agendamento/agendamento-visita.html';
      _newRouteContato.templateUrl = 'app/agendamento/agendamento-contato.html';

      _newRouteAgendamento.controller = 'AgendamentoController';
      _newRouteContato.controller = 'AgendamentoController';

      $stateProvider.state(
        'main.' + _name + '-agendamento',
        _newRouteAgendamento
      );
      $stateProvider.state('main.' + _name + '-contato', _newRouteContato);
      $stateProvider.state('main.' + _name, _newRoute);
    }

    // Rotas com um parametro coringa *dummy
    // Pega qualquer path que vier pelo meio
    for (var x in listingRouteURLs) {
      var dummy = '/.dummy/:id';

      var _name = listingRouteURLs[x].split('/');

      var _newRoute = angular.copy(listingRoute);
      var _newRouteAgendamento = angular.copy(listingRoute);
      var _newRouteContato = angular.copy(listingRoute);

      _newRoute.url = listingRouteURLs[x] + dummy.replace('.', '*');
      _newRouteAgendamento.url =
        listingRouteURLs[x] + dummy.replace('.', '*') + '/agendamento';
      _newRouteContato.url =
        listingRouteURLs[x] + dummy.replace('.', '*') + '/contato';

      _newRoute.resolve['listingImovel'] = listingImovel;
      _newRouteAgendamento.resolve['listingImovel'] = listingImovel;
      _newRouteContato.resolve['listingImovel'] = listingImovel;

      _newRouteAgendamento.templateUrl =
        'app/agendamento/agendamento-visita.html';
      _newRouteContato.templateUrl = 'app/agendamento/agendamento-contato.html';

      _newRouteAgendamento.controller = 'AgendamentoController';
      _newRouteContato.controller = 'AgendamentoController';

      $stateProvider.state(
        'main.' + _name + '-agendamento-sub',
        _newRouteAgendamento
      );
      $stateProvider.state('main.' + _name + '-contato-sub', _newRouteContato);
      $stateProvider.state('main.' + _name + '-sub', _newRoute);
    }
  }
})();

(function () {
	'use strict';

	angular.module('arboWeb').factory('myHttpProvider', myHttpProvider);

	myHttpProvider.inject = ['$q', '$location'];

	function myHttpProvider($q, $location, $window, $rootScope) {
		return {
			'request': function (config) {
				// console.log($window.navigator.userAgent); // Contains the data about the request before it is sent.
				// Return the config or wrap it in a promise if blank.
				$rootScope.botreq = /googlebot|adsbot\-google|Feedfetcher\-Google|bingbot|yandex|baiduspider|Facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|Slack-ImgProxy|Slackbot-LinkExpanding|Site Analyzer|Prerender|SiteAnalyzerBot|Viber|Whatsapp|Telegram|SemrushBot|W3C_Validator/i.test(
					$window.navigator.userAgent
				);

				return config || $q.when(config);
			},
			'responseError': function (rejection) {
				// if (rejection.status === 401) {
				//   $location.path('/401');
				// }
				console.log(rejection);
				if (rejection.status === 403) {
					$location.path('/403');
				}
				if (rejection.status === 404) {
					if (rejection.config.url != 'https://cabemcasa-backend-staging-dev.mybluemix.net/api/users/reset' && !rejection.config.url.match('googleusercontent')) {
						$location.path('/404');
					}
				}
				if (rejection.status === 500) {
					$location.path('/500');
				}
				return $q.reject(rejection);
			},
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('arboWeb')
		.constant('FACEBOOK_APP_ID', 1842580909192464)
		.constant('SIZE_FILTER', {
			name: 'sizeFilter',
			fn: function (item /*{File|FileLikeObject}*/, options) {
				return item.size <= 10485760; // 10MB
			},
		})
		.constant('IMAGE_FILTER', {
			name: 'imageFilter',
			fn: function (item, options, deferred) {
				validateType(item).then(function(valid) {
					if (valid) {
						deferred.resolve();
					} else {
						deferred.reject();
					}
				});

				return deferred.promise;
			},
		})
		.constant('DOC_FILTER', {
			name: 'docFilter',
			fn: function (item /*{File|FileLikeObject}*/, options) {
				var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
				return '|pdf|jpg|png|jpeg|webp|jfif|gif|bmp'.indexOf(type) !== -1;
			},
		})
		.constant('FRONTEND_URL', window.location.origin);

		function validateType(item) {
			return new Promise(function(resolve, reject) {
				checkWebp(item)
					.then(function(result) {
						if(result) return resolve(true)
						getBLOBFileHeaderPromisse(item)
						.then(function(bytes) {
							var type = getTypeByBytes(bytes);
							return resolve(type != null);
						});

					});
				})
		}

		function getBLOBFileHeaderPromisse(blob) {
			return new Promise(function(resolve, reject) {
				var fileReader = new FileReader();
				fileReader.onloadend = function(e) {
					var arr = new Uint8Array(e.target.result).subarray(0, 4);
					var header = '';
					for (var i = 0; i < arr.length; i++) {
						header += arr[i].toString(16);
					}
					resolve(header);
				};
				fileReader.readAsArrayBuffer(blob);
			});
		}

		function getTypeByBytes(fileFirst4Bytes) {
			if (fileFirst4Bytes.indexOf('89504e47') != -1) {
				return 'png';
			} else if (fileFirst4Bytes.indexOf('47494638') != -1) {
				return 'gif';
			} else if (fileFirst4Bytes.indexOf('ffd8ff') != -1) {
				return 'jpeg';
			}
			return null;
		}

		function checkWebp(file) {
			return new Promise(function (resolve,reject) {
				readBuffer(file, 8, 12).then(function(buffers) {
					var bufferByteArray = new Uint8Array(buffers)
					var isWebP = checkTypeBytes(stringToBytes('WEBP'))
					resolve(isWebP(bufferByteArray))
				})
			})
		}

		function stringToBytes(string) {
			var newStringArray = []
			for(var i = 0; i < string.length; i++){
				newStringArray.push(string[i].charCodeAt(0))
			}
			return newStringArray
		}

		function checkTypeBytes(headers) {
			return (function(buffers) {
			  return headers.every(
				function(header, index) {
					return header === buffers[index]}
			  );
		  })
		}

		function readBuffer(file, start, end) {
			return new Promise(function(resolve, reject){
				var reader = new FileReader();
				reader.onload = function() {
					resolve(reader.result)
				}
				reader.onerror = reject
				reader.readAsArrayBuffer(file.slice(start || 0, end || 2))
			})
		}
})();

(function() {
'use strict'; 

 angular.module("arboWeb")
.constant("SERVER_URL", "https://api-site.arboimoveis.com.br/")
.constant("SITE_URL", "https://www.arboimoveis.com.br/")
.constant("URL_CDN", "https://static.arboimoveis.com.br/")
.constant("URL_BUCKET", "https://s3-sa-east-1.amazonaws.com/static-arbo/")
.constant("PROD", true)
.constant("API_MAPBOX", "pk.eyJ1IjoiZGVzZW52b2x2aW1lbnRvYXJibyIsImEiOiJjazdtYWEwYXowZzg5M2xwbWxjZXJpZWQ4In0.DvExA66ZlSTa8ONINr0H1g")
.constant("GOOGLE_API", "AIzaSyCyw6kTYG3BMHwip4aLFqGMfi2KW9COpJ0");
})();
(function () {
    'use strict';

    angular
        .module('arboWeb')
        .config(config);

    /** @ngInject */
    function config($logProvider, $httpProvider, toastrConfig, $locationProvider, FACEBOOK_APP_ID, $compileProvider, LoopBackResourceProvider, SERVER_URL, swangularProvider) {
        $locationProvider.html5Mode(true);
        $compileProvider.debugInfoEnabled(false);
        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;

        // Use a custom auth header instead of the default 'Authorization'
        LoopBackResourceProvider.setAuthHeader('X-Access-Token');

        // Change the URL where to access the LoopBack REST API server
        LoopBackResourceProvider.setUrlBase(SERVER_URL + 'api');
        // LoopBackResourceProvider.setUrlBase('https://dev.cabetech-dev.apic.mybluemix.net/api');


        // $authProvider.facebook({
        //   clientId: FACEBOOK_SMM_APP_ID
        // });

        // $authProvider.facebook({
        //   name: 'facebook',
        //   url: '/auth/facebook',
        //   authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
        //   redirectUri: window.location.origin + '/entrar',
        //   responseType: 'token',
        //   requiredUrlParams: ['display', 'scope'],
        //   scope: ['email', 'public_profile'],
        //   scopeDelimiter: ',',
        //   display: 'popup',
        //   oauthType: '2.0',
        //   popupOptions: {
        //     width: 580,
        //     height: 400
        //   }
        // });
        // Settings SW Alert
        swangularProvider.setDefaults({
            animation: false
        });

        $httpProvider.interceptors.push('myHttpProvider');
        //$httpProvider.defaults.headers.common = { 'X-From' : 'ANGULAR' };
    }

})();
angular.module("arboWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/account.html","<div class=nav-breadcrumb><div class=\"row container-fluid\"><div class=col-12><h1>Perfil de usuário</h1></div></div></div><div id=account class=\"d-flex flex-column account-container container-fluid\"><main class=\"row perfil-container mt-3\"><div class=\"col-12 col-sm-3\"></div><div class=\"col-12 col-sm-5\"><form action=\"\" name=etapa-transacao ng-submit=vm.validacao($event) ng-readonly=true><div class=\"form-default mt-0\"><div class=\"form-group d-flex flex-column\"><label for=\"\">Dados cadastrais</label><div><div class=\"row mb-2 ml-1\"><input type=text id=user-email class=\"form-control upper col-8 col-md-10\" ng-model=vm.form.email placeholder=email@dominio.com><label for=user-email class=\"ml-3 upper\">E-mail</label></div><div class=\"row mb-2 ml-1\"><input type=tel id=user-telefones class=\"form-control upper col-8 col-md-10\" ng-model=\"vm.form.telefones[\'numero\']\" ui-br-phone-number=areaCode placeholder=\"(00) 9 9999-9999\"><label for=user-telefones class=\"ml-3 upper\">Telefone</label></div><div class=\"row mb-2 ml-1\"><input type=tel id=user-rg class=\"form-control upper col-8 col-md-10\" ng-model=vm.form.rg mask=9?9.999.999-9 placeholder=\"Seu número de documento RG\"><label for=user-rg class=\"ml-3 upper\">RG</label></div><div class=\"row mb-2 ml-1\"><input type=tel id=user-cpf class=\"form-control upper col-8 col-md-10\" ng-model=vm.form.cpf ui-br-cpf-mask placeholder=\"Seu CPF\"><label for=user-cpf class=\"ml-3 upper\">CPF</label></div><div class=\"form-group d-flex\"><select id=select-ocupacao class=\"col-4 custom-select\" ng-model=vm.form.month ng-options=\"f.name for f in vm.mounthNumbers\" ng-change=vm.dayGenerate(vm.form.month.days) ng-init=\"vm.form.month =  vm.mounthNumbers[0]\" required></select><select id=select-ocupacao class=\"col-3 ml-1 custom-select\" ng-model=vm.form.day ng-options=\"f for f in vm.dayNumbers\" ng-init=\"vm.form.day =  vm.dayNumbers[0]\" required></select><select id=select-ocupacao class=\"col-3 ml-1 custom-select\" ng-model=vm.form.year ng-options=\"f for f in vm.yearNumbers\" ng-init=\"vm.form.year =   vm.yearNumbers[0]\" required></select></div><div class=\"form-group d-flex\"><select id=select-ocupacao class=\"col-5 custom-select\" ng-model=vm.form.ec_id ng-options=\"f.id as f.nome for f in vm.statusCivil\" ng-init=\"vm.form.ec_id =  vm.statusCivil[0].id\" required></select></div><div class=\"row mb-2 ml-1\"><input type=text id=user-email class=\"form-control upper col-5\" ng-model=vm.form.email placeholder=\"Sua Profissão\"><label for=user-email class=\"ml-3 upper\">Profissão</label></div></div></div><div class=\"form-group d-flex flex-column flex-wrap\"><label for=\"\">Endereço</label><div class=\"row mb-3 ml-1\"><input type=text id=zipcode-address class=\"form-control upper col-8 col-md-5\" ui-br-cep-mask ng-model=vm.formAddress.address.imv_cep ng-blur=vm.formAddress.viacepGet() required placeholder=\"Seu CEP\"><label for=zipcode-address class=\"ml-1 pl-3 upper\">CEP</label></div><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-8 col-sm-7 px-0\"><input type=text id=stre-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_endereco required placeholder=\"Sua Rua\"><label for=stre-address class=\"ml-1 pl-3 upper\">Rua</label></div><div class=\"d-flex col-4 col-sm-3 px-0\"><input type=text id=num-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_end_numero ng-model-options=\"{ debounce: 700 }\" required placeholder=\"Seu Número\"><label for=num-address class=\"ml-1 pl-3 upper\">num</label></div></div><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-7 col-sm-5 px-0\"><input type=text id=comp-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_end_complemento placeholder=\"Seu Complemento\"><label for=comp-address class=\"ml-1 pl-3 upper\">Complemento</label></div><div class=\"d-flex col-5 col-sm-5 px-0\"><input type=text id=neib-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_bairro required placeholder=\"Seu Bairro\"><label for=neib-address class=\"ml-1 pl-3 upper\">Bairro</label></div></div><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-6 col-sm-7 px-0\"><input type=text id=city-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_cidade required placeholder=\"Sua Cidade\"><label for=city-address class=\"ml-1 pl-3 upper\">Cidade</label></div><div class=\"d-flex col-4 col-sm-3 px-0\"><input type=text id=uf-address class=\"form-control upper\" ng-model=vm.formAddress.address.imv_estado required placeholder=\"Seu Estado\"><label for=uf-address class=\"ml-1 pl-3 upper\">Estado</label></div></div></div><div class=d-flex><button type=submit class=\"btn button btn-default col-4 ml-auto\">Salvar</button></div></div></form></div><div class=\"col-12 col-sm-4\"><div class=col-12></div></div></main></div>");
$templateCache.put("app/account/painel.html","<div id=painel class=margin-fluid><div ui-view id=main-content></div></div>");
$templateCache.put("app/agendamento/agendamento-contato.html","<section id=agendamento><div class=\"row container m-auto\"><nav class=navegator><ol class=\"breadcrumb bg-white mb-4 px-0\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item href=/ ><span itemprop=name>Início</span></a><meta itemprop=position content=1></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 1) }}\"><span itemprop=name>{{ vm.listing.imv_cidade }}</span></a><meta itemprop=position content=2></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 5) }}\"><span itemprop=name>{{ vm.listing.imv_bairro }}</span></a><meta itemprop=position content=6></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 2) }}\"><span itemprop=name>{{ vm.listing.imv_preco_locacao ? \'Aluguel\' : \'Venda\' }}</span></a><meta itemprop=position content=3></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 3) }}\"><span itemprop=name>{{ vm.listing.tipo_imovel.timv_nome }}</span></a><meta itemprop=position content=4></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 4) }}\"><span itemprop=name>imóvel {{ vm.listing.imv_cod_gaia }}</span></a><meta itemprop=position content=5></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, true) }}\"><span itemprop=name>{{ vm.titleContato }}</span></a><meta itemprop=position content=7></li></ol></nav></div><div class=\"row container m-auto\"><div class=\"row flex-row card col-12 col-lg-3 pt-2\"><a ng-href=\"{{ vm.makeUrl(vm.listing, 4) }}\"><div class=\"col-12 col-sm-8 col-lg-12 mx-auto p-0\"><img ng-src=\"{{ vm.listing.fotos[0].imvft_url }}\" class=\"image img-fluid\" alt=\"{{ (vm.listing.fotos[0].tipo_foto ? vm.listing.fotos[0].tipo_foto.tfoto_nome : \'Foto\') + \' do \' + vm.listing.tipo_imovel.timv_nome }} - {{ vm.listing.imv_titulo }} | {{ vm.config_wl.nome }}\"><h1 class=title>{{ vm.listing.imv_titulo }}</h1><h2 class=subtitle itemprop=name ng-if=!vm.listing.imobiliaria.imb_hidden_cond_num>{{ vm.listing.imv_nome_cond }}</h2><h2 class=subtitle>{{ vm.listing.subtipo_imovel.stimv_nome }}</h2><address class=address itemprop=address ng-if=!vm.listing.imobiliaria.imb_hidden_address>{{ vm.listing.imv_endereco }} <span ng-if=!vm.listing.imobiliaria.imb_hidden_cond_num>, {{ vm.listing.imv_end_numero }}</span> - {{ vm.listing.imv_bairro }} - {{ vm.listing.imv_cidade }}/{{ vm.listing.imv_estado }}</address><div class=description>cód. {{ vm.listing.imv_cod_gaia }} /<h2 class=\"d-inline-block px-1\" ng-if=vm.showimobiliaria><a ui-sref=\"main.imobiliariaPage({imobRoute: vm.generateImobLink()})\">{{ vm.listing.imobiliaria.imb_nome }}</a></h2>Creci {{ vm.listing.imobiliaria.imb_creci }}</div><ul class=\"offers mt-3\" itemprop=offers itemscope itemtype=http://schema.org/Offer><li class=\"highlight d-flex justify-content-between\" ng-if=\"vm.listing.imv_preco_venda && vm.listing.imv_ativo\"><div ng-if=\"vm.listing.timv_id != 36\">Venda</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio de venda</div><div class=text-right itemprop=price>R$ {{ vm.listing.imv_preco_venda | number: \'0\' }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"highlight d-flex justify-content-between\" ng-if=\"vm.listing.imv_preco_locacao && vm.listing.imv_ativo\"><div ng-if=\"vm.listing.timv_id != 36\">Aluguel</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio do Aluguel</div><div class=text-right itemprop=price>R$ {{ vm.listing.imv_preco_locacao | number: \'0\' }} <span ng-switch=vm.listing.tplc_id><span class=txt-tplc ng-switch-when=2>/dia</span> <span class=txt-tplc ng-switch-when=5>/semana</span> <span class=txt-tplc ng-switch-when=3>/mês</span> <span class=txt-tplc ng-switch-when=4>/ano</span></span><meta itemprop=priceCurrency content=BRL></div></li></ul></div><div class=\"col-12 p-0 offers\"><div class=\"btns-media d-flex flex-row flex-lg-column order-first order-lg-last\"><a ng-href=\"\" class=btn ng-class=\"{\'active\': vm.view === \'fotos\'}\" role=button ng-click=\"vm.changeView(\'fotos\')\"></a></div></div></a></div><div class=\"col-12 col-lg-6 order-first order-lg-last mb-5\"><div class=\"col-12 col-md-10 p-0 mx-auto mt-lg-1 mb-3\" ng-if=vm.tag.hidden><div class=\"tag-imovel d-flex align-items-center\"><div class=image-tag><svg ng-if=\"vm.tag.svg == \'pin\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #3b3b3b;\n                }\n\n                .st1 {\n                  fill: #ffffff;\n                }\n\n                .st2 {\n                  fill: #e8f9fc;\n                }\n\n                .st3 {\n                  fill: #caf7fc;\n                }\n\n                .st4 {\n                  fill: #3b3b3b;\n                }</style><g><path class=st0 d=\"M251.7,496.9c3,4.1,7.7,6.6,12.8,6.6s9.8-2.4,12.8-6.6C317,443.7,435.2,290.1,435.2,190\n                    c0-121.7-76.5-181.5-170.7-181.5S93.9,68.3,93.9,190C93.9,290.1,212.1,443.7,251.7,496.9z\"/><path class=st1 d=\"M238.9,496.9c6.2,8.7,6,8.7,12.2,0c37.7-53.2,150-206.8,150-306.9c0-121.7-72.6-181.5-162.1-181.5\n                    S76.8,68.3,76.8,190C76.8,290.1,201.2,443.7,238.9,496.9z\"/><path class=st2 d=\"M244.5,496.9c2.4,4.1,6.8,6.6,11.5,6.6c4.7,0,9.1-2.5,11.5-6.6c35.7-53.2,142.1-206.8,142.1-306.9\n                    C409.6,68.3,340.8,8.5,256,8.5S102.4,68.3,102.4,190C102.4,290.1,208.8,443.7,244.5,496.9z\"/><circle class=st3 cx=256 cy=187.7 r=128 /><path class=st2 d=\"M316.4,144.1l-0.7,0.9v102.4c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5v-33.1\n                    c0.2-8.6-5.7-16.1-14.2-17.8c-5-0.8-10,0.5-13.9,3.8s-6.1,8-6.1,13v34.1c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5V145.1\n                    l-3.2-5.2l57.3-35.2c3.3-2.9,8.2-2.9,11.4,0L316.4,144.1z\"/><g><path class=st4 d=\"M256,324.3c-75.4,0-136.5-61.1-136.5-136.5S180.6,51.2,256,51.2s136.5,61.1,136.5,136.5\n                      C392.4,263.1,331.4,324.2,256,324.3z M256,68.3c-66,0-119.5,53.5-119.5,119.5S190,307.2,256,307.2s119.5-53.5,119.5-119.5\n                      C375.4,121.8,321.9,68.3,256,68.3z\"/><path class=st4 d=\"M307.2,264.5h-25.6c-9.4,0-17.1-7.6-17.1-17.1v-33.1c0.2-4.4-2.8-8.3-7-9.4c-2.5-0.4-5,0.3-7,1.9\n                      s-3.1,4-3.1,6.5v34.1c0,9.4-7.6,17.1-17.1,17.1h-25.6c-9.4,0-17.1-7.6-17.1-17.1V145.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5\n                      v102.4h25.6v-34.1c0-7.5,3.3-14.7,9.1-19.6s13.4-6.9,20.8-5.7c12.5,2.5,21.4,13.5,21.3,26.3v33.1h25.6V145.1\n                      c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v102.4C324.3,256.9,316.6,264.5,307.2,264.5z\"/><path class=st4 d=\"M341.3,170.7c-1.8,0-3.5-0.6-5-1.6l-79.6-57.6c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4,0.3-0.8,0.6-1.3,0.9l-79.6,49\n                      c-2.6,1.6-5.8,1.7-8.5,0.2c-2.7-1.4-4.4-4.2-4.5-7.3s1.5-5.9,4.1-7.5l79.1-48.7c6.4-5.1,15.5-5,21.8,0.2l79.3,57.3\n                      c3,2.2,4.3,6,3.1,9.5C348.3,168.3,345,170.7,341.3,170.7L341.3,170.7z\"/><path class=st4 d=\"M256,512c-7.9,0-15.3-3.6-20.2-9.8l-5.4-6.8C189.1,442.7,92.2,319.5,72,223.6c-0.6-3,0.4-6.1,2.6-8.1\n                      c2.3-2,5.5-2.7,8.4-1.8c2.9,1,5.1,3.4,5.7,6.4c19.3,92,114.5,213,155.1,264.7l5.4,6.8c1.7,2,4.2,3.2,6.8,3.2s5.1-1.2,6.8-3.2\n                      l5.5-7c43.3-55.1,158.4-201.5,158.4-294.6c0-127.5-88.2-173-170.7-173c-92.4,0-155.3,51.5-168.1,137.8c-0.4,3-2.5,5.6-5.3,6.7\n                      c-2.8,1.1-6.1,0.6-8.4-1.3c-2.4-1.9-3.6-4.9-3.1-7.9C85,58.4,155.9,0,256,0c114,0,187.7,74.6,187.7,190\n                      c0,99-113.6,243.4-162,305.1l-5.5,7C271.4,508.4,263.9,512,256,512L256,512z\"/><circle class=st4 cx=76.8 cy=187.7 r=8.5 /></g></g></svg> <svg ng-if=\"vm.tag.svg == \'mudanca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #9de8eb;\n                }\n                .st1 {\n                  fill: #a2fcf3;\n                }\n                .st2 {\n                  fill: #e8f9fc;\n                }\n                .st3 {\n                  fill: #ffffff;\n                }\n                .st4 {\n                  fill: #2fbaba;\n                }</style><g><path id=Shape_1_ class=st0 d=\"M200.2,409.6c-7.4,0-13.9-4.8-16.2-11.8L70.6,49.7l-16.4,8.2c-8.4,4.2-18.7,0.8-22.9-7.6\n                    s-0.8-18.7,7.6-22.9l34.1-17.1c4.4-2.2,9.6-2.4,14.2-0.5s8.1,5.7,9.7,10.5l114,350.3l248-88c8.9-3.2,18.6,1.5,21.8,10.4\n                    c3.2,8.9-1.5,18.6-10.4,21.8l-264.5,93.9C204,409.2,202.1,409.6,200.2,409.6z\"/><path class=st0 d=\"M285.5,452.2c0,28.3-22.9,51.2-51.2,51.2c-5.2,0-10.4-0.8-15.4-2.3c-21.3-6.8-35.8-26.6-35.8-48.9\n                    c0-22.4,14.5-42.2,35.8-48.9c5-1.5,10.2-2.2,15.4-2.3C262.6,401,285.5,424,285.5,452.2z\"/><ellipse id=Oval class=st1 cx=219 cy=452.2 rx=35.8 ry=48.9 /><circle class=st0 cx=234.3 cy=452.2 r=17.1 /><path id=Rectangle-path_1_ class=st1 d=\"M203.8,192l161-56.5c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9\n                    l-161,56.5c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C197,198.5,199.3,193.6,203.8,192z\"/><path class=st2 d=\"M203.4,192.2l139.3-48.9c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9L260,353.2\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C196.7,198.6,199,193.7,203.4,192.2z\"/><path class=st0 d=\"M315.6,215.8l-8.8-2.3c-3.3-0.9-6.9,0.4-8.9,3.1l-5.5,7.3c-1.9,2.5-5,3.8-8.1,3.3c-3.1-0.5-5.7-2.6-6.7-5.6\n                    l-17.3-49.4l48.3-17l17.3,49.4c1,3,0.4,6.3-1.8,8.6C321.9,215.6,318.7,216.5,315.6,215.8z\"/><path class=st1 d=\"M189.1,75.9l102.6-36c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9l-102.6,36\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C182.3,82.4,184.6,77.5,189.1,75.9z\"/><path class=st2 d=\"M188.1,76.3l78.1-27.4c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9L226,184.2\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C181.3,82.7,183.6,77.8,188.1,76.3z\"/><path class=st0 d=\"M264,93.5l-9.5-2.4c-1.7-0.4-3.4,0.2-4.5,1.6l-5.9,7.8c-0.9,1.3-2.5,1.9-4.1,1.6c-1.6-0.2-2.8-1.3-3.4-2.8\n                    l-12.5-35.7l32.4-11.4l12.5,35.7c0.5,1.5,0.2,3.2-0.9,4.3C267.2,93.4,265.5,93.9,264,93.5z\"/><path class=st3 d=\"M54.2,57.9l6.1-3.1c-4-3.8-5.9-9.4-5.1-14.8c0.8-5.5,4.3-10.2,9.3-12.6l28-14c-5.1-5.1-13-6.4-19.5-3.1\n                    L38.9,27.4c-8.4,4.2-11.8,14.5-7.6,22.9S45.8,62.1,54.2,57.9z\"/><path class=st3 d=\"M73.8,59.6L184,397.8c1.4,4.4,4.6,8,8.7,10c4.1,2,8.9,2.3,13.2,0.8l4.5-1.6c-23,12.1-33.2,39.5-23.8,63.7\n                    c9.4,24.2,35.5,37.5,60.6,31c-20.4-5.3-35.5-22.6-38-43.5s8.2-41.3,26.8-51.2l-4.5,1.6c-4.3,1.5-9.1,1.3-13.2-0.8\n                    c-4.1-2-7.3-5.7-8.7-10L96.2,49.7l-16.4,8.2C77.9,58.8,75.9,59.4,73.8,59.6z\"/><polygon class=st3 points=\"78.7,47 113.1,152.5 192.1,395.1 175.8,400.4 96.8,157.8 62.5,52.3 	\"/><g><path class=st4 d=\"M99.4,118.5c2.1-4.2,0.4-9.3-3.7-11.5l-1.5-0.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.5-0.1-1.1-0.1-1.6,0\n                      c-0.6,0.1-1.1,0.2-1.7,0.4c-2.1,0.7-3.9,2.2-5,4.2c-2,4.2-0.4,9.3,3.7,11.5c1,0.5,2.1,0.8,3.2,0.9c1.1,0.1,2.2,0,3.3-0.4\n                      C96.5,122,98.3,120.5,99.4,118.5z\"/><path class=st4 d=\"M38.5,66.9c6.4,2.2,13.5,1.7,19.5-1.4l7.5-3.8l7.5,23c1.6,4.3,6.3,6.6,10.6,5.1c4.4-1.4,6.8-6,5.6-10.4\n                      L78.7,47.1l-0.2,0.1c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-4.2-7.2-5.9-11.4-3.9l-16.4,8.3c-4.2,2.1-9.4,0.4-11.5-3.8\n                      c-2.1-4.2-0.4-9.4,3.8-11.5L76.8,18c2.2-1.1,4.8-1.2,7.1-0.2c2.3,1,4.1,2.9,4.8,5.2l114.1,350.2c0.7,2.2,2.3,4,4.3,5\n                      c2.1,1,4.5,1.2,6.6,0.4l248-88c3.3-1.1,6.9-0.2,9.2,2.3c2.3,2.6,2.8,6.3,1.4,9.4c-1,2-2.7,3.6-4.8,4.4l-245.3,87\n                      c-5.2,1.1-10.2,2.9-15,5.3l-4.3,1.5c-2.2,0.8-4.6,0.6-6.6-0.4c-2.1-1-3.6-2.8-4.3-5l-81.6-250.7c-0.8-3-3.3-5.3-6.3-6\n                      c-3.1-0.7-6.2,0.3-8.3,2.7c-2.1,2.4-2.7,5.7-1.6,8.6l81.6,250.7c2,6.1,6.3,11.3,11.9,14.4c-16,19.8-17.6,47.5-4.2,69.1\n                      c13.5,21.6,39.1,32.3,63.9,26.6c24.8-5.6,43.3-26.3,46.1-51.6c2.8-25.3-10.7-49.6-33.6-60.5l213.2-75.7\n                      c8.9-2.8,15.5-10.3,17.3-19.5c1.8-9.2-1.5-18.6-8.7-24.6c-7.2-6-17-7.6-25.7-4.2l-22.7,8l-54-153.8c-0.8-2.1-2.3-3.9-4.4-4.9\n                      s-4.4-1.1-6.5-0.4l-26,9.1L307.2,31.8c-0.8-2.1-2.3-3.9-4.4-4.9s-4.4-1.1-6.5-0.4l-43.2,15.2l-32.4,11.4l-43.2,15.2\n                      c-2.1,0.8-3.9,2.3-4.9,4.4c-1,2-1.1,4.4-0.4,6.5L207.7,180l-16.3,5.7c-4.4,1.6-6.8,6.4-5.2,10.9L240.5,351l-24.1,8.5L105,17.6\n                      c-2.3-7.1-7.6-12.8-14.5-15.7S75.9-0.7,69.3,2.7L35.1,19.7C25.9,24.4,20.3,34.1,21,44.4S28.7,63.6,38.5,66.9z M234.3,409.6\n                      c21.9-0.3,40.6,15.9,43.4,37.7c2.8,21.8-11.1,42.2-32.4,47.5s-43.2-6.1-50.9-26.6c-7.8-20.5,1.1-43.6,20.6-53.7l11.4-4\n                      C229,409.8,231.6,409.6,234.3,409.6z M301.8,165l14.5,41.3l-14.4-3.7c-3.3-0.9-6.9,0.4-8.9,3.1l-8.9,11.8l-14.5-41.3l16.1-5.7\n                      L301.8,165z M257.8,80.8l-4.5-1.2c-3.3-0.9-6.9,0.4-8.9,3.1l-2.8,3.7l-7-20.1l8.1-2.9l8.1-2.9L257.8,80.8z M218.3,72l12.3,35.1\n                      c1,3,3.6,5.1,6.7,5.6c0.4,0.1,0.9,0.1,1.3,0.1c2.7,0,5.2-1.3,6.8-3.4l9-11.9l14.5,3.7c3,0.8,6.3-0.2,8.4-2.5\n                      c2.1-2.3,2.8-5.6,1.8-8.6L266.8,55l27.1-9.5l32.2,91.8l-102.6,36l-32.2-91.8L218.3,72z M253.5,182l19.8,56.4c1,3,3.6,5.1,6.7,5.6\n                      c3.1,0.5,6.2-0.8,8.1-3.3l15.1-20l24.3,6.2c3,0.8,6.3-0.2,8.4-2.5c2.1-2.3,2.8-5.6,1.8-8.6l-19.8-56.3l48.3-17l50.9,144.9\n                      l-161,56.5L205.2,199L253.5,182z\"/><path class=st4 d=\"M208.7,452.2c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6c0-14.1-11.5-25.6-25.6-25.6\n                      C220.2,426.6,208.7,438.1,208.7,452.2z M234.3,443.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5\n                      S229.6,443.7,234.3,443.7z\"/></g></g></svg> <svg ng-if=\"vm.tag.svg == \'busca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #a2fcf3;\n                }\n                .st1 {\n                  fill: #e8f9fc;\n                }\n                .st2 {\n                  fill: #808e87;\n                }\n                .st3 {\n                  fill: url(#SVGID_1_);\n                }\n                .st4 {\n                  fill: #f26546;\n                }\n                .st5 {\n                  fill: #9de8eb;\n                }\n                .st6 {\n                  fill: #ffffff;\n                }\n                .st7 {\n                  fill: #2fbaba;\n                }</style><g><path id=Shape class=st0 d=\"M458.8,399.6l-59.1,59l-0.3,0.3l-0.1-0.1h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l36.1-36.1\n                    l11.4-11.4c3.3-3.3,8.6-3.3,11.8,0L458.8,399.6z\"/><path class=st0 d=\"M486.9,487.1c-2.1,2.1-4.4,4-7,5.6c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l0.3-0.3l59.1-59l28.1,28.1\n                    C503.3,444.1,503.3,470.7,486.9,487.1z\"/><path class=st1 d=\"M436.9,420.5l-37.5,38.3h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l26.9-27.7c3.3-2.2,7.7-1.7,10.6,1.1\n                    L436.9,420.5z\"/><path class=st1 d=M480,492.7c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l38.1-38.1l28,28.1C479.8,463.2,490.5,476.4,480,492.7z /><rect id=Rectangle-path x=342.9 y=329.6 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -152.5583 368.0898)\" class=st0 width=50.3 height=77.3 /><rect x=346.4 y=338 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -160.953 364.6137)\" class=st1 width=26.6 height=77.3 /><path class=st0 d=\"M341.9,342.1c-75.8,72.7-195.9,71.5-270.2-2.8S-3.8,144.9,68.9,69.1c75.8-72.7,195.9-71.5,270.2,2.8\n                    S414.6,266.2,341.9,342.1z\"/><path class=st1 d=\"M316.7,342.1c-33,33.2-77.1,53.2-123.9,56.1c-75.6-4.9-141.4-53.6-168.1-124.6S15.3,122.7,68.9,69.1\n                    c33-33.2,77.1-53.2,123.9-56.1c75.6,4.9,141.4,53.6,168.1,124.6S370.3,288.5,316.7,342.1z\"/><path class=st2 d=\"M205.4,373.4c-67.9,0-129.1-40.9-155.1-103.6s-11.6-134.9,36.4-183c65.6-65.6,171.9-65.6,237.4,0\n                    s65.6,171.9,0,237.4C292.7,355.9,250,373.6,205.4,373.4z\"/><linearGradient id=SVGID_1_ gradientUnits=userSpaceOnUse x1=-700.6567 y1=795.9537 x2=-699.9529 y2=795.2502 gradientTransform=\"matrix(320.5412 0 0 -320.6926 224681.9375 255349.2344)\"><stop offset=0 style=\"stop-color: #d4f3f3\"/><stop offset=0.172 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #dbf1f3\"/><stop offset=0.201 style=\"stop-color: #ebedf3\"/><stop offset=0.201 style=\"stop-color: #f7f0f7\"/><stop offset=0.202 style=\"stop-color: #f1e6ec\"/><stop offset=0.205 style=\"stop-color: #fff2f7\"/><stop offset=0.252 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #d4f3f3\"/><stop offset=0.397 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #dbf1f3\"/><stop offset=0.421 style=\"stop-color: #ebedf3\"/><stop offset=0.421 style=\"stop-color: #f7f0f7\"/><stop offset=0.422 style=\"stop-color: #f1e6ec\"/><stop offset=0.425 style=\"stop-color: #fff2f7\"/><stop offset=0.489 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #f8f0f7\"/><stop offset=0.5 style=\"stop-color: #e8eef3\"/><stop offset=0.5 style=\"stop-color: #ddf1f3\"/><stop offset=0.5 style=\"stop-color: #d6f2f3\"/><stop offset=0.501 style=\"stop-color: #d4f3f3\"/><stop offset=0.706 style=\"stop-color: #d4f3f3\"/><stop offset=0.74 style=\"stop-color: #d4f3f3\"/><stop offset=0.741 style=\"stop-color: #fff2f7\"/><stop offset=0.835 style=\"stop-color: #fff2f7\"/><stop offset=0.85 style=\"stop-color: #fff2f7\"/><stop offset=0.851 style=\"stop-color: #d4f3f3\"/></linearGradient><path class=st3 d=\"M318.2,318.4c-62.3,62.2-163.3,62.2-225.6,0c-1.1-1.1-2.2-2.3-3.3-3.4c-39.7-40.9-54.5-99.8-39-154.7\n                    s59.2-97.2,114.4-111.1s113.7,2.7,153.4,43.6c17.8,17.8,31.1,39.5,38.8,63.5C375.5,213.3,360.6,275.9,318.2,318.4z\"/><path class=st4 d=M138.3,183.2l69.3-60.3l65,60.3v98c0,4.6-3.8,8.4-8.4,8.4H146.7c-4.6,0-8.4-3.8-8.4-8.4V183.2z /><path class=st1 d=M146.7,171.7l60.7-66.8l56.8,66.8v108.6c0.5,4.6-2.8,8.7-7.3,9.3H154c-4.6-0.6-7.8-4.7-7.3-9.3V171.7z /><path class=st5 d=\"M293.1,196.9l-83-55.3c-2.8-1.9-6.5-1.9-9.3,0l-83,55.3c-2.6,1.7-5.9,1.9-8.6,0.4c-2.7-1.5-4.4-4.3-4.4-7.4\n                    v-21.8c0-2.8,1.4-5.4,3.7-7l92.3-61.5c2.8-1.9,6.5-1.9,9.3,0l92.3,61.5c2.3,1.6,3.7,4.2,3.7,7v21.8c0,3.1-1.7,5.9-4.4,7.4\n                    C299,198.8,295.7,198.6,293.1,196.9z\"/><path class=st5 d=M188.6,222.4h33.6c4.6,0,8.4,3.8,8.4,8.4v58.8h-50.4v-58.8C180.2,226.1,184,222.4,188.6,222.4z /><path class=st6 d=\"M192.8,398.1c8.4,0.5,16.7,0.5,25.1,0c-75.6-4.9-141.3-53.7-168-124.6S40.5,122.7,94.1,69.1\n                    c33-33.2,77.1-53.1,123.8-56.1C111.6,6.1,19.8,86.7,12.8,193S86.5,391.2,192.8,398.1z\"/><path class=st6 d=\"M74.9,75c-12.2,12.5-22.7,26.5-31.2,41.7c-8.4,15.2-14.6,31.6-18.3,48.6c-6.7,30.3-5.8,61.9,2.7,91.8\n                    c8.9,29.8,24.9,56.9,46.7,79.1L63,348c-23.8-24.1-41.3-53.8-51-86.3c-9.3-32.6-10.3-67-3-100.1c4.1-18.6,10.8-36.4,20-53.1\n                    C38.3,92,49.7,76.7,63,63.1L74.9,75z\"/><path class=st7 d=\"M86.7,324.3c65.6,65.6,171.8,65.6,237.4,0c65.6-65.6,65.6-171.8,0-237.4c-42.4-42.4-104.2-59-162.2-43.5\n                    S58.8,104.2,43.3,162.1S44.3,281.9,86.7,324.3z M98.6,98.7c59-59,154.7-59,213.7,0s59,154.7,0,213.7s-154.7,59-213.7,0\n                    C70,284.2,53.9,245.7,53.9,205.6S70,126.9,98.6,98.7z\"/><path class=st7 d=\"M436.9,365.8c-6.6-6.6-17.2-6.6-23.7,0l-43.7-43.6c60.8-85.3,46-203-34-270.6S137-11.1,63,63.1l-11.7,13\n                    c-3.9,4.3-7.1,9.3-10.6,13.9c-1.4,1.8-2,4.1-1.6,6.4c0.4,2.2,1.7,4.2,3.7,5.4c3.8,2.3,8.8,1.4,11.6-2.1c3.3-4.2,6.1-8.8,9.7-12.8\n                    L74.8,75C147,2.9,263.9,2.9,336,75s72.1,189,0,261.1s-189,72.1-261.1,0C53,314,37,286.9,28.1,257.1c-8.5-29.9-9.5-61.5-2.7-91.8\n                    l1.9-7.8c1-4.4-1.5-8.8-5.8-10.2c-2.2-0.7-4.5-0.5-6.5,0.6c-2,1.1-3.4,3-3.9,5.2L9,161.7c-7.4,33.1-6.3,67.5,3,100.1\n                    c9.7,32.5,27.2,62.1,51,86.3c69.5,69.5,179,78.6,259,21.6l43.6,43.7c-6.6,6.6-6.6,17.2,0,23.7l56,56c12.7,12.9,31.3,18,48.8,13.4\n                    c17.5-4.6,31.1-18.3,35.8-35.8c4.6-17.5-0.5-36.1-13.4-48.8L436.9,365.8z M377.5,401.4l-42.1-42.1c4.2-3.6,8.5-7.3,12.5-11.3\n                    c4-4,7.7-8.2,11.3-12.5l42.2,42.1l-11.9,11.9L377.5,401.4z M425,377.7l21.9,21.9l-47.5,47.4l-21.9-21.9L425,377.7z M481,481.1\n                    c-13.3,12.7-34.2,12.7-47.5,0l-22.2-22.2l47.5-47.4l22.2,22.1c6.3,6.3,9.8,14.8,9.8,23.7S487.3,474.8,481,481.1z\"/><path class=st7 d=\"M100.7,213c2.7,1.5,6,1.3,8.6-0.4l20.5-13.7v82.3c0,9.3,7.5,16.8,16.8,16.8h117.5c9.3,0,16.8-7.5,16.8-16.8\n                    v-82.3l20.5,13.7c2.6,1.7,5.9,1.9,8.6,0.4c2.7-1.5,4.4-4.3,4.4-7.4v-42c0-2.8-1.4-5.4-3.7-7L210.1,89.5c-2.8-1.9-6.5-1.9-9.3,0\n                    L100,156.6c-2.3,1.6-3.7,4.2-3.7,7v42C96.3,208.7,98,211.5,100.7,213z M188.6,281.1v-50.4h33.6v50.4H188.6z M264.2,281.1H239v-50.4\n                    c0-9.3-7.5-16.8-16.8-16.8h-33.6c-9.3,0-16.8,7.5-16.8,16.8v50.4h-25.2v-93.4l58.8-39.2l58.8,39.2V281.1z M113.1,168.1l92.3-61.6\n                    l92.3,61.5v21.8l-87.7-58.5c-2.8-1.9-6.5-1.9-9.3,0l-87.7,58.4V168.1z\"/></g></svg></div><div class=\"body-tag d-flex flex-wrap flex-column justify-content-center\"><h4 class=title-tag>{{ vm.tag.text }}</h4><span class=desc-tag>{{ vm.tag.description }}</span></div></div></div><form action=\"\" name=formagendamento class=\"form col-12 col-md-10 p-0 m-1\" ng-submit=vm.submit($event)><span ng-if=!vm.listing.imv_ativo><h2 class=inactive-title>Você pode encontrar novas oportunidades!</h2><p class=inactive-desc>Este imóvel não está mais disponível, mas você pode conferir outros em nosso site ou deixar seu contato para receber mais informações.</p></span><h1 class=title>Entrar em contato</h1><p ng-if=vm.listing.imv_ativo class=description>Legal que você se interessou por esse imóvel! Preencha os campos abaixo para receber mais informações. :)</p><div class=\"row d-flex contact-header\"><div class=\"col-12 p-0\"><div class=form-group><div class=\"row mb-3\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form.cliente required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Primeiro Nome</label></div><div class=\"row mb-3\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form.telefone data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-3\"><input type=email id=email class=\"form-control upper\" ng-model=vm.form.email required placeholder=email@dominio.com><label for=email class=\"pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.card_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div></div><div class=\"btn-content col-10 m-auto\"><button ng-disabled=\"vm.loading || (vm.config_wl.isArbo && !vm.form.card_accept_terms)\" type=submit class=\"btn button active text-center\" ng-class=\"{\'bg-danger\': vm.error_submit}\"><span ng-if=!vm.loading>Enviar contato</span> <span ng-if=vm.loading ng-bind-html=\"(vm.msg_submit ? vm.msg_submit : vm.spinner)\" class=font-weight-bold></span></button></div></div></div></form></div></div></section>");
$templateCache.put("app/agendamento/agendamento-visita.html","<section id=agendamento><div class=\"row container m-auto\"><nav class=navegator><ol class=\"breadcrumb bg-white mb-4 px-0\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item href=/ ><span itemprop=name>Início</span></a><meta itemprop=position content=1></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 1) }}\"><span itemprop=name>{{ vm.listing.imv_cidade }}</span></a><meta itemprop=position content=2></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 5) }}\"><span itemprop=name>{{ vm.listing.imv_bairro }}</span></a><meta itemprop=position content=6></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 2) }}\"><span itemprop=name>{{ vm.listing.imv_preco_locacao ? \'Aluguel\' : \'Venda\' }}</span></a><meta itemprop=position content=3></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 3) }}\"><span itemprop=name>{{ vm.listing.tipo_imovel.timv_nome }}</span></a><meta itemprop=position content=4></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 4) }}\"><span itemprop=name>imóvel {{ vm.listing.imv_cod_gaia }}</span></a><meta itemprop=position content=5></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, true) }}\"><span itemprop=name>{{ vm.titleContato }}</span></a><meta itemprop=position content=7></li></ol></nav></div><div class=\"row container m-auto\"><div class=\"row flex-row card col-12 col-lg-3 pt-2\"><a ng-href=\"{{ vm.makeUrl(vm.listing, 4) }}\"><div class=\"col-12 col-sm-8 col-lg-12 mx-auto p-0\"><img ng-src=\"{{ vm.listing.fotos[0].imvft_url }}\" class=\"image img-fluid\" alt=\"{{ (vm.listing.fotos[0].tipo_foto ? vm.listing.fotos[0].tipo_foto.tfoto_nome : \'Foto\') + \' do \' + vm.listing.tipo_imovel.timv_nome }} - {{ vm.listing.imv_titulo }} | {{ vm.config_wl.nome }}\"><h1 class=title>{{ vm.listing.imv_titulo }}</h1><h2 class=subtitle itemprop=name ng-if=!vm.listing.imobiliaria.imb_hidden_cond_num>{{ vm.listing.imv_nome_cond }}</h2><h2 class=subtitle>{{ vm.listing.subtipo_imovel.stimv_nome }}</h2><address class=address itemprop=address ng-if=!vm.listing.imobiliaria.imb_hidden_address>{{ vm.listing.imv_endereco }} <span ng-if=!vm.listing.imobiliaria.imb_hidden_cond_num>, {{ vm.listing.imv_end_numero }}</span> - {{ vm.listing.imv_bairro }} - {{ vm.listing.imv_cidade }}/{{ vm.listing.imv_estado }}</address><div class=description>cód. {{ vm.listing.imv_cod_gaia }} /<h2 class=\"d-inline-block px-1\" ng-if=vm.showimobiliaria><a ui-sref=\"main.imobiliariaPage({imobRoute: vm.generateImobLink()})\">{{ vm.listing.imobiliaria.imb_nome }}</a></h2>Creci {{ vm.listing.imobiliaria.imb_creci }}</div><ul class=\"offers mt-3\" itemprop=offers itemscope itemtype=http://schema.org/Offer><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_venda><div ng-if=\"vm.listing.timv_id != 36\">Venda</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio de venda</div><div class=text-right itemprop=price>R$ {{ vm.listing.imv_preco_venda | number: \'0\' }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_locacao><div ng-if=\"vm.listing.timv_id != 36\">Aluguel</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio do Aluguel</div><div class=text-right itemprop=price>R$ {{ vm.listing.imv_preco_locacao | number: \'0\' }}<meta itemprop=priceCurrency content=BRL></div></li></ul></div><div class=\"col-12 p-0 offers\"><div class=\"btns-media d-flex flex-row flex-lg-column order-first order-lg-last\"><a ng-href=\"\" class=btn ng-class=\"{\'active\': vm.view === \'fotos\'}\" role=button ng-click=\"vm.changeView(\'fotos\')\"></a></div></div></a></div><div class=\"col-12 col-lg-6 order-first order-lg-last mb-5\"><div class=\"col-12 col-md-10 p-0 mx-auto mt-lg-1 mb-3\" ng-if=vm.tag.hidden><div class=\"tag-imovel d-flex align-items-center\"><div class=image-tag><svg ng-if=\"vm.tag.svg == \'pin\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #3b3b3b;\n                }\n\n                .st1 {\n                  fill: #ffffff;\n                }\n\n                .st2 {\n                  fill: #e8f9fc;\n                }\n\n                .st3 {\n                  fill: #caf7fc;\n                }\n\n                .st4 {\n                  fill: #3b3b3b;\n                }</style><g><path class=st0 d=\"M251.7,496.9c3,4.1,7.7,6.6,12.8,6.6s9.8-2.4,12.8-6.6C317,443.7,435.2,290.1,435.2,190\n                    c0-121.7-76.5-181.5-170.7-181.5S93.9,68.3,93.9,190C93.9,290.1,212.1,443.7,251.7,496.9z\"/><path class=st1 d=\"M238.9,496.9c6.2,8.7,6,8.7,12.2,0c37.7-53.2,150-206.8,150-306.9c0-121.7-72.6-181.5-162.1-181.5\n                    S76.8,68.3,76.8,190C76.8,290.1,201.2,443.7,238.9,496.9z\"/><path class=st2 d=\"M244.5,496.9c2.4,4.1,6.8,6.6,11.5,6.6c4.7,0,9.1-2.5,11.5-6.6c35.7-53.2,142.1-206.8,142.1-306.9\n                    C409.6,68.3,340.8,8.5,256,8.5S102.4,68.3,102.4,190C102.4,290.1,208.8,443.7,244.5,496.9z\"/><circle class=st3 cx=256 cy=187.7 r=128 /><path class=st2 d=\"M316.4,144.1l-0.7,0.9v102.4c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5v-33.1\n                    c0.2-8.6-5.7-16.1-14.2-17.8c-5-0.8-10,0.5-13.9,3.8s-6.1,8-6.1,13v34.1c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5V145.1\n                    l-3.2-5.2l57.3-35.2c3.3-2.9,8.2-2.9,11.4,0L316.4,144.1z\"/><g><path class=st4 d=\"M256,324.3c-75.4,0-136.5-61.1-136.5-136.5S180.6,51.2,256,51.2s136.5,61.1,136.5,136.5\n                      C392.4,263.1,331.4,324.2,256,324.3z M256,68.3c-66,0-119.5,53.5-119.5,119.5S190,307.2,256,307.2s119.5-53.5,119.5-119.5\n                      C375.4,121.8,321.9,68.3,256,68.3z\"/><path class=st4 d=\"M307.2,264.5h-25.6c-9.4,0-17.1-7.6-17.1-17.1v-33.1c0.2-4.4-2.8-8.3-7-9.4c-2.5-0.4-5,0.3-7,1.9\n                      s-3.1,4-3.1,6.5v34.1c0,9.4-7.6,17.1-17.1,17.1h-25.6c-9.4,0-17.1-7.6-17.1-17.1V145.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5\n                      v102.4h25.6v-34.1c0-7.5,3.3-14.7,9.1-19.6s13.4-6.9,20.8-5.7c12.5,2.5,21.4,13.5,21.3,26.3v33.1h25.6V145.1\n                      c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v102.4C324.3,256.9,316.6,264.5,307.2,264.5z\"/><path class=st4 d=\"M341.3,170.7c-1.8,0-3.5-0.6-5-1.6l-79.6-57.6c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4,0.3-0.8,0.6-1.3,0.9l-79.6,49\n                      c-2.6,1.6-5.8,1.7-8.5,0.2c-2.7-1.4-4.4-4.2-4.5-7.3s1.5-5.9,4.1-7.5l79.1-48.7c6.4-5.1,15.5-5,21.8,0.2l79.3,57.3\n                      c3,2.2,4.3,6,3.1,9.5C348.3,168.3,345,170.7,341.3,170.7L341.3,170.7z\"/><path class=st4 d=\"M256,512c-7.9,0-15.3-3.6-20.2-9.8l-5.4-6.8C189.1,442.7,92.2,319.5,72,223.6c-0.6-3,0.4-6.1,2.6-8.1\n                      c2.3-2,5.5-2.7,8.4-1.8c2.9,1,5.1,3.4,5.7,6.4c19.3,92,114.5,213,155.1,264.7l5.4,6.8c1.7,2,4.2,3.2,6.8,3.2s5.1-1.2,6.8-3.2\n                      l5.5-7c43.3-55.1,158.4-201.5,158.4-294.6c0-127.5-88.2-173-170.7-173c-92.4,0-155.3,51.5-168.1,137.8c-0.4,3-2.5,5.6-5.3,6.7\n                      c-2.8,1.1-6.1,0.6-8.4-1.3c-2.4-1.9-3.6-4.9-3.1-7.9C85,58.4,155.9,0,256,0c114,0,187.7,74.6,187.7,190\n                      c0,99-113.6,243.4-162,305.1l-5.5,7C271.4,508.4,263.9,512,256,512L256,512z\"/><circle class=st4 cx=76.8 cy=187.7 r=8.5 /></g></g></svg> <svg ng-if=\"vm.tag.svg == \'mudanca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #9de8eb;\n                }\n                .st1 {\n                  fill: #a2fcf3;\n                }\n                .st2 {\n                  fill: #e8f9fc;\n                }\n                .st3 {\n                  fill: #ffffff;\n                }\n                .st4 {\n                  fill: #2fbaba;\n                }</style><g><path id=Shape_1_ class=st0 d=\"M200.2,409.6c-7.4,0-13.9-4.8-16.2-11.8L70.6,49.7l-16.4,8.2c-8.4,4.2-18.7,0.8-22.9-7.6\n                    s-0.8-18.7,7.6-22.9l34.1-17.1c4.4-2.2,9.6-2.4,14.2-0.5s8.1,5.7,9.7,10.5l114,350.3l248-88c8.9-3.2,18.6,1.5,21.8,10.4\n                    c3.2,8.9-1.5,18.6-10.4,21.8l-264.5,93.9C204,409.2,202.1,409.6,200.2,409.6z\"/><path class=st0 d=\"M285.5,452.2c0,28.3-22.9,51.2-51.2,51.2c-5.2,0-10.4-0.8-15.4-2.3c-21.3-6.8-35.8-26.6-35.8-48.9\n                    c0-22.4,14.5-42.2,35.8-48.9c5-1.5,10.2-2.2,15.4-2.3C262.6,401,285.5,424,285.5,452.2z\"/><ellipse id=Oval class=st1 cx=219 cy=452.2 rx=35.8 ry=48.9 /><circle class=st0 cx=234.3 cy=452.2 r=17.1 /><path id=Rectangle-path_1_ class=st1 d=\"M203.8,192l161-56.5c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9\n                    l-161,56.5c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C197,198.5,199.3,193.6,203.8,192z\"/><path class=st2 d=\"M203.4,192.2l139.3-48.9c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9L260,353.2\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C196.7,198.6,199,193.7,203.4,192.2z\"/><path class=st0 d=\"M315.6,215.8l-8.8-2.3c-3.3-0.9-6.9,0.4-8.9,3.1l-5.5,7.3c-1.9,2.5-5,3.8-8.1,3.3c-3.1-0.5-5.7-2.6-6.7-5.6\n                    l-17.3-49.4l48.3-17l17.3,49.4c1,3,0.4,6.3-1.8,8.6C321.9,215.6,318.7,216.5,315.6,215.8z\"/><path class=st1 d=\"M189.1,75.9l102.6-36c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9l-102.6,36\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C182.3,82.4,184.6,77.5,189.1,75.9z\"/><path class=st2 d=\"M188.1,76.3l78.1-27.4c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9L226,184.2\n                    c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C181.3,82.7,183.6,77.8,188.1,76.3z\"/><path class=st0 d=\"M264,93.5l-9.5-2.4c-1.7-0.4-3.4,0.2-4.5,1.6l-5.9,7.8c-0.9,1.3-2.5,1.9-4.1,1.6c-1.6-0.2-2.8-1.3-3.4-2.8\n                    l-12.5-35.7l32.4-11.4l12.5,35.7c0.5,1.5,0.2,3.2-0.9,4.3C267.2,93.4,265.5,93.9,264,93.5z\"/><path class=st3 d=\"M54.2,57.9l6.1-3.1c-4-3.8-5.9-9.4-5.1-14.8c0.8-5.5,4.3-10.2,9.3-12.6l28-14c-5.1-5.1-13-6.4-19.5-3.1\n                    L38.9,27.4c-8.4,4.2-11.8,14.5-7.6,22.9S45.8,62.1,54.2,57.9z\"/><path class=st3 d=\"M73.8,59.6L184,397.8c1.4,4.4,4.6,8,8.7,10c4.1,2,8.9,2.3,13.2,0.8l4.5-1.6c-23,12.1-33.2,39.5-23.8,63.7\n                    c9.4,24.2,35.5,37.5,60.6,31c-20.4-5.3-35.5-22.6-38-43.5s8.2-41.3,26.8-51.2l-4.5,1.6c-4.3,1.5-9.1,1.3-13.2-0.8\n                    c-4.1-2-7.3-5.7-8.7-10L96.2,49.7l-16.4,8.2C77.9,58.8,75.9,59.4,73.8,59.6z\"/><polygon class=st3 points=\"78.7,47 113.1,152.5 192.1,395.1 175.8,400.4 96.8,157.8 62.5,52.3 	\"/><g><path class=st4 d=\"M99.4,118.5c2.1-4.2,0.4-9.3-3.7-11.5l-1.5-0.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.5-0.1-1.1-0.1-1.6,0\n                      c-0.6,0.1-1.1,0.2-1.7,0.4c-2.1,0.7-3.9,2.2-5,4.2c-2,4.2-0.4,9.3,3.7,11.5c1,0.5,2.1,0.8,3.2,0.9c1.1,0.1,2.2,0,3.3-0.4\n                      C96.5,122,98.3,120.5,99.4,118.5z\"/><path class=st4 d=\"M38.5,66.9c6.4,2.2,13.5,1.7,19.5-1.4l7.5-3.8l7.5,23c1.6,4.3,6.3,6.6,10.6,5.1c4.4-1.4,6.8-6,5.6-10.4\n                      L78.7,47.1l-0.2,0.1c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-4.2-7.2-5.9-11.4-3.9l-16.4,8.3c-4.2,2.1-9.4,0.4-11.5-3.8\n                      c-2.1-4.2-0.4-9.4,3.8-11.5L76.8,18c2.2-1.1,4.8-1.2,7.1-0.2c2.3,1,4.1,2.9,4.8,5.2l114.1,350.2c0.7,2.2,2.3,4,4.3,5\n                      c2.1,1,4.5,1.2,6.6,0.4l248-88c3.3-1.1,6.9-0.2,9.2,2.3c2.3,2.6,2.8,6.3,1.4,9.4c-1,2-2.7,3.6-4.8,4.4l-245.3,87\n                      c-5.2,1.1-10.2,2.9-15,5.3l-4.3,1.5c-2.2,0.8-4.6,0.6-6.6-0.4c-2.1-1-3.6-2.8-4.3-5l-81.6-250.7c-0.8-3-3.3-5.3-6.3-6\n                      c-3.1-0.7-6.2,0.3-8.3,2.7c-2.1,2.4-2.7,5.7-1.6,8.6l81.6,250.7c2,6.1,6.3,11.3,11.9,14.4c-16,19.8-17.6,47.5-4.2,69.1\n                      c13.5,21.6,39.1,32.3,63.9,26.6c24.8-5.6,43.3-26.3,46.1-51.6c2.8-25.3-10.7-49.6-33.6-60.5l213.2-75.7\n                      c8.9-2.8,15.5-10.3,17.3-19.5c1.8-9.2-1.5-18.6-8.7-24.6c-7.2-6-17-7.6-25.7-4.2l-22.7,8l-54-153.8c-0.8-2.1-2.3-3.9-4.4-4.9\n                      s-4.4-1.1-6.5-0.4l-26,9.1L307.2,31.8c-0.8-2.1-2.3-3.9-4.4-4.9s-4.4-1.1-6.5-0.4l-43.2,15.2l-32.4,11.4l-43.2,15.2\n                      c-2.1,0.8-3.9,2.3-4.9,4.4c-1,2-1.1,4.4-0.4,6.5L207.7,180l-16.3,5.7c-4.4,1.6-6.8,6.4-5.2,10.9L240.5,351l-24.1,8.5L105,17.6\n                      c-2.3-7.1-7.6-12.8-14.5-15.7S75.9-0.7,69.3,2.7L35.1,19.7C25.9,24.4,20.3,34.1,21,44.4S28.7,63.6,38.5,66.9z M234.3,409.6\n                      c21.9-0.3,40.6,15.9,43.4,37.7c2.8,21.8-11.1,42.2-32.4,47.5s-43.2-6.1-50.9-26.6c-7.8-20.5,1.1-43.6,20.6-53.7l11.4-4\n                      C229,409.8,231.6,409.6,234.3,409.6z M301.8,165l14.5,41.3l-14.4-3.7c-3.3-0.9-6.9,0.4-8.9,3.1l-8.9,11.8l-14.5-41.3l16.1-5.7\n                      L301.8,165z M257.8,80.8l-4.5-1.2c-3.3-0.9-6.9,0.4-8.9,3.1l-2.8,3.7l-7-20.1l8.1-2.9l8.1-2.9L257.8,80.8z M218.3,72l12.3,35.1\n                      c1,3,3.6,5.1,6.7,5.6c0.4,0.1,0.9,0.1,1.3,0.1c2.7,0,5.2-1.3,6.8-3.4l9-11.9l14.5,3.7c3,0.8,6.3-0.2,8.4-2.5\n                      c2.1-2.3,2.8-5.6,1.8-8.6L266.8,55l27.1-9.5l32.2,91.8l-102.6,36l-32.2-91.8L218.3,72z M253.5,182l19.8,56.4c1,3,3.6,5.1,6.7,5.6\n                      c3.1,0.5,6.2-0.8,8.1-3.3l15.1-20l24.3,6.2c3,0.8,6.3-0.2,8.4-2.5c2.1-2.3,2.8-5.6,1.8-8.6l-19.8-56.3l48.3-17l50.9,144.9\n                      l-161,56.5L205.2,199L253.5,182z\"/><path class=st4 d=\"M208.7,452.2c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6c0-14.1-11.5-25.6-25.6-25.6\n                      C220.2,426.6,208.7,438.1,208.7,452.2z M234.3,443.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5\n                      S229.6,443.7,234.3,443.7z\"/></g></g></svg> <svg ng-if=\"vm.tag.svg == \'busca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                  fill: #a2fcf3;\n                }\n                .st1 {\n                  fill: #e8f9fc;\n                }\n                .st2 {\n                  fill: #808e87;\n                }\n                .st3 {\n                  fill: url(#SVGID_1_);\n                }\n                .st4 {\n                  fill: #f26546;\n                }\n                .st5 {\n                  fill: #9de8eb;\n                }\n                .st6 {\n                  fill: #ffffff;\n                }\n                .st7 {\n                  fill: #2fbaba;\n                }</style><g><path id=Shape class=st0 d=\"M458.8,399.6l-59.1,59l-0.3,0.3l-0.1-0.1h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l36.1-36.1\n                    l11.4-11.4c3.3-3.3,8.6-3.3,11.8,0L458.8,399.6z\"/><path class=st0 d=\"M486.9,487.1c-2.1,2.1-4.4,4-7,5.6c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l0.3-0.3l59.1-59l28.1,28.1\n                    C503.3,444.1,503.3,470.7,486.9,487.1z\"/><path class=st1 d=\"M436.9,420.5l-37.5,38.3h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l26.9-27.7c3.3-2.2,7.7-1.7,10.6,1.1\n                    L436.9,420.5z\"/><path class=st1 d=M480,492.7c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l38.1-38.1l28,28.1C479.8,463.2,490.5,476.4,480,492.7z /><rect id=Rectangle-path x=342.9 y=329.6 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -152.5583 368.0898)\" class=st0 width=50.3 height=77.3 /><rect x=346.4 y=338 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -160.953 364.6137)\" class=st1 width=26.6 height=77.3 /><path class=st0 d=\"M341.9,342.1c-75.8,72.7-195.9,71.5-270.2-2.8S-3.8,144.9,68.9,69.1c75.8-72.7,195.9-71.5,270.2,2.8\n                    S414.6,266.2,341.9,342.1z\"/><path class=st1 d=\"M316.7,342.1c-33,33.2-77.1,53.2-123.9,56.1c-75.6-4.9-141.4-53.6-168.1-124.6S15.3,122.7,68.9,69.1\n                    c33-33.2,77.1-53.2,123.9-56.1c75.6,4.9,141.4,53.6,168.1,124.6S370.3,288.5,316.7,342.1z\"/><path class=st2 d=\"M205.4,373.4c-67.9,0-129.1-40.9-155.1-103.6s-11.6-134.9,36.4-183c65.6-65.6,171.9-65.6,237.4,0\n                    s65.6,171.9,0,237.4C292.7,355.9,250,373.6,205.4,373.4z\"/><linearGradient id=SVGID_1_ gradientUnits=userSpaceOnUse x1=-700.6567 y1=795.9537 x2=-699.9529 y2=795.2502 gradientTransform=\"matrix(320.5412 0 0 -320.6926 224681.9375 255349.2344)\"><stop offset=0 style=\"stop-color: #d4f3f3\"/><stop offset=0.172 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #dbf1f3\"/><stop offset=0.201 style=\"stop-color: #ebedf3\"/><stop offset=0.201 style=\"stop-color: #f7f0f7\"/><stop offset=0.202 style=\"stop-color: #f1e6ec\"/><stop offset=0.205 style=\"stop-color: #fff2f7\"/><stop offset=0.252 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #d4f3f3\"/><stop offset=0.397 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #dbf1f3\"/><stop offset=0.421 style=\"stop-color: #ebedf3\"/><stop offset=0.421 style=\"stop-color: #f7f0f7\"/><stop offset=0.422 style=\"stop-color: #f1e6ec\"/><stop offset=0.425 style=\"stop-color: #fff2f7\"/><stop offset=0.489 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #f8f0f7\"/><stop offset=0.5 style=\"stop-color: #e8eef3\"/><stop offset=0.5 style=\"stop-color: #ddf1f3\"/><stop offset=0.5 style=\"stop-color: #d6f2f3\"/><stop offset=0.501 style=\"stop-color: #d4f3f3\"/><stop offset=0.706 style=\"stop-color: #d4f3f3\"/><stop offset=0.74 style=\"stop-color: #d4f3f3\"/><stop offset=0.741 style=\"stop-color: #fff2f7\"/><stop offset=0.835 style=\"stop-color: #fff2f7\"/><stop offset=0.85 style=\"stop-color: #fff2f7\"/><stop offset=0.851 style=\"stop-color: #d4f3f3\"/></linearGradient><path class=st3 d=\"M318.2,318.4c-62.3,62.2-163.3,62.2-225.6,0c-1.1-1.1-2.2-2.3-3.3-3.4c-39.7-40.9-54.5-99.8-39-154.7\n                    s59.2-97.2,114.4-111.1s113.7,2.7,153.4,43.6c17.8,17.8,31.1,39.5,38.8,63.5C375.5,213.3,360.6,275.9,318.2,318.4z\"/><path class=st4 d=M138.3,183.2l69.3-60.3l65,60.3v98c0,4.6-3.8,8.4-8.4,8.4H146.7c-4.6,0-8.4-3.8-8.4-8.4V183.2z /><path class=st1 d=M146.7,171.7l60.7-66.8l56.8,66.8v108.6c0.5,4.6-2.8,8.7-7.3,9.3H154c-4.6-0.6-7.8-4.7-7.3-9.3V171.7z /><path class=st5 d=\"M293.1,196.9l-83-55.3c-2.8-1.9-6.5-1.9-9.3,0l-83,55.3c-2.6,1.7-5.9,1.9-8.6,0.4c-2.7-1.5-4.4-4.3-4.4-7.4\n                    v-21.8c0-2.8,1.4-5.4,3.7-7l92.3-61.5c2.8-1.9,6.5-1.9,9.3,0l92.3,61.5c2.3,1.6,3.7,4.2,3.7,7v21.8c0,3.1-1.7,5.9-4.4,7.4\n                    C299,198.8,295.7,198.6,293.1,196.9z\"/><path class=st5 d=M188.6,222.4h33.6c4.6,0,8.4,3.8,8.4,8.4v58.8h-50.4v-58.8C180.2,226.1,184,222.4,188.6,222.4z /><path class=st6 d=\"M192.8,398.1c8.4,0.5,16.7,0.5,25.1,0c-75.6-4.9-141.3-53.7-168-124.6S40.5,122.7,94.1,69.1\n                    c33-33.2,77.1-53.1,123.8-56.1C111.6,6.1,19.8,86.7,12.8,193S86.5,391.2,192.8,398.1z\"/><path class=st6 d=\"M74.9,75c-12.2,12.5-22.7,26.5-31.2,41.7c-8.4,15.2-14.6,31.6-18.3,48.6c-6.7,30.3-5.8,61.9,2.7,91.8\n                    c8.9,29.8,24.9,56.9,46.7,79.1L63,348c-23.8-24.1-41.3-53.8-51-86.3c-9.3-32.6-10.3-67-3-100.1c4.1-18.6,10.8-36.4,20-53.1\n                    C38.3,92,49.7,76.7,63,63.1L74.9,75z\"/><path class=st7 d=\"M86.7,324.3c65.6,65.6,171.8,65.6,237.4,0c65.6-65.6,65.6-171.8,0-237.4c-42.4-42.4-104.2-59-162.2-43.5\n                    S58.8,104.2,43.3,162.1S44.3,281.9,86.7,324.3z M98.6,98.7c59-59,154.7-59,213.7,0s59,154.7,0,213.7s-154.7,59-213.7,0\n                    C70,284.2,53.9,245.7,53.9,205.6S70,126.9,98.6,98.7z\"/><path class=st7 d=\"M436.9,365.8c-6.6-6.6-17.2-6.6-23.7,0l-43.7-43.6c60.8-85.3,46-203-34-270.6S137-11.1,63,63.1l-11.7,13\n                    c-3.9,4.3-7.1,9.3-10.6,13.9c-1.4,1.8-2,4.1-1.6,6.4c0.4,2.2,1.7,4.2,3.7,5.4c3.8,2.3,8.8,1.4,11.6-2.1c3.3-4.2,6.1-8.8,9.7-12.8\n                    L74.8,75C147,2.9,263.9,2.9,336,75s72.1,189,0,261.1s-189,72.1-261.1,0C53,314,37,286.9,28.1,257.1c-8.5-29.9-9.5-61.5-2.7-91.8\n                    l1.9-7.8c1-4.4-1.5-8.8-5.8-10.2c-2.2-0.7-4.5-0.5-6.5,0.6c-2,1.1-3.4,3-3.9,5.2L9,161.7c-7.4,33.1-6.3,67.5,3,100.1\n                    c9.7,32.5,27.2,62.1,51,86.3c69.5,69.5,179,78.6,259,21.6l43.6,43.7c-6.6,6.6-6.6,17.2,0,23.7l56,56c12.7,12.9,31.3,18,48.8,13.4\n                    c17.5-4.6,31.1-18.3,35.8-35.8c4.6-17.5-0.5-36.1-13.4-48.8L436.9,365.8z M377.5,401.4l-42.1-42.1c4.2-3.6,8.5-7.3,12.5-11.3\n                    c4-4,7.7-8.2,11.3-12.5l42.2,42.1l-11.9,11.9L377.5,401.4z M425,377.7l21.9,21.9l-47.5,47.4l-21.9-21.9L425,377.7z M481,481.1\n                    c-13.3,12.7-34.2,12.7-47.5,0l-22.2-22.2l47.5-47.4l22.2,22.1c6.3,6.3,9.8,14.8,9.8,23.7S487.3,474.8,481,481.1z\"/><path class=st7 d=\"M100.7,213c2.7,1.5,6,1.3,8.6-0.4l20.5-13.7v82.3c0,9.3,7.5,16.8,16.8,16.8h117.5c9.3,0,16.8-7.5,16.8-16.8\n                    v-82.3l20.5,13.7c2.6,1.7,5.9,1.9,8.6,0.4c2.7-1.5,4.4-4.3,4.4-7.4v-42c0-2.8-1.4-5.4-3.7-7L210.1,89.5c-2.8-1.9-6.5-1.9-9.3,0\n                    L100,156.6c-2.3,1.6-3.7,4.2-3.7,7v42C96.3,208.7,98,211.5,100.7,213z M188.6,281.1v-50.4h33.6v50.4H188.6z M264.2,281.1H239v-50.4\n                    c0-9.3-7.5-16.8-16.8-16.8h-33.6c-9.3,0-16.8,7.5-16.8,16.8v50.4h-25.2v-93.4l58.8-39.2l58.8,39.2V281.1z M113.1,168.1l92.3-61.6\n                    l92.3,61.5v21.8l-87.7-58.5c-2.8-1.9-6.5-1.9-9.3,0l-87.7,58.4V168.1z\"/></g></svg></div><div class=\"body-tag d-flex flex-wrap flex-column justify-content-center\"><h4 class=title-tag>{{ vm.tag.text }}</h4><span class=desc-tag>{{ vm.tag.description }}</span></div></div></div><form action=\"\" name=formagendamento class=\"form col-12 col-md-10 p-0 m-1\" ng-submit=vm.submit($event)><h1 class=title>Agendar visita</h1><p class=description>Legal que você se interessou por esse imóvel! Preencha os campos abaixo para receber o contato da nossa equipe e agendar uma visita ao imóvel :)</p><div class=\"row d-flex contact-header\"><div class=\"col-12 p-0\"><div class=form-group><div class=\"row mb-3\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form.cliente required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Nome</label></div><div class=\"row mb-3\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form.telefone data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-3\"><input type=text id=email class=\"form-control upper\" ng-model=vm.form.email required placeholder=email@dominio.com><label for=email class=\"pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.card_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div><div class=\"form-contact col-12 mx-auto py-2 mt-4\"><h3 class=\"title my-4\">Escolha um horário</h3><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"picker date-picker d-flex justify-content-between align-items-center col-12 px-0\" ng-init=vm.getMoreDates()><button type=button class=\"btn align-self-end\" role=button ng-click=\"vm.getMoreDates((vm.dates[0] || {}).date)\"><i class=\"date-picker-arrow fas fa-chevron-left\"></i></button><div ng-repeat=\"date in vm.dates\"><input type=radio name=date id=\"date-{{ $index }}\" class=picker-input ng-model=vm.form.visita_data ng-value=date.date ng-checked=\"(vm.form.visita_data == date.date)\" ng-change=\"vm.momentFormater(vm.form.visita_data, vm.form.visita_hora)\"><label for=\"date-{{ $index }}\" class=\"date-elem noSwipe no-select\"><span class=week>{{ date.dayOfWeek }}</span> <span class=\"day d-flex align-items-center justify-content-center\">{{ date.day }}</span></label></div><button type=button class=\"btn align-self-end\" role=button ng-click=\"vm.getMoreDates((vm.dates.slice(-1)[0] || {}).date)\"><i class=\"date-picker-arrow fas fa-chevron-right\"></i></button></div><div class=\"picker time-picker d-flex justify-content-between align-items-center col-12 px-0\" ng-init=vm.getMoreTimes()><button type=button class=btn role=button ng-click=\"vm.getMoreTimes((vm.times[0] || {}).index - 5)\" ng-disabled=\"(vm.times[0] || {}).index == 1\"><i class=\"date-picker-arrow fas fa-chevron-left\"></i></button><div ng-repeat=\"date in vm.times\"><input id=\"hour-{{ $index }}\" type=radio name=hour class=picker-input ng-model=vm.form.visita_hora ng-value=date.time ng-checked=$first ng-change=\"vm.momentFormater(vm.form.visita_data, vm.form.visita_hora)\"><label for=\"hour-{{ $index }}\" class=\"date-elem noSwipe no-select\"><span class=\"day d-flex align-items-center justify-content-center\">{{ date.time }}</span></label></div><button type=button class=btn role=button ng-click=\"vm.getMoreTimes((vm.times.slice(-1)[0] || {}).index)\" ng-disabled=\"(vm.times.slice(-1)[0] || {}).index == 22\"><i class=\"date-picker-arrow fas fa-chevron-right\"></i></button></div></div></div><div class=\"schedule col-12 text-center my-5 p-0\">{{ vm.stringTime }}</div></div><div class=\"btn-content col-10 m-auto\"><button type=submit class=\"btn button active text-center btn-agendar-visita\" ng-disabled=\"!vm.dateVisita || (vm.config_wl.isArbo && !vm.form.card_accept_terms)\" ng-style=\"vm.dateVisita ? {\'background-color\': \'var(--primary-color)\'} : {\'background-color\': \'darkgrey\'}\" ng-class=\"{\'bg-danger\': vm.error_submit}\"><span ng-if=!vm.loading>Agendar visita</span> <span ng-if=vm.loading ng-bind-html=\"(vm.msg_submit ? vm.msg_submit : vm.spinner)\" class=font-weight-bold></span></button></div></div></div></form></div></div></section>");
$templateCache.put("app/bairro/bairro.html","<div id=neighborhood class=container-fluid><div class=row style=\"width: 100%; margin-left: 0px; margin-top: 0px\"><div ng-if=vm.proximidades class=\"neighborhood-content col-sm\" style=\"width: calc(50% - 21px); min-width: calc(50% - 21px)\"><div><ol class=\"breadcrumb text-lowcase bg-white\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a href=/ itemprop=item><span itemprop=name>Início</span><meta itemprop=position content=1></a></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a ng-href=\"{{vm.config_wl.isArbo ? \'https://www.arboimoveis.com/regioes-atendidas/\' : \'/imoveis/\'}}{{vm.urlSearch}}\" itemprop=item><span itemprop=name>{{vm.proximidades.brr_cidade}}, {{ vm.proximidades.brr_estado }}</span><meta itemprop=position content=2></a></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a ng-href=\"/bairros/{{ vm.urlPath }}\" itemprop=item><span itemprop=name>{{vm.proximidades.brr_nome}}</span><meta itemprop=position content=3></a></li></ol></div><h1 class=\"title d-flex flex-column\"><span>Como é morar em {{ vm.proximidades.brr_nome }}</span> <span class=subtitle>{{ vm.proximidades.brr_cidade }}, {{ vm.proximidades.brr_estado }}</span></h1><div ng-if=vm.proximidades ng-show=vm.proximidades.brr_configs><div><div id=descriptions ng-class=\"{\'readmore-description\': !vm.readMore, \'readlite-description\': vm.readMore}\"><p class=description itemprop=description>{{ vm.proximidades.brr_descricao }}</p></div><span id=btn-read-more class=btn-read-more ng-click=vm.readMoreFunc() aria-label=\"Ver Mais\">Ver {{ !vm.readMore ? \'mais\' : \'menos\' }}</span></div><div class=btns-action><a class=btn target=_blank ng-href=\"{{ \'/imoveis/\'+ vm.tipovar + vm.proximidades.brr_slug }}\">Ver imóveis nesse bairro</a></div><div class=\"locations text-padding-right\" ng-if=\"vm.proximidades.brr_configs.bus_station.length || vm.proximidades.brr_configs.train_station.length || vm.proximidades.brr_configs.subway_station.length\"><div ng-repeat=\"place in vm.myPlaces\" ng-if=place.places.length><div class=section-container><h2 class=\"title d-flex flex-lg-row flex-lg-row align-items-center\"><span class=\"rounded-circle mr-2\"><i class=\"fas fa-{{place.icon}}\"></i> </span>{{place.name}}</h2><p class=ml-proximidades>{{place.desc}}</p></div><p class=\"search-new-imvs ml-proximidades\">Buscar imóveis perto de:</p><ul ng-repeat=\"_place in place.places\" class=\"subtitle-container pl-0\"><li class=ml-proximidades><a class=bairro ng-href={{vm.formatPlace(_place.name)}}>{{_place.name}}</a></li></ul></div></div><section class=carousel-container ng-if=vm.proximidades.superPadariaFarm.length><carousel-places navegator=true icon=\"fa fa-shopping-basket\" title-carousel=\"Supermercados, padarias e farmácias\" places=vm.proximidades.superPadariaFarm position=vm.proximidades.brr_location ng-if=vm.proximidades.superPadariaFarm.length></carousel-places></section><section class=carousel-container ng-if=vm.proximidades.barCafeRestaurant><carousel-places navegator=true icon=\"fa fa-utensils-alt\" title-carousel=\"Bares e restaurantes\" places=vm.proximidades.barCafeRestaurant ng-if=vm.proximidades.barCafeRestaurant.length position=vm.proximidades.brr_location></carousel-places></section><section class=carousel-container ng-if=vm.proximidades.oQueFazer><carousel-places navegator=true icon=../../assets/images/novosite/bairro-happy-face.png title-carousel=\"O que fazer em {{ vm.proximidades.brr_nome }}?\" places=vm.proximidades.oQueFazer ng-if=vm.proximidades.oQueFazer.length position=vm.proximidades.brr_location></carousel-places></section></div><div class=no-neighborhood ng-if=!vm.proximidades.brr_configs><h2 class=description-no-neighborhood>Ainda não temos informações sobre o bairro, mas queremos te ajudar a tomar a melhor decisão sobre onde morar.</h2><div class=btns-action><button class=btn ng-click=vm.openModalMoreInfo()>Quero mais informações</button></div></div><section class=carousel-container ng-if=vm.config_wl.isArbo><carousel-imovel navegator=true title-carousel=\"Veja imóveis recentes em {{ vm.proximidades.brr_nome }}\" properties=vm.owlProperties imoveis=vm.proximidades.imoveis ng-if=vm.proximidades.imoveis.length></carousel-imovel></section><div class=section-container ng-if=vm.proximidades.tags.length><h2 class=title style=\"font-weight: bold; font-size: 20px; color: #333333\">Temos mais imóveis próximos ao bairro</h2><ul id=imoveis-proximos class=readmore-links ng-class=\"{\'readmore-description\': !vm.readMoreImv, \'readlite-description\': vm.readMoreImv}\"><li class=info ng-repeat=\"u in vm.proximidades.tags\"><a target=_blank class=bairro ng-href=\"{{ u.url }}\">{{ u.label }}.</a></li></ul><span class=btn-read-more ng-click=vm.readMoreImoveisFunc() aria-label=\"Ver Mais\">Ver {{ !vm.readMoreImv ? \'mais\' : \'menos\' }}</span></div><div class=section-container ng-if=vm.proximidades.proxs><h2 class=title style=\"font-weight: bold; font-size: 20px; color: #333333\">Bairros próximos</h2><p class=info><a ng-href=\"{{ \'/bairros/\' + b.brr_slug }}\" target=_blank class=\"result bairro\" ng-repeat=\"b in vm.proximidades.proxs\">{{ b.brr_nome }},&nbsp;</a> <span id=more-region-string>{{ vm.moreRegion }}</span></p></div></div><div ng-show=vm.mapa class=\"map-wrapper col-sm\"><div class=map id=map-homepage search-map></div></div><div id=container-btn-mobile class=\"btn-fixed d-flex d-lg-none justify-content-start z-index-max\"><button class=\"btn button button-toogle btn-default col-8 mapa\" ng-click=\"vm.search.toggle(\'listaMobile\')\" ng-class=\"{\'d-none\': !vm.search.mapa}\"><i class=\"fal fa-bars\"></i>&nbsp; Ver conteúdo</button> <button class=\"btn button button-toogle btn-default col-8\" ng-click=\"vm.search.toggle(\'mapaMobile\')\" ng-class=\"{\'d-none\': vm.search.mapa}\"><i class=\"fas fa-map-marker-alt\"></i>&nbsp; Ver no mapa</button></div></div></div>");
$templateCache.put("app/conheca/conhecaImob.html","<main id=conheca class=conheca-imob ng-if=\"(\'main.conheca-imob\' | includedByState)\"><section class=\"main-img d-flex justify-content-between align-items-center\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/banner-imob.png)\'}\"><div class=texts><h3 class=\"title d-none d-md-block\">Arbo para: <span>Imobiliárias</span></h3><h3 class=\"title d-block d-md-none\">Arbo para<br><span>Imobiliárias</span></h3></div><div class=\"vantagens d-none d-md-flex flex-column\"><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-globe\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Equipe de TI dedicada</strong> promovendo atualizações<br>constantes no sistema e no portal</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-bullhorn\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Marketing especializado</strong> em mídias sociais, Google e<br>ferramentas de retargeting e remarketing</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-headphones\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Central de atendimento</strong>, com serviço de geração,<br>coleta e distribuição de Leads</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-chart-bar\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Customer Success + B.I.</strong> com suporte para você e seu<br>cliente e comprometimento com resultados</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-id-card\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Gestão</strong> de catálogos de imóveis, corretores, Leads e<br>documentos através de CRM e BigData</p></div></div></section><section class=\"video-container d-flex flex-column align-items-center\"><div class=\"vantagens d-flex d-md-none flex-column mx-3 mb-4\"><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-globe\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Equipe de TI dedicada</strong> promovendo atualizações constantes no sistema e no portal</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-bullhorn\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Marketing especializado</strong> em mídias sociais, Google e ferramentas de retargeting e remarketing</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-headphones\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Central de atendimento</strong>, com serviço de geração, coleta e distribuição de Leads</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-chart-bar\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Customer Success + B.I.</strong> com suporte para você e seu cliente e comprometimento com resultados</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-id-card\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Gestão</strong> de catálogos de imóveis, corretores, Leads e documentos através de CRM e BigData</p></div></div><div class=\"d-flex w-100\"><div class=\"d-none d-md-block col-1\"></div><h4 class=\"title padding-title\">Reinventando o<br>mercado imobiliário.</h4></div><div class=\"d-flex flex-wrap justify-content-center\"><div class=\"content col-12 col-md-5\"><p class=text>Nós revelamos os problemas que você não sabia que existiam, e os solucionamos de maneira simples e inteligente. Re-criamos um novo desenho para o negócio. Na Arbo, clientes, corretores e imobiliárias têm seus papéis redefinidos para compartilhar uma experiência perfeita.</p></div><div class=\"content col-12 col-md-5\"><p class=text>Será que o mercado imobiliário tradicional atende as necessidades e chateações dos clientes no cenário atual? Seja para proprietários, locatários ou compradores, o que mudou nos processos do mercado? Será que o velho formato ainda funciona? Qual a diferença da sua imobiliária para qualquer outra?</p></div></div><div class=\"video d-flex justify-content-center align-items-center col-12 col-md-10\" ng-class=\"{\'no-bg\': vm.playVideo}\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/video-background.png)\'}\"><video controls autoplay ng-if=vm.playVideo class=h-100 controlslist=nodownload><source media=\"(min-width: 787px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/drlcss1-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4><source media=\"(max-width: 786px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/hysdc81-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4></video><div ng-if=!vm.playVideo><button class=\"play d-flex align-items-center justify-content-center mx-auto c-pointer\" ng-click=\"vm.playVideo = true\"><i class=\"fas fa-play fa-2x\"></i></button><h4 class=\"title padding-title col-10 offset-1 text-center\">Clique aqui e entenda o que nos incomoda.</h4></div></div><div class=\"d-flex w-100 mt-5\"><div class=\"d-none d-md-block col-1\"></div><h4 class=\"title padding-title\">A Arbo é o futuro<br>do mercado imobiliário.</h4></div><div class=\"d-flex flex-wrap justify-content-center\"><div class=\"content col-12 col-md-5\"><p class=text>Nós acreditamos que a tecnologia pode mudar o mundo. E assim como Uber, Nubank, Netflix e tantas outras, revelamos problemas que as pessoas não sabiam que existiam. Agora, com a Arbo, é inimaginável qualquer transação imobiliária com métodos tradicionais. Descontruímos a maneira antiga e fazemos tudo muito mais fácil. E você? Acredita que o mundo vai continuar igual? O que a sua empresa está fazendo diferente da concorrência?</p></div><div class=\"content col-12 col-md-5\"><p class=text>Fazendo parte da Arbo você elimina os processos imobiliários desconexos e passa a focar no que realmente importa: resultados comerciais e a excelência na jornada do seu cliente. Todos os processos burocráticos, da angariação ao fechamento do contrato, passam a ser 100% online e automatizados. A Arbo expõe a problemática vivenciada pela ineficiência diária do mercado imobiliário, e resolve com inovação, tecnologia, expertise de marketing e uma excelente experiência.</p></div></div></section><section id=cadastro-rapido class=\"cadastro-rapido gradient d-flex justify-content-center\"><div class=\"col-12 col-md-11 px-md-4\"><div id=cadastro-rapido-carousel class=\"carousel slide px-md-3\" data-ride=carousel><div class=wrapper><div class=\"d-flex flex-wrap\"><div class=\"col-12 col-md-6\"><div class=\"trace px-md-1\">_</div><h4 class=\"trace-title mb-5 px-md-1\">Como fazer parte.</h4><p class=\"text px-md-1\">Saiba como estamos reinventando o mercado imobiliário, e como fazer parte dessa mudança! Preencha os dados e agende um contato com nosso representante de Customer Success.</p></div><div class=\"form-rapido-wrapper d-flex justify-content-center justify-content-md-end col-12 col-md-6\"><form id=form-rapido class=\"form-rapido d-flex flex-wrap col-12 col-md-8\" ng-submit=vm.sendConheca($event)><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Nome ng-model=vm.form_contato.name required></div><div class=\"form-group col-3\"><input type=text class=form-control placeholder=UF ng-model=vm.form_contato.uf required></div><div class=\"col-9 pr-0\" style=\"padding-left: 10px\"><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Cidade ng-model=vm.form_contato.city required></div></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Telefone ng-model=vm.form_contato.tel required></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=E-mail ng-model=vm.form_contato.email required></div><button class=\"btn btn-default button col-12\">Agendar</button></form></div></div></div></div></div></section><section class=\"cadastrar d-flex flex-column justify-content-center align-items-md-center\"><div class=\"image d-flex flex-column justify-content-center col-12 col-md-12\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/cadastrar-imob.png)\'}\"><div class=\"mask d-flex flex-column justify-content-center col-12 px-3\"><h3 class=\"title px-3\">Quer vender ou<br>alugar seus imóveis?</h3><div class=\"cad-btn px-3\"><a href=#cadastro-rapido><button class=\"btn button btn-default\">Cadastrar minha imobiliária</button></a></div></div></div></section><div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=modal-body><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><div class=\"embed-responsive embed-responsive-16by9\"><video width=640 height=480 controls><source src=\"https://www.youtube.com/watch?v=DvKmmkUwo4Q\" type=video/mp4></video></div></div></div></div></div></main>");
$templateCache.put("app/conheca/conhecaIncorp.html","<main id=conheca class=conheca-incorp ng-if=\"(\'main.conheca-incorp\' | includedByState)\"><section class=\"main-img d-flex justify-content-between align-items-center\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/banner-incorp.png)\'}\"><div class=texts><h3 class=\"title d-none d-md-block\">Arbo para: <span>Incorporadoras</span></h3><h3 class=\"title d-block d-md-none\">Arbo para<br><span>Incorporadoras</span></h3></div><div class=\"vantagens d-none d-md-flex flex-column\"><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-globe\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Equipe de TI dedicada</strong> promovendo atualizações<br>constantes no sistema e no portal</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-bullhorn\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Marketing especializado</strong> em mídias sociais, Google e<br>ferramentas de retargeting e remarketing</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-headphones\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Central de atendimento</strong>, com serviço de geração,<br>coleta e distribuição de Leads</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-chart-bar\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Customer Success + B.I.</strong> com suporte para você e seu<br>cliente e comprometimento com resultados</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-3\"><i class=\"fas fa-id-card\"></i></div><p class=\"mb-0 px-3 py-3\"><strong>Gestão</strong> de catálogos de imóveis, corretores, Leads e<br>documentos através de CRM e BigData</p></div></div></section><section class=\"video-container d-flex flex-column align-items-center\"><div class=\"vantagens d-flex d-md-none flex-column mx-3 mb-4\"><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-globe\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Equipe de TI dedicada</strong> promovendo atualizações constantes no sistema e no portal</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-bullhorn\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Marketing especializado</strong> em mídias sociais, Google e ferramentas de retargeting e remarketing</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-headphones\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Central de atendimento</strong>, com serviço de geração, coleta e distribuição de Leads</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-chart-bar\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Customer Success + B.I.</strong> com suporte para você e seu cliente e comprometimento com resultados</p></div><div class=\"d-flex vantagem mt-2\"><div class=\"vantagem-icon d-flex justify-content-center align-items-center px-3 py-2\"><i class=\"fas fa-id-card\"></i></div><p class=\"mb-0 pr-3 py-2\"><strong>Gestão</strong> de catálogos de imóveis, corretores, Leads e documentos através de CRM e BigData</p></div></div><div class=\"d-flex w-100\"><div class=\"d-none d-md-block col-1\"></div><h4 class=\"title padding-title\">Reinventando o<br>mercado imobiliário.</h4></div><div class=\"d-flex flex-wrap justify-content-center\"><div class=\"content col-12 col-md-5\"><p class=text>Nós revelamos os problemas que você não sabia que existiam, e os solucionamos de maneira simples e inteligente. Re-criamos um novo desenho para o negócio. Na Arbo, clientes, corretores e imobiliárias têm seus papéis redefinidos para compartilhar uma experiência perfeita.</p></div><div class=\"content col-12 col-md-5\"><p class=text>Será que o mercado imobiliário tradicional atende as necessidades e chateações dos clientes no cenário atual? Seja para proprietários, locatários ou compradores, o que mudou nos processos do mercado? Será que o velho formato ainda funciona? Qual a diferença da sua incorporadora para qualquer outra?</p></div></div><div class=\"video d-flex justify-content-center align-items-center col-12 col-md-10\" ng-class=\"{\'no-bg\': vm.playVideo}\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/video-background.png)\'}\"><video controls autoplay ng-if=vm.playVideo class=h-100 controlslist=nodownload><source media=\"(min-width: 787px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/drlcss1-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4><source media=\"(max-width: 786px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/hysdc81-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4></video><div ng-if=!vm.playVideo><button class=\"play d-flex align-items-center justify-content-center mx-auto c-pointer\" ng-click=\"vm.playVideo = true\"><i class=\"fas fa-play fa-2x\"></i></button><h4 class=\"title padding-title col-10 offset-1 text-center\">Clique aqui e entenda o que nos incomoda.</h4></div></div><div class=\"d-flex flex-wrap justify-content-center mt-5\"><div class=\"content col-12 col-md-5\"><h4 class=title>A Arbo é o futuro<br>do mercado imobiliário.</h4><p class=text>Nós acreditamos que a tecnologia pode mudar o mundo. E assim como Uber, Nubank, Netflix e tantas outras, revelamos problemas que as pessoas não sabiam que existiam. Agora, com a Arbo, é inimaginável qualquer transação imobiliária com métodos tradicionais. Descontruímos a maneira antiga e fazemos tudo muito mais fácil. E você? Acredita que o mundo vai continuar igual? O que a sua empresa está fazendo diferente da concorrência?</p></div><div class=\"content col-12 col-md-5\"><h4 class=title>Por que fazer<br>parte da Arbo?</h4><p class=text>Fazendo parte da Arbo você elimina os processos imobiliários desconexos e passa a focar no que realmente importa: resultados comerciais e a excelência na jornada do seu cliente. Todos os processos burocráticos, da angariação ao fechamento do contrato, passam a ser 100% online e automatizados. A Arbo expõe a problemática vivenciada pela ineficiência diária do mercado imobiliário, e resolve com inovação, tecnologia, expertise de marketing e uma excelente experiência.</p></div></div></section><section id=cadastro-rapido class=\"cadastro-rapido gradient d-flex justify-content-center\"><div class=\"col-12 col-md-11 px-md-4\"><div id=cadastro-rapido-carousel class=\"carousel slide px-md-3\" data-ride=carousel><div class=wrapper><div class=\"d-flex flex-wrap\"><div class=\"col-12 col-md-6\"><div class=\"trace px-md-1\">_</div><h4 class=\"trace-title mb-5 px-md-1\">Quer se cadastrar?<br>Entre em contato conosco!</h4><p class=text>Saiba como estamos reinventando o mercado imobiliário, e como fazer parte dessa mudança! Preencha os dados e agende um contato com nosso representante de Customer Success.</p></div><div class=\"form-rapido-wrapper d-flex justify-content-center justify-content-md-end col-12 col-md-6\"><form id=form-rapido class=\"form-rapido d-flex flex-wrap col-12 col-md-8\" ng-submit=vm.sendConheca($event)><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Nome ng-model=vm.form_contato.name required></div><div class=\"form-group col-3\"><input type=text class=form-control placeholder=UF ng-model=vm.form_contato.uf required></div><div class=\"col-9 pr-0\" style=\"padding-left: 10px\"><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Cidade ng-model=vm.form_contato.city required></div></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Telefone ng-model=vm.form_contato.tel required></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=E-mail ng-model=vm.form_contato.email required></div><button class=\"btn btn-default button col-12\">Agendar</button></form></div></div></div></div></div></section><section class=\"cadastrar d-flex flex-column justify-content-center align-items-center\"><div class=\"image d-flex flex-column justify-content-center col-12 col-md-12\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/cadastrar-incorp.png)\'}\"><div class=\"mask d-flex flex-column justify-content-center col-12 px-3\"><h3 class=\"title px-3\">Quer saber mais?</h3><div class=\"cad-btn px-3\"><a href=#cadastro-rapido><button class=\"btn button btn-default\">Entrar em contato</button></a></div></div></div></section><div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=modal-body><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><div class=\"embed-responsive embed-responsive-16by9\"><video width=640 height=480 controls><source src=\"https://www.youtube.com/watch?v=DvKmmkUwo4Q\" type=video/mp4></video></div></div></div></div></div></main>");
$templateCache.put("app/conheca/conhecaProp.html","<main id=conheca class=conheca-prop ng-if=\"(\'main.conheca-prop\' | includedByState)\"><section class=\"main-img d-flex flex-column justify-content-center\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/banner-prop.png)\'}\"><div class=texts><h3 class=\"title d-none d-md-block\">Arbo para: <span>Proprietários</span></h3><h3 class=\"title d-block d-md-none\">Arbo para<br><span>Proprietários</span></h3></div></section><section class=\"video-container d-flex flex-column align-items-center\"><div class=\"d-flex w-100\"><div class=\"d-none d-md-block col-1\"></div><h4 class=\"title padding-title\">Reinventando o<br>mercado imobiliário.</h4></div><div class=\"d-flex flex-wrap justify-content-center\"><div class=\"content col-12 col-md-5\"><p class=text>Nós revelamos os problemas que você não sabia que existiam, e os solucionamos de maneira simples e inteligente. Re-criamos um novo desenho para o negócio. Na Arbo, clientes, corretores e imobiliárias têm seus papéis redefinidos para compartilhar uma experiência perfeita.</p></div><div class=\"content col-12 col-md-5\"><p class=text>Será que o mercado imobiliário tradicional atende as necessidades e chateações dos clientes no cenário atual? Seja para proprietários, locatários ou compradores, o que mudou nos processos do mercado? Será que o velho formato ainda funciona? Qual a diferença da sua imobiliária para qualquer outra?</p></div></div><div class=\"video d-flex align-items-center col-12 col-md-10\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/video-background.png)\'}\"></div><div class=\"d-flex flex-wrap justify-content-center mt-5\"><div class=\"content col-12 col-md-5\"><h4 class=title>A Arbo é o futuro<br>do mercado imobiliário.</h4><p class=text>Nós acreditamos que a tecnologia pode mudar o mundo. E assim como Uber, Nubank, Netflix e tantas outras, revelamos problemas que as pessoas não sabiam que existiam. Agora, com a Arbo, é inimaginável qualquer transação imobiliária com métodos tradicionais. Descontruímos a maneira antiga e fazemos tudo muito mais fácil. E você? Acredita que o mundo vai continuar igual? O que a sua empresa está fazendo diferente da concorrência?</p></div><div class=\"content col-12 col-md-5\"><h4 class=title>Por que fazer<br>parte da Arbo?</h4><p class=text>Fazendo parte da Arbo você elimina os processos imobiliários desconexos e passa a focar no que realmente importa: resultados comerciais e a excelência na jornada do seu cliente. Todos os processos burocráticos, da angariação ao fechamento do contrato, passam a ser 100% online e automatizados. A Arbo expõe a problemática vivenciada pela ineficiência diária do mercado imobiliário, e resolve com inovação, tecnologia, expertise de marketing e uma excelente experiência.</p></div></div><div class=\"vantagens d-flex flex-wrap col-11 col-md-11 px-md-5\"><div class=\"w-100 pb-4 px-md-2\"><div class=\"trace px-md-1\">_</div><h4 class=\"trace-title px-md-1\">Vantagens da Arbo</h4><p class=\"col-12 col-md-9 px-0 px-md-1\">Veja alguns dos itens que nos faz diferente de tudo que você conhece no mercado imobiliário - no melhor sentido que a palavra diferente pode ter.</p></div><div class=\"vantagem d-flex col-12 col-md-4 mb-3 mb-md-5\"><div class=\"icon d-flex\"><i class=\"fal fa-globe\"></i></div><div><h5 class=\"title mb-3\">Site</h5><p>Uma equipe de TI está disponível para manter o melhor site de imóveis do país.</p></div></div><div class=\"vantagem d-flex col-12 col-md-4 mb-3 mb-md-5\"><div class=\"icon d-flex\"><i class=\"fal fa-window-maximize\"></i></div><div><h5 class=\"title mb-3\">Gestão de Leads + I.A.</h5><p>Central de atendimento, com serviço de geração, coleta e distribuição de leads.</p></div></div><div class=\"vantagem d-flex col-12 col-md-4 mb-3 mb-md-5\"><div class=\"icon d-flex\"><i class=\"fal fa-id-card\"></i></div><div><h5 class=\"title mb-3\">CRM + BIGDATA</h5><p>Gestao de catálogos de imóveis, corretores e leads, possui integração automática com site.</p></div></div><div class=\"vantagem d-flex col-12 col-md-4\"><div class=\"icon d-flex\"><i class=\"fal fa-headphones\"></i></div><div><h5 class=\"title mb-3\">Marketing</h5><p>Equipe especializada em mídias sociais, Google e retargeting fazendo sempre o melhor por você.</p></div></div><div class=\"vantagem d-flex col-12 col-md-4\"><div class=\"icon d-flex\"><i class=\"fal fa-id-card\"></i></div><div><h5 class=\"title mb-3\">CUSTOMER SUCCESS + B.I.</h5><p>Suporte para você e para o seu cliente. Equipe de atendimento para dúvidas e feedbacks.</p></div></div><div class=\"vantagem d-flex col-12 col-md-4\"><div class=\"icon d-flex\"><i class=\"fal fa-shield-check\"></i></div><div><h5 class=\"title mb-3\">E muito mais...</h5><p>Agende um contato e confira!</p></div></div></div></section><section id=cadastro-rapido class=\"cadastro-rapido gradient d-flex justify-content-center\"><div class=\"col-12 col-md-11 px-md-4\"><div id=cadastro-rapido-carousel class=\"carousel slide px-md-3\" data-ride=carousel><div class=wrapper><div class=\"d-flex flex-wrap\"><div class=\"col-12 col-md-6\"><div class=\"trace px-md-1\">_</div><h4 class=\"trace-title mb-5 px-md-1\">Quer se cadastrar?<br>Entre em contato conosco!</h4><p class=text>Saiba como estamos reinventando o mercado imobiliário, e como fazer parte dessa mudança! Preencha os dados e agende um contato com nosso representante de Customer Success.</p></div><div class=\"form-rapido-wrapper d-flex justify-content-center justify-content-md-end col-12 col-md-6\"><form id=form-rapido class=\"form-rapido d-flex flex-wrap col-12 col-md-8\" ng-submit=vm.sendConheca($event)><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Nome ng-model=vm.form_contato.name required></div><div class=\"form-group col-3\"><input type=text class=form-control placeholder=UF ng-model=vm.form_contato.uf required></div><div class=\"col-9 pr-0\" style=\"padding-left: 10px\"><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Cidade ng-model=vm.form_contato.city required></div></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=Telefone ng-model=vm.form_contato.tel required></div><div class=\"form-group col-12\"><input type=text class=form-control placeholder=E-mail ng-model=vm.form_contato.email required></div><button class=\"btn btn-default button col-12\">Agendar</button></form></div></div></div></div></div></section><section class=\"cadastrar d-flex flex-column justify-content-center align-items-center\"><div class=\"image d-flex flex-column justify-content-center col-12 col-md-12\" ng-style=\"{\'background-image\': \'url(./assets/images/conheca/cadastrar-prop.png)\'}\"><div class=\"mask d-flex flex-column justify-content-center col-12 px-3\"><h3 class=\"title px-3\">Quer saber mais?</h3><div class=\"cad-btn px-3\"><a href=#cadastro-rapido><button class=\"btn button btn-default\">Entrar em contato</button></a></div></div></div></section><div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=exampleModalLabel aria-hidden=true><div class=modal-dialog role=document><div class=modal-content><div class=modal-body><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><div class=\"embed-responsive embed-responsive-16by9\"><video width=640 height=480 controls><source src=\"https://www.youtube.com/watch?v=DvKmmkUwo4Q\" type=video/mp4></video></div></div></div></div></div></main>");
$templateCache.put("app/conheca/quemSomos.html","<div class=\"h-100 margin-fluid\"><div class=\"form title mx-auto px-4\" ng-if=\"vm.imob.id == 71\" ng-bind-html=vm.trustAsHtml(vm.imb_rich_text)></div><div class=\"form title mx-auto px-4\" ng-if=\"vm.imob.id != 71\"><p>Quem somos</p><br><div class=texto ng-bind-html=vm.trustAsHtml(vm.imb_rich_text)></div></div></div>");
$templateCache.put("app/conheca/tecnologia.html","<section id=tecnologia class=margin-fluid><div class=titulo-pag><p ng-if=!vm.imob.isArbo class=\"mb-3 titulo-imob\">A {{ vm.imob.nome.toLowerCase() }} usa tecnologia Arbo. Conheça:</p><p ng-if=vm.imob.isArbo>Arbo.</p><p ng-if=vm.imob.isArbo>All in One</p></div><div class=apresentacao><p class=titulo>Rompendo com o tradicional</p><p class=topico>Acreditamos que o mercado imobiliário precisa de uma ruptura, e fazemos isso através de duas frentes: a tecnologia e as pessoas.</p><div class=corpo><p>Com o conceito ALL-IN-ONE, nosso objetivo é simplicar as relações do mercado imobiliário, criando soluções simples, tecnológicas e seguras.</p><p>Na Arbo e na {{ vm.imob.nome.toLowerCase() }}, integramos todos os processos imobiliários redesenhando cada etapa. Oferecemos serviços para imobiliárias, corretores, compradores, vendedores, locatários e incorporadoras. Temos como missão aprimorar todos os fluxos do mercado imobiliário.</p></div></div><div class=\"desenvolvimento-1 gradient-content\"><div class=corpo><p class=titulo>Por que All-In-One?</p><p class=descricao>Somos all-in-one porque olhamos para o mercado em sua totalidade. Entendemos e redesenhamos o serviço de ponta a ponta, de pessoa a pessoa, e oferecemos uma solução para cada umas dessas partes.</p></div></div><div class=desenvolvimento-2><div class=bloco-dos-icons><div class=\"icones head\"><div class=icone><i class=\"fal fa-desktop-alt\"></i><p class=titulo>Tecnologia</p></div><div class=icone><i class=\"fal fa-bullhorn\"></i><p class=titulo>Marketing</p></div><div class=\"icone cust-suc\"><i class=\"fal fa-user-chart\"></i><p class=titulo>Custumer Success</p></div><div class=icone><i class=\"fal fa-phone-office\"></i><p class=titulo>Atendimento</p></div><div class=icone><i class=\"fal fa-analytics\"></i><p class=titulo>BI</p></div></div><div class=icones><div class=icone><p class=descricao>Processos automatizados e simplificados</p></div><div class=icone><p class=descricao>Equipe exclusiva especializada</p></div><div class=\"icone cust-suc\"><p class=descricao>Foco no cliente e no sucesso da jornada</p></div><div class=icone><p class=descricao>Atendimento de qualidade, personalizado.</p></div><div class=icone><p class=descricao>Sistema de controle, auditoria e qualidade</p></div></div></div><div id=icones class=\"bloco-dos-icons-mobile carousel slide\" data-ride=carousel><div class=\"carousel-inner icones\"><div class=\"icone carousel-item active\"><i class=\"fal fa-desktop-alt\"></i><p class=titulo>Tecnologia</p><p class=descricao>Processos automatizados e simplificados</p></div><div class=\"icone carousel-item\"><i class=\"fal fa-bullhorn\"></i><p class=titulo>Marketing</p><p class=descricao>Equipe exclusiva especializada</p></div><div class=\"icone cust-suc carousel-item\"><i class=\"fal fa-user-chart\"></i><p class=titulo>Custumer Success</p><p class=descricao>Foco no cliente e no sucesso da jornada</p></div><div class=\"icone carousel-item\"><i class=\"fal fa-phone-office\"></i><p class=titulo>Atendimento</p><p class=descricao>Atendimento de qualidade, personalizado</p></div><div class=\"icone carousel-item\"><i class=\"fal fa-analytics\"></i><p class=titulo>BI</p><p class=descricao>Sistema de controle, auditoria e qualidade</p></div></div><a class=carousel-control-prev href=#icones data-slide=prev><i class=\"fas fa-chevron-left\"></i> </a><a class=carousel-control-next href=#icones data-slide=next><i class=\"fas fa-chevron-right\"></i></a></div><div class=video><div class=row><div ng-if=vm.imob.isArbo class=\"col-md-6 col-lg-6 col-sm-12\"><div class=titulo><span>VEJA MAIS SOBRE COMO PENSAMOS</span></div><video controls class=apresentacao-video controlslist=nodownload><source media=\"(min-width: 787px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/drlcss1-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4><source media=\"(max-width: 786px)\" src=https://static.arboimoveis.com.br/white-label-assets/arbo/hysdc81-b5769b3bd8bf6cca43c6fbaefea6849d.mp4 type=video/mp4></video></div><div class=\"col-sm-12 texto-desenvolvimento col-md-6 col-lg-6\" ng-if=vm.imob.isArbo><span>Aqui tecnologia e capital humano trabalham juntos. Reunimos as melhores pessoas para trabalhar com as melhores tecnologias e transformar de maneira radical os fluxos desse mercado, a fim de simplificar, agilizar e facilitar os processos.</span><p>A Arbo vira a chave tradicional da burocracia e dos processos demorados, e entende as pessoas e o sucesso na jornada como nossa motivação inicial.</p></div><div ng-if=!vm.imob.isArbo class=\"col-sm-12 texto-desenvolvimento1 col-md-12 col-lg-12\"><span>Aqui tecnologia e capital humano trabalham juntos. Reunimos as melhores pessoas para trabalhar com as melhores tecnologias e transformar de maneira radical os fluxos do mercado imobiliário tradicional, a fim de simplificar, agilizar e facilitar os processos.</span><p>Viramos a chave de um mercado tradicional, burocracia e de processos demorados, e entende as pessoas e o sucesso na jornada como nossa motivação inicial.</p></div></div></div></div><div class=desenvolvimento-3 ng-if=vm.imob.isArbo><div class=corpo><span class=inicio>Novos mercados exigem novos processos</span><div class=descricao><p>Muito além de vender ou alugar um imóvel. Criamos uma experiência de negócio completamente diferente do mercado imobiliário tradicional.</p><p>Esse é o nosso funil all-in-one:</p></div><div id=funil class=\"funil-arbo carousel slide\" data-ride=carousel><div class=\"carousel-inner etapas\"><div class=\"etapa carousel-item active\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil 1.png\" alt=\"Captação Online\"><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>1. Captação Online </span><span class=descricao>Cadastro de imóvel online, proposta online, campanhas de marketing especializadas, entre outros serviços. Dessa forma, todos os momentos de captação e primeiro contato com o cliente é feita online, sem vincular nenhum deslocamento inicial geográfico do cliente em potencial. Os anúncios e nossas plataformas alcançam o interessado onde ele estiver.</span></div></div></div><div class=\"etapa carousel-item\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil 2.png\" alt=\"Atendimento Automatizado\"><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>2. Atendimento Automatizado </span><span class=descricao>Atendimento automatizado e personalizado. Dessa forma, nenhum cliente fica sem resposta ou espera mais de 3h para ser atendido. Levamos muito a sério nossa taxa de retorno.</span></div></div></div><div class=\"etapa carousel-item\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil 3.png\" alt=Serviços><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>3. Serviços </span><span class=descricao>Oferecemos serviço de CRM, site, vínculo com a plataforma Arbo Imóveis, EAD, gestão de leads, central de atendimento e marketing e anúncios digitais. Todos essas frentes contam com profissionais capacitados e especialistas, e foram pensadas e projetadas para o mercado imobiliário e as necessidades particulares desse nicho.</span></div></div></div><div class=\"etapa carousel-item\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil 4.png\" alt=Match><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>4. Match </span><span class=descricao>Cada serviço é pensado exatamente para dar MATCH com uma necessidade do negócio imobiliário, assim como, cada anúncio ou direcionamento de imóvel que fazemos é pensado para o MATCH com o cliente ideal. Todos os nossos serviços passam por uma curadoria acirrada, com o objetivo de entregar a excelência para todos os envolvidos.</span></div></div></div><div class=\"etapa carousel-item\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil 5.png\" alt=Facilidades><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>5. Facilidades </span><span class=descricao>A Arbo põe por terra a ideia de que o mercado imobiliário tem que ser burocrático. Colocamos no centro do processo a tecnologia e as pessoas, e, a partir disso, repensamos todas as etapas da jornada de compra, venda, locação, corretagem, e tantas outras. Facilitamos para o cliente final e para todos os outros envolvidos, desde o gestores das imobiliárias e incorporadoras, passando pelos corretores, pelo atendimento e pelo pessoal administrativo.</span></div></div></div><div class=\"etapa carousel-item\"><div class=row><img class=\"col-12 col-sm-6 p-0\" src=\"../assets/images/novosite/Funil B.I.png\" alt=ALL-IN-ONE><div class=\"col-12 col-sm-6 p-0 texto\"><span class=titulo>Durante todo o funil. Três serviços acompanham o ALL-IN-ONE ARBO. </span><span class=subtitulo>B.I.</span> <span class=descricao-bi>Business Intelligence: Com a tecnologia sempre em mente, oferecemos sistemas de controle, auditoria e qualidade em todos os momentos do serviço. Desde a captação dos clientes até a manutenção das nossas plataformas temos métricas e serviços de inteligência apurados fazendo o apoio. </span><span class=subtitulo>Customer Success</span> <span class=descricao-bi>Custumer Success: Apoio e qualidade na jornada do cliente. Oferecemos suporte e consultoria durante o uso de todas as nossas ferramentas, com o objetivo de valorizar e favorecer e facilitar a trajetória do cliente, oferecendo sucesso contínuo. </span><span class=subtitulo>E.A.D</span> <span class=descricao-bi>Sistema de treinamento e ensino da plataforma. A partir do momento que um novo parceiro entre na Arbo é realizado um treinamento completo passando por todos os pontos que serão essenciais no dia-a-dia. Oferecendo suporte full para todos os momentos da jornada Arbo.</span></div></div></div></div><a class=carousel-control-prev href=#funil data-slide=prev><i class=\"fas fa-chevron-left\"></i> </a><a class=carousel-control-next href=#funil data-slide=next><i class=\"fas fa-chevron-right\"></i></a></div></div></div><div class=desenvolvimento-2><div class=comparativos><div class=expand-mobile><div class=\"titulo row\"><span class=\"col-5 col-sm-5 p-0\" style=text-align:right>MERCADO TRADICIONAL</span> <span class=\"col-2 col-sm-2 p-0\">X</span> <span class=\"col-5 col-sm-5 p-0\" style=text-align:left>ARBO ALL-IN-ONE + {{ vm.imob.nome }}</span></div><div class=\"versus row\"><div class=\"comp-tradi col-6 col-sm-6\"><span class=comp-titulo>Burocracia</span> <span class=comp-descricao>Papeladas, contratos físicos, autenticação, assinaturas, fiador, entre tantas outras travas que são muito comuns no nosso mercado.</span></div><div class=\"comp-arbo col-6 col-sm-6\"><span class=comp-titulo>Agilidade</span> <span class=comp-descricao>Com o nosso serviço, tudo fica online, digital e pode ser resolvido pelo celular.</span></div></div><div class=\"versus row\"><div class=\"comp-tradi col-6 col-sm-6\"><span class=comp-titulo>Falta de precisão</span> <span class=comp-descricao>O mercado tradicional não encontra o cliente. Ele espera o cliente vir até ele no leilão dos portais ou em anúncios esporádicos em outdoors e facebook.</span></div><div class=\"comp-arbo col-6 col-sm-6\"><span class=comp-titulo>Imóvel ideal para o cliente ideal</span> <span class=comp-descricao>Com a expertise Arbo, entregamos para a pessoa em potencial o imóvel perfeito, com marketing, remarketing e curadoria.</span></div></div><div class=\"versus row\"><div class=\"comp-tradi col-6 col-sm-6\"><span class=comp-titulo>Portal Imobiliário Tradicional</span> <span class=comp-descricao>A vitrine virtual dos imóveis nos portais dificulta o contato entre corretor e cliente porque o processo possui muitas variáveis</span></div><div class=\"comp-arbo col-6 col-sm-6\"><span class=comp-titulo>Portal Arbo</span> <span class=comp-descricao ng-if=vm.imob.isArbo>Na Arbo, o cliente demonstra interesse e o lead automaticamente já é encaminhado para o corretor </span><span class=comp-descricao ng-if=!vm.imob.isArbo>No Portal Arbo, o cliente tem facilidade de navegação e encontra o imóvel de forma fácil, com a facilidade da busca por mapa.</span></div></div><div class=\"versus row\" ng-if=vm.imob.isArbo><div class=\"comp-tradi col-6 col-sm-6\"><span class=comp-titulo>Corretor fazendo tarefas administrativas</span> <span class=comp-descricao>80% do tempo dos gestores e corretores do mercado tradicional é gasto com processos administrativos.</span></div><div class=\"comp-arbo col-6 col-sm-6\"><span class=comp-titulo>Corretor com tempo para negociar</span> <span class=comp-descricao>Com a tecnologia Arbo, quem faz tarefa administrativa é o sistema, o corretor fica livre para fazer aquilo que faz de melhor: negociar.</span></div></div><div class=\"versus row\"><div class=\"comp-tradi col-6 col-sm-6\"><span class=comp-titulo>Uma plataforma para cada função</span> <span class=comp-descricao ng-if=vm.imob.isArbo>Para se manter atualizada, uma empresa imobiliária precisa: conta em portais, um bom site, uma equipe de marketing para as redes sociais, uma plataforma de crm, uma central de atendimento, entre outras especificações. </span><span class=comp-descricao ng-if=!vm.imob.isArbo>Para se manter atualizada, uma empresa imobiliária precisa de diversas ferramentas para melhor atender seus clientes, o que muitas vezes acaba não acontecendo.</span></div><div class=\"comp-arbo col-6 col-sm-6\"><span class=comp-titulo>Arbo.</span> <span class=comp-descricao ng-if=vm.imob.isArbo>Aqui, oferecemos full-service, nossa plataforma engloba todos os serviços necessários e você tem autonomia para decidir no que quer ou não investir a mais </span><span class=comp-descricao ng-if=!vm.imob.isArbo>Aqui, oferecemos full-service, nossa plataforma engloba todos os serviços necessários, pensando no sucesso pleno de todos os envolvidos no processo.</span></div></div></div></div></div><div class=\"saber-mais row\" ng-if=vm.imob.isArbo><div class=\"col-lg-6 col-md-6 col-sm-12 title\"><span>Gostou? Quer saber mais? </span><br><p>Nos encontre:</p></div><div class=\"col-lg-6 col-md-6 col-sm-12 row sou\"><div class=\"col-lg-4 col-md-4 col-sm-12\"></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><a href=https://www.arboimoveis.com.br/paraimobiliarias/ target=_blank><div class=item><span>Sou Imobiliária</span></div></a></div><div class=\"col-lg-4 col-md-4 col-sm-12\"><a href=https://www.arboimoveis.com.br/paraimobiliarias/ target=_blank><div class=item><span>Sou Incorporadora</span></div></a></div></div></div><div class=saiba-mais-imobiliaria ng-if=!vm.imob.isArbo><div class=row><a href=http://arboimoveis.com/conheca/tecnologia><div class=button>Saiba mais</div></a></div></div></section>");
$templateCache.put("app/contact/contact.html","<section id=contact class=margin-fluid><div class=\"gradient-content d-sm-flex justify-content-center\" ng-class=\"{ wl: !vm.config_wl.isArbo }\"><div class=\"contact-header d-sm-flex justify-content-between align-items-center w-100\"><div class=d-flex><h1>Entre em contato<br>conosco.</h1></div></div></div><div class=\"middle-content row d-flex\"><div ng-if=vm.config_wl.isArbo ng-class=\"{ \'col-lg-4\': vm.config_wl.isArbo }\" class=select-content><h2>Encontre a imobiliária mais perto de você!</h2><form action=\"\" name=map><div class=contact-div-full><a ng-repeat=\"imb in vm.imbs\" ng-href=\"{{ vm.routeImbContact(imb) }}\" ng-class=\"{ active: vm.imb_selected.id === imb.id }\" class=\"row d-flex imob-content py-3\"><div class=\"desc-imob-content col row flex-nowrap\"><i class=\"fal fa-map-marker-check\"></i><div><p class=\"imob-name mb-1\">{{ imb.nome }}</p><p class=\"imob-add mb-1\">{{ imb.endereco }}</p><p class=\"imob-click-advise d-block d-md-none\">Clique para ver mais</p></div></div></a></div></form></div><div ng-class=\"{\'col-lg-4\':vm.config_wl.isArbo,\'col-lg-6 select-content wl justify-content-end mb-4\':!vm.config_wl.isArbo,\'d-none d-sm-block\':{{vm.config_wl.isArbo}}}\" class=d-flex ng-if=!vm.isLoading><div class=\"imb-infos w-100\"><div class=\"row d-flex imb-info-item\"><div class=\"row d-flex imb-title\"><div class=\"col imb-info-header\"><span ng-class=\"{\'wl-imb-info-header-desc\':{{!vm.config_wl.isArbo}},\'imb-info-header-desc\':{{vm.config_wl.isArbo}}}\">{{ vm.imb_selected.descricao }}</span> <span ng-class=\"{\'wl-imb-info-header-name\':{{!vm.config_wl.isArbo}},\'imb-info-header-name\':{{vm.config_wl.isArbo}}}\">{{ vm.imb_selected.nome }}</span> <span ng-class=\"{\'wl-imb-info-header-creci\':{{!vm.config_wl.isArbo}},\'imb-info-header-creci\':{{vm.config_wl.isArbo}}}\">CRECI: {{ vm.imb_selected.creci }}</span></div></div></div><div ng-if=\"vm.config_wl.isArbo && vm.imb_selected.site\" class=\"row d-flex imb-info-item section\"><div class=\"row d-flex imb-title\"><div class=col><span ng-class=\"{\'imb-info-title\':{{vm.config_wl.isArbo}},\'wl-imb-info-title\':{{!vm.config_wl.isArbo}}}\">Website:<br></span></div></div><div class=\"row d-flex\"><div class=col><i class=\"fal fa-globe\"></i> <a href=\"{{ vm.imb_selected.site }}\" target=_blank>{{ vm.formatSite(vm.imb_selected.site) }}</a></div></div></div><div class=\"section row d-flex imb-info-item\" ng-if=\"\n            vm.imb_selected.imb_config_site.show_endereco == undefined ||\n            vm.imb_selected.imb_config_site.show_endereco == null\n              ? true\n              : vm.imb_selected.imb_config_site.show_endereco\n          \"><div class=\"row d-flex imb-title\"><div class=col><span ng-class=\"{\'imb-info-title\':{{vm.config_wl.isArbo}},\'wl-imb-info-title\':{{!vm.config_wl.isArbo}}}\">Onde estamos localizados:<br></span></div></div><div class=\"item row d-flex\"><div class=\"col row flex-nowrap\"><i class=\"fal fa-map-marker-check\"></i><div><p ng-if=vm.imb_selected.endereco_titulo class=name>{{ vm.imb_selected.endereco_titulo }}<br></p><div class=number>{{ vm.imb_selected.endereco }}</div></div></div></div><div ng-repeat=\"end in vm.imb_selected.enderecos\" class=\"item row d-flex\"><div class=\"col row flex-nowrap\"><i class=\"fal fa-map-marker-check\"></i><div><p ng-if=end.titulo class=name>{{ end.titulo }}<br></p><div class=number>{{ end.logradouro ? end.logradouro + \', \' + (end.numero ? end.numero + \'. \' : \'\') + (end.complemento ? end.complemento : \'\') + (end.cidade ? \' - \' + end.cidade.nome + \' - \' + end.cidade.estado.sigla : \'\') : \'\' }}</div></div></div></div></div><div class=\"row d-flex imb-info-item section\" ng-show=\"\n            vm.imb_selected.nome === \'Arbo Imóveis\' ||\n            (vm.imb_selected.telefones.length > 0 &&\n              vm.imb_selected.imb_config_site.show_contact_phones)\n          \" ng-if=\"vm.imb_selected.telefones.length > 0\"><div class=\"row d-flex imb-title\"><div class=col><span class=title>{{ vm.imb_selected.telefones.length > 1 ? \'Telefones\' : \'Telefone\' }} para contato:<br></span></div></div><div ng-repeat=\"tel in vm.imb_selected.telefones\" class=\"item row d-flex\"><a ng-href=\"{{ tel.url }}\" target=_blank ng-if=tel.url class=\"col c-pointer\"><span>{{ tel.numero }}</span></a><div ng-if=!tel.url class=\"col row flex-nowrap\"><i ng-class=\"\n                  tel.ttel_id === 3 ? \'fab fa-whatsapp\' : \'fal fa-phone\'\n                \"></i><div><p ng-if=tel.contato class=name>{{ tel.contato }}<br></p><div class=number>{{ vm.formatPhone(tel.ttel_id, tel.numero) }}</div></div></div></div></div><div class=\"row d-flex imb-info-item section\" ng-show=\"vm.imb_selected.nome === \'Arbo Imóveis\' ||\n        (vm.imb_selected.listaEmails.length > 0 \" ng-if=\"vm.imb_selected.listaEmails.length > 0\"><div class=\"row d-flex imb-title\"><div class=col><span class=title>{{ vm.imb_selected.listaEmails.length > 1 ? \'E-mails\' : \'E-mail\' }} para contato:<br></span></div></div><div ng-repeat=\"email in vm.imb_selected.listaEmails\" class=\"item row d-flex\"><div class=\"col row flex-nowrap\"><i class=\"fal fa-envelope\"></i><div><p ng-if=email.nome class=name>{{ email.nome }}</p><div class=number>{{ email.endereco }}</div></div></div></div></div><div class=\"row d-flex imb-info-item section\" ng-show=\"vm.horarios.length > 0\" ng-if=\"vm.horarios.length > 0\"><div class=\"row d-flex imb-title\"><div class=col><span class=title>Horários de funcionamento<br></span></div></div><div ng-repeat=\"horario in vm.horarios\" class=\"item row d-flex\"><div class=\"col row flex-nowrap\"><i class=\"fal fa-clock\"></i><div><p class=name>{{ horario.day }}<br></p><div class=number>{{ horario.hour }}</div></div></div></div></div><div ng-if=\"vm.imb_selected.sociais.length > 0\" class=\"row d-flex imb-info-item section\"><div class=\"row d-flex imb-title\"><div class=col><span class=title>Redes Sociais:<br></span></div></div><div ng-repeat=\"rd in vm.imb_selected.sociais\" class=\"row d-flex\"><div class=col><i ng-class=\"{\n                  \'fab fa-facebook-f\': rd.nome === \'Facebook\',\n                  \'fab fa-instagram\': rd.nome === \'Instagram\',\n                  \'fab fa-linkedin-in\': rd.nome === \'Linkedin\',\n                  \'fab fa-youtube\': rd.nome === \'YouTube\',\n                  \'fab fa-wordpress-simple\': rd.nome === \'Blog\',\n                  \'fab fa-twitter\': rd.nome === \'Twitter\',\n                  \'fab fa-pinterest\': rd.nome === \'Pinterest\',\n                }\"></i> <a href=\"{{ rd.url }}\" target=_blank>{{ vm.formatSite(rd.url) }}</a></div></div></div></div></div><div ng-if=\"\n        vm.imb_selected.imb_config_site.show_endereco == undefined ||\n        vm.imb_selected.imb_config_site.show_endereco == null\n          ? true\n          : vm.imb_selected.imb_config_site.show_endereco\n      \" ng-class=\"{\'col-lg-4\':vm.config_wl.isArbo,\'col-lg-6\':!vm.config_wl.isArbo, \'d-none d-sm-block\':{{vm.config_wl.isArbo}}}\" class=p-0><div class=\"d-block maps\" ng-show=\"vm.imb_selected.latitude != null\"><img src=../../assets/images/novosite/_marker.svg style=\"position: absolute;\n            top: 45%;\n            left: 48%;\n            width: 36px;\n            height: 48px\" data-aos=fade-down> <img width=100% height=100% frameborder=0 style=\"border: 0; object-fit: cover; z-index: 10\" srcset=\"\n            https://maps.googleapis.com/maps/api/staticmap?center={{vm.imb_selected.latitude}},{{vm.imb_selected.longitude}}&zoom=17&size=744x1119&scale=1&key={{vm.GOOGLE_API}} 1x,\n            https://maps.googleapis.com/maps/api/staticmap?center={{vm.imb_selected.latitude}},{{vm.imb_selected.longitude}}&zoom=17&size=744x1119&scale=2&key={{vm.GOOGLE_API}} 2x\n          \" src=\"https://maps.googleapis.com/maps/api/staticmap?center={{\n            vm.imb_selected.latitude\n          }},{{ vm.imb_selected.longitude }}&zoom=17&size=744x1119&key={{\n            vm.GOOGLE_API\n          }}\"></div></div></div><div class=\"gradient-content d-flex justify-content-center\" ng-class=\"{ wl: !vm.config_wl.isArbo }\"><div class=\"contact-header d-flex justify-content-between align-items-center w-100\"><form action=\"\" class=w-100 ng-submit=vm.sendContact($event)><div class=\"row d-flex contact-header\"><div class=\"col-lg-4 col-12 p-sm-0\"><h2>{{ vm.config_wl.isArbo ? \'Fale com a Arbo!\' : \'Fale conosco!\' }}</h2></div><div class=\"col-lg-4 col-12\"><div class=form-group><div class=\"row mb-2 ml-1\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form_contato.name required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Nome</label><label for=name class=\"pl-3 icon-inside\"><i class=\"fal fa-user\"></i></label></div><div class=\"row mb-2 ml-1\"><input type=email id=email class=\"form-control upper\" ng-model=vm.form_contato.email required placeholder=email@dominio.com pattern=.+@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?><label for=email class=\"pl-3 upper\">E-mail</label><label for=email class=\"pl-3 icon-inside\"><i class=\"fal fa-envelope\"></i></label></div><div class=\"row mb-2 ml-1\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form_contato.tel data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required pattern=\"\\([0-9]{2}\\) [9]?[0-9]{4}-[0-9]{4}$\" placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label><label for=phone class=\"pl-3 icon-inside\"><i class=\"fal fa-phone\"></i></label></div></div></div><div class=\"col-lg-4 col-12\"><div class=form-group><div class=\"row mb-2\"><textarea type=text id=message class=\"form-control upper db-size\" ng-model=vm.form_contato.message required placeholder=\"Sua Mensagem\"></textarea><label id=text-area-contato for=message class=\"pl-3 upper\">Envie-nos uma mensagem</label></div></div><div class=\"form-group d-flex flex-column\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-lgpd-check name=detail-co class=\"input-control square\" ng-model=vm.form_contato.lgpd ng-true-value=true ng-false-value=false><label for=form-lgpd-check class=\"checkbox col-12\"><span class=text-white>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div><div class=\"btn-content m-0\"><button type=submit class=\"btn button btn-home active text-center\" ng-disabled=\"(vm.config_wl.isArbo && !vm.form_contato.lgpd)\">Enviar</button></div></div></div></form></div></div><div class=modal id=modalContact><div class=modal-dialog><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal>&times;</button></div><div class=modal-body><div ng-show=!vm.showMapModal class=\"col-12 middle-content\"><div class=imb-infos><div class=\"row d-flex imb-info-item\"><div class=\"row d-flex imb-title\"><div class=\"col imb-info-header\"><span class=imb-info-header-desc>{{ vm.imb_selected.descricao }}</span> <span class=imb-info-header-name>{{ vm.imb_selected.nome }}</span> <span class=imb-info-header-creci>{{ vm.imb_selected.creci }}</span></div></div></div><div class=\"row d-flex imb-info-item\"><div class=\"row d-flex imb-title\"><div class=col><span class=imb-info-title>Como chegar:<br></span></div></div><div class=\"row d-flex\"><div class=col-1><i class=\"fal fa-map-marker-check\"></i></div><div class=col><span>{{ vm.imb_selected.endereco }}</span></div></div></div><div class=\"row d-flex imb-info-item\"><div class=\"row d-flex imb-title\"><div class=col><span class=imb-info-title>Telefone para contato:<br></span></div></div><div ng-repeat=\"tel in vm.imb_selected.telefones\" class=\"row d-flex\"><div class=col-1><i ng-class=\"\n                        tel.ttel_id === 3 ? \'fab fa-whatsapp\' : \'fal fa-phone\'\n                      \"></i></div><div class=col><span>{{ tel.numero }}</span></div></div></div><div class=\"row d-flex imb-info-item\" ng-if=vm.imb_selected.site><div class=\"row d-flex imb-title\"><div class=col><span class=imb-info-title>Website:<br></span></div></div><div class=\"row d-flex\"><div class=col-1><i class=\"fal fa-globe\"></i></div><div class=col><a href=\"{{ vm.imb_selected.site }}\" target=_blank>{{ vm.formatSite(vm.imb_selected.site) }}</a></div></div></div><div class=\"row d-flex imb-info-item\"><div class=\"row d-flex imb-title\"><div class=col><span class=imb-info-title>Redes Sociais:<br></span></div></div><div ng-repeat=\"rd in vm.imb_selected.sociais\" class=\"row d-flex\"><div class=col-1><i ng-class=\"{\n                        \'fab fa-facebook-f\': rd.nome === \'Facebook\',\n                        \'fab fa-instagram\': rd.nome === \'Instagram\'\n                      }\"></i></div><div class=col><a href=\"{{ rd.url }}\" target=_blank>{{ vm.formatSite(rd.url) }}</a></div></div></div></div></div><div ng-show=vm.showMapModal class=\"col-12 middle-content\"><div class=\"d-block maps\"><img width=100% height=100% frameborder=0 style=\"border: 0; object-fit: cover\" src=\"https://maps.googleapis.com/maps/api/staticmap?center={{\n                  vm.imb_selected.latitude\n                }},{{\n                  vm.imb_selected.longitude\n                }}&zoom=17&size=600x900&markers=color:green%7C{{\n                  vm.imb_selected.latitude\n                }},{{ vm.imb_selected.longitude }}&key={{ vm.GOOGLE_API }}\"></div></div><div class=\"d-flex justify-content-center\"><button class=\"btn button button-white\" ng-click=\"vm.showMapModal = !vm.showMapModal\">{{ !vm.showMapModal ? \'Ver Mapa\' : \'Remover Mapa\' }}</button></div></div></div></div></div></section>");
$templateCache.put("app/errors/error401.html","<div id=error404><div class=error-page><div class=\"row text-center\"><img class=\"img-responsive margin-center\" src=../../../assets/images/401.png alt=404><div class=error-caption-404><h2>Ops!</h2><h3>Acesso não autorizado!</h3></div></div></div></div>");
$templateCache.put("app/errors/error403.html","<div id=error403><div class=\"col-md-6 col-xs-6 offset-md-3\"><h1 class=error-title>Oops!<br>Você não está autenticado.</h1><p class=error-type>403</p><div class=\"d-flex justify-content-center\"><button ui-sref=main.home class=\"btn button btn-default\">Página Inicial</button></div></div></div>");
$templateCache.put("app/errors/error404.html","<div id=error-404><div class=\"col-md-6 col-xs-6 offset-md-3\"><h1 class=error-title>Oops!<br>Página não encontrada.</h1><p class=error-type>404</p><div class=\"d-flex justify-content-center\"><button ui-sref=main.home class=\"btn button btn-default\">Página Inicial</button></div></div></div>");
$templateCache.put("app/errors/error500.html","<div id=error-500><div class=\"col-md-6 col-xs-6 offset-md-3\"><h1 class=error-title>Oops!<br>Página não encontrada.</h1><p class=error-type>500</p><div class=\"d-flex justify-content-center\"><button ui-sref=main.home class=\"btn button btn-default\">Página Inicial</button></div></div></div>");
$templateCache.put("app/imobiliarias/imobiliarias.html","<div id=imobiliarias class=\"imobiliarias pb-3\"><div class=\"gradient-header py-5 px-2 px-md-5\"><h3 class=\"title col-12 my-3\">Imobiliárias credenciadas.</h3></div><div class=\"d-flex flex-wrap justify-content-center my-2 m-lg-5\"><div class=\"col-11 col-md-3 d-flex flex-column\"><h4 class=\"my-4 mt-md-0\">Pesquise por cidade</h4><form name=search-imob><div><div class=\"form-group d-flex flex-column\"><select id=select-state class=\"col-12 custom-select\" ng-model=vm.localData.state ng-change=vm.updateCities() ng-options=\"f.nome for f in vm.localData.states\" ng-init=\"vm.localData.state =  vm.localData.states[0]\"></select></div><div class=\"form-group d-flex flex-column\"><select id=select-city class=\"col-12 custom-select\" ng-model=vm.localData.city ng-change=vm.updateImobs() ng-options=\"f.nome for f in vm.localData.cities\" ng-init=\"vm.localData.city =  vm.localData.cities[0]\"></select></div></div></form></div><div class=\"col-11 col-md-9\"><div class=\"d-flex flex-column flex-md-row justify-content-between\"><p class=\"imobs-breadcrumb d-none d-md-block\">Brasil > {{vm.localData.state.nome}} > <strong>{{vm.localData.city.nome}}</strong></p><p class=\"imobs-breadcrumb d-block d-md-none\">Brasil > {{vm.localData.state.nome}} ><br><strong>{{vm.localData.city.nome}}</strong></p><p><strong>{{vm.currentImobs.length}}</strong> imobiliárias encontradas</p></div><div class=\"imobs w-100\"><div class=\"imob d-none d-md-flex col-12 py-3\" ng-repeat=\"imob in vm.currentImobs\" ng-if=\"imob.id != 74\"><i class=\"fal fa-thumbtack pl-2\"></i><div class=\"imob-info d-flex flex-column col-7\"><p class=\"name font-weight-bold\">{{imob.imb_nome}}</p><p class=address>{{imob.cidade.nome}} - {{imob.cidade.estado.sigla}}</p></div><div class=\"imob-info d-flex flex-column px-4 col-2\"><p class=font-weight-bold>CRECI</p><p>{{imob.imb_creci}}</p></div><div class=\"imob-info d-flex justify-content-end align-items-center col-3 pr-5\" ng-if=\"imob.imb_creci != 0 && vm.generateImobLink(imob)\"><a href={{vm.generateImobLink(imob)}}><strong>Ver mais</strong> <i class=\"fal fa-search-plus ml-1\"></i></a></div></div><div class=\"imob d-flex d-md-none flex-column col-12 px-0 pt-3\" ng-repeat=\"imob in vm.currentImobs\"><div class=\"d-flex px-2\"><i class=\"mob-icon fal fa-thumbtack col-1 pl-2\"></i><div class=\"imob-infos col-11 pl-2\"><div class=\"imob-info d-flex justify-content-between\"><p class=font-weight-bold>{{imob.imb_nome}}</p><p>CRECI - {{imob.imb_creci}}</p></div><div class=\"imob-info d-flex flex-column\"><p class=\"address mt-1\">{{imob.imb_endereco ? imob.imb_endereco : \'Avenida Ayrton Senna da Silva, Gleba Palhano\'}}</p></div></div></div><div class=\"imob-options d-flex w-100 mt-3 py-0\"><div class=\"imob-info d-flex justify-content-center align-items-center w-100 py-3\"><a href={{vm.generateImobLink(imob)}}><strong>Ver mais</strong> <i class=\"fal fa-search-plus ml-1\"></i></a></div></div></div></div></div></div></div>");
$templateCache.put("app/imobiliarias/imobiliariaspage.html","<div id=imobiliaria class=imobiliarias><ol class=\"breadcrumb-list mt-5 mb-0 p-0 d-block d-sm-block\" itemscope itemtype=http://schema.org/BreadcrumbList style=\"margin-bottom: 20px !important\"><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=/ ><span itemprop=name>Início</span></a><meta itemprop=position content=1></li><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=/imobiliarias><span itemprop=name>> Imobiliárias</span></a><meta itemprop=position content=2></li><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href={{vm.generateImobLink(vm.imob)}}><span itemprop=name>{{\'> \' + vm.imob.imb_nome}}</span></a><meta itemprop=position content=3></li></ol><section class=infos><div class=titulo><h1>{{vm.imob.imb_nome}}</h1></div><div class=corpo><div class=texto><p class=m-0>Temos paixão por imóveis e por transformar a vida das pessoas! Procuramos levar o melhor atendimento e as melhores opções de imóvel para cada um dos nossos clientes.</p><p class=m-0>A {{vm.imob.imb_nome}} está localizada em {{vm.imob.cidade.nome}} com as melhores opções para {{vm.tiponegocio}} da região!</p></div><img class=foto ng-src={{vm.imob.imb_url_logo}} alt=\"Logo da imobiliária {{vm.imob.imb_nome}}\" title=\"Logo da imobiliária {{vm.imob.imb_nome}}\"></div><div class=endereco><address>{{vm.imob.cidade.nome}} - {{vm.imob.cidade.estado.sigla}}</address></div></section><div id=relations class=relations ng-if=\"vm.vendaDestaques && vm.vendaDestaques.length\"><carousel-imovel imoveis=vm.vendaDestaques properties=vm.owlProperties navegator=true title-carousel=\"Imóveis da Imobiliária {{vm.imob.imb_nome}} para Venda\"></carousel-imovel><p><a class=\"title-desc title\" href={{vm.urlallvenda}} style=\"margin-top: -20px\">Mostrar todos imóveis para venda</a></p></div><div id=relations class=relations ng-if=\"vm.locacaoDestaques && vm.locacaoDestaques.length\"><carousel-imovel imoveis=vm.locacaoDestaques properties=vm.owlProperties navegator=true title-carousel=\"Imóveis da Imobiliária {{vm.imob.imb_nome}} para Locação\" ng-if=\"vm.locacaoDestaques && vm.locacaoDestaques.length\"></carousel-imovel><p><a class=\"title-desc title\" href={{vm.urlalllocacao}} style=\"margin-top: -20px\">Mostrar todos imóveis para locação</a></p></div></div>");
$templateCache.put("app/lgpd/accept-terms.html","<style>.ot-form-consent {\n    margin: 15vh auto;\n    max-width: 600px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n  }\n\n  .content-button {\n    display: flex;\n    justify-content: center;\n  }\n\n  .button.btn-default {\n    padding: 10px 18px;\n  }\n\n  input[type=\"checkbox\"]{\n    filter: grayscale(1)\n  }</style><form class=ot-form-consent ng-submit=vm.submit($event)><h3>Aceito as finalidades seguintes:</h3><div class=ot-checkbox><label><input ng-model=vm.checkData value=\"Dados de oportunidades entre imóveis e clientes\" type=checkbox required> Utilizaremos seus dados pessoais apenas para a finalidade coletada, melhorar a sua experiência como usuário e te ofertar produtos mais adequados ao o seu perfil.</label></div><div class=ot-ml-1><h5>Política de privacidade</h5><div class=ot-checkbox><label><input ng-model=vm.checkPolicy value=\"Ao informar meus dados, eu concordo com a Política de privacidade.\" type=checkbox required> Ao informar meus dados, eu concordo com os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a></label></div></div><div class=content-button><button id=trigger class=\"ot-submit-button btn button btn-default\" type=submit>Enviar</button></div></form>");
$templateCache.put("app/listing/listing.html","<div ng-if=vm.imovel><listing-detail ng-if=!vm.isEmp imovel=vm.imovel></listing-detail><listing-detail-empreendimento ng-if=vm.isEmp imovel=vm.imovel></listing-detail-empreendimento></div><div ng-if=!vm.imovel><listing-empty codigo=vm.codigo></listing-empty></div>");
$templateCache.put("app/listing/search.html","<div id=page-content class=container-fluid><div class=\"toggles-bar d-flex\" ng-style=\"\n      !vm.config_wl.isArbo && !vm.isMobile()\n        ? {\n            top: vm.filtersSize,\n          }\n        : {}\n    \"><div class=\"toggle-wrapper d-flex justify-content-between align-items-center\"><div ng-if=!vm.isMobile() class=toggles-button><button class=\"btn button btn-toggle mr-1\" ng-click=\"vm.updateFilter(\'a-venda\')\" ng-if=\"\n            vm.config_wl.imb_config_site.tipo_imob == 1 ||\n            vm.config_wl.imb_config_site.tipo_imob == 3\n          \" ng-class=\"{\n            active:\n              vm.search.title.tipovar == \'a-venda\' || !vm.search.title.tipovar\n          }\">Venda</button> <button ng-click=\"vm.updateFilter(\'para-alugar\')\" class=\"btn button btn-toggle mr-1\" ng-if=\"\n            vm.config_wl.imb_config_site.tipo_imob == 2 ||\n            vm.config_wl.imb_config_site.tipo_imob == 3\n          \" ng-class=\"{ active: vm.search.title.tipovar == \'para-alugar\' }\" ng-click=console.log(vm.search)>Locação</button> <button class=\"btn button btn-toggle\" ng-click=\"vm.updateFilter(\'lancamento\')\" ng-class=\"{ active: vm.search.title.tipovar == \'lancamento\' }\">Lançamentos</button></div><div class=toggles-button ng-if=vm.isMobile()><button class=\"btn button btn-toggle\">{{ vm.search.title.tipovar == \'a-venda\' || !vm.search.title.tipovar ? \'Venda\' : vm.search.title.tipovar == \'para-alugar\' ? \'Locação\' : \'Lançamentos\' }}</button><div class=\"relevance-dropdown toggle-dropdown dropdown-menu\"><div class=toggle-option ng-click=\"vm.updateFilter(\'a-venda\')\"><label class=my-1 ng-style=\"\n                vm.search.title.tipovar == \'a-venda\' || !vm.search.title.tipovar\n                  ? { color: \'var(--primary-color)\' }\n                  : {}\n              \">Venda</label></div><div class=toggle-option ng-click=\"vm.updateFilter(\'para-alugar\')\"><label class=my-1 ng-style=\"\n                vm.search.title.tipovar == \'para-alugar\'\n                  ? { color: \'var(--primary-color)\' }\n                  : {}\n              \">Locação</label></div><div class=toggle-option ng-click=\"vm.updateFilter(\'lancamento\')\"><label class=my-1 ng-style=\"\n                vm.search.title.tipovar == \'lancamento\'\n                  ? { color: \'var(--primary-color)\' }\n                  : {}\n              \">Lançamentos</label></div></div></div><div class=d-block><input type=checkbox class=d-none id=filtro-checkbox ng-change=\"!vm.isMobile()? vm.search.toggle() : vm.toggleFiltersModal()\" ng-model=vm.filtros><label class=\"btn button btn-toggle mr-1\" for=filtro-checkbox><span ng-if=!vm.isMobile()>Filtros</span><i class=\"fal fa-filter\"></i></label><button class=\"btn button btn-toggle\">{{ !vm.isMobile() ? vm.getSelectedOrder() : \'\' }} <span class=\"fal fa-list-ul\"></span></button><div class=\"relevance-dropdown toggle-dropdown dropdown-menu\"><div class=toggle-option><input type=radio class=\"input-control d-none\" id=radio-mais-proximos name=order ng-model=vm.selectedOrder value=mais_proximos ng-change=vm.updateFilter()><label for=radio-mais-proximos class=\"my-1 w-100\">Mais Próximos</label></div><div class=toggle-option><input type=radio class=\"input-control d-none\" id=radio-mais-relevantes name=order ng-model=vm.selectedOrder value=mais_relevantes ng-change=vm.updateFilter()><label for=radio-mais-relevantes class=\"my-1 w-100\">Mais Relevantes</label></div><div class=toggle-option><input type=radio class=\"input-control d-none\" id=radio-menor-preco name=order ng-model=vm.selectedOrder value=menor_preco ng-change=vm.updateFilter()><label for=radio-menor-preco class=\"my-1 w-100\">Menor Preço</label></div><div class=toggle-option><input type=radio class=\"input-control d-none\" id=radio-maior-preco name=order ng-model=vm.selectedOrder value=maior_preco ng-change=vm.updateFilter()><label for=radio-maior-preco class=\"my-1 w-100\">Maior Preço</label></div></div></div></div><div class=\"toggle-wrapper d-none d-lg-flex justify-content-end align-items-center\"><div><span class=toggle-label>Mapa</span><label class=switch><input type=checkbox ng-change=vm.search.toggle() ng-model=vm.mapa> <span class=\"switch-slider round\"></span></label></div></div></div><section id=busca class=\"section-result d-flex\" ng-style=\"\n      !vm.config_wl.isArbo && !vm.isMobile()\n        ? {\n            \'margin-top\':\n              \'calc(\' +\n              (vm.config_wl.imb_config_site.image_size &&\n              vm.config_wl.imb_config_site.image_size >= 110\n                ? \'85px\'\n                : vm.config_wl.imb_config_site.image_size + \'px\') +\n              \' + 30px)\'\n          }\n        : {}\n    \"><div class=\"results-wrapper wrap-toogle\"><div class=\"d-flex flex-column d-fixed animated-shimmer\"><div class=title-result-count><h1 class=results-title>{{ vm.search.title.count }} {{ vm.search.title.count ? vm.tituloImovel() : \'\' }} <strong ng-if=vm.search.title.tipovar>{{ vm.search.title.tipovar.split(\'-\')[0] === \'a\' ? \'à\' : vm.search.title.tipovar.split(\'-\')[0] }} {{ vm.search.title.tipovar.split(\'-\')[1] + \' \' }} </strong><strong>{{ vm.search.title.cidade_label }}</strong></h1></div><div class=\"search-breadcrumb animated-shimmer\"><ol class=\"breadcrumb text-lowcase px-1 pl-md-2 mb-4 bg-white\" style=\"padding-bottom: 12px\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=\"breadcrumb-item animated-title\" itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem ng-class=\"{ \'animated-title\': !vm.search.title.count }\"><a href=/ itemprop=item><span itemprop=name>{{ vm.search.title.count ? \'Início\' : \'\' }}</span><meta itemprop=position content=1></a></li><li class=breadcrumb-item ng-repeat=\"(key, val) in vm.search.title.cidade_pesquisa\" ng-if=val itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a ng-href=\"/imoveis/{{ vm.cidadeURL(key) }}\" itemprop=item><span itemprop=name>{{ val }}</span><meta itemprop=position content=\"{{ $index + 2 }}\"></a></li><li class=breadcrumb-item ng-if=vm.search.title.tipovar itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a ng-href=\"/imoveis/{{ vm.search.title.tipovar }}{{\n                  \'/\' + vm.cidadeURL(null)\n                }}\" itemprop=item><span itemprop=name>{{ vm.search.title.tipovar.split(\'-\')[0] === \'a\' ? \'à\' : vm.search.title.tipovar.split(\'-\')[0] }} {{ vm.search.title.tipovar.split(\'-\')[1] + \' \' }}</span><meta itemprop=position content=\"{{\n                    vm.sizeObject(vm.search.title.cidade_pesquisa || {}) + 2\n                  }}\"></a></li><li class=breadcrumb-item ng-if=vm.tipoimovelURl() itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a ng-href=\"/imoveis{{\n                  vm.search.title.tipovar ? \'/\' + vm.search.title.tipovar : \'\'\n                }}{{ vm.tipoimovelURl() ? \'/\' + vm.tipoimovelURl() : \'\' }}{{\n                  \'/\' + vm.cidadeURL(null)\n                }}\" itemprop=item><span itemprop=name>{{ vm.tituloImovel() }}</span><meta itemprop=position content=\"{{\n                    vm.sizeObject(vm.search.title.cidade_pesquisa || {}) + 3\n                  }}\"></a></li></ol></div></div><div id=result-sidebar class=result-sidebar result-sidebar></div><div id=page-loader class=\"page-loader justify-content-center align-items-center\"><div class=loader></div></div></div><div ng-show=vm.mapa class=\"map-wrapper wrap-toogle\"><div id=map-homepage class=map search-map></div></div></section><div class=\"btn-fixed d-flex d-lg-none justify-content-center z-index-max\"><button class=\"btn button button-toogle btn-default col-8\" ng-click=\"vm.search.toggle(\'listaMobile\')\" ng-class=\"{ \'d-none\': !vm.search.mapa }\">Ver Lista</button> <button class=\"btn button button-toogle btn-default col-8\" ng-click=\"vm.search.toggle(\'mapaMobile\')\" ng-class=\"{ \'d-none\': vm.search.mapa }\">Ver Mapa</button></div><filters pagetitle=vm.search.title tiposimovel=vm.tipos_imovel tipo-filtros=2 ng-if=!vm.isMobile() params=vm.search.params id=filter-lateral ng-class=\"{ active: vm.filtros }\"></filters></div>");
$templateCache.put("app/listing/searchLancamentos.html","<div id=page-content><div class=\"row mobile-filter-row padding-top-5px padding-bottom-5px mobile-filter-padding\"><div class=\"center visible-xs div-filtro\"><button ng-click=vm.hiddenMapMobile() class=\"btn btn-default btn-filtro\">{{vm.txtToggleMap}}</button> <button ng-click=vm.showHideFilter() class=\"btn btn-default btn-filtro\">Filtros</button></div><div class=\"hidden-xs filtros\"><div class=\"col-xs-12 col-md-12 col-lg-3 offset hidden-xs\"></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><select id=Cidade class=form-control ng-options=\"option.name for option in vm.Cidades track by option.value\" ng-model=vm.Cidade ng-change=\"vm.setFilter(option, \'type\')\"></select></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><select id=Status class=form-control ng-options=\"option.name for option in vm.Statuss track by option.value\" ng-model=vm.Status ng-change=\"vm.setFilter(option, \'type\')\"></select></div></div></div><div class=\"hero-section full-screen has-map has-sidebar padding-bottom-0px\"><div ng-show=vm.mobileShowResult class=results-wrapper><div id=collapse uib-collapse=!vm.showFilter><div id=accordionFilter class=row><div class=col-xs-12><div class=panel-group id=accordion role=tablist aria-multiselectable=true><div class=\"panel panel-default no-border\"><div class=panel-body><div id=selectFilters><h3 class=margin-top-0>Com as características...</h3><div class=filterOptions><div class=\"create-add-option col-xs-12 col-sm-12 col-md-12 col-lg-6\" ng-repeat=\"environment in vm.environments\"><div class=togglebutton><label><input type=checkbox ng-model=environment.enabled ng-change=vm.refreshSearch()> <span class=\"toggle width-40px\"></span> <span class=amenityName>{{ environment.name }}</span></label></div></div></div><div class=filterOptions><div class=\"create-add-option col-xs-12 col-sm-12 col-md-12 col-lg-6\" ng-repeat=\"access in vm.accessType\"><div class=togglebutton><label><input type=checkbox ng-model=access.enabled ng-change=vm.refreshSearch()> <span class=\"toggle width-40px\"></span> <span class=amenityName>{{ access.name }}</span></label></div></div></div><div class=filterOptions><div class=\"create-add-option col-xs-12 col-sm-12 col-md-12 col-lg-6\" ng-repeat=\"storage in vm.storageType\"><div class=togglebutton><label><input type=checkbox ng-model=storage.enabled ng-change=vm.refreshSearch()> <span class=\"toggle width-40px\"></span> <span class=amenityName>{{ storage.name }}</span></label></div></div></div></div></div></div></div></div></div></div><div class=\"results padding-left-20px\"><div class=section-title><h3 ng-if=vm.initSearching>Nenhum empreendimento encontrado! &nbsp;</h3><h3 ng-if=\"vm.filteredListings.length == 0 && !vm.initSearching\">Nenhum empreendimento encontrado! &nbsp;</h3><h3 ng-if=\"vm.filteredListings.length == 1 && !vm.initSearching\">{{vm.filteredListings.length}} empreendimento encontrado &nbsp;</h3><h3 ng-if=\"vm.filteredListings.length > 1 && !vm.initSearching\">{{vm.filteredListings.length}} empreendimentos encontrados &nbsp;</h3><div class=\"botoes hidden-xs\"><button ng-click=vm.hiddenMap()>{{vm.txtToggleMap}}</button> <button class=branco ng-click=vm.limpar()>Limpar Filtro</button></div></div><div result-sidebar-lancamento markers=vm.markers class=result-sidebar></div></div></div><div class=map-wrapper><div class=map id=map-homepage search-map map=vm.map listings=vm.listings markers=vm.markers></div></div></div></div>");
$templateCache.put("app/main/main.html","<header-main id=page-header class=fixed-top ng-show=showHeader()></header-main><div ui-view id=main-content></div><footer-main id=page-footer ng-show=showFooter() ng-class=\"{\'bairro\': !showFooterBairro()}\"></footer-main>");
$templateCache.put("app/nossotime/detailmodal.html","<div id=modal><div class=corretores><div class=foto><div class=borda><i ng-if=!vm.corretor.foto class=\"fas fa-user\"></i> <img ng-if=vm.corretor.foto alt={{vm.corretor.nome}} ng-src={{vm.corretor.foto}}></div></div><div class=textos><div ng-repeat=\"tl in vm.corretor.telefones\" class=telefones><span ng-if=\"tl.ttel_id == 16 || tl.ttel_id == 1\">{{tl.numero}}</span></div><span class=creci ng-if=vm.corretor.creci>Creci: {{vm.corretor.creci}}</span></div><div class=social><div ng-if=\"tl.ttel_id == 3\" ng-repeat=\"tl in vm.corretor.telefones\" class=c-pointer ng-click=vm.chamaNoZapBB(tl.numero)><i ng-if=\"tl.ttel_id == 3\" class=\"fab fa-whatsapp\"></i></div><div ng-if=vm.corretor.email class=c-pointer><i class=\"fas fa-envelope\"></i></div><div ng-repeat=\"rd in vm.corretor.redessociais\" ng-click=\" vm.openTab(rd.rd_url)\" class=c-pointer><i ng-if=\"rd.rds_id == 1\" class=\"fab fa-instagram\"></i> <i ng-if=\"rd.rds_id == 2\" class=\"fab fa-facebook\"></i> <i ng-if=\"rd.rds_id == 3\" class=\"fab fa-wordpress\"></i> <i ng-if=\"rd.rds_id == 4\" class=\"fab fa-linkedin-in\"></i> <i ng-if=\"rd.rds_id == 5\" class=\"fab fa-youtube\"></i> <i ng-if=\"rd.rds_id == 6\" class=\"fab fa-twitter\"></i> <i ng-if=\"rd.rds_id == 7\" class=\"fab fa-pinterest\"></i></div></div></div><div class=descricao><span class=nome>{{vm.corretor.nome}}</span> <span class=biografia>{{vm.corretor.biografia}}</span></div></div>");
$templateCache.put("app/nossotime/nossotime.html","<section id=nossotime class=margin-fluid><div ng-if=!vm.imob.isArbo class=titulo-pag>Conheça nosso time</div><div class=\"corretores row\"><div ng-repeat=\"co in vm.corretores\" class=\"bloco col-6 col-md-4 col-xl-3\"><div class=foto><div class=\"borda c-pointer\" ng-click=vm.openDetails(co)><i ng-if=!co.foto class=\"fas fa-user\"></i> <img ng-if=co.foto ng-src=\"{{ co.foto }}\" alt=\"corretor {{ co.nome }}, imobiliária {{ vm.imob.nome }}\"></div></div><div class=textos ng-click=vm.openDetails(co)><span class=nome>{{ co.nome }}</span><div ng-repeat=\"tl in co.telefones\" class=telefones><span ng-if=\"tl.ttel_id == 16 || tl.ttel_id == 1\">{{ tl.numero }}</span></div><span class=creci ng-if=co.creci>Creci: {{ co.creci }}</span></div><div class=social><div ng-if=\"tl.ttel_id == 3\" ng-repeat=\"tl in co.telefones\" class=c-pointer ng-click=vm.chamaNoZapBB(tl.numero)><i ng-if=\"tl.ttel_id == 3\" class=\"fab fa-whatsapp\"></i></div><div ng-if=co.email ng-click=\"vm.openTab(\'mailto:\'+co.email)\" class=c-pointer><i class=\"fas fa-envelope\"></i></div><div ng-repeat=\"rd in co.redessociais\" ng-click=\" vm.openTab(rd.rd_url)\" class=c-pointer><i ng-if=\"rd.rds_id == 1\" class=\"fab fa-instagram\"></i> <i ng-if=\"rd.rds_id == 2\" class=\"fab fa-facebook\"></i> <i ng-if=\"rd.rds_id == 3\" class=\"fab fa-wordpress\"></i> <i ng-if=\"rd.rds_id == 4\" class=\"fab fa-linkedin-in\"></i> <i ng-if=\"rd.rds_id == 5\" class=\"fab fa-youtube\"></i> <i ng-if=\"rd.rds_id == 6\" class=\"fab fa-twitter\"></i> <i ng-if=\"rd.rds_id == 7\" class=\"fab fa-pinterest\"></i></div></div></div></div></section>");
$templateCache.put("app/proposta/corretor.propostas.html","<div class=\"margin-fluid mb-4 pb-2 pt-2 corretor-proposta-background\"><div class=\"row ml-3 mb-2\"><h1>Minhas propostas</h1></div><div ng-repeat=\"proposta in vm.propostas\" class=\"card proposta-card ml-3 mr-3 mb-1\"><div class=card-body><div class=\"bold locatario mb-2\"><i class=\"fal fa-user mr-1\"></i> {{ proposta.locatario }}</div><div class=row><div class=\"font-weight-bold mr-1\">Código do imóvel:</div><div>{{ proposta.imovel_codigo }}</div></div><div class=row><div class=\"font-weight-bold mr-1\">Corretor:</div><div>{{ proposta.corretor }}</div></div><div class=row><div class=\"font-weight-bold mr-1\">Tipo:</div><div>{{ proposta.tipo }}</div></div><div class=\"row col-12 mt-2 p-0 justify-content-between\"><div class=\"col-5 font-weight-bold p-0\">Valor ofertado:</div><div class=\"col-6 text-right p-0\">R$ {{ vm.formatPrice(proposta.valor) }}</div></div></div><div class=card-footer ng-class=proposta.status.type><div class=\"row col-12 p-0 justify-content-between\"><div class=\"col-1 p-0 align-self-center\"><div class=\"circle mr-2\" ng-class=proposta.status.type></div></div><div class=\"col-7 pl-1 pr-0 align-self-center\"><p class=\"font-weight-bold mb-0 pb-0\">{{ proposta.status.name }}</p><p class=\"detail mb-0 pb-0\">Atualizado em: {{ vm.toDate(proposta.statusCriadoEm) }}</p></div><div class=\"col-4 p-0 text-right align-self-center\"><a href=\"proposta-locacao/status/{{ proposta.hash }}\" class=\"button proposta-detalhe-button pl-2 pr-2\">Detalhes</a></div></div></div></div></div>");
$templateCache.put("app/proposta/proposta.anexos.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=\"col-12 form-default\" id=img-container><h3 class=title>Faça upload da sua documentação</h3><div ng-repeat=\"(i, row) in vm.inputFiles\"><strong>{{row.ptax_nome}}</strong><div class=\"well my-drop-zone small\" name=teste nv-file-drop nv-file-over=\"\" uploader=uploaderFile[i]><label><div class=\"image-preview d-flex flex-wrap\"><div class=\"d-flex rectangle-label\" ng-repeat=\"item in uploaderFile[i].queue\"><a class=float-left href=# ng-click=item.remove()><i class=\"fa fal fa-times\" aria-hidden=true></i></a><div ng-thumb=\"{ file: item._file, width: 100 }\"></div><span class=progress><div class=progress-bar role=progressbar ng-style=\"{ \'width\': uploaderFile[i].progress + \'%\' }\" style=\"width: 0%\"></div></span></div></div><input type=file nv-file-select=\"\" uploader=uploaderFile[i] name=uploaderMessage multiple class=d-none> <span ng-show=!uploaderFile[i].queue.length class=m-auto><span>Clique</span> ou <span>arraste</span> uma ou mais fotos</span></label></div><div class=\"errMsg bold\"><p class=redLabel ng-show=!uploaderFile[i].queue.length>Adicione o documento</p></div></div><div class=\"d-flex w-100 pb-4\"><input type=checkbox id=form-rapido-checkbox name=\"\" class=\"input-control square abs\" ng-model=vm.checkSend><label for=form-rapido-checkbox class=\"checkbox col-12\"><span>Eu me responsabilizo pela autenticidade dos documentos apresentados e pela veracidade das informações prestadas.</span></label></div><div class=\"d-flex w-100 pb-4\"><button class=\"btn button btn-default col-5 col-sm-4\" ng-disabled=!vm.checkSend ng-click=vm.sendAnexos()>Enviar documentação</button></div></div></section></div>");
$templateCache.put("app/proposta/proposta.confirmacao-contra.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Contraproposta aceita.</h2><p>Parabéns, você aceitou a contraproposta.</p><p>Enviamos um e-mail ao proprietário, para informá-lo e dar sequência à negociação. Te manteremos informado sobre qualquer atualização.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta/proposta.confirmacao.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=\"container-fluid p-5 prop-classes\"><div class=form ng-if=\"vm.sucesso && !vm.finish\"><div class=mb-5><h2>Envio de documentos</h2><h6>Para confirmar o aceite na proposta e agilizar o processo de emissão do contrato você deve confirmar as informações abaixo.</h6></div><form name=confirmacaoproposta ng-submit=\"vm.submit($event, confirmacaoproposta)\" novalidate><div ng-if=vm.isPessoaFisica class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form\"><h4>Dados pessoais</h4><div class=\"col-12 col-md-5 col-lg-6 p-0 mb-3\"><label red-dot for=person-name>Qual é o seu nome completo?</label><input type=text id=person-name name=person-name class=form-control ng-model=vm.data.person.name autocomplete=off placeholder=\"Digite o seu nome\" required><div ng-messages=\"confirmacaoproposta[\'person-name\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-4 p-0 mb-3\"><label red-dot for=person-phone>Telefone de contato?</label><input type=tel id=person-phone name=person-phone ui-br-phone-number=areaCode class=\"form-control ng-valid-br-phone-number\" ng-model=vm.data.person.phone autocomplete=off placeholder=\"(00) 99999-9999\" required><div ng-messages=\"confirmacaoproposta[\'person-phone\'].$error\" style=\"color: red\" role=alert><div ng-message=brPhoneNumber>Telefone inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-8 p-0 mb-3\"><label red-dot for=person-email>Qual o seu email?</label><input type=text disabled id=person-email name=person-email class=form-control ng-model=vm.data.person.email ng-pattern=\"/[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/\" autocomplete=off placeholder=email@dominio.com required><div ng-messages=\"confirmacaoproposta[\'person-email\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Email inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 p-0 check-estrangeiro\"><input ng-model=vm.isEstrangeiro ng-click=\"vm.checkEstrangeiro($event, \'person\')\" type=checkbox><label>Estrangeiro</label></div><div class=\"col-12 col-md-3 col-lg-4 p-0 text-nowrap mb-3\"><label red-dot for=person-nationality>Qual é sua nacionalidade?</label><div class=input-nacionalidade><input required ng-disabled=!vm.isEstrangeiro type=text id=person-nationality name=person-nationality class=form-control ng-model=vm.data.person.nationality uib-typeahead=\"row as row.label for row in vm.getNationality($viewValue)\"> <i class=\"fas fa-search\"></i></div><div ng-messages=\"confirmacaoproposta[\'person-nationality\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(!vm.isEstrangeiro && !vm.data.person.crnm)\" class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-rg>Qual o seu RG?</label><input required type=text ui-number-mask=0 ui-hide-group-sep id=person-rg name=person-rg class=form-control ng-model=vm.data.person.rg autocomplete=off placeholder=\"Digite seu RG\"><div ng-messages=\"confirmacaoproposta[\'person-rg\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>RG!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(!vm.isEstrangeiro && !vm.data.person.crnm)\" class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RG</h5><label ng-if=\"uploaders[\'rg\'].queue.length != uploaders[\'rg\'].queueLimit\" class=file-label for=person-rgFile nv-file-drop nv-file-over uploader=\"uploaders[\'rg\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'rg\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'rg\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'rg\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'rg\']\" ng-model=vm.data.uploads.proprietario.rg ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=person-rgFile name=person-rgFile ng-disabled=\"uploaders[\'rg\'].queue.length == uploaders[\'rg\'].queueLimit\" ng-model=vm.data.person.rgFile><div ng-messages=\"confirmacaoproposta[\'person-rgFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'rg\'].queue.length\">Adicione o documento</h6></div><div ng-if=\"(vm.isEstrangeiro || vm.data.person.crnm)\" class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-crnm>RNE/CRNM</label><input type=text ui-number-mask=0 ui-hide-group-sep id=person-crnm name=person-crnm class=form-control ng-model=vm.data.person.crnm autocomplete=off placeholder=\"Digite seu RNE/CRNM\" required><div ng-messages=\"confirmacaoproposta[\'person-crnm\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CRNM!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(vm.isEstrangeiro || vm.data.person.crnm)\" class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RNE/CRNM</h5><label ng-if=\"uploaders[\'crnm\'].queue.length != uploaders[\'crnm\'].queueLimit\" class=file-label for=person-crnmFile nv-file-drop nv-file-over uploader=\"uploaders[\'crnm\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'crnm\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'crnm\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'crnm\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'crnm\']\" ng-model=vm.data.uploads.proprietario.crnm ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=person-crnmFile name=person-crnmFile ng-disabled=\"uploaders[\'crnm\'].queue.length == uploaders[\'crnm\'].queueLimit\" ng-model=vm.data.person.crnmFile><div ng-messages=\"confirmacaoproposta[\'person-crnmFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'crnm\'].queue.length\">Adicione o documento</h6></div><div ng-if=vm.isPessoaFisica class=\"col-12 col-md-4 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-cpf>Qual o seu CPF?</label><input type=tel id=person-cpf name=person-cpf class=form-control ng-model=vm.data.person.cpf autocomplete=off placeholder=\"Digite seu CPF\" ui-br-cpf-mask required><div ng-messages=\"confirmacaoproposta[\'person-cpf\'].$error\" style=\"color: red\" role=alert><div ng-message=cpf>CPF inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=vm.isPessoaFisica class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>CPF</h5><label ng-if=\"\n                uploaders[\'cpf\'].queue.length != uploaders[\'cpf\'].queueLimit\n              \" class=file-label for=person-cpfFile nv-file-drop nv-file-over uploader=\"uploaders[\'cpf\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'cpf\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'cpf\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'cpf\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'cpf\']\" ng-model=vm.data.uploads.proprietario.cpf ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=person-cpfFile name=person-cpfFile ng-disabled=\"uploaders[\'cpf\'].queue.length == uploaders[\'cpf\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-cpfFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'cpf\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-birthday>Qual sua data de nascimento?</label><div id=datepicker-form-entrance class=\"d-flex date\" data-provide=datepicker><input ng-change=\"vm.validateBornDate(\'person-birthday\', confirmacaoproposta)\" type=text id=person-birthday name=person-birthday class=form-control placeholder=dd/mm/aaaa ng-model=vm.data.person.birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{ sbmtd: vm.subterror }\" required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"confirmacaoproposta[\'person-birthday\'].$error\" style=\"color: red\" role=alert><div ng-message=date>Data de nascimento inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3\"><label for=person-profissao>Qual é sua profissão?</label><input id=person-profissao name=person-profissao class=form-control ng-model=vm.data.person.profissao autocomplete=off placeholder=\"Ex.: Professor(a)\"><div ng-messages=\"confirmacaoproposta[\'person-profissao\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-maritalStatus>Qual seu estado civil?</label><select id=person-maritalStatus name=person-maritalStatus class=form-control ng-model=vm.data.person.maritalStatus ng-change=vm.changeMaritalStatus() ng-options=\"x for x in vm.maritalStatuses\" required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'person-maritalStatus\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form\" ng-if=!vm.isPessoaFisica><h4>Dados da empresa</h4><div class=\"col-12 col-md-5 col-lg-6 p-0 mb-3\"><label red-dot for=person-name>Razão social</label><input type=text id=person-name name=person-name class=form-control ng-model=vm.data.person.name autocomplete=off placeholder=\"Digite a razão social da empresa\" required></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=person-cnpj>CNPJ da empresa</label><input type=tel id=person-cnpj name=person-cnpj class=form-control ng-model=vm.data.person.cnpj autocomplete=off ui-br-cnpj-mask placeholder=\"Digite o CNPJ\" required><div ng-messages=\"confirmacaoproposta[\'person-cnpj\'].$error\" style=\"color: red\" role=alert><div ng-message=cnpj>CNPJ inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3 text-nowrap\"><label for=person-ie>Inscrição estadual</label><input type=text ui-number-mask=0 ui-hide-group-sep id=person-ie name=person-ie class=form-control ng-model=vm.data.person.ie autocomplete=off placeholder=\"Digite a inscrição estadual\"><div ng-messages=\"confirmacaoproposta[\'person-ie\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 p-0 mb-3\"><label red-dot for=person-activity>Ramo de atividade</label><input id=person-activity name=person-activity class=form-control ng-model=vm.data.person.activity autocomplete=off placeholder=\"Ex.: Comércio\" required><div ng-messages=\"confirmacaoproposta[\'person-activity\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>Contrato social e última alteração</h5><label ng-if=\"\n                uploaders[\'contSocial\'].queue.length !=\n                uploaders[\'contSocial\'].queueLimit\n              \" class=file-label for=person-contratoSocial nv-file-drop nv-file-over uploader=\"uploaders[\'contSocial\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'contSocial\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'contSocial\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'contSocial\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'contSocial\']\" ng-model=vm.data.uploads.proprietario.contSocial ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=person-contratoSocial name=person-contratoSocial ng-disabled=\"uploaders[\'contSocial\'].queue.length == uploaders[\'contSocial\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-contratoSocial\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'contSocial\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>Comprovante de endereço</h5><label ng-if=\"\n                uploaders[\'compEnd\'].queue.length !=\n                uploaders[\'compEnd\'].queueLimit\n              \" class=file-label for=person-comprvEnd nv-file-drop nv-file-over uploader=\"uploaders[\'compEnd\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'compEnd\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'compEnd\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'compEnd\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'compEnd\']\" id=person-comprvEnd name=person-comprvEnd ng-model=vm.data.uploads.proprietario.compEnd ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" ng-disabled=\"uploaders[\'compEnd\'].queue.length == uploaders[\'compEnd\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-comprvEnd\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'compEnd\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>IRPJ do último exercício</h5><label ng-if=\"\n                uploaders[\'irpj\'].queue.length != uploaders[\'irpj\'].queueLimit\n              \" class=file-label for=person-irpj nv-file-drop nv-file-over uploader=\"uploaders[\'irpj\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'irpj\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'irpj\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'irpj\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'irpj\']\" ng-model=vm.data.uploads.proprietario.irpj ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=person-irpj name=person-irpj ng-disabled=\"uploaders[\'irpj\'].queue.length == uploaders[\'irpj\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-irpj\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'irpj\'].queue.length\">Adicione o documento</h6></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form border-form-mobile\"><h4>Endereço</h4><div class=\"col-6 col-md-2 col-lg-4 p-0 mb-3\"><label red-dot for=person-cep>CEP</label><input type=text id=person-cep name=person-cep class=form-control ng-model=vm.data.person.address.cep ui-br-cep-mask ng-blur=\"vm.getCEP(\'person\')\" autocomplete=off placeholder=00000-000 required><div ng-messages=\"confirmacaoproposta[\'person-cep\'].$error\" style=\"color: red\" role=alert><div ng-message=cep>CEP inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-md-2\"><label red-dot for=person-rua>Logradouro</label><input type=text id=person-rua name=person-rua class=form-control ng-model=vm.data.person.address.rua autocomplete=off placeholder=\"Digite o nome da rua\" required><div ng-messages=\"confirmacaoproposta[\'person-rua\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-2 col-lg-2 p-0 text-nowrap\"><label red-dot for=person-numero>Número</label><input type=text ui-hide-group-sep id=person-numero name=person-numero class=form-control ng-model=vm.data.person.address.numero autocomplete=off placeholder=\"Ex.: 999\" ng-disabled=vm.without_number_person required><div ng-messages=\"confirmacaoproposta[\'person-numero\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div style=\"padding: 2.3em 0em 0em 1em\"><input type=checkbox name=without_number_person ng-click=\"vm.setWithoutNumber($event, \'person\')\" ng-model=vm.without_number_person id=without_number_person><label class=\"form-check-label ml-2\" for=without_number_person>Propriedade sem número</label></div></div><div class=\"col-12 col-md-8 col-lg-8 p-0 mb-3\"><label for=person-complemento>Complemento &nbsp; <span class=\"text-secondary text-nowrap\">(campo opcional)</span></label><input type=text id=person-complemento name=person-complemento class=form-control ng-model=vm.data.person.address.complemento autocomplete=off placeholder=\"Ex.: Casa\"></div><div class=\"col-12 col-md-6 col-lg-8 p-0 mb-3\"><label red-dot for=person-bairro>Bairro</label><input type=text id=person-bairro name=person-bairro class=form-control ng-model=vm.data.person.address.bairro autocomplete=off placeholder=\"Digite o nome do bairro\" required><div ng-messages=\"confirmacaoproposta[\'person-bairro\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-md-2\"><label red-dot for=person-cidade>Cidade</label><input type=text id=person-cidade name=person-cidade class=form-control ng-model=vm.data.person.address.cidade autocomplete=off placeholder=\"Digite o nome da cidade\" disabled required><div ng-messages=\"confirmacaoproposta[\'person-cidade\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-2 col-lg-2 p-0\"><label red-dot for=person-estado>Estado</label><input type=text id=person-estado name=person-estado class=form-control ng-model=vm.data.person.address.estado disabled autocomplete=off placeholder=UF required><div ng-messages=\"confirmacaoproposta[\'person-estado\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form border-form-mobile conjuge-background-color\" ng-if=\"vm.isCasado && vm.isPessoaFisica\"><h4>Dados do cônjuge</h4><div class=\"col-12 col-md-5 col-lg-6 p-0 mb-3\"><label red-dot for=conjuge-name>Nome completo</label><input type=text id=conjuge-name name=conjuge-name class=form-control ng-model=vm.data.conjuge.nome autocomplete=off placeholder=\"Digite o nome\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-name\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-phone>Telefone de contato</label><input type=tel id=conjuge-phone name=conjuge-phone ui-br-phone-number=areaCode class=\"form-control ng-valid-br-phone-number\" ng-model=vm.data.conjuge.phone autocomplete=off placeholder=\"(00) 99999-9999\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-phone\'].$error\" style=\"color: red\" role=alert><div ng-message=brPhoneNumber>Telefone inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-8 p-0 mb-3\"><label red-dot for=conjuge-email>Email</label><input type=text id=conjuge-email name=conjuge-email class=form-control ng-model=vm.data.conjuge.email autocomplete=off ng-pattern=\"/[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/\" placeholder=email@dominio.com required><div ng-messages=\"confirmacaoproposta[\'conjuge-email\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Email inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 p-0 check-estrangeiro-conj\"><input ng-model=isEstrangeiroConj ng-click=\"vm.checkEstrangeiro($event, \'conjuge\')\" type=checkbox><label>Estrangeiro</label></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-nationality>Nacionalidade</label><div class=input-conj-nacionalidade><input required ng-disabled=!isEstrangeiroConj type=text id=conjuge-nationality name=conjuge-nationality class=form-control ng-model=vm.data.conjuge.nationality uib-typeahead=\"row as row.label for row in vm.getNationality($viewValue)\"> <i class=\"fas fa-search\"></i></div><div ng-messages=\"confirmacaoproposta[\'conjuge-nationality\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=!isEstrangeiroConj class=\"col-12 col-md-5 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=conjuge-rg>RG</label><input type=text ui-number-mask=0 ui-hide-group-sep id=conjuge-rg name=conjuge-rg class=form-control ng-model=vm.data.conjuge.rg autocomplete=off placeholder=\"Digite o RG\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-name\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=!isEstrangeiroConj class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RG</h5><label ng-if=\"\n                uploaders[\'conjRg\'].queue.length !=\n                uploaders[\'conjRg\'].queueLimit\n              \" class=file-label for=conjuge-rgFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjRg\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjRg\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjRg\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjRg\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjRg\']\" ng-model=vm.data.uploads.conjuge.conjRg ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-rgFile name=conjuge-rgFile ng-disabled=\"uploaders[\'conjRg\'].queue.length == uploaders[\'conjRg\'].queueLimit\"><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'conjRg\'].queue.length\">Adicione o documento</h6><div ng-messages=\"confirmacaoproposta[\'conjuge-rgFile\'].$error\" style=\"color: red\" role=alert></div></div><div ng-if=isEstrangeiroConj class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=conjuge-crnm>RNE/CRNM</label><input type=text ui-number-mask=0 ui-hide-group-sep id=conjuge-crnm name=conjuge-crnm class=form-control ng-model=vm.data.conjuge.crnm autocomplete=off placeholder=\"Digite seu RNE/CRNM\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-crnm\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CRNM!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=isEstrangeiroConj class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RNE/CRNM</h5><label ng-if=\"uploaders[\'conjCrnm\'].queue.length != uploaders[\'conjCrnm\'].queueLimit\" class=file-label for=conjuge-crnmFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjCrnm\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjCrnm\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjCrnm\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjCrnm\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjCrnm\']\" ng-model=vm.data.uploads.conjuge.conjCrnm ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-crnmFile name=conjuge-crnmFile ng-disabled=\"uploaders[\'conjCrnm\'].queue.length == uploaders[\'conjCrnm\'].queueLimit\" ng-model=vm.data.conjuge.crnmFile><div ng-messages=\"confirmacaoproposta[\'conjuge-crnmFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'conjCrnm\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=conjuge-cpf>CPF</label><input type=tel id=conjuge-cpf name=conjuge-cpf class=form-control ng-model=vm.data.conjuge.cpf autocomplete=off ui-br-cpf-mask placeholder=\"Digite o CPF\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-cpf\'].$error\" style=\"color: red\" role=alert><div ng-message=cpf>CPF inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>CPF</h5><label ng-if=\"\n                uploaders[\'conjCpf\'].queue.length !=\n                uploaders[\'conjCpf\'].queueLimit\n              \" class=file-label for=conjuge-cpfFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjCpf\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjCpf\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjCpf\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjCpf\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjCpf\']\" ng-model=vm.data.uploads.conjuge.conjCpf ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-cpfFile name=conjuge-cpfFile ng-disabled=\"uploaders[\'conjCpf\'].queue.length == uploaders[\'conjCpf\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-conjCpf\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'conjCpf\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-birthday>Data de nascimento</label><div id=datepicker-form-entrance class=\"d-flex date\" data-provide=datepicker><input ng-change=\"vm.validateBornDate(\'conjuge-birthday\', confirmacaoproposta)\" type=text id=conjuge-birthday name=conjuge-birthday class=form-control placeholder=dd/mm/aaaa ng-model=vm.data.conjuge.birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{ sbmtd: vm.subterror }\" required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"confirmacaoproposta[\'conjuge-birthday\'].$error\" style=\"color: red\" role=alert><div ng-message=date>Data de nascimento inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3\"><label for=conjuge-profissao>Profissão</label><input id=conjuge-profissao name=conjuge-profissao class=form-control ng-model=vm.data.conjuge.profissao autocomplete=off placeholder=\"Ex.: Professor(a)\"><div ng-messages=\"confirmacaoproposta[\'conjuge-profissao\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=mb-2><h4>Endereço do cônjuge</h4><div class=\"form-check mb-2 ml-1\" ng-if=vm.isCasado><input class=form-check-input type=checkbox name=sameAddress ng-click=vm.useSameAddress($event) ng-model=vm.autocomplete_endereco ng-init=vm.initConjugeAddressField() id=sameAddress><label class=\"form-check-label ml-2\" for=sameAddress>Usar o endereço preenchido</label></div><div ng-show=!vm.autocomplete_endereco class=\"col-8 col-md-2 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-cep>CEP</label><input type=text id=conjuge-cep name=conjuge-cep class=form-control ng-model=vm.data.conjuge.address.cep ui-br-cep-mask ng-blur=\"vm.getCEP(\'conjuge\')\" autocomplete=off placeholder=00000-000 required><div ng-messages=\"confirmacaoproposta[\'conjuge-cep\'].$error\" style=\"color: red\" role=alert><div ng-message=cep>CEP inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-2\"><label red-dot for=conjuge-rua>Logradouro</label><input type=text id=conjuge-rua name=conjuge-rua class=form-control ng-model=vm.data.conjuge.address.rua autocomplete=off placeholder=\"Digite o nome da rua\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-rua\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-2 col-lg-2 p-0 text-nowrap\"><label red-dot for=conjuge-numero>Número</label><input type=text ui-hide-group-sep id=conjuge-numero name=conjuge-numero class=form-control ng-model=vm.data.conjuge.address.numero autocomplete=off placeholder=\"Ex.: 999\" ng-disabled=vm.without_number_conjuge required><div ng-messages=\"confirmacaoproposta[\'conjuge-numero\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div style=\"padding: 2.3em 0em 0em 1em\"><input type=checkbox name=without_number_conjuge ng-click=\"vm.setWithoutNumber($event, \'conjuge\')\" ng-model=vm.without_number_conjuge id=without_number_conjuge><label class=\"form-check-label ml-2\" for=without_number_conjuge>Propriedade sem número</label></div></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-8 col-lg-8 p-0 mb-3\"><label for=conjuge-complemento>Complemento &nbsp; <span class=text-secondary>(campo opcional)</span></label><input type=text id=conjuge-complemento name=conjuge-complemento class=form-control ng-model=vm.data.conjuge.address.complemento autocomplete=off placeholder=\"Ex.: Casa\"></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-8 col-lg-8 p-0 mb-3\"><label red-dot for=conjuge-bairro>Bairro</label><input type=text id=conjuge-bairro name=conjuge-bairro class=form-control ng-model=vm.data.conjuge.address.bairro autocomplete=off placeholder=\"Digite o nome do bairro\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-bairro\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=d-md-flex><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-md-2\"><label red-dot for=conjuge-cidade>Cidade</label><input type=text id=conjuge-cidade name=conjuge-cidade class=form-control ng-model=vm.data.conjuge.address.cidade autocomplete=off placeholder=\"Digite o nome da cidade\" disabled required><div ng-messages=\"confirmacaoproposta[\'conjuge-cidade\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-2 col-lg-2 p-0\"><label red-dot for=conjuge-estado>Estado</label><input type=text id=conjuge-estado name=conjuge-estado class=form-control ng-model=vm.data.conjuge.address.estado autocomplete=off placeholder=UF disabled required><div ng-messages=\"confirmacaoproposta[\'conjuge-estado\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form border-form-mobile\" ng-if=!vm.isPessoaFisica><h4>Dados pessoais do sócio administrador</h4><div class=\"col-12 col-md-5 col-lg-6 p-0 mb-3\"><label red-dot for=socio-name>Qual é o seu nome completo?</label><input type=text id=socio-name name=socio-name class=form-control ng-model=vm.data.person.socio.name autocomplete=off placeholder=\"Digite o seu nome\" required><div ng-messages=\"confirmacaoproposta[\'socio-name\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-4 p-0 mb-3\"><label red-dot for=socio-phone>Telefone de contato?</label><input type=text id=socio-phone name=socio-phone ui-br-phone-number=areaCode class=\"form-control ng-valid-br-phone-number\" ng-model=vm.data.person.socio.phone autocomplete=off placeholder=\"(00) 99999-9999\" required><div ng-messages=\"confirmacaoproposta[\'socio-phone\'].$error\" style=\"color: red\" role=alert><div ng-message=brPhoneNumber>Telefone inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-5 col-lg-8 p-0 mb-3\"><label red-dot for=socio-email>Qual o seu email?</label><input type=email id=socio-email name=socio-email class=form-control ng-model=vm.data.person.socio.email ng-pattern=\"/[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/\" autocomplete=off placeholder=email@dominio.com required><div ng-messages=\"confirmacaoproposta[\'socio-email\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Email inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 p-0 check-estrangeiro-socio\"><input ng-model=vm.isEstrangeiroSocio ng-click=\"vm.checkEstrangeiro($event, \'socio\')\" type=checkbox><label>Estrangeiro</label></div><div class=\"col-12 col-md-3 col-lg-4 p-0 text-nowrap mb-3\"><label red-dot for=socio-nationality>Qual é sua nacionalidade?</label><div class=input-socio-nacionalidade><input required ng-disabled=!vm.isEstrangeiroSocio type=text id=socio-nationality name=socio-nationality class=form-control ng-model=vm.data.person.socio.nationality uib-typeahead=\"row as row.label for row in vm.getNationality($viewValue)\"> <i class=\"fas fa-search\"></i></div><div ng-messages=\"confirmacaoproposta[\'socio-nationality\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(!vm.isEstrangeiroSocio && !vm.data.person.socio.crnm)\" class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=socio-rg>Qual o seu RG?</label><input required type=text ui-number-mask=0 ui-hide-group-sep id=socio-rg name=socio-rg class=form-control ng-model=vm.data.person.socio.rg autocomplete=off placeholder=\"Digite seu RG\"><div ng-messages=\"confirmacaoproposta[\'socio-rg\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(!vm.isEstrangeiroSocio && !vm.data.person.socio.crnm)\" class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RG</h5><label ng-if=\"uploaders[\'rg\'].queue.length != uploaders[\'rg\'].queueLimit\" class=file-label for=person-rgFile nv-file-drop nv-file-over uploader=\"uploaders[\'rg\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'rg\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'rg\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'rg\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'rg\']\" ng-model=vm.data.uploads.socio.rg ng-click=\"vm.data.actualPartUpload = \'socio\'\" id=person-rgFile name=person-rgFile ng-disabled=\"uploaders[\'rg\'].queue.length == uploaders[\'rg\'].queueLimit\" ng-model=vm.data.person.rgFile><div ng-messages=\"confirmacaoproposta[\'person-rgFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'rg\'].queue.length\">Adicione o documento</h6><div ng-messages=\"confirmacaoproposta[\'person-rgFile\'].$error\" style=\"color: red\" role=alert></div></div><div ng-if=\"(vm.isEstrangeiroSocio || vm.data.person.socio.crnm)\" class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=socio-crnm>RNE/CRNM</label><input type=text ui-number-mask=0 ui-hide-group-sep id=socio-crnm name=socio-crnm class=form-control ng-model=vm.data.person.socio.crnm autocomplete=off placeholder=\"Digite seu RNE/CRNM\" required><div ng-messages=\"confirmacaoproposta[\'socio-crnm\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CRNM!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=\"(vm.isEstrangeiroSocio || vm.data.person.socio.crnm)\" class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RNE/CRNM</h5><label ng-if=\"uploaders[\'crnm\'].queue.length != uploaders[\'crnm\'].queueLimit\" class=file-label for=socio-crnmFile nv-file-drop nv-file-over uploader=\"uploaders[\'crnm\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'crnm\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'crnm\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'crnm\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'crnm\']\" ng-model=vm.data.uploads.proprietario.crnm ng-click=\"vm.data.actualPartUpload = \'proprietario\'\" id=socio-crnmFile name=socio-crnmFile ng-disabled=\"uploaders[\'crnm\'].queue.length == uploaders[\'crnm\'].queueLimit\" ng-model=vm.data.socio.crnmFile><div ng-messages=\"confirmacaoproposta[\'socio-crnmFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'crnm\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=socio-cpf>Qual o seu CPF?</label><input type=tel id=socio-cpf name=socio-cpf class=form-control ng-model=vm.data.person.socio.cpf autocomplete=off ui-br-cpf-mask placeholder=\"Digite seu CPF\" required><div ng-messages=\"confirmacaoproposta[\'socio-cpf\'].$error\" style=\"color: red\" role=alert><div ng-message=cpf>CPF inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>CPF</h5><label ng-if=\"\n                uploaders[\'cpf\'].queue.length != uploaders[\'cpf\'].queueLimit\n              \" class=file-label for=person-cpfFile nv-file-drop nv-file-over uploader=\"uploaders[\'cpf\']\" ng-model=vm.data.person.cpfFile class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'cpf\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'cpf\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'cpf\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'cpf\']\" id=person-cpfFile name=person-cpfFile ng-model=vm.data.uploads.socio.cpf ng-click=\"vm.data.actualPartUpload = \'socio\'\" ng-disabled=\"uploaders[\'cpf\'].queue.length == uploaders[\'cpf\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-cpfFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'cpf\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=socio-birthday>Qual sua data de nascimento?</label><div id=datepicker-form-entrance class=\"d-flex date\" data-provide=datepicker><input ng-change=\"vm.validateBornDate(\'socio-birthday\', confirmacaoproposta)\" type=text id=socio-birthday name=socio-birthday class=form-control placeholder=dd/mm/aaaa ng-model=vm.data.person.socio.birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{ sbmtd: vm.subterror }\" required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"confirmacaoproposta[\'socio-birthday\'].$error\" style=\"color: red\" role=alert><div ng-message=date>Data de nascimento inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3\"><label for=socio-profissao>Qual é sua profissão?</label><input id=socio-profissao name=socio-profissao class=form-control ng-model=vm.data.person.socio.profissao autocomplete=off placeholder=\"Ex.: Professor(a)\"><div ng-messages=\"confirmacaoproposta[\'socio-profissao\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=socio-maritalStatus>Qual seu estado civil?</label><select id=socio-maritalStatus name=socio-maritalStatus class=form-control ng-options=\"x for x in vm.maritalStatuses\" ng-change=vm.changeMaritalStatus() ng-model=vm.data.person.socio.maritalStatus required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'socio-maritalStatus\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form border-form-mobile conjuge-background-color\" ng-if=\"vm.isCasado && !vm.isPessoaFisica\"><h4>Dados do cônjuge</h4><div class=\"col-12 col-md-4 p-0 mb-3\"><label red-dot for=conjuge-name>Nome completo</label><input type=text id=conjuge-name name=conjuge-name class=form-control ng-model=vm.data.conjuge.nome autocomplete=off placeholder=\"Digite o nome\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-name\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 p-0 mb-3\"><label red-dot for=conjuge-phone>Telefone de contato</label><input type=text id=conjuge-phone name=conjuge-phone ui-br-phone-number=areaCode class=\"form-control ng-valid-br-phone-number\" ng-model=vm.data.conjuge.phone autocomplete=off placeholder=\"(00) 99999-9999\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-phone\'].$error\" style=\"color: red\" role=alert><div ng-message=brPhoneNumber>Telefone inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-8 p-0 mb-3\"><label red-dot for=conjuge-email>Email</label><input type=text id=conjuge-email name=conjuge-email class=form-control ng-model=vm.data.conjuge.email autocomplete=off ng-pattern=\"/[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/\" placeholder=email@dominio.com required><div ng-messages=\"confirmacaoproposta[\'conjuge-email\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Email inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-3 p-0 check-estrangeiro-conj\"><input ng-model=isEstrangeiroConj ng-click=\"vm.checkEstrangeiro($event, \'conjuge\')\" type=checkbox><label>Estrangeiro</label></div><div class=\"col-12 col-md-4 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-nationality>Nacionalidade</label><div class=input-conj-nacionalidade><input required ng-disabled=!isEstrangeiroConj type=text id=conjuge-nationality name=conjuge-nationality class=form-control ng-model=vm.data.conjuge.nationality uib-typeahead=\"row as row.label for row in vm.getNationality($viewValue)\"> <i class=\"fas fa-search\"></i></div><div ng-messages=\"confirmacaoproposta[\'conjuge-nationality\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=!isEstrangeiroConj class=\"col-12 col-md-3 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-rg>RG</label><input required type=text ui-number-mask=0 ui-hide-group-sep id=conjuge-rg name=conjuge-rg class=form-control ng-model=vm.data.conjuge.rg autocomplete=off placeholder=\"Digite o RG\"><div ng-messages=\"confirmacaoproposta[\'conjuge-rg\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=!isEstrangeiroConj class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RG</h5><label ng-if=\"\n                uploaders[\'conjRg\'].queue.length !=\n                uploaders[\'conjRg\'].queueLimit\n              \" class=file-label for=conjuge-rgFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjRg\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjRg\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjRg\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjRg\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjRg\']\" ng-model=vm.data.uploads.conjuge.conjRg ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-rgFile name=conjuge-rgFile ng-disabled=\"uploaders[\'conjRg\'].queue.length == uploaders[\'conjRg\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'conjuge-rgFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'conjRg\'].queue.length\">Adicione o documento</h6></div><div ng-if=isEstrangeiroConj class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=conjuge-crnm>RNE/CRNM</label><input type=text ui-number-mask=0 ui-hide-group-sep id=conjuge-crnm name=conjuge-crnm class=form-control ng-model=vm.data.conjuge.crnm autocomplete=off placeholder=\"Digite seu RNE/CRNM\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-crnm\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CRNM!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-if=isEstrangeiroConj class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>RNE/CRNM</h5><label ng-if=\"uploaders[\'conjCrnm\'].queue.length != uploaders[\'conjCrnm\'].queueLimit\" class=file-label for=conjuge-crnmFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjCrnm\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjCrnm\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjCrnm\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjCrnm\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjCrnm\']\" ng-model=vm.data.uploads.conjuge.conjCrnm ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-crnmFile name=conjuge-crnmFile ng-disabled=\"uploaders[\'conjCrnm\'].queue.length == uploaders[\'conjCrnm\'].queueLimit\" ng-model=vm.data.conjuge.crnmFile><div ng-messages=\"confirmacaoproposta[\'conjuge-crnmFile\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-3 text-secondary\" ng-if=\"!uploaders[\'conjCrnm\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-cpf>CPF</label><input type=tel id=conjuge-cpf name=conjuge-cpf class=form-control ng-model=vm.data.conjuge.cpf autocomplete=off ui-br-cpf-mask placeholder=\"Digite o CPF\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-cpf\'].$error\" style=\"color: red\" role=alert><div ng-message=cpf>CPF inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-6 col-lg-10 p-0\"><h5>CPF</h5><label ng-if=\"\n                uploaders[\'conjCpf\'].queue.length !=\n                uploaders[\'conjCpf\'].queueLimit\n              \" class=file-label for=conjuge-cpfFile nv-file-drop nv-file-over uploader=\"uploaders[\'conjCpf\']\" class=well>CLIQUE ou ARRASTE um arquivo</label><ul class=d-flex><li class=mr-2 ng-if=\"uploaders[\'conjCpf\'].queue.length\" ng-repeat=\"(idx, item) in uploaders[\'conjCpf\'].queue\"><span class=text-dark ng-bind=item.file.originalName></span><div><div ng-show=\"uploaders[\'conjCpf\'].isHTML5\" ng-thumb=\"{ file: item._file, height: 100 }\" ng-click=removeItem(item)></div><div class=progress><div class=progress-bar role=progressbar ng-style=\"{ width: item.progress + \'%\' }\">{{ item.progress + \'%\' }}</div></div></div></li></ul><input type=file nv-file-select uploader=\"uploaders[\'conjCpf\']\" ng-model=vm.data.uploads.conjuge.conjCpf ng-click=\"vm.data.actualPartUpload = \'conjuge\'\" id=conjuge-cpfFile name=conjuge-cpfFile ng-disabled=\"uploaders[\'conjCpf\'].queue.length == uploaders[\'conjCpf\'].queueLimit\"><div ng-messages=\"confirmacaoproposta[\'person-conjCpf\'].$error\" style=\"color: red\" role=alert></div><h6 class=\"mb-4 text-secondary\" ng-if=\"!uploaders[\'conjCpf\'].queue.length\">Adicione o documento</h6></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\"><label red-dot for=conjuge-birthday>Data de nascimento</label><div id=datepicker-form-entrance class=\"d-flex date\" data-provide=datepicker><input ng-change=\"vm.validateBornDate(\'conjuge-birthday\', confirmacaoproposta)\" type=text id=conjuge-birthday name=conjuge-birthday class=form-control placeholder=dd/mm/aaaa ng-model=vm.data.conjuge.birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{ sbmtd: vm.subterror }\" required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"confirmacaoproposta[\'conjuge-birthday\'].$error\" style=\"color: red\" role=alert><div ng-message=date>Data de nascimento inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 p-0 mb-3\"><label for=conjuge-profissao>Profissão</label><input id=conjuge-profissao name=conjuge-profissao class=form-control ng-model=vm.data.conjuge.profissao autocomplete=off placeholder=\"Ex.: Professor(a)\"><div ng-messages=\"confirmacaoproposta[\'conjuge-profissao\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=mb-2><h4>Endereço do cônjuge</h4><div class=\"form-check mb-2 ml-1\" ng-if=vm.isCasado><input class=form-check-input type=checkbox name=sameAddress ng-click=vm.useSameAddress($event) ng-model=vm.autocomplete_endereco ng-init=vm.initConjugeAddressField() id=sameAddress><label class=\"form-check-label ml-2\" for=sameAddress>Usar o endereço preenchido</label></div><div ng-show=!vm.autocomplete_endereco class=\"col-6 col-md-2 col-lg-4 p-0 mb-3\"><label red-dot for=conjuge-cep>CEP</label><input type=text id=conjuge-cep name=conjuge-cep class=form-control ng-model=vm.data.conjuge.address.cep ui-br-cep-mask ng-blur=\"vm.getCEP(\'conjuge\')\" autocomplete=off placeholder=00000-000 required><div ng-messages=\"confirmacaoproposta[\'conjuge-cep\'].$error\" style=\"color: red\" role=alert><div ng-message=cep>CEP inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-md-2\"><label red-dot for=conjuge-rua>Logradouro</label><input type=text id=conjuge-rua name=conjuge-rua class=form-control ng-model=vm.data.conjuge.address.rua autocomplete=off placeholder=\"Digite o nome da rua\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-rua\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-2 col-lg-2 p-0 text-nowrap\"><label red-dot for=conjuge-numero>Número</label><input type=text ui-hide-group-sep id=conjuge-numero name=conjuge-numero class=form-control ng-model=vm.data.conjuge.address.numero autocomplete=off placeholder=\"Ex.: 999\" ng-disabled=vm.without_number_conjuge required><div ng-messages=\"confirmacaoproposta[\'conjuge-numero\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div style=\"padding: 2.3em 0em 0em 1em\"><input type=checkbox name=without_number_conjuge ng-click=\"vm.setWithoutNumber($event, \'conjuge\')\" ng-model=vm.without_number_conjuge id=without_number_conjuge><label class=\"form-check-label ml-2\" for=without_number_conjuge>Propriedade sem número</label></div></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-8 col-lg-8 p-0 mb-3\"><label for=conjuge-complemento>Complemento &nbsp; <span class=\"text-secondary text-nowrap\">(campo opcional)</span></label><input type=text id=conjuge-complemento name=conjuge-complemento class=form-control ng-model=vm.data.conjuge.address.complemento autocomplete=off placeholder=\"Ex.: Casa\"></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-8 col-lg-8 p-0 mb-3\"><label red-dot for=conjuge-bairro>Bairro</label><input type=text id=conjuge-bairro name=conjuge-bairro class=form-control ng-model=vm.data.conjuge.address.bairro autocomplete=off placeholder=\"Digite o nome do bairro\" required><div ng-messages=\"confirmacaoproposta[\'conjuge-bairro\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=d-md-flex><div class=\"col-12 col-md-4 col-lg-6 p-0 mr-md-2\"><label red-dot for=conjuge-cidade>Cidade</label><input type=text id=conjuge-cidade name=conjuge-cidade class=form-control ng-model=vm.data.conjuge.address.cidade autocomplete=off placeholder=\"Digite o nome da Cidade\" disabled required><div ng-messages=\"confirmacaoproposta[\'conjuge-cidade\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div ng-show=!vm.autocomplete_endereco class=\"col-12 col-md-2 col-lg-2 p-0\"><label red-dot for=conjuge-estado>Estado</label><input type=text id=conjuge-estado name=conjuge-estado class=form-control ng-model=vm.data.conjuge.address.estado disabled autocomplete=off placeholder=UF required><div ng-messages=\"confirmacaoproposta[\'conjuge-estado\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div></div><div class=\"col-12 col-md-3 col-lg-4 p-0 mb-3 text-nowrap\" ng-if=\"!vm.isProp && currentProposta.tpng_id != 1\"><label red-dot for=rentDay>Dia do pagamento do aluguel</label><select id=rentDay name=rentDay class=form-control ng-model=vm.data.rentDay ng-options=\"x for x in vm.diasAluguel\" required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'rentDay\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"mb-4 col-12 col-lg-8 p-0 pt-3 p-md-5 border-form border-form-mobile\" ng-if=vm.isProp><h4>Dados Bancários</h4><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label for=pagamento>Forma de pagamento</label><select id=pagamento name=pagamento class=form-control ng-model=vm.pagamentoSelect ng-options=\"x.label for x in vm.pagamento track by x.id\"><option value=\"\" selected>Selecione</option></select></div></div><div ng-if=[12].includes(vm.pagamentoSelect.id)><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=pix>Tipo chave pix</label><select id=pix name=pix class=form-control ng-model=vm.pixSelect ng-options=\"x.label for x in vm.pix track by x.id\" required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'pix\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 p-0\"><label red-dot for=chavepix>Chave pix</label><input id=chavepix name=chavepixCPF class=form-control ng-model=vm.data.banco.chavepix autocomplete=off restrict=reject ui-br-cpf-mask required pattern=\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2} ng-disabled=\"vm.pixSelect.id == null\" ng-if=\"vm.chavepix[\'CPF\'] || vm.pixSelect.id == null\"> <input id=chavepix name=chavepixCNPJ class=form-control ng-model=vm.data.banco.chavepix autocomplete=off restrict=reject ui-br-cnpj-mask required pattern=\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}\\-\\d{2} ng-if=\"vm.chavepix[\'CNPJ\']\"> <input id=chavepix name=chavepixCel class=\"form-control ng-valid-br-phone-number\" ng-model=vm.data.banco.chavepix autocomplete=off required ng-if=\"vm.chavepix[\'Celular\']\" pattern=\"[+55]+ \\(\\d{2}\\) \\d{4,5}-\\d{4}\" placeholder=\"+55 (00) 00000-0000\"> <input id=chavepix name=chavepixEmail type=email class=form-control ng-model=vm.data.banco.chavepix restrict=reject required ng-if=\"vm.chavepix[\'E-mail\']\" pattern=\\S+@\\S+\\.\\S+ autocomplete=off> <input id=chavepix name=chavepixChaveAl class=form-control ng-model=vm.data.banco.chavepix required ng-if=\"vm.chavepix[\'Chave Aleatória\']\" placeholder=XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX pattern=[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12} autocomplete=off><div ng-messages=\"confirmacaoproposta[\'chavepixCPF\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CPF inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div><div ng-messages=\"confirmacaoproposta[\'chavepixCNPJ\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>CNPJ inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div><div ng-messages=\"confirmacaoproposta[\'chavepixCel\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Celular inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div><div ng-messages=\"confirmacaoproposta[\'chavepixEmail\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>E-mail inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div><div ng-messages=\"confirmacaoproposta[\'chavepixChaveAl\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Chave Aleatória inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div><div ng-if=\"[1, 2, 5, 6, 12].includes(vm.pagamentoSelect.id)\"><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=banco>Banco</label><select id=banco name=banco class=form-control ng-model=vm.bancoSelect ng-options=\"x.label for x in vm.banks track by x.id\" required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'banco\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=agencia>Agência (com dígito)</label><input id=agencia name=agencia class=form-control ng-model=vm.data.banco.agencia autocomplete=off pattern=^[0-9]{3,10}[-]{0,1}[0-9xX]{0,2}$ restrict=reject required ng-init=vm.makeAgenciaMask()><div ng-messages=\"confirmacaoproposta[\'agencia\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Agência inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=conta>Conta (com dígito)</label><input id=conta name=conta class=form-control ng-model=vm.data.banco.conta autocomplete=off pattern=^[0-9]{3,22}[-]{0,1}[0-9xX]{0,2}$ restrict=reject required ng-init=vm.makeContaMask()><div ng-messages=\"confirmacaoproposta[\'conta\'].$error\" style=\"color: red\" role=alert><div ng-message=pattern>Conta inválida!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=tipoConta>Tipo de conta</label><select id=tipoConta name=tipoConta class=form-control ng-model=vm.contaSelect ng-options=\"x.label for x in vm.conta\" required><option value=\"\" disabled selected>Selecione</option></select><div ng-messages=\"confirmacaoproposta[\'tipoConta\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div><div ng-if=\"[1, 2, 3, 5, 6, 12].includes(vm.pagamentoSelect.id)\"><div class=\"d-md-flex mb-3\"><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\" ng-if=\"vm.pagamentoSelect.id != 3\"><label for=operacao>Operação</label><input id=operacao name=operacao class=form-control ng-model=vm.data.banco.operacao autocomplete=off></div><div class=\"col-12 col-md-4 col-lg-4 mr-3 p-0 text-nowrap\"><label red-dot for=titular>Em nome de</label><input id=titular name=titular class=form-control ng-model=vm.data.banco.titular autocomplete=off required><div ng-messages=\"confirmacaoproposta[\'titular\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><div class=\"col-12 col-md-4 col-lg-4 p-0 text-nowrap\"><label red-dot for=titular-cpf>CPF/CNPJ do titular da conta</label><input type=tel id=titular-cpf name=titular-cpf class=form-control ng-model=vm.data.banco.titularCpf ui-br-cpfcnpj-mask autocomplete=off required><div ng-messages=\"confirmacaoproposta[\'titular-cpf\'].$error\" style=\"color: red\" role=alert><div ng-message=cpf>CPF/CNPJ inválido!</div><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div></div></div></div><div class=\"form-check mb-4\"><input name=truthfulness class=form-check-input type=checkbox value=true ng-model=vm.data.truthfulness id=truthfulness required><label red-dot class=\"form-check-label ml-1\" for=truthfulness>Eu me responsabilizo pela autenticidade dos documentos apresentados e pela veracidade das informações prestadas.</label><div ng-messages=\"confirmacaoproposta[\'truthfulness\'].$error\" style=\"color: red\" role=alert><div ng-if=vm.firstSubmit ng-message=required>Campo requerido.</div></div></div><button type=submit id=btn-submit class=\"btn btn-submit col-12 col-lg-6 col-md-8\">Enviar documentação</button></form></div><div class=form ng-if=\"vm.sucesso && vm.finish\"><div class=form-default><div class=form-group><h2 class=\"title mb-3\">Proposta aceita!</h2><p>Parabéns, você aceitou a proposta!</p><p>Enviamos um e-mail ao cliente interessado, para informá-lo e dar sequência à negociação. Te manteremos informado sobre qualquer atualização.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a class=green-text href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793</a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com class=green-text>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=\"title mb-3\">Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta/proposta.contraproposta.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><form name=contraproposta ng-submit=\"contraproposta.$valid && vm.submit($event)\" ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=title>Contraproposta</h2></div><div class=\"form-group d-flex flex-column\" ng-if=vm.prop_valor><p>a proposta inicial é de {{ vm.prop_valor | currency: \'R$ \' }}</p></div><div class=\"form-group d-flex flex-column\"><div class=d-flex><label for=form-valor class=\"mr-1 pt-3\">R$</label><input type=tel id=form-valor name=form-valor class=\"form-control col-10 col-md-5 upper\" ng-model=vm.data.valor autocomplete=off ui-number-mask=0 required><label for=form-valor class=\"ml-4 pl-3 upper\">Qual o valor da contraproposta?</label><label for=form-valor class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"contraproposta[\'form-valor\'].$error\" ng-if=\"contraproposta[\'form-valor\'].$dirty\" role=alert class=ng-message><div ng-message=pattern>Nome incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><textarea type=tel id=form-justificativa name=form-justificativa class=\"form-control upper col-12 col-sm-7\" ng-model=vm.data.justificativa autocomplete=off rows=5 required></textarea><label for=form-justificativa class=\"ml-1 pl-3 upper\">Qual a justificativa da contraproposta?</label><div ng-messages=\"contraproposta[\'form-justificativa\'].$error\" ng-if=\"contraproposta[\'form-justificativa\'].$dirty\" role=alert class=ng-message><div ng-message=pattern>Nome incorreto.</div><div ng-message=required>Campo requerido.</div></div></div></div><button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Enviar contraproposta <i class=\"fal fa-arrow-right\"></i></button><div class=clearfix></div></form><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Contraproposta enviada</h2><p>Enviamos um e-mail ao cliente interessado, para informá-lo e dar sequência à negociação. Te manteremos informado sobre qualquer atualização.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta/proposta.cotacoes-modal.html","<div id=cotacoes-modal><h2>Cotações de Seguro Fiança</h2><div class=cotacao-data><span>Data da cotação</span> <span>{{vm.cotacoes.data_calculo}}</span></div><main><section class=cotacao-main><div ng-class=vm.currentCotacao.cotacao.status><div class=cotacao-value><div class=cotacao-value-monthly><span><strong>R$ {{vm.currentCotacao.cotacao.formas_pagamento[0].valor_parcelas | currency}} </strong></span><span style=\"margin-bottom: 4px\">/mês</span></div><span>Valor total: R$ {{vm.currentCotacao.cotacao.formas_pagamento[0].valor_total | currency}}</span></div></div><div><div class=seguradora-logo><img ng-if=vm.currentCotacao.cotacao.seguradora.logo src={{vm.currentCotacao.cotacao.seguradora.logo}} alt=\"Logotipo da {{vm.currentCotacao.cotacao.seguradora.descricao}}\"><p ng-if=!vm.currentCotacao.cotacao.seguradora.logo>{{vm.currentCotacao.cotacao.seguradora.descricao}}</p></div></div></section><section class=cotacao-details><div><div class=cotacao-status><p>Status da cotação</p><span ng-class=vm.currentCotacao.cotacao.status>{{vm.currentCotacao.cotacao.status}}</span></div><div class=cotacao-vigencias><p>Vigência da Cotação</p><div class=vigencia-data><span>Data de início</span> <span>{{vm.cotacoes.vigencia_inicio}}</span></div><div class=vigencia-data><span>Data final</span> <span>{{vm.cotacoes.vigencia_fim}}</span></div></div></div><div class=cotacao-coberturas><p>Coberturas</p><div class=cotacao-coberturas-list ng-if=vm.currentCotacao.cotacao.coberturas.length><div ng-repeat=\"cobertura in vm.currentCotacao.cotacao.coberturas\" class=cobertura-info><span>{{cobertura.descricao}}</span> <span><b>R$ {{cobertura.valor | currency}}</b></span></div></div><div class=cotacao-coberturas-list ng-if=!vm.currentCotacao.cotacao.coberturas.length><div ng-repeat=\"cobertura in cotacoes.coberturas\" class=cobertura-info><span>{{cobertura.descricao}}</span> <span><b>R$ {{cobertura.valor | currency}}</b></span></div></div></div></section></main><footer><div class=modal-arrow ng-click=\"vm.changeCurrentCotacao(vm.currentCotacao.index - 1)\"><i class=\"fa fa-arrow-left\" aria-hidden=true></i></div><div class=modal-indexes><div ng-repeat=\"resultado in vm.resultados\" class=modal-index ng-class=\"{active: vm.currentCotacao.index === $index}\"></div></div><div class=modal-arrow ng-click=\"vm.changeCurrentCotacao(vm.currentCotacao.index + 1)\"><i class=\"fa fa-arrow-right\" aria-hidden=true></i></div></footer></div>");
$templateCache.put("app/proposta/proposta.form.html","<div id=proposta-form class=margin-fluid><section class=\"main container-fluid d-flex flex-column flex-md-row p-0\"><div class=\"asidebar col-md-4 col-lg-3\"><div><ol class=steps><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-click=vm.novaProposta() ng-class=\"{\'active\': vm.checkStep(1)}\"><span class=my-auto>INICIE A SUA PROPOSTA</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{\'active\': vm.checkStep(2)}\"><span class=my-auto>IMÓVEL E NEGOCIAÇÃO</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{\'active\': vm.checkStep(3)}\"><span class=my-auto>DADOS PESSOAIS</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{\'active\': vm.checkStep(4)}\"><span class=my-auto>REVISE A SUA PROPOSTA</span></li></ol></div></div><div class=\"main-forms col-md-8 col-lg-6\"><div class=\"d-flex flex-column forms\"><div class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=\"vm.urlshare || vm.checkStep(5)\"><div class=form-default><label for=\"\">Fique atento ao email: <strong>{{ vm.emailParte }}</strong> . Enviaremos todos os dados da proposta para o email cadastrado.</label><label for=\"\">Caso seja uma compra conjunta, envie esse link para que as demais partes entrem na proposta.</label><div class=form-group><div class=\"input-group d-flex\"><input type=text name=form-shareurl class=\"form-control noselect mr-0 py-2\" id=valueToCopy readonly ng-model=vm.urlshare><div class=\"input-group-append c-pointer\"><i class=\"fal fa-clone input-group-text\" ng-click=vm.copyPaste()></i></div></div><div class=submit-box style=\"display: flex; justify-content: center\"><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left rewind\" ng-click=vm.novaProposta()>Começar outra proposta</button></div></div></div></div><div class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(1)><div class=form-default><h3>CATEGORIA DE COMPRA</h3><label for=form-btn class=pb-4>A compra do imóvel será em</label><div id=form-btn class=\"form-group d-flex flex-column justify-content-around\"><button class=\"btn button btn-default\" ng-click=\"vm.setperfil(\'fisica\')\">Pessoa fisica</button> <button class=\"btn button btn-default\" ng-click=\"vm.setperfil(\'juridico\')\">Pessoa Juridica</button></div></div></div><div class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(2) style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>IMÓVEL E NEGOCIAÇÃO</h3><label class=pb-4>Nesse campo, nos conte sobre o imóvel que gostou e como planeja negociá-lo.</label><form action=\"\" name=etapanome ng-submit=\"vm.negocio($event, etapanome)\" novalidate><div class=\"form-group d-flex flex-column\"><label for=form-corretor class=ml-1>Qual o nome do seu corretor?</label><input id=form-corretor name=form-corretor ng-model=vm.data.corretor ng-readonly=vm.corretorRead ng-class=\"{\'sbmtd\': vm.subterror}\" uib-typeahead=\"row as row.label for row in vm.form.getCorretor($viewValue)\" typeahead-min-length=0 typeahead-on-select=\"vm.form.selectAutocomplete($item, $model, $label, $event, etapanome[\'form-corretor\'])\" class=\"form-control mr-0\" typeahead-no-results=noResults typeahead-select-on-blur=true typeahead-select-on-exact=true typeahead-show-hint=true required><div ng-messages=\"etapanome[\'form-corretor\'].$error\" ng-if=vm.subterror style=\"color: red\"><div ng-message=autcmplt>Selecione um corretor</div></div></div><div class=\"form-group d-flex flex-column col-12\"><label for=form-negocio class=ml-1>Qual o modelo de negociação?</label><div class=\"d-flex flex-column flex-md-row flex-wrap justify-content-start align-items-start\"><div class=\"btn-group-vertical flex-column justify-content-center align-items-stretch col-6 col-md-4 p-0\" role=group aria-label=\"Tipos de negocio\"><div class=\"form-check btn\"><input class=form-check-input type=radio name=negocio ng-model=vm.data.tnmod_id id=negocio1 ng-value=6 ng-checked=\"vm.data.tnmod_id == 6\"><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=negocio1><div>À vista</div></label></div><div class=\"form-check btn\"><input class=form-check-input type=radio name=negocio ng-model=vm.data.tnmod_id id=negocio2 ng-value=7 ng-checked=\"vm.data.tnmod_id == 7\"><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=negocio2><div>Permuta</div></label></div><div class=\"form-check btn\"><input class=form-check-input type=radio name=negocio ng-model=vm.data.tnmod_id id=negocio3 ng-value=8 ng-checked=\"vm.data.tnmod_id == 8\"><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=negocio3><div>Financiamento</div></label></div><div class=\"form-check btn\"><input class=form-check-input type=radio name=negocio ng-model=vm.data.tnmod_id id=negocio4 ng-value=9 ng-checked=\"vm.data.tnmod_id == 9\"><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=negocio4><div>Consórcio</div></label></div><div class=\"form-check btn\"><input class=form-check-input type=radio name=negocio ng-model=vm.data.tnmod_id id=negocio5 ng-value=10 ng-checked=\"vm.data.tnmod_id == 10\"><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=negocio5><div>Outra modalidade</div></label></div></div><div class=\"col-12 col-md-8 mt-3 box-modelo-neg\" ng-switch=vm.data.tnmod_id><div ng-switch-when=7><div class=d-flex><label for=form-0 class=ml-1>O que entra como parte do pagamento?</label></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-carro class=ml-1>Carro :</label><input id=form-desc-carro type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.permuta_carro></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-imv class=ml-1>Imovel :</label><input id=form-desc-imv type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.permuta_imovel></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-other class=ml-1>Outro :</label><input id=form-desc-other type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.permuta_outro></div></div><div ng-switch-when=8><div class=\"form-group d-flex\" style=\"margin-bottom: 0px\"><label>Qual banco será seu agente financiador?</label></div><div class=\"form-group d-flex flex-column\"><div class=radio-group><input type=checkbox name=caixa class=\"input-control square\" id=caixa ng-model=vm.data.descricao.caixa ng-true-value=true ng-false-value=false><label for=caixa>Caixa Econômica Federal</label></div><div class=radio-group><input type=checkbox name=bb class=\"input-control square\" id=bb ng-model=vm.data.descricao.bb ng-true-value=true ng-false-value=false><label for=bb>Banco do Brasil</label></div><div class=radio-group><input type=checkbox name=santander class=\"input-control square\" id=santander ng-model=vm.data.descricao.santander ng-true-value=true ng-false-value=false><label for=santander>Santander</label></div><div class=radio-group><input type=checkbox name=itau class=\"input-control square\" id=itau ng-model=vm.data.descricao.itau ng-true-value=true ng-false-value=false><label for=itau>Itau</label></div><div class=radio-group><input type=checkbox name=bradesco class=\"input-control square\" id=bradesco ng-model=vm.data.descricao.bradesco ng-true-value=true ng-false-value=false><label for=bradesco>Bradesco</label></div><div class=\"radio-group pl-4 col-10 col-md-10 col-xl-8\"><input type=text name=outro class=\"input-control mr-0\" id=outros ng-true-value=true ng-false-value=false><label for=outros>Outros. Qual?</label><input type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_outros></div></div><div class=\"form-group d-flex flex-column\"><label for=form-agencia class=ml-1>Qual a sua agência?</label><input id=form-agencia name=form-agencia type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_agencia ng-class=\"{\'sbmtd\': vm.subterror}\" ng-required=\"vm.data.tnmod_id === 8\"><div ng-messages=\"etapanome[\'form-agencia\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-financ class=ml-1>Qual o valor total do financiamento?</label><div class=\"form-group d-flex\"><label for=form-total class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.financiamento_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 8\" ng-class=\"{\'sbmtd\': vm.subterror}\"><label for=form-total class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red; margin-top: -12px; margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div></div><div ng-switch-when=9><div class=\"form-group d-flex flex-column\"><label for=form-total class=ml-1>Qual valor total do consórcio?</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorcio_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{\'sbmtd\': vm.subterror}\"><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red; margin-top: -12px; margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-consorciadora class=ml-1>Qual a sua consorciadora?</label><input id=form-consorciadora name=form-consorciadora type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorciadora ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapanome[\'form-consorciadora\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div class=\"form-group d-flex flex-column\" ng-switch-when=10><label for=form-descre class=ml-1>Descreva:</label><input id=form-descre name=form-descre type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.outros_descreva ng-required=\"vm.data.tnmod_id === 10\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapanome[\'form-descre\'].$error\" ng-if=vm.subterror role=alert class=ng-message></div><div ng-message=required>Campo requerido.</div></div></div></div></div><div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5 imv_select\" ng-show=!vm.data.end_imovel><label for=form-codimvoel class=ml-1>Digite o código do imovel</label><input id=form-codimvoel name=form-codimvoel type=text ng-model=vm.data.cod_imovel ng-readonly=vm.imovelRead uib-typeahead=\"imovel as imovel.imv_cod_gaia for imovel in vm.form.getImoveis($viewValue)\" class=\"form-control mr-0\" typeahead-template-url=app/components/typeahead/customTemplateProposta.html ng-class=\"{\'sbmtd\': vm.subterror}\" typeahead-on-select=\"vm.form.selectAutocomplete($item, $model, $label, $event, etapanome[\'form-codimvoel\'])\" typeahead-show-hint=true typeahead-min-length=1 oninput=\"this.value = this.value.replace(/[^a-zA-Z0-9_]/g, \'\')\"><div ng-messages=\"etapanome[\'form-codimvoel\'].$error\" ng-if=vm.subterror style=\"color: red\"><div ng-message=autcmplt>Selecione um imovel</div></div></div><div class=\"d-flex flex-column\"><label for=form-locacao>Valor da sua proposta</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input type=tel id=form-locacao name=form-locacao class=\"form-control col-10 col-md-5\" ng-model=vm.data.priceLocacao ng-class=\"{\'sbmtd\': vm.subterror}\" autocomplete=off ui-number-mask=0 required><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-locacao\'].$error\" ng-if=vm.subterror style=\"color: red; margin-top: -12px; margin-bottom: 12px\"><div ng-message=required>Campo requerido</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-addConditions class=ml-1>Quais seriam as condições adicionais ?</label><textarea type=tel id=form-addConditions class=\"form-control col-12 col-sm-7\" ng-model=vm.data.addConditions autocomplete=off rows=5></textarea></div><div class=\"form-group d-flex flex-column\"><div class=\"radio-group c-pointer\"><input type=checkbox name=position class=\"input-control square\" id=form-whats-accept ng-init=\"vm.data.accept_whats = true\" ng-model=vm.data.accept_whats ng-true-value=true ng-false-value=false><label for=form-whats-accept>Receber informações por whatsapp</label></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\" ng-if=!vm.proposta.perfil><label for=form-docCPF class=ml-1>Para continuar informe seu CPF</label><input type=tel id=form-docCPF name=form-docCPF class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCPF autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" ui-br-cpf-mask required><div ng-messages=\"etapanome[\'form-docCPF\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cpf>CPF incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\" ng-if=vm.proposta.perfil><label for=form-docCNPJ class=\"d-flex ml-1\">informe o CNPJ da empresa</label><input type=tel id=form-docCNPJ name=form-docCNPJ class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCNPJ autocomplete=off ui-br-cnpj-mask ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapanome[\'form-docCNPJ\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cnpj>CNPJ incorreto.</div><div ng-message=required>Campo requerido.</div></div></div></div><div class=submit-box><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left rewind\" ng-click=vm.novaProposta()>Começar outra proposta</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\">Próximo <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></form></div></div><div class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(3) style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>DADOS PESSOAIS</h3><label class=pb-4>Nos conte sobre você</label><form action=\"\" name=etapadocs ng-submit=\"vm.pessoais($event, etapadocs)\" novalidate><input type=hidden ng-if=!vm.proposta.perfil id=form-c-name ng-init=\"vm.data.type = 2\" autocomplete=off> <input type=hidden ng-if=vm.proposta.perfil id=form-c-name ng-init=\"vm.data.type = 5\" autocomplete=off><div class=\"form-group d-flex flex-column\"><label for=form-name ng-if=!vm.proposta.perfil class=ml-1>Qual é o seu nome completo?</label><label for=form-name ng-if=vm.proposta.perfil class=ml-1>Qual a razão social da empresa?</label><input type=text id=form-name name=form-name class=\"form-control mr-0\" ng-class=\"{\'sbmtd\': vm.subterror}\" ng-model=vm.data.name autocomplete=off required><div ng-messages=\"etapadocs[\'form-name\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-email class=ml-1 ng-if=!vm.proposta.perfil>Qual o seu email?</label><label for=form-email class=ml-1 ng-if=vm.proposta.perfil>Qual o email?</label><input type=email id=form-email name=form-email class=\"form-control mr-0\" ng-class=\"{\'sbmtd\': vm.subterror}\" ng-model=vm.data.email autocomplete=off required><div ng-messages=\"etapadocs[\'form-email\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=email>Email incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\"><label for=form-phone class=ml-1>Telefone de contato?</label><input type=tel id=form-phone name=form-phone class=\"form-control mr-0\" ng-class=\"{\'sbmtd\': vm.subterror}\" ng-model=vm.data.phone autocomplete=off ui-br-phone-number=areaCode required><div ng-messages=\"etapadocs[\'form-phone\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div ng-if=!vm.proposta.perfil><input type=hidden id=form-c-name ng-init=\"vm.data.parte[0].type = 2\" autocomplete=off><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-nationality class=ml-1>Qual é a sua nacionalidade?</label><input type=text name=form-nationality id=form-nationality ng-class=\"{\'sbmtd\': vm.subterror}\" class=\"form-control mr-0\" ng-model=vm.data.parte[0].nationality required><div ng-messages=\"etapadocs[\'form-nationality\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-professional class=ml-1>Qual é sua profissão?</label><input type=text name=form-professional class=\"form-control mr-0\" id=form-professional ng-model=vm.data.parte[0].professional ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-professional\'].$error\" ng-if=vm.subterror ng-class=\"{\'sbmtd\': vm.subterror}\" role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\"><label for=form-birthday class=ml-1>Qual sua data de nascimento?</label><input type=tel id=form-birthday name=form-birthday class=\"form-control mr-0\" placeholder=dd/mm/aaaa ng-model=vm.data.parte[0].birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-birthday\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div><div ng-message=date>Data inválida</div></div></div><div class=\"form-group d-flex flex-column col-md-6 col-xl-4\"><label for=form-docRG class=ml-1>Qual seu RG?</label><input type=tel id=form-docRG name=form-docRG class=\"form-control mr-0\" ng-model=vm.data.parte[0].docRG ng-class=\"{\'sbmtd\': vm.subterror}\" autocomplete=off required><div ng-messages=\"etapadocs[\'form-docRG\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-6 col-xl-4\"><label for=form-docCPF class=ml-1>Qual seu CPF?</label><input type=tel id=form-docCPF name=form-docCPF class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCPF autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" ui-br-cpf-mask required><div ng-messages=\"etapadocs[\'form-docCPF\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cpf>CPF incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column flex-wrap col-md-6 col-xl-4\"><label for=form-civil class=ml-1>Qual seu estado civil ?</label><input id=form-civil name=form-civil type=text ng-model=vm.data.parte[0].estadocivil uib-typeahead=\"row as row.label for row in vm.estadoCivil | filter:$viewValue | limitTo:8\" typeahead-on-select=\"vm.form.selectAutocomplete($item, $model, $label, $event, etapadocs[\'form-civil\'])\" typeahead-min-length=0 autocomplete=off autocomplete=off class=\"form-control mr-0\" ng-class=\"{\'sbmtd\': vm.subterror}\" typeahead-select-on-blur=true typeahead-select-on-exact=true typeahead-show-hint=true required><div ng-messages=\"etapadocs[\'form-civil\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=autcmplt>Campo requerido.</div></div></div><div><label for=\"\" style=\"color: #555; font-weight: 600\">Dados do cônjuge</label><input type=hidden id=form-c-name ng-init=\"vm.data.parte[1].type = 3\" autocomplete=off><div class=\"form-group d-flex flex-column\"><label for=form-c-name class=\"d-flex ml-1\">Nome completo<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=text id=form-c-name name=form-c-name class=\"form-control mr-0\" ng-model=vm.data.parte[1].name autocomplete=off ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-name\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-6 col-xl-4\"><label for=form-c-docCPF class=\"d-flex ml-1\">CPF<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=tel id=form-c-docCPF name=form-c-docCPF class=\"form-control mr-0\" ng-model=vm.data.parte[1].docCPF autocomplete=off mask=999.999.999-99 ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-docCPF\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cpf>CPF incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-6 col-xl-4\"><label for=form-c-docRG class=\"d-flex ml-1\">RG<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=tel id=form-c-docRG name=form-c-docRG class=\"form-control mr-0\" ng-model=vm.data.parte[1].docRG autocomplete=off ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-docRG\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-6 col-xl-4\"><label for=form-c-birthday class=\"d-flex ml-1\">Data de nascimento?<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=tel id=form-c-birthday name=form-c-birthday class=\"form-control mr-0\" ng-model=vm.data.parte[1].birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-birthday\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div><div ng-message=date>Data inválida</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-c-nationality class=\"d-flex ml-1\">Qual é a nacionalidade?<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=text name=form-c-nationality class=\"form-control mr-0\" id=form-nationality ng-model=vm.data.parte[1].nationality ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-nationality\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-c-professional class=\"d-flex ml-1\">Qual é a profissão?<div class=opcional ng-if=\"vm.data.parte[0].estadocivil.id != 2\">(opcional)</div></label><input type=text name=form-c-professional class=\"form-control mr-0\" id=form-professional ng-model=vm.data.parte[1].professional ng-required=\"vm.data.parte[0].estadocivil.id == 2\" ng-class=\"{\'sbmtd\': vm.subterror}\"><div ng-messages=\"etapadocs[\'form-c-professional\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div></div><div ng-if=vm.proposta.perfil><input type=hidden id=form-c-name ng-init=\"vm.data.parte[0].type = 4\" autocomplete=off><div class=\"form-group d-flex flex-column\"><label for=form-docCNPJ class=\"d-flex ml-1\">Qual o CNPJ da empresa?</label><input type=tel id=form-docCNPJ name=form-docCNPJ class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCNPJ autocomplete=off ui-br-cnpj-mask ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-docCNPJ\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cnpj>CNPJ incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-docIE class=\"d-flex ml-1\">E o inscrição estadual ?</label><input type=tel id=form-docIE name=form-docIE class=\"form-control mr-0\" ng-model=vm.data.parte[0].docIE autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-docIE\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-action class=\"d-flex ml-1\">Ramo de atividade?</label><input type=tel id=form-action name=form-action class=\"form-control mr-0\" ng-model=vm.data.parte[0].action autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-action\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><label for=\"\">Dados Sócio Administrador</label><input type=hidden id=form-c-name ng-init=\"vm.data.parte[1].type = 5\" autocomplete=off><div class=\"form-group d-flex flex-column\"><label for=form-c-name class=\"d-flex ml-1\">Nome completo?</label><input type=text id=form-c-name name=form-c-name class=\"form-control mr-0\" ng-model=vm.data.parte[1].name autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-c-name\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-c-nationality class=\"d-flex ml-1\">Qual é a nacionalidade?</label><input type=text id=form-c-nationality name=form-c-nationality class=\"form-control mr-0\" id=form-nationality ng-model=vm.data.parte[1].nationality ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-c-nationality\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-c-professional class=\"d-flex ml-1\">Qual é a profissão?</label><input type=text id=form-c-professional name=form-c-professional class=\"form-control mr-0\" id=form-professional ng-model=vm.data.parte[1].professional ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-c-nationality\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-c-birthday class=\"d-flex ml-1\">Data de nascimento?</label><input type=tel id=form-c-birthday name=form-c-birthday class=\"form-control mr-0\" ng-model=vm.data.parte[1].birthday autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-c-birthday\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-c-docRG class=\"d-flex ml-1\">RG</label><input type=tel id=form-c-docRG class=\"form-control mr-0\" ng-model=vm.data.parte[1].docRG autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-c-docRG\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-c-docCPF class=\"d-flex ml-1\">CPF</label><input type=tel id=form-c-docCPF name=form-c-docCPF class=\"form-control mr-0\" ng-model=vm.data.parte[1].docCPF autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" ui-br-cpf-mask required><div ng-messages=\"etapadocs[\'form-c-docCPF\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cpf>CPF incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-p2email class=\"d-flex ml-1\">Um email de contato para o sócio administrador?</label><input type=text id=form-p2email name=form-p2email class=\"form-control mr-0\" ng-model=vm.data.parte[1].email autocomplete=off ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-p2email\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div class=\"form-group d-flex flex-column flex-wrap\"><label style=\"color: #555; font-weight: 600\">Endereço</label><div class=\"row mb-3 d-flex flex-column\"><label for=zipcode-address class=\"d-flex ml-1\">CEP</label><input type=text id=zipcode-address name=zipcode-address class=\"form-control col-12 col-md-7\" ui-br-cep-mask ng-model=vm.address.end_cep ng-blur=vm.form.viacepGet() ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'zipcode-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"row mb-3\"><div class=\"d-flex col-8 col-sm-7 px-0 d-flex flex-column\"><label for=stre-address class=\"d-flex ml-1\">Rua</label><input type=text id=stre-address name=stre-address class=form-control ng-model=vm.address.end_logradouro ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'stre-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"d-flex col-4 col-sm-3 px-0 d-flex flex-column\" style=\"padding-left: 10px !important\"><label for=num-address class=\"d-flex ml-1\">num</label><input type=text id=num-address name=num-address class=form-control ng-model=vm.address.end_numero ng-model-options=\"{ debounce: 700 }\" ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'num-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div class=\"row mb-3\"><div class=\"d-flex col-12 col-md-10 px-0 d-flex flex-column\"><label for=comp-address class=\"d-flex ml-1\">Complemento</label><input type=text id=comp-address class=form-control ng-model=vm.address.end_complemento></div></div><div class=\"row mb-3\"><div class=\"d-flex col-12 col-md-10 px-0 d-flex flex-column\"><label for=neib-address class=\"d-flex ml-1\">Bairro</label><input type=text id=neib-address name=neib-address class=form-control ng-class=\"{\'sbmtd\': vm.subterror}\" ng-model=vm.address.end_bairro required><div ng-messages=\"etapadocs[\'neib-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div class=\"row mb-3\"><div class=\"d-flex col-7 col-md-7 px-0 d-flex flex-column\"><label for=city-address class=\"d-flex ml-1\">Cidade</label><input type=text id=city-address name=city-address class=form-control ng-model=vm.address.end_cidade ng-class=\"{\'sbmtd\': vm.subterror}\" disabled required><div ng-messages=\"etapadocs[\'city-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"d-flex col-5 col-md-3 px-0 d-flex flex-column\" style=\"padding-left: 10px !important\"><label for=uf-address class=\"d-flex ml-1\">Estado</label><input type=text id=uf-address name=uf-address class=form-control ng-model=vm.address.end_estado ng-class=\"{\'sbmtd\': vm.subterror}\" disabled required><div ng-messages=\"etapadocs[\'uf-address\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div></div><div><label for=form-contato-nome class=ml-1>Para finalizar essa sessão, indique uma pessoa de sua confiança. <i class=\"fal fa-info-circle ml-2\"></i></label><label class=\"d-none ml-1 newtooltip\">Pedimos esse dado como uma segurança extra, mas não incomodaremos seu contato, fique tranquilo. Seu contato de referência pode ser um familiar ou amigo.</label><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-contato-nome class=ml-1>Qual é o nome completo do seu contato?</label><input type=text name=form-contato-nome class=form-control id=form-contato-nome ng-model=vm.data.parte[0].contatoNome ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-contato-nome\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-6\"><label for=form-contato-tel class=ml-1>Qual o número de telefone?</label><input type=text name=form-contato-tel class=form-control id=form-contato-tel ng-model=vm.data.parte[0].contatoTel ui-br-phone-number=areaCode ng-class=\"{\'sbmtd\': vm.subterror}\" required><div ng-messages=\"etapadocs[\'form-contato-tel\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div class=submit-box><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left rewind\" ng-click=vm.novaProposta()>Começar outra proposta</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\">Próximo <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></form></div></div><div class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(4) style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>ENVIAR PROPOSTA</h3><label class=pb-4>Revise a sua proposta</label><form action=\"\" name=etapacontato ng-submit=vm.enviar($event,etapacontato) novalidate><span>Pronto, agora é só revisar os dados e confirmar sua proposta.<br>Clique em Finalizar proposta se estiver tudo certo.</span><div class=relatorio><div class=\"section-title d-flex row\"><h4 class=\"col-12 col-md-7 col-xl-6\">Imóvel e Negociação</h4><button type=button class=\"btn d-md-flex col-12 col-md-5 col-xl-4\" ng-click=\" vm.gonegocio()\">Voltar para etapa</button></div><div class=row><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.corretor><span class=\"fieldlabel d-flex\">Corretor</span> <span class=fieldvalue>{{ vm.data.corretor.label }}</span></div><div class=\"col-6 col-md-6 d-flex flex-column\" ng-if=vm.data.tnmod_id><span class=fieldlabel>Modelo de negociação</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 1\">Sem garantia</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 5\">Título de capitalização</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 6\">À vista</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 7\">Permuta</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 8\">Financiamento</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 9\">Consórcio</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 10\">Outra modalidade</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 7\"><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_imovel><span class=fieldlabel>Imovel</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_imovel }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_carro><span class=fieldlabel>Carro</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_carro }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_outro><span class=fieldlabel>Outro</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_outro }}</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 8\"><div class=\"col-12 col-md-4 d-flex flex-column\"><span class=fieldlabel ng-if=\"vm.data.tnmod_id === 8\">Banco</span> <span class=fieldvalue ng-if=vm.data.descricao.caixa>Caixa Econômica Federal</span> <span class=fieldvalue ng-if=vm.data.descricao.bb>Banco do Brasil</span> <span class=fieldvalue ng-if=vm.data.descricao.santander>Santander</span> <span class=fieldvalue ng-if=vm.data.descricao.bradesco>Bradesco</span> <span class=fieldvalue ng-if=vm.data.descricao.banco_outros>{{ vm.data.descricao.banco_outros }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.banco_agencia><span class=fieldlabel>Agência</span> <span class=fieldvalue>{{ vm.data.descricao.banco_agencia }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.financiamento_valor><span class=fieldlabel>Valor do financiamento</span> <span class=fieldvalue>R$ {{ vm.data.descricao.financiamento_valor.toLocaleString(\'pt-BR\') }},00</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 9\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.descricao.consorcio_valor><span class=fieldlabel>Valor total do consórcio</span> <span class=fieldvalue>R$ {{ vm.data.descricao.consorcio_valor.toLocaleString(\'pt-BR\') }},00</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.descricao.consorciadora><span class=fieldlabel>Consorciadora</span> <span class=fieldvalue>{{ vm.data.descricao.consorciadora }}</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 10\"><div class=\"col-12 col-md-12 d-flex flex-column\" ng-if=vm.data.descricao.outros_descreva><span class=fieldlabel>Descrição modalidade</span> <span class=fieldvalue>{{ vm.data.descricao.outros_descreva }}</span></div></div><div class=row ng-if=\"vm.data.cod_imovel || vm.data.priceLocacao\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.cod_imovel><span class=fieldlabel>Código do Imovel</span> <span class=fieldvalue>{{ vm.data.cod_imovel.imv_cod_gaia }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.priceLocacao><span class=fieldlabel>Valor da proposta</span> <span class=fieldvalue>R$ {{ vm.data.priceLocacao.toLocaleString(\'pt-BR\') }},00</span></div></div><div class=row ng-if=vm.data.addConditions><div class=\"col-12 col-md-12 d-flex flex-column\"><span class=fieldlabel>Condições adicionais</span> <span class=fieldvalue>{{ vm.data.addConditions }}</span></div></div><div class=\"section-title d-flex row\"><h4 class=\"col-12 col-md-7 col-xl-6\">Dados Pessoais</h4><button type=button class=\"btn d-md-flex col-12 col-md-5 col-xl-4\" ng-click=\" vm.gopessoal()\">Voltar para etapa</button></div><div class=row ng-if=vm.data.name><div class=\"col-12 col-md-12 d-flex flex-column\"><span class=fieldlabel ng-if=!vm.proposta.perfil>Nome completo</span> <span class=fieldlabel ng-if=vm.proposta.perfil>razão social</span> <span class=fieldvalue>{{ vm.data.name }}</span></div></div><div class=row ng-if=\"vm.data.email || vm.data.phone\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.email><span class=fieldlabel>Email</span> <span class=fieldvalue>{{ vm.data.email }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.phone><span class=fieldlabel>Telefone</span> <span class=fieldvalue>{{ vm.textFormatter.phoneMask(vm.data.phone) }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].docCNPJ || vm.data.parte[0].docIE\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].docCNPJ><span class=fieldlabel>CNPJ</span> <span class=fieldvalue>{{ vm.data.parte[0].docCNPJ }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].docIE><span class=fieldlabel>Inscrição estadual</span> <span class=fieldvalue>{{ vm.data.parte[0].docIE }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].action || vm.address.end_cep\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].action><span class=fieldlabel>Ramo de atividade</span> <span class=fieldvalue>{{ vm.data.parte[0].action }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_cep><span class=fieldlabel>CEP</span> <span class=fieldvalue>{{ vm.address.end_cep }}</span></div></div><div class=row ng-if=\"vm.address.end_logradouro || vm.address.end_numero\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_logradouro><span class=fieldlabel>Rua</span> <span class=fieldvalue>{{ vm.address.end_logradouro }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_numero><span class=fieldlabel>Numero</span> <span class=fieldvalue>{{ vm.address.end_numero }}</span></div></div><div class=row ng-if=\"vm.address.end_complemento || vm.address.end_bairro\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_complemento><span class=fieldlabel>Complemento</span> <span class=fieldvalue>{{ vm.address.end_complemento }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_bairro><span class=fieldlabel>Bairro</span> <span class=fieldvalue>{{ vm.address.end_bairro }}</span></div></div><div class=row ng-if=\"vm.address.end_cidade || vm.address.end_estado\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_complemento><span class=fieldlabel>Cidade</span> <span class=fieldvalue>{{ vm.address.end_cidade }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.address.end_bairro><span class=fieldlabel>Estado</span> <span class=fieldvalue>{{ vm.address.end_estado }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].nationality || vm.data.parte[0].estadocivil\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].nationality><span class=fieldlabel>Nacionalidade</span> <span class=fieldvalue>{{ vm.data.parte[0].nationality }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].estadocivil><span class=fieldlabel>Estado Civil</span> <span class=fieldvalue>{{ vm.data.parte[0].estadocivil.label }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].birthday || vm.data.parte[0].professional\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].birthday><span class=fieldlabel>Data de nascimento</span> <span class=fieldvalue>{{ vm.calendario(vm.data.parte[0].birthday) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].professional><span class=fieldlabel>Profissão</span> <span class=fieldvalue>{{ vm.data.parte[0].professional }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].docRG || vm.data.parte[0].docCPF\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].docRG><span class=fieldlabel>RG</span> <span class=fieldvalue>{{ vm.data.parte[0].docRG }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[0].docCPF><span class=fieldlabel>CPF</span> <span class=fieldvalue>{{ vm.textFormatter.cpfMask(vm.data.parte[0].docCPF) }}</span></div></div><div class=row ng-if=\"vm.data.parte[0].estadocivil || vm.data.parte[1].name\"><div class=\"col-12 col-md-12 d-flex flex-column\" ng-if=vm.data.parte[1].name><span class=fieldlabel ng-if=!vm.proposta.perfil>Nome do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>Nome do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].name }}</span></div></div><div class=row ng-if=\"vm.data.parte[1].docRG || vm.data.parte[1].docCPF\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].docRG><span class=fieldlabel ng-if=!vm.proposta.perfil>RG do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>RG do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].docRG }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].docCPF><span class=fieldlabel ng-if=!vm.proposta.perfil>CPF do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>CPF do sócio</span> <span class=fieldvalue>{{ vm.textFormatter.cpfMask(vm.data.parte[1].docCPF) }}</span></div></div><div class=row ng-if=\"vm.data.parte[1].birthday || vm.data.parte[1].professional\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].birthday><span class=fieldlabel ng-if=!vm.proposta.perfil>Data de nascimento do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>Data de nascimento do sócio</span> <span class=fieldvalue>{{ vm.calendario(vm.data.parte[1].birthday) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].professional><span class=fieldlabel ng-if=!vm.proposta.perfil>Profissão do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>Profissão do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].professional }}</span></div></div><div class=row ng-if=\"vm.data.parte[1].email || vm.data.parte[1].nationality\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].email><span class=fieldlabel ng-if=!vm.proposta.perfil>email do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>email do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].email }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.parte[1].nationality><span class=fieldlabel ng-if=!vm.proposta.perfil>nacionalidade do cônjuge</span> <span class=fieldlabel ng-if=vm.proposta.perfil>nacionalidade do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].nationality }}</span></div></div><div class=\"section-title d-flex row\"><h4 style=\"margin-top: 10px\" ng-if=\"vm.data.parte[0].contatoNome || vm.data.parte[0].contatoTel\" class=\"col-12 col-md-7 col-xl-6\">Dados Contato</h4></div><div class=row ng-if=\"vm.data.parte[0].contatoNome || vm.data.parte[0].contatoTel\"><div class=\"col-12 col-md-12 d-flex flex-column\" ng-if=vm.data.parte[0].contatoNome><span class=fieldlabel>Nome do contato</span> <span class=fieldvalue>{{ vm.data.parte[0].contatoNome }}</span></div><div class=\"col-12 col-md-12 d-flex flex-column\" ng-if=vm.data.parte[0].contatoTel><span class=fieldlabel>Telefone do contato</span> <span class=fieldvalue>{{ vm.textFormatter.phoneMask(vm.data.parte[0].contatoTel) }}</span></div></div></div><div style=\"margin-top: 30px\" class=submit-box><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left rewind\" ng-click=vm.novaProposta()>Começar outra proposta</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\">Finalizar proposta <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></form></div></div></div></div><div class=\"asidebar col-md-4 col-lg-3\"></div></section></div>");
$templateCache.put("app/proposta/proposta.html","<div ui-view></div>");
$templateCache.put("app/proposta/proposta.locacaoconjunta.html","<div id=proposta-form class=\"h-100 margin-fluid prop-locacao-conjunta\"><section class=container><form name=locacaoconjunta ng-submit=vm.submit($event)><div class=form-default><h3 style=\"margin-bottom: 0px\">Locação conjunta do imóvel | {{vm.cod_imovel}}</h3><a class=link-imovel-site target=_blank href=\"{{vm.urlSite }}/imovel/{{vm.cod_imovel}}\">Link do anúncio<span class=\"fa fa-external-link\"></span></a><div class=\"form-group d-flex\"><input type=text id=form-c-name class=\"form-control upper mr-0\" ng-model=vm.parte.name autocomplete=off required><label for=form-c-name class=\"ml-1 pl-3 upper\">Nome completo?</label></div><div class=\"form-group d-flex flex-column\"><input type=email id=form-email name=form-email class=\"form-control upper mr-0\" ng-model=vm.parte.email autocomplete=off required><label for=form-email class=\"ml-1 pl-3 upper\">Qual o seu email?</label><div ng-messages=\"locacaoconjunta[\'form-email\'].$error\" ng-if=\"locacaoconjunta[\'form-email\'].$dirty\" role=alert class=ng-message><div ng-message=email>Email incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><input type=tel id=form-phone name=form-phone class=\"form-control upper mr-0\" ng-model=vm.parte.phone autocomplete=off ui-br-phone-number=areaCode required><label for=form-phone class=\"ml-1 pl-3 upper\">Telefone de contato?</label><div ng-messages=\"locacaoconjunta[\'form-phone\'].$error\" ng-if=\"locacaoconjunta[\'form-phone\'].$dirty\" role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"input-check-foreigner d-flex\"><div class=\"form-group d-flex\"><input ng-disabled=!isEstrangeiroPropConjunta type=text name=form-c-nationality class=\"form-control upper mr-0\" id=form-nationality ng-model=vm.parte.nationality uib-typeahead=\"row as row.label for row in vm.getNationalityPropConjunta($viewValue)\" required><label for=form-c-nationality class=\"ml-1 pl-3 upper\">Qual a sua nacionalidade?</label><i class=\"fas fa-search\"></i></div><div class=\"check-estrangeiro d-flex ml-3 mb-3\"><input ng-model=isEstrangeiroPropConjunta ng-click=vm.checkEstrangeiroPropConjunta($event) type=checkbox><label style=\"margin: 0\">Estrangeiro</label></div></div><div class=\"form-group d-flex\"><input type=text name=form-c-professional class=\"form-control upper mr-0\" id=form-professional ng-model=vm.parte.professional required><label for=form-c-professional class=\"ml-1 pl-3 upper\">Qual é a profissão?</label></div><div class=\"form-group d-flex\"><input type=text id=form-c-renda name=form-c-renda class=\"form-control upper mr-0\" ng-model=vm.parte.rendaMensal autocomplete=off ui-money-mask required><label for=form-c-renda class=\"ml-1 pl-3 upper\">Qual é a renda mensal?</label></div><div id=datepicker-form-entrance class=\"form-group d-flex date\" data-provide=datepicker><input type=tel id=form-c-birthday name=form-c-birthday class=\"form-control upper mr-0\" ng-model=vm.parte.birthday autocomplete=off ui-date-mask=DD/MM/YYYY required><label for=form-c-birthday class=\"ml-1 pl-3 upper\">Data de nascimento?</label><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-if=!isEstrangeiroPropConjunta class=\"form-group d-flex\"><input type=tel id=form-c-docRG class=\"form-control upper mr-0\" ng-model=vm.parte.docRG autocomplete=off required><label for=form-c-docRG class=\"ml-1 pl-3 upper\">RG</label></div><div ng-if=isEstrangeiroPropConjunta class=\"form-group d-flex\"><input type=tel id=form-c-docCRNM class=\"form-control upper mr-0\" ng-model=vm.parte.docCRNM autocomplete=off required><label for=form-c-docCRNM class=\"ml-1 pl-3 upper\">CRNM</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-docCPF class=\"form-control upper mr-0\" ng-model=vm.parte.docCPF autocomplete=off ui-br-cpf-mask required><label for=form-c-docCPF class=\"ml-1 pl-3 upper\">CPF</label></div></div><button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Próximo<i class=\"fal fa-arrow-right\"></i></button><div class=clearfix></div></form></section></div>");
$templateCache.put("app/proposta/proposta.recusar.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Proposta recusada.</h2><p>Você recusou a proposta.</p><p>Enviamos um e-mail ao cliente interessado, para informá-lo, encerrando a negociação. Caso queira iniciar uma nova proposta.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></div></section></div>");
$templateCache.put("app/proposta/proposta.status.html","<div id=proposta-form class=\"margin-fluid align-items-center mb-4\"><div class=proposta-status-header><h1>Status da proposta</h1><button ng-if=\"ConfigWhiteLabel.imb_config_crm && ConfigWhiteLabel.imb_config_crm.imb_analise\" class=cotacao-seguros-btn ng-click=vm.openModal() ng-class=\"{disabled: !vm.checkIfValid(), reprovado: !vm.checkIfApproved()}\" ng-disabled=!vm.checkIfValid()>Cotações de Seguro Fiança</button></div><section class=\"d-block d-sm-none\"><div class=\"main-forms col-md-6\"><div class=\"container row col-12 container-imovel proposta-status-card status-proposta\"><div class=\"col-1 p-0\"><div class=\"circle mr-2 mt-2\" ng-class=vm.propostaStatus.status.type></div></div><div class=\"col-10 p-0\"><p class=\"title active\">{{ vm.propostaStatus.status.name }}</p><p class=\"detail active\">Atualizado em: {{ vm.toDate(vm.propostaStatus.statusCreatedAt) }}</p></div></div><button ng-if=\"ConfigWhiteLabel.imb_config_crm && ConfigWhiteLabel.imb_config_crm.imb_analise\" class=cotacao-seguros-btn style=\"width: 100%; margin-bottom: 24px\" ng-click=vm.openModal() ng-class=\"{disabled: !vm.propostaStatus.cotacao_seguros, reprovado: !vm.checkIfApproved()}\" ng-disabled=!vm.propostaStatus.cotacao_seguros>Cotações de Seguro Fiança</button></div></section><section class=\"main container-fluid d-flex flex-column flex-lg-row p-0\"><div class=\"main-forms col-md-8 col-lg-6\"><div class=\"container row container-imovel\"><div class=\"col-12 p-0 image background-status-image\" ng-style=\"{\'background-image\': \'url({{ vm.propostaStatus.images[0].url }})\'}\"></div><div class=\"col-12 p-0 md-3 mt-3\"><p class=titulo>{{ vm.propostaStatus.title }}</p><p class=address>{{ vm.propostaStatus.address }}, {{ vm.propostaStatus.district }}</p><p class=\"address city\">{{ vm.propostaStatus.city }} - {{ vm.propostaStatus.uf }}</p><ul><li ng-if=vm.propostaStatus.totalArea><span class=font-weight-bold>{{ vm.propostaStatus.totalArea || 0 }} m² </span>Útil</li><li ng-if=vm.propostaStatus.bedroomsQuantity><span class=font-weight-bold>{{ vm.propostaStatus.bedroomsQuantity || 0 }} </span>{{ vm.propostaStatus.bedroomsQuantity > 1 ? \'Quartos\' : \'Quarto\' }}</li><li ng-if=vm.propostaStatus.bathroomsQuantity><span class=font-weight-bold>{{ vm.propostaStatus.bathroomsQuantity || 0}} </span>{{vm.propostaStatus.bathroomsQuantity > 1 ? \'Banheiros\' : \'Banheiro\' }}</li></ul><div class=\"d-flex justify-content-between\" ng-if=vm.propostaStatus.condominiumPrice><p class=label>Valor do condomínio</p><p class=price>{{ vm.formatPrice(vm.propostaStatus.condominiumPrice) }}</p></div><div class=\"d-flex justify-content-between\" ng-if=vm.propostaStatus.rentPrice><p class=\"label m-0\">Valor do aluguel</p><p class=\"price m-0\">{{ vm.formatPrice(vm.propostaStatus.rentPrice) }}</p></div></div></div></div><div class=\"pl-4 status-proposta\"><div class=row><h6>Acompanhe os status da sua proposta:</h6></div><div ng-repeat=\"status in vm.statusList\"><div class=\"row col-12 col-sm-12 pl-0\"><div class=\"col-1 col-sm-1 pl-0\"><div class=\"circle mr-2 align-self-center\" ng-class=vm.circleClass(status)></div><div ng-if=\"$index != vm.statusSize - 1\"><div class=vertical-line ng-class=\"vm.propostaStatus.status.name != status.name && status.type\"></div></div></div><div class=\"col-11 col-sm-11 pl-0\"><p class=\"title m-0\" ng-class=vm.stepTextClass(status)>{{ status.name }}</p><p class=\"detail m-0\" ng-class=vm.stepTextClass(status)>Atualizado em: {{ vm.toDate(status.createdAt) }}</p></div></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.anexos.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=\"col-12 form-default\" id=img-container><h3 class=title>Faça upload da sua documentação</h3><div ng-repeat=\"(i, row) in vm.inputFiles\"><strong>{{row.ptax_nome}}</strong><div class=\"well my-drop-zone small\" name=teste nv-file-drop nv-file-over=\"\" uploader=uploaderFile[i]><label><div class=\"image-preview d-flex flex-wrap\"><div class=\"d-flex rectangle-label\" ng-repeat=\"item in uploaderFile[i].queue\"><a class=float-left href=# ng-click=item.remove()><i class=\"fa fal fa-times\" aria-hidden=true></i></a><div ng-thumb=\"{ file: item._file, width: 100 }\"></div><span class=progress><div class=progress-bar role=progressbar ng-style=\"{ \'width\': uploaderFile[i].progress + \'%\' }\" style=\"width: 0%\"></div></span></div></div><input type=file nv-file-select=\"\" uploader=uploaderFile[i] name=uploaderMessage multiple class=d-none> <span ng-show=!uploaderFile[i].queue.length class=m-auto><span>Clique</span> ou <span>arraste</span> uma ou mais fotos</span></label></div><div class=\"errMsg bold\"><p class=redLabel ng-show=!uploaderFile[i].queue.length>Adicione o documento</p></div></div><div class=\"d-flex w-100 pb-4\"><input type=checkbox id=form-rapido-checkbox name=\"\" class=\"input-control square abs\" ng-model=vm.checkSend><label for=form-rapido-checkbox class=\"checkbox col-12\"><span>Eu me responsabilizo pela autenticidade dos documentos apresentados e pela veracidade das informações prestadas.</span></label></div><div class=\"d-flex w-100 pb-4\"><button class=\"btn button btn-default col-5 col-sm-4\" ng-disabled=!vm.checkSend ng-click=vm.sendAnexos()>Enviar documentação</button></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.confirmacao-contra.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Contraproposta aceita.</h2><p>Parabéns, você aceitou a contraproposta.</p><p>Um e-mail será enviado para o proprietário informando o status contraproposta aceita pelo cliente e vamos dar sequência à negociação.</p><p>Te manteremos informado.</p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.confirmacao.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Proposta aceita</h2><p>Parabéns, você aceitou a proposta!</p><p>Enviamos um e-mail ao cliente interessado, para informá-lo e dar sequência à negociação. Te manteremos informado sobre qualquer atualização.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.conjunta.html","<div id=proposta-form class=\"h-100 margin-fluid prop-venda-conjunta\"><section class=container><form name=locacaoconjunta ng-submit=vm.submit($event)><div class=form-default><h3 style=\"margin-bottom: 0px\">Compra conjunta do imóvel | {{vm.cod_imovel}}</h3><a class=link-imovel-site target=_blank href=\"{{vm.urlSite }}/imovel/{{vm.cod_imovel}}\">Link do anúncio<span class=\"fa fa-external-link\"></span></a><div class=\"form-group d-flex\"><input type=text id=form-c-name class=\"form-control upper mr-0\" ng-model=vm.parte.name autocomplete=off required><label for=form-c-name class=\"ml-1 pl-3 upper\">Nome completo?</label></div><div class=\"form-group d-flex flex-column\"><input type=email id=form-email name=form-email class=\"form-control upper mr-0\" ng-model=vm.parte.email autocomplete=off required><label for=form-email class=\"ml-1 pl-3 upper\">Qual o seu email?</label><div ng-messages=\"locacaoconjunta[\'form-email\'].$error\" ng-if=\"locacaoconjunta[\'form-email\'].$dirty\" role=alert class=ng-message><div ng-message=email>Email incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><input type=tel id=form-phone name=form-phone class=\"form-control upper mr-0\" ng-model=vm.parte.phone autocomplete=off ui-br-phone-number=areaCode ng-required><label for=form-phone class=\"ml-1 pl-3 upper\">Telefone de contato?</label><div ng-messages=\"locacaoconjunta[\'form-phone\'].$error\" ng-if=\"locacaoconjunta[\'form-phone\'].$dirty\" role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"input-check-foreigner d-flex\"><div class=\"form-group d-flex\"><input ng-disabled=!isEstrangeiroPropConjunta type=text name=form-c-nationality class=\"form-control upper mr-0\" id=form-nationality ng-model=vm.parte.nationality uib-typeahead=\"row as row.label for row in vm.getNationalityPropConjunta($viewValue)\" required><label for=form-c-nationality class=\"ml-1 pl-3 upper\">Qual a sua nacionalidade?</label><i class=\"fas fa-search\"></i></div><div class=\"check-estrangeiro d-flex ml-3 mb-3\"><input ng-model=isEstrangeiroPropConjunta ng-click=vm.checkEstrangeiroPropConjunta($event) type=checkbox><label style=\"margin: 0\">Estrangeiro</label></div></div><div class=\"form-group d-flex\"><input type=text name=form-c-professional class=\"form-control upper mr-0\" id=form-professional ng-model=vm.parte.professional><label for=form-c-professional class=\"ml-1 pl-3 upper\">Qual é a profissão?</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-birthday class=\"form-control upper mr-0\" ng-model=vm.parte.birthday autocomplete=off ui-date-mask=DD/MM/YYYY required><label for=form-c-birthday class=\"ml-1 pl-3 upper\">Data de nascimento?</label></div><div ng-if=!isEstrangeiroPropConjunta class=\"form-group d-flex\"><input type=tel id=form-c-docRG class=\"form-control upper mr-0\" ng-model=vm.parte.docRG autocomplete=off required><label for=form-c-docRG class=\"ml-1 pl-3 upper\">RG</label></div><div ng-if=isEstrangeiroPropConjunta class=\"form-group d-flex\"><input type=tel id=form-c-docCRNM class=\"form-control upper mr-0\" ng-model=vm.parte.docCRNM autocomplete=off required><label for=form-c-docCRNM class=\"ml-1 pl-3 upper\">CRNM</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-docCPF class=\"form-control upper mr-0\" ng-model=vm.parte.docCPF autocomplete=off ui-br-cpf-mask required><label for=form-c-docCPF class=\"ml-1 pl-3 upper\">CPF</label></div></div><button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Próximo<i class=\"fal fa-arrow-right\"></i></button><div class=clearfix></div></form></section></div>");
$templateCache.put("app/proposta-compra/proposta.contraproposta.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><form name=contraproposta ng-submit=\"contraproposta.$valid && vm.submit($event)\" ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=title>Faça sua Contraproposta</h2></div><div class=\"form-group d-flex flex-column\" ng-if=vm.prop_valor><p>a proposta inicial é de {{ vm.prop_valor | currency: \'R$ \' }}</p><p ng-if=vm.cprop_valor>a proposta contraproposta é de {{ vm.cprop_valor | currency: \'R$ \' }}</p></div><div class=\"form-group d-flex flex-column\"><div class=d-flex><label for=form-valor class=\"mr-1 pt-3\">R$</label><input type=tel id=form-valor name=form-valor class=\"form-control col-10 col-md-5 upper\" ng-model=vm.data.valor autocomplete=off ui-number-mask=0 required><label for=form-valor class=\"ml-4 pl-3 upper\">Qual o valor da contraproposta?</label><label for=form-valor class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"contraproposta[\'form-valor\'].$error\" ng-if=\"contraproposta[\'form-valor\'].$dirty\" role=alert class=ng-message><div ng-message=pattern>Nome incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><textarea type=tel id=form-justificativa name=form-justificativa class=\"form-control upper col-12 col-sm-7\" ng-model=vm.data.justificativa autocomplete=off rows=5 required></textarea><label for=form-justificativa class=\"ml-1 pl-3 upper\">Qual a justificativa da contraproposta?</label><div ng-messages=\"contraproposta[\'form-justificativa\'].$error\" ng-if=\"contraproposta[\'form-justificativa\'].$dirty\" role=alert class=ng-message><div ng-message=pattern>Nome incorreto.</div><div ng-message=required>Campo requerido.</div></div></div></div><button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Enviar contraproposta <i class=\"fal fa-arrow-right\"></i></button><div class=clearfix></div></form><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Contraproposta enviada</h2><p>Enviamos um e-mail ao cliente interessado, para informá-lo e dar sequência à negociação. Te manteremos informado sobre qualquer atualização.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.form.html","<div id=proposta-form class=margin-fluid><section class=\"main container-fluid d-flex flex-column flex-md-row p-0\" ng-init=vm.getCardData(vm.card_imovel)><div class=\"asidebar col-md-4 col-xl-3\"><div class=wrapperSidebar><ol class=steps><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{ active: vm.checkStep(1) }\"><span class=my-auto>INICIE A SUA PROPOSTA</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{ active: vm.checkStep(2) }\"><button class=rewind ng-click=vm.novaProposta()>&#60;</button> <span class=my-auto>IMÓVEL E NEGOCIAÇÃO</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{ active: vm.checkStep(3) }\"><button class=rewind ng-click=vm.prevStep()>&#60;</button> <span class=my-auto>DADOS PESSOAIS</span></li><li class=\"item d-flex align-items-center justify-content-center justify-content-md-end\" ng-class=\"{ active: vm.checkStep(4) }\"><button class=\"rewind revise-sua-proposta\">&#60;</button> <span class=\"my-auto revise-sua-proposta\">REVISE A SUA PROPOSTA</span></li></ol></div></div><div class=\"main-forms col-md-8 col-xl-6\"><div class=\"d-flex flex-column forms\"><div class=\"form animated col-xl-10 px-0 mx-auto proposta-sucesso\" ng-show=vm.urlshare><div id=proposta-realizada><h2>Sua proposta foi enviada!</h2><p>Fique atento ao e-mail cadastrado. Você será notificado dos próximos passos de sua negociação por lá.</p></div><div class=form-default><p>Fique atento ao e-mail<strong>{{ vm.emailParte }}</strong>. Enviaremos todos os dados da proposta para o email cadastrado.</p><p>Caso seja uma compra conjunta, envie esse link para que as demais partes entrem na proposta.</p><div class=form-group><div class=\"input-group d-flex\"><input type=text name=form-shareurl class=\"form-control noselect mr-0 py-2\" id=valueToCopy readonly ng-model=vm.urlshare><div class=\"input-group-append c-pointer\"><i class=\"fal fa-clone input-group-text\" ng-click=vm.copyPaste()></i></div></div></div></div></div><div id=form-step-1 class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(1)><div class=form-default><h3>CATEGORIA DE {{ vm.tpng.client_label.toUpperCase() }}</h3><label for=form-btn class=pb-4>A {{ vm.tpng.client_label }} do imóvel será em</label><div id=form-btn class=\"form-group d-flex flex-column justify-content-around\"><button class=\"btn button btn-default\" ng-click=\"vm.setperfil(\'fisica\')\">Pessoa fisica</button> <button class=\"btn button btn-default\" ng-click=\"vm.setperfil(\'juridico\')\">Pessoa Juridica</button></div></div></div><div id=form-step-2 class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(2) style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>IMÓVEL E NEGOCIAÇÃO</h3><label class=pb-4>Nesse campo, nos conte sobre o imóvel que gostou e como planeja negociá-lo.</label><div class=\"containerDropdown d-flex justify-content-between align-items-center\" ng-click=vm.toggleImovel() ng-if=\"vm.isMobile() && vm.data.cod_imovel.id\"><span>Informações sobre o imóvel</span> <i ng-class=\"\n                  vm.showImovel ? \'fal fa-chevron-up\' : \'fal fa-chevron-down\'\n                \"></i></div><form action=\"\" name=etapanome ng-submit=\"vm.negocio($event, etapanome)\" novalidate><div class=\"form-group d-flex flex-row mb-0\"><label for=form-corretor class=ml-1>Você está sendo atendido por:</label><span class=ml-1 id=form-corretor name=form-corretor ng-model=\"vm.data.corretor[\'id\']\" ng-readonly=vm.corretorRead ng-class=\"{ sbmtd: vm.subterror }\" style=\"font-weight: bold; color: #00bf70\">{{ vm.data.corretor[\'label\'] || \'Não informado\' }}</span><div ng-messages=\"etapanome[\'form-corretor\'].$error\" ng-if=vm.subterror style=\"color: red\"><div ng-message=autcmplt>Selecione um corretor</div></div></div><div style=\"display: flex; justify-content: center; font-size: x-large\"><span ng-if=vm.isLoading ng-bind-html=vm.spinner class=font-weight-bold></span></div><div class=\"container row container-imovel\" ng-if=\"vm.data.cod_imovel.id && vm.showImovel && !vm.isLoading\"><div class=\"col-12 col-md-6 p-0 image\" ng-style=\"{\'background-image\': \'url({{ vm.data.cod_imovel.fotos.length > 0 ? vm.imageThumb(vm.data.cod_imovel.fotos[0].imvft_url) : \'https://www.arboimoveis.com.br/fallback.png\' }})\'}\"></div><div class=\"col-12 col-md-6 p-0 pl-md-3\"><p class=titulo>{{ vm.data.cod_imovel.imv_titulo }}</p><p class=address>{{ vm.data.cod_imovel.imv_endereco }}, {{ vm.data.cod_imovel.imv_bairro }}</p><p class=\"address city\">{{ vm.data.cod_imovel.imv_cidade }} - {{ vm.data.cod_imovel.imv_estado }}</p><p class=\"address city\" style=\"margin-top: -4%\">Cód. imóvel: {{ vm.data.cod_imovel.imv_cod_gaia }}</p><ul><li ng-if=vm.data.cod_imovel.imv_area_util><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_area_util || 0 }} m²</span> Útil</li><li ng-if=vm.data.cod_imovel.imv_qtd_dorm><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_qtd_dorm || 0 }}</span> {{ vm.data.cod_imovel.imv_qtd_dorm > 1 ? \'Quartos\' : \'Quarto\' }}</li><li ng-if=vm.data.cod_imovel.imv_qtd_banheiros><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_qtd_banheiros || 0 }}</span> {{ vm.data.cod_imovel.imv_qtd_banheiros > 1 ? \'Banheiros\' : \'Banheiro\' }}</li></ul><div class=\"d-flex justify-content-between\" ng-if=vm.data.cod_imovel.imv_preco_cond><p class=label>Valor do condomínio</p><p class=price>{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_cond) }}</p></div><div class=\"d-flex justify-content-between\" ng-if=\"\n                      vm.data.cod_imovel.imv_preco_venda && vm.tpng.id === 1\n                    \"><p class=\"label m-0\">Valor da compra</p><p class=\"price m-0\">{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_venda) }}</p></div><div class=\"d-flex justify-content-between\" ng-if=\"\n                      vm.data.cod_imovel.imv_preco_locacao && vm.tpng.id === 2\n                    \"><p class=\"label m-0\">Valor do aluguel</p><p class=\"price m-0\">{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_locacao) }}</p></div></div></div><div class=\"d-flex flex-column\"><label ng-if=\"vm.data.cod_imovel.imv_preco_venda && vm.tpng.id === 1\" for=form-locacao>Valor da sua proposta de compra</label><label ng-if=\"\n                    vm.data.cod_imovel.imv_preco_locacao && vm.tpng.id === 2\n                  \" for=form-locacao>Valor da sua proposta de locação</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input type=tel id=form-locacao name=form-locacao class=\"form-control col-10 col-md-5\" ng-model=vm.data.priceLocacao ng-class=\"{ sbmtd: vm.subterror }\" autocomplete=off ui-number-mask=0 required><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-locacao\'].$error\" ng-if=vm.subterror><div ng-message=required style=\"color: red; margin-top: -12px; margin-bottom: 12px\">Campo requerido</div></div></div><div class=\"form-group d-flex flex-column col-12\" ng-include=\"\'app/proposta-compra/partials/part-modalidades.html\'\"></div><div class=\"d-flex flex-column\" ng-if=\"vm.tpng.id === 2\"><label for=form-renda>{{vm.proposta.perfil ? \'Informe o faturamento mensal da empresa\' : \'Informe sua renda mensal\'}}</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input type=tel id=form-renda name=form-renda class=\"form-control col-10 col-md-5\" ng-model=vm.data.renda_mensal ng-class=\"{ sbmtd: vm.subterror }\" autocomplete=off ui-number-mask=0 required><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-renda\'].$error\" ng-if=vm.subterror><div ng-message=required style=\"color: red; margin-top: -12px; margin-bottom: 12px\">Campo requerido</div></div></div><div><div class=\"d-flex flex-column\" ng-if=\"vm.tpng.id === 2\"><label for=form-locacao>Data da pretensão de entrada</label><div id=datepicker-form-entrance class=\"form-group d-flex date\" data-provide=datepicker><input ng-change=\"vm.resetCustomValidation(\'form-entrace\',[\'olddate\'])\" type=tel id=form-entrace name=form-entrace class=\"form-control col-10 col-md-5\" placeholder=dd/mm/aaaa ng-model=vm.data.propt_data_pretencao autocomplete=off ui-date-mask=DD/MM/YYYY ng-class=\"{ sbmtd: vm.subterror }\" required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"etapanome[\'form-entrace\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required style=\"color: red;\n                        margin-top: -12px;\n                        margin-bottom: 12px;\n                        font-size: 16px\">Campo requerido.</div><div ng-message=date style=\"color: red;\n                        margin-top: -12px;\n                        margin-bottom: 12px;\n                        font-size: 16px\">Data inválida</div><div ng-message=olddate style=\"color: red;\n                        margin-top: -12px;\n                        margin-bottom: 12px;\n                        font-size: 16px\">Data de entrada deve ser maior que {{ vm.calendario() }}</div></div></div><div class=\"d-flex flex-column\"><label for=form-locacao></label></div><div class=\"form-group d-flex flex-column\"><label for=form-addConditions class=ml-1>Quais seriam as condições adicionais ?</label><textarea type=tel id=form-addConditions class=\"form-control col-12 col-sm-7\" ng-model=vm.data.addConditions autocomplete=off rows=5 placeholder=Descreva>\n<sub>(campo opcional)</sub></textarea></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\" ng-if=!vm.proposta.perfil><label for=form-docCPF class=ml-1>Para continuar informe seu CPF</label><input type=tel id=form-docCPF name=form-docCPF class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCPF autocomplete=off ng-class=\"{ sbmtd: vm.subterror }\" placeholder=\"Digite seu CPF\" ui-br-cpf-mask required><div ng-messages=\"etapanome[\'form-docCPF\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cpf>CPF incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\" ng-if=vm.proposta.perfil><label for=form-docCNPJ class=\"d-flex ml-1\">Informe o CNPJ da empresa</label><input type=tel id=form-docCNPJ name=form-docCNPJ class=\"form-control mr-0\" ng-model=vm.data.parte[0].docCNPJ autocomplete=off placeholder=\"Digite o CNPJ\" ui-br-cnpj-mask ng-class=\"{ sbmtd: vm.subterror }\" required><div ng-messages=\"etapanome[\'form-docCNPJ\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=cnpj>CNPJ incorreto.</div><div ng-message=required>Campo requerido.</div></div></div></div><div class=\"form-group d-flex flex-column\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-proposta-check name=detail-co class=\"input-control square\" ng-model=vm.form.propt_accept_terms ng-true-value=true ng-false-value=false><label for=form-proposta-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div><div class=submit-box><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left\" ng-click=vm.novaProposta()>Voltar</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\" ng-disabled=\"(vm.config_wl.isArbo && !vm.form.propt_accept_terms)\">Próximo <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></form></div></div><div id=form-step-3 class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=vm.checkStep(3) style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>DADOS PESSOAIS</h3><label class=pb-4>Nos conte sobre você</label><form action=\"\" name=etapadocs ng-submit=\"vm.pessoais($event, etapadocs)\" novalidate><input type=hidden ng-if=!vm.proposta.perfil id=form-c-name ng-init=\"vm.data.type = 2\" autocomplete=off> <input type=hidden ng-if=vm.proposta.perfil id=form-c-name ng-init=\"vm.data.type = 5\" autocomplete=off><div class=\"form-group d-flex flex-column\" ng-if=!vm.proposta.perfil><label for=form-name ng-if=!vm.proposta.perfil class=ml-1>Qual é o seu nome completo?</label><label for=form-name ng-if=vm.proposta.perfil class=ml-1>Qual a razão social da empresa?</label><input type=text id=form-name name=form-name class=\"form-control mr-0\" ng-if=!vm.proposta.perfil ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.name autocomplete=off placeholder=\"Escreva seu nome\" required> <input type=text id=form-name name=form-name class=\"form-control mr-0\" ng-if=vm.proposta.perfil ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.name autocomplete=off placeholder=\"Escreva a razão social da rasão social da empresa\" required><div ng-messages=\"etapadocs[\'form-name\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\" ng-if=!vm.proposta.perfil><label for=form-name class=ml-1>Data de nascimento</label><div class=\"input-group date\" data-provide=datepicker><input type=tel id=form-dataNasc name=form-dataNasc class=\"form-control mr-0\" ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.dataNasc autocomplete=off placeholder=DD/MM/AAAA ui-date-mask=DD/MM/YYYY required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"etapadocs[\'form-dataNasc\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div><div ng-message=date>Data inválida.</div><div ng-message=dateCheck>Data inválida.</div></div></div><div class=\"form-group d-flex flex-column\" ng-if=!vm.proposta.perfil><label for=form-email class=ml-1 ng-if=!vm.proposta.perfil>Qual o seu email?</label><input type=email id=form-email name=form-email ng-if=!vm.proposta.perfil class=\"form-control mr-0\" ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.email autocomplete=off placeholder=email@dominio.com pattern=\"[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\" required><div ng-messages=\"etapadocs[\'form-email\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=email>Email incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\" ng-if=!vm.proposta.perfil><label for=form-phone class=ml-1>Telefone de contato?</label><input type=tel id=form-phone name=form-phone class=\"form-control mr-0 ng-valid-br-phone-number\" ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.phone pattern=(?:^\\([0]?[1-9]{2}\\)\\s|^[0]?[1-9]{2}[\\.-\\s]?)[9]?[1-9]\\d{3}[\\.-\\s]?\\d{4}$ autocomplete=off placeholder=\"(00) 99999-9999\" ui-br-phone-number=areaCode required><div ng-messages=\"etapadocs[\'form-phone\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone inválido.</div><div ng-message=required>Campo requerido.</div></div></div><div ng-if=vm.proposta.perfil><input type=hidden id=form-c-name ng-init=\"vm.data.parte[0].type = 4\" autocomplete=off><label for=\"\">Dados Sócio Administrador</label><input type=hidden id=form-c-name ng-init=\"vm.data.parte[1].type = 5\" autocomplete=off><div class=\"form-group d-flex flex-column\"><label for=form-c-name class=\"d-flex ml-1\">Nome completo?</label><input type=text id=form-c-name name=form-c-name class=\"form-control mr-0\" ng-model=vm.data.parte[1].name autocomplete=off placeholder=\"Digite seu nome\" ng-class=\"{ sbmtd: vm.subterror }\" required><div ng-messages=\"etapadocs[\'form-c-name\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\" ng-if=vm.proposta.perfil><label for=form-name class=ml-1>Data de nascimento</label><div class=\"input-group date\" data-provide=datepicker><input type=tel id=form-dataNasc name=form-dataNasc class=\"form-control mr-0\" ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.dataNasc autocomplete=off placeholder=DD/MM/AAAA ui-date-mask=DD/MM/YYYY required><div class=input-group-addon><span class=\"glyphicon glyphicon-th\"></span></div></div><div ng-messages=\"etapadocs[\'form-dataNasc\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div><div ng-message=date>Data inválida.</div><div ng-message=dateCheck>Data inválida.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-p2email class=\"d-flex ml-1\">Um email de contato para o sócio administrador?</label><input type=email id=form-p2email name=form-p2email class=\"form-control mr-0\" ng-model=vm.data.parte[1].email autocomplete=off placeholder=email@dominio.com ng-class=\"{ sbmtd: vm.subterror }\" pattern=\"[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\" required><div ng-messages=\"etapadocs[\'form-p2email\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column col-md-8 col-xl-5\"><label for=form-phone class=ml-1>Telefone de contato?</label><input type=tel id=form-p2phone name=form-p2phone class=\"form-control mr-0 ng-valid-br-phone-number\" ng-class=\"{ sbmtd: vm.subterror }\" ng-model=vm.data.phone autocomplete=off placeholder=\"(00) 99999-9999\" pattern=(?:^\\([0]?[1-9]{2}\\)\\s|^[0]?[1-9]{2}[\\.-\\s]?)[9]?[1-9]\\d{3}[\\.-\\s]?\\d{4}$ ui-br-phone-number=areaCode required><div ng-messages=\"etapadocs[\'form-phone\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone incorreto.</div><div ng-message=required>Campo requerido.</div></div></div></div><div class=submit-box><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left\" ng-click=vm.prevStep()>Voltar</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\">Próximo <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></form></div></div><div id=form-step-4 class=\"form animated col-xl-10 px-0 mx-auto\" ng-show=\"vm.checkStep(4) && !vm.urlshare\" style=\"transition: all 0.4s ease-in-out\"><div class=form-default><h3>ENVIAR PROPOSTA</h3><label class=pb-4>Revise a sua proposta</label><form action=\"\" name=etapacontato ng-submit=vm.enviar($event) novalidate><p style=\"margin-bottom: 32px\">Pronto, agora é só revisar os dados e confirmar sua proposta.<br>Clique em Finalizar proposta se estiver tudo certo.</p><div class=\"containerDropdown d-flex justify-content-between align-items-center\" ng-click=vm.toggleImovel() ng-if=\"vm.isMobile() && vm.data.cod_imovel.id\"><span>Informações sobre o imóvel</span> <i ng-class=\"\n                    vm.showImovel ? \'fal fa-chevron-up\' : \'fal fa-chevron-down\'\n                  \"></i></div><div class=\"container row container-imovel\" ng-if=\"vm.data.cod_imovel.id && vm.showImovel\"><div class=\"col-12 col-md-6 p-0 image\" ng-style=\"{\'background-image\': \'url({{ vm.data.cod_imovel.fotos.length > 0 ? vm.imageThumb(vm.data.cod_imovel.fotos[0].imvft_url) : \'https://www.arboimoveis.com.br/fallback.png\' }})\'}\"></div><div class=\"col-12 col-md-6 p-0 pl-md-3\"><p class=titulo>{{ vm.data.cod_imovel.imv_titulo }}</p><p class=address>{{ vm.data.cod_imovel.imv_endereco }}, {{ vm.data.cod_imovel.imv_bairro }}</p><p class=\"address city\">{{ vm.data.cod_imovel.imv_cidade }} - {{ vm.data.cod_imovel.imv_estado }}</p><ul><li ng-if=vm.data.cod_imovel.imv_area_util><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_area_util || 0 }} m²</span> Útil</li><li ng-if=vm.data.cod_imovel.imv_qtd_dorm><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_qtd_dorm || 0 }}</span> {{ vm.data.cod_imovel.imv_qtd_dorm > 1 ? \'Quartos\' : \'Quarto\' }}</li><li ng-if=vm.data.cod_imovel.imv_qtd_banheiros><span class=font-weight-bold>{{ vm.data.cod_imovel.imv_qtd_banheiros || 0 }}</span> {{ vm.data.cod_imovel.imv_qtd_banheiros > 1 ? \'Banheiros\' : \'Banheiro\' }}</li></ul><div class=\"d-flex justify-content-between\" ng-if=vm.data.cod_imovel.imv_preco_cond><p class=label>Valor do condomínio</p><p class=price>{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_cond) }}</p></div><div class=\"d-flex justify-content-between\" ng-if=\"\n                      vm.data.cod_imovel.imv_preco_venda && vm.tpng.id === 1\n                    \"><p class=\"label m-0\">Valor da compra</p><p class=\"price m-0\">{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_venda) }}</p></div><div class=\"d-flex justify-content-between\" ng-if=\"\n                      vm.data.cod_imovel.imv_preco_locacao && vm.tpng.id === 2\n                    \"><p class=\"label m-0\">Valor do aluguel</p><p class=\"price m-0\">{{ vm.formatPrice(vm.data.cod_imovel.imv_preco_locacao) }}</p></div></div></div><div class=relatorio><div class=\"section-title d-flex row\"><h4 class=\"col-12 col-md-7 col-xl-6\">Imóvel e Negociação</h4><button type=button class=\"btn d-md-flex col-12 col-md-5 col-xl-4\" ng-click=\" vm.gonegocio()\">Voltar para etapa</button></div><div class=row><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.corretor><span class=\"fieldlabel d-flex\">Corretor</span> <span class=fieldvalue>{{ vm.data.corretor.label }}</span></div><div class=\"col-6 col-md-6 d-flex flex-column\" ng-if=vm.data.tnmod_id><span class=fieldlabel>Modelo de negociação</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 1\">Sem garantia</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 2\">Seguro fiança</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 5\">Título de capitalização</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 6\">À vista</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 7\">Permuta</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 8\">Financiamento</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 9\">Consórcio</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 10\">Outra modalidade</span> <span class=fieldvalue ng-if=\"vm.data.tnmod_id === 11\">Cartão de crédito</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 7\"><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_imovel><span class=fieldlabel>Imovel</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_imovel }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_carro><span class=fieldlabel>Carro</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_carro }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.permuta_outro><span class=fieldlabel>Outro</span> <span class=fieldvalue>{{ vm.data.descricao.permuta_outro }}</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 8\"><div class=\"col-12 col-md-4 d-flex flex-column\"><span class=fieldlabel ng-if=\"vm.data.tnmod_id === 8\">Banco</span> <span class=fieldvalue ng-if=vm.data.descricao.caixa>Caixa Econômica Federal</span> <span class=fieldvalue ng-if=vm.data.descricao.bb>Banco do Brasil</span> <span class=fieldvalue ng-if=vm.data.descricao.santander>Santander</span> <span class=fieldvalue ng-if=vm.data.descricao.bradesco>Bradesco</span> <span class=fieldvalue ng-if=vm.data.descricao.banco_outros>{{ vm.data.descricao.banco_outros }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.banco_agencia><span class=fieldlabel>Agência</span> <span class=fieldvalue>{{ vm.data.descricao.banco_agencia }}</span></div><div class=\"col-12 col-md-4 d-flex flex-column\" ng-if=vm.data.descricao.financiamento_valor><span class=fieldlabel>Valor do financiamento</span> <span class=fieldvalue>R$ {{ vm.data.descricao.financiamento_valor.toLocaleString( \'pt-BR\' ) }},00</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 9\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.descricao.consorcio_valor><span class=fieldlabel>Valor total do consórcio</span> <span class=fieldvalue>R$ {{ vm.data.descricao.consorcio_valor.toLocaleString( \'pt-BR\' ) }},00</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.descricao.consorciadora><span class=fieldlabel>Consorciadora</span> <span class=fieldvalue>{{ vm.data.descricao.consorciadora }}</span></div></div><div class=row ng-if=\"vm.data.tnmod_id === 10\"><div class=\"col-12 col-md-12 d-flex flex-column\" ng-if=vm.data.descricao.outros_descreva><span class=fieldlabel>Descrição modalidade</span> <span class=fieldvalue>{{ vm.data.descricao.outros_descreva }}</span></div></div><div class=row ng-if=\"vm.data.cod_imovel || vm.data.priceLocacao\"><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.cod_imovel><span class=fieldlabel>Código do Imovel</span> <span class=fieldvalue>{{ vm.data.cod_imovel.imv_cod_gaia }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.priceLocacao><span class=fieldlabel>Valor da proposta</span> <span class=fieldvalue>R$ {{ vm.data.priceLocacao.toLocaleString(\'pt-BR\') }},00</span></div></div><div class=row ng-if=\"vm.data.propt_dia_pag || vm.data.propt_data_pretencao\"><div class=\"col-12 col-md-6 d-flex flex-column\"><span class=fieldlabel>Data da pretensão de entrada</span> <span class=fieldvalue>{{ vm.calendario(vm.data.propt_data_pretencao) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.renda_mensal><span class=fieldlabel>Renda mensal</span> <span class=fieldvalue>R$ {{ vm.data.renda_mensal.toLocaleString(\'pt-BR\') }},00</span></div></div><div class=row ng-if=vm.data.addConditions><div class=\"col-12 col-md-12 d-flex flex-column\"><span class=fieldlabel>Condições adicionais</span> <span class=fieldvalue>{{ vm.data.addConditions }}</span></div></div><div class=\"section-title d-flex row\"><h4 class=\"col-12 col-md-7 col-xl-6\">Dados Pessoais</h4><button type=button class=\"btn d-md-flex col-12 col-md-5 col-xl-4\" ng-click=\" vm.gopessoal()\">Voltar para etapa</button></div><div class=row ng-if=\"(vm.data.name || vm.data.dataNasc) &&\n                !vm.proposta.perfil\"><div class=\"col-12 col-md-6 d-flex flex-column\"><span class=fieldlabel>Nome completo</span> <span class=fieldvalue>{{ vm.data.name }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.dataNasc && !vm.proposta.perfil\"><span class=fieldlabel>Data de nascimento</span> <span class=fieldvalue>{{ vm.calendario(vm.data.dataNasc) }}</span></div></div><div class=row><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.parte[1].name && vm.proposta.perfil\"><span class=fieldlabel>Nome do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].name }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.dataNasc && vm.proposta.perfil\"><span class=fieldlabel>Data de nascimento</span> <span class=fieldvalue>{{ vm.calendario(vm.data.dataNasc) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.parte[0].docCPF && !vm.proposta.perfil\"><span class=fieldlabel>CPF</span> <span class=fieldvalue>{{ vm.textFormatter.cpfMask(vm.data.parte[0].docCPF) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.email && !vm.proposta.perfil\"><span class=fieldlabel>Email</span> <span class=fieldvalue>{{ vm.data.email }}</span></div></div><div class=row><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=vm.data.phone><span class=fieldlabel>Telefone</span> <span class=fieldvalue ng-if=!vm.data.phone.numero>{{ vm.textFormatter.phoneMask(vm.data.phone) }}</span> <span class=fieldvalue ng-if=vm.data.phone.numero>{{ vm.textFormatter.phoneMask(vm.data.phone.numero) }}</span></div><div class=\"col-12 col-md-6 d-flex flex-column\" ng-if=\"vm.data.parte[0].docCNPJ && vm.proposta.perfil\"><span class=fieldlabel>CNPJ</span> <span class=fieldvalue>{{ vm.data.parte[0].docCNPJ | cnpjMask }}</span></div></div><div class=row ng-if=\"vm.data.parte[1].email && vm.proposta.perfil\"><div class=\"col-12 col-md-6 d-flex flex-column\"><span class=fieldlabel>Email do sócio</span> <span class=fieldvalue>{{ vm.data.parte[1].email }}</span></div></div><div class=\"section-title d-flex row\"><h4 style=\"margin-top: 10px\" ng-if=\"\n                    vm.data.parte[0].contatoNome || vm.data.parte[0].contatoTel\n                  \" class=\"col-12 col-md-7 col-xl-6\">Dados Contato</h4></div><div style=\"margin-top: 30px\" class=\"submit-box finalizarProposta\"><button type=button class=\"btn button btn-default col-12 col-sm-6 col-xl-5 float-left\" ng-click=vm.prevStep()>Voltar</button> <button type=submit class=\"btn button btn-default col-12 col-sm-4 float-right\">Finalizar proposta <i class=\"fal fa-arrow-right\"></i></button></div><div class=clearfix></div></div></form></div></div></div></div><div class=\"asidebar col-md-4 col-lg-3\"></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.html","<div ui-view></div>");
$templateCache.put("app/proposta-compra/proposta.locacaoconjunta.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><form name=locacaoconjunta ng-submit=vm.submit($event)><div class=form-default><h3>Locação conjunta do imovel <a href=\"{{vm.urlSite }}/imovel/{{vm.imovel}}\">link</a></h3><div class=\"form-group d-flex\"><input type=text id=form-c-name class=\"form-control upper mr-0\" ng-model=vm.parte.name autocomplete=off required placeholder=\"Seu Nome\"><label for=form-c-name class=\"ml-1 pl-3 upper\">Nome completo?</label></div><div class=\"form-group d-flex\"><input type=email id=form-email name=form-email class=\"form-control upper mr-0\" ng-model=vm.parte.email autocomplete=off required><label for=form-email class=\"ml-1 pl-3 upper\">Qual o seu email?</label><div ng-messages=\"locacaoconjunta[\'form-email\'].$error\" ng-if=\"locacaoconjunta[\'form-email\'].$dirty\" role=alert class=ng-message><div ng-message=email>Email incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><input type=tel id=form-phone name=form-phone class=\"form-control upper mr-0\" ng-model=vm.parte.phone autocomplete=off ui-br-phone-number=areaCode required><label for=form-phone class=\"ml-1 pl-3 upper\">Telefone de contato?</label><div ng-messages=\"locacaoconjunta[\'form-phone\'].$error\" ng-if=\"locacaoconjunta[\'form-phone\'].$dirty\" role=alert class=ng-message><div ng-message=brPhoneNumber>Telefone incorreto.</div><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex\"><input type=text name=form-c-nationality class=\"form-control upper mr-0\" id=form-nationality ng-model=vm.parte.nationality><label for=form-c-nationality class=\"ml-1 pl-3 upper\">Qual a sua nacionalidade?</label></div><div class=\"form-group d-flex\"><input type=text name=form-c-professional class=\"form-control upper mr-0\" id=form-professional ng-model=vm.parte.professional><label for=form-c-professional class=\"ml-1 pl-3 upper\">Qual é a profissão?</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-birthday class=\"form-control upper mr-0\" ng-model=vm.parte.birthday autocomplete=off ui-date-mask=DD/MM/YYYY required><label for=form-c-birthday class=\"ml-1 pl-3 upper\">Data de nascimento?</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-docRG class=\"form-control upper mr-0\" ng-model=vm.parte.docRG autocomplete=off required><label for=form-c-docRG class=\"ml-1 pl-3 upper\">RG</label></div><div class=\"form-group d-flex\"><input type=tel id=form-c-docCPF class=\"form-control upper mr-0\" ng-model=vm.parte.docCPF autocomplete=off ui-br-cpf-mask required><label for=form-c-docCPF class=\"ml-1 pl-3 upper\">CPF</label></div></div><button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Próximo<i class=\"fal fa-arrow-right\"></i></button><div class=clearfix></div></form></section></div>");
$templateCache.put("app/proposta-compra/proposta.recusa-contra.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Contraproposta recusada.</h2><p>Você recusou a contraproposta.</p><p>Enviamos um e-mail ao proprietário para informá-lo, encerrando a negociação. Caso queira iniciar uma nova proposta, visite a página mkt.arboimoveis.com.br.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.recusa.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Proposta recusada.</h2><p>Você recusou a proposta.</p><p>Enviamos um e-mail ao cliente interessado, para informá-lo, encerrando a negociação. Caso queira iniciar uma nova proposta.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=\"!vm.sucesso && !vm.resend\"><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Sentimos muito, ocorreu um erro e a proposta não pôde ser confirmada. Por favor, tente novamente ou entre em contato com <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793 </a>, ou através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></h2></div></div></div><div class=form ng-if=vm.resend><div class=form-default><div class=\"form-group d-flex flex-column\"><h2 class=title>Você já enviou um email</h2><p>Caso tenha alguma atualização, te manteremos informado.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div></section></div>");
$templateCache.put("app/proposta-compra/proposta.recusar.html","<div id=proposta-form class=\"h-100 margin-fluid\"><section class=container><div class=form ng-if=vm.sucesso><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Proposta recusada.</h2><p>Você recusou a proposta.</p><p>Enviamos um e-mail ao cliente interessado, para informá-lo, encerrando a negociação. Caso queira iniciar uma nova proposta.</p><p>Em caso de dúvidas ou algum outro problema, entre em contato com o suporte através do e-mail <a href=mailto:meajuda@arboimoveis.com>meajuda@arboimoveis.com</a></p></div></div></div><div class=form ng-if=!vm.sucesso><div class=form-default><div class=\"form-group d-flex\"><h2 class=\"title text-center\">Ocorreu um erro ao atualizar a proposta. Entre em contato <a href=tel:04340033793><i class=\"fal fa-phone fa-flip-horizontal\"></i> 4003-3793</a></h2></div></div></div></section></div>");
$templateCache.put("app/test/test.html","<button type=button class=\"btn btn-default\"><span class=simple-spinner></span></button>");
$templateCache.put("app/unsubscribe/unsubscribe.html","<section id=favorites><div id=favoritesResults class=\"d-flex flex-wrap justify-content-between justify-content-sm-start\"><div class=\"nenhum_imovel d-flex flex-column p-4\"><h1>Unsubscribe realizado com sucesso!</h1></div></div></section>");
$templateCache.put("app/account/dashboard/dashboard.html","<div id=dashboard class=\"dashboard pb-3\"><div class=\"gradient-header py-4 px-2 px-md-5 mb-2\"><h3 class=\"title col-12 my-0\">Meus Imóveis</h3><p class=\"col-12 my-0\">Home > Minha conta > {{vm.selectedTab[0]}} {{vm.selectedTab[1] ? \' > \' + vm.selectedTab[1] : \'\'}}</p></div><div class=\"ml-4 py-1 p-lg-0 m-lg-0\"><a ng-if=\"vm.selectedTab[0] == \'Meus imóveis\'\" class=\"d-inline-flex d-lg-none switch-btn btn rounded-pill mr-2\" ng-class=\"vm.tab == \'vender\' ? \'active\' : \'\'\" ui-sref=\"main.painel.dashboard({tab:\'vender\'})\">À Venda </a><a ng-if=\"vm.selectedTab[0] == \'Meus imóveis\'\" class=\"d-inline-flex d-lg-none switch-btn btn rounded-pill\" ng-class=\"vm.tab == \'alugar\' ? \'active\' : \'\'\" ui-sref=\"main.painel.dashboard({tab:\'alugar\'})\">Para alugar</a></div><div class=\"dash-body d-flex my-2 m-lg-5\"><div class=\"profile-wrapper col-3 d-lg-flex flex-column\"><div class=\"profile-card py-5\"><div class=\"profile d-flex flex-column align-items-center\"><div class=\"photo d-flex justify-content-center align-items-center\"><i class=\"fal fa-user\"></i></div><p class=\"title mt-4 mb-2\">{{vm.user.nome}}</p><a class=\"my-profile mb-2\" ui-sref=\"main.painel.dashboard({tab:\'meu-perfil\', selected})\">Meu perfil</a></div><nav class=navbar><div id=sidenav class=options><div class=submenu-header><a class=nav-link ng-click=vm.activeSubmenu($event)><i class=\"fal fa-home mr-2\"></i>Meus Imóveis <i class=\"icon-more fal fa-chevron-down\"></i></a><ul class=submenu ng-class=\"{\'active\': (vm.selectedTab[0] == \'Meus imóveis\')}\"><li><a class=nav-link ng-class=\"{\'active\': (vm.selectedTab[0] == \'Meus imóveis\') && (vm.selectedTab[1] == \'Para alugar\')}\" ui-sref=\"main.painel.dashboard({tab:\'alugar\',selected:\'publicados\'})\">Para alugar</a></li><li><a class=nav-link ng-class=\"{\'active\': (vm.selectedTab[0] == \'Meus imóveis\') && (vm.selectedTab[1] == \'Para vender\')}\" ui-sref=\"main.painel.dashboard({tab:\'vender\',selected:\'publicados\'})\">Para vender</a></li></ul></div><a class=nav-link ui-sref=\"main.painel.dashboard({tab:\'favoritos\',selected:\'todos\'})\" ng-class=\"{\'active\': (vm.selectedTab[0] == \'Favoritos\')}\" ui-sref=\"main.painel.dashboard({tab:\'favoritos\'})\"><i style=\"width: 18px\" class=\"fal fa-heart mr-2\"></i>Meus favoritos</a><a class=nav-link ng-class=\"{\'active\': (vm.selectedTab[0] == \'Renovação\')}\" ui-sref=\"main.painel.dashboard({tab:\'renovacao\', selected:\'todos\'})\"><i style=\"width: 18px\" class=\"fa fa-repeat mr-2\"></i>Aceite de Termos / Renovação</a></div></nav></div></div><div class=\"body-options col\" ng-show=\"vm.dashPage == 0\"><form class=\"col-12 col-md-9 mx-auto my-5\" ng-submit=vm.validacao($event) ng-readonly=true><div class=\"form-default mt-0\"><div class=\"form-group d-flex flex-column\"><span class=rowhead>Dados cadastrais</span><div><div class=\"row mb-2\"><input type=text id=user-email class=\"form-control upper col-12 mx-0\" ng-model=vm.form.email placeholder=email@dominio.com><label for=user-email class=\"pl-3 upper\">E-mail</label></div><div class=\"row mb-2\"><input type=tel id=user-telefones class=\"form-control upper col-12 mx-0\" ng-model=\"vm.lastTel[\'numero\']\" ui-br-phone-number=areaCode placeholder=\"(00) 9 9999-9999\"><label for=user-telefones class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-2\"><input type=tel id=user-rg class=\"form-control upper col-12 mx-0\" ng-model=vm.form.rg placeholder=\"Seu RG\"><label for=user-rg class=\"pl-3 upper\">RG</label></div><div class=\"row mb-2\"><input type=tel id=user-cpf class=\"form-control upper col-12 mx-0\" ng-model=vm.form.cpf mask=999.999.999-99 restrict=reject placeholder=999.999.999-99><label for=user-cpf class=\"pl-3 upper\">CPF</label></div><div class=\"form-group d-flex row mb-2\"><select id=select-ocupacao class=\"form-control col-3 mr-1 mx-0 ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vm.form.ec_id ng-options=\"f.id as f.nome for f in vm.statusCivil\" ng-init=\"vm.form.ec_id = vm.statusCivil[0].id\" required></select></div><div class=\"form-group d-flex row mb-2\"><span class=rowhead style=\"margin-top: 20px\">Data de nascimento</span><select id=select-ocupacao class=\"form-control col-3 mr-1 mx-0 ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vm.form.day ng-options=\"f for f in vm.dayNumbers\" ng-init=\"vm.form.day = vm.dayNumbers[0]\"></select><select id=select-ocupacao class=\"form-control col-3 mr-1 mx-0 ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vm.form.month ng-options=\"f.name for f in vm.mounthNumbers\" ng-change=vm.dayGenerate(vm.form.month.days) ng-init=\"vm.form.month =  vm.mounthNumbers[0]\"></select><select id=select-ocupacao class=\"form-control col-3 mr-1 mx-0 ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vm.form.year ng-options=\"f for f in vm.yearNumbers\" ng-init=\"vm.form.year = vm.yearNumbers[0]\"></select></div></div></div><div class=\"form-group d-flex flex-column flex-wrap\"><span class=rowhead>Endereço</span><div class=\"row mb-3\"><input type=text id=zipcode-address class=\"form-control upper col-12 col-md-6\" ui-br-cep-mask ng-model=vm.formAddress.address.cep ng-blur=vm.formAddress.viacepGet() required placeholder=\"Seu CEP\"><label for=zipcode-address class=\"pl-3 upper\">CEP</label></div><div class=\"row mb-3\"><div class=\"d-flex col-8 px-0\"><input type=text id=stre-address class=\"form-control upper\" ng-model=vm.formAddress.address.logradouro required placeholder=\"Sua Rua\"><label for=stre-address class=\"pl-3 upper\">Rua</label></div><div class=\"d-flex col-4 px-0\"><input type=text id=num-address class=\"form-control upper\" ng-model=vm.formAddress.address.numero ng-model-options=\"{ debounce: 700 }\" required placeholder=Número><label for=num-address class=\"pl-3 upper\">Núm.</label></div></div><div class=\"row mb-3\"><div class=\"d-flex col-7 col-sm-6 px-0\"><input type=text id=comp-address class=\"form-control upper\" ng-model=vm.formAddress.address.complemento placeholder=Complemento><label for=comp-address class=\"ml-1 pl-3 upper\">Complemento</label></div><div class=\"d-flex col-5 col-sm-6 px-0\"><input type=text id=neib-address class=\"form-control upper\" ng-model=vm.formAddress.address.bairro required placeholder=Bairro><label for=neib-address class=\"ml-1 pl-3 upper\">Bairro</label></div></div><div class=\"row mb-3\"><div class=\"d-flex col-7 col-sm-8 px-0\"><input type=text id=city-address class=\"form-control upper\" ng-model=vm.formAddress.address.cidade required placeholder=Cidade><label for=city-address class=\"ml-1 pl-3 upper\">Cidade</label></div><div class=\"d-flex col-5 col-sm-4 px-0\"><input type=text id=uf-address class=\"form-control upper\" ng-model=vm.formAddress.address.estado required placeholder=Estado><label for=uf-address class=\"ml-1 pl-3 upper\">Estado</label></div></div></div><div class=\"d-flex mr-2\"><button type=submit class=\"btn button btn-default col-6 col-sm-4 ml-auto\"><span ng-if=!vm.loader>Salvar</span><div ng-if=vm.loader class=loader__dots style=margin-left:auto><span class=\"ml-auto loader__dot pulse pulse__one\" style=\"margin-left: 42% !important\"></span><span class=\"loader__dot pulse pulse__two\"></span><span class=\"loader__dot pulse pulse__three\"></span></div></button></div></div></form></div><div class=\"col px-0\" ng-show=\"vm.dashPage == 1\"><div class=\"body-options d-flex\"><p class=\"title col-4 d-none d-lg-flex align-items-center ml-2 mb-0\">{{vm.selectedTab[0]}} > <strong class=pl-1>{{vm.selectedTab[1]}}</strong></p><div class=\"nav nav-tabs d-flex col-12 col-lg-8 justify-content-end mt-2 mb-2\" style=\"position: relative\"><p class=\"d-none d-lg-flex align-items-center justify-content-end mr-3 mb-0\">Status do imóvel</p><div id=select-status class=col-4 ng-click=\"vm.contentDropdown = !vm.contentDropdown\"><div class=\"row align-items-center\"><div class=\"p-0 m-0\"><div id=selected-status-dot></div></div><div id=status-name class=pl-2>{{vm.selectedImovel.statusProp.nome}}</div></div></div><span id=custom-arrow><i class=\"fal fa-solid fa-chevron-down d-flex justify-content-center pt-2\"></i></span><div id=dropdown-box class=row ng-if=vm.contentDropdown><div class=col-4></div><div class=col-4></div><ul id=dropdown-options class=col-4><li id=option ng-repeat=\"status in vm.imoveis\"><div class=\"row align-items-center\" ng-click=updateSelectedStatus(status)><div class=\"p-0 m-0\"><div id=status-dot ng-style=\"{\'background-color\': \'{{status.statusProp.hex_text_color}}\'}\"></div></div><div id=status-name class=\"col pl-2\">{{status.statusProp.nome}}</div><div id=status-qtd class=pr-2>{{status.imvs.length}}</div></div></li></ul></div></div></div><div class=tab-content id=myTabContent><div class=\"tab-pane fade show active\" id=publicados role=tabpanel aria-labelledby=publicados-tab><div class=\"imoveis d-flex flex-column my-1\"><div class=\"imovel d-flex p-4\" ng-repeat=\"imovel in vm.selectedImovel.imvs\"><div class=\"imovel-img col-4 col-lg-3\" ng-style=\"{\'background-image\': \'url({{imovel.fotos[0].imvft_url ? imovel.fotos[0].imvft_url : \'../../assets/images/novosite/fallback.png\'}})\'}\"><a href={{vm.makeUrl(imovel)}}><div class=\"tag-imgs px-2 px-lg-3 py-1\"><i class=\"fal fa-images\"></i> {{imovel.fotos.length}}</div></a></div><div class=\"col-8 col-lg-9 d-flex flex-column flex-lg-row px-0\"><a href={{vm.makeUrl(imovel)}}><div class=\"imovel-info w-100 col-lg-8\"><p class=date><i class=\"fal fa-calendar-alt mr-1\"></i>{{imovel.updatedAt | date:\'dd/MM/yyyy\'}}</p><p class=title>{{imovel.imv_titulo}}</p><p class=\"address d-none d-lg-block pt-2 pt-lg-0\">{{imovel.imv_endereco}}, {{imovel.imv_end_numero}} - {{imovel.imv_bairro}} - {{imovel.imv_cidade}} / {{imovel.imv_estado}}</p><p class=info>cód. {{imovel.imv_cod_gaia}} / {{imovel.imobiliaria.imb_nome}} - Creci {{imovel.imobiliaria.imb_creci}}</p></div><div class=\"imovel-edit d-flex justify-content-center align-items-center w-100 col-lg-4 px-0 mt-2 mt-lg-0\"><a class=\"px-5 py-2 py-lg-3 c-pointer\" ng-click=vm.editImovel(imovel)><i class=\"fal fa-edit mr-1\"></i> Editar</a></div></a></div></div><div class=\"nenhum_imovel d-flex p-4\" ng-if=\"vm.selectedImovel.imvs.length == 0 || !vm.selectedImovel.imvs\"><p>Poxa, ainda não tem nenhum imóvel por aqui :(</p></div></div></div></div></div><div class=\"body-options col-12 col-lg-9\" ng-show=\"vm.dashPage == 2\"><p>Propostas</p></div><div class=\"col px-0\" ng-show=\"vm.dashPage == 3\"><div class=\"body-options d-flex\"><p class=\"title col-4 d-none d-lg-flex align-items-center ml-2 mb-0\"><strong>{{vm.selectedTab[0]}}</strong></p><ul class=\"nav nav-tabs d-flex col-12 col-lg-8 justify-content-around\" id=myTab role=tablist><li id=todos-tab class=\"active col-6 d-flex justify-content-center align-items-center py-3 px-0\"><a class=\"active w-100 h-100 d-flex justify-content-center align-items-center text-center\" data-toggle=tab role=tab aria-controls=todos ui-sref=\"main.painel.dashboard({selected:\'todos\'})\" aria-selected=true>Todos</a></li></ul></div><div class=tab-content id=myTabContent><div class=\"tab-pane fade show active\" id=todos role=tabpanel aria-labelledby=todos-tab><div class=\"imoveis d-flex flex-column my-1\"><div class=\"imovel d-flex p-4\" ng-repeat=\"imovel in vm.favoritos\"><div class=\"imovel-img col-4 col-lg-3\" ng-style=\"{\'background-image\': \'url({{imovel.fotos[0].imvft_url ? imovel.fotos[0].imvft_url : \'../../assets/images/novosite/fallback.png\'}})\'}\"><a href={{vm.makeUrl(imovel)}}><div class=\"tag-imgs px-2 px-lg-3 py-1\"><i class=\"fal fa-images\"></i> {{imovel.fotos.length}}</div></a></div><div class=\"col-8 col-lg-9 d-flex flex-column flex-lg-row px-0\"><a href={{vm.makeUrl(imovel)}}><div class=\"imovel-info w-100 col-lg-8\"><p class=date><i class=\"fal fa-calendar-alt mr-1\"></i>{{imovel.updatedAt | date:\'dd/MM/yyyy\'}}</p><p class=title>{{imovel.imv_titulo}}</p><p class=\"address d-none d-lg-block pt-2 pt-lg-0\">{{imovel.imv_endereco}}, {{imovel.imv_end_numero}} - {{imovel.imv_bairro}} - {{imovel.imv_cidade}} / {{imovel.imv_estado}}</p><p class=info>cód. {{imovel.imv_cod_gaia}} / {{imovel.imobiliaria.imb_nome}} - Creci {{imovel.imobiliaria.imb_creci}}</p></div><div class=\"imovel-edit d-flex justify-content-center align-items-center w-100 col-lg-4 px-0 mt-2 mt-lg-0\"></div></a></div></div><div class=\"nenhum_imovel d-flex p-4\" ng-if=\"vm.favoritos.length == 0 || !vm.favoritos\"><p>Poxa, ainda não tem nenhum imóvel por aqui :(</p></div></div></div></div></div><div class=\"body-options col-12 col-lg-9\" ng-show=\"vm.dashPage == 4\"><p>Configurações</p></div><div class=\"col px-0\" ng-show=\"vm.dashPage == 5\"><div class=\"body-options d-flex\"><p class=\"title col-4 d-none d-lg-flex align-items-center ml-2 mb-0\"><strong>{{vm.selectedTab[0]}}</strong></p><ul class=\"nav nav-tabs d-flex col-12 col-lg-8 justify-content-around\" id=myTab role=tablist><li id=todos-renovacao-tab class=\"active col-6 d-flex justify-content-center align-items-center py-3 px-0\"><a class=\"active w-100 h-100 d-flex justify-content-center align-items-center text-center\" ui-sref=\"main.painel.dashboard({selected:\'todos\'})\" data-toggle=tab role=tab aria-controls=todos aria-selected=true>Todos</a></li></ul></div><div class=tab-content id=myTabContent><div class=\"tab-pane fade show active\" id=todos-renovacao role=tabpanel aria-labelledby=todos-renovacao-tab><div class=\"imoveis d-flex flex-column my-1\"><div class=\"imovel d-flex p-4\" ng-repeat=\"imovel in vm.renovacoes\"><div class=\"imovel-img col-4 col-lg-3\" href={{vm.makeUrl(imovel)}} ng-style=\"{\'background-image\': \'url({{imovel.fotos[0].imvft_url ? imovel.fotos[0].imvft_url : \'../../assets/images/novosite/fallback.png\'}})\'}\"><div class=\"tag-imgs px-2 px-lg-3 py-1\"><i class=\"fal fa-images\"></i> {{imovel.fotos.length}}</div></div><div class=\"col-8 col-lg-9 d-flex flex-column flex-lg-row px-0\"><a class=col-lg-8 href={{vm.makeUrl(imovel)}}><div class=\"imovel-info w-100\"><p class=date><i class=\"fal fa-calendar-alt mr-1\"></i>{{imovel.updatedAt | date:\'dd/MM/yyyy\'}}</p><p class=title>{{imovel.imv_titulo}}</p><p class=\"address d-none d-lg-block pt-2 pt-lg-0\">{{imovel.imv_endereco}}, {{imovel.imv_end_numero}} - {{imovel.imv_bairro}} - {{imovel.imv_cidade}} / {{imovel.imv_estado}}</p><p class=info>cód. {{imovel.imv_cod_gaia}} / {{imovel.imobiliaria.imb_nome}} - Creci {{imovel.imobiliaria.imb_creci}}</p></div></a><div class=\"imovel-edit d-flex justify-content-center align-items-center w-100 col-lg-4 px-0 mt-2 mt-lg-0\"><a class=\"px-5 py-2 py-lg-3 c-pointer\" ng-click=vm.renewTerms(imovel)><i class=\"fal fa-edit mr-1\"></i> Aceitar Termos</a></div></div></div><div class=\"nenhum_imovel d-flex p-4\" ng-if=\"vm.renovacoes == 0 || !vm.renovacoes\"><p>Nenhum Aceite/Renovação necessaria no momento.</p></div></div></div></div></div></div></div><div id=botao_campanha_video ng-if=botao_ctr><style scoped>#lp-pom-box-666 {\n			width: 0px;\n			height: 0px;\n			right: 633px;\n			bottom: 174px;\n			position: fixed;\n			z-index: 999;\n			left: unset;\n			top: unset;\n		}\n\n		#lp-pom-image-665 {\n			display: block;\n			background: rgba(255, 255, 255, 0);\n			left: 48px;\n			top: 46px;\n			z-index: 995;\n			position: absolute;\n		}\n\n		#lp-pom-image-667 {\n			display: block;\n			background: rgba(255, 255, 255, 0);\n			left: 61px;\n			top: 60px;\n			z-index: 999;\n			position: absolute;\n		}\n\n		#lp-pom-text-670 {\n			display: block;\n			background: rgba(255, 255, 255, 0);\n			border-style: none;\n			border-radius: 0px;\n			left: 123px;\n			top: 62px;\n			z-index: 999;\n			width: 431px;\n			height: 26px;\n			position: absolute;\n		}\n\n		#lp-pom-text-671 {\n			display: block;\n			background: rgba(255, 255, 255, 0);\n			border-style: none;\n			border-radius: 0px;\n			left: 125px;\n			top: 86px;\n			z-index: 999;\n			width: 442px;\n			height: 26px;\n			position: absolute;\n		}\n\n		#lp-pom-button-676 {\n			display: block;\n			border-style: none;\n			border-radius: 16px;\n			left: 55px;\n			top: 52px;\n			z-index: 998;\n			width: 531px;\n			height: 69px;\n			position: absolute;\n			background: rgba(134, 0, 255, 0);\n			box-shadow: none;\n			text-shadow: none;\n			color: #ffffff;\n			border-width: undefinedpx;\n			border-color: transparent;\n			font-size: 16px;\n			line-height: 19px;\n			font-weight: 300;\n			/* font-family: Krub; */\n			font-style: normal;\n			text-align: center;\n			background-repeat: no-repeat;\n		}\n\n		#lp-pom-image-667 .lp-pom-image-container img {\n			width: 60px;\n			height: 52px;\n		}\n\n		.lp-pom-root .lp-pom-image img {\n			vertical-align: top;\n		}\n\n		#lp-pom-box-677 {\n			display: none;\n		}\n\n		@media only screen and (max-width: 600px) {\n			#lp-pom-box-666 {\n				display: none;\n			}\n\n			#lp-pom-image-667 .lp-pom-image-container {\n				border-style: none;\n				border-radius: 160px;\n				width: 60px;\n				height: 52px;\n			}\n\n			#lp-pom-image-667 .lp-pom-image-container a img {\n				width: 60px;\n				height: 52px;\n			}\n\n			#lp-pom-box-677 {\n				display: block;\n				background: rgba(255, 255, 255, 0);\n				border-style: none;\n				border-radius: 0px;\n				left: 0px;\n				bottom: 13px;\n				z-index: 989;\n				width: 320px;\n				height: 219px;\n				position: absolute;\n			}\n\n			#lp-pom-image-678 {\n				display: block;\n				background: rgba(255, 255, 255, 0);\n\n				bottom: 69px;\n				right: 196px;\n				z-index: 1000;\n				position: absolute;\n			}\n\n			#lp-pom-box-677 {\n				height: 0;\n\n			}\n\n			#lp-pom-text-679 {\n				display: block;\n				background: rgba(255, 255, 255, 0);\n				border-style: none;\n				border-radius: 0px;\n				/* left: 100px; */\n				bottom: 44px;\n				z-index: 1000;\n				width: 178px;\n				height: 31px;\n				position: absolute;\n\n				right: 10px;\n			}\n\n			#lp-pom-button-680 {\n				display: block;\n				border-style: none;\n				border-radius: 16px;\n\n				bottom: 50px;\n				z-index: 998;\n				width: 228px;\n				height: 69px;\n				position: absolute;\n				background: rgba(134, 0, 255, 0);\n				box-shadow: none;\n				text-shadow: none;\n				color: #ffffff;\n\n				border-color: transparent;\n				font-size: 16px;\n				line-height: 19px;\n				font-weight: 300;\n				right: 15px;\n				font-style: normal;\n				text-align: center;\n				background-repeat: no-repeat;\n			}\n\n			#lp-pom-image-681 {\n				display: block;\n				background: rgba(255, 255, 255, 0);\n				right: 7px;\n				bottom: 40px;\n				z-index: 990;\n				position: absolute;\n			}\n\n			#lp-pom-text-682 {\n				display: block;\n				background: rgba(255, 255, 255, 0);\n				border-style: none;\n				border-radius: 0px;\n				right: 34px;\n				bottom: 79px;\n				z-index: 999;\n				width: 166px;\n				height: 18px;\n				position: absolute;\n			}\n\n			#lp-pom-image-678 .lp-pom-image-container {\n				border-style: none;\n				border-radius: 160px;\n				width: 37px;\n				height: 32px;\n			}\n\n			#lp-pom-image-678 .lp-pom-image-container a img {\n				width: 37px;\n				height: 32px;\n			}\n		}</style></div>");
$templateCache.put("app/account/formulario/form.html","<div class=embedded-container><title>Cadastre seu Imóvel na Arbo</title><iframe class=embedded-form id=“typeform-full” width=“100%” height=“100%” frameborder=“0” src=https://arboimoveis.typeform.com/to/cYHPEY></iframe><script type=“text/javascript” src=“https://embed.typeform.com/embed.js”></script></div>");
$templateCache.put("app/account/formulario/proposta-compra.html","<div class=embedded-container><title>Proposta de compra</title><iframe class=embedded-form id=“typeform-full” width=“100%” height=“100%” frameborder=“0” src=https://arboimoveis.typeform.com/to/UdI6Im></iframe><script type=“text/javascript” src=“https://embed.typeform.com/embed.js”></script></div>");
$templateCache.put("app/account/formulario/proposta-locacao.html","<div class=embedded-container><title>Proposta de locação</title><iframe class=embedded-form id=“typeform-full” width=“100%” height=“100%” frameborder=“0” src=https://arboimoveis.typeform.com/to/PTWF4F></iframe><script type=“text/javascript” src=“https://embed.typeform.com/embed.js”></script></div>");
$templateCache.put("app/account/formulario/typeform.html","<section id=typeform class=\"typeform container-fluid pt-5\"><div class=\"d-flex flex-column pt-4\"><div class=\"col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2\"><ul class=\"list-circle row flex-column flex-sm-row justify-content-between\" ng-if=\"!(\'main.painel.typeform-termos\'| includedByState)\"><li class=\"d-flex flex-row flex-sm-column align-items-center\" ng-class=\"{active: (\'main.painel.typeform-1\' | includedByState)}\"><span ng-class=\"{active: (\'main.painel.typeform-1\' | includedByState) || (\'main.painel.typeform-2\' | includedByState) || (\'main.painel.typeform-upload\' | includedByState) || (\'main.painel.typeform-3\' | includedByState) || (\'main.painel.typeform-obrigado\'| includedByState)}\">1</span><em>Tipo do imóvel</em></li><li class=\"d-flex flex-row flex-sm-column align-items-center\" ng-class=\"{active: (\'main.painel.typeform-2\' | includedByState)}\"><span ng-class=\"{active: (\'main.painel.typeform-2\' | includedByState) || (\'main.painel.typeform-3\' | includedByState) || (\'main.painel.typeform-upload\' | includedByState) || (\'main.painel.typeform-obrigado\'| includedByState)}\">2</span><em>Detalhes da transação</em></li><li class=\"d-flex flex-row flex-sm-column align-items-center\" ng-class=\"{active: (\'main.painel.typeform-3\' | includedByState)}\"><span ng-class=\"{active: (\'main.painel.typeform-3\' | includedByState) || (\'main.painel.typeform-upload\' | includedByState) || (\'main.painel.typeform-obrigado\'| includedByState)}\">3</span><em>Detalhes do imóvel</em></li><li class=\"d-flex flex-row flex-sm-column align-items-center\" ng-class=\"{active: (\'main.painel.typeform-upload\' | includedByState)}\"><span ng-class=\"{active: (\'main.painel.typeform-upload\' | includedByState) || (\'main.painel.typeform-obrigado\'| includedByState)}\">4</span><em>Fotos do imóvel</em></li></ul><div class=term-ad ng-if=\"(\'main.painel.typeform-termos\'| includedByState)\"><h4 class=title-term>Termos de anúncio</h4><p class=\"descript-term px-0\">Aqui estão informações que você precisa saber e estar de acordo para publicar seu imóvel</p></div></div><div class=\"col-12 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2\"><div class=\"steps-form col-12 col-sm-12 px-0\" ng-if=\"(\'main.painel.typeform-1\'| includedByState)\" ng-init=vm.form_tipo.init()><form action=\"\" name=etapatipo ng-submit=\"vm.form_tipo.validacao($event, etapatipo)\"><div class=form-default><div class=\"form-group d-flex flex-column\"><label for=\"select-tipo-imv col-12\">Qual seu imóvel?</label><select id=select-tipo-imv name=select-finalidade-imv class=\"col-12 col-sm-8 custom-select\" ng-model=vm.form_tipo.imv.imv_finalidade ng-options=\"f.id as f.fnl_nome for f in vm.form_tipo.imv_finalidade\" ng-change=vm.form_tipo.changeFinalidade(vm.form_tipo.imv.imv_finalidade) ng-required=vm.form_tipo.requiredForm() ng-class=\"{\'selecterr\': novalid}\"></select><div ng-messages=\"etapatipo[\'select-finalidade-imv\'].$error\" ng-if=\"etapatipo[\'select-finalidade-imv\'].$dirty\" role=alert class=ng-message><div ng-message=required>Selecione ao menos um tipo.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=\"select-subtipo-imv col-12\">Qual o tipo do seu imóvel?</label><select id=select-subtipo-imv name=select-tipo-imv class=\"col-12 col-sm-8 custom-select\" ng-model=vm.form_tipo.imv.imv_tipo ng-options=\"f.id as f.timv_nome for f in vm.form_tipo.imv_tipo\" ng-change=vm.form_tipo.changeTipo(vm.form_tipo.imv.imv_tipo) ng-required=vm.form_tipo.requiredForm() ng-class=\"{\'selecterr\': novalid}\"></select><div ng-messages=\"etapatipo[\'select-tipo-imv\'].$error\" ng-if=\"etapatipo[\'select-tipo-imv\'].$dirty\" role=alert class=ng-message><div ng-message=required>Selecione o tipo do seu imóvel.</div></div></div><div class=\"form-group d-flex flex-column\" ng-if=\"vm.form_tipo.imv.imv_finalidade == 1\"><label for=\"select-subtipo-imv col-12\">Qual o subtipo do seu imóvel?</label><select id=select-subtipo-imv name=select-subtipo-imv class=\"col-12 col-sm-8 custom-select\" ng-model=vm.form_tipo.imv.imv_subtipo ng-options=\"f.id as f.timv_nome for f in vm.form_tipo.imv_subtipo\" ng-required=vm.form_tipo.requiredFormSub() ng-class=\"{\'selecterr\': novalid}\"></select><div ng-messages=\"etapatipo[\'select-subtipo-imv\'].$error\" ng-if=\"etapatipo[\'select-subtipo-imv\'].$dirty\" role=alert class=ng-message><div ng-message=required>Selecione o subtipo do imóvel.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=\"select-transacao-imv col-12\">Qual o tipo de transação?</label><select id=select-transacao-imv name=select-transacao-imv class=\"col-12 col-sm-8 custom-select\" ng-model=vm.form_tipo.imv.imv_tiponegocio ng-options=\"f.id as f.tpng_nome for f in vm.form_tipo.imv_tiponegocio\" ng-required=vm.form_tipo.requiredForm() ng-class=\"{\'selecterr\': novalid}\"></select><div ng-messages=\"etapatipo[\'select-transacao-imv\'].$error\" ng-if=\"etapatipo[\'select-transacao-imv\'].$dirty\" role=alert class=ng-message><div ng-message=required>Selecione o tipo de transação.</div></div></div></div><button type=submit ng-click=vm.form_tipo.dirtyForm(etapatipo) class=\"btn button btn-default col-5 col-sm-4 float-right\">Próximo <i class=\"fal fa-arrow-right\"></i></button></form></div><div class=\"steps-form col-12 col-sm-12 px-0\" ng-if=\"(\'main.painel.typeform-2\'| includedByState)\" ng-init=vm.form_tran.init()><form action=\"\" name=etapatransacao ng-submit=\"vm.form_tran.validacao($event, etapatransacao)\"><div class=form-default><div class=\"form-group d-flex flex-column\"><label for=\"\">Cadastro do Imóvel:</label><div class=\"form-group d-flex flex-column\" ng-if=\"vm.form_tran.params.condominio == 1\"><div class=\"d-flex ml-1\"><input type=text id=nome_cond class=\"form-control upper col-8 col-md-6\" ng-model=vm.form_tran.imv.imv_nome_cond required placeholder=\"Nome do condomínio ?\" maxlength=120><label for=nome_cond class=\"ml-1 pl-3 upper\">Nome do condomínio ?</label></div></div><div class=\"form-group d-flex flex-column\" ng-if=\"(vm.form_tran.params.condominio == 1) && (vm.form_tran.params.imv_tipo != 2) && (vm.form_tran.params.imv_tipo != 3) && (vm.form_tran.params.imv_tipo != 4)\"><div class=\"d-flex ml-1\"><input type=text id=andar_cond class=\"form-control upper col-8 col-md-6\" ng-model=vm.form_tran.imv.imv_andar_cond ui-number-mask=0 required placeholder=\"Qual o andar ?\"><label for=andar_cond class=\"ml-1 pl-3 upper\">Qual o andar ?</label></div></div><div><div class=\"row mb-2 ml-1\" ng-if=\"(vm.form_tran.params.imv_tiponegocio == 1) || (vm.form_tran.params.imv_tiponegocio == 3)\"><label for=venda-detalhe class=\"mr-1 pt-3\">R$</label><input type=text id=venda-detalhe class=\"form-control upper col-8 col-md-4\" ng-model=vm.form_tran.imv.imv_preco_venda ui-number-mask=0 required placeholder=\"Valor Venda\"><label for=venda-detalhe class=\"ml-4 pl-3 upper\">Valor Venda</label><label for=venda-detalhe class=\"mr-1 pt-3\">,00</label></div><div class=\"row mb-2 ml-1\" ng-if=\"(vm.form_tran.params.imv_tiponegocio == 2) || (vm.form_tran.params.imv_tiponegocio == 3)\"><label for=locacao-detalhe class=\"mr-1 pt-3\">R$</label><input type=text id=locacao-detalhe class=\"form-control upper col-8 col-md-4\" ng-model=vm.form_tran.imv.imv_preco_locacao ui-number-mask=0 required placeholder=\"Valor Locação mensal\"><label for=locacao-detalhe class=\"ml-4 pl-3 upper\">Valor Locação mensal</label><label for=locacao-detalhe class=\"mr-1 pt-3\">,00</label></div><div class=\"row mb-2 ml-1\" ng-if=\"(vm.form_tran.params.condominio == 1)\"><label for=cond-detalhe class=\"mr-1 pt-3\">R$</label><input type=text id=cond-detalhe class=\"form-control upper col-8 col-md-4\" ng-model=vm.form_tran.imv.imv_preco_cond ui-number-mask=0 required placeholder=\"Condomínio mensal\"><label for=cond-detalhe class=\"ml-4 pl-3 upper\">Condomínio mensal</label><label for=cond-detalhe class=\"mr-1 pt-3\">,00</label></div><div class=\"row mb-2 ml-1\" ng-if=\"(vm.form_tran.params.imv_tipo != 4) && ((vm.form_tran.params.imv_tiponegocio == 2) || (vm.form_tran.params.imv_tiponegocio == 3) || (vm.form_tran.params.imv_tiponegocio == 1))\"><label for=iptu-detalhe class=\"mr-1 pt-3\">R$</label><input type=text id=iptu-detalhe class=\"form-control upper col-8 col-md-4\" ng-model=vm.form_tran.imv.imv_preco_iptu ui-number-mask=0 placeholder=\"IPTU mensal\"><label for=iptu-detalhe class=\"ml-4 pl-3 upper\">IPTU mensal</label><label for=iptu-detalhe class=\"mr-1 pt-3\">,00</label><label for=iptu-detalhe class=\"mr-1 pt-3\">(valor anual dividido por 10)</label></div><div class=\"row mt-4 mb-4 ml-1\" ng-if=\"(vm.form_tran.params.imv_tiponegocio == 1) || (vm.form_tran.params.imv_tiponegocio == 3)\"><input type=checkbox name=detail-ap class=\"input-control square\" id=permuta ng-model=vm.form_tran.imv.imv_aceita_negoc ng-true-value=true ng-false-value=false><label for=permuta class=\"d-block mr-2\">Aceita permuta</label></div><div class=\"row mb-4 ml-1\" ng-if=\"(vm.form_tran.params.imv_tiponegocio == 1) || (vm.form_tran.params.imv_tiponegocio == 3)\"><input type=checkbox name=detail-ap class=\"input-control square\" id=finalidade ng-model=vm.form_tran.imv.imv_aceita_financ ng-true-value=true ng-false-value=false><label for=finalidade class=\"d-block mr-2\">Financiamento bancário</label></div></div></div><div class=\"form-group d-flex flex-column\" ng-if=\"vm.form_tran.imv.imv_tipo != 4\"><select id=select-ocupacao name=select-ocupacao class=\"col-sm-8 col-md-6 custom-select\" ng-model=vm.form_tran.imv.ocp_id ng-options=\"f.id as f.ocp_nome for f in vm.form_tran.ocupacao\" required ng-class=\"{\'selecterr\': novalid}\"></select><div ng-messages=\"etapatransacao[\'select-ocupacao\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Selecione o tipo do seu imóvel.</div></div></div><div class=row ng-if=\"vm.form_tran.imv.imv_tipo != 4\"><div class=\"form-group d-flex flex-column col-md-6\"><select id=select-tipo-detalhe name=select-tipo-detalhe class=\"col-12 custom-select\" ng-model=vm.form_tran.imv.chvest_id ng-options=\"f.id as f.local_chave for f in vm.form_tran.localchave\" required ng-class=\"{\'selecterr\': novalid}\"></select></div></div><div class=\"form-group d-flex flex-column mt-3\" ng-if=\"(vm.form_tran.params.imv_tiponegocio == 2) || (vm.form_tran.params.imv_tiponegocio == 3)\"><label>Quais as garantias locatícias você aceita ?</label><div class=\"row mb-4 ml-1\"><input type=checkbox name=detail-ap class=\"input-control square\" id=gar_sem_garantia ng-model=vm.form_tran.imv.garantias.gar_sem_garantia ng-true-value=true ng-false-value=false><label for=gar_sem_garantia class=\"d-block mr-2\">Garantia total</label><div class=\"px-0 info-cadastro c-pointer\"><div class=px-2 ng-click=vm.form_tran.openModal(5)><div class=\"d-none d-sm-inline-block\">Nova modalidade</div><div class=\"d-inline-block d-sm-none\">Conheça</div><i class=\"fal fa-info-circle\"></i></div></div></div><div class=\"row mb-4 ml-1\"><input type=checkbox name=detail-ap class=\"input-control square\" id=gar_fiador ng-model=vm.form_tran.imv.garantias.gar_fiador ng-true-value=true ng-false-value=false><label for=gar_fiador class=\"d-block mr-2\">Fiador</label><div class=\"px-0 info-cadastro c-pointer\"><i class=\"fal fa-info-circle\" ng-click=vm.form_tran.openModal(1)></i></div></div><div class=\"row mb-4 ml-1\"><input type=checkbox name=detail-ap class=\"input-control square\" id=gar_seguro_fianca ng-model=vm.form_tran.imv.garantias.gar_seguro_fianca ng-true-value=true ng-false-value=false><label for=gar_seguro_fianca class=\"d-block mr-2\">Seguro fiança</label><div class=\"px-0 info-cadastro c-pointer\"><i class=\"fal fa-info-circle\" ng-click=vm.form_tran.openModal(2)></i></div></div><div class=\"row mb-4 ml-1\"><input type=checkbox name=detail-ap class=\"input-control square\" id=gar_titulo_capitalizacao ng-model=vm.form_tran.imv.garantias.gar_titulo_capitalizacao ng-true-value=true ng-false-value=false><label for=gar_titulo_capitalizacao class=\"d-block mr-2\">Titulo de capitalização</label><div class=\"px-0 info-cadastro c-pointer\"><i class=\"fal fa-info-circle\" ng-click=vm.form_tran.openModal(3)></i></div></div><div class=\"row mb-4 ml-1\"><input type=checkbox name=detail-ap class=\"input-control square\" id=gar_caucao ng-model=vm.form_tran.imv.garantias.gar_caucao ng-true-value=true ng-false-value=false><label for=gar_caucao class=\"d-block mr-2\">Caução</label><div class=\"px-0 info-cadastro c-pointer\"><i class=\"fal fa-info-circle\" ng-click=vm.form_tran.openModal(4)></i></div></div></div><div class=\"form-group d-flex flex-column\"><label for=\"\">Endereço</label><div class=\"d-flex ml-1\"><input type=text id=zipcode-address class=\"form-control upper col-8 col-md-6\" ui-br-cep-mask ng-model=vm.form_tran.address.imv_cep ng-blur=vm.form_tran.viacepGet() required><label for=zipcode-address class=\"ml-1 pl-3 upper\">CEP</label></div><div id=label-cep class=\"tooltip tooltip-top-left col-12 col-sm-9\"><i class=\"fal fa-map-marker-check\"></i> {{vm.form_tran.address_viacep.bairro ? vm.form_tran.address_viacep.bairro + \', \':\'\'}} {{ vm.form_tran.address_viacep.localidade + \' - \' + vm.form_tran.address_viacep.uf}}</div></div><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-8 col-sm-7 px-0\"><input type=text id=stre-address class=\"form-control upper\" ng-model=vm.form_tran.address.imv_endereco required><label for=stre-address class=\"ml-1 pl-3 upper\">Rua</label></div><div class=\"d-flex col-4 col-sm-3 px-0\"><input type=text id=num-address class=\"form-control upper mr-0\" ng-model=vm.form_tran.address.imv_end_numero ng-model-options=\"{ debounce: 700 }\" required oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\'); this.value = this.value.replace(/(\\..*)\\./g, \'$1\')\" maxlength=6><label for=num-address class=\"ml-1 pl-3 upper\">Numero</label></div></div><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-12 mb-3 mb-sm-0 col-sm-5 px-0\"><input type=text id=comp-address class=\"form-control upper mr-0 mr-sm-1\" ng-model=vm.form_tran.address.imv_end_complemento><label for=comp-address class=\"ml-1 pl-3 upper\">Complemento</label></div><div class=\"d-flex col-12 col-sm-5 px-0\"><input type=text id=neib-address class=\"form-control upper mr-0\" ng-model=vm.form_tran.address.imv_bairro required><label for=neib-address class=\"ml-1 pl-3 upper\">Bairro</label></div></div><div class=\"row mb-3 ml-1\"><div class=\"d-flex col-6 col-sm-5 px-0\"><input type=text id=city-address class=\"form-control upper\" ng-model=vm.form_tran.address.imv_cidade required><label for=city-address class=\"ml-1 pl-3 upper\">Cidade</label></div><div class=\"d-flex col-6 col-sm-3 px-0\"><input type=text id=uf-address class=\"form-control upper\" ng-model=vm.form_tran.address.imv_estado required><label for=uf-address class=\"ml-1 pl-3 upper\">Estado</label></div><button type=button class=\"btn button btn-default col-12 col-sm-2 mb-O px-0\" ng-class=\"{active: vm.form_tran.movermap}\" ng-click=vm.form_tran.movePin()>{{vm.form_tran.movermap ? \'Travar PIN\' : \'Mover PIN\'}}</button><div class=\"tooltip tooltip-top-right col-12 col-sm-10 text-center\" ng-class=\"{active: !vm.form_tran.movermap}\"><i class=\"fal fa-exclamation-circle\"></i> Se a localização do imóvel estiver errada, por favor mover o PIN do mapa.</div></div></div><div class=\"form-group d-block maps col-12\"><div id=googlemaps class=\"col-12 col-md-10\"></div></div><div class=\"d-flex col-12 px-0\"><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form_tran.imv_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Seus dados estão seguros. Para prosseguir, precisamos que esteja ciente e concorde com os nossos <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div></div><div class=\"d-flex justify-content-between\"><button type=button class=\"btn button button-white col-5 col-sm-4\" ng-if=!(vm.form_tran.imv_id) ui-sref=main.painel.typeform-1(vm.form_tran.params)>Anterior</button> <button type=submit class=\"btn button btn-default col-5 col-sm-4 ml-auto\" ng-disabled=!vm.form_tran.imv_accept_terms>Próximo <i class=\"fal fa-arrow-right\"></i></button></div></form></div><div class=\"steps-form col-12 col-sm-12 px-0\" ng-if=\"(\'main.painel.typeform-upload\'| includedByState)\" ng-init=vm.form_img.init()><form name=form-upload action=\"\" ng-submit=vm.form_img.uploadAll($event)><div class=\"col-12 form-default\" id=img-container><div class=\"form-group d-flex flex-column\"><div uib-alert ng-repeat=\"alert in alerts\" ng-class=\"\'alert-\' + (alert.type || \'warning\')\" close=closeAlert($index) ng-if=new>{{alert.msg}}</div><div uib-alert close=closeAlert($index) ng-if=overImgs.isError class=alert-danger><div>Arquivos com erro:</div><div ng-repeat=\"overImg in overImgs\">{{overImg}}</div><br><div>Lembre-se sempre de verificar se suas fotos são menores que 5MB e dentro do limite de 25 imagens.</div></div><div ng-init=\"accordion=false\"><div class=accordion ng-class=\"{active:accordion==true}\" class=descricao-title><div href ng-click=\"accordion=!accordion\" class=descricao-title style=\"border-radius: 2px\"><span style=\"margin-right: auto\">Dicas de fotografia. Como vender seu imóvel mais rápido:</span><div><i class=\"fas fa-chevron-down\" ng-class=\"{\'fas fa-chevron-up\': accordion, \'fas fa-chevron-down\': !accordion}\"></i></div></div></div><div class=\"accordion-content descricao-text\" ng-show=\"accordion==true\" style=\"border-radius: 2px\"><p>Prepare sua melhor câmera, guarde a bagunça, acenda as luzes do imóvel e siga nossas dicas para valorizar seu imóvel com as melhores fotos!<br><br><b>1. Itens pessoais:</b> Elimine da cena itens pessoais como fotografias, itens religiosos ou de time de futebol.<br><b>2. Enquadramento:</b> Determine o que você quer mostrar. Escolha um enquadramento que mostre todo o cômodo. Tire a foto de 2 a 3 ângulos diferentes por cômodo.<br><b>3. Foco:</b> Não se esqueça de cuidar com o foco. Fotos fora de foco não valorizam o imóvel.<br><b>4. Detalhes:</b> Ao invés de usar o zoom, se aproxime do objeto para fotografar detalhes. Evite se aproximar demais a ponto de não saber em qual lugar do cômodo fica o objeto.<br><b>5. Segure corretamente a câmera:</b> Use as duas mãos e separe os pés para garantir estabilidade no enquadramento.<br><b>6. Cuidado:</b> Verifique se a lente da câmera está limpa e o foco funcionando.</p><p><b>Ainda não tenho as fotos, o que fazer?</b><br>Não se preocupe! Você sempre poderá encontrar o cadastro deste imóvel no seu perfil e editar as informações assim que tiver as fotos. Mas não se esqueça, a fotografia é essencial para um bom anúncio.</p></div></div></div><h3 class=title>Faça upload das imagens do seu imóvel</h3><div class=\"well my-drop-zone\" nv-file-drop nv-file-over=\"\" uploader=uploaderImgImovel><label><div class=\"image-preview d-flex flex-wrap\"><div class=\"d-flex rectangle-label\" ng-repeat=\"item in uploaderImgImovel.queue\"><a class=float-left href=# ng-click=item.remove()><i class=\"fa fal fa-times\" aria-hidden=true></i></a><div ng-thumb=\"{ file: item._file, width: 100 }\" id=canvas_img{{$index}}></div></div></div><input type=file ngf-fix-orientation=true nv-file-select=\"\" uploader=uploaderImgImovel name=uploaderMessage multiple class=d-none> <span ng-show=!uploaderImgImovel.queue.length class=m-auto><span>Clique</span> ou <span>arraste</span> uma ou mais fotos (máximo de 25 fotos por upload)</span></label></div><div class=\"errMsg bold\"><p class=redLabel ng-show=!uploaderImgImovel.queue.length></p></div></div><div class=\"image-preview mb-5 d-flex flex-wrap\" ng-if=vm.form_img.allFotos.length><h4 class=col-12>Fotos do imóvel</h4><div class=\"d-flex rectangle-label\" ng-repeat=\"item in vm.form_img.allFotos | filter:{imvft_ativo: true}\"><a class=\"float-left idle\" href=# ng-click=vm.form_img.idle(item)><i class=\"fa fal fa-times\" aria-hidden=true></i></a> <img src={{item.imvft_url}}></div></div><div class=\"col-12 px-0\"><button type=button class=\"btn button button-white col-5 col-sm-4\" ng-click=vm.form_img.prevStep()>Anterior</button> <button type=submit class=\"btn button btn-default col-7 col-sm-4 float-right\">Upload imagens <i class=\"fal fa-arrow-right\"></i></button></div></form></div><div class=\"steps-form col-12 col-sm-12 px-0\" ng-if=\"(\'main.painel.typeform-3\'| includedByState)\" ng-init=vm.form_imov.init()><form name=etapa-imovel ng-submit=\"vm.form_imov.nextStep($event, etapa-imovel)\"><div class=form-default><div class=row><p>{{vm.form_imov.idArray + 1}} de {{vm.form_imov.form.length}}</p></div><div class=mt-3 ng-if=\"(vm.form_imov.form[vm.form_imov.idArray].gcmd_id == 1)\"><div class=\"form-group d-flex\"><input step=0.5 lang=pt-BR type=text id=mat-imv string-to-number=\"\" fw-dynamic=\"\" ng-model=vm.form_imov.imv.imv_matriculaimv size=\"\" class=\"main-input form-control upper col-10 col-sm-3\" autocomplete=off><label for=mat-imv class=\"ml-1 pl-3 upper\">Matrícula do imóvel</label></div><div ng-if=\"vm.form_tran.imv.imv_tipo == 4\"><div class=\"form-group d-flex\"><input type=tel id=detalhe-06 class=\"form-control upper col-10 col-sm-2\" ng-model=vm.form_imov.imv.imv_area_total ui-number-mask=0 required><label for=detalhe-06 class=\"pl-3 upper\">Área total do terreno</label><label for=detalhe-06 class=\"mr-1 pt-3\">m<sup>2</sup></label></div><div class=\"form-group d-flex\"><input type=tel id=detalhe-05 class=\"form-control upper col-10 col-sm-3\" ng-model=vm.form_imov.imv.imv_area_util ui-number-mask=0><label for=detalhe-05 class=\"pl-3 upper\">A medida da área util do seu terreno ?</label><label for=detalhe-05 class=\"mr-1 pt-3\">m<sup>2</sup></label></div><div class=radio-group><input type=radio name=position class=\"input-control radio-circle\" id=posicao-aclive ng-model=vm.form_imov.imv.imv_topografia ng-value=aclive><label for=posicao-aclive>Aclive</label></div><div class=radio-group><input type=radio name=position class=\"input-control radio-circle\" id=posicao-declive ng-model=vm.form_imov.imv.imv_topografia ng-value=declive><label for=posicao-declive>Declive</label></div></div><div ng-if=\"vm.form_tran.imv.imv_tipo != 4\"><div class=\"form-group d-flex\"><input type=tel id=detalhe-05 class=\"form-control upper col-10 col-sm-3\" ng-model=vm.form_imov.imv.imv_area_util ui-number-mask=0 required><label for=detalhe-05 class=\"mr-1 pl-3 upper\">Área útil</label><label for=detalhe-05 class=\"mr-1 pt-3\">m<sup>2</sup></label></div><div class=\"form-group d-flex\"><input type=tel id=detalhe-06 class=\"form-control upper col-10 col-sm-3\" ng-model=vm.form_imov.imv.imv_area_total ui-number-mask=0 required><label for=detalhe-06 class=\"ml-1 pl-3 upper\">Área total</label><label for=detalhe-06 class=\"mr-1 pt-3\">m<sup>2</sup></label></div><div class=\"form-group d-flex flex-column col-12 col-sm-7\"><div ng-init=\"accordion=false\"><div class=accordion ng-class=\"{active:accordion==true}\" class=descricao-title><div href ng-click=\"accordion=!accordion\" class=descricao-title style=\"border-radius: 2px\"><span style=\"margin-right: auto\">Como descrever meu imóvel ?</span><div><i class=\"fas fa-chevron-down\" ng-class=\"{\'fas fa-chevron-up\': accordion, \'fas fa-chevron-down\': !accordion}\"></i></div></div></div><div class=\"accordion-content descricao-text\" style=\"border-radius: 2px\" ng-show=\"accordion==true\"><p>Quanto mais detalhada a sua descrição, mais atrativo será o seu imóvel.<b> Confira os itens abaixo para entender o que não pode faltar em uma boa descrição:</b><br><br>- Ponto de referência<br>- Características e atrativos do bairro<br>- Área comum do condomínio<br>- Cômodos<br>- Acabamentos<br>- Metragem total<br>- Condições do imóvel</p><p><b>Veja o exemplo:</b><br>Apartamento em ótima localização, próximo ao Aeroporto e a 5 minutos à pé do Supermercado. Região tranquila, com bancos e padaria a 2 quadras de distância do edifício. Imóvel novo, claro e arejado, voltado para a face sul, com armários embutidos nos quartos e na cozinha. O apartamento com 96m², 2 quartos e 1 banheiro. Lazer completo e segurança 24h.</p></div></div></div><div class=\"form-group d-flex flex-column\"><textarea type=tel id=detalhe-09 class=\"form-control upper col-12 col-sm-7\" ng-model=vm.form_imov.imv.imv_obs rows=5>\n                  </textarea><label for=detalhe-09 class=\"ml-1 pl-3 upper\">Descreva seu imóvel</label></div><div class=\"form-group d-flex flex-column\"><label for=\"\" class=\"ml-1 pl-3\">Quantos banheiros possui?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=banheiro class=\"input-control circle\" id=banheiro-{{f}} ng-model=vm.form_imov.imv.imv_qtd_banheiros ng-true-value={{f}} ng-false-value=0><label for=banheiro-{{f}}>{{f}}</label></div></div></div><div class=\"form-group d-flex flex-column\"><label for=\"\" class=\"ml-1 pl-3 upper\">Quantos lavabos possui?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=lavabo class=\"input-control circle\" id=lavabo-{{f}} ng-model=vm.form_imov.imv.imv_qtd_lavabo ng-true-value={{f}} ng-false-value=0 ng-disabled=\"(vm.form_imov.imv.imv_qtd_banheiros < {{f}})\"><label for=lavabo-{{f}}>{{f}}</label></div></div></div><div class=\"form-group d-flex flex-column\"><label for=\"\" class=\"ml-1 pl-3 upper\">Quantos quartos?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=quarto class=\"input-control circle\" id=quarto-{{f}} ng-model=vm.form_imov.imv.imv_qtd_dorm ng-true-value={{f}} ng-false-value=0><label for=quarto-{{f}}>{{f}}</label></div></div></div><div class=\"form-group d-flex flex-column\"><label for=detalhe-10 class=\"ml-1 pl-3 upper\">Sendo quantas suites?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=suite class=\"input-control circle\" id=suite-{{f}} ng-model=vm.form_imov.imv.imv_qtd_suite ng-true-value={{f}} ng-false-value=0 ng-disabled=\"(vm.form_imov.imv.imv_qtd_dorm < {{f}})\"><label for=suite-{{f}}>{{f}}</label></div></div></div><div class=\"form-group d-flex flex-column\"><label for=detalhe-09 class=\"ml-1 pl-3 upper\">Quantas salas?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=sala class=\"input-control circle\" id=sala-{{f}} ng-model=vm.form_imov.imv.imv_qtd_sala ng-true-value={{f}} ng-false-value=0><label for=sala-{{f}}>{{f}}</label></div></div></div><div class=\"form-group d-flex flex-column\"><label for=detalhe-07 class=\"ml-1 pl-3 upper\">Quantas vagas de garagem?</label><div class=row><div class=circle-group ng-repeat=\"f in vm.form_imov.rangeDetalhe\"><input type=checkbox name=vagas class=\"input-control circle\" id=vagas-{{f}} ng-model=vm.form_imov.imv.imv_qtd_vagas ng-true-value={{f}} ng-false-value=0><label for=vagas-{{f}}>{{f}}</label></div></div></div></div></div><div ng-if=\"vm.form_imov.form[vm.form_imov.idArray].gcmd_id != 1\"><div class=\"form-group d-flex flex-column\"><h3 for=\"\">{{ vm.form_imov.form[vm.form_imov.idArray].grupocomodidade .gcmd_ask }}</h3><label for=\"\">{{ vm.form_imov.form[vm.form_imov.idArray].grupocomodidade .gcmd_label }}</label><div class=row ng-if=\"\n                    !vm.form_imov.form[vm.form_imov.idArray].grupocomodidade\n                      .gcmd_tipo\n                  \"><div class=\"col-12 col-sm-4\" ng-repeat=\"c in vm.form_imov.form[vm.form_imov.idArray].grupocomodidade.grupocategoria | orderBy:\'comodidades.cmd_nome\' \"><input type=checkbox class=\"input-control square\" name={{vm.form_imov.form[vm.form_imov.idArray].grupocomodidade.gcmd_nome}} id=comodidade-{{c.comodidades.id}} ng-model=vm.form_imov.imv_comodidades[c.comodidades.id] ng-true-value=true ng-false-value=false><label for=comodidade-{{c.comodidades.id}}>{{c.comodidades.cmd_nome}}</label></div></div><div class=row ng-if=(vm.form_imov.form[vm.form_imov.idArray].grupocomodidade.gcmd_tipo)><div class=radio-group ng-repeat=\"c in vm.form_imov.form[vm.form_imov.idArray].grupocomodidade.grupocategoria | orderBy:\'comodidades.cmd_nome\'\"><input type=radio name=position class=\"input-control radio-circle\" id=comodidade-{{c.comodidades.id}} ng-model=vm.form_imov.imv_comodidades[c.comodidades.id] ng-value=true ng-checked=$first><label for=comodidade-{{c.comodidades.id}}>{{c.comodidades.cmd_nome}}</label></div></div></div></div></div><button type=button ng-if=!vm.form_imov.idArray ng-click=vm.form_imov.prevStepImovel() class=\"btn button button-white col-5 col-sm-4 float-left\">Anterior</button> <button type=button ng-if=vm.form_imov.idArray ng-click=vm.form_imov.prevStep() class=\"btn button button-white col-5 col-sm-4 float-left\">Anterior</button> <button type=button ng-if=vm.form_imov.idArray ng-click=vm.form_imov.jumpSteps() class=\"btn button button-white col-2 col-sm-4\">Pular</button> <button type=submit class=\"btn button btn-default col-5 col-sm-4 float-right\">Próximo <i class=\"fal fa-arrow-right\"></i></button></form></div><div class=steps-form ng-if=\"(\'main.painel.typeform-termos\'| includedByState)\" ng-init=vm.form_terms.init()><div class=form-term><ul ng-if=\"vm.imobiliaria.id != 75\"><div ng-if=\"(vm.form_terms.imv.tpng_id == 1) || (vm.form_terms.imv.tpng_id == 2)  || (vm.form_terms.imv.tpng_id == 3)\" class=component-term><li class=li-term><div><h4>Exclusividade no anúncio</h4><div class=container-term><div ng-if=vm.imbTermsConfig.exclusividade class=\"px-0 col\"><p>Durante o período de Exclusividade, o proprietário não pode anunciar seu imóvel - para venda ou locação - em outras imobiliárias e classificados.</p></div><div ng-if=!vm.imbTermsConfig.exclusividade class=\"px-0 col\"><p>A {{vm.imb.imb_nome ? vm.imb.imb_nome : \'Arbo imóveis\'}} não trabalha com cláusula de exclusividade.</p></div><div class=info-btn><i ng-click=vm.form_terms.openModal(0) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></div></li><li class=li-term><div class=container-term><div class=\"px-0 col\"><p>A presente autorização vigorará pelo prazo de período {{vm.imbTermsConfig.periodo ? vm.imbTermsConfig.periodo : \'60\'}} dias, a partir do aceite destes termos de anúncio.</p></div></div></li></div><div ng-if=\"(vm.form_terms.imv.tpng_id == 1)\" class=component-term><li class=li-term-type><div class=content-type><h4>Tipo de negócio</h4><div class=\"px-0 col\"><p class=info-business>Este imóvel está configurado para atender a negociação do tipo venda</p></div></div></li><li class=li-term-type><div class=container-term><p>A comissão da {{vm.imb.imb_nome ? vm.imb.imb_nome : \'Arbo imóveis\'}} a ser paga pela intermediação do negócio de venda será de {{vm.imbTermsConfig.intermediacao_padrao ? vm.imbTermsConfig.intermediacao_padrao : \'6\'}}% sobre o valor efetivo da venda em contrato.</p><div class=info-btn><i ng-click=vm.form_terms.openModal(1) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></li></div><div ng-if=\"(vm.form_terms.imv.tpng_id == 2)\" class=component-term><li class=li-term-type><div class=content-type><h4>Tipo de negócio</h4><div class=\"px-0 col\"><p class=info-business>Este imóvel está configurado para atender a negociação do tipo locação</p></div><div class=\"px-0 col\"><p class=info-business>A comissão da {{vm.imb.imb_nome ? vm.imb.imb_nome : \'Arbo imóveis\'}} compreende:</p></div></div></li><li class=li-term-type><div class=container-term><p>Taxa de intermediação do imóvel de locação, equivalente a {{vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel || vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel == 0 ? vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel : \'100\'}}% do valor do primeiro aluguel. <span ng-if=vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel>E {{vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel || vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel == 0 ? vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel : \'60\'}}% do segundo aluguel.</span></p><div class=info-btn><i ng-click=vm.form_terms.openModal(2) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></li><li ng-if=vm.imbTermsConfig.locacao_administrativa class=li-term-type><div class=container-term><p>Taxa de administração do imóvel de locação, equivalente a {{vm.imbTermsConfig.taxa_padrao ? vm.imbTermsConfig.taxa_padrao + \'%\' : \'10% a 15%\'}} sobre o valor do aluguel a partir do segundo mês.</p></div></li></div><div ng-if=\"(vm.form_terms.imv.tpng_id == 3)\" class=component-term><li class=li-term-type><div class=content-type><h4>Tipo de negócio</h4><div class=\"px-0 col\"><p class=info-business>Este imóvel está configurado para atender a negociação do tipo venda e locação</p></div></div></li><div class=content-intermediacao><p>Para intermediação de venda</p></div><li class=li-term><div class=container-term><p>A comissão da {{vm.imb.imb_nome ? vm.imb.imb_nome : \'Arbo imóveis\'}} a ser paga pela intermediação do negócio de venda será de {{vm.imbTermsConfig.intermediacao_padrao ? vm.imbTermsConfig.intermediacao_padrao : \'6\'}}% sobre o valor efetivo da venda em contrato.</p><div class=info-btn><i ng-click=vm.form_terms.openModal(1) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></li><div class=content-intermediacao><p>Para intermediação de Locação</p></div><div class=content-intermediacao><p>A comissão da {{vm.imb.imb_nome ? vm.imb.imb_nome : \'Arbo imóveis\'}} compreende:</p></div><li class=li-term><div class=container-term><p>Taxa de intermediação do imóvel de locação, equivalente a {{vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel || vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel == 0 ? vm.imbTermsConfig.intermediacao_padrao_primeiro_aluguel : \'100\'}}% do valor do primeiro aluguel. <span ng-if=vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel>E {{vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel || vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel == 0 ? vm.imbTermsConfig.intermediacao_padrao_segundo_aluguel : \'60\'}}% do segundo aluguel.</span></p><div class=info-btn><i ng-click=vm.form_terms.openModal(2) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></li><li ng-if=vm.imbTermsConfig.locacao_administrativa class=li-term><div class=container-term><p>Taxa de administração do imóvel de locação, equivalente a {{vm.imbTermsConfig.taxa_padrao ? vm.imbTermsConfig.taxa_padrao + \'%\' : \'10% a 15%\'}} sobre o valor do aluguel a partir do segundo mês.</p></div></li></div><div ng-if=\"(vm.form_terms.imv.tpng_id == 1) || (vm.form_terms.imv.tpng_id == 2)  || (vm.form_terms.imv.tpng_id == 3)\" class=component-term><li class=li-term><div class=content-type><h4>Responsabilidades</h4><div class=container-term><div class=\"px-0 col\"><p>Apresentação de todas as documentações necessárias para a conclusão de negócio imobiliário.</p></div><div class=info-btn><i ng-click=vm.form_terms.openModal(3) class=\"fas fa-info-circle\" style=color:#929292></i></div></div></div></li><div><li class=li-term-resp><div class=\"px-0 col\"><p>A {{vm.imobiliaria.nome ? vm.imobiliaria.nome : \'Arbo imóveis\'}} não se responsabiliza por eventuais estragos ou depredações sofridas no imóvel no intervalo compreendido entre a presente data e a concretização da negociação, bem como por sinistros causados por incêndios, vendavais, etc.</p></div></li></div></div></ul></div><form name=termsuse class=mt-3 ng-submit=\"termsuse.$valid && vm.form_terms.callAcceptTerm()\"><div class=term_teste_conft><div><input type=checkbox name=terms-anuncio class=\"input-control square\" id=term_anuncio ng-model=vm.form_terms.terms.terms_accept_ad ng-true-value=true ng-false-value=false ng-required=vm.form_terms.requiredForm()><label for=term_anuncio class=\"d-block mr-2\">Concordo em anunciar meu imovel na plataforma {{vm.imobiliaria.nome ? vm.imobiliaria.nome : \'Arbo Imóveis\'}}</label><div ng-messages=\"termsuse[\'terms-anuncio\'].$error\" ng-if=\"termsuse[\'terms-anuncio\'].$dirty\" role=alert class=ng-message><div ng-message=required>Concorde em anunciar seu imovel na plataforma {{vm.imobiliaria.nome ? vm.imobiliaria.nome : \'Arbo Imóveis\'}} primeiro.</div></div></div><div><input type=checkbox name=terms-termos class=\"input-control square\" id=term_termos ng-model=vm.form_terms.terms.terms_accept ng-true-value=true ng-false-value=false ng-required=vm.form_terms.requiredForm()><label for=term_termos class=d-inline-block>Aceito os</label>&nbsp;<a href=/termos-uso target=_blank class=\"d-inline-block custom-link-terms\">termos de uso</a><label ng-if=\"!vm.config_wl.configwl[\'POLITICA-PRIVACIDADE\']\">&nbsp;e <a href=/politica-privacidade target=_blank class=\"d-inline-block custom-link-terms\">política de privacidade</a></label><div ng-messages=\"termsuse[\'terms-termos\'].$error\" ng-if=\"termsuse[\'terms-termos\'].$dirty\" role=alert class=ng-message><div ng-message=required>Aceite os termos primeiro.</div></div></div><div class=term_groupbtn><button type=submit class=btn_submit_term ng-click=\"termsuse[\'terms-termos\'].$dirty = true; termsuse[\'terms-anuncio\'].$dirty = true\">Concluir cadastro</button> <button type=button class=btn_cancel_term ng-click=vm.form_terms.cancelar()>Cancelar</button></div></div></form></div><div class=\"steps-form col-12 col-sm-12 px-0\" ng-if=\"(\'main.painel.typeform-obrigado\'| includedByState)\" ng-init=vm.form_obg.init()><div class=\"col-12 form-group\"><h4 class=title>Vamos analisar seu imóvel em breve estará em nosso site</h4><h4 class=\"text-center mt-4\"><i class=\"fal fa-smile-beam\"></i></h4></div></div></div></div></section>");
$templateCache.put("app/components/cardImovel/cardImovel.html","<div id=new-card-imovel class=\"m-auto p-0 position-relative\" data-id=\"{{ vm.imovel.id }}\" ng-style=\"{ \'pointer-events\': vm.imovel.shimmer && \'none\' }\"><a ng-href=\"{{ vm.imovel.custom_url || vm.makeUrl(vm.imovel) }}\" target=_blank ng-class=\"{ \'result-hover\': vm.imovel.hover }\"><div ng-class=\"{ \'animated-shimmer\': vm.imovel.shimmer }\" ng-style=\"{ \'pointer-events\': vm.imovel.shimmer && \'none\' }\"><a class=\"playBtnCard position-absolute\" href=\"{{ vm.makeUrl(vm.imovel, true) }}\" ng-if=vm.imovel.imv_videourl></a> <a class=\"anchorLink position-absolute\" href=\"{{ vm.makeUrl(vm.imovel, true) }}\"></a><div id=\"carousel-{{ vm.imovel.id }}-{{ vm.rnd }}\" class=\"carousel slide\" data-pause=true><ol class=carousel-indicators><li data-target=\"#carousel-{{ vm.imovel.id }}-{{ vm.rnd }}\" data-slide-to=\"{{ $index }}\" ng-if=!vm.imovel.shimmer ng-repeat=\"x in [].constructor(vm.imovel.imgThumb.length) track by $index\" ng-class=\"{ active: !$index }\"></li></ol><div class=\"carousel-inner w-100 p-0\" ng-class=\"{ \'animated-title\': vm.imovel.shimmer }\"><div class=carousel-item ng-repeat=\"foto in vm.imovel.imgThumb | limitTo:7\" ng-style=\"{ width: \'100%\', height: \'100%\' }\" ng-class=\"{ active: !$index }\"><img ng-src=\"{{ !$index ? foto.imvft_url : \'\' }}\" class=d-block alt=\"{{\n                (foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto\') +\n                  \' do \' +\n                  vm.imovel.tipo_imovel.timv_nome\n              }} - {{ vm.imovel.imv_titulo }} | {{ vm.config_wl.nome }}\" data-img=\"{{ $index ? foto.imvft_url : \'\' }}\" on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}}></div><img src=./assets/images/novosite/fallback.png ng-if=\"!vm.imovel.imgThumb.length && !vm.imovel.shimmer\"></div><a class=\"carousel-control-prev c-pointer\" ng-show=vm.imovel.imgThumb.length data-target=\"#carousel-{{ vm.imovel.id }}-{{ vm.rnd }}\" data-slide=prev><span class=carousel-control-prev-icon aria-hidden=true></span> <span class=sr-only>Previous</span> </a><a class=\"carousel-control-next c-pointer\" ng-show=vm.imovel.imgThumb.length data-target=\"#carousel-{{ vm.imovel.id }}-{{ vm.rnd }}\" data-slide=next><span class=carousel-control-next-icon aria-hidden=true></span> <span class=sr-only>Next</span></a></div></div><div class=icon-favorite ng-if=!vm.imovel.shimmer></div></a><span type=button class=heartContent id=\"favorite-{{ vm.imovel.id }}\" aria-busy=false ng-click=vm.setFavorite(vm.imovel) ng-if=!vm.imovel.shimmer><i class=\"fal fa-heart\" ng-show=!vm.imovel.isFavorite></i> <i class=\"fas fa-heart fullHeart\" ng-show=vm.imovel.isFavorite></i> </span><a ng-href=\"{{ vm.imovel.custom_url || vm.makeUrl(vm.imovel) }}\" target=_blank class=result ng-class=\"{ \'result-hover\': vm.imovel.hover }\"><div class=info itemscope itemtype=\"{{\n        vm.imovel.timv_id == 1\n          ? \'http://schema.org/Apartment\'\n          : \'http://schema.org/Residence\'\n      }}\"><div class=\"row no-gutters align-items-start\"><div class=\"col-11 p-0\"><div class=\"shimmer w-50\" ng-if=vm.imovel.shimmer></div><div class=\"shimmer py-2 w-100\" ng-if=vm.imovel.shimmer></div><h2 class=\"col-11 p-0\" ng-if=!vm.imovel.shimmer><span ng-if=!vm.imovel.shimmer>{{ vm.imovel.tipo_imovel.timv_nome }}</span> <span ng-if=\"vm.imovel.imv_bairro || vm.imovel.imv_nome_cond\" style=\"display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                line-height: 22px\">{{ !( vm.imovel.imobiliaria.imb_hidden_cond_num || vm.config_wl.imb_hidden_cond_num ) && vm.imovel.imv_nome_cond ? vm.titleCase(vm.titleCondominio) : vm.title }} </span><span class=d-none>{{ vm.imovel.imv_titulo }}</span></h2><div class=\"shimmer py-3 w-100\" ng-if=vm.imovel.shimmer></div><p class=pre-line ng-if=!vm.imovel.shimmer><span ng-class=\"{\n                \'d-none\':\n                  vm.imovel.imobiliaria.imb_hidden_address ||\n                  vm.config_wl.imb_hidden_address\n              }\">{{ vm.imovel.imv_endereco }},</span> <span ng-class=\"{\n                \'d-none\':\n                  vm.imovel.imobiliaria.imb_hidden_number ||\n                  vm.config_wl.imb_hidden_number\n              }\">{{ vm.imovel.imv_end_numero }} -</span> <span>{{ vm.imovel.imv_bairro }}</span> <span class=d-none>{{ vm.imovel.imv_obs }}</span></p><p class=pre-line ng-if=!vm.imovel.shimmer><span>{{ vm.imovel.imv_cidade }} -</span> <span>{{ vm.imovel.imv_estado }}</span></p></div><div class=\"col-12 align-self-end\"><div class=\"shimmer w-50\" ng-if=vm.imovel.shimmer></div><ul ng-if=!vm.imovel.shimmer><li ng-if=\"(vm.imovel.imv_area_util || vm.imovel.imv_area_total) > 0\"><span>{{ vm.imovel.imv_area_util || vm.imovel.imv_area_total }} m²</span> {{ vm.imovel.imv_area_util ? \'Útil\' : \'Área\' }}</li><li ng-if=\"vm.imovel.imv_qtd_dorm > 0\"><span>{{ vm.imovel.imv_qtd_dorm }}</span> {{ vm.imovel.imv_qtd_dorm > 1 ? \'Quartos\' : \'Quarto\' }}</li><li ng-if=\"vm.imovel.imv_qtd_banheiros > 0\"><span>{{ vm.imovel.imv_qtd_banheiros }}</span> {{ vm.imovel.imv_qtd_banheiros > 1 ? \'Banheiros\' : \'Banheiro\' }}</li></ul><div class=\"shimmer py-3 w-75\" ng-if=vm.imovel.shimmer></div><h3 ng-if=\"!vm.imovel.shimmer && !vm.ocultarPreco\"><div class=\"row row-cols-2 no-gutters\" ng-if=\"vm.imovel.tipovar == \'a-venda\'\"><div class=\"d-flex flex-column\"><span>Venda</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorVenda || \'Sob consulta\') }}</span></div><div class=\"d-flex flex-column\" ng-if=\"vm.valorVenda > 0 && vm.valorCondominio > 0\"><span>Condomínio</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorCondominio || \'Sob consulta\') }}</span></div></div><div class=\"row row-cols-2 no-gutters\" ng-if=\"vm.imovel.tipovar == \'para-alugar\'\"><div class=\"d-flex flex-column\"><span>Aluguel</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorAluguel || \'Sob consulta\') }}</span></div><div class=\"d-flex flex-column\" ng-if=\"vm.valorAluguel > 0 && vm.valorCondominio > 0\"><span>Condomínio</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorCondominio || \'Sob consulta\') }}</span></div></div><div class=\"row row-cols-2 no-gutters\" ng-if=\"![\'a-venda\', \'para-alugar\'].includes(vm.imovel.tipovar)\"><div class=\"d-flex flex-column\" ng-if=\"vm.valorVenda > 0\"><span>Venda</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorVenda || \'Sob consulta\') }}</span></div><div class=\"d-flex flex-column\" ng-if=\"vm.valorAluguel > 0\"><span>Aluguel</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorAluguel || \'Sob consulta\') }}</span></div><div class=\"d-flex flex-column\" ng-if=\"vm.valorCondominio > 0 && !vm.valorAluguel\"><span>Condomínio</span> <span class=text-truncate>{{ vm.formatPrice(vm.valorCondominio || \'Sob consulta\') }}</span></div></div></h3><h3 ng-if=vm.ocultarPreco style=\"font-weight: 600\">Valores sob consulta</h3></div></div></div></a></div>");
$templateCache.put("app/components/cardImovel/cardImovelDestaque.html","<section id=card-imovel class=\"result-item d-flex flex-column item p-0\" data-id=\"{{ vm.imovel.id }}\" style=\"width: 100%\"><div itemscope itemtype=\"{{vm.imovel.timv_id == 1 ? \'http://schema.org/Apartment\' : \'http://schema.org/Residence\'}}\"><a ng-href=\"{{vm.imovel.custom_url || vm.makeUrl(vm.imovel)}}\" target=_blank class=result ng-class=\"{\'result-hover\': vm.imovel.hover}\"><div id=\"carousel-{{ vm.imovel.id }}-{{vm.rnd}}\" class=\"carousel slide\" data-pause=true><ol class=carousel-indicators><li data-target=\"#carousel-{{ vm.imovel.id }}-{{vm.rnd}}\" data-slide-to={{$index}} ng-repeat=\"foto in vm.imovel.imgThumb640640 | limitTo:7\" ng-class=\"{\'active\': !($index)}\"></li></ol><div class=\"carousel-inner w-100\"><div class=carousel-item ng-repeat=\"foto in vm.imovel.imgThumb640 | limitTo:7\" ng-style=\"{ \'width\': \'100%\', \'height\': \'100%\'}\" ng-class=\"{\'active\': !($index)}\"><img ng-src=\"{{!($index) ? foto.imvft_url : \'\'}}\" class=d-block alt=\"{{(foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto\') + \' do \' + vm.imovel.tipo_imovel.timv_nome}} - {{vm.imovel.imv_titulo}} | {{vm.config_wl.nome}}\" data-img=\"{{($index) ? foto.imvft_url : \'\'}}\" on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}}></div><div class=\"carousel-item border\" ng-if=!(vm.imovel.imgThumb640.length) style=\"display: block; width: 100%; height: 100%; background-image: url(\'./assets/images/novosite/fallback.png\')\"></div></div><a class=\"carousel-control-prev c-pointer\" ng-show=(vm.imovel.imgThumb640.length) data-target=\"#carousel-{{ vm.imovel.id }}-{{vm.rnd}}\" data-slide=prev><span class=carousel-control-prev-icon aria-hidden=true></span> <span class=sr-only>Previous</span> </a><a class=\"carousel-control-next c-pointer\" ng-show=(vm.imovel.imgThumb640.length) data-target=\"#carousel-{{ vm.imovel.id }}-{{vm.rnd}}\" data-slide=next><span class=carousel-control-next-icon aria-hidden=true></span> <span class=sr-only>Next</span></a></div><div class=icon-favorite><button type=button class=\"btn button button-transparent ml-auto\" id=favorite-{{vm.imovel.id}} aria-busy=false ng-click=vm.setFavorite(vm.imovel)><i class=\"fal fa-heart\" ng-show=!vm.imovel.isFavorite></i> <i class=\"fas fa-heart\" ng-show=vm.imovel.isFavorite></i></button></div></a><div class=description><div class=row><h1 itemprop=name class=\"title col-12\" style=\"-webkit-box-orient: vertical !important\">{{ vm.imovel.imv_titulo }}</h1></div><div class=\"row col-12\"><div class=\"comodidades col-12 row\"><div class=col ng-repeat=\"item in vm.showComodidades\"><i class=fas ng-class=item.icon></i><p style=\"margin-bottom: 2px\">{{item.label}}</p><p class=value>{{ item.data || \'-\'}} <span ng-if=item.tipo>m<sup>2</sup></span></p></div></div></div><div class=\"row col-12 d-flex justify-content-center\" style=\"padding-top: 5px\"><a ng-href=\"{{ vm.imovel.custom_url || vm.makeUrl(vm.imovel)}}\" target=_blank class=\"btn btn-outline\">VER MAIS</a></div></div></div></section>");
$templateCache.put("app/components/cardPlace/cardPlace.html","<section id=card-place class=\"result-item d-flex flex-column item p-0\" data-id=\"{{ vm.place.place_id }}\"><a target=_blank class=result ng-href=\"{{ vm.url }}\"><div class=result-description itemscope><div class=column><div class=row><img ng-if=vm.place.photos[0].url ng-src=\"{{ vm.place.photos[0].url.split(\'=\')[0] + \'=w196\' }}\" alt=\"{{ vm.place.name }}\" loading=lazy check-image> <img ng-if=!vm.place.photos[0].url ng-src=../../assets/images/novosite/sem-foto-locais.jpg alt=\"{{ vm.place.name }}\" loading=lazy check-image></div><div class=row><h3 class=title-place data-toggle=tooltip title=\"{{ vm.place.name }}\">{{ vm.place.name }}</h3></div><div class=row><div class=avaliacao><div class=\"stars-ctr flex-1\"><span class=block-click data-toggle=tooltip title=\"{{ vm.place.rating }}\"></span><rating-stars class=stars ng-model=vm.place.rating ratings=5 place-id=vm.place.place_id></rating-stars></div><div class=\"rating-crt flex-2\"><p ng-if=vm.place.user_ratings_total>{{ vm.place.user_ratings_total }} avaliações</p><p ng-if=!vm.place.user_ratings_total>0 avaliação</p></div></div></div><div class=row><p class=distancia>{{ vm.getDistanceFromLatLonInKm(vm.place.location, vm.position) }} metros</p></div></div></div></a></section>");
$templateCache.put("app/components/carouselImovel/carouselImovel.html","<section id=carousel-imovel class=p-0><div class=\"carousel-title d-flex align-items-center flex-column\"><h2 class=\"title title col-12 col-sm-12\">{{vm.titleCarousel}}</h2><div class=\"row w-100 justify-content-end\"><div class=\"btn-box col-sm-6 carousel-options d-none d-sm-flex justify-content-sm-end owl-nav\" ng-if=!!vm.navegator><button class=\"btn button btn-carousel change-carousel d-none d-md-block prev-img owl-prev\" ng-click=\"vm.prevOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-left\"></i></button> <button class=\"btn button btn-carousel change-carousel d-none d-md-block next-img owl-next\" ng-click=\"vm.nextOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-right\"></i></button></div></div></div><ng-owl-carousel id=carousel-venda class=\"owl-theme d-flex flex-fill pb-2\" owl-items=vm.imoveis owl-properties=vm.owlProperties owl-ready=vm.readyCarousel($api)><card-imovel imovel=listing ng-repeat=\"listing in vm.imoveis | orderBy:[\'precoVenda\',\'precoLocacao\']\"></card-imovel></ng-owl-carousel></section>");
$templateCache.put("app/components/carouselImovel/carouselImovelDestaque.html","<section id=carousel-imovel class=p-0><div class=\"carousel-title d-flex align-items-center flex-column\"><h1 class=\"title title col-12 col-sm-12\">{{vm.titleCarousel}}</h1><div class=\"row w-100 justify-content-end\"></div></div><div class=\"nav-carousel d-none d-lg-flex justify-content-between align-items-center\"><button class=\"carousel-direction prev-carousel d-flex justify-content-center align-items-center\" ng-click=\"vm.prevOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-left\"></i></button> <button class=\"carousel-direction next-carousel d-flex justify-content-center align-items-center\" ng-click=\"vm.nextOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-right\"></i></button></div><ng-owl-carousel id=carousel-venda class=\"owl-theme d-flex flex-fill pb-2\" owl-items=vm.imoveis owl-properties=vm.owlProperties owl-ready=vm.readyCarousel($api)><card-imovel-destaques imovel=listing ng-repeat=\"listing in vm.imoveis | orderBy:[\'precoVenda\',\'precoLocacao\']\"></card-imovel-destaques></ng-owl-carousel></section>");
$templateCache.put("app/components/carouselPlaces/carouselPlaces.html","<div id=carousel-places class=p-0 ng-if=vm.places><div class=\"carousel-title d-flex align-items-center flex-column\"><h2 class=\"title title col-12 d-flex flex-lg-row flex-lg-row\" style=\"padding-left: 0\"><i class=\"{{vm.icon}} mr-2\"></i> {{vm.titleCarousel}}</h2><div class=\"row w-100 justify-content-end\"><div class=\"btn-box col-sm-6 carousel-options d-none d-sm-flex justify-content-sm-end owl-nav\" ng-if=!!vm.navegator><button class=\"btn button btn-carousel change-carousel d-none d-md-block prev-img owl-prev\" ng-click=\"vm.prevOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-left\"></i></button> <button class=\"btn button btn-carousel change-carousel d-none d-md-block next-img owl-next\" ng-click=\"vm.nextOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-right\"></i></button></div></div></div><ng-owl-carousel id=carousel class=\"owl-theme d-flex flex-fill pb-2\" owl-items=vm.places owl-properties=vm.owlPropertiesPlaces owl-ready=vm.readyCarousel($api)><card-place place=listing position=vm.position ng-repeat=\"listing in vm.places\"></card-place></ng-owl-carousel></div>");
$templateCache.put("app/components/favoritos/favoritos.html","<section id=favorites class=margin-fluid><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Favoritos</h3><p class=\"col-12 my-0\">Aqui estão os seus imóveis favoritos</p></div><div id=favoritesResults class=\"d-flex flex-wrap justify-content-between justify-content-sm-start\"><card-imovel class=card-item-div imovel=listing ng-repeat=\"listing in vm.favorites | orderBy:[\'precoVenda\',\'precoLocacao\']\"></card-imovel><div class=\"nenhum_imovel d-flex flex-column p-4\" ng-if=\"vm.favorites.length == 0 || !vm.favorites\"><h1>Salve seus imóveis <span>favoritos</span> <i class=\"fal fa-heart\"></i></h1><p>Na lista de favoritos você pode salvar e fazer<br>propostas naquele cantinho que mais amou!</p></div></div></section>");
$templateCache.put("app/components/filters/filters.html","<div class=d-flex><form ng-if=\"!vm.tipoFiltros || vm.tipoFiltros == 1\" id=formHeader class=\"form-inline navbar-form navbar-left col ml-1\" ng-submit=vm.search.getGeoLocation(vm.search.setFilterForm)><div class=\"form-group border\" style=\"box-shadow: none\"><div class=\"input-group col-12\"><div class=\"col px-0\"><input type=text id=header-search ng-model=vm.searchInput ng-model-options=\"{allowInvalid: true, debounce: 200}\" class=\"col-12 form-control size d-flex align-items-center\" placeholder=\"Digite sua busca\" style=\"padding-left: 8px; width: 100%\" ng-if=!vm.isMobile() typeahead-on-select=vm.clickSelect($item) uib-typeahead=\"address as address.description for address in vm.getLocation($viewValue)\" typeahead-popup-template-url=app/components/typeahead/customPopupTemplate.html typeahead-template-url=app/components/typeahead/customTemplate.html typeahead-show-hint=true typeahead-min-length=1 oninput=\"this.value = this.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ_0-9,\\-\\ ]/g, \'\')\" typeahead-focus-first=false> <input type=text id=header-search ng-model=vm.searchInput ng-model-options=\"{allowInvalid: true, debounce: 200}\" class=\"col-12 form-control size d-flex align-items-center\" placeholder=\"Digite sua busca\" style=\"padding-left: 8px; width: 100%\" ng-if=vm.isMobile() typeahead-on-select=vm.clickSelect($item) uib-typeahead=\"address as address.description for address in vm.getLocation($viewValue)\" typeahead-popup-template-url=app/components/typeahead/customPopupTemplate.html typeahead-template-url=app/components/typeahead/customTemplate.html typeahead-show-hint=true typeahead-min-length=1 typeahead-focus-first=false></div><div class=\"d-flex justify-content-end input-group-prepend\"><button type=submit class=\"btn button btn-white\"><i class=\"fas fa-search\"></i></button></div></div></div></form></div><aside ng-if=\"vm.tipoFiltros == 2\" class=\"aside-filters mobile-filter-row padding-top-5px padding-bottom-5px mobile-filter-padding\"><div class=\"row filters\"><div class=col-12 ng-if=\"vm.search.params.tipovar == \'lancamento\'\"><h4 class=title-search>Fase</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.fase === 2 }\" ng-model=vm.search.params.fase ng-click=vm.search.btnFase(2)>Em Construção</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.fase === 1 }\" ng-model=vm.search.params.fase ng-click=vm.search.btnFase(1)>Pronto</button></div></div><div class=col-12><h4 class=title-search>Tipo de Interesse</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.residencial }\" ng-click=vm.search.btnInteresse(1) ng-init=\"vm.search.residencial = true\">Residencial</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.comercial }\" ng-click=vm.search.btnInteresse(2) ng-init=\"vm.search.comercial = true\">Comercial</button></div></div><div class=col-12 ng-if=\"vm.search.params.tipovar != \'lancamento\'\"><h4 class=title-search>Tipos de imóvel</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'apartamento\'] }\" ng-click=\"vm.search.btnTipoimovel(\'apartamento\')\">Apartamento</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'casa\'] }\" ng-click=\"vm.search.btnTipoimovel(\'casa\')\">Casa</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'terreno\'] }\" ng-click=\"vm.search.btnTipoimovel(\'terreno\')\">Terreno</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'barracao\'] }\" ng-click=\"vm.search.btnTipoimovel(\'barracao\')\">Barracão</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'loja\'] }\" ng-click=\"vm.search.btnTipoimovel(\'loja\')\">Loja / Sala</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'chacara\'] }\" ng-click=\"vm.search.btnTipoimovel(\'chacara\')\">Chácara</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'kitnet\'] }\" ng-click=\"vm.search.btnTipoimovel(\'kitnet\')\">Kitnet</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'studio\'] }\" ng-click=\"vm.search.btnTipoimovel(\'studio\')\">Studio</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'casa-condominio\'] }\" ng-click=\"vm.search.btnTipoimovel(\'casa-condominio\')\">Casa Condominio</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{\n            active: vm.search.params.tipoimovel[\'terreno-condominio\']\n          }\" ng-click=\"vm.search.btnTipoimovel(\'terreno-condominio\')\">Terreno Condominio</button></div></div><div class=col-12 ng-show=\"vm.search.params.tipovar == \'a-venda\'\"><h4 class=title-search>Preço de venda</h4><div id=pricev-bars2 class=graph-bars><div id=pricev-range2 class=\"range pricev-range\"></div></div><div id=rangePricev2 class=graph-bars><div id=min class=float-left></div><div id=max class=float-right></div></div></div><div class=col-12 ng-show=\"vm.search.params.tipovar == \'para-alugar\'\"><h4 class=title-search>Preço de locação</h4><div id=pricel-bars2 class=graph-bars><div id=pricel-range2 class=range></div></div><div id=rangePricel2 class=graph-bars><div id=min class=float-left></div><div id=max class=float-right></div></div></div><div class=col-12><h4 class=title-search>Dormitórios</h4><div class=row><div class=circle-group><input type=checkbox name=dormitory class=\"input-control circle\" id=dormitory1 ng-model=\"vm.search.params.dormitorios[\'1\']\" ng-true-value=true ng-false-value=false ng-change=\"\"><label for=dormitory1>1</label></div><div class=circle-group><input type=checkbox name=dormitory class=\"input-control circle\" id=dormitory2 ng-model=\"vm.search.params.dormitorios[\'2\']\" ng-true-value=true ng-false-value=false ng-change=\"\"><label for=dormitory2>2</label></div><div class=circle-group><input type=checkbox name=dormitory class=\"input-control circle\" id=dormitory3 ng-model=\"vm.search.params.dormitorios[\'3\']\" ng-true-value=true ng-false-value=false ng-change=\"\"><label for=dormitory3>3</label></div><div class=circle-group><input type=checkbox name=dormitory class=\"input-control circle\" id=dormitory4 ng-model=\"vm.search.params.dormitorios[\'4\']\" ng-true-value=true ng-false-value=false ng-change=\"\"><label for=dormitory4>4+</label></div></div></div><div class=col-12><h4 class=title-search>Área</h4><div id=area-bars class=graph-bars><div id=area-range2 class=range></div></div><div id=rangeArea2 class=graph-bars><div id=min class=float-left></div><div id=max class=float-right></div></div></div><div class=col-12><h4 class=title-search>Vagas</h4><div class=row><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage1 ng-model=vm.search.params.vagas[0] ng-true-value=true ng-false-value=false ng-change=\"\"><label for=garage1>0</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage2 ng-model=vm.search.params.vagas[1] ng-true-value=true ng-false-value=false ng-change=\"\"><label for=garage2>1</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage3 ng-model=vm.search.params.vagas[2] ng-true-value=true ng-false-value=false ng-change=\"\"><label for=garage3>2</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage4 ng-model=vm.search.params.vagas[3] ng-true-value=true ng-false-value=false ng-change=\"\"><label for=garage4>3+</label></div></div></div><div class=col-12><h4 class=title-search>Mobilia</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'sim\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'sim\')\">Sim</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'não\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'não\')\">Não</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'talvez\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'talvez\')\">Talvez</button></div></div></div><div class=\"row fixed-filter justify-content-center z-index-max\"><div class=\"mx-auto col-8\"><button class=\"btn button button-toogle btn-default col-12 btn-shadow-white\" ng-click=vm.search.setFilter()>Aplicar</button></div></div></aside><div ng-if=\"vm.tipoFiltros == 1 && vm.isMobile()\" class=\"filters-modal hide\"><div class=\"close-btn d-flex justify-content-center align-items-center\"><a href=javascript:void(0) ng-click=vm.toggleFiltersModal()><i class=\"fal fa-times\"></i></a></div><div class=\"row filters\"><div class=col-12 ng-show=\"vm.search.params.tipovar == \'a-venda\'\"><h4 class=title-search>Preço de venda</h4><div id=pricev-bars-mobile class=graph-bars><div id=pricev-range-mobile class=range></div></div><div id=rangePricev-mobile></div></div><div class=col-12 ng-show=\"vm.search.params.tipovar == \'para-alugar\'\"><h4 class=title-search>Preço de locação</h4><div id=pricel-bars-mobile class=graph-bars><div id=pricel-range-mobile class=range></div></div><div id=rangePricel-mobile></div></div><div class=col-12><h4 class=title-search>Dormitórios</h4><div class=row><div class=circle-group><input type=checkbox name=dormitory-m class=\"input-control circle\" id=dormitory1-m ng-model=vm.search.params.dormitorios[1] ng-true-value=true ng-false-value=false><label for=dormitory1-m>1</label></div><div class=circle-group><input type=checkbox name=dormitory-m class=\"input-control circle\" id=dormitory2-m ng-model=vm.search.params.dormitorios[2] ng-true-value=true ng-false-value=false><label for=dormitory2-m>2</label></div><div class=circle-group><input type=checkbox name=dormitory-m class=\"input-control circle\" id=dormitory3-m ng-model=vm.search.params.dormitorios[3] ng-true-value=true ng-false-value=false><label for=dormitory3-m>3</label></div><div class=circle-group><input type=checkbox name=dormitory-m class=\"input-control circle\" id=dormitory4-m ng-model=vm.search.params.dormitorios[4] ng-true-value=true ng-false-value=false><label for=dormitory4-m>4+</label></div></div></div><div class=col-12 ng-if=\"vm.search.params.tipovar != \'lancamento\'\"><h4 class=title-search>Tipos de imóvel</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'apartamento\'] }\" ng-click=\"vm.search.btnTipoimovel(\'apartamento\')\">Apartamento</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'casa\'] }\" ng-click=\"vm.search.btnTipoimovel(\'casa\')\">Casa</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'terreno\'] }\" ng-click=\"vm.search.btnTipoimovel(\'terreno\')\">Terreno</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'barracao\'] }\" ng-click=\"vm.search.btnTipoimovel(\'barracao\')\">Barracão</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'loja\'] }\" ng-click=\"vm.search.btnTipoimovel(\'loja\')\">Loja / Sala</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'chacara\'] }\" ng-click=\"vm.search.btnTipoimovel(\'chacara\')\">Chácara</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'kitnet\'] }\" ng-click=\"vm.search.btnTipoimovel(\'kitnet\')\">Kitnet</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'studio\'] }\" ng-click=\"vm.search.btnTipoimovel(\'studio\')\">Studio</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.tipoimovel[\'casa-condominio\'] }\" ng-click=\"vm.search.btnTipoimovel(\'casa-condominio\')\">Casa Condominio</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{\n            active: vm.search.params.tipoimovel[\'terreno-condominio\']\n          }\" ng-click=\"vm.search.btnTipoimovel(\'terreno-condominio\')\">Terreno Condominio</button></div></div><div class=col-12><h4 class=title-search>Área</h4><div id=area-bars-mobile class=graph-bars><div id=area-range-mobile class=range></div></div><div id=rangeArea-mobile></div></div><div class=col-12><h4 class=title-search>Vagas</h4><div class=row><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage1-m ng-model=vm.search.params.vagas[0] ng-true-value=true ng-false-value=false><label for=garage1-m>0</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage2-m ng-model=vm.search.params.vagas[1] ng-true-value=true ng-false-value=false><label for=garage2-m>1</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage3-m ng-model=vm.search.params.vagas[2] ng-true-value=true ng-false-value=false><label for=garage3-m>2</label></div><div class=circle-group><input type=checkbox name=garage class=\"input-control circle\" id=garage4-m ng-model=vm.search.params.vagas[3] ng-true-value=true ng-false-value=false><label for=garage4-m>3+</label></div></div></div><div class=col-12><h4 class=title-search>Mobilia</h4><div class=\"container-buttons d-flex flex-wrap\"><button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'sim\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'sim\')\">Sim</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'não\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'não\')\">Não</button> <button class=\"btn button button-white flex-fill mx-1\" ng-class=\"{ active: vm.search.params.mobilia == \'talvez\' }\" ng-model=vm.search.params.mobilia ng-click=\"vm.search.btnMobilia(\'talvez\')\">Talvez</button></div></div></div><div class=\"row fixed-filter fixed-filter-mobile hide d-flex justify-content-center z-index-max\"><div class=\"mx-auto col-8\"><button class=\"btn button button-toogle btn-default col-12 btn-shadow-white\" ng-click=vm.search.setFilter()>Aplicar</button></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer class=footer><section class=customContainer><div><div class=\"row row-cols-1 row-cols-sm-3 row-cols-xl-4 rows\"><div class=\"col-sm-12 logos\"><ul class=\"logos list list-unstyled\" ng-class=\"vm.config_wl.isArbo ? \'customInline\' : \'\'\"><li class=arboLogo><img class=img-fluid src={{vm.config_wl.url_logo_footer}} alt=\"Logo da imobiliária\" ng-style=\"vm.config_wl.isArbo ? { height: \'33px\' } : {}\"></li><li ng-show=!vm.config_wl.isArbo>CRECI: {{ vm.config_wl.creci }}</li><li ng-show=vm.config_wl.isArbo class=scaleUpImage><img class=img-fluid src={{vm.config_wl.url_logo_footer_endeavor}} ng-style=\"vm.config_wl.isArbo ? { height: \'70px\' } : {}\" alt=\"Logo ScaleUp\"></li></ul></div><div class=\"col conheca\"><h5 ng-if=\"\n              (vm.config_wl.quemSomos && vm.config_wl.quemSomos != \'false\') ||\n              vm.config_wl.url_blog ||\n              vm.config_wl.imb_config_site.tecnologia ||\n              vm.config_wl.imb_config_site.nossotime ||\n              vm.config_wl.isArbo\n            \">Conheça</h5><ul class=\"list list-unstyled\"><li ng-if=\"\n                !vm.config_wl.isArbo &&\n                vm.config_wl.quemSomos &&\n                vm.config_wl.quemSomos != \'false\'\n              \"><a ui-sref=main.conheca-quem-somos>Quem Somos</a></li><li ng-if=vm.config_wl.imb_config_site.nossotime><a ui-sref=main.nosso-time>Nosso Time</a></li><li ng-if=vm.config_wl.isArbo><a ui-sref=main.imobiliarias>Imobiliárias Parceiras</a></li><li ng-if=vm.config_wl.isArbo><a target=_blank href=https://superlogica.gupy.io/ >Trabalhe conosco</a></li></ul></div><div class=col><h5>Contato</h5><ul class=\"list list-unstyled\"><li ng-repeat=\"tel in vm.config_wl.telefones\"><a href=\"{{vm.formatPhoneLink(tel.ttel_id, tel.numero)}}\" target=_blank><div class=title>{{ tel.contato }}</div><div><i ng-if=\"tel.ttel_id == 3\" class=\"fab fa-whatsapp\"></i> {{vm.formatPhone(tel.ttel_id, tel.numero)}}</div></a></li><li ng-if=\"vm.config_wl.imb_config_site.contato != false\"><a ui-sref=main.contact>Fale conosco</a></li><li ng-if=vm.config_wl.isArbo><a href=https://ajuda.arboimoveis.com.br class=custom-item>Central de ajuda</a></li></ul></div><div class=col><ul class=\"buttons list m-0 list-unstyled\"><li ng-if=vm.config_wl.isArbo><a class=\"btn button btn-default\" href=https://mkt.arboimoveis.com.br/anuncie-seu-imovel/ target=_blank>Cadastre seu imóvel</a></li><li><a class=\"btn button btn-default\" ui-sref=main.registerimovel ng-if=\"!vm.config_wl.isArbo && vm.config_wl.imb_angariadora\">Cadastre seu imóvel</a></li></ul></div></div><div class=\"container-fluid px-0 marginTop\"><div class=\"d-block d-xl-flex justify-content-between\"><div class=\"d-block d-xl-flex justify-content-between\"><div class=\"d-block d-xl-flex copyright\"><ul class=\"list-inline m-0\"><li class=list-inline-item>&copy; <span ng-show=vm.config_wl.isArbo class=bold>Arbo.</span> <span ng-show=!vm.config_wl.isArbo class=bold>{{ vm.config_wl.nome }}.</span></li></ul><ul class=\"list-inline m-0\"><li class=list-inline-item>Todos os direitos reservados.</li><li class=list-inline-item>·</li><li class=list-inline-item><a href=/termos-uso>Termos de uso</a></li><li class=list-inline-item>·</li><li class=list-inline-item ng-if=!vm.config_wl.isArbo><div ng-if=vm.existsPrivacyPolicy><a href=/politica-privacidade>Políticas de privacidade</a></div><div ng-if=!vm.existsPrivacyPolicy><a>Políticas de privacidade</a></div></li><span ng-if=vm.config_wl.isArbo><li class=list-inline-item><a href=/politica-privaci2dade>Políticas de privacidade</a></li><li class=list-inline-item>·</li><li class=list-inline-item><a href=/codigo-de-conduta.pdf target=_blank>Código de Conduta</a></li><li class=list-inline-item>·</li><li class=list-inline-item><a href=https://docs.google.com/forms/d/e/1FAIpQLScIB2kaRFTQhIp3UazpEIFOqhbg5NSMv5ubj_AhX0Agjl8TUQ/viewform target=_blank>Canal de denúncia</a></li></span></ul><ul ng-if=!vm.config_wl.isArbo class=\"list-inline m-0\"><li class=list-inline-item><a href=https://www.arboimoveis.com.br style=\"text-decoration: none\"><span class=mr-1>Desenvolvido por&nbsp; <img src=./assets/images/novosite/arbo_imoveis_desktop.svg height=14px alt=\"Logo arbo imóveis\"></span></a></li></ul></div></div><div class=d-flex id=social-media><ul class=\"socials list-inline m-0\"><li class=list-inline-item ng-if=vm.config_wl.facebook ng-repeat=\"fb in vm.config_wl.facebook track by $index\"><a ng-href=\"{{ fb }}\" target=_blank><i class=\"fab fa-facebook-f\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.instagram ng-repeat=\"ig in vm.config_wl.instagram track by $index\"><a ng-href=\"{{ ig }}\" target=_blank><i class=\"fab fa-instagram\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.linkedin ng-repeat=\"lk in vm.config_wl.linkedin track by $index\"><a ng-href=\"{{ lk }}\" target=_blank><i class=\"fab fa-linkedin-in\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.youtube ng-repeat=\"yt in vm.config_wl.youtube track by $index\"><a ng-href=\"{{ yt }}\" target=_blank><i class=\"fab fa-youtube\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.blog ng-repeat=\"bg in vm.config_wl.blog track by $index\"><a ng-href=\"{{ bg }}\" target=_blank><i class=\"fab fa-wordpress-simple\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.twitter ng-repeat=\"tt in vm.config_wl.twitter track by $index\"><a ng-href=\"{{ tt }}\" target=_blank><i class=\"fab fa-twitter\"></i></a></li><li class=list-inline-item ng-if=vm.config_wl.pinterest ng-repeat=\"pt in vm.config_wl.pinterest track by $index\"><a ng-href=\"{{ pt }}\" target=_blank><i class=\"fab fa-pinterest\"></i></a></li></ul></div></div></div></div></section></footer>");
$templateCache.put("app/components/header/header.html","<header id=header class=\"header-nav container-fluid d-flex justify-content-center align-items-center bg-transparent text-white\" ng-class=\"{\n    \'hide-shadow\':\n      (\'main.search-all\' | includedByState) ||\n      (\'main.search-address\' | includedByState) ||\n      (\'main.search-address-ad-type\' | includedByState) ||\n      (\'main.search-address-ad-build-type\' | includedByState)\n  }\" style=\"transition: all 200ms ease 0s;\n    position: fixed;\n    font-size: 0.875rem\" ng-style=\"vm.config_wl.isArbo ? { height: \'100px\' } : {}\"><nav style=\"padding: 0 !important\" class=\"navbar navbar-expand-xl\"><div id=logo class=\"menu-logo d-flex align-items-center\"><a id=navbar-brand style=\"margin-right: 2.75rem\" href=# role=button ng-click=vm.changeLocation()><ng-include id=arbo-logo ng-if=vm.config_wl.isArbo src=\"\'./assets/images/novosite/arbo_imoveis_desktop.svg\'\"></ng-include><img id=navbar-logo ng-if=!vm.config_wl.isArbo class=\"img img-logo wl-img\" src=\"{{ vm.config_wl.url_logo_bg_escura }}\" alt=\"logo whitelabel\" style=\"transition: height 200ms ease\" ng-style=\"\n            {\n              height: vm.config_wl.imb_config_site.image_size\n                ? vm.config_wl.imb_config_site.image_size + \'px\'\n                : \'60px\'\n            }\n          \"></a></div><div id=sidenav class=\"sidenav text-center\"><div class=\"close-btn d-flex align-items-center\"><a href=javascript:void(0) class=\"ml-auto bg-transparent d-flex align-items-center justify-content-center\"><i class=\"fal fa-times\"></i></a></div><div class=\"d-flex flex-column px-3 inside-sidenav mt-1\" style=\"color: #0a1420\"><a ng-if=vm.isAuthenticated class=\"p-0 d-flex align-items-center py-3 nav-link\" ui-sref=\"main.painel.dashboard({tab:\'meu-perfil\'})\" style=\"margin: 0 .3175rem\"><b>Olá, {{ vm.user.nome }}</b> </a><a href=# role=button ng-click=vm.changeLocation() class=\"p-0 d-flex align-items-center py-3 nav-link\" style=\"margin: 0 .3175rem\">Início </a><span id=sidenav-list class=\"d-flex flex-column\" ng-if=!vm.config_wl.isArbo></span><div ng-if=vm.config_wl.isArbo class=dropdown><a class=\"nav-link p-0\" id=dropdown-start ng-attr-target=_blank ng-href=https://plataforma.arboimoveis.com.br/ role=button aria-haspopup=true aria-expanded=false><button type=button class=\"bg-transparent nav-link border-0 col-12 h-100 p-0\" style=\"outline: none\"><div class=\"p-0 d-flex align-items-center justify-content-between py-3 nav-link\" style=\"margin: 0 .3175rem\"><span class=mr-2>Para seu negócio</span></div></button></a></div><div ng-if=vm.config_wl.isArbo class=dropdown><a class=\"nav-link p-0\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><button type=button class=\"bg-transparent nav-link border-0 col-12 h-100 p-0\" style=\"outline: none\"><div class=\"p-0 d-flex align-items-center justify-content-between py-3 nav-link\" style=\"margin: 0 .3175rem\"><span class=mr-2>Ajuda </span><i class=\"fas fa-chevron-down\" style=\"font-size: 0.715rem\"></i></div></button></a><div class=\"dropdown-menu new-drop-style border-0 w-100\" style=\"width: -moz-fit-content;\n              width: fit-content;\n              position: initial;\n              box-shadow: none !important\" aria-labelledby=dsropdown-start><a class=\"dropdown-item p-3\" href=/fale-conosco target=_self>Fale conosco</a> <a href=https://ajuda.arboimoveis.com.br/hc/pt-br class=\"dropdown-item p-3\" target=_blank>Central de ajuda</a></div></div><div ng-if=vm.config_wl.isArbo class=dropdown><a class=\"nav-link p-0\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><button type=button class=\"bg-transparent nav-link border-0 col-12 h-100 p-0\" style=\"outline: none\"><div class=\"p-0 d-flex align-items-center justify-content-between py-3 nav-link\" style=\"margin: 0 .3175rem\"><span class=mr-2>Mais </span><i class=\"fas fa-chevron-down\" style=\"font-size: 0.715rem\"></i></div></button></a><div class=\"dropdown-menu new-drop-style border-0 w-100\" style=\"width: -moz-fit-content;\n              width: fit-content;\n              position: initial;\n              box-shadow: none !important\" aria-labelledby=dsropdown-start><a class=\"dropdown-item p-3\" href=# ui-sref=main.favorites>Imóveis curtidos </a><a href=/regioes-atendidas class=\"dropdown-item p-3\" target=_self>Explore bairros</a> <a class=\"dropdown-item p-3\" ng-href=\"{{ vm.config_wl.url_blog }}\" ng-if=vm.config_wl.url_blog>Blog</a></div></div><div ng-if=\"vm.config_wl.imb_config_site.login != false\" class=dropdown-divider style=\"margin-right: .3175rem; margin-left: .3175rem\" role=separator></div><div class=dropdown ng-if=\"vm.config_wl.imb_config_site.login != false && vm.isAuthenticated\"><a class=\"nav-link p-0\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><button type=button class=\"bg-transparent nav-link border-0 col-12 h-100 p-0\" style=\"outline: none\"><div class=\"p-0 d-flex align-items-center justify-content-between py-3 nav-link\" style=\"margin: 0 .3175rem\"><span class=mr-2>Acessar </span><i class=\"fas fa-chevron-down\" style=\"font-size: 0.715rem\"></i></div></button></a><div class=\"dropdown-menu new-drop-style border-0 w-100\" style=\"width: -moz-fit-content;\n              width: fit-content;\n              position: initial;\n              box-shadow: none !important\" aria-labelledby=dsropdown-start><a class=\"dropdown-item p-3\" href=# ui-sref=\"main.painel.dashboard({tab:\'meu-perfil\'})\">Meu perfil </a><a class=\"dropdown-item p-3\" ui-sref=\"main.painel.dashboard({tab:\'vender\',selected:\'publicados\'})\">Imóveis anunciados </a><a class=\"dropdown-item p-3\" ui-sref=\"main.painel.dashboard({tab:\'renovacao\',selected:\'todos\'})\">Aceite de Termos/Renovação </a><span ng-if=vm.config_wl.isArbo><a class=\"dropdown-item p-3\" href=https://adm030667.superlogica.net/clients/areadofornecedor target=_blank>Área do proprietário </a><a class=\"dropdown-item p-3\" href=https://adm030667.superlogica.net/clients/areadocliente target=_blank>Área do locatário </a></span><a class=\"dropdown-item p-3\" href=# ui-sref=\"main.painel.dashboard({tab:\'favoritos\',selected:\'todos\'})\">Imóveis curtidos</a></div></div><a role=button ng-click=vm.forms.openModalLogin($event) class=\"p-0 d-flex align-items-center py-3 nav-link\" style=\"margin: 0 .3175rem\" ng-if=\"\n            vm.config_wl.imb_config_site.login != false && !vm.isAuthenticated\n          \">Entrar </a><a role=button ng-click=vm.logout() class=\"p-0 d-flex align-items-center py-3 nav-link\" style=\"margin: 0 .3175rem\" ng-if=\"\n            vm.config_wl.imb_config_site.login != false && vm.isAuthenticated\n          \">Sair</a><div class=\"nav-item focus-btn\" ng-if=vm.config_wl.imb_angariadora><a class=\"btn button anuncie-seu-imovel rounded-pill px-4 d-flex justify-content-center align-items-center\" ng-if=!vm.config_wl.isArbo ui-sref=main.registerimovel style=\"font-size: 1rem;\n              padding-top: 0.75rem !important;\n              padding-bottom: 0.75rem !important;\n              margin: 2.75rem .3175rem 5rem\">Anuncie seu imóvel </a><a class=\"btn button anuncie-seu-imovel rounded-pill px-4 d-flex justify-content-center align-items-center\" ng-if=vm.config_wl.isArbo ng-attr-target=\"{{(vm.isAuthenticated) ? \'_self\' : \'_blank\'}}\" ng-href=\"{{\n              vm.isAuthenticated\n                ? \'/formulario/tipo-imovel\'\n                : \'https://mkt.arboimoveis.com.br/anuncie-seu-imovel/\'\n            }}\" style=\"font-size: 1rem;\n              padding-top: 0.75rem !important;\n              padding-bottom: 0.75rem !important;\n              margin: 2.75rem .3175rem 5rem\">Anuncie seu imóvel</a></div></div></div><filters pagetitle=vm.search.title tipo-filtros=1 id=formHeaderFilter class=\"col col-xl-3 p-0 mr-xl-4\"></filters><div ng-click=vm.toggleSidenav($event) id=toggle-sidenav class=\"d-flex justify-content-center align-items-center d-xl-none\" ng-class=\"\n        (vm.config_wl.imb_config_site.busca_menu != false ||\n          (\'main.search-address\' | includedByState) ||\n          (\'main.search-address-ad-type\' | includedByState) ||\n          (\'main.search-address-ad-build-type\' | includedByState)) &&\n        !(\'main.painel\' | includedByState) ? \'ml-4\' : \'ml-auto\'\"><i class=\"fas fa-bars\" style=\"font-size: 1.5rem\"></i></div><div id=navDesktop class=\"collapse navbar-collapse\"><ul id=nav-list ng-if=!vm.config_wl.isArbo ng-style=\"vm.config_wl.isArbo ? { maxWidth: \'428px\' } : {}\" style=\"height: 44px\" ng-class=\"vm.config_wl.isArbo ? \'justify-content-between\' : \'\'\" class=\"navbar-nav d-xl-flex align-items-center p-0 pl-3 col mr-auto\"></ul><ul ng-if=vm.config_wl.isArbo ng-style=\"vm.config_wl.isArbo ? { maxWidth: \'428px\' } : {}\" style=\"height: 44px\" ng-class=\"vm.config_wl.isArbo ? \'justify-content-between\' : \'\'\" class=\"navbar-nav d-xl-flex align-items-center p-0 pl-3 col mr-auto\"><a class=\"btn button para-seu-negocio inverted d-flex justify-content-center align-items-center rounded-pill mt-2 ml-2 mr-3 m-xl-0 p-2 px-4\" ng-attr-target=_blank ng-href=https://plataforma.arboimoveis.com.br/ style=\"height: 44px; font-size: 14px; line-height: 1\">Para seu negócio</a><li class=\"nav-item h-100 dropdown mr-xl-4\"><a class=\"nav-link d-flex align-items-center h-100\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false>Ajuda <i class=\"ml-2 fas fa-chevron-down\" style=\"font-size: 0.715rem\"></i></a><div style=\"width: -moz-fit-content; width: fit-content\" ng-style=\"\n              vm.config_wl.imb_angariadora ? { left: 0 } : { left: \'unset\' }\n            \" class=\"dropdown-menu add-links-prop new-drop-style\" aria-labelledby=dsropdown-start><a class=dropdown-item href=/fale-conosco target=_self>Fale conosco </a><a class=dropdown-item href=https://ajuda.arboimoveis.com.br/hc/pt-br target=_blank>Central de ajuda</a></div></li><li class=\"nav-item h-100 dropdown\"><a class=\"nav-link d-flex align-items-center h-100\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false>Mais <i class=\"ml-2 fas fa-chevron-down\" style=\"font-size: 0.715rem\"></i></a><div style=\"width: -moz-fit-content; width: fit-content\" ng-style=\"\n              vm.config_wl.imb_angariadora ? { left: 0 } : { left: \'unset\' }\n            \" class=\"dropdown-menu add-links-prop new-drop-style\" aria-labelledby=dsropdown-start><a class=dropdown-item href=# ui-sref=main.favorites>Imóveis curtidos </a><a class=dropdown-item href=/regioes-atendidas target=_self>Explore bairros </a><a href=https://blog.arboimoveis.com.br/ class=dropdown-item target=_blank>Blog</a></div></li></ul><ul class=\"navbar-nav align-items-center\"><li class=\"nav-item focus-btn\" ng-if=vm.config_wl.imb_angariadora><a class=\"btn button anuncie-seu-imovel inverted d-flex justify-content-center align-items-center rounded-pill mt-2 ml-2 mr-3 m-xl-0 p-2 px-4\" ng-if=!vm.config_wl.isArbo ui-sref=main.registerimovel style=\"height: 44px; font-size: 14px; line-height: 1\">Anuncie seu imóvel </a><a class=\"btn button anuncie-seu-imovel inverted d-flex justify-content-center align-items-center rounded-pill mt-2 ml-2 mr-3 m-xl-0 p-2 px-4\" ng-if=vm.config_wl.isArbo ng-attr-target=\"{{(vm.isAuthenticated) ? \'_self\' : \'_blank\'}}\" ng-href=\"{{\n              vm.isAuthenticated\n                ? \'/formulario/tipo-imovel\'\n                : \'https://mkt.arboimoveis.com.br/anuncie-seu-imovel/\'\n            }}\" style=\"height: 44px; font-size: 14px; line-height: 1\">Anuncie seu imóvel</a></li><li id=loginButton class=\"nav-link d-flex align-items-center h-100 pl-xl-4 pr-xl-0\" ng-click=vm.forms.openModalLogin($event) ng-if=\"\n            vm.config_wl.imb_config_site.login != false && !vm.isAuthenticated\n          \"><b>Entrar</b></li><li id=loginButton class=\"dropdown nav-item\" style=\"padding-left: 12px\" ng-if=\"(vm.config_wl.isArbo || vm.config_wl.imb_config_site.login) && vm.isAuthenticated\"><a class=\"nav-link p-0\" style=\"margin-right: 0\" href=# id=dropdown-start role=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><button type=button class=\"bg-transparent nav-link border-0 col-12 h-100 p-0\" style=\"outline: none\"><div class=\"d-none border-white text-white d-xl-flex rounded-pill align-items-center pr-xl-2 pl-xl-3 py-2\" style=\"border: 0.063rem solid\"><i class=\"fas fa-chevron-down\" style=\"font-size: 0.715rem;\n                    margin-top: 0.2rem;\n                    margin-right: 0.75rem\"></i> <i id=user-drop class=\"fas fa-user-circle\" style=\"font-size: 1.65rem; opacity: 0.8\"></i></div></button></a><div class=\"dropdown-menu new-drop-style\" style=\"width: -moz-fit-content; width: fit-content; right: 0; left: unset\" aria-labelledby=dsropdown-start><span ng-if=\"\n                vm.config_wl.imb_config_site.login != false &&\n                vm.isAuthenticated\n              \"><a class=dropdown-item href=# ui-sref=\"main.painel.dashboard({tab:\'meu-perfil\'})\">Meu perfil </a><a class=dropdown-item ui-sref=\"main.painel.dashboard({tab:\'vender\',selected:\'publicados\'})\">Imóveis anunciados </a><a class=dropdown-item ui-sref=\"main.painel.dashboard({tab:\'renovacao\',selected:\'todos\'})\">Aceite de Termos/Renovação </a><span ng-if=vm.config_wl.isArbo><a class=dropdown-item href=https://adm030667.superlogica.net/clients/areadofornecedor target=_blank>Área do proprietário </a><a class=dropdown-item href=https://adm030667.superlogica.net/clients/areadocliente target=_blank>Área do locatário</a></span><div class=\"mx-xl-3 dropdown-divider\" role=separator></div></span><a class=dropdown-item href=# ui-sref=\"main.painel.dashboard({tab:\'favoritos\',selected:\'todos\'})\">Imóveis curtidos </a><a class=dropdown-item href=# ng-click=vm.logout()>Sair</a></div></li></ul></div></nav></header>");
$templateCache.put("app/components/listingDetail/listingDetail.html","<section id=ficha-imovel ng-style=\"\n    !vm.config_wl.isArbo && !vm.isTablet\n      ? {\n          \'margin-top\': vm.topSize,\n        }\n      : {\n          \'margin-top\': \'80px\'\n        }\n  \" scroll itemscope itemtype=http://schema.org/Article><div class=\"container mt-5\" ng-if=\"vm.tag.hidden && vm.mobile\"><div class=\"tag-imovel d-flex\"><div class=\"body-tag d-flex flex-wrap flex-column justify-content-center col\"><h4 class=title-tag>{{ vm.tag.text }}</h4></div><div class=image-tag><svg ng-if=\"vm.tag.svg == \'pin\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n              fill: #c0f2cd;\n            }\n\n            .st1 {\n              fill: #ffffff;\n            }\n\n            .st2 {\n              fill: #f1fbf4;\n            }\n\n            .st3 {\n              fill: #c0f2cd;\n            }\n\n            .st4 {\n              fill: #00bf6f;\n            }</style><g><path class=st0 d=\"M251.7,496.9c3,4.1,7.7,6.6,12.8,6.6s9.8-2.4,12.8-6.6C317,443.7,435.2,290.1,435.2,190\n                c0-121.7-76.5-181.5-170.7-181.5S93.9,68.3,93.9,190C93.9,290.1,212.1,443.7,251.7,496.9z\"/><path class=st1 d=\"M238.9,496.9c6.2,8.7,6,8.7,12.2,0c37.7-53.2,150-206.8,150-306.9c0-121.7-72.6-181.5-162.1-181.5\n                S76.8,68.3,76.8,190C76.8,290.1,201.2,443.7,238.9,496.9z\"/><path class=st2 d=\"M244.5,496.9c2.4,4.1,6.8,6.6,11.5,6.6c4.7,0,9.1-2.5,11.5-6.6c35.7-53.2,142.1-206.8,142.1-306.9\n                C409.6,68.3,340.8,8.5,256,8.5S102.4,68.3,102.4,190C102.4,290.1,208.8,443.7,244.5,496.9z\"/><circle class=st3 cx=256 cy=187.7 r=128 /><path class=st2 d=\"M316.4,144.1l-0.7,0.9v102.4c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5v-33.1\n                c0.2-8.6-5.7-16.1-14.2-17.8c-5-0.8-10,0.5-13.9,3.8s-6.1,8-6.1,13v34.1c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5V145.1\n                l-3.2-5.2l57.3-35.2c3.3-2.9,8.2-2.9,11.4,0L316.4,144.1z\"/><g><path class=st4 d=\"M256,324.3c-75.4,0-136.5-61.1-136.5-136.5S180.6,51.2,256,51.2s136.5,61.1,136.5,136.5\n                  C392.4,263.1,331.4,324.2,256,324.3z M256,68.3c-66,0-119.5,53.5-119.5,119.5S190,307.2,256,307.2s119.5-53.5,119.5-119.5\n                  C375.4,121.8,321.9,68.3,256,68.3z\"/><path class=st4 d=\"M307.2,264.5h-25.6c-9.4,0-17.1-7.6-17.1-17.1v-33.1c0.2-4.4-2.8-8.3-7-9.4c-2.5-0.4-5,0.3-7,1.9\n                  s-3.1,4-3.1,6.5v34.1c0,9.4-7.6,17.1-17.1,17.1h-25.6c-9.4,0-17.1-7.6-17.1-17.1V145.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5\n                  v102.4h25.6v-34.1c0-7.5,3.3-14.7,9.1-19.6s13.4-6.9,20.8-5.7c12.5,2.5,21.4,13.5,21.3,26.3v33.1h25.6V145.1\n                  c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v102.4C324.3,256.9,316.6,264.5,307.2,264.5z\"/><path class=st4 d=\"M341.3,170.7c-1.8,0-3.5-0.6-5-1.6l-79.6-57.6c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4,0.3-0.8,0.6-1.3,0.9l-79.6,49\n                  c-2.6,1.6-5.8,1.7-8.5,0.2c-2.7-1.4-4.4-4.2-4.5-7.3s1.5-5.9,4.1-7.5l79.1-48.7c6.4-5.1,15.5-5,21.8,0.2l79.3,57.3\n                  c3,2.2,4.3,6,3.1,9.5C348.3,168.3,345,170.7,341.3,170.7L341.3,170.7z\"/><path class=st4 d=\"M256,512c-7.9,0-15.3-3.6-20.2-9.8l-5.4-6.8C189.1,442.7,92.2,319.5,72,223.6c-0.6-3,0.4-6.1,2.6-8.1\n                  c2.3-2,5.5-2.7,8.4-1.8c2.9,1,5.1,3.4,5.7,6.4c19.3,92,114.5,213,155.1,264.7l5.4,6.8c1.7,2,4.2,3.2,6.8,3.2s5.1-1.2,6.8-3.2\n                  l5.5-7c43.3-55.1,158.4-201.5,158.4-294.6c0-127.5-88.2-173-170.7-173c-92.4,0-155.3,51.5-168.1,137.8c-0.4,3-2.5,5.6-5.3,6.7\n                  c-2.8,1.1-6.1,0.6-8.4-1.3c-2.4-1.9-3.6-4.9-3.1-7.9C85,58.4,155.9,0,256,0c114,0,187.7,74.6,187.7,190\n                  c0,99-113.6,243.4-162,305.1l-5.5,7C271.4,508.4,263.9,512,256,512L256,512z\"/><circle class=st4 cx=76.8 cy=187.7 r=8.5 /></g></g></svg> <svg ng-if=\"vm.tag.svg == \'mudanca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n              fill: #9de8eb;\n            }\n\n            .st1 {\n              fill: #a2fcf3;\n            }\n\n            .st2 {\n              fill: #e8f9fc;\n            }\n\n            .st3 {\n              fill: #ffffff;\n            }\n\n            .st4 {\n              fill: #2fbaba;\n            }</style><g><path id=Shape_1_ class=st0 d=\"M200.2,409.6c-7.4,0-13.9-4.8-16.2-11.8L70.6,49.7l-16.4,8.2c-8.4,4.2-18.7,0.8-22.9-7.6\n                s-0.8-18.7,7.6-22.9l34.1-17.1c4.4-2.2,9.6-2.4,14.2-0.5s8.1,5.7,9.7,10.5l114,350.3l248-88c8.9-3.2,18.6,1.5,21.8,10.4\n                c3.2,8.9-1.5,18.6-10.4,21.8l-264.5,93.9C204,409.2,202.1,409.6,200.2,409.6z\"/><path class=st0 d=\"M285.5,452.2c0,28.3-22.9,51.2-51.2,51.2c-5.2,0-10.4-0.8-15.4-2.3c-21.3-6.8-35.8-26.6-35.8-48.9\n                c0-22.4,14.5-42.2,35.8-48.9c5-1.5,10.2-2.2,15.4-2.3C262.6,401,285.5,424,285.5,452.2z\"/><ellipse id=Oval class=st1 cx=219 cy=452.2 rx=35.8 ry=48.9 /><circle class=st0 cx=234.3 cy=452.2 r=17.1 /><path id=Rectangle-path_1_ class=st1 d=\"M203.8,192l161-56.5c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9\n                l-161,56.5c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C197,198.5,199.3,193.6,203.8,192z\"/><path class=st2 d=\"M203.4,192.2l139.3-48.9c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9L260,353.2\n                c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C196.7,198.6,199,193.7,203.4,192.2z\"/><path class=st0 d=\"M315.6,215.8l-8.8-2.3c-3.3-0.9-6.9,0.4-8.9,3.1l-5.5,7.3c-1.9,2.5-5,3.8-8.1,3.3c-3.1-0.5-5.7-2.6-6.7-5.6\n                l-17.3-49.4l48.3-17l17.3,49.4c1,3,0.4,6.3-1.8,8.6C321.9,215.6,318.7,216.5,315.6,215.8z\"/><path class=st1 d=\"M189.1,75.9l102.6-36c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9l-102.6,36\n                c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C182.3,82.4,184.6,77.5,189.1,75.9z\"/><path class=st2 d=\"M188.1,76.3l78.1-27.4c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9L226,184.2\n                c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C181.3,82.7,183.6,77.8,188.1,76.3z\"/><path class=st0 d=\"M264,93.5l-9.5-2.4c-1.7-0.4-3.4,0.2-4.5,1.6l-5.9,7.8c-0.9,1.3-2.5,1.9-4.1,1.6c-1.6-0.2-2.8-1.3-3.4-2.8\n                l-12.5-35.7l32.4-11.4l12.5,35.7c0.5,1.5,0.2,3.2-0.9,4.3C267.2,93.4,265.5,93.9,264,93.5z\"/><path class=st3 d=\"M54.2,57.9l6.1-3.1c-4-3.8-5.9-9.4-5.1-14.8c0.8-5.5,4.3-10.2,9.3-12.6l28-14c-5.1-5.1-13-6.4-19.5-3.1\n                L38.9,27.4c-8.4,4.2-11.8,14.5-7.6,22.9S45.8,62.1,54.2,57.9z\"/><path class=st3 d=\"M73.8,59.6L184,397.8c1.4,4.4,4.6,8,8.7,10c4.1,2,8.9,2.3,13.2,0.8l4.5-1.6c-23,12.1-33.2,39.5-23.8,63.7\n                c9.4,24.2,35.5,37.5,60.6,31c-20.4-5.3-35.5-22.6-38-43.5s8.2-41.3,26.8-51.2l-4.5,1.6c-4.3,1.5-9.1,1.3-13.2-0.8\n                c-4.1-2-7.3-5.7-8.7-10L96.2,49.7l-16.4,8.2C77.9,58.8,75.9,59.4,73.8,59.6z\"/><polygon class=st3 points=\"78.7,47 113.1,152.5 192.1,395.1 175.8,400.4 96.8,157.8 62.5,52.3 	\"/><g><path class=st4 d=\"M99.4,118.5c2.1-4.2,0.4-9.3-3.7-11.5l-1.5-0.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.5-0.1-1.1-0.1-1.6,0\n                  c-0.6,0.1-1.1,0.2-1.7,0.4c-2.1,0.7-3.9,2.2-5,4.2c-2,4.2-0.4,9.3,3.7,11.5c1,0.5,2.1,0.8,3.2,0.9c1.1,0.1,2.2,0,3.3-0.4\n                  C96.5,122,98.3,120.5,99.4,118.5z\"/><path class=st4 d=\"M38.5,66.9c6.4,2.2,13.5,1.7,19.5-1.4l7.5-3.8l7.5,23c1.6,4.3,6.3,6.6,10.6,5.1c4.4-1.4,6.8-6,5.6-10.4\n                  L78.7,47.1l-0.2,0.1c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-4.2-7.2-5.9-11.4-3.9l-16.4,8.3c-4.2,2.1-9.4,0.4-11.5-3.8\n                  c-2.1-4.2-0.4-9.4,3.8-11.5L76.8,18c2.2-1.1,4.8-1.2,7.1-0.2c2.3,1,4.1,2.9,4.8,5.2l114.1,350.2c0.7,2.2,2.3,4,4.3,5\n                  c2.1,1,4.5,1.2,6.6,0.4l248-88c3.3-1.1,6.9-0.2,9.2,2.3c2.3,2.6,2.8,6.3,1.4,9.4c-1,2-2.7,3.6-4.8,4.4l-245.3,87\n                  c-5.2,1.1-10.2,2.9-15,5.3l-4.3,1.5c-2.2,0.8-4.6,0.6-6.6-0.4c-2.1-1-3.6-2.8-4.3-5l-81.6-250.7c-0.8-3-3.3-5.3-6.3-6\n                  c-3.1-0.7-6.2,0.3-8.3,2.7c-2.1,2.4-2.7,5.7-1.6,8.6l81.6,250.7c2,6.1,6.3,11.3,11.9,14.4c-16,19.8-17.6,47.5-4.2,69.1\n                  c13.5,21.6,39.1,32.3,63.9,26.6c24.8-5.6,43.3-26.3,46.1-51.6c2.8-25.3-10.7-49.6-33.6-60.5l213.2-75.7\n                  c8.9-2.8,15.5-10.3,17.3-19.5c1.8-9.2-1.5-18.6-8.7-24.6c-7.2-6-17-7.6-25.7-4.2l-22.7,8l-54-153.8c-0.8-2.1-2.3-3.9-4.4-4.9\n                  s-4.4-1.1-6.5-0.4l-26,9.1L307.2,31.8c-0.8-2.1-2.3-3.9-4.4-4.9s-4.4-1.1-6.5-0.4l-43.2,15.2l-32.4,11.4l-43.2,15.2\n                  c-2.1,0.8-3.9,2.3-4.9,4.4c-1,2-1.1,4.4-0.4,6.5L207.7,180l-16.3,5.7c-4.4,1.6-6.8,6.4-5.2,10.9L240.5,351l-24.1,8.5L105,17.6\n                  c-2.3-7.1-7.6-12.8-14.5-15.7S75.9-0.7,69.3,2.7L35.1,19.7C25.9,24.4,20.3,34.1,21,44.4S28.7,63.6,38.5,66.9z M234.3,409.6\n                  c21.9-0.3,40.6,15.9,43.4,37.7c2.8,21.8-11.1,42.2-32.4,47.5s-43.2-6.1-50.9-26.6c-7.8-20.5,1.1-43.6,20.6-53.7l11.4-4\n                  C229,409.8,231.6,409.6,234.3,409.6z M301.8,165l14.5,41.3l-14.4-3.7c-3.3-0.9-6.9,0.4-8.9,3.1l-8.9,11.8l-14.5-41.3l16.1-5.7\n                  L301.8,165z M257.8,80.8l-4.5-1.2c-3.3-0.9-6.9,0.4-8.9,3.1l-2.8,3.7l-7-20.1l8.1-2.9l8.1-2.9L257.8,80.8z M218.3,72l12.3,35.1\n                  c1,3,3.6,5.1,6.7,5.6c0.4,0.1,0.9,0.1,1.3,0.1c2.7,0,5.2-1.3,6.8-3.4l9-11.9l14.5,3.7c3,0.8,6.3-0.2,8.4-2.5\n                  c2.1-2.3,2.8-5.6,1.8-8.6L266.8,55l27.1-9.5l32.2,91.8l-102.6,36l-32.2-91.8L218.3,72z M253.5,182l19.8,56.4c1,3,3.6,5.1,6.7,5.6\n                  c3.1,0.5,6.2-0.8,8.1-3.3l15.1-20l24.3,6.2c3,0.8,6.3-0.2,8.4-2.5c2.1-2.3,2.8-5.6,1.8-8.6l-19.8-56.3l48.3-17l50.9,144.9\n                  l-161,56.5L205.2,199L253.5,182z\"/><path class=st4 d=\"M208.7,452.2c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6c0-14.1-11.5-25.6-25.6-25.6\n                  C220.2,426.6,208.7,438.1,208.7,452.2z M234.3,443.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5\n                  S229.6,443.7,234.3,443.7z\"/></g></g></svg> <svg ng-if=\"vm.tag.svg == \'busca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n              fill: #a2fcf3;\n            }\n\n            .st1 {\n              fill: #e8f9fc;\n            }\n\n            .st2 {\n              fill: #808e87;\n            }\n\n            .st3 {\n              fill: url(#SVGID_1_);\n            }\n\n            .st4 {\n              fill: #f26546;\n            }\n\n            .st5 {\n              fill: #9de8eb;\n            }\n\n            .st6 {\n              fill: #ffffff;\n            }\n\n            .st7 {\n              fill: #2fbaba;\n            }</style><g><path id=Shape class=st0 d=\"M458.8,399.6l-59.1,59l-0.3,0.3l-0.1-0.1h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l36.1-36.1\n                l11.4-11.4c3.3-3.3,8.6-3.3,11.8,0L458.8,399.6z\"/><path class=st0 d=\"M486.9,487.1c-2.1,2.1-4.4,4-7,5.6c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l0.3-0.3l59.1-59l28.1,28.1\n                C503.3,444.1,503.3,470.7,486.9,487.1z\"/><path class=st1 d=\"M436.9,420.5l-37.5,38.3h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l26.9-27.7c3.3-2.2,7.7-1.7,10.6,1.1\n                L436.9,420.5z\"/><path class=st1 d=M480,492.7c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l38.1-38.1l28,28.1C479.8,463.2,490.5,476.4,480,492.7z /><rect id=Rectangle-path x=342.9 y=329.6 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -152.5583 368.0898)\" class=st0 width=50.3 height=77.3 /><rect x=346.4 y=338 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -160.953 364.6137)\" class=st1 width=26.6 height=77.3 /><path class=st0 d=\"M341.9,342.1c-75.8,72.7-195.9,71.5-270.2-2.8S-3.8,144.9,68.9,69.1c75.8-72.7,195.9-71.5,270.2,2.8\n                S414.6,266.2,341.9,342.1z\"/><path class=st1 d=\"M316.7,342.1c-33,33.2-77.1,53.2-123.9,56.1c-75.6-4.9-141.4-53.6-168.1-124.6S15.3,122.7,68.9,69.1\n                c33-33.2,77.1-53.2,123.9-56.1c75.6,4.9,141.4,53.6,168.1,124.6S370.3,288.5,316.7,342.1z\"/><path class=st2 d=\"M205.4,373.4c-67.9,0-129.1-40.9-155.1-103.6s-11.6-134.9,36.4-183c65.6-65.6,171.9-65.6,237.4,0\n                s65.6,171.9,0,237.4C292.7,355.9,250,373.6,205.4,373.4z\"/><linearGradient id=SVGID_1_ gradientUnits=userSpaceOnUse x1=-700.6567 y1=795.9537 x2=-699.9529 y2=795.2502 gradientTransform=\"matrix(320.5412 0 0 -320.6926 224681.9375 255349.2344)\"><stop offset=0 style=\"stop-color: #d4f3f3\"/><stop offset=0.172 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #dbf1f3\"/><stop offset=0.201 style=\"stop-color: #ebedf3\"/><stop offset=0.201 style=\"stop-color: #f7f0f7\"/><stop offset=0.202 style=\"stop-color: #f1e6ec\"/><stop offset=0.205 style=\"stop-color: #fff2f7\"/><stop offset=0.252 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #d4f3f3\"/><stop offset=0.397 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #dbf1f3\"/><stop offset=0.421 style=\"stop-color: #ebedf3\"/><stop offset=0.421 style=\"stop-color: #f7f0f7\"/><stop offset=0.422 style=\"stop-color: #f1e6ec\"/><stop offset=0.425 style=\"stop-color: #fff2f7\"/><stop offset=0.489 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #f8f0f7\"/><stop offset=0.5 style=\"stop-color: #e8eef3\"/><stop offset=0.5 style=\"stop-color: #ddf1f3\"/><stop offset=0.5 style=\"stop-color: #d6f2f3\"/><stop offset=0.501 style=\"stop-color: #d4f3f3\"/><stop offset=0.706 style=\"stop-color: #d4f3f3\"/><stop offset=0.74 style=\"stop-color: #d4f3f3\"/><stop offset=0.741 style=\"stop-color: #fff2f7\"/><stop offset=0.835 style=\"stop-color: #fff2f7\"/><stop offset=0.85 style=\"stop-color: #fff2f7\"/><stop offset=0.851 style=\"stop-color: #d4f3f3\"/></linearGradient><path class=st3 d=\"M318.2,318.4c-62.3,62.2-163.3,62.2-225.6,0c-1.1-1.1-2.2-2.3-3.3-3.4c-39.7-40.9-54.5-99.8-39-154.7\n                s59.2-97.2,114.4-111.1s113.7,2.7,153.4,43.6c17.8,17.8,31.1,39.5,38.8,63.5C375.5,213.3,360.6,275.9,318.2,318.4z\"/><path class=st4 d=M138.3,183.2l69.3-60.3l65,60.3v98c0,4.6-3.8,8.4-8.4,8.4H146.7c-4.6,0-8.4-3.8-8.4-8.4V183.2z /><path class=st1 d=M146.7,171.7l60.7-66.8l56.8,66.8v108.6c0.5,4.6-2.8,8.7-7.3,9.3H154c-4.6-0.6-7.8-4.7-7.3-9.3V171.7z /><path class=st5 d=\"M293.1,196.9l-83-55.3c-2.8-1.9-6.5-1.9-9.3,0l-83,55.3c-2.6,1.7-5.9,1.9-8.6,0.4c-2.7-1.5-4.4-4.3-4.4-7.4\n                v-21.8c0-2.8,1.4-5.4,3.7-7l92.3-61.5c2.8-1.9,6.5-1.9,9.3,0l92.3,61.5c2.3,1.6,3.7,4.2,3.7,7v21.8c0,3.1-1.7,5.9-4.4,7.4\n                C299,198.8,295.7,198.6,293.1,196.9z\"/><path class=st5 d=M188.6,222.4h33.6c4.6,0,8.4,3.8,8.4,8.4v58.8h-50.4v-58.8C180.2,226.1,184,222.4,188.6,222.4z /><path class=st6 d=\"M192.8,398.1c8.4,0.5,16.7,0.5,25.1,0c-75.6-4.9-141.3-53.7-168-124.6S40.5,122.7,94.1,69.1\n                c33-33.2,77.1-53.1,123.8-56.1C111.6,6.1,19.8,86.7,12.8,193S86.5,391.2,192.8,398.1z\"/><path class=st6 d=\"M74.9,75c-12.2,12.5-22.7,26.5-31.2,41.7c-8.4,15.2-14.6,31.6-18.3,48.6c-6.7,30.3-5.8,61.9,2.7,91.8\n                c8.9,29.8,24.9,56.9,46.7,79.1L63,348c-23.8-24.1-41.3-53.8-51-86.3c-9.3-32.6-10.3-67-3-100.1c4.1-18.6,10.8-36.4,20-53.1\n                C38.3,92,49.7,76.7,63,63.1L74.9,75z\"/><path class=st7 d=\"M86.7,324.3c65.6,65.6,171.8,65.6,237.4,0c65.6-65.6,65.6-171.8,0-237.4c-42.4-42.4-104.2-59-162.2-43.5\n                S58.8,104.2,43.3,162.1S44.3,281.9,86.7,324.3z M98.6,98.7c59-59,154.7-59,213.7,0s59,154.7,0,213.7s-154.7,59-213.7,0\n                C70,284.2,53.9,245.7,53.9,205.6S70,126.9,98.6,98.7z\"/><path class=st7 d=\"M436.9,365.8c-6.6-6.6-17.2-6.6-23.7,0l-43.7-43.6c60.8-85.3,46-203-34-270.6S137-11.1,63,63.1l-11.7,13\n                c-3.9,4.3-7.1,9.3-10.6,13.9c-1.4,1.8-2,4.1-1.6,6.4c0.4,2.2,1.7,4.2,3.7,5.4c3.8,2.3,8.8,1.4,11.6-2.1c3.3-4.2,6.1-8.8,9.7-12.8\n                L74.8,75C147,2.9,263.9,2.9,336,75s72.1,189,0,261.1s-189,72.1-261.1,0C53,314,37,286.9,28.1,257.1c-8.5-29.9-9.5-61.5-2.7-91.8\n                l1.9-7.8c1-4.4-1.5-8.8-5.8-10.2c-2.2-0.7-4.5-0.5-6.5,0.6c-2,1.1-3.4,3-3.9,5.2L9,161.7c-7.4,33.1-6.3,67.5,3,100.1\n                c9.7,32.5,27.2,62.1,51,86.3c69.5,69.5,179,78.6,259,21.6l43.6,43.7c-6.6,6.6-6.6,17.2,0,23.7l56,56c12.7,12.9,31.3,18,48.8,13.4\n                c17.5-4.6,31.1-18.3,35.8-35.8c4.6-17.5-0.5-36.1-13.4-48.8L436.9,365.8z M377.5,401.4l-42.1-42.1c4.2-3.6,8.5-7.3,12.5-11.3\n                c4-4,7.7-8.2,11.3-12.5l42.2,42.1l-11.9,11.9L377.5,401.4z M425,377.7l21.9,21.9l-47.5,47.4l-21.9-21.9L425,377.7z M481,481.1\n                c-13.3,12.7-34.2,12.7-47.5,0l-22.2-22.2l47.5-47.4l22.2,22.1c6.3,6.3,9.8,14.8,9.8,23.7S487.3,474.8,481,481.1z\"/><path class=st7 d=\"M100.7,213c2.7,1.5,6,1.3,8.6-0.4l20.5-13.7v82.3c0,9.3,7.5,16.8,16.8,16.8h117.5c9.3,0,16.8-7.5,16.8-16.8\n                v-82.3l20.5,13.7c2.6,1.7,5.9,1.9,8.6,0.4c2.7-1.5,4.4-4.3,4.4-7.4v-42c0-2.8-1.4-5.4-3.7-7L210.1,89.5c-2.8-1.9-6.5-1.9-9.3,0\n                L100,156.6c-2.3,1.6-3.7,4.2-3.7,7v42C96.3,208.7,98,211.5,100.7,213z M188.6,281.1v-50.4h33.6v50.4H188.6z M264.2,281.1H239v-50.4\n                c0-9.3-7.5-16.8-16.8-16.8h-33.6c-9.3,0-16.8,7.5-16.8,16.8v50.4h-25.2v-93.4l58.8-39.2l58.8,39.2V281.1z M113.1,168.1l92.3-61.6\n                l92.3,61.5v21.8l-87.7-58.5c-2.8-1.9-6.5-1.9-9.3,0l-87.7,58.4V168.1z\"/></g></svg></div></div></div><div class=\"headers headers-images\" ng-show=\"vm.view === \'fotos\'\"><ng-owl-carousel id=carousel-imagem class=carousel-imovel owl-properties=vm.properties ng-if=\"vm.listing.imgFull.length != 0\" owl-items=vm.listing.imgFull owl-ready=vm.readyImagens($api)><div ng-if=\"vm.imovel.imv_videourl && vm.thumbvideo\"><a class=image-box href=\"{{ vm.imovel.imv_videourl }}\"><img src=\"{{ vm.thumbvideoHQ }}\" alt=\"\"><div class=play-btn></div></a></div><div ng-repeat=\"foto in vm.listing.imgFull\" class=image-box data-src=\"{{ vm.trustSrc(vm.listing.imgFull[$index].imvft_url) }}\" data-src-error=\"{{ vm.createThumb.removeWmk(foto.imvft_url) }}\"><img src=\"{{ $index < 4 ? foto.imvft_url : \'\' }}\" itemprop=photo alt=\"{{\n            (foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto\') +\n              \' do \' +\n              vm.listing.tipo_imovel.timv_nome\n          }} - {{ vm.listing.imv_titulo }} | {{ vm.config_wl.nome }}\" data-img=\"{{ $index ? foto.imvft_url : \'\' }}\" class=d-block on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}} ng-if=foto.imvft_url> <img src=\"{{ $index < 4 ? foto.imvft_url : \'\' }}\" itemprop=photo alt=\"\" data-img=\"{{ $index ? foto.imvft_url : \'\' }}\" class=d-block on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}} ng-if=!foto.imvft_url></div></ng-owl-carousel><div id=carousel-imagem class=carousel-imovel ng-if=\"vm.listing.imgFull.length == 0\"><div ng-if=\"vm.listing.imgFull.length == 0\" class=image-box><img src=../../assets/images/novosite/fallback.png class=d-block></div></div><div class=\"nav-carousel d-flex justify-content-between align-items-center\" ng-if=\"vm.listing.imgFull.length != 0\"><button class=\"carousel-direction prev-carousel d-flex justify-content-center align-items-center\" ng-click=vm.prevImageOwl()><i class=\"fal fa-chevron-left\"></i></button> <button class=\"carousel-direction next-carousel d-flex justify-content-center align-items-center\" ng-click=vm.nextImageOwl()><i class=\"fal fa-chevron-right\"></i></button></div></div><div class=\"headers headers-mapa\" ng-if=\"vm.view === \'maps\'\" style=\"position: relative\"><div id=maps-detail class=maps ng-init=vm.initMaps() ng-if=!vm.staticmap></div><div id=maps-static ng-click=\"vm.staticmap = !vm.staticmap\" ng-if=vm.staticmap><img src=../../assets/images/novosite/_marker.svg class=marker data-aos=fade-down> <img width=100% height=100% frameborder=0 class=static-map ng-src=\"https://maps.googleapis.com/maps/api/staticmap?center={{\n          vm.listing.imv_location.lat\n        }},{{\n          vm.listing.imv_location.lng\n        }}&zoom=15&scale=2&size=2290x540&key={{ vm.GOOGLE_API }}\"></div></div><section id=tourimovel ng-if=\"vm.view === \'tour\' && !!vm.listing.imv_toururl\"><a ng-href=\"{{ vm.trustSrc(vm.listing.imv_toururl) }}\" target=_blank class=icon-content><i class=\"fa fa-external-link-alt\"></i></a><iframe class=video-bckg ng-src=\"{{ vm.trustSrc(vm.listing.imv_toururl) }}\"></iframe></section><div class=\"headers headers-video\" ng-if=\"vm.view === \'video\' && !!vm.listing.imv_videourl\"><div class=\"imv-video w-100 d-none\"></div><video class=\"imv-video w-100\"></video></div><div class=\"body container d-flex p-0 mb-5\"><div class=\"col-12 col-lg-8\"><section><nav class=navegator><ol class=\"breadcrumb bg-white mb-4 px-0\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item href=/ ><span itemprop=name>Início</span></a><meta itemprop=position content=1></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 1) }}\"><span itemprop=name>{{ vm.listing.imv_cidade }}</span></a><meta itemprop=position content=2></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 5) }}\"><span itemprop=name>{{ vm.listing.imv_bairro }}</span></a><meta itemprop=position content=6></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 2) }}\"><span itemprop=name>{{ vm.listing.imv_preco_locacao ? \'Aluguel\' : \'Venda\' }}</span></a><meta itemprop=position content=3></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 3) }}\"><span itemprop=name>{{ vm.listing.tipo_imovel.timv_nome }}</span></a><meta itemprop=position content=4></li><li class=breadcrumb-item itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{ vm.makeUrl(vm.listing, 4) }}\"><span itemprop=name>imóvel {{ vm.listing.imv_cod_gaia }}</span></a><meta itemprop=position content=5></li></ol></nav><header class=header><div class=\"d-flex flex-column flex-lg-row\"><div class=\"col-12 col-lg pl-0 pr-0 pr-lg-3\"><div class=d-flex><h1 class=\"title pre-line\"><span class=mb-4>{{ vm.listing.imv_titulo }}</span> <span ng-if=\"vm.imovel.imv_bairro || vm.imovel.imv_nome_cond\">{{ !vm.imovel.imobiliaria.imb_hidden_cond_num ? vm.imovel.imv_nome_cond : vm.imovel.imv_bairro }}</span></h1><div ng-if=vm.mobile class=\"pl-2 d-inline-block\"><i class=\"fa-heart c-pointer\" ng-class=\"{\n                      fal: !vm.listing.isFavorite,\n                      fas: vm.listing.isFavorite\n                    }\" role=button ng-click=vm.setFavorite(vm.listing)></i></div></div><h2 class=subtitle>{{ vm.listing.subtipo_imovel.stimv_nome }}</h2><address class=address itemprop=address><span ng-class=\"{\n                    \'d-none\': vm.imovel.imobiliaria.imb_hidden_address\n                  }\">{{ vm.imovel.imv_endereco }},</span> <span ng-class=\"{\n                    \'d-none\': vm.imovel.imobiliaria.imb_hidden_number\n                  }\">{{ vm.imovel.imv_end_numero }} -</span> {{ vm.imovel.imv_bairro }} - {{ vm.imovel.imv_cidade }}/{{ vm.imovel.imv_estado }}</address><div class=description ng-if=vm.listing.imv_bloco_cond>Número de blocos/torres: <span>{{ vm.listing.imv_bloco_cond }}</span></div><div class=description>cód. {{ vm.listing.imv_cod_gaia }} /<h2 class=\"d-inline-block px-1\" ng-if=vm.showimobiliaria><a ui-sref=\"main.imobiliariaPage({imobRoute: vm.generateImobLink()})\">{{ vm.listing.imobiliaria.imb_nome }}</a></h2>Creci {{ vm.listing.imobiliaria.imb_creci }}</div><div class=description ng-if=vm.listing.imv_cod_origem>Código de origem: {{ vm.listing.imv_cod_origem }}</div><div ng-if=vm.mobile><div class=offers><ul itemprop=offers itemscope itemtype=http://schema.org/Offer><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_venda><div>Venda</div><div class=text-right itemprop=price>R$ {{ vm.formatPrice(vm.listing.imv_preco_venda) }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_locacao><div>Aluguel</div><div class=text-right itemprop=price>R$ {{ vm.formatPrice(vm.listing.imv_preco_locacao) }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_cond><div>Condominio</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_cond) }}</div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_iptu><div>IPTU mensal</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_iptu) }}</div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_seguro><div>Seguro incêndio</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_seguro) }}</div></li></ul></div><div class=btns-action id=box-contatar-btns><a ng-click=\"vm.openVisit(vm.listing, true)\" class=\"btn active\" aria-label=\"entrar em contato\">Entrar em contato</a><a ng-click=\"vm.openVisit(vm.listing, false)\" class=btn aria-label=\"agendar visita\">Agendar visita</a> <button class=btn ng-click=vm.gotoProp(vm.listing.tpng_id) ng-show=!vm.showPropbtn aria-label=\"fazer proposta\">Fazer proposta</button> <button class=btn ng-click=vm.gotoProp(1) ng-show=vm.showPropbtn aria-label=\"fazer proposta de compra\">Fazer proposta de compra</button> <button class=btn ng-click=vm.gotoProp(2) ng-show=vm.showPropbtn aria-label=\"fazer proposta de locação\">Fazer proposta de locação</button> <button class=btn role=button aria-label=compartilhar ng-click=vm.openShare()><i class=\"fal fa-share-alt\"></i> &nbsp;Compartilhar</button></div></div></div><div class=\"btns-media d-flex flex-row flex-lg-column order-first order-lg-last\"><button class=btn ng-show=\"vm.view !== \'tour\' && vm.listing.imv_toururl\" role=button ng-click=\"vm.changeView(\'tour\')\"><i class=\"fal fa-expand-arrows\"></i>&nbsp;Tour Virtual</button> <button class=btn ng-show=\"vm.view !== \'fotos\'\" role=button ng-click=\"vm.changeView(\'fotos\')\"><i class=\"fal fa-images\"></i>&nbsp;Fotos</button> <button class=btn ng-show=\"vm.view !== \'maps\'\" role=button ng-click=\"vm.changeView(\'maps\')\"><i class=\"fal fa-map-marker-alt\"></i>&nbsp;Mapa</button></div></div><div class=\"d-flex justify-content-center justify-content-lg-start flex-wrap mt-5\"><div class=\"comodidades d-flex flex-column justify-content-center align-items-center px-3 mt-2\" ng-repeat=\"item in vm.showComodidades\"><i class=\"icon fas\" ng-class=item.icon></i> <span class=label>{{ item.label }}</span> <span class=data>{{ item.data || \'-\' }} <span ng-if=item.tipo>m <sup>2</sup></span></span></div></div><div class=mt-5 ng-if=vm.tag.hidden><div class=\"tag-imovel d-flex\"><div class=image-tag><svg ng-if=\"vm.tag.svg == \'pin\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                      fill: #c0f2cd;\n                    }\n\n                    .st1 {\n                      fill: #ffffff;\n                    }\n\n                    .st2 {\n                      fill: #f1fbf4;\n                    }\n\n                    .st3 {\n                      fill: #c0f2cd;\n                    }\n\n                    .st4 {\n                      fill: #00bf6f;\n                    }</style><g><path class=st0 d=\"M251.7,496.9c3,4.1,7.7,6.6,12.8,6.6s9.8-2.4,12.8-6.6C317,443.7,435.2,290.1,435.2,190\n                        c0-121.7-76.5-181.5-170.7-181.5S93.9,68.3,93.9,190C93.9,290.1,212.1,443.7,251.7,496.9z\"/><path class=st1 d=\"M238.9,496.9c6.2,8.7,6,8.7,12.2,0c37.7-53.2,150-206.8,150-306.9c0-121.7-72.6-181.5-162.1-181.5\n                        S76.8,68.3,76.8,190C76.8,290.1,201.2,443.7,238.9,496.9z\"/><path class=st2 d=\"M244.5,496.9c2.4,4.1,6.8,6.6,11.5,6.6c4.7,0,9.1-2.5,11.5-6.6c35.7-53.2,142.1-206.8,142.1-306.9\n                        C409.6,68.3,340.8,8.5,256,8.5S102.4,68.3,102.4,190C102.4,290.1,208.8,443.7,244.5,496.9z\"/><circle class=st3 cx=256 cy=187.7 r=128 /><path class=st2 d=\"M316.4,144.1l-0.7,0.9v102.4c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5v-33.1\n                        c0.2-8.6-5.7-16.1-14.2-17.8c-5-0.8-10,0.5-13.9,3.8s-6.1,8-6.1,13v34.1c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5V145.1\n                        l-3.2-5.2l57.3-35.2c3.3-2.9,8.2-2.9,11.4,0L316.4,144.1z\"/><g><path class=st4 d=\"M256,324.3c-75.4,0-136.5-61.1-136.5-136.5S180.6,51.2,256,51.2s136.5,61.1,136.5,136.5\n                          C392.4,263.1,331.4,324.2,256,324.3z M256,68.3c-66,0-119.5,53.5-119.5,119.5S190,307.2,256,307.2s119.5-53.5,119.5-119.5\n                          C375.4,121.8,321.9,68.3,256,68.3z\"/><path class=st4 d=\"M307.2,264.5h-25.6c-9.4,0-17.1-7.6-17.1-17.1v-33.1c0.2-4.4-2.8-8.3-7-9.4c-2.5-0.4-5,0.3-7,1.9\n                          s-3.1,4-3.1,6.5v34.1c0,9.4-7.6,17.1-17.1,17.1h-25.6c-9.4,0-17.1-7.6-17.1-17.1V145.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5\n                          v102.4h25.6v-34.1c0-7.5,3.3-14.7,9.1-19.6s13.4-6.9,20.8-5.7c12.5,2.5,21.4,13.5,21.3,26.3v33.1h25.6V145.1\n                          c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v102.4C324.3,256.9,316.6,264.5,307.2,264.5z\"/><path class=st4 d=\"M341.3,170.7c-1.8,0-3.5-0.6-5-1.6l-79.6-57.6c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4,0.3-0.8,0.6-1.3,0.9l-79.6,49\n                          c-2.6,1.6-5.8,1.7-8.5,0.2c-2.7-1.4-4.4-4.2-4.5-7.3s1.5-5.9,4.1-7.5l79.1-48.7c6.4-5.1,15.5-5,21.8,0.2l79.3,57.3\n                          c3,2.2,4.3,6,3.1,9.5C348.3,168.3,345,170.7,341.3,170.7L341.3,170.7z\"/><path class=st4 d=\"M256,512c-7.9,0-15.3-3.6-20.2-9.8l-5.4-6.8C189.1,442.7,92.2,319.5,72,223.6c-0.6-3,0.4-6.1,2.6-8.1\n                          c2.3-2,5.5-2.7,8.4-1.8c2.9,1,5.1,3.4,5.7,6.4c19.3,92,114.5,213,155.1,264.7l5.4,6.8c1.7,2,4.2,3.2,6.8,3.2s5.1-1.2,6.8-3.2\n                          l5.5-7c43.3-55.1,158.4-201.5,158.4-294.6c0-127.5-88.2-173-170.7-173c-92.4,0-155.3,51.5-168.1,137.8c-0.4,3-2.5,5.6-5.3,6.7\n                          c-2.8,1.1-6.1,0.6-8.4-1.3c-2.4-1.9-3.6-4.9-3.1-7.9C85,58.4,155.9,0,256,0c114,0,187.7,74.6,187.7,190\n                          c0,99-113.6,243.4-162,305.1l-5.5,7C271.4,508.4,263.9,512,256,512L256,512z\"/><circle class=st4 cx=76.8 cy=187.7 r=8.5 /></g></g></svg> <svg ng-if=\"vm.tag.svg == \'mudanca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                      fill: #9de8eb;\n                    }\n\n                    .st1 {\n                      fill: #a2fcf3;\n                    }\n\n                    .st2 {\n                      fill: #e8f9fc;\n                    }\n\n                    .st3 {\n                      fill: #ffffff;\n                    }\n\n                    .st4 {\n                      fill: #2fbaba;\n                    }</style><g><path id=Shape_1_ class=st0 d=\"M200.2,409.6c-7.4,0-13.9-4.8-16.2-11.8L70.6,49.7l-16.4,8.2c-8.4,4.2-18.7,0.8-22.9-7.6\n                        s-0.8-18.7,7.6-22.9l34.1-17.1c4.4-2.2,9.6-2.4,14.2-0.5s8.1,5.7,9.7,10.5l114,350.3l248-88c8.9-3.2,18.6,1.5,21.8,10.4\n                        c3.2,8.9-1.5,18.6-10.4,21.8l-264.5,93.9C204,409.2,202.1,409.6,200.2,409.6z\"/><path class=st0 d=\"M285.5,452.2c0,28.3-22.9,51.2-51.2,51.2c-5.2,0-10.4-0.8-15.4-2.3c-21.3-6.8-35.8-26.6-35.8-48.9\n                        c0-22.4,14.5-42.2,35.8-48.9c5-1.5,10.2-2.2,15.4-2.3C262.6,401,285.5,424,285.5,452.2z\"/><ellipse id=Oval class=st1 cx=219 cy=452.2 rx=35.8 ry=48.9 /><circle class=st0 cx=234.3 cy=452.2 r=17.1 /><path id=Rectangle-path_1_ class=st1 d=\"M203.8,192l161-56.5c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9\n                        l-161,56.5c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C197,198.5,199.3,193.6,203.8,192z\"/><path class=st2 d=\"M203.4,192.2l139.3-48.9c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9L260,353.2\n                        c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C196.7,198.6,199,193.7,203.4,192.2z\"/><path class=st0 d=\"M315.6,215.8l-8.8-2.3c-3.3-0.9-6.9,0.4-8.9,3.1l-5.5,7.3c-1.9,2.5-5,3.8-8.1,3.3c-3.1-0.5-5.7-2.6-6.7-5.6\n                        l-17.3-49.4l48.3-17l17.3,49.4c1,3,0.4,6.3-1.8,8.6C321.9,215.6,318.7,216.5,315.6,215.8z\"/><path class=st1 d=\"M189.1,75.9l102.6-36c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9l-102.6,36\n                        c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C182.3,82.4,184.6,77.5,189.1,75.9z\"/><path class=st2 d=\"M188.1,76.3l78.1-27.4c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9L226,184.2\n                        c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C181.3,82.7,183.6,77.8,188.1,76.3z\"/><path class=st0 d=\"M264,93.5l-9.5-2.4c-1.7-0.4-3.4,0.2-4.5,1.6l-5.9,7.8c-0.9,1.3-2.5,1.9-4.1,1.6c-1.6-0.2-2.8-1.3-3.4-2.8\n                        l-12.5-35.7l32.4-11.4l12.5,35.7c0.5,1.5,0.2,3.2-0.9,4.3C267.2,93.4,265.5,93.9,264,93.5z\"/><path class=st3 d=\"M54.2,57.9l6.1-3.1c-4-3.8-5.9-9.4-5.1-14.8c0.8-5.5,4.3-10.2,9.3-12.6l28-14c-5.1-5.1-13-6.4-19.5-3.1\n                        L38.9,27.4c-8.4,4.2-11.8,14.5-7.6,22.9S45.8,62.1,54.2,57.9z\"/><path class=st3 d=\"M73.8,59.6L184,397.8c1.4,4.4,4.6,8,8.7,10c4.1,2,8.9,2.3,13.2,0.8l4.5-1.6c-23,12.1-33.2,39.5-23.8,63.7\n                        c9.4,24.2,35.5,37.5,60.6,31c-20.4-5.3-35.5-22.6-38-43.5s8.2-41.3,26.8-51.2l-4.5,1.6c-4.3,1.5-9.1,1.3-13.2-0.8\n                        c-4.1-2-7.3-5.7-8.7-10L96.2,49.7l-16.4,8.2C77.9,58.8,75.9,59.4,73.8,59.6z\"/><polygon class=st3 points=\"78.7,47 113.1,152.5 192.1,395.1 175.8,400.4 96.8,157.8 62.5,52.3 	\"/><g><path class=st4 d=\"M99.4,118.5c2.1-4.2,0.4-9.3-3.7-11.5l-1.5-0.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.5-0.1-1.1-0.1-1.6,0\n                          c-0.6,0.1-1.1,0.2-1.7,0.4c-2.1,0.7-3.9,2.2-5,4.2c-2,4.2-0.4,9.3,3.7,11.5c1,0.5,2.1,0.8,3.2,0.9c1.1,0.1,2.2,0,3.3-0.4\n                          C96.5,122,98.3,120.5,99.4,118.5z\"/><path class=st4 d=\"M38.5,66.9c6.4,2.2,13.5,1.7,19.5-1.4l7.5-3.8l7.5,23c1.6,4.3,6.3,6.6,10.6,5.1c4.4-1.4,6.8-6,5.6-10.4\n                          L78.7,47.1l-0.2,0.1c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-4.2-7.2-5.9-11.4-3.9l-16.4,8.3c-4.2,2.1-9.4,0.4-11.5-3.8\n                          c-2.1-4.2-0.4-9.4,3.8-11.5L76.8,18c2.2-1.1,4.8-1.2,7.1-0.2c2.3,1,4.1,2.9,4.8,5.2l114.1,350.2c0.7,2.2,2.3,4,4.3,5\n                          c2.1,1,4.5,1.2,6.6,0.4l248-88c3.3-1.1,6.9-0.2,9.2,2.3c2.3,2.6,2.8,6.3,1.4,9.4c-1,2-2.7,3.6-4.8,4.4l-245.3,87\n                          c-5.2,1.1-10.2,2.9-15,5.3l-4.3,1.5c-2.2,0.8-4.6,0.6-6.6-0.4c-2.1-1-3.6-2.8-4.3-5l-81.6-250.7c-0.8-3-3.3-5.3-6.3-6\n                          c-3.1-0.7-6.2,0.3-8.3,2.7c-2.1,2.4-2.7,5.7-1.6,8.6l81.6,250.7c2,6.1,6.3,11.3,11.9,14.4c-16,19.8-17.6,47.5-4.2,69.1\n                          c13.5,21.6,39.1,32.3,63.9,26.6c24.8-5.6,43.3-26.3,46.1-51.6c2.8-25.3-10.7-49.6-33.6-60.5l213.2-75.7\n                          c8.9-2.8,15.5-10.3,17.3-19.5c1.8-9.2-1.5-18.6-8.7-24.6c-7.2-6-17-7.6-25.7-4.2l-22.7,8l-54-153.8c-0.8-2.1-2.3-3.9-4.4-4.9\n                          s-4.4-1.1-6.5-0.4l-26,9.1L307.2,31.8c-0.8-2.1-2.3-3.9-4.4-4.9s-4.4-1.1-6.5-0.4l-43.2,15.2l-32.4,11.4l-43.2,15.2\n                          c-2.1,0.8-3.9,2.3-4.9,4.4c-1,2-1.1,4.4-0.4,6.5L207.7,180l-16.3,5.7c-4.4,1.6-6.8,6.4-5.2,10.9L240.5,351l-24.1,8.5L105,17.6\n                          c-2.3-7.1-7.6-12.8-14.5-15.7S75.9-0.7,69.3,2.7L35.1,19.7C25.9,24.4,20.3,34.1,21,44.4S28.7,63.6,38.5,66.9z M234.3,409.6\n                          c21.9-0.3,40.6,15.9,43.4,37.7c2.8,21.8-11.1,42.2-32.4,47.5s-43.2-6.1-50.9-26.6c-7.8-20.5,1.1-43.6,20.6-53.7l11.4-4\n                          C229,409.8,231.6,409.6,234.3,409.6z M301.8,165l14.5,41.3l-14.4-3.7c-3.3-0.9-6.9,0.4-8.9,3.1l-8.9,11.8l-14.5-41.3l16.1-5.7\n                          L301.8,165z M257.8,80.8l-4.5-1.2c-3.3-0.9-6.9,0.4-8.9,3.1l-2.8,3.7l-7-20.1l8.1-2.9l8.1-2.9L257.8,80.8z M218.3,72l12.3,35.1\n                          c1,3,3.6,5.1,6.7,5.6c0.4,0.1,0.9,0.1,1.3,0.1c2.7,0,5.2-1.3,6.8-3.4l9-11.9l14.5,3.7c3,0.8,6.3-0.2,8.4-2.5\n                          c2.1-2.3,2.8-5.6,1.8-8.6L266.8,55l27.1-9.5l32.2,91.8l-102.6,36l-32.2-91.8L218.3,72z M253.5,182l19.8,56.4c1,3,3.6,5.1,6.7,5.6\n                          c3.1,0.5,6.2-0.8,8.1-3.3l15.1-20l24.3,6.2c3,0.8,6.3-0.2,8.4-2.5c2.1-2.3,2.8-5.6,1.8-8.6l-19.8-56.3l48.3-17l50.9,144.9\n                          l-161,56.5L205.2,199L253.5,182z\"/><path class=st4 d=\"M208.7,452.2c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6c0-14.1-11.5-25.6-25.6-25.6\n                          C220.2,426.6,208.7,438.1,208.7,452.2z M234.3,443.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5\n                          S229.6,443.7,234.3,443.7z\"/></g></g></svg> <svg ng-if=\"vm.tag.svg == \'busca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                      fill: #a2fcf3;\n                    }\n\n                    .st1 {\n                      fill: #e8f9fc;\n                    }\n\n                    .st2 {\n                      fill: #808e87;\n                    }\n\n                    .st3 {\n                      fill: url(#SVGID_1_);\n                    }\n\n                    .st4 {\n                      fill: #f26546;\n                    }\n\n                    .st5 {\n                      fill: #9de8eb;\n                    }\n\n                    .st6 {\n                      fill: #ffffff;\n                    }\n\n                    .st7 {\n                      fill: #2fbaba;\n                    }</style><g><path id=Shape class=st0 d=\"M458.8,399.6l-59.1,59l-0.3,0.3l-0.1-0.1h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l36.1-36.1\n                        l11.4-11.4c3.3-3.3,8.6-3.3,11.8,0L458.8,399.6z\"/><path class=st0 d=\"M486.9,487.1c-2.1,2.1-4.4,4-7,5.6c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l0.3-0.3l59.1-59l28.1,28.1\n                        C503.3,444.1,503.3,470.7,486.9,487.1z\"/><path class=st1 d=\"M436.9,420.5l-37.5,38.3h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l26.9-27.7c3.3-2.2,7.7-1.7,10.6,1.1\n                        L436.9,420.5z\"/><path class=st1 d=M480,492.7c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l38.1-38.1l28,28.1C479.8,463.2,490.5,476.4,480,492.7z /><rect id=Rectangle-path x=342.9 y=329.6 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -152.5583 368.0898)\" class=st0 width=50.3 height=77.3 /><rect x=346.4 y=338 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -160.953 364.6137)\" class=st1 width=26.6 height=77.3 /><path class=st0 d=\"M341.9,342.1c-75.8,72.7-195.9,71.5-270.2-2.8S-3.8,144.9,68.9,69.1c75.8-72.7,195.9-71.5,270.2,2.8\n                        S414.6,266.2,341.9,342.1z\"/><path class=st1 d=\"M316.7,342.1c-33,33.2-77.1,53.2-123.9,56.1c-75.6-4.9-141.4-53.6-168.1-124.6S15.3,122.7,68.9,69.1\n                        c33-33.2,77.1-53.2,123.9-56.1c75.6,4.9,141.4,53.6,168.1,124.6S370.3,288.5,316.7,342.1z\"/><path class=st2 d=\"M205.4,373.4c-67.9,0-129.1-40.9-155.1-103.6s-11.6-134.9,36.4-183c65.6-65.6,171.9-65.6,237.4,0\n                        s65.6,171.9,0,237.4C292.7,355.9,250,373.6,205.4,373.4z\"/><linearGradient id=SVGID_1_ gradientUnits=userSpaceOnUse x1=-700.6567 y1=795.9537 x2=-699.9529 y2=795.2502 gradientTransform=\"matrix(320.5412 0 0 -320.6926 224681.9375 255349.2344)\"><stop offset=0 style=\"stop-color: #d4f3f3\"/><stop offset=0.172 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #dbf1f3\"/><stop offset=0.201 style=\"stop-color: #ebedf3\"/><stop offset=0.201 style=\"stop-color: #f7f0f7\"/><stop offset=0.202 style=\"stop-color: #f1e6ec\"/><stop offset=0.205 style=\"stop-color: #fff2f7\"/><stop offset=0.252 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #d4f3f3\"/><stop offset=0.397 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #dbf1f3\"/><stop offset=0.421 style=\"stop-color: #ebedf3\"/><stop offset=0.421 style=\"stop-color: #f7f0f7\"/><stop offset=0.422 style=\"stop-color: #f1e6ec\"/><stop offset=0.425 style=\"stop-color: #fff2f7\"/><stop offset=0.489 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #f8f0f7\"/><stop offset=0.5 style=\"stop-color: #e8eef3\"/><stop offset=0.5 style=\"stop-color: #ddf1f3\"/><stop offset=0.5 style=\"stop-color: #d6f2f3\"/><stop offset=0.501 style=\"stop-color: #d4f3f3\"/><stop offset=0.706 style=\"stop-color: #d4f3f3\"/><stop offset=0.74 style=\"stop-color: #d4f3f3\"/><stop offset=0.741 style=\"stop-color: #fff2f7\"/><stop offset=0.835 style=\"stop-color: #fff2f7\"/><stop offset=0.85 style=\"stop-color: #fff2f7\"/><stop offset=0.851 style=\"stop-color: #d4f3f3\"/></linearGradient><path class=st3 d=\"M318.2,318.4c-62.3,62.2-163.3,62.2-225.6,0c-1.1-1.1-2.2-2.3-3.3-3.4c-39.7-40.9-54.5-99.8-39-154.7\n                        s59.2-97.2,114.4-111.1s113.7,2.7,153.4,43.6c17.8,17.8,31.1,39.5,38.8,63.5C375.5,213.3,360.6,275.9,318.2,318.4z\"/><path class=st4 d=M138.3,183.2l69.3-60.3l65,60.3v98c0,4.6-3.8,8.4-8.4,8.4H146.7c-4.6,0-8.4-3.8-8.4-8.4V183.2z /><path class=st1 d=M146.7,171.7l60.7-66.8l56.8,66.8v108.6c0.5,4.6-2.8,8.7-7.3,9.3H154c-4.6-0.6-7.8-4.7-7.3-9.3V171.7z /><path class=st5 d=\"M293.1,196.9l-83-55.3c-2.8-1.9-6.5-1.9-9.3,0l-83,55.3c-2.6,1.7-5.9,1.9-8.6,0.4c-2.7-1.5-4.4-4.3-4.4-7.4\n                        v-21.8c0-2.8,1.4-5.4,3.7-7l92.3-61.5c2.8-1.9,6.5-1.9,9.3,0l92.3,61.5c2.3,1.6,3.7,4.2,3.7,7v21.8c0,3.1-1.7,5.9-4.4,7.4\n                        C299,198.8,295.7,198.6,293.1,196.9z\"/><path class=st5 d=M188.6,222.4h33.6c4.6,0,8.4,3.8,8.4,8.4v58.8h-50.4v-58.8C180.2,226.1,184,222.4,188.6,222.4z /><path class=st6 d=\"M192.8,398.1c8.4,0.5,16.7,0.5,25.1,0c-75.6-4.9-141.3-53.7-168-124.6S40.5,122.7,94.1,69.1\n                        c33-33.2,77.1-53.1,123.8-56.1C111.6,6.1,19.8,86.7,12.8,193S86.5,391.2,192.8,398.1z\"/><path class=st6 d=\"M74.9,75c-12.2,12.5-22.7,26.5-31.2,41.7c-8.4,15.2-14.6,31.6-18.3,48.6c-6.7,30.3-5.8,61.9,2.7,91.8\n                        c8.9,29.8,24.9,56.9,46.7,79.1L63,348c-23.8-24.1-41.3-53.8-51-86.3c-9.3-32.6-10.3-67-3-100.1c4.1-18.6,10.8-36.4,20-53.1\n                        C38.3,92,49.7,76.7,63,63.1L74.9,75z\"/><path class=st7 d=\"M86.7,324.3c65.6,65.6,171.8,65.6,237.4,0c65.6-65.6,65.6-171.8,0-237.4c-42.4-42.4-104.2-59-162.2-43.5\n                        S58.8,104.2,43.3,162.1S44.3,281.9,86.7,324.3z M98.6,98.7c59-59,154.7-59,213.7,0s59,154.7,0,213.7s-154.7,59-213.7,0\n                        C70,284.2,53.9,245.7,53.9,205.6S70,126.9,98.6,98.7z\"/><path class=st7 d=\"M436.9,365.8c-6.6-6.6-17.2-6.6-23.7,0l-43.7-43.6c60.8-85.3,46-203-34-270.6S137-11.1,63,63.1l-11.7,13\n                        c-3.9,4.3-7.1,9.3-10.6,13.9c-1.4,1.8-2,4.1-1.6,6.4c0.4,2.2,1.7,4.2,3.7,5.4c3.8,2.3,8.8,1.4,11.6-2.1c3.3-4.2,6.1-8.8,9.7-12.8\n                        L74.8,75C147,2.9,263.9,2.9,336,75s72.1,189,0,261.1s-189,72.1-261.1,0C53,314,37,286.9,28.1,257.1c-8.5-29.9-9.5-61.5-2.7-91.8\n                        l1.9-7.8c1-4.4-1.5-8.8-5.8-10.2c-2.2-0.7-4.5-0.5-6.5,0.6c-2,1.1-3.4,3-3.9,5.2L9,161.7c-7.4,33.1-6.3,67.5,3,100.1\n                        c9.7,32.5,27.2,62.1,51,86.3c69.5,69.5,179,78.6,259,21.6l43.6,43.7c-6.6,6.6-6.6,17.2,0,23.7l56,56c12.7,12.9,31.3,18,48.8,13.4\n                        c17.5-4.6,31.1-18.3,35.8-35.8c4.6-17.5-0.5-36.1-13.4-48.8L436.9,365.8z M377.5,401.4l-42.1-42.1c4.2-3.6,8.5-7.3,12.5-11.3\n                        c4-4,7.7-8.2,11.3-12.5l42.2,42.1l-11.9,11.9L377.5,401.4z M425,377.7l21.9,21.9l-47.5,47.4l-21.9-21.9L425,377.7z M481,481.1\n                        c-13.3,12.7-34.2,12.7-47.5,0l-22.2-22.2l47.5-47.4l22.2,22.1c6.3,6.3,9.8,14.8,9.8,23.7S487.3,474.8,481,481.1z\"/><path class=st7 d=\"M100.7,213c2.7,1.5,6,1.3,8.6-0.4l20.5-13.7v82.3c0,9.3,7.5,16.8,16.8,16.8h117.5c9.3,0,16.8-7.5,16.8-16.8\n                        v-82.3l20.5,13.7c2.6,1.7,5.9,1.9,8.6,0.4c2.7-1.5,4.4-4.3,4.4-7.4v-42c0-2.8-1.4-5.4-3.7-7L210.1,89.5c-2.8-1.9-6.5-1.9-9.3,0\n                        L100,156.6c-2.3,1.6-3.7,4.2-3.7,7v42C96.3,208.7,98,211.5,100.7,213z M188.6,281.1v-50.4h33.6v50.4H188.6z M264.2,281.1H239v-50.4\n                        c0-9.3-7.5-16.8-16.8-16.8h-33.6c-9.3,0-16.8,7.5-16.8,16.8v50.4h-25.2v-93.4l58.8-39.2l58.8,39.2V281.1z M113.1,168.1l92.3-61.6\n                        l92.3,61.5v21.8l-87.7-58.5c-2.8-1.9-6.5-1.9-9.3,0l-87.7,58.4V168.1z\"/></g></svg></div><div class=\"body-tag d-flex flex-wrap flex-column justify-content-center\"><h4 class=title-tag>{{ vm.tag.text }}</h4><span class=desc-tag>{{ vm.tag.description }}</span></div></div></div></header><article class=\"main mt-5\"><div class=\"d-flex flex-column row\"><carousel-imovel class=\"infos carousel-imovel\" ng-if=vm.listing.imoveis.length imoveis=vm.listing.imoveis properties=vm.owlPropertiesGaleria navegator=true title-carousel=\"Unidades Disponíveis\"></carousel-imovel><section class=infos><h2 id=title-all-infos class=title>Informações Gerais</h2><div ng-class=\"{\n                  \'readmore-description\': !vm.readMore,\n                  \'readlite-description\': vm.readMore\n                }\"><p class=description itemprop=description>{{ vm.listing.imv_obs }}</p></div><span class=btn-read-more ng-click=vm.readMoreFunc() aria-label=\"Ver Mais\">Ver {{ !vm.readMore ? \'mais\' : \'menos\' }}</span></section><section class=infos ng-show=\"vm.listing.comodidades.length && !vm.comodidadeEmp\"><h2 class=title>Detalhes do imóvel</h2><ul class=comodidades><li class=\"col-12 col-sm-4 d-inline-block pl-0\" itemprop=amenityFeature ng-repeat=\"c in vm.listing.comodidades | orderBy:\'comodidade.cmd_nome\'\" ng-show=\"c.cmd_id && !c.gcmd_isemp\"><i class=\"{{ c.comodidade.cmd_icone ? c.comodidade.cmd_icone : \'fal fa-angle-right\' }}\"></i> &nbsp{{ c.comodidade.cmd_nome }}</li></ul></section><section class=infos ng-show=vm.comodidadeEmp><h2 class=title>Detalhes do Condomínio</h2><ul class=comodidades><li class=\"col-12 col-sm-4 d-inline-block pl-0\" itemprop=amenityFeature ng-repeat=\"c in vm.listing.comodidades | orderBy:\'comodidade.cmd_nome\'\" ng-show=\"c.cmd_id && c.gcmd_isemp\"><i class=\"{{ c.comodidade.cmd_icone ? c.comodidade.cmd_icone : \'fal fa-angle-right\' }}\"></i> &nbsp{{ c.comodidade.cmd_nome }}</li></ul></section><section class=\"infos col-12 p-0\" ng-if=vm.galeriaLen.length><div class=\"col-12 p-0 headers-images\" ng-repeat=\"(key, tipo) in vm.tipoFotos\"><h2 class=title style=\"margin-bottom: 10px\">{{ key }}</h2><div class=\"header-galeria d-flex justify-content-between align-items-center p-0\" style=\"margin-bottom: 10px\"><span>&nbsp;</span><div class=\"btn-box col-sm-6 carousel-options d-none d-sm-flex justify-content-sm-end owl-nav\" ng-if=vm.checknavGaleria(tipo)><button class=\"btn button btn-carousel change-carousel d-none d-md-block prev-img owl-prev\" style=\"border-radius: 0.25rem 0 0 0.25rem\" ng-click=vm.galeriaprevOwl($index)><i class=\"fal fa-chevron-left\"></i></button> <button class=\"btn button btn-carousel change-carousel d-none d-md-block next-img owl-next\" style=\"border-radius: 0 0.25rem 0.25rem 0\" ng-click=vm.galerianextOwl($index)><i class=\"fal fa-chevron-right\"></i></button></div></div><ng-owl-carousel id=\"carousel-{{ $index }}\" class=\"carousel-imovel owl-theme galeria\" owl-items=tipo owl-properties=vm.owlPropertiesGaleria owl-ready=vm.readyLocacao($api)><div ng-repeat=\"foto in tipo\" class=image-box data-src=\"{{ vm.setURLPhoto(foto) }}\" data-src-error=\"{{\n                      vm.createThumb.removeWmk(foto.imvft_url)\n                    }}\"><img itemprop=photo alt=\"{{\n                        (foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto\') +\n                          \' do \' +\n                          vm.listing.tipo_imovel.timv_nome\n                      }} - {{ vm.listing.imv_titulo }} | {{\n                        vm.config_wl.nome\n                      }}\" data-src=\"{{ foto.imvft_url }}\" class=\"d-block owl-lazy\" on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}}></div></ng-owl-carousel></div></section><section class=\"infos col-12 p-0\" ng-if=vm.listing.plantas.length><h2 class=title>Plantas</h2><div class=\"col-12 headers-images p-0\" ng-repeat=\"(key, tipo) in vm.fotosPlantas\"><div class=\"header-galeria d-flex justify-content-between align-items-center\"><div class=\"nav-galeria d-flex justify-content-end align-items-center\" ng-if=vm.checknavGaleria(vm.listing.plantas)><button class=\"carousel-direction prev-carousel d-flex justify-content-center align-items-center\" ng-click=\"vm.galeriaprevOwl(\'plantas-\'+ $index)\"><i class=\"fal fa-chevron-left\"></i></button> <button class=\"carousel-direction next-carousel d-flex justify-content-center align-items-center\" ng-click=\"vm.galerianextOwl(\'plantas-\'+ $index)\"><i class=\"fal fa-chevron-right\"></i></button></div></div><ng-owl-carousel id=\"carousel-plantas-{{ $index }}\" class=\"carousel-imovel owl-theme galeria\" owl-items=tipo owl-properties=vm.owlPropertiesGaleria owl-ready=vm.readyLocacao($api)><div ng-repeat=\"foto in vm.listing.plantas\" data-src=\"{{ vm.setURLPhotoPlantas(foto) }}\" data-src-error=\"{{\n                      vm.createThumb.removeWmk(foto.imvpl_foto_planta)\n                    }}\"><div class=row><div class=tag-top>{{ foto.imvpl_titulo || \'Planta\' }}</div></div><div data-src=\"{{ vm.setURLPhotoPlantas(foto) }}\" data-src-error=\"{{\n                        vm.createThumb.removeWmk(foto.imvpl_foto_planta)\n                      }}\" class=image-box><img itemprop=photo alt=\"{{\n                          (foto.tipo_foto\n                            ? foto.tipo_foto.tfoto_nome\n                            : \'Foto\') +\n                            \' do \' +\n                            vm.listing.tipo_imovel.timv_nome\n                        }} - {{ vm.listing.imv_titulo }} | {{\n                          vm.config_wl.nome\n                        }}\" data-src=\"{{\n                          vm.createThumb.singleThumbUrl(foto.imvpl_foto_planta)\n                        }}\" class=\"d-block owl-lazy\" on-error-src={{vm.createThumb.removeWmk(foto.imvpl_foto_planta)}}></div></div></ng-owl-carousel></div><div class=\"plantas d-flex flex-column justify-content-center justify-content-lg-start flex-wrap\" ng-repeat=\"item in vm.listing.plantas\"><div class=subtitle>{{ item.imvpl_titulo }}</div><div class=\"comodidades items d-flex justify-content-center justify-content-lg-start flex-wrap\"><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Área total</span> <span class=data>{{ item.imvpl_area_total || \'-\' }} <span>m <sup>2</sup></span></span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Área util</span> <span class=data>{{ item.imvpl_area_util || \'-\' }} <span>m <sup>2</sup></span></span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Vaga</span> <span class=data>{{ item.imvpl_qtd_vagas || \'-\' }}</span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Dormitório</span> <span class=data>{{ item.imvpl_qtd_dorm || \'-\' }}</span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Suíte</span> <span class=data>{{ item.imvpl_qtd_suite || \'-\' }}</span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Sala</span> <span class=data>{{ item.imvpl_qtd_sala || \'-\' }}</span></div><div class=\"comodidade d-flex flex-column justify-content-center align-items-center pr-3 mt-2\"><span class=label>Banheiros</span> <span class=data>{{ item.imvpl_qtd_banheiros || \'-\' }}</span></div></div><div class=\"comodidade d-flex flex-column pr-3 mt-4\" ng-if=item.imvpl_obs><span class=\"label d-block mb-2\">Observações</span> <span class=data>{{ item.imvpl_obs || \'-\' }}</span></div></div></section><section class=infos ng-show=vm.config_wl.isArbo><h2 class=title><a ui-sref=\"main.imobiliariaPage({imobRoute: vm.generateImobLink()})\">{{ vm.listing.imobiliaria.imb_nome }}</a></h2><div class=\"d-flex flex-column flex-lg-row\"><div class=\"col-12 col-lg pl-0\"><p class=m-0>Temos paixão por imóveis e por transformar a vida das pessoas! Procuramos levar o melhor atendimento e as melhores opções de imóvel para cada um dos nossos clientes.</p><p class=m-0>A {{ vm.listing.imobiliaria.imb_nome }} está localizada em {{ vm.listing.imobiliaria.cidade.nome }} com as melhores opções para {{ vm.listing.imobiliaria.imb_config_site && vm.listing.imobiliaria.imb_config_site.tipo_imob && vm.listing.imobiliaria.imb_config_site.tipo_imob != 3 ? vm.listing.imobiliaria.imb_config_site.tipo_imob == 2 ? \'locação\' : \'venda\' : \'venda e locação\' }} da região!</p></div><div class=\"d-none d-lg-flex logo-imb\" ng-if=vm.listing.imobiliaria.imb_url_logo><img class=w-100 ng-src=\"{{ vm.listing.imobiliaria.imb_url_logo }}\" alt=\"Logo da imobiliária {{\n                      vm.listing.imobiliaria.imb_nome\n                    }}\" title=\"Logo da imobiliária {{\n                      vm.listing.imobiliaria.imb_nome\n                    }}\"></div></div></section></div></article></section></div><div class=\"d-none d-lg-block col-lg-4\" ng-if=!vm.mobile><section class=\"call-action prices d-block\"><div class=card><div class=offers><ul itemprop=offers itemscope itemtype=http://schema.org/Offer><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_venda><div ng-if=\"vm.listing.timv_id != 36\">Venda</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio de venda</div><div class=text-right itemprop=price>R$ {{ vm.formatPrice(vm.listing.imv_preco_venda) }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_locacao><div ng-if=\"vm.listing.timv_id != 36\">Aluguel</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio do Aluguel</div><div class=text-right itemprop=price>R$ {{ vm.formatPrice(vm.listing.imv_preco_locacao) }} <span ng-switch=vm.listing.tplc_id><span class=txt-tplc ng-switch-when=2>por dia</span> <span class=txt-tplc ng-switch-when=5>por semana</span> <span class=txt-tplc ng-switch-when=3>por mês</span> <span class=txt-tplc ng-switch-when=4>por ano</span></span><meta itemprop=priceCurrency content=BRL></div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_cond><div>Condominio</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_cond) }}</div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_iptu><div>IPTU mensal</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_iptu) }}</div></li><li class=\"d-flex justify-content-between\" ng-if=vm.listing.imv_preco_seguro><div>Seguro incêndio</div><div class=text-right>R$ {{ vm.formatPrice(vm.listing.imv_preco_seguro) }}</div></li></ul></div></div></section><section class=\"call-action form d-block\"><div class=card><form action=\"\" name=formagendamento class=\"form p-0 m-1\" ng-submit=vm.submit($event) ng-if=vm.contato><h4 class=title>Entrar em contato</h4><div class=\"row d-flex contact-header\"><div class=\"col-12 p-0\"><div class=form-group><div class=\"row mb-3\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form.cliente required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Nome</label></div><div class=\"row mb-3\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form.telefone data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required pattern=\"\\([0-9]{2}\\) [9]?[0-9]{4}-[0-9]{4}$\" placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-3\"><input type=email id=email class=\"form-control upper\" ng-model=vm.form.email required placeholder=email@dominio.com><label for=email class=\"pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.card_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div></div><div class=btns-action><button type=submit class=\"btn active\" ng-disabled=\"vm.loading || (vm.config_wl.isArbo && !vm.form.card_accept_terms)\"><span ng-if=!vm.loading>Enviar</span> <span ng-if=vm.loading ng-bind-html=\"(vm.msg_submit ? vm.msg_submit : vm.spinner)\" class=font-weight-bold></span></button></div></div></div></form><div ng-if=!vm.contato><div ng-if=\"vm.message && !vm.error_submit\"><div class=message ng-bind-html=vm.message></div></div><form action=\"\" name=formagendamento class=\"form p-0 m-1\" ng-submit=vm.submit($event) ng-if=\"!vm.finished && !vm.succ\"><div ng-if=!vm.succ><h4 class=title>Entrar em contato</h4></div><div class=\"row d-flex contact-header\"><div class=\"col-12 p-0\"><div class=form-group><div ng-if=!vm.succ><div class=\"row mb-3\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form.cliente required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Nome</label></div><div class=\"row mb-3\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form.telefone data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required pattern=\"\\([0-9]{2}\\) [9]?[0-9]{4}-[0-9]{4}$\" placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-3\"><input type=text id=email class=\"form-control upper\" ng-model=vm.form.email required placeholder=email@dominio.com><label for=email class=\"pl-3 upper\">E-mail</label></div><div class=\"row mb-3 position-relative\"><div class=\"row col-8 pl-0\"><input type=date id=date class=\"form-control upper\" ng-model=vm.form.visita_data min=\"{{ vm.today }}\" max=9999-12-31 required><label for=date class=\"pl-3 upper\">Data</label></div><div class=\"row col-4 p-0\"><input type=time id=time class=\"form-control upper\" ng-model=vm.form.visita_hora required><label for=time class=\"pl-3 upper\">Hora</label></div><i class=\"fas fa-times position-absolute\" style=\"right: -1.75rem; top: 17px; font-size: 1rem\" ng-click=vm.goToAgendar(1)></i></div><div class=\"d-flex col-12 px-0\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.card_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div></div></div><div class=btns-action><button type=submit class=\"btn active\" ng-disabled=\"vm.loading || (vm.config_wl.isArbo && !vm.form.card_accept_terms)\"><span ng-if=!vm.loading>Enviar</span> <span ng-if=vm.loading ng-bind-html=\"(vm.msg_submit ? vm.msg_submit : vm.spinner)\" class=font-weight-bold></span></button></div></div></div></form></div><div class=btns-action ng-if=vm.contato><button class=btn aria-label=\"Agendar visita\" ng-click=vm.goToAgendar(2)>Agendar visita</button> <button class=btn ng-click=vm.gotoProp(vm.listing.tpng_id) ng-show=!vm.showPropbtn aria-label=\"fazer proposta\">Fazer proposta</button></div><div class=\"tag-msg d-flex justify-content-around\" ng-if=\"vm.tag.hidden && vm.contato\"><div class=\"body d-flex flex-wrap flex-column justify-content-center\"><span class=title-tag>{{ vm.tag.textca }}</span></div><div class=image-tag><svg ng-if=\"vm.tag.svg == \'pin\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                    fill: #c0f2cd;\n                  }\n\n                  .st1 {\n                    fill: #ffffff;\n                  }\n\n                  .st2 {\n                    fill: #f1fbf4;\n                  }\n\n                  .st3 {\n                    fill: #c0f2cd;\n                  }\n\n                  .st4 {\n                    fill: #00bf6f;\n                  }</style><g><path class=st0 d=\"M251.7,496.9c3,4.1,7.7,6.6,12.8,6.6s9.8-2.4,12.8-6.6C317,443.7,435.2,290.1,435.2,190\n                      c0-121.7-76.5-181.5-170.7-181.5S93.9,68.3,93.9,190C93.9,290.1,212.1,443.7,251.7,496.9z\"/><path class=st1 d=\"M238.9,496.9c6.2,8.7,6,8.7,12.2,0c37.7-53.2,150-206.8,150-306.9c0-121.7-72.6-181.5-162.1-181.5\n                      S76.8,68.3,76.8,190C76.8,290.1,201.2,443.7,238.9,496.9z\"/><path class=st2 d=\"M244.5,496.9c2.4,4.1,6.8,6.6,11.5,6.6c4.7,0,9.1-2.5,11.5-6.6c35.7-53.2,142.1-206.8,142.1-306.9\n                      C409.6,68.3,340.8,8.5,256,8.5S102.4,68.3,102.4,190C102.4,290.1,208.8,443.7,244.5,496.9z\"/><circle class=st3 cx=256 cy=187.7 r=128 /><path class=st2 d=\"M316.4,144.1l-0.7,0.9v102.4c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5v-33.1\n                      c0.2-8.6-5.7-16.1-14.2-17.8c-5-0.8-10,0.5-13.9,3.8s-6.1,8-6.1,13v34.1c0,4.7-3.8,8.5-8.5,8.5h-25.6c-4.7,0-8.5-3.8-8.5-8.5V145.1\n                      l-3.2-5.2l57.3-35.2c3.3-2.9,8.2-2.9,11.4,0L316.4,144.1z\"/><g><path class=st4 d=\"M256,324.3c-75.4,0-136.5-61.1-136.5-136.5S180.6,51.2,256,51.2s136.5,61.1,136.5,136.5\n                        C392.4,263.1,331.4,324.2,256,324.3z M256,68.3c-66,0-119.5,53.5-119.5,119.5S190,307.2,256,307.2s119.5-53.5,119.5-119.5\n                        C375.4,121.8,321.9,68.3,256,68.3z\"/><path class=st4 d=\"M307.2,264.5h-25.6c-9.4,0-17.1-7.6-17.1-17.1v-33.1c0.2-4.4-2.8-8.3-7-9.4c-2.5-0.4-5,0.3-7,1.9\n                        s-3.1,4-3.1,6.5v34.1c0,9.4-7.6,17.1-17.1,17.1h-25.6c-9.4,0-17.1-7.6-17.1-17.1V145.1c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5\n                        v102.4h25.6v-34.1c0-7.5,3.3-14.7,9.1-19.6s13.4-6.9,20.8-5.7c12.5,2.5,21.4,13.5,21.3,26.3v33.1h25.6V145.1\n                        c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v102.4C324.3,256.9,316.6,264.5,307.2,264.5z\"/><path class=st4 d=\"M341.3,170.7c-1.8,0-3.5-0.6-5-1.6l-79.6-57.6c-0.2-0.2-0.5-0.4-0.7-0.6c-0.4,0.3-0.8,0.6-1.3,0.9l-79.6,49\n                        c-2.6,1.6-5.8,1.7-8.5,0.2c-2.7-1.4-4.4-4.2-4.5-7.3s1.5-5.9,4.1-7.5l79.1-48.7c6.4-5.1,15.5-5,21.8,0.2l79.3,57.3\n                        c3,2.2,4.3,6,3.1,9.5C348.3,168.3,345,170.7,341.3,170.7L341.3,170.7z\"/><path class=st4 d=\"M256,512c-7.9,0-15.3-3.6-20.2-9.8l-5.4-6.8C189.1,442.7,92.2,319.5,72,223.6c-0.6-3,0.4-6.1,2.6-8.1\n                        c2.3-2,5.5-2.7,8.4-1.8c2.9,1,5.1,3.4,5.7,6.4c19.3,92,114.5,213,155.1,264.7l5.4,6.8c1.7,2,4.2,3.2,6.8,3.2s5.1-1.2,6.8-3.2\n                        l5.5-7c43.3-55.1,158.4-201.5,158.4-294.6c0-127.5-88.2-173-170.7-173c-92.4,0-155.3,51.5-168.1,137.8c-0.4,3-2.5,5.6-5.3,6.7\n                        c-2.8,1.1-6.1,0.6-8.4-1.3c-2.4-1.9-3.6-4.9-3.1-7.9C85,58.4,155.9,0,256,0c114,0,187.7,74.6,187.7,190\n                        c0,99-113.6,243.4-162,305.1l-5.5,7C271.4,508.4,263.9,512,256,512L256,512z\"/><circle class=st4 cx=76.8 cy=187.7 r=8.5 /></g></g></svg> <svg ng-if=\"vm.tag.svg == \'mudanca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                    fill: #9de8eb;\n                  }\n\n                  .st1 {\n                    fill: #a2fcf3;\n                  }\n\n                  .st2 {\n                    fill: #e8f9fc;\n                  }\n\n                  .st3 {\n                    fill: #ffffff;\n                  }\n\n                  .st4 {\n                    fill: #2fbaba;\n                  }</style><g><path id=Shape_1_ class=st0 d=\"M200.2,409.6c-7.4,0-13.9-4.8-16.2-11.8L70.6,49.7l-16.4,8.2c-8.4,4.2-18.7,0.8-22.9-7.6\n                      s-0.8-18.7,7.6-22.9l34.1-17.1c4.4-2.2,9.6-2.4,14.2-0.5s8.1,5.7,9.7,10.5l114,350.3l248-88c8.9-3.2,18.6,1.5,21.8,10.4\n                      c3.2,8.9-1.5,18.6-10.4,21.8l-264.5,93.9C204,409.2,202.1,409.6,200.2,409.6z\"/><path class=st0 d=\"M285.5,452.2c0,28.3-22.9,51.2-51.2,51.2c-5.2,0-10.4-0.8-15.4-2.3c-21.3-6.8-35.8-26.6-35.8-48.9\n                      c0-22.4,14.5-42.2,35.8-48.9c5-1.5,10.2-2.2,15.4-2.3C262.6,401,285.5,424,285.5,452.2z\"/><ellipse id=Oval class=st1 cx=219 cy=452.2 rx=35.8 ry=48.9 /><circle class=st0 cx=234.3 cy=452.2 r=17.1 /><path id=Rectangle-path_1_ class=st1 d=\"M203.8,192l161-56.5c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9\n                      l-161,56.5c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C197,198.5,199.3,193.6,203.8,192z\"/><path class=st2 d=\"M203.4,192.2l139.3-48.9c4.4-1.6,9.3,0.8,10.9,5.2l50.9,144.9c1.6,4.4-0.8,9.3-5.2,10.9L260,353.2\n                      c-4.4,1.6-9.3-0.8-10.9-5.2l-50.9-144.9C196.7,198.6,199,193.7,203.4,192.2z\"/><path class=st0 d=\"M315.6,215.8l-8.8-2.3c-3.3-0.9-6.9,0.4-8.9,3.1l-5.5,7.3c-1.9,2.5-5,3.8-8.1,3.3c-3.1-0.5-5.7-2.6-6.7-5.6\n                      l-17.3-49.4l48.3-17l17.3,49.4c1,3,0.4,6.3-1.8,8.6C321.9,215.6,318.7,216.5,315.6,215.8z\"/><path class=st1 d=\"M189.1,75.9l102.6-36c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9l-102.6,36\n                      c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C182.3,82.4,184.6,77.5,189.1,75.9z\"/><path class=st2 d=\"M188.1,76.3l78.1-27.4c4.4-1.6,9.3,0.8,10.9,5.2l32.2,91.9c1.6,4.4-0.8,9.3-5.2,10.9L226,184.2\n                      c-4.4,1.6-9.3-0.8-10.9-5.2l-32.2-91.9C181.3,82.7,183.6,77.8,188.1,76.3z\"/><path class=st0 d=\"M264,93.5l-9.5-2.4c-1.7-0.4-3.4,0.2-4.5,1.6l-5.9,7.8c-0.9,1.3-2.5,1.9-4.1,1.6c-1.6-0.2-2.8-1.3-3.4-2.8\n                      l-12.5-35.7l32.4-11.4l12.5,35.7c0.5,1.5,0.2,3.2-0.9,4.3C267.2,93.4,265.5,93.9,264,93.5z\"/><path class=st3 d=\"M54.2,57.9l6.1-3.1c-4-3.8-5.9-9.4-5.1-14.8c0.8-5.5,4.3-10.2,9.3-12.6l28-14c-5.1-5.1-13-6.4-19.5-3.1\n                      L38.9,27.4c-8.4,4.2-11.8,14.5-7.6,22.9S45.8,62.1,54.2,57.9z\"/><path class=st3 d=\"M73.8,59.6L184,397.8c1.4,4.4,4.6,8,8.7,10c4.1,2,8.9,2.3,13.2,0.8l4.5-1.6c-23,12.1-33.2,39.5-23.8,63.7\n                      c9.4,24.2,35.5,37.5,60.6,31c-20.4-5.3-35.5-22.6-38-43.5s8.2-41.3,26.8-51.2l-4.5,1.6c-4.3,1.5-9.1,1.3-13.2-0.8\n                      c-4.1-2-7.3-5.7-8.7-10L96.2,49.7l-16.4,8.2C77.9,58.8,75.9,59.4,73.8,59.6z\"/><polygon class=st3 points=\"78.7,47 113.1,152.5 192.1,395.1 175.8,400.4 96.8,157.8 62.5,52.3 	\"/><g><path class=st4 d=\"M99.4,118.5c2.1-4.2,0.4-9.3-3.7-11.5l-1.5-0.6c-0.6-0.2-1.1-0.3-1.7-0.3c-0.5-0.1-1.1-0.1-1.6,0\n                        c-0.6,0.1-1.1,0.2-1.7,0.4c-2.1,0.7-3.9,2.2-5,4.2c-2,4.2-0.4,9.3,3.7,11.5c1,0.5,2.1,0.8,3.2,0.9c1.1,0.1,2.2,0,3.3-0.4\n                        C96.5,122,98.3,120.5,99.4,118.5z\"/><path class=st4 d=\"M38.5,66.9c6.4,2.2,13.5,1.7,19.5-1.4l7.5-3.8l7.5,23c1.6,4.3,6.3,6.6,10.6,5.1c4.4-1.4,6.8-6,5.6-10.4\n                        L78.7,47.1l-0.2,0.1c-0.1-0.4-0.2-0.8-0.3-1.2c-2.1-4.2-7.2-5.9-11.4-3.9l-16.4,8.3c-4.2,2.1-9.4,0.4-11.5-3.8\n                        c-2.1-4.2-0.4-9.4,3.8-11.5L76.8,18c2.2-1.1,4.8-1.2,7.1-0.2c2.3,1,4.1,2.9,4.8,5.2l114.1,350.2c0.7,2.2,2.3,4,4.3,5\n                        c2.1,1,4.5,1.2,6.6,0.4l248-88c3.3-1.1,6.9-0.2,9.2,2.3c2.3,2.6,2.8,6.3,1.4,9.4c-1,2-2.7,3.6-4.8,4.4l-245.3,87\n                        c-5.2,1.1-10.2,2.9-15,5.3l-4.3,1.5c-2.2,0.8-4.6,0.6-6.6-0.4c-2.1-1-3.6-2.8-4.3-5l-81.6-250.7c-0.8-3-3.3-5.3-6.3-6\n                        c-3.1-0.7-6.2,0.3-8.3,2.7c-2.1,2.4-2.7,5.7-1.6,8.6l81.6,250.7c2,6.1,6.3,11.3,11.9,14.4c-16,19.8-17.6,47.5-4.2,69.1\n                        c13.5,21.6,39.1,32.3,63.9,26.6c24.8-5.6,43.3-26.3,46.1-51.6c2.8-25.3-10.7-49.6-33.6-60.5l213.2-75.7\n                        c8.9-2.8,15.5-10.3,17.3-19.5c1.8-9.2-1.5-18.6-8.7-24.6c-7.2-6-17-7.6-25.7-4.2l-22.7,8l-54-153.8c-0.8-2.1-2.3-3.9-4.4-4.9\n                        s-4.4-1.1-6.5-0.4l-26,9.1L307.2,31.8c-0.8-2.1-2.3-3.9-4.4-4.9s-4.4-1.1-6.5-0.4l-43.2,15.2l-32.4,11.4l-43.2,15.2\n                        c-2.1,0.8-3.9,2.3-4.9,4.4c-1,2-1.1,4.4-0.4,6.5L207.7,180l-16.3,5.7c-4.4,1.6-6.8,6.4-5.2,10.9L240.5,351l-24.1,8.5L105,17.6\n                        c-2.3-7.1-7.6-12.8-14.5-15.7S75.9-0.7,69.3,2.7L35.1,19.7C25.9,24.4,20.3,34.1,21,44.4S28.7,63.6,38.5,66.9z M234.3,409.6\n                        c21.9-0.3,40.6,15.9,43.4,37.7c2.8,21.8-11.1,42.2-32.4,47.5s-43.2-6.1-50.9-26.6c-7.8-20.5,1.1-43.6,20.6-53.7l11.4-4\n                        C229,409.8,231.6,409.6,234.3,409.6z M301.8,165l14.5,41.3l-14.4-3.7c-3.3-0.9-6.9,0.4-8.9,3.1l-8.9,11.8l-14.5-41.3l16.1-5.7\n                        L301.8,165z M257.8,80.8l-4.5-1.2c-3.3-0.9-6.9,0.4-8.9,3.1l-2.8,3.7l-7-20.1l8.1-2.9l8.1-2.9L257.8,80.8z M218.3,72l12.3,35.1\n                        c1,3,3.6,5.1,6.7,5.6c0.4,0.1,0.9,0.1,1.3,0.1c2.7,0,5.2-1.3,6.8-3.4l9-11.9l14.5,3.7c3,0.8,6.3-0.2,8.4-2.5\n                        c2.1-2.3,2.8-5.6,1.8-8.6L266.8,55l27.1-9.5l32.2,91.8l-102.6,36l-32.2-91.8L218.3,72z M253.5,182l19.8,56.4c1,3,3.6,5.1,6.7,5.6\n                        c3.1,0.5,6.2-0.8,8.1-3.3l15.1-20l24.3,6.2c3,0.8,6.3-0.2,8.4-2.5c2.1-2.3,2.8-5.6,1.8-8.6l-19.8-56.3l48.3-17l50.9,144.9\n                        l-161,56.5L205.2,199L253.5,182z\"/><path class=st4 d=\"M208.7,452.2c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6c0-14.1-11.5-25.6-25.6-25.6\n                        C220.2,426.6,208.7,438.1,208.7,452.2z M234.3,443.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5\n                        S229.6,443.7,234.3,443.7z\"/></g></g></svg> <svg ng-if=\"vm.tag.svg == \'busca\'\" class=image version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 512 512\" style=\"enable-background: new 0 0 512 512\" xml:space=preserve><style type=text/css>.st0 {\n                    fill: #a2fcf3;\n                  }\n\n                  .st1 {\n                    fill: #e8f9fc;\n                  }\n\n                  .st2 {\n                    fill: #808e87;\n                  }\n\n                  .st3 {\n                    fill: url(#SVGID_1_);\n                  }\n\n                  .st4 {\n                    fill: #f26546;\n                  }\n\n                  .st5 {\n                    fill: #9de8eb;\n                  }\n\n                  .st6 {\n                    fill: #ffffff;\n                  }\n\n                  .st7 {\n                    fill: #2fbaba;\n                  }</style><g><path id=Shape class=st0 d=\"M458.8,399.6l-59.1,59l-0.3,0.3l-0.1-0.1h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l36.1-36.1\n                      l11.4-11.4c3.3-3.3,8.6-3.3,11.8,0L458.8,399.6z\"/><path class=st0 d=\"M486.9,487.1c-2.1,2.1-4.4,4-7,5.6c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l0.3-0.3l59.1-59l28.1,28.1\n                      C503.3,444.1,503.3,470.7,486.9,487.1z\"/><path class=st1 d=\"M436.9,420.5l-37.5,38.3h-0.1l-27.7-27.8c-3.3-3.3-3.3-8.6,0-11.8l26.9-27.7c3.3-2.2,7.7-1.7,10.6,1.1\n                      L436.9,420.5z\"/><path class=st1 d=M480,492.7c-16.6,10.7-38.4,8.3-52.4-5.6L399.5,459l38.1-38.1l28,28.1C479.8,463.2,490.5,476.4,480,492.7z /><rect id=Rectangle-path x=342.9 y=329.6 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -152.5583 368.0898)\" class=st0 width=50.3 height=77.3 /><rect x=346.4 y=338 transform=\"matrix(0.7071 -0.7071 0.7071 0.7071 -160.953 364.6137)\" class=st1 width=26.6 height=77.3 /><path class=st0 d=\"M341.9,342.1c-75.8,72.7-195.9,71.5-270.2-2.8S-3.8,144.9,68.9,69.1c75.8-72.7,195.9-71.5,270.2,2.8\n                      S414.6,266.2,341.9,342.1z\"/><path class=st1 d=\"M316.7,342.1c-33,33.2-77.1,53.2-123.9,56.1c-75.6-4.9-141.4-53.6-168.1-124.6S15.3,122.7,68.9,69.1\n                      c33-33.2,77.1-53.2,123.9-56.1c75.6,4.9,141.4,53.6,168.1,124.6S370.3,288.5,316.7,342.1z\"/><path class=st2 d=\"M205.4,373.4c-67.9,0-129.1-40.9-155.1-103.6s-11.6-134.9,36.4-183c65.6-65.6,171.9-65.6,237.4,0\n                      s65.6,171.9,0,237.4C292.7,355.9,250,373.6,205.4,373.4z\"/><linearGradient id=SVGID_1_ gradientUnits=userSpaceOnUse x1=-700.6567 y1=795.9537 x2=-699.9529 y2=795.2502 gradientTransform=\"matrix(320.5412 0 0 -320.6926 224681.9375 255349.2344)\"><stop offset=0 style=\"stop-color: #d4f3f3\"/><stop offset=0.172 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #d4f3f3\"/><stop offset=0.2 style=\"stop-color: #dbf1f3\"/><stop offset=0.201 style=\"stop-color: #ebedf3\"/><stop offset=0.201 style=\"stop-color: #f7f0f7\"/><stop offset=0.202 style=\"stop-color: #f1e6ec\"/><stop offset=0.205 style=\"stop-color: #fff2f7\"/><stop offset=0.252 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #fff2f7\"/><stop offset=0.26 style=\"stop-color: #d4f3f3\"/><stop offset=0.397 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #d4f3f3\"/><stop offset=0.42 style=\"stop-color: #dbf1f3\"/><stop offset=0.421 style=\"stop-color: #ebedf3\"/><stop offset=0.421 style=\"stop-color: #f7f0f7\"/><stop offset=0.422 style=\"stop-color: #f1e6ec\"/><stop offset=0.425 style=\"stop-color: #fff2f7\"/><stop offset=0.489 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #fff2f7\"/><stop offset=0.5 style=\"stop-color: #f8f0f7\"/><stop offset=0.5 style=\"stop-color: #e8eef3\"/><stop offset=0.5 style=\"stop-color: #ddf1f3\"/><stop offset=0.5 style=\"stop-color: #d6f2f3\"/><stop offset=0.501 style=\"stop-color: #d4f3f3\"/><stop offset=0.706 style=\"stop-color: #d4f3f3\"/><stop offset=0.74 style=\"stop-color: #d4f3f3\"/><stop offset=0.741 style=\"stop-color: #fff2f7\"/><stop offset=0.835 style=\"stop-color: #fff2f7\"/><stop offset=0.85 style=\"stop-color: #fff2f7\"/><stop offset=0.851 style=\"stop-color: #d4f3f3\"/></linearGradient><path class=st3 d=\"M318.2,318.4c-62.3,62.2-163.3,62.2-225.6,0c-1.1-1.1-2.2-2.3-3.3-3.4c-39.7-40.9-54.5-99.8-39-154.7\n                      s59.2-97.2,114.4-111.1s113.7,2.7,153.4,43.6c17.8,17.8,31.1,39.5,38.8,63.5C375.5,213.3,360.6,275.9,318.2,318.4z\"/><path class=st4 d=M138.3,183.2l69.3-60.3l65,60.3v98c0,4.6-3.8,8.4-8.4,8.4H146.7c-4.6,0-8.4-3.8-8.4-8.4V183.2z /><path class=st1 d=M146.7,171.7l60.7-66.8l56.8,66.8v108.6c0.5,4.6-2.8,8.7-7.3,9.3H154c-4.6-0.6-7.8-4.7-7.3-9.3V171.7z /><path class=st5 d=\"M293.1,196.9l-83-55.3c-2.8-1.9-6.5-1.9-9.3,0l-83,55.3c-2.6,1.7-5.9,1.9-8.6,0.4c-2.7-1.5-4.4-4.3-4.4-7.4\n                      v-21.8c0-2.8,1.4-5.4,3.7-7l92.3-61.5c2.8-1.9,6.5-1.9,9.3,0l92.3,61.5c2.3,1.6,3.7,4.2,3.7,7v21.8c0,3.1-1.7,5.9-4.4,7.4\n                      C299,198.8,295.7,198.6,293.1,196.9z\"/><path class=st5 d=M188.6,222.4h33.6c4.6,0,8.4,3.8,8.4,8.4v58.8h-50.4v-58.8C180.2,226.1,184,222.4,188.6,222.4z /><path class=st6 d=\"M192.8,398.1c8.4,0.5,16.7,0.5,25.1,0c-75.6-4.9-141.3-53.7-168-124.6S40.5,122.7,94.1,69.1\n                      c33-33.2,77.1-53.1,123.8-56.1C111.6,6.1,19.8,86.7,12.8,193S86.5,391.2,192.8,398.1z\"/><path class=st6 d=\"M74.9,75c-12.2,12.5-22.7,26.5-31.2,41.7c-8.4,15.2-14.6,31.6-18.3,48.6c-6.7,30.3-5.8,61.9,2.7,91.8\n                      c8.9,29.8,24.9,56.9,46.7,79.1L63,348c-23.8-24.1-41.3-53.8-51-86.3c-9.3-32.6-10.3-67-3-100.1c4.1-18.6,10.8-36.4,20-53.1\n                      C38.3,92,49.7,76.7,63,63.1L74.9,75z\"/><path class=st7 d=\"M86.7,324.3c65.6,65.6,171.8,65.6,237.4,0c65.6-65.6,65.6-171.8,0-237.4c-42.4-42.4-104.2-59-162.2-43.5\n                      S58.8,104.2,43.3,162.1S44.3,281.9,86.7,324.3z M98.6,98.7c59-59,154.7-59,213.7,0s59,154.7,0,213.7s-154.7,59-213.7,0\n                      C70,284.2,53.9,245.7,53.9,205.6S70,126.9,98.6,98.7z\"/><path class=st7 d=\"M436.9,365.8c-6.6-6.6-17.2-6.6-23.7,0l-43.7-43.6c60.8-85.3,46-203-34-270.6S137-11.1,63,63.1l-11.7,13\n                      c-3.9,4.3-7.1,9.3-10.6,13.9c-1.4,1.8-2,4.1-1.6,6.4c0.4,2.2,1.7,4.2,3.7,5.4c3.8,2.3,8.8,1.4,11.6-2.1c3.3-4.2,6.1-8.8,9.7-12.8\n                      L74.8,75C147,2.9,263.9,2.9,336,75s72.1,189,0,261.1s-189,72.1-261.1,0C53,314,37,286.9,28.1,257.1c-8.5-29.9-9.5-61.5-2.7-91.8\n                      l1.9-7.8c1-4.4-1.5-8.8-5.8-10.2c-2.2-0.7-4.5-0.5-6.5,0.6c-2,1.1-3.4,3-3.9,5.2L9,161.7c-7.4,33.1-6.3,67.5,3,100.1\n                      c9.7,32.5,27.2,62.1,51,86.3c69.5,69.5,179,78.6,259,21.6l43.6,43.7c-6.6,6.6-6.6,17.2,0,23.7l56,56c12.7,12.9,31.3,18,48.8,13.4\n                      c17.5-4.6,31.1-18.3,35.8-35.8c4.6-17.5-0.5-36.1-13.4-48.8L436.9,365.8z M377.5,401.4l-42.1-42.1c4.2-3.6,8.5-7.3,12.5-11.3\n                      c4-4,7.7-8.2,11.3-12.5l42.2,42.1l-11.9,11.9L377.5,401.4z M425,377.7l21.9,21.9l-47.5,47.4l-21.9-21.9L425,377.7z M481,481.1\n                      c-13.3,12.7-34.2,12.7-47.5,0l-22.2-22.2l47.5-47.4l22.2,22.1c6.3,6.3,9.8,14.8,9.8,23.7S487.3,474.8,481,481.1z\"/><path class=st7 d=\"M100.7,213c2.7,1.5,6,1.3,8.6-0.4l20.5-13.7v82.3c0,9.3,7.5,16.8,16.8,16.8h117.5c9.3,0,16.8-7.5,16.8-16.8\n                      v-82.3l20.5,13.7c2.6,1.7,5.9,1.9,8.6,0.4c2.7-1.5,4.4-4.3,4.4-7.4v-42c0-2.8-1.4-5.4-3.7-7L210.1,89.5c-2.8-1.9-6.5-1.9-9.3,0\n                      L100,156.6c-2.3,1.6-3.7,4.2-3.7,7v42C96.3,208.7,98,211.5,100.7,213z M188.6,281.1v-50.4h33.6v50.4H188.6z M264.2,281.1H239v-50.4\n                      c0-9.3-7.5-16.8-16.8-16.8h-33.6c-9.3,0-16.8,7.5-16.8,16.8v50.4h-25.2v-93.4l58.8-39.2l58.8,39.2V281.1z M113.1,168.1l92.3-61.6\n                      l92.3,61.5v21.8l-87.7-58.5c-2.8-1.9-6.5-1.9-9.3,0l-87.7,58.4V168.1z\"/></g></svg></div></div><div class=\"btns-share d-flex\" ng-if=vm.contato><button class=\"btn m-auto\" role=button aria-label=compartilhar ng-click=vm.openShare()><i class=\"fal fa-share-alt\"></i> &nbsp;Compartilhar</button></div></div></section></div></div><div class=footer><div id=relations class=\"relations container\" ng-if=\"vm.relacionados && vm.relacionados.length\"><carousel-imovel imoveis=vm.relacionados properties=vm.owlProperties navegator=true title-carousel=\"Outros Imóveis que você pode gostar\"></carousel-imovel></div></div><div class=fixed-bottom-imv ng-if=\"vm.isMobile && btnsContatar\"><div class=\"box-btn-footer fixed-theme d-flex justify-content-between align-items-center\"><a ng-click=\"vm.openVisit(vm.listing, false)\" class=\"btn btn-footer-av\" aria-label=\"agendar visita\">Agendar visita</a> <a ng-click=\"vm.openVisit(vm.listing, true)\" class=\"btn active btn-footer-ct\" aria-label=\"entrar em contato\">Contatar</a> <a ng-show=vm.config_wl.isArbo ng-href=\"{{ vm.urlWhats }}\" class=\"btn-wpp d-flex justify-content-center align-items-center\" target=_blank><i class=\"fab fa-whatsapp\"></i></a></div></div></section>");
$templateCache.put("app/components/listingDetail/listingDetailLancamento.html","<div id=detail-imovel class=\"container-fluid margin-fluid\"><nav id=navbar-bottom class=\"navbar fixed-bottom navbar-expand-lg navbar-light d-lg-none\" ng-if=vm.mobile><div data-toggle=collapse data-target=#navbarCollapse aria-controls=navbarCollapse aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"vm.setTipoNegocio($event, vm.tipoNegocio)\" ng-if=vm.tipoNegocio class=\"d-flex w-100 justify-content-center\"><span class=\"icon-more fal fa-chevron-down\"></span></div><div class=\"d-flex w-100 pb-2 justify-content-center\" ng-if=\"vm.listing.imv_preco_locacao && !vm.listing.imv_preco_venda\"><button type=button class=\"btn button btn-default both-btn mb-0 py-1\" data-toggle=collapse data-target=#navbarCollapse aria-controls=navbarCollapse aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"vm.setTipoNegocio($event, 1)\" ng-class=\"{\'active\': (vm.tipoNegocio == 1)}\" ng-style=\"{\'width\':\'65%\'}\">Alugue por<br><strong>R$ {{vm.formatPrice(vm.listing.imv_preco_locacao)}}</strong></button></div><div class=\"d-flex w-100 pb-2 justify-content-center\" ng-if=\"!vm.listing.imv_preco_locacao && vm.listing.imv_preco_venda\"><button type=button class=\"btn button btn-default both-btn mb-0 py-1\" data-toggle=collapse data-target=#navbarCollapse aria-controls=navbarCollapse aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"vm.setTipoNegocio($event, 2)\" ng-class=\"{\'active\': (vm.tipoNegocio == 2)}\" ng-style=\"{\'width\':\'65%\'}\">Compre por<br><strong>R$ {{vm.formatPrice(vm.listing.imv_preco_venda)}}</strong></button></div><div class=\"d-flex w-100 pb-2\" ng-if=\"vm.listing.imv_preco_locacao && vm.listing.imv_preco_venda\"><button type=button class=\"btn button btn-default both-btn mb-0 py-1\" data-toggle=collapse data-target=#navbarCollapse aria-controls=navbarCollapse aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"vm.setTipoNegocio($event, 1)\" ng-class=\"{\'active\': (vm.tipoNegocio == 1)}\">Alugue por<br><strong>R$ {{vm.formatPrice(vm.listing.imv_preco_locacao)}}</strong></button> <span class=\"px-2 my-auto\">ou</span> <button type=button class=\"btn button btn-default both-btn mb-0 py-1\" data-toggle=collapse data-target=#navbarCollapse aria-controls=navbarCollapse aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"vm.setTipoNegocio($event, 2)\" ng-class=\"{\'active\': (vm.tipoNegocio == 2)}\">Compre por<br><strong>R$ {{vm.formatPrice(vm.listing.imv_preco_venda)}}</strong></button></div><div class=\"navbar-collapse collapse mt-5\" id=navbarCollapse><div class=\"valores-mobile card-flip border d-block\"><div id=form-valores><ul ng-if=vm.hasExtraExpenses><li class=\"row destaque\" ng-show=\"vm.listing.imv_preco_venda && !vm.listing.imv_preco_locacao\"><div class=col-5>Venda</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_venda)}}</div></li><li class=\"row destaque\" ng-show=\"vm.listing.imv_preco_locacao && !vm.listing.imv_preco_venda\"><div class=col-5>Aluguel</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_locacao)}}</div></li><li class=row ng-show=vm.listing.imv_preco_cond><div class=col-5>Condominio</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_cond)}}</div></li><li class=row ng-show=vm.listing.imv_preco_iptu><div class=col-5>IPTU mensal</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_iptu)}}</div></li><li class=row ng-show=vm.listing.imv_preco_seguro><div class=col-5>Seguro incêndio</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_seguro)}}</div></li></ul><div id=form-contato class=\"d-flex border-top\" ng-if=!(vm.mobile)><form action=\"\" name=tipoImovel ng-submit=vm.form.submitContato($event)><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><h4 class=title-form>Tenho interesse neste imóvel!</h4><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-nome class=\"form-control upper\" ng-model=vm.form.formData.cliente autocomplete=off required placeholder=\"Escreva seu nome\"><label for=form-contact-nome class=\"ml-1 pl-3 upper\">Nome</label></div><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-tel class=\"form-control upper\" ng-model=vm.form.formData.telefone autocomplete=off required placeholder=\"(00) 9 9999-9999\"><label for=form-contact-tel class=\"ml-1 pl-3 upper\">Telefone</label></div><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-email class=\"form-control upper\" ng-model=vm.form.formData.email autocomplete=off required placeholder=email@dominio.com><label for=form-contact-email class=\"ml-1 pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\"><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.formData.check ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Quero receber o contato somente por Whatsapp.</span></label></div><div class=\"d-flex col-12 px-0\"><button type=submit id=tipoImovel class=\"btn button btn-default btn-big mx-auto mt-3\">Entrar em contato</button></div></div></div></form></div><div class=button-favorite ng-class=\"{\'border-top pt-4\': vm.hasExtraExpenses}\"><button class=\"btn button button-transparent border m-0\" ng-click=vm.changeFavorite(vm.listing)><i class=\"fal fa-heart\" ng-show=!vm.listing.isFavorite></i> <i class=\"fas fa-heart\" style=\"color: #555\" ng-show=vm.listing.isFavorite></i></button> <span class=\"pl-2 text-span\">Adicionar aos favoritos</span></div></div></div><div class=\"formulario-contato d-block\"><div id=form-contato class=d-flex><form action=\"\" name=tipoImovel ng-submit=vm.form.submitContato($event) class=mx-auto><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><h4 class=title-form>Tenho interesse neste imóvel!</h4><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-nome class=\"form-control upper\" ng-model=vm.form.formData.cliente ng-focus=\"vm.clickInput(\'-120px\')\" ng-blur=vm.resetInput() autocomplete=off required placeholder=\"Escreva seu nome\"><label for=form-contact-nome class=\"ml-1 pl-3 upper\">Nome</label></div><div class=\"d-flex col-12 px-0\"><input type=tel id=form-contact-tel class=\"form-control upper\" ng-model=vm.form.formData.telefone ng-focus=\"vm.clickInput(\'-80px\')\" ng-blur=vm.resetInput() autocomplete=off ui-br-phone-number-mask required placeholder=\"(00) 9 9999-9999\"><label for=form-contact-tel class=\"ml-1 pl-3 upper\">Telefone</label></div><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-email class=\"form-control upper\" ng-model=vm.form.formData.email ng-focus=\"vm.clickInput(\'-10px\')\" ng-blur=vm.resetInput() autocomplete=off required placeholder=email@dominio.com><label for=form-contact-email class=\"ml-1 pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\"><button type=submit id=LeadSubmitMobile class=\"btn button btn-default btn-big col-8 mx-auto mt-4\">Entrar em contato</button></div></div></div></form></div><div id=form-agendamento class=d-none><form action=\"\" name=tipoImovel class=\"datepicker-form mx-auto\" ng-submit=vm.form.submitAgendamento($event)><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><h4 class=subtitle-form>Seus dados foram enviados! Um corretor vai entrar em contato com você!</h4><h4 class=\"title-form border-top\">Gostaria de já agendar um horário para visitar o imóvel?</h4></div></div><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"date-picker d-flex justify-content-around align-items-center\"><a ng-disabled=(vm.datesPage)><i ng-click=\"vm.datesPage = vm.datesPage - 1\" class=\"date-picker-arrow fal fa-chevron-left\"></i></a><div ng-repeat=\"date in vm.tempDates | limitTo: 6 track by $index\"><input type=radio name=date id=date-{{date.day}} class=datepicker-input ng-model=vm.form.formData.visita_data ng-value=date.date ng-checked=$first><label for=date-{{date.day}} class=\"date-elem noSwipe no-select\">{{date.dayOfWeek}}<br>{{date.day}}/{{date.month}}</label></div><a ng-disabled=\"(vm.datesPage == 10)\"><i ng-click=\"vm.datesPage = vm.datesPage + 1\" class=\"date-picker-arrow fal fa-chevron-right\"></i></a></div><div class=\"date-picker d-flex justify-content-around align-items-center\"><a ng-disabled=(vm.timesPage)><i ng-click=\"vm.timesPage = vm.timesPage - 1\" class=\"date-picker-arrow fal fa-chevron-left\"></i></a><div ng-repeat=\"date in vm.tempTimes | limitTo: 6 track by $index\"><input id=hour-{{date.time}} type=radio name=hour class=datepicker-input ng-model=vm.form.formData.visita_hora ng-value=date.time ng-checked=$first><label for=hour-{{date.time}} class=\"date-elem noSwipe no-select\">{{date.time}}</label></div><a ng-disabled=\"(vm.timesPage == 10)\"><i ng-click=\"vm.timesPage = vm.timesPage + 1\" class=\"date-picker-arrow fal fa-chevron-right\"></i></a></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big mx-auto\">Agendar</button></div></div></form></div><div id=form-agradecimento class=\"form d-none h-100 flex-column flex-wrap justify-content-center align-content-center\"><div class=form-contact><div class=form-group><h4 class=subtitle-form>Recebemos o seu contato, um corretor entrará em contato com você!</h4><h4 class=\"text-center mt-4\"><i class=\"fal fa-smile-beam\"></i></h4></div></div></div></div></div></nav><div id=valores-container><ol class=\"breadcrumb-list mt-5 mb-0 p-0 d-none d-sm-block\" itemscope itemtype=http://schema.org/BreadcrumbList><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{vm.makeUrl(vm.listing, 1)}}\"><span itemprop=name>{{vm.listing.imv_cidade}}</span></a><meta itemprop=position content=1></li><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{vm.makeUrl(vm.listing, 2)}}\"><span itemprop=name>{{vm.listing.imv_preco_locacao ? \' > Aluguel\' : \' > Venda\'}}</span></a><meta itemprop=position content=2></li><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{vm.makeUrl(vm.listing, 3)}}\"><span itemprop=name>{{\' > \' + vm.listing.tipo_imovel.timv_nome}}</span></a><meta itemprop=position content=3></li><li class=list-no-style itemprop=itemListElement itemscope itemtype=http://schema.org/ListItem><a itemprop=item ng-href=\"{{vm.makeUrl(vm.listing, 4)}}\"><span itemprop=name>{{\' > cód. \' + vm.listing.imv_cod_gaia}}</span></a><meta itemprop=position content=4></li></ol><div class=\"d-none d-sm-flex\"><header ng-show=vm.listing.imv_titulo><h1 class=title>{{vm.listing.imv_nome_cond}}</h1></header><div class=\"imob-avatar d-flex align-items-center ml-auto mr-3\"><img ng-src={{vm.listing.imobiliaria.imb_url_logo}} alt={{vm.listing.imobiliaria.imb_nome}} srcset=\"\"></div></div><div class=\"d-flex flex-column flex-md-row align-items-lg-stretch header\"><div class=\"row col-md-6 col-lg-7 col-xl-8\"><div id=c-detail class=\"wrap-toogle col-12 pr-sm-1\"><div class=imagem ng-if=vm.listing style=\"width: 100%; height: 380px; background-repeat: no-repeat; background-size: cover; background-position: center\" ng-style=\"{\'background-image\': \'url({{vm.listing.fotos[0][\'imvft_url\'] ? vm.listing.fotos[0][\'imvft_url\'] : \'../../assets/images/novosite/fallback.png\'}})\'}\"></div></div></div><div class=\"d-flex d-sm-none px-4\"><header><h1 class=title>{{vm.listing.tipo_imovel.timv_nome}} - {{vm.listing.imv_bairro}}</h1><address class=address>{{vm.listing.imv_endereco}}, {{vm.listing.imv_end_numero}} - {{vm.listing.imv_bairro}} - {{vm.listing.imv_cidade}}/{{vm.listing.imv_estado}}</address><address class=address>cód. {{vm.listing.imv_cod_gaia}} / {{vm.listing.imobiliaria.imb_nome}} - Creci {{vm.listing.imobiliaria.imb_creci}}</address></header><div class=ml-auto><img src=\"\" alt=\"\" srcset=\"\"></div></div><div id=valores class=\"row col-md-6 col-xl-4 mt-3 mt-sm-0 pr-sm-1 pr-lg-3 pl-md-3\"><div class=\"valores card-flip border d-none d-md-block\"><div id=form-valores><ul><li class=\"row destaque\" ng-show=vm.listing.imv_preco_venda><div class=col-5>Venda</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_venda)}}</div></li><li class=\"row destaque\" ng-show=vm.listing.imv_preco_locacao><div class=col-5>Aluguel</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_locacao)}}</div></li><li class=row ng-show=vm.listing.imv_preco_cond><div class=col-5>Condominio</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_cond)}}</div></li><li class=row ng-show=vm.listing.imv_preco_iptu><div class=col-5>IPTU mensal</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_iptu)}}</div></li><li class=row ng-show=vm.listing.imv_preco_seguro><div class=col-5>Seguro incêndio</div><div class=\"col-7 text-right\">R$ {{vm.formatPrice(vm.listing.imv_preco_seguro)}}</div></li></ul><div id=form-contato class=\"d-flex border-top\" ng-if=!(vm.mobile)><form action=\"\" name=tipoImovel ng-submit=vm.form.submitContato($event)><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><h4 class=title-form>Tenho interesse neste imóvel!</h4><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-nome class=\"form-control upper\" ng-model=vm.form.formData.cliente autocomplete=off required placeholder=Nome><label for=form-contact-nome class=\"ml-1 pl-3 upper\">Nome</label></div><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-tel class=\"form-control upper\" ng-model=vm.form.formData.telefone autocomplete=off required placeholder=\"(00) 9 9999-9999\"><label for=form-contact-tel class=\"ml-1 pl-3 upper\">Telefone</label></div><div class=\"d-flex col-12 px-0\"><input type=text id=form-contact-email class=\"form-control upper\" ng-model=vm.form.formData.email autocomplete=off required placeholder=email@dominio.com><label for=form-contact-email class=\"ml-1 pl-3 upper\">E-mail</label></div><div class=\"d-flex col-12 px-0\"><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.formData.check ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Quero receber o contato somente por Whatsapp.</span></label></div><div class=\"d-flex col-12 px-0\"><button type=submit id=tipoImovel class=\"btn button btn-default btn-big mx-auto mt-3\">Entrar em contato</button></div></div></div></form></div><div class=\"button-favorite border-top pt-4\"><button class=\"btn button button-transparent border m-0\" ng-click=vm.changeFavorite(vm.listing)><i class=\"fal fa-heart\" ng-show=!vm.listing.isFavorite></i> <i class=\"fas fa-heart\" style=\"color: #555\" ng-show=vm.listing.isFavorite></i></button> <span class=\"pl-2 text-span\">Adicionar aos favoritos</span></div></div><div class=\"formulario-contato d-none d-sm-inline-block\" ng-if=!(vm.mobile)><div id=form-agendamento class=d-none><form action=\"\" name=tipoImovel class=datepicker-form ng-submit=vm.form.submitAgendamento($event)><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><h4 class=subtitle-form>Seus dados foram enviados! Um corretor vai entrar em contato com você!</h4><h4 class=\"title-form border-top\">Gostaria de já agendar um horário para visitar o imóvel?</h4></div></div><div class=form-contact><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"date-picker d-flex justify-content-around align-items-center\"><a ng-disabled=(vm.datesPage)><i ng-click=\"vm.datesPage = vm.datesPage - 1\" class=\"date-picker-arrow fal fa-chevron-left\"></i></a><div ng-repeat=\"date in vm.tempDates | limitTo: 6 track by $index\"><input type=radio name=date id=date-{{date.day}} class=datepicker-input ng-model=vm.form.formData.visita_data ng-value=date.date ng-checked=$first><label for=date-{{date.day}} class=\"date-elem noSwipe no-select\">{{date.dayOfWeek}}<br>{{date.day}}/{{date.month}}</label></div><a ng-disabled=\"(vm.datesPage == 10)\"><i ng-click=\"vm.datesPage = vm.datesPage + 1\" class=\"date-picker-arrow fal fa-chevron-right\"></i></a></div><div class=\"date-picker d-flex justify-content-around align-items-center\"><a ng-disabled=(vm.timesPage)><i ng-click=\"vm.timesPage = vm.timesPage - 1\" class=\"date-picker-arrow fal fa-chevron-left\"></i></a><div ng-repeat=\"date in vm.tempTimes | limitTo: 6 track by $index\"><input id=hour-{{date.time}} type=radio name=hour class=datepicker-input ng-model=vm.form.formData.visita_hora ng-value=date.time ng-checked=$first><label for=hour-{{date.time}} class=\"date-elem noSwipe no-select\">{{date.time}}</label></div><a ng-disabled=\"(vm.timesPage == 10)\"><i ng-click=\"vm.timesPage = vm.timesPage + 1\" class=\"date-picker-arrow fal fa-chevron-right\"></i></a></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big mx-auto\">Agendar</button></div></div></form></div><div id=form-agradecimento class=\"form d-none h-100 flex-column flex-wrap justify-content-center align-content-center\"><div class=form-contact><div class=form-group><h4 class=subtitle-form>Recebemos o seu contato, um corretor entrará em contato com você!</h4><h4 class=\"text-center mt-4\"><i class=\"fal fa-smile-beam\"></i></h4></div></div></div></div></div></div></div><div class=\"d-flex flex-column informations\"><div class=row><div class=\"infos col-sm-12 col-lg-6 col-xl-8\"><div class=galeria-empreendimento ng-repeat=\"(key, tipo) in vm.tipoFotos\"><div class=header-galeria><div class=title-galeria>{{key}}</div></div><ng-owl-carousel id=carousel-locacao class=\"owl-theme d-flex flex-fill\" owl-items=tipo owl-properties=vm.owlPropertiesGaleria owl-ready=vm.readyLocacao($api)><div ng-repeat=\"listing in tipo\" class=\"d-flex flex-column mb-5 light-gallery\" data-id=\"{{ listing.imvft_id }}\" style=\"width: 100%\"><div class=\"imagem c-pointer\" data-src=\"{{vm.trustSrc(listing[\'imvft_url\'] ? listing[\'imvft_url\'] : \'../../assets/images/novosite/fallback.png\')}}\" ng-style=\"{\'background-image\': \'url({{listing[\'imvft_url\'] ? listing[\'imvft_url\'] : \'../../assets/images/novosite/fallback.png\'}})\'}\"><img src=\"{{!($index) ? foto.imvft_url : \'\'}}\" alt=\"{{(foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto\') + \' do \' + vm.listing.tipo_imovel.timv_nome}} - {{vm.listing.imv_titulo}} | {{vm.config_wl.nome}}\" data-img=\"{{($index) ? foto.imvft_url : \'\'}}\" class=d-block on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}}></div></div></ng-owl-carousel></div></div><div class=\"infos col-sm-12 col-lg-6 col-xl-8\" ng-if=vm.listing.imv_videourl><div class=\"video d-flex justify-content-center align-items-center\" ng-class=\"{\'no-bg\': vm.playVideo}\"><div class=\"div-video w-100 h-100 d-none\" ng-show=vm.playVideo></div><video class=\"imv-video w-100\" ng-show=vm.playVideo controlslist=nodownload></video><div ng-if=!vm.playVideo><button class=\"play d-flex align-items-center justify-content-center mx-auto c-pointer\" ng-click=\"vm.playVideo = true; vm.initVideo()\"><i class=\"fas fa-play fa-2x\"></i></button><h4 class=\"title padding-title col-10 offset-1 text-center\">Conheça nosso empreendimento.</h4></div></div></div><div class=\"infos col-sm-11 col-lg-6 col-xl-8\"><div id=map-detail class=map></div></div><div class=\"infos col-sm-12 col-lg-6 col-xl-8\"><h2 class=title-desc>Informações Gerais</h2><p class=info-desc>{{vm.listing.imv_obs}}</p></div><div class=\"infos col-sm-12 col-lg-6 col-xl-8\" ng-show=vm.listing.comodidades.length><h2 class=title-desc>Ficha técnica</h2><ul class=\"comodidades c-ap col-12\"><li class=\"col-12 col-sm-4 d-inline-block\" ng-repeat=\"c in vm.listing.comodidades | orderBy:\'comodidade.cmd_nome\'\" ng-show=c.cmd_id><i class={{c.comodidade.cmd_icone}}></i>&nbsp{{c.comodidade.cmd_nome}}</li></ul></div></div></div></div><div id=share class=\"btns-share d-flex flex-wrap align-items-center pl-4 pl-md-0\"><a class=\"btn-face btn-share btn button\" href=# socialshare socialshare-provider=facebook socialshare-text=\"Arbo Imóveis\" socialshare-hashtags=\"\" socialshare-url={{vm.getLocation()}}><i class=\"fab fa-facebook-f mr-md-1\"></i> <span class=\"d-none d-md-inline\">Facebook</span> </a><a class=\"btn-whats btn-share btn button\" href=# socialshare socialshare-provider=whatsapp socialshare-text=\"Arbo Imóveis\" socialshare-url={{vm.getLocation()}}><i class=\"fab fa-whatsapp mr-md-1\"></i> <span class=\"d-none d-md-inline\">WhatsApp</span> </a><a class=\"btn-linkedin btn-share btn button\" href=# socialshare socialshare-provider=linkedin socialshare-text=\"Arbo Imóveis\" socialshare-hashtags=\"\" socialshare-url={{vm.getLocation()}}><i class=\"fab fa-linkedin-in mr-md-1\"></i> <span class=\"d-none d-md-inline\">Linkedin</span> </a><a class=\"btn-pinterest btn-share btn button\" href=# socialshare socialshare-provider=pinterest socialshare-text=\"Arbo Imóveis\" socialshare-media={{vm.listing.fotos[0].imvft_url}} socialshare-url={{vm.getLocation()}}><i class=\"fab fa-pinterest-p mr-md-1\"></i> <span class=\"d-none d-md-inline\">Pinterest</span></a></div><div id=relations class=relations><div class=\"carousel-title d-flex align-items-center\"><p class=\"title-desc title col-12 col-sm-6\">Outros Imóveis que você pode gostar</p><div class=\"col-sm-6 carousel-options d-none d-sm-flex justify-content-sm-end owl-nav\"><button class=\"btn button btn-carousel change-carousel d-none d-md-block prev-img owl-prev\" ng-click=\"vm.prevOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-left\"></i></button> <button class=\"btn button btn-carousel change-carousel d-none d-md-block next-img owl-next\" ng-click=\"vm.nextOwl(\'carousel-similares\')\"><i class=\"fal fa-chevron-right\"></i></button></div></div><ng-owl-carousel id=carousel-venda class=\"owl-theme d-flex flex-fill\" owl-items=vm.relacionados owl-properties=vm.owlProperties owl-ready=vm.readyVenda($api)><div ng-repeat=\"listing in vm.relacionados | orderBy:[\'precoVenda\',\'precoLocacao\']\" ng-mouseenter=\"vm.highlight($event, listing)\" ng-mouseleave=\"vm.highlight($event, listing)\" class=\"result-item d-flex flex-column item px-2\" data-id=\"{{ listing.id }}\" style=\"width: 100%\"><a href={{vm.makeUrl(listing)}} class=result ng-mousedown=vm.showListing(listing) ng-class=\"{\'result-hover\': listing.hover}\"><div id=\"carousel-2-{{ listing.id }}\" class=\"carousel slide\" data-pause=true><ol class=carousel-indicators><li data-target=\"#carousel-2-{{ listing.id }}\" data-slide-to={{$index}} ng-repeat=\"foto in listing.imgThumb | limitTo:7\" ng-class=\"{\'active\': !($index)}\"></li></ol><div class=\"carousel-inner w-100\"><div class=carousel-item ng-repeat=\"foto in listing.imgThumb | limitTo:7\" ng-style=\"{ \'width\': \'100%\', \'height\': \'100%\'}\" ng-class=\"{\'active\': !($index)}\"><img src=\"{{!($index) ? foto.imvft_url : \'\'}}\" alt=\"{{foto.tipo_foto ? foto.tipo_foto.tfoto_nome : \'Foto do \' + listing.tipo_imovel.timv_nome}} | {{listing.imv_titulo}} - {{listing.imobiliaria.imb_nome}} | {{vm.config_wl.nome}}\" data-img=\"{{($index) ? foto.imvft_url : \'\'}}\" class=d-block on-error-src={{vm.createThumb.removeWmk(foto.imvft_url)}}></div><div class=\"carousel-item border\" ng-if=!(listing.imgThumb.length) style=\"display: block; width: 100%; height: 100%; background-image: url(\'./assets/images/novosite/fallback.png\')\"></div></div><a class=carousel-control-prev ng-show=(listing.imgThumb.length) data-target=\"#carousel-2-{{ listing.id }}\" data-slide=prev><span class=carousel-control-prev-icon aria-hidden=true></span> <span class=sr-only>Previous</span> </a><a class=carousel-control-next ng-show=(listing.imgThumb.length) data-target=\"#carousel-2-{{ listing.id }}\" data-slide=next><span class=carousel-control-next-icon aria-hidden=true></span> <span class=sr-only>Next</span></a></div><div class=icon-favorite><button type=button class=\"btn button button-transparent ml-auto\" id=favorite-{{listing.id}} aria-busy=false><i class=\"fal fa-heart\" ng-show=!listing.isFavorite ng-click=vm.setFavorite(listing)></i> <i class=\"fas fa-heart\" ng-show=listing.isFavorite ng-click=vm.unsetFavorite(listing)></i></button></div></a><a href={{vm.makeUrl(listing)}} class=result ng-mousedown=vm.showListing(listing) ng-class=\"{\'result-hover\': listing.hover}\"><div class=result-description itemscope itemtype=\"{{listing.timv_id == 1 ? \'http://schema.org/Apartment\' : \'http://schema.org/Residence\'}}\"><div class=row><div class=\"row col-12\"><p itemprop=name class=\"title col-12\">{{ listing.subtipo_imovel.stimv_nome }}</p><em class=\"cod col-6\">cód. {{ listing.imv_cod_gaia }}</em></div><p class=\"address col-8\">{{ listing.imv_endereco }}</p><p class=\"imobiliaria col-8\">{{ listing.imobiliaria.imb_nome +\' \'+ listing.imobiliaria.imb_creci }}</p><div class=\"row col-12\"><div class=\"comodidades col-7 row\"><div class=col><i class=\"fal fa-ruler-triangle\"></i><p>{{ listing.imv_area_util ? listing.imv_area_util : \'-\'}} <span>m<sup>2</sup></span></p></div><div class=col><i class=\"fal fa-bed\"></i><p>{{ listing.imv_qtd_dorm ? listing.imv_qtd_dorm : \'-\' }}</p></div><div class=col><i class=\"fal fa-shower\"></i><p>{{ listing.imv_qtd_banheiros ? listing.imv_qtd_banheiros : \'-\'}}</p></div><div class=col><i class=\"fal fa-car\"></i><p>{{ listing.imv_qtd_vagas ? listing.imv_qtd_vagas : \'-\'}}</p></div></div><div class=\"offer-info col-5\"><p class=\"offer-cond {{listing.imv_preco_cond ? \'visible\' : \'invisible\'}}\">Condomínio<br>R$ {{ vm.formatPrice(listing.imv_preco_cond) }}</p><div class=offer-contaner itemprop=offers itemscope itemtype=http://schema.org/Offer ng-show=\"(listing.type === \'para-alugar\' && listing.type !== \'a-venda\') && (listing.imv_preco_locacao != null) || (listing.type == undefined && listing.imv_preco_locacao != null && listing.imv_preco_venda == null)\"><em class=offer itemprop=price><span>R$</span> {{ vm.formatPrice( listing.imv_preco_locacao ) }}</em></div><div class=offer-contaner itemprop=offers itemscope itemtype=http://schema.org/Offer ng-show=\"(listing.type !== \'para-alugar\' && listing.type === \'a-venda\') && (listing.imv_preco_venda != null) || (listing.type == undefined && listing.imv_preco_venda != null)\"><em class=offer itemprop=price><span>R$</span> {{ vm.formatPrice( listing.imv_preco_venda ) }}</em></div></div></div></div></div></a></div></ng-owl-carousel></div></div>");
$templateCache.put("app/components/listingDetail/modalVisit.html","<section id=box-modal-visit><header><h1 tabindex=-1 class=title-modal-visit>Entrar em contato</h1></header><main><div ng-if=\"vm.message && !vm.error_submit\"><div class=message ng-bind-html=vm.message></div></div><form action=\"\" name=formagendamento class=\"form col-12 col-md-10 p-0 m-1\" ng-submit=vm.submit($event) ng-if=\"!vm.finished && !vm.succ\"><div class=\"links d-flex flex-column\"><div class=form-group><div class=\"row mb-3\"><input type=text id=name class=\"form-control upper\" ng-model=vm.form.cliente ng-change=checkField() required placeholder=\"Escreva seu nome\"><label for=name class=\"pl-3 upper\">Nome</label></div><div class=\"row mb-3\"><input type=tel id=phone class=\"form-control upper\" ng-model=vm.form.telefone data-mask=\"(99) 9?9999-9999\" ui-br-phone-number-mask required pattern=\"\\([0-9]{2}\\) [9]?[0-9]{4}-[0-9]{4}$\" placeholder=\"(00) 9 9999-9999\"><label for=phone class=\"pl-3 upper\">Telefone</label></div><div class=\"row mb-3\"><input type=email id=email class=\"form-control upper\" ng-model=vm.form.email ng-change=checkField() required placeholder=email@dominio.com><label for=email class=\"pl-3 upper\">E-mail</label></div><div class=\"row mb-3 position-relative\" ng-if=!pageContato><div class=\"row col-8 p-0\"><input type=date id=date class=\"form-control upper\" ng-model=vm.form.visita_data min=\"{{ vm.today }}\" max=9999-12-31 required><label for=date class=\"pl-3 upper\">Data</label></div><div class=\"row col p-0\"><input type=time id=time class=\"form-control upper\" ng-model=vm.form.visita_hora required><label for=time class=\"pl-3 upper\">Hora</label></div></div><div class=\"d-flex col-12 px-0\" ng-if=vm.config_wl.isArbo><input type=checkbox id=form-contact-check name=detail-co class=\"input-control square abs\" ng-model=vm.form.card_accept_terms ng-true-value=true ng-false-value=false><label for=form-contact-check class=\"checkbox col-12\"><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> .</span></label></div></div><div class=box-addr>{{ vm.listing.imv_endereco }} <span ng-if=!vm.listing.imobiliaria.imb_hidden_cond_num>, {{ vm.listing.imv_end_numero }}</span> - {{ vm.listing.imv_bairro }} - {{ vm.listing.imv_cidade }}/{{ vm.listing.imv_estado }}</div><div class=listValores><ul class=\"offers mt-3\" itemprop=offers itemscope itemtype=http://schema.org/Offer><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_venda><div class=valueVenda ng-if=\"vm.listing.timv_id != 36\">Venda</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio de venda</div><div class=\"text-right valueNumber\" itemprop=price>R$ {{ vm.listing.imv_preco_venda | number: \'0\' }}<meta itemprop=priceCurrency content=BRL></div></li><li class=\"highlight d-flex justify-content-between\" ng-if=vm.listing.imv_preco_locacao><div class=valueAluguel ng-if=\"vm.listing.timv_id != 36\">Aluguel</div><div ng-if=\"vm.listing.timv_id == 36\">Valor médio do Aluguel</div><div class=\"text-right valueNumber\" itemprop=price>R$ {{ vm.listing.imv_preco_locacao | number: \'0\' }}<meta itemprop=priceCurrency content=BRL></div></li></ul></div><div class=boxProx><button type=submit class=\"btn active btn-proximo-visit\" role=button ng-disabled=\"vm.loading || (vm.config_wl.isArbo && !vm.form.card_accept_terms)\"><span ng-if=!vm.loading>Enviar</span> <span ng-if=vm.loading ng-bind-html=\"(vm.msg_submit ? vm.msg_submit : vm.spinner)\" class=font-weight-bold></span></button></div></div></form></main></section>");
$templateCache.put("app/components/listingDetail/share.html","<section id=box-share><header><h1 tabindex=-1 class=title>Compartilhar</h1></header><main><div class=\"links d-flex flex-column\"><div class=link><i class=\"fab fa-facebook-square\"></i> <a ng-href={{urlFacebook}} target=_blank>Facebook</a></div><div class=link><i class=\"fab fa-twitter-square\"></i> <a ng-href={{urlTwitter}} target=_blank>Twitter</a></div><div class=link><i class=\"fab fa-whatsapp-square\"></i> <a ng-href={{urlWhatsapp}} target=_blank>Whatsapp</a></div><div class=link><i class=\"fas fa-envelope-square\"></i> <a ng-href={{urlMail}}>Email</a></div><div class=link><i class=\"fas fa-clone\"></i> <span ng-click=copyPaste() ng-bind=\"textCopy || \'Copiar Link\'\"></span></div></div></main></section>");
$templateCache.put("app/components/home/home.html","<main id=home><section ng-if=\"vm.config_wl.imb_config_site.toggle_carousel != true || !vm.config_wl.imb_config_site.carousel.length\" class=\"home-main-img d-flex flex-column justify-content-end justify-content-lg-center\" ng-style=\"{\'background-image\': \'url({{vm.config_wl.url_capa}})\'}\" ng-class=\"{\'home-full\': (vm.config_wl.imb_config_site.busca_home == false) }\"><div ng-class=\"{\'bg-shadow\': !vm.config_wl.isArbo}\"></div><div class=texts><h3 class=\"text title d-sm-block\" ng-bind-html=vm.config_wl.imb_config_site.titulo></h3><p class=text ng-bind-html=vm.config_wl.imb_config_site.sub_titulo></p></div><form class=\"form-inline ml-auto mr-auto top-form\" ng-if=\"vm.config_wl.imb_config_site.busca_home != false && !vm.isMobile()\" ng-submit=vm.search($event)><div class=\"form-group col-12 col-sm-12\"><div class=\"home-search input-group col-12\"><div class=\"col px-0 d-flex navbar justify-content-start p-0\"><div id=finalidade class=\"dropdown-box c-pointer\"><input type=text ng-model=vm.finalidade uib-typeahead=\"finalidade as finalidade.label for finalidade in vm.finalidades\" placeholder=Finalidade typeahead-focus-first=false class=\"form-control c-pointer fin\" typeahead-min-length=0 ng-readonly=true style=\"max-width: 180px;margin-left: 10px\"> <i class=\"fa fa-chevron-down fin\" aria-hidden=true></i></div><div id=tipoimovel class=\"dropdown-box c-pointer\"><input type=text ng-model=vm.tipo uib-typeahead=\"tipo as tipo.label for tipo in vm.tipoImovel\" typeahead-focus-first=false typeahead-min-length=0 placeholder=\"Tipo de Imóvel\" class=\"form-control c-pointer tip\" ng-readonly=true style=\"max-width: 180px\"> <i class=\"fa fa-chevron-down tip\" aria-hidden=true></i></div><div class=\"col citysearch\"><input id=input-city-home type=text class=form-control ng-model=vm.busca ng-model-options=\"{allowInvalid: true, debounce: 200}\" ng-class=\"{\'d-none\': vm.codCheck}\" placeholder=\"Digite a cidade, bairro ou rua\" style=\"width: 100%;padding-left: 20px\" typeahead-on-select=vm.clickSelect($item) typeahead-focus-first=false uib-typeahead=\"address as address.description for address in vm.getLocation($viewValue)\" typeahead-popup-template-url=app/components/typeahead/customPopupTemplate.html typeahead-template-url=app/components/typeahead/customTemplate.html typeahead-show-hint=true typeahead-min-length=1 oninput=\"this.value = this.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ_0-9,\\-\\ ]/g, \'\')\"></div></div><div class=input-group-prepend style=\"border: 0;background-color: var(--secondary-color) !important;border-radius: 0 80px 80px 0;display: -ms-flexbox;display: flex;-ms-flex-align: center;align-items: center;font-size: 18px;font-weight: 600;color: #fff\"><button type=submit style=\"padding: 0px 50px;padding-bottom: 2px\" class=\"btn button btn-white\"><span ng-if=!vm.loaderSearch style=\"font-size: 18px;font-weight: 600;color: #fff\">Buscar</span><div ng-if=vm.loaderSearch class=loader__dots><span class=\"loader__dot pulse pulse__one\"></span><span class=\"loader__dot pulse pulse__two\"></span><span class=\"loader__dot pulse pulse__three\"></span></div></button></div></div></div></form><div class=\"anuncio d-none d-lg-block\" ng-if=vm.config_wl.imb_angariadora><a ui-sref=main.registerimovel ng-if=!vm.config_wl.isArbo>Anuncie seu imóvel</a> <a href=https://mkt.arboimoveis.com.br/anuncie-seu-imovel/ style=color:var(--primary-color) target=_blank ng-if=vm.config_wl.isArbo>Anuncie seu imóvel</a></div></section><section ng-if=\"vm.config_wl.imb_config_site.toggle_carousel == true && vm.config_wl.imb_config_site.carousel.length\" class=\"home-main-img d-flex flex-column justify-content-end justify-content-lg-center\" ng-class=\"{\'home-full\': (vm.config_wl.imb_config_site.busca_home == false) }\"><div class=\"nav-carousel d-none d-lg-flex justify-content-between align-items-center\"><button class=\"carousel-direction prev-carousel d-flex justify-content-center align-items-center\" ng-click=vm.prevOwlHome()><i class=\"fal fa-chevron-left\"></i></button> <button class=\"carousel-direction next-carousel d-flex justify-content-center align-items-center\" ng-click=vm.nextOwlHome()><i class=\"fal fa-chevron-right\"></i></button></div><ng-owl-carousel id=carousel-images class=\"owl-theme d-flex flex-fill\" style=\"height: 100%; width: 100%; top: 0; left: 0; position: absolute\" owl-items=vm.config_wl.imb_config_site.carousel owl-properties=vm.owlPropertiesSection owl-ready=vm.readyCarousel($api)><div ng-repeat=\"listing in vm.config_wl.imb_config_site.carousel | orderBy:[\'order\']\" class=div-carousel><div ng-class=\"{\'bg-carousel\': !vm.config_wl.isArbo}\" ng-style=\"{\'background-image\': \'url({{listing.img}})\'}\"></div><div class=texts><h3 class=\"text title d-sm-block\" ng-bind-html=listing.title></h3><p class=text ng-bind-html=listing.subtitle></p><a ng-href={{listing.url_btn}} target=_blank ng-if=listing.text_btn class=\"btn btn-default button btn-cta mt-3\" ng-bind-html=listing.text_btn></a></div></div></ng-owl-carousel></section><section ng-if=\"vm.config_wl.imb_config_site.toggle_carousel == true && vm.config_wl.imb_config_site.busca_home == true && !vm.isMobile()\" class=\"home-main-img home-main-search d-flex flex-column justify-content-end justify-content-lg-center\"><div class=texts><h3 class=\"text title d-sm-block\" ng-bind-html=vm.config_wl.imb_config_site.titulo></h3><p class=text ng-bind-html=vm.config_wl.imb_config_site.sub_titulo></p></div><form class=\"form-inline ml-auto mr-auto top-form\" ng-submit=vm.search($event)><div class=\"form-group col-12 col-sm-12\"><div class=\"home-search input-group col-12\"><div class=\"col px-0 d-flex navbar justify-content-start p-0\"><div id=finalidade class=\"dropdown-box c-pointer\"><input type=text ng-model=vm.finalidade uib-typeahead=\"finalidade as finalidade.label for finalidade in vm.finalidades\" placeholder=Finalidade typeahead-focus-first=false class=\"form-control c-pointer fin\" typeahead-min-length=0 ng-readonly=true style=\"max-width: 180px;margin-left: 10px\"> <i class=\"fa fa-chevron-down fin\" aria-hidden=true></i></div><div id=tipoimovel class=\"dropdown-box c-pointer\"><input type=text ng-model=vm.tipo uib-typeahead=\"tipo as tipo.label for tipo in vm.tipoImovel\" typeahead-focus-first=false typeahead-min-length=0 placeholder=\"Tipo de Imóvel\" class=\"form-control c-pointer tip\" ng-readonly=true style=\"max-width: 180px\"> <i class=\"fa fa-chevron-down tip\" aria-hidden=true></i></div><div class=\"col citysearch\"><input id=input-city-home type=text class=form-control ng-model=vm.busca ng-model-options=\"{allowInvalid: true, debounce: 200}\" ng-class=\"{\'d-none\': vm.codCheck}\" placeholder=\"Digite a cidade, bairro ou rua\" style=\"width: 100%;padding-left: 20px\" typeahead-on-select=vm.clickSelect($item) typeahead-focus-first=false uib-typeahead=\"address as address.description for address in vm.getLocation($viewValue)\" typeahead-popup-template-url=app/components/typeahead/customPopupTemplate.html typeahead-template-url=app/components/typeahead/customTemplate.html typeahead-show-hint=true typeahead-min-length=1></div></div><div class=input-group-prepend style=\"border: 0;background-color: var(--secondary-color) !important;border-radius: 0 80px 80px 0;display: -ms-flexbox;display: flex;-ms-flex-align: center;align-items: center;font-size: 18px;font-weight: 600;color: #fff\"><button type=submit style=\"padding: 0px 50px;padding-bottom: 2px\" class=\"btn button btn-white\"><span ng-if=!vm.loaderSearch style=\"font-size: 18px;font-weight: 600;color: #fff\">Buscar</span><div ng-if=vm.loaderSearch class=loader__dots><span class=\"loader__dot pulse pulse__one\"></span><span class=\"loader__dot pulse pulse__two\"></span><span class=\"loader__dot pulse pulse__three\"></span></div></button></div></div></div></form><div class=\"anuncio d-none d-lg-block\" ng-if=vm.config_wl.imb_angariadora><a ui-sref=main.registerimovel ng-if=!vm.config_wl.isArbo>Anuncie seu imóvel</a> <a href=https://mkt.arboimoveis.com.br/anuncie-seu-imovel/ target=_blank ng-if=vm.config_wl.isArbo>Anuncie seu imóvel</a></div></section><section class=section-btn-mobile><div class=\"btn-cadastro-home w-100\"><div class=btns-proposta><button class=\"btn button btn-proposta col-12 d-inline-block d-sm-none\" ui-sref=main.propostacompra.form>Proposta de compra!</button> <button class=\"btn button btn-proposta col-12 d-inline-block d-sm-none\" ui-sref=main.proposta.form>Proposta de locação!</button></div><div class=\"grey-area d-none\" ng-if=\"vm.config_wl.imb_config_site.busca_home != false && vm.isMobile()\"><div class=formMobile><form ng-submit=vm.search($event)><div class=line><div id=finalidade class=\"dropdown-box c-pointer\" style=\"width: 50%;margin-right: 3px\"><input type=text ng-model=vm.finalidade typeahead-focus-first=false uib-typeahead=\"finalidade as finalidade.label for finalidade in vm.finalidades\" placeholder=Finalidade class=\"form-control c-pointer fin\" typeahead-min-length=0 ng-readonly=true> <i class=\"fa fa-chevron-down fin\" aria-hidden=true></i></div><div id=tipoimovel class=\"dropdown-box c-pointer\" style=\"width: 50%;margin-left: 3px\"><input type=text ng-model=vm.tipo typeahead-focus-first=false uib-typeahead=\"tipo as tipo.label for tipo in vm.tipoImovel\" typeahead-min-length=0 placeholder=\"Tipo de Imóvel\" class=\"form-control c-pointer tip\" ng-readonly=true> <i class=\"fa fa-chevron-down tip\" aria-hidden=true></i></div></div><div class=line><div class=citysearch style=\"width: 100%\"><input id=input-city-home type=text class=form-control ng-model=vm.busca ng-model-options=\"{allowInvalid: true, debounce: 200}\" ng-class=\"{\'d-none\': vm.codCheck}\" placeholder=\"Digite a cidade, bairro ou rua\" style=\"width: 100%;padding-left: 20px;border: 0px transparent\" typeahead-on-select=vm.clickSelect($item) typeahead-focus-first=false uib-typeahead=\"address as address.description for address in vm.getLocation($viewValue)\" typeahead-popup-template-url=app/components/typeahead/customPopupTemplate.html typeahead-template-url=app/components/typeahead/customTemplate.html typeahead-show-hint=true typeahead-min-length=1></div></div><div class=line><button type=submit class=\"btn button btn-white\" style=\"width: 100%\"><span ng-if=!vm.loaderSearch style=\"font-size: 18px;font-weight: 600;color: #fff\">Buscar</span><div ng-if=vm.loaderSearch class=loader__dots><span class=\"loader__dot pulse pulse__one\"></span><span class=\"loader__dot pulse pulse__two\"></span><span class=\"loader__dot pulse pulse__three\"></span></div></button></div><div class=line><a class=anuncio ui-sref=main.registerimovel ng-if=!vm.config_wl.isArbo>Anuncie seu imóvel</a> <a class=anuncio href=https://mkt.arboimoveis.com.br/anuncie-seu-imovel/ ng-if=vm.config_wl.isArbo>Anuncie seu imóvel</a></div></form></div></div></div></section><div class=\"pagebody container\" style=\"padding-right: 10px; padding-left: 10px\"><section ng-if=vm.config_wl.isArbo class=\"carousels pb-0\" data-aos=fade-up><carousel-imovel navegator=true title-carousel=\"Imóveis recentes à venda\" properties=vm.owlProperties imoveis=vm.new_venda ng-if=(vm.new_venda.length)></carousel-imovel><carousel-imovel navegator=true title-carousel=\"Imóveis recentes para alugar\" properties=vm.owlProperties imoveis=vm.new_locacao ng-if=(vm.new_locacao.length)></carousel-imovel></section><section ng-if=vm.config_wl.isArbo class=\"subsections d-flex flex-column\" data-aos=fade-up><div class=header-subsection><div class=\"title-sub c-pointer\" ng-class=\"{\'active\': (vm.subsection === 1)}\" ng-click=\"vm.subsection = 1\"><h1 ng-class=\"{\'active\': (vm.subsection === 1)}\">Quero um novo imóvel</h1></div><div class=\"title-sub c-pointer\" ng-class=\"{\'active\': (vm.subsection === 2)}\" ng-click=\"vm.subsection = 2\"><h1 ng-class=\"{\'active\': (vm.subsection === 2)}\">Quero vender meu imóvel</h1></div><div class=\"title-sub c-pointer\" ng-class=\"{\'active\': (vm.subsection === 3)}\" ng-click=\"vm.subsection = 3\"><h1 ng-class=\"{\'active\': (vm.subsection === 3)}\">Quero ser parceiro</h1></div></div><ng-owl-carousel id=carousel-subsection class=\"owl-theme d-flex flex-fill pb-2\" owl-items=[] owl-properties=vm.owlSubsection owl-ready=vm.readySubsection($api) ng-show=\"vm.subsection === 1\"><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-1.png alt=\"\"><div class=text><span class=headtitle>Busca por mapa, fácil navegação e variedade de imóveis.</span> <span class=description>Encontre agora mesmo, de forma rápida e simples, imóveis para morar ou investir. Opções na planta ou prontos para morar.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-2.png alt=\"\"><div class=text><span class=headtitle>Equipe de corretores especializada, propostas online, e negociação simples.</span> <span class=description>Aqui é sem burocracia. Você tem apoio de profissionais na hora de negociar e lança a proposta online, de onde estiver.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-3.png alt=\"\"><div class=text><span class=headtitle>Contrato com assinatura online, compre seu imóvel sem sair de casa.</span> <span class=description>Aluguel e compra rápida. Nosso contrato é digital, com assinatura em até 48h. Você fecha o negócio online e só se desloca para pegar as chaves!</span></div></div></ng-owl-carousel><ng-owl-carousel id=carousel-subsection class=\"owl-theme d-flex flex-fill pb-2\" owl-items=[] owl-properties=vm.owlSubsection owl-ready=vm.readySubsection($api) ng-show=\"vm.subsection === 2\"><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-4.png alt=\"\"><div class=text><span class=headtitle>Anuncie seu imóvel de maneira rápida e fácil.</span> <span class=description>Prezamos pela facilidade. Você preenche o formulário do imóvel com detalhes do apartamento, da casa ou do terreno e nós cuidamos do resto pra você.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-5.png alt=\"\"><div class=text><span class=headtitle>Suporte de equipe profissional.</span> <span class=description>Nossa equipe oferece suporte completo e integral. Auxiliamos na avaliação e descrição do imóvel, além de serviços de anúncios, marketing e tratativas de venda e negociação.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-6.png alt=\"\"><div class=text><span class=headtitle>Segurança e garantia com o seu investimento.</span> <span class=description>Oferecemos equipe completa com suporte de vendas e assistência jurídica para garantir tranquilidade e segurança para você e para seus negócios imobiliários.</span></div></div></ng-owl-carousel><ng-owl-carousel id=carousel-subsection class=\"owl-theme d-flex flex-fill pb-2\" owl-items=[] owl-properties=vm.owlSubsection owl-ready=vm.readySubsection($api) ng-show=\"vm.subsection === 3\"><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-7.png alt=\"\"><div class=text><span class=headtitle>Sou Imobiliária e quero ser Arbo.</span> <span class=description>Entre para o novo mercado imobiliário. Oferecemos gestão de catálogos de imóveis, corretores, leads, além de serviços de TI, marketing e central de atendimento.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-8.png alt=\"\"><div class=text><span class=headtitle>Sou Incorporadora e quero ser Arbo.</span> <span class=description>Automatize e tenha um controle dos seus leads e do seu atendimento com ferramentas de CRM, big data e customer success. Oferecemos também equipe de TI e marketing.</span></div></div><div class=post><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-9.png alt=\"\"><div class=text><span class=headtitle>Sou Corretor e quero ser Arbo.</span> <span class=description>Nossa sistema cuida dos processos administrativos para você se concentrar no que mais importa: as negociações. Indique a Arbo para sua imobiliária ou entre em contato com nossas imobiliárias parceiras da sua região.</span></div></div></ng-owl-carousel><div class=\"buttons row col-12 d-flex justify-content-center\" style=\"padding-top: 5px\" ng-if=\"vm.subsection === 1\"><a ng-click=vm.search($event) href=/imoveis/a-venda class=\"btn btn-outline c-pointer\">Buscar Imóveis</a></div><div class=\"buttons row col-12 d-flex justify-content-center\" style=\"padding-top: 5px\" ng-if=\"vm.subsection === 2\"><a href=/cadastre-seu-imovel class=\"btn btn-outline\">Anunciar meu Imóvel</a></div><div class=\"buttons row col-12 d-flex justify-content-center\" style=\"padding-top: 5px\" ng-if=\"vm.subsection === 3\"><a href=/fale-conosco class=\"btn btn-outline\">Entrar em contato</a></div></section><section class=\"container-fluid p-0 d-flex\" ng-if=!vm.config_wl.isArbo ng-repeat=\"section in vm.config_wl.configwl[\'SECTION-HOME\']\" ng-bind-html=vm.trustHTML(section.valor)></section><section ng-if=\"!vm.config_wl.isArbo && vm.imb_destaques\" class=pb-0 data-aos=fade-up><carousel-imovel ng-if=\"(vm.imb_destaques.length) && vm.config_wl.imb_config_site.toggle_destaques != false && vm.config_wl.imb_config_site.destaques_tipo == 1\" imb_config_site navegator=true title-carousel=\"{{ vm.config_wl.imb_config_site.destaques_titulo || \'Imóveis que você vai amar\'}}\" properties=vm.owlProperties imoveis=vm.imb_destaques></carousel-imovel><carousel-imovel-destaques ng-if=\"(vm.imb_destaques.length) && vm.config_wl.imb_config_site.toggle_destaques != false && vm.config_wl.imb_config_site.destaques_tipo != 1\" navegator=true title-carousel=\"{{ vm.config_wl.imb_config_site.destaques_titulo || \'Imóveis que você vai amar\'}}\" properties=vm.owlDestaques imoveis=vm.imb_destaques></carousel-imovel-destaques></section><section ng-if=vm.config_wl.isArbo class=cities-filter><div data-aos=fade-up><h2 class=title>Você já pode nos encontrar em {{vm.numeroCidades}} cidades!</h2><h3 class=chamada><span>No nosso portal, você encontra imóveis na planta e imóveis prontos para morar.</span> <span>Comece a busca pelo seu novo investimento:</span></h3></div><div class=cidades data-aos=fade-up><div class=cidade><h3 class=nomecidade><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'curitiba-pr\' })\">Curitiba - PR</a></h3><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'curitiba-pr\' })\"><img src=https://static-arbo.s3-sa-east-1.amazonaws.com/assets/Estufa-Jardim-Botanico-Curitiba-out.jpg alt=curitiba-pr class=fotocidade></a><div class=bairros><span class=chamada></span><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'agua-verde-curitiba-pr\'})\" class=bairro title=\"Apartamentos no Água verde\">Apartamentos no Água verde</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'centro-curitiba-pr\'})\" class=bairro title=\"Apartamentos no Centro\">Apartamentos no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'portao-curitiba-pr\'})\" class=bairro title=\"Apartamentos no portão\">Apartamentos no portão</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'bigorrilho-curitiba-pr\'})\" class=bairro title=\"Apartamentos no Bigorrilho\">Apartamentos no Bigorrilho</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'batel-curitiba-pr\'})\" class=bairro title=\"Apartamentos no Batel\">Apartamentos no Batel</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'agua-verde-curitiba-pr\'})\" class=bairro title=\"Casas no Água verde\">Casas no Água verde</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'centro-curitiba-pr\'})\" class=bairro title=\"Casas no Centro\">Casas no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'portao-curitiba-pr\'})\" class=bairro title=\"Casas no portão\">Casas no portão</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'bigorrilho-curitiba-pr\'})\" class=bairro title=\"Casas no Bigorrilho\">Casas no Bigorrilho</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'batel-curitiba-pr\'})\" class=bairro title=\"Apartamentos no Batel\">Casas no Batel</a></div></div><div class=cidade><h3 class=nomecidade><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'sao-paulo-sao-paulo-sp\' })\">São Paulo - SP</a></h3><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'sao-paulo-sao-paulo-sp\' })\"><img src=https://static-arbo.s3-sa-east-1.amazonaws.com/assets/1280px-Ponte_estaiada_Octavio_Frias_-_Sao_Paulo.jpg alt=\"sao paulo-sp\" class=fotocidade></a><div class=bairros><span class=chamada></span> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'vila-mariana-vila-mariana-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos na Vila Mariana\">Apartamentos na Vila Mariana</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'pinheiros-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos no Pinheiros\">Apartamentos no Pinheiros</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'perdizes-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos no Perdizes\">Apartamentos no Perdizes</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'bela-vista-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos no Bela Vista\">Apartamentos no Bela Vista</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'rua-rubens-porta-nova-barra-funda-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos na Barra Funda\">Apartamentos na Barra Funda</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'brooklin-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos no Brooklin\">Apartamentos no Brooklin</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'campo-belo-sao-paulo-sp\'})\" class=bairro title=\"Apartamentos no Campo Belo\">Apartamentos no Campo Belo</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'pinheiros-sao-paulo-sp\'})\" class=bairro title=\"Casas no Pinheiros\">Casas no Pinheiros </a><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'perdizes-sao-paulo-sp\'})\" class=bairro title=\"Casas no Perdizes\">Casas no Perdizes</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'brooklin-sao-paulo-sp\'})\" class=bairro title=\"Casas no Brooklin\">Casas no Brooklin</a></div></div><div class=cidade><h3 class=nomecidade><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'balneario-camboriu-sc\' })\">Balneário Camboriú - SC</a></h3><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'balneario-camboriu-sc\' })\"><img src=https://static-arbo.s3-sa-east-1.amazonaws.com/assets/Panorama_Balne%E2%94%9C%D0%B1rio_Cambori%E2%94%9C%E2%95%91.jpg alt=\"balneario camboriu-sc\" class=fotocidade></a><div class=bairros><span class=chamada></span><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'centro-balneario-camboriu-sc\'})\" class=bairro title=\"Apartamentos no Centro\">Apartamentos no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'pioneiros-balneario-camboriu-sc\'})\" class=bairro title=\"Apartamentos no Pioneiros\">Apartamentos no Pioneiros</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'barra-sul-balneario-camboriu-sc\'})\" class=bairro title=\"Apartamentos na Barra Sul\">Apartamentos na Barra Sul</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'praia-brava-itajai-sc\'})\" class=bairro title=\"Apartamentos na Praia Brava\">Apartamentos na Praia Brava</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'praia-das-taquaras-balneario-camboriu-sc\'})\" class=bairro title=\"Apartamentos na Praia das Taquaras\">Apartamentos na Praia das Taquaras</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'centro-balneario-camboriu-sc\'})\" class=bairro title=\"Casas no Centro\">Casas no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'barra-sul-balneario-camboriu-sc\'})\" class=bairro title=\"Casas na Barra Sul\">Casas na Barra Sul</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'praia-das-taquaras-balneario-camboriu-sc\'})\" class=bairro title=\"Casas na Praia das Taquaras\">Casas na Praia das Taquaras</a></div></div><div class=cidade><h3 class=nomecidade><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'londrina-pr\' })\">Londrina - PR</a></h3><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'londrina-pr\' })\"><img src=https://static-arbo.s3-sa-east-1.amazonaws.com/assets/09-07-2011_Entardecer_no_lago_Igap%E2%94%9C%E2%94%82_-_Londrina_-_panoramio.jpg alt=londrina-pr class=fotocidade></a><div class=bairros><span class=chamada></span><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'centro-londrina-pr\'})\" class=bairro title=\"Apartamentos no Centro\">Apartamentos no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'gleba-fazenda-palhano-londrina-pr\'})\" class=bairro title=\"Apartamentos na Gleba Palhano\">Apartamentos na Gleba Palhano</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'esperanca-londrina-pr\'})\" class=bairro title=\"Apartamentos no Esperança\">Apartamentos no Esperança</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'terra-bonita-londrina-pr\'})\" class=bairro title=\"Apartamentos no Terra Bonita\">Apartamentos no Terra Bonita</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'bela-suica-londrina-pr\'})\" class=bairro title=\"Apartamentos no Bela Suiça\">Apartamentos no Bela Suiça</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'centro-londrina-pr\'})\" class=bairro title=\"Casas no Centro\">Casas no Centro</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'gleba-fazenda-palhano-londrina-pr\'})\" class=bairro title=\"Casas na Gleba Palhano\">Casas na Gleba Palhano</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'esperanca-londrina-pr\'})\" class=bairro title=\"Casas no Esperança\">Casas no Esperança</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'terra-bonita-londrina-pr\'})\" class=bairro title=\"Casas no Terra Bonita\">Casas no Terra Bonita</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'bela-suica-londrina-pr\'})\" class=bairro title=\"Casas no Bela Suiça\">Casas no Bela Suiça</a></div></div><div class=cidade><h3 class=nomecidade><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'maringa-pr\' })\">Maringá - PR</a></h3><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'maringa-pr\' })\"><img src=https://static-arbo.s3-sa-east-1.amazonaws.com/assets/Maring%E2%94%9C%D0%B1_(5459246839).jpg alt=maringa-pr class=fotocidade></a><div class=bairros><span class=chamada></span><a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'zona-07-maringa-pr\'})\" class=bairro title=\"Apartamentos na Zona 7\">Apartamentos na Zona 7</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-type({tipo1: \'a-venda\', tipo2:\'jardim-oriental-maringa-pr\'})\" class=bairro title=\"Apartamentos no Jardim Oriental\">Apartamentos no Jardim Oriental</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'jardim-ipiranga-maringa-pr\'})\" class=bairro title=\"Apartamentos no Jardim Ipiranga\">Apartamentos no Jardim Ipiranga</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'apartamento\', cidade:\'zona-08-maringa-pr\'})\" class=bairro title=\"Apartamentos na Zona 08\">Apartamentos na Zona 08</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'zona-07-maringa-pr\'})\" class=bairro title=\"Casas na Zona 7\">Casas na Zona 7</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'jardim-oriental-maringa-pr\'})\" class=bairro title=\"Casas no Jardim Oriental\">Casas no Jardim Oriental</a> <a ui-sref-opts=\"{reload: true}\" ui-sref=\"main.search-address-ad-build-type({tipovar: \'a-venda\', tipoimovel:\'casa\', cidade:\'zona-08-maringa-pr\'})\" class=bairro title=\"Casas na Zona 08\">Casas na Zona 08</a></div></div></div></section><section class=calls ng-if=\"vm.config_wl.isArbo && vm.calls\" data-aos=fade-up><div class=know-headers><h1 class=title>Levamos o novo mercado imobiliário até você.</h1><h2 class=subtitle>Vender, comprar e locar um imóvel com a Arbo é prático, online e simples.</h2></div><ng-owl-carousel id=carousel-calls class=\"owl-theme d-flex flex-fill pb-2\" owl-items=vm.calls owl-properties=vm.owlCalls owl-ready=vm.readyCall($api)><div class=call ng-repeat=\"ca in vm.calls\"><div class=cardcall><h1 class=title>{{ca.title}}</h1><h2 class=description>{{ca.description}}</h2><button class=\"btn btnbox\" ng-if=!ca.linkbtn ng-click=vm.search($event)><span>{{ca.btn}}</span></button> <a class=\"btn btnbox\" href={{ca.linkbtn}} ng-if=ca.linkbtn><span>{{ca.btn}}</span></a><div class=bottombox><div class=icon ng-bind-html=vm.trustHTML(ca.icon)></div><div class=icontext><button class=btn ng-click=\"vm.nextOwl(\'carousel-calls\')\">PRÓXIMO</button> <span>{{ca.iconcall}}</span></div></div></div><div class=\"photo d-none d-md-block\"><img src={{ca.photo}} alt=\"\"></div></div></ng-owl-carousel></section><section class=carousels><div class=venda data-aos=fade-up ng-if=\"vm.config_wl.imb_config_site.destaques_venda != false\"><carousel-imovel navegator=true title-carousel=\"Imóveis em destaque à venda\" properties=vm.owlProperties imoveis=vm.listingsVenda ng-if=(vm.listingsVenda.length)></carousel-imovel></div><div data-aos=fade-up ng-if=\"vm.config_wl.imb_config_site.destaques_locacao != false\"><carousel-imovel navegator=true title-carousel=\"Imóveis em destaque para alugar\" properties=vm.owlProperties imoveis=vm.listingsLocacao ng-if=(vm.listingsLocacao.length)></carousel-imovel></div></section><section ng-if=vm.config_wl.isArbo class=\"testimoniais d-flex flex-column flex-lg-row\" style=\"padding-top: 0px\" data-aos=fade-up><div class=photo><img src=https://static.arboimoveis.com.br/assets/arbonext/Arbo-ilustracao-3.png alt=\"Arbo imóveis testimoniais\"></div><ng-owl-carousel id=carousel-testimonial class=\"owl-theme d-flex flex-fill pb-2\" owl-items=vm.testimoniais owl-properties=vm.owlTestimoniais owl-ready=vm.readyTestimonial($api)><div class=testimonial ng-repeat=\"t in vm.testimoniais\"><div class=texts><i class=\"fas fa-quote-right\"></i> <span class=description>{{t.text}}</span> <span class=author>{{t.author}}</span> <span ng-if=t.role class=role>{{t.role}}</span></div></div></ng-owl-carousel></section><div class=\"buttons endcall row col-12 d-flex justify-content-center\" style=\"padding-top: 5px\" ng-if=\"vm.config_wl.imb_config_site.busca_home != false\"><a ng-click=vm.search($event) href=/imoveis/a-venda class=\"btn c-pointer\">Buscar Imóveis</a></div></div><section class=\"container-fluid p-0 d-flex\" ng-if=!vm.config_wl.isArbo ng-repeat=\"section in vm.config_wl.configwl[\'SECTION-FOOTER\']\" ng-bind-html=vm.trustHTML(section.valor)></section><section class=container ng-show=vm.listopened.length><h2 class=title-link>Pesquisas mais populares:</h2><nav><ul class=list-ul-link><li class=list-li-link ng-repeat=\"link in vm.listopened\" ng-bind-html=link></li></ul></nav></section></main>");
$templateCache.put("app/components/listingEmpty/listingEmpty.html","<section id=listing-empty class=\"d-flex flex-row justify-content-around m-auto\"><div class=\"headers col-11 col-lg-6\"><h1 class=title>{{vm.title_page}}</h1><p class=description>Parece que alguém já garantiu este imóvel que está procurando. De qualquer forma, estamos aqui para te ajudar!</p><carousel-imovel imoveis=vm.relacionados properties=vm.customProperties navegator=vm.navegator title-carousel=\"Temos {{vm.relacionados.length > 1 ? \'algumas\' : \'essa\'}} recomendaç{{vm.relacionados.length > 1 ? \'ões\' : \'ão\'}} para você\" ng-if=\"vm.relacionados && vm.relacionados.length\"></carousel-imovel><div class=\"d-flex flex-row flex-wrap justify-content-start\" ng-if=\"vm.tags && vm.tags.length\"><h2 class=title>Você também pode pesquisar imóveis com outras características</h2><div class=\"tags d-flex flex-row flex-wrap justify-content-center justify-content-lg-start\"><a ng-href={{tag.url}} ng-repeat=\"tag in vm.tags track by $index\" class=tag>{{tag.label}}</a></div></div></div><div class=\"images d-none d-lg-flex justify-content-around align-items-center col col-md-4\"><div class=parallax><img class=\"item cidade\" src=/assets/images/novosite/cidade-eita.png srcset=\"\" alt=\"Desenho de quatro prédios, um ao lado do outro. Um deles está incompleto, sem linhas definidas no desenho e contém um ponto de interrogação, dando a entender que é o imóvel não encontrado.\"> <img class=\"item mascote\" src=/assets/images/novosite/marlin-eita.png srcset=\"\" title=\"Mascote Arbo imóveis\" alt=\"Mascote Arbo imóveis olhando para prédios com expressão de dúvida pois o imóvel não foi encontrado\"></div></div></section>");
$templateCache.put("app/components/modal/dialog-forgot.html","<div class=modal-body><div class=main><h3 class=title>Esqueceu sua senha?</h3><p class=decription>Digite seu e-mail que enviaremos um link para definir uma nova senha.</p><form action=\"\" ng-submit=vm.sendNext($event)><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off required placeholder=email@dominio.com><label for=form-email class=\"pl-3 upper\">Endereço de E-mail</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-envelope\"></i></div></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 ml-auto\">Recuperar</button></div></div></form></div><div class=\"footer border-top d-flex justify-content-center\" ng-if=vm.form.alert><span class=\"alert alert-{{vm.form.alert.status}}\">{{vm.form.alert.msg}}</span></div></div>");
$templateCache.put("app/components/modal/dialog-infos.html","<div class=modal-body><div class=main><form name=modalInfos action=\"\"><div class=\"form-group d-flex flex-column flex-wrap\"><h1 style=\"font-size: 20px; color: #3B3B3B; font-weight: bold\">Receba novas informações sobre {{vm.proximidades.brr_nome}}.</h1><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input class=\"form-control upper\" autocomplete=off ng-required=true placeholder=\"Escreva seu nome\"><label for=form-email class=\"pl-3 upper\">Nome</label></div></div><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email name=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off ng-required=true placeholder=email@dominio.com><label for=form-email class=\"pl-3 upper\">Endereço de E-mail</label><div class=\"input-group-prepend d-flex align-items-center\"></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 mx-auto mt-4\">Enviar</button></div></div></form></div></div>");
$templateCache.put("app/components/modal/dialog-invalid-link.html","<div class=\"modal-body modal-error-feedback-proposta\" style=\"justify-content: flex-start\"><div class=main><h3 class=title><i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> O link para a proposta é inválido</h3><div class=decription><p class=px-0>Certifique-se de que a URL acessada é a mesma enviada pelo corretor.</p><p class=px-0>Se o problema persistir, entre em contato com seu corretor e solicite um novo link de proposta para o imóvel desejado.</p></div><div class=\"d-flex flex-column flex-wrap\"><button ng-click=redirect() type=submit class=\"btn button btn-danger btn-small ml-auto\">Entendi</button></div></div></div>");
$templateCache.put("app/components/modal/dialog-login.html","<div class=modal-body><div class=main><form name=modallogin action=\"\" ng-submit=\"modallogin.$valid && vm.sendNext($event, modallogin)\"><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email name=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off ng-required=true placeholder=email@dominio.com><label for=form-email class=\"pl-3 upper\">Endereço de E-mail</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-envelope\"></i></div></div><div ng-messages=\"modallogin[\'form-email\'].$error\" ng-if=\"modallogin[\'form-email\'].$dirty\" role=alert class=ng-message><div ng-message=required>Insira seu E-mail.</div></div><div ng-if=vm.error role=alert class=ng-message><div>Login inválido.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=password id=form-pass name=form-pass class=\"form-control upper\" ng-model=vm.form.password autocomplete=off ng-required=true placeholder=\"Sua Senha\"><label for=form-pass class=\"pl-3 upper\">Senha</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-lock-alt\"></i></div></div><div ng-messages=\"modallogin[\'form-pass\'].$error\" ng-if=\"modallogin[\'form-pass\'].$dirty\" role=alert class=ng-message><div ng-message=required>Insira sua senha.</div></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 mx-auto mt-4\">Entrar</button></div></div><div class=\"forgot d-flex justify-content-center\"><span><a href=# role=button ng-click=vm.sendForgot()>Esqueceu a senha?</a></span></div></form></div><div class=\"footer border-top d-flex justify-content-center\"><span>Você ainda não tem uma conta? <a href=# role=button ng-click=vm.sendRegister()>Cadastre-se</a></span></div></div>");
$templateCache.put("app/components/modal/dialog-register-form.html","<div class=modal-body id=register><div class=main><form name=formRegister ng-submit=vm.sendNext($event,formRegister) novalidate><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"header d-flex justify-content-center\"><h2>Crie a sua conta. É grátis!</h2></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=text id=form-name name=form-name class=\"form-control upper\" ng-model=vm.form.name ng-class=\"{ verificacao: vm.novalid }\" autocomplete=off required minlength=3 placeholder=\"Seu Nome\"><label for=form-name class=\"pl-3 upper\">Nome</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-user\"></i></div></div><div ng-messages=\"formRegister[\'form-name\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Insira o nome.</div><div ng-message=minlength>Nome mínimo é 3 caracteres.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=text id=form-last-name name=form-last-name class=\"form-control upper\" ng-model=vm.form.lastname ng-class=\"{ verificacao: vm.novalid }\" autocomplete=off required minlength=3 placeholder=\"Seu Sobrenome\"><label for=form-last-name class=\"pl-3 upper\">Sobrenome</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-user\"></i></div></div><div ng-messages=\"formRegister[\'form-last-name\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Insira o sobrenome.</div><div ng-message=minlength>Sobrenome mínimo é 3 caracteres.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email name=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off ng-class=\"{ verificacao: vm.novalid }\" required placeholder=email@dominio.com><label for=form-email class=\"pl-3 upper\">Endereço de E-mail</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-envelope\"></i></div></div><div ng-messages=\"formRegister[\'form-email\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Insira o e-mail.</div><div ng-message=email>O e-mail é inválido.</div></div><div ng-if=vm.error role=alert class=ng-message><div>E-mail ja existe.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=tel id=user-telefones name=user-telefones class=\"form-control upper telefone\" ng-model=\"vm.form.telefones[\'numero\']\" ng-class=\"{ verificacao: vm.novalid }\" ui-br-phone-number=areaCode required placeholder=\"(00) 9 9999-9999\"><label for=user-telefones class=\"pl-3 upper\">Telefone<i class=\"fal fa-info-circle ml-2\"></i></label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-phone\"></i></div></div><div ng-messages=\"formRegister[\'user-telefones\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Insira o telefone.</div><div ng-message=brPhoneNumber>O telefone é inválido.</div></div></div><label class=\"d-none row mb-3 newtooltip\">Não divulgaremos seu telefone no site. Usaremos apenas para suas negociações.</label><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=\"{{ inputType }}\" id=form-pass name=form-pass class=\"form-control upper senha\" ng-model=vm.form.password ng-class=\"{ verificacao: vm.novalid }\" autocomplete=off required minlength=6 zxcvbn=passwordStrength placeholder=Password><label for=form-pass class=\"pl-3 upper\">Criar uma senha</label><div class=\"input-group-prepend d-flex align-items-center\" ng-click=vm.showpassword()><i ng-if=\"inputType == \'password\'\" class=\"fal fa-eye\"></i> <i ng-if=\"inputType == \'text\'\" class=\"fal fa-eye-slash\"></i></div></div><div ng-messages=\"formRegister[\'form-pass\'].$error\" ng-if=vm.novalid role=alert class=ng-message><div ng-message=required>Por favor preencha sua Senha.</div><div ng-message=minlength>Senha mínima é 6 caracteres.</div></div></div><label class=\"d-none row mb-3 newtooltipsenha\">Escolha uma senha forte com no minimo 6 caracteres.</label><div class=strength-meter><div class=strength-meter-fill id=meter data-strength=\"{{ passwordStrength.score }}\"></div></div><label class=form-hint for=meter>Força da senha</label><div class=\"form-group form-check text-left ml-4 mb-0\" ng-if=vm.config_wl.isArbo><input class=form-check-input type=checkbox id=form-contact-check name=form-contact-check ng-model=vm.form.usu_accept_terms ng-true-value=true ng-false-value=false><label class=form-check-label for=form-contact-check><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> . </span></label></div><div class=\"d-flex col-12 px-0\"><button class=\"btn button btn-default btn-big col-12 mx-auto mt-4\" ng-disabled=\"(vm.config_wl.isArbo && !vm.form.usu_accept_terms)\">Cadastrar</button></div><div class=\"footer border-top d-flex justify-content-center mt-2\"><span>Já tem uma conta da Arbo? <a href=# role=button ng-click=vm.openModalLogin($event)>Entrar</a></span></div></div></form></div></div>");
$templateCache.put("app/components/newPass/newPass.html","<div id=newPassword class=\"new-password margin-fluid pb-3\"><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Digite sua nova senha.</h3></div><div class=\"new-password-body d-flex align-items-center my-2 m-lg-5\"><form name=newPwdForm class=\"form-login col-10 offset-1 col-sm-6 offset-sm-3 col-lg-4 offset-lg-4\" ng-submit=\"newPwdForm.$valid && vm.send()\"><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=password class=\"form-control upper\" id=form-pwd name=form-pwd ng-model=vm.newPwd autocomplete=off ng-required=true placeholder=\"Nova Senha\"><label for=pwd class=\"pl-3 upper\">Nova senha</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-lock\"></i></div></div><div ng-messages=\"modallogin[\'form-pwd\'].$error\" ng-if=\"modallogin[\'form-pwd\'].$dirty\" role=alert class=ng-message><div ng-message=required>Insira uma senha.</div></div></div></div><button type=submit class=\"btn button btn-default btn-big col-10 offset-1\" ng-click=\"modallogin[\'form-pwd\'].$dirty == true\">ENVIAR</button></form></div></div>");
$templateCache.put("app/components/nps/lead-corretor.nps.html","<div id=npslead><div class=\"row container m-auto\"><div class=\"formulario m-auto\" style=\"max-width: 512px; width: 100%\"><form action=\"\" name=formRegister class=form ng-submit=\"vm.sendNext($event, formRegister)\" ng-show=!vm.formData.send><h1 class=title style=\"font-size: 18px\">Avaliação do Corretor</h1><h2 class=\"title name\" style=\"font-size: 20px\">{{vm.formData.corretor || \'Arbo.\'}}</h2><div style=\"padding-top: 15px; padding-bottom: 25px\"><style>/* style esta mal feito aqui, mas tava com pressa*/\n            img.selecionado {\n              filter: grayscale(0) ! important;\n            }\n            img.deselecionado {\n              filter: grayscale(100%);\n            }</style><div style=\"width: 100%; text-align: center\"><span style=\"margin-right: 10px\" ng-click=\"vm.formData.stars = 1\"><img src=assets/images/nps/1@2x.png style=\"width:53px;\n            height: 53px;\n            object-fit: contain\" ng-class=\"{selecionado: vm.formData.stars == 1, deselecionado: vm.formData.stars != 1}\"></span><span style=\"margin-right: 10px\" ng-click=\"vm.formData.stars = 2\"><img src=assets/images/nps/2@2x.png ng-class=\"{selecionado: vm.formData.stars == 2, deselecionado: vm.formData.stars != 2}\" style=\"width:53px;\n            height: 53px;\n            object-fit: contain\"></span><span style=\"margin-right: 10px\" ng-click=\"vm.formData.stars = 3\"><img src=assets/images/nps/3@2x.png ng-class=\"{selecionado: vm.formData.stars == 3, deselecionado: vm.formData.stars != 3}\" style=\"width:53px;\n            height: 53px;\n            object-fit: contain\"></span><span style=\"margin-right: 10px\" ng-click=\"vm.formData.stars = 4\"><img src=assets/images/nps/4@2x.png ng-class=\"{selecionado: vm.formData.stars == 4, deselecionado: vm.formData.stars != 4}\" style=\"width:53px;\n            height: 53px;\n            object-fit: contain\"></span><span ng-click=\"vm.formData.stars = 5\"><img src=assets/images/nps/5@2x.png ng-class=\"{selecionado: vm.formData.stars == 5, deselecionado: vm.formData.stars != 5}\" style=\"width:53px; \n            height: 53px;\n            object-fit: contain\"></span></div></div><div ng-show=vm.formData.stars><p class=description>Agradecemos o seu feedback!</p><p class=description>Gostaria de fazer mais algum comentário? Escreve a seguir:</p><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\" style=\"padding-left: 20px; padding-right: 20px\"><div class=\"d-flex col-12 border rounded px-0\"><textarea type=tel id=detalhe-09 class=\"form-control upper col-12\" placeholder=\"Adicionar comentário\" ng-model=vm.formData.obs rows=5>\n                  </textarea></div></div><div class=\"d-flex ml-auto col-12 col-lg-6 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 mx-auto mt-4\"><span ng-if=!vm.loaderSearch style=\"font-size: 18px;font-weight: 600;color: #fff\">Enviar</span><div ng-if=vm.loaderSearch class=loader__dots><span class=\"loader__dot pulse pulse__one\"></span><span class=\"loader__dot pulse pulse__two\"></span><span class=\"loader__dot pulse pulse__three\"></span></div></button></div></div></div></form><div class=\"form py-2 d-flex flex-column\" ng-show=vm.formData.send><div style=\"width: 100%\"><div style=\"text-align: center; padding-bottom: 30px\"><img src=assets/images/nps/hands.png alt=\"\" style=\"width: 61px; height: 61px\"></div></div><h1 class=title>Sua resposta foi enviada</h1><p class=description>Agradecemos por ajudar a melhorar nosso serviço!</p><a href=/ class=\"btn button btn-default btn-big col-12 col-lg-6 mx-auto mt-4\">Acesso nosso site</a></div></div></div></div>");
$templateCache.put("app/components/ourServices/privacy-policy.html","<section id=privacy-policy class=margin-fluid><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0 uppercase\">POLÍTICAS DE PRIVACIDADE {{vm.config_wl.nome}}</h3><p class=\"col-12 my-0\" ng-if=\"(!vm.config_wl.isArbo && vm.config_wl.configwl[\'POLITICA-PRIVACIDADE\']) || vm.config_wl.isArbo\">Última atualização: {{ vm.dateupdate }}</p></div><div class=\"content mt-5 pb-5\" ng-if=\"!vm.config_wl.isArbo && vm.config_wl.configwl[\'POLITICA-PRIVACIDADE\']\"><p class=text-justify ng-bind-html=\"vm.config_wl.configwl[\'POLITICA-PRIVACIDADE\']\"></p></div><div class=\"content mt-5 pb-5\" ng-if=vm.config_wl.isArbo><p class=text-justify ng-bind-html=vm.config_wl.content></p></div><div ng-if=vm.config_wl.isArbo class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Tem dúvidas? Entre em contato conosco!</h3><p class=\"col-12 my-0\"><a href=mailto:juridico@arboimoveis.com>juridico@arboimoveis.com</a></p></div></section>");
$templateCache.put("app/components/ourServices/terms-of-use.html","<section id=terms-of-use class=margin-fluid ng-if=(!vm.redirectToTermsPage)><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Termos de uso</h3><p class=\"col-12 my-0\" ng-if=\"vm.config_wl.isArbo || !vm.config_wl.configwl[\'TERMOS-DE-USO\']\">Última atualização: 26/02/2020</p><p class=\"col-12 my-0\" ng-if=\"!vm.config_wl.isArbo && vm.config_wl.configwl[\'TERMOS-DE-USO\']\">Última atualização: {{ vm.dateupdate }}</p></div><div class=\"content mt-5 pb-5\" ng-if=\"vm.config_wl.isArbo || !vm.config_wl.configwl[\'TERMOS-DE-USO\']\"><p class=\"text-justify font-weight-bold\">Leia atentamente estes termos de serviço, pois eles contêm informações importantes sobre seus direitos, recursos e obrigações.</p><p class=text-justify>Estes termos de uso (“Termos de Uso”) têm por objeto definir as regras a serem seguidas para a utilização da <strong>Arbo. Platform</strong> (daqui em diante “Plataforma Arbo” ou “Plataforma”), sem prejuízo da aplicação da legislação vigente, cujo serviço é fornecido pela <strong>ARBO TRANSFORMACAO DIGITAL IMOBILIARIA LTDA.</strong>, inscrita no CNPJ/MF nº 24.991.787/0001-69 e pelas <a ui-sref=main.imobiliarias class=link-custom>imobiliárias parceiras</a> (daqui em diante “ARBO” ou “Nós”), sediada na R. Bento Munhoz da Rocha Neto, nº685, Jardim do Lago, Londrina/PR, CEP 86050-435, local no qual ocorrem a administração, o estabelecimento e a prestação de serviços executados pela ARBO.</p><p class=text-justify>AO UTILIZAR A PLATAFORMA ARBO, VOCÊ AUTOMATICAMENTE CONCORDA COM ESTES TERMOS DE USO, RESPONSABILIZANDO-SE INTEGRALMENTE POR TODOS E QUAISQUER ATOS PRATICADOS POR VOCÊ NA PLATAFORMA ARBO OU EM SERVIÇOS A ELA RELACIONADOS. CASO VOCÊ NÃO CONCORDE COM QUALQUER DOS TERMOS E CONDIÇÕES ABAIXO ESTABELECIDOS, VOCÊ NÃO DEVE UTILIZAR A PLATAFORMA ARBO. VOCÊ TAMBÉM CONCORDA COM OS TERMOS DESCRITOS EM NOSSA POLÍTICA DE PRIVACIDADE. PARA ACESSÁ-LA, <a ng-href=/politica-privacidade target=blank class=link-custom>CLIQUE AQUI.</a></p><p class=text-justify>Caso queira nos dar algum feedback sobre a Plataforma Arbo, tenha dúvidas ou precise tratar de qualquer assunto relacionado a estes Termos de Uso ou a nossa Política de Privacidade, entre em contato conosco através do e-mail juridico@arboimoveis.com.</p><p class=text-justify>Estes Termos constituem um contrato vinculante (“Contrato”) entre você e a ARBO (conforme definido abaixo), regendo seu acesso ao site da ARBO e seu uso, incluindo seus subdomínios, e quaisquer outros sites nos quais a ARBO disponibilize seus serviços (coletivamente, “Site”), nossos aplicativos de celular, tablet ou de outro dispositivo smart aplicável, e interfaces de programa do aplicativo (coletivamente “Aplicativo”) e todos os serviços relacionados (coletivamente, “Serviços da ARBO”). O Site, o Aplicativo e os Serviços da ARBO serão coletivamente referidos como a “Plataforma ARBO”. Nossa POLÍTICA DE PRIVACIDADE e outras Políticas aplicáveis ao uso da Plataforma ARBO estão incorporados por referência neste Contrato.</p><p class=text-justify>Ao estabelecer o contrato que permite ao usuário o gozo das funcionalidades do sistema, a Plataforma Arbo está oferecendo prestação de serviços via Software (modalidade SaaS – Software as a Service).</p><p class=\"text-justify font-weight-bold\">1. Aceite dos Termos</p><p class=text-justify>O acesso à Plataforma Arbo, bem como sua efetiva utilização, implica no aceite, pelo Usuário, desses Termos de Uso e da Política de Privacidade, independentemente da realização de seu cadastro na Plataforma. Esse aceite será ratificado por meio da seleção do checkbox correspondente à opção “Aceito os Termos”, oportunidade na qual o Usuário manifesta seu consentimento livre, expresso e inequívoco com relação ao conteúdo deste documento. Caso o Usuário discorde de alguma das previsões destes Termos, deverá se abster de utilizar a Plataforma.</p><p class=\"text-justify font-weight-bold\">2. Glossário</p><p class=text-justify>As palavras listadas abaixo são utilizadas em várias partes destes Termos, no singular ou no plural, sempre com o significado definido a seguir.</p><p class=text-justify>• Proprietário: Usuário proprietário, possuidor de imóvel (residencial ou comercial) ou seu representante, responsável por algum anúncio de imóvel disponível para locação e/ou venda na Plataforma ou que por meio dela o aluga ou vende.</p><p class=text-justify>• Anúncio: publicação sobre um imóvel apresentado por um Proprietário como disponível para locação e/ou venda, na Plataforma.</p><p class=text-justify>• Corretor: Usuário credenciado pelo CRECI para exercer a profissão de corretor de imóveis e prestador terceiro e independente de serviços de corretagem por meio da Plataforma.</p><p class=text-justify>• Gestor: Usuário que lidera e coordena os corretores de uma determinada região, responsável por acompanhar as movimentações de venda e locação através da Plataforma.</p><p class=text-justify>• Inquilino: Usuário que busca imóvel para locação na Plataforma ou que por meio dela seja locatário de um imóvel.</p><p class=text-justify>• Comprador: Usuário que busca um imóvel na Plataforma para compra.</p><p class=text-justify>• Personas: diferentes papéis assumidos por uma mesma pessoa na Plataforma. No contexto da ARBO, um mesmo Usuário poderá assumir, simultaneamente ou não, diferentes personas incluindo, mas não se limitando, os papéis de \"Inquilino\", \"Proprietário\", \"Comprador\", \"Corretor\" ou \"Proprietário\".</p><p class=text-justify>• Serviços: Estes termos regem o acesso e uso de aplicativos, sítios de Internet, conteúdos e também serviços, pelos Usuários, para a locação e venda de imóveis por meio da Plataforma, incluindo, mas não se limitando a, divulgação, intermediação e administração de locações imobiliárias por meio da Plataforma, através de nossos parceiros.</p><p class=text-justify>• Usuário: toda pessoa que acessa ou utiliza a Plataforma ou os Serviços da ARBO, independentemente de ter se cadastrado, incluindo, mas não se limitando, os Inquilinos, Proprietários e Corretores. Salvo quando expressamente indicado em contrário, os termos \"você\", \"seu\" ou \"sua\" se referem ao Usuário.</p><p class=\"text-justify font-weight-bold\">3. Dos serviços e funcionalidades</p><p class=text-justify>A Plataforma consiste em um conjunto de funcionalidades que proporcionarão a intermediação de negócios imobiliários, entre Usuários independentes, para que contratem, entre si: a) a locação de imóveis residenciais ou comerciais e b) a compra e venda de imóveis residenciais ou comerciais, ambas com o auxílio do Corretor de Imóveis. Para tanto, a ARBO atua no planejamento, manutenção e atualização de sua Plataforma, onde viabiliza a divulgação, intermediação, administração e gestão de locações imobiliárias, estando disponível para acesso por meio do site <a href=https://arboimoveis.com.br class=link-custom target=blank>www.arboimoveis.com</a> ou por meio dos aplicativos específicos para cada tipo de Usuário.</p><p class=text-justify>O Usuário se declara ciente de que determinadas seções e funcionalidades da Plataforma somente poderão ser utilizadas e acessadas mediante cadastro, oportunidade na qual o Usuário deverá fornecer corretamente todos os dados a ele solicitados, em consonância com o exposto em nossa <a href=# ui-sref=main.privacypolicy class=link-custom>Política de Privacidade</a>.</p><p class=text-justify>Neste sentido, o Usuário reconhece que, quando da realização do cadastro, deverá fornecer seu número de telefone, ao qual o seu cadastro ficará vinculado, sendo facultado à ARBO o envio de mensagens a este número para validar tal cadastro.</p><p class=text-justify>Desde já, o Usuário se declara ciente de que a ARBO utilizará meios de comunicação como (não se limitando) mensagem de texto, e-mails, mensagens por <em>WhatsApp</em>, visando o envio de informações diretamente relacionadas aos interesses dos Usuários.</p><p class=text-justify>Por meio do aceite aos presentes Termos, o Usuário se declara ciente de que é única e exclusivamente responsável por todas as informações fornecidas quando de seu acesso a Plataforma, responsabilizando-se, inclusive perante terceiros, por quaisquer danos ou prejuízos decorrentes de informações incorretas, incompletas ou inverídicas.</p><p class=text-justify>O Usuário reconhece, ainda, que a inclusão de qualquer informação inverídica, falsa ou adulterada o sujeitará a todas as sanções aplicáveis consoante a legislação brasileira vigente, inclusive em âmbito criminal.</p><p class=\"text-justify font-weight-bold\">4. Regras para Utilização da Plataforma</p><p class=text-justify>Por meio do aceite aos presentes Termos, o Usuário se declara ciente que:</p><p class=text-justify>a) apenas pessoas civilmente capazes, à luz da legislação brasileira, poderão utilizar o aplicativo;</p><p class=text-justify>b) O Usuário poderá assumir diferentes Personas incluindo, mas não se limitando a, Inquilino, Proprietário, Corretor, podendo, contudo, possuir apenas uma Conta da ARBO.</p><p class=text-justify>c) Cada conta fica associada a um único CPF/CNPJ e a um único CRECI, no caso de Usuários que também sejam corretores.</p><p class=text-justify>d) Não é permitida a criação de nova Conta de Usuário por pessoas que tenham sido inabilitadas pela ARBO, temporária ou definitivamente, independente do motivo.</p><p class=text-justify>e) Não poderá inserir na Plataforma qualquer conteúdo considerado ilícito ou capaz de violar direitos de terceiros.</p><p class=text-justify>f) Não deverá inserir na Plataforma, por quaisquer meios, conteúdos ou materiais capazes de incorporar vírus ou outros elementos que possam impedir o normal funcionamento da Plataforma, de equipamentos informáticos da ARBO ou de terceiros, bem como capazes de danificar documentos eletrônicos e arquivos armazenados em tais equipamentos.</p><p class=text-justify>g) Não deverá compartilhar suas credenciais de acesso com terceiros, sendo o único responsável por quaisquer operações, inclusive financeiras, realizadas por meio de sua conta;</p><p class=text-justify>h) Em nenhuma hipótese será permitida a cessão, venda, aluguel ou outra forma de transferência de contas de usuário da ARBO, incluindo, mas não se limitando a, qualificações, histórico e reputação; e</p><p class=text-justify>i) Não poderá ativar imóvel cadastrado incorretamente ou fora das normas de publicação, o qual será inativado da Plataforma pela ARBO.</p><p class=text-justify>A ARBO se reserva o direito de recusar qualquer solicitação de cadastro e de inativar um cadastro previamente aceito, a seu exclusivo critério e sem aviso prévio, não cabendo nenhuma indenização ou reparação pelo cancelamento de quaisquer cadastros ou de impossibilidade de cadastro.</p><p class=text-justify>Por meio do aceite aos presentes Termos, o Usuário reconhece que, em qualquer hipótese, é o único responsável pela utilização da Plataforma, isentando a ARBO de qualquer responsabilidade por danos e prejuízos decorrentes do uso indevido da Plataforma.</p><p class=\"text-justify font-weight-bold\">5. Da utilização da Plataforma</p><p class=\"text-justify font-weight-bold\">5.1 Anúncios</p><p class=text-justify>Os Anúncios, na Plataforma, podem ser realizados por Proprietários ou seus representantes, devidamente autorizados. Ao publicar um Anúncio na Plataforma, Você declara:</p><p class=text-justify>• possuir possibilidade para dispor do imóvel para locação imediata; e</p><p class=text-justify>• possuir o direito de alugar, em nome próprio, o imóvel oferecido, bem como todos os direitos sobre o conteúdo do Anúncio, incluindo, mas não se limitando a todos os direitos necessários para que você possa utilizar, divulgar e conceder a ARBO licença de tal Conteúdo, conforme definido no item Publicação e promoção do Anúncio abaixo.</p><p class=text-justify>O Usuário reconhece ser permitida a publicação de Anúncios de imóveis residenciais ou comerciais destinados à locação e/ou venda de longo prazo, desde que localizado em municípios brasileiros e bairros atendidos pela ARBO e livres de quaisquer impedimentos.</p><p class=text-justify>O Usuário compreende que cada Imobiliária parceira poderá angariar o imóvel apenas uma vez, porém o anúncio poderá ser atualizado, sempre que a ARBO entender necessário, podendo ainda, o imóvel ser anunciado mais de uma vez na Plataforma.</p><p class=text-justify>Não deverá o Proprietário fornecer informações de contato ou quaisquer outras informações diretamente ao potencial inquilino ou comprador com o intuito de evitar a formalização da transação por meio da ARBO, exceto quando expressamente autorizado pela ARBO.</p><p class=text-justify>A ARBO entende que Você é livre para anunciar seu imóvel em todos os meios que entender pertinente. Por isso, não trabalha com cláusula de exclusividade. Porém, o Proprietário não poderá negociar com um cliente que vier dos Nossos canais de captação de leads, sem a intermediação da ARBO.</p><p class=text-justify>Caso o proprietário tiver firmado contrato de anuncio com cláusula de exclusividade com terceiro, deverá se abster de anunciar na Plataforma ARBO.</p><p class=text-justify>Os Proprietários são inteiramente responsáveis pelo conteúdo de seus anúncios, incluindo, mas não se limitando a, definição do preço do aluguel e encargos locatícios e das condições da locação, podendo, inclusive, responder legalmente por seus atos ou omissões. A ARBO não exerce nenhuma influência nem assume nenhuma responsabilidade sobre tais preços e condições.</p><p class=\"text-justify font-weight-bold\">5.2 Criação do Anúncio</p><p class=text-justify>Ao negociar com outro Usuário, por meio da Plataforma, o Proprietário declara estar ciente, entender e concordar com os termos previstos no Contrato de Locação e no Contrato de Administração da Locação que lhe serão disponibilizados e garante que honrará com tais termos caso seu imóvel venha a ser locado por meio da Plataforma, a partir da assinatura destes contratos.</p><p class=text-justify>Ao aceitar os presentes Termos, o Proprietário autoriza a ARBO a utilizar quaisquer meios disponíveis para divulgar seu Anúncio fora da Plataforma ARBO (Instagram, Facebook, Portais Imobiliários, entre outros), sem necessidade de aviso ou consentimento prévio, desde que tais medidas não impliquem em custos ou responsabilidades extras para o Proprietário.</p><p class=\"text-justify font-weight-bold\">5.3 Upload de Fotos e Vídeos</p><p class=text-justify>O Usuário reconhece que o anúncio na Plataforma requer o upload de vídeos e fotos do imóvel e dos bens móveis que porventura nele existirem, cujo material deverá ser fornecido pelo próprio Usuário, por meio de Upload na Plataforma. As fotos e vídeo têm o objetivo de mostrar as condições reais do imóvel, proporcionando aos usuários da Plataforma maior entendimento em relação ao espaço.</p><p class=text-justify>O Usuário deve se abster de incluir em qualquer parte da imagem ou vídeo seus dados pessoais e/ou de contato, sob pena de reprovação da imagem ou vídeo pela ARBO.</p><p class=text-justify>O Proprietário autoriza a publicação das fotos e vídeos do imóvel - e eventuais bens móveis - a ser anunciado no site, conforme condições descritas nestes Termos, entendendo que tal material é condição essencial para a publicação do anúncio na Plataforma. O Proprietário também autoriza a divulgação das fotos e vídeos na Plataforma, em sites terceiros, redes sociais, mas a estas não se limitando, juntamente com a descrição do imóvel, que será composta por informações como o número de cômodos, metragem e endereço, entre outras informações que Nós julgarmos necessária.</p><p class=text-justify>A ARBO se reserva o direito de limitar o uso das fotografias aos Anúncios publicados na Plataforma ou em sites de terceiros, bem como a manter tal conteúdo em seus arquivos, mesmo após o encerramento do anúncio ou do Contrato.</p><p class=\"text-justify font-weight-bold\">5.4 Publicação e promoção do Anúncio</p><p class=text-justify>A publicação do Anúncio no site da ARBO é condicionada ao preenchimento de um mínimo de campos assinalados como obrigatórios.</p><p class=text-justify>Ao publicar um anúncio no nosso site, o Proprietário autoriza a ARBO a utilizar quaisquer meios disponíveis para divulgar tal anúncio, sem necessidade de aviso ou consentimento prévio por parte do Proprietário, desde que tais medidas NÃO impliquem em custos ou responsabilidades extras para o Proprietário.</p><p class=text-justify>Embora a ARBO facilite a publicação do anúncio em sites de terceiros, uma vez que o anúncio seja publicado em tais sites, tanto o anúncio quanto o Proprietário estarão sujeitos aos termos e condições dos respectivos sites. A ARBO não se responsabiliza perante os sites terceiros ou perante Proprietários.</p><p class=text-justify>Ao publicar um anúncio no site da ARBO, o Proprietário entende que seu anúncio poderá ser indexado por mecanismos de busca e agregadores tais como Google, Bing, Trovit, dentre outros serviços similares e, portanto, ficar exposto ou passível de ser localizado por usuários destes sites.</p><p class=\"text-justify font-weight-bold\">5.5 Visualização e manutenção do Anúncio</p><p class=text-justify>Os Anúncios ativos serão exibidos na interface da Plataforma, podendo ser filtrados e ordenados de acordo com critérios informados pelos interessados.</p><p class=text-justify>O Usuário tem total autonomia para editar, desativar ou reativar seu Anúncio, a qualquer momento, mediante acesso à Plataforma por login e senha. O Proprietário está ciente de que a ARBO também poderá, unilateralmente, editar, desativar, reativar os Anúncios em sua Plataforma, independente de prévia notificação, nas condições descritas aqui.</p><p class=text-justify>O Usuário é ciente de que a ARBO jamais excluirá anúncios da Plataforma, uma vez que os dados do imóvel ficarão armazenado no banco de dados da ARBO, em conformidade com nossa <a href=# ui-sref=main.privacypolicy class=link-custom>Política de Privacidade</a>.</p><p class=text-justify>A atualização das publicações realizadas pela ARBO em outros sites e/ou classificados serão editadas ou desativadas tão logo seja possível, respeitando os termos de Anúncio e publicação dos meios utilizados.</p><p class=text-justify>O Usuário reconhece que a ARBO não é responsável pela qualidade, exatidão, veracidade ou legalidade dos Anúncios ou imóveis anunciados na Plataforma, razão pela qual incentiva que Você visite e vistorie o imóvel escolhido antes de fazer uma proposta.</p><p class=text-justify>A ARBO reserva-se o direito de editar, solicitar que o Proprietário edite, suspender qualquer Anúncio, a qualquer momento, sem prévio aviso e a seu exclusivo critério. No entanto, a ARBO não é obrigada a retirar do ar nenhum Anúncio a não ser que haja uma ordem legal para fazê-lo. Se houver algum Anúncio em nosso site que foi publicado sem sua autorização ou incorretamente, Você deve contatar a ARBO através do email <a href=mailto:mkt@arbo.com>mkt@arbo.com</a> ou pelo telefone 4003-3793</p><p class=\"text-justify font-weight-bold\">5.6 Custo do Anúncio</p><p class=text-justify>A publicação de Anúncios na Plataforma da ARBO é inteiramente gratuita para todos Proprietários, independentemente das características e conteúdo do Anúncio, da quantidade de Anúncios por Proprietário ou do prazo que o Anúncio será disponibilizado na Plataforma.</p><p class=text-justify>A promoção de anúncios em sites de terceiros poderá estar sujeita a custos extras cobrados por tais sites. A ARBO poderá arcar com tais custos ocasionalmente e a seu exclusivo critério.</p><p class=text-justify>Caso a ARBO não subsidie tais custos, o Proprietário será devidamente informado antes da publicação de seus anúncios em outros sites e terá a opção de não publicar ou de pagar os custos pertinentes conforme instruções fornecidas oportunamente.</p><p class=text-justify>A ARBO reserva-se o direito de alterar esta política de preços e subsídios a seu exclusivo critério, a qualquer momento, sendo de responsabilidade única e exclusiva do Usuário o seu acompanhamento.</p><p class=\"text-justify font-weight-bold\">5.7 Agendamento de visitas</p><p class=text-justify>No caso de o proprietário residir no imóvel anunciado, a ARBO entra em contato através da equipe de Leads ou corretor para agendar diretamente a visita.</p><p class=text-justify>No caso de imóveis desocupados, a ARBO entrará em contato através do corretor ou equipe de Leads no intuito de agendar a visita. Para tanto, o proprietário deverá disponibilizar as chaves do imóvel ao corretor autorizado.</p><p class=text-justify>A ARBO não se responsabiliza por eventuais prejuízos causados pela falta de atualização do status do imóvel na plataforma, cuja a responsabilidade é inteiramente do proprietário, uma vez que a ARBO não trabalha com cláusula de exclusividade.</p><p class=text-justify>O Proprietário está ciente de que a ARBO poderá suspender ou desativar Anúncios que tenham um grande número de cancelamentos de visitas por parte do Proprietário, conforme sua política.</p><p class=text-justify>Os horários agendados para visitas nos imóveis anunciados na Plataforma dependem de outros fatores além dos horários disponibilizados pelo Proprietário, como horários disponíveis na agenda de Corretores e número de visitas em cada imóvel, por exemplo. Assim, a ARBO não se responsabiliza pela disponibilização de todos os horários abertos na agenda do imóvel pelo Proprietário, bem como não garante a demanda para a realização dessas visitas nos imóveis anunciados.</p><p class=text-justify>O Proprietário é o único responsável pela definição de horários compatíveis com as regras do condomínio. A ARBO não assume nenhuma responsabilidade por visitas que desrespeitem tais regras.</p><p class=text-justify>O Proprietário, o Corretor e o potencial Inquilino/Comprador podem alterar a disponibilidade de suas agendas bem como realizar o cancelamento das visitas já agendas, preferencialmente com antecedência mínima de 1 hora da visita</p><p class=text-justify>É expressamente proibido, a troca de contato de qualquer natureza, entre proprietários e potenciais inquilinos/compradores. Toda a tratativa de negociação de um imóvel da Plataforma deve ser realizada por meio de um Corretor autorizado e cadastrado na Plataforma, sob pena das sanções previstas em lei.</p><p class=text-justify>No caso de cancelamento de visita por parte do Corretor, a ARBO providenciará a transferência da visita para outro Corretor, caso haja tempo hábil, sendo a visita cancelada somente se não houver outro corretor disponível no dia e horário agendado. Neste caso, as outras partes serão automaticamente notificadas.</p><p class=text-justify>A ARBO não se responsabiliza pela exatidão das informações, pontualidade, comportamento das partes e eventuais danos de qualquer natureza. A ARBO atua como um mero facilitador do agendamento e não pode assumir nenhuma responsabilidade sobre tais visitas.</p><p class=text-justify>A ARBO poderá, a seu exclusivo critério, limitar as visitas a um determinado imóvel ou realizadas por um determinado Usuário. Ademais, a ARBO reserva-se o direito de monitorar o comportamento dos Usuários com o intuito de evitar fraudes.</p><p class=text-justify>Ainda, o Proprietário assume e reconhece como SUAS todas as responsabilidades sobre as visitas realizadas no imóvel, incluindo, mas não se limitando, a conformidade com regras do condomínio, proteção do imóvel e dos bens existentes dentro do mesmo, bem como de qualquer pessoa envolvida, eximindo a ARBO de quaisquer questionamentos decorrentes de sua desconformidade.</p><p class=\"text-justify font-weight-bold\">5.8 Proposta de Compra e Locação</p><p class=text-justify>A ARBO oferece uma ferramenta para submissão, negociação e análise de propostas de locação e de compra dos imóveis anunciados por meio da Plataforma.</p><p class=text-justify>Qualquer Usuário cadastrado pode submeter propostas de compra ou locação para imóveis anunciados na Plataforma, desde que esteja livre de impedimentos com a ARBO e que forneça as informações mínimas requeridas pela ARBO e pelo Proprietário do imóvel. Qualquer Proprietário pode receber propostas, desde que o Proprietário e o	Anúncio estejam ativos, recebendo visitas e livre de impedimentos pela ARBO.</p><p class=\"text-justify font-weight-bold\">5.9 Análise e aceitação da proposta e do Inquilino/Comprador pelo Proprietário</p><p class=text-justify>O envio de propostas se dá exclusivamente por meio dos botões “Faça sua proposta” no site, ou “Fazer proposta” na página do Anúncio do imóvel, e é condicionado ao fornecimento de um mínimo de informações indicadas como “obrigatórias” no formulário de proposta disponibilizado na Plataforma, bem como ao aceite destes Termos de Uso e da Política de Privacidade da Arbo.</p><p class=text-justify>O Usuário declara estar ciente de que os valores acessórios ao valor do aluguel, tais como condomínio, IPTU, seguros, são apenas estimativas e podem apresentar variação de valor para mais ou para menos, sem aviso prévio ao locatário, uma vez que não são de responsabilidade ou controle da ARBO.</p><p class=text-justify>Cabe, no entanto, ao Proprietário fornecer à ARBO todos os dados pertinentes ao anúncio, com veracidade e com o maior número de detalhes possível.</p><p class=text-justify>A ARBO permite o envio de propostas sem a apresentação de documentação para identificação do Inquilino/Comprador, bem como sem o envio de seu comprovante de renda. Entretanto, ao enviar uma proposta, o Inquilino/Comprador declara estar ciente, entender e concordar com a necessidade de apresentar toda a documentação solicitada, posteriormente.</p><p class=text-justify>O Inquilino/Comprador garante também ter intenção de honrar a proposta e ter condições de preencher os requisitos informados no momento do envio da proposta. O Inquilino/Comprador é responsável pela exatidão, veracidade e autenticidade das informações fornecidas, e declara estar ciente que poderá responder legalmente caso forneça informações inexatas ou falsas.</p><p class=text-justify>O potencial Inquilino/Comprador poderá cancelar a proposta enviada enquanto não houver manifestação do Proprietário, não podendo, contudo, editar a proposta já enviada. Caso haja a necessidade de alterar qualquer dado enviado na proposta, o Inquilino/Comprador deverá entrar em contato com um de nossos atendentes através do email <a href=mailto:suporte@arboimoveis.com>suporte@arboimoveis.com</a>. O Proprietário, por sua vez, pode rejeitar as propostas referentes ao seu imóvel ou realizar uma contraproposta, a seu exclusivo critério.</p><p class=text-justify>As propostas enviadas por meio da Plataforma ficarão disponíveis para a outra parte por tempo limitado, informado aos Usuários no momento da proposta ou determinados nos e-mails informativos enviados. Transcorrido o prazo, que caberá exclusivamente a ARBO estabelecer, a proposta caducará automaticamente.</p><p class=text-justify>Ao enviar uma proposta, o Inquilino/Comprador autoriza a divulgação, o fornecimento e a utilização de seus dados cadastrais, pessoais, de crédito e de comunicação para o Proprietário, ARBO e/ou empresas parceiras da ARBO envolvidas em todas e quaisquer questões de natureza financeira ou que versem acerca do crédito do Usuário. Para mais informações sobre privacidade, consultar <a href=# ui-sref=main.privacypolicy class=link-custom>Política de Privacidade</a>.</p><p class=text-justify>O Usuário pode realizar propostas simultâneas a diferentes imóveis. Contudo, a ARBO se reserva ao direito de, a seu exclusivo critério, limitar o número de propostas por Anúncio ou Usuário.</p><p class=text-justify>A ARBO reserva-se o direito de inativar Usuários com comportamentos suspeitos incluindo, mas não se limitando ao cancelamento de múltiplas propostas enviadas ou a rejeição de múltiplas propostas recebidas. A ARBO não se responsabiliza por consequências decorrentes da sua decisão de inativar um imóvel ou Usuário em fase de negociação.</p><p class=text-justify>Os Usuários entendem que o envio ou o aceite da proposta não representa reserva do imóvel ou qualquer direito ou expectativa de direito, de nenhuma das partes até que seja assinado o Contrato de Locação, por ambas as partes. O Inquilino/Comprador e o Proprietário são os únicos responsáveis pela negociação da proposta. À ARBO compete apenas a intermediação do negócio. Ainda a ARBO não se envolverá na negociação de preços ou outras condições da locação, salvo aquelas definidas nos contratos padrões de locação e administração da locação e nos contratos de compromisso de compra e venda.</p><p class=text-justify>Além disso, todos os acordos realizados fora da nossa Plataforma de negociação não estarão registrados em contrato a ser assinado entre as partes. Assim, é de responsabilidade dos Usuários assegurar que todas as informações estejam dentro da plataforma, não podendo a ARBO ser responsabilizado pelo descumprimento dessa obrigação, pelos Usuários.</p><p class=text-justify>Os Usuários concordam que o imóvel será inativado da Plataforma após aceita a proposta pelas partes, podendo ser reativado caso não haja a concretização do negócio.</p><p class=text-justify>O Inquilino pode oferecer até 05 (cinco) propostas de locação em diferentes imóveis, podendo escolher entre elas após o processo de análise de crédito, nos limites do crédito a ele aprovado.</p><p class=text-justify>Após o aceite da proposta pelas partes, o preço e condições da locação ou venda não poderão ser alterados entre elas.</p><p class=\"text-justify font-weight-bold\">5.10 Análise de cadastro e documentação pela ARBO</p><p class=text-justify>Após aceitação da proposta pelo Proprietário, o Inquilino/Comprador deve fazer o upload dos documentos solicitados pela ARBO, dentro do prazo estipulado pela Plataforma. Caso o Inquilino não envie os documentos neste prazo, a proposta pode ser desconsiderada.</p><p class=text-justify>Os Usuários estão de acordo de que a simples aceitação de proposta pelas partes não significa fechamento de contrato ou promessa de venda/locação. O fechamento do negócio está sujeito à análise de crédito e documentação das partes, fase que antecede a assinatura do contrato.</p><p class=text-justify>O Proprietário poderá aceitar diferentes propostas de locação, direcionando, assim, os potenciais Inquilinos para o processo de análise de crédito, competindo-lhe escolher dentre os Inquilinos aprovados. O mesmo vale para o Inquilino aprovado em mais de uma proposta.</p><p class=text-justify>O Inquilino poderá indicar, para análise de crédito, mais de um Proponente para composição da renda requerida para aceitação da locação pela ARBO, que não precisarão residir no imóvel alugado. Caso haja a necessidade de complementação de renda para locação após a envio da proposta, o inquilino deverá realizar uma nova proposta, informando os dados da pessoa que irá complementar a renda no campo solicitado e apresentar todos os documentos solicitados. Todos os Inquilinos são partes integrantes do Contrato de Locação e por ele se responsabilizam de forma solidária.</p><p class=text-justify>A ARBO comunicará ao Inquilino, em tempo hábil, o resultado da análise de crédito para a proposta em questão.</p><p class=text-justify>O Proprietário é comunicado sobre a aprovação, na análise de crédito e documentação, dos Inquilinos/Compradores com quem esteja em negociação através de email enviado pela ARBO, oportunidade em que deverá escolher dentre as propostas a ele oferecidas, no caso de haver mais de uma, e enviar seu aceite, além das informações solicitadas, para a realização do contrato.</p><p class=text-justify>O Proprietário, desde já, compreende que a ARBO não realizará a administração de imóveis nem permitirá a realização do contrato de locação em sua Plataforma em caso de desaprovação do Inquilino na análise de crédito.</p><p class=text-justify>Os critérios de análise serão estabelecidos pela ARBO e eventuais parceiros, a seu exclusivo critério, nos limites permitidos pela legislação brasileira.</p><p class=text-justify>O Usuário autoriza a ARBO a usar e fornecer os dados cadastrais, pessoais, de comunicação ou quaisquer outras informações especificamente a instituições financeiras, de crédito ou de consulta.</p><p class=text-justify>A ARBO não se responsabiliza por qualquer locação ou compromisso de compra e venda realizada diretamente entre Proprietários e Inquilinos/Compradores, mesmo que as partes tenham se conhecido por meio da ARBO.</p><p class=\"text-justify font-weight-bold\">5.11 Contrato de Locação e Compromisso de Compra e Venda</p><p class=text-justify>A ARBO facilita a formalização dos termos da locação ou venda por meio da assinatura de um \"Contrato de Locação\" entre Inquilino e Proprietário ou \"Compromisso de Compra e Venda\" entre Comprador e Vendedor (Proprietário).</p><p class=text-justify>O Contrato de Locação deve ser assinado por i) um ou mais inquilinos que podem ou não residir no imóvel, mas sendo todos corresponsáveis pelo pagamento do aluguel, e ii) proprietário ou seu procurador</p><p class=text-justify>O Compromisso de compra e venda deve ser assinado por i) um ou mais compradores, mas sendo todos corresponsáveis pelo pagamento do valor de venda, e ii) proprietário ou seu procurador e cônjuge, se for o caso.</p><p class=text-justify>Todos os contratos da ARBO, sejam eles de Locação, Administração ou Compromisso de Compra e Venda são validados por meio de assinatura eletrônica das partes, e substitui o reconhecimento de firma em cartório do documento físico.</p><p class=\"text-justify font-weight-bold\">5.12 Intermediação e Administração da locação</p><p class=text-justify>A relação entre a ARBO e Proprietário durante o período de locação é formalizada e regulamentada pelo Contrato de Intermediação e Administração da Locação. O Contrato de Administração deverá ser assinado eletronicamente por i) um representante legal da ARBO, e ii) o proprietário ou seu procurador.</p><p class=text-justify>Pelo serviço de intermediação será devida a taxa de intermediação, a ser paga pelo Proprietário à ARBO e ao Corretor de Imóveis. A ARBO é responsável somente pela emissão de NFS-e referente aos serviços prestados pela mesma, bem como o repasse do valor referente aos serviços prestados pelas Imobiliárias parceiras.</p><p class=text-justify>Atuando como administrador da locação, a ARBO fará o repasse dos valores relativos aos aluguéis mensais do imóvel locado ao Proprietário, descontado do valor da taxa de administração e eventuais outros descontos ou reembolsos contratados entre as partes. A ARBO é responsável somente pela emissão de NFS-e referente aos serviços prestados pela mesma, não se responsabilizando pelos demais tributos que possam incidir sobre o valor repassado ao proprietário.</p><p class=text-justify>Neste sentido, o Usuário reconhece que a Taxa de Intermediação e a Taxa de Administração estão representadas pelas seguintes taxas, respectivamente:</p><p class=text-justify>Taxa de Intermediação:</p><p class=text-justify>A referida Taxa será no valor equivalente a um aluguel, sendo cobrada sempre no primeiro pagamento do Inquilino, salvo disposição específica em contrário na campanha realizada ou no contrato de Administração da Locação.</p><p class=text-justify>Taxa de Administração:</p><p class=text-justify>A referida Taxa será no valor equivalente a 10% (dez por cento) do valor do aluguel vigente, salvo disposição específica em contrário na campanha realizada ou no contrato de Administração da Locação.</p><p class=\"text-justify font-weight-bold\">5.13 Intermediação da Venda</p><p class=text-justify>Pelo serviço de intermediação será devida a taxa de corretagem, a ser paga pelo Proprietário (salvo disposição distinta em contrato) à ARBO e ao Corretor de Imóveis. A ARBO é responsável somente pela emissão de NFS-e referente aos serviços prestados pela mesma, bem como o repasse do valor referente aos serviços prestados pelo Corretor.</p><p class=text-justify>A referida Taxa será no valor equivalente a 6% (seis por cento) do valor da venda em contrato, salvo disposição específica em contrário na campanha realizada ou no Compromisso de Compra e Venda.<br>Os Usuários estão cientes que a comissão de corretagem pela intermediação da compra e venda será devida ainda que o negócio não se efetive em virtude de desistência ou arrependimento não justificado das partes, nos termos do art. 725 do Código Civil.</p><p class=\"text-justify font-weight-bold\">5.14 Preços dos Serviços e Remuneração</p><p class=text-justify>Algumas categorias de Usuários poderão receber remuneração de acordo com os serviços que prestarem aos outros, por intermédio da Plataforma. As taxas relativas a cada Usuário serão informadas às partes envolvidas na própria Plataforma, e poderão sofrer alterações periódicas, sem aviso prévio.</p><p class=text-justify>Assim, o Usuário deverá pagar à ARBO e/ou a terceiros os valores indicados na Plataforma, relacionados aos Serviços contratados, podendo tais valores corresponderem à remuneração tanto da ARBO quanto de outros Usuários, como Proprietários e Corretores, que atuam de forma autônoma na Plataforma e são contratados e pagos diretamente pelos Usuários.</p><p class=text-justify>Neste sentido, os Usuários reconhecem que os valores recebidos pela ARBO e repassados a terceiros não correspondem, para fins tributários, à receita da ARBO.</p><p class=text-justify>Ainda, o Usuário compreende que o atraso na realização de quaisquer pagamentos relacionados a estes Termos e/ou o descumprimento de qualquer contrato firmado por intermédio da plataforma poderá ensejar a cobrança de juros e multas, consoante valores dispostos no contrato.</p><p class=\"text-justify font-weight-bold\">5.14.1. Do Pagamento aos Corretores</p><p class=text-justify>Por meio destes Termos, o Usuário compreende que a ARBO apenas exerce papel de intermediação entre os usuários da Plataforma, os quais possuem interesse na celebração de Contrato de Locação ou Compra e Venda referente aos imóveis anunciados.</p><p class=text-justify>Assim, o Usuário reconhece que os Corretores são contratados diretamente pelos Proprietários interessados na celebração do Contrato de Locação, mediante cobrança de taxa de corretagem (\"Taxa de Corretagem\"), sendo certo que a ARBO repassará o valor a eles devido da Taxa de Corretagem, seja de locação quando da realização do pagamento do primeiro aluguel ou de compra e venda quando da concretização do negócio, não configurando os valores de tal natureza como receita da ARBO.</p><p class=text-justify>Para a realização do Repasse, a ARBO, quando na condição de ADMINISTRADORA, disponibilizará relatórios mensais (\"Relatórios\") dos repasses realizados, aos Corretores, de modo a assegurar a transparência da relação assumida por meio destes Termos.</p><p class=text-justify>Sendo assim, os Corretores, na qualidade de prestadores de serviços de corretagem aos Proprietários, serão responsáveis pela emissão de NFS-e referente aos serviços prestados ou quaisquer obrigações acessórias correspondentes ao pagamento da taxa de corretagem, onde a ARBO se responsabiliza apenas pelo repasse dos valores.</p><p class=text-justify>A ARBO não se responsabiliza por emissão de documentos fiscais, sendo esses recibos ou NFS-e, referentes a comissões pagas aos corretores ou imobiliárias parceiras que intermediaram as locações/vendas.</p><p class=\"text-justify font-weight-bold\">6. Outras obrigações, responsabilidades e isenções das partes</p><p class=\"text-justify font-weight-bold\">6.1. Adequação às leis e regulamentos</p><p class=text-justify>A ARBO respeita e obedece a todas as leis e regulamentos aplicáveis às suas atividades e espera que todos seus Usuários façam o mesmo. Entretanto, a ARBO não pode garantir e não assume nenhuma responsabilidade pela conformidade de seus Usuários com quaisquer leis ou regulamentos. Ao utilizar a Plataforma ou Serviços da ARBO, o Usuário declara estar ciente, entender e concordar que é exclusiva e totalmente responsável pelo cumprimento de todas e quaisquer leis, normas, regulamentos e obrigações legais e fiscais que possam ser aplicadas para ao seu uso do Site, Serviços e Conteúdos, incluindo, mas não se limitando aos Códigos Civil - Lei 10.406/02 e Processo Civil - Lei 13.105/15, à Lei Federal nº 8.245/1991, que regula a locação de imóveis no Brasil, e normas específicas de cada condomínio.</p><p class=\"text-justify font-weight-bold\">6.2. Elegibilidade</p><p class=text-justify>A Plataforma e os Serviços da ARBO são destinados exclusivamente para pessoas capazes de exercer pessoalmente os atos da vida civil, em acordo com a lei 10.406/02. Qualquer acesso ou utilização da Plataforma ou Serviços por menores de 18 anos não emancipados é expressamente proibido. Ao acessar ou utilizar a Plataforma ou Serviços, você declara e garante que é capaz de exercer pessoalmente os atos da vida civil e que está ciente das sanções legais previstas no Código Civil, notadamente, art. 166, I; 171, I e 180 da lei n° 10.406/02.</p><p class=\"text-justify font-weight-bold\">6.3. Atribuição</p><p class=text-justify>Você não pode ceder ou transferir estes Termos, por força de lei ou outro, sem consentimento prévio por escrito da ARBO. Qualquer tentativa de atribuir ou transferir estes Termos, sem tal consentimento, será nula e sem efeito.</p><p class=text-justify>A ARBO pode ceder ou transferir estes Termos, a seu exclusivo critério, sem restrição. Sujeito ao precedente, estes Termos vinculam e revertem em benefício das partes, seus sucessores e cessionários autorizados.</p><p class=\"text-justify font-weight-bold\">6.4. Direitos autorais e de propriedade da Plataforma</p><p class=text-justify>Todos os direitos relativos à PLATAFORMA ARBO e suas funcionalidades são de propriedade exclusiva da PLATAFORMA ARBO, inclusive no que diz respeito aos seus textos, imagens, layouts, software, códigos, bases de dados, gráficos, artigos, fotografias e demais conteúdos produzidos direta ou indiretamente pela PLATAFORMA ARBO (“Conteúdo da PLATAFORMA ARBO”). O Conteúdo da PLATAFORMA ARBO é protegido pela lei de direitos autorais e de propriedade intelectual. É proibido usar, copiar, reproduzir, modificar, traduzir, publicar, transmitir, distribuir, executar, fazer o upload, exibir, licenciar, vender ou explorar e fazer engenharia reversa do Conteúdo da PLATAFORMA ARBO, para qualquer finalidade, sem o consentimento prévio e expresso da PLATAFORMA ARBO. Qualquer uso não autorizado do Conteúdo da PLATAFORMA ARBO será considerado como violação dos direitos autorais e de propriedade intelectual da PLATAFORMA ARBO.</p><p class=text-justify>As marcas, os nomes comerciais ou logotipos de qualquer espécie apresentados por meio da Plataforma são de propriedade da ARBO ou de terceiro que permitiu o seu uso, de modo que a utilização da Plataforma não consiste em autorização para que o Usuário possa citar as tais marcas, nomes comerciais e logotipos.</p><p class=text-justify>Ademais, o Usuário, ao postar qualquer conteúdo na Plataforma (marcas, logos, nomes, desenhos, textos, imagens, fotos, vídeos, fonogramas, obras audiovisuais, códigos-fonte etc.), concede a ARBO licença de uso, por tempo indeterminado, para que possamos veicular tal conteúdo, sob qualquer forma, em Anúncios (em meio físico e/ou virtual), demonstrações de uso e apresentações institucionais. O Usuário concorda que tal conteúdo poderá ser utilizado em qualquer página ou campo da Plataforma.</p><p class=\"text-justify font-weight-bold\">6.5. Isenções de Responsabilidade</p><p class=text-justify>Para além das demais isenções de responsabilidade indicadas nos presentes Termos, o Usuário se declara ciente de que a ARBO não será responsável:</p><p class=text-justify>• por garantir a eficácia de qualquer contratação, ou a qualidade de qualquer serviço ou imóvel. Portanto, a ARBO não é responsável por quaisquer danos ou indenizações decorrentes de falha no cumprimento de obrigação por qualquer Usuário;</p><p class=text-justify>• pelas obrigações tributárias decorrentes das atividades dos Usuários relacionadas à utilização da Plataforma. O Usuário é exclusiva e integralmente responsável por determinar todos e quaisquer impostos e taxas incidentes sobre suas atividades relacionadas à utilização do Plataforma ou Serviços da ARBO;</p><p class=text-justify>• pela conduta dos Usuários ou de terceiros contatados ou contratados por meio da Plataforma. A ARBO explicitamente não se responsabiliza por qualquer ato ou omissão de qualquer Usuário em relação a outros Usuários ou terceiros;</p><p class=text-justify>• por quaisquer indisponibilidades, erros ou falhas apresentadas pela Plataforma, assim como por eventual defraudação da utilidade que o Usuário possa atribuir a Plataforma, pela falibilidade deste, nem por qualquer dificuldade de acesso a este;</p><p class=text-justify>• por erros ou eventuais inconsistências na transmissão de dados, pela qualidade ou disponibilidade da conexão de Internet, que impeçam o adequado recebimento de informações pela ARBO ou pelo Usuário;</p><p class=text-justify>• por dados desatualizados, incompletos ou inverídicos eventualmente disponibilizados e atualizados por terceiros, como de instituições financeiras, sites utilizados para anúncios e demais parceiros comerciais;</p><p class=text-justify>• pela presença de vírus ou demais elementos nocivos na Plataforma, capazes de causar alterações em seus sistemas informáticos (software e hardware), documentos eletrônicos e nos boletos gerados para pagamento por parte do Usuário, eximindo-se a ARBO de qualquer responsabilidade por eventuais danos e prejuízos decorrentes de quaisquer elementos nocivos inseridos por terceiros; e</p><p class=text-justify>• pelos danos e prejuízos de toda natureza decorrentes do conhecimento que terceiros não autorizados possam ter de quaisquer dados fornecidas pela Plataforma, em decorrência de falha exclusivamente relacionada ao Usuário ou a terceiros que fujam a qualquer controle razoável da ARBO.</p><p class=text-justify>A ARBO se exime da responsabilidade por quaisquer informações imprecisas ou inconsistentes inseridas na Plataforma, que são de responsabilidade do Usuário que a fornece, sendo certo que, em caso de eventual divergência entre informações indicadas na Plataforma e quaisquer documentos e/ou informações fornecidas diretamente por representante da ARBO, deverão prevalecer estes.</p><p class=\"text-justify font-weight-bold\">6.6 Links</p><p class=text-justify>A Plataforma poderá conter links para outros websites. Isto não implica em nenhuma relação de sociedade, de supervisão, de cumplicidade, de endosso ou solidariedade da ARBO para com esses sites, seus conteúdos, produtos ou serviços.</p><p class=text-justify>Dessa Forma, o Usuário assume exclusiva e total responsabilidade por todos os riscos e eventuais danos e/ou prejuízos decorrentes do uso de quaisquer desses sites ou de seus conteúdos, produtos ou serviços.</p><p class=\"text-justify font-weight-bold\">6.7 Isenção de responsabilidade sobre itens não previstos nestes termos</p><p class=text-justify>Nenhum conselho, orientação ou informação, verbal ou por escrito, obtidos do ARBO ou através do Site, Serviços ou Conteúdos, cria qualquer garantia ou responsabilidade que não tenha sido expressamente feita nestes Termos.</p><p class=\"text-justify font-weight-bold\">6.8 Sanções</p><p class=text-justify>A Plataforma é disponibilizada ao Usuário por prazo indeterminado. Contudo, a ARBO poderá, a qualquer tempo, descontinuar a Plataforma, sem necessidade de prévio aviso ao Usuário e sem que lhe seja devida qualquer indenização em razão disso.</p><p class=text-justify>A ARBO pode, a qualquer momento, limitar o acesso do Usuário a Plataforma, sendo-lhe possível negá-lo ou suspendê-lo, em caso de suspeita de uso indevido ou ilícito da Plataforma, o que pode motivar a exclusão de todas as informações fornecidas por este, sem qualquer indenização ou compensação por conta disso.</p><p class=\"text-justify font-weight-bold\">6.9 Rescisão</p><p class=text-justify>A ARBO pode rescindir estes Termos, Contas de Usuários ou acesso dos Usuários ao Site e aos Serviços, a qualquer momento, sem aviso ou consentimento prévios, a seu exclusivo critério. Você pode cancelar sua Conta da ARBO na Plataforma, desde que não tenha nenhuma obrigação pendente em relação a ARBO ou outros Usuários.</p><p class=text-justify>Em caso de rescisão por parte da ARBO: i) a ARBO deverá pagar, em tempo hábil, quaisquer valores devidos ao Usuário; ii) Você permanecerá responsável por todos os montantes devidos a ARBO ou a terceiros; iii) a ARBO não assumirá nenhuma responsabilidade por valores devidos por (ou a) terceiros.</p><p class=text-justify>Rescisões de Contratos de Locação, Contratos de Administração de Locação e Compromisso de Compra e Venda são reguladas pelas cláusulas existentes nos respectivos instrumentos.</p><p class=\"text-justify font-weight-bold\">7. Disposições Gerais</p><p class=text-justify>Todas as comunicações encaminhadas pelo Usuário a ARBO serão consideradas plenamente válidas quando realizadas por escrito e entregues via e-mail para o endereço <a href=mailto:atendimento@arboimoveis.com>atendimento@arboimoveis.com </a>.</p><p class=text-justify>Ainda, as comunicações realizadas por parte da ARBO ao Usuário serão consideradas eficazes, para todos os efeitos, quando realizadas por quaisquer meios de contato, escritos ou não.</p><p class=text-justify>Os casos fortuitos ou de força maior serão excludentes de responsabilidades das partes, na forma da Legislação Brasileira.</p><p class=text-justify>Qualquer cláusula ou condição deste instrumento que, por qualquer razão, venha a ser reputada nula ou ineficaz por qualquer juízo ou tribunal, não afetará a validade das demais disposições destes Termos, as quais permanecerão plenamente válidas e vinculantes, gerando efeitos em sua máxima extensão.</p><p class=text-justify>A falha da ARBO em exigir quaisquer direitos ou disposições dos presentes Termos não constituirá renúncia, podendo esta exercer regularmente o seu direito, dentro dos prazos legais.</p><p class=text-justify>Estes Termos poderão ser alterados a qualquer momento, sendo que a nova versão deste documento entrará em vigor no dia seguinte da publicação na Plataforma. O Usuário somente será comunicado da alteração dos Termos se houver obrigação legal em tal sentido.</p><p class=\"text-justify font-weight-bold\">8. Legislação e Foro</p><p class=text-justify>Todos os itens destes Termos de Uso são regidos pelas leis vigentes na República Federativa do Brasil. Para todos os assuntos referentes à interpretação, ao cumprimento ou qualquer outro questionamento relacionado a estes Termos de Uso, as partes concordam em se submeter ao Foro da Comarca de Londrina/PR, com exceção de reclamações apresentadas por USUÁRIOS que se enquadrem no conceito legal de consumidores, que poderão submeter tais reclamações ao foro de seu domicílio.</p><p class=text-justify><i>Esta aplicação e seu conteúdo (\"PLATAFORMA ARBO\") são controlados e operados pela própria PLATAFORMA ARBO. Todos os direitos reservados.</i></p></div><div class=\"content mt-5 pb-5\" ng-if=\"!vm.config_wl.isArbo && vm.config_wl.configwl[\'TERMOS-DE-USO\']\"><p class=text-justify ng-bind-html=\"vm.config_wl.configwl[\'TERMOS-DE-USO\']\"></p></div><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Tem dúvidas? Entre em contato conosco!</h3><p class=\"col-12 my-0\">juridico@arboimoveis.com</p></div></section>");
$templateCache.put("app/components/panelHeader/panel-header.html","<div id=panel-header><ul><div class=\"row no-padding\"><div class=\"text-center no-padding\" ng-class=\"{\'{{vm.myColClass}}\': true}\" ng-repeat=\"tab in vm.tabs\"><li><a ui-sref=\"{{tab.sref}}({newListing: true})\" id=\"tab{{$index + 1}}\" ui-sref-active=active>{{tab.title}}</a></li></div></div></ul></div>");
$templateCache.put("app/components/quemsomos/quemsomos.html","<section id=quemsomos><section id=Banner><div class=container><div class=row><div class=title><h2><span class=arrow-left></span>Na contra mão do mercado imobiliário <span class=arrow-right></span></h2></div><figure><img alt=\"Na contramão do mercado imobiliário\" src=../../../assets/images/quemsomos-banner.jpg></figure></div></div></section><section id=o-mundo><div class=container><div class=row><h3 class=center>O mundo mudou</h3><p class=\"bold center\">Que tal você também mudar a forma de comprar, vender ou alugar?<br>Esqueça tudo o que você sabe sobre mercado imobiliário e<br>conheça a Startup que veio para facilitar a sua vida</p></div></div></section><section id=inconformados><div class=container><div class=row><div class=col-sm-6><figure><img alt=\"Os inconformados\" src=../../../assets/images/quemsomos-1.jpg></figure></div><div class=col-sm-6><h3>\"Os inconformados\"</h3><p>Somos uma startup formada por pessoas inconformadas com o serviço imobiliário tradicional. Se você já tentou comprar ou alugar um imóvel deve saber do que estamos falando. Burocracia, papelada e estresse. Assim como, se você tem um imóvel para vender ou alugar, sabe que as imobiliárias demoram para conseguir negociar o seu imóvel.<br>Por que não facilitar tudo isso? Nosso objetivo é simplificar a sua relação com o mercado imobiliário, criando soluções simples, tecnológicas e seguras. E levar essas soluções para o Brasil todo.<br>E muito mais do que simplesmente vender ou alugar, nossa prioridade é oferecer uma nova experiência, distante do mundo quadrado e burocrático das imobiliárias tradicionais.</p></div></div></div></section><section id=fazemos><div class=container><div class=row><div class=col-sm-6><h3>Como fazemos</h3><p>Se você chegou até aqui já entendeu que não somos uma imobiliária, certo? Somos uma plataforma digital de imóveis. Mas, então o que fazemos de diferente? Se você for um proprietário de imóveis, a Arbo te ajuda a vender ou alugar muito mais rápido do que as imobiliárias tradicionais. Isso porque usamos todas as tecnologias de marketing digital disponíveis para anunciar seu imóvel (saiba mais).<br>Já se você está querendo comprar ou alugar, aqui te oferecemos a facilidade de resolver tudo online. Todo o processo de negociação até a assinatura do contrato é feita do seu computador ou smartphone de forma simples, rápida e segura (saiba mais).</p></div><div class=col-sm-6><figure><img alt=\"Como fazemos?\" src=../../../assets/images/quemsomos-2.jpg></figure></div></div></div></section><section id=time><div class=container><div class=row><div class=col-sm-12><figure><img alt=\"Nosso Time\" src=../../../assets/images/quemsomos-3.jpg></figure></div><div class=\"col-sm-12 time\"><h3 class=center>Nosso time</h3><p class=center>A Arbo é um time que acredita que pode fazer a diferença no mundo ajudando você a administrar o seu imóvel, seja se ele for o seu lar, ou o seu investimento. Nós estamos do seu lado porque entendemos a dificuldade em lidar com as imobiliárias tradicionais.<br>Trabalhamos para tornar todo o processo de venda ou locação o mais simples possível. O nosso objetivo é que você tenha todo o controle do seu imóvel por meio dos nossos canais online. Mas, por trás dessa tecnologia, há uma equipe muito dedicada em prestar um bom atendimento, com empatia e boa comunicação para merecer a sua confiança.</p></div><div class=col-sm-12><figure><img alt=\"Time da Arbo\" src=../../../assets/images/quemsomos-4.jpg></figure></div></div></div></section><section id=historia><div class=container><div class=row><div class=col-sm-6><figure><img alt=\"Nossa história\" src=../../../assets/images/quemsomos-5.jpg></figure></div><div class=col-sm-6><h3>Nossa história:<br>Da terra roxa para o mundo.</h3><p>A região de Londrina, no interior do Paraná, é conhecida como Terra Roxa. Quem conhece a região sabe muito bem o porquê. A pigmentação forte da terra deu origem à marca registrada dos londrinenses: pé vermelho. E foi aqui, nessa terra fértil, na cabeça de um pé vermelho sonhador que nasceu a Arbo.<br>Em 10 anos atuando no mercado imobiliário tradicional, Manoel Gonçalves, idealizador e CEO da Arbo, foi fundador de uma das maiores imobiliárias de Londrina. Nesses 10 anos, nosso “Mané” identificou muitas falhas na prestação de serviço das imobiliárias tradicionais. E resolveu começar tudo do zero, reinventando a maneira de fazer negócio.<br>Foi então que nosso CEO fechou sua antiga imobiliária e começou a se dedicar totalmente ao sonho de transformar o mercado imobiliário e dar vida ao que, mais tarde, se tornaria a Arbo.<br>Motivado em criar uma plataforma de prestação de serviço imobiliário que solucionasse o modelo tradicional que é burocrático, cansativo e estressante, tanto para os proprietários de imóveis, quantos para inquilinos, Manoel pegou todo o conhecimento que adquiriu no mercado e juntou com muita tecnologia. Na missão de, acima de tudo, criar relações transparentes e sólidas, colocando as pessoas em primeiro lugar.<br>Depois de muito planejamento e estudo de mercado, em fevereiro de 2017 nasceu a Arbo. Com um desafio enorme pela frente, mas muito determinada a tornar mais simples as relações entre pessoas com o mercado imobiliário, em apenas seis meses a Arbo já atua em mais quatro outras cidades além de Londrina: Araraquara, Bragança Paulista, São Carlos e São Paulo. E queremos ir muito além, levando tecnologia e um bom atendimento para simplificar o mercado imobiliário de todo o Brasil (e quem sabe do mundo!).</p></div></div></div></section></section>");
$templateCache.put("app/components/registro/login.anuncio.html","<div id=registroanuncio><div class=\"row container m-auto\"><div class=\"formulario col-12 col-lg-6 order-first order-lg-last mb-5 m-auto\"><form name=modallogin class=form ng-submit=\"modallogin.$valid && vm.sendNext($event, modallogin)\"><h1 class=title>Login</h1><p class=description>Faça o login para continuar o cadastro do seu imóvel</p><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email name=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off ng-required=true placeholder=\"Endereço de Email\"><label for=form-email class=\"pl-3 upper\">Endereço de Email</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-envelope\"></i></div></div><div ng-messages=\"modallogin[\'form-email\'].$error\" ng-if=\"modallogin[\'form-email\'].$dirty\" role=alert class=ng-message><div ng-message=required>Insira seu email.</div></div><div ng-if=vm.error role=alert class=ng-message><div>Insira um email válido.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=password id=form-pass name=form-pass class=\"form-control upper\" ng-model=vm.form.password autocomplete=off ng-required=true placeholder=Senha><label for=form-pass class=\"pl-3 upper\">Senha</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-lock-alt\"></i></div></div><div ng-messages=\"modallogin[\'form-pass\'].$error\" ng-if=\"modallogin[\'form-pass\'].$dirty\" role=alert class=ng-message><div ng-message=required>Insira sua senha.</div></div></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 mx-auto mt-4\">Entrar</button></div></div><div class=\"forgot d-flex justify-content-center\"><span><a href=# role=button ng-click=vm.sendForgot()>Esqueceu a senha?</a></span></div></form><div class=\"footer my-2 border-top d-flex justify-content-center\"><span class=mt-2>Você ainda não tem uma conta? <a href=# role=button ng-click=vm.gotoregister($event)>Cadastre-se</a></span></div></div></div></div>");
$templateCache.put("app/components/registro/registro.anuncio.html","<div id=registroanuncio><div class=\"row container m-auto\"><div class=\"formulario col-12 col-lg-6 order-first order-lg-last mb-5 m-auto\"><form action=\"\" name=formRegister class=form ng-submit=vm.sendNext($event)><h1 class=title>Chegou a hora de anunciar o seu imóvel</h1><p class=description>Informe os dados a seguir e nós fazemos o resto. Em caso de dúvida, a gente te ajuda!</p><div class=\"form-group d-flex flex-column flex-wrap\"><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=email id=form-email class=\"form-control upper\" ng-model=vm.form.email autocomplete=off required placeholder=Email><label for=form-email class=\"pl-3 upper\">Endereço de E-mail</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-envelope\"></i></div></div><div ng-if=vm.error role=alert class=ng-message><div>E-mail já cadastrado.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=text id=form-name class=\"form-control upper\" ng-model=vm.form.name autocomplete=off required placeholder=\"Primeiro Nome\"><label for=form-name class=\"pl-3 upper\">Primeiro nome</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-user\"></i></div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=text id=form-last-name class=\"form-control upper\" ng-model=vm.form.lastname autocomplete=off required placeholder=\"Último Nome\"><label for=form-last-name class=\"pl-3 upper\">Último nome</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-user\"></i></div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=tel id=user-telefones name=user-telefones class=\"form-control upper\" ng-model=\"vm.form.telefones[\'numero\']\" ui-br-phone-number=areaCode required placeholder=\"(00) 9 9999-9999\"><label for=user-telefones class=\"ml-3 upper\">Telefone</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-phone\"></i></div></div><div ng-messages=\"formRegister[\'user-telefones\'].$error\" ng-if=\"formRegister[\'user-telefones\'].$dirty\" role=alert class=ng-message><div ng-message=required>Telefone requerido.</div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=password id=form-pass class=\"form-control upper\" ng-model=vm.form.password autocomplete=off required minlength=6 placeholder=\"Criar uma senha\"><label for=form-pass class=\"pl-3 upper\">Criar uma senha</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-lock-alt\"></i></div></div></div><div class=\"input-group row mb-3\"><div class=\"d-flex col-12 border rounded px-0\"><input type=password id=form-confirm-pass name=form-confirm-pass class=\"form-control upper\" ng-model=vm.form.confirm_password autocomplete=off required compare-to=vm.form.password minlength=6 placeholder=\"Confirma Senha\"><label for=form-confirm-pass class=\"pl-3 upper\">Confirmar senha</label><div class=\"input-group-prepend d-flex align-items-center\"><i class=\"fal fa-lock-alt\"></i></div></div><div ng-messages=\"formRegister[\'form-confirm-pass\'].$error\" ng-if=\"formRegister[\'form-confirm-pass\'].$dirty\" role=alert class=ng-message><div ng-message=compareTo>Senhas diferentes.</div></div></div><div class=\"form-group form-check text-left ml-4 mb-0\" ng-if=vm.config_wl.isArbo><input class=form-check-input type=checkbox id=form-contact-check name=form-contact-check ng-model=vm.form.usu_accept_terms ng-true-value=true ng-false-value=false><label class=form-check-label for=form-contact-check><span>Aceito os <a class=text-primary href=https://www.arboimoveis.com.br/termos-uso target=_blank>termos de uso</a> e <a class=text-primary href=https://www.arboimoveis.com.br/politica-privacidade target=_blank>políticas de privacidade</a> . </span></label></div><div class=\"d-flex col-12 px-0\"><button type=submit class=\"btn button btn-default btn-big col-12 mx-auto mt-4\" ng-disabled=\"(vm.config_wl.isArbo && !vm.form.usu_accept_terms)\">Cadastre-se</button></div><div class=\"footer border-top d-flex justify-content-center mt-2\"><span>Já tem uma conta da Arbo? <a href=# role=button ng-click=vm.gotologin($event)>Entrar</a></span></div></div></form></div></div></div>");
$templateCache.put("app/components/stars-rate/starts.html","<div class=\"d-flex justify-content-center\" ng-class=\"{hover: vm.mutable, mutable: vm.mutable}\" ng-attr-id=\"{{\'place\'+ vm.placeId }}\" data-id=\"{{ vm.placeId }}\"><i ng-repeat=\"item in vm.stars\" ng-mouseover=vm.mouseover(item) ng-mouseout=vm.mouseout() ng-click=vm.click() ng-class=vm.getClass(item)></i></div>");
$templateCache.put("app/components/typeahead/customPopupTemplate.html","<div class=custom-popup-wrapper ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\" style=\"display: block\" ng-show=\"isOpen() && !moveInProgress\" aria-hidden={{!isOpen()}}><ul class=dropdown-menu role=listbox><li class=uib-typeahead-match ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=selectActive($index) ng-click=selectMatch($index) role=option id={{::match.id}}><div uib-typeahead-match index=$index match=match query=query template-url=templateUrl></div></li><li class=uib-typeahead-match role=option id=power-google><a style=\"background-color: #fff\" class=d-flex><img src=/assets/images/novosite/c487a8e5170433fad61a1e2e2c121050.png alt=powered_by_google class=ml-auto></a></li></ul></div>");
$templateCache.put("app/components/typeahead/customTemplate.html","<div class=template-padrao><a ng-if=!match.model.imv_cod_gaia><i class=\"fal fa-map-marker-alt pr-3\"></i> <span ng-if=!match.model.imv_cod_gaia ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span> </a><a ng-if=match.model.imv_cod_gaia><div class=filter-imovel><div class=\"imovel d-flex flex-column flex-md-row\"><div class=\"imovel-img d-none d-md-flex\" bg-image=\"{{ match.model.fotos[0].imvft_url ? match.model.fotos[0].imvft_url : \'../../assets/images/novosite/fallback.png\' }}\"></div><div class=\"imovel-info w-100 p-0 px-1 col-lg-10 d-flex flex-column\"><p class=title><span class=\"tag valor px-1\">{{ match.model.tipo_imovel.timv_nome }}</span> R$ {{ match.model.imv_preco_venda ? match.model.imv_preco_venda : (match.model.imv_preco_locacao | currency) }}</p><p class=info>cód: {{ match.model.imv_cod_gaia }} <span ng-if=match.model.imv_cod_origem>/ {{ match.model.imv_cod_origem }}</span><br><span ng-if=!match.model.imobiliaria.imb_hidden_cond_num>{{ match.model.imv_nome_cond }}</span><br><span ng-if=!match.model.imobiliaria.imb_hidden_address>{{ match.model.imv_endereco }},</span> <span ng-if=!match.model.imobiliaria.imb_hidden_number>{{ match.model.imv_end_numero }} -</span> <span>{{ match.model.imv_bairro }} - {{ match.model.imv_cidade }}/{{ match.model.imv_estado }}</span></p></div></div></div></a></div>");
$templateCache.put("app/components/typeahead/customTemplateProposta.html","<div class=template-padrao><a ng-if=!match.model.imv_cod_gaia><i class=\"fal fa-map-marker-alt pr-3\"></i> <span ng-if=!match.model.imv_cod_gaia ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span> </a><a ng-if=match.model.imv_cod_gaia><div class=filter-imovel><div class=\"imovel d-flex flex-column flex-md-row\"><div class=\"imovel-img d-none d-md-flex\" bg-image=\"{{match.model.fotos[0].imvft_url ? match.model.fotos[0].imvft_url : \'../../assets/images/novosite/fallback.png\'}}\"></div><div class=\"imovel-info w-100 p-0 px-1 d-flex flex-column\"><p class=info><b>{{match.model.imv_cod_gaia}}</b></p><p class=info>{{match.model.imv_titulo}}</p></div></div></div></a></div>");
$templateCache.put("app/components/view-creci/view-creci.html","<div id=viewcreci class=\"viewcreci margin-fluid pb-3\"><div class=\"gradient-header py-4 px-2 px-md-5\"><h3 class=\"title col-12 my-0\">Imobiliárias credenciadas.</h3></div><div class=\"creci-body d-flex flex-column flex-lg-row my-2 m-lg-5\"><main class=\"d-flex flex-wrap col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2\"><div class=\"imob d-flex flex-wrap flex-row col-12\" ng-repeat=\"imb in vm.imobiliarias | orderBy:\'imb_nome\'\"><div class=\"col-12 col-sm-4\"><h4 class=\"title d-inline-block d-block\">{{imb.imb_nome}}<p class=\"description d-inline-block d-sm-none\">CRECI - {{imb.imb_creci}}</p></h4><p class=description>{{ imb.cidade ? imb.cidade.nome +\' - \'+imb.cidade.estado.nome: \'\'}}</p></div><div class=\"col-3 col-sm-2 d-none d-sm-block\"><h5 class=title>CRECI</h5><p class=description>{{imb.imb_creci}}</p></div><div class=\"col-9 col-sm-4 d-none d-sm-block\"><h5 class=title>Site</h5><a href=//{{imb.imb_subdomain_url}} target=_blank class=link>{{imb.imb_subdomain_url}}</a></div><div class=\"col-6 col-sm-2 d-flex justify-content-center align-items-center\"><a role=button class=\"link text-center\">Ver mais <i class=\"fal fa-search-plus\"></i></a></div><div class=\"col-6 col-sm-2 d-flex d-sm-none justify-content-center align-items-center\"><a href=//{{imb.imb_subdomain_url}} target=_blank class=\"link text-center\">Site <i class=\"fal fa-window\"></i></a></div></div></main></div></div>");
$templateCache.put("app/components/view-register/view-register.html","<div id=viewregister class=\"margin-fluid pb-3\"><div class=\"view-register-body d-flex flex-column flex-lg-row my-2 m-lg-5\"><section class=\"d-flex flex-wrap col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2\"><div class=\"container-register d-flex flex-wrap flex-row\"><div class=\"row justify-content-center align-self-center text-center\"><div class=top-content><span class=head-text>Legal! Que bom que você chegou até aqui.<br>Esse é um formulário bem fácil de preencher.</span></div><div class=bottom-content><span class=bottom-text>Nós vamos usar este formulário para saber tudo sobre seu imóvel.</span> <span class=\"bottom-text mt-3 font-weight-bold\">Lembrando que os detalhes são importantes!</span></div><button class=\"btn button button-toogle btn-default col-8\" ng-click=vm.checkRegister()>Vamos Começar!</button></div></div></section></div></div>");
$templateCache.put("app/listing/sidebar/result-sidebar-lancamento.html","<div id=searchResults infinite-scroll-container=vm.getContainer() infinite-scroll=vm.loadMore() infinite-scroll-distance=2><div ng-repeat=\"listing in vm.filteredListings | orderBy:[\'precoVenda\',\'precoLocacao\']\" ng-mouseenter=\"vm.highlight($event, listing)\" ng-mouseleave=\"vm.highlight($event, listing)\" class=result-item data-id=\"{{ listing.id }}\"><a target=_blank href={{vm.makeUrl(listing)}} class=\"result no-padding-sides padding-top-10px padding-bottom-10px\" ng-class=\"{\'result-hover\': listing.hover}\"><div class=\"result-item-detail row padding-left-25px\" itemscope itemtype=http://schema.org/Product><div class=\"image col-xs-12 no-padding listingPhoto\"><img ng-if=listing.thumb ng-src={{listing.thumb}} itemprop=image class=listingImg alt=\"{{ listing.title }} / {{ listing.address.street }} / {{ listing.address.neighborhood }} / {{ listing.address.city }} / {{ listing.address.state }} / {{ listing.address.country }}\"></div><div class=\"description col-xs-12\"><div class=info-imovel><div itemprop=name class=titilos>{{listing.nome._cdata}}</div><div>{{listing.bairro._text}} - {{listing.cidade._text}}.</div><div><span ng-show=\"listing.dormMin != listing.dormMax\">{{listing.dormMin._text}} a {{listing.dormMax._text}} dorm.</span> <span ng-show=\"listing.dormMin == listing.dormMax\">{{listing.dormMax._text}} dorm.</span> <span ng-show=\"listing.vagasMin != listing.vagasMax\">{{listing.vagasMin._text}} a {{listing.vagasMax._text}} {{listing.vagasMax._text > 1 ? \'vagas\' : \'vaga\'}}.</span> <span ng-show=\"listing.vagasMin == listing.vagasMax\">{{listing.vagasMax._text}} {{listing.vagasMax._text > 1 ? \'vagas\' : \'vaga\'}}.</span> <span ng-show=\"listing.suiteMin != listing.suiteMax\">{{listing.suiteMin._text}} a {{listing.suiteMax._text}} {{listing.suiteMax._text > 1 ? \'suítes\' : \'suíte\'}}.</span> <span ng-show=\"listing.suiteMin == listing.suiteMax\">{{listing.suiteMax._text}} {{listing.suiteMax._text > 1 ? \'suítes\' : \'suíte\'}}.</span><div ng-show=\"listing.areaUtilMin != listing.areaUtilMax\">Área útil de {{listing.areaUtilMin._text}} a {{listing.areaUtilMax._text}} m².</div><div ng-show=\"listing.areaUtilMin == listing.areaUtilMax\">Área útil de {{listing.areaUtilMax._text}} m².</div></div><div>Código do Imóvel: <b>{{ listing.codigoEmpreendimento._text }}</b></div><div itemprop=offers itemscope itemtype=http://schema.org/Offer class=\"preco hidden-sm\"><span class=tipo>A partir de</span> <span itemprop=price class=caixa>{{listing.valorMinimo == 0 ? \'Não informado\' : \'R$ \' + vm.formatPrice(listing.valorMinimo._text) }}</span></div></div><div itemprop=offers itemscope itemtype=http://schema.org/Offer class=\"preco-md visible-sm-* hidden-lg hidden-md hidden-xs\"><span class=tipo>Aluguel</span> <span itemprop=price class=caixa>{{listing.valorMinimo == 0 ? \'Não informado\' : \'R$ \' + vm.formatPrice(listing.valorMinimo._text) }}</span></div></div></div></a></div></div>");
$templateCache.put("app/listing/sidebar/result-sidebar.html","<div id=searchResults infinite-scroll=vm.loadMore() infinite-scroll-distance=2 style=\"margin: 0 -0.5rem\"><ul class=\"row list\"><li ng-repeat=\"listing in vm.filteredListings | orderBy:[\'precoVenda\',\'precoLocacao\']\" class=\"col-12 col-sm-6 col-xl-3 list-no-bullet my-3\" ng-class=\"{\'col-xl-4\': $parent.$parent.vm.mapa}\"><card-imovel imovel=listing url-imovel=vm.makeUrl(listing)></card-imovel></li></ul><div ng-if=\"vm.filteredListings.length && !vm.loading\" class=\"d-flex justify-content-center paginator-results\"><span class=item ng-if=\"vm.params.pagina - 1 > 0\"><a ng-href=\"{{ vm.urlPage }}?pagina={{ +vm.params.pagina - 1 }}\" rel=prev>&lt;&nbsp;{{ +vm.params.pagina - 1 }}</a> </span><span class=\"item active\">{{ vm.params.pagina }}</span> <span class=item ng-if=\"+vm.params.pagina + 1 < vm.maxPages\"><a ng-href=\"{{ vm.urlPage }}?pagina={{ +vm.params.pagina + 1 }}\" rel=next>{{ +vm.params.pagina + 1 }}&nbsp;&gt;</a></span></div><div ng-if=\"!vm.filteredListings.length && !vm.loading\" class=\"d-block col w-100 busca-notfound mb-5\"><h2 class=\"subtitle mt-2 mb-5\">Opa, parece que não temos imóveis nesta região :(</h2><section class=\"tags mt-3 mt-md-5 mb-5\"><h1 class=\"title mb-4\">Você também pode pesquisar imóveis com outras características</h1><div class=\"d-flex flex-row flex-wrap justify-content-center justify-content-lg-start\"><a ng-href=\"{{ tag.url }}\" ng-repeat=\"tag in vm.tags track by $index\" class=tag>{{ tag.label }}</a></div></section><carousel-imovel imoveis=vm.relacionados properties=vm.customProperties title-carousel=\"Selecionamos alguns imóveis mais próximos que encontramos.\" navegator=true ng-if=\"vm.relacionados && vm.relacionados.length\"></carousel-imovel></div></div>");
$templateCache.put("app/proposta-compra/partials/part-modalidades.html","<label for=form-negocio class=ml-1>{{vm.tpng.id === 2 ? \'Tipo de garantia\' : \'Forma de pagamento\'}}</label><div class=\"d-flex flex-column flex-md-row flex-wrap justify-content-start align-items-start\"><div class=\"btn-group-vertical flex-column justify-content-center align-items-stretch col-6 col-md-4 p-0 no-col-6\" role=group aria-label=\"Tipos de negocio\"><div ng-repeat=\"modalidade in vm.modalidades\" class=btn-modalidade><div ng-if=modalidade.tnmod_label class=\"form-check btn\"><input class=form-check-input type=radio name=negocio id=\"negocio{{ modalidade.tnmod_id }}\" ng-model=vm.data.tnmod_id ng-value=modalidade.tnmod_id><label class=\"form-check-label d-flex align-items-center justify-content-center\" for=\"negocio{{ modalidade.tnmod_id }}\"><div>{{ modalidade.tnmod_nome }}</div></label></div></div></div><div class=\"col-12 col-md-8 mt-0 box-modelo-neg\"><div ng-repeat=\"md in vm.modalidades\" ng-switch on=vm.data.tnmod_id><div ng-if=\"md.tnmod_id == 2\" class=\"form-group d-flex flex-column\" ng-switch-when=2><p for=form-descre class=form-descre><span>Com o seguro fiança, você tem garantia por todo o contrato, trazendo mais tranquilidade para você. Sujeito a aprovação de cadastro. </span><a class=faq target=_blank rel=nofollow href=https://ajuda.arboimoveis.com.br/hc/pt-br/articles/360057691554-O-que-%C3%A9-seguro-fian%C3%A7a->FAQ.</a></p></div><div ng-if=\"md.tnmod_id == 3\" class=\"form-group d-flex flex-column\" ng-switch-when=3><p for=form-descre>{{ md.tnmod_label }}</p></div><div ng-if=\"md.tnmod_id == 4\" class=\"form-group d-flex flex-column\" ng-switch-when=4><p for=form-descre>{{ md.tnmod_label }}</p></div><div ng-if=\"md.tnmod_id == 5\" class=\"form-group d-flex flex-column\" ng-switch-when=5><p for=form-descre>{{ md.tnmod_label }}</p></div><div ng-if=\"md.tnmod_id == 7\" ng-switch-when=7><div class=d-flex><label for=form-0 class=ml-1>O que entra como parte do pagamento?</label></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-carro class=ml-1>Carro :</label><textarea id=form-desc-carro type=text style=\"min-height: 70px\" class=\"form-control mr-0\" placeholder=\"Descreva o modelo, ano, valor e detalhes do veículo\" ng-model=vm.data.descricao.permuta_carro></textarea></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-imv class=ml-1>Imovel :</label><textarea id=form-desc-imv type=text class=\"form-control mr-0\" style=\"min-height: 70px\" placeholder=\"Descreva o valor, situação e localização do imóvel \" ng-model=vm.data.descricao.permuta_imovel></textarea></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-other class=ml-1>Outro :</label><textarea id=form-desc-other type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.permuta_outro></textarea></div></div><div ng-if=\"md.tnmod_id == 8\" ng-switch-when=8><div class=\"form-group d-flex\" style=\"margin-bottom: 0px\"><label>Qual banco será seu agente financiador?</label></div><div class=\"form-group d-flex flex-column\"><div class=radio-group><input type=checkbox name=caixa class=\"input-control square\" id=caixa ng-model=vm.data.descricao.caixa ng-true-value=true ng-false-value=false><label for=caixa>Caixa Econômica Federal</label></div><div class=radio-group><input type=checkbox name=bb class=\"input-control square\" id=bb ng-model=vm.data.descricao.bb ng-true-value=true ng-false-value=false><label for=bb>Banco do Brasil</label></div><div class=radio-group><input type=checkbox name=santander class=\"input-control square\" id=santander ng-model=vm.data.descricao.santander ng-true-value=true ng-false-value=false><label for=santander>Santander</label></div><div class=radio-group><input type=checkbox name=itau class=\"input-control square\" id=itau ng-model=vm.data.descricao.itau ng-true-value=true ng-false-value=false><label for=itau>Itau</label></div><div class=radio-group><input type=checkbox name=bradesco class=\"input-control square\" id=bradesco ng-model=vm.data.descricao.bradesco ng-true-value=true ng-false-value=false><label for=bradesco>Bradesco</label></div><div class=\"radio-group col-10 col-md-10 col-xl-8\"><input type=radio name=outro class=\"input-control mr-0\" id=outros ng-true-value=true ng-false-value=false><label for=outros>Outros. Qual?</label><input type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_outros></div></div><div class=\"form-group d-flex flex-column\"><label for=form-agencia class=ml-1>Qual a sua agência?</label><input id=form-agencia name=form-agencia type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_agencia ng-class=\"{ sbmtd: vm.subterror }\" ng-required=\"vm.data.tnmod_id === 8\"><div ng-messages=\"etapanome[\'form-agencia\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-financ class=ml-1>Qual o valor total do financiamento?</label><div class=\"form-group d-flex\"><label for=form-total class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.financiamento_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 8\" ng-class=\"{ sbmtd: vm.subterror }\"><label for=form-total class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red;\n            margin-top: -12px;\n            margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div></div><div ng-if=\"md.tnmod_id == 9\" ng-switch-when=9><div class=\"form-group d-flex flex-column\"><label for=form-total class=ml-1>Qual valor total do consórcio?</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorcio_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{ sbmtd: vm.subterror }\"><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red;\n            margin-top: -12px;\n            margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-consorciadora class=ml-1>Qual a sua consorciadora?</label><input id=form-consorciadora name=form-consorciadora type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorciadora ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{ sbmtd: vm.subterror }\"><div ng-messages=\"etapanome[\'form-consorciadora\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div></div><div ng-if=\"md.tnmod_id === 10\" class=\"form-group d-flex flex-column\" ng-switch-when=10><label for=form-descre>Descreva:</label><input id=form-descre name=form-descre type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.outros_descreva ng-required=\"vm.data.tnmod_id === 10\" ng-class=\"{ sbmtd: vm.subterror }\"><div ng-messages=\"etapanome[\'form-descre\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div ng-if=\"md.tnmod_id == 11\" class=\"form-group d-flex flex-column\" ng-switch-when=11><p for=form-descre class=form-descre><span ng-if=\"md.isarborent && md.tnmod_labelarborent\" ng-bind-html=convertToHtml(md.tnmod_labelarborent)></span> <span ng-if=\"(md.isarborent && !md.tnmod_labelarborent) || !md.isarborent\">{{ md.tnmod_label }}</span> <a class=faq target=_blank rel=nofollow href=https://ajuda.arboimoveis.com.br/hc/pt-br/sections/360005982834-Proposta>FAQ.</a></p></div></div></div></div>");
$templateCache.put("app/proposta-compra/partials/part-venda-consorcio.html","<div class=\"form-group d-flex flex-column\"><label for=form-total class=ml-1>Qual valor total do consórcio?</label><div class=\"form-group d-flex\"><label for=form-locacao class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorcio_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{ sbmtd: vm.subterror }\"><label for=form-locacao class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red;\n          margin-top: -12px;\n          margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-consorciadora class=ml-1>Qual a sua consorciadora?</label><input id=form-consorciadora name=form-consorciadora type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.consorciadora ng-required=\"vm.data.tnmod_id === 9\" ng-class=\"{ sbmtd: vm.subterror }\"><div ng-messages=\"etapanome[\'form-consorciadora\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div>");
$templateCache.put("app/proposta-compra/partials/part-venda-financiamento.html","<div class=\"form-group d-flex\" style=\"margin-bottom: 0px\"><label>Qual banco será seu agente financiador?</label></div><div class=\"form-group d-flex flex-column\"><div class=radio-group><input type=checkbox name=caixa class=\"input-control square\" id=caixa ng-model=vm.data.descricao.caixa ng-true-value=true ng-false-value=false><label for=caixa>Caixa Econômica Federal</label></div><div class=radio-group><input type=checkbox name=bb class=\"input-control square\" id=bb ng-model=vm.data.descricao.bb ng-true-value=true ng-false-value=false><label for=bb>Banco do Brasil</label></div><div class=radio-group><input type=checkbox name=santander class=\"input-control square\" id=santander ng-model=vm.data.descricao.santander ng-true-value=true ng-false-value=false><label for=santander>Santander</label></div><div class=radio-group><input type=checkbox name=itau class=\"input-control square\" id=itau ng-model=vm.data.descricao.itau ng-true-value=true ng-false-value=false><label for=itau>Itau</label></div><div class=radio-group><input type=checkbox name=bradesco class=\"input-control square\" id=bradesco ng-model=vm.data.descricao.bradesco ng-true-value=true ng-false-value=false><label for=bradesco>Bradesco</label></div><div class=\"radio-group pl-4 col-10 col-md-10 col-xl-8\"><input type=text name=outro class=\"input-control mr-0\" id=outros ng-true-value=true ng-false-value=false><label for=outros>Outros. Qual?</label><input type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_outros></div></div><div class=\"form-group d-flex flex-column\"><label for=form-agencia class=ml-1>Qual a sua agência?</label><input id=form-agencia name=form-agencia type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.banco_agencia ng-class=\"{ sbmtd: vm.subterror }\" ng-required=\"vm.data.tnmod_id === 8\"><div ng-messages=\"etapanome[\'form-agencia\'].$error\" ng-if=vm.subterror role=alert class=ng-message><div ng-message=required>Campo requerido.</div></div></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-financ class=ml-1>Qual o valor total do financiamento?</label><div class=\"form-group d-flex\"><label for=form-total class=\"mr-1 pt-3\">R$</label><input id=form-total name=form-total type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.financiamento_valor autocomplete=off ui-number-mask=0 ng-required=\"vm.data.tnmod_id === 8\" ng-class=\"{ sbmtd: vm.subterror }\"><label for=form-total class=\"mr-1 pt-3\">,00</label></div><div ng-messages=\"etapanome[\'form-total\'].$error\" ng-if=vm.subterror role=alert class=ng-message style=\"color: red;\n          margin-top: -12px;\n          margin-bottom: 12px\"><div ng-message=required>Campo requerido.</div></div></div>");
$templateCache.put("app/proposta-compra/partials/part-venda-permuta.html","<div class=d-flex><label for=form-0 class=ml-1>O que entra como parte do pagamento?</label></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-carro class=ml-1>Carro :</label><textarea id=form-desc-carro type=text style=\"min-height: 70px\" class=\"form-control mr-0\" placeholder=\"Descreva o modelo, ano, valor e detalhes do veículo\" ng-model=vm.data.descricao.permuta_carro></textarea></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-imv class=ml-1>Imovel :</label><textarea id=form-desc-imv type=text class=\"form-control mr-0\" style=\"min-height: 70px\" placeholder=\"Descreva o valor, situação e localização do imóvel \" ng-model=vm.data.descricao.permuta_imovel></textarea></div><div class=\"form-group d-flex flex-column\"><label for=form-desc-other class=ml-1>Outro :</label><textarea id=form-desc-other type=text class=\"form-control mr-0\" ng-model=vm.data.descricao.permuta_outro></textarea></div>");}]);